
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirecb4c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirecb4c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
'use strict';

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$k = Symbol.for("react.element"), $1bb9784afa87e369$var$l = Symbol.for("react.fragment"), $1bb9784afa87e369$var$m = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$n = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1bb9784afa87e369$var$m.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1bb9784afa87e369$var$n.current
    };
}
$1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$l;
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRegister("7fPBF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $b9040d2deeb360f4$export$3ba232387fd5d6dd; }, function (v) { return $b9040d2deeb360f4$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b9040d2deeb360f4$export$7568632d0d33d16d; }, function (v) { return $b9040d2deeb360f4$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b9040d2deeb360f4$export$88948ce120ea2619; }, function (v) { return $b9040d2deeb360f4$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf; }, function (v) { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b9040d2deeb360f4$export$f680877a34711e37; }, function (v) { return $b9040d2deeb360f4$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b9040d2deeb360f4$export$aaabe4eda9ed9969; }, function (v) { return $b9040d2deeb360f4$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b9040d2deeb360f4$export$306c0aa65ff9ec16; }, function (v) { return $b9040d2deeb360f4$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b9040d2deeb360f4$export$7b286972b8d8ccbf; }, function (v) { return $b9040d2deeb360f4$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$3ba232387fd5d6dd;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$7568632d0d33d16d;
var $b9040d2deeb360f4$export$88948ce120ea2619;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6a7bc4e911dc01cf;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$f680877a34711e37;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$aaabe4eda9ed9969;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$306c0aa65ff9ec16;
var $b9040d2deeb360f4$export$7b286972b8d8ccbf;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
'use strict';
var $b9040d2deeb360f4$var$l = Symbol.for("react.element"), $b9040d2deeb360f4$var$n = Symbol.for("react.portal"), $b9040d2deeb360f4$var$p = Symbol.for("react.fragment"), $b9040d2deeb360f4$var$q = Symbol.for("react.strict_mode"), $b9040d2deeb360f4$var$r = Symbol.for("react.profiler"), $b9040d2deeb360f4$var$t = Symbol.for("react.provider"), $b9040d2deeb360f4$var$u = Symbol.for("react.context"), $b9040d2deeb360f4$var$v = Symbol.for("react.forward_ref"), $b9040d2deeb360f4$var$w = Symbol.for("react.suspense"), $b9040d2deeb360f4$var$x = Symbol.for("react.memo"), $b9040d2deeb360f4$var$y = Symbol.for("react.lazy"), $b9040d2deeb360f4$var$z = Symbol.iterator;
function $b9040d2deeb360f4$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$z && a[$b9040d2deeb360f4$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b9040d2deeb360f4$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$C = Object.assign, $b9040d2deeb360f4$var$D = {};
function $b9040d2deeb360f4$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
$b9040d2deeb360f4$var$E.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$F() {}
$b9040d2deeb360f4$var$F.prototype = $b9040d2deeb360f4$var$E.prototype;
function $b9040d2deeb360f4$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
var $b9040d2deeb360f4$var$H = $b9040d2deeb360f4$var$G.prototype = new $b9040d2deeb360f4$var$F;
$b9040d2deeb360f4$var$H.constructor = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$var$C($b9040d2deeb360f4$var$H, $b9040d2deeb360f4$var$E.prototype);
$b9040d2deeb360f4$var$H.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$I = Array.isArray, $b9040d2deeb360f4$var$J = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$K = {
    current: null
}, $b9040d2deeb360f4$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$J.call(b, d) && !$b9040d2deeb360f4$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b9040d2deeb360f4$var$K.current
    };
}
function $b9040d2deeb360f4$var$N(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$l;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$P = /\/+/g;
function $b9040d2deeb360f4$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$l:
                case $b9040d2deeb360f4$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b9040d2deeb360f4$var$Q(h, 0) : d, $b9040d2deeb360f4$var$I(c) ? (e = "", null != a && (e = a.replace($b9040d2deeb360f4$var$P, "$&/") + "/"), $b9040d2deeb360f4$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b9040d2deeb360f4$var$O(c) && (c = $b9040d2deeb360f4$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b9040d2deeb360f4$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b9040d2deeb360f4$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b9040d2deeb360f4$var$Q(k, g);
        h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    }
    else if (f = $b9040d2deeb360f4$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b9040d2deeb360f4$var$Q(k, g++), h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b9040d2deeb360f4$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b9040d2deeb360f4$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b9040d2deeb360f4$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b9040d2deeb360f4$var$U = {
    current: null
}, $b9040d2deeb360f4$var$V = {
    transition: null
}, $b9040d2deeb360f4$var$W = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$U,
    ReactCurrentBatchConfig: $b9040d2deeb360f4$var$V,
    ReactCurrentOwner: $b9040d2deeb360f4$var$K
};
function $b9040d2deeb360f4$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$S,
    forEach: function(a, b, e) {
        $b9040d2deeb360f4$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$p;
$b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$r;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$q;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$W;
$b9040d2deeb360f4$export$3ba232387fd5d6dd = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b9040d2deeb360f4$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$J.call(b, f) && !$b9040d2deeb360f4$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b9040d2deeb360f4$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$M;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$O;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$T
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$7568632d0d33d16d = function(a) {
    var b = $b9040d2deeb360f4$var$V.transition;
    $b9040d2deeb360f4$var$V.transition = {};
    try {
        a();
    } finally{
        $b9040d2deeb360f4$var$V.transition = b;
    }
};
$b9040d2deeb360f4$export$88948ce120ea2619 = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useContext(a);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6a7bc4e911dc01cf = function(a) {
    return $b9040d2deeb360f4$var$U.current.useDeferredValue(a);
};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useEffect(a, b);
};
$b9040d2deeb360f4$export$f680877a34711e37 = function() {
    return $b9040d2deeb360f4$var$U.current.useId();
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useImperativeHandle(a, b, e);
};
$b9040d2deeb360f4$export$aaabe4eda9ed9969 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useInsertionEffect(a, b);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useReducer(a, b, e);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$U.current.useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useState(a);
};
$b9040d2deeb360f4$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useSyncExternalStore(a, b, e);
};
$b9040d2deeb360f4$export$7b286972b8d8ccbf = function() {
    return $b9040d2deeb360f4$var$U.current.useTransition();
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("6EA3T", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4d82739dd229d539$export$ae55be85d98224ed; }, function (v) { return $4d82739dd229d539$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $4d82739dd229d539$export$d39a5bbd09211389; }, function (v) { return $4d82739dd229d539$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $4d82739dd229d539$export$882461b6382ed46c; }, function (v) { return $4d82739dd229d539$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $4d82739dd229d539$export$466bfc07425424d5; }, function (v) { return $4d82739dd229d539$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4d82739dd229d539$export$cd75ccfd720a3cd4; }, function (v) { return $4d82739dd229d539$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $4d82739dd229d539$export$fa8d919ba61d84db; }, function (v) { return $4d82739dd229d539$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4d82739dd229d539$export$757ceba2d55c277e; }, function (v) { return $4d82739dd229d539$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $4d82739dd229d539$export$b3890eb0ae9dca99; }, function (v) { return $4d82739dd229d539$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4d82739dd229d539$export$502457920280e6be; }, function (v) { return $4d82739dd229d539$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4d82739dd229d539$export$c78a37762a8d58e1; }, function (v) { return $4d82739dd229d539$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $4d82739dd229d539$export$dc54d992c10e8a18; }, function (v) { return $4d82739dd229d539$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $4d82739dd229d539$export$83d89fbfd8236492; }, function (v) { return $4d82739dd229d539$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4d82739dd229d539$export$ae55be85d98224ed;
var $4d82739dd229d539$export$d39a5bbd09211389;
var $4d82739dd229d539$export$882461b6382ed46c;
var $4d82739dd229d539$export$466bfc07425424d5;
var $4d82739dd229d539$export$cd75ccfd720a3cd4;
var $4d82739dd229d539$export$fa8d919ba61d84db;
var $4d82739dd229d539$export$757ceba2d55c277e;
var $4d82739dd229d539$export$b3890eb0ae9dca99;
var $4d82739dd229d539$export$502457920280e6be;
var $4d82739dd229d539$export$c78a37762a8d58e1;
var $4d82739dd229d539$export$dc54d992c10e8a18;
var $4d82739dd229d539$export$83d89fbfd8236492;
'use strict';

var $7fPBF = parcelRequire("7fPBF");

var $33s19 = parcelRequire("33s19");
function $4d82739dd229d539$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4d82739dd229d539$var$da = new Set, $4d82739dd229d539$var$ea = {};
function $4d82739dd229d539$var$fa(a, b) {
    $4d82739dd229d539$var$ha(a, b);
    $4d82739dd229d539$var$ha(a + "Capture", b);
}
function $4d82739dd229d539$var$ha(a, b) {
    $4d82739dd229d539$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$4d82739dd229d539$var$da.add(b[a]);
}
var $4d82739dd229d539$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4d82739dd229d539$var$ja = Object.prototype.hasOwnProperty, $4d82739dd229d539$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4d82739dd229d539$var$la = {}, $4d82739dd229d539$var$ma = {};
function $4d82739dd229d539$var$oa(a) {
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$ma, a)) return !0;
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$la, a)) return !1;
    if ($4d82739dd229d539$var$ka.test(a)) return $4d82739dd229d539$var$ma[a] = !0;
    $4d82739dd229d539$var$la[a] = !0;
    return !1;
}
function $4d82739dd229d539$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4d82739dd229d539$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4d82739dd229d539$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $4d82739dd229d539$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $4d82739dd229d539$var$ra = /[\-:]([a-z])/g;
function $4d82739dd229d539$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$4d82739dd229d539$var$z.xlinkHref = new $4d82739dd229d539$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $4d82739dd229d539$var$ta(a, b, c, d) {
    var e = $4d82739dd229d539$var$z.hasOwnProperty(b) ? $4d82739dd229d539$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $4d82739dd229d539$var$qa(b, c, e, d) && (c = null), d || null === e ? $4d82739dd229d539$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $4d82739dd229d539$var$ua = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4d82739dd229d539$var$va = Symbol.for("react.element"), $4d82739dd229d539$var$wa = Symbol.for("react.portal"), $4d82739dd229d539$var$ya = Symbol.for("react.fragment"), $4d82739dd229d539$var$za = Symbol.for("react.strict_mode"), $4d82739dd229d539$var$Aa = Symbol.for("react.profiler"), $4d82739dd229d539$var$Ba = Symbol.for("react.provider"), $4d82739dd229d539$var$Ca = Symbol.for("react.context"), $4d82739dd229d539$var$Da = Symbol.for("react.forward_ref"), $4d82739dd229d539$var$Ea = Symbol.for("react.suspense"), $4d82739dd229d539$var$Fa = Symbol.for("react.suspense_list"), $4d82739dd229d539$var$Ga = Symbol.for("react.memo"), $4d82739dd229d539$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $4d82739dd229d539$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $4d82739dd229d539$var$Ja = Symbol.iterator;
function $4d82739dd229d539$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4d82739dd229d539$var$Ja && a[$4d82739dd229d539$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4d82739dd229d539$var$A = Object.assign, $4d82739dd229d539$var$La;
function $4d82739dd229d539$var$Ma(a) {
    if (void 0 === $4d82739dd229d539$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $4d82739dd229d539$var$La = b && b[1] || "";
    }
    return "\n" + $4d82739dd229d539$var$La + a;
}
var $4d82739dd229d539$var$Na = !1;
function $4d82739dd229d539$var$Oa(a, b) {
    if (!a || $4d82739dd229d539$var$Na) return "";
    $4d82739dd229d539$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $4d82739dd229d539$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $4d82739dd229d539$var$Ma(a) : "";
}
function $4d82739dd229d539$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $4d82739dd229d539$var$Ma(a.type);
        case 16:
            return $4d82739dd229d539$var$Ma("Lazy");
        case 13:
            return $4d82739dd229d539$var$Ma("Suspense");
        case 19:
            return $4d82739dd229d539$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $4d82739dd229d539$var$Oa(a.type, !1), a;
        case 11:
            return a = $4d82739dd229d539$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $4d82739dd229d539$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4d82739dd229d539$var$ya:
            return "Fragment";
        case $4d82739dd229d539$var$wa:
            return "Portal";
        case $4d82739dd229d539$var$Aa:
            return "Profiler";
        case $4d82739dd229d539$var$za:
            return "StrictMode";
        case $4d82739dd229d539$var$Ea:
            return "Suspense";
        case $4d82739dd229d539$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4d82739dd229d539$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $4d82739dd229d539$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $4d82739dd229d539$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $4d82739dd229d539$var$Ga:
            return b = a.displayName || null, null !== b ? b : $4d82739dd229d539$var$Qa(a.type) || "Memo";
        case $4d82739dd229d539$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $4d82739dd229d539$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $4d82739dd229d539$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $4d82739dd229d539$var$Qa(b);
        case 8:
            return b === $4d82739dd229d539$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $4d82739dd229d539$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4d82739dd229d539$var$Ua(a) {
    var b = $4d82739dd229d539$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4d82739dd229d539$var$Va(a) {
    a._valueTracker || (a._valueTracker = $4d82739dd229d539$var$Ua(a));
}
function $4d82739dd229d539$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4d82739dd229d539$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $4d82739dd229d539$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4d82739dd229d539$var$Ya(a, b) {
    var c = b.checked;
    return $4d82739dd229d539$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4d82739dd229d539$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4d82739dd229d539$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4d82739dd229d539$var$ab(a, b) {
    b = b.checked;
    null != b && $4d82739dd229d539$var$ta(a, "checked", b, !1);
}
function $4d82739dd229d539$var$bb(a, b) {
    $4d82739dd229d539$var$ab(a, b);
    var c = $4d82739dd229d539$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4d82739dd229d539$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4d82739dd229d539$var$cb(a, b.type, $4d82739dd229d539$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4d82739dd229d539$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4d82739dd229d539$var$cb(a, b, c) {
    if ("number" !== b || $4d82739dd229d539$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4d82739dd229d539$var$eb = Array.isArray;
function $4d82739dd229d539$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4d82739dd229d539$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4d82739dd229d539$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($4d82739dd229d539$var$p(91));
    return $4d82739dd229d539$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4d82739dd229d539$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($4d82739dd229d539$var$p(92));
            if ($4d82739dd229d539$var$eb(c)) {
                if (1 < c.length) throw Error($4d82739dd229d539$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $4d82739dd229d539$var$Sa(c)
    };
}
function $4d82739dd229d539$var$ib(a, b) {
    var c = $4d82739dd229d539$var$Sa(b.value), d = $4d82739dd229d539$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4d82739dd229d539$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $4d82739dd229d539$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4d82739dd229d539$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4d82739dd229d539$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4d82739dd229d539$var$mb, $4d82739dd229d539$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $4d82739dd229d539$var$mb = $4d82739dd229d539$var$mb || document.createElement("div");
        $4d82739dd229d539$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $4d82739dd229d539$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4d82739dd229d539$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4d82739dd229d539$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4d82739dd229d539$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4d82739dd229d539$var$pb).forEach(function(a) {
    $4d82739dd229d539$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4d82739dd229d539$var$pb[b] = $4d82739dd229d539$var$pb[a];
    });
});
function $4d82739dd229d539$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4d82739dd229d539$var$pb.hasOwnProperty(a) && $4d82739dd229d539$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $4d82739dd229d539$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4d82739dd229d539$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4d82739dd229d539$var$tb = $4d82739dd229d539$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4d82739dd229d539$var$ub(a, b) {
    if (b) {
        if ($4d82739dd229d539$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($4d82739dd229d539$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($4d82739dd229d539$var$p(62));
    }
}
function $4d82739dd229d539$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4d82739dd229d539$var$wb = null;
function $4d82739dd229d539$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $4d82739dd229d539$var$yb = null, $4d82739dd229d539$var$zb = null, $4d82739dd229d539$var$Ab = null;
function $4d82739dd229d539$var$Bb(a) {
    if (a = $4d82739dd229d539$var$Cb(a)) {
        if ("function" !== typeof $4d82739dd229d539$var$yb) throw Error($4d82739dd229d539$var$p(280));
        var b = a.stateNode;
        b && (b = $4d82739dd229d539$var$Db(b), $4d82739dd229d539$var$yb(a.stateNode, a.type, b));
    }
}
function $4d82739dd229d539$var$Eb(a) {
    $4d82739dd229d539$var$zb ? $4d82739dd229d539$var$Ab ? $4d82739dd229d539$var$Ab.push(a) : $4d82739dd229d539$var$Ab = [
        a
    ] : $4d82739dd229d539$var$zb = a;
}
function $4d82739dd229d539$var$Fb() {
    if ($4d82739dd229d539$var$zb) {
        var a = $4d82739dd229d539$var$zb, b = $4d82739dd229d539$var$Ab;
        $4d82739dd229d539$var$Ab = $4d82739dd229d539$var$zb = null;
        $4d82739dd229d539$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$4d82739dd229d539$var$Bb(b[a]);
    }
}
function $4d82739dd229d539$var$Gb(a, b) {
    return a(b);
}
function $4d82739dd229d539$var$Hb() {}
var $4d82739dd229d539$var$Ib = !1;
function $4d82739dd229d539$var$Jb(a, b, c) {
    if ($4d82739dd229d539$var$Ib) return a(b, c);
    $4d82739dd229d539$var$Ib = !0;
    try {
        return $4d82739dd229d539$var$Gb(a, b, c);
    } finally{
        if ($4d82739dd229d539$var$Ib = !1, null !== $4d82739dd229d539$var$zb || null !== $4d82739dd229d539$var$Ab) $4d82739dd229d539$var$Hb(), $4d82739dd229d539$var$Fb();
    }
}
function $4d82739dd229d539$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $4d82739dd229d539$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($4d82739dd229d539$var$p(231, b, typeof c));
    return c;
}
var $4d82739dd229d539$var$Lb = !1;
if ($4d82739dd229d539$var$ia) try {
    var $4d82739dd229d539$var$Mb = {};
    Object.defineProperty($4d82739dd229d539$var$Mb, "passive", {
        get: function() {
            $4d82739dd229d539$var$Lb = !0;
        }
    });
    window.addEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
    window.removeEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
} catch (a) {
    $4d82739dd229d539$var$Lb = !1;
}
function $4d82739dd229d539$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $4d82739dd229d539$var$Ob = !1, $4d82739dd229d539$var$Pb = null, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, $4d82739dd229d539$var$Sb = {
    onError: function(a) {
        $4d82739dd229d539$var$Ob = !0;
        $4d82739dd229d539$var$Pb = a;
    }
};
function $4d82739dd229d539$var$Tb(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Ob = !1;
    $4d82739dd229d539$var$Pb = null;
    $4d82739dd229d539$var$Nb.apply($4d82739dd229d539$var$Sb, arguments);
}
function $4d82739dd229d539$var$Ub(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Tb.apply(this, arguments);
    if ($4d82739dd229d539$var$Ob) {
        if ($4d82739dd229d539$var$Ob) {
            var l = $4d82739dd229d539$var$Pb;
            $4d82739dd229d539$var$Ob = !1;
            $4d82739dd229d539$var$Pb = null;
        } else throw Error($4d82739dd229d539$var$p(198));
        $4d82739dd229d539$var$Qb || ($4d82739dd229d539$var$Qb = !0, $4d82739dd229d539$var$Rb = l);
    }
}
function $4d82739dd229d539$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $4d82739dd229d539$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $4d82739dd229d539$var$Xb(a) {
    if ($4d82739dd229d539$var$Vb(a) !== a) throw Error($4d82739dd229d539$var$p(188));
}
function $4d82739dd229d539$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $4d82739dd229d539$var$Vb(a);
        if (null === b) throw Error($4d82739dd229d539$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $4d82739dd229d539$var$Xb(e), a;
                if (f === d) return $4d82739dd229d539$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($4d82739dd229d539$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($4d82739dd229d539$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($4d82739dd229d539$var$p(190));
    }
    if (3 !== c.tag) throw Error($4d82739dd229d539$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $4d82739dd229d539$var$Zb(a) {
    a = $4d82739dd229d539$var$Yb(a);
    return null !== a ? $4d82739dd229d539$var$$b(a) : null;
}
function $4d82739dd229d539$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $4d82739dd229d539$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$ac = $33s19.unstable_scheduleCallback, $4d82739dd229d539$var$bc = $33s19.unstable_cancelCallback, $4d82739dd229d539$var$cc = $33s19.unstable_shouldYield, $4d82739dd229d539$var$dc = $33s19.unstable_requestPaint, $4d82739dd229d539$var$B = $33s19.unstable_now, $4d82739dd229d539$var$ec = $33s19.unstable_getCurrentPriorityLevel, $4d82739dd229d539$var$fc = $33s19.unstable_ImmediatePriority, $4d82739dd229d539$var$gc = $33s19.unstable_UserBlockingPriority, $4d82739dd229d539$var$hc = $33s19.unstable_NormalPriority, $4d82739dd229d539$var$ic = $33s19.unstable_LowPriority, $4d82739dd229d539$var$jc = $33s19.unstable_IdlePriority, $4d82739dd229d539$var$kc = null, $4d82739dd229d539$var$lc = null;
function $4d82739dd229d539$var$mc(a) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberRoot) try {
        $4d82739dd229d539$var$lc.onCommitFiberRoot($4d82739dd229d539$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $4d82739dd229d539$var$oc = Math.clz32 ? Math.clz32 : $4d82739dd229d539$var$nc, $4d82739dd229d539$var$pc = Math.log, $4d82739dd229d539$var$qc = Math.LN2;
function $4d82739dd229d539$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($4d82739dd229d539$var$pc(a) / $4d82739dd229d539$var$qc | 0) | 0;
}
var $4d82739dd229d539$var$rc = 64, $4d82739dd229d539$var$sc = 4194304;
function $4d82739dd229d539$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $4d82739dd229d539$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $4d82739dd229d539$var$tc(h) : (f &= g, 0 !== f && (d = $4d82739dd229d539$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $4d82739dd229d539$var$tc(g) : 0 !== f && (d = $4d82739dd229d539$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $4d82739dd229d539$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $4d82739dd229d539$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4d82739dd229d539$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $4d82739dd229d539$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $4d82739dd229d539$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $4d82739dd229d539$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $4d82739dd229d539$var$yc() {
    var a = $4d82739dd229d539$var$rc;
    $4d82739dd229d539$var$rc <<= 1;
    0 === ($4d82739dd229d539$var$rc & 4194240) && ($4d82739dd229d539$var$rc = 64);
    return a;
}
function $4d82739dd229d539$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $4d82739dd229d539$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $4d82739dd229d539$var$oc(b);
    a[b] = c;
}
function $4d82739dd229d539$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $4d82739dd229d539$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $4d82739dd229d539$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $4d82739dd229d539$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $4d82739dd229d539$var$C = 0;
function $4d82739dd229d539$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $4d82739dd229d539$var$Ec, $4d82739dd229d539$var$Fc, $4d82739dd229d539$var$Gc, $4d82739dd229d539$var$Hc, $4d82739dd229d539$var$Ic, $4d82739dd229d539$var$Jc = !1, $4d82739dd229d539$var$Kc = [], $4d82739dd229d539$var$Lc = null, $4d82739dd229d539$var$Mc = null, $4d82739dd229d539$var$Nc = null, $4d82739dd229d539$var$Oc = new Map, $4d82739dd229d539$var$Pc = new Map, $4d82739dd229d539$var$Qc = [], $4d82739dd229d539$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $4d82739dd229d539$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $4d82739dd229d539$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $4d82739dd229d539$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $4d82739dd229d539$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $4d82739dd229d539$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4d82739dd229d539$var$Pc.delete(b.pointerId);
    }
}
function $4d82739dd229d539$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $4d82739dd229d539$var$Cb(b), null !== b && $4d82739dd229d539$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $4d82739dd229d539$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $4d82739dd229d539$var$Lc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $4d82739dd229d539$var$Mc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $4d82739dd229d539$var$Nc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $4d82739dd229d539$var$Oc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $4d82739dd229d539$var$Pc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $4d82739dd229d539$var$Vc(a) {
    var b = $4d82739dd229d539$var$Wc(a.target);
    if (null !== b) {
        var c = $4d82739dd229d539$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $4d82739dd229d539$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $4d82739dd229d539$var$Ic(a.priority, function() {
                        $4d82739dd229d539$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $4d82739dd229d539$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $4d82739dd229d539$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $4d82739dd229d539$var$wb = d;
            c.target.dispatchEvent(d);
            $4d82739dd229d539$var$wb = null;
        } else return b = $4d82739dd229d539$var$Cb(c), null !== b && $4d82739dd229d539$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $4d82739dd229d539$var$Zc(a, b, c) {
    $4d82739dd229d539$var$Xc(a) && c.delete(b);
}
function $4d82739dd229d539$var$$c() {
    $4d82739dd229d539$var$Jc = !1;
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Lc) && ($4d82739dd229d539$var$Lc = null);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Mc) && ($4d82739dd229d539$var$Mc = null);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Nc) && ($4d82739dd229d539$var$Nc = null);
    $4d82739dd229d539$var$Oc.forEach($4d82739dd229d539$var$Zc);
    $4d82739dd229d539$var$Pc.forEach($4d82739dd229d539$var$Zc);
}
function $4d82739dd229d539$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $4d82739dd229d539$var$Jc || ($4d82739dd229d539$var$Jc = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, $4d82739dd229d539$var$$c)));
}
function $4d82739dd229d539$var$bd(a) {
    function b(b) {
        return $4d82739dd229d539$var$ad(b, a);
    }
    if (0 < $4d82739dd229d539$var$Kc.length) {
        $4d82739dd229d539$var$ad($4d82739dd229d539$var$Kc[0], a);
        for(var c = 1; c < $4d82739dd229d539$var$Kc.length; c++){
            var d = $4d82739dd229d539$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Lc, a);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Mc, a);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Nc, a);
    $4d82739dd229d539$var$Oc.forEach(b);
    $4d82739dd229d539$var$Pc.forEach(b);
    for(c = 0; c < $4d82739dd229d539$var$Qc.length; c++)d = $4d82739dd229d539$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $4d82739dd229d539$var$Qc.length && (c = $4d82739dd229d539$var$Qc[0], null === c.blockedOn);)$4d82739dd229d539$var$Vc(c), null === c.blockedOn && $4d82739dd229d539$var$Qc.shift();
}
var $4d82739dd229d539$var$cd = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$dd = !0;
function $4d82739dd229d539$var$ed(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$gd(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 4, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$fd(a, b, c, d) {
    if ($4d82739dd229d539$var$dd) {
        var e = $4d82739dd229d539$var$Yc(a, b, c, d);
        if (null === e) $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c), $4d82739dd229d539$var$Sc(a, d);
        else if ($4d82739dd229d539$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($4d82739dd229d539$var$Sc(a, d), b & 4 && -1 < $4d82739dd229d539$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $4d82739dd229d539$var$Cb(e);
                null !== f && $4d82739dd229d539$var$Ec(f);
                f = $4d82739dd229d539$var$Yc(a, b, c, d);
                null === f && $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $4d82739dd229d539$var$hd(a, b, d, null, c);
    }
}
var $4d82739dd229d539$var$id = null;
function $4d82739dd229d539$var$Yc(a, b, c, d) {
    $4d82739dd229d539$var$id = null;
    a = $4d82739dd229d539$var$xb(d);
    a = $4d82739dd229d539$var$Wc(a);
    if (null !== a) {
        if (b = $4d82739dd229d539$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $4d82739dd229d539$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $4d82739dd229d539$var$id = a;
    return null;
}
function $4d82739dd229d539$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($4d82739dd229d539$var$ec()){
                case $4d82739dd229d539$var$fc:
                    return 1;
                case $4d82739dd229d539$var$gc:
                    return 4;
                case $4d82739dd229d539$var$hc:
                case $4d82739dd229d539$var$ic:
                    return 16;
                case $4d82739dd229d539$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ld = null, $4d82739dd229d539$var$md = null;
function $4d82739dd229d539$var$nd() {
    if ($4d82739dd229d539$var$md) return $4d82739dd229d539$var$md;
    var a, b = $4d82739dd229d539$var$ld, c = b.length, d, e = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4d82739dd229d539$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4d82739dd229d539$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $4d82739dd229d539$var$pd() {
    return !0;
}
function $4d82739dd229d539$var$qd() {
    return !1;
}
function $4d82739dd229d539$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $4d82739dd229d539$var$pd : $4d82739dd229d539$var$qd;
        this.isPropagationStopped = $4d82739dd229d539$var$qd;
        return this;
    }
    $4d82739dd229d539$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4d82739dd229d539$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4d82739dd229d539$var$pd);
        },
        persist: function() {},
        isPersistent: $4d82739dd229d539$var$pd
    });
    return b;
}
var $4d82739dd229d539$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4d82739dd229d539$var$td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$sd), $4d82739dd229d539$var$ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    view: 0,
    detail: 0
}), $4d82739dd229d539$var$vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$ud), $4d82739dd229d539$var$wd, $4d82739dd229d539$var$xd, $4d82739dd229d539$var$yd, $4d82739dd229d539$var$Ad = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $4d82739dd229d539$var$yd && ($4d82739dd229d539$var$yd && "mousemove" === a.type ? ($4d82739dd229d539$var$wd = a.screenX - $4d82739dd229d539$var$yd.screenX, $4d82739dd229d539$var$xd = a.screenY - $4d82739dd229d539$var$yd.screenY) : $4d82739dd229d539$var$xd = $4d82739dd229d539$var$wd = 0, $4d82739dd229d539$var$yd = a);
        return $4d82739dd229d539$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $4d82739dd229d539$var$xd;
    }
}), $4d82739dd229d539$var$Bd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ad), $4d82739dd229d539$var$Cd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    dataTransfer: 0
}), $4d82739dd229d539$var$Dd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Cd), $4d82739dd229d539$var$Ed = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    relatedTarget: 0
}), $4d82739dd229d539$var$Fd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ed), $4d82739dd229d539$var$Gd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Hd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Gd), $4d82739dd229d539$var$Id = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4d82739dd229d539$var$Jd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Id), $4d82739dd229d539$var$Kd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    data: 0
}), $4d82739dd229d539$var$Ld = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Kd), $4d82739dd229d539$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4d82739dd229d539$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4d82739dd229d539$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4d82739dd229d539$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4d82739dd229d539$var$Od[a]) ? !!b[a] : !1;
}
function $4d82739dd229d539$var$zd() {
    return $4d82739dd229d539$var$Pd;
}
var $4d82739dd229d539$var$Qd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $4d82739dd229d539$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4d82739dd229d539$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4d82739dd229d539$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4d82739dd229d539$var$Rd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Qd), $4d82739dd229d539$var$Sd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4d82739dd229d539$var$Td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Sd), $4d82739dd229d539$var$Ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4d82739dd229d539$var$zd
}), $4d82739dd229d539$var$Vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ud), $4d82739dd229d539$var$Wd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Xd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Wd), $4d82739dd229d539$var$Yd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4d82739dd229d539$var$Zd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Yd), $4d82739dd229d539$var$$d = [
    9,
    13,
    27,
    32
], $4d82739dd229d539$var$ae = $4d82739dd229d539$var$ia && "CompositionEvent" in window, $4d82739dd229d539$var$be = null;
$4d82739dd229d539$var$ia && "documentMode" in document && ($4d82739dd229d539$var$be = document.documentMode);
var $4d82739dd229d539$var$ce = $4d82739dd229d539$var$ia && "TextEvent" in window && !$4d82739dd229d539$var$be, $4d82739dd229d539$var$de = $4d82739dd229d539$var$ia && (!$4d82739dd229d539$var$ae || $4d82739dd229d539$var$be && 8 < $4d82739dd229d539$var$be && 11 >= $4d82739dd229d539$var$be), $4d82739dd229d539$var$ee = String.fromCharCode(32), $4d82739dd229d539$var$fe = !1;
function $4d82739dd229d539$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4d82739dd229d539$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4d82739dd229d539$var$ie = !1;
function $4d82739dd229d539$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $4d82739dd229d539$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4d82739dd229d539$var$fe = !0;
            return $4d82739dd229d539$var$ee;
        case "textInput":
            return a = b.data, a === $4d82739dd229d539$var$ee && $4d82739dd229d539$var$fe ? null : a;
        default:
            return null;
    }
}
function $4d82739dd229d539$var$ke(a, b) {
    if ($4d82739dd229d539$var$ie) return "compositionend" === a || !$4d82739dd229d539$var$ae && $4d82739dd229d539$var$ge(a, b) ? (a = $4d82739dd229d539$var$nd(), $4d82739dd229d539$var$md = $4d82739dd229d539$var$ld = $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4d82739dd229d539$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4d82739dd229d539$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4d82739dd229d539$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $4d82739dd229d539$var$ne(a, b, c, d) {
    $4d82739dd229d539$var$Eb(d);
    b = $4d82739dd229d539$var$oe(b, "onChange");
    0 < b.length && (c = new $4d82739dd229d539$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $4d82739dd229d539$var$pe = null, $4d82739dd229d539$var$qe = null;
function $4d82739dd229d539$var$re(a) {
    $4d82739dd229d539$var$se(a, 0);
}
function $4d82739dd229d539$var$te(a) {
    var b = $4d82739dd229d539$var$ue(a);
    if ($4d82739dd229d539$var$Wa(b)) return a;
}
function $4d82739dd229d539$var$ve(a, b) {
    if ("change" === a) return b;
}
var $4d82739dd229d539$var$we = !1;
if ($4d82739dd229d539$var$ia) {
    var $4d82739dd229d539$var$xe;
    if ($4d82739dd229d539$var$ia) {
        var $4d82739dd229d539$var$ye = "oninput" in document;
        if (!$4d82739dd229d539$var$ye) {
            var $4d82739dd229d539$var$ze = document.createElement("div");
            $4d82739dd229d539$var$ze.setAttribute("oninput", "return;");
            $4d82739dd229d539$var$ye = "function" === typeof $4d82739dd229d539$var$ze.oninput;
        }
        $4d82739dd229d539$var$xe = $4d82739dd229d539$var$ye;
    } else $4d82739dd229d539$var$xe = !1;
    $4d82739dd229d539$var$we = $4d82739dd229d539$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $4d82739dd229d539$var$Ae() {
    $4d82739dd229d539$var$pe && ($4d82739dd229d539$var$pe.detachEvent("onpropertychange", $4d82739dd229d539$var$Be), $4d82739dd229d539$var$qe = $4d82739dd229d539$var$pe = null);
}
function $4d82739dd229d539$var$Be(a) {
    if ("value" === a.propertyName && $4d82739dd229d539$var$te($4d82739dd229d539$var$qe)) {
        var b = [];
        $4d82739dd229d539$var$ne(b, $4d82739dd229d539$var$qe, a, $4d82739dd229d539$var$xb(a));
        $4d82739dd229d539$var$Jb($4d82739dd229d539$var$re, b);
    }
}
function $4d82739dd229d539$var$Ce(a, b, c) {
    "focusin" === a ? ($4d82739dd229d539$var$Ae(), $4d82739dd229d539$var$pe = b, $4d82739dd229d539$var$qe = c, $4d82739dd229d539$var$pe.attachEvent("onpropertychange", $4d82739dd229d539$var$Be)) : "focusout" === a && $4d82739dd229d539$var$Ae();
}
function $4d82739dd229d539$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4d82739dd229d539$var$te($4d82739dd229d539$var$qe);
}
function $4d82739dd229d539$var$Ee(a, b) {
    if ("click" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4d82739dd229d539$var$He = "function" === typeof Object.is ? Object.is : $4d82739dd229d539$var$Ge;
function $4d82739dd229d539$var$Ie(a, b) {
    if ($4d82739dd229d539$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$4d82739dd229d539$var$ja.call(b, e) || !$4d82739dd229d539$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $4d82739dd229d539$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4d82739dd229d539$var$Ke(a, b) {
    var c = $4d82739dd229d539$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4d82739dd229d539$var$Je(c);
    }
}
function $4d82739dd229d539$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4d82739dd229d539$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4d82739dd229d539$var$Me() {
    for(var a = window, b = $4d82739dd229d539$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $4d82739dd229d539$var$Xa(a.document);
    }
    return b;
}
function $4d82739dd229d539$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $4d82739dd229d539$var$Oe(a) {
    var b = $4d82739dd229d539$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $4d82739dd229d539$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $4d82739dd229d539$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $4d82739dd229d539$var$Ke(c, f);
                var g = $4d82739dd229d539$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $4d82739dd229d539$var$Pe = $4d82739dd229d539$var$ia && "documentMode" in document && 11 >= document.documentMode, $4d82739dd229d539$var$Qe = null, $4d82739dd229d539$var$Re = null, $4d82739dd229d539$var$Se = null, $4d82739dd229d539$var$Te = !1;
function $4d82739dd229d539$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $4d82739dd229d539$var$Te || null == $4d82739dd229d539$var$Qe || $4d82739dd229d539$var$Qe !== $4d82739dd229d539$var$Xa(d) || (d = $4d82739dd229d539$var$Qe, "selectionStart" in d && $4d82739dd229d539$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $4d82739dd229d539$var$Se && $4d82739dd229d539$var$Ie($4d82739dd229d539$var$Se, d) || ($4d82739dd229d539$var$Se = d, d = $4d82739dd229d539$var$oe($4d82739dd229d539$var$Re, "onSelect"), 0 < d.length && (b = new $4d82739dd229d539$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $4d82739dd229d539$var$Qe)));
}
function $4d82739dd229d539$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4d82739dd229d539$var$We = {
    animationend: $4d82739dd229d539$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $4d82739dd229d539$var$Ve("Animation", "AnimationIteration"),
    animationstart: $4d82739dd229d539$var$Ve("Animation", "AnimationStart"),
    transitionend: $4d82739dd229d539$var$Ve("Transition", "TransitionEnd")
}, $4d82739dd229d539$var$Xe = {}, $4d82739dd229d539$var$Ye = {};
$4d82739dd229d539$var$ia && ($4d82739dd229d539$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $4d82739dd229d539$var$We.animationend.animation, delete $4d82739dd229d539$var$We.animationiteration.animation, delete $4d82739dd229d539$var$We.animationstart.animation), "TransitionEvent" in window || delete $4d82739dd229d539$var$We.transitionend.transition);
function $4d82739dd229d539$var$Ze(a) {
    if ($4d82739dd229d539$var$Xe[a]) return $4d82739dd229d539$var$Xe[a];
    if (!$4d82739dd229d539$var$We[a]) return a;
    var b = $4d82739dd229d539$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4d82739dd229d539$var$Ye) return $4d82739dd229d539$var$Xe[a] = b[c];
    return a;
}
var $4d82739dd229d539$var$$e = $4d82739dd229d539$var$Ze("animationend"), $4d82739dd229d539$var$af = $4d82739dd229d539$var$Ze("animationiteration"), $4d82739dd229d539$var$bf = $4d82739dd229d539$var$Ze("animationstart"), $4d82739dd229d539$var$cf = $4d82739dd229d539$var$Ze("transitionend"), $4d82739dd229d539$var$df = new Map, $4d82739dd229d539$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $4d82739dd229d539$var$ff(a, b) {
    $4d82739dd229d539$var$df.set(a, b);
    $4d82739dd229d539$var$fa(b, [
        a
    ]);
}
for(var $4d82739dd229d539$var$gf = 0; $4d82739dd229d539$var$gf < $4d82739dd229d539$var$ef.length; $4d82739dd229d539$var$gf++){
    var $4d82739dd229d539$var$hf = $4d82739dd229d539$var$ef[$4d82739dd229d539$var$gf], $4d82739dd229d539$var$jf = $4d82739dd229d539$var$hf.toLowerCase(), $4d82739dd229d539$var$kf = $4d82739dd229d539$var$hf[0].toUpperCase() + $4d82739dd229d539$var$hf.slice(1);
    $4d82739dd229d539$var$ff($4d82739dd229d539$var$jf, "on" + $4d82739dd229d539$var$kf);
}
$4d82739dd229d539$var$ff($4d82739dd229d539$var$$e, "onAnimationEnd");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$af, "onAnimationIteration");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$bf, "onAnimationStart");
$4d82739dd229d539$var$ff("dblclick", "onDoubleClick");
$4d82739dd229d539$var$ff("focusin", "onFocus");
$4d82739dd229d539$var$ff("focusout", "onBlur");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$cf, "onTransitionEnd");
$4d82739dd229d539$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4d82739dd229d539$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4d82739dd229d539$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4d82739dd229d539$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($4d82739dd229d539$var$lf));
function $4d82739dd229d539$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $4d82739dd229d539$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $4d82739dd229d539$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($4d82739dd229d539$var$Qb) throw a = $4d82739dd229d539$var$Rb, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, a;
}
function $4d82739dd229d539$var$D(a, b) {
    var c = b[$4d82739dd229d539$var$of];
    void 0 === c && (c = b[$4d82739dd229d539$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($4d82739dd229d539$var$pf(b, a, 2, !1), c.add(d));
}
function $4d82739dd229d539$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $4d82739dd229d539$var$pf(c, a, d, b);
}
var $4d82739dd229d539$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $4d82739dd229d539$var$sf(a) {
    if (!a[$4d82739dd229d539$var$rf]) {
        a[$4d82739dd229d539$var$rf] = !0;
        $4d82739dd229d539$var$da.forEach(function(b) {
            "selectionchange" !== b && ($4d82739dd229d539$var$mf.has(b) || $4d82739dd229d539$var$qf(b, !1, a), $4d82739dd229d539$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$4d82739dd229d539$var$rf] || (b[$4d82739dd229d539$var$rf] = !0, $4d82739dd229d539$var$qf("selectionchange", !1, b));
    }
}
function $4d82739dd229d539$var$pf(a, b, c, d) {
    switch($4d82739dd229d539$var$jd(b)){
        case 1:
            var e = $4d82739dd229d539$var$ed;
            break;
        case 4:
            e = $4d82739dd229d539$var$gd;
            break;
        default:
            e = $4d82739dd229d539$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$4d82739dd229d539$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $4d82739dd229d539$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $4d82739dd229d539$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $4d82739dd229d539$var$Jb(function() {
        var d = f, e = $4d82739dd229d539$var$xb(c), g = [];
        a: {
            var h = $4d82739dd229d539$var$df.get(a);
            if (void 0 !== h) {
                var k = $4d82739dd229d539$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $4d82739dd229d539$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $4d82739dd229d539$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $4d82739dd229d539$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $4d82739dd229d539$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $4d82739dd229d539$var$Vd;
                        break;
                    case $4d82739dd229d539$var$$e:
                    case $4d82739dd229d539$var$af:
                    case $4d82739dd229d539$var$bf:
                        k = $4d82739dd229d539$var$Hd;
                        break;
                    case $4d82739dd229d539$var$cf:
                        k = $4d82739dd229d539$var$Xd;
                        break;
                    case "scroll":
                        k = $4d82739dd229d539$var$vd;
                        break;
                    case "wheel":
                        k = $4d82739dd229d539$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $4d82739dd229d539$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $4d82739dd229d539$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $4d82739dd229d539$var$Kb(w, x), null != F && t.push($4d82739dd229d539$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $4d82739dd229d539$var$wb && (n = c.relatedTarget || c.fromElement) && ($4d82739dd229d539$var$Wc(n) || n[$4d82739dd229d539$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $4d82739dd229d539$var$Wc(n) : null, null !== n && (J = $4d82739dd229d539$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $4d82739dd229d539$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $4d82739dd229d539$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $4d82739dd229d539$var$ue(k);
                        u = null == n ? h : $4d82739dd229d539$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $4d82739dd229d539$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $4d82739dd229d539$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $4d82739dd229d539$var$vf(F))u++;
                            for(; 0 < w - u;)t = $4d82739dd229d539$var$vf(t), w--;
                            for(; 0 < u - w;)x = $4d82739dd229d539$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $4d82739dd229d539$var$vf(t);
                                x = $4d82739dd229d539$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $4d82739dd229d539$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $4d82739dd229d539$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $4d82739dd229d539$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $4d82739dd229d539$var$ve;
                else if ($4d82739dd229d539$var$me(h)) {
                    if ($4d82739dd229d539$var$we) na = $4d82739dd229d539$var$Fe;
                    else {
                        na = $4d82739dd229d539$var$De;
                        var xa = $4d82739dd229d539$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $4d82739dd229d539$var$Ee);
                if (na && (na = na(a, d))) {
                    $4d82739dd229d539$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $4d82739dd229d539$var$cb(h, "number", h.value);
            }
            xa = d ? $4d82739dd229d539$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($4d82739dd229d539$var$me(xa) || "true" === xa.contentEditable) $4d82739dd229d539$var$Qe = xa, $4d82739dd229d539$var$Re = d, $4d82739dd229d539$var$Se = null;
                    break;
                case "focusout":
                    $4d82739dd229d539$var$Se = $4d82739dd229d539$var$Re = $4d82739dd229d539$var$Qe = null;
                    break;
                case "mousedown":
                    $4d82739dd229d539$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4d82739dd229d539$var$Te = !1;
                    $4d82739dd229d539$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($4d82739dd229d539$var$Pe) break;
                case "keydown":
                case "keyup":
                    $4d82739dd229d539$var$Ue(g, c, e);
            }
            var $a;
            if ($4d82739dd229d539$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $4d82739dd229d539$var$ie ? $4d82739dd229d539$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($4d82739dd229d539$var$de && "ko" !== c.locale && ($4d82739dd229d539$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $4d82739dd229d539$var$ie && ($a = $4d82739dd229d539$var$nd()) : ($4d82739dd229d539$var$kd = e, $4d82739dd229d539$var$ld = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, $4d82739dd229d539$var$ie = !0)), xa = $4d82739dd229d539$var$oe(d, ba), 0 < xa.length && (ba = new $4d82739dd229d539$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $4d82739dd229d539$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $4d82739dd229d539$var$ce ? $4d82739dd229d539$var$je(a, c) : $4d82739dd229d539$var$ke(a, c)) d = $4d82739dd229d539$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $4d82739dd229d539$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $4d82739dd229d539$var$se(g, b);
    });
}
function $4d82739dd229d539$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $4d82739dd229d539$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $4d82739dd229d539$var$Kb(a, c), null != f && d.unshift($4d82739dd229d539$var$tf(a, f, e)), f = $4d82739dd229d539$var$Kb(a, b), null != f && d.push($4d82739dd229d539$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $4d82739dd229d539$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4d82739dd229d539$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.unshift($4d82739dd229d539$var$tf(c, k, h))) : e || (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.push($4d82739dd229d539$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $4d82739dd229d539$var$xf = /\r\n?/g, $4d82739dd229d539$var$yf = /\u0000|\uFFFD/g;
function $4d82739dd229d539$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($4d82739dd229d539$var$xf, "\n").replace($4d82739dd229d539$var$yf, "");
}
function $4d82739dd229d539$var$Af(a, b, c) {
    b = $4d82739dd229d539$var$zf(b);
    if ($4d82739dd229d539$var$zf(a) !== b && c) throw Error($4d82739dd229d539$var$p(425));
}
function $4d82739dd229d539$var$Bf() {}
var $4d82739dd229d539$var$Cf = null, $4d82739dd229d539$var$Df = null;
function $4d82739dd229d539$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4d82739dd229d539$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $4d82739dd229d539$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $4d82739dd229d539$var$Hf = "function" === typeof Promise ? Promise : void 0, $4d82739dd229d539$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4d82739dd229d539$var$Hf ? function(a) {
    return $4d82739dd229d539$var$Hf.resolve(null).then(a).catch($4d82739dd229d539$var$If);
} : $4d82739dd229d539$var$Ff;
function $4d82739dd229d539$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $4d82739dd229d539$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $4d82739dd229d539$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $4d82739dd229d539$var$bd(b);
}
function $4d82739dd229d539$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $4d82739dd229d539$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nf = Math.random().toString(36).slice(2), $4d82739dd229d539$var$Of = "__reactFiber$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Pf = "__reactProps$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$uf = "__reactContainer$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$of = "__reactEvents$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Qf = "__reactListeners$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Rf = "__reactHandles$" + $4d82739dd229d539$var$Nf;
function $4d82739dd229d539$var$Wc(a) {
    var b = a[$4d82739dd229d539$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$4d82739dd229d539$var$uf] || c[$4d82739dd229d539$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $4d82739dd229d539$var$Mf(a); null !== a;){
                if (c = a[$4d82739dd229d539$var$Of]) return c;
                a = $4d82739dd229d539$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $4d82739dd229d539$var$Cb(a) {
    a = a[$4d82739dd229d539$var$Of] || a[$4d82739dd229d539$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $4d82739dd229d539$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($4d82739dd229d539$var$p(33));
}
function $4d82739dd229d539$var$Db(a) {
    return a[$4d82739dd229d539$var$Pf] || null;
}
var $4d82739dd229d539$var$Sf = [], $4d82739dd229d539$var$Tf = -1;
function $4d82739dd229d539$var$Uf(a) {
    return {
        current: a
    };
}
function $4d82739dd229d539$var$E(a) {
    0 > $4d82739dd229d539$var$Tf || (a.current = $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf], $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = null, $4d82739dd229d539$var$Tf--);
}
function $4d82739dd229d539$var$G(a, b) {
    $4d82739dd229d539$var$Tf++;
    $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = a.current;
    a.current = b;
}
var $4d82739dd229d539$var$Vf = {}, $4d82739dd229d539$var$H = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Vf), $4d82739dd229d539$var$Wf = $4d82739dd229d539$var$Uf(!1), $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$Vf;
function $4d82739dd229d539$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4d82739dd229d539$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4d82739dd229d539$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4d82739dd229d539$var$$f() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
}
function $4d82739dd229d539$var$ag(a, b, c) {
    if ($4d82739dd229d539$var$H.current !== $4d82739dd229d539$var$Vf) throw Error($4d82739dd229d539$var$p(168));
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
function $4d82739dd229d539$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($4d82739dd229d539$var$p(108, $4d82739dd229d539$var$Ra(a) || "Unknown", e));
    return $4d82739dd229d539$var$A({}, c, d);
}
function $4d82739dd229d539$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $4d82739dd229d539$var$Vf;
    $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$H.current;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, $4d82739dd229d539$var$Wf.current);
    return !0;
}
function $4d82739dd229d539$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($4d82739dd229d539$var$p(169));
    c ? (a = $4d82739dd229d539$var$bg(a, b, $4d82739dd229d539$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a)) : $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
var $4d82739dd229d539$var$eg = null, $4d82739dd229d539$var$fg = !1, $4d82739dd229d539$var$gg = !1;
function $4d82739dd229d539$var$hg(a) {
    null === $4d82739dd229d539$var$eg ? $4d82739dd229d539$var$eg = [
        a
    ] : $4d82739dd229d539$var$eg.push(a);
}
function $4d82739dd229d539$var$ig(a) {
    $4d82739dd229d539$var$fg = !0;
    $4d82739dd229d539$var$hg(a);
}
function $4d82739dd229d539$var$jg() {
    if (!$4d82739dd229d539$var$gg && null !== $4d82739dd229d539$var$eg) {
        $4d82739dd229d539$var$gg = !0;
        var a = 0, b = $4d82739dd229d539$var$C;
        try {
            var c = $4d82739dd229d539$var$eg;
            for($4d82739dd229d539$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $4d82739dd229d539$var$eg = null;
            $4d82739dd229d539$var$fg = !1;
        } catch (e) {
            throw null !== $4d82739dd229d539$var$eg && ($4d82739dd229d539$var$eg = $4d82739dd229d539$var$eg.slice(a + 1)), $4d82739dd229d539$var$ac($4d82739dd229d539$var$fc, $4d82739dd229d539$var$jg), e;
        } finally{
            $4d82739dd229d539$var$C = b, $4d82739dd229d539$var$gg = !1;
        }
    }
    return null;
}
var $4d82739dd229d539$var$kg = [], $4d82739dd229d539$var$lg = 0, $4d82739dd229d539$var$mg = null, $4d82739dd229d539$var$ng = 0, $4d82739dd229d539$var$og = [], $4d82739dd229d539$var$pg = 0, $4d82739dd229d539$var$qg = null, $4d82739dd229d539$var$rg = 1, $4d82739dd229d539$var$sg = "";
function $4d82739dd229d539$var$tg(a, b) {
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$ng;
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$mg;
    $4d82739dd229d539$var$mg = a;
    $4d82739dd229d539$var$ng = b;
}
function $4d82739dd229d539$var$ug(a, b, c) {
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg;
    $4d82739dd229d539$var$qg = a;
    var d = $4d82739dd229d539$var$rg;
    a = $4d82739dd229d539$var$sg;
    var e = 32 - $4d82739dd229d539$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $4d82739dd229d539$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $4d82739dd229d539$var$rg = 1 << 32 - $4d82739dd229d539$var$oc(b) + e | c << e | d;
        $4d82739dd229d539$var$sg = f + a;
    } else $4d82739dd229d539$var$rg = 1 << f | c << e | d, $4d82739dd229d539$var$sg = a;
}
function $4d82739dd229d539$var$vg(a) {
    null !== a.return && ($4d82739dd229d539$var$tg(a, 1), $4d82739dd229d539$var$ug(a, 1, 0));
}
function $4d82739dd229d539$var$wg(a) {
    for(; a === $4d82739dd229d539$var$mg;)$4d82739dd229d539$var$mg = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null, $4d82739dd229d539$var$ng = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null;
    for(; a === $4d82739dd229d539$var$qg;)$4d82739dd229d539$var$qg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$sg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$rg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null;
}
var $4d82739dd229d539$var$xg = null, $4d82739dd229d539$var$yg = null, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$zg = null;
function $4d82739dd229d539$var$Ag(a, b) {
    var c = $4d82739dd229d539$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $4d82739dd229d539$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $4d82739dd229d539$var$qg ? {
                id: $4d82739dd229d539$var$rg,
                overflow: $4d82739dd229d539$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $4d82739dd229d539$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $4d82739dd229d539$var$Eg(a) {
    if ($4d82739dd229d539$var$I) {
        var b = $4d82739dd229d539$var$yg;
        if (b) {
            var c = b;
            if (!$4d82739dd229d539$var$Cg(a, b)) {
                if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
                b = $4d82739dd229d539$var$Lf(c.nextSibling);
                var d = $4d82739dd229d539$var$xg;
                b && $4d82739dd229d539$var$Cg(a, b) ? $4d82739dd229d539$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$xg = a);
            }
        } else {
            if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $4d82739dd229d539$var$I = !1;
            $4d82739dd229d539$var$xg = a;
        }
    }
}
function $4d82739dd229d539$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $4d82739dd229d539$var$xg = a;
}
function $4d82739dd229d539$var$Gg(a) {
    if (a !== $4d82739dd229d539$var$xg) return !1;
    if (!$4d82739dd229d539$var$I) return $4d82739dd229d539$var$Fg(a), $4d82739dd229d539$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$4d82739dd229d539$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $4d82739dd229d539$var$yg)) {
        if ($4d82739dd229d539$var$Dg(a)) throw $4d82739dd229d539$var$Hg(), Error($4d82739dd229d539$var$p(418));
        for(; b;)$4d82739dd229d539$var$Ag(a, b), b = $4d82739dd229d539$var$Lf(b.nextSibling);
    }
    $4d82739dd229d539$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($4d82739dd229d539$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $4d82739dd229d539$var$yg = null;
        }
    } else $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg ? $4d82739dd229d539$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $4d82739dd229d539$var$Hg() {
    for(var a = $4d82739dd229d539$var$yg; a;)a = $4d82739dd229d539$var$Lf(a.nextSibling);
}
function $4d82739dd229d539$var$Ig() {
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg = null;
    $4d82739dd229d539$var$I = !1;
}
function $4d82739dd229d539$var$Jg(a) {
    null === $4d82739dd229d539$var$zg ? $4d82739dd229d539$var$zg = [
        a
    ] : $4d82739dd229d539$var$zg.push(a);
}
var $4d82739dd229d539$var$Kg = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig;
function $4d82739dd229d539$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($4d82739dd229d539$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($4d82739dd229d539$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($4d82739dd229d539$var$p(284));
        if (!c._owner) throw Error($4d82739dd229d539$var$p(290, a));
    }
    return a;
}
function $4d82739dd229d539$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($4d82739dd229d539$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $4d82739dd229d539$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $4d82739dd229d539$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $4d82739dd229d539$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4d82739dd229d539$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $4d82739dd229d539$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $4d82739dd229d539$var$Lg(a, b, c), d.return = a, d;
        d = $4d82739dd229d539$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4d82739dd229d539$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4d82739dd229d539$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4d82739dd229d539$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $4d82739dd229d539$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c = $4d82739dd229d539$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $4d82739dd229d539$var$Lg(a, null, b), c.return = a, c;
                case $4d82739dd229d539$var$wa:
                    return b = $4d82739dd229d539$var$Sg(b, a.mode, c), b.return = a, b;
                case $4d82739dd229d539$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($4d82739dd229d539$var$eb(b) || $4d82739dd229d539$var$Ka(b)) return b = $4d82739dd229d539$var$Tg(b, a.mode, c, null), b.return = a, b;
            $4d82739dd229d539$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $4d82739dd229d539$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $4d82739dd229d539$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($4d82739dd229d539$var$eb(c) || $4d82739dd229d539$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $4d82739dd229d539$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4d82739dd229d539$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $4d82739dd229d539$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $4d82739dd229d539$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($4d82739dd229d539$var$eb(d) || $4d82739dd229d539$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $4d82739dd229d539$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $4d82739dd229d539$var$Ka(h);
        if ("function" !== typeof l) throw Error($4d82739dd229d539$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($4d82739dd229d539$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $4d82739dd229d539$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $4d82739dd229d539$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $4d82739dd229d539$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $4d82739dd229d539$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $4d82739dd229d539$var$ya ? (d = $4d82739dd229d539$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4d82739dd229d539$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $4d82739dd229d539$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $4d82739dd229d539$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $4d82739dd229d539$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $4d82739dd229d539$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($4d82739dd229d539$var$eb(f)) return n(a, d, f, h);
            if ($4d82739dd229d539$var$Ka(f)) return t(a, d, f, h);
            $4d82739dd229d539$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $4d82739dd229d539$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $4d82739dd229d539$var$Ug = $4d82739dd229d539$var$Og(!0), $4d82739dd229d539$var$Vg = $4d82739dd229d539$var$Og(!1), $4d82739dd229d539$var$Wg = $4d82739dd229d539$var$Uf(null), $4d82739dd229d539$var$Xg = null, $4d82739dd229d539$var$Yg = null, $4d82739dd229d539$var$Zg = null;
function $4d82739dd229d539$var$$g() {
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Xg = null;
}
function $4d82739dd229d539$var$ah(a) {
    var b = $4d82739dd229d539$var$Wg.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wg);
    a._currentValue = b;
}
function $4d82739dd229d539$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $4d82739dd229d539$var$ch(a, b) {
    $4d82739dd229d539$var$Xg = a;
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($4d82739dd229d539$var$dh = !0), a.firstContext = null);
}
function $4d82739dd229d539$var$eh(a) {
    var b = a._currentValue;
    if ($4d82739dd229d539$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $4d82739dd229d539$var$Yg) {
            if (null === $4d82739dd229d539$var$Xg) throw Error($4d82739dd229d539$var$p(308));
            $4d82739dd229d539$var$Yg = a;
            $4d82739dd229d539$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Yg.next = a;
    }
    return b;
}
var $4d82739dd229d539$var$fh = null;
function $4d82739dd229d539$var$gh(a) {
    null === $4d82739dd229d539$var$fh ? $4d82739dd229d539$var$fh = [
        a
    ] : $4d82739dd229d539$var$fh.push(a);
}
function $4d82739dd229d539$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $4d82739dd229d539$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $4d82739dd229d539$var$ih(a, d);
}
function $4d82739dd229d539$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $4d82739dd229d539$var$jh = !1;
function $4d82739dd229d539$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $4d82739dd229d539$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $4d82739dd229d539$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4d82739dd229d539$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($4d82739dd229d539$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $4d82739dd229d539$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $4d82739dd229d539$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $4d82739dd229d539$var$ih(a, c);
}
function $4d82739dd229d539$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
function $4d82739dd229d539$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $4d82739dd229d539$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $4d82739dd229d539$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $4d82739dd229d539$var$A({}, q, r);
                            break a;
                        case 2:
                            $4d82739dd229d539$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $4d82739dd229d539$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $4d82739dd229d539$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($4d82739dd229d539$var$p(191, e));
            e.call(d);
        }
    }
}
var $4d82739dd229d539$var$th = {}, $4d82739dd229d539$var$uh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$vh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$wh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th);
function $4d82739dd229d539$var$xh(a) {
    if (a === $4d82739dd229d539$var$th) throw Error($4d82739dd229d539$var$p(174));
    return a;
}
function $4d82739dd229d539$var$yh(a, b) {
    $4d82739dd229d539$var$G($4d82739dd229d539$var$wh, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, $4d82739dd229d539$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4d82739dd229d539$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $4d82739dd229d539$var$lb(b, a);
    }
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, b);
}
function $4d82739dd229d539$var$zh() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$vh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$wh);
}
function $4d82739dd229d539$var$Ah(a) {
    $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
    var b = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
    var c = $4d82739dd229d539$var$lb(b, a.type);
    b !== c && ($4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a), $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, c));
}
function $4d82739dd229d539$var$Bh(a) {
    $4d82739dd229d539$var$vh.current === a && ($4d82739dd229d539$var$E($4d82739dd229d539$var$uh), $4d82739dd229d539$var$E($4d82739dd229d539$var$vh));
}
var $4d82739dd229d539$var$L = $4d82739dd229d539$var$Uf(0);
function $4d82739dd229d539$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$Dh = [];
function $4d82739dd229d539$var$Eh() {
    for(var a = 0; a < $4d82739dd229d539$var$Dh.length; a++)$4d82739dd229d539$var$Dh[a]._workInProgressVersionPrimary = null;
    $4d82739dd229d539$var$Dh.length = 0;
}
var $4d82739dd229d539$var$Fh = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$Gh = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$Hh = 0, $4d82739dd229d539$var$M = null, $4d82739dd229d539$var$N = null, $4d82739dd229d539$var$O = null, $4d82739dd229d539$var$Ih = !1, $4d82739dd229d539$var$Jh = !1, $4d82739dd229d539$var$Kh = 0, $4d82739dd229d539$var$Lh = 0;
function $4d82739dd229d539$var$P() {
    throw Error($4d82739dd229d539$var$p(321));
}
function $4d82739dd229d539$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4d82739dd229d539$var$He(a[c], b[c])) return !1;
    return !0;
}
function $4d82739dd229d539$var$Nh(a, b, c, d, e, f) {
    $4d82739dd229d539$var$Hh = f;
    $4d82739dd229d539$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $4d82739dd229d539$var$Fh.current = null === a || null === a.memoizedState ? $4d82739dd229d539$var$Oh : $4d82739dd229d539$var$Ph;
    a = c(d, e);
    if ($4d82739dd229d539$var$Jh) {
        f = 0;
        do {
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            if (25 <= f) throw Error($4d82739dd229d539$var$p(301));
            f += 1;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
            b.updateQueue = null;
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Qh;
            a = c(d, e);
        }while ($4d82739dd229d539$var$Jh);
    }
    $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
    b = null !== $4d82739dd229d539$var$N && null !== $4d82739dd229d539$var$N.next;
    $4d82739dd229d539$var$Hh = 0;
    $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
    $4d82739dd229d539$var$Ih = !1;
    if (b) throw Error($4d82739dd229d539$var$p(300));
    return a;
}
function $4d82739dd229d539$var$Sh() {
    var a = 0 !== $4d82739dd229d539$var$Kh;
    $4d82739dd229d539$var$Kh = 0;
    return a;
}
function $4d82739dd229d539$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Uh() {
    if (null === $4d82739dd229d539$var$N) {
        var a = $4d82739dd229d539$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $4d82739dd229d539$var$N.next;
    var b = null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState : $4d82739dd229d539$var$O.next;
    if (null !== b) $4d82739dd229d539$var$O = b, $4d82739dd229d539$var$N = a;
    else {
        if (null === a) throw Error($4d82739dd229d539$var$p(310));
        $4d82739dd229d539$var$N = a;
        a = {
            memoizedState: $4d82739dd229d539$var$N.memoizedState,
            baseState: $4d82739dd229d539$var$N.baseState,
            baseQueue: $4d82739dd229d539$var$N.baseQueue,
            queue: $4d82739dd229d539$var$N.queue,
            next: null
        };
        null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    }
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4d82739dd229d539$var$Wh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = $4d82739dd229d539$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($4d82739dd229d539$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $4d82739dd229d539$var$M.lanes |= m;
                $4d82739dd229d539$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $4d82739dd229d539$var$He(d, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $4d82739dd229d539$var$M.lanes |= f, $4d82739dd229d539$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4d82739dd229d539$var$Xh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $4d82739dd229d539$var$He(f, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $4d82739dd229d539$var$Yh() {}
function $4d82739dd229d539$var$Zh(a, b) {
    var c = $4d82739dd229d539$var$M, d = $4d82739dd229d539$var$Uh(), e = b(), f = !$4d82739dd229d539$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $4d82739dd229d539$var$dh = !0);
    d = d.queue;
    $4d82739dd229d539$var$$h($4d82739dd229d539$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $4d82739dd229d539$var$O && $4d82739dd229d539$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
        0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(c, b, e);
    }
    return e;
}
function $4d82739dd229d539$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $4d82739dd229d539$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
}
function $4d82739dd229d539$var$ai(a, b, c) {
    return c(function() {
        $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
    });
}
function $4d82739dd229d539$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$4d82739dd229d539$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $4d82739dd229d539$var$fi(a) {
    var b = $4d82739dd229d539$var$ih(a, 1);
    null !== b && $4d82739dd229d539$var$gi(b, a, 1, -1);
}
function $4d82739dd229d539$var$hi(a) {
    var b = $4d82739dd229d539$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4d82739dd229d539$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $4d82739dd229d539$var$ii.bind(null, $4d82739dd229d539$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $4d82739dd229d539$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $4d82739dd229d539$var$ji() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$ki(a, b, c, d) {
    var e = $4d82739dd229d539$var$Th();
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $4d82739dd229d539$var$li(a, b, c, d) {
    var e = $4d82739dd229d539$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4d82739dd229d539$var$N) {
        var g = $4d82739dd229d539$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $4d82739dd229d539$var$Mh(d, g.deps)) {
            e.memoizedState = $4d82739dd229d539$var$bi(b, c, f, d);
            return;
        }
    }
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, f, d);
}
function $4d82739dd229d539$var$mi(a, b) {
    return $4d82739dd229d539$var$ki(8390656, 8, a, b);
}
function $4d82739dd229d539$var$$h(a, b) {
    return $4d82739dd229d539$var$li(2048, 8, a, b);
}
function $4d82739dd229d539$var$ni(a, b) {
    return $4d82739dd229d539$var$li(4, 2, a, b);
}
function $4d82739dd229d539$var$oi(a, b) {
    return $4d82739dd229d539$var$li(4, 4, a, b);
}
function $4d82739dd229d539$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4d82739dd229d539$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $4d82739dd229d539$var$li(4, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
}
function $4d82739dd229d539$var$ri() {}
function $4d82739dd229d539$var$si(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ti(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ui(a, b, c) {
    if (0 === ($4d82739dd229d539$var$Hh & 21)) return a.baseState && (a.baseState = !1, $4d82739dd229d539$var$dh = !0), a.memoizedState = c;
    $4d82739dd229d539$var$He(c, b) || (c = $4d82739dd229d539$var$yc(), $4d82739dd229d539$var$M.lanes |= c, $4d82739dd229d539$var$rh |= c, a.baseState = !0);
    return b;
}
function $4d82739dd229d539$var$vi(a, b) {
    var c = $4d82739dd229d539$var$C;
    $4d82739dd229d539$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $4d82739dd229d539$var$Gh.transition;
    $4d82739dd229d539$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$Gh.transition = d;
    }
}
function $4d82739dd229d539$var$wi() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$xi(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, c);
    else if (c = $4d82739dd229d539$var$hh(a, b, c, d), null !== c) {
        var e = $4d82739dd229d539$var$R();
        $4d82739dd229d539$var$gi(c, a, d, e);
        $4d82739dd229d539$var$Bi(c, b, d);
    }
}
function $4d82739dd229d539$var$ii(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($4d82739dd229d539$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $4d82739dd229d539$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $4d82739dd229d539$var$hh(a, b, e, d);
        null !== c && (e = $4d82739dd229d539$var$R(), $4d82739dd229d539$var$gi(c, a, d, e), $4d82739dd229d539$var$Bi(c, b, d));
    }
}
function $4d82739dd229d539$var$zi(a) {
    var b = a.alternate;
    return a === $4d82739dd229d539$var$M || null !== b && b === $4d82739dd229d539$var$M;
}
function $4d82739dd229d539$var$Ai(a, b) {
    $4d82739dd229d539$var$Jh = $4d82739dd229d539$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $4d82739dd229d539$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
var $4d82739dd229d539$var$Rh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$P,
    useContext: $4d82739dd229d539$var$P,
    useEffect: $4d82739dd229d539$var$P,
    useImperativeHandle: $4d82739dd229d539$var$P,
    useInsertionEffect: $4d82739dd229d539$var$P,
    useLayoutEffect: $4d82739dd229d539$var$P,
    useMemo: $4d82739dd229d539$var$P,
    useReducer: $4d82739dd229d539$var$P,
    useRef: $4d82739dd229d539$var$P,
    useState: $4d82739dd229d539$var$P,
    useDebugValue: $4d82739dd229d539$var$P,
    useDeferredValue: $4d82739dd229d539$var$P,
    useTransition: $4d82739dd229d539$var$P,
    useMutableSource: $4d82739dd229d539$var$P,
    useSyncExternalStore: $4d82739dd229d539$var$P,
    useId: $4d82739dd229d539$var$P,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Oh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: function(a, b) {
        $4d82739dd229d539$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $4d82739dd229d539$var$ki(4194308, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $4d82739dd229d539$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4d82739dd229d539$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $4d82739dd229d539$var$xi.bind(null, $4d82739dd229d539$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4d82739dd229d539$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $4d82739dd229d539$var$hi,
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        return $4d82739dd229d539$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$hi(!1), b = a[0];
        a = $4d82739dd229d539$var$vi.bind(null, a[1]);
        $4d82739dd229d539$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $4d82739dd229d539$var$M, e = $4d82739dd229d539$var$Th();
        if ($4d82739dd229d539$var$I) {
            if (void 0 === c) throw Error($4d82739dd229d539$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
            0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $4d82739dd229d539$var$mi($4d82739dd229d539$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $4d82739dd229d539$var$Th(), b = $4d82739dd229d539$var$Q.identifierPrefix;
        if ($4d82739dd229d539$var$I) {
            var c = $4d82739dd229d539$var$sg;
            var d = $4d82739dd229d539$var$rg;
            c = (d & ~(1 << 32 - $4d82739dd229d539$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $4d82739dd229d539$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $4d82739dd229d539$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Ph = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Wh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Qh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Xh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return null === $4d82739dd229d539$var$N ? b.memoizedState = a : $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
};
function $4d82739dd229d539$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $4d82739dd229d539$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $4d82739dd229d539$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4d82739dd229d539$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $4d82739dd229d539$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $4d82739dd229d539$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $4d82739dd229d539$var$R(), d = $4d82739dd229d539$var$yi(a), e = $4d82739dd229d539$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $4d82739dd229d539$var$nh(a, e, d);
        null !== b && ($4d82739dd229d539$var$gi(b, a, d, c), $4d82739dd229d539$var$oh(b, a, d));
    }
};
function $4d82739dd229d539$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4d82739dd229d539$var$Ie(c, d) || !$4d82739dd229d539$var$Ie(e, f) : !0;
}
function $4d82739dd229d539$var$Gi(a, b, c) {
    var d = !1, e = $4d82739dd229d539$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4d82739dd229d539$var$eh(f) : (e = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4d82739dd229d539$var$Yf(a, e) : $4d82739dd229d539$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4d82739dd229d539$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4d82739dd229d539$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4d82739dd229d539$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $4d82739dd229d539$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $4d82739dd229d539$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4d82739dd229d539$var$eh(f) : (f = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, e.context = $4d82739dd229d539$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4d82739dd229d539$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4d82739dd229d539$var$Ei.enqueueReplaceState(e, e.state, null), $4d82739dd229d539$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $4d82739dd229d539$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $4d82739dd229d539$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $4d82739dd229d539$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $4d82739dd229d539$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $4d82739dd229d539$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $4d82739dd229d539$var$Ni(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4d82739dd229d539$var$Oi || ($4d82739dd229d539$var$Oi = !0, $4d82739dd229d539$var$Pi = d);
        $4d82739dd229d539$var$Li(a, b);
    };
    return c;
}
function $4d82739dd229d539$var$Qi(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $4d82739dd229d539$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $4d82739dd229d539$var$Li(a, b);
        "function" !== typeof d && (null === $4d82739dd229d539$var$Ri ? $4d82739dd229d539$var$Ri = new Set([
            this
        ]) : $4d82739dd229d539$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $4d82739dd229d539$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $4d82739dd229d539$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $4d82739dd229d539$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $4d82739dd229d539$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $4d82739dd229d539$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $4d82739dd229d539$var$mh(-1, 1), b.tag = 2, $4d82739dd229d539$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $4d82739dd229d539$var$Wi = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$dh = !1;
function $4d82739dd229d539$var$Xi(a, b, c, d) {
    b.child = null === a ? $4d82739dd229d539$var$Vg(b, null, c, d) : $4d82739dd229d539$var$Ug(b, a.child, c, d);
}
function $4d82739dd229d539$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4d82739dd229d539$var$ch(b, e);
    d = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    c = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && c && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, d, e);
    return b.child;
}
function $4d82739dd229d539$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$4d82739dd229d539$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $4d82739dd229d539$var$bj(a, b, f, d, e);
        a = $4d82739dd229d539$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $4d82739dd229d539$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $4d82739dd229d539$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $4d82739dd229d539$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4d82739dd229d539$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($4d82739dd229d539$var$Ie(f, d) && a.ref === b.ref) {
            if ($4d82739dd229d539$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($4d82739dd229d539$var$dh = !0);
            else return b.lanes = a.lanes, $4d82739dd229d539$var$Zi(a, b, e);
        }
    }
    return $4d82739dd229d539$var$cj(a, b, c, d, e);
}
function $4d82739dd229d539$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj);
            $4d82739dd229d539$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= d;
    $4d82739dd229d539$var$Xi(a, b, e, c);
    return b.child;
}
function $4d82739dd229d539$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $4d82739dd229d539$var$cj(a, b, c, d, e) {
    var f = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current;
    f = $4d82739dd229d539$var$Yf(b, f);
    $4d82739dd229d539$var$ch(b, e);
    c = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    d = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && d && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, c, e);
    return b.child;
}
function $4d82739dd229d539$var$hj(a, b, c, d, e) {
    if ($4d82739dd229d539$var$Zf(c)) {
        var f = !0;
        $4d82739dd229d539$var$cg(b);
    } else f = !1;
    $4d82739dd229d539$var$ch(b, e);
    if (null === b.stateNode) $4d82739dd229d539$var$ij(a, b), $4d82739dd229d539$var$Gi(b, c, d), $4d82739dd229d539$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $4d82739dd229d539$var$eh(l) : (l = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, l = $4d82739dd229d539$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $4d82739dd229d539$var$Hi(b, g, d, l);
        $4d82739dd229d539$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof m && ($4d82739dd229d539$var$Di(b, c, m, d), k = b.memoizedState), (h = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $4d82739dd229d539$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $4d82739dd229d539$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $4d82739dd229d539$var$eh(k) : (k = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, k = $4d82739dd229d539$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $4d82739dd229d539$var$Hi(b, g, d, k);
        $4d82739dd229d539$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof y && ($4d82739dd229d539$var$Di(b, c, y, d), n = b.memoizedState), (l = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $4d82739dd229d539$var$jj(a, b, c, d, f, e);
}
function $4d82739dd229d539$var$jj(a, b, c, d, e, f) {
    $4d82739dd229d539$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $4d82739dd229d539$var$dg(b, c, !1), $4d82739dd229d539$var$Zi(a, b, f);
    d = b.stateNode;
    $4d82739dd229d539$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $4d82739dd229d539$var$Ug(b, a.child, null, f), b.child = $4d82739dd229d539$var$Ug(b, null, h, f)) : $4d82739dd229d539$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $4d82739dd229d539$var$dg(b, c, !0);
    return b.child;
}
function $4d82739dd229d539$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $4d82739dd229d539$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4d82739dd229d539$var$ag(a, b.context, !1);
    $4d82739dd229d539$var$yh(a, b.containerInfo);
}
function $4d82739dd229d539$var$lj(a, b, c, d, e) {
    $4d82739dd229d539$var$Ig();
    $4d82739dd229d539$var$Jg(e);
    b.flags |= 256;
    $4d82739dd229d539$var$Xi(a, b, c, d);
    return b.child;
}
var $4d82739dd229d539$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $4d82739dd229d539$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $4d82739dd229d539$var$oj(a, b, c) {
    var d = b.pendingProps, e = $4d82739dd229d539$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, e & 1);
    if (null === a) {
        $4d82739dd229d539$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $4d82739dd229d539$var$pj(g, d, 0, null), a = $4d82739dd229d539$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $4d82739dd229d539$var$nj(c), b.memoizedState = $4d82739dd229d539$var$mj, a) : $4d82739dd229d539$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $4d82739dd229d539$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $4d82739dd229d539$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $4d82739dd229d539$var$Pg(h, f) : (f = $4d82739dd229d539$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $4d82739dd229d539$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $4d82739dd229d539$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $4d82739dd229d539$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $4d82739dd229d539$var$qj(a, b) {
    b = $4d82739dd229d539$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $4d82739dd229d539$var$sj(a, b, c, d) {
    null !== d && $4d82739dd229d539$var$Jg(d);
    $4d82739dd229d539$var$Ug(b, a.child, null, c);
    a = $4d82739dd229d539$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $4d82739dd229d539$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(422))), $4d82739dd229d539$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $4d82739dd229d539$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $4d82739dd229d539$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $4d82739dd229d539$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $4d82739dd229d539$var$nj(g);
        b.memoizedState = $4d82739dd229d539$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $4d82739dd229d539$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($4d82739dd229d539$var$p(419));
        d = $4d82739dd229d539$var$Ki(f, d, void 0);
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($4d82739dd229d539$var$dh || h) {
        d = $4d82739dd229d539$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $4d82739dd229d539$var$ih(a, e), $4d82739dd229d539$var$gi(d, a, e, -1));
        }
        $4d82739dd229d539$var$tj();
        d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(421)));
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $4d82739dd229d539$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(e.nextSibling);
    $4d82739dd229d539$var$xg = b;
    $4d82739dd229d539$var$I = !0;
    $4d82739dd229d539$var$zg = null;
    null !== a && ($4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg, $4d82739dd229d539$var$rg = a.id, $4d82739dd229d539$var$sg = a.overflow, $4d82739dd229d539$var$qg = b);
    b = $4d82739dd229d539$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $4d82739dd229d539$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $4d82739dd229d539$var$bh(a.return, b, c);
}
function $4d82739dd229d539$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $4d82739dd229d539$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $4d82739dd229d539$var$Xi(a, b, d.children, c);
    d = $4d82739dd229d539$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $4d82739dd229d539$var$vj(a, c, b);
            else if (19 === a.tag) $4d82739dd229d539$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $4d82739dd229d539$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $4d82739dd229d539$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $4d82739dd229d539$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $4d82739dd229d539$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $4d82739dd229d539$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $4d82739dd229d539$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $4d82739dd229d539$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($4d82739dd229d539$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $4d82739dd229d539$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4d82739dd229d539$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $4d82739dd229d539$var$kj(b);
            $4d82739dd229d539$var$Ig();
            break;
        case 5:
            $4d82739dd229d539$var$Ah(b);
            break;
        case 1:
            $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$cg(b);
            break;
        case 4:
            $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $4d82739dd229d539$var$oj(a, b, c);
                $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
                a = $4d82739dd229d539$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $4d82739dd229d539$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $4d82739dd229d539$var$dj(a, b, c);
    }
    return $4d82739dd229d539$var$Zi(a, b, c);
}
var $4d82739dd229d539$var$zj, $4d82739dd229d539$var$Aj, $4d82739dd229d539$var$Bj, $4d82739dd229d539$var$Cj;
$4d82739dd229d539$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4d82739dd229d539$var$Aj = function() {};
$4d82739dd229d539$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $4d82739dd229d539$var$Ya(a, e);
                d = $4d82739dd229d539$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $4d82739dd229d539$var$A({}, e, {
                    value: void 0
                });
                d = $4d82739dd229d539$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $4d82739dd229d539$var$gb(a, e);
                d = $4d82739dd229d539$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
        }
        $4d82739dd229d539$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $4d82739dd229d539$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$4d82739dd229d539$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $4d82739dd229d539$var$Dj(a, b) {
    if (!$4d82739dd229d539$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $4d82739dd229d539$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $4d82739dd229d539$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4d82739dd229d539$var$S(b), null;
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 3:
            d = b.stateNode;
            $4d82739dd229d539$var$zh();
            $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
            $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
            $4d82739dd229d539$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $4d82739dd229d539$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null));
            $4d82739dd229d539$var$Aj(a, b);
            $4d82739dd229d539$var$S(b);
            return null;
        case 5:
            $4d82739dd229d539$var$Bh(b);
            var e = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $4d82739dd229d539$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                    $4d82739dd229d539$var$S(b);
                    return null;
                }
                a = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    d[$4d82739dd229d539$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $4d82739dd229d539$var$D("cancel", d);
                            $4d82739dd229d539$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], d);
                            break;
                        case "source":
                            $4d82739dd229d539$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $4d82739dd229d539$var$D("error", d);
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "details":
                            $4d82739dd229d539$var$D("toggle", d);
                            break;
                        case "input":
                            $4d82739dd229d539$var$Za(d, f);
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$hb(d, f), $4d82739dd229d539$var$D("invalid", d);
                    }
                    $4d82739dd229d539$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $4d82739dd229d539$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $4d82739dd229d539$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $4d82739dd229d539$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $4d82739dd229d539$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$4d82739dd229d539$var$Of] = b;
                    a[$4d82739dd229d539$var$Pf] = d;
                    $4d82739dd229d539$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $4d82739dd229d539$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $4d82739dd229d539$var$D("cancel", a);
                                $4d82739dd229d539$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $4d82739dd229d539$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $4d82739dd229d539$var$D("error", a);
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $4d82739dd229d539$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $4d82739dd229d539$var$Za(a, d);
                                e = $4d82739dd229d539$var$Ya(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $4d82739dd229d539$var$A({}, d, {
                                    value: void 0
                                });
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$hb(a, d);
                                e = $4d82739dd229d539$var$gb(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $4d82739dd229d539$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $4d82739dd229d539$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $4d82739dd229d539$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $4d82739dd229d539$var$ob(a, k) : "number" === typeof k && $4d82739dd229d539$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($4d82739dd229d539$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $4d82739dd229d539$var$D("scroll", a) : null != k && $4d82739dd229d539$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $4d82739dd229d539$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $4d82739dd229d539$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $4d82739dd229d539$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $4d82739dd229d539$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                c = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
                $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $4d82739dd229d539$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$4d82739dd229d539$var$Of] = b, b.stateNode = d;
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($4d82739dd229d539$var$I && null !== $4d82739dd229d539$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $4d82739dd229d539$var$Hg(), $4d82739dd229d539$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $4d82739dd229d539$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($4d82739dd229d539$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($4d82739dd229d539$var$p(317));
                        f[$4d82739dd229d539$var$Of] = b;
                    } else $4d82739dd229d539$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $4d82739dd229d539$var$S(b);
                    f = !1;
                } else null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($4d82739dd229d539$var$L.current & 1) ? 0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 3) : $4d82739dd229d539$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $4d82739dd229d539$var$S(b);
            return null;
        case 4:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$Aj(a, b), null === a && $4d82739dd229d539$var$sf(b.stateNode.containerInfo), $4d82739dd229d539$var$S(b), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), $4d82739dd229d539$var$S(b), null;
        case 17:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 19:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            f = b.memoizedState;
            if (null === f) return $4d82739dd229d539$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $4d82739dd229d539$var$Dj(f, !1);
                else {
                    if (0 !== $4d82739dd229d539$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $4d82739dd229d539$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $4d82739dd229d539$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $4d82739dd229d539$var$B() > $4d82739dd229d539$var$Gj && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $4d82739dd229d539$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $4d82739dd229d539$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$4d82739dd229d539$var$I) return $4d82739dd229d539$var$S(b), null;
                    } else 2 * $4d82739dd229d539$var$B() - f.renderingStartTime > $4d82739dd229d539$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $4d82739dd229d539$var$B(), b.sibling = null, c = $4d82739dd229d539$var$L.current, $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d ? c & 1 | 2 : c & 1), b;
            $4d82739dd229d539$var$S(b);
            return null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($4d82739dd229d539$var$fj & 1073741824) && ($4d82739dd229d539$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $4d82739dd229d539$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
}
function $4d82739dd229d539$var$Ij(a, b) {
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $4d82739dd229d539$var$Bh(b), null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($4d82739dd229d539$var$p(340));
                $4d82739dd229d539$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $4d82739dd229d539$var$E($4d82739dd229d539$var$L), null;
        case 4:
            return $4d82739dd229d539$var$zh(), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$Jj = !1, $4d82739dd229d539$var$U = !1, $4d82739dd229d539$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $4d82739dd229d539$var$V = null;
function $4d82739dd229d539$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $4d82739dd229d539$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $4d82739dd229d539$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $4d82739dd229d539$var$W(a, b, d);
    }
}
var $4d82739dd229d539$var$Nj = !1;
function $4d82739dd229d539$var$Oj(a, b) {
    $4d82739dd229d539$var$Cf = $4d82739dd229d539$var$dd;
    a = $4d82739dd229d539$var$Me();
    if ($4d82739dd229d539$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $4d82739dd229d539$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $4d82739dd229d539$var$dd = !1;
    for($4d82739dd229d539$var$V = b; null !== $4d82739dd229d539$var$V;)if (b = $4d82739dd229d539$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $4d82739dd229d539$var$V = a;
    else for(; null !== $4d82739dd229d539$var$V;){
        b = $4d82739dd229d539$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $4d82739dd229d539$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(163));
            }
        } catch (F) {
            $4d82739dd229d539$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $4d82739dd229d539$var$V = a;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
    n = $4d82739dd229d539$var$Nj;
    $4d82739dd229d539$var$Nj = !1;
    return n;
}
function $4d82739dd229d539$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $4d82739dd229d539$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $4d82739dd229d539$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $4d82739dd229d539$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $4d82739dd229d539$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $4d82739dd229d539$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$4d82739dd229d539$var$Of], delete b[$4d82739dd229d539$var$Pf], delete b[$4d82739dd229d539$var$of], delete b[$4d82739dd229d539$var$Qf], delete b[$4d82739dd229d539$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $4d82739dd229d539$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4d82739dd229d539$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $4d82739dd229d539$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $4d82739dd229d539$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $4d82739dd229d539$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Vj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Vj(a, b, c), a = a.sibling;
}
function $4d82739dd229d539$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Wj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Wj(a, b, c), a = a.sibling;
}
var $4d82739dd229d539$var$X = null, $4d82739dd229d539$var$Xj = !1;
function $4d82739dd229d539$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$4d82739dd229d539$var$Zj(a, b, c), c = c.sibling;
}
function $4d82739dd229d539$var$Zj(a, b, c) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberUnmount) try {
        $4d82739dd229d539$var$lc.onCommitFiberUnmount($4d82739dd229d539$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $4d82739dd229d539$var$U || $4d82739dd229d539$var$Lj(c, b);
        case 6:
            var d = $4d82739dd229d539$var$X, e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $4d82739dd229d539$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? $4d82739dd229d539$var$Kf(a.parentNode, c) : 1 === a.nodeType && $4d82739dd229d539$var$Kf(a, c), $4d82739dd229d539$var$bd(a)) : $4d82739dd229d539$var$Kf($4d82739dd229d539$var$X, c.stateNode));
            break;
        case 4:
            d = $4d82739dd229d539$var$X;
            e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = c.stateNode.containerInfo;
            $4d82739dd229d539$var$Xj = !0;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$4d82739dd229d539$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $4d82739dd229d539$var$Mj(c, b, g) : 0 !== (f & 4) && $4d82739dd229d539$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 1:
            if (!$4d82739dd229d539$var$U && ($4d82739dd229d539$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $4d82739dd229d539$var$W(c, b, h);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 21:
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($4d82739dd229d539$var$U = (d = $4d82739dd229d539$var$U) || null !== c.memoizedState, $4d82739dd229d539$var$Yj(a, b, c), $4d82739dd229d539$var$U = d) : $4d82739dd229d539$var$Yj(a, b, c);
            break;
        default:
            $4d82739dd229d539$var$Yj(a, b, c);
    }
}
function $4d82739dd229d539$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $4d82739dd229d539$var$Kj);
        b.forEach(function(b) {
            var d = $4d82739dd229d539$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $4d82739dd229d539$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $4d82739dd229d539$var$X = h.stateNode;
                        $4d82739dd229d539$var$Xj = !1;
                        break a;
                    case 3:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                    case 4:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $4d82739dd229d539$var$X) throw Error($4d82739dd229d539$var$p(160));
            $4d82739dd229d539$var$Zj(f, g, e);
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $4d82739dd229d539$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$4d82739dd229d539$var$dk(b, a), b = b.sibling;
}
function $4d82739dd229d539$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                try {
                    $4d82739dd229d539$var$Pj(3, a, a.return), $4d82739dd229d539$var$Qj(3, a);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
                try {
                    $4d82739dd229d539$var$Pj(5, a, a.return);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            break;
        case 5:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $4d82739dd229d539$var$ob(e, "");
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $4d82739dd229d539$var$ab(e, f);
                    $4d82739dd229d539$var$vb(h, g);
                    var l = $4d82739dd229d539$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $4d82739dd229d539$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $4d82739dd229d539$var$nb(e, q) : "children" === m ? $4d82739dd229d539$var$ob(e, q) : $4d82739dd229d539$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $4d82739dd229d539$var$bb(e, f);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $4d82739dd229d539$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $4d82739dd229d539$var$fb(e, !!f.multiple, f.defaultValue, !0) : $4d82739dd229d539$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$4d82739dd229d539$var$Pf] = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($4d82739dd229d539$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $4d82739dd229d539$var$bd(b.containerInfo);
            } catch (t) {
                $4d82739dd229d539$var$W(a, a.return, t);
            }
            break;
        case 4:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            break;
        case 13:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($4d82739dd229d539$var$fk = $4d82739dd229d539$var$B()));
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($4d82739dd229d539$var$U = (l = $4d82739dd229d539$var$U) || m, $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$U = l) : $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($4d82739dd229d539$var$V = a, m = a.child; null !== m;){
                    for(q = $4d82739dd229d539$var$V = m; null !== $4d82739dd229d539$var$V;){
                        r = $4d82739dd229d539$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $4d82739dd229d539$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $4d82739dd229d539$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $4d82739dd229d539$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $4d82739dd229d539$var$V = y) : $4d82739dd229d539$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $4d82739dd229d539$var$rb("display", g));
                            } catch (t) {
                                $4d82739dd229d539$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $4d82739dd229d539$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 21:
            break;
        default:
            $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$ek(a);
    }
}
function $4d82739dd229d539$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($4d82739dd229d539$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($4d82739dd229d539$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($4d82739dd229d539$var$ob(e, ""), d.flags &= -33);
                    var f = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(161));
            }
        } catch (k) {
            $4d82739dd229d539$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $4d82739dd229d539$var$hk(a, b, c) {
    $4d82739dd229d539$var$V = a;
    $4d82739dd229d539$var$ik(a, b, c);
}
function $4d82739dd229d539$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $4d82739dd229d539$var$V;){
        var e = $4d82739dd229d539$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $4d82739dd229d539$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $4d82739dd229d539$var$U;
                h = $4d82739dd229d539$var$Jj;
                var l = $4d82739dd229d539$var$U;
                $4d82739dd229d539$var$Jj = g;
                if (($4d82739dd229d539$var$U = k) && !l) for($4d82739dd229d539$var$V = e; null !== $4d82739dd229d539$var$V;)g = $4d82739dd229d539$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $4d82739dd229d539$var$jk(e) : null !== k ? (k.return = g, $4d82739dd229d539$var$V = k) : $4d82739dd229d539$var$jk(e);
                for(; null !== f;)$4d82739dd229d539$var$V = f, $4d82739dd229d539$var$ik(f, b, c), f = f.sibling;
                $4d82739dd229d539$var$V = e;
                $4d82739dd229d539$var$Jj = h;
                $4d82739dd229d539$var$U = l;
            }
            $4d82739dd229d539$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $4d82739dd229d539$var$V = f) : $4d82739dd229d539$var$kk(a, b, c);
    }
}
function $4d82739dd229d539$var$kk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $4d82739dd229d539$var$U || $4d82739dd229d539$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$4d82739dd229d539$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $4d82739dd229d539$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $4d82739dd229d539$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $4d82739dd229d539$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $4d82739dd229d539$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($4d82739dd229d539$var$p(163));
                }
                $4d82739dd229d539$var$U || b.flags & 512 && $4d82739dd229d539$var$Rj(b);
            } catch (r) {
                $4d82739dd229d539$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$gk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$jk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $4d82739dd229d539$var$Qj(4, b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $4d82739dd229d539$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $4d82739dd229d539$var$W(b, b.return, k);
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $4d82739dd229d539$var$V = h;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
var $4d82739dd229d539$var$lk = Math.ceil, $4d82739dd229d539$var$mk = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$nk = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$ok = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$K = 0, $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Y = null, $4d82739dd229d539$var$Z = 0, $4d82739dd229d539$var$fj = 0, $4d82739dd229d539$var$ej = $4d82739dd229d539$var$Uf(0), $4d82739dd229d539$var$T = 0, $4d82739dd229d539$var$pk = null, $4d82739dd229d539$var$rh = 0, $4d82739dd229d539$var$qk = 0, $4d82739dd229d539$var$rk = 0, $4d82739dd229d539$var$sk = null, $4d82739dd229d539$var$tk = null, $4d82739dd229d539$var$fk = 0, $4d82739dd229d539$var$Gj = Infinity, $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Oi = !1, $4d82739dd229d539$var$Pi = null, $4d82739dd229d539$var$Ri = null, $4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = null, $4d82739dd229d539$var$xk = 0, $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, $4d82739dd229d539$var$Ak = -1, $4d82739dd229d539$var$Bk = 0;
function $4d82739dd229d539$var$R() {
    return 0 !== ($4d82739dd229d539$var$K & 6) ? $4d82739dd229d539$var$B() : -1 !== $4d82739dd229d539$var$Ak ? $4d82739dd229d539$var$Ak : $4d82739dd229d539$var$Ak = $4d82739dd229d539$var$B();
}
function $4d82739dd229d539$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($4d82739dd229d539$var$K & 2) && 0 !== $4d82739dd229d539$var$Z) return $4d82739dd229d539$var$Z & -$4d82739dd229d539$var$Z;
    if (null !== $4d82739dd229d539$var$Kg.transition) return 0 === $4d82739dd229d539$var$Bk && ($4d82739dd229d539$var$Bk = $4d82739dd229d539$var$yc()), $4d82739dd229d539$var$Bk;
    a = $4d82739dd229d539$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $4d82739dd229d539$var$jd(a.type);
    return a;
}
function $4d82739dd229d539$var$gi(a, b, c, d) {
    if (50 < $4d82739dd229d539$var$yk) throw $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, Error($4d82739dd229d539$var$p(185));
    $4d82739dd229d539$var$Ac(a, c, d);
    if (0 === ($4d82739dd229d539$var$K & 2) || a !== $4d82739dd229d539$var$Q) a === $4d82739dd229d539$var$Q && (0 === ($4d82739dd229d539$var$K & 2) && ($4d82739dd229d539$var$qk |= c), 4 === $4d82739dd229d539$var$T && $4d82739dd229d539$var$Ck(a, $4d82739dd229d539$var$Z)), $4d82739dd229d539$var$Dk(a, d), 1 === c && 0 === $4d82739dd229d539$var$K && 0 === (b.mode & 1) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
}
function $4d82739dd229d539$var$Dk(a, b) {
    var c = a.callbackNode;
    $4d82739dd229d539$var$wc(a, b);
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) null !== c && $4d82739dd229d539$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $4d82739dd229d539$var$bc(c);
        if (1 === b) 0 === a.tag ? $4d82739dd229d539$var$ig($4d82739dd229d539$var$Ek.bind(null, a)) : $4d82739dd229d539$var$hg($4d82739dd229d539$var$Ek.bind(null, a)), $4d82739dd229d539$var$Jf(function() {
            0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
        }), c = null;
        else {
            switch($4d82739dd229d539$var$Dc(d)){
                case 1:
                    c = $4d82739dd229d539$var$fc;
                    break;
                case 4:
                    c = $4d82739dd229d539$var$gc;
                    break;
                case 16:
                    c = $4d82739dd229d539$var$hc;
                    break;
                case 536870912:
                    c = $4d82739dd229d539$var$jc;
                    break;
                default:
                    c = $4d82739dd229d539$var$hc;
            }
            c = $4d82739dd229d539$var$Fk(c, $4d82739dd229d539$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $4d82739dd229d539$var$Gk(a, b) {
    $4d82739dd229d539$var$Ak = -1;
    $4d82739dd229d539$var$Bk = 0;
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    var c = a.callbackNode;
    if ($4d82739dd229d539$var$Hk() && a.callbackNode !== c) return null;
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $4d82739dd229d539$var$Ik(a, d);
    else {
        b = d;
        var e = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 2;
        var f = $4d82739dd229d539$var$Jk();
        if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$Kk(a, b);
        for(;;)try {
            $4d82739dd229d539$var$Lk();
            break;
        } catch (h) {
            $4d82739dd229d539$var$Mk(a, h);
        }
        $4d82739dd229d539$var$$g();
        $4d82739dd229d539$var$mk.current = f;
        $4d82739dd229d539$var$K = e;
        null !== $4d82739dd229d539$var$Y ? b = 0 : ($4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0, b = $4d82739dd229d539$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $4d82739dd229d539$var$xc(a), 0 !== e && (d = e, b = $4d82739dd229d539$var$Nk(a, e)));
        if (1 === b) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
        if (6 === b) $4d82739dd229d539$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$4d82739dd229d539$var$Ok(e) && (b = $4d82739dd229d539$var$Ik(a, d), 2 === b && (f = $4d82739dd229d539$var$xc(a), 0 !== f && (d = f, b = $4d82739dd229d539$var$Nk(a, f))), 1 === b)) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($4d82739dd229d539$var$p(345));
                case 2:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 3:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $4d82739dd229d539$var$fk + 500 - $4d82739dd229d539$var$B(), 10 < b)) {
                        if (0 !== $4d82739dd229d539$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $4d82739dd229d539$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), b);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 4:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $4d82739dd229d539$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $4d82739dd229d539$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $4d82739dd229d539$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), d);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 5:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(329));
            }
        }
    }
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return a.callbackNode === c ? $4d82739dd229d539$var$Gk.bind(null, a) : null;
}
function $4d82739dd229d539$var$Nk(a, b) {
    var c = $4d82739dd229d539$var$sk;
    a.current.memoizedState.isDehydrated && ($4d82739dd229d539$var$Kk(a, b).flags |= 256);
    a = $4d82739dd229d539$var$Ik(a, b);
    2 !== a && (b = $4d82739dd229d539$var$tk, $4d82739dd229d539$var$tk = c, null !== b && $4d82739dd229d539$var$Fj(b));
    return a;
}
function $4d82739dd229d539$var$Fj(a) {
    null === $4d82739dd229d539$var$tk ? $4d82739dd229d539$var$tk = a : $4d82739dd229d539$var$tk.push.apply($4d82739dd229d539$var$tk, a);
}
function $4d82739dd229d539$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$4d82739dd229d539$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $4d82739dd229d539$var$Ck(a, b) {
    b &= ~$4d82739dd229d539$var$rk;
    b &= ~$4d82739dd229d539$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $4d82739dd229d539$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $4d82739dd229d539$var$Ek(a) {
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$uc(a, 0);
    if (0 === (b & 1)) return $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), null;
    var c = $4d82739dd229d539$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $4d82739dd229d539$var$xc(a);
        0 !== d && (b = d, c = $4d82739dd229d539$var$Nk(a, d));
    }
    if (1 === c) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, b), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
    if (6 === c) throw Error($4d82739dd229d539$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return null;
}
function $4d82739dd229d539$var$Qk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    try {
        return a(b);
    } finally{
        $4d82739dd229d539$var$K = c, 0 === $4d82739dd229d539$var$K && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
    }
}
function $4d82739dd229d539$var$Rk(a) {
    null !== $4d82739dd229d539$var$wk && 0 === $4d82739dd229d539$var$wk.tag && 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    var c = $4d82739dd229d539$var$ok.transition, d = $4d82739dd229d539$var$C;
    try {
        if ($4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, a) return a();
    } finally{
        $4d82739dd229d539$var$C = d, $4d82739dd229d539$var$ok.transition = c, $4d82739dd229d539$var$K = b, 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
    }
}
function $4d82739dd229d539$var$Hj() {
    $4d82739dd229d539$var$fj = $4d82739dd229d539$var$ej.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$ej);
}
function $4d82739dd229d539$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $4d82739dd229d539$var$Gf(c));
    if (null !== $4d82739dd229d539$var$Y) for(c = $4d82739dd229d539$var$Y.return; null !== c;){
        var d = c;
        $4d82739dd229d539$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $4d82739dd229d539$var$$f();
                break;
            case 3:
                $4d82739dd229d539$var$zh();
                $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
                $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
                $4d82739dd229d539$var$Eh();
                break;
            case 5:
                $4d82739dd229d539$var$Bh(d);
                break;
            case 4:
                $4d82739dd229d539$var$zh();
                break;
            case 13:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 19:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 10:
                $4d82739dd229d539$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $4d82739dd229d539$var$Hj();
        }
        c = c.return;
    }
    $4d82739dd229d539$var$Q = a;
    $4d82739dd229d539$var$Y = a = $4d82739dd229d539$var$Pg(a.current, null);
    $4d82739dd229d539$var$Z = $4d82739dd229d539$var$fj = b;
    $4d82739dd229d539$var$T = 0;
    $4d82739dd229d539$var$pk = null;
    $4d82739dd229d539$var$rk = $4d82739dd229d539$var$qk = $4d82739dd229d539$var$rh = 0;
    $4d82739dd229d539$var$tk = $4d82739dd229d539$var$sk = null;
    if (null !== $4d82739dd229d539$var$fh) {
        for(b = 0; b < $4d82739dd229d539$var$fh.length; b++)if (c = $4d82739dd229d539$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $4d82739dd229d539$var$fh = null;
    }
    return a;
}
function $4d82739dd229d539$var$Mk(a, b) {
    do {
        var c = $4d82739dd229d539$var$Y;
        try {
            $4d82739dd229d539$var$$g();
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
            if ($4d82739dd229d539$var$Ih) {
                for(var d = $4d82739dd229d539$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $4d82739dd229d539$var$Ih = !1;
            }
            $4d82739dd229d539$var$Hh = 0;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            $4d82739dd229d539$var$nk.current = null;
            if (null === c || null === c.return) {
                $4d82739dd229d539$var$T = 1;
                $4d82739dd229d539$var$pk = b;
                $4d82739dd229d539$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $4d82739dd229d539$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $4d82739dd229d539$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $4d82739dd229d539$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $4d82739dd229d539$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $4d82739dd229d539$var$Si(f, l, b);
                            $4d82739dd229d539$var$tj();
                            break a;
                        }
                        k = Error($4d82739dd229d539$var$p(426));
                    }
                } else if ($4d82739dd229d539$var$I && h.mode & 1) {
                    var J = $4d82739dd229d539$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $4d82739dd229d539$var$Vi(J, g, h, f, b);
                        $4d82739dd229d539$var$Jg($4d82739dd229d539$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $4d82739dd229d539$var$Ji(k, h);
                4 !== $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 2);
                null === $4d82739dd229d539$var$sk ? $4d82739dd229d539$var$sk = [
                    f
                ] : $4d82739dd229d539$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $4d82739dd229d539$var$Ni(f, k, b);
                            $4d82739dd229d539$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $4d82739dd229d539$var$Qi(f, h, b);
                                $4d82739dd229d539$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $4d82739dd229d539$var$Sk(c);
        } catch (na) {
            b = na;
            $4d82739dd229d539$var$Y === c && null !== c && ($4d82739dd229d539$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $4d82739dd229d539$var$Jk() {
    var a = $4d82739dd229d539$var$mk.current;
    $4d82739dd229d539$var$mk.current = $4d82739dd229d539$var$Rh;
    return null === a ? $4d82739dd229d539$var$Rh : a;
}
function $4d82739dd229d539$var$tj() {
    if (0 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T || 2 === $4d82739dd229d539$var$T) $4d82739dd229d539$var$T = 4;
    null === $4d82739dd229d539$var$Q || 0 === ($4d82739dd229d539$var$rh & 268435455) && 0 === ($4d82739dd229d539$var$qk & 268435455) || $4d82739dd229d539$var$Ck($4d82739dd229d539$var$Q, $4d82739dd229d539$var$Z);
}
function $4d82739dd229d539$var$Ik(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 2;
    var d = $4d82739dd229d539$var$Jk();
    if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Kk(a, b);
    for(;;)try {
        $4d82739dd229d539$var$Tk();
        break;
    } catch (e) {
        $4d82739dd229d539$var$Mk(a, e);
    }
    $4d82739dd229d539$var$$g();
    $4d82739dd229d539$var$K = c;
    $4d82739dd229d539$var$mk.current = d;
    if (null !== $4d82739dd229d539$var$Y) throw Error($4d82739dd229d539$var$p(261));
    $4d82739dd229d539$var$Q = null;
    $4d82739dd229d539$var$Z = 0;
    return $4d82739dd229d539$var$T;
}
function $4d82739dd229d539$var$Tk() {
    for(; null !== $4d82739dd229d539$var$Y;)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Lk() {
    for(; null !== $4d82739dd229d539$var$Y && !$4d82739dd229d539$var$cc();)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Uk(a) {
    var b = $4d82739dd229d539$var$Vk(a.alternate, a, $4d82739dd229d539$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $4d82739dd229d539$var$Sk(a) : $4d82739dd229d539$var$Y = b;
    $4d82739dd229d539$var$nk.current = null;
}
function $4d82739dd229d539$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $4d82739dd229d539$var$Ej(c, b, $4d82739dd229d539$var$fj), null !== c) {
                $4d82739dd229d539$var$Y = c;
                return;
            }
        } else {
            c = $4d82739dd229d539$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $4d82739dd229d539$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $4d82739dd229d539$var$T = 6;
                $4d82739dd229d539$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $4d82739dd229d539$var$Y = b;
            return;
        }
        $4d82739dd229d539$var$Y = b = a;
    }while (null !== b);
    0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 5);
}
function $4d82739dd229d539$var$Pk(a, b, c) {
    var d = $4d82739dd229d539$var$C, e = $4d82739dd229d539$var$ok.transition;
    try {
        $4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$Wk(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$ok.transition = e, $4d82739dd229d539$var$C = d;
    }
    return null;
}
function $4d82739dd229d539$var$Wk(a, b, c, d) {
    do $4d82739dd229d539$var$Hk();
    while (null !== $4d82739dd229d539$var$wk);
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($4d82739dd229d539$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $4d82739dd229d539$var$Bc(a, f);
    a === $4d82739dd229d539$var$Q && ($4d82739dd229d539$var$Y = $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $4d82739dd229d539$var$vk || ($4d82739dd229d539$var$vk = !0, $4d82739dd229d539$var$Fk($4d82739dd229d539$var$hc, function() {
        $4d82739dd229d539$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $4d82739dd229d539$var$ok.transition;
        $4d82739dd229d539$var$ok.transition = null;
        var g = $4d82739dd229d539$var$C;
        $4d82739dd229d539$var$C = 1;
        var h = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 4;
        $4d82739dd229d539$var$nk.current = null;
        $4d82739dd229d539$var$Oj(a, c);
        $4d82739dd229d539$var$dk(c, a);
        $4d82739dd229d539$var$Oe($4d82739dd229d539$var$Df);
        $4d82739dd229d539$var$dd = !!$4d82739dd229d539$var$Cf;
        $4d82739dd229d539$var$Df = $4d82739dd229d539$var$Cf = null;
        a.current = c;
        $4d82739dd229d539$var$hk(c, a, e);
        $4d82739dd229d539$var$dc();
        $4d82739dd229d539$var$K = h;
        $4d82739dd229d539$var$C = g;
        $4d82739dd229d539$var$ok.transition = f;
    } else a.current = c;
    $4d82739dd229d539$var$vk && ($4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = a, $4d82739dd229d539$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($4d82739dd229d539$var$Ri = null);
    $4d82739dd229d539$var$mc(c.stateNode, d);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($4d82739dd229d539$var$Oi) throw $4d82739dd229d539$var$Oi = !1, a = $4d82739dd229d539$var$Pi, $4d82739dd229d539$var$Pi = null, a;
    0 !== ($4d82739dd229d539$var$xk & 1) && 0 !== a.tag && $4d82739dd229d539$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $4d82739dd229d539$var$zk ? $4d82739dd229d539$var$yk++ : ($4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = a) : $4d82739dd229d539$var$yk = 0;
    $4d82739dd229d539$var$jg();
    return null;
}
function $4d82739dd229d539$var$Hk() {
    if (null !== $4d82739dd229d539$var$wk) {
        var a = $4d82739dd229d539$var$Dc($4d82739dd229d539$var$xk), b = $4d82739dd229d539$var$ok.transition, c = $4d82739dd229d539$var$C;
        try {
            $4d82739dd229d539$var$ok.transition = null;
            $4d82739dd229d539$var$C = 16 > a ? 16 : a;
            if (null === $4d82739dd229d539$var$wk) var d = !1;
            else {
                a = $4d82739dd229d539$var$wk;
                $4d82739dd229d539$var$wk = null;
                $4d82739dd229d539$var$xk = 0;
                if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(331));
                var e = $4d82739dd229d539$var$K;
                $4d82739dd229d539$var$K |= 4;
                for($4d82739dd229d539$var$V = a.current; null !== $4d82739dd229d539$var$V;){
                    var f = $4d82739dd229d539$var$V, g = f.child;
                    if (0 !== ($4d82739dd229d539$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($4d82739dd229d539$var$V = l; null !== $4d82739dd229d539$var$V;){
                                    var m = $4d82739dd229d539$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $4d82739dd229d539$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $4d82739dd229d539$var$V = q;
                                    else for(; null !== $4d82739dd229d539$var$V;){
                                        m = $4d82739dd229d539$var$V;
                                        var r = m.sibling, y = m.return;
                                        $4d82739dd229d539$var$Sj(m);
                                        if (m === l) {
                                            $4d82739dd229d539$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $4d82739dd229d539$var$V = r;
                                            break;
                                        }
                                        $4d82739dd229d539$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $4d82739dd229d539$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $4d82739dd229d539$var$V = g;
                    else b: for(; null !== $4d82739dd229d539$var$V;){
                        f = $4d82739dd229d539$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $4d82739dd229d539$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $4d82739dd229d539$var$V = x;
                            break b;
                        }
                        $4d82739dd229d539$var$V = f.return;
                    }
                }
                var w = a.current;
                for($4d82739dd229d539$var$V = w; null !== $4d82739dd229d539$var$V;){
                    g = $4d82739dd229d539$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $4d82739dd229d539$var$V = u;
                    else b: for(g = w; null !== $4d82739dd229d539$var$V;){
                        h = $4d82739dd229d539$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $4d82739dd229d539$var$Qj(9, h);
                            }
                        } catch (na) {
                            $4d82739dd229d539$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $4d82739dd229d539$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $4d82739dd229d539$var$V = F;
                            break b;
                        }
                        $4d82739dd229d539$var$V = h.return;
                    }
                }
                $4d82739dd229d539$var$K = e;
                $4d82739dd229d539$var$jg();
                if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onPostCommitFiberRoot) try {
                    $4d82739dd229d539$var$lc.onPostCommitFiberRoot($4d82739dd229d539$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$ok.transition = b;
        }
    }
    return !1;
}
function $4d82739dd229d539$var$Xk(a, b, c) {
    b = $4d82739dd229d539$var$Ji(c, b);
    b = $4d82739dd229d539$var$Ni(a, b, 1);
    a = $4d82739dd229d539$var$nh(a, b, 1);
    b = $4d82739dd229d539$var$R();
    null !== a && ($4d82739dd229d539$var$Ac(a, 1, b), $4d82739dd229d539$var$Dk(a, b));
}
function $4d82739dd229d539$var$W(a, b, c) {
    if (3 === a.tag) $4d82739dd229d539$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $4d82739dd229d539$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(d))) {
                a = $4d82739dd229d539$var$Ji(c, a);
                a = $4d82739dd229d539$var$Qi(b, a, 1);
                b = $4d82739dd229d539$var$nh(b, a, 1);
                a = $4d82739dd229d539$var$R();
                null !== b && ($4d82739dd229d539$var$Ac(b, 1, a), $4d82739dd229d539$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $4d82739dd229d539$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $4d82739dd229d539$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $4d82739dd229d539$var$Q === a && ($4d82739dd229d539$var$Z & c) === c && (4 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$Z & 130023424) === $4d82739dd229d539$var$Z && 500 > $4d82739dd229d539$var$B() - $4d82739dd229d539$var$fk ? $4d82739dd229d539$var$Kk(a, 0) : $4d82739dd229d539$var$rk |= c);
    $4d82739dd229d539$var$Dk(a, b);
}
function $4d82739dd229d539$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $4d82739dd229d539$var$sc, $4d82739dd229d539$var$sc <<= 1, 0 === ($4d82739dd229d539$var$sc & 130023424) && ($4d82739dd229d539$var$sc = 4194304)));
    var c = $4d82739dd229d539$var$R();
    a = $4d82739dd229d539$var$ih(a, b);
    null !== a && ($4d82739dd229d539$var$Ac(a, b, c), $4d82739dd229d539$var$Dk(a, c));
}
function $4d82739dd229d539$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $4d82739dd229d539$var$Yk(a, c);
}
function $4d82739dd229d539$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($4d82739dd229d539$var$p(314));
    }
    null !== d && d.delete(b);
    $4d82739dd229d539$var$Yk(a, c);
}
var $4d82739dd229d539$var$Vk;
$4d82739dd229d539$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4d82739dd229d539$var$Wf.current) $4d82739dd229d539$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$yj(a, b, c);
            $4d82739dd229d539$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$I && 0 !== (b.flags & 1048576) && $4d82739dd229d539$var$ug(b, $4d82739dd229d539$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $4d82739dd229d539$var$ij(a, b);
            a = b.pendingProps;
            var e = $4d82739dd229d539$var$Yf(b, $4d82739dd229d539$var$H.current);
            $4d82739dd229d539$var$ch(b, c);
            e = $4d82739dd229d539$var$Nh(null, b, d, a, e, c);
            var f = $4d82739dd229d539$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $4d82739dd229d539$var$Zf(d) ? (f = !0, $4d82739dd229d539$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $4d82739dd229d539$var$kh(b), e.updater = $4d82739dd229d539$var$Ei, b.stateNode = e, e._reactInternals = b, $4d82739dd229d539$var$Ii(b, d, a, c), b = $4d82739dd229d539$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $4d82739dd229d539$var$I && f && $4d82739dd229d539$var$vg(b), $4d82739dd229d539$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $4d82739dd229d539$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $4d82739dd229d539$var$Zk(d);
                a = $4d82739dd229d539$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $4d82739dd229d539$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $4d82739dd229d539$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $4d82739dd229d539$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $4d82739dd229d539$var$$i(null, b, d, $4d82739dd229d539$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($4d82739dd229d539$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $4d82739dd229d539$var$kj(b);
                if (null === a) throw Error($4d82739dd229d539$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $4d82739dd229d539$var$lh(a, b);
                $4d82739dd229d539$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(423)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(424)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else for($4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.stateNode.containerInfo.firstChild), $4d82739dd229d539$var$xg = b, $4d82739dd229d539$var$I = !0, $4d82739dd229d539$var$zg = null, c = $4d82739dd229d539$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $4d82739dd229d539$var$Ig();
                    if (d === e) {
                        b = $4d82739dd229d539$var$Zi(a, b, c);
                        break a;
                    }
                    $4d82739dd229d539$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $4d82739dd229d539$var$Ah(b), null === a && $4d82739dd229d539$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4d82739dd229d539$var$Ef(d, e) ? g = null : null !== f && $4d82739dd229d539$var$Ef(d, f) && (b.flags |= 32), $4d82739dd229d539$var$gj(a, b), $4d82739dd229d539$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $4d82739dd229d539$var$Eg(b), null;
        case 13:
            return $4d82739dd229d539$var$oj(a, b, c);
        case 4:
            return $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4d82739dd229d539$var$Ug(b, null, d, c) : $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$Yi(a, b, d, e, c);
        case 7:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($4d82739dd229d539$var$He(f.value, g)) {
                        if (f.children === e.children && !$4d82739dd229d539$var$Wf.current) {
                            b = $4d82739dd229d539$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $4d82739dd229d539$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $4d82739dd229d539$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($4d82739dd229d539$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $4d82739dd229d539$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $4d82739dd229d539$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $4d82739dd229d539$var$ch(b, c), e = $4d82739dd229d539$var$eh(e), d = d(e), b.flags |= 1, $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $4d82739dd229d539$var$Ci(d, b.pendingProps), e = $4d82739dd229d539$var$Ci(d.type, e), $4d82739dd229d539$var$$i(a, b, d, e, c);
        case 15:
            return $4d82739dd229d539$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$ij(a, b), b.tag = 1, $4d82739dd229d539$var$Zf(d) ? (a = !0, $4d82739dd229d539$var$cg(b)) : a = !1, $4d82739dd229d539$var$ch(b, c), $4d82739dd229d539$var$Gi(b, d, e), $4d82739dd229d539$var$Ii(b, d, e, c), $4d82739dd229d539$var$jj(null, b, d, !0, a, c);
        case 19:
            return $4d82739dd229d539$var$xj(a, b, c);
        case 22:
            return $4d82739dd229d539$var$dj(a, b, c);
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
};
function $4d82739dd229d539$var$Fk(a, b) {
    return $4d82739dd229d539$var$ac(a, b);
}
function $4d82739dd229d539$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4d82739dd229d539$var$Bg(a, b, c, d) {
    return new $4d82739dd229d539$var$$k(a, b, c, d);
}
function $4d82739dd229d539$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4d82739dd229d539$var$Zk(a) {
    if ("function" === typeof a) return $4d82739dd229d539$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4d82739dd229d539$var$Da) return 11;
        if (a === $4d82739dd229d539$var$Ga) return 14;
    }
    return 2;
}
function $4d82739dd229d539$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $4d82739dd229d539$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $4d82739dd229d539$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4d82739dd229d539$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4d82739dd229d539$var$ya:
            return $4d82739dd229d539$var$Tg(c.children, e, f, b);
        case $4d82739dd229d539$var$za:
            g = 8;
            e |= 8;
            break;
        case $4d82739dd229d539$var$Aa:
            return a = $4d82739dd229d539$var$Bg(12, c, b, e | 2), a.elementType = $4d82739dd229d539$var$Aa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ea:
            return a = $4d82739dd229d539$var$Bg(13, c, b, e), a.elementType = $4d82739dd229d539$var$Ea, a.lanes = f, a;
        case $4d82739dd229d539$var$Fa:
            return a = $4d82739dd229d539$var$Bg(19, c, b, e), a.elementType = $4d82739dd229d539$var$Fa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ia:
            return $4d82739dd229d539$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4d82739dd229d539$var$Ba:
                    g = 10;
                    break a;
                case $4d82739dd229d539$var$Ca:
                    g = 9;
                    break a;
                case $4d82739dd229d539$var$Da:
                    g = 11;
                    break a;
                case $4d82739dd229d539$var$Ga:
                    g = 14;
                    break a;
                case $4d82739dd229d539$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($4d82739dd229d539$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $4d82739dd229d539$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $4d82739dd229d539$var$Tg(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$pj(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(22, a, d, b);
    a.elementType = $4d82739dd229d539$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $4d82739dd229d539$var$Qg(a, b, c) {
    a = $4d82739dd229d539$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$Sg(a, b, c) {
    b = $4d82739dd229d539$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4d82739dd229d539$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $4d82739dd229d539$var$zc(0);
    this.expirationTimes = $4d82739dd229d539$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4d82739dd229d539$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $4d82739dd229d539$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $4d82739dd229d539$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $4d82739dd229d539$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $4d82739dd229d539$var$kh(f);
    return a;
}
function $4d82739dd229d539$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4d82739dd229d539$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $4d82739dd229d539$var$dl(a) {
    if (!a) return $4d82739dd229d539$var$Vf;
    a = a._reactInternals;
    a: {
        if ($4d82739dd229d539$var$Vb(a) !== a || 1 !== a.tag) throw Error($4d82739dd229d539$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($4d82739dd229d539$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($4d82739dd229d539$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($4d82739dd229d539$var$Zf(c)) return $4d82739dd229d539$var$bg(a, c, b);
    }
    return b;
}
function $4d82739dd229d539$var$el(a, b, c, d, e, f, g, h, k) {
    a = $4d82739dd229d539$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $4d82739dd229d539$var$dl(null);
    c = a.current;
    d = $4d82739dd229d539$var$R();
    e = $4d82739dd229d539$var$yi(c);
    f = $4d82739dd229d539$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $4d82739dd229d539$var$nh(c, f, e);
    a.current.lanes = e;
    $4d82739dd229d539$var$Ac(a, e, d);
    $4d82739dd229d539$var$Dk(a, d);
    return a;
}
function $4d82739dd229d539$var$fl(a, b, c, d) {
    var e = b.current, f = $4d82739dd229d539$var$R(), g = $4d82739dd229d539$var$yi(e);
    c = $4d82739dd229d539$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $4d82739dd229d539$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $4d82739dd229d539$var$nh(e, b, g);
    null !== a && ($4d82739dd229d539$var$gi(a, e, g, f), $4d82739dd229d539$var$oh(a, e, g));
    return g;
}
function $4d82739dd229d539$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4d82739dd229d539$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $4d82739dd229d539$var$il(a, b) {
    $4d82739dd229d539$var$hl(a, b);
    (a = a.alternate) && $4d82739dd229d539$var$hl(a, b);
}
function $4d82739dd229d539$var$jl() {
    return null;
}
var $4d82739dd229d539$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $4d82739dd229d539$var$ll(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.render = $4d82739dd229d539$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($4d82739dd229d539$var$p(409));
    $4d82739dd229d539$var$fl(a, b, null, null);
};
$4d82739dd229d539$var$ml.prototype.unmount = $4d82739dd229d539$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $4d82739dd229d539$var$Rk(function() {
            $4d82739dd229d539$var$fl(null, a, null, null);
        });
        b[$4d82739dd229d539$var$uf] = null;
    }
};
function $4d82739dd229d539$var$ml(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $4d82739dd229d539$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $4d82739dd229d539$var$Qc.length && 0 !== b && b < $4d82739dd229d539$var$Qc[c].priority; c++);
        $4d82739dd229d539$var$Qc.splice(c, 0, a);
        0 === c && $4d82739dd229d539$var$Vc(a);
    }
};
function $4d82739dd229d539$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $4d82739dd229d539$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $4d82739dd229d539$var$pl() {}
function $4d82739dd229d539$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $4d82739dd229d539$var$gl(g);
                f.call(a);
            };
        }
        var g = $4d82739dd229d539$var$el(b, d, a, 0, null, !1, !1, "", $4d82739dd229d539$var$pl);
        a._reactRootContainer = g;
        a[$4d82739dd229d539$var$uf] = g.current;
        $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
        $4d82739dd229d539$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $4d82739dd229d539$var$gl(k);
            h.call(a);
        };
    }
    var k = $4d82739dd229d539$var$bl(a, 0, !1, null, null, !1, !1, "", $4d82739dd229d539$var$pl);
    a._reactRootContainer = k;
    a[$4d82739dd229d539$var$uf] = k.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    $4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$fl(b, k, c, d);
    });
    return k;
}
function $4d82739dd229d539$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4d82739dd229d539$var$gl(g);
                h.call(a);
            };
        }
        $4d82739dd229d539$var$fl(b, g, a, e);
    } else g = $4d82739dd229d539$var$ql(c, b, a, e, d);
    return $4d82739dd229d539$var$gl(g);
}
$4d82739dd229d539$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $4d82739dd229d539$var$tc(b.pendingLanes);
                0 !== c && ($4d82739dd229d539$var$Cc(b, c | 1), $4d82739dd229d539$var$Dk(b, $4d82739dd229d539$var$B()), 0 === ($4d82739dd229d539$var$K & 6) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$jg()));
            }
            break;
        case 13:
            $4d82739dd229d539$var$Rk(function() {
                var b = $4d82739dd229d539$var$ih(a, 1);
                if (null !== b) {
                    var c = $4d82739dd229d539$var$R();
                    $4d82739dd229d539$var$gi(b, a, 1, c);
                }
            }), $4d82739dd229d539$var$il(a, 1);
    }
};
$4d82739dd229d539$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$ih(a, 134217728);
        if (null !== b) {
            var c = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(b, a, 134217728, c);
        }
        $4d82739dd229d539$var$il(a, 134217728);
    }
};
$4d82739dd229d539$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$yi(a), c = $4d82739dd229d539$var$ih(a, b);
        if (null !== c) {
            var d = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(c, a, b, d);
        }
        $4d82739dd229d539$var$il(a, b);
    }
};
$4d82739dd229d539$var$Hc = function() {
    return $4d82739dd229d539$var$C;
};
$4d82739dd229d539$var$Ic = function(a, b) {
    var c = $4d82739dd229d539$var$C;
    try {
        return $4d82739dd229d539$var$C = a, b();
    } finally{
        $4d82739dd229d539$var$C = c;
    }
};
$4d82739dd229d539$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $4d82739dd229d539$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4d82739dd229d539$var$Db(d);
                        if (!e) throw Error($4d82739dd229d539$var$p(90));
                        $4d82739dd229d539$var$Wa(d);
                        $4d82739dd229d539$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4d82739dd229d539$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $4d82739dd229d539$var$fb(a, !!c.multiple, b, !1);
    }
};
$4d82739dd229d539$var$Gb = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$var$Hb = $4d82739dd229d539$var$Rk;
var $4d82739dd229d539$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $4d82739dd229d539$var$Cb,
        $4d82739dd229d539$var$ue,
        $4d82739dd229d539$var$Db,
        $4d82739dd229d539$var$Eb,
        $4d82739dd229d539$var$Fb,
        $4d82739dd229d539$var$Qk
    ]
}, $4d82739dd229d539$var$tl = {
    findFiberByHostInstance: $4d82739dd229d539$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $4d82739dd229d539$var$ul = {
    bundleType: $4d82739dd229d539$var$tl.bundleType,
    version: $4d82739dd229d539$var$tl.version,
    rendererPackageName: $4d82739dd229d539$var$tl.rendererPackageName,
    rendererConfig: $4d82739dd229d539$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $4d82739dd229d539$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $4d82739dd229d539$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $4d82739dd229d539$var$tl.findFiberByHostInstance || $4d82739dd229d539$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4d82739dd229d539$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4d82739dd229d539$var$vl.isDisabled && $4d82739dd229d539$var$vl.supportsFiber) try {
        $4d82739dd229d539$var$kc = $4d82739dd229d539$var$vl.inject($4d82739dd229d539$var$ul), $4d82739dd229d539$var$lc = $4d82739dd229d539$var$vl;
    } catch (a) {}
}
$4d82739dd229d539$export$ae55be85d98224ed = $4d82739dd229d539$var$sl;
$4d82739dd229d539$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$4d82739dd229d539$var$nl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$cl(a, b, null, c);
};
$4d82739dd229d539$export$882461b6382ed46c = function(a, b) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(299));
    var c = !1, d = "", e = $4d82739dd229d539$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $4d82739dd229d539$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $4d82739dd229d539$var$ll(b);
};
$4d82739dd229d539$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($4d82739dd229d539$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($4d82739dd229d539$var$p(268, a));
    }
    a = $4d82739dd229d539$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$4d82739dd229d539$export$cd75ccfd720a3cd4 = function(a) {
    return $4d82739dd229d539$var$Rk(a);
};
$4d82739dd229d539$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !0, c);
};
$4d82739dd229d539$export$757ceba2d55c277e = function(a, b, c) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $4d82739dd229d539$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $4d82739dd229d539$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $4d82739dd229d539$var$ml(b);
};
$4d82739dd229d539$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !1, c);
};
$4d82739dd229d539$export$502457920280e6be = function(a) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(40));
    return a._reactRootContainer ? ($4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$4d82739dd229d539$var$uf] = null;
        });
    }), !0) : !1;
};
$4d82739dd229d539$export$c78a37762a8d58e1 = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$4d82739dd229d539$var$ol(c)) throw Error($4d82739dd229d539$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($4d82739dd229d539$var$p(38));
    return $4d82739dd229d539$var$rl(a, b, c, !1, d);
};
$4d82739dd229d539$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("33s19", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$cf845f2c119da08a;
'use strict';
function $749777fefd570b40$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $749777fefd570b40$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $749777fefd570b40$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $749777fefd570b40$var$g(C, c)) n < e && 0 > $749777fefd570b40$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $749777fefd570b40$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $749777fefd570b40$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
var $749777fefd570b40$var$r = [], $749777fefd570b40$var$t = [], $749777fefd570b40$var$u = 1, $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = 3, $749777fefd570b40$var$z = !1, $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = !1, $749777fefd570b40$var$D = "function" === typeof setTimeout ? setTimeout : null, $749777fefd570b40$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $749777fefd570b40$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $749777fefd570b40$var$G(a) {
    for(var b = $749777fefd570b40$var$h($749777fefd570b40$var$t); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$k($749777fefd570b40$var$t);
        else if (b.startTime <= a) $749777fefd570b40$var$k($749777fefd570b40$var$t), b.sortIndex = b.expirationTime, $749777fefd570b40$var$f($749777fefd570b40$var$r, b);
        else break;
        b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
    }
}
function $749777fefd570b40$var$H(a) {
    $749777fefd570b40$var$B = !1;
    $749777fefd570b40$var$G(a);
    if (!$749777fefd570b40$var$A) {
        if (null !== $749777fefd570b40$var$h($749777fefd570b40$var$r)) $749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J);
        else {
            var b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== b && $749777fefd570b40$var$K($749777fefd570b40$var$H, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$J(a, b) {
    $749777fefd570b40$var$A = !1;
    $749777fefd570b40$var$B && ($749777fefd570b40$var$B = !1, $749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1);
    $749777fefd570b40$var$z = !0;
    var c = $749777fefd570b40$var$y;
    try {
        $749777fefd570b40$var$G(b);
        for($749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r); null !== $749777fefd570b40$var$v && (!($749777fefd570b40$var$v.expirationTime > b) || a && !$749777fefd570b40$var$M());){
            var d = $749777fefd570b40$var$v.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$v.callback = null;
                $749777fefd570b40$var$y = $749777fefd570b40$var$v.priorityLevel;
                var e = d($749777fefd570b40$var$v.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$v.callback = e : $749777fefd570b40$var$v === $749777fefd570b40$var$h($749777fefd570b40$var$r) && $749777fefd570b40$var$k($749777fefd570b40$var$r);
                $749777fefd570b40$var$G(b);
            } else $749777fefd570b40$var$k($749777fefd570b40$var$r);
            $749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r);
        }
        if (null !== $749777fefd570b40$var$v) var w = !0;
        else {
            var m = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== m && $749777fefd570b40$var$K($749777fefd570b40$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = c, $749777fefd570b40$var$z = !1;
    }
}
var $749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$L = -1, $749777fefd570b40$var$P = 5, $749777fefd570b40$var$Q = -1;
function $749777fefd570b40$var$M() {
    return $749777fefd570b40$export$c4744153514ff05d() - $749777fefd570b40$var$Q < $749777fefd570b40$var$P ? !1 : !0;
}
function $749777fefd570b40$var$R() {
    if (null !== $749777fefd570b40$var$O) {
        var a = $749777fefd570b40$export$c4744153514ff05d();
        $749777fefd570b40$var$Q = a;
        var b = !0;
        try {
            b = $749777fefd570b40$var$O(!0, a);
        } finally{
            b ? $749777fefd570b40$var$S() : ($749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null);
        }
    } else $749777fefd570b40$var$N = !1;
}
var $749777fefd570b40$var$S;
if ("function" === typeof $749777fefd570b40$var$F) $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$F($749777fefd570b40$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $749777fefd570b40$var$T = new MessageChannel, $749777fefd570b40$var$U = $749777fefd570b40$var$T.port2;
    $749777fefd570b40$var$T.port1.onmessage = $749777fefd570b40$var$R;
    $749777fefd570b40$var$S = function() {
        $749777fefd570b40$var$U.postMessage(null);
    };
} else $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$D($749777fefd570b40$var$R, 0);
};
function $749777fefd570b40$var$I(a) {
    $749777fefd570b40$var$O = a;
    $749777fefd570b40$var$N || ($749777fefd570b40$var$N = !0, $749777fefd570b40$var$S());
}
function $749777fefd570b40$var$K(a, b) {
    $749777fefd570b40$var$L = $749777fefd570b40$var$D(function() {
        a($749777fefd570b40$export$c4744153514ff05d());
    }, b);
}
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J));
};
$749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$y;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$h($749777fefd570b40$var$r);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$y;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = function() {};
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$f($749777fefd570b40$var$t, a), null === $749777fefd570b40$var$h($749777fefd570b40$var$r) && a === $749777fefd570b40$var$h($749777fefd570b40$var$t) && ($749777fefd570b40$var$B ? ($749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1) : $749777fefd570b40$var$B = !0, $749777fefd570b40$var$K($749777fefd570b40$var$H, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$f($749777fefd570b40$var$r, a), $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J)));
    return a;
};
$749777fefd570b40$export$b5836b71941fa3ed = $749777fefd570b40$var$M;
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$y;
    return function() {
        var c = $749777fefd570b40$var$y;
        $749777fefd570b40$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$y = c;
        }
    };
};

});



parcelRegister("gzcup", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("diYUK")).default; });

var $diYUK = parcelRequire("diYUK");

});
parcelRegister("diYUK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9afc3518733c6a5e$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $9afc3518733c6a5e$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});


parcelRegister("8m7yE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("5mrJy")).default; });

var $5mrJy = parcelRequire("5mrJy");

});
parcelRegister("5mrJy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e74852d812b8b64$export$2e2bcd8739ae039; });
function $3e74852d812b8b64$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $3e74852d812b8b64$export$2e2bcd8739ae039 = $3e74852d812b8b64$var$clamp;

});


parcelRegister("45MkT", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $2fad1f91101d4119$export$2b8d127b894957b9; }, function (v) { return $2fad1f91101d4119$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $2fad1f91101d4119$export$cea3a54a6425200c; }, function (v) { return $2fad1f91101d4119$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $2fad1f91101d4119$export$a7c73072b1a182ae; }, function (v) { return $2fad1f91101d4119$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2fad1f91101d4119$export$9f27bc3417b4524d; }, function (v) { return $2fad1f91101d4119$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2fad1f91101d4119$export$db77ccec0bb4ccac; }, function (v) { return $2fad1f91101d4119$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2fad1f91101d4119$export$8392c0c9d3dcbd35; }, function (v) { return $2fad1f91101d4119$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2fad1f91101d4119$export$ffb0004e005737fa; }, function (v) { return $2fad1f91101d4119$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2fad1f91101d4119$export$b624eff549462981; }, function (v) { return $2fad1f91101d4119$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2fad1f91101d4119$export$7897aa7841a5380c; }, function (v) { return $2fad1f91101d4119$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2fad1f91101d4119$export$602eac185826482c; }, function (v) { return $2fad1f91101d4119$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2fad1f91101d4119$export$e2c29f18771995cb; }, function (v) { return $2fad1f91101d4119$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2fad1f91101d4119$export$5f8d39834fd61797; }, function (v) { return $2fad1f91101d4119$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2fad1f91101d4119$export$74bf444e3cd11ea5; }, function (v) { return $2fad1f91101d4119$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2fad1f91101d4119$export$92387174baf9b227; }, function (v) { return $2fad1f91101d4119$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2fad1f91101d4119$export$ec112efeb987d9c6; }, function (v) { return $2fad1f91101d4119$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2fad1f91101d4119$export$b706b080d889d2c9; }, function (v) { return $2fad1f91101d4119$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2fad1f91101d4119$export$5be5a87408f70ddc; }, function (v) { return $2fad1f91101d4119$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2fad1f91101d4119$export$45a5e7f76e0caa8d; }, function (v) { return $2fad1f91101d4119$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2fad1f91101d4119$export$455c2e768291efa6; }, function (v) { return $2fad1f91101d4119$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2fad1f91101d4119$export$9522e17588c12572; }, function (v) { return $2fad1f91101d4119$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2fad1f91101d4119$export$2110ac352bb060b9; }, function (v) { return $2fad1f91101d4119$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2fad1f91101d4119$export$56885ab8b9c456ab; }, function (v) { return $2fad1f91101d4119$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2fad1f91101d4119$export$d927fcb6adf8f9de; }, function (v) { return $2fad1f91101d4119$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2fad1f91101d4119$export$b82d16f27459e05a; }, function (v) { return $2fad1f91101d4119$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2fad1f91101d4119$export$522c17b4f5e123e8; }, function (v) { return $2fad1f91101d4119$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2fad1f91101d4119$export$1aabd8a0274ecfd6; }, function (v) { return $2fad1f91101d4119$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2fad1f91101d4119$export$9b621391a187a31a; }, function (v) { return $2fad1f91101d4119$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2fad1f91101d4119$export$f5bbd400c2f4426f; }, function (v) { return $2fad1f91101d4119$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2fad1f91101d4119$export$2b8d127b894957b9;
var $2fad1f91101d4119$export$cea3a54a6425200c;
var $2fad1f91101d4119$export$a7c73072b1a182ae;
var $2fad1f91101d4119$export$9f27bc3417b4524d;
var $2fad1f91101d4119$export$db77ccec0bb4ccac;
var $2fad1f91101d4119$export$8392c0c9d3dcbd35;
var $2fad1f91101d4119$export$ffb0004e005737fa;
var $2fad1f91101d4119$export$b624eff549462981;
var $2fad1f91101d4119$export$7897aa7841a5380c;
var $2fad1f91101d4119$export$602eac185826482c;
var $2fad1f91101d4119$export$e2c29f18771995cb;
var $2fad1f91101d4119$export$5f8d39834fd61797;
var $2fad1f91101d4119$export$74bf444e3cd11ea5;
var $2fad1f91101d4119$export$92387174baf9b227;
var $2fad1f91101d4119$export$ec112efeb987d9c6;
var $2fad1f91101d4119$export$b706b080d889d2c9;
var $2fad1f91101d4119$export$5be5a87408f70ddc;
var $2fad1f91101d4119$export$45a5e7f76e0caa8d;
var $2fad1f91101d4119$export$455c2e768291efa6;
var $2fad1f91101d4119$export$9522e17588c12572;
var $2fad1f91101d4119$export$2110ac352bb060b9;
var $2fad1f91101d4119$export$56885ab8b9c456ab;
var $2fad1f91101d4119$export$d927fcb6adf8f9de;
var $2fad1f91101d4119$export$b82d16f27459e05a;
var $2fad1f91101d4119$export$522c17b4f5e123e8;
var $2fad1f91101d4119$export$1aabd8a0274ecfd6;
var $2fad1f91101d4119$export$9b621391a187a31a;
var $2fad1f91101d4119$export$f5bbd400c2f4426f;
'use strict';
var $2fad1f91101d4119$var$b = "function" === typeof Symbol && Symbol.for, $2fad1f91101d4119$var$c = $2fad1f91101d4119$var$b ? Symbol.for("react.element") : 60103, $2fad1f91101d4119$var$d = $2fad1f91101d4119$var$b ? Symbol.for("react.portal") : 60106, $2fad1f91101d4119$var$e = $2fad1f91101d4119$var$b ? Symbol.for("react.fragment") : 60107, $2fad1f91101d4119$var$f = $2fad1f91101d4119$var$b ? Symbol.for("react.strict_mode") : 60108, $2fad1f91101d4119$var$g = $2fad1f91101d4119$var$b ? Symbol.for("react.profiler") : 60114, $2fad1f91101d4119$var$h = $2fad1f91101d4119$var$b ? Symbol.for("react.provider") : 60109, $2fad1f91101d4119$var$k = $2fad1f91101d4119$var$b ? Symbol.for("react.context") : 60110, $2fad1f91101d4119$var$l = $2fad1f91101d4119$var$b ? Symbol.for("react.async_mode") : 60111, $2fad1f91101d4119$var$m = $2fad1f91101d4119$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2fad1f91101d4119$var$n = $2fad1f91101d4119$var$b ? Symbol.for("react.forward_ref") : 60112, $2fad1f91101d4119$var$p = $2fad1f91101d4119$var$b ? Symbol.for("react.suspense") : 60113, $2fad1f91101d4119$var$q = $2fad1f91101d4119$var$b ? Symbol.for("react.suspense_list") : 60120, $2fad1f91101d4119$var$r = $2fad1f91101d4119$var$b ? Symbol.for("react.memo") : 60115, $2fad1f91101d4119$var$t = $2fad1f91101d4119$var$b ? Symbol.for("react.lazy") : 60116, $2fad1f91101d4119$var$v = $2fad1f91101d4119$var$b ? Symbol.for("react.block") : 60121, $2fad1f91101d4119$var$w = $2fad1f91101d4119$var$b ? Symbol.for("react.fundamental") : 60117, $2fad1f91101d4119$var$x = $2fad1f91101d4119$var$b ? Symbol.for("react.responder") : 60118, $2fad1f91101d4119$var$y = $2fad1f91101d4119$var$b ? Symbol.for("react.scope") : 60119;
function $2fad1f91101d4119$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2fad1f91101d4119$var$c:
                switch(a = a.type, a){
                    case $2fad1f91101d4119$var$l:
                    case $2fad1f91101d4119$var$m:
                    case $2fad1f91101d4119$var$e:
                    case $2fad1f91101d4119$var$g:
                    case $2fad1f91101d4119$var$f:
                    case $2fad1f91101d4119$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2fad1f91101d4119$var$k:
                            case $2fad1f91101d4119$var$n:
                            case $2fad1f91101d4119$var$t:
                            case $2fad1f91101d4119$var$r:
                            case $2fad1f91101d4119$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2fad1f91101d4119$var$d:
                return u;
        }
    }
}
function $2fad1f91101d4119$var$A(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$m;
}
$2fad1f91101d4119$export$2b8d127b894957b9 = $2fad1f91101d4119$var$l;
$2fad1f91101d4119$export$cea3a54a6425200c = $2fad1f91101d4119$var$m;
$2fad1f91101d4119$export$a7c73072b1a182ae = $2fad1f91101d4119$var$k;
$2fad1f91101d4119$export$9f27bc3417b4524d = $2fad1f91101d4119$var$h;
$2fad1f91101d4119$export$db77ccec0bb4ccac = $2fad1f91101d4119$var$c;
$2fad1f91101d4119$export$8392c0c9d3dcbd35 = $2fad1f91101d4119$var$n;
$2fad1f91101d4119$export$ffb0004e005737fa = $2fad1f91101d4119$var$e;
$2fad1f91101d4119$export$b624eff549462981 = $2fad1f91101d4119$var$t;
$2fad1f91101d4119$export$7897aa7841a5380c = $2fad1f91101d4119$var$r;
$2fad1f91101d4119$export$602eac185826482c = $2fad1f91101d4119$var$d;
$2fad1f91101d4119$export$e2c29f18771995cb = $2fad1f91101d4119$var$g;
$2fad1f91101d4119$export$5f8d39834fd61797 = $2fad1f91101d4119$var$f;
$2fad1f91101d4119$export$74bf444e3cd11ea5 = $2fad1f91101d4119$var$p;
$2fad1f91101d4119$export$92387174baf9b227 = function(a) {
    return $2fad1f91101d4119$var$A(a) || $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$l;
};
$2fad1f91101d4119$export$ec112efeb987d9c6 = $2fad1f91101d4119$var$A;
$2fad1f91101d4119$export$b706b080d889d2c9 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$k;
};
$2fad1f91101d4119$export$5be5a87408f70ddc = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$h;
};
$2fad1f91101d4119$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2fad1f91101d4119$var$c;
};
$2fad1f91101d4119$export$455c2e768291efa6 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$n;
};
$2fad1f91101d4119$export$9522e17588c12572 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$e;
};
$2fad1f91101d4119$export$2110ac352bb060b9 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$t;
};
$2fad1f91101d4119$export$56885ab8b9c456ab = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$r;
};
$2fad1f91101d4119$export$d927fcb6adf8f9de = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$d;
};
$2fad1f91101d4119$export$b82d16f27459e05a = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$g;
};
$2fad1f91101d4119$export$522c17b4f5e123e8 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$f;
};
$2fad1f91101d4119$export$1aabd8a0274ecfd6 = function(a) {
    return $2fad1f91101d4119$var$z(a) === $2fad1f91101d4119$var$p;
};
$2fad1f91101d4119$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2fad1f91101d4119$var$e || a === $2fad1f91101d4119$var$m || a === $2fad1f91101d4119$var$g || a === $2fad1f91101d4119$var$f || a === $2fad1f91101d4119$var$p || a === $2fad1f91101d4119$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2fad1f91101d4119$var$t || a.$$typeof === $2fad1f91101d4119$var$r || a.$$typeof === $2fad1f91101d4119$var$h || a.$$typeof === $2fad1f91101d4119$var$k || a.$$typeof === $2fad1f91101d4119$var$n || a.$$typeof === $2fad1f91101d4119$var$w || a.$$typeof === $2fad1f91101d4119$var$x || a.$$typeof === $2fad1f91101d4119$var$y || a.$$typeof === $2fad1f91101d4119$var$v);
};
$2fad1f91101d4119$export$f5bbd400c2f4426f = $2fad1f91101d4119$var$z;

});

parcelRegister("cvBp9", function(module, exports) {
function $91b5651481cc9d5c$var$_extends() {
    return module.exports = $91b5651481cc9d5c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $91b5651481cc9d5c$var$_extends.apply(null, arguments);
}
module.exports = $91b5651481cc9d5c$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5VCcJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $450fe936b88a7a32$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $450fe936b88a7a32$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "internal_serializeStyles", function () { return $450fe936b88a7a32$export$13a2d3ef13012b32; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("6te04")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("5nUae")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("5nUae")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("e6xq6")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("5tMhb")).default; });
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $70jUf = parcelRequire("70jUf");

var $6lPck = parcelRequire("6lPck");

var $5nUae = parcelRequire("5nUae");
var $6te04 = parcelRequire("6te04");

var $e6xq6 = parcelRequire("e6xq6");

var $5tMhb = parcelRequire("5tMhb");
'use client';
function $450fe936b88a7a32$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $70jUf.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $450fe936b88a7a32$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};
// Emotion only accepts an array, but we want to avoid allocations
const $450fe936b88a7a32$var$wrapper = [];
function $450fe936b88a7a32$export$13a2d3ef13012b32(styles) {
    $450fe936b88a7a32$var$wrapper[0] = styles;
    return (0, $6lPck.serializeStyles)($450fe936b88a7a32$var$wrapper);
}

});
parcelRegister("70jUf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5197f9709daec52b$export$2e2bcd8739ae039; });

var $lmsDT = parcelRequire("lmsDT");
parcelRequire("cvBp9");

parcelRequire("6lPck");
parcelRequire("9uXao");
parcelRequire("80dPg");
parcelRequire("7fPBF");
parcelRequire("9YmaI");
var $5197f9709daec52b$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $5197f9709daec52b$export$2e2bcd8739ae039 = (0, $lmsDT.default).bind(null);
$5197f9709daec52b$var$tags.forEach(function(tagName) {
    $5197f9709daec52b$export$2e2bcd8739ae039[tagName] = $5197f9709daec52b$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("lmsDT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8d1dedc3623dfeb$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("5nUae");
var $6te04 = parcelRequire("6te04");

var $6lPck = parcelRequire("6lPck");

var $9uXao = parcelRequire("9uXao");

var $80dPg = parcelRequire("80dPg");

var $7fPBF = parcelRequire("7fPBF");

var $9YmaI = parcelRequire("9YmaI");
var $f8d1dedc3623dfeb$var$isBrowser = typeof document !== 'undefined';
var $f8d1dedc3623dfeb$var$isDevelopment = false;
var $f8d1dedc3623dfeb$var$testOmitPropsOnStringTag = (0, $9YmaI.default);
var $f8d1dedc3623dfeb$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $f8d1dedc3623dfeb$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $f8d1dedc3623dfeb$var$testOmitPropsOnStringTag : $f8d1dedc3623dfeb$var$testOmitPropsOnComponent;
};
var $f8d1dedc3623dfeb$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $f8d1dedc3623dfeb$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $80dPg.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $9uXao.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $80dPg.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$f8d1dedc3623dfeb$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $f8d1dedc3623dfeb$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $f8d1dedc3623dfeb$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $f8d1dedc3623dfeb$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $6te04.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $7fPBF.useContext((0, $6te04.T));
            }
            if (typeof props.className === 'string') className = (0, $80dPg.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $6lPck.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $f8d1dedc3623dfeb$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($f8d1dedc3623dfeb$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $7fPBF.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $f8d1dedc3623dfeb$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $kY3Ke.default)({}, options, nextOptions, {
                shouldForwardProp: $f8d1dedc3623dfeb$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("kY3Ke", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f43c50d92a19d876$export$2e2bcd8739ae039; });
function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    return $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f43c50d92a19d876$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("5nUae", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $3ebaaabf76fb5db5$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $3ebaaabf76fb5db5$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $3ebaaabf76fb5db5$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("6te04")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("6te04")).w; });

var $6te04 = parcelRequire("6te04");

var $7fPBF = parcelRequire("7fPBF");

var $80dPg = parcelRequire("80dPg");

var $9uXao = parcelRequire("9uXao");

var $6lPck = parcelRequire("6lPck");
parcelRequire("3mESc");
parcelRequire("cvBp9");
parcelRequire("lT6zG");

parcelRequire("8Ae2G");
var $3ebaaabf76fb5db5$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $6te04.h).call(props, 'css')) return $7fPBF.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $6te04.E);
    createElementArgArray[1] = (0, $6te04.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $7fPBF.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($3ebaaabf76fb5db5$export$c8a8987d4410bf2d || ($3ebaaabf76fb5db5$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $3ebaaabf76fb5db5$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $6te04.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $6lPck.serializeStyles)([
        styles
    ], undefined, $7fPBF.useContext((0, $6te04.T)));
    if (!(0, $6te04.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $7fPBF.useRef();
    (0, $9uXao.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $9uXao.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $80dPg.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $3ebaaabf76fb5db5$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $6lPck.serializeStyles)(args);
}
function $3ebaaabf76fb5db5$export$d25ddfdf17c3ad3e() {
    var insertable = $3ebaaabf76fb5db5$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $3ebaaabf76fb5db5$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $3ebaaabf76fb5db5$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $80dPg.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $3ebaaabf76fb5db5$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $9uXao.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $80dPg.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $6te04.i) && res !== undefined) rules += res;
        }
        if (!(0, $6te04.i)) return rules;
    });
    if (!(0, $6te04.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $3ebaaabf76fb5db5$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $6te04.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $6te04.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $6lPck.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $80dPg.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $6te04.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $3ebaaabf76fb5db5$var$merge(cache.registered, css, $3ebaaabf76fb5db5$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $7fPBF.useContext((0, $6te04.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($3ebaaabf76fb5db5$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("6te04", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $4b604f9ff2f6f5b8$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $4b604f9ff2f6f5b8$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $4b604f9ff2f6f5b8$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $4b604f9ff2f6f5b8$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $4b604f9ff2f6f5b8$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $4b604f9ff2f6f5b8$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $4b604f9ff2f6f5b8$export$a9c23c6ac3fc3eca; });

var $7fPBF = parcelRequire("7fPBF");

var $3mESc = parcelRequire("3mESc");

var $kY3Ke = parcelRequire("kY3Ke");

var $lT6zG = parcelRequire("lT6zG");

var $10FT7 = parcelRequire("10FT7");

var $80dPg = parcelRequire("80dPg");

var $6lPck = parcelRequire("6lPck");

var $9uXao = parcelRequire("9uXao");
var $4b604f9ff2f6f5b8$export$407448d2b89b1813 = false;
var $4b604f9ff2f6f5b8$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $4b604f9ff2f6f5b8$var$EmotionCacheContext = /* #__PURE__ */ $7fPBF.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $3mESc.default)({
    key: 'css'
}) : null);
var $4b604f9ff2f6f5b8$export$e7094788287c5e9b = $4b604f9ff2f6f5b8$var$EmotionCacheContext.Provider;
var $4b604f9ff2f6f5b8$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
};
var $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$4b604f9ff2f6f5b8$export$23f2a1d2818174ef) $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $3mESc.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $4b604f9ff2f6f5b8$export$971d5caa766a69d7 = /* #__PURE__ */ $7fPBF.createContext({});
var $4b604f9ff2f6f5b8$export$3b14a55fb2447963 = function useTheme() {
    return $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
};
var $4b604f9ff2f6f5b8$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $kY3Ke.default)({}, outerTheme, theme);
};
var $4b604f9ff2f6f5b8$var$createCacheWithTheme = /* #__PURE__ */ (0, $lT6zG.default)(function(outerTheme) {
    return (0, $lT6zG.default)(function(theme) {
        return $4b604f9ff2f6f5b8$var$getTheme(outerTheme, theme);
    });
});
var $4b604f9ff2f6f5b8$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $4b604f9ff2f6f5b8$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $4b604f9ff2f6f5b8$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $7fPBF.forwardRef(function render(props, ref) {
        var theme = $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $10FT7.default)(WithTheme, Component);
}
var $4b604f9ff2f6f5b8$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $4b604f9ff2f6f5b8$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $4b604f9ff2f6f5b8$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($4b604f9ff2f6f5b8$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$4b604f9ff2f6f5b8$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $4b604f9ff2f6f5b8$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $80dPg.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $9uXao.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $80dPg.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$4b604f9ff2f6f5b8$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $4b604f9ff2f6f5b8$var$Emotion = /* #__PURE__ */ $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$4b604f9ff2f6f5b8$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $80dPg.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $6lPck.serializeStyles)(registeredStyles, undefined, $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($4b604f9ff2f6f5b8$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $4b604f9ff2f6f5b8$var$typePropName && !$4b604f9ff2f6f5b8$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $7fPBF.createElement(WrappedComponent, newProps));
});
var $4b604f9ff2f6f5b8$export$a9c23c6ac3fc3eca = $4b604f9ff2f6f5b8$var$Emotion;

});
parcelRegister("3mESc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $273321b94be832ab$export$2e2bcd8739ae039; });

var $4cVy4 = parcelRequire("4cVy4");

var $cByrN = parcelRequire("cByrN");

var $lT6zG = parcelRequire("lT6zG");

var $4AWAi = parcelRequire("4AWAi");
var $273321b94be832ab$var$isBrowser = typeof document !== 'undefined';
var $273321b94be832ab$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $cByrN.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $cByrN.token)(character)) break;
        (0, $cByrN.next)();
    }
    return (0, $cByrN.slice)(begin, (0, $cByrN.position));
};
var $273321b94be832ab$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $cByrN.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $cByrN.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $273321b94be832ab$var$identifierWithPointTracking((0, $cByrN.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $cByrN.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $cByrN.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $cByrN.from)(character);
    }
    while (character = (0, $cByrN.next)());
    return parsed;
};
var $273321b94be832ab$var$getRules = function getRules(value, points) {
    return (0, $cByrN.dealloc)($273321b94be832ab$var$toRules((0, $cByrN.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $273321b94be832ab$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $273321b94be832ab$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$273321b94be832ab$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $273321b94be832ab$var$fixedElements.set(element, true);
    var points = [];
    var rules = $273321b94be832ab$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $273321b94be832ab$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $273321b94be832ab$var$prefix(value, length) {
    switch((0, $cByrN.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $cByrN.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $cByrN.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MOZ) + value + (0, $cByrN.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + value + value;
        // order
        case 6165:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.replace)(value, /(\w+).+(:[^]+)/, (0, $cByrN.WEBKIT) + 'box-$1$2' + (0, $cByrN.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + 'flex-item-' + (0, $cByrN.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + 'flex-line-pack' + (0, $cByrN.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $cByrN.WEBKIT) + 'box-' + (0, $cByrN.replace)(value, '-grow', '') + (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $cByrN.WEBKIT) + (0, $cByrN.replace)(value, /([^-])(transform)/g, '$1' + (0, $cByrN.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $cByrN.replace)((0, $cByrN.replace)((0, $cByrN.replace)(value, /(zoom-|grab)/, (0, $cByrN.WEBKIT) + '$1'), /(image-set)/, (0, $cByrN.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $cByrN.replace)(value, /(image-set\([^]*)/, (0, $cByrN.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $cByrN.replace)((0, $cByrN.replace)(value, /(.+:)(flex-)?(.*)/, (0, $cByrN.WEBKIT) + 'box-pack:$3' + (0, $cByrN.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $cByrN.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $cByrN.replace)(value, /(.+)-inline(.+)/, (0, $cByrN.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $cByrN.strlen)(value) - 1 - length > 6) switch((0, $cByrN.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $cByrN.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $cByrN.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $cByrN.WEBKIT) + '$2-$3' + '$1' + (0, $cByrN.MOZ) + ((0, $cByrN.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $cByrN.indexof)(value, 'stretch') ? $273321b94be832ab$var$prefix((0, $cByrN.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $cByrN.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $cByrN.charat)(value, (0, $cByrN.strlen)(value) - 3 - (~(0, $cByrN.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $cByrN.replace)(value, ':', ':' + (0, $cByrN.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $cByrN.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $cByrN.WEBKIT) + ((0, $cByrN.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $cByrN.WEBKIT) + '$2$3' + '$1' + (0, $cByrN.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $cByrN.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + value + value;
    }
    return value;
}
var $273321b94be832ab$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $cByrN.DECLARATION:
                element["return"] = $273321b94be832ab$var$prefix(element.value, element.length);
                break;
            case 0, $cByrN.KEYFRAMES:
                return (0, $cByrN.serialize)([
                    (0, $cByrN.copy)(element, {
                        value: (0, $cByrN.replace)(element.value, '@', '@' + (0, $cByrN.WEBKIT))
                    })
                ], callback);
            case 0, $cByrN.RULESET:
                if (element.length) return (0, $cByrN.combine)(element.props, function(value) {
                    switch((0, $cByrN.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $cByrN.serialize)([
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(read-\w+)/, ':' + (0, $cByrN.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $cByrN.serialize)([
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, ':' + (0, $cByrN.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, ':' + (0, $cByrN.MOZ) + '$1')
                                    ]
                                }),
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, (0, $cByrN.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $273321b94be832ab$var$getServerStylisCache = $273321b94be832ab$var$isBrowser ? undefined : (0, $lT6zG.default)(function() {
    return (0, $4AWAi.default)(function() {
        return {};
    });
});
var $273321b94be832ab$var$defaultStylisPlugins = [
    $273321b94be832ab$var$prefixer
];
var $273321b94be832ab$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($273321b94be832ab$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $273321b94be832ab$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($273321b94be832ab$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $273321b94be832ab$var$compat,
        $273321b94be832ab$var$removeLabel
    ];
    if (!$273321b94be832ab$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $cByrN.stringify),
            (0, $cByrN.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $cByrN.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $cByrN.serialize)((0, $cByrN.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $cByrN.stringify)
        ];
        var _serializer = (0, $cByrN.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $cByrN.serialize)((0, $cByrN.compile)(styles), _serializer);
        };
        var serverStylisCache = $273321b94be832ab$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $4cVy4.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("4cVy4", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $3104ec53a35158ff$export$9d753cd7ae895cce; });
var $3104ec53a35158ff$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $3104ec53a35158ff$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $3104ec53a35158ff$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $3104ec53a35158ff$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$3104ec53a35158ff$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($3104ec53a35158ff$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $3104ec53a35158ff$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("cByrN", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $83f8df0fc4bef2f6$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $83f8df0fc4bef2f6$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $83f8df0fc4bef2f6$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $83f8df0fc4bef2f6$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $83f8df0fc4bef2f6$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $83f8df0fc4bef2f6$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $83f8df0fc4bef2f6$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $83f8df0fc4bef2f6$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $83f8df0fc4bef2f6$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $83f8df0fc4bef2f6$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $83f8df0fc4bef2f6$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $83f8df0fc4bef2f6$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $83f8df0fc4bef2f6$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $83f8df0fc4bef2f6$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $83f8df0fc4bef2f6$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $83f8df0fc4bef2f6$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $83f8df0fc4bef2f6$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $83f8df0fc4bef2f6$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $83f8df0fc4bef2f6$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $83f8df0fc4bef2f6$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $83f8df0fc4bef2f6$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $83f8df0fc4bef2f6$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $83f8df0fc4bef2f6$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $83f8df0fc4bef2f6$export$38bcb760f1d4871c; });
var $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 = "-ms-";
var $83f8df0fc4bef2f6$export$2c0f367103c8d01c = "-moz-";
var $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 = "-webkit-";
var $83f8df0fc4bef2f6$export$a29989082612d0d9 = "comm";
var $83f8df0fc4bef2f6$export$aa3a2e812ca8570d = "rule";
var $83f8df0fc4bef2f6$export$527d108ccf083c2b = "decl";
var $83f8df0fc4bef2f6$export$d3d35020fa5b54f0 = "@page";
var $83f8df0fc4bef2f6$export$500415a86c544f73 = "@media";
var $83f8df0fc4bef2f6$export$a763edbf796b780a = "@import";
var $83f8df0fc4bef2f6$export$2790aeb8b4e5c826 = "@charset";
var $83f8df0fc4bef2f6$export$1cc683e23b84b133 = "@viewport";
var $83f8df0fc4bef2f6$export$9447a5efea57e862 = "@supports";
var $83f8df0fc4bef2f6$export$ef011b4e114b1fba = "@document";
var $83f8df0fc4bef2f6$export$6aad947bda0f3f46 = "@namespace";
var $83f8df0fc4bef2f6$export$b44a8529a35fcb60 = "@keyframes";
var $83f8df0fc4bef2f6$export$2c16de31893252e6 = "@font-face";
var $83f8df0fc4bef2f6$export$3d846dd52e150c6f = "@counter-style";
var $83f8df0fc4bef2f6$export$22314bfbb57653fe = "@font-feature-values";
var $83f8df0fc4bef2f6$export$d773506282b3cfe6 = "@layer";
var $83f8df0fc4bef2f6$export$2335f513bbd82c6d = Math.abs;
var $83f8df0fc4bef2f6$export$6788812c4e6611e6 = String.fromCharCode;
var $83f8df0fc4bef2f6$export$e6e34fd1f2686227 = Object.assign;
function $83f8df0fc4bef2f6$export$d6af199866bfb566(e, r) {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 1)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 2)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 3) : 0;
}
function $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $83f8df0fc4bef2f6$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $83f8df0fc4bef2f6$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $83f8df0fc4bef2f6$export$36776f635604f274(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$f9084667e487ed46(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $83f8df0fc4bef2f6$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = 1;
var $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1;
var $83f8df0fc4bef2f6$export$f24224f1c91d8156 = 0;
var $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0;
var $83f8df0fc4bef2f6$export$c0306caf338ac095 = 0;
var $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "";
function $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c,
        column: $83f8df0fc4bef2f6$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $83f8df0fc4bef2f6$export$784d13d8ee351f07(e, r) {
    return $83f8df0fc4bef2f6$export$e6e34fd1f2686227($83f8df0fc4bef2f6$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $83f8df0fc4bef2f6$export$eba6f6f03b0a92e7() {
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$232faf9add678146() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 > 0 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, --$83f8df0fc4bef2f6$export$5880b8b5730aff45) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3--, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c--;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 < $83f8df0fc4bef2f6$export$f24224f1c91d8156 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45++) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3++, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c++;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$e88cb2efb12ae807() {
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, r) {
    return $83f8df0fc4bef2f6$export$2f35ab04d2335697($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, e, r);
}
function $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $83f8df0fc4bef2f6$export$2de70f21292aac9e(e) {
    return $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$f24224f1c91d8156 = $83f8df0fc4bef2f6$export$36776f635604f274($83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = e), $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0, [];
}
function $83f8df0fc4bef2f6$export$45918ac1574455b1(e) {
    return $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "", e;
}
function $83f8df0fc4bef2f6$export$410ac95b9ec204b8(e) {
    return $83f8df0fc4bef2f6$export$87c2784dc9fc4ab($83f8df0fc4bef2f6$export$58adb3bec8346d0f($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1, $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1($83f8df0fc4bef2f6$export$2de70f21292aac9e(e)));
}
function $83f8df0fc4bef2f6$export$7af1228ff777d175(e) {
    while($83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 33) $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    else break;
    return $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) > 2 || $83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095)){
        case 0:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
            break;
        default:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
    }
    return e;
}
function $83f8df0fc4bef2f6$export$955ba06d119e085e(e, r) {
    while(--r && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 48 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 102 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 57 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 65 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 70 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 97) break;
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$e88cb2efb12ae807() + (r < 6 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() == 32 && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() == 32));
}
function $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$c0306caf338ac095){
        case e:
            return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12($83f8df0fc4bef2f6$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
            break;
    }
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$4254d4e2b3745c4c(e, r) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 57) break;
    else if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 84 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $83f8df0fc4bef2f6$export$58adb3bec8346d0f(r, $83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1) + "*" + $83f8df0fc4bef2f6$export$6788812c4e6611e6(e === 47 ? e : $83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
}
function $83f8df0fc4bef2f6$export$c2ab62c7bf24634(e) {
    while(!$83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()))$83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$ef7acd7185315e22(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $83f8df0fc4bef2f6$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $83f8df0fc4bef2f6$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($83f8df0fc4bef2f6$export$f8e21b1e77979a08(j += $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $83f8df0fc4bef2f6$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $83f8df0fc4bef2f6$export$955ba06d119e085e($83f8df0fc4bef2f6$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$4a34f930e789283c($83f8df0fc4bef2f6$export$4254d4e2b3745c4c($83f8df0fc4bef2f6$export$48cfd1e771a65c4f(), $83f8df0fc4bef2f6$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $83f8df0fc4bef2f6$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $83f8df0fc4bef2f6$export$36776f635604f274(j) - l) $83f8df0fc4bef2f6$export$10d8903dec122b9d(p > 32 ? $83f8df0fc4bef2f6$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $83f8df0fc4bef2f6$export$f8483753829ec8f3($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d(y = $83f8df0fc4bef2f6$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, y, y, n && $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $83f8df0fc4bef2f6$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $83f8df0fc4bef2f6$export$232faf9add678146() == 125) continue;
            }
            switch(j += $83f8df0fc4bef2f6$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($83f8df0fc4bef2f6$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 45) j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
                    v = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e(), o = l = $83f8df0fc4bef2f6$export$36776f635604f274(g = j += $83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $83f8df0fc4bef2f6$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $83f8df0fc4bef2f6$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, v + 1, v = $83f8df0fc4bef2f6$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, s === 0 ? $83f8df0fc4bef2f6$export$aa3a2e812ca8570d : i, f, o, l);
}
function $83f8df0fc4bef2f6$export$4a34f930e789283c(e, r, a) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$a29989082612d0d9, $83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$eba6f6f03b0a92e7()), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $83f8df0fc4bef2f6$export$f8483753829ec8f3(e, r, a, n) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$527d108ccf083c2b, $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 0, n), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n, c, s) {
    switch($83f8df0fc4bef2f6$export$d6af199866bfb566(n, c)){
        case 5103:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-$1$2" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-item-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-line-pack" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-grow", "") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-pack:$3" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-column-align" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(s, "span") ? $83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) : +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) - +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($83f8df0fc4bef2f6$export$36776f635604f274(n) - 1 - c > 6) switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n, "stretch") ? $83f8df0fc4bef2f6$export$82e9f45cca5ba907($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 6) === 121) return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, $83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $83f8df0fc4bef2f6$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $83f8df0fc4bef2f6$export$a763edbf796b780a:
        case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $83f8df0fc4bef2f6$export$a29989082612d0d9:
            return "";
        case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $83f8df0fc4bef2f6$export$36776f635604f274(a = $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $83f8df0fc4bef2f6$export$5a7767152ae0305f(e) {
    var r = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $83f8df0fc4bef2f6$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $83f8df0fc4bef2f6$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
                n.return = $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
                return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                    $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                        value: $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
                if (n.length) return $83f8df0fc4bef2f6$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($83f8df0fc4bef2f6$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $83f8df0fc4bef2f6$export$76a88f7de6507443(e) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $83f8df0fc4bef2f6$export$1be1fc439b849fdf($83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($83f8df0fc4bef2f6$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $83f8df0fc4bef2f6$export$2f35ab04d2335697(r, 1, $83f8df0fc4bef2f6$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $83f8df0fc4bef2f6$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $83f8df0fc4bef2f6$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("lT6zG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fef3d59b736200bc$export$2e2bcd8739ae039; });
var $fef3d59b736200bc$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("4AWAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3587f7e2ed7416b3$export$2e2bcd8739ae039; });
function $3587f7e2ed7416b3$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("10FT7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bc6489980e08e1c$export$2e2bcd8739ae039; });

var $8Ae2G = parcelRequire("8Ae2G");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $0bc6489980e08e1c$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(targetComponent, sourceComponent);
};

});
parcelRegister("8Ae2G", function(module, exports) {
'use strict';

var $j2VHG = parcelRequire("j2VHG");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $63fc9407ef8fcdfe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $63fc9407ef8fcdfe$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$TYPE_STATICS = {};
$63fc9407ef8fcdfe$var$TYPE_STATICS[$j2VHG.ForwardRef] = $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS;
$63fc9407ef8fcdfe$var$TYPE_STATICS[$j2VHG.Memo] = $63fc9407ef8fcdfe$var$MEMO_STATICS;
function $63fc9407ef8fcdfe$var$getStatics(component) {
    // React v16.11 and below
    if ($j2VHG.isMemo(component)) return $63fc9407ef8fcdfe$var$MEMO_STATICS;
     // React v16.12 and above
    return $63fc9407ef8fcdfe$var$TYPE_STATICS[component['$$typeof']] || $63fc9407ef8fcdfe$var$REACT_STATICS;
}
var $63fc9407ef8fcdfe$var$defineProperty = Object.defineProperty;
var $63fc9407ef8fcdfe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $63fc9407ef8fcdfe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $63fc9407ef8fcdfe$var$getPrototypeOf = Object.getPrototypeOf;
var $63fc9407ef8fcdfe$var$objectPrototype = Object.prototype;
function $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($63fc9407ef8fcdfe$var$objectPrototype) {
            var inheritedComponent = $63fc9407ef8fcdfe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $63fc9407ef8fcdfe$var$objectPrototype) $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $63fc9407ef8fcdfe$var$getOwnPropertyNames(sourceComponent);
        if ($63fc9407ef8fcdfe$var$getOwnPropertySymbols) keys = keys.concat($63fc9407ef8fcdfe$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $63fc9407ef8fcdfe$var$getStatics(targetComponent);
        var sourceStatics = $63fc9407ef8fcdfe$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$63fc9407ef8fcdfe$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $63fc9407ef8fcdfe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $63fc9407ef8fcdfe$var$hoistNonReactStatics;

});
parcelRegister("j2VHG", function(module, exports) {
'use strict';

module.exports = (parcelRequire("45MkT"));

});



parcelRegister("80dPg", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $5d390c582efd47c3$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $5d390c582efd47c3$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $5d390c582efd47c3$export$6f077d94b33a01aa; });
var $5d390c582efd47c3$var$isBrowser = typeof document !== 'undefined';
function $5d390c582efd47c3$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5d390c582efd47c3$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5d390c582efd47c3$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5d390c582efd47c3$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5d390c582efd47c3$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5d390c582efd47c3$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5d390c582efd47c3$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("6lPck", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $49fc6b0b9a1bf345$export$6321afa313b251b5; });

var $1OEsj = parcelRequire("1OEsj");

var $cfR4M = parcelRequire("cfR4M");

var $4AWAi = parcelRequire("4AWAi");
var $49fc6b0b9a1bf345$var$isDevelopment = false;
var $49fc6b0b9a1bf345$var$hyphenateRegex = /[A-Z]|^ms/g;
var $49fc6b0b9a1bf345$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $49fc6b0b9a1bf345$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $49fc6b0b9a1bf345$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $49fc6b0b9a1bf345$var$processStyleName = /* #__PURE__ */ (0, $4AWAi.default)(function(styleName) {
    return $49fc6b0b9a1bf345$var$isCustomProperty(styleName) ? styleName : styleName.replace($49fc6b0b9a1bf345$var$hyphenateRegex, '-$&').toLowerCase();
});
var $49fc6b0b9a1bf345$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($49fc6b0b9a1bf345$var$animationRegex, function(match, p1, p2) {
                $49fc6b0b9a1bf345$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $49fc6b0b9a1bf345$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cfR4M.default)[key] !== 1 && !$49fc6b0b9a1bf345$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $49fc6b0b9a1bf345$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $49fc6b0b9a1bf345$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $49fc6b0b9a1bf345$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $49fc6b0b9a1bf345$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $49fc6b0b9a1bf345$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $49fc6b0b9a1bf345$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $49fc6b0b9a1bf345$var$cursor;
                var result = interpolation(mergedProps);
                $49fc6b0b9a1bf345$var$cursor = previousCursor;
                return $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $49fc6b0b9a1bf345$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($49fc6b0b9a1bf345$var$isProcessableValue(asString)) string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + $49fc6b0b9a1bf345$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $49fc6b0b9a1bf345$var$isDevelopment) throw new Error($49fc6b0b9a1bf345$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($49fc6b0b9a1bf345$var$isProcessableValue(value[_i])) string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + $49fc6b0b9a1bf345$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $49fc6b0b9a1bf345$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $49fc6b0b9a1bf345$var$cursor;
function $49fc6b0b9a1bf345$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $49fc6b0b9a1bf345$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $49fc6b0b9a1bf345$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $49fc6b0b9a1bf345$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $1OEsj.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $49fc6b0b9a1bf345$var$cursor
    };
}

});
parcelRegister("1OEsj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1529d79d9aa6f066$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1529d79d9aa6f066$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cfR4M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039; });
var $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("9uXao", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $6ea4cfa701df259a$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $6ea4cfa701df259a$export$811a713a7276cb9d; });

var $7fPBF = parcelRequire("7fPBF");
var $6ea4cfa701df259a$var$isBrowser = typeof document !== 'undefined';
var $6ea4cfa701df259a$var$syncFallback = function syncFallback(create) {
    return create();
};
var $6ea4cfa701df259a$var$useInsertionEffect = $7fPBF.useInsertionEffect ? $7fPBF.useInsertionEffect : false;
var $6ea4cfa701df259a$export$db21c7ffa21794e7 = !$6ea4cfa701df259a$var$isBrowser ? $6ea4cfa701df259a$var$syncFallback : $6ea4cfa701df259a$var$useInsertionEffect || $6ea4cfa701df259a$var$syncFallback;
var $6ea4cfa701df259a$export$811a713a7276cb9d = $6ea4cfa701df259a$var$useInsertionEffect || $7fPBF.useLayoutEffect;

});



parcelRegister("9YmaI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $742aea85e4e67b26$export$2e2bcd8739ae039; });

var $4AWAi = parcelRequire("4AWAi");
// eslint-disable-next-line no-undef
var $742aea85e4e67b26$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $742aea85e4e67b26$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $4AWAi.default)(function(prop) {
    return $742aea85e4e67b26$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("e6xq6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a44b8cbd62c27155$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $6te04 = parcelRequire("6te04");

var $3mESc = parcelRequire("3mESc");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $a44b8cbd62c27155$var$getCache(injectFirst, enableCssLayer) {
    const emotionCache = (0, $3mESc.default)({
        key: 'css',
        prepend: injectFirst
    });
    if (enableCssLayer) {
        const prevInsert = emotionCache.insert;
        emotionCache.insert = (...args)=>{
            if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
            args[1].styles = `@layer mui {${args[1].styles}}`;
            return prevInsert(...args);
        };
    }
    return emotionCache;
}
const $a44b8cbd62c27155$var$cacheMap = new Map();
function $a44b8cbd62c27155$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $7fPBF.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $a44b8cbd62c27155$var$cacheMap.has(cacheKey)) return $a44b8cbd62c27155$var$cacheMap.get(cacheKey);
        const fresh = $a44b8cbd62c27155$var$getCache(injectFirst, enableCssLayer);
        $a44b8cbd62c27155$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    if (injectFirst || enableCssLayer) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6te04.C), {
        value: cache,
        children: children
    });
    return children;
}

});
parcelRegister("bbzbN", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2nzLi"));

});


parcelRegister("5tMhb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fd51bd676aa60b7$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");


var $5nUae = parcelRequire("5nUae");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $3fd51bd676aa60b7$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $3fd51bd676aa60b7$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($3fd51bd676aa60b7$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5nUae.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("a1Cvm", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $74c7dda075bc8f04$export$306c0aa65ff9ec16; }, function (v) { return $74c7dda075bc8f04$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $74c7dda075bc8f04$export$306c0aa65ff9ec16;
"use strict";

var $7fPBF = parcelRequire("7fPBF");
function $74c7dda075bc8f04$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $74c7dda075bc8f04$var$objectIs = "function" === typeof Object.is ? Object.is : $74c7dda075bc8f04$var$is, $74c7dda075bc8f04$var$useState = $7fPBF.useState, $74c7dda075bc8f04$var$useEffect = $7fPBF.useEffect, $74c7dda075bc8f04$var$useLayoutEffect = $7fPBF.useLayoutEffect, $74c7dda075bc8f04$var$useDebugValue = $7fPBF.useDebugValue;
function $74c7dda075bc8f04$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $74c7dda075bc8f04$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $74c7dda075bc8f04$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $74c7dda075bc8f04$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $74c7dda075bc8f04$var$useEffect(function() {
        $74c7dda075bc8f04$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $74c7dda075bc8f04$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $74c7dda075bc8f04$var$useDebugValue(value);
    return value;
}
function $74c7dda075bc8f04$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$74c7dda075bc8f04$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $74c7dda075bc8f04$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $74c7dda075bc8f04$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $74c7dda075bc8f04$var$useSyncExternalStore$1 : $74c7dda075bc8f04$var$useSyncExternalStore$2;
$74c7dda075bc8f04$export$306c0aa65ff9ec16 = void 0 !== $7fPBF.useSyncExternalStore ? $7fPBF.useSyncExternalStore : $74c7dda075bc8f04$var$shim;

});

parcelRegister("a04va", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $6zjya = parcelRequire("6zjya");

var $8PZpp = parcelRequire("8PZpp");

var $5f6d7 = parcelRequire("5f6d7");

var $ef5jC = parcelRequire("ef5jC");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $747d656b899e6115$var$createInstance(defaultConfig) {
    var context = new $8PZpp(defaultConfig);
    var instance = $6zjya($8PZpp.prototype.request, context);
    // Copy axios.prototype to instance
    $adReO.extend(instance, $8PZpp.prototype, context);
    // Copy context to instance
    $adReO.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $747d656b899e6115$var$createInstance($5f6d7(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $747d656b899e6115$var$axios = $747d656b899e6115$var$createInstance($ef5jC);
// Expose Axios class to allow class inheritance
$747d656b899e6115$var$axios.Axios = $8PZpp;

// Expose Cancel & CancelToken
$747d656b899e6115$var$axios.CanceledError = (parcelRequire("lb2qV"));

$747d656b899e6115$var$axios.CancelToken = (parcelRequire("kZZD0"));

$747d656b899e6115$var$axios.isCancel = (parcelRequire("4IsRW"));

$747d656b899e6115$var$axios.VERSION = (parcelRequire("cR4ZD")).version;

$747d656b899e6115$var$axios.toFormData = (parcelRequire("29a93"));

// Expose AxiosError class
$747d656b899e6115$var$axios.AxiosError = (parcelRequire("fX03H"));
// alias for CanceledError for backward compatibility
$747d656b899e6115$var$axios.Cancel = $747d656b899e6115$var$axios.CanceledError;
// Expose all/spread
$747d656b899e6115$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$747d656b899e6115$var$axios.spread = (parcelRequire("b676K"));

// Expose isAxiosError
$747d656b899e6115$var$axios.isAxiosError = (parcelRequire("kgiwQ"));
module.exports = $747d656b899e6115$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $747d656b899e6115$var$axios;

});
parcelRegister("adReO", function(module, exports) {
'use strict';

var $6zjya = parcelRequire("6zjya");
// utils is a library of generic helper functions non-specific to axios
var $77146a31cb578292$var$toString = Object.prototype.toString;
// eslint-disable-next-line func-names
var $77146a31cb578292$var$kindOf = function(cache) {
    // eslint-disable-next-line func-names
    return function(thing) {
        var str = $77146a31cb578292$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    };
}(Object.create(null));
function $77146a31cb578292$var$kindOfTest(type) {
    type = type.toLowerCase();
    return function isKindOf(thing) {
        return $77146a31cb578292$var$kindOf(thing) === type;
    };
}
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $77146a31cb578292$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $77146a31cb578292$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $77146a31cb578292$var$isBuffer(val) {
    return val !== null && !$77146a31cb578292$var$isUndefined(val) && val.constructor !== null && !$77146a31cb578292$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ var $77146a31cb578292$var$isArrayBuffer = $77146a31cb578292$var$kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $77146a31cb578292$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $77146a31cb578292$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $77146a31cb578292$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $77146a31cb578292$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $77146a31cb578292$var$isPlainObject(val) {
    if ($77146a31cb578292$var$kindOf(val) !== 'object') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ var $77146a31cb578292$var$isDate = $77146a31cb578292$var$kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $77146a31cb578292$var$isFile = $77146a31cb578292$var$kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ var $77146a31cb578292$var$isBlob = $77146a31cb578292$var$kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ var $77146a31cb578292$var$isFileList = $77146a31cb578292$var$kindOfTest('FileList');
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $77146a31cb578292$var$isFunction(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $77146a31cb578292$var$isStream(val) {
    return $77146a31cb578292$var$isObject(val) && $77146a31cb578292$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $77146a31cb578292$var$isFormData(thing) {
    var pattern = '[object FormData]';
    return thing && (typeof FormData === 'function' && thing instanceof FormData || $77146a31cb578292$var$toString.call(thing) === pattern || $77146a31cb578292$var$isFunction(thing.toString) && thing.toString() === pattern);
}
/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ var $77146a31cb578292$var$isURLSearchParams = $77146a31cb578292$var$kindOfTest('URLSearchParams');
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $77146a31cb578292$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $77146a31cb578292$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $77146a31cb578292$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($77146a31cb578292$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $77146a31cb578292$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($77146a31cb578292$var$isPlainObject(result[key]) && $77146a31cb578292$var$isPlainObject(val)) result[key] = $77146a31cb578292$var$merge(result[key], val);
        else if ($77146a31cb578292$var$isPlainObject(val)) result[key] = $77146a31cb578292$var$merge({}, val);
        else if ($77146a31cb578292$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$77146a31cb578292$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $77146a31cb578292$var$extend(a, b, thisArg) {
    $77146a31cb578292$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $6zjya(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $77146a31cb578292$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */ function $77146a31cb578292$var$inherits(constructor, superConstructor, props, descriptors) {
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    props && Object.assign(constructor.prototype, props);
}
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */ function $77146a31cb578292$var$toFlatObject(sourceObj, destObj, filter) {
    var props;
    var i;
    var prop;
    var merged = {};
    destObj = destObj || {};
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if (!merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
}
/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */ function $77146a31cb578292$var$endsWith(str, searchString, position) {
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    var lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
}
/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */ function $77146a31cb578292$var$toArray(thing) {
    if (!thing) return null;
    var i = thing.length;
    if ($77146a31cb578292$var$isUndefined(i)) return null;
    var arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
}
// eslint-disable-next-line func-names
var $77146a31cb578292$var$isTypedArray = function(TypedArray) {
    // eslint-disable-next-line func-names
    return function(thing) {
        return TypedArray && thing instanceof TypedArray;
    };
}(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));
module.exports = {
    isArray: $77146a31cb578292$var$isArray,
    isArrayBuffer: $77146a31cb578292$var$isArrayBuffer,
    isBuffer: $77146a31cb578292$var$isBuffer,
    isFormData: $77146a31cb578292$var$isFormData,
    isArrayBufferView: $77146a31cb578292$var$isArrayBufferView,
    isString: $77146a31cb578292$var$isString,
    isNumber: $77146a31cb578292$var$isNumber,
    isObject: $77146a31cb578292$var$isObject,
    isPlainObject: $77146a31cb578292$var$isPlainObject,
    isUndefined: $77146a31cb578292$var$isUndefined,
    isDate: $77146a31cb578292$var$isDate,
    isFile: $77146a31cb578292$var$isFile,
    isBlob: $77146a31cb578292$var$isBlob,
    isFunction: $77146a31cb578292$var$isFunction,
    isStream: $77146a31cb578292$var$isStream,
    isURLSearchParams: $77146a31cb578292$var$isURLSearchParams,
    isStandardBrowserEnv: $77146a31cb578292$var$isStandardBrowserEnv,
    forEach: $77146a31cb578292$var$forEach,
    merge: $77146a31cb578292$var$merge,
    extend: $77146a31cb578292$var$extend,
    trim: $77146a31cb578292$var$trim,
    stripBOM: $77146a31cb578292$var$stripBOM,
    inherits: $77146a31cb578292$var$inherits,
    toFlatObject: $77146a31cb578292$var$toFlatObject,
    kindOf: $77146a31cb578292$var$kindOf,
    kindOfTest: $77146a31cb578292$var$kindOfTest,
    endsWith: $77146a31cb578292$var$endsWith,
    toArray: $77146a31cb578292$var$toArray,
    isTypedArray: $77146a31cb578292$var$isTypedArray,
    isFileList: $77146a31cb578292$var$isFileList
};

});
parcelRegister("6zjya", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("8PZpp", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $6nvAH = parcelRequire("6nvAH");

var $khPLX = parcelRequire("khPLX");

var $eystn = parcelRequire("eystn");

var $5f6d7 = parcelRequire("5f6d7");

var $40T1q = parcelRequire("40T1q");

var $2iR5D = parcelRequire("2iR5D");
var $66f2b8a41463d1e8$var$validators = $2iR5D.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $66f2b8a41463d1e8$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $khPLX(),
        response: new $khPLX()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $66f2b8a41463d1e8$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $5f6d7(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $2iR5D.assertOptions(transitional, {
        silentJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
        forcedJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
        clarifyTimeoutError: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $eystn,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $eystn(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$66f2b8a41463d1e8$var$Axios.prototype.getUri = function getUri(config) {
    config = $5f6d7(this.defaults, config);
    var fullPath = $40T1q(config.baseURL, config.url);
    return $6nvAH(fullPath, config.params, config.paramsSerializer);
};
// Provide aliases for supported request methods
$adReO.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, config) {
        return this.request($5f6d7(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$adReO.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request($5f6d7(config || {}, {
                method: method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $66f2b8a41463d1e8$var$Axios.prototype[method] = generateHTTPMethod();
    $66f2b8a41463d1e8$var$Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
module.exports = $66f2b8a41463d1e8$var$Axios;

});
parcelRegister("6nvAH", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
function $4a4d655613ae826e$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($adReO.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $adReO.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($adReO.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $adReO.forEach(val, function parseValue(v) {
                if ($adReO.isDate(v)) v = v.toISOString();
                else if ($adReO.isObject(v)) v = JSON.stringify(v);
                parts.push($4a4d655613ae826e$var$encode(key) + '=' + $4a4d655613ae826e$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("khPLX", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
function $ec4d8e24b0699790$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $adReO.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $ec4d8e24b0699790$var$InterceptorManager;

});

parcelRegister("eystn", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $15ANS = parcelRequire("15ANS");

var $4IsRW = parcelRequire("4IsRW");

var $ef5jC = parcelRequire("ef5jC");

var $lb2qV = parcelRequire("lb2qV");
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ function $a98a53c8a75f9db0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $lb2qV();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $15ANS.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $adReO.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $adReO.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $ef5jC.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $15ANS.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$4IsRW(reason)) {
            $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $15ANS.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("15ANS", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $ef5jC = parcelRequire("ef5jC");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $ef5jC;
    /*eslint no-param-reassign:0*/ $adReO.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("ef5jC", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $9y7wC = parcelRequire("9y7wC");

var $fX03H = parcelRequire("fX03H");

var $aP7qx = parcelRequire("aP7qx");

var $29a93 = parcelRequire("29a93");
var $a5e696f232d0dc12$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $a5e696f232d0dc12$var$setContentTypeIfUnset(headers, value) {
    if (!$adReO.isUndefined(headers) && $adReO.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $a5e696f232d0dc12$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("3PMHb"));
    return adapter;
}
function $a5e696f232d0dc12$var$stringifySafely(rawValue, parser, encoder) {
    if ($adReO.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $adReO.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}

var $a5e696f232d0dc12$var$defaults = {
    transitional: $aP7qx,
    adapter: $a5e696f232d0dc12$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $9y7wC(headers, 'Accept');
            $9y7wC(headers, 'Content-Type');
            if ($adReO.isFormData(data) || $adReO.isArrayBuffer(data) || $adReO.isBuffer(data) || $adReO.isStream(data) || $adReO.isFile(data) || $adReO.isBlob(data)) return data;
            if ($adReO.isArrayBufferView(data)) return data.buffer;
            if ($adReO.isURLSearchParams(data)) {
                $a5e696f232d0dc12$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            var isObjectPayload = $adReO.isObject(data);
            var contentType = headers && headers['Content-Type'];
            var isFileList;
            if ((isFileList = $adReO.isFileList(data)) || isObjectPayload && contentType === 'multipart/form-data') {
                var _FormData = this.env && this.env.FormData;
                return $29a93(isFileList ? {
                    'files[]': data
                } : data, _FormData && new _FormData());
            } else if (isObjectPayload || contentType === 'application/json') {
                $a5e696f232d0dc12$var$setContentTypeIfUnset(headers, 'application/json');
                return $a5e696f232d0dc12$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $a5e696f232d0dc12$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && $adReO.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw $fX03H.from(e, $fX03H.ERR_BAD_RESPONSE, this, null, this.response);
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (parcelRequire("4htkn"))
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*'
        }
    }
};
$adReO.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $a5e696f232d0dc12$var$defaults.headers[method] = {};
});
$adReO.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $a5e696f232d0dc12$var$defaults.headers[method] = $adReO.merge($a5e696f232d0dc12$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $a5e696f232d0dc12$var$defaults;

});
parcelRegister("9y7wC", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $adReO.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("fX03H", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ function $b9cc6960093b095e$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
$adReO.inherits($b9cc6960093b095e$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
var $b9cc6960093b095e$var$prototype = $b9cc6960093b095e$var$AxiosError.prototype;
var $b9cc6960093b095e$var$descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED'
].forEach(function(code) {
    $b9cc6960093b095e$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($b9cc6960093b095e$var$AxiosError, $b9cc6960093b095e$var$descriptors);
Object.defineProperty($b9cc6960093b095e$var$prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
$b9cc6960093b095e$var$AxiosError.from = function(error, code, config, request, response, customProps) {
    var axiosError = Object.create($b9cc6960093b095e$var$prototype);
    $adReO.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    });
    $b9cc6960093b095e$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
module.exports = $b9cc6960093b095e$var$AxiosError;

});

parcelRegister("aP7qx", function(module, exports) {
'use strict';
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("29a93", function(module, exports) {

var $bdjQ6 = parcelRequire("bdjQ6");
var $19044a9fa7281693$require$Buffer = $bdjQ6.Buffer;
'use strict';

var $adReO = parcelRequire("adReO");
/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/ function $19044a9fa7281693$var$toFormData(obj, formData) {
    // eslint-disable-next-line no-param-reassign
    formData = formData || new FormData();
    var stack = [];
    function convertValue(value) {
        if (value === null) return '';
        if ($adReO.isDate(value)) return value.toISOString();
        if ($adReO.isArrayBuffer(value) || $adReO.isTypedArray(value)) return typeof Blob === 'function' ? new Blob([
            value
        ]) : $19044a9fa7281693$require$Buffer.from(value);
        return value;
    }
    function build(data, parentKey) {
        if ($adReO.isPlainObject(data) || $adReO.isArray(data)) {
            if (stack.indexOf(data) !== -1) throw Error('Circular reference detected in ' + parentKey);
            stack.push(data);
            $adReO.forEach(data, function each(value, key) {
                if ($adReO.isUndefined(value)) return;
                var fullKey = parentKey ? parentKey + '.' + key : key;
                var arr;
                if (value && !parentKey && typeof value === 'object') {
                    if ($adReO.endsWith(key, '{}')) // eslint-disable-next-line no-param-reassign
                    value = JSON.stringify(value);
                    else if ($adReO.endsWith(key, '[]') && (arr = $adReO.toArray(value))) {
                        // eslint-disable-next-line func-names
                        arr.forEach(function(el) {
                            !$adReO.isUndefined(el) && formData.append(fullKey, convertValue(el));
                        });
                        return;
                    }
                }
                build(value, fullKey);
            });
            stack.pop();
        } else formData.append(parentKey, convertValue(data));
    }
    build(obj);
    return formData;
}
module.exports = $19044a9fa7281693$var$toFormData;

});
parcelRegister("bdjQ6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $82a04c4ec6982288$export$a143d493d941bafc; }, function (v) { return $82a04c4ec6982288$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $82a04c4ec6982288$export$f99ded8fe4b79145; }, function (v) { return $82a04c4ec6982288$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $82a04c4ec6982288$export$a143d493d941bafc;
var $82a04c4ec6982288$export$e4cf37d7f6fb9e0a;
var $82a04c4ec6982288$export$f99ded8fe4b79145;
var $82a04c4ec6982288$export$599f31c3813fae4d;
'use strict';

var $3nocJ = parcelRequire("3nocJ");

var $gU9iR = parcelRequire("gU9iR");
const $82a04c4ec6982288$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$82a04c4ec6982288$export$a143d493d941bafc = $82a04c4ec6982288$var$Buffer;
$82a04c4ec6982288$export$e4cf37d7f6fb9e0a = $82a04c4ec6982288$var$SlowBuffer;
$82a04c4ec6982288$export$f99ded8fe4b79145 = 50;
const $82a04c4ec6982288$var$K_MAX_LENGTH = 0x7fffffff;
$82a04c4ec6982288$export$599f31c3813fae4d = $82a04c4ec6982288$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT = $82a04c4ec6982288$var$typedArraySupport();
if (!$82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $82a04c4ec6982288$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $82a04c4ec6982288$var$createBuffer(length) {
    if (length > $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $82a04c4ec6982288$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $82a04c4ec6982288$var$allocUnsafe(arg);
    }
    return $82a04c4ec6982288$var$from(arg, encodingOrOffset, length);
}
$82a04c4ec6982288$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $82a04c4ec6982288$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $82a04c4ec6982288$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $82a04c4ec6982288$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($82a04c4ec6982288$var$isInstance(value, ArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, ArrayBuffer)) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($82a04c4ec6982288$var$isInstance(value, SharedArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, SharedArrayBuffer))) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $82a04c4ec6982288$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $82a04c4ec6982288$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $82a04c4ec6982288$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $82a04c4ec6982288$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $82a04c4ec6982288$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer, Uint8Array);
function $82a04c4ec6982288$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $82a04c4ec6982288$var$alloc(size, fill, encoding) {
    $82a04c4ec6982288$var$assertSize(size);
    if (size <= 0) return $82a04c4ec6982288$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $82a04c4ec6982288$var$createBuffer(size).fill(fill, encoding) : $82a04c4ec6982288$var$createBuffer(size).fill(fill);
    return $82a04c4ec6982288$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $82a04c4ec6982288$var$Buffer.alloc = function(size, fill, encoding) {
    return $82a04c4ec6982288$var$alloc(size, fill, encoding);
};
function $82a04c4ec6982288$var$allocUnsafe(size) {
    $82a04c4ec6982288$var$assertSize(size);
    return $82a04c4ec6982288$var$createBuffer(size < 0 ? 0 : $82a04c4ec6982288$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $82a04c4ec6982288$var$Buffer.allocUnsafe = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $82a04c4ec6982288$var$Buffer.allocUnsafeSlow = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
function $82a04c4ec6982288$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $82a04c4ec6982288$var$byteLength(string, encoding) | 0;
    let buf = $82a04c4ec6982288$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $82a04c4ec6982288$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $82a04c4ec6982288$var$checked(array.length) | 0;
    const buf = $82a04c4ec6982288$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $82a04c4ec6982288$var$fromArrayView(arrayView) {
    if ($82a04c4ec6982288$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $82a04c4ec6982288$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $82a04c4ec6982288$var$fromArrayLike(arrayView);
}
function $82a04c4ec6982288$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
function $82a04c4ec6982288$var$fromObject(obj) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(obj)) {
        const len = $82a04c4ec6982288$var$checked(obj.length) | 0;
        const buf = $82a04c4ec6982288$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $82a04c4ec6982288$var$numberIsNaN(obj.length)) return $82a04c4ec6982288$var$createBuffer(0);
        return $82a04c4ec6982288$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $82a04c4ec6982288$var$fromArrayLike(obj.data);
}
function $82a04c4ec6982288$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $82a04c4ec6982288$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $82a04c4ec6982288$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $82a04c4ec6982288$var$Buffer.alloc(+length);
}
$82a04c4ec6982288$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $82a04c4ec6982288$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$82a04c4ec6982288$var$Buffer.compare = function compare(a, b) {
    if ($82a04c4ec6982288$var$isInstance(a, Uint8Array)) a = $82a04c4ec6982288$var$Buffer.from(a, a.offset, a.byteLength);
    if ($82a04c4ec6982288$var$isInstance(b, Uint8Array)) b = $82a04c4ec6982288$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(a) || !$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$82a04c4ec6982288$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$82a04c4ec6982288$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $82a04c4ec6982288$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $82a04c4ec6982288$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($82a04c4ec6982288$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) buf = $82a04c4ec6982288$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $82a04c4ec6982288$var$byteLength(string, encoding) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $82a04c4ec6982288$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $82a04c4ec6982288$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $82a04c4ec6982288$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$82a04c4ec6982288$var$Buffer.byteLength = $82a04c4ec6982288$var$byteLength;
function $82a04c4ec6982288$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Slice(this, start, end);
        case 'ascii':
            return $82a04c4ec6982288$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$latin1Slice(this, start, end);
        case 'base64':
            return $82a04c4ec6982288$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$82a04c4ec6982288$var$Buffer.prototype._isBuffer = true;
function $82a04c4ec6982288$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$82a04c4ec6982288$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$82a04c4ec6982288$var$swap(this, i, i + 1);
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $82a04c4ec6982288$var$swap(this, i, i + 3);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $82a04c4ec6982288$var$swap(this, i, i + 7);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 6);
        $82a04c4ec6982288$var$swap(this, i + 2, i + 5);
        $82a04c4ec6982288$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $82a04c4ec6982288$var$utf8Slice(this, 0, length);
    return $82a04c4ec6982288$var$slowToString.apply(this, arguments);
};
$82a04c4ec6982288$var$Buffer.prototype.toLocaleString = $82a04c4ec6982288$var$Buffer.prototype.toString;
$82a04c4ec6982288$var$Buffer.prototype.equals = function equals(b) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $82a04c4ec6982288$var$Buffer.compare(this, b) === 0;
};
$82a04c4ec6982288$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $82a04c4ec6982288$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($82a04c4ec6982288$var$customInspectSymbol) $82a04c4ec6982288$var$Buffer.prototype[$82a04c4ec6982288$var$customInspectSymbol] = $82a04c4ec6982288$var$Buffer.prototype.inspect;
$82a04c4ec6982288$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($82a04c4ec6982288$var$isInstance(target, Uint8Array)) target = $82a04c4ec6982288$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $82a04c4ec6982288$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($82a04c4ec6982288$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $82a04c4ec6982288$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($82a04c4ec6982288$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $82a04c4ec6982288$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$82a04c4ec6982288$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$82a04c4ec6982288$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$82a04c4ec6982288$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $82a04c4ec6982288$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($82a04c4ec6982288$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $82a04c4ec6982288$var$utf8Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $82a04c4ec6982288$var$asciiWrite(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$asciiToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$base64Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$base64ToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$ucs2Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$82a04c4ec6982288$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $82a04c4ec6982288$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$82a04c4ec6982288$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $82a04c4ec6982288$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3nocJ.fromByteArray(buf);
    else return $3nocJ.fromByteArray(buf.slice(start, end));
}
function $82a04c4ec6982288$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $82a04c4ec6982288$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $82a04c4ec6982288$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $82a04c4ec6982288$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $82a04c4ec6982288$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $82a04c4ec6982288$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $82a04c4ec6982288$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $82a04c4ec6982288$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$82a04c4ec6982288$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $82a04c4ec6982288$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $82a04c4ec6982288$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$82a04c4ec6982288$var$Buffer.prototype.readUintLE = $82a04c4ec6982288$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUintBE = $82a04c4ec6982288$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint8 = $82a04c4ec6982288$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$82a04c4ec6982288$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$82a04c4ec6982288$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, true, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, false, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, true, 52, 8);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, false, 52, 8);
};
function $82a04c4ec6982288$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$82a04c4ec6982288$var$Buffer.prototype.writeUintLE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUintBE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint8 = $82a04c4ec6982288$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $82a04c4ec6982288$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $82a04c4ec6982288$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $82a04c4ec6982288$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$82a04c4ec6982288$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, false, noAssert);
};
function $82a04c4ec6982288$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$82a04c4ec6982288$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$82a04c4ec6982288$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $82a04c4ec6982288$var$Buffer.isBuffer(val) ? val : $82a04c4ec6982288$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $82a04c4ec6982288$var$errors = {};
function $82a04c4ec6982288$var$E(sym, getMessage, Base) {
    $82a04c4ec6982288$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$82a04c4ec6982288$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$82a04c4ec6982288$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$82a04c4ec6982288$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $82a04c4ec6982288$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $82a04c4ec6982288$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $82a04c4ec6982288$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength) {
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $82a04c4ec6982288$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength);
}
function $82a04c4ec6982288$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $82a04c4ec6982288$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $82a04c4ec6982288$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $82a04c4ec6982288$var$validateNumber(value, type);
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $82a04c4ec6982288$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $82a04c4ec6982288$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $82a04c4ec6982288$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($82a04c4ec6982288$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $82a04c4ec6982288$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $82a04c4ec6982288$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $82a04c4ec6982288$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $82a04c4ec6982288$var$base64ToBytes(str) {
    return $3nocJ.toByteArray($82a04c4ec6982288$var$base64clean(str));
}
function $82a04c4ec6982288$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $82a04c4ec6982288$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $82a04c4ec6982288$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $82a04c4ec6982288$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $82a04c4ec6982288$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $82a04c4ec6982288$var$BufferBigIntNotDefined : fn;
}
function $82a04c4ec6982288$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("3nocJ", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $27564b8a0078aa3d$export$d622b2ad8d90c771; }, function (v) { return $27564b8a0078aa3d$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $27564b8a0078aa3d$export$6100ba28696e12de; }, function (v) { return $27564b8a0078aa3d$export$6100ba28696e12de = v; });
var $27564b8a0078aa3d$export$a48f0734ac7c2329;
var $27564b8a0078aa3d$export$d622b2ad8d90c771;
var $27564b8a0078aa3d$export$6100ba28696e12de;
'use strict';
$27564b8a0078aa3d$export$a48f0734ac7c2329 = $27564b8a0078aa3d$var$byteLength;
$27564b8a0078aa3d$export$d622b2ad8d90c771 = $27564b8a0078aa3d$var$toByteArray;
$27564b8a0078aa3d$export$6100ba28696e12de = $27564b8a0078aa3d$var$fromByteArray;
var $27564b8a0078aa3d$var$lookup = [];
var $27564b8a0078aa3d$var$revLookup = [];
var $27564b8a0078aa3d$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $27564b8a0078aa3d$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $27564b8a0078aa3d$var$i = 0, $27564b8a0078aa3d$var$len = $27564b8a0078aa3d$var$code.length; $27564b8a0078aa3d$var$i < $27564b8a0078aa3d$var$len; ++$27564b8a0078aa3d$var$i){
    $27564b8a0078aa3d$var$lookup[$27564b8a0078aa3d$var$i] = $27564b8a0078aa3d$var$code[$27564b8a0078aa3d$var$i];
    $27564b8a0078aa3d$var$revLookup[$27564b8a0078aa3d$var$code.charCodeAt($27564b8a0078aa3d$var$i)] = $27564b8a0078aa3d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$27564b8a0078aa3d$var$revLookup['-'.charCodeAt(0)] = 62;
$27564b8a0078aa3d$var$revLookup['_'.charCodeAt(0)] = 63;
function $27564b8a0078aa3d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $27564b8a0078aa3d$var$byteLength(b64) {
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$toByteArray(b64) {
    var tmp;
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $27564b8a0078aa3d$var$Arr($27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 18 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 2 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 10 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $27564b8a0078aa3d$var$tripletToBase64(num) {
    return $27564b8a0078aa3d$var$lookup[num >> 18 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 12 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 6 & 0x3F] + $27564b8a0078aa3d$var$lookup[num & 0x3F];
}
function $27564b8a0078aa3d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($27564b8a0078aa3d$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $27564b8a0078aa3d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($27564b8a0078aa3d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 2] + $27564b8a0078aa3d$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 10] + $27564b8a0078aa3d$var$lookup[tmp >> 4 & 0x3F] + $27564b8a0078aa3d$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("gU9iR", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $c4e917b4c37bfab7$export$aafa59e2e03f2942; }, function (v) { return $c4e917b4c37bfab7$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $c4e917b4c37bfab7$export$68d8715fc104d294; }, function (v) { return $c4e917b4c37bfab7$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $c4e917b4c37bfab7$export$aafa59e2e03f2942;
var $c4e917b4c37bfab7$export$68d8715fc104d294;
$c4e917b4c37bfab7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$c4e917b4c37bfab7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("3PMHb", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $3PfpF = parcelRequire("3PfpF");

var $79n0f = parcelRequire("79n0f");

var $6nvAH = parcelRequire("6nvAH");

var $40T1q = parcelRequire("40T1q");

var $hMzvi = parcelRequire("hMzvi");

var $besJL = parcelRequire("besJL");

var $aP7qx = parcelRequire("aP7qx");

var $fX03H = parcelRequire("fX03H");

var $lb2qV = parcelRequire("lb2qV");

var $41as5 = parcelRequire("41as5");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener('abort', onCanceled);
        }
        if ($adReO.isFormData(requestData) && $adReO.isStandardBrowserEnv()) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $40T1q(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $6nvAH(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $hMzvi(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $3PfpF(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new $fX03H('Request aborted', $fX03H.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new $fX03H('Network Error', $fX03H.ERR_NETWORK, config, request, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = config.transitional || $aP7qx;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new $fX03H(timeoutErrorMessage, transitional.clarifyTimeoutError ? $fX03H.ETIMEDOUT : $fX03H.ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($adReO.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $besJL(fullPath)) && config.xsrfCookieName ? $79n0f.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $adReO.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$adReO.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $lb2qV() : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
        }
        if (!requestData) requestData = null;
        var protocol = $41as5(fullPath);
        if (protocol && [
            'http',
            'https',
            'file'
        ].indexOf(protocol) === -1) {
            reject(new $fX03H('Unsupported protocol ' + protocol + ':', $fX03H.ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("3PfpF", function(module, exports) {
'use strict';

var $fX03H = parcelRequire("fX03H");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new $fX03H('Request failed with status code ' + response.status, [
        $fX03H.ERR_BAD_REQUEST,
        $fX03H.ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
};

});

parcelRegister("79n0f", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = $adReO.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($adReO.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($adReO.isString(path)) cookie.push('path=' + path);
            if ($adReO.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("40T1q", function(module, exports) {
'use strict';

var $1yk63 = parcelRequire("1yk63");

var $l45Ly = parcelRequire("l45Ly");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$1yk63(requestedURL)) return $l45Ly(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("1yk63", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("l45Ly", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("hMzvi", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $cf2275aca40d6d88$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $adReO.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $adReO.trim(line.substr(0, i)).toLowerCase();
        val = $adReO.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $cf2275aca40d6d88$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("besJL", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = $adReO.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $adReO.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("lb2qV", function(module, exports) {
'use strict';

var $fX03H = parcelRequire("fX03H");

var $adReO = parcelRequire("adReO");
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $f6ac833a4b31e3dc$var$CanceledError(message) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    $fX03H.call(this, message == null ? 'canceled' : message, $fX03H.ERR_CANCELED);
    this.name = 'CanceledError';
}
$adReO.inherits($f6ac833a4b31e3dc$var$CanceledError, $fX03H, {
    __CANCEL__: true
});
module.exports = $f6ac833a4b31e3dc$var$CanceledError;

});

parcelRegister("41as5", function(module, exports) {
'use strict';
module.exports = function parseProtocol(url) {
    var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
};

});


parcelRegister("4htkn", function(module, exports) {
// eslint-disable-next-line strict
module.exports = null;

});



parcelRegister("4IsRW", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("5f6d7", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($adReO.isPlainObject(target) && $adReO.isPlainObject(source)) return $adReO.merge(target, source);
        else if ($adReO.isPlainObject(source)) return $adReO.merge({}, source);
        else if ($adReO.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$adReO.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$adReO.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$adReO.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$adReO.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$adReO.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        'url': valueFromConfig2,
        'method': valueFromConfig2,
        'data': valueFromConfig2,
        'baseURL': defaultToConfig2,
        'transformRequest': defaultToConfig2,
        'transformResponse': defaultToConfig2,
        'paramsSerializer': defaultToConfig2,
        'timeout': defaultToConfig2,
        'timeoutMessage': defaultToConfig2,
        'withCredentials': defaultToConfig2,
        'adapter': defaultToConfig2,
        'responseType': defaultToConfig2,
        'xsrfCookieName': defaultToConfig2,
        'xsrfHeaderName': defaultToConfig2,
        'onUploadProgress': defaultToConfig2,
        'onDownloadProgress': defaultToConfig2,
        'decompress': defaultToConfig2,
        'maxContentLength': defaultToConfig2,
        'maxBodyLength': defaultToConfig2,
        'beforeRedirect': defaultToConfig2,
        'transport': defaultToConfig2,
        'httpAgent': defaultToConfig2,
        'httpsAgent': defaultToConfig2,
        'cancelToken': defaultToConfig2,
        'socketPath': defaultToConfig2,
        'responseEncoding': defaultToConfig2,
        'validateStatus': mergeDirectKeys
    };
    $adReO.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $adReO.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("2iR5D", function(module, exports) {
'use strict';

var $cR4ZD = parcelRequire("cR4ZD");
var $1ad671c27810423e$require$VERSION = $cR4ZD.version;

var $fX03H = parcelRequire("fX03H");
var $1ad671c27810423e$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $1ad671c27810423e$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $1ad671c27810423e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $1ad671c27810423e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + $1ad671c27810423e$require$VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new $fX03H(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), $fX03H.ERR_DEPRECATED);
        if (version && !$1ad671c27810423e$var$deprecatedWarnings[opt]) {
            $1ad671c27810423e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $1ad671c27810423e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new $fX03H('options must be an object', $fX03H.ERR_BAD_OPTION_VALUE);
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new $fX03H('option ' + opt + ' must be ' + result, $fX03H.ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new $fX03H('Unknown option ' + opt, $fX03H.ERR_BAD_OPTION);
    }
}
module.exports = {
    assertOptions: $1ad671c27810423e$var$assertOptions,
    validators: $1ad671c27810423e$var$validators
};

});
parcelRegister("cR4ZD", function(module, exports) {
module.exports = {
    "version": "0.27.2"
};

});



parcelRegister("kZZD0", function(module, exports) {
'use strict';

var $lb2qV = parcelRequire("lb2qV");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $f4994f37c883aea2$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $lb2qV(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `CanceledError` if cancellation has been requested.
 */ $f4994f37c883aea2$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $f4994f37c883aea2$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $f4994f37c883aea2$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $f4994f37c883aea2$var$CancelToken.source = function source() {
    var cancel;
    var token = new $f4994f37c883aea2$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $f4994f37c883aea2$var$CancelToken;

});

parcelRegister("b676K", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("kgiwQ", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $adReO.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("1ifJj", function(module, exports) {
function $0f13ac86de1755d2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $0f13ac86de1755d2$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3oBOp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("iCiVn")).default; });

var $iCiVn = parcelRequire("iCiVn");

});
parcelRegister("iCiVn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8da749d88f71122$export$2e2bcd8739ae039; });

var $diYUK = parcelRequire("diYUK");
function $d8da749d88f71122$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $diYUK.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("ehv4n", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("bXHHW")).default; });

var $bXHHW = parcelRequire("bXHHW");
$parcel$exportWildcard(module.exports, $bXHHW);

});
parcelRegister("bXHHW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $8b571bd6b8501d36$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $8b571bd6b8501d36$export$2e2bcd8739ae039; });

var $61wrp = parcelRequire("61wrp");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $8b571bd6b8501d36$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $8b571bd6b8501d36$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($8b571bd6b8501d36$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $8b571bd6b8501d36$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $8b571bd6b8501d36$export$aad197c7121a6651(Component) || fallback;
}
function $8b571bd6b8501d36$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $8b571bd6b8501d36$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $8b571bd6b8501d36$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $8b571bd6b8501d36$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $61wrp.ForwardRef:
            return $8b571bd6b8501d36$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $61wrp.Memo:
            return $8b571bd6b8501d36$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("61wrp", function(module, exports) {
'use strict';

module.exports = (parcelRequire("kzuP0"));

});
parcelRegister("kzuP0", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $ef9efc139901a96c$export$a7c73072b1a182ae; }, function (v) { return $ef9efc139901a96c$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $ef9efc139901a96c$export$9f27bc3417b4524d; }, function (v) { return $ef9efc139901a96c$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $ef9efc139901a96c$export$db77ccec0bb4ccac; }, function (v) { return $ef9efc139901a96c$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $ef9efc139901a96c$export$8392c0c9d3dcbd35; }, function (v) { return $ef9efc139901a96c$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ef9efc139901a96c$export$ffb0004e005737fa; }, function (v) { return $ef9efc139901a96c$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $ef9efc139901a96c$export$b624eff549462981; }, function (v) { return $ef9efc139901a96c$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $ef9efc139901a96c$export$7897aa7841a5380c; }, function (v) { return $ef9efc139901a96c$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $ef9efc139901a96c$export$602eac185826482c; }, function (v) { return $ef9efc139901a96c$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $ef9efc139901a96c$export$e2c29f18771995cb; }, function (v) { return $ef9efc139901a96c$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ef9efc139901a96c$export$5f8d39834fd61797; }, function (v) { return $ef9efc139901a96c$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ef9efc139901a96c$export$74bf444e3cd11ea5; }, function (v) { return $ef9efc139901a96c$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $ef9efc139901a96c$export$998bcd577473dd93; }, function (v) { return $ef9efc139901a96c$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $ef9efc139901a96c$export$b706b080d889d2c9; }, function (v) { return $ef9efc139901a96c$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $ef9efc139901a96c$export$5be5a87408f70ddc; }, function (v) { return $ef9efc139901a96c$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $ef9efc139901a96c$export$45a5e7f76e0caa8d; }, function (v) { return $ef9efc139901a96c$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $ef9efc139901a96c$export$455c2e768291efa6; }, function (v) { return $ef9efc139901a96c$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $ef9efc139901a96c$export$9522e17588c12572; }, function (v) { return $ef9efc139901a96c$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $ef9efc139901a96c$export$2110ac352bb060b9; }, function (v) { return $ef9efc139901a96c$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $ef9efc139901a96c$export$56885ab8b9c456ab; }, function (v) { return $ef9efc139901a96c$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $ef9efc139901a96c$export$d927fcb6adf8f9de; }, function (v) { return $ef9efc139901a96c$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $ef9efc139901a96c$export$b82d16f27459e05a; }, function (v) { return $ef9efc139901a96c$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $ef9efc139901a96c$export$522c17b4f5e123e8; }, function (v) { return $ef9efc139901a96c$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $ef9efc139901a96c$export$1aabd8a0274ecfd6; }, function (v) { return $ef9efc139901a96c$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $ef9efc139901a96c$export$3d6c20d97e46b957; }, function (v) { return $ef9efc139901a96c$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $ef9efc139901a96c$export$9b621391a187a31a; }, function (v) { return $ef9efc139901a96c$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $ef9efc139901a96c$export$f5bbd400c2f4426f; }, function (v) { return $ef9efc139901a96c$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ef9efc139901a96c$export$a7c73072b1a182ae;
var $ef9efc139901a96c$export$9f27bc3417b4524d;
var $ef9efc139901a96c$export$db77ccec0bb4ccac;
var $ef9efc139901a96c$export$8392c0c9d3dcbd35;
var $ef9efc139901a96c$export$ffb0004e005737fa;
var $ef9efc139901a96c$export$b624eff549462981;
var $ef9efc139901a96c$export$7897aa7841a5380c;
var $ef9efc139901a96c$export$602eac185826482c;
var $ef9efc139901a96c$export$e2c29f18771995cb;
var $ef9efc139901a96c$export$5f8d39834fd61797;
var $ef9efc139901a96c$export$74bf444e3cd11ea5;
var $ef9efc139901a96c$export$998bcd577473dd93;
var $ef9efc139901a96c$export$b706b080d889d2c9;
var $ef9efc139901a96c$export$5be5a87408f70ddc;
var $ef9efc139901a96c$export$45a5e7f76e0caa8d;
var $ef9efc139901a96c$export$455c2e768291efa6;
var $ef9efc139901a96c$export$9522e17588c12572;
var $ef9efc139901a96c$export$2110ac352bb060b9;
var $ef9efc139901a96c$export$56885ab8b9c456ab;
var $ef9efc139901a96c$export$d927fcb6adf8f9de;
var $ef9efc139901a96c$export$b82d16f27459e05a;
var $ef9efc139901a96c$export$522c17b4f5e123e8;
var $ef9efc139901a96c$export$1aabd8a0274ecfd6;
var $ef9efc139901a96c$export$3d6c20d97e46b957;
var $ef9efc139901a96c$export$9b621391a187a31a;
var $ef9efc139901a96c$export$f5bbd400c2f4426f;
"use strict";
var $ef9efc139901a96c$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $ef9efc139901a96c$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $ef9efc139901a96c$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $ef9efc139901a96c$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $ef9efc139901a96c$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $ef9efc139901a96c$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $ef9efc139901a96c$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $ef9efc139901a96c$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $ef9efc139901a96c$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $ef9efc139901a96c$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $ef9efc139901a96c$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $ef9efc139901a96c$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $ef9efc139901a96c$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $ef9efc139901a96c$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $ef9efc139901a96c$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $ef9efc139901a96c$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $ef9efc139901a96c$var$REACT_FRAGMENT_TYPE:
                    case $ef9efc139901a96c$var$REACT_PROFILER_TYPE:
                    case $ef9efc139901a96c$var$REACT_STRICT_MODE_TYPE:
                    case $ef9efc139901a96c$var$REACT_SUSPENSE_TYPE:
                    case $ef9efc139901a96c$var$REACT_SUSPENSE_LIST_TYPE:
                    case $ef9efc139901a96c$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $ef9efc139901a96c$var$REACT_CONTEXT_TYPE:
                            case $ef9efc139901a96c$var$REACT_FORWARD_REF_TYPE:
                            case $ef9efc139901a96c$var$REACT_LAZY_TYPE:
                            case $ef9efc139901a96c$var$REACT_MEMO_TYPE:
                                return object;
                            case $ef9efc139901a96c$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $ef9efc139901a96c$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$ef9efc139901a96c$export$a7c73072b1a182ae = $ef9efc139901a96c$var$REACT_CONSUMER_TYPE;
$ef9efc139901a96c$export$9f27bc3417b4524d = $ef9efc139901a96c$var$REACT_CONTEXT_TYPE;
$ef9efc139901a96c$export$db77ccec0bb4ccac = $ef9efc139901a96c$var$REACT_ELEMENT_TYPE;
$ef9efc139901a96c$export$8392c0c9d3dcbd35 = $ef9efc139901a96c$var$REACT_FORWARD_REF_TYPE;
$ef9efc139901a96c$export$ffb0004e005737fa = $ef9efc139901a96c$var$REACT_FRAGMENT_TYPE;
$ef9efc139901a96c$export$b624eff549462981 = $ef9efc139901a96c$var$REACT_LAZY_TYPE;
$ef9efc139901a96c$export$7897aa7841a5380c = $ef9efc139901a96c$var$REACT_MEMO_TYPE;
$ef9efc139901a96c$export$602eac185826482c = $ef9efc139901a96c$var$REACT_PORTAL_TYPE;
$ef9efc139901a96c$export$e2c29f18771995cb = $ef9efc139901a96c$var$REACT_PROFILER_TYPE;
$ef9efc139901a96c$export$5f8d39834fd61797 = $ef9efc139901a96c$var$REACT_STRICT_MODE_TYPE;
$ef9efc139901a96c$export$74bf444e3cd11ea5 = $ef9efc139901a96c$var$REACT_SUSPENSE_TYPE;
$ef9efc139901a96c$export$998bcd577473dd93 = $ef9efc139901a96c$var$REACT_SUSPENSE_LIST_TYPE;
$ef9efc139901a96c$export$b706b080d889d2c9 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_CONSUMER_TYPE;
};
$ef9efc139901a96c$export$5be5a87408f70ddc = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_CONTEXT_TYPE;
};
$ef9efc139901a96c$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $ef9efc139901a96c$var$REACT_ELEMENT_TYPE;
};
$ef9efc139901a96c$export$455c2e768291efa6 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_FORWARD_REF_TYPE;
};
$ef9efc139901a96c$export$9522e17588c12572 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_FRAGMENT_TYPE;
};
$ef9efc139901a96c$export$2110ac352bb060b9 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_LAZY_TYPE;
};
$ef9efc139901a96c$export$56885ab8b9c456ab = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_MEMO_TYPE;
};
$ef9efc139901a96c$export$d927fcb6adf8f9de = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_PORTAL_TYPE;
};
$ef9efc139901a96c$export$b82d16f27459e05a = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_PROFILER_TYPE;
};
$ef9efc139901a96c$export$522c17b4f5e123e8 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_STRICT_MODE_TYPE;
};
$ef9efc139901a96c$export$1aabd8a0274ecfd6 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_SUSPENSE_TYPE;
};
$ef9efc139901a96c$export$3d6c20d97e46b957 = function(object) {
    return $ef9efc139901a96c$var$typeOf(object) === $ef9efc139901a96c$var$REACT_SUSPENSE_LIST_TYPE;
};
$ef9efc139901a96c$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $ef9efc139901a96c$var$REACT_FRAGMENT_TYPE || type === $ef9efc139901a96c$var$REACT_PROFILER_TYPE || type === $ef9efc139901a96c$var$REACT_STRICT_MODE_TYPE || type === $ef9efc139901a96c$var$REACT_SUSPENSE_TYPE || type === $ef9efc139901a96c$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $ef9efc139901a96c$var$REACT_LAZY_TYPE || type.$$typeof === $ef9efc139901a96c$var$REACT_MEMO_TYPE || type.$$typeof === $ef9efc139901a96c$var$REACT_CONTEXT_TYPE || type.$$typeof === $ef9efc139901a96c$var$REACT_CONSUMER_TYPE || type.$$typeof === $ef9efc139901a96c$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $ef9efc139901a96c$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$ef9efc139901a96c$export$f5bbd400c2f4426f = $ef9efc139901a96c$var$typeOf;

});




parcelRegister("eqNKX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("2G6xE")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("iZrRs")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("56TFl")).default; });

var $2G6xE = parcelRequire("2G6xE");

var $iZrRs = parcelRequire("iZrRs");

var $56TFl = parcelRequire("56TFl");

});
parcelRegister("2G6xE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f34940f58017e5f$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $3wRTY = parcelRequire("3wRTY");

var $iZrRs = parcelRequire("iZrRs");

var $l8Cag = parcelRequire("l8Cag");

var $GLqnW = parcelRequire("GLqnW");

var $8M6a3 = parcelRequire("8M6a3");

var $hXGiu = parcelRequire("hXGiu");

var $56TFl = parcelRequire("56TFl");
const $1f34940f58017e5f$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $1f34940f58017e5f$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $cFLic.default)(options, $1f34940f58017e5f$var$_excluded);
    const breakpoints = (0, $iZrRs.default)(breakpointsInput);
    const spacing = (0, $GLqnW.default)(spacingInput);
    let muiTheme = (0, $3wRTY.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $kY3Ke.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $kY3Ke.default)({}, (0, $l8Cag.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $56TFl.default);
    muiTheme = args.reduce((acc, argument)=>(0, $3wRTY.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $kY3Ke.default)({}, (0, $hXGiu.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $8M6a3.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $1f34940f58017e5f$export$2e2bcd8739ae039 = $1f34940f58017e5f$var$createTheme;

});
parcelRegister("cFLic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $939dffaddf93a85b$export$2e2bcd8739ae039; });
function $939dffaddf93a85b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("3wRTY", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $291e2c063c5d6173$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $291e2c063c5d6173$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");
function $291e2c063c5d6173$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $291e2c063c5d6173$var$deepClone(source) {
    if (/*#__PURE__*/ $7fPBF.isValidElement(source) || !$291e2c063c5d6173$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $291e2c063c5d6173$var$deepClone(source[key]);
    });
    return output;
}
function $291e2c063c5d6173$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $kY3Ke.default)({}, target) : target;
    if ($291e2c063c5d6173$export$53b83ca8eaab0383(target) && $291e2c063c5d6173$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $7fPBF.isValidElement(source[key])) output[key] = source[key];
        else if ($291e2c063c5d6173$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $291e2c063c5d6173$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $291e2c063c5d6173$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $291e2c063c5d6173$export$53b83ca8eaab0383(source[key]) ? $291e2c063c5d6173$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("iZrRs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd33892704fa9f8b$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
const $dd33892704fa9f8b$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $dd33892704fa9f8b$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $dd33892704fa9f8b$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $kY3Ke.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $dd33892704fa9f8b$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $cFLic.default)(breakpoints, $dd33892704fa9f8b$var$_excluded);
    const sortedValues = $dd33892704fa9f8b$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $kY3Ke.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("l8Cag", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f637f3037d6dee04$export$2e2bcd8739ae039; });
const $f637f3037d6dee04$var$shape = {
    borderRadius: 4
};
var $f637f3037d6dee04$export$2e2bcd8739ae039 = $f637f3037d6dee04$var$shape;

});

parcelRegister("GLqnW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0808b5e3ab0ab6d4$export$2e2bcd8739ae039; });

var $5z69T = parcelRequire("5z69T");
function $0808b5e3ab0ab6d4$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $5z69T.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("5z69T", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $40d4ff9e66a5531b$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $40d4ff9e66a5531b$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $40d4ff9e66a5531b$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $40d4ff9e66a5531b$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $40d4ff9e66a5531b$export$6f98e8eaf0be1996; });


var $cvrkU = parcelRequire("cvrkU");

var $190Wm = parcelRequire("190Wm");

var $4So0q = parcelRequire("4So0q");

var $dMDTp = parcelRequire("dMDTp");
const $40d4ff9e66a5531b$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $40d4ff9e66a5531b$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $40d4ff9e66a5531b$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $40d4ff9e66a5531b$var$getCssProperties = (0, $dMDTp.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($40d4ff9e66a5531b$var$aliases[prop]) prop = $40d4ff9e66a5531b$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $40d4ff9e66a5531b$var$properties[a];
    const direction = $40d4ff9e66a5531b$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $40d4ff9e66a5531b$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $40d4ff9e66a5531b$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $40d4ff9e66a5531b$var$spacingKeys = [
    ...$40d4ff9e66a5531b$export$aab52a0dde05ad8a,
    ...$40d4ff9e66a5531b$export$f8397d44f03ab6ad
];
function $40d4ff9e66a5531b$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $190Wm.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $40d4ff9e66a5531b$export$1def6f833384e3d1(theme) {
    return $40d4ff9e66a5531b$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $40d4ff9e66a5531b$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $40d4ff9e66a5531b$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $40d4ff9e66a5531b$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $40d4ff9e66a5531b$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $40d4ff9e66a5531b$var$getCssProperties(prop);
    const styleFromPropValue = $40d4ff9e66a5531b$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $cvrkU.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $40d4ff9e66a5531b$var$style(props, keys) {
    const transformer = $40d4ff9e66a5531b$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$40d4ff9e66a5531b$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $4So0q.default), {});
}
function $40d4ff9e66a5531b$export$7ede87f9b603dd3c(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$export$aab52a0dde05ad8a);
}
$40d4ff9e66a5531b$export$7ede87f9b603dd3c.propTypes = {};
$40d4ff9e66a5531b$export$7ede87f9b603dd3c.filterProps = $40d4ff9e66a5531b$export$aab52a0dde05ad8a;
function $40d4ff9e66a5531b$export$6f98e8eaf0be1996(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$export$f8397d44f03ab6ad);
}
$40d4ff9e66a5531b$export$6f98e8eaf0be1996.propTypes = {};
$40d4ff9e66a5531b$export$6f98e8eaf0be1996.filterProps = $40d4ff9e66a5531b$export$f8397d44f03ab6ad;
function $40d4ff9e66a5531b$var$spacing(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$var$spacingKeys);
}
$40d4ff9e66a5531b$var$spacing.propTypes = {};
$40d4ff9e66a5531b$var$spacing.filterProps = $40d4ff9e66a5531b$var$spacingKeys;
var $40d4ff9e66a5531b$export$2e2bcd8739ae039 = $40d4ff9e66a5531b$var$spacing;

});
parcelRegister("cvrkU", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $91ad95ac62846a03$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $91ad95ac62846a03$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $91ad95ac62846a03$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $91ad95ac62846a03$export$8922c90b6e020726; });

var $kY3Ke = parcelRequire("kY3Ke");


var $3wRTY = parcelRequire("3wRTY");

var $4So0q = parcelRequire("4So0q");
const $91ad95ac62846a03$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $91ad95ac62846a03$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$91ad95ac62846a03$export$68c286be0e7e55b7[key]}px)`
};
function $91ad95ac62846a03$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $91ad95ac62846a03$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $91ad95ac62846a03$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $kY3Ke.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $4So0q.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $91ad95ac62846a03$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $91ad95ac62846a03$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $91ad95ac62846a03$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $91ad95ac62846a03$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $3wRTY.default)(prev, next), {});
    return $91ad95ac62846a03$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $91ad95ac62846a03$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $91ad95ac62846a03$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $91ad95ac62846a03$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $91ad95ac62846a03$export$2e2bcd8739ae039 = $91ad95ac62846a03$var$breakpoints;

});
parcelRegister("4So0q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38ced3a04f47cab4$export$2e2bcd8739ae039; });

var $3wRTY = parcelRequire("3wRTY");
function $38ced3a04f47cab4$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $3wRTY.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $38ced3a04f47cab4$export$2e2bcd8739ae039 = $38ced3a04f47cab4$var$merge;

});


parcelRegister("190Wm", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $0d575c74131361b5$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $0d575c74131361b5$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $0d575c74131361b5$export$2e2bcd8739ae039; });

var $iCiVn = parcelRequire("iCiVn");


var $cvrkU = parcelRequire("cvrkU");
function $0d575c74131361b5$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $0d575c74131361b5$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $0d575c74131361b5$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $0d575c74131361b5$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $iCiVn.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $0d575c74131361b5$export$2e2bcd8739ae039 = $0d575c74131361b5$var$style;

});

parcelRegister("dMDTp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a08eb3ea758ca121$export$2e2bcd8739ae039; });
function $a08eb3ea758ca121$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("8M6a3", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $663795ec7cbfcd06$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $663795ec7cbfcd06$export$2e2bcd8739ae039; });

var $iCiVn = parcelRequire("iCiVn");

var $4So0q = parcelRequire("4So0q");

var $190Wm = parcelRequire("190Wm");

var $cvrkU = parcelRequire("cvrkU");

var $hXGiu = parcelRequire("hXGiu");
function $663795ec7cbfcd06$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $663795ec7cbfcd06$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $663795ec7cbfcd06$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $190Wm.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $190Wm.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $190Wm.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $iCiVn.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $hXGiu.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $cvrkU.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $663795ec7cbfcd06$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $4So0q.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $cvrkU.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($663795ec7cbfcd06$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $4So0q.default)(css, breakpointsValues);
                        }
                    } else css = (0, $4So0q.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $cvrkU.removeUnusedBreakpoints)(breakpointsKeys, css)
            };
            return (0, $cvrkU.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $663795ec7cbfcd06$var$styleFunctionSx = $663795ec7cbfcd06$export$7d53d8bf2911e013();
$663795ec7cbfcd06$var$styleFunctionSx.filterProps = [
    'sx'
];
var $663795ec7cbfcd06$export$2e2bcd8739ae039 = $663795ec7cbfcd06$var$styleFunctionSx;

});
parcelRegister("hXGiu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d138c1b003d294d5$export$2e2bcd8739ae039; });

var $5z69T = parcelRequire("5z69T");

var $brmMH = parcelRequire("brmMH");

var $aoYMG = parcelRequire("aoYMG");

var $lzsJx = parcelRequire("lzsJx");

var $8LvXe = parcelRequire("8LvXe");
const $d138c1b003d294d5$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $brmMH.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $lzsJx.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $lzsJx.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $lzsJx.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $5z69T.padding)
    },
    pt: {
        style: (0, $5z69T.padding)
    },
    pr: {
        style: (0, $5z69T.padding)
    },
    pb: {
        style: (0, $5z69T.padding)
    },
    pl: {
        style: (0, $5z69T.padding)
    },
    px: {
        style: (0, $5z69T.padding)
    },
    py: {
        style: (0, $5z69T.padding)
    },
    padding: {
        style: (0, $5z69T.padding)
    },
    paddingTop: {
        style: (0, $5z69T.padding)
    },
    paddingRight: {
        style: (0, $5z69T.padding)
    },
    paddingBottom: {
        style: (0, $5z69T.padding)
    },
    paddingLeft: {
        style: (0, $5z69T.padding)
    },
    paddingX: {
        style: (0, $5z69T.padding)
    },
    paddingY: {
        style: (0, $5z69T.padding)
    },
    paddingInline: {
        style: (0, $5z69T.padding)
    },
    paddingInlineStart: {
        style: (0, $5z69T.padding)
    },
    paddingInlineEnd: {
        style: (0, $5z69T.padding)
    },
    paddingBlock: {
        style: (0, $5z69T.padding)
    },
    paddingBlockStart: {
        style: (0, $5z69T.padding)
    },
    paddingBlockEnd: {
        style: (0, $5z69T.padding)
    },
    m: {
        style: (0, $5z69T.margin)
    },
    mt: {
        style: (0, $5z69T.margin)
    },
    mr: {
        style: (0, $5z69T.margin)
    },
    mb: {
        style: (0, $5z69T.margin)
    },
    ml: {
        style: (0, $5z69T.margin)
    },
    mx: {
        style: (0, $5z69T.margin)
    },
    my: {
        style: (0, $5z69T.margin)
    },
    margin: {
        style: (0, $5z69T.margin)
    },
    marginTop: {
        style: (0, $5z69T.margin)
    },
    marginRight: {
        style: (0, $5z69T.margin)
    },
    marginBottom: {
        style: (0, $5z69T.margin)
    },
    marginLeft: {
        style: (0, $5z69T.margin)
    },
    marginX: {
        style: (0, $5z69T.margin)
    },
    marginY: {
        style: (0, $5z69T.margin)
    },
    marginInline: {
        style: (0, $5z69T.margin)
    },
    marginInlineStart: {
        style: (0, $5z69T.margin)
    },
    marginInlineEnd: {
        style: (0, $5z69T.margin)
    },
    marginBlock: {
        style: (0, $5z69T.margin)
    },
    marginBlockStart: {
        style: (0, $5z69T.margin)
    },
    marginBlockEnd: {
        style: (0, $5z69T.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $aoYMG.gap)
    },
    rowGap: {
        style: (0, $aoYMG.rowGap)
    },
    columnGap: {
        style: (0, $aoYMG.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $8LvXe.sizingTransform)
    },
    maxWidth: {
        style: (0, $8LvXe.maxWidth)
    },
    minWidth: {
        transform: (0, $8LvXe.sizingTransform)
    },
    height: {
        transform: (0, $8LvXe.sizingTransform)
    },
    maxHeight: {
        transform: (0, $8LvXe.sizingTransform)
    },
    minHeight: {
        transform: (0, $8LvXe.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $d138c1b003d294d5$export$2e2bcd8739ae039 = $d138c1b003d294d5$var$defaultSxConfig;

});
parcelRegister("brmMH", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $8543e3d4e0a2f626$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $8543e3d4e0a2f626$export$7a57f79000377ca2; });


var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $5z69T = parcelRequire("5z69T");

var $cvrkU = parcelRequire("cvrkU");
function $8543e3d4e0a2f626$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $8543e3d4e0a2f626$var$createBorderStyle(prop, transform) {
    return (0, $190Wm.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $8543e3d4e0a2f626$export$1edee58a52776cd9 = $8543e3d4e0a2f626$var$createBorderStyle('border', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$f9a7b6bd24892946 = $8543e3d4e0a2f626$var$createBorderStyle('borderTop', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$5abca33e6be905d2 = $8543e3d4e0a2f626$var$createBorderStyle('borderRight', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$e2ce9f12a980a822 = $8543e3d4e0a2f626$var$createBorderStyle('borderBottom', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$47658cca1a909427 = $8543e3d4e0a2f626$var$createBorderStyle('borderLeft', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$e7fb0694ba2404fc = $8543e3d4e0a2f626$var$createBorderStyle('borderColor');
const $8543e3d4e0a2f626$export$126a92c968acdb85 = $8543e3d4e0a2f626$var$createBorderStyle('borderTopColor');
const $8543e3d4e0a2f626$export$85cc51cb8fbb8c0e = $8543e3d4e0a2f626$var$createBorderStyle('borderRightColor');
const $8543e3d4e0a2f626$export$340b0327727f6d1a = $8543e3d4e0a2f626$var$createBorderStyle('borderBottomColor');
const $8543e3d4e0a2f626$export$60beef91a985b4bf = $8543e3d4e0a2f626$var$createBorderStyle('borderLeftColor');
const $8543e3d4e0a2f626$export$f9258c55612cbed7 = $8543e3d4e0a2f626$var$createBorderStyle('outline', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$621fe586efeb64b9 = $8543e3d4e0a2f626$var$createBorderStyle('outlineColor');
const $8543e3d4e0a2f626$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$8543e3d4e0a2f626$export$7a57f79000377ca2.propTypes = {};
$8543e3d4e0a2f626$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $8543e3d4e0a2f626$var$borders = (0, $eB9d8.default)($8543e3d4e0a2f626$export$1edee58a52776cd9, $8543e3d4e0a2f626$export$f9a7b6bd24892946, $8543e3d4e0a2f626$export$5abca33e6be905d2, $8543e3d4e0a2f626$export$e2ce9f12a980a822, $8543e3d4e0a2f626$export$47658cca1a909427, $8543e3d4e0a2f626$export$e7fb0694ba2404fc, $8543e3d4e0a2f626$export$126a92c968acdb85, $8543e3d4e0a2f626$export$85cc51cb8fbb8c0e, $8543e3d4e0a2f626$export$340b0327727f6d1a, $8543e3d4e0a2f626$export$60beef91a985b4bf, $8543e3d4e0a2f626$export$7a57f79000377ca2, $8543e3d4e0a2f626$export$f9258c55612cbed7, $8543e3d4e0a2f626$export$621fe586efeb64b9);
var $8543e3d4e0a2f626$export$2e2bcd8739ae039 = $8543e3d4e0a2f626$var$borders;

});
parcelRegister("eB9d8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa0baa79cee865b3$export$2e2bcd8739ae039; });

var $4So0q = parcelRequire("4So0q");
function $aa0baa79cee865b3$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $4So0q.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $aa0baa79cee865b3$export$2e2bcd8739ae039 = $aa0baa79cee865b3$var$compose;

});


parcelRegister("aoYMG", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $792b4bc41110be3c$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $792b4bc41110be3c$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $792b4bc41110be3c$export$8a833ffa5f5dbeda; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $5z69T = parcelRequire("5z69T");

var $cvrkU = parcelRequire("cvrkU");

const $792b4bc41110be3c$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$5df9adcb0db95e1e.propTypes = {};
$792b4bc41110be3c$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $792b4bc41110be3c$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$ec60d70ff941a580.propTypes = {};
$792b4bc41110be3c$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $792b4bc41110be3c$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$8a833ffa5f5dbeda.propTypes = {};
$792b4bc41110be3c$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $792b4bc41110be3c$export$baf44164ca3a34e8 = (0, $190Wm.default)({
    prop: 'gridColumn'
});
const $792b4bc41110be3c$export$8f7213a1cd01e832 = (0, $190Wm.default)({
    prop: 'gridRow'
});
const $792b4bc41110be3c$export$b0e0abbc49ba668 = (0, $190Wm.default)({
    prop: 'gridAutoFlow'
});
const $792b4bc41110be3c$export$bcd8b929d4b4142 = (0, $190Wm.default)({
    prop: 'gridAutoColumns'
});
const $792b4bc41110be3c$export$e5039a674e14c828 = (0, $190Wm.default)({
    prop: 'gridAutoRows'
});
const $792b4bc41110be3c$export$42bd9088661ffb03 = (0, $190Wm.default)({
    prop: 'gridTemplateColumns'
});
const $792b4bc41110be3c$export$920682ae05b999bc = (0, $190Wm.default)({
    prop: 'gridTemplateRows'
});
const $792b4bc41110be3c$export$1b88fbdd482fd33a = (0, $190Wm.default)({
    prop: 'gridTemplateAreas'
});
const $792b4bc41110be3c$export$bdb486e40d52d26f = (0, $190Wm.default)({
    prop: 'gridArea'
});
const $792b4bc41110be3c$var$grid = (0, $eB9d8.default)($792b4bc41110be3c$export$5df9adcb0db95e1e, $792b4bc41110be3c$export$ec60d70ff941a580, $792b4bc41110be3c$export$8a833ffa5f5dbeda, $792b4bc41110be3c$export$baf44164ca3a34e8, $792b4bc41110be3c$export$8f7213a1cd01e832, $792b4bc41110be3c$export$b0e0abbc49ba668, $792b4bc41110be3c$export$bcd8b929d4b4142, $792b4bc41110be3c$export$e5039a674e14c828, $792b4bc41110be3c$export$42bd9088661ffb03, $792b4bc41110be3c$export$920682ae05b999bc, $792b4bc41110be3c$export$1b88fbdd482fd33a, $792b4bc41110be3c$export$bdb486e40d52d26f);
var $792b4bc41110be3c$export$2e2bcd8739ae039 = $792b4bc41110be3c$var$grid;

});

parcelRegister("lzsJx", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $fb4327c08e40e84e$export$dbaffd4420ea0ac6; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");
function $fb4327c08e40e84e$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $fb4327c08e40e84e$export$35e9368ef982300f = (0, $190Wm.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$export$2506f56c10355b33 = (0, $190Wm.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$export$8c5a050822fd698c = (0, $190Wm.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$var$palette = (0, $eB9d8.default)($fb4327c08e40e84e$export$35e9368ef982300f, $fb4327c08e40e84e$export$2506f56c10355b33, $fb4327c08e40e84e$export$8c5a050822fd698c);
var $fb4327c08e40e84e$export$2e2bcd8739ae039 = $fb4327c08e40e84e$var$palette;

});

parcelRegister("8LvXe", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $661b7ffebb8ef134$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $661b7ffebb8ef134$export$488fda99655ff65a; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $cvrkU = parcelRequire("cvrkU");
function $661b7ffebb8ef134$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $661b7ffebb8ef134$export$7e3df82ee760448c = (0, $190Wm.default)({
    prop: 'width',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $cvrkU.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $661b7ffebb8ef134$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$661b7ffebb8ef134$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $661b7ffebb8ef134$export$ee148fbbe8357dd2 = (0, $190Wm.default)({
    prop: 'minWidth',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$ac607276a8fe9f0a = (0, $190Wm.default)({
    prop: 'height',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$dc0d8bd0b94f8570 = (0, $190Wm.default)({
    prop: 'maxHeight',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$a43cf604e12f3b17 = (0, $190Wm.default)({
    prop: 'minHeight',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$ffed9f14fb65e276 = (0, $190Wm.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$905076ed6620e671 = (0, $190Wm.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$6ccc93f785106a58 = (0, $190Wm.default)({
    prop: 'boxSizing'
});
const $661b7ffebb8ef134$var$sizing = (0, $eB9d8.default)($661b7ffebb8ef134$export$7e3df82ee760448c, $661b7ffebb8ef134$export$488fda99655ff65a, $661b7ffebb8ef134$export$ee148fbbe8357dd2, $661b7ffebb8ef134$export$ac607276a8fe9f0a, $661b7ffebb8ef134$export$dc0d8bd0b94f8570, $661b7ffebb8ef134$export$a43cf604e12f3b17, $661b7ffebb8ef134$export$6ccc93f785106a58);
var $661b7ffebb8ef134$export$2e2bcd8739ae039 = $661b7ffebb8ef134$var$sizing;

});



parcelRegister("56TFl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b88b157d6186746$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $3b88b157d6186746$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("3aVNX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("8M6a3")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("8M6a3")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("mqrnX")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("hXGiu")).default; });

var $8M6a3 = parcelRequire("8M6a3");

var $mqrnX = parcelRequire("mqrnX");

var $hXGiu = parcelRequire("hXGiu");

});
parcelRegister("mqrnX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $043690c2de8ba6fa$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $3wRTY = parcelRequire("3wRTY");

var $hXGiu = parcelRequire("hXGiu");
const $043690c2de8ba6fa$var$_excluded = [
    "sx"
];
const $043690c2de8ba6fa$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $hXGiu.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $043690c2de8ba6fa$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $cFLic.default)(props, $043690c2de8ba6fa$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $043690c2de8ba6fa$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $3wRTY.isPlainObject)(result)) return systemProps;
        return (0, $kY3Ke.default)({}, systemProps, result);
    };
    else finalSx = (0, $kY3Ke.default)({}, systemProps, inSx);
    return (0, $kY3Ke.default)({}, otherProps, {
        sx: finalSx
    });
}

});



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
var $f11ec298ebcca059$exports = {};

$parcel$export($f11ec298ebcca059$exports, "createRoot", function () { return $f11ec298ebcca059$export$882461b6382ed46c; }, function (v) { return $f11ec298ebcca059$export$882461b6382ed46c = v; });
$parcel$export($f11ec298ebcca059$exports, "hydrateRoot", function () { return $f11ec298ebcca059$export$757ceba2d55c277e; }, function (v) { return $f11ec298ebcca059$export$757ceba2d55c277e = v; });
var $f11ec298ebcca059$export$882461b6382ed46c;
var $f11ec298ebcca059$export$757ceba2d55c277e;
'use strict';
var $b4ba1c853f6e1116$exports = {};
'use strict';
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

$b4ba1c853f6e1116$exports = (parcelRequire("6EA3T"));


var $f11ec298ebcca059$var$i;
$f11ec298ebcca059$export$882461b6382ed46c = $b4ba1c853f6e1116$exports.createRoot;
$f11ec298ebcca059$export$757ceba2d55c277e = $b4ba1c853f6e1116$exports.hydrateRoot;



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $diYUK = parcelRequire("diYUK");

var $3wRTY = parcelRequire("3wRTY");

var $8M6a3 = parcelRequire("8M6a3");
var $hXGiu = parcelRequire("hXGiu");

var $2G6xE = parcelRequire("2G6xE");


var $kY3Ke = parcelRequire("kY3Ke");
function $04aa49c3b5b31b02$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $kY3Ke.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $diYUK = parcelRequire("diYUK");

var $3wRTY = parcelRequire("3wRTY");
var $553ed2baba4347ed$exports = {};
"use strict";
var $4657741705a128f0$exports = {};
function $4657741705a128f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
$4657741705a128f0$exports = $4657741705a128f0$var$_interopRequireDefault, $4657741705a128f0$exports.__esModule = true, $4657741705a128f0$exports["default"] = $4657741705a128f0$exports;


Object.defineProperty($553ed2baba4347ed$exports, "__esModule", {
    value: true
});
$553ed2baba4347ed$exports.alpha = $553ed2baba4347ed$var$alpha;
$553ed2baba4347ed$exports.blend = $553ed2baba4347ed$var$blend;
$553ed2baba4347ed$exports.colorChannel = void 0;
$553ed2baba4347ed$exports.darken = $553ed2baba4347ed$var$darken;
$553ed2baba4347ed$exports.decomposeColor = $553ed2baba4347ed$var$decomposeColor;
$553ed2baba4347ed$exports.emphasize = $553ed2baba4347ed$var$emphasize;
$553ed2baba4347ed$exports.getContrastRatio = $553ed2baba4347ed$var$getContrastRatio;
$553ed2baba4347ed$exports.getLuminance = $553ed2baba4347ed$var$getLuminance;
$553ed2baba4347ed$exports.hexToRgb = $553ed2baba4347ed$var$hexToRgb;
$553ed2baba4347ed$exports.hslToRgb = $553ed2baba4347ed$var$hslToRgb;
$553ed2baba4347ed$exports.lighten = $553ed2baba4347ed$var$lighten;
$553ed2baba4347ed$exports.private_safeAlpha = $553ed2baba4347ed$var$private_safeAlpha;
$553ed2baba4347ed$exports.private_safeColorChannel = void 0;
$553ed2baba4347ed$exports.private_safeDarken = $553ed2baba4347ed$var$private_safeDarken;
$553ed2baba4347ed$exports.private_safeEmphasize = $553ed2baba4347ed$var$private_safeEmphasize;
$553ed2baba4347ed$exports.private_safeLighten = $553ed2baba4347ed$var$private_safeLighten;
$553ed2baba4347ed$exports.recomposeColor = $553ed2baba4347ed$var$recomposeColor;
$553ed2baba4347ed$exports.rgbToHex = $553ed2baba4347ed$var$rgbToHex;

var $553ed2baba4347ed$var$_formatMuiErrorMessage2 = $4657741705a128f0$exports((parcelRequire("gzcup")));

var $553ed2baba4347ed$var$_clamp = $4657741705a128f0$exports((parcelRequire("8m7yE")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $553ed2baba4347ed$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $553ed2baba4347ed$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $553ed2baba4347ed$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $553ed2baba4347ed$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $553ed2baba4347ed$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $553ed2baba4347ed$var$decomposeColor($553ed2baba4347ed$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $553ed2baba4347ed$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $553ed2baba4347ed$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $553ed2baba4347ed$var$colorChannel = (color)=>{
    const decomposedColor = $553ed2baba4347ed$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
$553ed2baba4347ed$exports.colorChannel = $553ed2baba4347ed$var$colorChannel;
const $553ed2baba4347ed$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $553ed2baba4347ed$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ $553ed2baba4347ed$exports.private_safeColorChannel = $553ed2baba4347ed$var$private_safeColorChannel;
function $553ed2baba4347ed$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $553ed2baba4347ed$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $553ed2baba4347ed$var$decomposeColor(color);
    return `#${values.map((n, i)=>$553ed2baba4347ed$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $553ed2baba4347ed$var$hslToRgb(color) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $553ed2baba4347ed$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $553ed2baba4347ed$var$getLuminance(color) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $553ed2baba4347ed$var$decomposeColor($553ed2baba4347ed$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $553ed2baba4347ed$var$getContrastRatio(foreground, background) {
    const lumA = $553ed2baba4347ed$var$getLuminance(foreground);
    const lumB = $553ed2baba4347ed$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $553ed2baba4347ed$var$alpha(color, value) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    value = $553ed2baba4347ed$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $553ed2baba4347ed$var$recomposeColor(color);
}
function $553ed2baba4347ed$var$private_safeAlpha(color, value, warning) {
    try {
        return $553ed2baba4347ed$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $553ed2baba4347ed$var$darken(color, coefficient) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    coefficient = $553ed2baba4347ed$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $553ed2baba4347ed$var$recomposeColor(color);
}
function $553ed2baba4347ed$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $553ed2baba4347ed$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $553ed2baba4347ed$var$lighten(color, coefficient) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    coefficient = $553ed2baba4347ed$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $553ed2baba4347ed$var$recomposeColor(color);
}
function $553ed2baba4347ed$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $553ed2baba4347ed$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $553ed2baba4347ed$var$emphasize(color, coefficient = 0.15) {
    return $553ed2baba4347ed$var$getLuminance(color) > 0.5 ? $553ed2baba4347ed$var$darken(color, coefficient) : $553ed2baba4347ed$var$lighten(color, coefficient);
}
function $553ed2baba4347ed$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $553ed2baba4347ed$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $553ed2baba4347ed$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $553ed2baba4347ed$var$decomposeColor(background);
    const overlayColor = $553ed2baba4347ed$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $553ed2baba4347ed$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}


const $47d3f19e39b3b144$var$common = {
    black: '#000',
    white: '#fff'
};
var $47d3f19e39b3b144$export$2e2bcd8739ae039 = $47d3f19e39b3b144$var$common;


const $1baba9d0f229a247$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $1baba9d0f229a247$export$2e2bcd8739ae039 = $1baba9d0f229a247$var$grey;


const $2a2bdbc6cce4aa96$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $2a2bdbc6cce4aa96$export$2e2bcd8739ae039 = $2a2bdbc6cce4aa96$var$purple;


const $72940215fdf862f4$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $72940215fdf862f4$export$2e2bcd8739ae039 = $72940215fdf862f4$var$red;


const $454ad523c90fa85d$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $454ad523c90fa85d$export$2e2bcd8739ae039 = $454ad523c90fa85d$var$orange;


const $bc4de82bafd68977$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $bc4de82bafd68977$export$2e2bcd8739ae039 = $bc4de82bafd68977$var$blue;


const $12b015f9ee6c8f9f$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $12b015f9ee6c8f9f$export$2e2bcd8739ae039 = $12b015f9ee6c8f9f$var$lightBlue;


const $ca65bc19996a7eac$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $ca65bc19996a7eac$export$2e2bcd8739ae039 = $ca65bc19996a7eac$var$green;


const $07e9efd96a5c6f8a$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $07e9efd96a5c6f8a$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $47d3f19e39b3b144$export$2e2bcd8739ae039).white,
        default: (0, $47d3f19e39b3b144$export$2e2bcd8739ae039).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $07e9efd96a5c6f8a$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $47d3f19e39b3b144$export$2e2bcd8739ae039).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $47d3f19e39b3b144$export$2e2bcd8739ae039).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $07e9efd96a5c6f8a$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $553ed2baba4347ed$exports.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $553ed2baba4347ed$exports.darken)(intent.main, tonalOffsetDark);
    }
}
function $07e9efd96a5c6f8a$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[200],
        light: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[50],
        dark: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[700],
        light: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[400],
        dark: (0, $bc4de82bafd68977$export$2e2bcd8739ae039)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[200],
        light: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[50],
        dark: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[500],
        light: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[300],
        dark: (0, $2a2bdbc6cce4aa96$export$2e2bcd8739ae039)[700]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[500],
        light: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[300],
        dark: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[700],
        light: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[400],
        dark: (0, $72940215fdf862f4$export$2e2bcd8739ae039)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[400],
        light: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[300],
        dark: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[700],
        light: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[500],
        dark: (0, $12b015f9ee6c8f9f$export$2e2bcd8739ae039)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[400],
        light: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[300],
        dark: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[800],
        light: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[500],
        dark: (0, $ca65bc19996a7eac$export$2e2bcd8739ae039)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $454ad523c90fa85d$export$2e2bcd8739ae039)[400],
        light: (0, $454ad523c90fa85d$export$2e2bcd8739ae039)[300],
        dark: (0, $454ad523c90fa85d$export$2e2bcd8739ae039)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $454ad523c90fa85d$export$2e2bcd8739ae039)[500],
        dark: (0, $454ad523c90fa85d$export$2e2bcd8739ae039)[900]
    };
}
function $07e9efd96a5c6f8a$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $cFLic.default)(palette, $07e9efd96a5c6f8a$var$_excluded);
    const primary = palette.primary || $07e9efd96a5c6f8a$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $07e9efd96a5c6f8a$var$getDefaultSecondary(mode);
    const error = palette.error || $07e9efd96a5c6f8a$var$getDefaultError(mode);
    const info = palette.info || $07e9efd96a5c6f8a$var$getDefaultInfo(mode);
    const success = palette.success || $07e9efd96a5c6f8a$var$getDefaultSuccess(mode);
    const warning = palette.warning || $07e9efd96a5c6f8a$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $553ed2baba4347ed$exports.getContrastRatio)(background, $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary : $07e9efd96a5c6f8a$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $kY3Ke.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $diYUK.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $diYUK.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $07e9efd96a5c6f8a$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $07e9efd96a5c6f8a$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $07e9efd96a5c6f8a$export$55ce6f3a06c59543,
        light: $07e9efd96a5c6f8a$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $3wRTY.default)((0, $kY3Ke.default)({
        // A collection of common colors.
        common: (0, $kY3Ke.default)({}, (0, $47d3f19e39b3b144$export$2e2bcd8739ae039)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $1baba9d0f229a247$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $3wRTY = parcelRequire("3wRTY");
const $4027cd084802bc60$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $4027cd084802bc60$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $4027cd084802bc60$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $4027cd084802bc60$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $4027cd084802bc60$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $4027cd084802bc60$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $cFLic.default)(_ref, $4027cd084802bc60$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $kY3Ke.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $4027cd084802bc60$var$defaultFontFamily ? {
            letterSpacing: `${$4027cd084802bc60$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $4027cd084802bc60$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $4027cd084802bc60$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $3wRTY.default)((0, $kY3Ke.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}


const $26a3ee12a0d43232$var$shadowKeyUmbraOpacity = 0.2;
const $26a3ee12a0d43232$var$shadowKeyPenumbraOpacity = 0.14;
const $26a3ee12a0d43232$var$shadowAmbientShadowOpacity = 0.12;
function $26a3ee12a0d43232$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $26a3ee12a0d43232$var$shadows = [
    'none',
    $26a3ee12a0d43232$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $26a3ee12a0d43232$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $26a3ee12a0d43232$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $26a3ee12a0d43232$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $26a3ee12a0d43232$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $26a3ee12a0d43232$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $26a3ee12a0d43232$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $26a3ee12a0d43232$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $26a3ee12a0d43232$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $26a3ee12a0d43232$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $26a3ee12a0d43232$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $26a3ee12a0d43232$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $26a3ee12a0d43232$export$2e2bcd8739ae039 = $26a3ee12a0d43232$var$shadows;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
const $ec94076b9ecccee1$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $ec94076b9ecccee1$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $ec94076b9ecccee1$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $ec94076b9ecccee1$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $ec94076b9ecccee1$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $ec94076b9ecccee1$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $kY3Ke.default)({}, $ec94076b9ecccee1$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $kY3Ke.default)({}, $ec94076b9ecccee1$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $cFLic.default)(options, $ec94076b9ecccee1$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $ec94076b9ecccee1$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $ec94076b9ecccee1$var$formatMs(delay)}`).join(',');
    };
    return (0, $kY3Ke.default)({
        getAutoHeightDuration: $ec94076b9ecccee1$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $ab06614e124e32b2$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $ab06614e124e32b2$export$2e2bcd8739ae039 = $ab06614e124e32b2$var$zIndex;


const $ca3239ce6bf6e490$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $ca3239ce6bf6e490$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $cFLic.default)(options, $ca3239ce6bf6e490$var$_excluded);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateCssVars === undefined) throw new Error((0, $diYUK.default)(18));
    const palette = (0, $07e9efd96a5c6f8a$export$2e2bcd8739ae039)(paletteInput);
    const systemTheme = (0, $2G6xE.default)(options);
    let muiTheme = (0, $3wRTY.default)(systemTheme, {
        mixins: (0, $04aa49c3b5b31b02$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $26a3ee12a0d43232$export$2e2bcd8739ae039).slice(),
        typography: (0, $4027cd084802bc60$export$2e2bcd8739ae039)(palette, typographyInput),
        transitions: (0, $ec94076b9ecccee1$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: (0, $kY3Ke.default)({}, (0, $ab06614e124e32b2$export$2e2bcd8739ae039))
    });
    muiTheme = (0, $3wRTY.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3wRTY.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $kY3Ke.default)({}, (0, $hXGiu.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $8M6a3.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $ca3239ce6bf6e490$var$warnedOnce = false;
function $ca3239ce6bf6e490$export$c469355549431d9b(...args) {
    return $ca3239ce6bf6e490$var$createTheme(...args);
}
var $ca3239ce6bf6e490$export$2e2bcd8739ae039 = $ca3239ce6bf6e490$var$createTheme;


var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");
parcelRequire("7fPBF");


var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");
const $c21ce0253dc11cd3$var$ThemeContext = /*#__PURE__*/ $7fPBF.createContext(null);
var $c21ce0253dc11cd3$export$2e2bcd8739ae039 = $c21ce0253dc11cd3$var$ThemeContext;



var $7fPBF = parcelRequire("7fPBF");

function $b5dba0f0f3e50f8f$export$2e2bcd8739ae039() {
    const theme = $7fPBF.useContext((0, $c21ce0253dc11cd3$export$2e2bcd8739ae039));
    return theme;
}


const $24ebfb3bf89f6ffe$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $24ebfb3bf89f6ffe$export$2e2bcd8739ae039 = $24ebfb3bf89f6ffe$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $bbzbN = parcelRequire("bbzbN");
function $f311b16c4b43b6fd$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $kY3Ke.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $f311b16c4b43b6fd$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $b5dba0f0f3e50f8f$export$2e2bcd8739ae039)();
    const theme = $7fPBF.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $f311b16c4b43b6fd$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $24ebfb3bf89f6ffe$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c21ce0253dc11cd3$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $f311b16c4b43b6fd$export$2e2bcd8739ae039 = $f311b16c4b43b6fd$var$ThemeProvider;



parcelRequire("5nUae");
var $6te04 = parcelRequire("6te04");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("5nUae");
var $6te04 = parcelRequire("6te04");
'use client';
function $5e16ee62ac64bb0b$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $5e16ee62ac64bb0b$var$useTheme(defaultTheme = null) {
    const contextTheme = $7fPBF.useContext((0, $6te04.T));
    return !contextTheme || $5e16ee62ac64bb0b$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $5e16ee62ac64bb0b$export$2e2bcd8739ae039 = $5e16ee62ac64bb0b$var$useTheme;



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $bbzbN = parcelRequire("bbzbN");
const $ef654b446fc390d6$var$_excluded = [
    "value"
];
const $ef654b446fc390d6$var$RtlContext = /*#__PURE__*/ $7fPBF.createContext();
function $ef654b446fc390d6$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $cFLic.default)(_ref, $ef654b446fc390d6$var$_excluded);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($ef654b446fc390d6$var$RtlContext.Provider, (0, $kY3Ke.default)({
        value: value != null ? value : true
    }, props));
}
const $ef654b446fc390d6$export$b2dd014b6c321cb = ()=>{
    const value = $7fPBF.useContext($ef654b446fc390d6$var$RtlContext);
    return value != null ? value : false;
};
var $ef654b446fc390d6$export$2e2bcd8739ae039 = $ef654b446fc390d6$var$RtlProvider;



var $7fPBF = parcelRequire("7fPBF");


var $kY3Ke = parcelRequire("kY3Ke");
function $bdfe01df7c24351f$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $kY3Ke.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $kY3Ke.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $kY3Ke.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $bdfe01df7c24351f$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $5431f86afe49fae8$var$PropsContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
function $5431f86afe49fae8$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)($5431f86afe49fae8$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $5431f86afe49fae8$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $bdfe01df7c24351f$export$2e2bcd8739ae039)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $bdfe01df7c24351f$export$2e2bcd8739ae039)(config, props);
    return props;
}
function $5431f86afe49fae8$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $7fPBF.useContext($5431f86afe49fae8$var$PropsContext);
    return $5431f86afe49fae8$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $5431f86afe49fae8$export$2e2bcd8739ae039 = $5431f86afe49fae8$var$DefaultPropsProvider;


parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $fd3794ae41ea97a8$var$useEnhancedEffect = typeof window !== 'undefined' ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $fd3794ae41ea97a8$export$2e2bcd8739ae039 = $fd3794ae41ea97a8$var$useEnhancedEffect;



var $7fPBF = parcelRequire("7fPBF");
'use client';
let $46f5b561912058f9$var$globalId = 0;
function $46f5b561912058f9$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $7fPBF.useState(idOverride);
    const id = idOverride || defaultId;
    $7fPBF.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $46f5b561912058f9$var$globalId += 1;
            setDefaultId(`mui-${$46f5b561912058f9$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $46f5b561912058f9$var$maybeReactUseId = $7fPBF['useId'.toString()];
function $46f5b561912058f9$export$2e2bcd8739ae039(idOverride) {
    if ($46f5b561912058f9$var$maybeReactUseId !== undefined) {
        const reactId = $46f5b561912058f9$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $46f5b561912058f9$var$useGlobalId(idOverride);
}


parcelRequire("7fPBF");


var $5tMhb = parcelRequire("5tMhb");
var $5VCcJ = parcelRequire("5VCcJ");

var $2G6xE = parcelRequire("2G6xE");

'use client';
const $328672c8d07e1c59$export$35e57303dbd8a66 = (0, $2G6xE.default)();
function $328672c8d07e1c59$var$useTheme(defaultTheme = $328672c8d07e1c59$export$35e57303dbd8a66) {
    return (0, $5e16ee62ac64bb0b$export$2e2bcd8739ae039)(defaultTheme);
}
var $328672c8d07e1c59$export$2e2bcd8739ae039 = $328672c8d07e1c59$var$useTheme;



var $bbzbN = parcelRequire("bbzbN");
'use client';
function $ee13700d4d997375$var$wrapGlobalLayer(styles) {
    const serialized = (0, $5VCcJ.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $ee13700d4d997375$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $328672c8d07e1c59$export$2e2bcd8739ae039)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $ee13700d4d997375$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $ee13700d4d997375$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $ee13700d4d997375$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5tMhb.default), {
        styles: globalStyles
    });
}
var $ee13700d4d997375$export$2e2bcd8739ae039 = $ee13700d4d997375$var$GlobalStyles;




var $bbzbN = parcelRequire("bbzbN");
'use client';
function $eab94dcf3e175f98$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $5e16ee62ac64bb0b$export$2e2bcd8739ae039)();
    const id = (0, $46f5b561912058f9$export$2e2bcd8739ae039)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            var _firstChild$hasAttrib;
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && (_firstChild$hasAttrib = firstChild.hasAttribute) != null && _firstChild$hasAttrib.call(firstChild, 'data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else {
            var _head$querySelector;
            (_head$querySelector = head.querySelector(`style[data-mui-layer-order="${id}"]`)) == null || _head$querySelector.remove();
        }
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ee13700d4d997375$export$2e2bcd8739ae039), {
        styles: layerOrder
    });
}



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $cac97cfcc46fa531$var$EMPTY_THEME = {};
function $cac97cfcc46fa531$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $7fPBF.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $kY3Ke.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $kY3Ke.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $kY3Ke.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $cac97cfcc46fa531$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $5e16ee62ac64bb0b$export$2e2bcd8739ae039)($cac97cfcc46fa531$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $b5dba0f0f3e50f8f$export$2e2bcd8739ae039)() || $cac97cfcc46fa531$var$EMPTY_THEME;
    const engineTheme = $cac97cfcc46fa531$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $cac97cfcc46fa531$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    const layerOrder = (0, $eab94dcf3e175f98$export$2e2bcd8739ae039)(engineTheme);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f311b16c4b43b6fd$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6te04.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ef654b446fc390d6$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $5431f86afe49fae8$export$2e2bcd8739ae039), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $cac97cfcc46fa531$export$2e2bcd8739ae039 = $cac97cfcc46fa531$var$ThemeProvider;


var $e35ef6915a224202$export$2e2bcd8739ae039 = '$$material';



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $b8226d5132dedede$var$_excluded = [
    "theme"
];
function $b8226d5132dedede$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $cFLic.default)(_ref, $b8226d5132dedede$var$_excluded);
    const scopedTheme = themeInput[0, $e35ef6915a224202$export$2e2bcd8739ae039];
    let finalTheme = scopedTheme || themeInput;
    if (typeof themeInput !== 'function') {
        if (scopedTheme && !scopedTheme.vars) finalTheme = (0, $kY3Ke.default)({}, scopedTheme, {
            vars: null
        });
        else if (themeInput && !themeInput.vars) finalTheme = (0, $kY3Ke.default)({}, themeInput, {
            vars: null
        });
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cac97cfcc46fa531$export$2e2bcd8739ae039), (0, $kY3Ke.default)({}, props, {
        themeId: scopedTheme ? (0, $e35ef6915a224202$export$2e2bcd8739ae039) : undefined,
        theme: finalTheme
    }));
}



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
/**
 * React Router DOM v6.30.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");

/**
 * @remix-run/router v1.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $55100129ab36ed65$var$_extends() {
    $55100129ab36ed65$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $55100129ab36ed65$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $55100129ab36ed65$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($55100129ab36ed65$export$e19cd5f9376f8cee || ($55100129ab36ed65$export$e19cd5f9376f8cee = {}));
const $55100129ab36ed65$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $55100129ab36ed65$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $55100129ab36ed65$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $55100129ab36ed65$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $55100129ab36ed65$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $55100129ab36ed65$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $55100129ab36ed65$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $55100129ab36ed65$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $55100129ab36ed65$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $55100129ab36ed65$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $55100129ab36ed65$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $55100129ab36ed65$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $55100129ab36ed65$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $55100129ab36ed65$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $55100129ab36ed65$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $55100129ab36ed65$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($55100129ab36ed65$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $55100129ab36ed65$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $55100129ab36ed65$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($55100129ab36ed65$var$ResultType || ($55100129ab36ed65$var$ResultType = {}));
const $55100129ab36ed65$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $55100129ab36ed65$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $55100129ab36ed65$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $55100129ab36ed65$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($55100129ab36ed65$var$isIndexRoute(route)) {
            let indexRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $55100129ab36ed65$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $55100129ab36ed65$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $55100129ab36ed65$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $55100129ab36ed65$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $55100129ab36ed65$var$flattenRoutes(routes);
    $55100129ab36ed65$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $55100129ab36ed65$export$30d21fd6d7295f52(pathname);
        matches = $55100129ab36ed65$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $55100129ab36ed65$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $55100129ab36ed65$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $55100129ab36ed65$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $55100129ab36ed65$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $55100129ab36ed65$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $55100129ab36ed65$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $55100129ab36ed65$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $55100129ab36ed65$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $55100129ab36ed65$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $55100129ab36ed65$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $55100129ab36ed65$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $55100129ab36ed65$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $55100129ab36ed65$var$paramRe = /^:[\w-]+$/;
const $55100129ab36ed65$var$dynamicSegmentValue = 3;
const $55100129ab36ed65$var$indexRouteValue = 2;
const $55100129ab36ed65$var$emptySegmentValue = 1;
const $55100129ab36ed65$var$staticSegmentValue = 10;
const $55100129ab36ed65$var$splatPenalty = -2;
const $55100129ab36ed65$var$isSplat = (s)=>s === "*";
function $55100129ab36ed65$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($55100129ab36ed65$var$isSplat)) initialScore += $55100129ab36ed65$var$splatPenalty;
    if (index) initialScore += $55100129ab36ed65$var$indexRouteValue;
    return segments.filter((s)=>!$55100129ab36ed65$var$isSplat(s)).reduce((score, segment)=>score + ($55100129ab36ed65$var$paramRe.test(segment) ? $55100129ab36ed65$var$dynamicSegmentValue : segment === "" ? $55100129ab36ed65$var$emptySegmentValue : $55100129ab36ed65$var$staticSegmentValue), initialScore);
}
function $55100129ab36ed65$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $55100129ab36ed65$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $55100129ab36ed65$export$a5c6d149b50c1d86($55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $55100129ab36ed65$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $55100129ab36ed65$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $55100129ab36ed65$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $55100129ab36ed65$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $55100129ab36ed65$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $55100129ab36ed65$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $55100129ab36ed65$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $55100129ab36ed65$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $55100129ab36ed65$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $55100129ab36ed65$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $55100129ab36ed65$var$isAbsoluteUrl = (url)=>$55100129ab36ed65$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($55100129ab36ed65$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $55100129ab36ed65$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $55100129ab36ed65$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $55100129ab36ed65$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $55100129ab36ed65$var$normalizeSearch(search),
        hash: $55100129ab36ed65$var$normalizeHash(hash)
    };
}
function $55100129ab36ed65$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $55100129ab36ed65$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $55100129ab36ed65$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $55100129ab36ed65$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $55100129ab36ed65$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $55100129ab36ed65$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $55100129ab36ed65$export$8ccf933b0513f8d0(toArg);
    else {
        to = $55100129ab36ed65$var$_extends({}, toArg);
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $55100129ab36ed65$var$getInvalidPathError("?", "pathname", "search", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "pathname", "hash", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $55100129ab36ed65$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $55100129ab36ed65$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $55100129ab36ed65$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $55100129ab36ed65$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $55100129ab36ed65$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $55100129ab36ed65$export$4051a07651545597(data, init) {
    return new $55100129ab36ed65$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $55100129ab36ed65$export$42a99a7a4bc0e76a extends Error {
}
class $55100129ab36ed65$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $55100129ab36ed65$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $55100129ab36ed65$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $55100129ab36ed65$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $55100129ab36ed65$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $55100129ab36ed65$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $55100129ab36ed65$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $55100129ab36ed65$var$unwrapTrackedPromise(value) {
    if (!$55100129ab36ed65$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $55100129ab36ed65$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $55100129ab36ed65$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $55100129ab36ed65$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $55100129ab36ed65$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $55100129ab36ed65$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $55100129ab36ed65$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $55100129ab36ed65$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $55100129ab36ed65$var$validMutationMethods = new Set($55100129ab36ed65$var$validMutationMethodsArr);
const $55100129ab36ed65$var$validRequestMethodsArr = [
    "get",
    ...$55100129ab36ed65$var$validMutationMethodsArr
];
const $55100129ab36ed65$var$validRequestMethods = new Set($55100129ab36ed65$var$validRequestMethodsArr);
const $55100129ab36ed65$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $55100129ab36ed65$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $55100129ab36ed65$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $55100129ab36ed65$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $55100129ab36ed65$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $55100129ab36ed65$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $55100129ab36ed65$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $55100129ab36ed65$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$55100129ab36ed65$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$55100129ab36ed65$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $55100129ab36ed65$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $55100129ab36ed65$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$55100129ab36ed65$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($55100129ab36ed65$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $55100129ab36ed65$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $55100129ab36ed65$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $55100129ab36ed65$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($55100129ab36ed65$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $55100129ab36ed65$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $55100129ab36ed65$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $55100129ab36ed65$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $55100129ab36ed65$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $55100129ab36ed65$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $55100129ab36ed65$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $55100129ab36ed65$var$findNearestBoundary(matches).route.id,
            {
                type: $55100129ab36ed65$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($55100129ab36ed65$var$isErrorResult(result) && $55100129ab36ed65$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $55100129ab36ed65$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $55100129ab36ed65$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $55100129ab36ed65$var$_extends({
            matches: updatedMatches || matches
        }, $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $55100129ab36ed65$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $55100129ab36ed65$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $55100129ab36ed65$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $55100129ab36ed65$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $55100129ab36ed65$var$ResultType.error,
            error: $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $55100129ab36ed65$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isDeferredResult(result)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $55100129ab36ed65$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $55100129ab36ed65$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($55100129ab36ed65$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $55100129ab36ed65$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $55100129ab36ed65$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $55100129ab36ed65$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $55100129ab36ed65$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $55100129ab36ed65$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $55100129ab36ed65$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$55100129ab36ed65$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $55100129ab36ed65$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $55100129ab36ed65$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($55100129ab36ed65$var$isRedirectResult(actionResult) || $55100129ab36ed65$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($55100129ab36ed65$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $55100129ab36ed65$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($55100129ab36ed65$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($55100129ab36ed65$var$isDeferredResult(actionResult)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $55100129ab36ed65$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $55100129ab36ed65$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $55100129ab36ed65$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $55100129ab36ed65$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $55100129ab36ed65$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $55100129ab36ed65$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $55100129ab36ed65$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $55100129ab36ed65$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $55100129ab36ed65$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($55100129ab36ed65$var$isDeferredResult(result)) result = await $55100129ab36ed65$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $55100129ab36ed65$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $55100129ab36ed65$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $55100129ab36ed65$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $55100129ab36ed65$export$e19cd5f9376f8cee.Replace : $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $55100129ab36ed65$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($55100129ab36ed65$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $55100129ab36ed65$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $55100129ab36ed65$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $55100129ab36ed65$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $55100129ab36ed65$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($55100129ab36ed65$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $55100129ab36ed65$var$ResultType.redirect,
                response: $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $55100129ab36ed65$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $55100129ab36ed65$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: $55100129ab36ed65$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $55100129ab36ed65$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $55100129ab36ed65$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $55100129ab36ed65$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $55100129ab36ed65$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $55100129ab36ed65$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $55100129ab36ed65$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$55100129ab36ed65$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $55100129ab36ed65$export$4d0306f8f6a4585b = Symbol("deferred");
function $55100129ab36ed65$export$3336b097a6fbc59a(routes, opts) {
    $55100129ab36ed65$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD") {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $55100129ab36ed65$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $55100129ab36ed65$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $55100129ab36ed65$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$55100129ab36ed65$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $55100129ab36ed65$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($55100129ab36ed65$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $55100129ab36ed65$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $55100129ab36ed65$var$isResponse(result) ? result : $55100129ab36ed65$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($55100129ab36ed65$var$isDataStrategyResult(e) && $55100129ab36ed65$var$isResponse(e.result)) {
                if (e.type === $55100129ab36ed65$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($55100129ab36ed65$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            let error = $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($55100129ab36ed65$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $55100129ab36ed65$var$_extends({}, context, {
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $55100129ab36ed65$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $55100129ab36ed65$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $55100129ab36ed65$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $55100129ab36ed65$var$callDataStrategyImpl(dataStrategy || $55100129ab36ed65$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($55100129ab36ed65$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($55100129ab36ed65$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $55100129ab36ed65$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $55100129ab36ed65$export$fec11da027c70692(routes, context, error) {
    let newContext = $55100129ab36ed65$var$_extends({}, context, {
        statusCode: $55100129ab36ed65$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $55100129ab36ed65$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $55100129ab36ed65$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $55100129ab36ed65$export$cae722b0cc860f13(to ? to : ".", $55100129ab36ed65$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $55100129ab36ed65$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $55100129ab36ed65$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $55100129ab36ed65$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $55100129ab36ed65$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$55100129ab36ed65$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$55100129ab36ed65$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $55100129ab36ed65$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $55100129ab36ed65$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $55100129ab36ed65$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($55100129ab36ed65$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $55100129ab36ed65$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $55100129ab36ed65$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $55100129ab36ed65$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $55100129ab36ed65$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $55100129ab36ed65$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($55100129ab36ed65$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $55100129ab36ed65$var$shouldRevalidateLoader(match, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $55100129ab36ed65$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $55100129ab36ed65$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $55100129ab36ed65$var$shouldRevalidateLoader(fetcherMatch, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $55100129ab36ed65$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $55100129ab36ed65$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $55100129ab36ed65$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $55100129ab36ed65$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$55100129ab36ed65$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $55100129ab36ed65$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$55100129ab36ed65$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $55100129ab36ed65$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $55100129ab36ed65$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $55100129ab36ed65$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$55100129ab36ed65$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $55100129ab36ed65$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $55100129ab36ed65$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $55100129ab36ed65$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $55100129ab36ed65$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $55100129ab36ed65$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $55100129ab36ed65$var$ResultType.data,
                result: undefined
            });
        };
        return $55100129ab36ed65$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $55100129ab36ed65$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $55100129ab36ed65$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $55100129ab36ed65$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $55100129ab36ed65$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $55100129ab36ed65$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($55100129ab36ed65$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $55100129ab36ed65$var$ResultType.error,
                error: e
            };
        }
        if (type === $55100129ab36ed65$var$ResultType.error) return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: new $55100129ab36ed65$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $55100129ab36ed65$var$ResultType.error) {
        if ($55100129ab36ed65$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $55100129ab36ed65$var$ResultType.error,
                error: new $55100129ab36ed65$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: result,
            statusCode: $55100129ab36ed65$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($55100129ab36ed65$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $55100129ab36ed65$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($55100129ab36ed65$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $55100129ab36ed65$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $55100129ab36ed65$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $55100129ab36ed65$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $55100129ab36ed65$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($55100129ab36ed65$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $55100129ab36ed65$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $55100129ab36ed65$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($55100129ab36ed65$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $55100129ab36ed65$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $55100129ab36ed65$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($55100129ab36ed65$var$isErrorResult(result)) {
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $55100129ab36ed65$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($55100129ab36ed65$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($55100129ab36ed65$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $55100129ab36ed65$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $55100129ab36ed65$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $55100129ab36ed65$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $55100129ab36ed65$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $55100129ab36ed65$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $55100129ab36ed65$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $55100129ab36ed65$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($55100129ab36ed65$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $55100129ab36ed65$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(path) : path;
    return $55100129ab36ed65$export$fe53371bee54353d($55100129ab36ed65$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $55100129ab36ed65$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $55100129ab36ed65$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $55100129ab36ed65$var$ResultType.data || result.type === $55100129ab36ed65$var$ResultType.error);
}
function $55100129ab36ed65$var$isRedirectDataStrategyResultResult(result) {
    return $55100129ab36ed65$var$isResponse(result.result) && $55100129ab36ed65$var$redirectStatusCodes.has(result.result.status);
}
function $55100129ab36ed65$var$isDeferredResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.deferred;
}
function $55100129ab36ed65$var$isErrorResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.error;
}
function $55100129ab36ed65$var$isRedirectResult(result) {
    return (result && result.type) === $55100129ab36ed65$var$ResultType.redirect;
}
function $55100129ab36ed65$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $55100129ab36ed65$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $55100129ab36ed65$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $55100129ab36ed65$var$isRedirectResponse(result) {
    if (!$55100129ab36ed65$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $55100129ab36ed65$var$isValidMethod(method) {
    return $55100129ab36ed65$var$validRequestMethods.has(method.toLowerCase());
}
function $55100129ab36ed65$var$isMutationMethod(method) {
    return $55100129ab36ed65$var$validMutationMethods.has(method.toLowerCase());
}
async function $55100129ab36ed65$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($55100129ab36ed65$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $55100129ab36ed65$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $55100129ab36ed65$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $55100129ab36ed65$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $55100129ab36ed65$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $55100129ab36ed65$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $55100129ab36ed65$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $55100129ab36ed65$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $55100129ab36ed65$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $55100129ab36ed65$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $55100129ab36ed65$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $55100129ab36ed65$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $55100129ab36ed65$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $55100129ab36ed65$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $55100129ab36ed65$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $55100129ab36ed65$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $55100129ab36ed65$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $55100129ab36ed65$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");

function $d9fd026bfea79ab9$var$_extends() {
    $d9fd026bfea79ab9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9fd026bfea79ab9$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $d9fd026bfea79ab9$export$3add0d5dce533e2e = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$145dfa71566a64dc = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$var$AwaitContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $d9fd026bfea79ab9$export$26749e8557646306 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$c7914228fb69b0f5 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$9072aa6dd1f93057 = /*#__PURE__*/ $7fPBF.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $d9fd026bfea79ab9$var$RouteErrorContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $d9fd026bfea79ab9$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $d9fd026bfea79ab9$export$9c954a9d03d32f4a() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $d9fd026bfea79ab9$export$45d76561a5302f2b() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $d9fd026bfea79ab9$export$1b3f31771c5d07c() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $d9fd026bfea79ab9$export$6c330e8992e8a295(pattern) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$81336c211d5ff295)(pattern, (0, $55100129ab36ed65$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $d9fd026bfea79ab9$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $7fPBF.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $d9fd026bfea79ab9$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $d9fd026bfea79ab9$var$useNavigateStable() : $d9fd026bfea79ab9$var$useNavigateUnstable();
}
function $d9fd026bfea79ab9$var$useNavigateUnstable() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$OutletContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $d9fd026bfea79ab9$export$4138103a3ae699cc() {
    return $7fPBF.useContext($d9fd026bfea79ab9$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $d9fd026bfea79ab9$export$a3be3530d8e40d0b(context) {
    let outlet = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $d9fd026bfea79ab9$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $d9fd026bfea79ab9$export$5d3fca4a98652595(routes, locationArg) {
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: parentMatches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $55100129ab36ed65$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $d9fd026bfea79ab9$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $d9fd026bfea79ab9$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $d9fd026bfea79ab9$var$DefaultErrorComponent() {
    let error = $d9fd026bfea79ab9$export$ed527bf60f6e05f2();
    let message = (0, $55100129ab36ed65$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $7fPBF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $7fPBF.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $d9fd026bfea79ab9$var$defaultErrorElement = /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DefaultErrorComponent, null);
class $d9fd026bfea79ab9$var$RenderErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $d9fd026bfea79ab9$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $d9fd026bfea79ab9$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $d9fd026bfea79ab9$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $d9fd026bfea79ab9$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $7fPBF.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $d9fd026bfea79ab9$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($d9fd026bfea79ab9$var$DataRouterHook || {});
var $d9fd026bfea79ab9$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($d9fd026bfea79ab9$var$DataRouterStateHook || {});
function $d9fd026bfea79ab9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $d9fd026bfea79ab9$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $d9fd026bfea79ab9$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext($d9fd026bfea79ab9$export$145dfa71566a64dc);
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
function $d9fd026bfea79ab9$var$useRouteContext(hookName) {
    let route = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $d9fd026bfea79ab9$var$useCurrentRouteId(hookName) {
    let route = $d9fd026bfea79ab9$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $d9fd026bfea79ab9$export$5fc8298006ad9e58() {
    return $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $d9fd026bfea79ab9$export$d0fd4b7106de2769() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $d9fd026bfea79ab9$export$600dc272ed516c15() {
    let dataRouterContext = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseRevalidator);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRevalidator);
    return $7fPBF.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $d9fd026bfea79ab9$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseMatches);
    return $7fPBF.useMemo(()=>matches.map((m)=>(0, $55100129ab36ed65$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $d9fd026bfea79ab9$export$1448a5050d252c4d() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $d9fd026bfea79ab9$export$fd5d37484eab868d(routeId) {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $d9fd026bfea79ab9$export$fdc00f3f26066d5e() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseActionData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $d9fd026bfea79ab9$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $7fPBF.useContext($d9fd026bfea79ab9$var$RouteErrorContext);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$78a72ddb39bdd145() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$17f53340677d5831() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $d9fd026bfea79ab9$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $d9fd026bfea79ab9$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseBlocker);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $7fPBF.useState("");
    let blockerFunction = $7fPBF.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $d9fd026bfea79ab9$var$_extends({}, currentLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $d9fd026bfea79ab9$var$_extends({}, nextLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $7fPBF.useEffect(()=>{
        let key = String(++$d9fd026bfea79ab9$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $7fPBF.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $55100129ab36ed65$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $d9fd026bfea79ab9$var$useNavigateStable() {
    let { router: router } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseNavigateStable);
    let id = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $d9fd026bfea79ab9$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$alreadyWarned$1 = {};
function $d9fd026bfea79ab9$var$warningOnce(key, cond, message) {
    if (!cond && !$d9fd026bfea79ab9$var$alreadyWarned$1[key]) $d9fd026bfea79ab9$var$alreadyWarned$1[key] = true;
}
const $d9fd026bfea79ab9$var$alreadyWarned = {};
function $d9fd026bfea79ab9$var$warnOnce(key, message) {}
const $d9fd026bfea79ab9$var$logDeprecation = (flag, msg, link)=>$d9fd026bfea79ab9$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $d9fd026bfea79ab9$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $d9fd026bfea79ab9$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d9fd026bfea79ab9$var$START_TRANSITION = "startTransition";
const $d9fd026bfea79ab9$var$startTransitionImpl = $7fPBF[$d9fd026bfea79ab9$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d9fd026bfea79ab9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        if (v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl) $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7fPBF.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $7fPBF.useEffect(()=>$d9fd026bfea79ab9$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $d9fd026bfea79ab9$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $d9fd026bfea79ab9$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl ? $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>$d9fd026bfea79ab9$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $d9fd026bfea79ab9$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let navigate = $d9fd026bfea79ab9$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, (0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7fPBF.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $d9fd026bfea79ab9$export$910ae8079b2c2852(props) {
    return $d9fd026bfea79ab9$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $d9fd026bfea79ab9$export$e7b0ac011bb776c6(_props) {
    (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $d9fd026bfea79ab9$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7fPBF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $d9fd026bfea79ab9$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $7fPBF.useMemo(()=>{
        let trailingPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $d9fd026bfea79ab9$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $d9fd026bfea79ab9$export$5d3fca4a98652595($d9fd026bfea79ab9$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $d9fd026bfea79ab9$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$ResolveAwait, null, children));
}
var $d9fd026bfea79ab9$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($d9fd026bfea79ab9$var$AwaitRenderStatus || {});
const $d9fd026bfea79ab9$var$neverSettledPromise = new Promise(()=>{});
class $d9fd026bfea79ab9$var$AwaitErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $d9fd026bfea79ab9$var$AwaitRenderStatus.error : "_data" in promise ? $d9fd026bfea79ab9$var$AwaitRenderStatus.success : $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && promise._error instanceof (0, $55100129ab36ed65$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $d9fd026bfea79ab9$var$neverSettledPromise;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $d9fd026bfea79ab9$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $d9fd026bfea79ab9$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $d9fd026bfea79ab9$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $7fPBF.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7fPBF.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $d9fd026bfea79ab9$export$e7b0ac011bb776c6) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $d9fd026bfea79ab9$export$daf73786167a7f72(matches) {
    return $d9fd026bfea79ab9$var$_renderMatches(matches);
}
function $d9fd026bfea79ab9$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $7fPBF.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $7fPBF.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $7fPBF.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $d9fd026bfea79ab9$export$f30f7e456d254e83(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d9fd026bfea79ab9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $d9fd026bfea79ab9$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $a0cf24fd73ae067c$var$_extends() {
    $a0cf24fd73ae067c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a0cf24fd73ae067c$var$_extends.apply(this, arguments);
}
function $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a0cf24fd73ae067c$var$defaultMethod = "get";
const $a0cf24fd73ae067c$var$defaultEncType = "application/x-www-form-urlencoded";
function $a0cf24fd73ae067c$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $a0cf24fd73ae067c$var$isButtonElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $a0cf24fd73ae067c$var$isFormElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $a0cf24fd73ae067c$var$isInputElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $a0cf24fd73ae067c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$a0cf24fd73ae067c$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $a0cf24fd73ae067c$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = null;
function $a0cf24fd73ae067c$var$isFormDataSubmitterSupported() {
    if ($a0cf24fd73ae067c$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = true;
    }
    return $a0cf24fd73ae067c$var$_formDataSupportsSubmitter;
}
const $a0cf24fd73ae067c$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $a0cf24fd73ae067c$var$getFormEncType(encType) {
    if (encType != null && !$a0cf24fd73ae067c$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($a0cf24fd73ae067c$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        formData = new FormData(target);
    } else if ($a0cf24fd73ae067c$var$isButtonElement(target) || $a0cf24fd73ae067c$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("formenctype")) || $a0cf24fd73ae067c$var$getFormEncType(form.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$a0cf24fd73ae067c$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($a0cf24fd73ae067c$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $a0cf24fd73ae067c$var$defaultMethod;
        action = null;
        encType = $a0cf24fd73ae067c$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $a0cf24fd73ae067c$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $a0cf24fd73ae067c$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $a0cf24fd73ae067c$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $a0cf24fd73ae067c$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $a0cf24fd73ae067c$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $a0cf24fd73ae067c$export$1f3f55432a00e06d(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $a0cf24fd73ae067c$var$_extends({}, state, {
        errors: $a0cf24fd73ae067c$var$deserializeErrors(state.errors)
    });
    return state;
}
function $a0cf24fd73ae067c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $55100129ab36ed65$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $a0cf24fd73ae067c$export$7ad602f0e94e62d1 = /*#__PURE__*/ $7fPBF.createContext({
    isTransitioning: false
});
const $a0cf24fd73ae067c$export$148fd98d095596d4 = /*#__PURE__*/ $7fPBF.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a0cf24fd73ae067c$var$START_TRANSITION = "startTransition";
const $a0cf24fd73ae067c$var$startTransitionImpl = $7fPBF[$a0cf24fd73ae067c$var$START_TRANSITION];
const $a0cf24fd73ae067c$var$FLUSH_SYNC = "flushSync";
const $a0cf24fd73ae067c$var$flushSyncImpl = $b4ba1c853f6e1116$exports[$a0cf24fd73ae067c$var$FLUSH_SYNC];
const $a0cf24fd73ae067c$var$USE_ID = "useId";
const $a0cf24fd73ae067c$var$useIdImpl = $7fPBF[$a0cf24fd73ae067c$var$USE_ID];
function $a0cf24fd73ae067c$var$startTransitionSafe(cb) {
    if ($a0cf24fd73ae067c$var$startTransitionImpl) $a0cf24fd73ae067c$var$startTransitionImpl(cb);
    else cb();
}
function $a0cf24fd73ae067c$var$flushSyncSafe(cb) {
    if ($a0cf24fd73ae067c$var$flushSyncImpl) $a0cf24fd73ae067c$var$flushSyncImpl(cb);
    else cb();
}
class $a0cf24fd73ae067c$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $a0cf24fd73ae067c$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let [pendingState, setPendingState] = $7fPBF.useState();
    let [vtContext, setVtContext] = $7fPBF.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7fPBF.useState();
    let [transition, setTransition] = $7fPBF.useState();
    let [interruption, setInterruption] = $7fPBF.useState();
    let fetcherData = $7fPBF.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $7fPBF.useCallback((cb)=>{
        if (v7_startTransition) $a0cf24fd73ae067c$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $7fPBF.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $a0cf24fd73ae067c$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $a0cf24fd73ae067c$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $a0cf24fd73ae067c$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $a0cf24fd73ae067c$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $a0cf24fd73ae067c$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $7fPBF.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $a0cf24fd73ae067c$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $7fPBF.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $7fPBF.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $7fPBF.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $a0cf24fd73ae067c$var$MemoizedDataRoutes = /*#__PURE__*/ $7fPBF.memo($a0cf24fd73ae067c$var$DataRoutes);
function $a0cf24fd73ae067c$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $d9fd026bfea79ab9$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $a0cf24fd73ae067c$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $a0cf24fd73ae067c$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $a0cf24fd73ae067c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $a0cf24fd73ae067c$export$a6c7ac8248d6e38a = /*#__PURE__*/ $7fPBF.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref7, $a0cf24fd73ae067c$var$_excluded);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($a0cf24fd73ae067c$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $d9fd026bfea79ab9$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $a0cf24fd73ae067c$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $7fPBF.createElement("a", $a0cf24fd73ae067c$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $a0cf24fd73ae067c$export$b0d92dbee9b5b60d = /*#__PURE__*/ $7fPBF.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref8, $a0cf24fd73ae067c$var$_excluded2);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let routerState = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $a0cf24fd73ae067c$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a6c7ac8248d6e38a, $a0cf24fd73ae067c$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $a0cf24fd73ae067c$export$a7fed597f4b8afd8 = /*#__PURE__*/ $7fPBF.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $a0cf24fd73ae067c$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref9, $a0cf24fd73ae067c$var$_excluded3);
    let submit = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let formAction = $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $7fPBF.createElement("form", $a0cf24fd73ae067c$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $a0cf24fd73ae067c$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $a0cf24fd73ae067c$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $a0cf24fd73ae067c$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($a0cf24fd73ae067c$var$DataRouterHook || ($a0cf24fd73ae067c$var$DataRouterHook = {}));
var $a0cf24fd73ae067c$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($a0cf24fd73ae067c$var$DataRouterStateHook || ($a0cf24fd73ae067c$var$DataRouterStateHook = {}));
// Internal hooks
function $a0cf24fd73ae067c$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $a0cf24fd73ae067c$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e));
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $a0cf24fd73ae067c$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $a0cf24fd73ae067c$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $7fPBF.useCallback((event)=>{
        if ($a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $55100129ab36ed65$export$fe53371bee54353d)(location) === (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $a0cf24fd73ae067c$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $7fPBF.useRef($a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7fPBF.useRef(false);
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let searchParams = $7fPBF.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $a0cf24fd73ae067c$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let setSearchParams = $7fPBF.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $a0cf24fd73ae067c$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $a0cf24fd73ae067c$var$fetcherId = 0;
let $a0cf24fd73ae067c$var$getUniqueFetcherId = ()=>"__" + String(++$a0cf24fd73ae067c$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $a0cf24fd73ae067c$export$47c85c6e3a081d3() {
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let currentRouteId = (0, $d9fd026bfea79ab9$export$5fc8298006ad9e58)();
    return $7fPBF.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $a0cf24fd73ae067c$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $a0cf24fd73ae067c$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let routeContext = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    !routeContext && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $a0cf24fd73ae067c$var$_extends({}, (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $a0cf24fd73ae067c$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseFetcher);
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $7fPBF.useContext($a0cf24fd73ae067c$export$148fd98d095596d4);
    let route = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $a0cf24fd73ae067c$var$useIdImpl ? $a0cf24fd73ae067c$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $7fPBF.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($a0cf24fd73ae067c$var$getUniqueFetcherId());
    // Registration/cleanup
    $7fPBF.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $7fPBF.useCallback((href, opts)=>{
        !routeId && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let submit = $7fPBF.useCallback((target, opts)=>{
        submitImpl(target, $a0cf24fd73ae067c$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $7fPBF.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a7fed597f4b8afd8, $a0cf24fd73ae067c$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $55100129ab36ed65$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7fPBF.useMemo(()=>$a0cf24fd73ae067c$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $a0cf24fd73ae067c$export$fa996778a3a31087() {
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $a0cf24fd73ae067c$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $a0cf24fd73ae067c$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $a0cf24fd73ae067c$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let matches = (0, $d9fd026bfea79ab9$export$2378eb7f5ff86053)();
    let navigation = (0, $d9fd026bfea79ab9$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $7fPBF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $a0cf24fd73ae067c$var$usePageHide($7fPBF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $a0cf24fd73ae067c$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($a0cf24fd73ae067c$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $a0cf24fd73ae067c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($a0cf24fd73ae067c$var$_extends({}, location, {
                    pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($a0cf24fd73ae067c$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $a0cf24fd73ae067c$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $d9fd026bfea79ab9$export$b273b3273281a049)(when);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $a0cf24fd73ae067c$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $7fPBF.useContext($a0cf24fd73ae067c$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.useViewTransitionState);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


function $919ebf39980bf8f3$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $6e5b65c9cbae0db9$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $919ebf39980bf8f3$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $1c481e73824c6361$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c481e73824c6361$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $1c481e73824c6361$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}


// TYPES
// UTILS


const $642b8e2027a4e792$export$6acf61af03e62db = typeof window === 'undefined' || 'Deno' in window;
function $642b8e2027a4e792$export$8793edee2d425525() {
    return undefined;
}
function $642b8e2027a4e792$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === 'function' ? updater(input) : updater;
}
function $642b8e2027a4e792$export$e539f754e934e270(value) {
    return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function $642b8e2027a4e792$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $642b8e2027a4e792$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $642b8e2027a4e792$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $642b8e2027a4e792$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$642b8e2027a4e792$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === 'function') return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg3), {
        queryKey: arg1,
        queryFn: arg2
    });
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg2), {
        queryKey: arg1
    });
}
function $642b8e2027a4e792$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($642b8e2027a4e792$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === 'function') return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg3), {
            mutationKey: arg1,
            mutationFn: arg2
        });
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg2), {
            mutationKey: arg1
        });
    }
    if (typeof arg1 === 'function') return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg2), {
        mutationFn: arg1
    });
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg1);
}
function $642b8e2027a4e792$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $642b8e2027a4e792$export$aaae5295ec3351c9(arg1) ? [
        (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg2), {
            queryKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $642b8e2027a4e792$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $642b8e2027a4e792$export$aaae5295ec3351c9(arg1) ? [
        (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg2), {
            mutationKey: arg1
        }),
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $642b8e2027a4e792$export$c5d1efe363797780(filters, query) {
    const { type: type = 'all', exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($642b8e2027a4e792$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $642b8e2027a4e792$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$642b8e2027a4e792$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== 'all') {
        const isActive = query.isActive();
        if (type === 'active' && !isActive) return false;
        if (type === 'inactive' && isActive) return false;
    }
    if (typeof stale === 'boolean' && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== 'undefined' && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $642b8e2027a4e792$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($642b8e2027a4e792$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($642b8e2027a4e792$export$5fcb678681417b54(mutation.options.mutationKey) !== $642b8e2027a4e792$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$642b8e2027a4e792$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $642b8e2027a4e792$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $642b8e2027a4e792$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $642b8e2027a4e792$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$642b8e2027a4e792$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $642b8e2027a4e792$export$2f07189bb9fa26a7(a, b) {
    return $642b8e2027a4e792$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $642b8e2027a4e792$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') return !Object.keys(b).some((key)=>!$642b8e2027a4e792$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $642b8e2027a4e792$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $642b8e2027a4e792$export$7a8558113332b71e(a) && $642b8e2027a4e792$export$7a8558113332b71e(b);
    if (array || $642b8e2027a4e792$export$53b83ca8eaab0383(a) && $642b8e2027a4e792$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $642b8e2027a4e792$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $642b8e2027a4e792$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $642b8e2027a4e792$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $642b8e2027a4e792$export$53b83ca8eaab0383(o) {
    if (!$642b8e2027a4e792$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === 'undefined') return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$642b8e2027a4e792$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty('isPrototypeOf')) return false;
     // Most likely a plain Object
    return true;
}
function $642b8e2027a4e792$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $642b8e2027a4e792$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $642b8e2027a4e792$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $642b8e2027a4e792$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $642b8e2027a4e792$export$4304cb76768ca134(callback) {
    $642b8e2027a4e792$export$e772c8ff12451969(0).then(callback);
}
function $642b8e2027a4e792$export$382ca5d13a8f252c() {
    if (typeof AbortController === 'function') return new AbortController();
    return;
}
function $642b8e2027a4e792$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === 'function') return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $642b8e2027a4e792$export$77a71fc411098696(prevData, data);
    return data;
}






const $79ea400dd6f52808$export$1cf3d545f2d4635c = console;



function $5e53ba1b50ae52c5$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $642b8e2027a4e792$export$4304cb76768ca134)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $642b8e2027a4e792$export$4304cb76768ca134)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $5e53ba1b50ae52c5$export$520687f44db6e1ab = $5e53ba1b50ae52c5$export$316a8efd03cd1458();


class $ab488a4425af0cf9$export$d26086b469ecdbcc {
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
}



class $cb6ef54b07ab16fd$export$86f1af424b2ca4de extends (0, $ab488a4425af0cf9$export$d26086b469ecdbcc) {
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === 'boolean') this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === 'boolean') return this.focused;
         // document global can be unavailable in react native
        if (typeof document === 'undefined') return true;
        return [
            undefined,
            'visible',
            'prerender'
        ].includes(document.visibilityState);
    }
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $642b8e2027a4e792$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener('visibilitychange', listener, false);
                window.addEventListener('focus', listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener('visibilitychange', listener);
                    window.removeEventListener('focus', listener);
                };
            }
            return;
        };
    }
}
const $cb6ef54b07ab16fd$export$6bf54661be5b02cf = new $cb6ef54b07ab16fd$export$86f1af424b2ca4de();




const $c86fc979a466dc83$var$onlineEvents = [
    'online',
    'offline'
];
class $c86fc979a466dc83$export$58774fb55d5ff7fc extends (0, $ab488a4425af0cf9$export$d26086b469ecdbcc) {
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === 'boolean') this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === 'boolean') return this.online;
        if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') return true;
        return navigator.onLine;
    }
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $642b8e2027a4e792$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $c86fc979a466dc83$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $c86fc979a466dc83$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
}
const $c86fc979a466dc83$export$b113e788b2dd3fdc = new $c86fc979a466dc83$export$58774fb55d5ff7fc();



function $9085da9576c6a399$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $9085da9576c6a399$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : 'online') === 'online' ? (0, $c86fc979a466dc83$export$b113e788b2dd3fdc).isOnline() : true;
}
class $9085da9576c6a399$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $9085da9576c6a399$export$986cc6445c1d323(value) {
    return value instanceof $9085da9576c6a399$export$a8430ed4188f35a9;
}
function $9085da9576c6a399$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $9085da9576c6a399$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $cb6ef54b07ab16fd$export$6bf54661be5b02cf).isFocused() || config.networkMode !== 'always' && !(0, $c86fc979a466dc83$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $9085da9576c6a399$var$defaultRetryDelay;
            const delay = typeof retryDelay === 'function' ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === 'number' && failureCount < retry || typeof retry === 'function' && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $642b8e2027a4e792$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($9085da9576c6a399$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}



class $418fa3be23ac979d$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $642b8e2027a4e792$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $642b8e2027a4e792$export$6acf61af03e62db) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}


// CLASS
class $d5c1d79539885b26$export$62297b13309008b2 extends (0, $418fa3be23ac979d$export$e09608847fcc8c59) {
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.defaultOptions, options);
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === 'idle') this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $642b8e2027a4e792$export$17619bac5b909b23)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: 'success',
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: 'setState',
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $642b8e2027a4e792$export$8793edee2d425525)).catch((0, $642b8e2027a4e792$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $642b8e2027a4e792$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: 'observerAdded',
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: 'observerRemoved',
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: 'invalidate'
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== 'idle') {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $642b8e2027a4e792$export$382ca5d13a8f252c)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, 'signal', {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: 'fetch',
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $9085da9576c6a399$export$986cc6445c1d323)(error) && error.silent)) this.dispatch({
                type: 'error',
                error: error
            });
            if (!(0, $9085da9576c6a399$export$986cc6445c1d323)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $9085da9576c6a399$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === 'undefined') {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: 'failed',
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: 'pause'
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: 'continue'
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case 'failed':
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    });
                case 'pause':
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        fetchStatus: 'paused'
                    });
                case 'continue':
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        fetchStatus: 'fetching'
                    });
                case 'fetch':
                    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $9085da9576c6a399$export$61b92f63f30245cf)(this.options.networkMode) ? 'fetching' : 'paused'
                    }), !state.dataUpdatedAt && {
                        error: null,
                        status: 'loading'
                    });
                case 'success':
                    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: 'success'
                    }), !action.manual && {
                        fetchStatus: 'idle',
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    });
                case 'error':
                    const error = action.error;
                    if ((0, $9085da9576c6a399$export$986cc6445c1d323)(error) && error.revert && this.revertState) return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.revertState), {
                        fetchStatus: 'idle'
                    });
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: 'idle',
                        status: 'error'
                    });
                case 'invalidate':
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        isInvalidated: true
                    });
                case 'setState':
                    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state, action.state);
            }
        };
        this.state = reducer(this.state);
        (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: 'updated',
                action: action
            });
        });
    }
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $79ea400dd6f52808$export$1cf3d545f2d4635c);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $d5c1d79539885b26$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
}
function $d5c1d79539885b26$var$getDefaultState(options) {
    const data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
    const hasData = typeof data !== 'undefined';
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? 'success' : 'loading',
        fetchStatus: 'idle'
    };
}




// CLASS
class $1aad915e15a0edb0$export$5dde0cd941da8468 extends (0, $ab488a4425af0cf9$export$d26086b469ecdbcc) {
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $642b8e2027a4e792$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $d5c1d79539885b26$export$62297b13309008b2)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: 'added',
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: 'removed',
                query: query
            });
        }
    }
    clear() {
        (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ find(arg1, arg2) {
        const [filters] = (0, $642b8e2027a4e792$export$18e8f4b987e6c111)(arg1, arg2);
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.queries.find((query)=>(0, $642b8e2027a4e792$export$c5d1efe363797780)(filters, query));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ findAll(arg1, arg2) {
        const [filters] = (0, $642b8e2027a4e792$export$18e8f4b987e6c111)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $642b8e2027a4e792$export$c5d1efe363797780)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
}









// CLASS
class $f5323f6286908bf7$export$17b8b19c814bcf56 extends (0, $418fa3be23ac979d$export$e09608847fcc8c59) {
    setOptions(options) {
        this.options = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.defaultOptions, options);
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: 'setState',
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: 'observerAdded',
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: 'observerRemoved',
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === 'loading') this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $9085da9576c6a399$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject('No mutationFn found');
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: 'failed',
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: 'pause'
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: 'continue'
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === 'loading';
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: 'loading',
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: 'loading',
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: 'success',
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: 'error',
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case 'failed':
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        failureCount: action.failureCount,
                        failureReason: action.error
                    });
                case 'pause':
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        isPaused: true
                    });
                case 'continue':
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        isPaused: false
                    });
                case 'loading':
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $9085da9576c6a399$export$61b92f63f30245cf)(this.options.networkMode),
                        status: 'loading',
                        variables: action.variables
                    });
                case 'success':
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: 'success',
                        isPaused: false
                    });
                case 'error':
                    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: 'error'
                    });
                case 'setState':
                    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state, action.state);
            }
        };
        this.state = reducer(this.state);
        (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: 'updated',
                action: action
            });
        });
    }
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $79ea400dd6f52808$export$1cf3d545f2d4635c);
        this.observers = [];
        this.state = config.state || $f5323f6286908bf7$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
}
function $f5323f6286908bf7$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: 'idle',
        variables: undefined
    };
}




// CLASS
class $ad5bddb7aff1eda0$export$1fcfd9a244434844 extends (0, $ab488a4425af0cf9$export$d26086b469ecdbcc) {
    build(client, options, state) {
        const mutation = new (0, $f5323f6286908bf7$export$17b8b19c814bcf56)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: 'added',
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: 'removed',
            mutation: mutation
        });
    }
    clear() {
        (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === 'undefined') filters.exact = true;
        return this.mutations.find((mutation)=>(0, $642b8e2027a4e792$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $642b8e2027a4e792$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $642b8e2027a4e792$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
}





function $ea16c3953685060f$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, 'signal', {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener('abort', ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject('Cancelled');
                    if (typeof param === 'undefined' && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $ea16c3953685060f$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== 'undefined';
                    const param = manual ? pageParam : $ea16c3953685060f$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === 'undefined';
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $ea16c3953685060f$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $ea16c3953685060f$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $ea16c3953685060f$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $ea16c3953685060f$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $ea16c3953685060f$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $ea16c3953685060f$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $ea16c3953685060f$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}



// CLASS
class $c2aa340bb6cff64d$export$405d0624ed55a03f {
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $cb6ef54b07ab16fd$export$6bf54661be5b02cf).subscribe(()=>{
            if ((0, $cb6ef54b07ab16fd$export$6bf54661be5b02cf).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $c86fc979a466dc83$export$b113e788b2dd3fdc).subscribe(()=>{
            if ((0, $c86fc979a466dc83$export$b113e788b2dd3fdc).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ isFetching(arg1, arg2) {
        const [filters] = (0, $642b8e2027a4e792$export$18e8f4b987e6c111)(arg1, arg2);
        filters.fetchStatus = 'fetching';
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, filters), {
            fetching: true
        })).length;
    }
    /**
   * @deprecated This method will accept only queryKey in the next major version.
   */ getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $642b8e2027a4e792$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $642b8e2027a4e792$export$7f095f455ad5af3f)(updater, prevData);
        if (typeof data === 'undefined') return undefined;
        const parsedOptions = (0, $642b8e2027a4e792$export$8a11fbc2c8ea08fd)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
            manual: true
        }));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, /**
   * @deprecated This filters will be removed in the next major version.
   */ filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ removeQueries(arg1, arg2) {
        const [filters] = (0, $642b8e2027a4e792$export$18e8f4b987e6c111)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $642b8e2027a4e792$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            type: 'active'
        }, filters);
        return (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $642b8e2027a4e792$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === 'undefined') cancelOptions.revert = true;
        const promises = (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $642b8e2027a4e792$export$8793edee2d425525)).catch((0, $642b8e2027a4e792$export$8793edee2d425525));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $642b8e2027a4e792$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        return (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === 'none') return Promise.resolve();
            const refetchFilters = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, filters), {
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $642b8e2027a4e792$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const promises = (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                }));
            }));
        let promise = Promise.all(promises).then((0, $642b8e2027a4e792$export$8793edee2d425525));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $642b8e2027a4e792$export$8793edee2d425525));
        return promise;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $642b8e2027a4e792$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === 'undefined') defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $642b8e2027a4e792$export$8793edee2d425525)).catch((0, $642b8e2027a4e792$export$8793edee2d425525));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $642b8e2027a4e792$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $ea16c3953685060f$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $642b8e2027a4e792$export$8793edee2d425525)).catch((0, $642b8e2027a4e792$export$8793edee2d425525));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $642b8e2027a4e792$export$5fcb678681417b54)(queryKey) === (0, $642b8e2027a4e792$export$5fcb678681417b54)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $642b8e2027a4e792$export$2f07189bb9fa26a7)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $642b8e2027a4e792$export$5fcb678681417b54)(mutationKey) === (0, $642b8e2027a4e792$export$5fcb678681417b54)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $642b8e2027a4e792$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.defaultOptions.queries, this.getQueryDefaults(options == null ? void 0 : options.queryKey), options), {
            _defaulted: true
        });
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $642b8e2027a4e792$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === 'undefined') defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
        if (typeof defaultedOptions.useErrorBoundary === 'undefined') defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.defaultOptions.mutations, this.getMutationDefaults(options == null ? void 0 : options.mutationKey), options), {
            _defaulted: true
        });
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $1aad915e15a0edb0$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $ad5bddb7aff1eda0$export$1fcfd9a244434844)();
        this.logger = config.logger || (0, $79ea400dd6f52808$export$1cf3d545f2d4635c);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
}


var $7fPBF = parcelRequire("7fPBF");
'use client';
const $2a48bc0174310031$export$2fba198b5b2e37fa = /*#__PURE__*/ $7fPBF.createContext(undefined);
const $2a48bc0174310031$var$QueryClientSharingContext = /*#__PURE__*/ $7fPBF.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $2a48bc0174310031$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== 'undefined') {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $2a48bc0174310031$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $2a48bc0174310031$export$2fba198b5b2e37fa;
}
const $2a48bc0174310031$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $7fPBF.useContext($2a48bc0174310031$var$getQueryClientContext(context, $7fPBF.useContext($2a48bc0174310031$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error('No QueryClient set, use QueryClientProvider to set one');
    return queryClient;
};
const $2a48bc0174310031$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $7fPBF.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $2a48bc0174310031$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $7fPBF.createElement($2a48bc0174310031$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $7fPBF.createElement(Context.Provider, {
        value: client
    }, children));
};



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");


function $75dbb8f78ee65245$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}


function $8901fc92b5563702$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $75dbb8f78ee65245$export$71511d61b312f219)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}







class $c23401b806fb9686$export$a06cf8c0066f0d4c extends (0, $ab488a4425af0cf9$export$d26086b469ecdbcc) {
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($c23401b806fb9686$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $c23401b806fb9686$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $c23401b806fb9686$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $642b8e2027a4e792$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: 'observerOptionsUpdated',
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') throw new Error('Expected enabled to be a boolean');
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $c23401b806fb9686$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($c23401b806fb9686$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch(_param = {}) {
        var { refetchPage: refetchPage } = _param, options = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
            "refetchPage"
        ]);
        return this.fetch((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
            meta: {
                refetchPage: refetchPage
            }
        }));
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, fetchOptions), {
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        })).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $642b8e2027a4e792$export$8793edee2d425525));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $642b8e2027a4e792$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $642b8e2027a4e792$export$e539f754e934e270)(this.options.staleTime)) return;
        const time = (0, $642b8e2027a4e792$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $642b8e2027a4e792$export$6acf61af03e62db) || this.options.enabled === false || !(0, $642b8e2027a4e792$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $cb6ef54b07ab16fd$export$6bf54661be5b02cf).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $c23401b806fb9686$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $c23401b806fb9686$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $9085da9576c6a399$export$61b92f63f30245cf)(query.options.networkMode) ? 'fetching' : 'paused';
                if (!dataUpdatedAt) status = 'loading';
            }
            if (options._optimisticResults === 'isRestoring') fetchStatus = 'idle';
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== 'error') {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== 'undefined') {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $642b8e2027a4e792$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && status === 'loading') {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== 'undefined') try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== 'undefined') {
                status = 'success';
                data = (0, $642b8e2027a4e792$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = 'error';
        }
        const isFetching = fetchStatus === 'fetching';
        const isLoading = status === 'loading';
        const isError = status === 'error';
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === 'success',
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === 'paused',
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $c23401b806fb9686$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $642b8e2027a4e792$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === 'function' ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === 'all' || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add('error');
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultNotifyOptions, notifyOptions));
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === 'success') notifyOptions.onSuccess = !action.manual;
        else if (action.type === 'error' && !(0, $9085da9576c6a399$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: 'observerResultsUpdated'
            });
        });
    }
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
}
function $c23401b806fb9686$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}
function $c23401b806fb9686$var$shouldFetchOnMount(query, options) {
    return $c23401b806fb9686$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $c23401b806fb9686$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $c23401b806fb9686$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === 'function' ? field(query) : field;
        return value === 'always' || value !== false && $c23401b806fb9686$var$isStale(query, options);
    }
    return false;
}
function $c23401b806fb9686$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && $c23401b806fb9686$var$isStale(query, options);
}
function $c23401b806fb9686$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $c23401b806fb9686$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $642b8e2027a4e792$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}



var $7fPBF = parcelRequire("7fPBF");

var $cedbbf16ea1d6249$exports = {};
'use strict';

$cedbbf16ea1d6249$exports = (parcelRequire("a1Cvm"));


'use client';
const $e947951e7a07eff5$export$306c0aa65ff9ec16 = (0, $cedbbf16ea1d6249$exports.useSyncExternalStore);



var $7fPBF = parcelRequire("7fPBF");
'use client';
function $d2a636c4b3e53229$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $d2a636c4b3e53229$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $7fPBF.createContext($d2a636c4b3e53229$var$createValue()); // HOOK
const $d2a636c4b3e53229$export$50dfac555130cafd = ()=>$7fPBF.useContext($d2a636c4b3e53229$var$QueryErrorResetBoundaryContext); // COMPONENT
const $d2a636c4b3e53229$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $7fPBF.useState(()=>$d2a636c4b3e53229$var$createValue());
    return /*#__PURE__*/ $7fPBF.createElement($d2a636c4b3e53229$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === 'function' ? children(value) : children);
};




var $7fPBF = parcelRequire("7fPBF");
'use client';
const $101df0d090ed3a50$var$IsRestoringContext = /*#__PURE__*/ $7fPBF.createContext(false);
const $101df0d090ed3a50$export$4da0178d6b5f553 = ()=>$7fPBF.useContext($101df0d090ed3a50$var$IsRestoringContext);
const $101df0d090ed3a50$export$593807d4e94f9621 = $101df0d090ed3a50$var$IsRestoringContext.Provider;



var $7fPBF = parcelRequire("7fPBF");
function $59592778d71bce0e$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === 'function') return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}


'use client';
const $7d16dfaeb2d10e1e$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $7d16dfaeb2d10e1e$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $7fPBF.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $7d16dfaeb2d10e1e$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $59592778d71bce0e$export$2072f68e6c3507cf)(useErrorBoundary, [
        result.error,
        query
    ]);
};


/**
 * Ensures minimum staleTime and cacheTime values when suspense is enabled.
 * Despite the name, this function guards both staleTime and cacheTime to prevent
 * infinite re-render loops with synchronous queries.
 *
 * @deprecated in v5 - replaced by ensureSuspenseTimers
 */ const $31f731375e7feb77$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        // Always set stale time when using suspense to prevent
        // fetching again when directly mounting after suspending
        if (typeof defaultedOptions.staleTime !== 'number') defaultedOptions.staleTime = 1000;
        if (typeof defaultedOptions.cacheTime === 'number') defaultedOptions.cacheTime = Math.max(defaultedOptions.cacheTime, 1000);
    }
};
const $31f731375e7feb77$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $31f731375e7feb77$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $31f731375e7feb77$export$e0a3f29513afe430(result, isRestoring);
const $31f731375e7feb77$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });


'use client';
function $1be5bc399461b460$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $2a48bc0174310031$export$22e77b9572c4fded)({
        context: options.context
    });
    const isRestoring = (0, $101df0d090ed3a50$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $d2a636c4b3e53229$export$50dfac555130cafd)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic'; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    (0, $31f731375e7feb77$export$2c40a591ad2dafb1)(defaultedOptions);
    (0, $7d16dfaeb2d10e1e$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $7d16dfaeb2d10e1e$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $7fPBF.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $e947951e7a07eff5$export$306c0aa65ff9ec16)($7fPBF.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $5e53ba1b50ae52c5$export$520687f44db6e1ab).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $7fPBF.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $31f731375e7feb77$export$88d3586dfed64df9)(defaultedOptions, result, isRestoring)) throw (0, $31f731375e7feb77$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $7d16dfaeb2d10e1e$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


'use client';
function $d8deb3a6a62b947e$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $642b8e2027a4e792$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $1be5bc399461b460$export$fff0865807e996c5)(parsedOptions, (0, $c23401b806fb9686$export$a06cf8c0066f0d4c));
}




var $kY3Ke = parcelRequire("kY3Ke");
/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $91da240b76094466$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($91da240b76094466$export$e19cd5f9376f8cee || ($91da240b76094466$export$e19cd5f9376f8cee = {}));
var $91da240b76094466$var$readOnly = function(obj) {
    return obj;
};
function $91da240b76094466$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== 'undefined') console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $91da240b76094466$var$BeforeUnloadEventType = 'beforeunload';
var $91da240b76094466$var$HashChangeEventType = 'hashchange';
var $91da240b76094466$var$PopStateEventType = 'popstate';
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $91da240b76094466$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $91da240b76094466$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($91da240b76094466$var$PopStateEventType, handlePop);
    var action = $91da240b76094466$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $91da240b76094466$var$createEvents();
    var blockers = $91da240b76094466$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $kY3Ke.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function createHref(to) {
        return typeof to === 'string' ? to : $91da240b76094466$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $91da240b76094466$var$readOnly((0, $kY3Ke.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $91da240b76094466$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $91da240b76094466$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($91da240b76094466$var$BeforeUnloadEventType, $91da240b76094466$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($91da240b76094466$var$BeforeUnloadEventType, $91da240b76094466$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $91da240b76094466$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $91da240b76094466$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? '/' : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? '' : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? '' : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $91da240b76094466$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($91da240b76094466$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($91da240b76094466$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($91da240b76094466$export$fe53371bee54353d(nextLocation) !== $91da240b76094466$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $91da240b76094466$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $91da240b76094466$var$createEvents();
    var blockers = $91da240b76094466$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $kY3Ke.default)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function getBaseHref() {
        var base = document.querySelector('base');
        var href = '';
        if (base && base.getAttribute('href')) {
            var url = window.location.href;
            var hashIndex = url.indexOf('#');
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + '#' + (typeof to === 'string' ? to : $91da240b76094466$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $91da240b76094466$var$readOnly((0, $kY3Ke.default)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $91da240b76094466$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $91da240b76094466$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($91da240b76094466$var$BeforeUnloadEventType, $91da240b76094466$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($91da240b76094466$var$BeforeUnloadEventType, $91da240b76094466$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $91da240b76094466$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        '/'
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $91da240b76094466$var$readOnly((0, $kY3Ke.default)({
            pathname: '/',
            search: '',
            hash: '',
            state: null,
            key: $91da240b76094466$var$createKey()
        }, typeof entry === 'string' ? $91da240b76094466$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $91da240b76094466$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $91da240b76094466$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $91da240b76094466$var$createEvents();
    var blockers = $91da240b76094466$var$createEvents();
    function createHref(to) {
        return typeof to === 'string' ? to : $91da240b76094466$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $91da240b76094466$var$readOnly((0, $kY3Ke.default)({
            pathname: location.pathname,
            search: '',
            hash: ''
        }, typeof to === 'string' ? $91da240b76094466$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $91da240b76094466$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $91da240b76094466$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $91da240b76094466$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $91da240b76094466$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = '';
}
function $91da240b76094466$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $91da240b76094466$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $91da240b76094466$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? '/' : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? '' : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? '' : _ref$hash;
    if (search && search !== '?') pathname += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') pathname += hash.charAt(0) === '#' ? hash : '#' + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $91da240b76094466$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf('#');
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf('?');
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}


const $2df1405d783f614e$export$cdbdf26448f9da5b = 'ACCESS_TOKEN';
const $2df1405d783f614e$export$212a8f1ea37518bd = 'USER_ID';
const $2df1405d783f614e$export$77078610759fe5f6 = 'USER_NAME';
const $2df1405d783f614e$export$9228056436eff844 = 'TEAM_ID';
const $2df1405d783f614e$export$d57b6b390e78d90f = 'TEAM_NAME';
const $2df1405d783f614e$export$145c04625c32c6f3 = {
    'ERROR1': "\uC77C\uC2DC\uC801\uC778 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC5B4\uC694.",
    'ERROR2': "\uC7A0\uC2DC \uD6C4 \uB2E4\uC2DC \uC2DC\uB3C4\uD574 \uC8FC\uC138\uC694.",
    'LOGIN_EXPIRED': "\uB85C\uADF8\uC778 \uC815\uBCF4\uAC00 \uB9CC\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
    'AUTHENTICATION_FAIL': "\uC778\uC99D\uC5D0 \uC2E4\uD328\uD558\uC600\uC2B5\uB2C8\uB2E4. \uAD00\uB9AC\uC790\uC5D0\uAC8C \uBB38\uC758 \uD558\uC138\uC694.",
    'LOGOUT': "\uB85C\uADF8\uC544\uC6C3 \uB418\uC5C8\uC2B5\uB2C8\uB2E4.",
    'DELETE_USER': "\uACC4\uC815 \uC0AD\uC81C\uAC00 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4"
};
const $2df1405d783f614e$export$8593a9e2cd5efda5 = {
    'LOGOUT': 'logout',
    'EXPIRED': 'expired',
    'DELETE_USER': 'deleteUser'
};
const $2df1405d783f614e$export$a847abda144a238b = {
    'LOGOUT': {
        'LBTN': "\uB85C\uADF8\uC544\uC6C3",
        'RBTN': "\uCDE8\uC18C",
        'CONTENT': "\uB85C\uADF8\uC544\uC6C3 \uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"
    },
    'TERMS_AGREE': {
        'LBTN': "\uCCA0\uD68C\uD558\uAE30",
        'RBTN': "\uCDE8\uC18C",
        'CONTENT': "\uC120\uD0DD\uC815\uBCF4 \uC218\uC9D1 \uBC0F \uC774\uC6A9\uC57D\uAD00\uC744 \uB3D9\uC758\uD558\uC2DC\uBA74\n\uB9DE\uCDA4 \uC815\uBCF4\uB97C \uC81C\uACF5\uD574\uB4DC\uB824\uC694. \n\uC815\uB9D0 \uCCA0\uD68C\uD558\uC2DC\uACA0\uC5B4\uC694?"
    }
};
const $2df1405d783f614e$export$b1f0f495d632262c = {
    'BTN': "\uACC4\uC815\uC0AD\uC81C",
    'NOTI_LINE1': "\uAD00\uACC4\uBC95\uB839 \uBC0F \uB0B4\uBD80\uBC29\uCE68\uC5D0 \uC758\uD574 \uBCF4\uC874\uD558\uB3C4\uB85D \uADDC\uC815\uB41C \uAC1C\uC778\uC815\uBCF4\uB294",
    'NOTI_LINE2': "\uD574\uB2F9 \uAE30\uAC04\uAE4C\uC9C0\uB9CC \uBCF4\uAD00\uB418\uBA70 \uADF8 \uC678\uC758 \uAC1C\uC778\uC815\uBCF4\uB294 \uBC14\uB85C \uC0AD\uC81C\uB429\uB2C8\uB2E4",
    'CONTS_LINE1': "\uACC4\uC815\uC744 \uC0AD\uC81C\uD558\uC2DC\uBA74",
    'CONTS_LINE2_1': "\uC77C\uAC04 \uD568\uAED8 \uC313\uC544\uC628",
    'CONTS_LINE2_2': "\uC9C0\uAE08\uAE4C\uC9C0 \uC785\uB825\uD55C",
    'CONTS_LINE3': "\uAE30\uB85D\uB4E4\uC774 \uC0AC\uB77C\uC838\uC694"
};
const $2df1405d783f614e$export$a0c484e01edd59fe = {
    'STEP': 'STEP',
    'WEIGHT': 'WEIGHT',
    'SLEEP': 'SLEEP'
};
const $2df1405d783f614e$export$eed606b4351295d7 = {
    'TYPE': {
        'GOOGLE': 'G',
        'NAVER': 'N',
        'KAKAO': 'K',
        'EMAIL': 'E',
        'APPLE': 'A'
    },
    'HNAME': {
        'G': "\uAD6C\uAE00",
        'K': "\uCE74\uCE74\uC624",
        'N': "\uB124\uC774\uBC84",
        'E': "\uC774\uBA54\uC77C",
        'A': "\uC560\uD50C"
    },
    'TITLE': {
        'SNS': "SNS\uB85C \uC2DC\uC791",
        'EMAIL': "\uC774\uBA54\uC77C\uB85C \uC2DC\uC791\uD558\uAE30"
    },
    'SKIP': 'skip',
    'START_NOW': "\uBC14\uB85C \uC2DC\uC791\uD558\uAE30",
    'NEXT': "\uB2E4\uC74C",
    'EMAIL_LOGIN': "\uC774\uBA54\uC77C\uB85C \uB85C\uADF8\uC778",
    'SIGN_UP': {
        'MESSAGE1': "\uACC4\uC815\uC774 \uC5C6\uC73C\uC2E0\uAC00\uC694?",
        'EMAIL': "\uC774\uBA54\uC77C \uD68C\uC6D0\uAC00\uC785"
    }
};
const $2df1405d783f614e$export$fc9b794c7a748be5 = {
    'ROOT_PATH': undefined,
    'PUT_MEASURE': 'putMeasure/',
    'PUT_MEASURE_HISTORY': 'putMeasureHistory/',
    'STEP': 'step/',
    'USER_ID': 'userId_'
};
const $2df1405d783f614e$export$114ac5f844b12aca = {
    'Y': 'Y',
    'N': 'N'
};
const $2df1405d783f614e$export$45c85543ba71221d = {
    'DAY': 'YYYY-MM-DD',
    'DAY_DOT': 'YY.MM.DD',
    'DATE_TIME': 'YYYY-MM-DD HH:mm:ss',
    'DATE_TIME_UTC': 'YYYY-MM-DDTHH:mm:ss'
};
const $2df1405d783f614e$export$76a2e4c433c23bb9 = {
    'STEP_DAY': 'STEP_DAY',
    'STEP_HISTORY': 'STEP_HISTORY'
};


function $33eb00f42ea63933$var$setLocalStorage(name, data) {
    if (localStorage != null) localStorage.setItem(name, data);
}
function $33eb00f42ea63933$var$getLocalStorage(name) {
    let value = "";
    if (localStorage != null) value = localStorage.getItem(name);
    return value;
}
function $33eb00f42ea63933$var$initStorage() {
    localStorage.setItem((0, $2df1405d783f614e$export$cdbdf26448f9da5b), '');
    localStorage.setItem((0, $2df1405d783f614e$export$212a8f1ea37518bd), '');
    localStorage.setItem((0, $2df1405d783f614e$export$77078610759fe5f6), '');
    localStorage.setItem((0, $2df1405d783f614e$export$9228056436eff844), '');
    localStorage.setItem((0, $2df1405d783f614e$export$d57b6b390e78d90f), '');
}
var $33eb00f42ea63933$export$2e2bcd8739ae039 = {
    setLocalStorage: $33eb00f42ea63933$var$setLocalStorage,
    getLocalStorage: $33eb00f42ea63933$var$getLocalStorage,
    initStorage: $33eb00f42ea63933$var$initStorage
};




var $c6ba0193c6fadd6f$exports = {};

$c6ba0193c6fadd6f$exports = (parcelRequire("a04va"));




const $b13c137540e062b0$var$data = {
    type: (0, $2df1405d783f614e$export$8593a9e2cd5efda5).EXPIRED
};
const $b13c137540e062b0$export$55abd4691b317664 = (0, $91da240b76094466$export$719fc203c4e16dee)();
const $b13c137540e062b0$export$407ca81eb46778dd = (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).create({
    baseURL: "http://footballposition.com:8086/api"
});
const $b13c137540e062b0$export$7c3e5db52fb53dc8 = (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).create({
    baseURL: "http://footballposition.com:8086/api"
});
$b13c137540e062b0$export$7c3e5db52fb53dc8.interceptors.request.use(function(config) {
    config.headers["Content-Type"] = 'application/json';
    return config;
});
$b13c137540e062b0$export$407ca81eb46778dd.interceptors.request.use(function(config) {
    config.headers["Content-Type"] = 'application/json';
    config.headers["Authorization"] = `Bearer ${localStorage.getItem((0, $2df1405d783f614e$export$cdbdf26448f9da5b)) ? localStorage.getItem((0, $2df1405d783f614e$export$cdbdf26448f9da5b)) : ''}`;
    return config;
});
$b13c137540e062b0$export$7c3e5db52fb53dc8.interceptors.response.use((response)=>{
    return response;
}, function(error) {
    return Promise.reject(error);
});
$b13c137540e062b0$export$407ca81eb46778dd.interceptors.response.use((response)=>{
    return response;
}, function(error) {
    console.log(error);
    if (error.response.status == 401 || error.response.status == 403) {
        // 401 은 토큰이 없는 상태, 혹은 토큰 만료,
        $b13c137540e062b0$export$55abd4691b317664.push({
            pathname: "/login"
        }, $b13c137540e062b0$var$data);
        alert("\uC0AC\uC6A9\uC790 \uC778\uC99D\uC774 \uB9CC\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
        location.reload();
    }
    //400 및 기타에러는 화면에서 처리(axios 요청 실패시, 여러번 호출 되기 때문에 interceptor에서 처리 하지 않음)
    return Promise.reject(error);
});


class $4d624a4edc63c668$export$78aa35cd3523fa8f {
    constructor(nickName, userEmail, pwd){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "nickName", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "userEmail", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "pwd", void 0);
        this.nickName = nickName;
        this.userEmail = userEmail;
        this.pwd = pwd;
    }
}
class $4d624a4edc63c668$export$21d614480bd2768e {
    constructor(termsAgree, privateInfoAgree, adInfoAgree, gpsAgree, healthSyncAgree){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "termsAgree", void 0 // 서비스 이용
        );
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "privateInfoAgree", void 0 // 개인정보
        );
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "adInfoAgree", void 0 // 마케팅
        );
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "gpsAgree", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "healthSyncAgree", void 0);
        this.termsAgree = termsAgree;
        this.privateInfoAgree = privateInfoAgree;
        this.adInfoAgree = adInfoAgree;
        this.gpsAgree = gpsAgree;
        this.healthSyncAgree = healthSyncAgree;
    }
}
const $4d624a4edc63c668$var$getUser = async (userId)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).get("/user/" + String(userId)).then((res)=>res.data);
const $4d624a4edc63c668$var$deleteUser = async (userId)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).delete("/user/" + String(userId)).then((res)=>res);
const $4d624a4edc63c668$var$signIn = async (uuid, mnbrNtrySeCd)=>(0, $b13c137540e062b0$export$7c3e5db52fb53dc8).post("/svcUsers/svcUser/signIn", {
        'uuid': uuid,
        'mnbrNtrySeCd': mnbrNtrySeCd
    }).then((res)=>res.data);
const $4d624a4edc63c668$var$emailSignIn = async (email, pwd)=>(0, $b13c137540e062b0$export$7c3e5db52fb53dc8).post("/user/signIn", {
        'userEmail': email,
        'pwd': pwd
    }).then((res)=>res);
const $4d624a4edc63c668$var$signUp = async (svcUserSignUp)=>(0, $b13c137540e062b0$export$7c3e5db52fb53dc8).post("/user/signUp", svcUserSignUp).then((res)=>res);
const $4d624a4edc63c668$var$checkNickNmDuplicate = async (nickName)=>(0, $b13c137540e062b0$export$7c3e5db52fb53dc8).post("/user/nickNameCheck", {
        'nickName': nickName
    }).then((res)=>res);
const $4d624a4edc63c668$var$checkEmailDuplicate = async (email)=>(0, $b13c137540e062b0$export$7c3e5db52fb53dc8).post("/user/emailCheck", {
        'userEmail': email
    }).then((res)=>res);
const $4d624a4edc63c668$var$UserService = {
    getUser: $4d624a4edc63c668$var$getUser,
    deleteUser: $4d624a4edc63c668$var$deleteUser,
    signIn: $4d624a4edc63c668$var$signIn,
    SvcUserSignUp: $4d624a4edc63c668$export$78aa35cd3523fa8f,
    emailSignIn: $4d624a4edc63c668$var$emailSignIn,
    signUp: $4d624a4edc63c668$var$signUp,
    checkEmailDuplicate: $4d624a4edc63c668$var$checkEmailDuplicate,
    checkNickNmDuplicate: $4d624a4edc63c668$var$checkNickNmDuplicate
};
var $4d624a4edc63c668$export$2e2bcd8739ae039 = $4d624a4edc63c668$var$UserService;


function $b553984b7fac59de$var$isEmpty(str) {
    return str === undefined || str === null || str === "";
}
function $b553984b7fac59de$var$isNotEmpty(str) {
    return !$b553984b7fac59de$var$isEmpty(str);
}
function $b553984b7fac59de$var$stringify(object) {
    for(const eachIdx in object){
        if (object[eachIdx] instanceof Map) {
            object[eachIdx] = Array.from(object[eachIdx]);
            $b553984b7fac59de$var$stringify(object);
        } else if (typeof object[eachIdx] == 'object') $b553984b7fac59de$var$stringify(object[eachIdx]);
    }
    return JSON.stringify(object, null, 4);
}
function $b553984b7fac59de$var$jsonString2ObjectWithMap(jsonString) {
    if ($b553984b7fac59de$var$isEmpty(jsonString)) return {};
    const object = JSON.parse(jsonString);
    const jsonStringToObject = (object)=>{
        for(const eachIdx in object){
            if (object[eachIdx] instanceof Array && object[eachIdx].length > 0 && object[eachIdx][0].constructor === Array) {
                object[eachIdx] = new Map(object[eachIdx]);
                jsonStringToObject(object);
            } else if (typeof object[eachIdx] == 'object') jsonStringToObject(object[eachIdx]);
        }
        return object;
    };
    const result = jsonStringToObject(object);
    return result;
}
function $b553984b7fac59de$var$addComma(num) {
    if (!num) num = 0;
    const parts = num.toString().split(".");
    const regexp = /\B(?=(\d{3})+(?!\d))/g;
    return parts[0].replace(regexp, ',') + (parts[1] ? "." + parts[1] : "");
}
var $b553984b7fac59de$export$2e2bcd8739ae039 = {
    isEmpty: $b553984b7fac59de$var$isEmpty,
    isNotEmpty: $b553984b7fac59de$var$isNotEmpty,
    stringify: $b553984b7fac59de$var$stringify,
    jsonString2ObjectWithMap: $b553984b7fac59de$var$jsonString2ObjectWithMap,
    addComma: $b553984b7fac59de$var$addComma
};



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");


const $db737e13183cbb66$var$Splash = ()=>{
    const [teamName] = (0, $7fPBF.useState)((0, $33eb00f42ea63933$export$2e2bcd8739ae039).getLocalStorage((0, $2df1405d783f614e$export$d57b6b390e78d90f)));
    const [visible, setVisible] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        // 등장 애니메이션 트리거
        setVisible(true);
    }, []);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "splash-screen",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            className: `splash-text ${visible ? 'show' : ''}`,
            children: teamName
        })
    });
};
var $db737e13183cbb66$export$2e2bcd8739ae039 = $db737e13183cbb66$var$Splash;


const $020b91714255568e$var$AuthenticationView = ()=>{
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const history = (0, $91da240b76094466$export$719fc203c4e16dee)();
    const location = history.location;
    const state = location.state;
    const type = state === null || state === void 0 ? void 0 : state.type;
    const data = {
        type: (0, $2df1405d783f614e$export$8593a9e2cd5efda5).EXPIRED
    };
    const userId = (0, $33eb00f42ea63933$export$2e2bcd8739ae039).getLocalStorage((0, $2df1405d783f614e$export$212a8f1ea37518bd));
    const initAuthentication = ()=>{
        if (type === (0, $2df1405d783f614e$export$8593a9e2cd5efda5).EXPIRED) navigate({
            pathname: '/login',
            search: (0, $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f)(data).toString()
        });
        else if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty((0, $33eb00f42ea63933$export$2e2bcd8739ae039).getLocalStorage((0, $2df1405d783f614e$export$212a8f1ea37518bd))) || (0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty((0, $33eb00f42ea63933$export$2e2bcd8739ae039).getLocalStorage((0, $2df1405d783f614e$export$9228056436eff844))) || (0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty((0, $33eb00f42ea63933$export$2e2bcd8739ae039).getLocalStorage((0, $2df1405d783f614e$export$cdbdf26448f9da5b)))) goLogin();
        else getUser(); // token 유효성 검사를 위해서 호출
    };
    const { refetch: getUser } = (0, $d8deb3a6a62b947e$export$dd0a697e1782aedd)([
        'getUser'
    ], ()=>(0, $4d624a4edc63c668$export$2e2bcd8739ae039).getUser(userId), {
        onSuccess: ()=>onSuccess(),
        onError: ()=>onError()
    });
    const onSuccess = ()=>{
        goMain();
    };
    const onError = ()=>{
        //goLogin()
        goMain();
    };
    const goMain = ()=>{
        navigate('/main');
    };
    const goLogin = ()=>{
        navigate('/login');
    };
    (0, $7fPBF.useEffect)(()=>{
        setTimeout(function() {
            // Code here
            initAuthentication();
        }, 1500);
    }, []);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $db737e13183cbb66$export$2e2bcd8739ae039), {})
    });
};
var $020b91714255568e$export$2e2bcd8739ae039 = $020b91714255568e$var$AuthenticationView;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");


var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");


var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $cFLic = parcelRequire("cFLic");
function $da27c96857818bcc$export$2e2bcd8739ae039(t, e) {
    return $da27c96857818bcc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $da27c96857818bcc$export$2e2bcd8739ae039(t, e);
}


function $146ee816144a450d$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $da27c96857818bcc$export$2e2bcd8739ae039)(t, o);
}




var $7fPBF = parcelRequire("7fPBF");

var $8a9a7006a9b8efe4$export$2e2bcd8739ae039 = {
    disabled: false
};




var $7fPBF = parcelRequire("7fPBF");
var $61c94efb1735eff6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);


var $f1bbb084f2fb10b7$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $623678cbb6daf054$export$bb38bb9a1161268 = 'unmounted';
var $623678cbb6daf054$export$84cbff306f539230 = 'exited';
var $623678cbb6daf054$export$df38205c966be359 = 'entering';
var $623678cbb6daf054$export$78e9e6e3e014d60a = 'entered';
var $623678cbb6daf054$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $623678cbb6daf054$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $146ee816144a450d$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $623678cbb6daf054$export$84cbff306f539230;
                _this.appearStatus = $623678cbb6daf054$export$df38205c966be359;
            } else initialStatus = $623678cbb6daf054$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $623678cbb6daf054$export$bb38bb9a1161268;
        else initialStatus = $623678cbb6daf054$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $623678cbb6daf054$export$bb38bb9a1161268) return {
            status: $623678cbb6daf054$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $623678cbb6daf054$export$df38205c966be359 && status !== $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$df38205c966be359;
            } else if (status === $623678cbb6daf054$export$df38205c966be359 || status === $623678cbb6daf054$export$78e9e6e3e014d60a) nextStatus = $623678cbb6daf054$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $623678cbb6daf054$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $f1bbb084f2fb10b7$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $623678cbb6daf054$export$84cbff306f539230) this.setState({
            status: $623678cbb6daf054$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $8a9a7006a9b8efe4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $623678cbb6daf054$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $623678cbb6daf054$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $8a9a7006a9b8efe4$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $623678cbb6daf054$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $623678cbb6daf054$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $623678cbb6daf054$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $623678cbb6daf054$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $cFLic.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$623678cbb6daf054$var$Transition.contextType = (0, $61c94efb1735eff6$export$2e2bcd8739ae039);
$623678cbb6daf054$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $623678cbb6daf054$var$noop() {}
$623678cbb6daf054$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $623678cbb6daf054$var$noop,
    onEntering: $623678cbb6daf054$var$noop,
    onEntered: $623678cbb6daf054$var$noop,
    onExit: $623678cbb6daf054$var$noop,
    onExiting: $623678cbb6daf054$var$noop,
    onExited: $623678cbb6daf054$var$noop
};
$623678cbb6daf054$var$Transition.UNMOUNTED = $623678cbb6daf054$export$bb38bb9a1161268;
$623678cbb6daf054$var$Transition.EXITED = $623678cbb6daf054$export$84cbff306f539230;
$623678cbb6daf054$var$Transition.ENTERING = $623678cbb6daf054$export$df38205c966be359;
$623678cbb6daf054$var$Transition.ENTERED = $623678cbb6daf054$export$78e9e6e3e014d60a;
$623678cbb6daf054$var$Transition.EXITING = $623678cbb6daf054$export$4aacc83d4d59139f;
var $623678cbb6daf054$export$2e2bcd8739ae039 = $623678cbb6daf054$var$Transition;






var $7fPBF = parcelRequire("7fPBF");
function $8971fd60a8b100cf$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($7fPBF.version, 10) >= 19) {
        var _element$props;
        return (element == null || (_element$props = element.props) == null ? void 0 : _element$props.ref) || null;
    }
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return (element == null ? void 0 : element.ref) || null;
}


// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $c285f587ed4585eb$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}


var $3aadd01758bd49c1$export$2e2bcd8739ae039 = (0, $c285f587ed4585eb$export$2e2bcd8739ae039);



var $7fPBF = parcelRequire("7fPBF");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $e91b37e03c9e5276$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $e7adb12ba33c17bd$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $7fPBF.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $e91b37e03c9e5276$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


'use client';
var $4f30d4c1188a58e6$export$2e2bcd8739ae039 = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039);


parcelRequire("7fPBF");


'use client';
const $726fe1d2377a5002$var$defaultTheme = (0, $ca3239ce6bf6e490$export$2e2bcd8739ae039)();
var $726fe1d2377a5002$export$2e2bcd8739ae039 = $726fe1d2377a5002$var$defaultTheme;



'use client';
function $bc16b792e42cac5d$export$2e2bcd8739ae039() {
    const theme = (0, $328672c8d07e1c59$export$2e2bcd8739ae039)((0, $726fe1d2377a5002$export$2e2bcd8739ae039));
    return theme[0, $e35ef6915a224202$export$2e2bcd8739ae039] || theme;
}


const $1ae2edacd7be6319$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $1ae2edacd7be6319$export$8cb1e9b404609ae9(props, options) {
    var _style$transitionDura, _style$transitionTimi;
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
        easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
        delay: style.transitionDelay
    };
}


function $35e4b0c27d76b933$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


function $c1e4563498af7952$export$2e2bcd8739ae039(node) {
    const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $6cb2f4180c9526e0$export$2e2bcd8739ae039 = (0, $c1e4563498af7952$export$2e2bcd8739ae039);



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $a3f6f5762623b961$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "container",
    "direction",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $a3f6f5762623b961$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $a3f6f5762623b961$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $a3f6f5762623b961$var$resolveContainer(containerProp);
    const transform = $a3f6f5762623b961$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $a3f6f5762623b961$var$Slide = /*#__PURE__*/ $7fPBF.forwardRef(function Slide(props, ref) {
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $623678cbb6daf054$export$2e2bcd8739ae039) } = props, other = (0, $cFLic.default)(props, $a3f6f5762623b961$var$_excluded);
    const childrenRef = $7fPBF.useRef(null);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)((0, $8971fd60a8b100cf$export$2e2bcd8739ae039)(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $1ae2edacd7be6319$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, $kY3Ke.default)({}, transitionProps));
        node.style.transition = theme.transitions.create('transform', (0, $kY3Ke.default)({}, transitionProps));
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $7fPBF.useCallback(()=>{
        if (childrenRef.current) $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $7fPBF.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $3aadd01758bd49c1$export$2e2bcd8739ae039)(()=>{
            if (childrenRef.current) $a3f6f5762623b961$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $7fPBF.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $kY3Ke.default)({
                ref: handleRef,
                style: (0, $kY3Ke.default)({
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, style, children.props.style)
            }, childProps));
        }
    }));
});
var $a3f6f5762623b961$export$2e2bcd8739ae039 = $a3f6f5762623b961$var$Slide;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

function $07a883fe7c352c85$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $07a883fe7c352c85$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $07a883fe7c352c85$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $07a883fe7c352c85$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $07a883fe7c352c85$export$2e2bcd8739ae039 = $07a883fe7c352c85$export$4f5d2d50c9deca37;


function $93971f0806345477$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}




var $iCiVn = parcelRequire("iCiVn");
var $816c65c0e1f7082c$export$2e2bcd8739ae039 = (0, $iCiVn.default);



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");






var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");


var $kY3Ke = parcelRequire("kY3Ke");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $b4522a0df256fb21$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $b4522a0df256fb21$export$2e2bcd8739ae039 = $b4522a0df256fb21$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $4520d0f80a3f7305$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $b4522a0df256fb21$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $kY3Ke.default)({}, otherProps, {
        ownerState: (0, $kY3Ke.default)({}, otherProps.ownerState, ownerState)
    });
}
var $4520d0f80a3f7305$export$2e2bcd8739ae039 = $4520d0f80a3f7305$var$appendOwnerState;



var $kY3Ke = parcelRequire("kY3Ke");

/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $7a075a443b93da2d$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $7a075a443b93da2d$export$2e2bcd8739ae039 = $7a075a443b93da2d$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $16d23e6599aa60ec$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $16d23e6599aa60ec$export$2e2bcd8739ae039 = $16d23e6599aa60ec$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $a945a7a9a1371b8c$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $kY3Ke.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $kY3Ke.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $7a075a443b93da2d$export$2e2bcd8739ae039)((0, $kY3Ke.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $16d23e6599aa60ec$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $16d23e6599aa60ec$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $kY3Ke.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $kY3Ke.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $a945a7a9a1371b8c$export$2e2bcd8739ae039 = $a945a7a9a1371b8c$var$mergeSlotProps;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $ae0f0ccae9f4b3cc$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $ae0f0ccae9f4b3cc$export$2e2bcd8739ae039 = $ae0f0ccae9f4b3cc$var$resolveComponentProps;


'use client';
const $a70b740322660959$var$_excluded = [
    "elementType",
    "externalSlotProps",
    "ownerState",
    "skipResolvingSlotProps"
];
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $a70b740322660959$var$useSlotProps(parameters) {
    var _parameters$additiona;
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false } = parameters, rest = (0, $cFLic.default)(parameters, $a70b740322660959$var$_excluded);
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $ae0f0ccae9f4b3cc$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $a945a7a9a1371b8c$export$2e2bcd8739ae039)((0, $kY3Ke.default)({}, rest, {
        externalSlotProps: resolvedComponentsProps
    }));
    const ref = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, (_parameters$additiona = parameters.additionalProps) == null ? void 0 : _parameters$additiona.ref);
    const props = (0, $4520d0f80a3f7305$export$2e2bcd8739ae039)(elementType, (0, $kY3Ke.default)({}, mergedProps, {
        ref: ref
    }), ownerState);
    return props;
}
var $a70b740322660959$export$2e2bcd8739ae039 = $a70b740322660959$var$useSlotProps;



var $7fPBF = parcelRequire("7fPBF");



var $bbzbN = parcelRequire("bbzbN");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $8e062765deddb857$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $8e062765deddb857$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $8e062765deddb857$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $8e062765deddb857$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $8e062765deddb857$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $8e062765deddb857$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($8e062765deddb857$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $8e062765deddb857$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$8e062765deddb857$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $8e062765deddb857$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $8e062765deddb857$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $8e062765deddb857$var$defaultGetTabbable, isEnabled: isEnabled = $8e062765deddb857$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $7fPBF.useRef(false);
    const sentinelStart = $7fPBF.useRef(null);
    const sentinelEnd = $7fPBF.useRef(null);
    const nodeToRestore = $7fPBF.useRef(null);
    const reactFocusEventTarget = $7fPBF.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $7fPBF.useRef(false);
    const rootRef = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)((0, $8971fd60a8b100cf$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $7fPBF.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                var _lastKeydown$current, _lastKeydown$current2;
                const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $7fPBF.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $8e062765deddb857$export$2e2bcd8739ae039 = $8e062765deddb857$var$FocusTrap;



var $7fPBF = parcelRequire("7fPBF");




var $bbzbN = parcelRequire("bbzbN");
'use client';
function $7aea8adc1cf7298d$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $7aea8adc1cf7298d$var$Portal = /*#__PURE__*/ $7fPBF.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $7fPBF.useState(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(/*#__PURE__*/ $7fPBF.isValidElement(children) ? (0, $8971fd60a8b100cf$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($7aea8adc1cf7298d$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $e91b37e03c9e5276$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $e91b37e03c9e5276$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $7fPBF.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $7fPBF.cloneElement(children, newProps);
        }
        return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
        children: mountNode ? /*#__PURE__*/ $b4ba1c853f6e1116$exports.createPortal(children, mountNode) : mountNode
    });
});
var $7aea8adc1cf7298d$export$2e2bcd8739ae039 = $7aea8adc1cf7298d$var$Portal;


var $6f197680cb170281$exports = {};
"use strict";

Object.defineProperty($6f197680cb170281$exports, "__esModule", {
    value: true
});
$6f197680cb170281$exports.default = $6f197680cb170281$var$createStyled;
$6f197680cb170281$exports.shouldForwardProp = $6f197680cb170281$var$shouldForwardProp;
$6f197680cb170281$exports.systemDefaultTheme = void 0;

var $6f197680cb170281$var$_extends2 = $4657741705a128f0$exports((parcelRequire("cvBp9")));

var $6f197680cb170281$var$_objectWithoutPropertiesLoose2 = $4657741705a128f0$exports((parcelRequire("1ifJj")));

var $6f197680cb170281$var$_styledEngine = $6f197680cb170281$var$_interopRequireWildcard((parcelRequire("5VCcJ")));

var $3wRTY = parcelRequire("3wRTY");

var $6f197680cb170281$var$_capitalize = $4657741705a128f0$exports((parcelRequire("3oBOp")));

var $6f197680cb170281$var$_getDisplayName = $4657741705a128f0$exports((parcelRequire("ehv4n")));

var $6f197680cb170281$var$_createTheme = $4657741705a128f0$exports((parcelRequire("eqNKX")));

var $6f197680cb170281$var$_styleFunctionSx = $4657741705a128f0$exports((parcelRequire("3aVNX")));
const $6f197680cb170281$var$_excluded = [
    "ownerState"
], $6f197680cb170281$var$_excluded2 = [
    "variants"
], $6f197680cb170281$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $6f197680cb170281$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6f197680cb170281$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $6f197680cb170281$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $6f197680cb170281$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $6f197680cb170281$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $6f197680cb170281$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $6f197680cb170281$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $6f197680cb170281$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $6f197680cb170281$var$systemDefaultTheme = $6f197680cb170281$exports.systemDefaultTheme = (0, $6f197680cb170281$var$_createTheme.default)();
const $6f197680cb170281$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $6f197680cb170281$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $6f197680cb170281$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $6f197680cb170281$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $6f197680cb170281$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $6f197680cb170281$var$_objectWithoutPropertiesLoose2.default)(_ref, $6f197680cb170281$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $6f197680cb170281$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$6f197680cb170281$var$processStyleArg(resolvedStyle, (0, $6f197680cb170281$var$_extends2.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $6f197680cb170281$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $6f197680cb170281$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $6f197680cb170281$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $6f197680cb170281$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $6f197680cb170281$var$shallowLayer((0, $6f197680cb170281$var$_styledEngine.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $6f197680cb170281$var$shallowLayer((0, $6f197680cb170281$var$_styledEngine.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $6f197680cb170281$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $6f197680cb170281$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $6f197680cb170281$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $6f197680cb170281$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $6f197680cb170281$var$_styleFunctionSx.default)((0, $6f197680cb170281$var$_extends2.default)({}, props, {
            theme: $6f197680cb170281$var$resolveTheme((0, $6f197680cb170281$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $6f197680cb170281$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $6f197680cb170281$var$defaultOverridesResolver($6f197680cb170281$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $6f197680cb170281$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $6f197680cb170281$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $6f197680cb170281$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($6f197680cb170281$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $6f197680cb170281$var$_styledEngine.default)(tag, (0, $6f197680cb170281$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $3wRTY.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $6f197680cb170281$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $6f197680cb170281$var$processStyleArg(stylesArg, (0, $6f197680cb170281$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $6f197680cb170281$var$resolveTheme((0, $6f197680cb170281$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $6f197680cb170281$var$processStyleArg(slotStyle, (0, $6f197680cb170281$var$_extends2.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $6f197680cb170281$var$resolveTheme((0, $6f197680cb170281$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $6f197680cb170281$var$processStyleArg({
                    variants: themeVariants
                }, (0, $6f197680cb170281$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}




// copied from @mui/system/createStyled
function $066f83798075d563$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $066f83798075d563$export$2e2bcd8739ae039 = $066f83798075d563$var$slotShouldForwardProp;


const $0820e164eb5fbaff$var$rootShouldForwardProp = (prop)=>(0, $066f83798075d563$export$2e2bcd8739ae039)(prop) && prop !== 'classes';
var $0820e164eb5fbaff$export$2e2bcd8739ae039 = $0820e164eb5fbaff$var$rootShouldForwardProp;



'use client';
const $f0645ef192f222f7$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($6f197680cb170281$exports)))({
    themeId: (0, $e35ef6915a224202$export$2e2bcd8739ae039),
    defaultTheme: $726fe1d2377a5002$export$2e2bcd8739ae039,
    rootShouldForwardProp: $0820e164eb5fbaff$export$2e2bcd8739ae039
});
var $f0645ef192f222f7$export$2e2bcd8739ae039 = $f0645ef192f222f7$var$styled;



var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");



var $bbzbN = parcelRequire("bbzbN");
'use client';
function $dc79fb0f6686e80b$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5431f86afe49fae8$export$2e2bcd8739ae039), (0, $kY3Ke.default)({}, props));
}
var $dc79fb0f6686e80b$export$2e2bcd8739ae039 = $dc79fb0f6686e80b$var$DefaultPropsProvider;
function $dc79fb0f6686e80b$export$2440da353cedad43(params) {
    return (0, $5431f86afe49fae8$export$2440da353cedad43)(params);
}



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");






var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");








var $bbzbN = parcelRequire("bbzbN");
'use client';
const $68214be7242cbfc8$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
const $68214be7242cbfc8$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $68214be7242cbfc8$var$Fade = /*#__PURE__*/ $7fPBF.forwardRef(function Fade(props, ref) {
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $623678cbb6daf054$export$2e2bcd8739ae039) } = props, other = (0, $cFLic.default)(props, $68214be7242cbfc8$var$_excluded);
    const enableStrictModeCompat = true;
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(nodeRef, (0, $8971fd60a8b100cf$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $1ae2edacd7be6319$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $kY3Ke.default)({
                style: (0, $kY3Ke.default)({
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $68214be7242cbfc8$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
var $68214be7242cbfc8$export$2e2bcd8739ae039 = $68214be7242cbfc8$var$Fade;


const $f37dfc12e5d89c96$var$defaultGenerator = (componentName)=>componentName;
const $f37dfc12e5d89c96$var$createClassNameGenerator = ()=>{
    let generate = $f37dfc12e5d89c96$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $f37dfc12e5d89c96$var$defaultGenerator;
        }
    };
};
const $f37dfc12e5d89c96$var$ClassNameGenerator = $f37dfc12e5d89c96$var$createClassNameGenerator();
var $f37dfc12e5d89c96$export$2e2bcd8739ae039 = $f37dfc12e5d89c96$var$ClassNameGenerator;


const $ea3dfa6b173640a4$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $ea3dfa6b173640a4$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $ea3dfa6b173640a4$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $f37dfc12e5d89c96$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $ea3dfa6b173640a4$export$34c0130b1f3e8ae3(slot) {
    return $ea3dfa6b173640a4$export$9d6b9120de57c54[slot] !== undefined;
}


function $32447174989d1976$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}



function $36421d1d94159248$export$9927a91fd93152bd(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiBackdrop', slot);
}
const $36421d1d94159248$var$backdropClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $36421d1d94159248$export$2e2bcd8739ae039 = $36421d1d94159248$var$backdropClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $e70e583d684cb5f4$var$_excluded = [
    "children",
    "className",
    "component",
    "components",
    "componentsProps",
    "invisible",
    "open",
    "slotProps",
    "slots",
    "TransitionComponent",
    "transitionDuration"
];
const $e70e583d684cb5f4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $36421d1d94159248$export$9927a91fd93152bd), classes);
};
const $e70e583d684cb5f4$var$BackdropRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        WebkitTapHighlightColor: 'transparent'
    }, ownerState.invisible && {
        backgroundColor: 'transparent'
    }));
const $e70e583d684cb5f4$var$Backdrop = /*#__PURE__*/ $7fPBF.forwardRef(function Backdrop(inProps, ref) {
    var _slotProps$root, _ref, _slots$root;
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', components: components = {}, componentsProps: componentsProps = {}, invisible: invisible = false, open: open, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponent = (0, $68214be7242cbfc8$export$2e2bcd8739ae039), transitionDuration: transitionDuration } = props, other = (0, $cFLic.default)(props, $e70e583d684cb5f4$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        invisible: invisible
    });
    const classes = $e70e583d684cb5f4$var$useUtilityClasses(ownerState);
    const rootSlotProps = (_slotProps$root = slotProps.root) != null ? _slotProps$root : componentsProps.root;
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        in: open,
        timeout: transitionDuration
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($e70e583d684cb5f4$var$BackdropRoot, (0, $kY3Ke.default)({
            "aria-hidden": true
        }, rootSlotProps, {
            as: (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : component,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className, rootSlotProps == null ? void 0 : rootSlotProps.className),
            ownerState: (0, $kY3Ke.default)({}, ownerState, rootSlotProps == null ? void 0 : rootSlotProps.ownerState),
            classes: classes,
            ref: ref,
            children: children
        }))
    }));
});
var $e70e583d684cb5f4$export$2e2bcd8739ae039 = $e70e583d684cb5f4$var$Backdrop;



var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $d6e7ffad706c848e$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}


var $7fPBF = parcelRequire("7fPBF");

'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $bddccca9f6cee29b$var$useEventCallback(fn) {
    const ref = $7fPBF.useRef(fn);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $7fPBF.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $bddccca9f6cee29b$export$2e2bcd8739ae039 = $bddccca9f6cee29b$var$useEventCallback;



// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $5f729e410b274c00$export$2e2bcd8739ae039(doc) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = doc.documentElement.clientWidth;
    return Math.abs(window.innerWidth - documentWidth);
}


// Is a vertical scrollbar displayed?
function $6368973433f2cfde$var$isOverflowing(container) {
    const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $c1e4563498af7952$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $6368973433f2cfde$export$e1bd0c6150f13d96(element, show) {
    if (show) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $6368973433f2cfde$var$getPaddingRight(element) {
    return parseInt((0, $c1e4563498af7952$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $6368973433f2cfde$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.indexOf(element.tagName) !== -1;
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $6368973433f2cfde$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, show) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = blacklist.indexOf(element) === -1;
        const isNotForbiddenElement = !$6368973433f2cfde$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $6368973433f2cfde$export$e1bd0c6150f13d96(element, show);
    });
}
function $6368973433f2cfde$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $6368973433f2cfde$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($6368973433f2cfde$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $5f729e410b274c00$export$2e2bcd8739ae039)((0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$6368973433f2cfde$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$6368973433f2cfde$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $c1e4563498af7952$export$2e2bcd8739ae039)(container);
            scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $6368973433f2cfde$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $6368973433f2cfde$export$ce11c4ecd08cea67 {
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $6368973433f2cfde$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $6368973433f2cfde$var$getHiddenSiblings(container);
        $6368973433f2cfde$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $6368973433f2cfde$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $6368973433f2cfde$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $6368973433f2cfde$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $6368973433f2cfde$var$findIndexOf(this.containers, (item)=>item.modals.indexOf(modal) !== -1);
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $6368973433f2cfde$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $6368973433f2cfde$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $6368973433f2cfde$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
    constructor(){
        this.containers = void 0;
        this.modals = void 0;
        this.modals = [];
        this.containers = [];
    }
}


'use client';
function $bb037c33603903c5$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $bb037c33603903c5$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $bb037c33603903c5$var$defaultManager = new (0, $6368973433f2cfde$export$ce11c4ecd08cea67)();
/**
 *
 * Demos:
 *
 * - [Modal](https://mui.com/base-ui/react-modal/#hook)
 *
 * API:
 *
 * - [useModal API](https://mui.com/base-ui/react-modal/hooks-api/#use-modal)
 */ function $bb037c33603903c5$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, manager: // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager = $bb037c33603903c5$var$defaultManager, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $7fPBF.useRef({});
    const mountNodeRef = $7fPBF.useRef(null);
    const modalRef = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $7fPBF.useState(!open);
    const hasTransition = $bb037c33603903c5$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $bb037c33603903c5$var$getContainer(container) || getDoc().body;
        manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = $7fPBF.useCallback(()=>manager.isTopModal(getModal()), [
        manager
    ]);
    const handlePortalRef = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $6368973433f2cfde$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $7fPBF.useCallback(()=>{
        manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp,
        manager
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $7fPBF.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            var _otherHandlers$onKeyD;
            (_otherHandlers$onKeyD = otherHandlers.onKeyDown) == null || _otherHandlers$onKeyD.call(otherHandlers, event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            var _otherHandlers$onClic;
            (_otherHandlers$onClic = otherHandlers.onClick) == null || _otherHandlers$onClic.call(otherHandlers, event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $7a075a443b93da2d$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = (0, $kY3Ke.default)({}, propsEventHandlers, otherHandlers);
        return (0, $kY3Ke.default)({
            role: 'presentation'
        }, externalEventHandlers, {
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        });
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return (0, $kY3Ke.default)({
            'aria-hidden': true
        }, externalEventHandlers, {
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        });
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $d6e7ffad706c848e$export$2e2bcd8739ae039)(handleEnter, children == null ? void 0 : children.props.onEnter),
            onExited: (0, $d6e7ffad706c848e$export$2e2bcd8739ae039)(handleExited, children == null ? void 0 : children.props.onExited)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $bb037c33603903c5$export$2e2bcd8739ae039 = $bb037c33603903c5$var$useModal;




function $1581382eb39c1df6$export$67960e22b12a638d(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiModal', slot);
}
const $1581382eb39c1df6$var$modalClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $1581382eb39c1df6$export$2e2bcd8739ae039 = $1581382eb39c1df6$var$modalClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $a65b89a1133e1fe4$var$_excluded = [
    "BackdropComponent",
    "BackdropProps",
    "classes",
    "className",
    "closeAfterTransition",
    "children",
    "container",
    "component",
    "components",
    "componentsProps",
    "disableAutoFocus",
    "disableEnforceFocus",
    "disableEscapeKeyDown",
    "disablePortal",
    "disableRestoreFocus",
    "disableScrollLock",
    "hideBackdrop",
    "keepMounted",
    "onBackdropClick",
    "onClose",
    "onTransitionEnter",
    "onTransitionExited",
    "open",
    "slotProps",
    "slots",
    "theme"
];
const $a65b89a1133e1fe4$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $1581382eb39c1df6$export$67960e22b12a638d), classes);
};
const $a65b89a1133e1fe4$var$ModalRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0
    }, !ownerState.open && ownerState.exited && {
        visibility: 'hidden'
    }));
const $a65b89a1133e1fe4$var$ModalBackdrop = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $e70e583d684cb5f4$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop',
    overridesResolver: (props, styles)=>{
        return styles.backdrop;
    }
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $a65b89a1133e1fe4$var$Modal = /*#__PURE__*/ $7fPBF.forwardRef(function Modal(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$backdrop, _slotProps$root, _slotProps$backdrop;
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $a65b89a1133e1fe4$var$ModalBackdrop, BackdropProps: BackdropProps, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onBackdropClick: onBackdropClick, open: open, slotProps: slotProps, slots: slots } = props, other = (0, $cFLic.default)(props, $a65b89a1133e1fe4$var$_excluded);
    const propsWithDefaults = (0, $kY3Ke.default)({}, props, {
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    });
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $bb037c33603903c5$export$2e2bcd8739ae039)((0, $kY3Ke.default)({}, propsWithDefaults, {
        rootRef: ref
    }));
    const ownerState = (0, $kY3Ke.default)({}, propsWithDefaults, {
        exited: exited
    });
    const classes = $a65b89a1133e1fe4$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const RootSlot = (_ref = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : components.Root) != null ? _ref : $a65b89a1133e1fe4$var$ModalRoot;
    const BackdropSlot = (_ref2 = (_slots$backdrop = slots == null ? void 0 : slots.backdrop) != null ? _slots$backdrop : components.Backdrop) != null ? _ref2 : BackdropComponent;
    const rootSlotProps = (_slotProps$root = slotProps == null ? void 0 : slotProps.root) != null ? _slotProps$root : componentsProps.root;
    const backdropSlotProps = (_slotProps$backdrop = slotProps == null ? void 0 : slotProps.backdrop) != null ? _slotProps$backdrop : componentsProps.backdrop;
    const rootProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: rootSlotProps,
        externalForwardedProps: other,
        getSlotProps: getRootProps,
        additionalProps: {
            ref: ref,
            as: component
        },
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, rootSlotProps == null ? void 0 : rootSlotProps.className, classes == null ? void 0 : classes.root, !ownerState.open && ownerState.exited && (classes == null ? void 0 : classes.hidden))
    });
    const backdropProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: BackdropSlot,
        externalSlotProps: backdropSlotProps,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps((0, $kY3Ke.default)({}, otherHandlers, {
                onClick: (e)=>{
                    if (onBackdropClick) onBackdropClick(e);
                    if (otherHandlers != null && otherHandlers.onClick) otherHandlers.onClick(e);
                }
            }));
        },
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(backdropSlotProps == null ? void 0 : backdropSlotProps.className, BackdropProps == null ? void 0 : BackdropProps.className, classes == null ? void 0 : classes.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7aea8adc1cf7298d$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)(RootSlot, (0, $kY3Ke.default)({}, rootProps, {
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $bbzbN.jsx)(BackdropSlot, (0, $kY3Ke.default)({}, backdropProps)) : null,
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8e062765deddb857$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $7fPBF.cloneElement(children, childProps)
                })
            ]
        }))
    });
});
var $a65b89a1133e1fe4$export$2e2bcd8739ae039 = $a65b89a1133e1fe4$var$Modal;




var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");







// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $8fa7ddbbf42193a7$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $8fa7ddbbf42193a7$export$2e2bcd8739ae039 = $8fa7ddbbf42193a7$var$getOverlayAlpha;






function $bde3e2fffcaea664$export$29cdb466b9b6f20b(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPaper', slot);
}
const $bde3e2fffcaea664$var$paperClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $bde3e2fffcaea664$export$2e2bcd8739ae039 = $bde3e2fffcaea664$var$paperClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $74e245c78e363f11$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $74e245c78e363f11$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $bde3e2fffcaea664$export$29cdb466b9b6f20b), classes);
};
const $74e245c78e363f11$var$PaperRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $kY3Ke.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $kY3Ke.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $553ed2baba4347ed$exports.alpha)('#fff', (0, $8fa7ddbbf42193a7$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $553ed2baba4347ed$exports.alpha)('#fff', (0, $8fa7ddbbf42193a7$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $74e245c78e363f11$var$Paper = /*#__PURE__*/ $7fPBF.forwardRef(function Paper(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $cFLic.default)(props, $74e245c78e363f11$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $74e245c78e363f11$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($74e245c78e363f11$var$PaperRoot, (0, $kY3Ke.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other));
});
var $74e245c78e363f11$export$2e2bcd8739ae039 = $74e245c78e363f11$var$Paper;






function $8523c8ab2139cf2c$export$2177af0aa15c34c2(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDialog', slot);
}
const $8523c8ab2139cf2c$var$dialogClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $8523c8ab2139cf2c$export$2e2bcd8739ae039 = $8523c8ab2139cf2c$var$dialogClasses;



var $7fPBF = parcelRequire("7fPBF");
const $40596d25b0f9c334$var$DialogContext = /*#__PURE__*/ $7fPBF.createContext({});
var $40596d25b0f9c334$export$2e2bcd8739ae039 = $40596d25b0f9c334$var$DialogContext;





var $bbzbN = parcelRequire("bbzbN");
'use client';
const $7f096abd658f7c85$var$_excluded = [
    "aria-describedby",
    "aria-labelledby",
    "BackdropComponent",
    "BackdropProps",
    "children",
    "className",
    "disableEscapeKeyDown",
    "fullScreen",
    "fullWidth",
    "maxWidth",
    "onBackdropClick",
    "onClick",
    "onClose",
    "open",
    "PaperComponent",
    "PaperProps",
    "scroll",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $7f096abd658f7c85$var$DialogBackdrop = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $e70e583d684cb5f4$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $7f096abd658f7c85$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(scroll)}`,
            `paperWidth${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $8523c8ab2139cf2c$export$2177af0aa15c34c2), classes);
};
const $7f096abd658f7c85$var$DialogRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $a65b89a1133e1fe4$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $7f096abd658f7c85$var$DialogContainer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.scroll)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        height: '100%',
        '@media print': {
            height: 'auto'
        },
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.scroll === 'body' && {
        overflowY: 'auto',
        overflowX: 'hidden',
        textAlign: 'center',
        '&::after': {
            content: '""',
            display: 'inline-block',
            verticalAlign: 'middle',
            height: '100%',
            width: '0'
        }
    }));
const $7f096abd658f7c85$var$DialogPaper = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        // Fix IE11 issue, to remove at some point.
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        }
    }, ownerState.scroll === 'paper' && {
        display: 'flex',
        flexDirection: 'column',
        maxHeight: 'calc(100% - 64px)'
    }, ownerState.scroll === 'body' && {
        display: 'inline-block',
        verticalAlign: 'middle',
        textAlign: 'left' // 'initial' doesn't work on IE11
    }, !ownerState.maxWidth && {
        maxWidth: 'calc(100% - 64px)'
    }, ownerState.maxWidth === 'xs' && {
        maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
        [`&.${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.maxWidth && ownerState.maxWidth !== 'xs' && {
        maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
        [`&.${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).paperScrollBody}`]: {
            [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 64)]: {
                maxWidth: 'calc(100% - 64px)'
            }
        }
    }, ownerState.fullWidth && {
        width: 'calc(100% - 64px)'
    }, ownerState.fullScreen && {
        margin: 0,
        width: '100%',
        maxWidth: '100%',
        height: '100%',
        maxHeight: 'none',
        borderRadius: 0,
        [`&.${(0, $8523c8ab2139cf2c$export$2e2bcd8739ae039).paperScrollBody}`]: {
            margin: 0,
            maxWidth: '100%'
        }
    }));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $7f096abd658f7c85$var$Dialog = /*#__PURE__*/ $7fPBF.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onBackdropClick: onBackdropClick, onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $74e245c78e363f11$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', TransitionComponent: TransitionComponent = (0, $68214be7242cbfc8$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps } = props, other = (0, $cFLic.default)(props, $7f096abd658f7c85$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    });
    const classes = $7f096abd658f7c85$var$useUtilityClasses(ownerState);
    const backdropClick = $7fPBF.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onBackdropClick) onBackdropClick(event);
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $46f5b561912058f9$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $7fPBF.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7f096abd658f7c85$var$DialogRoot, (0, $kY3Ke.default)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        closeAfterTransition: true,
        components: {
            Backdrop: $7f096abd658f7c85$var$DialogBackdrop
        },
        componentsProps: {
            backdrop: (0, $kY3Ke.default)({
                transitionDuration: transitionDuration,
                as: BackdropComponent
            }, BackdropProps)
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        ref: ref,
        onClick: handleBackdropClick,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: "presentation"
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)($7f096abd658f7c85$var$DialogContainer, {
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.container),
                onMouseDown: handleMouseDown,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)($7f096abd658f7c85$var$DialogPaper, (0, $kY3Ke.default)({
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby
                }, PaperProps, {
                    className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.paper, PaperProps.className),
                    ownerState: ownerState,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $40596d25b0f9c334$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                }))
            })
        }))
    }));
});
var $7f096abd658f7c85$export$2e2bcd8739ae039 = $7f096abd658f7c85$var$Dialog;



var $bbzbN = parcelRequire("bbzbN");
const $82f6451296af3115$var$Icon = (props)=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: `icon ${props.divClass ? props.divClass : ''}`,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: props.iconClass
        })
    });
};
var $82f6451296af3115$export$2e2bcd8739ae039 = $82f6451296af3115$var$Icon;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");
const $4ac626799ed465c3$var$HeaderSpacer = (param)=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: `header-spacer ${param.className ? param.className : ''}`
    });
};
var $4ac626799ed465c3$export$2e2bcd8739ae039 = $4ac626799ed465c3$var$HeaderSpacer;




var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");




var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");





var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");


parcelRequire("7fPBF");

const $82bcba16c3ce4448$export$55abd4691b317664 = (0, $91da240b76094466$export$719fc203c4e16dee)();


const $5f47bfd43cc47d77$var$Transition = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Transition(props, ref) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a3f6f5762623b961$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        direction: "left",
        ref: ref
    }, props));
});
const $5f47bfd43cc47d77$var$DialogHeader = (props)=>{
    const handleOverlayClick = (0, $7fPBF.useCallback)(()=>props.onClose(), [
        props.onClose
    ]);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false);
    const handleClickOpen = ()=>{
        setOpen(true);
    };
    const handleClose = ()=>{
        setOpen(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        const unlistenHistoryEvent = (0, $82bcba16c3ce4448$export$55abd4691b317664).listen(({ action: action })=>{
            if (action === 'POP') handleOverlayClick();
        });
        return unlistenHistoryEvent;
    }, [
        (0, $82bcba16c3ce4448$export$55abd4691b317664)
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            className: "header",
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: "left svg",
                    onClick: handleOverlayClick,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                        iconClass: props.leftIcon ? props.leftIcon : 'prev w-8 w-17'
                    })
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                    className: "b1_r",
                    children: props.title
                }),
                props.rightIcon && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: "right svg",
                    onClick: handleClickOpen,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                        iconClass: props.rightIcon
                    })
                })
            ]
        })
    });
};
var $5f47bfd43cc47d77$export$2e2bcd8739ae039 = $5f47bfd43cc47d77$var$DialogHeader;



var $bbzbN = parcelRequire("bbzbN");
const $fd30181b78da18c2$var$BottomButton = (props)=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            className: "button-wrapper",
            style: {
                marginLeft: props.main ? '0px' : undefined
            },
            children: [
                props.notification,
                /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                    className: `${props.className ? props.className : 'primary'} bottomButton`,
                    onClick: ()=>props.onClick ? props.onClick() : null,
                    disabled: props.disabled,
                    children: props.title
                })
            ]
        })
    });
};
var $fd30181b78da18c2$export$2e2bcd8739ae039 = $fd30181b78da18c2$var$BottomButton;




const $dc67bf4d9f1c69d7$var$getBoardList = async ()=>(0, $b13c137540e062b0$export$407ca81eb46778dd).get("/board/list").then((res)=>res.data);
const $dc67bf4d9f1c69d7$var$postBoard = async (board)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).post("/board", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, board)).then((res)=>res.data);
const $dc67bf4d9f1c69d7$var$updateBoard = async (board, boardNo)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).patch("/board/" + boardNo.toString(), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, board));
const $dc67bf4d9f1c69d7$var$BoardService = {
    getBoardList: $dc67bf4d9f1c69d7$var$getBoardList,
    postBoard: $dc67bf4d9f1c69d7$var$postBoard,
    updateBoard: $dc67bf4d9f1c69d7$var$updateBoard
};
var $dc67bf4d9f1c69d7$export$2e2bcd8739ae039 = $dc67bf4d9f1c69d7$var$BoardService;



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
const $4c180b03f3e7cb44$var$NoContent = (props)=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            className: "no-content-wrapper",
            children: /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                className: "b1_r cl-gray05",
                children: props.notification
            })
        })
    });
};
var $4c180b03f3e7cb44$export$2e2bcd8739ae039 = $4c180b03f3e7cb44$var$NoContent;





var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
const $81f71a07c181b281$var$BoardDetail = (props)=>{
    const [boardData, setBoardData] = (0, $7fPBF.useState)(props.board);
    (0, $7fPBF.useEffect)(()=>{
        setBoardData(props.board);
    }, [
        props
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            className: 'mt-24px',
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: 'w-100p h-min-50p',
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: 's_title_1_m',
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                children: boardData === null || boardData === void 0 ? void 0 : boardData.title
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: 'c1_r cl-gray04',
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("p", {
                                children: [
                                    "\uC791\uC131\uC790 : ",
                                    boardData === null || boardData === void 0 ? void 0 : boardData.writerNickName
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: 'c1_r cl-gray04',
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("p", {
                                children: [
                                    "\uC791\uC131\uC77C\uC2DC : ",
                                    boardData === null || boardData === void 0 ? void 0 : boardData.regDt
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: 'c1_r cl-gray04',
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("p", {
                                children: [
                                    "\uB9C8\uC9C0\uB9C9 \uC218\uC815\uC77C\uC2DC : ",
                                    boardData === null || boardData === void 0 ? void 0 : boardData.updateDt
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: 'b2_r mt-32px',
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                className: 'board-content',
                                children: boardData === null || boardData === void 0 ? void 0 : boardData.content
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: 'border-top-gray mt-36px'
                })
            ]
        })
    });
};
var $81f71a07c181b281$export$2e2bcd8739ae039 = $81f71a07c181b281$var$BoardDetail;







var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");



var $3wRTY = parcelRequire("3wRTY");


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $diYUK = parcelRequire("diYUK");

var $7fPBF = parcelRequire("7fPBF");







var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $fb9bd25a2238f701$var$_excluded = [
    "onChange",
    "maxRows",
    "minRows",
    "style",
    "value"
];
function $fb9bd25a2238f701$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $fb9bd25a2238f701$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $fb9bd25a2238f701$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $fb9bd25a2238f701$var$isEmpty(obj) {
    return $fb9bd25a2238f701$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $fb9bd25a2238f701$var$TextareaAutosize = /*#__PURE__*/ $7fPBF.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value } = props, other = (0, $cFLic.default)(props, $fb9bd25a2238f701$var$_excluded);
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const textareaRef = $7fPBF.useRef(null);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(forwardedRef, textareaRef);
    const heightRef = $7fPBF.useRef(null);
    const hiddenTextareaRef = $7fPBF.useRef(null);
    const calculateTextareaStyles = $7fPBF.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $c1e4563498af7952$export$2e2bcd8739ae039)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $fb9bd25a2238f701$var$getStyleValue(computedStyle.paddingBottom) + $fb9bd25a2238f701$var$getStyleValue(computedStyle.paddingTop);
        const border = $fb9bd25a2238f701$var$getStyleValue(computedStyle.borderBottomWidth) + $fb9bd25a2238f701$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $fb9bd25a2238f701$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $7fPBF.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $fb9bd25a2238f701$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $7fPBF.useRef(-1);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        const debouncedHandleResize = (0, $c285f587ed4585eb$export$2e2bcd8739ae039)(syncHeight);
        const textarea = textareaRef == null ? void 0 : textareaRef.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $c1e4563498af7952$export$2e2bcd8739ae039)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", (0, $kY3Ke.default)({
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style
            }, other)),
            /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: (0, $kY3Ke.default)({}, $fb9bd25a2238f701$var$styles.shadow, style, {
                    paddingTop: 0,
                    paddingBottom: 0
                })
            })
        ]
    });
});
var $fb9bd25a2238f701$export$2e2bcd8739ae039 = $fb9bd25a2238f701$var$TextareaAutosize;


function $e570c333aacea667$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $f29d66cab44a33c0$var$FormControlContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $f29d66cab44a33c0$export$2e2bcd8739ae039 = $f29d66cab44a33c0$var$FormControlContext;



var $7fPBF = parcelRequire("7fPBF");

'use client';
function $1af6f86e160474f0$export$2e2bcd8739ae039() {
    return $7fPBF.useContext((0, $f29d66cab44a33c0$export$2e2bcd8739ae039));
}







'use client';
var $cfde3819487a0686$export$2e2bcd8739ae039 = (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039);



var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");





var $bbzbN = parcelRequire("bbzbN");
'use client';
function $a50e20ff7f02e09b$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ee13700d4d997375$export$2e2bcd8739ae039), (0, $kY3Ke.default)({}, props, {
        defaultTheme: (0, $726fe1d2377a5002$export$2e2bcd8739ae039),
        themeId: (0, $e35ef6915a224202$export$2e2bcd8739ae039)
    }));
}
var $a50e20ff7f02e09b$export$2e2bcd8739ae039 = $a50e20ff7f02e09b$var$GlobalStyles;


// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $5e9f5ca6e3e911fc$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $5e9f5ca6e3e911fc$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($5e9f5ca6e3e911fc$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $5e9f5ca6e3e911fc$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $5e9f5ca6e3e911fc$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}




function $2b15682cef07fc0a$export$ef57d5c8ca2278f6(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiInputBase', slot);
}
const $2b15682cef07fc0a$var$inputBaseClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $2b15682cef07fc0a$export$2e2bcd8739ae039 = $2b15682cef07fc0a$var$inputBaseClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $ba9f7182d6802613$var$_excluded = [
    "aria-describedby",
    "autoComplete",
    "autoFocus",
    "className",
    "color",
    "components",
    "componentsProps",
    "defaultValue",
    "disabled",
    "disableInjectingGlobalStyles",
    "endAdornment",
    "error",
    "fullWidth",
    "id",
    "inputComponent",
    "inputProps",
    "inputRef",
    "margin",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onClick",
    "onFocus",
    "onKeyDown",
    "onKeyUp",
    "placeholder",
    "readOnly",
    "renderSuffix",
    "rows",
    "size",
    "slotProps",
    "slots",
    "startAdornment",
    "type",
    "value"
];
const $ba9f7182d6802613$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $ba9f7182d6802613$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $ba9f7182d6802613$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $2b15682cef07fc0a$export$ef57d5c8ca2278f6), classes);
};
const $ba9f7182d6802613$export$298a043133d72a38 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $ba9f7182d6802613$export$965edad20a84fa75
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $2b15682cef07fc0a$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        }
    }, ownerState.multiline && (0, $kY3Ke.default)({
        padding: '4px 0 5px'
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }), ownerState.fullWidth && {
        width: '100%'
    }));
const $ba9f7182d6802613$export$a1ad29c901026019 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $ba9f7182d6802613$export$cf507b112810e72d
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = (0, $kY3Ke.default)({
        color: 'currentColor'
    }, theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    }, {
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    });
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return (0, $kY3Ke.default)({
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        // Fix IE11 width issue
        animationName: 'mui-auto-fill-cancel',
        animationDuration: '10ms',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholder,
        // IE11
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $2b15682cef07fc0a$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&:-ms-input-placeholder': placeholderHidden,
            // IE11
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus:-ms-input-placeholder': placeholderVisible,
            // IE11
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $2b15682cef07fc0a$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        '&:-webkit-autofill': {
            animationDuration: '5000s',
            animationName: 'mui-auto-fill'
        }
    }, ownerState.size === 'small' && {
        paddingTop: 1
    }, ownerState.multiline && {
        height: 'auto',
        resize: 'none',
        padding: 0,
        paddingTop: 0
    }, ownerState.type === 'search' && {
        // Improve type search style.
        MozAppearance: 'textfield'
    });
});
const $ba9f7182d6802613$var$inputGlobalStyles = /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a50e20ff7f02e09b$export$2e2bcd8739ae039), {
    styles: {
        '@keyframes mui-auto-fill': {
            from: {
                display: 'block'
            }
        },
        '@keyframes mui-auto-fill-cancel': {
            from: {
                display: 'block'
            }
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $ba9f7182d6802613$var$InputBase = /*#__PURE__*/ $7fPBF.forwardRef(function InputBase(inProps, ref) {
    var _slotProps$input;
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp } = props, other = (0, $cFLic.default)(props, $ba9f7182d6802613$var$_excluded);
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $7fPBF.useRef(value != null);
    const inputRef = $7fPBF.useRef();
    const handleInputRefWarning = $7fPBF.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $7fPBF.useState(false);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $7fPBF.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $7fPBF.useCallback((obj)=>{
        if ((0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        // Fix a bug with IE11 where the focus/blur events are triggered
        // while the component is disabled.
        if (fcs.disabled) {
            event.stopPropagation();
            return;
        }
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $diYUK.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $7fPBF.useEffect(()=>{
        checkDirty(inputRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = (0, $kY3Ke.default)({
            type: undefined,
            minRows: rows,
            maxRows: rows
        }, inputProps);
        else inputProps = (0, $kY3Ke.default)({
            type: undefined,
            maxRows: maxRows,
            minRows: minRows
        }, inputProps);
        InputComponent = (0, $fb9bd25a2238f701$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $7fPBF.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    });
    const classes = $ba9f7182d6802613$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $ba9f7182d6802613$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $ba9f7182d6802613$export$a1ad29c901026019;
    inputProps = (0, $kY3Ke.default)({}, inputProps, (_slotProps$input = slotProps.input) != null ? _slotProps$input : componentsProps.input);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            !disableInjectingGlobalStyles && $ba9f7182d6802613$var$inputGlobalStyles,
            /*#__PURE__*/ (0, $bbzbN.jsxs)(Root, (0, $kY3Ke.default)({}, rootProps, !(0, $b4522a0df256fb21$export$2e2bcd8739ae039)(Root) && {
                ownerState: (0, $kY3Ke.default)({}, ownerState, rootProps.ownerState)
            }, {
                ref: ref,
                onClick: handleClick
            }, other, {
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f29d66cab44a33c0$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)(Input, (0, $kY3Ke.default)({
                            ownerState: ownerState,
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type
                        }, inputProps, !(0, $b4522a0df256fb21$export$2e2bcd8739ae039)(Input) && {
                            as: InputComponent,
                            ownerState: (0, $kY3Ke.default)({}, ownerState, inputProps.ownerState)
                        }, {
                            ref: handleInputRef,
                            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        }))
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix((0, $kY3Ke.default)({}, fcs, {
                        startAdornment: startAdornment
                    })) : null
                ]
            }))
        ]
    });
});
var $ba9f7182d6802613$export$2e2bcd8739ae039 = $ba9f7182d6802613$var$InputBase;





var $kY3Ke = parcelRequire("kY3Ke");



function $aadd2b32ac43594b$export$cdb270390122322b(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiInput', slot);
}
const $aadd2b32ac43594b$var$inputClasses = (0, $kY3Ke.default)({}, (0, $2b15682cef07fc0a$export$2e2bcd8739ae039), (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiInput', [
    'root',
    'underline',
    'input'
]));
var $aadd2b32ac43594b$export$2e2bcd8739ae039 = $aadd2b32ac43594b$var$inputClasses;




var $bbzbN = parcelRequire("bbzbN");
'use client';
const $e0d49bb29c2f8b76$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $e0d49bb29c2f8b76$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $aadd2b32ac43594b$export$cdb270390122322b), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $e0d49bb29c2f8b76$var$InputRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $ba9f7182d6802613$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return (0, $kY3Ke.default)({
        position: 'relative'
    }, ownerState.formControl && {
        'label + &': {
            marginTop: 16
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).disabled}, .${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                borderBottom: `1px solid ${bottomLineColor}`
            }
        },
        [`&.${(0, $aadd2b32ac43594b$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    });
});
const $e0d49bb29c2f8b76$var$InputInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$a1ad29c901026019), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $ba9f7182d6802613$export$cf507b112810e72d)
})({});
const $e0d49bb29c2f8b76$var$Input = /*#__PURE__*/ $7fPBF.forwardRef(function Input(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $cFLic.default)(props, $e0d49bb29c2f8b76$var$_excluded);
    const classes = $e0d49bb29c2f8b76$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3wRTY.default)(slotProps != null ? slotProps : componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $e0d49bb29c2f8b76$var$InputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $e0d49bb29c2f8b76$var$InputInput;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ba9f7182d6802613$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$e0d49bb29c2f8b76$var$Input.muiName = 'Input';
var $e0d49bb29c2f8b76$export$2e2bcd8739ae039 = $e0d49bb29c2f8b76$var$Input;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");





var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");



var $mqrnX = parcelRequire("mqrnX");






function $d9914d0380157c73$export$24c1f8f60cbac79e(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiTypography', slot);
}
const $d9914d0380157c73$var$typographyClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $d9914d0380157c73$export$2e2bcd8739ae039 = $d9914d0380157c73$var$typographyClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $26f68e516ee75fc4$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $26f68e516ee75fc4$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $d9914d0380157c73$export$24c1f8f60cbac79e), classes);
};
const $26f68e516ee75fc4$export$140e2f5526d3cad8 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $26f68e516ee75fc4$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $26f68e516ee75fc4$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $26f68e516ee75fc4$var$transformDeprecatedColors = (color)=>{
    return $26f68e516ee75fc4$var$colorTransformations[color] || color;
};
const $26f68e516ee75fc4$var$Typography = /*#__PURE__*/ $7fPBF.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $26f68e516ee75fc4$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $mqrnX.default)((0, $kY3Ke.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $26f68e516ee75fc4$var$defaultVariantMapping } = props, other = (0, $cFLic.default)(props, $26f68e516ee75fc4$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $26f68e516ee75fc4$var$defaultVariantMapping[variant]) || 'span';
    const classes = $26f68e516ee75fc4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($26f68e516ee75fc4$export$140e2f5526d3cad8, (0, $kY3Ke.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
    }, other));
});
var $26f68e516ee75fc4$export$2e2bcd8739ae039 = $26f68e516ee75fc4$var$Typography;







function $3347e858a7e1bb40$export$4b135a4b3a6c4550(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiInputAdornment', slot);
}
const $3347e858a7e1bb40$var$inputAdornmentClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $3347e858a7e1bb40$export$2e2bcd8739ae039 = $3347e858a7e1bb40$var$inputAdornmentClasses;




var $bbzbN = parcelRequire("bbzbN");
'use client';
var $a1383c8904b71ac9$var$_span;
const $a1383c8904b71ac9$var$_excluded = [
    "children",
    "className",
    "component",
    "disablePointerEvents",
    "disableTypography",
    "position",
    "variant"
];
const $a1383c8904b71ac9$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $a1383c8904b71ac9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $3347e858a7e1bb40$export$4b135a4b3a6c4550), classes);
};
const $a1383c8904b71ac9$var$InputAdornmentRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $a1383c8904b71ac9$var$overridesResolver
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'flex',
        height: '0.01em',
        // Fix IE11 flexbox alignment. To remove at some point.
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active
    }, ownerState.variant === 'filled' && {
        // Styles applied to the root element if `variant="filled"`.
        [`&.${(0, $3347e858a7e1bb40$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $3347e858a7e1bb40$export$2e2bcd8739ae039).hiddenLabel})`]: {
            marginTop: 16
        }
    }, ownerState.position === 'start' && {
        // Styles applied to the root element if `position="start"`.
        marginRight: 8
    }, ownerState.position === 'end' && {
        // Styles applied to the root element if `position="end"`.
        marginLeft: 8
    }, ownerState.disablePointerEvents === true && {
        // Styles applied to the root element if `disablePointerEvents={true}`.
        pointerEvents: 'none'
    }));
const $a1383c8904b71ac9$var$InputAdornment = /*#__PURE__*/ $7fPBF.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp } = props, other = (0, $cFLic.default)(props, $a1383c8904b71ac9$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    });
    const classes = $a1383c8904b71ac9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f29d66cab44a33c0$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($a1383c8904b71ac9$var$InputAdornmentRoot, (0, $kY3Ke.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref
        }, other, {
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                color: "text.secondary",
                children: children
            }) : /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $a1383c8904b71ac9$var$_span || ($a1383c8904b71ac9$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "notranslate",
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        }))
    });
});
var $a1383c8904b71ac9$export$2e2bcd8739ae039 = $a1383c8904b71ac9$var$InputAdornment;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");




var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");



var $bbzbN = parcelRequire("bbzbN");
'use client';
var $ae700d9709d2b786$var$_span;
const $ae700d9709d2b786$var$_excluded = [
    "children",
    "classes",
    "className",
    "label",
    "notched"
];
const $ae700d9709d2b786$var$NotchedOutlineRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $0820e164eb5fbaff$export$2e2bcd8739ae039)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $ae700d9709d2b786$var$NotchedOutlineLegend = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $0820e164eb5fbaff$export$2e2bcd8739ae039)
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden'
    }, !ownerState.withLabel && {
        padding: 0,
        lineHeight: '11px',
        // sync with `height` in `legend` styles
        transition: theme.transitions.create('width', {
            duration: 150,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.withLabel && (0, $kY3Ke.default)({
        display: 'block',
        // Fix conflict with normalize.css and sanitize.css
        padding: 0,
        height: 11,
        // sync with `lineHeight` in `legend` styles
        fontSize: '0.75em',
        visibility: 'hidden',
        maxWidth: 0.01,
        transition: theme.transitions.create('max-width', {
            duration: 50,
            easing: theme.transitions.easing.easeOut
        }),
        whiteSpace: 'nowrap',
        '& > span': {
            paddingLeft: 5,
            paddingRight: 5,
            display: 'inline-block',
            opacity: 0,
            visibility: 'visible'
        }
    }, ownerState.notched && {
        maxWidth: '100%',
        transition: theme.transitions.create('max-width', {
            duration: 100,
            easing: theme.transitions.easing.easeOut,
            delay: 50
        })
    })));
function $ae700d9709d2b786$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $cFLic.default)(props, $ae700d9709d2b786$var$_excluded);
    const withLabel = label != null && label !== '';
    const ownerState = (0, $kY3Ke.default)({}, props, {
        notched: notched,
        withLabel: withLabel
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($ae700d9709d2b786$var$NotchedOutlineRoot, (0, $kY3Ke.default)({
        "aria-hidden": true,
        className: className,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($ae700d9709d2b786$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                children: label
            }) : $ae700d9709d2b786$var$_span || ($ae700d9709d2b786$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                className: "notranslate",
                children: "\u200B"
            }))
        })
    }));
}






var $kY3Ke = parcelRequire("kY3Ke");



function $fbe32ff46b8bf823$export$89922944c7227687(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiOutlinedInput', slot);
}
const $fbe32ff46b8bf823$var$outlinedInputClasses = (0, $kY3Ke.default)({}, (0, $2b15682cef07fc0a$export$2e2bcd8739ae039), (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));
var $fbe32ff46b8bf823$export$2e2bcd8739ae039 = $fbe32ff46b8bf823$var$outlinedInputClasses;





var $bbzbN = parcelRequire("bbzbN");
'use client';
const $50e7e9efec2c0b8c$var$_excluded = [
    "components",
    "fullWidth",
    "inputComponent",
    "label",
    "multiline",
    "notched",
    "slots",
    "type"
];
const $50e7e9efec2c0b8c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $fbe32ff46b8bf823$export$89922944c7227687), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $50e7e9efec2c0b8c$var$OutlinedInputRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $ba9f7182d6802613$export$965edad20a84fa75)
})(({ theme: theme, ownerState: ownerState })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return (0, $kY3Ke.default)({
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).focused} .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette[ownerState.color].main,
            borderWidth: 2
        },
        [`&.${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).error} .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        [`&.${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).disabled} .${(0, $fbe32ff46b8bf823$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.startAdornment && {
        paddingLeft: 14
    }, ownerState.endAdornment && {
        paddingRight: 14
    }, ownerState.multiline && (0, $kY3Ke.default)({
        padding: '16.5px 14px'
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }));
});
const $50e7e9efec2c0b8c$var$NotchedOutlineRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ae700d9709d2b786$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline',
    overridesResolver: (props, styles)=>styles.notchedOutline
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $50e7e9efec2c0b8c$var$OutlinedInputInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$a1ad29c901026019), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $ba9f7182d6802613$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        padding: '16.5px 14px'
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        padding: '8.5px 14px'
    }, ownerState.multiline && {
        padding: 0
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }));
const $50e7e9efec2c0b8c$var$OutlinedInput = /*#__PURE__*/ $7fPBF.forwardRef(function OutlinedInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input, _React$Fragment;
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, type: type = 'text' } = props, other = (0, $cFLic.default)(props, $50e7e9efec2c0b8c$var$_excluded);
    const classes = $50e7e9efec2c0b8c$var$useUtilityClasses(props);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    });
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $50e7e9efec2c0b8c$var$OutlinedInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $50e7e9efec2c0b8c$var$OutlinedInputInput;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ba9f7182d6802613$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $bbzbN.jsx)($50e7e9efec2c0b8c$var$NotchedOutlineRoot, {
                ownerState: ownerState,
                className: classes.notchedOutline,
                label: label != null && label !== '' && fcs.required ? _React$Fragment || (_React$Fragment = /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                })) : label,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: (0, $kY3Ke.default)({}, classes, {
            notchedOutline: null
        })
    }));
});
$50e7e9efec2c0b8c$var$OutlinedInput.muiName = 'Input';
var $50e7e9efec2c0b8c$export$2e2bcd8739ae039 = $50e7e9efec2c0b8c$var$OutlinedInput;




const $9b1289c7070ab5c1$var$BoardEdit = /*#__PURE__*/ (0, $7fPBF.forwardRef)((props, ref)=>{
    const titleMaxLength = 20;
    const contentMaxLength = 1000;
    const [titleLength, setTitleLength] = (0, $7fPBF.useState)(props.board ? props.board.title.length : 0);
    const [contentLength, setContentLengh] = (0, $7fPBF.useState)(props.board ? props.board.content.length : 0);
    const [boardItem, setBoardItem] = (0, $7fPBF.useState)({
        title: props.board ? props.board.title : '',
        content: props.board ? props.board.content : ''
    });
    const inputChanged = (event)=>{
        const { id: id, value: value } = event.target;
        setBoardItem((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, boardItem), {
            [id]: value
        }));
        if (id === 'title' && value !== undefined) setTitleLength(value.length);
        else if (id === 'content' && value !== undefined) setContentLengh(value.length);
    };
    (0, $7fPBF.useImperativeHandle)(ref, ()=>({
            update: ()=>{
                return updateBoard();
            }
        }));
    const updateBoard = ()=>{
        const updateItem = {
            title: boardItem.title,
            content: boardItem.content,
            writerId: localStorage.getItem((0, $2df1405d783f614e$export$212a8f1ea37518bd))
        };
        (0, $dc67bf4d9f1c69d7$export$2e2bcd8739ae039).updateBoard(updateItem, props.board ? props.board.boardNo : 0).then((r)=>r).catch((reason)=>console.log(reason));
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e0d49bb29c2f8b76$export$2e2bcd8739ae039), {
                className: 'b2_r w-100p h-22px mt-39px mb-24px',
                id: 'title',
                required: true,
                placeholder: "\uC81C\uBAA9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694",
                value: boardItem.title,
                inputProps: {
                    maxLength: titleMaxLength
                },
                endAdornment: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $a1383c8904b71ac9$export$2e2bcd8739ae039), {
                    className: 'c1_r',
                    position: "end",
                    children: [
                        titleLength,
                        "/",
                        titleMaxLength
                    ]
                }),
                onChange: inputChanged
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $50e7e9efec2c0b8c$export$2e2bcd8739ae039), {
                className: 'b2_r w-100p',
                style: {
                    flexDirection: 'column',
                    alignItems: 'flex-end'
                },
                id: 'content',
                required: true,
                placeholder: "\uB0B4\uC6A9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694",
                value: boardItem.content,
                rows: 10,
                multiline: true,
                inputProps: {
                    maxLength: contentMaxLength
                },
                endAdornment: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $a1383c8904b71ac9$export$2e2bcd8739ae039), {
                    className: 'c1_r',
                    position: "end",
                    children: [
                        contentLength,
                        "/",
                        contentMaxLength
                    ]
                }),
                onChange: inputChanged
            })
        ]
    });
});
var $9b1289c7070ab5c1$export$2e2bcd8739ae039 = $9b1289c7070ab5c1$var$BoardEdit;


const $d01f05945a6aa616$var$BoardDetailView = (props)=>{
    const handleOverlayClick = (0, $7fPBF.useCallback)(()=>{
        props.onClose();
    }, [
        props.onClose
    ]);
    const [isEditable, setIsEditable] = (0, $7fPBF.useState)(false);
    const [editing, setEditing] = (0, $7fPBF.useState)(false);
    const boardEditRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        var _props_board;
        if (((_props_board = props.board) === null || _props_board === void 0 ? void 0 : _props_board.writerId) == localStorage.getItem((0, $2df1405d783f614e$export$212a8f1ea37518bd))) setIsEditable(true);
        else setIsEditable(false);
    }, [
        props
    ]);
    const goToEdit = ()=>{
        setEditing(true);
    };
    const updateBoard = ()=>{
        if (boardEditRef.current) {
            boardEditRef.current.update();
            props.onReturn();
            handleOverlayClick();
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5f47bfd43cc47d77$export$2e2bcd8739ae039), {
                onClose: handleOverlayClick,
                title: "\uC0C1\uC138\uBCF4\uAE30"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: 'board',
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4ac626799ed465c3$export$2e2bcd8739ae039), {}),
                    editing ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9b1289c7070ab5c1$export$2e2bcd8739ae039), {
                        board: props.board,
                        ref: boardEditRef
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $81f71a07c181b281$export$2e2bcd8739ae039), {
                        board: props.board
                    })
                ]
            }),
            isEditable && !editing ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fd30181b78da18c2$export$2e2bcd8739ae039), {
                className: 'primary',
                title: "\uC218\uC815\uD558\uAE30",
                disabled: false,
                onClick: goToEdit
            }) : null,
            editing ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fd30181b78da18c2$export$2e2bcd8739ae039), {
                className: 'primary',
                title: "\uC800\uC7A5\uD558\uAE30",
                disabled: false,
                onClick: updateBoard
            }) : null
        ]
    });
};
var $d01f05945a6aa616$export$2e2bcd8739ae039 = $d01f05945a6aa616$var$BoardDetailView;


const $6b0f059b86dc0182$var$Transition = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Transition(props, ref) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a3f6f5762623b961$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        direction: "left",
        ref: ref
    }, props));
});
const $6b0f059b86dc0182$var$BoardListItem = (props)=>{
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false);
    const handleReturnClick = (0, $7fPBF.useCallback)(()=>{
        props.onReturn && props.onReturn();
    }, [
        props.onReturn
    ]);
    const handleClose = ()=>{
        setOpen(false);
    };
    const onClickEvent = ()=>{
        props.contents && setOpen(true);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: `flex ${props.index == 0 ? '' : 'border-top-gray'} ${props.heightClass}`,
        children: [
            props.leftIcon ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: 'mr-8px pt-22px',
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                    iconClass: props.leftIcon
                })
            }) : null,
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: `board-item w-100p`,
                onClick: onClickEvent,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: 'board-item-title',
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            className: 'flex-column',
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                    className: "b2_r",
                                    children: props.title
                                }),
                                props.nickName ? /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                    className: 'c1_r cl-gray04',
                                    children: props.nickName
                                }) : '',
                                props.subTitle ? /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                    className: 'c1_r cl-gray04',
                                    children: props.subTitle
                                }) : ''
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: `${props.rightContent === undefined ? '' : 'right-contents'}`,
                            children: props.rightContent
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7f096abd658f7c85$export$2e2bcd8739ae039), {
                fullScreen: true,
                open: open,
                onClose: handleClose,
                TransitionComponent: $6b0f059b86dc0182$var$Transition,
                children: props.type === 'boardDetail' && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d01f05945a6aa616$export$2e2bcd8739ae039), {
                    onClose: handleClose,
                    onReturn: handleReturnClick,
                    board: props === null || props === void 0 ? void 0 : props.detailProp
                })
            })
        ]
    });
};
var $6b0f059b86dc0182$export$2e2bcd8739ae039 = $6b0f059b86dc0182$var$BoardListItem;


const $97257e90552d81c1$var$Board = (props)=>{
    if (props.boardList.length === 0) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4c180b03f3e7cb44$export$2e2bcd8739ae039), {
            className: "no-board-list mb-18px",
            notification: "\uC791\uC131\uB41C \uAE00\uC774 \uC5C6\uC2B5\uB2C8\uB2E4"
        })
    });
    else return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            className: 'question-list',
            children: props.boardList.map((data, index)=>{
                return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6b0f059b86dc0182$export$2e2bcd8739ae039), {
                        index: index,
                        type: 'boardDetail',
                        title: data.title,
                        contents: data.content,
                        detailProp: data,
                        subTitle: data.regDt,
                        heightClass: 'h-88px',
                        nickName: data.writerNickName,
                        onReturn: ()=>props.onReturn(),
                        rightContent: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                            divClass: 'align-end',
                            iconClass: 'next w-20px h-20px'
                        })
                    })
                }, index);
            })
        })
    });
};
var $97257e90552d81c1$export$2e2bcd8739ae039 = $97257e90552d81c1$var$Board;





var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");











var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $5VCcJ = parcelRequire("5VCcJ");

var $8M6a3 = parcelRequire("8M6a3");
var $mqrnX = parcelRequire("mqrnX");


var $bbzbN = parcelRequire("bbzbN");
'use client';
const $bd7b6b8695507478$var$_excluded = [
    "className",
    "component"
];
function $bd7b6b8695507478$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $5VCcJ.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $8M6a3.default));
    const Box = /*#__PURE__*/ $7fPBF.forwardRef(function Box(inProps, ref) {
        const theme = (0, $328672c8d07e1c59$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $mqrnX.default)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $cFLic.default)(_extendSxProp, $bd7b6b8695507478$var$_excluded);
        return /*#__PURE__*/ (0, $bbzbN.jsx)(BoxRoot, (0, $kY3Ke.default)({
            as: component,
            ref: ref,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}







const $9dbabfa00f5ea67f$var$boxClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiBox', [
    'root'
]);
var $9dbabfa00f5ea67f$export$2e2bcd8739ae039 = $9dbabfa00f5ea67f$var$boxClasses;


'use client';
const $77ec199cefd4182a$var$defaultTheme = (0, $ca3239ce6bf6e490$export$2e2bcd8739ae039)();
const $77ec199cefd4182a$var$Box = (0, $bd7b6b8695507478$export$2e2bcd8739ae039)({
    themeId: (0, $e35ef6915a224202$export$2e2bcd8739ae039),
    defaultTheme: $77ec199cefd4182a$var$defaultTheme,
    defaultClassName: (0, $9dbabfa00f5ea67f$export$2e2bcd8739ae039).root,
    generateClassName: (0, $f37dfc12e5d89c96$export$2e2bcd8739ae039).generate
});
var $77ec199cefd4182a$export$2e2bcd8739ae039 = $77ec199cefd4182a$var$Box;



const $79d0143175d5363b$var$style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 270
};
const $79d0143175d5363b$var$Confirm = (props)=>{
    const handleClick = (0, $7fPBF.useCallback)(()=>{
        props.onClick();
    }, [
        props.onClick
    ]);
    const handleClose = (0, $7fPBF.useCallback)(()=>{
        props.onClose();
    }, [
        props.onClose
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            className: 'modal-dialog',
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a65b89a1133e1fe4$export$2e2bcd8739ae039), {
                open: props.isOpen,
                onClose: handleClose,
                "aria-describedby": "modal-modal-description",
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                    sx: $79d0143175d5363b$var$style,
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            id: "modal-modal-description",
                            className: 'modal-body',
                            children: [
                                props.title !== undefined ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                                    children: props.title
                                }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {}),
                                props.content
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            className: "modal-footer",
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                    className: 'modal-btn confirm-btn confirm-lbtn',
                                    onClick: handleClick,
                                    children: props.leftBtnContent
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                    className: 'modal-btn confirm-btn',
                                    onClick: handleClose,
                                    children: props.rightBtnContent
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
};
var $79d0143175d5363b$export$2e2bcd8739ae039 = $79d0143175d5363b$var$Confirm;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");



const $bff7cece80ddc6b9$var$BoardAddComplete = (props)=>{
    const handleOverlayClick = (0, $7fPBF.useCallback)(()=>props.onClose(), [
        props.onClose
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: 'no-content-wrapper',
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4ac626799ed465c3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                        iconClass: 'question-complete'
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                        className: 'text-center h5_l mt-35px',
                        children: "\uAC8C\uC2DC\uAE00\uC774 \uB4F1\uB85D\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fd30181b78da18c2$export$2e2bcd8739ae039), {
                title: "\uBAA9\uB85D\uC73C\uB85C \uB3CC\uC544\uAC00\uAE30",
                disabled: false,
                onClick: handleOverlayClick
            })
        ]
    });
};
var $bff7cece80ddc6b9$export$2e2bcd8739ae039 = $bff7cece80ddc6b9$var$BoardAddComplete;


const $d94f0b082b571fbc$var$Transition = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Transition(props, ref) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a3f6f5762623b961$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        direction: "left",
        ref: ref
    }, props));
});
const $d94f0b082b571fbc$var$BoardAdd = (props)=>{
    const handleOverlayClick = (0, $7fPBF.useCallback)(()=>props.onClose(), [
        props.onClose
    ]);
    const handleReturnClick = (0, $7fPBF.useCallback)(()=>{
        props.onReturn();
    }, [
        props.onReturn
    ]);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false);
    const titleMaxLength = 20;
    const contentMaxLength = 1000;
    const [titleLength, setTitleLength] = (0, $7fPBF.useState)(0);
    const [contentLength, setContentLengh] = (0, $7fPBF.useState)(0);
    const [boardItem, setBoardItem] = (0, $7fPBF.useState)({
        title: "",
        content: ""
    });
    const [registItem, setRegistItem] = (0, $7fPBF.useState)();
    let registFlag = false;
    const [isOpen, setIsOpen] = (0, $7fPBF.useState)(false);
    const [regable] = (0, $7fPBF.useState)((0, $33eb00f42ea63933$export$2e2bcd8739ae039).getLocalStorage((0, $2df1405d783f614e$export$212a8f1ea37518bd)) === '1');
    (0, $7fPBF.useEffect)(()=>{
        const unlistenHistoryEvent = (0, $82bcba16c3ce4448$export$55abd4691b317664).listen(({ action: action })=>{
            if (action === 'POP') checkIsChanged();
        });
        return unlistenHistoryEvent;
    }, [
        (0, $82bcba16c3ce4448$export$55abd4691b317664)
    ]);
    const checkIsChanged = ()=>{
        if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(boardItem.title) || (0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(boardItem.content)) setIsOpen(true);
        else handleOverlayClick();
    };
    const inputChanged = (event)=>{
        const { id: id, value: value } = event.target;
        setBoardItem((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, boardItem), {
            [id]: value
        }));
        if (id === 'title' && value !== undefined) setTitleLength(value.length);
        else if (id === 'content' && value !== undefined) setContentLengh(value.length);
    };
    const { refetch: postBoard } = (0, $d8deb3a6a62b947e$export$dd0a697e1782aedd)([
        'postBoard'
    ], ()=>(0, $dc67bf4d9f1c69d7$export$2e2bcd8739ae039).postBoard(registItem), {
        onSuccess: (v)=>{
            setOpen(true);
        }
    });
    const registBoard = ()=>{
        const userId = (0, $33eb00f42ea63933$export$2e2bcd8739ae039).getLocalStorage((0, $2df1405d783f614e$export$212a8f1ea37518bd));
        setRegistItem({
            title: boardItem.title,
            content: boardItem.content,
            writerId: userId
        });
    };
    (0, $7fPBF.useEffect)(()=>{
        if (registItem !== undefined) {
            if (registFlag) return;
            registFlag = true;
            postBoard().then((r)=>{
                registFlag = false;
                return Promise;
            }).catch((reason)=>{
                console.log(reason);
            });
        }
    }, [
        registItem
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5f47bfd43cc47d77$export$2e2bcd8739ae039), {
                onClose: checkIsChanged,
                title: "\uBB38\uC758\uB4F1\uB85D"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: 'board',
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4ac626799ed465c3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e0d49bb29c2f8b76$export$2e2bcd8739ae039), {
                        className: 'b2_r w-100p h-22px mt-39px mb-24px',
                        id: 'title',
                        required: true,
                        placeholder: "\uC81C\uBAA9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694",
                        inputProps: {
                            maxLength: titleMaxLength
                        },
                        endAdornment: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $a1383c8904b71ac9$export$2e2bcd8739ae039), {
                            className: 'c1_r',
                            position: "end",
                            children: [
                                titleLength,
                                "/",
                                titleMaxLength
                            ]
                        }),
                        onChange: inputChanged
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $50e7e9efec2c0b8c$export$2e2bcd8739ae039), {
                        className: 'b2_r w-100p',
                        style: {
                            flexDirection: 'column',
                            alignItems: 'flex-end'
                        },
                        id: 'content',
                        required: true,
                        placeholder: "\uB0B4\uC6A9\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694",
                        rows: 10,
                        multiline: true,
                        inputProps: {
                            maxLength: contentMaxLength
                        },
                        endAdornment: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $a1383c8904b71ac9$export$2e2bcd8739ae039), {
                            className: 'c1_r',
                            position: "end",
                            children: [
                                contentLength,
                                "/",
                                contentMaxLength
                            ]
                        }),
                        onChange: inputChanged
                    })
                ]
            }),
            boardItem.title === '' || boardItem.content === '' ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fd30181b78da18c2$export$2e2bcd8739ae039), {
                className: 'primary',
                disabled: true,
                title: "\uAE00 \uB4F1\uB85D\uD558\uAE30"
            }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fd30181b78da18c2$export$2e2bcd8739ae039), {
                className: 'primary',
                disabled: !regable,
                title: "\uAE00 \uB4F1\uB85D\uD558\uAE30",
                onClick: registBoard
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7f096abd658f7c85$export$2e2bcd8739ae039), {
                fullScreen: true,
                open: open,
                onClose: handleReturnClick,
                TransitionComponent: $d94f0b082b571fbc$var$Transition,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bff7cece80ddc6b9$export$2e2bcd8739ae039), {
                    onClose: handleReturnClick
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $79d0143175d5363b$export$2e2bcd8739ae039), {
                content: /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                    children: [
                        "\uC791\uC131 \uC911\uC778 \uB0B4\uC6A9\uC774 \uC0AC\uB77C\uC9D1\uB2C8\uB2E4",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        "\uADF8\uB798\uB3C4 \uB098\uAC00\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"
                    ]
                }),
                title: undefined,
                leftBtnContent: "\uC544\uB2C8\uC624",
                rightBtnContent: "\uB124",
                isOpen: isOpen,
                onClick: ()=>setIsOpen(false),
                onClose: ()=>props.onClose()
            })
        ]
    });
};
var $d94f0b082b571fbc$export$2e2bcd8739ae039 = $d94f0b082b571fbc$var$BoardAdd;




const $c2dc123a54a47ffb$var$Transition = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Transition(props, ref) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a3f6f5762623b961$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        direction: "left",
        ref: ref
    }, props));
});
const $c2dc123a54a47ffb$var$BoardView = (props)=>{
    const handleOverlayClick = (0, $7fPBF.useCallback)(()=>props.onClose(), [
        props.onClose
    ]);
    const handleReturnClick = (0, $7fPBF.useCallback)(()=>{
        handleClose();
        initData();
    }, [
        props.onClose
    ]);
    const handleEditComplete = (0, $7fPBF.useCallback)(()=>{
        initData();
    }, [
        props.onClose
    ]);
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false);
    const [regable] = (0, $7fPBF.useState)((0, $33eb00f42ea63933$export$2e2bcd8739ae039).getLocalStorage((0, $2df1405d783f614e$export$212a8f1ea37518bd)) === '1');
    const [boardList, setBoardList] = (0, $7fPBF.useState)([]);
    const { refetch: getBoardList } = (0, $d8deb3a6a62b947e$export$dd0a697e1782aedd)([
        'getBoardList'
    ], ()=>(0, $dc67bf4d9f1c69d7$export$2e2bcd8739ae039).getBoardList(), {
        onSuccess: (v)=>{
            console.log(v);
            setBoardList(v ? v : []);
        }
    });
    const initData = ()=>{
        getBoardList().then((r)=>{
            return Promise;
        }).catch((reason)=>{
            console.log(reason);
        });
    };
    (0, $7fPBF.useEffect)(()=>{
        initData();
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        console.log("\uBCC0\uD654\uAC10\uC9C0");
    }, [
        boardList
    ]);
    const handleClickOpen = ()=>{
        setOpen(true);
    };
    const handleClose = ()=>{
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5f47bfd43cc47d77$export$2e2bcd8739ae039), {
                title: "\uAE00 \uBAA9\uB85D",
                onClose: handleOverlayClick
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: 'board',
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4ac626799ed465c3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $97257e90552d81c1$export$2e2bcd8739ae039), {
                        boardList: boardList,
                        onReturn: handleEditComplete
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fd30181b78da18c2$export$2e2bcd8739ae039), {
                title: "\uAE00 \uB4F1\uB85D\uD558\uAE30",
                disabled: !regable,
                onClick: handleClickOpen
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7f096abd658f7c85$export$2e2bcd8739ae039), {
                fullScreen: true,
                open: open,
                onClose: handleClose,
                TransitionComponent: $c2dc123a54a47ffb$var$Transition,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d94f0b082b571fbc$export$2e2bcd8739ae039), {
                    onClose: handleClose,
                    onReturn: handleReturnClick
                })
            })
        ]
    });
};
var $c2dc123a54a47ffb$export$2e2bcd8739ae039 = $c2dc123a54a47ffb$var$BoardView;





var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");









var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $3wRTY = parcelRequire("3wRTY");







var $kY3Ke = parcelRequire("kY3Ke");



function $c2b262889cde4af1$export$3331e419f1a48437(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiFilledInput', slot);
}
const $c2b262889cde4af1$var$filledInputClasses = (0, $kY3Ke.default)({}, (0, $2b15682cef07fc0a$export$2e2bcd8739ae039), (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiFilledInput', [
    'root',
    'underline',
    'input'
]));
var $c2b262889cde4af1$export$2e2bcd8739ae039 = $c2b262889cde4af1$var$filledInputClasses;




var $bbzbN = parcelRequire("bbzbN");
'use client';
const $faf35b44bb61ebfd$var$_excluded = [
    "disableUnderline",
    "components",
    "componentsProps",
    "fullWidth",
    "hiddenLabel",
    "inputComponent",
    "multiline",
    "slotProps",
    "slots",
    "type"
];
const $faf35b44bb61ebfd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $c2b262889cde4af1$export$3331e419f1a48437), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $faf35b44bb61ebfd$var$FilledInputRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $ba9f7182d6802613$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return (0, $kY3Ke.default)({
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        }
    }, !ownerState.disableUnderline && {
        '&::after': {
            borderBottom: `2px solid ${(_palette = (theme.vars || theme).palette[ownerState.color || 'primary']) == null ? void 0 : _palette.main}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '""',
            position: 'absolute',
            right: 0,
            transform: 'scaleX(0)',
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shorter,
                easing: theme.transitions.easing.easeOut
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).focused}:after`]: {
            // translateX(0) is a workaround for Safari transform scale bug
            // See https://github.com/mui/material-ui/issues/31766
            transform: 'scaleX(1) translateX(0)'
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).error}`]: {
            '&::before, &::after': {
                borderBottomColor: (theme.vars || theme).palette.error.main
            }
        },
        '&::before': {
            borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
            left: 0,
            bottom: 0,
            // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
            content: '"\\00a0"',
            position: 'absolute',
            right: 0,
            transition: theme.transitions.create('border-bottom-color', {
                duration: theme.transitions.duration.shorter
            }),
            pointerEvents: 'none' // Transparent to the hover style.
        },
        [`&:hover:not(.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).disabled}, .${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).error}):before`]: {
            borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
        },
        [`&.${(0, $c2b262889cde4af1$export$2e2bcd8739ae039).disabled}:before`]: {
            borderBottomStyle: 'dotted'
        }
    }, ownerState.startAdornment && {
        paddingLeft: 12
    }, ownerState.endAdornment && {
        paddingRight: 12
    }, ownerState.multiline && (0, $kY3Ke.default)({
        padding: '25px 12px 8px'
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }));
});
const $faf35b44bb61ebfd$var$FilledInputInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $ba9f7182d6802613$export$a1ad29c901026019), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $ba9f7182d6802613$export$cf507b112810e72d)
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12
    }, !theme.vars && {
        '&:-webkit-autofill': {
            WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
            WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
            caretColor: theme.palette.mode === 'light' ? null : '#fff',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        }
    }, theme.vars && {
        '&:-webkit-autofill': {
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
        },
        [theme.getColorSchemeSelector('dark')]: {
            '&:-webkit-autofill': {
                WebkitBoxShadow: '0 0 0 100px #266798 inset',
                WebkitTextFillColor: '#fff',
                caretColor: '#fff'
            }
        }
    }, ownerState.size === 'small' && {
        paddingTop: 21,
        paddingBottom: 4
    }, ownerState.hiddenLabel && {
        paddingTop: 16,
        paddingBottom: 17
    }, ownerState.startAdornment && {
        paddingLeft: 0
    }, ownerState.endAdornment && {
        paddingRight: 0
    }, ownerState.hiddenLabel && ownerState.size === 'small' && {
        paddingTop: 8,
        paddingBottom: 9
    }, ownerState.multiline && {
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0
    }));
const $faf35b44bb61ebfd$var$FilledInput = /*#__PURE__*/ $7fPBF.forwardRef(function FilledInput(inProps, ref) {
    var _ref, _slots$root, _ref2, _slots$input;
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text' } = props, other = (0, $cFLic.default)(props, $faf35b44bb61ebfd$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    });
    const classes = $faf35b44bb61ebfd$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = (slotProps != null ? slotProps : componentsPropsProp) ? (0, $3wRTY.default)(filledInputComponentsProps, slotProps != null ? slotProps : componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = (_ref = (_slots$root = slots.root) != null ? _slots$root : components.Root) != null ? _ref : $faf35b44bb61ebfd$var$FilledInputRoot;
    const InputSlot = (_ref2 = (_slots$input = slots.input) != null ? _slots$input : components.Input) != null ? _ref2 : $faf35b44bb61ebfd$var$FilledInputInput;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ba9f7182d6802613$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        componentsProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type
    }, other, {
        classes: classes
    }));
});
$faf35b44bb61ebfd$var$FilledInput.muiName = 'Input';
var $faf35b44bb61ebfd$export$2e2bcd8739ae039 = $faf35b44bb61ebfd$var$FilledInput;




var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");






var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");










function $94ffd68a66aaae7e$export$f7d501e40371cd17(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiFormLabel', slot);
}
const $94ffd68a66aaae7e$var$formLabelClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $94ffd68a66aaae7e$export$2e2bcd8739ae039 = $94ffd68a66aaae7e$var$formLabelClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $90370d1df15229dd$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "required"
];
const $90370d1df15229dd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $94ffd68a66aaae7e$export$f7d501e40371cd17), classes);
};
const $90370d1df15229dd$export$aa5bc7f8a4705b27 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $kY3Ke.default)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.body1, {
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).focused}`]: {
            color: (theme.vars || theme).palette[ownerState.color].main
        },
        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $90370d1df15229dd$var$AsteriskComponent = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk',
    overridesResolver: (props, styles)=>styles.asterisk
})(({ theme: theme })=>({
        [`&.${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }));
const $90370d1df15229dd$var$FormLabel = /*#__PURE__*/ $7fPBF.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, component: component = 'label' } = props, other = (0, $cFLic.default)(props, $90370d1df15229dd$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $90370d1df15229dd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($90370d1df15229dd$export$aa5bc7f8a4705b27, (0, $kY3Ke.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $bbzbN.jsxs)($90370d1df15229dd$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    }));
});
var $90370d1df15229dd$export$2e2bcd8739ae039 = $90370d1df15229dd$var$FormLabel;







function $2b0d2ae144238f59$export$c1c4b4545ad2ea5f(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiInputLabel', slot);
}
const $2b0d2ae144238f59$var$inputLabelClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $2b0d2ae144238f59$export$2e2bcd8739ae039 = $2b0d2ae144238f59$var$inputLabelClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $fcd80672e9993aad$var$_excluded = [
    "disableAnimation",
    "margin",
    "shrink",
    "variant",
    "className"
];
const $fcd80672e9993aad$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'normal' && `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $2b0d2ae144238f59$export$c1c4b4545ad2ea5f), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $fcd80672e9993aad$var$InputLabelRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $90370d1df15229dd$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $94ffd68a66aaae7e$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%'
    }, ownerState.formControl && {
        position: 'absolute',
        left: 0,
        top: 0,
        // slight alteration to spec spacing to match visual spec result
        transform: 'translate(0, 20px) scale(1)'
    }, ownerState.size === 'small' && {
        // Compensation for the `Input.inputSizeSmall` style.
        transform: 'translate(0, 17px) scale(1)'
    }, ownerState.shrink && {
        transform: 'translate(0, -1.5px) scale(0.75)',
        transformOrigin: 'top left',
        maxWidth: '133%'
    }, !ownerState.disableAnimation && {
        transition: theme.transitions.create([
            'color',
            'transform',
            'max-width'
        ], {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        })
    }, ownerState.variant === 'filled' && (0, $kY3Ke.default)({
        // Chrome's autofill feature gives the input field a yellow background.
        // Since the input field is behind the label in the HTML tree,
        // the input field is drawn last and hides the label with an opaque background color.
        // zIndex: 1 will raise the label above opaque background-colors of input.
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(12px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 13px) scale(1)'
    }, ownerState.shrink && (0, $kY3Ke.default)({
        userSelect: 'none',
        pointerEvents: 'auto',
        transform: 'translate(12px, 7px) scale(0.75)',
        maxWidth: 'calc(133% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(12px, 4px) scale(0.75)'
    })), ownerState.variant === 'outlined' && (0, $kY3Ke.default)({
        // see comment above on filled.zIndex
        zIndex: 1,
        pointerEvents: 'none',
        transform: 'translate(14px, 16px) scale(1)',
        maxWidth: 'calc(100% - 24px)'
    }, ownerState.size === 'small' && {
        transform: 'translate(14px, 9px) scale(1)'
    }, ownerState.shrink && {
        userSelect: 'none',
        pointerEvents: 'auto',
        // Theoretically, we should have (8+5)*2/0.75 = 34px
        // but it feels a better when it bleeds a bit on the left, so 32px.
        maxWidth: 'calc(133% - 32px)',
        transform: 'translate(14px, -9px) scale(0.75)'
    })));
const $fcd80672e9993aad$var$InputLabel = /*#__PURE__*/ $7fPBF.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, shrink: shrinkProp, className: className } = props, other = (0, $cFLic.default)(props, $fcd80672e9993aad$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    });
    const classes = $fcd80672e9993aad$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($fcd80672e9993aad$var$InputLabelRoot, (0, $kY3Ke.default)({
        "data-shrink": shrink,
        ownerState: ownerState,
        ref: ref,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
    }, other, {
        classes: classes
    }));
});
var $fcd80672e9993aad$export$2e2bcd8739ae039 = $fcd80672e9993aad$var$InputLabel;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");
function $de2da0b284b1a3c2$export$2e2bcd8739ae039(element, muiNames) {
    var _muiName, _element$type;
    return /*#__PURE__*/ $7fPBF.isValidElement(element) && muiNames.indexOf(// relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (_muiName = element.type.muiName) != null ? _muiName : (_element$type = element.type) == null || (_element$type = _element$type._payload) == null || (_element$type = _element$type.value) == null ? void 0 : _element$type.muiName) !== -1;
}


var $6926d37cb7ff7774$export$2e2bcd8739ae039 = (0, $de2da0b284b1a3c2$export$2e2bcd8739ae039);





function $6fa629ce89e8ad57$export$149c8b8bab2289d1(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiFormControl', slot);
}
const $6fa629ce89e8ad57$var$formControlClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $6fa629ce89e8ad57$export$2e2bcd8739ae039 = $6fa629ce89e8ad57$var$formControlClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $26a8e925f0aa9998$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "disabled",
    "error",
    "focused",
    "fullWidth",
    "hiddenLabel",
    "margin",
    "required",
    "size",
    "variant"
];
const $26a8e925f0aa9998$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $6fa629ce89e8ad57$export$149c8b8bab2289d1), classes);
};
const $26a8e925f0aa9998$var$FormControlRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: ({ ownerState: ownerState }, styles)=>{
        return (0, $kY3Ke.default)({}, styles.root, styles[`margin${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'inline-flex',
        flexDirection: 'column',
        position: 'relative',
        // Reset fieldset default style.
        minWidth: 0,
        padding: 0,
        margin: 0,
        border: 0,
        verticalAlign: 'top'
    }, ownerState.margin === 'normal' && {
        marginTop: 16,
        marginBottom: 8
    }, ownerState.margin === 'dense' && {
        marginTop: 8,
        marginBottom: 4
    }, ownerState.fullWidth && {
        width: '100%'
    }));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $26a8e925f0aa9998$var$FormControl = /*#__PURE__*/ $7fPBF.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined' } = props, other = (0, $cFLic.default)(props, $26a8e925f0aa9998$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    });
    const classes = $26a8e925f0aa9998$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $5e9f5ca6e3e911fc$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $7fPBF.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $7fPBF.Children.forEach(children, (child)=>{
            if (!(0, $6926d37cb7ff7774$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)(child.props, true) || (0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $7fPBF.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const childContext = $7fPBF.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onEmpty: ()=>{
                setFilled(false);
            },
            onFilled: ()=>{
                setFilled(true);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f29d66cab44a33c0$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($26a8e925f0aa9998$var$FormControlRoot, (0, $kY3Ke.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref
        }, other, {
            children: children
        }))
    });
});
var $26a8e925f0aa9998$export$2e2bcd8739ae039 = $26a8e925f0aa9998$var$FormControl;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");









function $10a7abfeb1405549$export$a394fa61b1d583a9(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiFormHelperText', slot);
}
const $10a7abfeb1405549$var$formHelperTextClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $10a7abfeb1405549$export$2e2bcd8739ae039 = $10a7abfeb1405549$var$formHelperTextClasses;




var $bbzbN = parcelRequire("bbzbN");
'use client';
var $0321a2cb63129955$var$_span;
const $0321a2cb63129955$var$_excluded = [
    "children",
    "className",
    "component",
    "disabled",
    "error",
    "filled",
    "focused",
    "margin",
    "required",
    "variant"
];
const $0321a2cb63129955$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $10a7abfeb1405549$export$a394fa61b1d583a9), classes);
};
const $0321a2cb63129955$var$FormHelperTextRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        color: (theme.vars || theme).palette.text.secondary
    }, theme.typography.caption, {
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $10a7abfeb1405549$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $10a7abfeb1405549$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    }, ownerState.size === 'small' && {
        marginTop: 4
    }, ownerState.contained && {
        marginLeft: 14,
        marginRight: 14
    }));
const $0321a2cb63129955$var$FormHelperText = /*#__PURE__*/ $7fPBF.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p' } = props, other = (0, $cFLic.default)(props, $0321a2cb63129955$var$_excluded);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    });
    const classes = $0321a2cb63129955$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($0321a2cb63129955$var$FormHelperTextRoot, (0, $kY3Ke.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other, {
        children: children === ' ' ? $0321a2cb63129955$var$_span || ($0321a2cb63129955$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: "notranslate",
            children: "\u200B"
        })) : children
    }));
});
var $0321a2cb63129955$export$2e2bcd8739ae039 = $0321a2cb63129955$var$FormHelperText;



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");



var $3wRTY = parcelRequire("3wRTY");


var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $diYUK = parcelRequire("diYUK");

var $7fPBF = parcelRequire("7fPBF");







var $9502daaf177b272b$export$2e2bcd8739ae039 = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039);




var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");








var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");




var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * @ignore - internal component.
 */ const $94e271e17fd22222$var$ListContext = /*#__PURE__*/ $7fPBF.createContext({});
var $94e271e17fd22222$export$2e2bcd8739ae039 = $94e271e17fd22222$var$ListContext;




function $d56e26d1d10ff784$export$c6bd6795ed6e3203(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiList', slot);
}
const $d56e26d1d10ff784$var$listClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $d56e26d1d10ff784$export$2e2bcd8739ae039 = $d56e26d1d10ff784$var$listClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $fb70212a09473954$var$_excluded = [
    "children",
    "className",
    "component",
    "dense",
    "disablePadding",
    "subheader"
];
const $fb70212a09473954$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $d56e26d1d10ff784$export$c6bd6795ed6e3203), classes);
};
const $fb70212a09473954$var$ListRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        listStyle: 'none',
        margin: 0,
        padding: 0,
        position: 'relative'
    }, !ownerState.disablePadding && {
        paddingTop: 8,
        paddingBottom: 8
    }, ownerState.subheader && {
        paddingTop: 0
    }));
const $fb70212a09473954$var$List = /*#__PURE__*/ $7fPBF.forwardRef(function List(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader } = props, other = (0, $cFLic.default)(props, $fb70212a09473954$var$_excluded);
    const context = $7fPBF.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        dense: dense,
        disablePadding: disablePadding
    });
    const classes = $fb70212a09473954$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)($fb70212a09473954$var$ListRoot, (0, $kY3Ke.default)({
            as: component,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                subheader,
                children
            ]
        }))
    });
});
var $fb70212a09473954$export$2e2bcd8739ae039 = $fb70212a09473954$var$List;



var $15bf9ba27fbfc052$export$2e2bcd8739ae039 = (0, $5f729e410b274c00$export$2e2bcd8739ae039);





var $bbzbN = parcelRequire("bbzbN");
'use client';
const $9cb95136bc90d127$var$_excluded = [
    "actions",
    "autoFocus",
    "autoFocusItem",
    "children",
    "className",
    "disabledItemsFocusable",
    "disableListWrap",
    "onKeyDown",
    "variant"
];
function $9cb95136bc90d127$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $9cb95136bc90d127$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $9cb95136bc90d127$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.indexOf(textCriteria.keys.join('')) === 0;
}
function $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$9cb95136bc90d127$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $9cb95136bc90d127$var$MenuList = /*#__PURE__*/ $7fPBF.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu' } = props, other = (0, $cFLic.default)(props, $9cb95136bc90d127$var$_excluded);
    const listRef = $7fPBF.useRef(null);
    const textCriteriaRef = $7fPBF.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $15bf9ba27fbfc052$export$2e2bcd8739ae039)((0, $9502daaf177b272b$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $9502daaf177b272b$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $9cb95136bc90d127$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $9cb95136bc90d127$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $9cb95136bc90d127$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $9cb95136bc90d127$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $9cb95136bc90d127$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $7fPBF.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $7fPBF.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fb70212a09473954$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1
    }, other, {
        children: items
    }));
});
var $9cb95136bc90d127$export$2e2bcd8739ae039 = $9cb95136bc90d127$var$MenuList;



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

















var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
'use client';
const $890b21ec8e20082a$var$UNINITIALIZED = {};
function $890b21ec8e20082a$export$2e2bcd8739ae039(init, initArg) {
    const ref = $7fPBF.useRef($890b21ec8e20082a$var$UNINITIALIZED);
    if (ref.current === $890b21ec8e20082a$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $7fPBF = parcelRequire("7fPBF");
'use client';
const $1d2095ad20314533$var$EMPTY = [];
function $1d2095ad20314533$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $7fPBF.useEffect(fn, $1d2095ad20314533$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $9a1088a9a7141b09$export$786b4da70f00938b {
    static create() {
        return new $9a1088a9a7141b09$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
}
function $9a1088a9a7141b09$export$2e2bcd8739ae039() {
    const timeout = (0, $890b21ec8e20082a$export$2e2bcd8739ae039)($9a1088a9a7141b09$export$786b4da70f00938b.create).current;
    (0, $1d2095ad20314533$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}









var $bbzbN = parcelRequire("bbzbN");
'use client';
const $7ec2c0aa92d4d29c$var$_excluded = [
    "addEndListener",
    "appear",
    "children",
    "easing",
    "in",
    "onEnter",
    "onEntered",
    "onEntering",
    "onExit",
    "onExited",
    "onExiting",
    "style",
    "timeout",
    "TransitionComponent"
];
function $7ec2c0aa92d4d29c$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $7ec2c0aa92d4d29c$var$styles = {
    entering: {
        opacity: 1,
        transform: $7ec2c0aa92d4d29c$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $7ec2c0aa92d4d29c$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $7ec2c0aa92d4d29c$var$Grow = /*#__PURE__*/ $7fPBF.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $623678cbb6daf054$export$2e2bcd8739ae039) } = props, other = (0, $cFLic.default)(props, $7ec2c0aa92d4d29c$var$_excluded);
    const timer = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    const autoTimeout = $7fPBF.useRef();
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const nodeRef = $7fPBF.useRef(null);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(nodeRef, (0, $8971fd60a8b100cf$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $1ae2edacd7be6319$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $7ec2c0aa92d4d29c$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $1ae2edacd7be6319$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $7ec2c0aa92d4d29c$var$isWebKit154 ? duration : duration * 0.666,
                delay: $7ec2c0aa92d4d29c$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $7ec2c0aa92d4d29c$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout
    }, other, {
        children: (state, childProps)=>{
            return /*#__PURE__*/ $7fPBF.cloneElement(children, (0, $kY3Ke.default)({
                style: (0, $kY3Ke.default)({
                    opacity: 0,
                    transform: $7ec2c0aa92d4d29c$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined
                }, $7ec2c0aa92d4d29c$var$styles[state], style, children.props.style),
                ref: handleRef
            }, childProps));
        }
    }));
});
$7ec2c0aa92d4d29c$var$Grow.muiSupportAuto = true;
var $7ec2c0aa92d4d29c$export$2e2bcd8739ae039 = $7ec2c0aa92d4d29c$var$Grow;






function $a5a68170633995c3$export$88f455dd56c95edb(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiPopover', slot);
}
const $a5a68170633995c3$var$popoverClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiPopover', [
    'root',
    'paper'
]);
var $a5a68170633995c3$export$2e2bcd8739ae039 = $a5a68170633995c3$var$popoverClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $77b3b30833fb8c12$var$_excluded = [
    "onEntering"
], $77b3b30833fb8c12$var$_excluded2 = [
    "action",
    "anchorEl",
    "anchorOrigin",
    "anchorPosition",
    "anchorReference",
    "children",
    "className",
    "container",
    "elevation",
    "marginThreshold",
    "open",
    "PaperProps",
    "slots",
    "slotProps",
    "transformOrigin",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps",
    "disableScrollLock"
], $77b3b30833fb8c12$var$_excluded3 = [
    "slotProps"
];
function $77b3b30833fb8c12$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $77b3b30833fb8c12$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $77b3b30833fb8c12$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $77b3b30833fb8c12$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $77b3b30833fb8c12$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $a5a68170633995c3$export$88f455dd56c95edb), classes);
};
const $77b3b30833fb8c12$export$bcce13685275fc99 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $a65b89a1133e1fe4$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $77b3b30833fb8c12$export$821346c38a2d9390 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $77b3b30833fb8c12$var$Popover = /*#__PURE__*/ $7fPBF.forwardRef(function Popover(inProps, ref) {
    var _slotProps$paper, _slots$root, _slots$paper;
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: slots, slotProps: slotProps, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent = (0, $7ec2c0aa92d4d29c$export$2e2bcd8739ae039), transitionDuration: transitionDurationProp = 'auto', TransitionProps: { onEntering: onEntering } = {}, disableScrollLock: disableScrollLock = false } = props, TransitionProps = (0, $cFLic.default)(props.TransitionProps, $77b3b30833fb8c12$var$_excluded), other = (0, $cFLic.default)(props, $77b3b30833fb8c12$var$_excluded2);
    const externalPaperSlotProps = (_slotProps$paper = slotProps == null ? void 0 : slotProps.paper) != null ? _slotProps$paper : PaperPropsProp;
    const paperRef = $7fPBF.useRef();
    const handlePaperRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(paperRef, externalPaperSlotProps.ref);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        externalPaperSlotProps: externalPaperSlotProps,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    });
    const classes = $77b3b30833fb8c12$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $7fPBF.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $77b3b30833fb8c12$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $9502daaf177b272b$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $77b3b30833fb8c12$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $77b3b30833fb8c12$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $7fPBF.useCallback((elemRect)=>{
        return {
            vertical: $77b3b30833fb8c12$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $77b3b30833fb8c12$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $7fPBF.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $77b3b30833fb8c12$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $77b3b30833fb8c12$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $7fPBF.useState(open);
    const setPositioningStyles = $7fPBF.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.top = positioning.top;
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $7fPBF.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = (element, isAppearing)=>{
        if (onEntering) onEntering(element, isAppearing);
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $7fPBF.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $7fPBF.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $3aadd01758bd49c1$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)(anchorEl);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $9502daaf177b272b$export$2e2bcd8739ae039)($77b3b30833fb8c12$var$resolveAnchorEl(anchorEl)).body : undefined);
    const RootSlot = (_slots$root = slots == null ? void 0 : slots.root) != null ? _slots$root : $77b3b30833fb8c12$export$bcce13685275fc99;
    const PaperSlot = (_slots$paper = slots == null ? void 0 : slots.paper) != null ? _slots$paper : $77b3b30833fb8c12$export$821346c38a2d9390;
    const paperProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: (0, $kY3Ke.default)({}, externalPaperSlotProps, {
            style: isPositioned ? externalPaperSlotProps.style : (0, $kY3Ke.default)({}, externalPaperSlotProps.style, {
                opacity: 0
            })
        }),
        additionalProps: {
            elevation: elevation,
            ref: handlePaperRef
        },
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.paper, externalPaperSlotProps == null ? void 0 : externalPaperSlotProps.className)
    });
    const _useSlotProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: RootSlot,
        externalSlotProps: (slotProps == null ? void 0 : slotProps.root) || {},
        externalForwardedProps: other,
        additionalProps: {
            ref: ref,
            slotProps: {
                backdrop: {
                    invisible: true
                }
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
    }), { slotProps: rootSlotPropsProp } = _useSlotProps, rootProps = (0, $cFLic.default)(_useSlotProps, $77b3b30833fb8c12$var$_excluded3);
    return /*#__PURE__*/ (0, $bbzbN.jsx)(RootSlot, (0, $kY3Ke.default)({}, rootProps, !(0, $b4522a0df256fb21$export$2e2bcd8739ae039)(RootSlot) && {
        slotProps: rootSlotPropsProp,
        disableScrollLock: disableScrollLock
    }, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
            appear: true,
            in: open,
            onEntering: handleEntering,
            onExited: handleExited,
            timeout: transitionDuration
        }, TransitionProps, {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)(PaperSlot, (0, $kY3Ke.default)({}, paperProps, {
                children: children
            }))
        }))
    }));
});
var $77b3b30833fb8c12$export$2e2bcd8739ae039 = $77b3b30833fb8c12$var$Popover;






function $a942fdfc6e6c5d42$export$2cf86a63a84fe23d(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiMenu', slot);
}
const $a942fdfc6e6c5d42$var$menuClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $a942fdfc6e6c5d42$export$2e2bcd8739ae039 = $a942fdfc6e6c5d42$var$menuClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $c415fb7f3f0f9d08$var$_excluded = [
    "onEntering"
], $c415fb7f3f0f9d08$var$_excluded2 = [
    "autoFocus",
    "children",
    "className",
    "disableAutoFocusItem",
    "MenuListProps",
    "onClose",
    "open",
    "PaperProps",
    "PopoverClasses",
    "transitionDuration",
    "TransitionProps",
    "variant",
    "slots",
    "slotProps"
];
const $c415fb7f3f0f9d08$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $c415fb7f3f0f9d08$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $c415fb7f3f0f9d08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $a942fdfc6e6c5d42$export$2cf86a63a84fe23d), classes);
};
const $c415fb7f3f0f9d08$var$MenuRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $77b3b30833fb8c12$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
const $c415fb7f3f0f9d08$export$4f7c51a5920c9f33 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $77b3b30833fb8c12$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper',
    overridesResolver: (props, styles)=>styles.paper
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $c415fb7f3f0f9d08$var$MenuMenuList = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $9cb95136bc90d127$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List',
    overridesResolver: (props, styles)=>styles.list
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $c415fb7f3f0f9d08$var$Menu = /*#__PURE__*/ $7fPBF.forwardRef(function Menu(inProps, ref) {
    var _slots$paper, _slotProps$paper;
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {} } = props, TransitionProps = (0, $cFLic.default)(props.TransitionProps, $c415fb7f3f0f9d08$var$_excluded), other = (0, $cFLic.default)(props, $c415fb7f3f0f9d08$var$_excluded2);
    const isRtl = (0, $ef654b446fc390d6$export$b2dd014b6c321cb)();
    const ownerState = (0, $kY3Ke.default)({}, props, {
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    });
    const classes = $c415fb7f3f0f9d08$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $7fPBF.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $7fPBF.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const PaperSlot = (_slots$paper = slots.paper) != null ? _slots$paper : $c415fb7f3f0f9d08$export$4f7c51a5920c9f33;
    const paperExternalSlotProps = (_slotProps$paper = slotProps.paper) != null ? _slotProps$paper : PaperProps;
    const rootSlotProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const paperSlotProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: PaperSlot,
        externalSlotProps: paperExternalSlotProps,
        ownerState: ownerState,
        className: classes.paper
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($c415fb7f3f0f9d08$var$MenuRoot, (0, $kY3Ke.default)({
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $c415fb7f3f0f9d08$var$RTL_ORIGIN : $c415fb7f3f0f9d08$var$LTR_ORIGIN,
        slots: {
            paper: PaperSlot,
            root: slots.root
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        TransitionProps: (0, $kY3Ke.default)({
            onEntering: handleEntering
        }, TransitionProps),
        ownerState: ownerState
    }, other, {
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($c415fb7f3f0f9d08$var$MenuMenuList, (0, $kY3Ke.default)({
            onKeyDown: handleListKeyDown,
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant
        }, MenuListProps, {
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.list, MenuListProps.className),
            children: children
        }))
    }));
});
var $c415fb7f3f0f9d08$export$2e2bcd8739ae039 = $c415fb7f3f0f9d08$var$Menu;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");







function $a5651256592f6f65$export$1ee13051fd9e2ab5(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiNativeSelect', slot);
}
const $a5651256592f6f65$var$nativeSelectClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $a5651256592f6f65$export$2e2bcd8739ae039 = $a5651256592f6f65$var$nativeSelectClasses;




var $bbzbN = parcelRequire("bbzbN");
'use client';
const $7a6261f84c63d345$var$_excluded = [
    "className",
    "disabled",
    "error",
    "IconComponent",
    "inputRef",
    "variant"
];
const $7a6261f84c63d345$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $a5651256592f6f65$export$1ee13051fd9e2ab5), classes);
};
const $7a6261f84c63d345$export$c1eccd1617458c87 = ({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // Reset
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        borderRadius: 0,
        // Reset
        cursor: 'pointer',
        '&:focus': (0, $kY3Ke.default)({}, theme.vars ? {
            backgroundColor: `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.05)`
        } : {
            backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)'
        }, {
            borderRadius: 0 // Reset Chrome style
        }),
        // Remove IE11 arrow
        '&::-ms-expand': {
            display: 'none'
        },
        [`&.${(0, $a5651256592f6f65$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        // Bump specificity to allow extending custom inputs
        '&&&': {
            paddingRight: 24,
            minWidth: 16 // So it doesn't collapse.
        }
    }, ownerState.variant === 'filled' && {
        '&&&': {
            paddingRight: 32
        }
    }, ownerState.variant === 'outlined' && {
        borderRadius: (theme.vars || theme).shape.borderRadius,
        '&:focus': {
            borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
        },
        '&&&': {
            paddingRight: 32
        }
    });
const $7a6261f84c63d345$var$NativeSelectSelect = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('select', {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $0820e164eb5fbaff$export$2e2bcd8739ae039),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $a5651256592f6f65$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})($7a6261f84c63d345$export$c1eccd1617458c87);
const $7a6261f84c63d345$export$e7a817afd12a40d0 = ({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        top: 'calc(50% - .5em)',
        // Center vertically, height is 1em
        pointerEvents: 'none',
        // Don't block pointer events on the select under the icon.
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $a5651256592f6f65$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        }
    }, ownerState.open && {
        transform: 'rotate(180deg)'
    }, ownerState.variant === 'filled' && {
        right: 7
    }, ownerState.variant === 'outlined' && {
        right: 7
    });
const $7a6261f84c63d345$var$NativeSelectIcon = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('svg', {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})($7a6261f84c63d345$export$e7a817afd12a40d0);
/**
 * @ignore - internal component.
 */ const $7a6261f84c63d345$var$NativeSelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard' } = props, other = (0, $cFLic.default)(props, $7a6261f84c63d345$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disabled: disabled,
        variant: variant,
        error: error
    });
    const classes = $7a6261f84c63d345$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($7a6261f84c63d345$var$NativeSelectSelect, (0, $kY3Ke.default)({
                ownerState: ownerState,
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref
            }, other)),
            props.multiple ? null : /*#__PURE__*/ (0, $bbzbN.jsx)($7a6261f84c63d345$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $7a6261f84c63d345$export$2e2bcd8739ae039 = $7a6261f84c63d345$var$NativeSelectInput;






var $7fPBF = parcelRequire("7fPBF");
'use client';
function $bc6c881cebb96954$export$2e2bcd8739ae039({ controlled: controlled, default: defaultProp, name: name, state: state = 'value' }) {
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $7fPBF.useRef(controlled !== undefined);
    const [valueState, setValue] = $7fPBF.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $7fPBF.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $3b64539a8a5729fa$export$2e2bcd8739ae039 = (0, $bc6c881cebb96954$export$2e2bcd8739ae039);




function $5ea8b5d2968b699c$export$2c0c1ee5a3392e(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiSelect', slot);
}
const $5ea8b5d2968b699c$var$selectClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $5ea8b5d2968b699c$export$2e2bcd8739ae039 = $5ea8b5d2968b699c$var$selectClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
var $59b8977b1194262f$var$_span;
const $59b8977b1194262f$var$_excluded = [
    "aria-describedby",
    "aria-label",
    "autoFocus",
    "autoWidth",
    "children",
    "className",
    "defaultOpen",
    "defaultValue",
    "disabled",
    "displayEmpty",
    "error",
    "IconComponent",
    "inputRef",
    "labelId",
    "MenuProps",
    "multiple",
    "name",
    "onBlur",
    "onChange",
    "onClose",
    "onFocus",
    "onOpen",
    "open",
    "readOnly",
    "renderValue",
    "SelectDisplayProps",
    "tabIndex",
    "type",
    "value",
    "variant"
];
const $59b8977b1194262f$var$SelectSelect = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})((0, $7a6261f84c63d345$export$c1eccd1617458c87), {
    // Win specificity over the input base
    [`&.${(0, $5ea8b5d2968b699c$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $59b8977b1194262f$var$SelectIcon = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('svg', {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})((0, $7a6261f84c63d345$export$e7a817afd12a40d0));
const $59b8977b1194262f$var$SelectNativeInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('input', {
    shouldForwardProp: (prop)=>(0, $066f83798075d563$export$2e2bcd8739ae039)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput',
    overridesResolver: (props, styles)=>styles.nativeInput
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $59b8977b1194262f$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $59b8977b1194262f$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $59b8977b1194262f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $5ea8b5d2968b699c$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $59b8977b1194262f$var$SelectInput = /*#__PURE__*/ $7fPBF.forwardRef(function SelectInput(props, ref) {
    var _MenuProps$slotProps;
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, value: valueProp, variant: variant = 'standard' } = props, other = (0, $cFLic.default)(props, $59b8977b1194262f$var$_excluded);
    const [value, setValueState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $3b64539a8a5729fa$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $7fPBF.useRef(null);
    const displayRef = $7fPBF.useRef(null);
    const [displayNode, setDisplayNode] = $7fPBF.useState(null);
    const { current: isOpenControlled } = $7fPBF.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $7fPBF.useState();
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $7fPBF.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode == null ? void 0 : displayNode.parentNode;
    $7fPBF.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $7fPBF.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $7fPBF.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $7fPBF.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $9502daaf177b272b$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $7fPBF.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.indexOf(event.key) !== -1) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $5e9f5ca6e3e911fc$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $diYUK.default)(2));
            selected = value.some((v)=>$59b8977b1194262f$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $59b8977b1194262f$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $7fPBF.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        variant: variant,
        value: value,
        open: open,
        error: error
    });
    const classes = $59b8977b1194262f$var$useUtilityClasses(ownerState);
    const paperProps = (0, $kY3Ke.default)({}, MenuProps.PaperProps, (_MenuProps$slotProps = MenuProps.slotProps) == null ? void 0 : _MenuProps$slotProps.paper);
    const listboxId = (0, $46f5b561912058f9$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectSelect, (0, $kY3Ke.default)({
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": listboxId,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus
            }, SelectDisplayProps, {
                ownerState: ownerState,
                className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $59b8977b1194262f$var$isEmpty(display) ? $59b8977b1194262f$var$_span || ($59b8977b1194262f$var$_span = /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                    className: "notranslate",
                    children: "\u200B"
                })) : display
            })),
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectNativeInput, (0, $kY3Ke.default)({
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                ownerState: ownerState
            }, other)),
            /*#__PURE__*/ (0, $bbzbN.jsx)($59b8977b1194262f$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c415fb7f3f0f9d08$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                }
            }, MenuProps, {
                MenuListProps: (0, $kY3Ke.default)({
                    'aria-labelledby': labelId,
                    role: 'listbox',
                    'aria-multiselectable': multiple ? 'true' : undefined,
                    disableListWrap: true,
                    id: listboxId
                }, MenuProps.MenuListProps),
                slotProps: (0, $kY3Ke.default)({}, MenuProps.slotProps, {
                    paper: (0, $kY3Ke.default)({}, paperProps, {
                        style: (0, $kY3Ke.default)({
                            minWidth: menuMinWidth
                        }, paperProps != null ? paperProps.style : null)
                    })
                }),
                children: items
            }))
        ]
    });
});
var $59b8977b1194262f$export$2e2bcd8739ae039 = $59b8977b1194262f$var$SelectInput;




parcelRequire("7fPBF");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");








function $50c5d2f6ad13a504$export$c7c50641356bdfa5(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiSvgIcon', slot);
}
const $50c5d2f6ad13a504$var$svgIconClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $50c5d2f6ad13a504$export$2e2bcd8739ae039 = $50c5d2f6ad13a504$var$svgIconClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $b3d4ccc5f426d62a$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $b3d4ccc5f426d62a$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            `fontSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(fontSize)}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $50c5d2f6ad13a504$export$c7c50641356bdfa5), classes);
};
const $b3d4ccc5f426d62a$var$SvgIconRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`fontSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $b3d4ccc5f426d62a$var$SvgIcon = /*#__PURE__*/ $7fPBF.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $cFLic.default)(props, $b3d4ccc5f426d62a$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $7fPBF.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $b3d4ccc5f426d62a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($b3d4ccc5f426d62a$var$SvgIconRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $bbzbN.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$b3d4ccc5f426d62a$var$SvgIcon.muiName = 'SvgIcon';
var $b3d4ccc5f426d62a$export$2e2bcd8739ae039 = $b3d4ccc5f426d62a$var$SvgIcon;



var $bbzbN = parcelRequire("bbzbN");
'use client';
function $4f9bc8f83648f682$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b3d4ccc5f426d62a$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $b3d4ccc5f426d62a$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ $7fPBF.memo(/*#__PURE__*/ $7fPBF.forwardRef(Component));
}



var $bbzbN = parcelRequire("bbzbN");
'use client';
var $7cc16c93aade5bc5$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');










var $bbzbN = parcelRequire("bbzbN");
'use client';
const $e07ff65b28ac412d$var$_excluded = [
    "autoWidth",
    "children",
    "classes",
    "className",
    "defaultOpen",
    "displayEmpty",
    "IconComponent",
    "id",
    "input",
    "inputProps",
    "label",
    "labelId",
    "MenuProps",
    "multiple",
    "native",
    "onClose",
    "onOpen",
    "open",
    "renderValue",
    "SelectDisplayProps",
    "variant"
], $e07ff65b28ac412d$var$_excluded2 = [
    "root"
];
const $e07ff65b28ac412d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return classes;
};
const $e07ff65b28ac412d$var$styledRootConfig = {
    name: 'MuiSelect',
    overridesResolver: (props, styles)=>styles.root,
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) && prop !== 'variant',
    slot: 'Root'
};
const $e07ff65b28ac412d$var$StyledInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $e0d49bb29c2f8b76$export$2e2bcd8739ae039), $e07ff65b28ac412d$var$styledRootConfig)('');
const $e07ff65b28ac412d$var$StyledOutlinedInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $50e7e9efec2c0b8c$export$2e2bcd8739ae039), $e07ff65b28ac412d$var$styledRootConfig)('');
const $e07ff65b28ac412d$var$StyledFilledInput = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $faf35b44bb61ebfd$export$2e2bcd8739ae039), $e07ff65b28ac412d$var$styledRootConfig)('');
const $e07ff65b28ac412d$var$Select = /*#__PURE__*/ $7fPBF.forwardRef(function Select(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $7cc16c93aade5bc5$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined' } = props, other = (0, $cFLic.default)(props, $e07ff65b28ac412d$var$_excluded);
    const inputComponent = native ? (0, $7a6261f84c63d345$export$2e2bcd8739ae039) : (0, $59b8977b1194262f$export$2e2bcd8739ae039);
    const muiFormControl = (0, $1af6f86e160474f0$export$2e2bcd8739ae039)();
    const fcs = (0, $e570c333aacea667$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = (0, $kY3Ke.default)({}, props, {
        variant: variant,
        classes: classesProp
    });
    const classes = $e07ff65b28ac412d$var$useUtilityClasses(ownerState);
    const restOfClasses = (0, $cFLic.default)(classes, $e07ff65b28ac412d$var$_excluded2);
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $bbzbN.jsx)($e07ff65b28ac412d$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, (0, $8971fd60a8b100cf$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
        children: /*#__PURE__*/ $7fPBF.cloneElement(InputComponent, (0, $kY3Ke.default)({
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: (0, $kY3Ke.default)({
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple
            }, native ? {
                id: id
            } : {
                autoWidth: autoWidth,
                defaultOpen: defaultOpen,
                displayEmpty: displayEmpty,
                labelId: labelId,
                MenuProps: MenuProps,
                onClose: onClose,
                onOpen: onOpen,
                open: open,
                renderValue: renderValue,
                SelectDisplayProps: (0, $kY3Ke.default)({
                    id: id
                }, SelectDisplayProps)
            }, inputProps, {
                classes: inputProps ? (0, $3wRTY.default)(restOfClasses, inputProps.classes) : restOfClasses
            }, input ? input.props.inputProps : {})
        }, (multiple && native || displayEmpty) && variant === 'outlined' ? {
            notched: true
        } : {}, {
            ref: inputComponentRef,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(InputComponent.props.className, className, classes.root)
        }, !input && {
            variant: variant
        }, other))
    });
});
$e07ff65b28ac412d$var$Select.muiName = 'Select';
var $e07ff65b28ac412d$export$2e2bcd8739ae039 = $e07ff65b28ac412d$var$Select;




function $16716b95f6c79ff6$export$c1bdcbaf0596aeda(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiTextField', slot);
}
const $16716b95f6c79ff6$var$textFieldClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiTextField', [
    'root'
]);
var $16716b95f6c79ff6$export$2e2bcd8739ae039 = $16716b95f6c79ff6$var$textFieldClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $afe2b905acb8b9f6$var$_excluded = [
    "autoComplete",
    "autoFocus",
    "children",
    "className",
    "color",
    "defaultValue",
    "disabled",
    "error",
    "FormHelperTextProps",
    "fullWidth",
    "helperText",
    "id",
    "InputLabelProps",
    "inputProps",
    "InputProps",
    "inputRef",
    "label",
    "maxRows",
    "minRows",
    "multiline",
    "name",
    "onBlur",
    "onChange",
    "onFocus",
    "placeholder",
    "required",
    "rows",
    "select",
    "SelectProps",
    "type",
    "value",
    "variant"
];
const $afe2b905acb8b9f6$var$variantComponent = {
    standard: (0, $e0d49bb29c2f8b76$export$2e2bcd8739ae039),
    filled: (0, $faf35b44bb61ebfd$export$2e2bcd8739ae039),
    outlined: (0, $50e7e9efec2c0b8c$export$2e2bcd8739ae039)
};
const $afe2b905acb8b9f6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $16716b95f6c79ff6$export$c1bdcbaf0596aeda), classes);
};
const $afe2b905acb8b9f6$var$TextFieldRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $26a8e925f0aa9998$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $afe2b905acb8b9f6$var$TextField = /*#__PURE__*/ $7fPBF.forwardRef(function TextField(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextProps, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelProps, inputProps: inputProps, InputProps: InputProps, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectProps, type: type, value: value, variant: variant = 'outlined' } = props, other = (0, $cFLic.default)(props, $afe2b905acb8b9f6$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    });
    const classes = $afe2b905acb8b9f6$var$useUtilityClasses(ownerState);
    const InputMore = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') InputMore.notched = InputLabelProps.shrink;
        InputMore.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectProps || !SelectProps.native) InputMore.id = undefined;
        InputMore['aria-describedby'] = undefined;
    }
    const id = (0, $46f5b561912058f9$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $afe2b905acb8b9f6$var$variantComponent[variant];
    const InputElement = /*#__PURE__*/ (0, $bbzbN.jsx)(InputComponent, (0, $kY3Ke.default)({
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: inputProps
    }, InputMore, InputProps));
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($afe2b905acb8b9f6$var$TextFieldRoot, (0, $kY3Ke.default)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        ref: ref,
        required: required,
        color: color,
        variant: variant,
        ownerState: ownerState
    }, other, {
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fcd80672e9993aad$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
                htmlFor: id,
                id: inputLabelId
            }, InputLabelProps, {
                children: label
            })),
            select ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement
            }, SelectProps, {
                children: children
            })) : InputElement,
            helperText && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $0321a2cb63129955$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
                id: helperTextId
            }, FormHelperTextProps, {
                children: helperText
            }))
        ]
    }));
});
var $afe2b905acb8b9f6$export$2e2bcd8739ae039 = $afe2b905acb8b9f6$var$TextField;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");








var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");









'use client';
var $16db65b1f19e65f7$export$2e2bcd8739ae039 = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039);



var $7fPBF = parcelRequire("7fPBF");

'use client';
let $52b16131f46e7800$var$hadKeyboardEvent = true;
let $52b16131f46e7800$var$hadFocusVisibleRecently = false;
const $52b16131f46e7800$var$hadFocusVisibleRecentlyTimeout = new (0, $9a1088a9a7141b09$export$786b4da70f00938b)();
const $52b16131f46e7800$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $52b16131f46e7800$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $52b16131f46e7800$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $52b16131f46e7800$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $52b16131f46e7800$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $52b16131f46e7800$var$handlePointerDown() {
    $52b16131f46e7800$var$hadKeyboardEvent = false;
}
function $52b16131f46e7800$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($52b16131f46e7800$var$hadFocusVisibleRecently) $52b16131f46e7800$var$hadKeyboardEvent = true;
    }
}
function $52b16131f46e7800$var$prepare(doc) {
    doc.addEventListener('keydown', $52b16131f46e7800$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $52b16131f46e7800$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $52b16131f46e7800$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $52b16131f46e7800$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $52b16131f46e7800$var$handleVisibilityChange, true);
}
function $52b16131f46e7800$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $52b16131f46e7800$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $52b16131f46e7800$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $52b16131f46e7800$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $52b16131f46e7800$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $52b16131f46e7800$var$handleVisibilityChange, true);
}
function $52b16131f46e7800$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $52b16131f46e7800$var$hadKeyboardEvent || $52b16131f46e7800$var$focusTriggersKeyboardModality(target);
}
function $52b16131f46e7800$export$2e2bcd8739ae039() {
    const ref = $7fPBF.useCallback((node)=>{
        if (node != null) $52b16131f46e7800$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $7fPBF.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $52b16131f46e7800$var$hadFocusVisibleRecently = true;
            $52b16131f46e7800$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $52b16131f46e7800$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($52b16131f46e7800$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


'use client';
var $77c51d9bab7ec5dd$export$2e2bcd8739ae039 = (0, $52b16131f46e7800$export$2e2bcd8739ae039);



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
function $298ff58efa174465$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}





var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
function $2a31251aa5f7eb4f$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $7fPBF.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $7fPBF.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $2a31251aa5f7eb4f$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $2a31251aa5f7eb4f$export$fa71e2345c31d7a2(props, onExited) {
    return $2a31251aa5f7eb4f$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $2a31251aa5f7eb4f$var$getProp(child, 'appear', props),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', props),
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', props)
        });
    });
}
function $2a31251aa5f7eb4f$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $2a31251aa5f7eb4f$export$bbc8a025727ea824(nextProps.children);
    var children = $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $7fPBF.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $7fPBF.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $7fPBF.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $30921f11ad4ef55c$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $30921f11ad4ef55c$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $30921f11ad4ef55c$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $146ee816144a450d$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $2a31251aa5f7eb4f$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $2a31251aa5f7eb4f$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $2a31251aa5f7eb4f$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $kY3Ke.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $cFLic.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $30921f11ad4ef55c$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$30921f11ad4ef55c$var$TransitionGroup.propTypes = {};
$30921f11ad4ef55c$var$TransitionGroup.defaultProps = $30921f11ad4ef55c$var$defaultProps;
var $30921f11ad4ef55c$export$2e2bcd8739ae039 = $30921f11ad4ef55c$var$TransitionGroup;




var $5nUae = parcelRequire("5nUae");




var $7fPBF = parcelRequire("7fPBF");



var $bbzbN = parcelRequire("bbzbN");
'use client';
function $3d4a0ced9cf2c3c7$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $7fPBF.useState(false);
    const rippleClassName = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $7fPBF.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: childClassName
        })
    });
}
var $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039 = $3d4a0ced9cf2c3c7$var$Ripple;




function $fbda7a0931c56f58$export$b464606f735ab902(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiTouchRipple', slot);
}
const $fbda7a0931c56f58$var$touchRippleClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $fbda7a0931c56f58$export$2e2bcd8739ae039 = $fbda7a0931c56f58$var$touchRippleClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
let $3f5ffa895ad4456e$var$_ = (t)=>t, $3f5ffa895ad4456e$var$t, $3f5ffa895ad4456e$var$t1, $3f5ffa895ad4456e$var$t2, $3f5ffa895ad4456e$var$t3;
const $3f5ffa895ad4456e$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $3f5ffa895ad4456e$var$_1 = (t)=>t, $3f5ffa895ad4456e$var$_t, $3f5ffa895ad4456e$var$_t2, $3f5ffa895ad4456e$var$_t3, $3f5ffa895ad4456e$var$_t4;
const $3f5ffa895ad4456e$var$DURATION = 550;
const $3f5ffa895ad4456e$export$95d0c9356b2231a3 = 80;
const $3f5ffa895ad4456e$var$enterKeyframe = (0, $5nUae.keyframes)($3f5ffa895ad4456e$var$_t || ($3f5ffa895ad4456e$var$_t = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t || ($3f5ffa895ad4456e$var$t = $3f5ffa895ad4456e$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`))));
const $3f5ffa895ad4456e$var$exitKeyframe = (0, $5nUae.keyframes)($3f5ffa895ad4456e$var$_t2 || ($3f5ffa895ad4456e$var$_t2 = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t1 || ($3f5ffa895ad4456e$var$t1 = $3f5ffa895ad4456e$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`))));
const $3f5ffa895ad4456e$var$pulsateKeyframe = (0, $5nUae.keyframes)($3f5ffa895ad4456e$var$_t3 || ($3f5ffa895ad4456e$var$_t3 = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t2 || ($3f5ffa895ad4456e$var$t2 = $3f5ffa895ad4456e$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`))));
const $3f5ffa895ad4456e$export$f6b7418508c72c25 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $3f5ffa895ad4456e$export$676cfe7b12693c4b = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($3f5ffa895ad4456e$var$_t4 || ($3f5ffa895ad4456e$var$_t4 = $3f5ffa895ad4456e$var$_1($3f5ffa895ad4456e$var$t3 || ($3f5ffa895ad4456e$var$t3 = $3f5ffa895ad4456e$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)), (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).rippleVisible, $3f5ffa895ad4456e$var$enterKeyframe, $3f5ffa895ad4456e$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).child, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childLeaving, $3f5ffa895ad4456e$var$exitKeyframe, $3f5ffa895ad4456e$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childPulsate, $3f5ffa895ad4456e$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $3f5ffa895ad4456e$var$TouchRipple = /*#__PURE__*/ $7fPBF.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $cFLic.default)(props, $3f5ffa895ad4456e$var$_excluded);
    const [ripples, setRipples] = $7fPBF.useState([]);
    const nextKey = $7fPBF.useRef(0);
    const rippleCallback = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $7fPBF.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $7fPBF.useRef(null);
    const container = $7fPBF.useRef(null);
    const startCommit = $7fPBF.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $bbzbN.jsx)($3f5ffa895ad4456e$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.ripple, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.rippleVisible, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.ripplePulsate, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.child, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.childLeaving, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.childPulsate, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $3f5ffa895ad4456e$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $7fPBF.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($3f5ffa895ad4456e$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $7fPBF.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $7fPBF.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $7fPBF.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($3f5ffa895ad4456e$export$f6b7418508c72c25, (0, $kY3Ke.default)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)((0, $fbda7a0931c56f58$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $30921f11ad4ef55c$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $3f5ffa895ad4456e$export$2e2bcd8739ae039 = $3f5ffa895ad4456e$var$TouchRipple;




function $d365e8bde1350eb0$export$fccb0498dcd99783(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiButtonBase', slot);
}
const $d365e8bde1350eb0$var$buttonBaseClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $d365e8bde1350eb0$export$2e2bcd8739ae039 = $d365e8bde1350eb0$var$buttonBaseClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $2d0c76ae9ca5c817$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $2d0c76ae9ca5c817$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $d365e8bde1350eb0$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36 = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $d365e8bde1350eb0$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $2d0c76ae9ca5c817$var$ButtonBase = /*#__PURE__*/ $7fPBF.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $cFLic.default)(props, $2d0c76ae9ca5c817$var$_excluded);
    const buttonRef = $7fPBF.useRef(null);
    const rippleRef = $7fPBF.useRef(null);
    const handleRippleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $77c51d9bab7ec5dd$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $7fPBF.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $7fPBF.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $7fPBF.useState(false);
    $7fPBF.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $7fPBF.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $7fPBF.useRef(false);
    const handleKeyDown = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $2d0c76ae9ca5c817$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36, (0, $kY3Ke.default)({
        as: ComponentProp,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $bbzbN.jsx)((0, $3f5ffa895ad4456e$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $2d0c76ae9ca5c817$export$2e2bcd8739ae039 = $2d0c76ae9ca5c817$var$ButtonBase;






function $be601d991ccbe49a$export$46f01d01378ec5a2(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDivider', slot);
}
const $be601d991ccbe49a$var$dividerClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $be601d991ccbe49a$export$2e2bcd8739ae039 = $be601d991ccbe49a$var$dividerClasses;




function $7a8a9052410fb062$export$81478e24460c57f2(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiListItemIcon', slot);
}
const $7a8a9052410fb062$var$listItemIconClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $7a8a9052410fb062$export$2e2bcd8739ae039 = $7a8a9052410fb062$var$listItemIconClasses;




function $2a8a1c268392e331$export$1061006a0db3aeb5(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiListItemText', slot);
}
const $2a8a1c268392e331$var$listItemTextClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $2a8a1c268392e331$export$2e2bcd8739ae039 = $2a8a1c268392e331$var$listItemTextClasses;




function $81e9a11bd449f186$export$515f8c67b5305377(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiMenuItem', slot);
}
const $81e9a11bd449f186$var$menuItemClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $81e9a11bd449f186$export$2e2bcd8739ae039 = $81e9a11bd449f186$var$menuItemClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $3bdbe9250415b022$var$_excluded = [
    "autoFocus",
    "component",
    "dense",
    "divider",
    "disableGutters",
    "focusVisibleClassName",
    "role",
    "tabIndex",
    "className"
];
const $3bdbe9250415b022$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $3bdbe9250415b022$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $81e9a11bd449f186$export$515f8c67b5305377), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $3bdbe9250415b022$var$MenuItemRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $3bdbe9250415b022$export$4334bb34c76fef24
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, theme.typography.body1, {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap'
    }, !ownerState.disableGutters && {
        paddingLeft: 16,
        paddingRight: 16
    }, ownerState.divider && {
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
        backgroundClip: 'padding-box'
    }, {
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $553ed2baba4347ed$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity),
            [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.focusOpacity}))` : (0, $553ed2baba4347ed$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
            }
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / calc(${theme.vars.palette.action.selectedOpacity} + ${theme.vars.palette.action.hoverOpacity}))` : (0, $553ed2baba4347ed$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.selectedOpacity})` : (0, $553ed2baba4347ed$exports.alpha)(theme.palette.primary.main, theme.palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $81e9a11bd449f186$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $be601d991ccbe49a$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $be601d991ccbe49a$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $2a8a1c268392e331$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $7a8a9052410fb062$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        }
    }, !ownerState.dense && {
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    }, ownerState.dense && (0, $kY3Ke.default)({
        minHeight: 32,
        // https://m2.material.io/components/menus#specs > Dense
        paddingTop: 4,
        paddingBottom: 4
    }, theme.typography.body2, {
        [`& .${(0, $7a8a9052410fb062$export$2e2bcd8739ae039).root} svg`]: {
            fontSize: '1.25rem'
        }
    })));
const $3bdbe9250415b022$var$MenuItem = /*#__PURE__*/ $7fPBF.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className } = props, other = (0, $cFLic.default)(props, $3bdbe9250415b022$var$_excluded);
    const context = $7fPBF.useContext((0, $94e271e17fd22222$export$2e2bcd8739ae039));
    const childContext = $7fPBF.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $7fPBF.useRef(null);
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    });
    const classes = $3bdbe9250415b022$var$useUtilityClasses(props);
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $94e271e17fd22222$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($3bdbe9250415b022$var$MenuItemRoot, (0, $kY3Ke.default)({
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className)
        }, other, {
            ownerState: ownerState,
            classes: classes
        }))
    });
});
var $3bdbe9250415b022$export$2e2bcd8739ae039 = $3bdbe9250415b022$var$MenuItem;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");











function $bf96407f1f5b4126$export$5a6f9035944c8119(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiButton', slot);
}
const $bf96407f1f5b4126$var$buttonClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $bf96407f1f5b4126$export$2e2bcd8739ae039 = $bf96407f1f5b4126$var$buttonClasses;



var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $40ed7573a59c2be9$var$ButtonGroupContext = /*#__PURE__*/ $7fPBF.createContext({});
var $40ed7573a59c2be9$export$2e2bcd8739ae039 = $40ed7573a59c2be9$var$ButtonGroupContext;



var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $e319f5c3a4402058$var$ButtonGroupButtonContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $e319f5c3a4402058$export$2e2bcd8739ae039 = $e319f5c3a4402058$var$ButtonGroupButtonContext;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $45be1777d6a28263$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $45be1777d6a28263$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            `${variant}Size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ]
    };
    const composedClasses = (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $bf96407f1f5b4126$export$5a6f9035944c8119), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $45be1777d6a28263$var$commonIconStyles = (ownerState)=>(0, $kY3Ke.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $45be1777d6a28263$var$ButtonRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $0820e164eb5fbaff$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $kY3Ke.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $kY3Ke.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $553ed2baba4347ed$exports.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $553ed2baba4347ed$exports.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $553ed2baba4347ed$exports.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $kY3Ke.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).focusVisible}`]: (0, $kY3Ke.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).disabled}`]: (0, $kY3Ke.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $553ed2baba4347ed$exports.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $45be1777d6a28263$var$ButtonStartIcon = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $45be1777d6a28263$var$commonIconStyles(ownerState)));
const $45be1777d6a28263$var$ButtonEndIcon = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $45be1777d6a28263$var$commonIconStyles(ownerState)));
const $45be1777d6a28263$var$Button = /*#__PURE__*/ $7fPBF.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $7fPBF.useContext((0, $40ed7573a59c2be9$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $7fPBF.useContext((0, $e319f5c3a4402058$export$2e2bcd8739ae039));
    const resolvedProps = (0, $bdfe01df7c24351f$export$2e2bcd8739ae039)(contextProps, inProps);
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $cFLic.default)(props, $45be1777d6a28263$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $45be1777d6a28263$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $bbzbN.jsx)($45be1777d6a28263$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $bbzbN.jsx)($45be1777d6a28263$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($45be1777d6a28263$var$ButtonRoot, (0, $kY3Ke.default)({
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $45be1777d6a28263$export$2e2bcd8739ae039 = $45be1777d6a28263$var$Button;



/** 팀 멤버 목록 */ const $ce4cf4b5ea0f1720$var$getMemberList = async ()=>(0, $b13c137540e062b0$export$407ca81eb46778dd).get('/member/list').then((res)=>res.data);
/** 멤버 등록 / 수정 */ const $ce4cf4b5ea0f1720$var$saveMember = async (data)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).post('/member', data).then((res)=>res.data);
/** 멤버 삭제 */ const $ce4cf4b5ea0f1720$var$deleteMember = async (id)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).delete(`/member/${id}`);
const $ce4cf4b5ea0f1720$var$MemberService = {
    getMemberList: $ce4cf4b5ea0f1720$var$getMemberList,
    saveMember: $ce4cf4b5ea0f1720$var$saveMember,
    deleteMember: $ce4cf4b5ea0f1720$var$deleteMember
};
var $ce4cf4b5ea0f1720$export$2e2bcd8739ae039 = $ce4cf4b5ea0f1720$var$MemberService;




const $8e5c94195ca6a6c8$var$POSITIONS = [
    'GK',
    'CB',
    'SB',
    'MF',
    'WF',
    'CF'
];
const $8e5c94195ca6a6c8$var$MemberView = (props)=>{
    const handleOverlayClick = (0, $7fPBF.useCallback)(()=>props.onClose(), [
        props.onClose
    ]);
    //const handleReturnClick = useCallback(() => {handleClose(); initData();}, [props.onClose])
    //const handleEditComplete = useCallback(() => {initData();}, [props.onClose])
    const [members, setMembers] = (0, $7fPBF.useState)([]);
    const [selectedMember, setSelectedMember] = (0, $7fPBF.useState)(null);
    const [name, setName] = (0, $7fPBF.useState)('');
    const [position1, setPosition1] = (0, $7fPBF.useState)('');
    const [position2, setPosition2] = (0, $7fPBF.useState)('');
    const [mode, setMode] = (0, $7fPBF.useState)('create');
    /** 멤버 목록 조회 */ (0, $7fPBF.useEffect)(()=>{
        loadMembers();
    }, []);
    const loadMembers = async ()=>{
        const list = await (0, $ce4cf4b5ea0f1720$export$2e2bcd8739ae039).getMemberList();
        setMembers(list);
    };
    /** 멤버 클릭 */ const handleMemberClick = (m)=>{
        setSelectedMember(m);
        setName(m.name);
        setPosition1(m.position1);
        setPosition2(m.position2 || '');
        setMode('delete');
    };
    /** 입력 변경 감지 */ const handleNameChange = (v)=>{
        setName(v);
        if (selectedMember && v !== selectedMember.name) setMode('create');
    };
    const handlePositionChange = (p1, p2)=>{
        setPosition1(p1);
        setPosition2(p2);
        if (selectedMember && (p1 !== selectedMember.position1 || p2 !== (selectedMember.position2 || ''))) setMode('update');
    };
    /** 버튼 액션 */ const handleAction = async ()=>{
        if (mode === 'delete' && (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.id)) await (0, $ce4cf4b5ea0f1720$export$2e2bcd8739ae039).deleteMember(selectedMember.id);
        if (mode === 'update' && (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.id)) await (0, $ce4cf4b5ea0f1720$export$2e2bcd8739ae039).saveMember((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, selectedMember), {
            name: name,
            position1: position1,
            position2: position2
        }));
        if (mode === 'create') await (0, $ce4cf4b5ea0f1720$export$2e2bcd8739ae039).saveMember({
            name: name,
            position1: position1,
            position2: position2
        });
        resetForm();
        loadMembers();
    };
    const resetForm = ()=>{
        setSelectedMember(null);
        setName('');
        setPosition1('');
        setPosition2('');
        setMode('create');
    };
    /** 버튼 텍스트 */ const getButtonLabel = ()=>{
        if (mode === 'delete') return "\uC0AD\uC81C";
        if (mode === 'update') return "\uC218\uC815";
        return "\uB4F1\uB85D";
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5f47bfd43cc47d77$export$2e2bcd8739ae039), {
                title: "\uD68C\uC6D0 \uAD00\uB9AC",
                onClose: handleOverlayClick
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "member-board",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4ac626799ed465c3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        className: "member-list",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("h4", {
                                className: 'member-header',
                                children: [
                                    "\uC804\uCCB4 (",
                                    members.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                className: "member-scroll",
                                children: members.map((m)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                        className: "member-row",
                                        onClick: ()=>handleMemberClick(m),
                                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                            className: "member-line",
                                            style: {
                                                justifyContent: "center"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                    className: "member-info",
                                                    children: m.name
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                                    className: "position",
                                                    children: [
                                                        m.position1,
                                                        m.position2 && `/${m.position2}`
                                                    ]
                                                })
                                            ]
                                        })
                                    }, m.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            gap: 1,
                            mt: 2
                        },
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
                                size: "small",
                                placeholder: "\uC774\uB984",
                                value: name,
                                onChange: (e)=>handleNameChange(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                sx: {
                                    height: '40px'
                                },
                                size: "small",
                                value: position1,
                                onChange: (e)=>handlePositionChange(e.target.value, position2),
                                children: $8e5c94195ca6a6c8$var$POSITIONS.map((p)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                        value: p,
                                        children: p
                                    }, p))
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                sx: {
                                    height: '40px'
                                },
                                size: "small",
                                value: position2,
                                onChange: (e)=>handlePositionChange(position1, e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                        value: "",
                                        children: "\uC5C6\uC74C"
                                    }),
                                    $8e5c94195ca6a6c8$var$POSITIONS.map((p)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: p,
                                            children: p
                                        }, p))
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                                sx: {
                                    height: '40px'
                                },
                                variant: "contained",
                                color: mode === 'delete' ? 'error' : 'primary',
                                onClick: handleAction,
                                children: getButtonLabel()
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $8e5c94195ca6a6c8$export$2e2bcd8739ae039 = $8e5c94195ca6a6c8$var$MemberView;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");


/** 경기장 목록 */ const $744a577e8e94e017$var$getPlaceList = async ()=>(0, $b13c137540e062b0$export$407ca81eb46778dd).get('/place/list').then((res)=>res.data);
/** 경기장 등록 */ const $744a577e8e94e017$var$savePlace = async (data)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).post('/place', data).then((res)=>res.data);
/** 경기장 삭제 */ const $744a577e8e94e017$var$deletePlace = async (id)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).delete(`/place/${id}`);
const $744a577e8e94e017$var$PlaceService = {
    getPlaceList: $744a577e8e94e017$var$getPlaceList,
    savePlace: $744a577e8e94e017$var$savePlace,
    deletePlace: $744a577e8e94e017$var$deletePlace
};
var $744a577e8e94e017$export$2e2bcd8739ae039 = $744a577e8e94e017$var$PlaceService;




const $289bf3c04b4f6227$var$PlaceView = (props)=>{
    const handleOverlayClick = (0, $7fPBF.useCallback)(()=>props.onClose(), [
        props.onClose
    ]);
    const [places, setPlaces] = (0, $7fPBF.useState)([]);
    const [selectedPlace, setSelectedPlace] = (0, $7fPBF.useState)(null);
    const [name, setName] = (0, $7fPBF.useState)('');
    const [mode, setMode] = (0, $7fPBF.useState)('create');
    /** 경기장 목록 조회 */ (0, $7fPBF.useEffect)(()=>{
        loadPlaces();
    }, []);
    const loadPlaces = async ()=>{
        const list = await (0, $744a577e8e94e017$export$2e2bcd8739ae039).getPlaceList();
        setPlaces(list);
    };
    /** 경기장 클릭 */ const handlePlaceClick = (p)=>{
        setSelectedPlace(p);
        setName(p.name);
        setMode('delete');
    };
    /** 이름 변경 감지 */ const handleNameChange = (v)=>{
        setName(v);
        if (selectedPlace && v !== selectedPlace.name) setMode('create');
    };
    /** 버튼 액션 */ const handleAction = async ()=>{
        if (mode === 'delete' && (selectedPlace === null || selectedPlace === void 0 ? void 0 : selectedPlace.id)) await (0, $744a577e8e94e017$export$2e2bcd8739ae039).deletePlace(selectedPlace.id);
        if (mode === 'create') await (0, $744a577e8e94e017$export$2e2bcd8739ae039).savePlace({
            name: name
        });
        resetForm();
        loadPlaces();
    };
    const resetForm = ()=>{
        setSelectedPlace(null);
        setName('');
        setMode('create');
    };
    /** 버튼 텍스트 */ const getButtonLabel = ()=>{
        return mode === 'delete' ? "\uC0AD\uC81C" : "\uB4F1\uB85D";
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5f47bfd43cc47d77$export$2e2bcd8739ae039), {
                title: "\uACBD\uAE30\uC7A5 \uAD00\uB9AC",
                onClose: handleOverlayClick
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "place-board",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4ac626799ed465c3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        className: "place-list",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("h4", {
                                className: "place-header",
                                children: [
                                    "\uC804\uCCB4 (",
                                    places.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                className: "place-scroll",
                                children: places.map((p)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                        className: "place-row",
                                        onClick: ()=>handlePlaceClick(p),
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                            className: "place-line",
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: "place-name",
                                                children: p.name
                                            })
                                        })
                                    }, p.id))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            gap: 1,
                            mt: 2,
                            justifyContent: 'space-around'
                        },
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
                                size: "small",
                                placeholder: "\uACBD\uAE30\uC7A5 \uC774\uB984",
                                value: name,
                                onChange: (e)=>handleNameChange(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                                sx: {
                                    height: '40px'
                                },
                                variant: "contained",
                                color: mode === 'delete' ? 'error' : 'primary',
                                onClick: handleAction,
                                disabled: !name,
                                children: getButtonLabel()
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $289bf3c04b4f6227$export$2e2bcd8739ae039 = $289bf3c04b4f6227$var$PlaceView;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");











// Source from https://github.com/alitaheri/normalize-scroll-left
let $ac35c5e63375259c$var$cachedType;
function $ac35c5e63375259c$export$a10970ffb6510128() {
    if ($ac35c5e63375259c$var$cachedType) return $ac35c5e63375259c$var$cachedType;
    const dummy = document.createElement('div');
    const container = document.createElement('div');
    container.style.width = '10px';
    container.style.height = '1px';
    dummy.appendChild(container);
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    $ac35c5e63375259c$var$cachedType = 'reverse';
    if (dummy.scrollLeft > 0) $ac35c5e63375259c$var$cachedType = 'default';
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) $ac35c5e63375259c$var$cachedType = 'negative';
    }
    document.body.removeChild(dummy);
    return $ac35c5e63375259c$var$cachedType;
}
function $ac35c5e63375259c$export$3c615b88e5d7e4f6(element, direction) {
    const scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior
    if (direction !== 'rtl') return scrollLeft;
    const type = $ac35c5e63375259c$export$a10970ffb6510128();
    switch(type){
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
        default:
            return scrollLeft;
    }
}


function $83b553d4c6fa4e14$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $83b553d4c6fa4e14$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $83b553d4c6fa4e14$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");




var $bbzbN = parcelRequire("bbzbN");
'use client';
const $3a66d534e874acfc$var$_excluded = [
    "onChange"
];
const $3a66d534e874acfc$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $3a66d534e874acfc$export$2e2bcd8739ae039(props) {
    const { onChange: onChange } = props, other = (0, $cFLic.default)(props, $3a66d534e874acfc$var$_excluded);
    const scrollbarHeight = $7fPBF.useRef();
    const nodeRef = $7fPBF.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $cfde3819487a0686$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $3aadd01758bd49c1$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $7fPBF.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", (0, $kY3Ke.default)({
        style: $3a66d534e874acfc$var$styles
    }, other, {
        ref: nodeRef
    }));
}



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");





parcelRequire("7fPBF");


var $bbzbN = parcelRequire("bbzbN");
'use client';
var $590c3983f7881c0e$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');


parcelRequire("7fPBF");


var $bbzbN = parcelRequire("bbzbN");
'use client';
var $0fb9b8a257411062$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');







function $b12a210959784eb2$export$34861783d3c2eef8(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiTabScrollButton', slot);
}
const $b12a210959784eb2$var$tabScrollButtonClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $b12a210959784eb2$export$2e2bcd8739ae039 = $b12a210959784eb2$var$tabScrollButtonClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $a882ddb0e71234be$var$_excluded = [
    "className",
    "slots",
    "slotProps",
    "direction",
    "orientation",
    "disabled"
];
const $a882ddb0e71234be$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $b12a210959784eb2$export$34861783d3c2eef8), classes);
};
const $a882ddb0e71234be$var$TabScrollButtonRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        width: 40,
        flexShrink: 0,
        opacity: 0.8,
        [`&.${(0, $b12a210959784eb2$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 0
        }
    }, ownerState.orientation === 'vertical' && {
        width: '100%',
        height: 40,
        '& svg': {
            transform: `rotate(${ownerState.isRtl ? -90 : 90}deg)`
        }
    }));
const $a882ddb0e71234be$var$TabScrollButton = /*#__PURE__*/ $7fPBF.forwardRef(function TabScrollButton(inProps, ref) {
    var _slots$StartScrollBut, _slots$EndScrollButto;
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction } = props, other = (0, $cFLic.default)(props, $a882ddb0e71234be$var$_excluded);
    const isRtl = (0, $ef654b446fc390d6$export$b2dd014b6c321cb)();
    const ownerState = (0, $kY3Ke.default)({
        isRtl: isRtl
    }, props);
    const classes = $a882ddb0e71234be$var$useUtilityClasses(ownerState);
    const StartButtonIcon = (_slots$StartScrollBut = slots.StartScrollButtonIcon) != null ? _slots$StartScrollBut : (0, $590c3983f7881c0e$export$2e2bcd8739ae039);
    const EndButtonIcon = (_slots$EndScrollButto = slots.EndScrollButtonIcon) != null ? _slots$EndScrollButto : (0, $0fb9b8a257411062$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $bbzbN.jsx)($a882ddb0e71234be$var$TabScrollButtonRoot, (0, $kY3Ke.default)({
        component: "div",
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null
    }, other, {
        children: direction === 'left' ? /*#__PURE__*/ (0, $bbzbN.jsx)(StartButtonIcon, (0, $kY3Ke.default)({}, startButtonIconProps)) : /*#__PURE__*/ (0, $bbzbN.jsx)(EndButtonIcon, (0, $kY3Ke.default)({}, endButtonIconProps))
    }));
});
var $a882ddb0e71234be$export$2e2bcd8739ae039 = $a882ddb0e71234be$var$TabScrollButton;





function $11c5a026a0fc305f$export$cdd93bd054dec359(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiTabs', slot);
}
const $11c5a026a0fc305f$var$tabsClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiTabs', [
    'root',
    'vertical',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $11c5a026a0fc305f$export$2e2bcd8739ae039 = $11c5a026a0fc305f$var$tabsClasses;





var $bbzbN = parcelRequire("bbzbN");
'use client';
const $c45f613599c3205d$var$_excluded = [
    "aria-label",
    "aria-labelledby",
    "action",
    "centered",
    "children",
    "className",
    "component",
    "allowScrollButtonsMobile",
    "indicatorColor",
    "onChange",
    "orientation",
    "ScrollButtonComponent",
    "scrollButtons",
    "selectionFollowsFocus",
    "slots",
    "slotProps",
    "TabIndicatorProps",
    "TabScrollButtonProps",
    "textColor",
    "value",
    "variant",
    "visibleScrollbar"
];
const $c45f613599c3205d$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $c45f613599c3205d$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $c45f613599c3205d$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $c45f613599c3205d$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        flexContainer: [
            'flexContainer',
            vertical && 'flexContainerVertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $11c5a026a0fc305f$export$cdd93bd054dec359), classes);
};
const $c45f613599c3205d$var$TabsRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $11c5a026a0fc305f$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $11c5a026a0fc305f$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.scrollButtonsHideMobile && {
        [`& .${(0, $11c5a026a0fc305f$export$2e2bcd8739ae039).scrollButtons}`]: {
            [theme.breakpoints.down('sm')]: {
                display: 'none'
            }
        }
    }));
const $c45f613599c3205d$var$TabsScroller = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        position: 'relative',
        display: 'inline-block',
        flex: '1 1 auto',
        whiteSpace: 'nowrap'
    }, ownerState.fixed && {
        overflowX: 'hidden',
        width: '100%'
    }, ownerState.hideScrollbar && {
        // Hide dimensionless scrollbar on macOS
        scrollbarWidth: 'none',
        // Firefox
        '&::-webkit-scrollbar': {
            display: 'none' // Safari + Chrome
        }
    }, ownerState.scrollableX && {
        overflowX: 'auto',
        overflowY: 'hidden'
    }, ownerState.scrollableY && {
        overflowY: 'auto',
        overflowX: 'hidden'
    }));
const $c45f613599c3205d$var$FlexContainer = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiTabs',
    slot: 'FlexContainer',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'flex'
    }, ownerState.vertical && {
        flexDirection: 'column'
    }, ownerState.centered && {
        justifyContent: 'center'
    }));
const $c45f613599c3205d$var$TabsIndicator = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiTabs',
    slot: 'Indicator',
    overridesResolver: (props, styles)=>styles.indicator
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create()
    }, ownerState.indicatorColor === 'primary' && {
        backgroundColor: (theme.vars || theme).palette.primary.main
    }, ownerState.indicatorColor === 'secondary' && {
        backgroundColor: (theme.vars || theme).palette.secondary.main
    }, ownerState.vertical && {
        height: '100%',
        width: 2,
        right: 0
    }));
const $c45f613599c3205d$var$TabsScrollbarSize = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $3a66d534e874acfc$export$2e2bcd8739ae039))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $c45f613599c3205d$var$defaultIndicatorStyle = {};
let $c45f613599c3205d$var$warnedOnceTabPresent = false;
const $c45f613599c3205d$var$Tabs = /*#__PURE__*/ $7fPBF.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const isRtl = (0, $ef654b446fc390d6$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent = (0, $a882ddb0e71234be$export$2e2bcd8739ae039), scrollButtons: scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: TabScrollButtonProps = {}, textColor: textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false } = props, other = (0, $cFLic.default)(props, $c45f613599c3205d$var$_excluded);
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    });
    const classes = $c45f613599c3205d$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $7fPBF.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $7fPBF.useState($c45f613599c3205d$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $7fPBF.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $7fPBF.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $7fPBF.useState(false);
    const [scrollerStyle, setScrollerStyle] = $7fPBF.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $7fPBF.useRef(null);
    const tabListRef = $7fPBF.useRef(null);
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollLeftNormalized: (0, $ac35c5e63375259c$export$3c615b88e5d7e4f6)(tabsNode, isRtl ? 'rtl' : 'ltr'),
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) {
                const correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
                startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + correction);
            }
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        // IE11 support, replace with Number.isNaN
        // eslint-disable-next-line no-restricted-globals
        if (isNaN(indicatorStyle[startIndicator]) || isNaN(indicatorStyle[size])) setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $83b553d4c6fa4e14$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else {
            scrollValue += delta * (isRtl ? -1 : 1);
            // Fix for Edge
            scrollValue *= isRtl && (0, $ac35c5e63375259c$export$a10970ffb6510128)() === 'reverse' ? -1 : 1;
        }
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $7fPBF.useCallback((scrollbarWidth)=>{
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, []);
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $bbzbN.jsx)($c45f613599c3205d$var$TabsScrollbarSize, {
            onChange: handleScrollbarSizeChange,
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.scrollableX, classes.hideScrollbar)
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $bbzbN.jsx)(ScrollButtonComponent, (0, $kY3Ke.default)({
            slots: {
                StartScrollButtonIcon: slots.StartScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll
        }, TabScrollButtonProps, {
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $bbzbN.jsx)(ScrollButtonComponent, (0, $kY3Ke.default)({
            slots: {
                EndScrollButtonIcon: slots.EndScrollButtonIcon
            },
            slotProps: {
                endScrollButtonIcon: endScrollButtonIconProps
            },
            orientation: orientation,
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll
        }, TabScrollButtonProps, {
            className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.scrollButtons, TabScrollButtonProps.className)
        })) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $7fPBF.useEffect(()=>{
        const handleResize = (0, $3aadd01758bd49c1$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    var _resizeObserver2;
                    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $6cb2f4180c9526e0$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            var _mutationObserver, _resizeObserver3;
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            (_mutationObserver = mutationObserver) == null || _mutationObserver.disconnect();
            (_resizeObserver3 = resizeObserver) == null || _resizeObserver3.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $7fPBF.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp == null ? void 0 : childrenProp.length
    ]);
    $7fPBF.useEffect(()=>{
        setMounted(true);
    }, []);
    $7fPBF.useEffect(()=>{
        updateIndicatorState();
    });
    $7fPBF.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($c45f613599c3205d$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $7fPBF.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const indicator = /*#__PURE__*/ (0, $bbzbN.jsx)($c45f613599c3205d$var$TabsIndicator, (0, $kY3Ke.default)({}, TabIndicatorProps, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.indicator, TabIndicatorProps.className),
        ownerState: ownerState,
        style: (0, $kY3Ke.default)({}, indicatorStyle, TabIndicatorProps.style)
    }));
    let childIndex = 0;
    const children = $7fPBF.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $7fPBF.cloneElement(child, (0, $kY3Ke.default)({
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue
        }, childIndex === 1 && value === false && !child.props.tabIndex ? {
            tabIndex: 0
        } : {}));
    });
    const handleKeyDown = (event)=>{
        const list = tabListRef.current;
        const currentFocus = (0, $9502daaf177b272b$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $c45f613599c3205d$var$moveFocus(list, currentFocus, $c45f613599c3205d$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $c45f613599c3205d$var$moveFocus(list, currentFocus, $c45f613599c3205d$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $c45f613599c3205d$var$moveFocus(list, null, $c45f613599c3205d$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $c45f613599c3205d$var$moveFocus(list, null, $c45f613599c3205d$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($c45f613599c3205d$var$TabsRoot, (0, $kY3Ke.default)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        as: component
    }, other, {
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $bbzbN.jsxs)($c45f613599c3205d$var$TabsScroller, {
                className: classes.scroller,
                ownerState: ownerState,
                style: {
                    overflow: scrollerStyle.overflow,
                    [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
                },
                ref: tabsRef,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)($c45f613599c3205d$var$FlexContainer, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        className: classes.flexContainer,
                        ownerState: ownerState,
                        onKeyDown: handleKeyDown,
                        ref: tabListRef,
                        role: "tablist",
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    }));
});
var $c45f613599c3205d$export$2e2bcd8739ae039 = $c45f613599c3205d$var$Tabs;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");










function $ec63e1681c0cbdaa$export$72aef224d6115253(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiTab', slot);
}
const $ec63e1681c0cbdaa$var$tabClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper'
]);
var $ec63e1681c0cbdaa$export$2e2bcd8739ae039 = $ec63e1681c0cbdaa$var$tabClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $b2a8111cea006e88$var$_excluded = [
    "className",
    "disabled",
    "disableFocusRipple",
    "fullWidth",
    "icon",
    "iconPosition",
    "indicator",
    "label",
    "onChange",
    "onClick",
    "onFocus",
    "selected",
    "selectionFollowsFocus",
    "textColor",
    "value",
    "wrapped"
];
const $b2a8111cea006e88$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        iconWrapper: [
            'iconWrapper'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $ec63e1681c0cbdaa$export$72aef224d6115253), classes);
};
const $b2a8111cea006e88$var$TabRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $ec63e1681c0cbdaa$export$2e2bcd8739ae039).iconWrapper}`]: styles.iconWrapper
            }
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, theme.typography.button, {
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center'
    }, ownerState.label && {
        flexDirection: ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom' ? 'column' : 'row'
    }, {
        lineHeight: 1.25
    }, ownerState.icon && ownerState.label && {
        minHeight: 72,
        paddingTop: 9,
        paddingBottom: 9,
        [`& > .${(0, $ec63e1681c0cbdaa$export$2e2bcd8739ae039).iconWrapper}`]: (0, $kY3Ke.default)({}, ownerState.iconPosition === 'top' && {
            marginBottom: 6
        }, ownerState.iconPosition === 'bottom' && {
            marginTop: 6
        }, ownerState.iconPosition === 'start' && {
            marginRight: theme.spacing(1)
        }, ownerState.iconPosition === 'end' && {
            marginLeft: theme.spacing(1)
        })
    }, ownerState.textColor === 'inherit' && {
        color: 'inherit',
        opacity: 0.6,
        // same opacity as theme.palette.text.secondary
        [`&.${(0, $ec63e1681c0cbdaa$export$2e2bcd8739ae039).selected}`]: {
            opacity: 1
        },
        [`&.${(0, $ec63e1681c0cbdaa$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        }
    }, ownerState.textColor === 'primary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $ec63e1681c0cbdaa$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.primary.main
        },
        [`&.${(0, $ec63e1681c0cbdaa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.textColor === 'secondary' && {
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $ec63e1681c0cbdaa$export$2e2bcd8739ae039).selected}`]: {
            color: (theme.vars || theme).palette.secondary.main
        },
        [`&.${(0, $ec63e1681c0cbdaa$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        }
    }, ownerState.fullWidth && {
        flexShrink: 1,
        flexGrow: 1,
        flexBasis: 0,
        maxWidth: 'none'
    }, ownerState.wrapped && {
        fontSize: theme.typography.pxToRem(12)
    }));
const $b2a8111cea006e88$var$Tab = /*#__PURE__*/ $7fPBF.forwardRef(function Tab(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false } = props, other = (0, $cFLic.default)(props, $b2a8111cea006e88$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    });
    const classes = $b2a8111cea006e88$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $7fPBF.isValidElement(iconProp) ? /*#__PURE__*/ $7fPBF.cloneElement(iconProp, {
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.iconWrapper, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($b2a8111cea006e88$var$TabRoot, (0, $kY3Ke.default)({
        focusRipple: !disableFocusRipple,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1
    }, other, {
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    }));
});
var $b2a8111cea006e88$export$2e2bcd8739ae039 = $b2a8111cea006e88$var$Tab;





/* =======================
 * API
 * ======================= */ /**
 * 참석률 랭킹 조회
 */ const $c2d7e554a57806f2$var$getAttendStats = async (year, month)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).get(`/game/stats/attend`, {
        params: {
            year: year,
            month: month
        }
    }).then((res)=>res.data);
/**
 * 승점 랭킹 조회
 */ const $c2d7e554a57806f2$var$getPointStats = async (year, month)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).get(`/game/stats/point`, {
        params: {
            year: year,
            month: month
        }
    }).then((res)=>res.data);
/**
 * 공격 포인트 랭킹 조회
 */ const $c2d7e554a57806f2$var$getAttackStats = async (year, month)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).get(`/game/stats/attack`, {
        params: {
            year: year,
            month: month
        }
    }).then((res)=>res.data);
/* =======================
 * EXPORT
 * ======================= */ const $c2d7e554a57806f2$var$StatService = {
    getAttendStats: $c2d7e554a57806f2$var$getAttendStats,
    getPointStats: $c2d7e554a57806f2$var$getPointStats,
    getAttackStats: $c2d7e554a57806f2$var$getAttackStats
};
var $c2d7e554a57806f2$export$2e2bcd8739ae039 = $c2d7e554a57806f2$var$StatService;


const $88ae740b1b510842$var$RankView = ({ onClose: onClose })=>{
    const handleOverlayClick = (0, $7fPBF.useCallback)(()=>onClose(), [
        onClose
    ]);
    const [tabIndex, setTabIndex] = (0, $7fPBF.useState)(0);
    const [year, setYear] = (0, $7fPBF.useState)(new Date().getFullYear());
    const [attendList, setAttendList] = (0, $7fPBF.useState)([]);
    const [pointList, setPointList] = (0, $7fPBF.useState)([]);
    const [attackList, setAttackList] = (0, $7fPBF.useState)([]);
    const [month, setMonth] = (0, $7fPBF.useState)('');
    (0, $7fPBF.useEffect)(()=>{
        if (year) loadData();
    }, [
        year,
        month
    ]);
    const loadData = async ()=>{
        setAttendList(await (0, $c2d7e554a57806f2$export$2e2bcd8739ae039).getAttendStats(year, month));
        setPointList(await (0, $c2d7e554a57806f2$export$2e2bcd8739ae039).getPointStats(year, month));
        setAttackList(await (0, $c2d7e554a57806f2$export$2e2bcd8739ae039).getAttackStats(year, month));
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5f47bfd43cc47d77$export$2e2bcd8739ae039), {
                title: "\uB7AD\uD0B9",
                onClose: handleOverlayClick
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "rank-board",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4ac626799ed465c3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        style: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginTop: '2px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    justifyContent: 'center',
                                    mb: 1,
                                    minHeight: '40px',
                                    marginBottom: '0px'
                                },
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                    sx: {
                                        height: '40px'
                                    },
                                    size: "small",
                                    value: year,
                                    onChange: (e)=>setYear(Number(e.target.value)),
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                        value: '2026',
                                        children: "2026"
                                    }, '2026')
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    justifyContent: 'center',
                                    mb: 1,
                                    minHeight: '40px',
                                    marginBottom: '0px'
                                },
                                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                    sx: {
                                        height: '40px',
                                        ml: 1
                                    },
                                    size: "small",
                                    value: month,
                                    onChange: (e)=>setMonth(e.target.value === '' ? '' : String(e.target.value)),
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: "",
                                            children: "\uC804\uCCB4"
                                        }, ''),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: '01',
                                            children: "01"
                                        }, '01'),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: '02',
                                            children: "02"
                                        }, '02'),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: '03',
                                            children: "03"
                                        }, '03'),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: '04',
                                            children: "04"
                                        }, '04'),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: '05',
                                            children: "05"
                                        }, '05'),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: '06',
                                            children: "06"
                                        }, '06'),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: '07',
                                            children: "07"
                                        }, '07'),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: '08',
                                            children: "08"
                                        }, '08'),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: '09',
                                            children: "09"
                                        }, '09'),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: '10',
                                            children: "10"
                                        }, '10'),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: '11',
                                            children: "11"
                                        }, '11'),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: '12',
                                            children: "12"
                                        }, '12')
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $c45f613599c3205d$export$2e2bcd8739ae039), {
                        value: tabIndex,
                        onChange: (_, v)=>setTabIndex(v),
                        variant: "fullWidth",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b2a8111cea006e88$export$2e2bcd8739ae039), {
                                label: "\uCC38\uC11D\uB960"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b2a8111cea006e88$export$2e2bcd8739ae039), {
                                label: "\uC2B9\uC810"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b2a8111cea006e88$export$2e2bcd8739ae039), {
                                label: "\uACF5\uACA9\uD3EC\uC778\uD2B8"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        className: "rank-content",
                        children: [
                            tabIndex === 0 && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                        className: "rank-row rank-header",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                children: "\uC21C\uC704"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                children: "\uC774\uB984"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                children: "\uCD9C\uC11D\uB960"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                children: "\uCC38\uC11D/\uC804\uCCB4"
                                            })
                                        ]
                                    }),
                                    attendList.map((r)=>{
                                        const trophy = r.ranking === 1 ? "\uD83E\uDD47" : r.ranking === 2 ? "\uD83E\uDD48" : r.ranking === 3 ? "\uD83E\uDD49" : r.ranking;
                                        return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                            className: "rank-row",
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                    children: trophy
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                    children: r.name
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                                    children: [
                                                        r.attendRatio,
                                                        "%"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                                    children: [
                                                        r.attendGameCnt,
                                                        "/",
                                                        r.totalGameCnt
                                                    ]
                                                })
                                            ]
                                        }, `1-${r.ranking}-${r.name}`);
                                    })
                                ]
                            }),
                            tabIndex === 1 && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                        className: "rank-row rank-header",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                children: "\uC21C\uC704"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                children: "\uC774\uB984"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                children: "\uD3EC\uC778\uD2B8"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                children: "\uC2B9/\uBB34/\uD328"
                                            })
                                        ]
                                    }),
                                    pointList.map((r)=>{
                                        const trophy = r.ranking === 1 ? "\uD83E\uDD47" : r.ranking === 2 ? "\uD83E\uDD48" : r.ranking === 3 ? "\uD83E\uDD49" : r.ranking;
                                        return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                            className: "rank-row",
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                    children: trophy
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                    children: r.name
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                                    children: [
                                                        r.totalPoint,
                                                        "\uC810"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                                    children: [
                                                        r.winCnt,
                                                        "/",
                                                        r.drawCnt,
                                                        "/",
                                                        r.loseCnt
                                                    ]
                                                })
                                            ]
                                        }, `2-${r.ranking}-${r.name}`);
                                    })
                                ]
                            }),
                            tabIndex === 2 && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                        className: "rank-row rank-header",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                children: "\uC21C\uC704"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                children: "\uC774\uB984"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                children: "\uACF5\uACA9\uD3EC\uC778\uD2B8"
                                            })
                                        ]
                                    }),
                                    attackList.map((r)=>{
                                        const trophy = r.ranking === 1 ? "\uD83E\uDD47" : r.ranking === 2 ? "\uD83E\uDD48" : r.ranking === 3 ? "\uD83E\uDD49" : r.ranking;
                                        return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                            className: "rank-row",
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                    children: trophy
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                    children: r.name
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                                    children: [
                                                        r.goal,
                                                        "\uACE8 / ",
                                                        r.assist,
                                                        "\uB3C4\uC6C0"
                                                    ]
                                                })
                                            ]
                                        }, `3-${r.ranking}-${r.name}`);
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $88ae740b1b510842$export$2e2bcd8739ae039 = $88ae740b1b510842$var$RankView;


const $972fb1522e38491c$var$Transition = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Transition(props, ref) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a3f6f5762623b961$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        direction: "left",
        ref: ref
    }, props));
});
const $972fb1522e38491c$var$MenuItem = (props)=>{
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false);
    const handleClickOpen = ()=>{
        setOpen(true);
    };
    const handleClose = ()=>{
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: `mrml-24px ptpb-22px flex justify-between ${props.className ? props.className : ''}`,
                onClick: handleClickOpen,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        children: props.title
                    }),
                    props.iconClass && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                        iconClass: props.iconClass
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $7f096abd658f7c85$export$2e2bcd8739ae039), {
                fullScreen: true,
                open: open,
                onClose: handleClose,
                TransitionComponent: $972fb1522e38491c$var$Transition,
                children: [
                    props.link === 'board' && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c2dc123a54a47ffb$export$2e2bcd8739ae039), {
                        onClose: handleClose
                    }),
                    props.link === 'member' && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8e5c94195ca6a6c8$export$2e2bcd8739ae039), {
                        onClose: handleClose
                    }),
                    props.link === 'place' && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $289bf3c04b4f6227$export$2e2bcd8739ae039), {
                        onClose: handleClose
                    }),
                    props.link === 'rank' && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $88ae740b1b510842$export$2e2bcd8739ae039), {
                        onClose: handleClose
                    })
                ]
            })
        ]
    });
};
var $972fb1522e38491c$export$2e2bcd8739ae039 = $972fb1522e38491c$var$MenuItem;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");




const $853382ce6814d157$var$Logout = ()=>{
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [isOpen, setIsOpen] = (0, $7fPBF.useState)(false);
    const logout = ()=>{
        (0, $33eb00f42ea63933$export$2e2bcd8739ae039).initStorage();
        navigate("/");
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "mrml-24px ptpb-22px border-top-gray text-center b2_l",
                onClick: ()=>setIsOpen(true),
                children: "\uB85C\uADF8\uC544\uC6C3"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $79d0143175d5363b$export$2e2bcd8739ae039), {
                content: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                    children: (0, $2df1405d783f614e$export$a847abda144a238b).LOGOUT.CONTENT
                }),
                title: undefined,
                leftBtnContent: (0, $2df1405d783f614e$export$a847abda144a238b).LOGOUT.LBTN,
                rightBtnContent: (0, $2df1405d783f614e$export$a847abda144a238b).LOGOUT.RBTN,
                isOpen: isOpen,
                onClick: ()=>logout(),
                onClose: ()=>setIsOpen(false)
            })
        ]
    });
};
var $853382ce6814d157$export$2e2bcd8739ae039 = $853382ce6814d157$var$Logout;



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");






const $b467738b35160cd4$var$DeleteUser = ()=>{
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [isOpen, setIsOpen] = (0, $7fPBF.useState)(false);
    const { refetch: deleteUser } = (0, $d8deb3a6a62b947e$export$dd0a697e1782aedd)([
        'deleteUser'
    ], ()=>(0, $4d624a4edc63c668$export$2e2bcd8739ae039).deleteUser((0, $33eb00f42ea63933$export$2e2bcd8739ae039).getLocalStorage("USER_ID") ? Number((0, $33eb00f42ea63933$export$2e2bcd8739ae039).getLocalStorage("USER_ID")) : 0), {
        onSuccess: ()=>{
            (0, $33eb00f42ea63933$export$2e2bcd8739ae039).initStorage();
            navigate("/");
        }
    });
    const logout = async ()=>{
        await deleteUser();
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "mrml-24px ptpb-22px border-top-gray text-center button2-style cl-point06 c1_r",
                onClick: ()=>setIsOpen(true),
                children: (0, $2df1405d783f614e$export$b1f0f495d632262c).BTN
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $79d0143175d5363b$export$2e2bcd8739ae039), {
                content: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                    children: "\uACC4\uC815\uC744 \uC0AD\uC81C \uD558\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"
                }),
                title: undefined,
                leftBtnContent: "\uC0AD\uC81C",
                rightBtnContent: "\uCDE8\uC18C",
                isOpen: isOpen,
                onClick: ()=>logout(),
                onClose: ()=>setIsOpen(false)
            })
        ]
    });
};
var $b467738b35160cd4$export$2e2bcd8739ae039 = $b467738b35160cd4$var$DeleteUser;


const $399a0fbc1d919eed$var$DeleteUserView = ()=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b467738b35160cd4$export$2e2bcd8739ae039), {})
    });
};
var $399a0fbc1d919eed$export$2e2bcd8739ae039 = $399a0fbc1d919eed$var$DeleteUserView;



const $a406a60673f791be$var$MenuView = (props)=>{
    const [noticeIcon, setNoticeIcon] = (0, $7fPBF.useState)('notice-off');
    const handleOverlayClick = (0, $7fPBF.useCallback)(()=>props.onClose(), [
        props.onClose
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "menu b2_r",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5f47bfd43cc47d77$export$2e2bcd8739ae039), {
                title: "\uBA54\uB274",
                onClose: handleOverlayClick,
                rightIcon: `${noticeIcon.toString()} w-26px h-26px`,
                rightLink: "notificationList"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4ac626799ed465c3$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $972fb1522e38491c$export$2e2bcd8739ae039), {
                title: "\uACF5\uC9C0\uC0AC\uD56D",
                link: "board",
                className: "border-top-gray",
                iconClass: "next w-6px h-12px"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $972fb1522e38491c$export$2e2bcd8739ae039), {
                title: "\uD68C\uC6D0 \uAD00\uB9AC",
                link: "member",
                className: "border-top-gray",
                iconClass: "next w-6px h-12px"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $972fb1522e38491c$export$2e2bcd8739ae039), {
                title: "\uACBD\uAE30\uC7A5 \uAD00\uB9AC",
                link: "place",
                className: "border-top-gray",
                iconClass: "next w-6px h-12px"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $972fb1522e38491c$export$2e2bcd8739ae039), {
                title: "\uB7AD\uD0B9",
                link: "rank",
                className: "border-top-gray",
                iconClass: "next w-6px h-12px"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $853382ce6814d157$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $399a0fbc1d919eed$export$2e2bcd8739ae039), {})
        ]
    });
};
var $a406a60673f791be$export$2e2bcd8739ae039 = $a406a60673f791be$var$MenuView;


const $a44d74230def4758$var$Transition = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(function Transition(props, ref) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a3f6f5762623b961$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        direction: "right",
        ref: ref
    }, props));
});
const $a44d74230def4758$var$Header = (props)=>{
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false);
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const handleClickOpen = ()=>{
        setOpen(true);
    };
    const handleClose = ()=>{
        navigate('/main');
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "header",
                children: [
                    props.leftIcon && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "left svg",
                                onClick: handleClickOpen,
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                                    iconClass: props.leftIcon
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                className: "b1_r",
                                children: props.title
                            })
                        ]
                    }),
                    props.rightLink && props.rightIcon && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                        to: props.rightLink,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: "right svg",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                                iconClass: props.rightIcon
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7f096abd658f7c85$export$2e2bcd8739ae039), {
                fullScreen: true,
                open: open,
                onClose: handleClose,
                TransitionComponent: $a44d74230def4758$var$Transition,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a406a60673f791be$export$2e2bcd8739ae039), {
                    onClose: handleClose
                })
            })
        ]
    });
};
var $a44d74230def4758$export$2e2bcd8739ae039 = $a44d74230def4758$var$Header;




var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");





const $9edd82d19644f411$var$getGameList = async ()=>(0, $b13c137540e062b0$export$407ca81eb46778dd).get("/game/list").then((res)=>res.data);
const $9edd82d19644f411$var$postGame = async (game)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).post("/game", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, game)).then((res)=>res.data);
const $9edd82d19644f411$var$putGame = async (game, gameId)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).patch("/game/" + gameId.toString(), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, game));
const $9edd82d19644f411$var$putGameResult = async (game, gameId)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).patch("/game/" + gameId.toString() + "/result", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, game));
/** 경기 단건 조회 */ const $9edd82d19644f411$var$getGame = async (gameId)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).get(`/game/${gameId}`).then((res)=>res.data);
const $9edd82d19644f411$var$GameService = {
    getGameList: $9edd82d19644f411$var$getGameList,
    postGame: $9edd82d19644f411$var$postGame,
    putGame: $9edd82d19644f411$var$putGame,
    getGame: $9edd82d19644f411$var$getGame,
    putGameResult: $9edd82d19644f411$var$putGameResult
};
var $9edd82d19644f411$export$2e2bcd8739ae039 = $9edd82d19644f411$var$GameService;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");









function $833ef9b800b82ea7$export$f3b76d2cce458caa(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiCard', slot);
}
const $833ef9b800b82ea7$var$cardClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiCard', [
    'root'
]);
var $833ef9b800b82ea7$export$2e2bcd8739ae039 = $833ef9b800b82ea7$var$cardClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $bfb223886c302418$var$_excluded = [
    "className",
    "raised"
];
const $bfb223886c302418$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $833ef9b800b82ea7$export$f3b76d2cce458caa), classes);
};
const $bfb223886c302418$var$CardRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: 'hidden'
    };
});
const $bfb223886c302418$var$Card = /*#__PURE__*/ $7fPBF.forwardRef(function Card(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false } = props, other = (0, $cFLic.default)(props, $bfb223886c302418$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        raised: raised
    });
    const classes = $bfb223886c302418$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($bfb223886c302418$var$CardRoot, (0, $kY3Ke.default)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $bfb223886c302418$export$2e2bcd8739ae039 = $bfb223886c302418$var$Card;


var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");







function $c2cdbecd165cb878$export$964336739a8c7119(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiCardContent', slot);
}
const $c2cdbecd165cb878$var$cardContentClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiCardContent', [
    'root'
]);
var $c2cdbecd165cb878$export$2e2bcd8739ae039 = $c2cdbecd165cb878$var$cardContentClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $8bffaacbbee0c705$var$_excluded = [
    "className",
    "component"
];
const $8bffaacbbee0c705$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $c2cdbecd165cb878$export$964336739a8c7119), classes);
};
const $8bffaacbbee0c705$var$CardContentRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiCardContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        '&:last-child': {
            paddingBottom: 24
        }
    };
});
const $8bffaacbbee0c705$var$CardContent = /*#__PURE__*/ $7fPBF.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $cFLic.default)(props, $8bffaacbbee0c705$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component
    });
    const classes = $8bffaacbbee0c705$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($8bffaacbbee0c705$var$CardContentRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $8bffaacbbee0c705$export$2e2bcd8739ae039 = $8bffaacbbee0c705$var$CardContent;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");






var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");




var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


'use client';
/**
 * The basic building block for creating custom snackbar.
 *
 * Demos:
 *
 * - [Snackbar](https://mui.com/base-ui/react-snackbar/#hook)
 *
 * API:
 *
 * - [useSnackbar API](https://mui.com/base-ui/react-snackbar/hooks-api/#use-snackbar)
 */ function $fbecd6c36e5e044e$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    $7fPBF.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) // IE11, Edge (prior to using Blink?) use 'Esc'
            {
                if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose == null || onClose(nativeEvent, 'escapeKeyDown');
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event, reason)=>{
        onClose == null || onClose(event, reason);
    });
    const setAutoHideTimer = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, 'timeout');
        });
    });
    $7fPBF.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose == null || onClose(event, 'clickaway');
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $7fPBF.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback == null || onBlurCallback(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback == null || onFocusCallback(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback == null || onMouseEnterCallback(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback == null || onMouseLeaveCallback(event);
            handleResume();
        };
    $7fPBF.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return ()=>{
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = (0, $kY3Ke.default)({}, (0, $7a075a443b93da2d$export$2e2bcd8739ae039)(parameters), (0, $7a075a443b93da2d$export$2e2bcd8739ae039)(externalProps));
        return (0, $kY3Ke.default)({
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: 'presentation'
        }, externalProps, externalEventHandlers, {
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        });
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $fbecd6c36e5e044e$export$2e2bcd8739ae039 = $fbecd6c36e5e044e$var$useSnackbar;



var $7fPBF = parcelRequire("7fPBF");




var $bbzbN = parcelRequire("bbzbN");
'use client';
function $feb114cb8fcb331a$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $feb114cb8fcb331a$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $feb114cb8fcb331a$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $7fPBF.useRef(false);
    const nodeRef = $7fPBF.useRef(null);
    const activatedRef = $7fPBF.useRef(false);
    const syntheticEventRef = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)((0, $8971fd60a8b100cf$export$2e2bcd8739ae039)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $feb114cb8fcb331a$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $7fPBF.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $feb114cb8fcb331a$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $7fPBF.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $feb114cb8fcb331a$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $35e4b0c27d76b933$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($7fPBF.Fragment, {
        children: /*#__PURE__*/ $7fPBF.cloneElement(children, childrenProps)
    });
}







var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");









function $58be9cb10f53ed84$export$def81488db1a3216(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiSnackbarContent', slot);
}
const $58be9cb10f53ed84$var$snackbarContentClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiSnackbarContent', [
    'root',
    'message',
    'action'
]);
var $58be9cb10f53ed84$export$2e2bcd8739ae039 = $58be9cb10f53ed84$var$snackbarContentClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $7f3b829aa55dc1b3$var$_excluded = [
    "action",
    "className",
    "message",
    "role"
];
const $7f3b829aa55dc1b3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        action: [
            'action'
        ],
        message: [
            'message'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $58be9cb10f53ed84$export$def81488db1a3216), classes);
};
const $7f3b829aa55dc1b3$var$SnackbarContentRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiSnackbarContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(({ theme: theme })=>{
    const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    const backgroundColor = (0, $553ed2baba4347ed$exports.emphasize)(theme.palette.background.default, emphasis);
    return (0, $kY3Ke.default)({}, theme.typography.body2, {
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText(backgroundColor),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : backgroundColor,
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            flexGrow: 'initial',
            minWidth: 288
        }
    });
});
const $7f3b829aa55dc1b3$var$SnackbarContentMessage = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0'
});
const $7f3b829aa55dc1b3$var$SnackbarContentAction = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
});
const $7f3b829aa55dc1b3$var$SnackbarContent = /*#__PURE__*/ $7fPBF.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSnackbarContent'
    });
    const { action: action, className: className, message: message, role: role = 'alert' } = props, other = (0, $cFLic.default)(props, $7f3b829aa55dc1b3$var$_excluded);
    const ownerState = props;
    const classes = $7f3b829aa55dc1b3$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7f3b829aa55dc1b3$var$SnackbarContentRoot, (0, $kY3Ke.default)({
        role: role,
        square: true,
        elevation: 6,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($7f3b829aa55dc1b3$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $bbzbN.jsx)($7f3b829aa55dc1b3$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    }));
});
var $7f3b829aa55dc1b3$export$2e2bcd8739ae039 = $7f3b829aa55dc1b3$var$SnackbarContent;




function $4645864a9a0034f9$export$6cb096457f5926f4(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiSnackbar', slot);
}
const $4645864a9a0034f9$var$snackbarClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiSnackbar', [
    'root',
    'anchorOriginTopCenter',
    'anchorOriginBottomCenter',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft'
]);
var $4645864a9a0034f9$export$2e2bcd8739ae039 = $4645864a9a0034f9$var$snackbarClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $ac8294fb74a722b7$var$_excluded = [
    "onEnter",
    "onExited"
], $ac8294fb74a722b7$var$_excluded2 = [
    "action",
    "anchorOrigin",
    "autoHideDuration",
    "children",
    "className",
    "ClickAwayListenerProps",
    "ContentProps",
    "disableWindowBlurListener",
    "message",
    "onBlur",
    "onClose",
    "onFocus",
    "onMouseEnter",
    "onMouseLeave",
    "open",
    "resumeHideDuration",
    "TransitionComponent",
    "transitionDuration",
    "TransitionProps"
];
const $ac8294fb74a722b7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            'root',
            `anchorOrigin${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(anchorOrigin.vertical)}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $4645864a9a0034f9$export$6cb096457f5926f4), classes);
};
const $ac8294fb74a722b7$var$SnackbarRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.anchorOrigin.vertical)}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    const center = {
        left: '50%',
        right: 'auto',
        transform: 'translateX(-50%)'
    };
    return (0, $kY3Ke.default)({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center'
    }, ownerState.anchorOrigin.vertical === 'top' ? {
        top: 8
    } : {
        bottom: 8
    }, ownerState.anchorOrigin.horizontal === 'left' && {
        justifyContent: 'flex-start'
    }, ownerState.anchorOrigin.horizontal === 'right' && {
        justifyContent: 'flex-end'
    }, {
        [theme.breakpoints.up('sm')]: (0, $kY3Ke.default)({}, ownerState.anchorOrigin.vertical === 'top' ? {
            top: 24
        } : {
            bottom: 24
        }, ownerState.anchorOrigin.horizontal === 'center' && center, ownerState.anchorOrigin.horizontal === 'left' && {
            left: 24,
            right: 'auto'
        }, ownerState.anchorOrigin.horizontal === 'right' && {
            right: 24,
            left: 'auto'
        })
    });
});
const $ac8294fb74a722b7$var$Snackbar = /*#__PURE__*/ $7fPBF.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    const theme = (0, $bc16b792e42cac5d$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: 'bottom',
        horizontal: 'left'
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerProps, ContentProps: ContentProps, disableWindowBlurListener: disableWindowBlurListener = false, message: message, open: open, TransitionComponent: TransitionComponent = (0, $7ec2c0aa92d4d29c$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited } = {} } = props, TransitionProps = (0, $cFLic.default)(props.TransitionProps, $ac8294fb74a722b7$var$_excluded), other = (0, $cFLic.default)(props, $ac8294fb74a722b7$var$_excluded2);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDuration
    });
    const classes = $ac8294fb74a722b7$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $fbecd6c36e5e044e$export$2e2bcd8739ae039)((0, $kY3Ke.default)({}, ownerState));
    const [exited, setExited] = $7fPBF.useState(true);
    const rootProps = (0, $a70b740322660959$export$2e2bcd8739ae039)({
        elementType: $ac8294fb74a722b7$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: other,
        ownerState: ownerState,
        additionalProps: {
            ref: ref
        },
        className: [
            classes.root,
            className
        ]
    });
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $feb114cb8fcb331a$export$58385c17fee43f89), (0, $kY3Ke.default)({
        onClickAway: onClickAway
    }, ClickAwayListenerProps, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($ac8294fb74a722b7$var$SnackbarRoot, (0, $kY3Ke.default)({}, rootProps, {
            children: /*#__PURE__*/ (0, $bbzbN.jsx)(TransitionComponent, (0, $kY3Ke.default)({
                appear: true,
                in: open,
                timeout: transitionDuration,
                direction: vertical === 'top' ? 'down' : 'up',
                onEnter: handleEnter,
                onExited: handleExited
            }, TransitionProps, {
                children: children || /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7f3b829aa55dc1b3$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
                    message: message,
                    action: action
                }, ContentProps))
            }))
        }))
    }));
});
var $ac8294fb74a722b7$export$2e2bcd8739ae039 = $ac8294fb74a722b7$var$Snackbar;




var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");







var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");




'use client';
const $6a8e6231295d6b22$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $6a8e6231295d6b22$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $6a8e6231295d6b22$var$_excluded3 = [
    "component"
];
function $6a8e6231295d6b22$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $cFLic.default)(parameters, $6a8e6231295d6b22$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $cFLic.default)(externalForwardedProps, $6a8e6231295d6b22$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $ae0f0ccae9f4b3cc$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $a945a7a9a1371b8c$export$2e2bcd8739ae039)((0, $kY3Ke.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $cFLic.default)(_mergeSlotProps.props, $6a8e6231295d6b22$var$_excluded3);
    const ref = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $kY3Ke.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $4520d0f80a3f7305$export$2e2bcd8739ae039)(elementType, (0, $kY3Ke.default)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}






function $565e939c768ed837$export$69aecd24bc2cf7e3(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiAlert', slot);
}
const $565e939c768ed837$var$alertClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $565e939c768ed837$export$2e2bcd8739ae039 = $565e939c768ed837$var$alertClasses;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");











function $0bca18aab596affa$export$5e8702d71474f093(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiIconButton', slot);
}
const $0bca18aab596affa$var$iconButtonClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $0bca18aab596affa$export$2e2bcd8739ae039 = $0bca18aab596affa$var$iconButtonClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $67a243c492197f3b$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $67a243c492197f3b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`,
            edge && `edge${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $0bca18aab596affa$export$5e8702d71474f093), classes);
};
const $67a243c492197f3b$var$IconButtonRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $553ed2baba4347ed$exports.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $kY3Ke.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $kY3Ke.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $kY3Ke.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $553ed2baba4347ed$exports.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $0bca18aab596affa$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $67a243c492197f3b$var$IconButton = /*#__PURE__*/ $7fPBF.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $cFLic.default)(props, $67a243c492197f3b$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $67a243c492197f3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($67a243c492197f3b$var$IconButtonRoot, (0, $kY3Ke.default)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $67a243c492197f3b$export$2e2bcd8739ae039 = $67a243c492197f3b$var$IconButton;


parcelRequire("7fPBF");


var $bbzbN = parcelRequire("bbzbN");
'use client';
var $4b1f521fdeb04ba7$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');


parcelRequire("7fPBF");


var $bbzbN = parcelRequire("bbzbN");
'use client';
var $a8adb66ebb93bcb3$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');


parcelRequire("7fPBF");


var $bbzbN = parcelRequire("bbzbN");
'use client';
var $ac73453dd233d58d$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');


parcelRequire("7fPBF");


var $bbzbN = parcelRequire("bbzbN");
'use client';
var $f3c8ba0a935153e4$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');


parcelRequire("7fPBF");


var $bbzbN = parcelRequire("bbzbN");
'use client';
var $8b028f185c60f26d$export$2e2bcd8739ae039 = (0, $4f9bc8f83648f682$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $c181cff0789717b3$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $c181cff0789717b3$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color || severity)}`,
            `${variant}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $565e939c768ed837$export$69aecd24bc2cf7e3), classes);
};
const $c181cff0789717b3$var$AlertRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? (0, $553ed2baba4347ed$exports.darken) : (0, $553ed2baba4347ed$exports.lighten);
    const getBackgroundColor = theme.palette.mode === 'light' ? (0, $553ed2baba4347ed$exports.lighten) : (0, $553ed2baba4347ed$exports.darken);
    return (0, $kY3Ke.default)({}, theme.typography.body2, {
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $565e939c768ed837$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $565e939c768ed837$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.dark).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: (0, $kY3Ke.default)({
                        fontWeight: theme.typography.fontWeightMedium
                    }, theme.vars ? {
                        color: theme.vars.palette.Alert[`${color}FilledColor`],
                        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                    } : {
                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                        color: theme.palette.getContrastText(theme.palette[color].main)
                    })
                }))
        ]
    });
});
const $c181cff0789717b3$var$AlertIcon = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $c181cff0789717b3$var$AlertMessage = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $c181cff0789717b3$var$AlertAction = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $c181cff0789717b3$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4b1f521fdeb04ba7$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a8adb66ebb93bcb3$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ac73453dd233d58d$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f3c8ba0a935153e4$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $c181cff0789717b3$var$Alert = /*#__PURE__*/ $7fPBF.forwardRef(function Alert(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $c181cff0789717b3$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard' } = props, other = (0, $cFLic.default)(props, $c181cff0789717b3$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    });
    const classes = $c181cff0789717b3$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, $kY3Ke.default)({
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon
        }, slots),
        slotProps: (0, $kY3Ke.default)({}, componentsProps, slotProps)
    };
    const [CloseButtonSlot, closeButtonProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('closeButton', {
        elementType: (0, $67a243c492197f3b$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('closeIcon', {
        elementType: (0, $8b028f185c60f26d$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($c181cff0789717b3$var$AlertRoot, (0, $kY3Ke.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $bbzbN.jsx)($c181cff0789717b3$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $c181cff0789717b3$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $bbzbN.jsx)($c181cff0789717b3$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $bbzbN.jsx)($c181cff0789717b3$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $bbzbN.jsx)($c181cff0789717b3$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)(CloseButtonSlot, (0, $kY3Ke.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)(CloseIconSlot, (0, $kY3Ke.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $c181cff0789717b3$export$2e2bcd8739ae039 = $c181cff0789717b3$var$Alert;










const $888f0a95330227fe$var$GameEditTab = (props)=>{
    const handleOverlayClick = (0, $7fPBF.useCallback)(()=>props.onClose(), [
        props.onClose
    ]);
    const handleReturnClick = (0, $7fPBF.useCallback)(()=>{
        props.onReturn();
    }, [
        props.onReturn
    ]);
    const dateRef = (0, $7fPBF.useRef)(null);
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const [places, setPlaces] = (0, $7fPBF.useState)([]);
    const writerId = (0, $33eb00f42ea63933$export$2e2bcd8739ae039).getLocalStorage((0, $2df1405d783f614e$export$212a8f1ea37518bd));
    var _props_game_matchDt, _props_game_time, _props_game_place, _props_game_type, _props_game_playersCountType, _props_game_vsName;
    const [gameItem, setGameItem] = (0, $7fPBF.useState)({
        id: props.game.id,
        writerId: writerId,
        teamId: props.game.teamId,
        matchDt: (_props_game_matchDt = props.game.matchDt) !== null && _props_game_matchDt !== void 0 ? _props_game_matchDt : '',
        time: (_props_game_time = props.game.time) !== null && _props_game_time !== void 0 ? _props_game_time : '',
        place: (_props_game_place = props.game.place) !== null && _props_game_place !== void 0 ? _props_game_place : '',
        type: (_props_game_type = props.game.type) !== null && _props_game_type !== void 0 ? _props_game_type : '',
        playersCountType: (_props_game_playersCountType = props.game.playersCountType) !== null && _props_game_playersCountType !== void 0 ? _props_game_playersCountType : '',
        vsName: (_props_game_vsName = props.game.vsName) !== null && _props_game_vsName !== void 0 ? _props_game_vsName : ''
    });
    const TIME_OPTIONS = [
        '20:00~22:00',
        '19:00~21:00',
        '18:00~20:00',
        '17:00~19:00',
        '16:00~18:00',
        '15:00~17:00',
        '14:00~16:00',
        '13:00~15:00',
        '12:00~14:00',
        '11:00~13:00',
        '10:00~12:00',
        '09:00~11:00',
        '08:00~10:00',
        '07:00~09:00',
        '06:00~08:00'
    ];
    const TYPE_OPTIONS = [
        {
            value: "\uC790\uCCB4\uC804",
            label: "\uC790\uCCB4\uC804"
        },
        {
            value: "\uC0C1\uB300\uC804",
            label: "\uC0C1\uB300\uC804"
        }
    ];
    const PLAYER_OPTIONS = [
        '11 VS 11',
        '10 VS 10'
    ];
    const [registItem, setRegistItem] = (0, $7fPBF.useState)();
    const [isOpen, setIsOpen] = (0, $7fPBF.useState)(false);
    let registFlag = false;
    /** 뒤로가기 감지 */ (0, $7fPBF.useEffect)(()=>{
        const unlisten = (0, $82bcba16c3ce4448$export$55abd4691b317664).listen(({ action: action })=>{
            if (action === 'POP') checkIsChanged();
        });
        return unlisten;
    }, []);
    const checkIsChanged = ()=>{
        if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(gameItem.matchDt) || (0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(gameItem.place)) setIsOpen(true);
        else {
            handleOverlayClick();
            props.onReturn();
        }
    };
    const inputChanged = (event)=>{
        const { id: id, value: value } = event.target;
        setGameItem((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, gameItem), {
            [id]: value
        }));
    };
    /** 경기 등록 API */ const { refetch: putGame } = (0, $d8deb3a6a62b947e$export$dd0a697e1782aedd)([
        'putGame'
    ], ()=>(0, $9edd82d19644f411$export$2e2bcd8739ae039).putGame(registItem, registItem.id), {
        onSuccess: ()=>{
            setOpen(true);
            handleReturnClick();
        }
    });
    const updateGame = ()=>{
        setRegistItem({
            id: props.game.id,
            writerId: writerId,
            teamId: props.game.teamId,
            matchDt: gameItem.matchDt,
            time: gameItem.time,
            place: gameItem.place,
            type: gameItem.type,
            playersCountType: gameItem.playersCountType,
            vsName: gameItem.vsName
        });
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!registItem) return;
        if (registFlag) return;
        registFlag = true;
        putGame().then(()=>{
            registFlag = false;
            return Promise;
        }).catch(console.log);
    }, [
        registItem
    ]);
    const isDisabled = gameItem.matchDt === '' || gameItem.time === '' || gameItem.place === '' || gameItem.type === '' || gameItem.playersCountType === '' || gameItem.type === "\uC0C1\uB300\uC804" && gameItem.vsName === '';
    (0, $7fPBF.useEffect)(()=>{
        loadPlaces();
    }, []);
    const loadPlaces = async ()=>{
        try {
            const list = await (0, $744a577e8e94e017$export$2e2bcd8739ae039).getPlaceList();
            setPlaces(list);
        } catch (e) {
            console.error(e);
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: 'game',
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "mainInput",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
                                id: "matchDt",
                                type: "date",
                                variant: "outlined",
                                fullWidth: true,
                                className: "b2_r mt-24px",
                                inputRef: dateRef,
                                value: gameItem.matchDt,
                                InputLabelProps: {
                                    shrink: true
                                },
                                onClick: ()=>{
                                    const input = dateRef.current;
                                    if (input === null || input === void 0 ? void 0 : input.showPicker) input.showPicker();
                                    else input === null || input === void 0 ? void 0 : input.focus();
                                },
                                onChange: inputChanged
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                value: gameItem.time,
                                displayEmpty: true,
                                className: "b2_r w-100p mt-16px",
                                onChange: (e)=>setGameItem((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, gameItem), {
                                        time: e.target.value
                                    })),
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                        value: "",
                                        disabled: true,
                                        children: "\uC2DC\uAC04"
                                    }),
                                    TIME_OPTIONS.map((time)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: time,
                                            children: time
                                        }, time))
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                value: gameItem.place,
                                displayEmpty: true,
                                className: "b2_r w-100p mt-16px",
                                onChange: (e)=>setGameItem((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, gameItem), {
                                        place: e.target.value
                                    })),
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                        value: "",
                                        disabled: true,
                                        children: "\uC7A5\uC18C"
                                    }),
                                    places.map((place)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: place.name,
                                            children: place.name
                                        }, place.id))
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                value: gameItem.type,
                                displayEmpty: true,
                                className: "b2_r w-100p mt-16px",
                                onChange: (e)=>setGameItem((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, gameItem), {
                                        type: e.target.value
                                    })),
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                        value: "",
                                        disabled: true,
                                        children: "\uD0C0\uC785"
                                    }),
                                    TYPE_OPTIONS.map((type)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: type.value,
                                            children: type.label
                                        }, type.value))
                                ]
                            }),
                            gameItem.type === "\uC0C1\uB300\uC804" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
                                id: "vsName",
                                variant: "outlined",
                                fullWidth: true,
                                className: "b2_r w-100p mt-16px",
                                placeholder: "\uC0C1\uB300\uD300 \uC774\uB984",
                                value: gameItem.vsName,
                                inputProps: {
                                    maxLength: 30
                                },
                                onChange: inputChanged
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                value: gameItem.playersCountType,
                                displayEmpty: true,
                                className: "b2_r w-100p mt-16px",
                                onChange: (e)=>setGameItem((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, gameItem), {
                                        playersCountType: e.target.value
                                    })),
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                        value: "",
                                        disabled: true,
                                        children: "\uC778\uC6D0 \uC120\uD0DD"
                                    }),
                                    PLAYER_OPTIONS.map((cnt)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: cnt,
                                            children: cnt
                                        }, cnt))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fd30181b78da18c2$export$2e2bcd8739ae039), {
                        className: "primary",
                        disabled: isDisabled,
                        title: "\uC800\uC7A5",
                        onClick: updateGame
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $79d0143175d5363b$export$2e2bcd8739ae039), {
                content: /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                    children: [
                        "\uC791\uC131 \uC911\uC778 \uB0B4\uC6A9\uC774 \uC0AC\uB77C\uC9D1\uB2C8\uB2E4",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        "\uADF8\uB798\uB3C4 \uB098\uAC00\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"
                    ]
                }),
                leftBtnContent: "\uC544\uB2C8\uC624",
                rightBtnContent: "\uB124",
                isOpen: isOpen,
                onClick: ()=>setIsOpen(false),
                onClose: ()=>props.onClose()
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ac8294fb74a722b7$export$2e2bcd8739ae039), {
                open: open,
                autoHideDuration: 1000,
                onClose: ()=>setOpen(false),
                sx: {
                    position: 'fixed',
                    top: '20%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c181cff0789717b3$export$2e2bcd8739ae039), {
                    severity: "success",
                    variant: "filled"
                })
            })
        ]
    });
};
var $888f0a95330227fe$export$2e2bcd8739ae039 = $888f0a95330227fe$var$GameEditTab;





var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");







function $38158dbfc23b097a$export$5e57a444791c63be(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDialogActions', slot);
}
const $38158dbfc23b097a$var$dialogActionsClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $38158dbfc23b097a$export$2e2bcd8739ae039 = $38158dbfc23b097a$var$dialogActionsClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $6282a3c293a0d8c9$var$_excluded = [
    "className",
    "disableSpacing"
];
const $6282a3c293a0d8c9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $38158dbfc23b097a$export$5e57a444791c63be), classes);
};
const $6282a3c293a0d8c9$var$DialogActionsRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'flex',
        alignItems: 'center',
        padding: 8,
        justifyContent: 'flex-end',
        flex: '0 0 auto'
    }, !ownerState.disableSpacing && {
        '& > :not(style) ~ :not(style)': {
            marginLeft: 8
        }
    }));
const $6282a3c293a0d8c9$var$DialogActions = /*#__PURE__*/ $7fPBF.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false } = props, other = (0, $cFLic.default)(props, $6282a3c293a0d8c9$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        disableSpacing: disableSpacing
    });
    const classes = $6282a3c293a0d8c9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($6282a3c293a0d8c9$var$DialogActionsRoot, (0, $kY3Ke.default)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $6282a3c293a0d8c9$export$2e2bcd8739ae039 = $6282a3c293a0d8c9$var$DialogActions;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");







function $64f614045184fa19$export$61b0ee1f05fb344e(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDialogContent', slot);
}
const $64f614045184fa19$var$dialogContentClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $64f614045184fa19$export$2e2bcd8739ae039 = $64f614045184fa19$var$dialogContentClasses;




function $18611d95980659c6$export$f5d2ec7e4c47e088(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiDialogTitle', slot);
}
const $18611d95980659c6$var$dialogTitleClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiDialogTitle', [
    'root'
]);
var $18611d95980659c6$export$2e2bcd8739ae039 = $18611d95980659c6$var$dialogTitleClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $634ad3fd5060cf75$var$_excluded = [
    "className",
    "dividers"
];
const $634ad3fd5060cf75$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $64f614045184fa19$export$61b0ee1f05fb344e), classes);
};
const $634ad3fd5060cf75$var$DialogContentRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px'
    }, ownerState.dividers ? {
        padding: '16px 24px',
        borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
        borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
    } : {
        [`.${(0, $18611d95980659c6$export$2e2bcd8739ae039).root} + &`]: {
            paddingTop: 0
        }
    }));
const $634ad3fd5060cf75$var$DialogContent = /*#__PURE__*/ $7fPBF.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false } = props, other = (0, $cFLic.default)(props, $634ad3fd5060cf75$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        dividers: dividers
    });
    const classes = $634ad3fd5060cf75$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($634ad3fd5060cf75$var$DialogContentRoot, (0, $kY3Ke.default)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $634ad3fd5060cf75$export$2e2bcd8739ae039 = $634ad3fd5060cf75$var$DialogContent;


var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");









var $bbzbN = parcelRequire("bbzbN");
'use client';
const $ac75506ecdb312f1$var$_excluded = [
    "className",
    "id"
];
const $ac75506ecdb312f1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $18611d95980659c6$export$f5d2ec7e4c47e088), classes);
};
const $ac75506ecdb312f1$var$DialogTitleRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $ac75506ecdb312f1$var$DialogTitle = /*#__PURE__*/ $7fPBF.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp } = props, other = (0, $cFLic.default)(props, $ac75506ecdb312f1$var$_excluded);
    const ownerState = props;
    const classes = $ac75506ecdb312f1$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $7fPBF.useContext((0, $40596d25b0f9c334$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $bbzbN.jsx)($ac75506ecdb312f1$var$DialogTitleRoot, (0, $kY3Ke.default)({
        component: "h2",
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp != null ? idProp : titleId
    }, other));
});
var $ac75506ecdb312f1$export$2e2bcd8739ae039 = $ac75506ecdb312f1$var$DialogTitle;




/** 게임별 참가자 목록 */ const $9bd0524d85115cef$var$getPlayersByGame = async (gameId)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).get(`/players/game/${gameId}`).then((res)=>res.data);
/** 참가자 추가 (회원 / 용병 공통) */ const $9bd0524d85115cef$var$postPlayer = async (player)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).post('/players', (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, player)).then((res)=>res.data);
/** 참가자 수정 */ const $9bd0524d85115cef$var$putPlayerResult = async (player)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).patch(`/players/${player.id}`, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, player)).then((res)=>res.data);
/** 참가자 삭제 */ const $9bd0524d85115cef$var$deletePlayer = (playerId)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).delete(`/players/${playerId}`);
const $9bd0524d85115cef$var$PlayerService = {
    getPlayersByGame: $9bd0524d85115cef$var$getPlayersByGame,
    postPlayer: $9bd0524d85115cef$var$postPlayer,
    putPlayerResult: $9bd0524d85115cef$var$putPlayerResult,
    deletePlayer: $9bd0524d85115cef$var$deletePlayer
};
var $9bd0524d85115cef$export$2e2bcd8739ae039 = $9bd0524d85115cef$var$PlayerService;



const $56417fab94697bb2$var$POSITIONS = [
    'CF',
    'WF',
    'MF',
    'CB',
    'SB',
    'GK'
];
const $56417fab94697bb2$var$GamePlayersTab = ({ game: game })=>{
    const isSelfGame = game.type === "\uC790\uCCB4\uC804";
    const [members, setMembers] = (0, $7fPBF.useState)([]);
    const [players, setPlayers] = (0, $7fPBF.useState)([]);
    /** 선택된 team player */ const [selectedPlayer, setSelectedPlayer] = (0, $7fPBF.useState)(null);
    /** 하단 입력폼 */ const [mercenaryName, setMercenaryName] = (0, $7fPBF.useState)('');
    const [mercenaryPosition1, setMercenaryPosition1] = (0, $7fPBF.useState)('MF');
    const [mercenaryPosition2, setMercenaryPosition2] = (0, $7fPBF.useState)('SB');
    (0, $7fPBF.useEffect)(()=>{
        if (!game.id) return;
        (0, $ce4cf4b5ea0f1720$export$2e2bcd8739ae039).getMemberList().then(setMembers);
        (0, $9bd0524d85115cef$export$2e2bcd8739ae039).getPlayersByGame(game.id).then(setPlayers);
    }, [
        game.id
    ]);
    /** ===== member → team 등록 로직 ===== */ const findPlayer = (memberId)=>players.find((p)=>p.memberId === memberId);
    const getNextTeam = (player)=>{
        if (!player) return 'A';
        if (player.teamABType === 'A') return isSelfGame ? 'B' : null;
        return null;
    };
    const handleMemberClick = async (member)=>{
        const player = findPlayer(member.id);
        const nextTeam = getNextTeam(player);
        if (player && !nextTeam) {
            await (0, $9bd0524d85115cef$export$2e2bcd8739ae039).deletePlayer(player.id);
            setPlayers((prev)=>prev.filter((p)=>p.id !== player.id));
            return;
        }
        if (nextTeam) {
            const saved = await (0, $9bd0524d85115cef$export$2e2bcd8739ae039).postPlayer({
                id: player === null || player === void 0 ? void 0 : player.id,
                gameId: game.id,
                memberId: member.id,
                name: member.name,
                position1: member.position1,
                position2: member.position2,
                teamABType: nextTeam
            });
            setPlayers((prev)=>player ? prev.map((p)=>p.id === saved.id ? saved : p) : [
                    ...prev,
                    saved
                ]);
        }
    };
    /** ===== team 클릭 → 하단 폼 채우기 ===== */ const handleTeamPlayerClick = (player)=>{
        // 이미 선택된 플레이어를 다시 클릭한 경우 → 팀 이동
        if ((selectedPlayer === null || selectedPlayer === void 0 ? void 0 : selectedPlayer.id) === player.id) {
            togglePlayerTeam(player);
            return;
        }
        // 처음 클릭 → 선택
        setSelectedPlayer(player);
        // 하단 입력폼 채우기
        setMercenaryName(player.name);
        setMercenaryPosition1(player.position1);
        var _player_position2;
        setMercenaryPosition2((_player_position2 = player.position2) !== null && _player_position2 !== void 0 ? _player_position2 : '');
    };
    /** ===== team A/B 토글 ===== */ const togglePlayerTeam = async (player)=>{
        if (!isSelfGame) return;
        const saved = await (0, $9bd0524d85115cef$export$2e2bcd8739ae039).postPlayer((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, player), {
            teamABType: player.teamABType === 'A' ? 'B' : 'A'
        }));
        setPlayers((prev)=>prev.map((p)=>p.id === saved.id ? saved : p));
    };
    /** ===== 하단 버튼 모드 ===== */ const isDirty = selectedPlayer && (mercenaryName !== selectedPlayer.name || mercenaryPosition1 !== selectedPlayer.position1 || mercenaryPosition2 !== selectedPlayer.position2);
    const isDeleteMode = selectedPlayer && !isDirty;
    const resetForm = ()=>{
        setSelectedPlayer(null);
        setMercenaryName('');
        setMercenaryPosition1('MF');
        setMercenaryPosition2('SB');
    };
    const handleMercenaryAction = async ()=>{
        if (!mercenaryName.trim()) return;
        /** 🔴 삭제 */ if (isDeleteMode && selectedPlayer) {
            await (0, $9bd0524d85115cef$export$2e2bcd8739ae039).deletePlayer(selectedPlayer.id);
            setPlayers((prev)=>prev.filter((p)=>p.id !== selectedPlayer.id));
            resetForm();
            return;
        }
        /** 🟢 등록 or 수정 */ const saved = await (0, $9bd0524d85115cef$export$2e2bcd8739ae039).postPlayer({
            id: selectedPlayer === null || selectedPlayer === void 0 ? void 0 : selectedPlayer.id,
            gameId: game.id,
            name: mercenaryName,
            position1: mercenaryPosition1,
            position2: mercenaryPosition2,
            teamABType: 'A'
        });
        setPlayers((prev)=>selectedPlayer ? prev.map((p)=>p.id === saved.id ? saved : p) : [
                ...prev,
                saved
            ]);
        resetForm();
    };
    /** ===== position 정렬 ===== */ const POSITION_ORDER = [
        'CF',
        'WF',
        'MF',
        'CB',
        'SB',
        'GK'
    ];
    const rank = (p)=>POSITION_ORDER.indexOf(p !== null && p !== void 0 ? p : '') === -1 ? 999 : POSITION_ORDER.indexOf(p);
    const sortByPosition = (list)=>[
            ...list
        ].sort((a, b)=>rank(a.position1) - rank(b.position1));
    const teamA = sortByPosition(players.filter((p)=>p.teamABType === 'A'));
    const teamB = sortByPosition(players.filter((p)=>p.teamABType === 'B'));
    const [copyOpen, setCopyOpen] = (0, $7fPBF.useState)(false);
    const [copyText, setCopyText] = (0, $7fPBF.useState)('');
    const handleCopyToClipboard = async ()=>{
        const formatPlayer = (p)=>`${p.name}${p.position1}`;
        var _game_matchDt, _game_time, _game_vsName, _game_place;
        const gameInfo = `${(_game_matchDt = game.matchDt) !== null && _game_matchDt !== void 0 ? _game_matchDt : ''} ${(_game_time = game.time) !== null && _game_time !== void 0 ? _game_time : ''} ${(_game_vsName = game.vsName) !== null && _game_vsName !== void 0 ? _game_vsName : "\uC790\uCCB4\uC804"}
${(_game_place = game.place) !== null && _game_place !== void 0 ? _game_place : ''} (${teamA.length + teamB.length}\u{BA85})`;
        const teamAInfo = `
--Team A (${teamA.length}) --
${teamA.map(formatPlayer).join(' ')}`;
        const teamBInfo = isSelfGame ? `
--Team B (${teamB.length}) --
${teamB.map(formatPlayer).join(' ')}` : '';
        const resultText = `${gameInfo}
${teamAInfo}
${teamBInfo}

* \u{ACBD}\u{AE30}\u{C911} \u{ACFC}\u{B3C4}\u{D55C}\u{C9C0}\u{C2DC} \u{C8FC}\u{C758} (\u{D734}\u{C2DD}\u{C2DC}\u{AC04}\u{C5D0} \u{CC28}\u{BD84}\u{D558}\u{AC8C} \u{C804}\u{B2EC})
* \u{D0C0}\u{C778}\u{C5D0} \u{B300}\u{D55C} \u{C874}\u{C911} (\u{D310}\u{C815}\u{C5D0}\u{D56D}\u{C758}, \u{C695}\u{C124}/\u{BE44}\u{B09C}/\u{C870}\u{B871} \u{D558}\u{C9C0} \u{C54A}\u{AE30})
* \u{AC70}\u{CE5C}\u{D50C}\u{B808}\u{C774}(\u{C0AC}\u{B78C}\u{C744} \u{D5A5}\u{D55C} \u{D0DC}\u{D074}, \u{C810}\u{D504}\u{D560}\u{B54C} \u{BBF8}\u{B294} \u{D589}\u{C704} \u{B4F1}) \u{C8FC}\u{C758}`;
        setCopyText(resultText);
        setCopyOpen(true);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
        className: "game-players",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                className: "player-layout",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        className: "member-list",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("h4", {
                                onClick: handleCopyToClipboard,
                                children: [
                                    "Member ",
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                        children: [
                                            "(",
                                            teamA.length + teamB.length,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                className: "member-scroll",
                                children: members.map((member)=>{
                                    const player = findPlayer(member.id);
                                    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                        className: "member-row",
                                        onClick: ()=>handleMemberClick(member),
                                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                            className: "member-line",
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                    className: "member-info",
                                                    children: member.name
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                                    className: "position",
                                                    children: [
                                                        member.position1,
                                                        member.position2 && `/${member.position2}`
                                                    ]
                                                }),
                                                player && /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                    className: `team-badge team-${player.teamABType}`
                                                })
                                            ]
                                        })
                                    }, member.id);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        className: "team-box",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("h4", {
                                children: [
                                    "Team A ",
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                        children: [
                                            "(",
                                            teamA.length,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "team-scroll",
                                children: teamA.map((p)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                        className: `team-player clickable ${(selectedPlayer === null || selectedPlayer === void 0 ? void 0 : selectedPlayer.id) === p.id ? 'selected' : ''}`,
                                        onClick: ()=>handleTeamPlayerClick(p),
                                        onDoubleClick: ()=>togglePlayerTeam(p),
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: `member-info ${!p.memberId ? 'mercenary-position' : ''}`,
                                                children: p.name
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                                className: `position`,
                                                children: [
                                                    p.position1,
                                                    p.position2 && `/${p.position2}`
                                                ]
                                            })
                                        ]
                                    }, p.id))
                            })
                        ]
                    }),
                    isSelfGame && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        className: "team-box",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("h4", {
                                children: [
                                    "Team B ",
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                        children: [
                                            "(",
                                            teamB.length,
                                            ")"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "team-scroll",
                                children: teamB.map((p)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                        className: `team-player clickable ${(selectedPlayer === null || selectedPlayer === void 0 ? void 0 : selectedPlayer.id) === p.id ? 'selected' : ''}`,
                                        onClick: ()=>handleTeamPlayerClick(p),
                                        onDoubleClick: ()=>togglePlayerTeam(p),
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: `member-info ${!p.memberId ? 'mercenary-position' : ''}`,
                                                children: p.name
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                                className: `position`,
                                                children: [
                                                    p.position1,
                                                    p.position2 && `/${p.position2}`
                                                ]
                                            })
                                        ]
                                    }, p.id))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    gap: 1,
                    mt: 1
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
                        size: "small",
                        placeholder: "\uC774\uB984",
                        value: mercenaryName,
                        onChange: (e)=>setMercenaryName(e.target.value)
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                        sx: {
                            height: '40px'
                        },
                        size: "small",
                        value: mercenaryPosition1,
                        onChange: (e)=>setMercenaryPosition1(e.target.value),
                        children: $56417fab94697bb2$var$POSITIONS.map((p)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                value: p,
                                children: p
                            }, p))
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                        sx: {
                            height: '40px'
                        },
                        size: "small",
                        value: mercenaryPosition2,
                        onChange: (e)=>setMercenaryPosition2(e.target.value),
                        children: $56417fab94697bb2$var$POSITIONS.map((p)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                value: p,
                                children: p
                            }, p))
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                        sx: {
                            height: '40px'
                        },
                        size: "small",
                        variant: "contained",
                        color: isDeleteMode ? 'error' : 'primary',
                        onClick: handleMercenaryAction,
                        children: isDeleteMode ? "\uC0AD\uC81C" : "\uB4F1\uB85D"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $7f096abd658f7c85$export$2e2bcd8739ae039), {
                open: copyOpen,
                onClose: ()=>setCopyOpen(false),
                maxWidth: "sm",
                fullWidth: true,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ac75506ecdb312f1$export$2e2bcd8739ae039), {
                        children: "\uD83D\uDCCB \uAC8C\uC784 \uC815\uBCF4 \uBCF5\uC0AC"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $634ad3fd5060cf75$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", {
                                value: copyText,
                                readOnly: true,
                                autoFocus: true,
                                style: {
                                    width: '100%',
                                    height: '300px',
                                    fontSize: '14px'
                                },
                                onFocus: (e)=>e.target.select()
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                style: {
                                    marginTop: 10,
                                    fontSize: 13
                                },
                                children: [
                                    "\uD83D\uDC49 ",
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("b", {
                                        children: "Ctrl + C"
                                    }),
                                    " \uB97C \uB20C\uB7EC \uBCF5\uC0AC\uD558\uC138\uC694."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6282a3c293a0d8c9$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                            onClick: ()=>setCopyOpen(false),
                            children: "\uB2EB\uAE30"
                        })
                    })
                ]
            })
        ]
    });
};
var $56417fab94697bb2$export$2e2bcd8739ae039 = $56417fab94697bb2$var$GamePlayersTab;





var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");



const $9037145f40acf490$var$SCORE_LIST = Array.from({
    length: 11
}, (_, i)=>i);
const $9037145f40acf490$var$GameResultTab = ({ game: game, onClose: onClose, onReturn: onReturn })=>{
    const handleOverlayClick = (0, $7fPBF.useCallback)(()=>onClose(), [
        onClose
    ]);
    const handleReturnClick = (0, $7fPBF.useCallback)(()=>{
        onReturn();
    }, [
        onReturn
    ]);
    const isSelfGame = game.type === "\uC790\uCCB4\uC804";
    const teamName = localStorage.getItem('TEAM_NAME') || 'Team A';
    const [players, setPlayers] = (0, $7fPBF.useState)([]);
    var _game_teamAScore;
    const [teamAScore, setTeamAScore] = (0, $7fPBF.useState)((_game_teamAScore = game.teamAScore) !== null && _game_teamAScore !== void 0 ? _game_teamAScore : '');
    var _game_teamBScore;
    const [teamBScore, setTeamBScore] = (0, $7fPBF.useState)((_game_teamBScore = game.teamBScore) !== null && _game_teamBScore !== void 0 ? _game_teamBScore : '');
    (0, $7fPBF.useEffect)(()=>{
        if (!game.id) return;
        (0, $9bd0524d85115cef$export$2e2bcd8739ae039).getPlayersByGame(game.id).then(setPlayers);
    }, [
        game.id
    ]);
    /** ===== 경기 점수 저장 ===== */ const saveGameScore = async (aScore, bScore)=>{
        if (aScore === '' || bScore === '') return;
        await (0, $9edd82d19644f411$export$2e2bcd8739ae039).putGameResult({
            teamAScore: aScore,
            teamBScore: bScore,
            status: "\uC644\uB8CC"
        }, game.id);
        handleReturnClick();
    };
    /** ===== 골/어시스트 저장 ===== */ const updatePlayerStat = async (player, field, value)=>{
        // ✅ UI 먼저 변경
        setPlayers((prev)=>prev.map((p)=>p.id === player.id ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, p), {
                    [field]: value
                }) : p));
        // ✅ 서버 저장
        await (0, $9bd0524d85115cef$export$2e2bcd8739ae039).putPlayerResult((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, player), {
            [field]: value
        }));
    };
    const teamA = players.filter((p)=>p.teamABType === 'A');
    const teamB = players.filter((p)=>p.teamABType === 'B');
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
        className: "game-result",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                className: "score-board",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        className: "score-team",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                className: "score-team-name",
                                children: isSelfGame ? 'Team A' : teamName
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                size: "small",
                                className: "score-select",
                                value: teamAScore,
                                onChange: (e)=>{
                                    const value = Number(e.target.value);
                                    setTeamAScore(value);
                                    saveGameScore(value, teamBScore);
                                },
                                children: $9037145f40acf490$var$SCORE_LIST.map((n)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                        value: n,
                                        children: n
                                    }, n))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "score-vs",
                        children: "VS"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        className: "score-team",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                className: "score-team-name",
                                children: isSelfGame ? 'Team B' : game.vsName
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                size: "small",
                                className: "score-select",
                                value: teamBScore,
                                onChange: (e)=>{
                                    const value = Number(e.target.value);
                                    setTeamBScore(value);
                                    saveGameScore(teamAScore, value);
                                },
                                children: $9037145f40acf490$var$SCORE_LIST.map((n)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                        value: n,
                                        children: n
                                    }, n))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: `game-status ${teamAScore !== '' && teamBScore !== '' ? 'completed' : ''}`,
                children: teamAScore !== '' && teamBScore !== '' ? "\uACBD\uAE30 \uC885\uB8CC" : ''
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: 'result-team-wrapper',
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        className: "result-team-box",
                        children: [
                            teamA.length === 0 && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "result-empty"
                            }),
                            teamA.map((p)=>{
                                var _p_goal, _p_assist;
                                return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                    className: "result-player",
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                            className: "result-player-info",
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: `result-player-name ${!p.memberId ? 'mercenary' : ''}`,
                                                children: p.name
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                            className: "result-stats",
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                                    size: "small",
                                                    className: "result-select",
                                                    value: (_p_goal = p.goal) !== null && _p_goal !== void 0 ? _p_goal : 0,
                                                    onChange: (e)=>updatePlayerStat(p, 'goal', Number(e.target.value)),
                                                    children: $9037145f40acf490$var$SCORE_LIST.map((n)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                            value: n,
                                                            children: n
                                                        }, n))
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                                    size: "small",
                                                    className: "result-select",
                                                    value: (_p_assist = p.assist) !== null && _p_assist !== void 0 ? _p_assist : 0,
                                                    onChange: (e)=>updatePlayerStat(p, 'assist', Number(e.target.value)),
                                                    children: $9037145f40acf490$var$SCORE_LIST.map((n)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                            value: n,
                                                            children: n
                                                        }, n))
                                                })
                                            ]
                                        })
                                    ]
                                }, p.id);
                            })
                        ]
                    }),
                    isSelfGame && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        className: "result-team-box",
                        children: [
                            teamB.length === 0 && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "result-empty"
                            }),
                            teamB.map((p)=>{
                                var _p_goal, _p_assist;
                                return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                    className: "result-player",
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                            className: "result-player-info",
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: `result-player-name ${!p.memberId ? 'mercenary' : ''}`,
                                                children: p.name
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                            className: "result-stats",
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                                    size: "small",
                                                    className: "result-select",
                                                    value: (_p_goal = p.goal) !== null && _p_goal !== void 0 ? _p_goal : 0,
                                                    onChange: (e)=>updatePlayerStat(p, 'goal', Number(e.target.value)),
                                                    children: $9037145f40acf490$var$SCORE_LIST.map((n)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                            value: n,
                                                            children: n
                                                        }, n))
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                                    size: "small",
                                                    className: "result-select",
                                                    value: (_p_assist = p.assist) !== null && _p_assist !== void 0 ? _p_assist : 0,
                                                    onChange: (e)=>updatePlayerStat(p, 'assist', Number(e.target.value)),
                                                    children: $9037145f40acf490$var$SCORE_LIST.map((n)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                            value: n,
                                                            children: n
                                                        }, n))
                                                })
                                            ]
                                        })
                                    ]
                                }, p.id);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $9037145f40acf490$export$2e2bcd8739ae039 = $9037145f40acf490$var$GameResultTab;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");



class $b1b7259e07d8b034$export$6cfd5dd1e3454866 {
    constructor(status, pointX, pointY){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "status", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "pointX", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "pointY", void 0);
        this.status = status;
        this.pointX = pointX;
        this.pointY = pointY;
    }
}
/* =======================
 * API
 * ======================= */ /**
 * 게임별 쿼터 목록 조회
 */ const $b1b7259e07d8b034$var$getQuatersByGame = async (gameId)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).get(`/quaters/game/${gameId}`).then((res)=>res.data);
/**
 * 쿼터 정보 수정
 */ const $b1b7259e07d8b034$var$updateQuater = async (quaterId, req)=>(0, $b13c137540e062b0$export$407ca81eb46778dd).put(`/quaters/${quaterId}`, req).then((res)=>res.data);
/* =======================
 * EXPORT
 * ======================= */ const $b1b7259e07d8b034$var$QuaterService = {
    getQuatersByGame: $b1b7259e07d8b034$var$getQuatersByGame,
    updateQuater: $b1b7259e07d8b034$var$updateQuater,
    QuaterUpdateReq: $b1b7259e07d8b034$export$6cfd5dd1e3454866
};
var $b1b7259e07d8b034$export$2e2bcd8739ae039 = $b1b7259e07d8b034$var$QuaterService;





var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
function $f268b97836dca6b6$var$_defineProperty(e, r, t) {
    return (r = $f268b97836dca6b6$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $f268b97836dca6b6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f268b97836dca6b6$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f268b97836dca6b6$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f268b97836dca6b6$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f268b97836dca6b6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f268b97836dca6b6$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $f268b97836dca6b6$var$_objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], t.indexOf(o) >= 0 || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function $f268b97836dca6b6$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $f268b97836dca6b6$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
function $f268b97836dca6b6$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f268b97836dca6b6$var$_toPropertyKey(t) {
    var i = $f268b97836dca6b6$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
class $f268b97836dca6b6$var$BaseConfiguration {
    constructor(){
        /**
     * Browser-specific constant to adjust CanvasRenderingContext2D.shadowBlur value,
     * which is unitless and not rendered equally across browsers.
     *
     * Values that work quite well (as of October 2017) are:
     * - Chrome: 1.5
     * - Edge: 1.75
     * - Firefox: 0.9
     * - Safari: 0.95
     *
     * @since 2.0.0
     * @type Number
     * @default 1
     */ $f268b97836dca6b6$var$_defineProperty(this, "browserShadowBlurConstant", 1);
        /**
     * Pixel per Inch as a default value set to 96. Can be changed for more realistic conversion.
     */ $f268b97836dca6b6$var$_defineProperty(this, "DPI", 96);
        /**
     * Device Pixel Ratio
     * @see https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/HTML-canvas-guide/SettingUptheCanvas/SettingUptheCanvas.html
     */ $f268b97836dca6b6$var$_defineProperty(this, "devicePixelRatio", typeof window !== 'undefined' ? window.devicePixelRatio : 1);
        // eslint-disable-line no-restricted-globals
        /**
     * Pixel limit for cache canvases. 1Mpx , 4Mpx should be fine.
     * @since 1.7.14
     * @type Number
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "perfLimitSizeTotal", 2097152);
        /**
     * Pixel limit for cache canvases width or height. IE fixes the maximum at 5000
     * @since 1.7.14
     * @type Number
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "maxCacheSideLimit", 4096);
        /**
     * Lowest pixel limit for cache canvases, set at 256PX
     * @since 1.7.14
     * @type Number
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "minCacheSideLimit", 256);
        /**
     * When 'true', style information is not retained when copy/pasting text, making
     * pasted text use destination style.
     * Defaults to 'false'.
     * @type Boolean
     * @default
     * @deprecated
     */ $f268b97836dca6b6$var$_defineProperty(this, "disableStyleCopyPaste", false);
        /**
     * Enable webgl for filtering picture is available
     * A filtering backend will be initialized, this will both take memory and
     * time since a default 2048x2048 canvas will be created for the gl context
     * @since 2.0.0
     * @type Boolean
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "enableGLFiltering", true);
        /**
     * if webgl is enabled and available, textureSize will determine the size
     * of the canvas backend
     *
     * In order to support old hardware set to `2048` to avoid OOM
     *
     * @since 2.0.0
     * @type Number
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "textureSize", 4096);
        /**
     * Skip performance testing of setupGLContext and force the use of putImageData that seems to be the one that works best on
     * Chrome + old hardware. if your users are experiencing empty images after filtering you may try to force this to true
     * this has to be set before instantiating the filtering backend ( before filtering the first image )
     * @type Boolean
     * @default false
     */ $f268b97836dca6b6$var$_defineProperty(this, "forceGLPutImageData", false);
        /**
     * If disabled boundsOfCurveCache is not used. For apps that make heavy usage of pencil drawing probably disabling it is better
     * With the standard behaviour of fabric to translate all curves in absolute commands and by not subtracting the starting point from
     * the curve is very hard to hit any cache.
     * Enable only if you know why it could be useful.
     * Candidate for removal/simplification
     * @default false
     */ $f268b97836dca6b6$var$_defineProperty(this, "cachesBoundsOfCurve", false);
        /**
     * Map of font files
     * Map<fontFamily, pathToFile> of font files
     */ $f268b97836dca6b6$var$_defineProperty(this, "fontPaths", {});
        /**
     * Defines the number of fraction digits to use when serializing object values.
     * Used in exporting methods (`toObject`, `toJSON`, `toSVG`)
     * You can use it to increase/decrease precision of such values like left, top, scaleX, scaleY, etc.
     */ $f268b97836dca6b6$var$_defineProperty(this, "NUM_FRACTION_DIGITS", 4);
    }
}
class $f268b97836dca6b6$var$Configuration extends $f268b97836dca6b6$var$BaseConfiguration {
    configure() {
        let config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        Object.assign(this, config);
    }
    /**
   * Map<fontFamily, pathToFile> of font files
   */ addFonts() {
        let paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.fontPaths = $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, this.fontPaths), paths);
    }
    removeFonts() {
        let fontFamilys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        fontFamilys.forEach((fontFamily)=>{
            delete this.fontPaths[fontFamily];
        });
    }
    clearFonts() {
        this.fontPaths = {};
    }
    restoreDefaults(keys) {
        const defaults = new $f268b97836dca6b6$var$BaseConfiguration();
        const config = (keys === null || keys === void 0 ? void 0 : keys.reduce((acc, key)=>{
            acc[key] = defaults[key];
            return acc;
        }, {})) || defaults;
        this.configure(config);
    }
    constructor(config){
        super();
        this.configure(config);
    }
}
const $f268b97836dca6b6$export$e506a1d27d1eaa20 = new $f268b97836dca6b6$var$Configuration();
const $f268b97836dca6b6$var$log = function(severity) {
    for(var _len = arguments.length, optionalParams = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)optionalParams[_key - 1] = arguments[_key];
    return(// eslint-disable-next-line no-restricted-syntax
    console[severity]('fabric', ...optionalParams));
};
class $f268b97836dca6b6$var$FabricError extends Error {
    constructor(message, options){
        super("fabric: ".concat(message), options);
    }
}
class $f268b97836dca6b6$var$SignalAbortedError extends $f268b97836dca6b6$var$FabricError {
    constructor(context){
        super("".concat(context, " 'options.signal' is in 'aborted' state"));
    }
}
class $f268b97836dca6b6$var$GLProbe {
}
/**
 * Lazy initialize WebGL constants
 */ class $f268b97836dca6b6$var$WebGLProbe extends $f268b97836dca6b6$var$GLProbe {
    /**
   * Tests if webgl supports certain precision
   * @param {WebGL} Canvas WebGL context to test on
   * @param {GLPrecision} Precision to test can be any of following
   * @returns {Boolean} Whether the user's browser WebGL supports given precision.
   */ testPrecision(gl, precision) {
        const fragmentSource = "precision ".concat(precision, " float;\nvoid main(){}");
        const fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
        if (!fragmentShader) return false;
        gl.shaderSource(fragmentShader, fragmentSource);
        gl.compileShader(fragmentShader);
        return !!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS);
    }
    /**
   * query browser for WebGL
   */ queryWebGL(canvas) {
        const gl = canvas.getContext('webgl');
        if (gl) {
            this.maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
            this.GLPrecision = [
                'highp',
                'mediump',
                'lowp'
            ].find((precision)=>this.testPrecision(gl, precision));
            gl.getExtension('WEBGL_lose_context').loseContext();
            $f268b97836dca6b6$var$log('log', "WebGL: max texture size ".concat(this.maxTextureSize));
        }
    }
    isSupported(textureSize) {
        return !!this.maxTextureSize && this.maxTextureSize >= textureSize;
    }
}
/* eslint-disable no-restricted-globals */ const $f268b97836dca6b6$var$copyPasteData = {};
const $f268b97836dca6b6$var$getEnv$1 = ()=>{
    return {
        document: document,
        window: window,
        isTouchSupported: 'ontouchstart' in window || 'ontouchstart' in document || window && window.navigator && window.navigator.maxTouchPoints > 0,
        WebGLProbe: new $f268b97836dca6b6$var$WebGLProbe(),
        dispose () {
        // noop
        },
        copyPasteData: $f268b97836dca6b6$var$copyPasteData
    };
};
/**
 * This file is consumed by fabric.
 * The `./node` and `./browser` files define the env variable that is used by this module.
 * The `./browser` module is defined to be the default env and doesn't set the env at all.
 * This is done in order to support isomorphic usage for browser and node applications
 * since window and document aren't defined at time of import in SSR, we can't set env so we avoid it by deferring to the default env.
 */ let $f268b97836dca6b6$var$env;
/**
 * Sets the environment variables used by fabric.\
 * This is exposed for special cases, such as configuring a test environment, and should be used with care.
 *
 * **CAUTION**: Must be called before using the package.
 *
 * @example
 * <caption>Passing `window` and `document` objects to fabric (in case they are mocked or something)</caption>
 * import { getEnv, setEnv } from 'fabric';
 * // we want fabric to use the `window` and `document` objects exposed by the environment we are running in.
 * setEnv({ ...getEnv(), window, document });
 * // done with setup, using fabric is now safe
 */ const $f268b97836dca6b6$export$84bc02d3c7a6b55f = (value)=>{
    $f268b97836dca6b6$var$env = value;
};
/**
 * In order to support SSR we **MUST** access the browser env only after the window has loaded
 */ const $f268b97836dca6b6$export$4bd44a2aa29d3d6e = ()=>$f268b97836dca6b6$var$env || ($f268b97836dca6b6$var$env = $f268b97836dca6b6$var$getEnv$1());
const $f268b97836dca6b6$export$91e93c41e950ddbb = ()=>$f268b97836dca6b6$export$4bd44a2aa29d3d6e().document;
const $f268b97836dca6b6$export$4a3a3142573970c3 = ()=>$f268b97836dca6b6$export$4bd44a2aa29d3d6e().window;
/**
 * @returns the config value if defined, fallbacks to the environment value
 */ const $f268b97836dca6b6$var$getDevicePixelRatio = ()=>{
    var _config$devicePixelRa;
    return Math.max((_config$devicePixelRa = $f268b97836dca6b6$export$e506a1d27d1eaa20.devicePixelRatio) !== null && _config$devicePixelRa !== void 0 ? _config$devicePixelRa : $f268b97836dca6b6$export$4a3a3142573970c3().devicePixelRatio, 1);
};
class $f268b97836dca6b6$var$Cache {
    /**
   * @return {Object} reference to cache
   */ getFontCache(_ref) {
        let { fontFamily: fontFamily, fontStyle: fontStyle, fontWeight: fontWeight } = _ref;
        fontFamily = fontFamily.toLowerCase();
        const cache = this.charWidthsCache;
        if (!cache.has(fontFamily)) cache.set(fontFamily, new Map());
        const fontCache = cache.get(fontFamily);
        const cacheKey = "".concat(fontStyle.toLowerCase(), "_").concat((fontWeight + '').toLowerCase());
        if (!fontCache.has(cacheKey)) fontCache.set(cacheKey, new Map());
        return fontCache.get(cacheKey);
    }
    /**
   * Clear char widths cache for the given font family or all the cache if no
   * fontFamily is specified.
   * Use it if you know you are loading fonts in a lazy way and you are not waiting
   * for custom fonts to load properly when adding text objects to the canvas.
   * If a text object is added when its own font is not loaded yet, you will get wrong
   * measurement and so wrong bounding boxes.
   * After the font cache is cleared, either change the textObject text content or call
   * initDimensions() to trigger a recalculation
   * @param {String} [fontFamily] font family to clear
   */ clearFontCache(fontFamily) {
        if (!fontFamily) this.charWidthsCache = new Map();
        else this.charWidthsCache.delete((fontFamily || '').toLowerCase());
    }
    /**
   * Given current aspect ratio, determines the max width and height that can
   * respect the total allowed area for the cache.
   * @param {number} ar aspect ratio
   * @return {number[]} Limited dimensions X and Y
   */ limitDimsByArea(ar) {
        const { perfLimitSizeTotal: perfLimitSizeTotal } = $f268b97836dca6b6$export$e506a1d27d1eaa20;
        const roughWidth = Math.sqrt(perfLimitSizeTotal * ar);
        // we are not returning a point on purpose, to avoid circular dependencies
        // this is an internal utility
        return [
            Math.floor(roughWidth),
            Math.floor(perfLimitSizeTotal / roughWidth)
        ];
    }
    /**
   * Cache of widths of chars in text rendering.
   */ constructor(){
        /**
     * This object keeps the results of the boundsOfCurve calculation mapped by the joined arguments necessary to calculate it.
     * It does speed up calculation, if you parse and add always the same paths, but in case of heavy usage of freedrawing
     * you do not get any speed benefit and you get a big object in memory.
     * The object was a private variable before, while now is appended to the lib so that you have access to it and you
     * can eventually clear it.
     * It was an internal variable, is accessible since version 2.3.4
     */ $f268b97836dca6b6$var$_defineProperty(this, "boundsOfCurveCache", {});
        this.charWidthsCache = new Map();
    }
}
const $f268b97836dca6b6$export$69a3209f1a06c04d = new $f268b97836dca6b6$var$Cache();
var $f268b97836dca6b6$var$version = "6.9.1";
// use this syntax so babel plugin see this import here
const $f268b97836dca6b6$export$83d89fbfd8236492 = $f268b97836dca6b6$var$version;
// eslint-disable-next-line @typescript-eslint/no-empty-function
function $f268b97836dca6b6$var$noop() {}
const $f268b97836dca6b6$var$halfPI = Math.PI / 2;
const $f268b97836dca6b6$var$twoMathPi = Math.PI * 2;
const $f268b97836dca6b6$var$PiBy180 = Math.PI / 180;
const $f268b97836dca6b6$export$3c5a7f9475b116e0 = Object.freeze([
    1,
    0,
    0,
    1,
    0,
    0
]);
const $f268b97836dca6b6$var$DEFAULT_SVG_FONT_SIZE = 16;
const $f268b97836dca6b6$var$ALIASING_LIMIT = 2;
/* "magic number" for bezier approximations of arcs (http://itc.ktu.lt/itc354/Riskus354.pdf) */ const $f268b97836dca6b6$var$kRect = 0.4477152502;
const $f268b97836dca6b6$var$CENTER = 'center';
const $f268b97836dca6b6$var$LEFT = 'left';
const $f268b97836dca6b6$var$TOP = 'top';
const $f268b97836dca6b6$var$BOTTOM = 'bottom';
const $f268b97836dca6b6$var$RIGHT = 'right';
const $f268b97836dca6b6$var$NONE = 'none';
const $f268b97836dca6b6$var$reNewline = /\r?\n/;
const $f268b97836dca6b6$var$MOVING = 'moving';
const $f268b97836dca6b6$var$SCALING = 'scaling';
const $f268b97836dca6b6$var$ROTATING = 'rotating';
const $f268b97836dca6b6$var$ROTATE = 'rotate';
const $f268b97836dca6b6$var$SKEWING = 'skewing';
const $f268b97836dca6b6$var$RESIZING = 'resizing';
const $f268b97836dca6b6$var$MODIFY_POLY = 'modifyPoly';
const $f268b97836dca6b6$var$MODIFY_PATH = 'modifyPath';
const $f268b97836dca6b6$var$CHANGED = 'changed';
const $f268b97836dca6b6$var$SCALE = 'scale';
const $f268b97836dca6b6$var$SCALE_X = 'scaleX';
const $f268b97836dca6b6$var$SCALE_Y = 'scaleY';
const $f268b97836dca6b6$var$SKEW_X = 'skewX';
const $f268b97836dca6b6$var$SKEW_Y = 'skewY';
const $f268b97836dca6b6$var$FILL = 'fill';
const $f268b97836dca6b6$var$STROKE = 'stroke';
const $f268b97836dca6b6$var$MODIFIED = 'modified';
/*
 * This Map connects the objects type value with their
 * class implementation. It used from any object to understand which are
 * the classes to enlive when requesting a object.type = 'path' for example.
 * Objects uses it for clipPath, Canvas uses it for everything.
 * This is necessary for generic code to run and enlive instances from serialized representation.
 * You can customize which classes get enlived from SVG parsing using this classRegistry.
 * The Registry start empty and gets filled in depending which files you import.
 * If you want to be able to parse arbitrary SVGs or JSON representation of canvases, coming from
 * different sources you will need to import all fabric because you may need all classes.
 */ const $f268b97836dca6b6$var$JSON$1 = 'json';
const $f268b97836dca6b6$var$SVG = 'svg';
class $f268b97836dca6b6$var$ClassRegistry {
    has(classType) {
        return this[$f268b97836dca6b6$var$JSON$1].has(classType);
    }
    getClass(classType) {
        const constructor = this[$f268b97836dca6b6$var$JSON$1].get(classType);
        if (!constructor) throw new $f268b97836dca6b6$var$FabricError("No class registered for ".concat(classType));
        return constructor;
    }
    setClass(classConstructor, classType) {
        if (classType) this[$f268b97836dca6b6$var$JSON$1].set(classType, classConstructor);
        else {
            this[$f268b97836dca6b6$var$JSON$1].set(classConstructor.type, classConstructor);
            // legacy
            // @TODO: needs to be removed in fabric 7 or 8
            this[$f268b97836dca6b6$var$JSON$1].set(classConstructor.type.toLowerCase(), classConstructor);
        }
    }
    getSVGClass(SVGTagName) {
        return this[$f268b97836dca6b6$var$SVG].get(SVGTagName);
    }
    setSVGClass(classConstructor, SVGTagName) {
        this[$f268b97836dca6b6$var$SVG].set(SVGTagName !== null && SVGTagName !== void 0 ? SVGTagName : classConstructor.type.toLowerCase(), classConstructor);
    }
    constructor(){
        this[$f268b97836dca6b6$var$JSON$1] = new Map();
        this[$f268b97836dca6b6$var$SVG] = new Map();
    }
}
const $f268b97836dca6b6$export$2792378e23a7920c = new $f268b97836dca6b6$var$ClassRegistry();
/**
 * Array holding all running animations
 */ class $f268b97836dca6b6$var$AnimationRegistry extends Array {
    /**
   * Remove a single animation using an animation context
   * @param {AnimationBase} context
   */ remove(context) {
        const index = this.indexOf(context);
        index > -1 && this.splice(index, 1);
    }
    /**
   * Cancel all running animations on the next frame
   */ cancelAll() {
        const animations = this.splice(0);
        animations.forEach((animation)=>animation.abort());
        return animations;
    }
    /**
   * Cancel all running animations attached to a canvas on the next frame
   * @param {StaticCanvas} canvas
   */ cancelByCanvas(canvas) {
        if (!canvas) return [];
        const animations = this.filter((animation)=>{
            var _animation$target;
            return animation.target === canvas || typeof animation.target === 'object' && ((_animation$target = animation.target) === null || _animation$target === void 0 ? void 0 : _animation$target.canvas) === canvas;
        });
        animations.forEach((animation)=>animation.abort());
        return animations;
    }
    /**
   * Cancel all running animations for target on the next frame
   * @param target
   */ cancelByTarget(target) {
        if (!target) return [];
        const animations = this.filter((animation)=>animation.target === target);
        animations.forEach((animation)=>animation.abort());
        return animations;
    }
}
const $f268b97836dca6b6$export$dc18923894d9e56a = new $f268b97836dca6b6$var$AnimationRegistry();
/**
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#events}
 * @see {@link http://fabricjs.com/events|Events demo}
 */ class $f268b97836dca6b6$export$77cea355fa80b5f4 {
    /**
   * Observes specified event
   * @alias on
   * @param {string} eventName Event name (eg. 'after:render')
   * @param {EventRegistryObject} handlers key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
   * @param {Function} handler Function that receives a notification when an event of the specified type occurs
   * @return {Function} disposer
   */ on(arg0, handler) {
        if (!this.__eventListeners) this.__eventListeners = {};
        if (typeof arg0 === 'object') {
            // one object with key/value pairs was passed
            Object.entries(arg0).forEach((_ref)=>{
                let [eventName, handler] = _ref;
                this.on(eventName, handler);
            });
            return ()=>this.off(arg0);
        } else if (handler) {
            const eventName = arg0;
            if (!this.__eventListeners[eventName]) this.__eventListeners[eventName] = [];
            this.__eventListeners[eventName].push(handler);
            return ()=>this.off(eventName, handler);
        } else // noop
        return ()=>false;
    }
    /**
   * Observes specified event **once**
   * @alias once
   * @param {string} eventName Event name (eg. 'after:render')
   * @param {EventRegistryObject} handlers key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
   * @param {Function} handler Function that receives a notification when an event of the specified type occurs
   * @return {Function} disposer
   */ once(arg0, handler) {
        if (typeof arg0 === 'object') {
            // one object with key/value pairs was passed
            const disposers = [];
            Object.entries(arg0).forEach((_ref2)=>{
                let [eventName, handler] = _ref2;
                disposers.push(this.once(eventName, handler));
            });
            return ()=>disposers.forEach((d)=>d());
        } else if (handler) {
            const disposer = this.on(arg0, function onceHandler() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                handler.call(this, ...args);
                disposer();
            });
            return disposer;
        } else // noop
        return ()=>false;
    }
    /**
   * @private
   * @param {string} eventName
   * @param {Function} [handler]
   */ _removeEventListener(eventName, handler) {
        if (!this.__eventListeners[eventName]) return;
        if (handler) {
            const eventListener = this.__eventListeners[eventName];
            const index = eventListener.indexOf(handler);
            index > -1 && eventListener.splice(index, 1);
        } else this.__eventListeners[eventName] = [];
    }
    /**
   * Unsubscribe all event listeners for eventname.
   * Do not use this pattern. You could kill internal fabricJS events.
   * We know we should have protected events for internal flows, but we don't have yet
   * @deprecated
   * @param {string} eventName event name (eg. 'after:render')
   */ /**
   * unsubscribe an event listener
   * @param {string} eventName event name (eg. 'after:render')
   * @param {TEventCallback} handler event listener to unsubscribe
   */ /**
   * unsubscribe event listeners
   * @param handlers handlers key/value pairs (eg. {'after:render': handler, 'selection:cleared': handler})
   */ /**
   * unsubscribe all event listeners
   */ off(arg0, handler) {
        if (!this.__eventListeners) return;
        // remove all key/value pairs (event name -> event handler)
        if (typeof arg0 === 'undefined') for(const eventName in this.__eventListeners)this._removeEventListener(eventName);
        else if (typeof arg0 === 'object') Object.entries(arg0).forEach((_ref3)=>{
            let [eventName, handler] = _ref3;
            this._removeEventListener(eventName, handler);
        });
        else this._removeEventListener(arg0, handler);
    }
    /**
   * Fires event with an optional options object
   * @param {String} eventName Event name to fire
   * @param {Object} [options] Options object
   */ fire(eventName, options) {
        var _this$__eventListener;
        if (!this.__eventListeners) return;
        const listenersForEvent = (_this$__eventListener = this.__eventListeners[eventName]) === null || _this$__eventListener === void 0 ? void 0 : _this$__eventListener.concat();
        if (listenersForEvent) for(let i = 0; i < listenersForEvent.length; i++)listenersForEvent[i].call(this, options || {});
    }
    constructor(){
        $f268b97836dca6b6$var$_defineProperty(this, "__eventListeners", {});
    }
}
/**
 * Removes value from an array.
 * Presence of value (and its position in an array) is determined via `Array.prototype.indexOf`
 * @param {Array} array
 * @param {*} value
 * @return {Array} original array
 */ const $f268b97836dca6b6$var$removeFromArray = (array, value)=>{
    const idx = array.indexOf(value);
    if (idx !== -1) array.splice(idx, 1);
    return array;
};
/**
 * Calculate the cos of an angle, avoiding returning floats for known results
 * This function is here just to avoid getting 0.999999999999999 when dealing
 * with numbers that are really 1 or 0.
 * @param {TRadian} angle the angle
 * @return {Number} the cosin value for angle.
 */ const $f268b97836dca6b6$var$cos = (angle)=>{
    if (angle === 0) return 1;
    const angleSlice = Math.abs(angle) / $f268b97836dca6b6$var$halfPI;
    switch(angleSlice){
        case 1:
        case 3:
            return 0;
        case 2:
            return -1;
    }
    return Math.cos(angle);
};
/**
 * Calculate the cos of an angle, avoiding returning floats for known results
 * This function is here just to avoid getting 0.999999999999999 when dealing
 * with numbers that are really 1 or 0.
 * @param {TRadian} angle the angle
 * @return {Number} the sin value for angle.
 */ const $f268b97836dca6b6$var$sin = (angle)=>{
    if (angle === 0) return 0;
    const angleSlice = angle / $f268b97836dca6b6$var$halfPI;
    const value = Math.sign(angle);
    switch(angleSlice){
        case 1:
            return value;
        case 2:
            return 0;
        case 3:
            return -value;
    }
    return Math.sin(angle);
};
/**
 * Adaptation of work of Kevin Lindsey(kevin@kevlindev.com)
 */ class $f268b97836dca6b6$export$baf26146a414f24a {
    /**
   * Adds another point to this one and returns another one
   * @param {XY} that
   * @return {Point} new Point instance with added values
   */ add(that) {
        return new $f268b97836dca6b6$export$baf26146a414f24a(this.x + that.x, this.y + that.y);
    }
    /**
   * Adds another point to this one
   * @param {XY} that
   * @return {Point} thisArg
   * @chainable
   * @deprecated
   */ addEquals(that) {
        this.x += that.x;
        this.y += that.y;
        return this;
    }
    /**
   * Adds value to this point and returns a new one
   * @param {Number} scalar
   * @return {Point} new Point with added value
   */ scalarAdd(scalar) {
        return new $f268b97836dca6b6$export$baf26146a414f24a(this.x + scalar, this.y + scalar);
    }
    /**
   * Adds value to this point
   * @param {Number} scalar
   * @return {Point} thisArg
   * @chainable
   * @deprecated
   */ scalarAddEquals(scalar) {
        this.x += scalar;
        this.y += scalar;
        return this;
    }
    /**
   * Subtracts another point from this point and returns a new one
   * @param {XY} that
   * @return {Point} new Point object with subtracted values
   */ subtract(that) {
        return new $f268b97836dca6b6$export$baf26146a414f24a(this.x - that.x, this.y - that.y);
    }
    /**
   * Subtracts another point from this point
   * @param {XY} that
   * @return {Point} thisArg
   * @chainable
   * @deprecated
   */ subtractEquals(that) {
        this.x -= that.x;
        this.y -= that.y;
        return this;
    }
    /**
   * Subtracts value from this point and returns a new one
   * @param {Number} scalar
   * @return {Point}
   */ scalarSubtract(scalar) {
        return new $f268b97836dca6b6$export$baf26146a414f24a(this.x - scalar, this.y - scalar);
    }
    /**
   * Subtracts value from this point
   * @param {Number} scalar
   * @return {Point} thisArg
   * @chainable
   * @deprecated
   */ scalarSubtractEquals(scalar) {
        this.x -= scalar;
        this.y -= scalar;
        return this;
    }
    /**
   * Multiplies this point by another value and returns a new one
   * @param {XY} that
   * @return {Point}
   */ multiply(that) {
        return new $f268b97836dca6b6$export$baf26146a414f24a(this.x * that.x, this.y * that.y);
    }
    /**
   * Multiplies this point by a value and returns a new one
   * @param {Number} scalar
   * @return {Point}
   */ scalarMultiply(scalar) {
        return new $f268b97836dca6b6$export$baf26146a414f24a(this.x * scalar, this.y * scalar);
    }
    /**
   * Multiplies this point by a value
   * @param {Number} scalar
   * @return {Point} thisArg
   * @chainable
   * @deprecated
   */ scalarMultiplyEquals(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    /**
   * Divides this point by another and returns a new one
   * @param {XY} that
   * @return {Point}
   */ divide(that) {
        return new $f268b97836dca6b6$export$baf26146a414f24a(this.x / that.x, this.y / that.y);
    }
    /**
   * Divides this point by a value and returns a new one
   * @param {Number} scalar
   * @return {Point}
   */ scalarDivide(scalar) {
        return new $f268b97836dca6b6$export$baf26146a414f24a(this.x / scalar, this.y / scalar);
    }
    /**
   * Divides this point by a value
   * @param {Number} scalar
   * @return {Point} thisArg
   * @chainable
   * @deprecated
   */ scalarDivideEquals(scalar) {
        this.x /= scalar;
        this.y /= scalar;
        return this;
    }
    /**
   * Returns true if this point is equal to another one
   * @param {XY} that
   * @return {Boolean}
   */ eq(that) {
        return this.x === that.x && this.y === that.y;
    }
    /**
   * Returns true if this point is less than another one
   * @param {XY} that
   * @return {Boolean}
   */ lt(that) {
        return this.x < that.x && this.y < that.y;
    }
    /**
   * Returns true if this point is less than or equal to another one
   * @param {XY} that
   * @return {Boolean}
   */ lte(that) {
        return this.x <= that.x && this.y <= that.y;
    }
    /**
    * Returns true if this point is greater another one
   * @param {XY} that
   * @return {Boolean}
   */ gt(that) {
        return this.x > that.x && this.y > that.y;
    }
    /**
   * Returns true if this point is greater than or equal to another one
   * @param {XY} that
   * @return {Boolean}
   */ gte(that) {
        return this.x >= that.x && this.y >= that.y;
    }
    /**
   * Returns new point which is the result of linear interpolation with this one and another one
   * @param {XY} that
   * @param {Number} t , position of interpolation, between 0 and 1 default 0.5
   * @return {Point}
   */ lerp(that) {
        let t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;
        t = Math.max(Math.min(1, t), 0);
        return new $f268b97836dca6b6$export$baf26146a414f24a(this.x + (that.x - this.x) * t, this.y + (that.y - this.y) * t);
    }
    /**
   * Returns distance from this point and another one
   * @param {XY} that
   * @return {Number}
   */ distanceFrom(that) {
        const dx = this.x - that.x, dy = this.y - that.y;
        return Math.sqrt(dx * dx + dy * dy);
    }
    /**
   * Returns the point between this point and another one
   * @param {XY} that
   * @return {Point}
   */ midPointFrom(that) {
        return this.lerp(that);
    }
    /**
   * Returns a new point which is the min of this and another one
   * @param {XY} that
   * @return {Point}
   */ min(that) {
        return new $f268b97836dca6b6$export$baf26146a414f24a(Math.min(this.x, that.x), Math.min(this.y, that.y));
    }
    /**
   * Returns a new point which is the max of this and another one
   * @param {XY} that
   * @return {Point}
   */ max(that) {
        return new $f268b97836dca6b6$export$baf26146a414f24a(Math.max(this.x, that.x), Math.max(this.y, that.y));
    }
    /**
   * Returns string representation of this point
   * @return {String}
   */ toString() {
        return "".concat(this.x, ",").concat(this.y);
    }
    /**
   * Sets x/y of this point
   * @param {Number} x
   * @param {Number} y
   * @chainable
   */ setXY(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    /**
   * Sets x of this point
   * @param {Number} x
   * @chainable
   */ setX(x) {
        this.x = x;
        return this;
    }
    /**
   * Sets y of this point
   * @param {Number} y
   * @chainable
   */ setY(y) {
        this.y = y;
        return this;
    }
    /**
   * Sets x/y of this point from another point
   * @param {XY} that
   * @chainable
   */ setFromPoint(that) {
        this.x = that.x;
        this.y = that.y;
        return this;
    }
    /**
   * Swaps x/y of this point and another point
   * @param {XY} that
   */ swap(that) {
        const x = this.x, y = this.y;
        this.x = that.x;
        this.y = that.y;
        that.x = x;
        that.y = y;
    }
    /**
   * return a cloned instance of the point
   * @return {Point}
   */ clone() {
        return new $f268b97836dca6b6$export$baf26146a414f24a(this.x, this.y);
    }
    /**
   * Rotates `point` around `origin` with `radians`
   * @static
   * @memberOf fabric.util
   * @param {XY} origin The origin of the rotation
   * @param {TRadian} radians The radians of the angle for the rotation
   * @return {Point} The new rotated point
   */ rotate(radians) {
        let origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f268b97836dca6b6$var$ZERO;
        // TODO benchmark and verify the add and subtract how much cost
        // and then in case early return if no origin is passed
        const sinus = $f268b97836dca6b6$var$sin(radians), cosinus = $f268b97836dca6b6$var$cos(radians);
        const p = this.subtract(origin);
        const rotated = new $f268b97836dca6b6$export$baf26146a414f24a(p.x * cosinus - p.y * sinus, p.x * sinus + p.y * cosinus);
        return rotated.add(origin);
    }
    /**
   * Apply transform t to point p
   * @static
   * @memberOf fabric.util
   * @param  {TMat2D} t The transform
   * @param  {Boolean} [ignoreOffset] Indicates that the offset should not be applied
   * @return {Point} The transformed point
   */ transform(t) {
        let ignoreOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return new $f268b97836dca6b6$export$baf26146a414f24a(t[0] * this.x + t[2] * this.y + (ignoreOffset ? 0 : t[4]), t[1] * this.x + t[3] * this.y + (ignoreOffset ? 0 : t[5]));
    }
    constructor(){
        let arg0 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        let y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        if (typeof arg0 === 'object') {
            this.x = arg0.x;
            this.y = arg0.y;
        } else {
            this.x = arg0;
            this.y = y;
        }
    }
}
const $f268b97836dca6b6$var$ZERO = new $f268b97836dca6b6$export$baf26146a414f24a(0, 0);
const $f268b97836dca6b6$var$isCollection = (fabricObject)=>{
    return !!fabricObject && Array.isArray(fabricObject._objects);
};
function $f268b97836dca6b6$export$f589b6d5b7ad4722(Base) {
    class Collection extends Base {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _onObjectAdded(object) {
        // subclasses should override this method
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _onObjectRemoved(object) {
        // subclasses should override this method
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _onStackOrderChanged(object) {
        // subclasses should override this method
        }
        /**
     * Adds objects to collection
     * Objects should be instances of (or inherit from) FabricObject
     * @param {...FabricObject[]} objects to add
     * @returns {number} new array length
     */ add() {
            for(var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++)objects[_key] = arguments[_key];
            const size = this._objects.push(...objects);
            objects.forEach((object)=>this._onObjectAdded(object));
            return size;
        }
        /**
     * Inserts an object into collection at specified index
     * @param {number} index Index to insert object at
     * @param {...FabricObject[]} objects Object(s) to insert
     * @returns {number} new array length
     */ insertAt(index) {
            for(var _len2 = arguments.length, objects = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)objects[_key2 - 1] = arguments[_key2];
            this._objects.splice(index, 0, ...objects);
            objects.forEach((object)=>this._onObjectAdded(object));
            return this._objects.length;
        }
        /**
     * Removes objects from a collection, then renders canvas (if `renderOnAddRemove` is not `false`)
     * @private
     * @param {...FabricObject[]} objects objects to remove
     * @returns {FabricObject[]} removed objects
     */ remove() {
            const array = this._objects, removed = [];
            for(var _len3 = arguments.length, objects = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)objects[_key3] = arguments[_key3];
            objects.forEach((object)=>{
                const index = array.indexOf(object);
                // only call onObjectRemoved if an object was actually removed
                if (index !== -1) {
                    array.splice(index, 1);
                    removed.push(object);
                    this._onObjectRemoved(object);
                }
            });
            return removed;
        }
        /**
     * Executes given function for each object in this group
     * A simple shortcut for getObjects().forEach, before es6 was more complicated,
     * now is just a shortcut.
     * @param {Function} callback
     *                   Callback invoked with current object as first argument,
     *                   index - as second and an array of all objects - as third.
     */ forEachObject(callback) {
            this.getObjects().forEach((object, index, objects)=>callback(object, index, objects));
        }
        /**
     * Returns an array of children objects of this instance
     * @param {...String} [types] When specified, only objects of these types are returned
     * @return {Array}
     */ getObjects() {
            for(var _len4 = arguments.length, types = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)types[_key4] = arguments[_key4];
            if (types.length === 0) return [
                ...this._objects
            ];
            return this._objects.filter((o)=>o.isType(...types));
        }
        /**
     * Returns object at specified index
     * @param {Number} index
     * @return {Object} object at index
     */ item(index) {
            return this._objects[index];
        }
        /**
     * Returns true if collection contains no objects
     * @return {Boolean} true if collection is empty
     */ isEmpty() {
            return this._objects.length === 0;
        }
        /**
     * Returns a size of a collection (i.e: length of an array containing its objects)
     * @return {Number} Collection size
     */ size() {
            return this._objects.length;
        }
        /**
     * Returns true if collection contains an object.\
     * **Prefer using {@link FabricObject#isDescendantOf} for performance reasons**
     * instead of `a.contains(b)` use `b.isDescendantOf(a)`
     * @param {Object} object Object to check against
     * @param {Boolean} [deep=false] `true` to check all descendants, `false` to check only `_objects`
     * @return {Boolean} `true` if collection contains an object
     */ contains(object, deep) {
            if (this._objects.includes(object)) return true;
            else if (deep) return this._objects.some((obj)=>obj instanceof Collection && obj.contains(object, true));
            return false;
        }
        /**
     * Returns number representation of a collection complexity
     * @return {Number} complexity
     */ complexity() {
            return this._objects.reduce((memo, current)=>{
                memo += current.complexity ? current.complexity() : 0;
                return memo;
            }, 0);
        }
        /**
     * Moves an object or the objects of a multiple selection
     * to the bottom of the stack of drawn objects
     * @param {fabric.Object} object Object to send to back
     * @returns {boolean} true if change occurred
     */ sendObjectToBack(object) {
            if (!object || object === this._objects[0]) return false;
            $f268b97836dca6b6$var$removeFromArray(this._objects, object);
            this._objects.unshift(object);
            this._onStackOrderChanged(object);
            return true;
        }
        /**
     * Moves an object or the objects of a multiple selection
     * to the top of the stack of drawn objects
     * @param {fabric.Object} object Object to send
     * @returns {boolean} true if change occurred
     */ bringObjectToFront(object) {
            if (!object || object === this._objects[this._objects.length - 1]) return false;
            $f268b97836dca6b6$var$removeFromArray(this._objects, object);
            this._objects.push(object);
            this._onStackOrderChanged(object);
            return true;
        }
        /**
     * Moves an object or a selection down in stack of drawn objects
     * An optional parameter, `intersecting` allows to move the object in behind
     * the first intersecting object. Where intersection is calculated with
     * bounding box. If no intersection is found, there will not be change in the
     * stack.
     * @param {fabric.Object} object Object to send
     * @param {boolean} [intersecting] If `true`, send object behind next lower intersecting object
     * @returns {boolean} true if change occurred
     */ sendObjectBackwards(object, intersecting) {
            if (!object) return false;
            const idx = this._objects.indexOf(object);
            if (idx !== 0) {
                // if object is not on the bottom of stack
                const newIdx = this.findNewLowerIndex(object, idx, intersecting);
                $f268b97836dca6b6$var$removeFromArray(this._objects, object);
                this._objects.splice(newIdx, 0, object);
                this._onStackOrderChanged(object);
                return true;
            }
            return false;
        }
        /**
     * Moves an object or a selection up in stack of drawn objects
     * An optional parameter, intersecting allows to move the object in front
     * of the first intersecting object. Where intersection is calculated with
     * bounding box. If no intersection is found, there will not be change in the
     * stack.
     * @param {fabric.Object} object Object to send
     * @param {boolean} [intersecting] If `true`, send object in front of next upper intersecting object
     * @returns {boolean} true if change occurred
     */ bringObjectForward(object, intersecting) {
            if (!object) return false;
            const idx = this._objects.indexOf(object);
            if (idx !== this._objects.length - 1) {
                // if object is not on top of stack (last item in an array)
                const newIdx = this.findNewUpperIndex(object, idx, intersecting);
                $f268b97836dca6b6$var$removeFromArray(this._objects, object);
                this._objects.splice(newIdx, 0, object);
                this._onStackOrderChanged(object);
                return true;
            }
            return false;
        }
        /**
     * Moves an object to specified level in stack of drawn objects
     * @param {fabric.Object} object Object to send
     * @param {number} index Position to move to
     * @returns {boolean} true if change occurred
     */ moveObjectTo(object, index) {
            if (object === this._objects[index]) return false;
            $f268b97836dca6b6$var$removeFromArray(this._objects, object);
            this._objects.splice(index, 0, object);
            this._onStackOrderChanged(object);
            return true;
        }
        findNewLowerIndex(object, idx, intersecting) {
            let newIdx;
            if (intersecting) {
                newIdx = idx;
                // traverse down the stack looking for the nearest intersecting object
                for(let i = idx - 1; i >= 0; --i)if (object.isOverlapping(this._objects[i])) {
                    newIdx = i;
                    break;
                }
            } else newIdx = idx - 1;
            return newIdx;
        }
        findNewUpperIndex(object, idx, intersecting) {
            let newIdx;
            if (intersecting) {
                newIdx = idx;
                // traverse up the stack looking for the nearest intersecting object
                for(let i = idx + 1; i < this._objects.length; ++i)if (object.isOverlapping(this._objects[i])) {
                    newIdx = i;
                    break;
                }
            } else newIdx = idx + 1;
            return newIdx;
        }
        /**
     * Given a bounding box, return all the objects of the collection that are contained in the bounding box.
     * If `includeIntersecting` is true, return also the objects that intersect the bounding box as well.
     * This is meant to work with selection. Is not a generic method.
     * @param {TBBox} bbox a bounding box in scene coordinates
     * @param {{ includeIntersecting?: boolean }} options an object with includeIntersecting
     * @returns array of objects contained in the bounding box, ordered from top to bottom stacking wise
     */ collectObjects(_ref) {
            let { left: left, top: top, width: width, height: height } = _ref;
            let { includeIntersecting: includeIntersecting = true } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            const objects = [], tl = new $f268b97836dca6b6$export$baf26146a414f24a(left, top), br = tl.add(new $f268b97836dca6b6$export$baf26146a414f24a(width, height));
            // we iterate reverse order to collect top first in case of click.
            for(let i = this._objects.length - 1; i >= 0; i--){
                const object = this._objects[i];
                if (object.selectable && object.visible && (includeIntersecting && object.intersectsWithRect(tl, br) || object.isContainedWithinRect(tl, br) || includeIntersecting && object.containsPoint(tl) || includeIntersecting && object.containsPoint(br))) objects.push(object);
            }
            return objects;
        }
        constructor(){
            super(...arguments);
            /**
       * @type {FabricObject[]}
       * @TODO needs to end up in the constructor too
       */ $f268b97836dca6b6$var$_defineProperty(this, "_objects", []);
        }
    }
    // https://github.com/microsoft/TypeScript/issues/32080
    return Collection;
}
class $f268b97836dca6b6$var$CommonMethods extends $f268b97836dca6b6$export$77cea355fa80b5f4 {
    /**
   * Sets object's properties from options, for initialization only
   * @protected
   * @param {Object} [options] Options object
   */ _setOptions() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        for(const prop in options)this.set(prop, options[prop]);
    }
    /**
   * @private
   */ _setObject(obj) {
        for(const prop in obj)this._set(prop, obj[prop]);
    }
    /**
   * Sets property to a given value. When changing position/dimension -related properties (left, top, scale, angle, etc.) `set` does not update position of object's borders/controls. If you need to update those, call `setCoords()`.
   * @param {String|Object} key Property name or object (if object, iterate over the object properties)
   * @param {Object|Function} value Property value (if function, the value is passed into it and its return value is used as a new one)
   */ set(key, value) {
        if (typeof key === 'object') this._setObject(key);
        else this._set(key, value);
        return this;
    }
    _set(key, value) {
        this[key] = value;
    }
    /**
   * Toggles specified property from `true` to `false` or from `false` to `true`
   * @param {String} property Property to toggle
   */ toggle(property) {
        const value = this.get(property);
        if (typeof value === 'boolean') this.set(property, !value);
        return this;
    }
    /**
   * Basic getter
   * @param {String} property Property name
   * @return {*} value of a property
   */ get(property) {
        return this[property];
    }
}
function $f268b97836dca6b6$var$requestAnimFrame(callback) {
    return $f268b97836dca6b6$export$4a3a3142573970c3().requestAnimationFrame(callback);
}
function $f268b97836dca6b6$var$cancelAnimFrame(handle) {
    return $f268b97836dca6b6$export$4a3a3142573970c3().cancelAnimationFrame(handle);
}
let $f268b97836dca6b6$var$id = 0;
const $f268b97836dca6b6$var$uid = ()=>$f268b97836dca6b6$var$id++;
/**
 * Creates canvas element
 * @return {CanvasElement} initialized canvas element
 */ const $f268b97836dca6b6$var$createCanvasElement = ()=>{
    const element = $f268b97836dca6b6$export$91e93c41e950ddbb().createElement('canvas');
    if (!element || typeof element.getContext === 'undefined') throw new $f268b97836dca6b6$var$FabricError('Failed to create `canvas` element');
    return element;
};
/**
 * Creates image element (works on client and node)
 * @return {HTMLImageElement} HTML image element
 */ const $f268b97836dca6b6$var$createImage = ()=>$f268b97836dca6b6$export$91e93c41e950ddbb().createElement('img');
/**
 * Creates a canvas element that is a copy of another and is also painted
 * @param {CanvasElement} canvas to copy size and content of
 * @return {CanvasElement} initialized canvas element
 */ const $f268b97836dca6b6$var$copyCanvasElement = (canvas)=>{
    var _newCanvas$getContext;
    const newCanvas = $f268b97836dca6b6$var$createCanvasElementFor(canvas);
    (_newCanvas$getContext = newCanvas.getContext('2d')) === null || _newCanvas$getContext === void 0 || _newCanvas$getContext.drawImage(canvas, 0, 0);
    return newCanvas;
};
/**
 * Creates a canvas element as big as another
 * @param {CanvasElement} canvas to copy size and content of
 * @return {CanvasElement} initialized canvas element
 */ const $f268b97836dca6b6$var$createCanvasElementFor = (canvas)=>{
    const newCanvas = $f268b97836dca6b6$var$createCanvasElement();
    newCanvas.width = canvas.width;
    newCanvas.height = canvas.height;
    return newCanvas;
};
/**
 * since 2.6.0 moved from canvas instance to utility.
 * possibly useless
 * @param {CanvasElement} canvasEl to copy size and content of
 * @param {String} format 'jpeg' or 'png', in some browsers 'webp' is ok too
 * @param {number} quality <= 1 and > 0
 * @return {String} data url
 */ const $f268b97836dca6b6$var$toDataURL = (canvasEl, format, quality)=>canvasEl.toDataURL("image/".concat(format), quality);
const $f268b97836dca6b6$var$isHTMLCanvas = (canvas)=>{
    return !!canvas && canvas.getContext !== undefined;
};
const $f268b97836dca6b6$var$toBlob = (canvasEl, format, quality)=>new Promise((resolve, _)=>{
        canvasEl.toBlob(resolve, "image/".concat(format), quality);
    });
/**
 * Transforms degrees to radians.
 * @param {TDegree} degrees value in degrees
 * @return {TRadian} value in radians
 */ const $f268b97836dca6b6$var$degreesToRadians = (degrees)=>degrees * $f268b97836dca6b6$var$PiBy180;
/**
 * Transforms radians to degrees.
 * @param {TRadian} radians value in radians
 * @return {TDegree} value in degrees
 */ const $f268b97836dca6b6$var$radiansToDegrees = (radians)=>radians / $f268b97836dca6b6$var$PiBy180;
const $f268b97836dca6b6$var$isIdentityMatrix = (mat)=>mat.every((value, index)=>value === $f268b97836dca6b6$export$3c5a7f9475b116e0[index]);
/**
 * Apply transform t to point p
 * @deprecated use {@link Point#transform}
 * @param  {Point | XY} p The point to transform
 * @param  {Array} t The transform
 * @param  {Boolean} [ignoreOffset] Indicates that the offset should not be applied
 * @return {Point} The transformed point
 */ const $f268b97836dca6b6$var$transformPoint = (p, t, ignoreOffset)=>new $f268b97836dca6b6$export$baf26146a414f24a(p).transform(t, ignoreOffset);
/**
 * Invert transformation t
 * @param {Array} t The transform
 * @return {Array} The inverted transform
 */ const $f268b97836dca6b6$var$invertTransform = (t)=>{
    const a = 1 / (t[0] * t[3] - t[1] * t[2]), r = [
        a * t[3],
        -a * t[1],
        -a * t[2],
        a * t[0],
        0,
        0
    ], { x: x, y: y } = new $f268b97836dca6b6$export$baf26146a414f24a(t[4], t[5]).transform(r, true);
    r[4] = -x;
    r[5] = -y;
    return r;
};
/**
 * Multiply matrix A by matrix B to nest transformations
 * @param  {TMat2D} a First transformMatrix
 * @param  {TMat2D} b Second transformMatrix
 * @param  {Boolean} is2x2 flag to multiply matrices as 2x2 matrices
 * @return {TMat2D} The product of the two transform matrices
 */ const $f268b97836dca6b6$var$multiplyTransformMatrices = (a, b, is2x2)=>[
        a[0] * b[0] + a[2] * b[1],
        a[1] * b[0] + a[3] * b[1],
        a[0] * b[2] + a[2] * b[3],
        a[1] * b[2] + a[3] * b[3],
        is2x2 ? 0 : a[0] * b[4] + a[2] * b[5] + a[4],
        is2x2 ? 0 : a[1] * b[4] + a[3] * b[5] + a[5]
    ];
/**
 * Multiplies {@link TMat2D} such that a matrix defines the plane for the rest of the matrices **after** it
 *
 * `multiplyTransformMatrixArray([A, B, C, D])` is equivalent to `A(B(C(D)))`
 *
 * @param matrices an array of matrices
 * @param [is2x2] flag to multiply matrices as 2x2 matrices
 * @returns the multiplication product
 */ const $f268b97836dca6b6$var$multiplyTransformMatrixArray = (matrices, is2x2)=>matrices.reduceRight((product, curr)=>curr && product ? $f268b97836dca6b6$var$multiplyTransformMatrices(curr, product, is2x2) : curr || product, undefined) || $f268b97836dca6b6$export$3c5a7f9475b116e0.concat();
const $f268b97836dca6b6$var$calcPlaneRotation = (_ref)=>{
    let [a, b] = _ref;
    return Math.atan2(b, a);
};
/**
 * Decomposes standard 2x3 matrix into transform components
 * @param  {TMat2D} a transformMatrix
 * @return {Object} Components of transform
 */ const $f268b97836dca6b6$var$qrDecompose = (a)=>{
    const angle = $f268b97836dca6b6$var$calcPlaneRotation(a), denom = Math.pow(a[0], 2) + Math.pow(a[1], 2), scaleX = Math.sqrt(denom), scaleY = (a[0] * a[3] - a[2] * a[1]) / scaleX, skewX = Math.atan2(a[0] * a[2] + a[1] * a[3], denom);
    return {
        angle: $f268b97836dca6b6$var$radiansToDegrees(angle),
        scaleX: scaleX,
        scaleY: scaleY,
        skewX: $f268b97836dca6b6$var$radiansToDegrees(skewX),
        skewY: 0,
        translateX: a[4] || 0,
        translateY: a[5] || 0
    };
};
/**
 * Generate a translation matrix
 *
 * A translation matrix in the form of
 * [ 1 0 x ]
 * [ 0 1 y ]
 * [ 0 0 1 ]
 *
 * See @link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#translate for more details
 *
 * @param {number} x translation on X axis
 * @param {number} [y] translation on Y axis
 * @returns {TMat2D} matrix
 */ const $f268b97836dca6b6$var$createTranslateMatrix = function(x) {
    let y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return [
        1,
        0,
        0,
        1,
        x,
        y
    ];
};
/**
 * Generate a rotation matrix around around a point (x,y), defaulting to (0,0)
 *
 * A matrix in the form of
 * [cos(a) -sin(a) -x*cos(a)+y*sin(a)+x]
 * [sin(a)  cos(a) -x*sin(a)-y*cos(a)+y]
 * [0       0      1                 ]
 *
 *
 * @param {TDegree} angle rotation in degrees
 * @param {XY} [pivotPoint] pivot point to rotate around
 * @returns {TMat2D} matrix
 */ function $f268b97836dca6b6$var$createRotateMatrix() {
    let { angle: angle = 0 } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let { x: x = 0, y: y = 0 } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const angleRadiant = $f268b97836dca6b6$var$degreesToRadians(angle), cosValue = $f268b97836dca6b6$var$cos(angleRadiant), sinValue = $f268b97836dca6b6$var$sin(angleRadiant);
    return [
        cosValue,
        sinValue,
        -sinValue,
        cosValue,
        x ? x - (cosValue * x - sinValue * y) : 0,
        y ? y - (sinValue * x + cosValue * y) : 0
    ];
}
/**
 * Generate a scale matrix around the point (0,0)
 *
 * A matrix in the form of
 * [x 0 0]
 * [0 y 0]
 * [0 0 1]
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#scale
 *
 * @param {number} x scale on X axis
 * @param {number} [y] scale on Y axis
 * @returns {TMat2D} matrix
 */ const $f268b97836dca6b6$var$createScaleMatrix = function(x) {
    let y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
    return [
        x,
        0,
        0,
        y,
        0,
        0
    ];
};
const $f268b97836dca6b6$var$angleToSkew = (angle)=>Math.tan($f268b97836dca6b6$var$degreesToRadians(angle));
/**
 * Generate a skew matrix for the X axis
 *
 * A matrix in the form of
 * [1 x 0]
 * [0 1 0]
 * [0 0 1]
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#skewx
 *
 * @param {TDegree} skewValue translation on X axis
 * @returns {TMat2D} matrix
 */ const $f268b97836dca6b6$var$createSkewXMatrix = (skewValue)=>[
        1,
        0,
        $f268b97836dca6b6$var$angleToSkew(skewValue),
        1,
        0,
        0
    ];
/**
 * Generate a skew matrix for the Y axis
 *
 * A matrix in the form of
 * [1 0 0]
 * [y 1 0]
 * [0 0 1]
 *
 * @link https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/transform#skewy
 *
 * @param {TDegree} skewValue translation on Y axis
 * @returns {TMat2D} matrix
 */ const $f268b97836dca6b6$var$createSkewYMatrix = (skewValue)=>[
        1,
        $f268b97836dca6b6$var$angleToSkew(skewValue),
        0,
        1,
        0,
        0
    ];
/**
 * Returns a transform matrix starting from an object of the same kind of
 * the one returned from qrDecompose, useful also if you want to calculate some
 * transformations from an object that is not enlived yet.
 * is called DimensionsTransformMatrix because those properties are the one that influence
 * the size of the resulting box of the object.
 * @param  {Object} options
 * @param  {Number} [options.scaleX]
 * @param  {Number} [options.scaleY]
 * @param  {Boolean} [options.flipX]
 * @param  {Boolean} [options.flipY]
 * @param  {Number} [options.skewX]
 * @param  {Number} [options.skewY]
 * @return {Number[]} transform matrix
 */ const $f268b97836dca6b6$var$calcDimensionsMatrix = (_ref2)=>{
    let { scaleX: scaleX = 1, scaleY: scaleY = 1, flipX: flipX = false, flipY: flipY = false, skewX: skewX = 0, skewY: skewY = 0 } = _ref2;
    let matrix = $f268b97836dca6b6$var$createScaleMatrix(flipX ? -scaleX : scaleX, flipY ? -scaleY : scaleY);
    if (skewX) matrix = $f268b97836dca6b6$var$multiplyTransformMatrices(matrix, $f268b97836dca6b6$var$createSkewXMatrix(skewX), true);
    if (skewY) matrix = $f268b97836dca6b6$var$multiplyTransformMatrices(matrix, $f268b97836dca6b6$var$createSkewYMatrix(skewY), true);
    return matrix;
};
/**
 * Returns a transform matrix starting from an object of the same kind of
 * the one returned from qrDecompose, useful also if you want to calculate some
 * transformations from an object that is not enlived yet
 * Before changing this function look at: src/benchmarks/calcTransformMatrix.mjs
 * @param  {Object} options
 * @param  {Number} [options.angle]
 * @param  {Number} [options.scaleX]
 * @param  {Number} [options.scaleY]
 * @param  {Boolean} [options.flipX]
 * @param  {Boolean} [options.flipY]
 * @param  {Number} [options.skewX]
 * @param  {Number} [options.skewY]
 * @param  {Number} [options.translateX]
 * @param  {Number} [options.translateY]
 * @return {Number[]} transform matrix
 */ const $f268b97836dca6b6$var$composeMatrix = (options)=>{
    const { translateX: translateX = 0, translateY: translateY = 0, angle: angle = 0 } = options;
    let matrix = $f268b97836dca6b6$var$createTranslateMatrix(translateX, translateY);
    if (angle) matrix = $f268b97836dca6b6$var$multiplyTransformMatrices(matrix, $f268b97836dca6b6$var$createRotateMatrix({
        angle: angle
    }));
    const scaleMatrix = $f268b97836dca6b6$var$calcDimensionsMatrix(options);
    if (!$f268b97836dca6b6$var$isIdentityMatrix(scaleMatrix)) matrix = $f268b97836dca6b6$var$multiplyTransformMatrices(matrix, scaleMatrix);
    return matrix;
};
/**
 * Loads image element from given url and resolve it, or catch.
 * @param {String} url URL representing an image
 * @param {LoadImageOptions} [options] image loading options
 * @returns {Promise<HTMLImageElement>} the loaded image.
 */ const $f268b97836dca6b6$var$loadImage = function(url) {
    let { signal: signal, crossOrigin: crossOrigin = null } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise(function(resolve, reject) {
        if (signal && signal.aborted) return reject(new $f268b97836dca6b6$var$SignalAbortedError('loadImage'));
        const img = $f268b97836dca6b6$var$createImage();
        let abort;
        if (signal) {
            abort = function(err) {
                img.src = '';
                reject(err);
            };
            signal.addEventListener('abort', abort, {
                once: true
            });
        }
        const done = function() {
            img.onload = img.onerror = null;
            abort && (signal === null || signal === void 0 || signal.removeEventListener('abort', abort));
            resolve(img);
        };
        if (!url) {
            done();
            return;
        }
        img.onload = done;
        img.onerror = function() {
            abort && (signal === null || signal === void 0 || signal.removeEventListener('abort', abort));
            reject(new $f268b97836dca6b6$var$FabricError("Error loading ".concat(img.src)));
        };
        crossOrigin && (img.crossOrigin = crossOrigin);
        img.src = url;
    });
};
/**
 * @TODO type this correctly.
 * Creates corresponding fabric instances from their object representations
 * @param {Object[]} objects Objects to enliven
 * @param {EnlivenObjectOptions} [options]
 * @param {(serializedObj: object, instance: FabricObject) => any} [options.reviver] Method for further parsing of object elements,
 * called after each fabric object created.
 * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
 * @returns {Promise<FabricObject[]>}
 */ const $f268b97836dca6b6$var$enlivenObjects = function(objects) {
    let { signal: signal, reviver: reviver = $f268b97836dca6b6$var$noop } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise((resolve, reject)=>{
        const instances = [];
        signal && signal.addEventListener('abort', reject, {
            once: true
        });
        Promise.all(objects.map((obj)=>$f268b97836dca6b6$export$2792378e23a7920c.getClass(obj.type).fromObject(obj, {
                signal: signal
            }).then((fabricInstance)=>{
                reviver(obj, fabricInstance);
                instances.push(fabricInstance);
                return fabricInstance;
            }))).then(resolve).catch((error)=>{
            // cleanup
            instances.forEach((instance)=>{
                instance.dispose && instance.dispose();
            });
            reject(error);
        }).finally(()=>{
            signal && signal.removeEventListener('abort', reject);
        });
    });
};
/**
 * Creates corresponding fabric instances residing in an object, e.g. `clipPath`
 * @param {Object} object with properties to enlive ( fill, stroke, clipPath, path )
 * @param {object} [options]
 * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
 * @returns {Promise<Record<string, FabricObject | TFiller | null>>} the input object with enlived values
 */ const $f268b97836dca6b6$var$enlivenObjectEnlivables = function(serializedObject) {
    let { signal: signal } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return new Promise((resolve, reject)=>{
        const instances = [];
        signal && signal.addEventListener('abort', reject, {
            once: true
        });
        // enlive every possible property
        const promises = Object.values(serializedObject).map((value)=>{
            if (!value) return value;
            /**
       * clipPath or shadow or gradient or text on a path or a pattern,
       * or the backgroundImage or overlayImage of canvas
       * If we have a type and there is a classe registered for it, we enlive it.
       * If there is no class registered for it we return the value as is
       * */ if (value.type && $f268b97836dca6b6$export$2792378e23a7920c.has(value.type)) return $f268b97836dca6b6$var$enlivenObjects([
                value
            ], {
                signal: signal
            }).then((_ref)=>{
                let [enlived] = _ref;
                instances.push(enlived);
                return enlived;
            });
            return value;
        });
        const keys = Object.keys(serializedObject);
        Promise.all(promises).then((enlived)=>{
            return enlived.reduce((acc, instance, index)=>{
                acc[keys[index]] = instance;
                return acc;
            }, {});
        }).then(resolve).catch((error)=>{
            // cleanup
            instances.forEach((instance)=>{
                instance.dispose && instance.dispose();
            });
            reject(error);
        }).finally(()=>{
            signal && signal.removeEventListener('abort', reject);
        });
    });
};
/**
 * Populates an object with properties of another object
 * @param {Object} source Source object
 * @param {string[]} properties Properties names to include
 * @returns object populated with the picked keys
 */ const $f268b97836dca6b6$var$pick = function(source) {
    let keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return keys.reduce((o, key)=>{
        if (key in source) o[key] = source[key];
        return o;
    }, {});
};
const $f268b97836dca6b6$var$pickBy = (source, predicate)=>{
    return Object.keys(source).reduce((o, key)=>{
        if (predicate(source[key], key, source)) o[key] = source[key];
        return o;
    }, {});
};
/**
 * A wrapper around Number#toFixed, which contrary to native method returns number, not string.
 * @param {number|string} number number to operate on
 * @param {number} fractionDigits number of fraction digits to "leave"
 * @return {number}
 */ const $f268b97836dca6b6$var$toFixed = (number, fractionDigits)=>parseFloat(Number(number).toFixed(fractionDigits));
/**
 * given an array of 6 number returns something like `"matrix(...numbers)"`
 * @param {TMat2D} transform an array with 6 numbers
 * @return {String} transform matrix for svg
 */ const $f268b97836dca6b6$var$matrixToSVG = (transform)=>'matrix(' + transform.map((value)=>$f268b97836dca6b6$var$toFixed(value, $f268b97836dca6b6$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS)).join(' ') + ')';
const $f268b97836dca6b6$var$isFiller = (filler)=>{
    return !!filler && filler.toLive !== undefined;
};
const $f268b97836dca6b6$var$isSerializableFiller = (filler)=>{
    return !!filler && typeof filler.toObject === 'function';
};
const $f268b97836dca6b6$var$isPattern = (filler)=>{
    return !!filler && filler.offsetX !== undefined && 'source' in filler;
};
const $f268b97836dca6b6$var$isTextObject = (fabricObject)=>{
    return !!fabricObject && typeof fabricObject._renderText === 'function';
};
const $f268b97836dca6b6$var$isPath = (fabricObject)=>{
    // we could use instanceof but that would mean pulling in Text code for a simple check
    // @todo discuss what to do and how to do
    return !!fabricObject && typeof fabricObject._renderPathCommands === 'function';
};
const $f268b97836dca6b6$var$isActiveSelection = (fabricObject)=>!!fabricObject && 'multiSelectionStacking' in fabricObject;
/**
 * Returns element scroll offsets
 * @param {HTMLElement} element Element to operate on
 * @return {Object} Object with left/top values
 */ function $f268b97836dca6b6$var$getScrollLeftTop(element) {
    const doc = element && $f268b97836dca6b6$var$getDocumentFromElement(element);
    let left = 0, top = 0;
    if (!element || !doc) return {
        left: left,
        top: top
    };
    let elementLoop = element;
    const docElement = doc.documentElement, body = doc.body || {
        scrollLeft: 0,
        scrollTop: 0
    };
    // While loop checks (and then sets element to) .parentNode OR .host
    //  to account for ShadowDOM. We still want to traverse up out of ShadowDOM,
    //  but the .parentNode of a root ShadowDOM node will always be null, instead
    //  it should be accessed through .host. See http://stackoverflow.com/a/24765528/4383938
    while(elementLoop && (elementLoop.parentNode || elementLoop.host)){
        elementLoop = elementLoop.parentNode || elementLoop.host;
        if (elementLoop === doc) {
            left = body.scrollLeft || docElement.scrollLeft || 0;
            top = body.scrollTop || docElement.scrollTop || 0;
        } else {
            left += elementLoop.scrollLeft || 0;
            top += elementLoop.scrollTop || 0;
        }
        if (elementLoop.nodeType === 1 && elementLoop.style.position === 'fixed') break;
    }
    return {
        left: left,
        top: top
    };
}
const $f268b97836dca6b6$var$getDocumentFromElement = (el)=>el.ownerDocument || null;
const $f268b97836dca6b6$var$getWindowFromElement = (el)=>{
    var _el$ownerDocument;
    return ((_el$ownerDocument = el.ownerDocument) === null || _el$ownerDocument === void 0 ? void 0 : _el$ownerDocument.defaultView) || null;
};
const $f268b97836dca6b6$var$setCanvasDimensions = function(el, ctx, _ref) {
    let { width: width, height: height } = _ref;
    let retinaScaling = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    el.width = width;
    el.height = height;
    if (retinaScaling > 1) {
        el.setAttribute('width', (width * retinaScaling).toString());
        el.setAttribute('height', (height * retinaScaling).toString());
        ctx.scale(retinaScaling, retinaScaling);
    }
};
const $f268b97836dca6b6$var$setCSSDimensions = (el, _ref2)=>{
    let { width: width, height: height } = _ref2;
    width && (el.style.width = typeof width === 'number' ? "".concat(width, "px") : width);
    height && (el.style.height = typeof height === 'number' ? "".concat(height, "px") : height);
};
/**
 * Returns offset for a given element
 * @param {HTMLElement} element Element to get offset for
 * @return {Object} Object with "left" and "top" properties
 */ function $f268b97836dca6b6$var$getElementOffset(element) {
    var _getWindowFromElement;
    const doc = element && $f268b97836dca6b6$var$getDocumentFromElement(element), offset = {
        left: 0,
        top: 0
    };
    if (!doc) return offset;
    const elemStyle = ((_getWindowFromElement = $f268b97836dca6b6$var$getWindowFromElement(element)) === null || _getWindowFromElement === void 0 ? void 0 : _getWindowFromElement.getComputedStyle(element, null)) || {};
    offset.left += parseInt(elemStyle.borderLeftWidth, 10) || 0;
    offset.top += parseInt(elemStyle.borderTopWidth, 10) || 0;
    offset.left += parseInt(elemStyle.paddingLeft, 10) || 0;
    offset.top += parseInt(elemStyle.paddingTop, 10) || 0;
    let box = {
        left: 0,
        top: 0
    };
    const docElem = doc.documentElement;
    if (typeof element.getBoundingClientRect !== 'undefined') box = element.getBoundingClientRect();
    const scrollLeftTop = $f268b97836dca6b6$var$getScrollLeftTop(element);
    return {
        left: box.left + scrollLeftTop.left - (docElem.clientLeft || 0) + offset.left,
        top: box.top + scrollLeftTop.top - (docElem.clientTop || 0) + offset.top
    };
}
/**
 * Makes element unselectable
 * @param {HTMLElement} element Element to make unselectable
 * @return {HTMLElement} Element that was passed in
 */ function $f268b97836dca6b6$var$makeElementUnselectable(element) {
    if (typeof element.onselectstart !== 'undefined') element.onselectstart = ()=>false;
    element.style.userSelect = $f268b97836dca6b6$var$NONE;
    return element;
}
class $f268b97836dca6b6$export$cf489a44e232c033 {
    createLowerCanvas(arg0) {
        // canvasEl === 'HTMLCanvasElement' does not work on jsdom/node
        const el = $f268b97836dca6b6$var$isHTMLCanvas(arg0) ? arg0 : arg0 && $f268b97836dca6b6$export$91e93c41e950ddbb().getElementById(arg0) || $f268b97836dca6b6$var$createCanvasElement();
        if (el.hasAttribute('data-fabric')) throw new $f268b97836dca6b6$var$FabricError('Trying to initialize a canvas that has already been initialized. Did you forget to dispose the canvas?');
        this._originalCanvasStyle = el.style.cssText;
        el.setAttribute('data-fabric', 'main');
        el.classList.add('lower-canvas');
        return el;
    }
    cleanupDOM(_ref) {
        let { width: width, height: height } = _ref;
        const { el: el } = this.lower;
        // restore canvas style and attributes
        el.classList.remove('lower-canvas');
        el.removeAttribute('data-fabric');
        // restore canvas size to original size in case retina scaling was applied
        el.setAttribute('width', "".concat(width));
        el.setAttribute('height', "".concat(height));
        el.style.cssText = this._originalCanvasStyle || '';
        this._originalCanvasStyle = undefined;
    }
    setDimensions(size, retinaScaling) {
        const { el: el, ctx: ctx } = this.lower;
        $f268b97836dca6b6$var$setCanvasDimensions(el, ctx, size, retinaScaling);
    }
    setCSSDimensions(size) {
        $f268b97836dca6b6$var$setCSSDimensions(this.lower.el, size);
    }
    /**
   * Calculates canvas element offset relative to the document
   */ calcOffset() {
        return $f268b97836dca6b6$var$getElementOffset(this.lower.el);
    }
    dispose() {
        $f268b97836dca6b6$export$4bd44a2aa29d3d6e().dispose(this.lower.el);
        // @ts-expect-error disposing
        delete this.lower;
    }
    constructor(arg0){
        /**
     * Keeps a copy of the canvas style before setting retina scaling and other potions
     * in order to return it to original state on dispose
     * @type string
     */ $f268b97836dca6b6$var$_defineProperty(this, "_originalCanvasStyle", void 0);
        $f268b97836dca6b6$var$_defineProperty(this, "lower", void 0);
        const el = this.createLowerCanvas(arg0);
        this.lower = {
            el: el,
            ctx: el.getContext('2d')
        };
    }
}
const $f268b97836dca6b6$var$staticCanvasDefaults = {
    backgroundVpt: true,
    backgroundColor: '',
    overlayVpt: true,
    overlayColor: '',
    includeDefaultValues: true,
    svgViewportTransformation: true,
    renderOnAddRemove: true,
    skipOffscreen: true,
    enableRetinaScaling: true,
    imageSmoothingEnabled: true,
    /**
   * @todo move to Canvas
   */ controlsAboveOverlay: false,
    /**
   * @todo move to Canvas
   */ allowTouchScrolling: false,
    viewportTransform: [
        ...$f268b97836dca6b6$export$3c5a7f9475b116e0
    ]
};
const $f268b97836dca6b6$var$_excluded$j = [
    "objects"
];
/**
 * Having both options in TCanvasSizeOptions set to true transform the call in a calcOffset
 * Better try to restrict with types to avoid confusion.
 */ /**
 * Static canvas class
 * @see {@link http://fabricjs.com/static_canvas|StaticCanvas demo}
 * @fires before:render
 * @fires after:render
 * @fires canvas:cleared
 * @fires object:added
 * @fires object:removed
 */ // TODO: fix `EventSpec` inheritance https://github.com/microsoft/TypeScript/issues/26154#issuecomment-1366616260
class $f268b97836dca6b6$export$ad01921fb0b1386e extends $f268b97836dca6b6$export$f589b6d5b7ad4722($f268b97836dca6b6$var$CommonMethods) {
    // background
    // overlay
    // rendering config
    /**
   * @todo move to Canvas
   */ /**
   * @todo move to Canvas
   */ /**
   * The viewport bounding box in scene plane coordinates, see {@link calcViewportBoundaries}
   */ /**
   * A reference to the canvas actual HTMLCanvasElement.
   * Can be use to read the raw pixels, but never write or manipulate
   * @type HTMLCanvasElement
   */ get lowerCanvasEl() {
        var _this$elements$lower;
        return (_this$elements$lower = this.elements.lower) === null || _this$elements$lower === void 0 ? void 0 : _this$elements$lower.el;
    }
    get contextContainer() {
        var _this$elements$lower2;
        return (_this$elements$lower2 = this.elements.lower) === null || _this$elements$lower2 === void 0 ? void 0 : _this$elements$lower2.ctx;
    }
    /**
   * If true the Canvas is in the process or has been disposed/destroyed.
   * No more rendering operation will be executed on this canvas.
   * @type boolean
   */ /**
   * Started the process of disposing but not done yet.
   * WIll likely complete the render cycle already scheduled but stopping adding more.
   * @type boolean
   */ /**
   * When true control drawing is skipped.
   * This boolean is used to avoid toDataURL to export controls.
   * Usage of this boolean to build up other flows and features is not supported
   * @type Boolean
   * @default false
   */ // reference to
    static getDefaults() {
        return $f268b97836dca6b6$export$ad01921fb0b1386e.ownDefaults;
    }
    initElements(el) {
        this.elements = new $f268b97836dca6b6$export$cf489a44e232c033(el);
    }
    add() {
        const size = super.add(...arguments);
        arguments.length > 0 && this.renderOnAddRemove && this.requestRenderAll();
        return size;
    }
    insertAt(index) {
        for(var _len = arguments.length, objects = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)objects[_key - 1] = arguments[_key];
        const size = super.insertAt(index, ...objects);
        objects.length > 0 && this.renderOnAddRemove && this.requestRenderAll();
        return size;
    }
    remove() {
        const removed = super.remove(...arguments);
        removed.length > 0 && this.renderOnAddRemove && this.requestRenderAll();
        return removed;
    }
    _onObjectAdded(obj) {
        if (obj.canvas && obj.canvas !== this) {
            $f268b97836dca6b6$var$log('warn', "Canvas is trying to add an object that belongs to a different canvas.\nResulting to default behavior: removing object from previous canvas and adding to new canvas");
            obj.canvas.remove(obj);
        }
        obj._set('canvas', this);
        obj.setCoords();
        this.fire('object:added', {
            target: obj
        });
        obj.fire('added', {
            target: this
        });
    }
    _onObjectRemoved(obj) {
        obj._set('canvas', undefined);
        this.fire('object:removed', {
            target: obj
        });
        obj.fire('removed', {
            target: this
        });
    }
    _onStackOrderChanged() {
        this.renderOnAddRemove && this.requestRenderAll();
    }
    /**
   * @private
   * @see https://developer.apple.com/library/safari/documentation/AudioVideo/Conceptual/HTML-canvas-guide/SettingUptheCanvas/SettingUptheCanvas.html
   * @return {Number} retinaScaling if applied, otherwise 1;
   */ getRetinaScaling() {
        return this.enableRetinaScaling ? $f268b97836dca6b6$var$getDevicePixelRatio() : 1;
    }
    /**
   * Calculates canvas element offset relative to the document
   * This method is also attached as "resize" event handler of window
   */ calcOffset() {
        return this._offset = this.elements.calcOffset();
    }
    /**
   * Returns canvas width (in px)
   * @return {Number}
   */ getWidth() {
        return this.width;
    }
    /**
   * Returns canvas height (in px)
   * @return {Number}
   */ getHeight() {
        return this.height;
    }
    /**
   * Sets width of this canvas instance
   * @param {Number|String} value                         Value to set width to
   * @param {Object}        [options]                     Options object
   * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
   * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
   * @deprecated will be removed in 7.0
   */ setWidth(value, options) {
        return this.setDimensions({
            width: value
        }, options);
    }
    /**s
   * Sets height of this canvas instance
   * @param {Number|String} value                         Value to set height to
   * @param {Object}        [options]                     Options object
   * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
   * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
   * @deprecated will be removed in 7.0
   */ setHeight(value, options) {
        return this.setDimensions({
            height: value
        }, options);
    }
    /**
   * Internal use only
   * @protected
   */ _setDimensionsImpl(dimensions) {
        let { cssOnly: cssOnly = false, backstoreOnly: backstoreOnly = false } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!cssOnly) {
            const size = $f268b97836dca6b6$var$_objectSpread2({
                width: this.width,
                height: this.height
            }, dimensions);
            this.elements.setDimensions(size, this.getRetinaScaling());
            this.hasLostContext = true;
            this.width = size.width;
            this.height = size.height;
        }
        if (!backstoreOnly) this.elements.setCSSDimensions(dimensions);
        this.calcOffset();
    }
    /**
   * Sets dimensions (width, height) of this canvas instance. when options.cssOnly flag active you should also supply the unit of measure (px/%/em)
   * @param {Object}        dimensions                    Object with width/height properties
   * @param {Number|String} [dimensions.width]            Width of canvas element
   * @param {Number|String} [dimensions.height]           Height of canvas element
   * @param {Object}        [options]                     Options object
   * @param {Boolean}       [options.backstoreOnly=false] Set the given dimensions only as canvas backstore dimensions
   * @param {Boolean}       [options.cssOnly=false]       Set the given dimensions only as css dimensions
   */ setDimensions(dimensions, options) {
        this._setDimensionsImpl(dimensions, options);
        if (!options || !options.cssOnly) this.requestRenderAll();
    }
    /**
   * Returns canvas zoom level
   * @return {Number}
   */ getZoom() {
        return this.viewportTransform[0];
    }
    /**
   * Sets viewport transformation of this canvas instance
   * @param {Array} vpt a Canvas 2D API transform matrix
   */ setViewportTransform(vpt) {
        this.viewportTransform = vpt;
        this.calcViewportBoundaries();
        this.renderOnAddRemove && this.requestRenderAll();
    }
    /**
   * Sets zoom level of this canvas instance, the zoom centered around point
   * meaning that following zoom to point with the same point will have the visual
   * effect of the zoom originating from that point. The point won't move.
   * It has nothing to do with canvas center or visual center of the viewport.
   * @param {Point} point to zoom with respect to
   * @param {Number} value to set zoom to, less than 1 zooms out
   */ zoomToPoint(point, value) {
        // TODO: just change the scale, preserve other transformations
        const before = point, vpt = [
            ...this.viewportTransform
        ];
        const newPoint = $f268b97836dca6b6$var$transformPoint(point, $f268b97836dca6b6$var$invertTransform(vpt));
        vpt[0] = value;
        vpt[3] = value;
        const after = $f268b97836dca6b6$var$transformPoint(newPoint, vpt);
        vpt[4] += before.x - after.x;
        vpt[5] += before.y - after.y;
        this.setViewportTransform(vpt);
    }
    /**
   * Sets zoom level of this canvas instance
   * @param {Number} value to set zoom to, less than 1 zooms out
   */ setZoom(value) {
        this.zoomToPoint(new $f268b97836dca6b6$export$baf26146a414f24a(0, 0), value);
    }
    /**
   * Pan viewport so as to place point at top left corner of canvas
   * @param {Point} point to move to
   */ absolutePan(point) {
        const vpt = [
            ...this.viewportTransform
        ];
        vpt[4] = -point.x;
        vpt[5] = -point.y;
        return this.setViewportTransform(vpt);
    }
    /**
   * Pans viewpoint relatively
   * @param {Point} point (position vector) to move by
   */ relativePan(point) {
        return this.absolutePan(new $f268b97836dca6b6$export$baf26146a414f24a(-point.x - this.viewportTransform[4], -point.y - this.viewportTransform[5]));
    }
    /**
   * Returns &lt;canvas> element corresponding to this instance
   * @return {HTMLCanvasElement}
   */ getElement() {
        return this.elements.lower.el;
    }
    /**
   * Clears specified context of canvas element
   * @param {CanvasRenderingContext2D} ctx Context to clear
   */ clearContext(ctx) {
        ctx.clearRect(0, 0, this.width, this.height);
    }
    /**
   * Returns context of canvas where objects are drawn
   * @return {CanvasRenderingContext2D}
   */ getContext() {
        return this.elements.lower.ctx;
    }
    /**
   * Clears all contexts (background, main, top) of an instance
   */ clear() {
        this.remove(...this.getObjects());
        this.backgroundImage = undefined;
        this.overlayImage = undefined;
        this.backgroundColor = '';
        this.overlayColor = '';
        this.clearContext(this.getContext());
        this.fire('canvas:cleared');
        this.renderOnAddRemove && this.requestRenderAll();
    }
    /**
   * Renders the canvas
   */ renderAll() {
        this.cancelRequestedRender();
        if (this.destroyed) return;
        this.renderCanvas(this.getContext(), this._objects);
    }
    /**
   * Function created to be instance bound at initialization
   * used in requestAnimationFrame rendering
   * Let the fabricJS call it. If you call it manually you could have more
   * animationFrame stacking on to of each other
   * for an imperative rendering, use canvas.renderAll
   * @private
   */ renderAndReset() {
        this.nextRenderHandle = 0;
        this.renderAll();
    }
    /**
   * Append a renderAll request to next animation frame.
   * unless one is already in progress, in that case nothing is done
   * a boolean flag will avoid appending more.
   */ requestRenderAll() {
        if (!this.nextRenderHandle && !this.disposed && !this.destroyed) this.nextRenderHandle = $f268b97836dca6b6$var$requestAnimFrame(()=>this.renderAndReset());
    }
    /**
   * Calculate the position of the 4 corner of canvas with current viewportTransform.
   * helps to determinate when an object is in the current rendering viewport
   */ calcViewportBoundaries() {
        const width = this.width, height = this.height, iVpt = $f268b97836dca6b6$var$invertTransform(this.viewportTransform), a = $f268b97836dca6b6$var$transformPoint({
            x: 0,
            y: 0
        }, iVpt), b = $f268b97836dca6b6$var$transformPoint({
            x: width,
            y: height
        }, iVpt), // we don't support vpt flipping
        // but the code is robust enough to mostly work with flipping
        min = a.min(b), max = a.max(b);
        return this.vptCoords = {
            tl: min,
            tr: new $f268b97836dca6b6$export$baf26146a414f24a(max.x, min.y),
            bl: new $f268b97836dca6b6$export$baf26146a414f24a(min.x, max.y),
            br: max
        };
    }
    cancelRequestedRender() {
        if (this.nextRenderHandle) {
            $f268b97836dca6b6$var$cancelAnimFrame(this.nextRenderHandle);
            this.nextRenderHandle = 0;
        }
    }
    drawControls(_ctx) {
    // Static canvas has no controls
    }
    /**
   * Renders background, objects, overlay and controls.
   * @param {CanvasRenderingContext2D} ctx
   * @param {Array} objects to render
   */ renderCanvas(ctx, objects) {
        if (this.destroyed) return;
        const v = this.viewportTransform, path = this.clipPath;
        this.calcViewportBoundaries();
        this.clearContext(ctx);
        ctx.imageSmoothingEnabled = this.imageSmoothingEnabled;
        // @ts-expect-error node-canvas stuff
        ctx.patternQuality = 'best';
        this.fire('before:render', {
            ctx: ctx
        });
        this._renderBackground(ctx);
        ctx.save();
        //apply viewport transform once for all rendering process
        ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
        this._renderObjects(ctx, objects);
        ctx.restore();
        if (!this.controlsAboveOverlay && !this.skipControlsDrawing) this.drawControls(ctx);
        if (path) {
            path._set('canvas', this);
            // needed to setup a couple of variables
            // todo migrate to the newer one
            path.shouldCache();
            path._transformDone = true;
            path.renderCache({
                forClipping: true
            });
            this.drawClipPathOnCanvas(ctx, path);
        }
        this._renderOverlay(ctx);
        if (this.controlsAboveOverlay && !this.skipControlsDrawing) this.drawControls(ctx);
        this.fire('after:render', {
            ctx: ctx
        });
        if (this.__cleanupTask) {
            this.__cleanupTask();
            this.__cleanupTask = undefined;
        }
    }
    /**
   * Paint the cached clipPath on the lowerCanvasEl
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ drawClipPathOnCanvas(ctx, clipPath) {
        const v = this.viewportTransform;
        ctx.save();
        ctx.transform(...v);
        // DEBUG: uncomment this line, comment the following
        // ctx.globalAlpha = 0.4;
        ctx.globalCompositeOperation = 'destination-in';
        clipPath.transform(ctx);
        ctx.scale(1 / clipPath.zoomX, 1 / clipPath.zoomY);
        ctx.drawImage(clipPath._cacheCanvas, -clipPath.cacheTranslationX, -clipPath.cacheTranslationY);
        ctx.restore();
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {Array} objects to render
   */ _renderObjects(ctx, objects) {
        for(let i = 0, len = objects.length; i < len; ++i)objects[i] && objects[i].render(ctx);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {string} property 'background' or 'overlay'
   */ _renderBackgroundOrOverlay(ctx, property) {
        const fill = this["".concat(property, "Color")], object = this["".concat(property, "Image")], v = this.viewportTransform, needsVpt = this["".concat(property, "Vpt")];
        if (!fill && !object) return;
        const isAFiller = $f268b97836dca6b6$var$isFiller(fill);
        if (fill) {
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(0, 0);
            ctx.lineTo(this.width, 0);
            ctx.lineTo(this.width, this.height);
            ctx.lineTo(0, this.height);
            ctx.closePath();
            ctx.fillStyle = isAFiller ? fill.toLive(ctx /* this */ ) : fill;
            if (needsVpt) ctx.transform(...v);
            if (isAFiller) {
                ctx.transform(1, 0, 0, 1, fill.offsetX || 0, fill.offsetY || 0);
                const m = fill.gradientTransform || fill.patternTransform;
                m && ctx.transform(...m);
            }
            ctx.fill();
            ctx.restore();
        }
        if (object) {
            ctx.save();
            const { skipOffscreen: skipOffscreen } = this;
            // if the object doesn't move with the viewport,
            // the offscreen concept does not apply;
            this.skipOffscreen = needsVpt;
            if (needsVpt) ctx.transform(...v);
            object.render(ctx);
            this.skipOffscreen = skipOffscreen;
            ctx.restore();
        }
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderBackground(ctx) {
        this._renderBackgroundOrOverlay(ctx, 'background');
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderOverlay(ctx) {
        this._renderBackgroundOrOverlay(ctx, 'overlay');
    }
    /**
   * Returns coordinates of a center of canvas.
   * Returned value is an object with top and left properties
   * @return {Object} object with "top" and "left" number values
   * @deprecated migrate to `getCenterPoint`
   */ getCenter() {
        return {
            top: this.height / 2,
            left: this.width / 2
        };
    }
    /**
   * Returns coordinates of a center of canvas.
   * @return {Point}
   */ getCenterPoint() {
        return new $f268b97836dca6b6$export$baf26146a414f24a(this.width / 2, this.height / 2);
    }
    /**
   * Centers object horizontally in the canvas
   */ centerObjectH(object) {
        return this._centerObject(object, new $f268b97836dca6b6$export$baf26146a414f24a(this.getCenterPoint().x, object.getCenterPoint().y));
    }
    /**
   * Centers object vertically in the canvas
   * @param {FabricObject} object Object to center vertically
   */ centerObjectV(object) {
        return this._centerObject(object, new $f268b97836dca6b6$export$baf26146a414f24a(object.getCenterPoint().x, this.getCenterPoint().y));
    }
    /**
   * Centers object vertically and horizontally in the canvas
   * @param {FabricObject} object Object to center vertically and horizontally
   */ centerObject(object) {
        return this._centerObject(object, this.getCenterPoint());
    }
    /**
   * Centers object vertically and horizontally in the viewport
   * @param {FabricObject} object Object to center vertically and horizontally
   */ viewportCenterObject(object) {
        return this._centerObject(object, this.getVpCenter());
    }
    /**
   * Centers object horizontally in the viewport, object.top is unchanged
   * @param {FabricObject} object Object to center vertically and horizontally
   */ viewportCenterObjectH(object) {
        return this._centerObject(object, new $f268b97836dca6b6$export$baf26146a414f24a(this.getVpCenter().x, object.getCenterPoint().y));
    }
    /**
   * Centers object Vertically in the viewport, object.top is unchanged
   * @param {FabricObject} object Object to center vertically and horizontally
   */ viewportCenterObjectV(object) {
        return this._centerObject(object, new $f268b97836dca6b6$export$baf26146a414f24a(object.getCenterPoint().x, this.getVpCenter().y));
    }
    /**
   * Calculate the point in canvas that correspond to the center of actual viewport.
   * @return {Point} vpCenter, viewport center
   */ getVpCenter() {
        return $f268b97836dca6b6$var$transformPoint(this.getCenterPoint(), $f268b97836dca6b6$var$invertTransform(this.viewportTransform));
    }
    /**
   * @private
   * @param {FabricObject} object Object to center
   * @param {Point} center Center point
   */ _centerObject(object, center) {
        object.setXY(center, $f268b97836dca6b6$var$CENTER, $f268b97836dca6b6$var$CENTER);
        object.setCoords();
        this.renderOnAddRemove && this.requestRenderAll();
    }
    /**
   * Returns dataless JSON representation of canvas
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {String} json string
   */ toDatalessJSON(propertiesToInclude) {
        return this.toDatalessObject(propertiesToInclude);
    }
    /**
   * Returns object representation of canvas
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toObject(propertiesToInclude) {
        return this._toObjectMethod('toObject', propertiesToInclude);
    }
    /**
   * Returns Object representation of canvas
   * this alias is provided because if you call JSON.stringify on an instance,
   * the toJSON object will be invoked if it exists.
   * Having a toJSON method means you can do JSON.stringify(myCanvas)
   * @return {Object} JSON compatible object
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
   * @see {@link http://jsfiddle.net/fabricjs/pec86/|jsFiddle demo}
   * @example <caption>JSON without additional properties</caption>
   * var json = canvas.toJSON();
   * @example <caption>JSON with additional properties included</caption>
   * var json = canvas.toJSON(['lockMovementX', 'lockMovementY', 'lockRotation', 'lockScalingX', 'lockScalingY']);
   * @example <caption>JSON without default values</caption>
   * var json = canvas.toJSON();
   */ toJSON() {
        return this.toObject();
    }
    /**
   * Returns dataless object representation of canvas
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toDatalessObject(propertiesToInclude) {
        return this._toObjectMethod('toDatalessObject', propertiesToInclude);
    }
    /**
   * @private
   */ _toObjectMethod(methodName, propertiesToInclude) {
        const clipPath = this.clipPath;
        const clipPathData = clipPath && !clipPath.excludeFromExport ? this._toObject(clipPath, methodName, propertiesToInclude) : null;
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({
            version: $f268b97836dca6b6$export$83d89fbfd8236492
        }, $f268b97836dca6b6$var$pick(this, propertiesToInclude)), {}, {
            objects: this._objects.filter((object)=>!object.excludeFromExport).map((instance)=>this._toObject(instance, methodName, propertiesToInclude))
        }, this.__serializeBgOverlay(methodName, propertiesToInclude)), clipPathData ? {
            clipPath: clipPathData
        } : null);
    }
    /**
   * @private
   */ _toObject(instance, methodName, propertiesToInclude) {
        let originalValue;
        if (!this.includeDefaultValues) {
            originalValue = instance.includeDefaultValues;
            instance.includeDefaultValues = false;
        }
        const object = instance[methodName](propertiesToInclude);
        if (!this.includeDefaultValues) instance.includeDefaultValues = !!originalValue;
        return object;
    }
    /**
   * @private
   */ __serializeBgOverlay(methodName, propertiesToInclude) {
        const data = {}, bgImage = this.backgroundImage, overlayImage = this.overlayImage, bgColor = this.backgroundColor, overlayColor = this.overlayColor;
        if ($f268b97836dca6b6$var$isFiller(bgColor)) {
            if (!bgColor.excludeFromExport) data.background = bgColor.toObject(propertiesToInclude);
        } else if (bgColor) data.background = bgColor;
        if ($f268b97836dca6b6$var$isFiller(overlayColor)) {
            if (!overlayColor.excludeFromExport) data.overlay = overlayColor.toObject(propertiesToInclude);
        } else if (overlayColor) data.overlay = overlayColor;
        if (bgImage && !bgImage.excludeFromExport) data.backgroundImage = this._toObject(bgImage, methodName, propertiesToInclude);
        if (overlayImage && !overlayImage.excludeFromExport) data.overlayImage = this._toObject(overlayImage, methodName, propertiesToInclude);
        return data;
    }
    /* _TO_SVG_START_ */ /**
   * Returns SVG representation of canvas
   * @function
   * @param {Object} [options] Options object for SVG output
   * @param {Boolean} [options.suppressPreamble=false] If true xml tag is not included
   * @param {Object} [options.viewBox] SVG viewbox object
   * @param {Number} [options.viewBox.x] x-coordinate of viewbox
   * @param {Number} [options.viewBox.y] y-coordinate of viewbox
   * @param {Number} [options.viewBox.width] Width of viewbox
   * @param {Number} [options.viewBox.height] Height of viewbox
   * @param {String} [options.encoding=UTF-8] Encoding of SVG output
   * @param {String} [options.width] desired width of svg with or without units
   * @param {String} [options.height] desired height of svg with or without units
   * @param {Function} [reviver] Method for further parsing of svg elements, called after each fabric object converted into svg representation.
   * @return {String} SVG string
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#serialization}
   * @see {@link http://jsfiddle.net/fabricjs/jQ3ZZ/|jsFiddle demo}
   * @example <caption>Normal SVG output</caption>
   * var svg = canvas.toSVG();
   * @example <caption>SVG output without preamble (without &lt;?xml ../>)</caption>
   * var svg = canvas.toSVG({suppressPreamble: true});
   * @example <caption>SVG output with viewBox attribute</caption>
   * var svg = canvas.toSVG({
   *   viewBox: {
   *     x: 100,
   *     y: 100,
   *     width: 200,
   *     height: 300
   *   }
   * });
   * @example <caption>SVG output with different encoding (default: UTF-8)</caption>
   * var svg = canvas.toSVG({encoding: 'ISO-8859-1'});
   * @example <caption>Modify SVG output with reviver function</caption>
   * var svg = canvas.toSVG(null, function(svg) {
   *   return svg.replace('stroke-dasharray: ; stroke-linecap: butt; stroke-linejoin: miter; stroke-miterlimit: 10; ', '');
   * });
   */ toSVG() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let reviver = arguments.length > 1 ? arguments[1] : undefined;
        options.reviver = reviver;
        const markup = [];
        this._setSVGPreamble(markup, options);
        this._setSVGHeader(markup, options);
        if (this.clipPath) markup.push("<g clip-path=\"url(#".concat(this.clipPath.clipPathId, ")\" >\n"));
        this._setSVGBgOverlayColor(markup, 'background');
        this._setSVGBgOverlayImage(markup, 'backgroundImage', reviver);
        this._setSVGObjects(markup, reviver);
        if (this.clipPath) markup.push('</g>\n');
        this._setSVGBgOverlayColor(markup, 'overlay');
        this._setSVGBgOverlayImage(markup, 'overlayImage', reviver);
        markup.push('</svg>');
        return markup.join('');
    }
    /**
   * @private
   */ _setSVGPreamble(markup, options) {
        if (options.suppressPreamble) return;
        markup.push('<?xml version="1.0" encoding="', options.encoding || 'UTF-8', '" standalone="no" ?>\n', '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" ', '"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">\n');
    }
    /**
   * @private
   */ _setSVGHeader(markup, options) {
        const width = options.width || "".concat(this.width), height = options.height || "".concat(this.height), NUM_FRACTION_DIGITS = $f268b97836dca6b6$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS, optViewBox = options.viewBox;
        let viewBox;
        if (optViewBox) viewBox = "viewBox=\"".concat(optViewBox.x, " ").concat(optViewBox.y, " ").concat(optViewBox.width, " ").concat(optViewBox.height, "\" ");
        else if (this.svgViewportTransformation) {
            const vpt = this.viewportTransform;
            viewBox = "viewBox=\"".concat($f268b97836dca6b6$var$toFixed(-vpt[4] / vpt[0], NUM_FRACTION_DIGITS), " ").concat($f268b97836dca6b6$var$toFixed(-vpt[5] / vpt[3], NUM_FRACTION_DIGITS), " ").concat($f268b97836dca6b6$var$toFixed(this.width / vpt[0], NUM_FRACTION_DIGITS), " ").concat($f268b97836dca6b6$var$toFixed(this.height / vpt[3], NUM_FRACTION_DIGITS), "\" ");
        } else viewBox = "viewBox=\"0 0 ".concat(this.width, " ").concat(this.height, "\" ");
        markup.push('<svg ', 'xmlns="http://www.w3.org/2000/svg" ', 'xmlns:xlink="http://www.w3.org/1999/xlink" ', 'version="1.1" ', 'width="', width, '" ', 'height="', height, '" ', viewBox, 'xml:space="preserve">\n', '<desc>Created with Fabric.js ', $f268b97836dca6b6$export$83d89fbfd8236492, '</desc>\n', '<defs>\n', this.createSVGFontFacesMarkup(), this.createSVGRefElementsMarkup(), this.createSVGClipPathMarkup(options), '</defs>\n');
    }
    createSVGClipPathMarkup(options) {
        const clipPath = this.clipPath;
        if (clipPath) {
            clipPath.clipPathId = "CLIPPATH_".concat($f268b97836dca6b6$var$uid());
            return "<clipPath id=\"".concat(clipPath.clipPathId, "\" >\n").concat(clipPath.toClipPathSVG(options.reviver), "</clipPath>\n");
        }
        return '';
    }
    /**
   * Creates markup containing SVG referenced elements like patterns, gradients etc.
   * @return {String}
   */ createSVGRefElementsMarkup() {
        return [
            'background',
            'overlay'
        ].map((prop)=>{
            const fill = this["".concat(prop, "Color")];
            if ($f268b97836dca6b6$var$isFiller(fill)) {
                const shouldTransform = this["".concat(prop, "Vpt")], vpt = this.viewportTransform, object = {
                    // otherwise circular dependency
                    isType: ()=>false,
                    width: this.width / (shouldTransform ? vpt[0] : 1),
                    height: this.height / (shouldTransform ? vpt[3] : 1)
                };
                return fill.toSVG(object, {
                    additionalTransform: shouldTransform ? $f268b97836dca6b6$var$matrixToSVG(vpt) : ''
                });
            }
        }).join('');
    }
    /**
   * Creates markup containing SVG font faces,
   * font URLs for font faces must be collected by developers
   * and are not extracted from the DOM by fabricjs
   * @param {Array} objects Array of fabric objects
   * @return {String}
   */ createSVGFontFacesMarkup() {
        const objects = [], fontList = {}, fontPaths = $f268b97836dca6b6$export$e506a1d27d1eaa20.fontPaths;
        this._objects.forEach(function add(object) {
            objects.push(object);
            if ($f268b97836dca6b6$var$isCollection(object)) object._objects.forEach(add);
        });
        objects.forEach((obj)=>{
            if (!$f268b97836dca6b6$var$isTextObject(obj)) return;
            const { styles: styles, fontFamily: fontFamily } = obj;
            if (fontList[fontFamily] || !fontPaths[fontFamily]) return;
            fontList[fontFamily] = true;
            if (!styles) return;
            Object.values(styles).forEach((styleRow)=>{
                Object.values(styleRow).forEach((_ref)=>{
                    let { fontFamily: fontFamily = '' } = _ref;
                    if (!fontList[fontFamily] && fontPaths[fontFamily]) fontList[fontFamily] = true;
                });
            });
        });
        const fontListMarkup = Object.keys(fontList).map((fontFamily)=>"\t\t@font-face {\n\t\t\tfont-family: '".concat(fontFamily, "';\n\t\t\tsrc: url('").concat(fontPaths[fontFamily], "');\n\t\t}\n")).join('');
        if (fontListMarkup) return "\t<style type=\"text/css\"><![CDATA[\n".concat(fontListMarkup, "]]></style>\n");
        return '';
    }
    /**
   * @private
   */ _setSVGObjects(markup, reviver) {
        this.forEachObject((fabricObject)=>{
            if (fabricObject.excludeFromExport) return;
            this._setSVGObject(markup, fabricObject, reviver);
        });
    }
    /**
   * This is its own function because the Canvas ( non static ) requires extra code here
   * @private
   */ _setSVGObject(markup, instance, reviver) {
        markup.push(instance.toSVG(reviver));
    }
    /**
   * @private
   */ _setSVGBgOverlayImage(markup, property, reviver) {
        const bgOrOverlay = this[property];
        if (bgOrOverlay && !bgOrOverlay.excludeFromExport && bgOrOverlay.toSVG) markup.push(bgOrOverlay.toSVG(reviver));
    }
    /**
   * @TODO this seems to handle patterns but fail at gradients.
   * @private
   */ _setSVGBgOverlayColor(markup, property) {
        const filler = this["".concat(property, "Color")];
        if (!filler) return;
        if ($f268b97836dca6b6$var$isFiller(filler)) {
            const repeat = filler.repeat || '', finalWidth = this.width, finalHeight = this.height, shouldInvert = this["".concat(property, "Vpt")], additionalTransform = shouldInvert ? $f268b97836dca6b6$var$matrixToSVG($f268b97836dca6b6$var$invertTransform(this.viewportTransform)) : '';
            markup.push("<rect transform=\"".concat(additionalTransform, " translate(").concat(finalWidth / 2, ",").concat(finalHeight / 2, ")\" x=\"").concat(filler.offsetX - finalWidth / 2, "\" y=\"").concat(filler.offsetY - finalHeight / 2, "\" width=\"").concat((repeat === 'repeat-y' || repeat === 'no-repeat') && $f268b97836dca6b6$var$isPattern(filler) ? filler.source.width : finalWidth, "\" height=\"").concat((repeat === 'repeat-x' || repeat === 'no-repeat') && $f268b97836dca6b6$var$isPattern(filler) ? filler.source.height : finalHeight, "\" fill=\"url(#SVGID_").concat(filler.id, ")\"></rect>\n"));
        } else markup.push('<rect x="0" y="0" width="100%" height="100%" ', 'fill="', filler, '"', '></rect>\n');
    }
    /* _TO_SVG_END_ */ /**
   * Populates canvas with data from the specified JSON.
   * JSON format must conform to the one of {@link fabric.Canvas#toJSON}
   *
   * **IMPORTANT**: It is recommended to abort loading tasks before calling this method to prevent race conditions and unnecessary networking
   *
   * @param {String|Object} json JSON string or object
   * @param {Function} [reviver] Method for further parsing of JSON elements, called after each fabric object created.
   * @param {Object} [options] options
   * @param {AbortSignal} [options.signal] see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @return {Promise<Canvas | StaticCanvas>} instance
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-3#deserialization}
   * @see {@link http://jsfiddle.net/fabricjs/fmgXt/|jsFiddle demo}
   * @example <caption>loadFromJSON</caption>
   * canvas.loadFromJSON(json).then((canvas) => canvas.requestRenderAll());
   * @example <caption>loadFromJSON with reviver</caption>
   * canvas.loadFromJSON(json, function(o, object) {
   *   // `o` = json object
   *   // `object` = fabric.Object instance
   *   // ... do some stuff ...
   * }).then((canvas) => {
   *   ... canvas is restored, add your code.
   * });
   *
   */ loadFromJSON(json, reviver) {
        let { signal: signal } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        if (!json) return Promise.reject(new $f268b97836dca6b6$var$FabricError('`json` is undefined'));
        // parse json if it wasn't already
        const _ref2 = typeof json === 'string' ? JSON.parse(json) : json, { objects: objects = [] } = _ref2, serialized = $f268b97836dca6b6$var$_objectWithoutProperties(_ref2, $f268b97836dca6b6$var$_excluded$j);
        const { backgroundImage: backgroundImage, background: background, overlayImage: overlayImage, overlay: overlay, clipPath: clipPath } = serialized;
        const renderOnAddRemove = this.renderOnAddRemove;
        this.renderOnAddRemove = false;
        return Promise.all([
            $f268b97836dca6b6$var$enlivenObjects(objects, {
                reviver: reviver,
                signal: signal
            }),
            $f268b97836dca6b6$var$enlivenObjectEnlivables({
                backgroundImage: backgroundImage,
                backgroundColor: background,
                overlayImage: overlayImage,
                overlayColor: overlay,
                clipPath: clipPath
            }, {
                signal: signal
            })
        ]).then((_ref3)=>{
            let [enlived, enlivedMap] = _ref3;
            this.clear();
            this.add(...enlived);
            this.set(serialized);
            this.set(enlivedMap);
            this.renderOnAddRemove = renderOnAddRemove;
            return this;
        });
    }
    /**
   * Clones canvas instance
   * @param {string[]} [properties] Array of properties to include in the cloned canvas and children
   */ clone(properties) {
        const data = this.toObject(properties);
        const canvas = this.cloneWithoutData();
        return canvas.loadFromJSON(data);
    }
    /**
   * Clones canvas instance without cloning existing data.
   * This essentially copies canvas dimensions since loadFromJSON does not affect canvas size.
   */ cloneWithoutData() {
        const el = $f268b97836dca6b6$var$createCanvasElementFor(this);
        return new this.constructor(el);
    }
    /**
   * Exports canvas element to a dataurl image. Note that when multiplier is used, cropping is scaled appropriately
   * @param {Object} [options] Options object
   * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
   * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
   * @param {Number} [options.multiplier=1] Multiplier to scale by, to have consistent
   * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
   * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
   * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
   * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
   * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 2.0.0
   * @param {(object: fabric.Object) => boolean} [options.filter] Function to filter objects.
   * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
   * @see {@link https://jsfiddle.net/xsjua1rd/ demo}
   * @example <caption>Generate jpeg dataURL with lower quality</caption>
   * var dataURL = canvas.toDataURL({
   *   format: 'jpeg',
   *   quality: 0.8
   * });
   * @example <caption>Generate cropped png dataURL (clipping of canvas)</caption>
   * var dataURL = canvas.toDataURL({
   *   format: 'png',
   *   left: 100,
   *   top: 100,
   *   width: 200,
   *   height: 200
   * });
   * @example <caption>Generate double scaled png dataURL</caption>
   * var dataURL = canvas.toDataURL({
   *   format: 'png',
   *   multiplier: 2
   * });
   * @example <caption>Generate dataURL with objects that overlap a specified object</caption>
   * var myObject;
   * var dataURL = canvas.toDataURL({
   *   filter: (object) => object.isContainedWithinObject(myObject) || object.intersectsWithObject(myObject)
   * });
   */ toDataURL() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { format: format = 'png', quality: quality = 1, multiplier: multiplier = 1, enableRetinaScaling: enableRetinaScaling = false } = options;
        const finalMultiplier = multiplier * (enableRetinaScaling ? this.getRetinaScaling() : 1);
        return $f268b97836dca6b6$var$toDataURL(this.toCanvasElement(finalMultiplier, options), format, quality);
    }
    toBlob() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const { format: format = 'png', quality: quality = 1, multiplier: multiplier = 1, enableRetinaScaling: enableRetinaScaling = false } = options;
        const finalMultiplier = multiplier * (enableRetinaScaling ? this.getRetinaScaling() : 1);
        return $f268b97836dca6b6$var$toBlob(this.toCanvasElement(finalMultiplier, options), format, quality);
    }
    /**
   * Create a new HTMLCanvas element painted with the current canvas content.
   * No need to resize the actual one or repaint it.
   * Will transfer object ownership to a new canvas, paint it, and set everything back.
   * This is an intermediary step used to get to a dataUrl but also it is useful to
   * create quick image copies of a canvas without passing for the dataUrl string
   * @param {Number} [multiplier] a zoom factor.
   * @param {Object} [options] Cropping informations
   * @param {Number} [options.left] Cropping left offset.
   * @param {Number} [options.top] Cropping top offset.
   * @param {Number} [options.width] Cropping width.
   * @param {Number} [options.height] Cropping height.
   * @param {(object: fabric.Object) => boolean} [options.filter] Function to filter objects.
   */ toCanvasElement() {
        let multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        let { width: width, height: height, left: left, top: top, filter: filter } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const scaledWidth = (width || this.width) * multiplier, scaledHeight = (height || this.height) * multiplier, zoom = this.getZoom(), originalWidth = this.width, originalHeight = this.height, originalSkipControlsDrawing = this.skipControlsDrawing, newZoom = zoom * multiplier, vp = this.viewportTransform, translateX = (vp[4] - (left || 0)) * multiplier, translateY = (vp[5] - (top || 0)) * multiplier, newVp = [
            newZoom,
            0,
            0,
            newZoom,
            translateX,
            translateY
        ], originalRetina = this.enableRetinaScaling, canvasEl = $f268b97836dca6b6$var$createCanvasElementFor({
            width: scaledWidth,
            height: scaledHeight
        }), objectsToRender = filter ? this._objects.filter((obj)=>filter(obj)) : this._objects;
        this.enableRetinaScaling = false;
        this.viewportTransform = newVp;
        this.width = scaledWidth;
        this.height = scaledHeight;
        this.skipControlsDrawing = true;
        this.calcViewportBoundaries();
        this.renderCanvas(canvasEl.getContext('2d'), objectsToRender);
        this.viewportTransform = vp;
        this.width = originalWidth;
        this.height = originalHeight;
        this.calcViewportBoundaries();
        this.enableRetinaScaling = originalRetina;
        this.skipControlsDrawing = originalSkipControlsDrawing;
        return canvasEl;
    }
    /**
   * Waits until rendering has settled to destroy the canvas
   * @returns {Promise<boolean>} a promise resolving to `true` once the canvas has been destroyed or to `false` if the canvas has was already destroyed
   * @throws if aborted by a consequent call
   */ dispose() {
        !this.disposed && this.elements.cleanupDOM({
            width: this.width,
            height: this.height
        });
        $f268b97836dca6b6$export$dc18923894d9e56a.cancelByCanvas(this);
        this.disposed = true;
        return new Promise((resolve, reject)=>{
            const task = ()=>{
                this.destroy();
                resolve(true);
            };
            task.kill = reject;
            if (this.__cleanupTask) this.__cleanupTask.kill('aborted');
            if (this.destroyed) resolve(false);
            else if (this.nextRenderHandle) this.__cleanupTask = task;
            else task();
        });
    }
    /**
   * Clears the canvas element, disposes objects and frees resources.
   *
   * Invoked as part of the **async** operation of {@link dispose}.
   *
   * **CAUTION**:
   *
   * This method is **UNSAFE**.
   * You may encounter a race condition using it if there's a requested render.
   * Call this method only if you are sure rendering has settled.
   * Consider using {@link dispose} as it is **SAFE**
   *
   * @private
   */ destroy() {
        this.destroyed = true;
        this.cancelRequestedRender();
        this.forEachObject((object)=>object.dispose());
        this._objects = [];
        if (this.backgroundImage) this.backgroundImage.dispose();
        this.backgroundImage = undefined;
        if (this.overlayImage) this.overlayImage.dispose();
        this.overlayImage = undefined;
        this.elements.dispose();
    }
    /**
   * Returns a string representation of an instance
   * @return {String} string representation of an instance
   */ toString() {
        return "#<Canvas (".concat(this.complexity(), "): { objects: ").concat(this._objects.length, " }>");
    }
    constructor(el){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        Object.assign(this, this.constructor.getDefaults());
        this.set(options);
        this.initElements(el);
        this._setDimensionsImpl({
            width: this.width || this.elements.lower.el.width || 0,
            height: this.height || this.elements.lower.el.height || 0
        });
        this.skipControlsDrawing = false;
        this.viewportTransform = [
            ...this.viewportTransform
        ];
        this.calcViewportBoundaries();
    }
}
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$ad01921fb0b1386e, "ownDefaults", $f268b97836dca6b6$var$staticCanvasDefaults);
const $f268b97836dca6b6$var$touchEvents = [
    'touchstart',
    'touchmove',
    'touchend'
];
function $f268b97836dca6b6$var$getTouchInfo(event) {
    const touchProp = event.changedTouches;
    if (touchProp && touchProp[0]) return touchProp[0];
    return event;
}
const $f268b97836dca6b6$var$getPointer = (event)=>{
    const element = event.target, scroll = $f268b97836dca6b6$var$getScrollLeftTop(element), _evt = $f268b97836dca6b6$var$getTouchInfo(event);
    return new $f268b97836dca6b6$export$baf26146a414f24a(_evt.clientX + scroll.left, _evt.clientY + scroll.top);
};
const $f268b97836dca6b6$var$isTouchEvent = (event)=>$f268b97836dca6b6$var$touchEvents.includes(event.type) || event.pointerType === 'touch';
const $f268b97836dca6b6$var$stopEvent = (e)=>{
    e.preventDefault();
    e.stopPropagation();
};
/**
 * Calculates bounding box (left, top, width, height) from given `points`
 * @param {XY[]} points
 * @return {Object} Object with left, top, width, height properties
 */ const $f268b97836dca6b6$var$makeBoundingBoxFromPoints = (points)=>{
    let left = 0, top = 0, width = 0, height = 0;
    for(let i = 0, len = points.length; i < len; i++){
        const { x: x, y: y } = points[i];
        if (x > width || !i) width = x;
        if (x < left || !i) left = x;
        if (y > height || !i) height = y;
        if (y < top || !i) top = y;
    }
    return {
        left: left,
        top: top,
        width: width - left,
        height: height - top
    };
};
const $f268b97836dca6b6$var$_excluded$i = [
    "translateX",
    "translateY",
    "scaleX",
    "scaleY"
];
/**
 * given an object and a transform, apply the inverse transform to the object,
 * this is equivalent to remove from that object that transformation, so that
 * added in a space with the removed transform, the object will be the same as before.
 * Removing from an object a transform that scale by 2 is like scaling it by 1/2.
 * Removing from an object a transform that rotate by 30deg is like rotating by 30deg
 * in the opposite direction.
 * This util is used to add objects inside transformed groups or nested groups.
 * @param {FabricObject} object the object you want to transform
 * @param {TMat2D} transform the destination transform
 */ const $f268b97836dca6b6$var$removeTransformFromObject = (object, transform)=>{
    const inverted = $f268b97836dca6b6$var$invertTransform(transform), finalTransform = $f268b97836dca6b6$var$multiplyTransformMatrices(inverted, object.calcOwnMatrix());
    $f268b97836dca6b6$var$applyTransformToObject(object, finalTransform);
};
/**
 * given an object and a transform, apply the transform to the object.
 * this is equivalent to change the space where the object is drawn.
 * Adding to an object a transform that scale by 2 is like scaling it by 2.
 * This is used when removing an object from an active selection for example.
 * @param {FabricObject} object the object you want to transform
 * @param {Array} transform the destination transform
 */ const $f268b97836dca6b6$var$addTransformToObject = (object, transform)=>$f268b97836dca6b6$var$applyTransformToObject(object, $f268b97836dca6b6$var$multiplyTransformMatrices(transform, object.calcOwnMatrix()));
/**
 * discard an object transform state and apply the one from the matrix.
 * @param {FabricObject} object the object you want to transform
 * @param {Array} transform the destination transform
 */ const $f268b97836dca6b6$var$applyTransformToObject = (object, transform)=>{
    const _qrDecompose = $f268b97836dca6b6$var$qrDecompose(transform), { translateX: translateX, translateY: translateY, scaleX: scaleX, scaleY: scaleY } = _qrDecompose, otherOptions = $f268b97836dca6b6$var$_objectWithoutProperties(_qrDecompose, $f268b97836dca6b6$var$_excluded$i), center = new $f268b97836dca6b6$export$baf26146a414f24a(translateX, translateY);
    object.flipX = false;
    object.flipY = false;
    Object.assign(object, otherOptions);
    object.set({
        scaleX: scaleX,
        scaleY: scaleY
    });
    object.setPositionByOrigin(center, $f268b97836dca6b6$var$CENTER, $f268b97836dca6b6$var$CENTER);
};
/**
 * reset an object transform state to neutral. Top and left are not accounted for
 * @param  {FabricObject} target object to transform
 */ const $f268b97836dca6b6$var$resetObjectTransform = (target)=>{
    target.scaleX = 1;
    target.scaleY = 1;
    target.skewX = 0;
    target.skewY = 0;
    target.flipX = false;
    target.flipY = false;
    target.rotate(0);
};
/**
 * Extract Object transform values
 * @param  {FabricObject} target object to read from
 * @return {Object} Components of transform
 */ const $f268b97836dca6b6$var$saveObjectTransform = (target)=>({
        scaleX: target.scaleX,
        scaleY: target.scaleY,
        skewX: target.skewX,
        skewY: target.skewY,
        angle: target.angle,
        left: target.left,
        flipX: target.flipX,
        flipY: target.flipY,
        top: target.top
    });
/**
 * given a width and height, return the size of the bounding box
 * that can contains the box with width/height with applied transform.
 * Use to calculate the boxes around objects for controls.
 * @param {Number} width
 * @param {Number} height
 * @param {TMat2D} t
 * @returns {Point} size
 */ const $f268b97836dca6b6$var$sizeAfterTransform = (width, height, t)=>{
    const dimX = width / 2, dimY = height / 2, points = [
        new $f268b97836dca6b6$export$baf26146a414f24a(-dimX, -dimY),
        new $f268b97836dca6b6$export$baf26146a414f24a(dimX, -dimY),
        new $f268b97836dca6b6$export$baf26146a414f24a(-dimX, dimY),
        new $f268b97836dca6b6$export$baf26146a414f24a(dimX, dimY)
    ].map((p)=>p.transform(t)), bbox = $f268b97836dca6b6$var$makeBoundingBoxFromPoints(points);
    return new $f268b97836dca6b6$export$baf26146a414f24a(bbox.width, bbox.height);
};
/**
 * We are actually looking for the transformation from the destination plane to the source plane (change of basis matrix)\
 * The object will exist on the destination plane and we want it to seem unchanged by it so we invert the destination matrix (`to`) and then apply the source matrix (`from`)
 * @param [from]
 * @param [to]
 * @returns
 */ const $f268b97836dca6b6$var$calcPlaneChangeMatrix = function() {
    let from = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $f268b97836dca6b6$export$3c5a7f9475b116e0;
    let to = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f268b97836dca6b6$export$3c5a7f9475b116e0;
    return $f268b97836dca6b6$var$multiplyTransformMatrices($f268b97836dca6b6$var$invertTransform(to), from);
};
/**
 * Sends a point from the source coordinate plane to the destination coordinate plane.\
 * From the canvas/viewer's perspective the point remains unchanged.
 *
 * @example <caption>Send point from canvas plane to group plane</caption>
 * var obj = new Rect({ left: 20, top: 20, width: 60, height: 60, strokeWidth: 0 });
 * var group = new Group([obj], { strokeWidth: 0 });
 * var sentPoint1 = sendPointToPlane(new Point(50, 50), undefined, group.calcTransformMatrix());
 * var sentPoint2 = sendPointToPlane(new Point(50, 50), iMatrix, group.calcTransformMatrix());
 * console.log(sentPoint1, sentPoint2) //  both points print (0,0) which is the center of group
 *
 * @param {Point} point
 * @param {TMat2D} [from] plane matrix containing object. Passing `undefined` is equivalent to passing the identity matrix, which means `point` exists in the canvas coordinate plane.
 * @param {TMat2D} [to] destination plane matrix to contain object. Passing `undefined` means `point` should be sent to the canvas coordinate plane.
 * @returns {Point} transformed point
 */ const $f268b97836dca6b6$var$sendPointToPlane = function(point) {
    let from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f268b97836dca6b6$export$3c5a7f9475b116e0;
    let to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $f268b97836dca6b6$export$3c5a7f9475b116e0;
    return point.transform($f268b97836dca6b6$var$calcPlaneChangeMatrix(from, to));
};
/**
 * See {@link sendPointToPlane}
 */ const $f268b97836dca6b6$var$sendVectorToPlane = function(point) {
    let from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f268b97836dca6b6$export$3c5a7f9475b116e0;
    let to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $f268b97836dca6b6$export$3c5a7f9475b116e0;
    return point.transform($f268b97836dca6b6$var$calcPlaneChangeMatrix(from, to), true);
};
/**
 *
 * A util that abstracts applying transform to objects.\
 * Sends `object` to the destination coordinate plane by applying the relevant transformations.\
 * Changes the space/plane where `object` is drawn.\
 * From the canvas/viewer's perspective `object` remains unchanged.
 *
 * @example <caption>Move clip path from one object to another while preserving it's appearance as viewed by canvas/viewer</caption>
 * let obj, obj2;
 * let clipPath = new Circle({ radius: 50 });
 * obj.clipPath = clipPath;
 * // render
 * sendObjectToPlane(clipPath, obj.calcTransformMatrix(), obj2.calcTransformMatrix());
 * obj.clipPath = undefined;
 * obj2.clipPath = clipPath;
 * // render, clipPath now clips obj2 but seems unchanged from the eyes of the viewer
 *
 * @example <caption>Clip an object's clip path with an existing object</caption>
 * let obj, existingObj;
 * let clipPath = new Circle({ radius: 50 });
 * obj.clipPath = clipPath;
 * let transformTo = multiplyTransformMatrices(obj.calcTransformMatrix(), clipPath.calcTransformMatrix());
 * sendObjectToPlane(existingObj, existingObj.group?.calcTransformMatrix(), transformTo);
 * clipPath.clipPath = existingObj;
 *
 * @param {FabricObject} object
 * @param {Matrix} [from] plane matrix containing object. Passing `undefined` is equivalent to passing the identity matrix, which means `object` is a direct child of canvas.
 * @param {Matrix} [to] destination plane matrix to contain object. Passing `undefined` means `object` should be sent to the canvas coordinate plane.
 * @returns {Matrix} the transform matrix that was applied to `object`
 */ const $f268b97836dca6b6$var$sendObjectToPlane = (object, from, to)=>{
    const t = $f268b97836dca6b6$var$calcPlaneChangeMatrix(from, to);
    $f268b97836dca6b6$var$applyTransformToObject(object, $f268b97836dca6b6$var$multiplyTransformMatrices(t, object.calcOwnMatrix()));
    return t;
};
const $f268b97836dca6b6$var$fireEvent = (eventName, options)=>{
    var _target$canvas;
    const { transform: { target: target } } = options;
    (_target$canvas = target.canvas) === null || _target$canvas === void 0 || _target$canvas.fire("object:".concat(eventName), $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, options), {}, {
        target: target
    }));
    target.fire(eventName, options);
};
const $f268b97836dca6b6$var$originOffset = {
    left: -0.5,
    top: -0.5,
    center: 0,
    bottom: 0.5,
    right: 0.5
};
/**
 * Resolves origin value relative to center
 * @private
 * @param {TOriginX | TOriginY} originValue originX / originY
 * @returns number
 */ const $f268b97836dca6b6$var$resolveOrigin = (originValue)=>typeof originValue === 'string' ? $f268b97836dca6b6$var$originOffset[originValue] : originValue - 0.5;
const $f268b97836dca6b6$var$NOT_ALLOWED_CURSOR = 'not-allowed';
/**
 * @param {Boolean} alreadySelected true if target is already selected
 * @param {String} corner a string representing the corner ml, mr, tl ...
 * @param {Event} e Event object
 * @param {FabricObject} [target] inserted back to help overriding. Unused
 */ const $f268b97836dca6b6$var$getActionFromCorner = (alreadySelected, corner, e, target)=>{
    if (!corner || !alreadySelected) return 'drag';
    const control = target.controls[corner];
    return control.getActionName(e, control, target);
};
/**
 * Checks if transform is centered
 * @param {Object} transform transform data
 * @return {Boolean} true if transform is centered
 */ function $f268b97836dca6b6$var$isTransformCentered(transform) {
    return $f268b97836dca6b6$var$resolveOrigin(transform.originX) === $f268b97836dca6b6$var$resolveOrigin($f268b97836dca6b6$var$CENTER) && $f268b97836dca6b6$var$resolveOrigin(transform.originY) === $f268b97836dca6b6$var$resolveOrigin($f268b97836dca6b6$var$CENTER);
}
function $f268b97836dca6b6$var$invertOrigin(origin) {
    return -$f268b97836dca6b6$var$resolveOrigin(origin) + 0.5;
}
const $f268b97836dca6b6$var$isLocked = (target, lockingKey)=>target[lockingKey];
const $f268b97836dca6b6$var$commonEventInfo = (eventData, transform, x, y)=>{
    return {
        e: eventData,
        transform: transform,
        pointer: new $f268b97836dca6b6$export$baf26146a414f24a(x, y)
    };
};
/**
 * Combine control position and object angle to find the control direction compared
 * to the object center.
 * @param {FabricObject} fabricObject the fabric object for which we are rendering controls
 * @param {Control} control the control class
 * @return {Number} 0 - 7 a quadrant number
 */ function $f268b97836dca6b6$var$findCornerQuadrant(fabricObject, control) {
    //  angle is relative to canvas plane
    const angle = fabricObject.getTotalAngle(), cornerAngle = angle + $f268b97836dca6b6$var$radiansToDegrees(Math.atan2(control.y, control.x)) + 360;
    return Math.round(cornerAngle % 360 / 45);
}
/**
 * @returns the normalized point (rotated relative to center) in local coordinates
 */ function $f268b97836dca6b6$var$normalizePoint(target, point, originX, originY) {
    const center = target.getRelativeCenterPoint(), p = typeof originX !== 'undefined' && typeof originY !== 'undefined' ? target.translateToGivenOrigin(center, $f268b97836dca6b6$var$CENTER, $f268b97836dca6b6$var$CENTER, originX, originY) : new $f268b97836dca6b6$export$baf26146a414f24a(target.left, target.top), p2 = target.angle ? point.rotate(-$f268b97836dca6b6$var$degreesToRadians(target.angle), center) : point;
    return p2.subtract(p);
}
/**
 * Transforms a point to the offset from the given origin
 * @param {Object} transform
 * @param {String} originX
 * @param {String} originY
 * @param {number} x
 * @param {number} y
 * @return {Fabric.Point} the normalized point
 */ function $f268b97836dca6b6$var$getLocalPoint(_ref, originX, originY, x, y) {
    var _target$canvas;
    let { target: target, corner: corner } = _ref;
    const control = target.controls[corner], zoom = ((_target$canvas = target.canvas) === null || _target$canvas === void 0 ? void 0 : _target$canvas.getZoom()) || 1, padding = target.padding / zoom, localPoint = $f268b97836dca6b6$var$normalizePoint(target, new $f268b97836dca6b6$export$baf26146a414f24a(x, y), originX, originY);
    if (localPoint.x >= padding) localPoint.x -= padding;
    if (localPoint.x <= -padding) localPoint.x += padding;
    if (localPoint.y >= padding) localPoint.y -= padding;
    if (localPoint.y <= padding) localPoint.y += padding;
    localPoint.x -= control.offsetX;
    localPoint.y -= control.offsetY;
    return localPoint;
}
/**
 * Action handler
 * @private
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if the translation occurred
 */ const $f268b97836dca6b6$var$dragHandler = (eventData, transform, x, y)=>{
    const { target: target, offsetX: offsetX, offsetY: offsetY } = transform, newLeft = x - offsetX, newTop = y - offsetY, moveX = !$f268b97836dca6b6$var$isLocked(target, 'lockMovementX') && target.left !== newLeft, moveY = !$f268b97836dca6b6$var$isLocked(target, 'lockMovementY') && target.top !== newTop;
    moveX && target.set($f268b97836dca6b6$var$LEFT, newLeft);
    moveY && target.set($f268b97836dca6b6$var$TOP, newTop);
    if (moveX || moveY) $f268b97836dca6b6$var$fireEvent($f268b97836dca6b6$var$MOVING, $f268b97836dca6b6$var$commonEventInfo(eventData, transform, x, y));
    return moveX || moveY;
};
const $f268b97836dca6b6$var$normalizeWs = (value)=>value.replace(/\s+/g, ' ');
/**
 * Map of the 148 color names with HEX code
 * @see: https://www.w3.org/TR/css3-color/#svg-color
 */ const $f268b97836dca6b6$var$ColorNameMap = {
    aliceblue: '#F0F8FF',
    antiquewhite: '#FAEBD7',
    aqua: '#0FF',
    aquamarine: '#7FFFD4',
    azure: '#F0FFFF',
    beige: '#F5F5DC',
    bisque: '#FFE4C4',
    black: '#000',
    blanchedalmond: '#FFEBCD',
    blue: '#00F',
    blueviolet: '#8A2BE2',
    brown: '#A52A2A',
    burlywood: '#DEB887',
    cadetblue: '#5F9EA0',
    chartreuse: '#7FFF00',
    chocolate: '#D2691E',
    coral: '#FF7F50',
    cornflowerblue: '#6495ED',
    cornsilk: '#FFF8DC',
    crimson: '#DC143C',
    cyan: '#0FF',
    darkblue: '#00008B',
    darkcyan: '#008B8B',
    darkgoldenrod: '#B8860B',
    darkgray: '#A9A9A9',
    darkgrey: '#A9A9A9',
    darkgreen: '#006400',
    darkkhaki: '#BDB76B',
    darkmagenta: '#8B008B',
    darkolivegreen: '#556B2F',
    darkorange: '#FF8C00',
    darkorchid: '#9932CC',
    darkred: '#8B0000',
    darksalmon: '#E9967A',
    darkseagreen: '#8FBC8F',
    darkslateblue: '#483D8B',
    darkslategray: '#2F4F4F',
    darkslategrey: '#2F4F4F',
    darkturquoise: '#00CED1',
    darkviolet: '#9400D3',
    deeppink: '#FF1493',
    deepskyblue: '#00BFFF',
    dimgray: '#696969',
    dimgrey: '#696969',
    dodgerblue: '#1E90FF',
    firebrick: '#B22222',
    floralwhite: '#FFFAF0',
    forestgreen: '#228B22',
    fuchsia: '#F0F',
    gainsboro: '#DCDCDC',
    ghostwhite: '#F8F8FF',
    gold: '#FFD700',
    goldenrod: '#DAA520',
    gray: '#808080',
    grey: '#808080',
    green: '#008000',
    greenyellow: '#ADFF2F',
    honeydew: '#F0FFF0',
    hotpink: '#FF69B4',
    indianred: '#CD5C5C',
    indigo: '#4B0082',
    ivory: '#FFFFF0',
    khaki: '#F0E68C',
    lavender: '#E6E6FA',
    lavenderblush: '#FFF0F5',
    lawngreen: '#7CFC00',
    lemonchiffon: '#FFFACD',
    lightblue: '#ADD8E6',
    lightcoral: '#F08080',
    lightcyan: '#E0FFFF',
    lightgoldenrodyellow: '#FAFAD2',
    lightgray: '#D3D3D3',
    lightgrey: '#D3D3D3',
    lightgreen: '#90EE90',
    lightpink: '#FFB6C1',
    lightsalmon: '#FFA07A',
    lightseagreen: '#20B2AA',
    lightskyblue: '#87CEFA',
    lightslategray: '#789',
    lightslategrey: '#789',
    lightsteelblue: '#B0C4DE',
    lightyellow: '#FFFFE0',
    lime: '#0F0',
    limegreen: '#32CD32',
    linen: '#FAF0E6',
    magenta: '#F0F',
    maroon: '#800000',
    mediumaquamarine: '#66CDAA',
    mediumblue: '#0000CD',
    mediumorchid: '#BA55D3',
    mediumpurple: '#9370DB',
    mediumseagreen: '#3CB371',
    mediumslateblue: '#7B68EE',
    mediumspringgreen: '#00FA9A',
    mediumturquoise: '#48D1CC',
    mediumvioletred: '#C71585',
    midnightblue: '#191970',
    mintcream: '#F5FFFA',
    mistyrose: '#FFE4E1',
    moccasin: '#FFE4B5',
    navajowhite: '#FFDEAD',
    navy: '#000080',
    oldlace: '#FDF5E6',
    olive: '#808000',
    olivedrab: '#6B8E23',
    orange: '#FFA500',
    orangered: '#FF4500',
    orchid: '#DA70D6',
    palegoldenrod: '#EEE8AA',
    palegreen: '#98FB98',
    paleturquoise: '#AFEEEE',
    palevioletred: '#DB7093',
    papayawhip: '#FFEFD5',
    peachpuff: '#FFDAB9',
    peru: '#CD853F',
    pink: '#FFC0CB',
    plum: '#DDA0DD',
    powderblue: '#B0E0E6',
    purple: '#800080',
    rebeccapurple: '#639',
    red: '#F00',
    rosybrown: '#BC8F8F',
    royalblue: '#4169E1',
    saddlebrown: '#8B4513',
    salmon: '#FA8072',
    sandybrown: '#F4A460',
    seagreen: '#2E8B57',
    seashell: '#FFF5EE',
    sienna: '#A0522D',
    silver: '#C0C0C0',
    skyblue: '#87CEEB',
    slateblue: '#6A5ACD',
    slategray: '#708090',
    slategrey: '#708090',
    snow: '#FFFAFA',
    springgreen: '#00FF7F',
    steelblue: '#4682B4',
    tan: '#D2B48C',
    teal: '#008080',
    thistle: '#D8BFD8',
    tomato: '#FF6347',
    turquoise: '#40E0D0',
    violet: '#EE82EE',
    wheat: '#F5DEB3',
    white: '#FFF',
    whitesmoke: '#F5F5F5',
    yellow: '#FF0',
    yellowgreen: '#9ACD32'
};
/**
 * Regex matching color in RGB or RGBA formats (ex: `rgb(0, 0, 0)`, `rgba(255, 100, 10, 0.5)`, `rgba( 255 , 100 , 10 , 0.5 )`, `rgb(1,1,1)`, `rgba(100%, 60%, 10%, 0.5)`)
 * Also matching rgba(r g b / a) as per new specs
 * https://developer.mozilla.org/en-US/docs/Web/CSS/color_value/rgb
 *
 * In order to avoid performance issues, you have to clean the input string for this regex from multiple spaces before.
 * ex: colorString.replace(/\s+/g, ' ');
 *
 * Formal syntax at the time of writing:
 * <rgb()> =
 *  rgb( [ <percentage> | none ]{3} [ / [ <alpha-value> | none ] ]? )  |
 *  rgb( [ <number> | none ]{3} [ / [ <alpha-value> | none ] ]? )
 * <alpha-value> = <number> | <percentage>
 *
 * For learners this is how you can read this regex
 * Regular expression for matching an rgba or rgb CSS color value
 *
 * /^          # Beginning of the string
 * rgba?       # "rgb" or "rgba"
 * \(\s?       # Opening parenthesis and zero or one whitespace character
 * (\d{0,3}    # 0 to three digits R channel
 *  (?:\.\d+)? # Optional decimal with one or more digits
 * )           # End of capturing group for the first color component
 * %?          # Optional percent sign after the first color component
 * \s?         # Zero or one whitespace character
 * [\s|,]      # Separator between color components can be a space or comma
 * \s?         # Zero or one whitespace character
 * (\d{0,3}    # 0 to three digits G channel
 *  (?:\.\d+)? # Optional decimal with one or more digits
 * )           # End of capturing group for the second color component
 * %?          # Optional percent sign after the second color component
 * \s?         # Zero or one whitespace character
 * [\s|,]      # Separator between color components can be a space or comma
 * \s?         # Zero or one whitespace character
 * (\d{0,3}    # 0 to three digits B channel
 *  (?:\.\d+)? # Optional decimal with one or more digits
 * )           # End of capturing group for the third color component
 * %?          # Optional percent sign after the third color component
 * \s?         # Zero or one whitespace character
 * (?:         # Beginning of non-capturing group for alpha value
 *  \s?        # Zero or one whitespace character
 *  [,/]       # Comma or slash separator for alpha value
 *  \s?        # Zero or one whitespace character
 *  (\d{0,3}   # Zero to three digits
 *    (?:\.\d+)? # Optional decimal with one or more digits
 *  )          # End of capturing group for alpha value
 *  %?         # Optional percent sign after alpha value
 *  \s?        # Zero or one whitespace character
 * )?          # End of non-capturing group for alpha value (optional)
 * \)          # Closing parenthesis
 * $           # End of the string
 *
 * The alpha channel can be in the format 0.4 .7 or 1 or 73%
 *
 * WARNING this regex doesn't fail on off spec colors. it matches everything that could be a color.
 * So the spec does not allow for `rgba(30 , 45%  35, 49%)` but this will work anyways for us
 */ const $f268b97836dca6b6$var$reRGBa = ()=>/^rgba?\(\s?(\d{0,3}(?:\.\d+)?%?)\s?[\s|,]\s?(\d{0,3}(?:\.\d+)?%?)\s?[\s|,]\s?(\d{0,3}(?:\.\d+)?%?)\s?(?:\s?[,/]\s?(\d{0,3}(?:\.\d+)?%?)\s?)?\)$/i;
/**
 * Regex matching color in HSL or HSLA formats (ex: hsl(0deg 0%, 0%), hsla(160, 100, 10, 0.5), hsla( 180 , 100 , 10 , 0.5 ), hsl(1,1,1))
 * Also matching hsla(h s l / a) as per new specs
 * https://developer.mozilla.org/en-US/docs/Web/CSS/color_value/hsl
 * In order to avoid performance issues, you have to clean the input string for this regex from multiple spaces before.
 * ex: colorString.replace(/\s+/g, ' ');
 * Formal syntax at the time of writing:
 * <hsl()> =
 *   hsl( [ <hue> | none ] [ <percentage> | none ] [ <percentage> | none ] [ / [ <alpha-value> | none ] ]? )
 *
 * <hue> =
 *   <number>  |
 *   <angle>
 *
 * <alpha-value> =
 *   <number>      |
 *   <percentage>
 *
 * For learners this is how you can read this regex
 * Regular expression for matching an hsla or hsl CSS color value
 *
 * /^hsla?\(         // Matches the beginning of the string and the opening parenthesis of "hsl" or "hsla"
 * \s?               // Matches any whitespace character (space, tab, etc.) zero or one time
 * (\d{0,3}          // Hue: 0 to three digits - start capture in a group
 * (?:\.\d+)?        // Hue: Optional (non capture group) decimal with one or more digits.
 * (?:deg|turn|rad)? // Hue: Optionally include suffix deg or turn or rad
 * )                 // Hue: End capture group
 * \s?               // Matches any whitespace character zero or one time
 * [\s|,]            // Matches a space, tab or comma
 * \s?               // Matches any whitespace character zero or one time
 * (\d{0,3}          // Saturation: 0 to three digits - start capture in a group
 * (?:\.\d+)?        // Saturation: Optional decimal with one or more digits in a non-capturing group
 * %?)               // Saturation: match optional % character and end capture group
 * \s?               // Matches any whitespace character zero or one time
 * [\s|,]            // Matches a space, tab or comma
 * \s?               // Matches any whitespace character zero or one time
 * (\d{0,3}          // Lightness: 0 to three digits - start capture in a group
 * (?:\.\d+)?        // Lightness: Optional decimal with one or more digits in a non-capturing group
 * %?)                // Lightness: match % character and end capture group
 * \s?               // Matches any whitespace character zero or one time
 * (?:               // Alpha: Begins a non-capturing group for the alpha value
 *   \s?             // Matches any whitespace character zero or one time
 *   [,/]            // Matches a comma or forward slash
 *   \s?             // Matches any whitespace character zero or one time
 *   (\d*(?:\.\d+)?%?) // Matches zero or more digits, optionally followed by a decimal point and one or more digits, followed by an optional percentage sign and captures it in a group
 *   \s?             // Matches any whitespace character zero or one time
 * )?                // Makes the alpha value group optional
 * \)                // Matches the closing parenthesis
 * $/i               // Matches the end of the string and sets the regular expression to case-insensitive mode
 *
 * WARNING this regex doesn't fail on off spec colors. It matches everything that could be a color.
 * So the spec does not allow `hsl(30 , 45%  35, 49%)` but this will work anyways for us.
 */ const $f268b97836dca6b6$var$reHSLa = ()=>/^hsla?\(\s?([+-]?\d{0,3}(?:\.\d+)?(?:deg|turn|rad)?)\s?[\s|,]\s?(\d{0,3}(?:\.\d+)?%?)\s?[\s|,]\s?(\d{0,3}(?:\.\d+)?%?)\s?(?:\s?[,/]\s?(\d*(?:\.\d+)?%?)\s?)?\)$/i;
/**
 * Regex matching color in HEX format (ex: #FF5544CC, #FF5555, 010155, aff)
 */ const $f268b97836dca6b6$var$reHex = ()=>/^#?(([0-9a-f]){3,4}|([0-9a-f]{2}){3,4})$/i;
/**
 * @param {Number} p
 * @param {Number} q
 * @param {Number} t
 * @return {Number}
 */ const $f268b97836dca6b6$var$hue2rgb = (p, q, t)=>{
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
};
/**
 * Adapted from {@link https://gist.github.com/mjackson/5311256 https://gist.github.com/mjackson}
 * @param {Number} r Red color value
 * @param {Number} g Green color value
 * @param {Number} b Blue color value
 * @param {Number} a Alpha color value pass through
 * @return {TRGBColorSource} Hsl color
 */ const $f268b97836dca6b6$var$rgb2Hsl = (r, g, b, a)=>{
    r /= 255;
    g /= 255;
    b /= 255;
    const maxValue = Math.max(r, g, b), minValue = Math.min(r, g, b);
    let h, s;
    const l = (maxValue + minValue) / 2;
    if (maxValue === minValue) h = s = 0; // achromatic
    else {
        const d = maxValue - minValue;
        s = l > 0.5 ? d / (2 - maxValue - minValue) : d / (maxValue + minValue);
        switch(maxValue){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return [
        Math.round(h * 360),
        Math.round(s * 100),
        Math.round(l * 100),
        a
    ];
};
const $f268b97836dca6b6$var$fromAlphaToFloat = function() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '1';
    return parseFloat(value) / (value.endsWith('%') ? 100 : 1);
};
/**
 * Convert a value in the inclusive range [0, 255] to hex
 */ const $f268b97836dca6b6$var$hexify = (value)=>Math.min(Math.round(value), 255).toString(16).toUpperCase().padStart(2, '0');
/**
 * Calculate the grey average value for rgb and pass through alpha
 */ const $f268b97836dca6b6$var$greyAverage = (_ref)=>{
    let [r, g, b, a = 1] = _ref;
    const avg = Math.round(r * 0.3 + g * 0.59 + b * 0.11);
    return [
        avg,
        avg,
        avg,
        a
    ];
};
/**
 * @class Color common color operations
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-2/#colors colors}
 */ class $f268b97836dca6b6$export$892596cec99bc70e {
    /**
   * @private
   * @param {string} [color] Color value to parse
   * @returns {TRGBAColorSource}
   */ _tryParsingColor(color) {
        color = color.toLowerCase();
        if (color in $f268b97836dca6b6$var$ColorNameMap) color = $f268b97836dca6b6$var$ColorNameMap[color];
        return color === 'transparent' ? [
            255,
            255,
            255,
            0
        ] : $f268b97836dca6b6$export$892596cec99bc70e.sourceFromHex(color) || $f268b97836dca6b6$export$892596cec99bc70e.sourceFromRgb(color) || $f268b97836dca6b6$export$892596cec99bc70e.sourceFromHsl(color) || (// color is not recognized
        // we default to black as canvas does
        // eslint-disable-next-line no-constant-binary-expression
        this.isUnrecognised = true, [
            0,
            0,
            0,
            1
        ]);
    }
    /**
   * Returns source of this color (where source is an array representation; ex: [200, 200, 100, 1])
   * @return {TRGBAColorSource}
   */ getSource() {
        return this._source;
    }
    /**
   * Sets source of this color (where source is an array representation; ex: [200, 200, 100, 1])
   * @param {TRGBAColorSource} source
   */ setSource(source) {
        this._source = source;
    }
    /**
   * Returns color representation in RGB format
   * @return {String} ex: rgb(0-255,0-255,0-255)
   */ toRgb() {
        const [r, g, b] = this.getSource();
        return "rgb(".concat(r, ",").concat(g, ",").concat(b, ")");
    }
    /**
   * Returns color representation in RGBA format
   * @return {String} ex: rgba(0-255,0-255,0-255,0-1)
   */ toRgba() {
        return "rgba(".concat(this.getSource().join(','), ")");
    }
    /**
   * Returns color representation in HSL format
   * @return {String} ex: hsl(0-360,0%-100%,0%-100%)
   */ toHsl() {
        const [h, s, l] = $f268b97836dca6b6$var$rgb2Hsl(...this.getSource());
        return "hsl(".concat(h, ",").concat(s, "%,").concat(l, "%)");
    }
    /**
   * Returns color representation in HSLA format
   * @return {String} ex: hsla(0-360,0%-100%,0%-100%,0-1)
   */ toHsla() {
        const [h, s, l, a] = $f268b97836dca6b6$var$rgb2Hsl(...this.getSource());
        return "hsla(".concat(h, ",").concat(s, "%,").concat(l, "%,").concat(a, ")");
    }
    /**
   * Returns color representation in HEX format
   * @return {String} ex: FF5555
   */ toHex() {
        const fullHex = this.toHexa();
        return fullHex.slice(0, 6);
    }
    /**
   * Returns color representation in HEXA format
   * @return {String} ex: FF5555CC
   */ toHexa() {
        const [r, g, b, a] = this.getSource();
        return "".concat($f268b97836dca6b6$var$hexify(r)).concat($f268b97836dca6b6$var$hexify(g)).concat($f268b97836dca6b6$var$hexify(b)).concat($f268b97836dca6b6$var$hexify(Math.round(a * 255)));
    }
    /**
   * Gets value of alpha channel for this color
   * @return {Number} 0-1
   */ getAlpha() {
        return this.getSource()[3];
    }
    /**
   * Sets value of alpha channel for this color
   * @param {Number} alpha Alpha value 0-1
   * @return {Color} thisArg
   */ setAlpha(alpha) {
        this._source[3] = alpha;
        return this;
    }
    /**
   * Transforms color to its grayscale representation
   * @return {Color} thisArg
   */ toGrayscale() {
        this.setSource($f268b97836dca6b6$var$greyAverage(this.getSource()));
        return this;
    }
    /**
   * Transforms color to its black and white representation
   * @param {Number} threshold
   * @return {Color} thisArg
   */ toBlackWhite(threshold) {
        const [average, , , a] = $f268b97836dca6b6$var$greyAverage(this.getSource()), bOrW = average < (threshold || 127) ? 0 : 255;
        this.setSource([
            bOrW,
            bOrW,
            bOrW,
            a
        ]);
        return this;
    }
    /**
   * Overlays color with another color
   * @param {String|Color} otherColor
   * @return {Color} thisArg
   */ overlayWith(otherColor) {
        if (!(otherColor instanceof $f268b97836dca6b6$export$892596cec99bc70e)) otherColor = new $f268b97836dca6b6$export$892596cec99bc70e(otherColor);
        const source = this.getSource(), otherAlpha = 0.5, otherSource = otherColor.getSource(), [R, G, B] = source.map((value, index)=>Math.round(value * (1 - otherAlpha) + otherSource[index] * otherAlpha));
        this.setSource([
            R,
            G,
            B,
            source[3]
        ]);
        return this;
    }
    /**
   * Returns new color object, when given a color in RGB format
   * @memberOf Color
   * @param {String} color Color value ex: rgb(0-255,0-255,0-255)
   * @return {Color}
   */ static fromRgb(color) {
        return $f268b97836dca6b6$export$892596cec99bc70e.fromRgba(color);
    }
    /**
   * Returns new color object, when given a color in RGBA format
   * @static
   * @function
   * @memberOf Color
   * @param {String} color
   * @return {Color}
   */ static fromRgba(color) {
        return new $f268b97836dca6b6$export$892596cec99bc70e($f268b97836dca6b6$export$892596cec99bc70e.sourceFromRgb(color));
    }
    /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in RGB or RGBA format
   * @memberOf Color
   * @param {String} color Color value ex: rgb(0-255,0-255,0-255), rgb(0%-100%,0%-100%,0%-100%)
   * @return {TRGBAColorSource | undefined} source
   */ static sourceFromRgb(color) {
        const match = $f268b97836dca6b6$var$normalizeWs(color).match($f268b97836dca6b6$var$reRGBa());
        if (match) {
            const [r, g, b] = match.slice(1, 4).map((value)=>{
                const parsedValue = parseFloat(value);
                return value.endsWith('%') ? Math.round(parsedValue * 2.55) : parsedValue;
            });
            return [
                r,
                g,
                b,
                $f268b97836dca6b6$var$fromAlphaToFloat(match[4])
            ];
        }
    }
    /**
   * Returns new color object, when given a color in HSL format
   * @param {String} color Color value ex: hsl(0-260,0%-100%,0%-100%)
   * @memberOf Color
   * @return {Color}
   */ static fromHsl(color) {
        return $f268b97836dca6b6$export$892596cec99bc70e.fromHsla(color);
    }
    /**
   * Returns new color object, when given a color in HSLA format
   * @static
   * @function
   * @memberOf Color
   * @param {String} color
   * @return {Color}
   */ static fromHsla(color) {
        return new $f268b97836dca6b6$export$892596cec99bc70e($f268b97836dca6b6$export$892596cec99bc70e.sourceFromHsl(color));
    }
    /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HSL or HSLA format.
   * Adapted from <a href="https://rawgithub.com/mjijackson/mjijackson.github.com/master/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript.html">https://github.com/mjijackson</a>
   * @memberOf Color
   * @param {String} color Color value ex: hsl(0-360,0%-100%,0%-100%) or hsla(0-360,0%-100%,0%-100%, 0-1)
   * @return {TRGBAColorSource | undefined} source
   * @see http://http://www.w3.org/TR/css3-color/#hsl-color
   */ static sourceFromHsl(color) {
        const match = $f268b97836dca6b6$var$normalizeWs(color).match($f268b97836dca6b6$var$reHSLa());
        if (!match) return;
        const match1degrees = $f268b97836dca6b6$export$892596cec99bc70e.parseAngletoDegrees(match[1]);
        const h = (match1degrees % 360 + 360) % 360 / 360, s = parseFloat(match[2]) / 100, l = parseFloat(match[3]) / 100;
        let r, g, b;
        if (s === 0) r = g = b = l;
        else {
            const q = l <= 0.5 ? l * (s + 1) : l + s - l * s, p = l * 2 - q;
            r = $f268b97836dca6b6$var$hue2rgb(p, q, h + 1 / 3);
            g = $f268b97836dca6b6$var$hue2rgb(p, q, h);
            b = $f268b97836dca6b6$var$hue2rgb(p, q, h - 1 / 3);
        }
        return [
            Math.round(r * 255),
            Math.round(g * 255),
            Math.round(b * 255),
            $f268b97836dca6b6$var$fromAlphaToFloat(match[4])
        ];
    }
    /**
   * Returns new color object, when given a color in HEX format
   * @static
   * @memberOf Color
   * @param {String} color Color value ex: FF5555
   * @return {Color}
   */ static fromHex(color) {
        return new $f268b97836dca6b6$export$892596cec99bc70e($f268b97836dca6b6$export$892596cec99bc70e.sourceFromHex(color));
    }
    /**
   * Returns array representation (ex: [100, 100, 200, 1]) of a color that's in HEX format
   * @static
   * @memberOf Color
   * @param {String} color ex: FF5555 or FF5544CC (RGBa)
   * @return {TRGBAColorSource | undefined} source
   */ static sourceFromHex(color) {
        if (color.match($f268b97836dca6b6$var$reHex())) {
            const value = color.slice(color.indexOf('#') + 1), isShortNotation = value.length <= 4;
            let expandedValue;
            if (isShortNotation) expandedValue = value.split('').map((hex)=>hex + hex);
            else expandedValue = value.match(/.{2}/g);
            const [r, g, b, a = 255] = expandedValue.map((hexCouple)=>parseInt(hexCouple, 16));
            return [
                r,
                g,
                b,
                a / 255
            ];
        }
    }
    /**
   * Converts a string that could be any angle notation (50deg, 0.5turn, 2rad)
   * into degrees without the 'deg' suffix
   * @static
   * @memberOf Color
   * @param {String} value ex: 0deg, 0.5turn, 2rad
   * @return {Number} number in degrees or NaN if inputs are invalid
   */ static parseAngletoDegrees(value) {
        const lowercase = value.toLowerCase();
        const numeric = parseFloat(lowercase);
        if (lowercase.includes('rad')) return $f268b97836dca6b6$var$radiansToDegrees(numeric);
        if (lowercase.includes('turn')) return numeric * 360;
        // Value is probably just a number already in degrees eg '50'
        return numeric;
    }
    /**
   *
   * @param {string} [color] optional in hex or rgb(a) or hsl format or from known color list
   */ constructor(color){
        $f268b97836dca6b6$var$_defineProperty(this, "isUnrecognised", false);
        if (!color) // we default to black as canvas does
        this.setSource([
            0,
            0,
            0,
            1
        ]);
        else if (color instanceof $f268b97836dca6b6$export$892596cec99bc70e) this.setSource([
            ...color._source
        ]);
        else if (Array.isArray(color)) {
            const [r, g, b, a = 1] = color;
            this.setSource([
                r,
                g,
                b,
                a
            ]);
        } else this.setSource(this._tryParsingColor(color));
    }
}
/**
 * Returns array of attributes for given svg that fabric parses
 * @param {SVGElementName} type Type of svg element (eg. 'circle')
 * @return {Array} string names of supported attributes
 */ const $f268b97836dca6b6$var$getSvgAttributes = (type)=>{
    const commonAttributes = [
        'instantiated_by_use',
        'style',
        'id',
        'class'
    ];
    switch(type){
        case 'linearGradient':
            return commonAttributes.concat([
                'x1',
                'y1',
                'x2',
                'y2',
                'gradientUnits',
                'gradientTransform'
            ]);
        case 'radialGradient':
            return commonAttributes.concat([
                'gradientUnits',
                'gradientTransform',
                'cx',
                'cy',
                'r',
                'fx',
                'fy',
                'fr'
            ]);
        case 'stop':
            return commonAttributes.concat([
                'offset',
                'stop-color',
                'stop-opacity'
            ]);
    }
    return commonAttributes;
};
/**
 * Converts from attribute value to pixel value if applicable.
 * Returns converted pixels or original value not converted.
 * @param {string} value number to operate on
 * @param {number} fontSize
 * @return {number}
 */ const $f268b97836dca6b6$var$parseUnit = function(value) {
    let fontSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $f268b97836dca6b6$var$DEFAULT_SVG_FONT_SIZE;
    const unit = /\D{0,2}$/.exec(value), number = parseFloat(value);
    const dpi = $f268b97836dca6b6$export$e506a1d27d1eaa20.DPI;
    switch(unit === null || unit === void 0 ? void 0 : unit[0]){
        case 'mm':
            return number * dpi / 25.4;
        case 'cm':
            return number * dpi / 2.54;
        case 'in':
            return number * dpi;
        case 'pt':
            return number * dpi / 72;
        // or * 4 / 3
        case 'pc':
            return number * dpi / 72 * 12;
        // or * 16
        case 'em':
            return number * fontSize;
        default:
            return number;
    }
};
// align can be either none or undefined or a combination of mid/max
const $f268b97836dca6b6$var$parseAlign = (align)=>{
    //divide align in alignX and alignY
    if (align && align !== $f268b97836dca6b6$var$NONE) return [
        align.slice(1, 4),
        align.slice(5, 8)
    ];
    else if (align === $f268b97836dca6b6$var$NONE) return [
        align,
        align
    ];
    return [
        'Mid',
        'Mid'
    ];
};
/**
 * Parse preserveAspectRatio attribute from element
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/preserveAspectRatio
 * @param {string} attribute to be parsed
 * @return {Object} an object containing align and meetOrSlice attribute
 */ const $f268b97836dca6b6$var$parsePreserveAspectRatioAttribute = (attribute)=>{
    const [firstPart, secondPart] = attribute.trim().split(' ');
    const [alignX, alignY] = $f268b97836dca6b6$var$parseAlign(firstPart);
    return {
        meetOrSlice: secondPart || 'meet',
        alignX: alignX,
        alignY: alignY
    };
};
/**
 * Adobe Illustrator (at least CS5) is unable to render rgba()-based fill values
 * we work around it by "moving" alpha channel into opacity attribute and setting fill's alpha to 1
 * @param prop
 * @param value
 * @param {boolean} inlineStyle The default is inline style, the separator used is ":", The other is "="
 * @returns
 */ const $f268b97836dca6b6$var$colorPropToSVG = function(prop, value) {
    let inlineStyle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    let colorValue;
    let opacityValue;
    if (!value) colorValue = 'none';
    else if (value.toLive) colorValue = "url(#SVGID_".concat(value.id, ")");
    else {
        const color = new $f268b97836dca6b6$export$892596cec99bc70e(value), opacity = color.getAlpha();
        colorValue = color.toRgb();
        if (opacity !== 1) opacityValue = opacity.toString();
    }
    if (inlineStyle) return "".concat(prop, ": ").concat(colorValue, "; ").concat(opacityValue ? "".concat(prop, "-opacity: ").concat(opacityValue, "; ") : '');
    else return "".concat(prop, "=\"").concat(colorValue, "\" ").concat(opacityValue ? "".concat(prop, "-opacity=\"").concat(opacityValue, "\" ") : '');
};
const $f268b97836dca6b6$var$createSVGRect = function(color, _ref) {
    let { left: left, top: top, width: width, height: height } = _ref;
    let precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $f268b97836dca6b6$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS;
    const svgColor = $f268b97836dca6b6$var$colorPropToSVG($f268b97836dca6b6$var$FILL, color, false);
    const [x, y, w, h] = [
        left,
        top,
        width,
        height
    ].map((value)=>$f268b97836dca6b6$var$toFixed(value, precision));
    return "<rect ".concat(svgColor, " x=\"").concat(x, "\" y=\"").concat(y, "\" width=\"").concat(w, "\" height=\"").concat(h, "\"></rect>");
};
class $f268b97836dca6b6$var$FabricObjectSVGExportMixin {
    /**
   * When an object is being exported as SVG as a clippath, a reference inside the SVG is needed.
   * This reference is a UID in the fabric namespace and is temporary stored here.
   * @type {String}
   */ /**
   * Returns styles-string for svg-export
   * @param {Boolean} skipShadow a boolean to skip shadow filter output
   * @return {String}
   */ getSvgStyles(skipShadow) {
        const fillRule = this.fillRule ? this.fillRule : 'nonzero', strokeWidth = this.strokeWidth ? this.strokeWidth : '0', strokeDashArray = this.strokeDashArray ? this.strokeDashArray.join(' ') : $f268b97836dca6b6$var$NONE, strokeDashOffset = this.strokeDashOffset ? this.strokeDashOffset : '0', strokeLineCap = this.strokeLineCap ? this.strokeLineCap : 'butt', strokeLineJoin = this.strokeLineJoin ? this.strokeLineJoin : 'miter', strokeMiterLimit = this.strokeMiterLimit ? this.strokeMiterLimit : '4', opacity = typeof this.opacity !== 'undefined' ? this.opacity : '1', visibility = this.visible ? '' : ' visibility: hidden;', filter = skipShadow ? '' : this.getSvgFilter(), fill = $f268b97836dca6b6$var$colorPropToSVG($f268b97836dca6b6$var$FILL, this.fill), stroke = $f268b97836dca6b6$var$colorPropToSVG($f268b97836dca6b6$var$STROKE, this.stroke);
        return [
            stroke,
            'stroke-width: ',
            strokeWidth,
            '; ',
            'stroke-dasharray: ',
            strokeDashArray,
            '; ',
            'stroke-linecap: ',
            strokeLineCap,
            '; ',
            'stroke-dashoffset: ',
            strokeDashOffset,
            '; ',
            'stroke-linejoin: ',
            strokeLineJoin,
            '; ',
            'stroke-miterlimit: ',
            strokeMiterLimit,
            '; ',
            fill,
            'fill-rule: ',
            fillRule,
            '; ',
            'opacity: ',
            opacity,
            ';',
            filter,
            visibility
        ].join('');
    }
    /**
   * Returns filter for svg shadow
   * @return {String}
   */ getSvgFilter() {
        return this.shadow ? "filter: url(#SVGID_".concat(this.shadow.id, ");") : '';
    }
    /**
   * Returns id attribute for svg output
   * @return {String}
   */ getSvgCommons() {
        return [
            this.id ? "id=\"".concat(this.id, "\" ") : '',
            this.clipPath ? "clip-path=\"url(#".concat(this.clipPath.clipPathId, ")\" ") : ''
        ].join('');
    }
    /**
   * Returns transform-string for svg-export
   * @param {Boolean} use the full transform or the single object one.
   * @return {String}
   */ getSvgTransform(full) {
        let additionalTransform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        const transform = full ? this.calcTransformMatrix() : this.calcOwnMatrix(), svgTransform = "transform=\"".concat($f268b97836dca6b6$var$matrixToSVG(transform));
        return "".concat(svgTransform).concat(additionalTransform, "\" ");
    }
    /**
   * Returns svg representation of an instance
   * This function is implemented in each subclass
   * This is just because typescript otherwise cryies all the time
   * @return {Array} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG(_reviver) {
        return [
            ''
        ];
    }
    /**
   * Returns svg representation of an instance
   * @param {TSVGReviver} [reviver] Method for further parsing of svg representation.
   * @return {String} svg representation of an instance
   */ toSVG(reviver) {
        return this._createBaseSVGMarkup(this._toSVG(reviver), {
            reviver: reviver
        });
    }
    /**
   * Returns svg clipPath representation of an instance
   * @param {TSVGReviver} [reviver] Method for further parsing of svg representation.
   * @return {String} svg representation of an instance
   */ toClipPathSVG(reviver) {
        return '\t' + this._createBaseClipPathSVGMarkup(this._toSVG(reviver), {
            reviver: reviver
        });
    }
    /**
   * @private
   */ _createBaseClipPathSVGMarkup(objectMarkup) {
        let { reviver: reviver, additionalTransform: additionalTransform = '' } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const commonPieces = [
            this.getSvgTransform(true, additionalTransform),
            this.getSvgCommons()
        ].join(''), // insert commons in the markup, style and svgCommons
        index = objectMarkup.indexOf('COMMON_PARTS');
        objectMarkup[index] = commonPieces;
        return reviver ? reviver(objectMarkup.join('')) : objectMarkup.join('');
    }
    /**
   * @private
   */ _createBaseSVGMarkup(objectMarkup) {
        let { noStyle: noStyle, reviver: reviver, withShadow: withShadow, additionalTransform: additionalTransform } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const styleInfo = noStyle ? '' : "style=\"".concat(this.getSvgStyles(), "\" "), shadowInfo = withShadow ? "style=\"".concat(this.getSvgFilter(), "\" ") : '', clipPath = this.clipPath, vectorEffect = this.strokeUniform ? 'vector-effect="non-scaling-stroke" ' : '', absoluteClipPath = clipPath && clipPath.absolutePositioned, stroke = this.stroke, fill = this.fill, shadow = this.shadow, markup = [], // insert commons in the markup, style and svgCommons
        index = objectMarkup.indexOf('COMMON_PARTS');
        let clipPathMarkup;
        if (clipPath) {
            clipPath.clipPathId = "CLIPPATH_".concat($f268b97836dca6b6$var$uid());
            clipPathMarkup = "<clipPath id=\"".concat(clipPath.clipPathId, "\" >\n").concat(clipPath.toClipPathSVG(reviver), "</clipPath>\n");
        }
        if (absoluteClipPath) markup.push('<g ', shadowInfo, this.getSvgCommons(), ' >\n');
        markup.push('<g ', this.getSvgTransform(false), !absoluteClipPath ? shadowInfo + this.getSvgCommons() : '', ' >\n');
        const commonPieces = [
            styleInfo,
            vectorEffect,
            noStyle ? '' : this.addPaintOrder(),
            ' ',
            additionalTransform ? "transform=\"".concat(additionalTransform, "\" ") : ''
        ].join('');
        objectMarkup[index] = commonPieces;
        if ($f268b97836dca6b6$var$isFiller(fill)) markup.push(fill.toSVG(this));
        if ($f268b97836dca6b6$var$isFiller(stroke)) markup.push(stroke.toSVG(this));
        if (shadow) markup.push(shadow.toSVG(this));
        if (clipPath) markup.push(clipPathMarkup);
        markup.push(objectMarkup.join(''));
        markup.push('</g>\n');
        absoluteClipPath && markup.push('</g>\n');
        return reviver ? reviver(markup.join('')) : markup.join('');
    }
    addPaintOrder() {
        return this.paintFirst !== $f268b97836dca6b6$var$FILL ? " paint-order=\"".concat(this.paintFirst, "\" ") : '';
    }
}
function $f268b97836dca6b6$var$getSvgRegex(arr) {
    return new RegExp('^(' + arr.join('|') + ')\\b', 'i');
}
const $f268b97836dca6b6$var$TEXT_DECORATION_THICKNESS = 'textDecorationThickness';
const $f268b97836dca6b6$var$fontProperties = [
    'fontSize',
    'fontWeight',
    'fontFamily',
    'fontStyle'
];
const $f268b97836dca6b6$var$textDecorationProperties = [
    'underline',
    'overline',
    'linethrough'
];
const $f268b97836dca6b6$var$textLayoutProperties = [
    ...$f268b97836dca6b6$var$fontProperties,
    'lineHeight',
    'text',
    'charSpacing',
    'textAlign',
    'styles',
    'path',
    'pathStartOffset',
    'pathSide',
    'pathAlign'
];
const $f268b97836dca6b6$var$additionalProps = [
    ...$f268b97836dca6b6$var$textLayoutProperties,
    ...$f268b97836dca6b6$var$textDecorationProperties,
    'textBackgroundColor',
    'direction',
    $f268b97836dca6b6$var$TEXT_DECORATION_THICKNESS
];
const $f268b97836dca6b6$var$styleProperties = [
    ...$f268b97836dca6b6$var$fontProperties,
    ...$f268b97836dca6b6$var$textDecorationProperties,
    $f268b97836dca6b6$var$STROKE,
    'strokeWidth',
    $f268b97836dca6b6$var$FILL,
    'deltaY',
    'textBackgroundColor',
    $f268b97836dca6b6$var$TEXT_DECORATION_THICKNESS
];
// @TODO: Many things here are configuration related and shouldn't be on the class nor prototype
// regexes, list of properties that are not suppose to change by instances, magic consts.
// this will be a separated effort
const $f268b97836dca6b6$var$textDefaultValues = {
    _reNewline: $f268b97836dca6b6$var$reNewline,
    _reSpacesAndTabs: /[ \t\r]/g,
    _reSpaceAndTab: /[ \t\r]/,
    _reWords: /\S+/g,
    fontSize: 40,
    fontWeight: 'normal',
    fontFamily: 'Times New Roman',
    underline: false,
    overline: false,
    linethrough: false,
    textAlign: $f268b97836dca6b6$var$LEFT,
    fontStyle: 'normal',
    lineHeight: 1.16,
    textBackgroundColor: '',
    stroke: null,
    shadow: null,
    path: undefined,
    pathStartOffset: 0,
    pathSide: $f268b97836dca6b6$var$LEFT,
    pathAlign: 'baseline',
    charSpacing: 0,
    deltaY: 0,
    direction: 'ltr',
    CACHE_FONT_SIZE: 400,
    MIN_TEXT_WIDTH: 2,
    // Text magic numbers
    superscript: {
        size: 0.6,
        // fontSize factor
        baseline: -0.35 // baseline-shift factor (upwards)
    },
    subscript: {
        size: 0.6,
        // fontSize factor
        baseline: 0.11 // baseline-shift factor (downwards)
    },
    _fontSizeFraction: 0.222,
    offsets: {
        underline: 0.1,
        linethrough: -0.28167,
        // added 1/30 to original number
        overline: -0.81333 // added 1/15 to original number
    },
    _fontSizeMult: 1.13,
    [$f268b97836dca6b6$var$TEXT_DECORATION_THICKNESS]: 66.667 // before implementation was 1/15
};
const $f268b97836dca6b6$var$JUSTIFY = 'justify';
const $f268b97836dca6b6$var$JUSTIFY_LEFT = 'justify-left';
const $f268b97836dca6b6$var$JUSTIFY_RIGHT = 'justify-right';
const $f268b97836dca6b6$var$JUSTIFY_CENTER = 'justify-center';
var $f268b97836dca6b6$var$_templateObject$1, $f268b97836dca6b6$var$_templateObject2$1, $f268b97836dca6b6$var$_templateObject3$1;
// matches, e.g.: +14.56e-12, etc.
const $f268b97836dca6b6$var$reNum = String.raw($f268b97836dca6b6$var$_templateObject$1 || ($f268b97836dca6b6$var$_templateObject$1 = $f268b97836dca6b6$var$_taggedTemplateLiteral([
    "[-+]?(?:d*.d+|d+.?)(?:[eE][-+]?d+)?"
], [
    "[-+]?(?:\\d*\\.\\d+|\\d+\\.?)(?:[eE][-+]?\\d+)?"
])));
const $f268b97836dca6b6$var$viewportSeparator = String.raw($f268b97836dca6b6$var$_templateObject2$1 || ($f268b97836dca6b6$var$_templateObject2$1 = $f268b97836dca6b6$var$_taggedTemplateLiteral([
    "(?:s*,?s+|s*,s*)"
], [
    "(?:\\s*,?\\s+|\\s*,\\s*)"
])));
const $f268b97836dca6b6$var$svgNS = 'http://www.w3.org/2000/svg';
const $f268b97836dca6b6$var$reFontDeclaration = new RegExp("(normal|italic)?\\s*(normal|small-caps)?\\s*(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(" + $f268b97836dca6b6$var$reNum + '(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|' + $f268b97836dca6b6$var$reNum + '))?\\s+(.*)');
const $f268b97836dca6b6$var$svgValidTagNames = [
    'path',
    'circle',
    'polygon',
    'polyline',
    'ellipse',
    'rect',
    'line',
    'image',
    'text'
], $f268b97836dca6b6$var$svgViewBoxElements = [
    'symbol',
    'image',
    'marker',
    'pattern',
    'view',
    'svg'
], $f268b97836dca6b6$var$svgInvalidAncestors = [
    'pattern',
    'defs',
    'symbol',
    'metadata',
    'clipPath',
    'mask',
    'desc'
], $f268b97836dca6b6$var$svgValidParents = [
    'symbol',
    'g',
    'a',
    'svg',
    'clipPath',
    'defs'
], $f268b97836dca6b6$var$attributesMap = {
    cx: $f268b97836dca6b6$var$LEFT,
    x: $f268b97836dca6b6$var$LEFT,
    r: 'radius',
    cy: $f268b97836dca6b6$var$TOP,
    y: $f268b97836dca6b6$var$TOP,
    display: 'visible',
    visibility: 'visible',
    transform: 'transformMatrix',
    'fill-opacity': 'fillOpacity',
    'fill-rule': 'fillRule',
    'font-family': 'fontFamily',
    'font-size': 'fontSize',
    'font-style': 'fontStyle',
    'font-weight': 'fontWeight',
    'letter-spacing': 'charSpacing',
    'paint-order': 'paintFirst',
    'stroke-dasharray': 'strokeDashArray',
    'stroke-dashoffset': 'strokeDashOffset',
    'stroke-linecap': 'strokeLineCap',
    'stroke-linejoin': 'strokeLineJoin',
    'stroke-miterlimit': 'strokeMiterLimit',
    'stroke-opacity': 'strokeOpacity',
    'stroke-width': 'strokeWidth',
    'text-decoration': 'textDecoration',
    'text-anchor': 'textAnchor',
    opacity: 'opacity',
    'clip-path': 'clipPath',
    'clip-rule': 'clipRule',
    'vector-effect': 'strokeUniform',
    'image-rendering': 'imageSmoothing',
    'text-decoration-thickness': $f268b97836dca6b6$var$TEXT_DECORATION_THICKNESS
}, $f268b97836dca6b6$var$fSize = 'font-size', $f268b97836dca6b6$var$cPath = 'clip-path';
const $f268b97836dca6b6$var$svgValidTagNamesRegEx = $f268b97836dca6b6$var$getSvgRegex($f268b97836dca6b6$var$svgValidTagNames);
const $f268b97836dca6b6$var$svgViewBoxElementsRegEx = $f268b97836dca6b6$var$getSvgRegex($f268b97836dca6b6$var$svgViewBoxElements);
const $f268b97836dca6b6$var$svgValidParentsRegEx = $f268b97836dca6b6$var$getSvgRegex($f268b97836dca6b6$var$svgValidParents);
// http://www.w3.org/TR/SVG/coords.html#ViewBoxAttribute
const $f268b97836dca6b6$var$reViewBoxAttrValue = new RegExp(String.raw($f268b97836dca6b6$var$_templateObject3$1 || ($f268b97836dca6b6$var$_templateObject3$1 = $f268b97836dca6b6$var$_taggedTemplateLiteral([
    "^s*(",
    ")",
    "(",
    ")",
    "(",
    ")",
    "(",
    ")s*$"
], [
    "^\\s*(",
    ")",
    "(",
    ")",
    "(",
    ")",
    "(",
    ")\\s*$"
])), $f268b97836dca6b6$var$reNum, $f268b97836dca6b6$var$viewportSeparator, $f268b97836dca6b6$var$reNum, $f268b97836dca6b6$var$viewportSeparator, $f268b97836dca6b6$var$reNum, $f268b97836dca6b6$var$viewportSeparator, $f268b97836dca6b6$var$reNum));
const $f268b97836dca6b6$var$unitVectorX = new $f268b97836dca6b6$export$baf26146a414f24a(1, 0);
const $f268b97836dca6b6$var$zero = new $f268b97836dca6b6$export$baf26146a414f24a();
/**
 * Rotates `vector` with `radians`
 * @param {Point} vector The vector to rotate (x and y)
 * @param {Number} radians The radians of the angle for the rotation
 * @return {Point} The new rotated point
 */ const $f268b97836dca6b6$var$rotateVector = (vector, radians)=>vector.rotate(radians);
/**
 * Creates a vector from points represented as a point
 *
 * @param {Point} from
 * @param {Point} to
 * @returns {Point} vector
 */ const $f268b97836dca6b6$var$createVector = (from, to)=>new $f268b97836dca6b6$export$baf26146a414f24a(to).subtract(from);
/**
 * return the magnitude of a vector
 * @return {number}
 */ const $f268b97836dca6b6$var$magnitude = (point)=>point.distanceFrom($f268b97836dca6b6$var$zero);
/**
 * Calculates the angle between 2 vectors
 * @param {Point} a
 * @param {Point} b
 * @returns the angle in radians from `a` to `b`
 */ const $f268b97836dca6b6$var$calcAngleBetweenVectors = (a, b)=>Math.atan2($f268b97836dca6b6$var$crossProduct(a, b), $f268b97836dca6b6$var$dotProduct(a, b));
/**
 * Calculates the angle between the x axis and the vector
 * @param {Point} v
 * @returns the angle in radians of `v`
 */ const $f268b97836dca6b6$var$calcVectorRotation = (v)=>$f268b97836dca6b6$var$calcAngleBetweenVectors($f268b97836dca6b6$var$unitVectorX, v);
/**
 * @param {Point} v
 * @returns {Point} vector representing the unit vector pointing to the direction of `v`
 */ const $f268b97836dca6b6$var$getUnitVector = (v)=>v.eq($f268b97836dca6b6$var$zero) ? v : v.scalarDivide($f268b97836dca6b6$var$magnitude(v));
/**
 * @param {Point} v
 * @param {Boolean} [counterClockwise] the direction of the orthogonal vector, defaults to `true`
 * @returns {Point} the unit orthogonal vector
 */ const $f268b97836dca6b6$var$getOrthonormalVector = function(v) {
    let counterClockwise = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return $f268b97836dca6b6$var$getUnitVector(new $f268b97836dca6b6$export$baf26146a414f24a(-v.y, v.x).scalarMultiply(counterClockwise ? 1 : -1));
};
/**
 * Cross product of two vectors in 2D
 * @param {Point} a
 * @param {Point} b
 * @returns {number} the magnitude of Z vector
 */ const $f268b97836dca6b6$var$crossProduct = (a, b)=>a.x * b.y - a.y * b.x;
/**
 * Dot product of two vectors in 2D
 * @param {Point} a
 * @param {Point} b
 * @returns {number}
 */ const $f268b97836dca6b6$var$dotProduct = (a, b)=>a.x * b.x + a.y * b.y;
/**
 * Checks if the vector is between two others. It is considered
 * to be inside when the vector to be tested is between the
 * initial vector and the final vector (included) in a counterclockwise direction.
 * @param {Point} t vector to be tested
 * @param {Point} a initial vector
 * @param {Point} b final vector
 * @returns {boolean} true if the vector is among the others
 */ const $f268b97836dca6b6$var$isBetweenVectors = (t, a, b)=>{
    if (t.eq(a) || t.eq(b)) return true;
    const AxB = $f268b97836dca6b6$var$crossProduct(a, b), AxT = $f268b97836dca6b6$var$crossProduct(a, t), BxT = $f268b97836dca6b6$var$crossProduct(b, t);
    return AxB >= 0 ? AxT >= 0 && BxT <= 0 : !(AxT <= 0 && BxT >= 0);
};
/**
   * Regex matching shadow offsetX, offsetY and blur (ex: "2px 2px 10px rgba(0,0,0,0.2)", "rgb(0,255,0) 2px 2px")
   * - (?:\s|^): This part captures either a whitespace character (\s) or the beginning of a line (^). It's non-capturing (due to (?:...)), meaning it doesn't create a capturing group.
   * - (-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?: This captures the first component of the shadow, which is the horizontal offset. Breaking it down:
   *   - (-?\d+): Captures an optional minus sign followed by one or more digits (integer part of the number).
   *   - (?:\.\d*)?: Optionally captures a decimal point followed by zero or more digits (decimal part of the number).
   *   - (?:px)?: Optionally captures the "px" unit.
   *   - (?:\s?|$): Captures either an optional whitespace or the end of the line. This whole part is wrapped in a non-capturing group and marked as optional with ?.
   * - (-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?: Similar to the previous step, this captures the vertical offset.

(\d+(?:\.\d*)?(?:px)?)?: This captures the blur radius. It's similar to the horizontal offset but without the optional minus sign.

(?:\s+(-?\d+(?:\.\d*)?(?:px)?(?:\s?|$))?){0,1}: This captures an optional part for the color. It allows for whitespace followed by a component with an optional minus sign, digits, decimal point, and "px" unit.

(?:$|\s): This captures either the end of the line or a whitespace character. It ensures that the match ends either at the end of the string or with a whitespace character.
   */ // eslint-disable-next-line max-len
const $f268b97836dca6b6$var$shadowOffsetRegex = '(-?\\d+(?:\\.\\d*)?(?:px)?(?:\\s?|$))?';
const $f268b97836dca6b6$var$reOffsetsAndBlur = new RegExp('(?:\\s|^)' + $f268b97836dca6b6$var$shadowOffsetRegex + $f268b97836dca6b6$var$shadowOffsetRegex + '(' + $f268b97836dca6b6$var$reNum + '?(?:px)?)?(?:\\s?|$)(?:$|\\s)');
const $f268b97836dca6b6$var$shadowDefaultValues = {
    color: 'rgb(0,0,0)',
    blur: 0,
    offsetX: 0,
    offsetY: 0,
    affectStroke: false,
    includeDefaultValues: true,
    nonScaling: false
};
class $f268b97836dca6b6$export$a24c14443968327c {
    /**
   * @param {String} value Shadow value to parse
   * @return {Object} Shadow object with color, offsetX, offsetY and blur
   */ static parseShadow(value) {
        const shadowStr = value.trim(), [, offsetX = 0, offsetY = 0, blur = 0] = ($f268b97836dca6b6$var$reOffsetsAndBlur.exec(shadowStr) || []).map((value)=>parseFloat(value) || 0), color = (shadowStr.replace($f268b97836dca6b6$var$reOffsetsAndBlur, '') || 'rgb(0,0,0)').trim();
        return {
            color: color,
            offsetX: offsetX,
            offsetY: offsetY,
            blur: blur
        };
    }
    /**
   * Returns a string representation of an instance
   * @see http://www.w3.org/TR/css-text-decor-3/#text-shadow
   * @return {String} Returns CSS3 text-shadow declaration
   */ toString() {
        return [
            this.offsetX,
            this.offsetY,
            this.blur,
            this.color
        ].join('px ');
    }
    /**
   * Returns SVG representation of a shadow
   * @param {FabricObject} object
   * @return {String} SVG representation of a shadow
   */ toSVG(object) {
        const offset = $f268b97836dca6b6$var$rotateVector(new $f268b97836dca6b6$export$baf26146a414f24a(this.offsetX, this.offsetY), $f268b97836dca6b6$var$degreesToRadians(-object.angle)), BLUR_BOX = 20, color = new $f268b97836dca6b6$export$892596cec99bc70e(this.color);
        let fBoxX = 40, fBoxY = 40;
        if (object.width && object.height) {
            //http://www.w3.org/TR/SVG/filters.html#FilterEffectsRegion
            // we add some extra space to filter box to contain the blur ( 20 )
            fBoxX = $f268b97836dca6b6$var$toFixed((Math.abs(offset.x) + this.blur) / object.width, $f268b97836dca6b6$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
            fBoxY = $f268b97836dca6b6$var$toFixed((Math.abs(offset.y) + this.blur) / object.height, $f268b97836dca6b6$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS) * 100 + BLUR_BOX;
        }
        if (object.flipX) offset.x *= -1;
        if (object.flipY) offset.y *= -1;
        return "<filter id=\"SVGID_".concat(this.id, "\" y=\"-").concat(fBoxY, "%\" height=\"").concat(100 + 2 * fBoxY, "%\" x=\"-").concat(fBoxX, "%\" width=\"").concat(100 + 2 * fBoxX, "%\" >\n\t<feGaussianBlur in=\"SourceAlpha\" stdDeviation=\"").concat($f268b97836dca6b6$var$toFixed(this.blur ? this.blur / 2 : 0, $f268b97836dca6b6$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS), "\"></feGaussianBlur>\n\t<feOffset dx=\"").concat($f268b97836dca6b6$var$toFixed(offset.x, $f268b97836dca6b6$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS), "\" dy=\"").concat($f268b97836dca6b6$var$toFixed(offset.y, $f268b97836dca6b6$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS), "\" result=\"oBlur\" ></feOffset>\n\t<feFlood flood-color=\"").concat(color.toRgb(), "\" flood-opacity=\"").concat(color.getAlpha(), "\"/>\n\t<feComposite in2=\"oBlur\" operator=\"in\" />\n\t<feMerge>\n\t\t<feMergeNode></feMergeNode>\n\t\t<feMergeNode in=\"SourceGraphic\"></feMergeNode>\n\t</feMerge>\n</filter>\n");
    }
    /**
   * Returns object representation of a shadow
   * @return {Object} Object representation of a shadow instance
   */ toObject() {
        const data = {
            color: this.color,
            blur: this.blur,
            offsetX: this.offsetX,
            offsetY: this.offsetY,
            affectStroke: this.affectStroke,
            nonScaling: this.nonScaling,
            type: this.constructor.type
        };
        const defaults = $f268b97836dca6b6$export$a24c14443968327c.ownDefaults;
        return !this.includeDefaultValues ? $f268b97836dca6b6$var$pickBy(data, (value, key)=>value !== defaults[key]) : data;
    }
    static async fromObject(options) {
        return new this(options);
    }
    /**
   * @see {@link http://fabricjs.com/shadows|Shadow demo}
   * @param {Object|String} [options] Options object with any of color, blur, offsetX, offsetY properties or string (e.g. "rgba(0,0,0,0.2) 2px 2px 10px")
   */ constructor(arg0){
        const options = typeof arg0 === 'string' ? $f268b97836dca6b6$export$a24c14443968327c.parseShadow(arg0) : arg0;
        Object.assign(this, $f268b97836dca6b6$export$a24c14443968327c.ownDefaults, options);
        this.id = $f268b97836dca6b6$var$uid();
    }
}
/**
 * Shadow color
 * @type String
 * @default
 */ /**
 * Shadow blur
 * @type Number
 */ /**
 * Shadow horizontal offset
 * @type Number
 * @default
 */ /**
 * Shadow vertical offset
 * @type Number
 * @default
 */ /**
 * Whether the shadow should affect stroke operations
 * @type Boolean
 * @default
 */ /**
 * Indicates whether toObject should include default values
 * @type Boolean
 * @default
 */ /**
 * When `false`, the shadow will scale with the object.
 * When `true`, the shadow's offsetX, offsetY, and blur will not be affected by the object's scale.
 * default to false
 * @type Boolean
 * @default
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$a24c14443968327c, "ownDefaults", $f268b97836dca6b6$var$shadowDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$a24c14443968327c, "type", 'shadow');
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$a24c14443968327c, 'shadow');
const $f268b97836dca6b6$var$capValue = (min, value, max)=>Math.max(min, Math.min(value, max));
const $f268b97836dca6b6$var$stateProperties = [
    $f268b97836dca6b6$var$TOP,
    $f268b97836dca6b6$var$LEFT,
    $f268b97836dca6b6$var$SCALE_X,
    $f268b97836dca6b6$var$SCALE_Y,
    'flipX',
    'flipY',
    'originX',
    'originY',
    'angle',
    'opacity',
    'globalCompositeOperation',
    'shadow',
    'visible',
    $f268b97836dca6b6$var$SKEW_X,
    $f268b97836dca6b6$var$SKEW_Y
];
const $f268b97836dca6b6$var$cacheProperties = [
    $f268b97836dca6b6$var$FILL,
    $f268b97836dca6b6$var$STROKE,
    'strokeWidth',
    'strokeDashArray',
    'width',
    'height',
    'paintFirst',
    'strokeUniform',
    'strokeLineCap',
    'strokeDashOffset',
    'strokeLineJoin',
    'strokeMiterLimit',
    'backgroundColor',
    'clipPath'
];
const $f268b97836dca6b6$var$fabricObjectDefaultValues = {
    // see composeMatrix() to see order of transforms. First defaults listed based on this
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    angle: 0,
    flipX: false,
    flipY: false,
    scaleX: 1,
    scaleY: 1,
    minScaleLimit: 0,
    skewX: 0,
    skewY: 0,
    originX: $f268b97836dca6b6$var$LEFT,
    originY: $f268b97836dca6b6$var$TOP,
    strokeWidth: 1,
    strokeUniform: false,
    padding: 0,
    opacity: 1,
    paintFirst: $f268b97836dca6b6$var$FILL,
    fill: 'rgb(0,0,0)',
    fillRule: 'nonzero',
    stroke: null,
    strokeDashArray: null,
    strokeDashOffset: 0,
    strokeLineCap: 'butt',
    strokeLineJoin: 'miter',
    strokeMiterLimit: 4,
    globalCompositeOperation: 'source-over',
    backgroundColor: '',
    shadow: null,
    visible: true,
    includeDefaultValues: true,
    excludeFromExport: false,
    objectCaching: true,
    clipPath: undefined,
    inverted: false,
    absolutePositioned: false,
    centeredRotation: true,
    centeredScaling: false,
    dirty: true
};
const $f268b97836dca6b6$var$interactiveObjectDefaultValues = {
    noScaleCache: true,
    lockMovementX: false,
    lockMovementY: false,
    lockRotation: false,
    lockScalingX: false,
    lockScalingY: false,
    lockSkewingX: false,
    lockSkewingY: false,
    lockScalingFlip: false,
    cornerSize: 13,
    touchCornerSize: 24,
    transparentCorners: true,
    cornerColor: 'rgb(178,204,255)',
    cornerStrokeColor: '',
    cornerStyle: 'rect',
    cornerDashArray: null,
    hasControls: true,
    borderColor: 'rgb(178,204,255)',
    borderDashArray: null,
    borderOpacityWhenMoving: 0.4,
    borderScaleFactor: 1,
    hasBorders: true,
    selectionBackgroundColor: '',
    selectable: true,
    evented: true,
    perPixelTargetFind: false,
    activeOn: 'down',
    hoverCursor: null,
    moveCursor: null
};
/**
 * Easing functions
 * @see {@link http://gizma.com/easing/ Easing Equations by Robert Penner}
 */ const $f268b97836dca6b6$var$normalize = (a, c, p, s)=>{
    if (a < Math.abs(c)) {
        a = c;
        s = p / 4;
    } else //handle the 0/0 case:
    if (c === 0 && a === 0) s = p / $f268b97836dca6b6$var$twoMathPi * Math.asin(1);
    else s = p / $f268b97836dca6b6$var$twoMathPi * Math.asin(c / a);
    return {
        a: a,
        c: c,
        p: p,
        s: s
    };
};
const $f268b97836dca6b6$var$elastic = (a, s, p, t, d)=>a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * d - s) * $f268b97836dca6b6$var$twoMathPi / p);
/**
 * Default sinusoidal easing
 */ const $f268b97836dca6b6$var$defaultEasing = (t, b, c, d)=>-c * Math.cos(t / d * $f268b97836dca6b6$var$halfPI) + c + b;
/**
 * Cubic easing in
 */ const $f268b97836dca6b6$var$easeInCubic = (t, b, c, d)=>c * (t / d) ** 3 + b;
/**
 * Cubic easing out
 */ const $f268b97836dca6b6$var$easeOutCubic = (t, b, c, d)=>c * ((t / d - 1) ** 3 + 1) + b;
/**
 * Cubic easing in and out
 */ const $f268b97836dca6b6$var$easeInOutCubic = (t, b, c, d)=>{
    t /= d / 2;
    if (t < 1) return c / 2 * t ** 3 + b;
    return c / 2 * ((t - 2) ** 3 + 2) + b;
};
/**
 * Quartic easing in
 */ const $f268b97836dca6b6$var$easeInQuart = (t, b, c, d)=>c * (t /= d) * t ** 3 + b;
/**
 * Quartic easing out
 */ const $f268b97836dca6b6$var$easeOutQuart = (t, b, c, d)=>-c * ((t = t / d - 1) * t ** 3 - 1) + b;
/**
 * Quartic easing in and out
 */ const $f268b97836dca6b6$var$easeInOutQuart = (t, b, c, d)=>{
    t /= d / 2;
    if (t < 1) return c / 2 * t ** 4 + b;
    return -c / 2 * ((t -= 2) * t ** 3 - 2) + b;
};
/**
 * Quintic easing in
 */ const $f268b97836dca6b6$var$easeInQuint = (t, b, c, d)=>c * (t / d) ** 5 + b;
/**
 * Quintic easing out
 */ const $f268b97836dca6b6$var$easeOutQuint = (t, b, c, d)=>c * ((t / d - 1) ** 5 + 1) + b;
/**
 * Quintic easing in and out
 */ const $f268b97836dca6b6$var$easeInOutQuint = (t, b, c, d)=>{
    t /= d / 2;
    if (t < 1) return c / 2 * t ** 5 + b;
    return c / 2 * ((t - 2) ** 5 + 2) + b;
};
/**
 * Sinusoidal easing in
 */ const $f268b97836dca6b6$var$easeInSine = (t, b, c, d)=>-c * Math.cos(t / d * $f268b97836dca6b6$var$halfPI) + c + b;
/**
 * Sinusoidal easing out
 */ const $f268b97836dca6b6$var$easeOutSine = (t, b, c, d)=>c * Math.sin(t / d * $f268b97836dca6b6$var$halfPI) + b;
/**
 * Sinusoidal easing in and out
 */ const $f268b97836dca6b6$var$easeInOutSine = (t, b, c, d)=>-c / 2 * (Math.cos(Math.PI * t / d) - 1) + b;
/**
 * Exponential easing in
 */ const $f268b97836dca6b6$var$easeInExpo = (t, b, c, d)=>t === 0 ? b : c * 2 ** (10 * (t / d - 1)) + b;
/**
 * Exponential easing out
 */ const $f268b97836dca6b6$var$easeOutExpo = (t, b, c, d)=>t === d ? b + c : c * -(2 ** (-10 * t / d) + 1) + b;
/**
 * Exponential easing in and out
 */ const $f268b97836dca6b6$var$easeInOutExpo = (t, b, c, d)=>{
    if (t === 0) return b;
    if (t === d) return b + c;
    t /= d / 2;
    if (t < 1) return c / 2 * 2 ** (10 * (t - 1)) + b;
    return c / 2 * -(2 ** (-10 * --t) + 2) + b;
};
/**
 * Circular easing in
 */ const $f268b97836dca6b6$var$easeInCirc = (t, b, c, d)=>-c * (Math.sqrt(1 - (t /= d) * t) - 1) + b;
/**
 * Circular easing out
 */ const $f268b97836dca6b6$var$easeOutCirc = (t, b, c, d)=>c * Math.sqrt(1 - (t = t / d - 1) * t) + b;
/**
 * Circular easing in and out
 */ const $f268b97836dca6b6$var$easeInOutCirc = (t, b, c, d)=>{
    t /= d / 2;
    if (t < 1) return -c / 2 * (Math.sqrt(1 - t ** 2) - 1) + b;
    return c / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + b;
};
/**
 * Elastic easing in
 */ const $f268b97836dca6b6$var$easeInElastic = (t, b, c, d)=>{
    const s = 1.70158, a = c;
    let p = 0;
    if (t === 0) return b;
    t /= d;
    if (t === 1) return b + c;
    if (!p) p = d * 0.3;
    const { a: normA, s: normS, p: normP } = $f268b97836dca6b6$var$normalize(a, c, p, s);
    return -$f268b97836dca6b6$var$elastic(normA, normS, normP, t, d) + b;
};
/**
 * Elastic easing out
 */ const $f268b97836dca6b6$var$easeOutElastic = (t, b, c, d)=>{
    const s = 1.70158, a = c;
    let p = 0;
    if (t === 0) return b;
    t /= d;
    if (t === 1) return b + c;
    if (!p) p = d * 0.3;
    const { a: normA, s: normS, p: normP, c: normC } = $f268b97836dca6b6$var$normalize(a, c, p, s);
    return normA * 2 ** (-10 * t) * Math.sin((t * d - normS) * $f268b97836dca6b6$var$twoMathPi / normP) + normC + b;
};
/**
 * Elastic easing in and out
 */ const $f268b97836dca6b6$var$easeInOutElastic = (t, b, c, d)=>{
    const s = 1.70158, a = c;
    let p = 0;
    if (t === 0) return b;
    t /= d / 2;
    if (t === 2) return b + c;
    if (!p) p = d * (0.3 * 1.5);
    const { a: normA, s: normS, p: normP, c: normC } = $f268b97836dca6b6$var$normalize(a, c, p, s);
    if (t < 1) return -0.5 * $f268b97836dca6b6$var$elastic(normA, normS, normP, t, d) + b;
    return normA * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * d - normS) * $f268b97836dca6b6$var$twoMathPi / normP) * 0.5 + normC + b;
};
/**
 * Backwards easing in
 */ const $f268b97836dca6b6$var$easeInBack = function(t, b, c, d) {
    let s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1.70158;
    return c * (t /= d) * t * ((s + 1) * t - s) + b;
};
/**
 * Backwards easing out
 */ const $f268b97836dca6b6$var$easeOutBack = function(t, b, c, d) {
    let s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1.70158;
    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b;
};
/**
 * Backwards easing in and out
 */ const $f268b97836dca6b6$var$easeInOutBack = function(t, b, c, d) {
    let s = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1.70158;
    t /= d / 2;
    if (t < 1) return c / 2 * (t * t * (((s *= 1.525) + 1) * t - s)) + b;
    return c / 2 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b;
};
/**
 * Bouncing easing out
 */ const $f268b97836dca6b6$var$easeOutBounce = (t, b, c, d)=>{
    if ((t /= d) < 1 / 2.75) return c * (7.5625 * t * t) + b;
    else if (t < 2 / 2.75) return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b;
    else if (t < 2.5 / 2.75) return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b;
    else return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b;
};
/**
 * Bouncing easing in
 */ const $f268b97836dca6b6$var$easeInBounce = (t, b, c, d)=>c - $f268b97836dca6b6$var$easeOutBounce(d - t, 0, c, d) + b;
/**
 * Bouncing easing in and out
 */ const $f268b97836dca6b6$var$easeInOutBounce = (t, b, c, d)=>t < d / 2 ? $f268b97836dca6b6$var$easeInBounce(t * 2, 0, c, d) * 0.5 + b : $f268b97836dca6b6$var$easeOutBounce(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b;
/**
 * Quadratic easing in
 */ const $f268b97836dca6b6$var$easeInQuad = (t, b, c, d)=>c * (t /= d) * t + b;
/**
 * Quadratic easing out
 */ const $f268b97836dca6b6$var$easeOutQuad = (t, b, c, d)=>-c * (t /= d) * (t - 2) + b;
/**
 * Quadratic easing in and out
 */ const $f268b97836dca6b6$var$easeInOutQuad = (t, b, c, d)=>{
    t /= d / 2;
    if (t < 1) return c / 2 * t ** 2 + b;
    return -c / 2 * (--t * (t - 2) - 1) + b;
};
var $f268b97836dca6b6$var$easing = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultEasing: $f268b97836dca6b6$var$defaultEasing,
    easeInBack: $f268b97836dca6b6$var$easeInBack,
    easeInBounce: $f268b97836dca6b6$var$easeInBounce,
    easeInCirc: $f268b97836dca6b6$var$easeInCirc,
    easeInCubic: $f268b97836dca6b6$var$easeInCubic,
    easeInElastic: $f268b97836dca6b6$var$easeInElastic,
    easeInExpo: $f268b97836dca6b6$var$easeInExpo,
    easeInOutBack: $f268b97836dca6b6$var$easeInOutBack,
    easeInOutBounce: $f268b97836dca6b6$var$easeInOutBounce,
    easeInOutCirc: $f268b97836dca6b6$var$easeInOutCirc,
    easeInOutCubic: $f268b97836dca6b6$var$easeInOutCubic,
    easeInOutElastic: $f268b97836dca6b6$var$easeInOutElastic,
    easeInOutExpo: $f268b97836dca6b6$var$easeInOutExpo,
    easeInOutQuad: $f268b97836dca6b6$var$easeInOutQuad,
    easeInOutQuart: $f268b97836dca6b6$var$easeInOutQuart,
    easeInOutQuint: $f268b97836dca6b6$var$easeInOutQuint,
    easeInOutSine: $f268b97836dca6b6$var$easeInOutSine,
    easeInQuad: $f268b97836dca6b6$var$easeInQuad,
    easeInQuart: $f268b97836dca6b6$var$easeInQuart,
    easeInQuint: $f268b97836dca6b6$var$easeInQuint,
    easeInSine: $f268b97836dca6b6$var$easeInSine,
    easeOutBack: $f268b97836dca6b6$var$easeOutBack,
    easeOutBounce: $f268b97836dca6b6$var$easeOutBounce,
    easeOutCirc: $f268b97836dca6b6$var$easeOutCirc,
    easeOutCubic: $f268b97836dca6b6$var$easeOutCubic,
    easeOutElastic: $f268b97836dca6b6$var$easeOutElastic,
    easeOutExpo: $f268b97836dca6b6$var$easeOutExpo,
    easeOutQuad: $f268b97836dca6b6$var$easeOutQuad,
    easeOutQuart: $f268b97836dca6b6$var$easeOutQuart,
    easeOutQuint: $f268b97836dca6b6$var$easeOutQuint,
    easeOutSine: $f268b97836dca6b6$var$easeOutSine
});
const $f268b97836dca6b6$var$defaultAbort = ()=>false;
class $f268b97836dca6b6$var$AnimationBase {
    get state() {
        return this._state;
    }
    isDone() {
        return this._state === 'aborted' || this._state === 'completed';
    }
    /**
   * Calculate the current value based on the easing parameters
   * @param timeElapsed in ms
   * @protected
   */ start() {
        const firstTick = (timestamp)=>{
            if (this._state !== 'pending') return;
            this.startTime = timestamp || +new Date();
            this._state = 'running';
            this._onStart();
            this.tick(this.startTime);
        };
        this.register();
        // setTimeout(cb, 0) will run cb on the next frame, causing a delay
        // we don't want that
        if (this.delay > 0) setTimeout(()=>$f268b97836dca6b6$var$requestAnimFrame(firstTick), this.delay);
        else $f268b97836dca6b6$var$requestAnimFrame(firstTick);
    }
    tick(t) {
        const durationMs = (t || +new Date()) - this.startTime;
        const boundDurationMs = Math.min(durationMs, this.duration);
        this.durationProgress = boundDurationMs / this.duration;
        const { value: value, valueProgress: valueProgress } = this.calculate(boundDurationMs);
        this.value = Object.freeze(value);
        this.valueProgress = valueProgress;
        if (this._state === 'aborted') return;
        else if (this._abort(this.value, this.valueProgress, this.durationProgress)) {
            this._state = 'aborted';
            this.unregister();
        } else if (durationMs >= this.duration) {
            this.durationProgress = this.valueProgress = 1;
            this._onChange(this.endValue, this.valueProgress, this.durationProgress);
            this._state = 'completed';
            this._onComplete(this.endValue, this.valueProgress, this.durationProgress);
            this.unregister();
        } else {
            this._onChange(this.value, this.valueProgress, this.durationProgress);
            $f268b97836dca6b6$var$requestAnimFrame(this.tick);
        }
    }
    register() {
        $f268b97836dca6b6$export$dc18923894d9e56a.push(this);
    }
    unregister() {
        $f268b97836dca6b6$export$dc18923894d9e56a.remove(this);
    }
    abort() {
        this._state = 'aborted';
        this.unregister();
    }
    /**
   * Current value
   */ /**
   * Animation start time ms
   */ constructor(_ref){
        let { startValue: startValue, byValue: byValue, duration: duration = 500, delay: delay = 0, easing: easing = $f268b97836dca6b6$var$defaultEasing, onStart: onStart = $f268b97836dca6b6$var$noop, onChange: onChange = $f268b97836dca6b6$var$noop, onComplete: onComplete = $f268b97836dca6b6$var$noop, abort: abort = $f268b97836dca6b6$var$defaultAbort, target: target } = _ref;
        /**
     * Used to register the animation to a target object
     * so that it can be cancelled within the object context
     */ $f268b97836dca6b6$var$_defineProperty(this, "_state", 'pending');
        /**
     * Time %, or the ratio of `timeElapsed / duration`
     * @see tick
     */ $f268b97836dca6b6$var$_defineProperty(this, "durationProgress", 0);
        /**
     * Value %, or the ratio of `(currentValue - startValue) / (endValue - startValue)`
     */ $f268b97836dca6b6$var$_defineProperty(this, "valueProgress", 0);
        this.tick = this.tick.bind(this);
        this.duration = duration;
        this.delay = delay;
        this.easing = easing;
        this._onStart = onStart;
        this._onChange = onChange;
        this._onComplete = onComplete;
        this._abort = abort;
        this.target = target;
        this.startValue = startValue;
        this.byValue = byValue;
        this.value = this.startValue;
        this.endValue = Object.freeze(this.calculate(this.duration).value);
    }
}
const $f268b97836dca6b6$var$_excluded$h = [
    "startValue",
    "endValue"
];
class $f268b97836dca6b6$var$ValueAnimation extends $f268b97836dca6b6$var$AnimationBase {
    calculate(timeElapsed) {
        const value = this.easing(timeElapsed, this.startValue, this.byValue, this.duration);
        return {
            value: value,
            valueProgress: Math.abs((value - this.startValue) / this.byValue)
        };
    }
    constructor(_ref){
        let { startValue: startValue = 0, endValue: endValue = 100 } = _ref, otherOptions = $f268b97836dca6b6$var$_objectWithoutProperties(_ref, $f268b97836dca6b6$var$_excluded$h);
        super($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, otherOptions), {}, {
            startValue: startValue,
            byValue: endValue - startValue
        }));
    }
}
const $f268b97836dca6b6$var$_excluded$g = [
    "startValue",
    "endValue"
];
class $f268b97836dca6b6$var$ArrayAnimation extends $f268b97836dca6b6$var$AnimationBase {
    calculate(timeElapsed) {
        const values = this.startValue.map((value, i)=>this.easing(timeElapsed, value, this.byValue[i], this.duration, i));
        return {
            value: values,
            valueProgress: Math.abs((values[0] - this.startValue[0]) / this.byValue[0])
        };
    }
    constructor(_ref){
        let { startValue: startValue = [
            0
        ], endValue: endValue = [
            100
        ] } = _ref, options = $f268b97836dca6b6$var$_objectWithoutProperties(_ref, $f268b97836dca6b6$var$_excluded$g);
        super($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, options), {}, {
            startValue: startValue,
            byValue: endValue.map((value, i)=>value - startValue[i])
        }));
    }
}
const $f268b97836dca6b6$var$_excluded$f = [
    "startValue",
    "endValue",
    "easing",
    "onChange",
    "onComplete",
    "abort"
];
const $f268b97836dca6b6$var$defaultColorEasing = (timeElapsed, startValue, byValue, duration)=>{
    const durationProgress = 1 - Math.cos(timeElapsed / duration * $f268b97836dca6b6$var$halfPI);
    return startValue + byValue * durationProgress;
};
const $f268b97836dca6b6$var$wrapColorCallback = (callback)=>callback && ((rgba, valueProgress, durationProgress)=>callback(new $f268b97836dca6b6$export$892596cec99bc70e(rgba).toRgba(), valueProgress, durationProgress));
class $f268b97836dca6b6$var$ColorAnimation extends $f268b97836dca6b6$var$AnimationBase {
    calculate(timeElapsed) {
        const [r, g, b, a] = this.startValue.map((value, i)=>this.easing(timeElapsed, value, this.byValue[i], this.duration, i));
        const value = [
            ...[
                r,
                g,
                b
            ].map(Math.round),
            $f268b97836dca6b6$var$capValue(0, a, 1)
        ];
        return {
            value: value,
            valueProgress: // to correctly calculate the change ratio we must find a changed value
            value.map((p, i)=>this.byValue[i] !== 0 ? Math.abs((p - this.startValue[i]) / this.byValue[i]) : 0).find((p)=>p !== 0) || 0
        };
    }
    constructor(_ref){
        let { startValue: startValue, endValue: endValue, easing: easing = $f268b97836dca6b6$var$defaultColorEasing, onChange: onChange, onComplete: onComplete, abort: abort } = _ref, options = $f268b97836dca6b6$var$_objectWithoutProperties(_ref, $f268b97836dca6b6$var$_excluded$f);
        const startColor = new $f268b97836dca6b6$export$892596cec99bc70e(startValue).getSource();
        const endColor = new $f268b97836dca6b6$export$892596cec99bc70e(endValue).getSource();
        super($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, options), {}, {
            startValue: startColor,
            byValue: endColor.map((value, i)=>value - startColor[i]),
            easing: easing,
            onChange: $f268b97836dca6b6$var$wrapColorCallback(onChange),
            onComplete: $f268b97836dca6b6$var$wrapColorCallback(onComplete),
            abort: $f268b97836dca6b6$var$wrapColorCallback(abort)
        }));
    }
}
const $f268b97836dca6b6$var$isArrayAnimation = (options)=>{
    return Array.isArray(options.startValue) || Array.isArray(options.endValue);
};
/**
 * Changes value(s) from startValue to endValue within a certain period of time,
 * invoking callbacks as the value(s) change.
 *
 * @example
 * animate({
 *   startValue: 1,
 *   endValue: 0,
 *   onChange: (v) => {
 *     obj.set('opacity', v);
 *     // since we are running in a requested frame we should call `renderAll` and not `requestRenderAll`
 *     canvas.renderAll();
 *   }
 * });
 *
 * @example Using lists:
 * animate({
 *   startValue: [1, 2, 3],
 *   endValue: [2, 4, 6],
 *   onChange: ([x, y, zoom]) => {
 *     canvas.zoomToPoint(new Point(x, y), zoom);
 *     canvas.renderAll();
 *   }
 * });
 *
 */ function $f268b97836dca6b6$var$animate(options) {
    const animation = $f268b97836dca6b6$var$isArrayAnimation(options) ? new $f268b97836dca6b6$var$ArrayAnimation(options) : new $f268b97836dca6b6$var$ValueAnimation(options);
    animation.start();
    return animation;
}
function $f268b97836dca6b6$var$animateColor(options) {
    const animation = new $f268b97836dca6b6$var$ColorAnimation(options);
    animation.start();
    return animation;
}
/* Adaptation of work of Kevin Lindsey (kevin@kevlindev.com) */ class $f268b97836dca6b6$export$869c896bf338bf5a {
    /**
   * Used to verify if a point is alredy in the collection
   * @param {Point} point
   * @returns {boolean}
   */ includes(point) {
        return this.points.some((p)=>p.eq(point));
    }
    /**
   * Appends points of intersection
   * @param {...Point[]} points
   * @return {Intersection} thisArg
   * @chainable
   */ append() {
        for(var _len = arguments.length, points = new Array(_len), _key = 0; _key < _len; _key++)points[_key] = arguments[_key];
        this.points = this.points.concat(points.filter((point)=>{
            return !this.includes(point);
        }));
        return this;
    }
    /**
   * check if point T is on the segment or line defined between A and B
   *
   * @param {Point} T the point we are checking for
   * @param {Point} A one extremity of the segment
   * @param {Point} B the other extremity of the segment
   * @param [infinite] if true checks if `T` is on the line defined by `A` and `B`
   * @returns true if `T` is contained
   */ static isPointContained(T, A, B) {
        let infinite = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        if (A.eq(B)) // Edge case: the segment is a point, we check for coincidence,
        // infinite param has no meaning because there are infinite lines to consider
        return T.eq(A);
        else if (A.x === B.x) // Edge case: horizontal line.
        // we first check if T.x has the same value, and then if T.y is contained between A.y and B.y
        return T.x === A.x && (infinite || T.y >= Math.min(A.y, B.y) && T.y <= Math.max(A.y, B.y));
        else if (A.y === B.y) // Edge case: vertical line.
        // we first check if T.y has the same value, and then if T.x is contained between A.x and B.x
        return T.y === A.y && (infinite || T.x >= Math.min(A.x, B.x) && T.x <= Math.max(A.x, B.x));
        else {
            // Generic case: sloped line.
            // we check that AT has the same slope as AB
            // for the segment case we need both the vectors to have the same direction and for AT to be lte AB in size
            // for the infinite case we check the absolute value of the slope, since direction is meaningless
            const AB = $f268b97836dca6b6$var$createVector(A, B);
            const AT = $f268b97836dca6b6$var$createVector(A, T);
            const s = AT.divide(AB);
            return infinite ? Math.abs(s.x) === Math.abs(s.y) : s.x === s.y && s.x >= 0 && s.x <= 1;
        }
    }
    /**
   * Use the ray casting algorithm to determine if {@link Point} is in the polygon defined by [points]{@link Point}
   * @see https://en.wikipedia.org/wiki/Point_in_polygon
   * @param point
   * @param points polygon points
   * @returns
   */ static isPointInPolygon(point, points) {
        const other = new $f268b97836dca6b6$export$baf26146a414f24a(point).setX(Math.min(point.x - 1, ...points.map((p)=>p.x)));
        let hits = 0;
        for(let index = 0; index < points.length; index++){
            const inter = this.intersectSegmentSegment(// polygon side
            points[index], points[(index + 1) % points.length], // ray
            point, other);
            if (inter.includes(point)) // point is on the polygon side
            return true;
            hits += Number(inter.status === 'Intersection');
        }
        return hits % 2 === 1;
    }
    /**
   * Checks if a line intersects another
   * @see {@link https://en.wikipedia.org/wiki/Line%E2%80%93line_intersection line intersection}
   * @see {@link https://en.wikipedia.org/wiki/Cramer%27s_rule Cramer's rule}
   * @static
   * @param {Point} a1
   * @param {Point} a2
   * @param {Point} b1
   * @param {Point} b2
   * @param {boolean} [aInfinite=true] check segment intersection by passing `false`
   * @param {boolean} [bInfinite=true] check segment intersection by passing `false`
   * @return {Intersection}
   */ static intersectLineLine(a1, a2, b1, b2) {
        let aInfinite = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
        let bInfinite = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
        const a2xa1x = a2.x - a1.x, a2ya1y = a2.y - a1.y, b2xb1x = b2.x - b1.x, b2yb1y = b2.y - b1.y, a1xb1x = a1.x - b1.x, a1yb1y = a1.y - b1.y, uaT = b2xb1x * a1yb1y - b2yb1y * a1xb1x, ubT = a2xa1x * a1yb1y - a2ya1y * a1xb1x, uB = b2yb1y * a2xa1x - b2xb1x * a2ya1y;
        if (uB !== 0) {
            const ua = uaT / uB, ub = ubT / uB;
            if ((aInfinite || 0 <= ua && ua <= 1) && (bInfinite || 0 <= ub && ub <= 1)) return new $f268b97836dca6b6$export$869c896bf338bf5a('Intersection').append(new $f268b97836dca6b6$export$baf26146a414f24a(a1.x + ua * a2xa1x, a1.y + ua * a2ya1y));
            else return new $f268b97836dca6b6$export$869c896bf338bf5a();
        } else {
            if (uaT === 0 || ubT === 0) {
                const segmentsCoincide = aInfinite || bInfinite || $f268b97836dca6b6$export$869c896bf338bf5a.isPointContained(a1, b1, b2) || $f268b97836dca6b6$export$869c896bf338bf5a.isPointContained(a2, b1, b2) || $f268b97836dca6b6$export$869c896bf338bf5a.isPointContained(b1, a1, a2) || $f268b97836dca6b6$export$869c896bf338bf5a.isPointContained(b2, a1, a2);
                return new $f268b97836dca6b6$export$869c896bf338bf5a(segmentsCoincide ? 'Coincident' : undefined);
            } else return new $f268b97836dca6b6$export$869c896bf338bf5a('Parallel');
        }
    }
    /**
   * Checks if a segment intersects a line
   * @see {@link intersectLineLine} for line intersection
   * @static
   * @param {Point} s1 boundary point of segment
   * @param {Point} s2 other boundary point of segment
   * @param {Point} l1 point on line
   * @param {Point} l2 other point on line
   * @return {Intersection}
   */ static intersectSegmentLine(s1, s2, l1, l2) {
        return $f268b97836dca6b6$export$869c896bf338bf5a.intersectLineLine(s1, s2, l1, l2, false, true);
    }
    /**
   * Checks if a segment intersects another
   * @see {@link intersectLineLine} for line intersection
   * @static
   * @param {Point} a1 boundary point of segment
   * @param {Point} a2 other boundary point of segment
   * @param {Point} b1 boundary point of segment
   * @param {Point} b2 other boundary point of segment
   * @return {Intersection}
   */ static intersectSegmentSegment(a1, a2, b1, b2) {
        return $f268b97836dca6b6$export$869c896bf338bf5a.intersectLineLine(a1, a2, b1, b2, false, false);
    }
    /**
   * Checks if line intersects polygon
   *
   * @todo account for stroke
   *
   * @static
   * @see {@link intersectSegmentPolygon} for segment intersection
   * @param {Point} a1 point on line
   * @param {Point} a2 other point on line
   * @param {Point[]} points polygon points
   * @param {boolean} [infinite=true] check segment intersection by passing `false`
   * @return {Intersection}
   */ static intersectLinePolygon(a1, a2, points) {
        let infinite = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
        const result = new $f268b97836dca6b6$export$869c896bf338bf5a();
        const length = points.length;
        for(let i = 0, b1, b2, inter; i < length; i++){
            b1 = points[i];
            b2 = points[(i + 1) % length];
            inter = $f268b97836dca6b6$export$869c896bf338bf5a.intersectLineLine(a1, a2, b1, b2, infinite, false);
            if (inter.status === 'Coincident') return inter;
            result.append(...inter.points);
        }
        if (result.points.length > 0) result.status = 'Intersection';
        return result;
    }
    /**
   * Checks if segment intersects polygon
   * @static
   * @see {@link intersectLinePolygon} for line intersection
   * @param {Point} a1 boundary point of segment
   * @param {Point} a2 other boundary point of segment
   * @param {Point[]} points polygon points
   * @return {Intersection}
   */ static intersectSegmentPolygon(a1, a2, points) {
        return $f268b97836dca6b6$export$869c896bf338bf5a.intersectLinePolygon(a1, a2, points, false);
    }
    /**
   * Checks if polygon intersects another polygon
   *
   * @todo account for stroke
   *
   * @static
   * @param {Point[]} points1
   * @param {Point[]} points2
   * @return {Intersection}
   */ static intersectPolygonPolygon(points1, points2) {
        const result = new $f268b97836dca6b6$export$869c896bf338bf5a(), length = points1.length;
        const coincidences = [];
        for(let i = 0; i < length; i++){
            const a1 = points1[i], a2 = points1[(i + 1) % length], inter = $f268b97836dca6b6$export$869c896bf338bf5a.intersectSegmentPolygon(a1, a2, points2);
            if (inter.status === 'Coincident') {
                coincidences.push(inter);
                result.append(a1, a2);
            } else result.append(...inter.points);
        }
        if (coincidences.length > 0 && coincidences.length === points1.length) return new $f268b97836dca6b6$export$869c896bf338bf5a('Coincident');
        else if (result.points.length > 0) result.status = 'Intersection';
        return result;
    }
    /**
   * Checks if polygon intersects rectangle
   * @static
   * @see {@link intersectPolygonPolygon} for polygon intersection
   * @param {Point[]} points polygon points
   * @param {Point} r1 top left point of rect
   * @param {Point} r2 bottom right point of rect
   * @return {Intersection}
   */ static intersectPolygonRectangle(points, r1, r2) {
        const min = r1.min(r2), max = r1.max(r2), topRight = new $f268b97836dca6b6$export$baf26146a414f24a(max.x, min.y), bottomLeft = new $f268b97836dca6b6$export$baf26146a414f24a(min.x, max.y);
        return $f268b97836dca6b6$export$869c896bf338bf5a.intersectPolygonPolygon(points, [
            min,
            topRight,
            max,
            bottomLeft
        ]);
    }
    constructor(status){
        this.status = status;
        this.points = [];
    }
}
class $f268b97836dca6b6$var$ObjectGeometry extends $f268b97836dca6b6$var$CommonMethods {
    // #region Geometry
    /**
   * Describe object's corner position in scene coordinates.
   * The coordinates are derived from the following:
   * left, top, width, height, scaleX, scaleY, skewX, skewY, angle, strokeWidth.
   * The coordinates do not depend on viewport changes.
   * The coordinates get updated with {@link setCoords}.
   * You can calculate them without updating with {@link calcACoords()}
   */ /**
   * storage cache for object transform matrix
   */ /**
   * storage cache for object full transform matrix
   */ /**
   * A Reference of the Canvas where the object is actually added
   * @type StaticCanvas | Canvas;
   * @default undefined
   * @private
   */ /**
   * @returns {number} x position according to object's {@link FabricObject#originX} property in canvas coordinate plane
   */ getX() {
        return this.getXY().x;
    }
    /**
   * @param {number} value x position according to object's {@link FabricObject#originX} property in canvas coordinate plane
   */ setX(value) {
        this.setXY(this.getXY().setX(value));
    }
    /**
   * @returns {number} y position according to object's {@link FabricObject#originY} property in canvas coordinate plane
   */ getY() {
        return this.getXY().y;
    }
    /**
   * @param {number} value y position according to object's {@link FabricObject#originY} property in canvas coordinate plane
   */ setY(value) {
        this.setXY(this.getXY().setY(value));
    }
    /**
   * @returns {number} x position according to object's {@link FabricObject#originX} property in parent's coordinate plane\
   * if parent is canvas then this property is identical to {@link getX}
   */ getRelativeX() {
        return this.left;
    }
    /**
   * @param {number} value x position according to object's {@link FabricObject#originX} property in parent's coordinate plane\
   * if parent is canvas then this method is identical to {@link setX}
   */ setRelativeX(value) {
        this.left = value;
    }
    /**
   * @returns {number} y position according to object's {@link FabricObject#originY} property in parent's coordinate plane\
   * if parent is canvas then this property is identical to {@link getY}
   */ getRelativeY() {
        return this.top;
    }
    /**
   * @param {number} value y position according to object's {@link FabricObject#originY} property in parent's coordinate plane\
   * if parent is canvas then this property is identical to {@link setY}
   */ setRelativeY(value) {
        this.top = value;
    }
    /**
   * @returns {Point} x position according to object's {@link FabricObject#originX} {@link FabricObject#originY} properties in canvas coordinate plane
   */ getXY() {
        const relativePosition = this.getRelativeXY();
        return this.group ? $f268b97836dca6b6$var$transformPoint(relativePosition, this.group.calcTransformMatrix()) : relativePosition;
    }
    /**
   * Set an object position to a particular point, the point is intended in absolute ( canvas ) coordinate.
   * You can specify {@link FabricObject#originX} and {@link FabricObject#originY} values,
   * that otherwise are the object's current values.
   * @example <caption>Set object's bottom left corner to point (5,5) on canvas</caption>
   * object.setXY(new Point(5, 5), 'left', 'bottom').
   * @param {Point} point position in scene coordinate plane
   * @param {TOriginX} [originX] Horizontal origin: 'left', 'center' or 'right'
   * @param {TOriginY} [originY] Vertical origin: 'top', 'center' or 'bottom'
   */ setXY(point, originX, originY) {
        if (this.group) point = $f268b97836dca6b6$var$transformPoint(point, $f268b97836dca6b6$var$invertTransform(this.group.calcTransformMatrix()));
        this.setRelativeXY(point, originX, originY);
    }
    /**
   * @returns {Point} x,y position according to object's {@link FabricObject#originX} {@link FabricObject#originY} properties in parent's coordinate plane
   */ getRelativeXY() {
        return new $f268b97836dca6b6$export$baf26146a414f24a(this.left, this.top);
    }
    /**
   * As {@link setXY}, but in current parent's coordinate plane (the current group if any or the canvas)
   * @param {Point} point position according to object's {@link FabricObject#originX} {@link FabricObject#originY} properties in parent's coordinate plane
   * @param {TOriginX} [originX] Horizontal origin: 'left', 'center' or 'right'
   * @param {TOriginY} [originY] Vertical origin: 'top', 'center' or 'bottom'
   */ setRelativeXY(point) {
        let originX = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.originX;
        let originY = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.originY;
        this.setPositionByOrigin(point, originX, originY);
    }
    /**
   * @deprecated intermidiate method to be removed, do not use
   */ isStrokeAccountedForInDimensions() {
        return false;
    }
    /**
   * @return {Point[]} [tl, tr, br, bl] in the scene plane
   */ getCoords() {
        const { tl: tl, tr: tr, br: br, bl: bl } = this.aCoords || (this.aCoords = this.calcACoords());
        const coords = [
            tl,
            tr,
            br,
            bl
        ];
        if (this.group) {
            const t = this.group.calcTransformMatrix();
            return coords.map((p)=>$f268b97836dca6b6$var$transformPoint(p, t));
        }
        return coords;
    }
    /**
   * Checks if object intersects with the scene rect formed by TL and BR
   * In this case the rect is meant aligned with the axis of the canvas.
   * TL is the TOP LEFT point while br is the BOTTOM RIGHT point
   */ intersectsWithRect(tl, br) {
        const intersection = $f268b97836dca6b6$export$869c896bf338bf5a.intersectPolygonRectangle(this.getCoords(), tl, br);
        return intersection.status === 'Intersection';
    }
    /**
   * Checks if object intersects with another object
   * @param {Object} other Object to test
   * @return {Boolean} true if object intersects with another object
   */ intersectsWithObject(other) {
        const intersection = $f268b97836dca6b6$export$869c896bf338bf5a.intersectPolygonPolygon(this.getCoords(), other.getCoords());
        return intersection.status === 'Intersection' || intersection.status === 'Coincident' || other.isContainedWithinObject(this) || this.isContainedWithinObject(other);
    }
    /**
   * Checks if object is fully contained within area of another object
   * @param {Object} other Object to test
   * @return {Boolean} true if object is fully contained within area of another object
   */ isContainedWithinObject(other) {
        const points = this.getCoords();
        return points.every((point)=>other.containsPoint(point));
    }
    /**
   * Checks if object is fully contained within the scene rect formed by TL and BR
   */ isContainedWithinRect(tl, br) {
        const { left: left, top: top, width: width, height: height } = this.getBoundingRect();
        return left >= tl.x && left + width <= br.x && top >= tl.y && top + height <= br.y;
    }
    isOverlapping(other) {
        return this.intersectsWithObject(other) || this.isContainedWithinObject(other) || other.isContainedWithinObject(this);
    }
    /**
   * Checks if point is inside the object
   * @param {Point} point Point to check against
   * @return {Boolean} true if point is inside the object
   */ containsPoint(point) {
        return $f268b97836dca6b6$export$869c896bf338bf5a.isPointInPolygon(point, this.getCoords());
    }
    /**
   * Checks if object is contained within the canvas with current viewportTransform
   * the check is done stopping at first point that appears on screen
   * @return {Boolean} true if object is fully or partially contained within canvas
   */ isOnScreen() {
        if (!this.canvas) return false;
        const { tl: tl, br: br } = this.canvas.vptCoords;
        const points = this.getCoords();
        // if some point is on screen, the object is on screen.
        if (points.some((point)=>point.x <= br.x && point.x >= tl.x && point.y <= br.y && point.y >= tl.y)) return true;
        // no points on screen, check intersection with absolute coordinates
        if (this.intersectsWithRect(tl, br)) return true;
        // check if the object is so big that it contains the entire viewport
        return this.containsPoint(tl.midPointFrom(br));
    }
    /**
   * Checks if object is partially contained within the canvas with current viewportTransform
   * @return {Boolean} true if object is partially contained within canvas
   */ isPartiallyOnScreen() {
        if (!this.canvas) return false;
        const { tl: tl, br: br } = this.canvas.vptCoords;
        if (this.intersectsWithRect(tl, br)) return true;
        const allPointsAreOutside = this.getCoords().every((point)=>(point.x >= br.x || point.x <= tl.x) && (point.y >= br.y || point.y <= tl.y));
        // check if the object is so big that it contains the entire viewport
        return allPointsAreOutside && this.containsPoint(tl.midPointFrom(br));
    }
    /**
   * Returns coordinates of object's bounding rectangle (left, top, width, height)
   * the box is intended as aligned to axis of canvas.
   * @return {Object} Object with left, top, width, height properties
   */ getBoundingRect() {
        return $f268b97836dca6b6$var$makeBoundingBoxFromPoints(this.getCoords());
    }
    /**
   * Returns width of an object's bounding box counting transformations
   * @todo shouldn't this account for group transform and return the actual size in canvas coordinate plane?
   * @return {Number} width value
   */ getScaledWidth() {
        return this._getTransformedDimensions().x;
    }
    /**
   * Returns height of an object bounding box counting transformations
   * @todo shouldn't this account for group transform and return the actual size in canvas coordinate plane?
   * @return {Number} height value
   */ getScaledHeight() {
        return this._getTransformedDimensions().y;
    }
    /**
   * Scales an object (equally by x and y)
   * @param {Number} value Scale factor
   * @return {void}
   */ scale(value) {
        this._set($f268b97836dca6b6$var$SCALE_X, value);
        this._set($f268b97836dca6b6$var$SCALE_Y, value);
        this.setCoords();
    }
    /**
   * Scales an object to a given width, with respect to bounding box (scaling by x/y equally)
   * @param {Number} value New width value
   * @return {void}
   */ scaleToWidth(value) {
        // adjust to bounding rect factor so that rotated shapes would fit as well
        const boundingRectFactor = this.getBoundingRect().width / this.getScaledWidth();
        return this.scale(value / this.width / boundingRectFactor);
    }
    /**
   * Scales an object to a given height, with respect to bounding box (scaling by x/y equally)
   * @param {Number} value New height value
   * @return {void}
   */ scaleToHeight(value) {
        // adjust to bounding rect factor so that rotated shapes would fit as well
        const boundingRectFactor = this.getBoundingRect().height / this.getScaledHeight();
        return this.scale(value / this.height / boundingRectFactor);
    }
    getCanvasRetinaScaling() {
        var _this$canvas;
        return ((_this$canvas = this.canvas) === null || _this$canvas === void 0 ? void 0 : _this$canvas.getRetinaScaling()) || 1;
    }
    /**
   * Returns the object angle relative to canvas counting also the group property
   * @returns {TDegree}
   */ getTotalAngle() {
        return this.group ? $f268b97836dca6b6$var$radiansToDegrees($f268b97836dca6b6$var$calcPlaneRotation(this.calcTransformMatrix())) : this.angle;
    }
    /**
   * Retrieves viewportTransform from Object's canvas if available
   * @return {TMat2D}
   */ getViewportTransform() {
        var _this$canvas2;
        return ((_this$canvas2 = this.canvas) === null || _this$canvas2 === void 0 ? void 0 : _this$canvas2.viewportTransform) || $f268b97836dca6b6$export$3c5a7f9475b116e0.concat();
    }
    /**
   * Calculates the coordinates of the 4 corner of the bbox, in absolute coordinates.
   * those never change with zoom or viewport changes.
   * @return {TCornerPoint}
   */ calcACoords() {
        const rotateMatrix = $f268b97836dca6b6$var$createRotateMatrix({
            angle: this.angle
        }), { x: x, y: y } = this.getRelativeCenterPoint(), tMatrix = $f268b97836dca6b6$var$createTranslateMatrix(x, y), finalMatrix = $f268b97836dca6b6$var$multiplyTransformMatrices(tMatrix, rotateMatrix), dim = this._getTransformedDimensions(), w = dim.x / 2, h = dim.y / 2;
        return {
            // corners
            tl: $f268b97836dca6b6$var$transformPoint({
                x: -w,
                y: -h
            }, finalMatrix),
            tr: $f268b97836dca6b6$var$transformPoint({
                x: w,
                y: -h
            }, finalMatrix),
            bl: $f268b97836dca6b6$var$transformPoint({
                x: -w,
                y: h
            }, finalMatrix),
            br: $f268b97836dca6b6$var$transformPoint({
                x: w,
                y: h
            }, finalMatrix)
        };
    }
    /**
   * Sets corner and controls position coordinates based on current angle, width and height, left and top.
   * aCoords are used to quickly find an object on the canvas.
   * See {@link https://github.com/fabricjs/fabric.js/wiki/When-to-call-setCoords} and {@link http://fabricjs.com/fabric-gotchas}
   */ setCoords() {
        this.aCoords = this.calcACoords();
    }
    transformMatrixKey() {
        let skipGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        let prefix = [];
        if (!skipGroup && this.group) prefix = this.group.transformMatrixKey(skipGroup);
        prefix.push(this.top, this.left, this.width, this.height, this.scaleX, this.scaleY, this.angle, this.strokeWidth, this.skewX, this.skewY, +this.flipX, +this.flipY, $f268b97836dca6b6$var$resolveOrigin(this.originX), $f268b97836dca6b6$var$resolveOrigin(this.originY));
        return prefix;
    }
    /**
   * calculate transform matrix that represents the current transformations from the
   * object's properties.
   * @param {Boolean} [skipGroup] return transform matrix for object not counting parent transformations
   * There are some situation in which this is useful to avoid the fake rotation.
   * @return {TMat2D} transform matrix for the object
   */ calcTransformMatrix() {
        let skipGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        let matrix = this.calcOwnMatrix();
        if (skipGroup || !this.group) return matrix;
        const key = this.transformMatrixKey(skipGroup), cache = this.matrixCache;
        if (cache && cache.key.every((x, i)=>x === key[i])) return cache.value;
        if (this.group) matrix = $f268b97836dca6b6$var$multiplyTransformMatrices(this.group.calcTransformMatrix(false), matrix);
        this.matrixCache = {
            key: key,
            value: matrix
        };
        return matrix;
    }
    /**
   * calculate transform matrix that represents the current transformations from the
   * object's properties, this matrix does not include the group transformation
   * @return {TMat2D} transform matrix for the object
   */ calcOwnMatrix() {
        const key = this.transformMatrixKey(true), cache = this.ownMatrixCache;
        if (cache && cache.key === key) return cache.value;
        const center = this.getRelativeCenterPoint(), options = {
            angle: this.angle,
            translateX: center.x,
            translateY: center.y,
            scaleX: this.scaleX,
            scaleY: this.scaleY,
            skewX: this.skewX,
            skewY: this.skewY,
            flipX: this.flipX,
            flipY: this.flipY
        }, value = $f268b97836dca6b6$var$composeMatrix(options);
        this.ownMatrixCache = {
            key: key,
            value: value
        };
        return value;
    }
    /**
   * Calculate object dimensions from its properties
   * @private
   * @returns {Point} dimensions
   */ _getNonTransformedDimensions() {
        return new $f268b97836dca6b6$export$baf26146a414f24a(this.width, this.height).scalarAdd(this.strokeWidth);
    }
    /**
   * Calculate object dimensions for controls box, including padding and canvas zoom.
   * and active selection
   * @private
   * @param {object} [options] transform options
   * @returns {Point} dimensions
   */ _calculateCurrentDimensions(options) {
        return this._getTransformedDimensions(options).transform(this.getViewportTransform(), true).scalarAdd(2 * this.padding);
    }
    // #region Origin
    /**
   * @deprecated please use 'center' as value in new projects
   * */ /**
   * @deprecated please use 'center' as value in new projects
   * */ /**
   * Object containing this object.
   * can influence its size and position
   */ /**
   * Calculate object bounding box dimensions from its properties scale, skew.
   * This bounding box is aligned with object angle and not with canvas axis or screen.
   * @param {Object} [options]
   * @param {Number} [options.scaleX]
   * @param {Number} [options.scaleY]
   * @param {Number} [options.skewX]
   * @param {Number} [options.skewY]
   * @private
   * @returns {Point} dimensions
   */ _getTransformedDimensions() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const dimOptions = $f268b97836dca6b6$var$_objectSpread2({
            // if scaleX or scaleY are negative numbers,
            // this will return dimensions that are negative.
            // and this will break assumptions around the codebase
            scaleX: this.scaleX,
            scaleY: this.scaleY,
            skewX: this.skewX,
            skewY: this.skewY,
            width: this.width,
            height: this.height,
            strokeWidth: this.strokeWidth
        }, options);
        // stroke is applied before/after transformations are applied according to `strokeUniform`
        const strokeWidth = dimOptions.strokeWidth;
        let preScalingStrokeValue = strokeWidth, postScalingStrokeValue = 0;
        if (this.strokeUniform) {
            preScalingStrokeValue = 0;
            postScalingStrokeValue = strokeWidth;
        }
        const dimX = dimOptions.width + preScalingStrokeValue, dimY = dimOptions.height + preScalingStrokeValue, noSkew = dimOptions.skewX === 0 && dimOptions.skewY === 0;
        let finalDimensions;
        if (noSkew) finalDimensions = new $f268b97836dca6b6$export$baf26146a414f24a(dimX * dimOptions.scaleX, dimY * dimOptions.scaleY);
        else finalDimensions = $f268b97836dca6b6$var$sizeAfterTransform(dimX, dimY, $f268b97836dca6b6$var$calcDimensionsMatrix(dimOptions));
        return finalDimensions.scalarAdd(postScalingStrokeValue);
    }
    /**
   * Translates the coordinates from a set of origin to another (based on the object's dimensions)
   * @param {Point} point The point which corresponds to the originX and originY params
   * @param {TOriginX} fromOriginX Horizontal origin: 'left', 'center' or 'right'
   * @param {TOriginY} fromOriginY Vertical origin: 'top', 'center' or 'bottom'
   * @param {TOriginX} toOriginX Horizontal origin: 'left', 'center' or 'right'
   * @param {TOriginY} toOriginY Vertical origin: 'top', 'center' or 'bottom'
   * @return {Point}
   */ translateToGivenOrigin(point, fromOriginX, fromOriginY, toOriginX, toOriginY) {
        let x = point.x, y = point.y;
        const offsetX = $f268b97836dca6b6$var$resolveOrigin(toOriginX) - $f268b97836dca6b6$var$resolveOrigin(fromOriginX), offsetY = $f268b97836dca6b6$var$resolveOrigin(toOriginY) - $f268b97836dca6b6$var$resolveOrigin(fromOriginY);
        if (offsetX || offsetY) {
            const dim = this._getTransformedDimensions();
            x += offsetX * dim.x;
            y += offsetY * dim.y;
        }
        return new $f268b97836dca6b6$export$baf26146a414f24a(x, y);
    }
    /**
   * Translates the coordinates from origin to center coordinates (based on the object's dimensions)
   * @param {Point} point The point which corresponds to the originX and originY params
   * @param {TOriginX} originX Horizontal origin: 'left', 'center' or 'right'
   * @param {TOriginY} originY Vertical origin: 'top', 'center' or 'bottom'
   * @return {Point}
   */ translateToCenterPoint(point, originX, originY) {
        if (originX === $f268b97836dca6b6$var$CENTER && originY === $f268b97836dca6b6$var$CENTER) return point;
        const p = this.translateToGivenOrigin(point, originX, originY, $f268b97836dca6b6$var$CENTER, $f268b97836dca6b6$var$CENTER);
        if (this.angle) return p.rotate($f268b97836dca6b6$var$degreesToRadians(this.angle), point);
        return p;
    }
    /**
   * Translates the coordinates from center to origin coordinates (based on the object's dimensions)
   * @param {Point} center The point which corresponds to center of the object
   * @param {OriginX} originX Horizontal origin: 'left', 'center' or 'right'
   * @param {OriginY} originY Vertical origin: 'top', 'center' or 'bottom'
   * @return {Point}
   */ translateToOriginPoint(center, originX, originY) {
        const p = this.translateToGivenOrigin(center, $f268b97836dca6b6$var$CENTER, $f268b97836dca6b6$var$CENTER, originX, originY);
        if (this.angle) return p.rotate($f268b97836dca6b6$var$degreesToRadians(this.angle), center);
        return p;
    }
    /**
   * Returns the center coordinates of the object relative to canvas
   * @return {Point}
   */ getCenterPoint() {
        const relCenter = this.getRelativeCenterPoint();
        return this.group ? $f268b97836dca6b6$var$transformPoint(relCenter, this.group.calcTransformMatrix()) : relCenter;
    }
    /**
   * Returns the center coordinates of the object relative to it's parent
   * @return {Point}
   */ getRelativeCenterPoint() {
        return this.translateToCenterPoint(new $f268b97836dca6b6$export$baf26146a414f24a(this.left, this.top), this.originX, this.originY);
    }
    /**
   * Returns the position of the object as if it has a different origin.
   * Take an object that has left, top set to 100, 100 with origin 'left', 'top'.
   * Return the values of left top ( wrapped in a point ) that you would need to keep
   * the same position if origin where different.
   * Alternatively you can use this to also find which point in the parent plane is a specific origin
   * ( where is the bottom right corner of my object? )
   * @param {TOriginX} originX Horizontal origin: 'left', 'center' or 'right'
   * @param {TOriginY} originY Vertical origin: 'top', 'center' or 'bottom'
   * @return {Point}
   */ getPointByOrigin(originX, originY) {
        return this.translateToOriginPoint(this.getRelativeCenterPoint(), originX, originY);
    }
    /**
   * Sets the position of the object taking into consideration the object's origin
   * @param {Point} pos The new position of the object
   * @param {TOriginX} originX Horizontal origin: 'left', 'center' or 'right'
   * @param {TOriginY} originY Vertical origin: 'top', 'center' or 'bottom'
   * @return {void}
   */ setPositionByOrigin(pos, originX, originY) {
        const center = this.translateToCenterPoint(pos, originX, originY), position = this.translateToOriginPoint(center, this.originX, this.originY);
        this.set({
            left: position.x,
            top: position.y
        });
    }
    /**
   * @private
   */ _getLeftTopCoords() {
        return this.translateToOriginPoint(this.getRelativeCenterPoint(), $f268b97836dca6b6$var$LEFT, $f268b97836dca6b6$var$TOP);
    }
}
const $f268b97836dca6b6$var$_excluded$e = [
    "type"
], $f268b97836dca6b6$var$_excluded2$4 = [
    "extraParam"
];
/**
 * Root object class from which all 2d shape classes inherit from
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#objects}
 *
 * @fires added
 * @fires removed
 *
 * @fires selected
 * @fires deselected
 *
 * @fires rotating
 * @fires scaling
 * @fires moving
 * @fires skewing
 * @fires modified
 *
 * @fires mousedown
 * @fires mouseup
 * @fires mouseover
 * @fires mouseout
 * @fires mousewheel
 * @fires mousedblclick
 *
 * @fires dragover
 * @fires dragenter
 * @fires dragleave
 * @fires drop
 */ let $f268b97836dca6b6$export$c2d2360b5ec84692 = class FabricObject extends $f268b97836dca6b6$var$ObjectGeometry {
    static getDefaults() {
        return FabricObject.ownDefaults;
    }
    /**
   * The class type.
   * This is used for serialization and deserialization purposes and internally it can be used
   * to identify classes.
   * When we transform a class in a plain JS object we need a way to recognize which class it was,
   * and the type is the way we do that. It has no other purposes and you should not give one.
   * Hard to reach on instances and please do not use to drive instance's logic (this.constructor.type).
   * To idenfity a class use instanceof class ( instanceof Rect ).
   * We do not do that in fabricJS code because we want to try to have code splitting possible.
   */ /**
   * Legacy identifier of the class. Prefer using utils like isType or instanceOf
   * Will be removed in fabric 7 or 8.
   * The setter exists to avoid type errors in old code and possibly current deserialization code.
   * DO NOT build new code around this type value
   * @TODO add sustainable warning message
   * @type string
   * @deprecated
   */ get type() {
        const name = this.constructor.type;
        if (name === 'FabricObject') return 'object';
        return name.toLowerCase();
    }
    set type(value) {
        $f268b97836dca6b6$var$log('warn', 'Setting type has no effect', value);
    }
    /**
   * Create a the canvas used to keep the cached copy of the object
   * @private
   */ _createCacheCanvas() {
        this._cacheCanvas = $f268b97836dca6b6$var$createCanvasElement();
        this._cacheContext = this._cacheCanvas.getContext('2d');
        this._updateCacheCanvas();
        // if canvas gets created, is empty, so dirty.
        this.dirty = true;
    }
    /**
   * Limit the cache dimensions so that X * Y do not cross config.perfLimitSizeTotal
   * and each side do not cross fabric.cacheSideLimit
   * those numbers are configurable so that you can get as much detail as you want
   * making bargain with performances.
   * @param {Object} dims
   * @param {Object} dims.width width of canvas
   * @param {Object} dims.height height of canvas
   * @param {Object} dims.zoomX zoomX zoom value to unscale the canvas before drawing cache
   * @param {Object} dims.zoomY zoomY zoom value to unscale the canvas before drawing cache
   * @return {Object}.width width of canvas
   * @return {Object}.height height of canvas
   * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
   * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
   */ _limitCacheSize(dims) {
        const width = dims.width, height = dims.height, max = $f268b97836dca6b6$export$e506a1d27d1eaa20.maxCacheSideLimit, min = $f268b97836dca6b6$export$e506a1d27d1eaa20.minCacheSideLimit;
        if (width <= max && height <= max && width * height <= $f268b97836dca6b6$export$e506a1d27d1eaa20.perfLimitSizeTotal) {
            if (width < min) dims.width = min;
            if (height < min) dims.height = min;
            return dims;
        }
        const ar = width / height, [limX, limY] = $f268b97836dca6b6$export$69a3209f1a06c04d.limitDimsByArea(ar), x = $f268b97836dca6b6$var$capValue(min, limX, max), y = $f268b97836dca6b6$var$capValue(min, limY, max);
        if (width > x) {
            dims.zoomX /= width / x;
            dims.width = x;
            dims.capped = true;
        }
        if (height > y) {
            dims.zoomY /= height / y;
            dims.height = y;
            dims.capped = true;
        }
        return dims;
    }
    /**
   * Return the dimension and the zoom level needed to create a cache canvas
   * big enough to host the object to be cached.
   * @private
   * @return {Object}.x width of object to be cached
   * @return {Object}.y height of object to be cached
   * @return {Object}.width width of canvas
   * @return {Object}.height height of canvas
   * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
   * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
   */ _getCacheCanvasDimensions() {
        const objectScale = this.getTotalObjectScaling(), // calculate dimensions without skewing
        dim = this._getTransformedDimensions({
            skewX: 0,
            skewY: 0
        }), neededX = dim.x * objectScale.x / this.scaleX, neededY = dim.y * objectScale.y / this.scaleY;
        return {
            // for sure this ALIASING_LIMIT is slightly creating problem
            // in situation in which the cache canvas gets an upper limit
            // also objectScale contains already scaleX and scaleY
            width: Math.ceil(neededX + $f268b97836dca6b6$var$ALIASING_LIMIT),
            height: Math.ceil(neededY + $f268b97836dca6b6$var$ALIASING_LIMIT),
            zoomX: objectScale.x,
            zoomY: objectScale.y,
            x: neededX,
            y: neededY
        };
    }
    /**
   * Update width and height of the canvas for cache
   * returns true or false if canvas needed resize.
   * @private
   * @return {Boolean} true if the canvas has been resized
   */ _updateCacheCanvas() {
        const canvas = this._cacheCanvas, context = this._cacheContext, { width: width, height: height, zoomX: zoomX, zoomY: zoomY, x: x, y: y } = this._limitCacheSize(this._getCacheCanvasDimensions()), dimensionsChanged = width !== canvas.width || height !== canvas.height, zoomChanged = this.zoomX !== zoomX || this.zoomY !== zoomY;
        if (!canvas || !context) return false;
        const shouldRedraw = dimensionsChanged || zoomChanged;
        if (shouldRedraw) {
            if (width !== canvas.width || height !== canvas.height) {
                canvas.width = width;
                canvas.height = height;
            } else {
                context.setTransform(1, 0, 0, 1, 0, 0);
                context.clearRect(0, 0, canvas.width, canvas.height);
            }
            const drawingWidth = x / 2;
            const drawingHeight = y / 2;
            this.cacheTranslationX = Math.round(canvas.width / 2 - drawingWidth) + drawingWidth;
            this.cacheTranslationY = Math.round(canvas.height / 2 - drawingHeight) + drawingHeight;
            context.translate(this.cacheTranslationX, this.cacheTranslationY);
            context.scale(zoomX, zoomY);
            this.zoomX = zoomX;
            this.zoomY = zoomY;
            return true;
        }
        return false;
    }
    /**
   * Sets object's properties from options, for class constructor only.
   * Needs to be overridden for different defaults.
   * @protected
   * @param {Object} [options] Options object
   */ setOptions() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this._setOptions(options);
    }
    /**
   * Transforms context when rendering an object
   * @param {CanvasRenderingContext2D} ctx Context
   */ transform(ctx) {
        const needFullTransform = this.group && !this.group._transformDone || this.group && this.canvas && ctx === this.canvas.contextTop;
        const m = this.calcTransformMatrix(!needFullTransform);
        ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
    }
    /**
   * Return the object scale factor counting also the group scaling
   * @return {Point}
   */ getObjectScaling() {
        // if the object is a top level one, on the canvas, we go for simple aritmetic
        // otherwise the complex method with angles will return approximations and decimals
        // and will likely kill the cache when not needed
        // https://github.com/fabricjs/fabric.js/issues/7157
        if (!this.group) return new $f268b97836dca6b6$export$baf26146a414f24a(Math.abs(this.scaleX), Math.abs(this.scaleY));
        // if we are inside a group total zoom calculation is complex, we defer to generic matrices
        const options = $f268b97836dca6b6$var$qrDecompose(this.calcTransformMatrix());
        return new $f268b97836dca6b6$export$baf26146a414f24a(Math.abs(options.scaleX), Math.abs(options.scaleY));
    }
    /**
   * Return the object scale factor counting also the group scaling, zoom and retina
   * @return {Object} object with scaleX and scaleY properties
   */ getTotalObjectScaling() {
        const scale = this.getObjectScaling();
        if (this.canvas) {
            const zoom = this.canvas.getZoom();
            const retina = this.getCanvasRetinaScaling();
            return scale.scalarMultiply(zoom * retina);
        }
        return scale;
    }
    /**
   * Return the object opacity counting also the group property
   * @return {Number}
   */ getObjectOpacity() {
        let opacity = this.opacity;
        if (this.group) opacity *= this.group.getObjectOpacity();
        return opacity;
    }
    /**
   * Makes sure the scale is valid and modifies it if necessary
   * @todo: this is a control action issue, not a geometry one
   * @private
   * @param {Number} value, unconstrained
   * @return {Number} constrained value;
   */ _constrainScale(value) {
        if (Math.abs(value) < this.minScaleLimit) {
            if (value < 0) return -this.minScaleLimit;
            else return this.minScaleLimit;
        } else if (value === 0) return 0.0001;
        return value;
    }
    /**
   * Handles setting values on the instance and handling internal side effects
   * @protected
   * @param {String} key
   * @param {*} value
   */ _set(key, value) {
        if (key === $f268b97836dca6b6$var$SCALE_X || key === $f268b97836dca6b6$var$SCALE_Y) value = this._constrainScale(value);
        if (key === $f268b97836dca6b6$var$SCALE_X && value < 0) {
            this.flipX = !this.flipX;
            value *= -1;
        } else if (key === 'scaleY' && value < 0) {
            this.flipY = !this.flipY;
            value *= -1;
        // i don't like this automatic initialization here
        } else if (key === 'shadow' && value && !(value instanceof $f268b97836dca6b6$export$a24c14443968327c)) value = new $f268b97836dca6b6$export$a24c14443968327c(value);
        const isChanged = this[key] !== value;
        this[key] = value;
        // invalidate caches
        if (isChanged && this.constructor.cacheProperties.includes(key)) this.dirty = true;
        // a dirty child makes the parent dirty.
        // but a non dirty child does not make the parent not dirty.
        // the parent could be dirty for some other reason.
        this.parent && (this.dirty || isChanged && this.constructor.stateProperties.includes(key)) && this.parent._set('dirty', true);
        return this;
    }
    /*
   * @private
   * return if the object would be visible in rendering
   * @memberOf FabricObject.prototype
   * @return {Boolean}
   */ isNotVisible() {
        return this.opacity === 0 || !this.width && !this.height && this.strokeWidth === 0 || !this.visible;
    }
    /**
   * Renders an object on a specified context
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ render(ctx) {
        // do not render if width/height are zeros or object is not visible
        if (this.isNotVisible()) return;
        if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) return;
        ctx.save();
        this._setupCompositeOperation(ctx);
        this.drawSelectionBackground(ctx);
        this.transform(ctx);
        this._setOpacity(ctx);
        this._setShadow(ctx);
        if (this.shouldCache()) {
            this.renderCache();
            this.drawCacheOnCanvas(ctx);
        } else {
            this._removeCacheCanvas();
            this.drawObject(ctx, false, {});
            this.dirty = false;
        }
        ctx.restore();
    }
    drawSelectionBackground(_ctx) {
    /* no op */ }
    renderCache(options) {
        options = options || {};
        if (!this._cacheCanvas || !this._cacheContext) this._createCacheCanvas();
        if (this.isCacheDirty() && this._cacheContext) {
            const { zoomX: zoomX, zoomY: zoomY, cacheTranslationX: cacheTranslationX, cacheTranslationY: cacheTranslationY } = this;
            const { width: width, height: height } = this._cacheCanvas;
            this.drawObject(this._cacheContext, options.forClipping, {
                zoomX: zoomX,
                zoomY: zoomY,
                cacheTranslationX: cacheTranslationX,
                cacheTranslationY: cacheTranslationY,
                width: width,
                height: height,
                parentClipPaths: []
            });
            this.dirty = false;
        }
    }
    /**
   * Remove cacheCanvas and its dimensions from the objects
   */ _removeCacheCanvas() {
        this._cacheCanvas = undefined;
        this._cacheContext = null;
    }
    /**
   * return true if the object will draw a stroke
   * Does not consider text styles. This is just a shortcut used at rendering time
   * We want it to be an approximation and be fast.
   * wrote to avoid extra caching, it has to return true when stroke happens,
   * can guess when it will not happen at 100% chance, does not matter if it misses
   * some use case where the stroke is invisible.
   * @since 3.0.0
   * @returns Boolean
   */ hasStroke() {
        return this.stroke && this.stroke !== 'transparent' && this.strokeWidth !== 0;
    }
    /**
   * return true if the object will draw a fill
   * Does not consider text styles. This is just a shortcut used at rendering time
   * We want it to be an approximation and be fast.
   * wrote to avoid extra caching, it has to return true when fill happens,
   * can guess when it will not happen at 100% chance, does not matter if it misses
   * some use case where the fill is invisible.
   * @since 3.0.0
   * @returns Boolean
   */ hasFill() {
        return this.fill && this.fill !== 'transparent';
    }
    /**
   * When returns `true`, force the object to have its own cache, even if it is inside a group
   * it may be needed when your object behave in a particular way on the cache and always needs
   * its own isolated canvas to render correctly.
   * Created to be overridden
   * since 1.7.12
   * @returns Boolean
   */ needsItsOwnCache() {
        // TODO re-evaluate this shadow condition
        if (this.paintFirst === $f268b97836dca6b6$var$STROKE && this.hasFill() && this.hasStroke() && !!this.shadow) return true;
        if (this.clipPath) return true;
        return false;
    }
    /**
   * Decide if the object should cache or not. Create its own cache level
   * objectCaching is a global flag, wins over everything
   * needsItsOwnCache should be used when the object drawing method requires
   * a cache step.
   * Generally you do not cache objects in groups because the group outside is cached.
   * Read as: cache if is needed, or if the feature is enabled but we are not already caching.
   * @return {Boolean}
   */ shouldCache() {
        this.ownCaching = this.objectCaching && (!this.parent || !this.parent.isOnACache()) || this.needsItsOwnCache();
        return this.ownCaching;
    }
    /**
   * Check if this object will cast a shadow with an offset.
   * used by Group.shouldCache to know if child has a shadow recursively
   * @return {Boolean}
   * @deprecated
   */ willDrawShadow() {
        return !!this.shadow && (this.shadow.offsetX !== 0 || this.shadow.offsetY !== 0);
    }
    /**
   * Execute the drawing operation for an object clipPath
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {FabricObject} clipPath
   */ drawClipPathOnCache(ctx, clipPath, canvasWithClipPath) {
        ctx.save();
        // DEBUG: uncomment this line, comment the following
        // ctx.globalAlpha = 0.4
        if (clipPath.inverted) ctx.globalCompositeOperation = 'destination-out';
        else ctx.globalCompositeOperation = 'destination-in';
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(canvasWithClipPath, 0, 0);
        ctx.restore();
    }
    /**
   * Execute the drawing operation for an object on a specified context
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {boolean} forClipping apply clipping styles
   * @param {DrawContext} context additional context for rendering
   */ drawObject(ctx, forClipping, context) {
        const originalFill = this.fill, originalStroke = this.stroke;
        if (forClipping) {
            this.fill = 'black';
            this.stroke = '';
            this._setClippingProperties(ctx);
        } else this._renderBackground(ctx);
        this._render(ctx);
        this._drawClipPath(ctx, this.clipPath, context);
        this.fill = originalFill;
        this.stroke = originalStroke;
    }
    createClipPathLayer(clipPath, context) {
        const canvas = $f268b97836dca6b6$var$createCanvasElementFor(context);
        const ctx = canvas.getContext('2d');
        ctx.translate(context.cacheTranslationX, context.cacheTranslationY);
        ctx.scale(context.zoomX, context.zoomY);
        clipPath._cacheCanvas = canvas;
        context.parentClipPaths.forEach((prevClipPath)=>{
            prevClipPath.transform(ctx);
        });
        context.parentClipPaths.push(clipPath);
        if (clipPath.absolutePositioned) {
            const m = $f268b97836dca6b6$var$invertTransform(this.calcTransformMatrix());
            ctx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        }
        clipPath.transform(ctx);
        clipPath.drawObject(ctx, true, context);
        return canvas;
    }
    /**
   * Prepare clipPath state and cache and draw it on instance's cache
   * @param {CanvasRenderingContext2D} ctx
   * @param {FabricObject} clipPath
   */ _drawClipPath(ctx, clipPath, context) {
        if (!clipPath) return;
        // needed to setup _transformDone
        // TODO find a better solution?
        clipPath._transformDone = true;
        const canvas = this.createClipPathLayer(clipPath, context);
        this.drawClipPathOnCache(ctx, clipPath, canvas);
    }
    /**
   * Paint the cached copy of the object on the target context.
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ drawCacheOnCanvas(ctx) {
        ctx.scale(1 / this.zoomX, 1 / this.zoomY);
        ctx.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
    }
    /**
   * Check if cache is dirty and if is dirty clear the context.
   * This check has a big side effect, it changes the underlying cache canvas if necessary.
   * Do not call this method on your own to check if the cache is dirty, because if it is,
   * it is also going to wipe the cache. This is badly designed and needs to be fixed.
   * @param {Boolean} skipCanvas skip canvas checks because this object is painted
   * on parent canvas.
   */ isCacheDirty() {
        let skipCanvas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        if (this.isNotVisible()) return false;
        const canvas = this._cacheCanvas;
        const ctx = this._cacheContext;
        if (canvas && ctx && !skipCanvas && this._updateCacheCanvas()) // in this case the context is already cleared.
        return true;
        else if (this.dirty || this.clipPath && this.clipPath.absolutePositioned) {
            if (canvas && ctx && !skipCanvas) {
                ctx.save();
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.clearRect(0, 0, canvas.width, canvas.height);
                ctx.restore();
            }
            return true;
        }
        return false;
    }
    /**
   * Draws a background for the object big as its untransformed dimensions
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderBackground(ctx) {
        if (!this.backgroundColor) return;
        const dim = this._getNonTransformedDimensions();
        ctx.fillStyle = this.backgroundColor;
        ctx.fillRect(-dim.x / 2, -dim.y / 2, dim.x, dim.y);
        // if there is background color no other shadows
        // should be casted
        this._removeShadow(ctx);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _setOpacity(ctx) {
        if (this.group && !this.group._transformDone) ctx.globalAlpha = this.getObjectOpacity();
        else ctx.globalAlpha *= this.opacity;
    }
    _setStrokeStyles(ctx, decl) {
        const stroke = decl.stroke;
        if (stroke) {
            ctx.lineWidth = decl.strokeWidth;
            ctx.lineCap = decl.strokeLineCap;
            ctx.lineDashOffset = decl.strokeDashOffset;
            ctx.lineJoin = decl.strokeLineJoin;
            ctx.miterLimit = decl.strokeMiterLimit;
            if ($f268b97836dca6b6$var$isFiller(stroke)) {
                if (stroke.gradientUnits === 'percentage' || stroke.gradientTransform || stroke.patternTransform) // need to transform gradient in a pattern.
                // this is a slow process. If you are hitting this codepath, and the object
                // is not using caching, you should consider switching it on.
                // we need a canvas as big as the current object caching canvas.
                this._applyPatternForTransformedGradient(ctx, stroke);
                else {
                    // is a simple gradient or pattern
                    ctx.strokeStyle = stroke.toLive(ctx);
                    this._applyPatternGradientTransform(ctx, stroke);
                }
            } else // is a color
            ctx.strokeStyle = decl.stroke;
        }
    }
    _setFillStyles(ctx, _ref) {
        let { fill: fill } = _ref;
        if (fill) {
            if ($f268b97836dca6b6$var$isFiller(fill)) {
                ctx.fillStyle = fill.toLive(ctx);
                this._applyPatternGradientTransform(ctx, fill);
            } else ctx.fillStyle = fill;
        }
    }
    _setClippingProperties(ctx) {
        ctx.globalAlpha = 1;
        ctx.strokeStyle = 'transparent';
        ctx.fillStyle = '#000000';
    }
    /**
   * @private
   * Sets line dash
   * @param {CanvasRenderingContext2D} ctx Context to set the dash line on
   * @param {Array} dashArray array representing dashes
   */ _setLineDash(ctx, dashArray) {
        if (!dashArray || dashArray.length === 0) return;
        ctx.setLineDash(dashArray);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _setShadow(ctx) {
        if (!this.shadow) return;
        const shadow = this.shadow, canvas = this.canvas, retinaScaling = this.getCanvasRetinaScaling(), [sx, , , sy] = (canvas === null || canvas === void 0 ? void 0 : canvas.viewportTransform) || $f268b97836dca6b6$export$3c5a7f9475b116e0, multX = sx * retinaScaling, multY = sy * retinaScaling, scaling = shadow.nonScaling ? new $f268b97836dca6b6$export$baf26146a414f24a(1, 1) : this.getObjectScaling();
        ctx.shadowColor = shadow.color;
        ctx.shadowBlur = shadow.blur * $f268b97836dca6b6$export$e506a1d27d1eaa20.browserShadowBlurConstant * (multX + multY) * (scaling.x + scaling.y) / 4;
        ctx.shadowOffsetX = shadow.offsetX * multX * scaling.x;
        ctx.shadowOffsetY = shadow.offsetY * multY * scaling.y;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _removeShadow(ctx) {
        if (!this.shadow) return;
        ctx.shadowColor = '';
        ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {TFiller} filler {@link Pattern} or {@link Gradient}
   */ _applyPatternGradientTransform(ctx, filler) {
        if (!$f268b97836dca6b6$var$isFiller(filler)) return {
            offsetX: 0,
            offsetY: 0
        };
        const t = filler.gradientTransform || filler.patternTransform;
        const offsetX = -this.width / 2 + filler.offsetX || 0, offsetY = -this.height / 2 + filler.offsetY || 0;
        if (filler.gradientUnits === 'percentage') ctx.transform(this.width, 0, 0, this.height, offsetX, offsetY);
        else ctx.transform(1, 0, 0, 1, offsetX, offsetY);
        if (t) ctx.transform(t[0], t[1], t[2], t[3], t[4], t[5]);
        return {
            offsetX: offsetX,
            offsetY: offsetY
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderPaintInOrder(ctx) {
        if (this.paintFirst === $f268b97836dca6b6$var$STROKE) {
            this._renderStroke(ctx);
            this._renderFill(ctx);
        } else {
            this._renderFill(ctx);
            this._renderStroke(ctx);
        }
    }
    /**
   * @private
   * function that actually render something on the context.
   * empty here to allow Obects to work on tests to benchmark fabric functionalites
   * not related to rendering
   * @param {CanvasRenderingContext2D} _ctx Context to render on
   */ _render(_ctx) {
    // placeholder to be overridden
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderFill(ctx) {
        if (!this.fill) return;
        ctx.save();
        this._setFillStyles(ctx, this);
        if (this.fillRule === 'evenodd') ctx.fill('evenodd');
        else ctx.fill();
        ctx.restore();
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderStroke(ctx) {
        if (!this.stroke || this.strokeWidth === 0) return;
        if (this.shadow && !this.shadow.affectStroke) this._removeShadow(ctx);
        ctx.save();
        if (this.strokeUniform) {
            const scaling = this.getObjectScaling();
            ctx.scale(1 / scaling.x, 1 / scaling.y);
        }
        this._setLineDash(ctx, this.strokeDashArray);
        this._setStrokeStyles(ctx, this);
        ctx.stroke();
        ctx.restore();
    }
    /**
   * This function try to patch the missing gradientTransform on canvas gradients.
   * transforming a context to transform the gradient, is going to transform the stroke too.
   * we want to transform the gradient but not the stroke operation, so we create
   * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
   * this method has drawbacks: is slow, is in low resolution, needs a patch for when the size
   * is limited.
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {Gradient} filler
   */ _applyPatternForTransformedGradient(ctx, filler) {
        var _pCtx$createPattern;
        const dims = this._limitCacheSize(this._getCacheCanvasDimensions()), retinaScaling = this.getCanvasRetinaScaling(), width = dims.x / this.scaleX / retinaScaling, height = dims.y / this.scaleY / retinaScaling, pCanvas = $f268b97836dca6b6$var$createCanvasElementFor({
            // in case width and height are less than 1px, we have to round up.
            // since the pattern is no-repeat, this is fine
            width: Math.ceil(width),
            height: Math.ceil(height)
        });
        const pCtx = pCanvas.getContext('2d');
        if (!pCtx) return;
        pCtx.beginPath();
        pCtx.moveTo(0, 0);
        pCtx.lineTo(width, 0);
        pCtx.lineTo(width, height);
        pCtx.lineTo(0, height);
        pCtx.closePath();
        pCtx.translate(width / 2, height / 2);
        pCtx.scale(dims.zoomX / this.scaleX / retinaScaling, dims.zoomY / this.scaleY / retinaScaling);
        this._applyPatternGradientTransform(pCtx, filler);
        pCtx.fillStyle = filler.toLive(ctx);
        pCtx.fill();
        ctx.translate(-this.width / 2 - this.strokeWidth / 2, -this.height / 2 - this.strokeWidth / 2);
        ctx.scale(retinaScaling * this.scaleX / dims.zoomX, retinaScaling * this.scaleY / dims.zoomY);
        ctx.strokeStyle = (_pCtx$createPattern = pCtx.createPattern(pCanvas, 'no-repeat')) !== null && _pCtx$createPattern !== void 0 ? _pCtx$createPattern : '';
    }
    /**
   * This function is an helper for svg import. it returns the center of the object in the svg
   * untransformed coordinates
   * @private
   * @return {Point} center point from element coordinates
   */ _findCenterFromElement() {
        return new $f268b97836dca6b6$export$baf26146a414f24a(this.left + this.width / 2, this.top + this.height / 2);
    }
    /**
   * Clones an instance.
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @returns {Promise<FabricObject>}
   */ clone(propertiesToInclude) {
        const objectForm = this.toObject(propertiesToInclude);
        return this.constructor.fromObject(objectForm);
    }
    /**
   * Creates an instance of Image out of an object
   * makes use of toCanvasElement.
   * Once this method was based on toDataUrl and loadImage, so it also had a quality
   * and format option. toCanvasElement is faster and produce no loss of quality.
   * If you need to get a real Jpeg or Png from an object, using toDataURL is the right way to do it.
   * toCanvasElement and then toBlob from the obtained canvas is also a good option.
   * @todo fix the export type, it could not be Image but the type that getClass return for 'image'.
   * @param {ObjectToCanvasElementOptions} [options] for clone as image, passed to toDataURL
   * @param {Number} [options.multiplier=1] Multiplier to scale by
   * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
   * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
   * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
   * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
   * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
   * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
   * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
   * @return {FabricImage} Object cloned as image.
   */ cloneAsImage(options) {
        const canvasEl = this.toCanvasElement(options);
        // TODO: how to import Image w/o an import cycle?
        const ImageClass = $f268b97836dca6b6$export$2792378e23a7920c.getClass('image');
        return new ImageClass(canvasEl);
    }
    /**
   * Converts an object into a HTMLCanvas element
   * @param {ObjectToCanvasElementOptions} options Options object
   * @param {Number} [options.multiplier=1] Multiplier to scale by
   * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
   * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
   * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
   * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
   * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
   * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
   * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
   * @param {Boolean} [options.viewportTransform] Account for canvas viewport transform
   * @param {(el?: HTMLCanvasElement) => StaticCanvas} [options.canvasProvider] Create the output canvas
   * @return {HTMLCanvasElement} Returns DOM element <canvas> with the FabricObject
   */ toCanvasElement() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const origParams = $f268b97836dca6b6$var$saveObjectTransform(this), originalGroup = this.group, originalShadow = this.shadow, abs = Math.abs, retinaScaling = options.enableRetinaScaling ? $f268b97836dca6b6$var$getDevicePixelRatio() : 1, multiplier = (options.multiplier || 1) * retinaScaling, canvasProvider = options.canvasProvider || ((el)=>new $f268b97836dca6b6$export$ad01921fb0b1386e(el, {
                enableRetinaScaling: false,
                renderOnAddRemove: false,
                skipOffscreen: false
            }));
        delete this.group;
        if (options.withoutTransform) $f268b97836dca6b6$var$resetObjectTransform(this);
        if (options.withoutShadow) this.shadow = null;
        if (options.viewportTransform) $f268b97836dca6b6$var$sendObjectToPlane(this, this.getViewportTransform());
        this.setCoords();
        const el = $f268b97836dca6b6$var$createCanvasElement(), boundingRect = this.getBoundingRect(), shadow = this.shadow, shadowOffset = new $f268b97836dca6b6$export$baf26146a414f24a();
        if (shadow) {
            const shadowBlur = shadow.blur;
            const scaling = shadow.nonScaling ? new $f268b97836dca6b6$export$baf26146a414f24a(1, 1) : this.getObjectScaling();
            // consider non scaling shadow.
            shadowOffset.x = 2 * Math.round(abs(shadow.offsetX) + shadowBlur) * abs(scaling.x);
            shadowOffset.y = 2 * Math.round(abs(shadow.offsetY) + shadowBlur) * abs(scaling.y);
        }
        const width = boundingRect.width + shadowOffset.x, height = boundingRect.height + shadowOffset.y;
        // if the current width/height is not an integer
        // we need to make it so.
        el.width = Math.ceil(width);
        el.height = Math.ceil(height);
        const canvas = canvasProvider(el);
        if (options.format === 'jpeg') canvas.backgroundColor = '#fff';
        this.setPositionByOrigin(new $f268b97836dca6b6$export$baf26146a414f24a(canvas.width / 2, canvas.height / 2), $f268b97836dca6b6$var$CENTER, $f268b97836dca6b6$var$CENTER);
        const originalCanvas = this.canvas;
        // static canvas and canvas have both an array of InteractiveObjects
        // @ts-expect-error this needs to be fixed somehow, or ignored globally
        canvas._objects = [
            this
        ];
        this.set('canvas', canvas);
        this.setCoords();
        const canvasEl = canvas.toCanvasElement(multiplier || 1, options);
        this.set('canvas', originalCanvas);
        this.shadow = originalShadow;
        if (originalGroup) this.group = originalGroup;
        this.set(origParams);
        this.setCoords();
        // canvas.dispose will call image.dispose that will nullify the elements
        // since this canvas is a simple element for the process, we remove references
        // to objects in this way in order to avoid object trashing.
        canvas._objects = [];
        // since render has settled it is safe to destroy canvas
        canvas.destroy();
        return canvasEl;
    }
    /**
   * Converts an object into a data-url-like string
   * @param {Object} options Options object
   * @param {String} [options.format=png] The format of the output image. Either "jpeg" or "png"
   * @param {Number} [options.quality=1] Quality level (0..1). Only used for jpeg.
   * @param {Number} [options.multiplier=1] Multiplier to scale by
   * @param {Number} [options.left] Cropping left offset. Introduced in v1.2.14
   * @param {Number} [options.top] Cropping top offset. Introduced in v1.2.14
   * @param {Number} [options.width] Cropping width. Introduced in v1.2.14
   * @param {Number} [options.height] Cropping height. Introduced in v1.2.14
   * @param {Boolean} [options.enableRetinaScaling] Enable retina scaling for clone image. Introduce in 1.6.4
   * @param {Boolean} [options.withoutTransform] Remove current object transform ( no scale , no angle, no flip, no skew ). Introduced in 2.3.4
   * @param {Boolean} [options.withoutShadow] Remove current object shadow. Introduced in 2.4.2
   * @return {String} Returns a data: URL containing a representation of the object in the format specified by options.format
   */ toDataURL() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return $f268b97836dca6b6$var$toDataURL(this.toCanvasElement(options), options.format || 'png', options.quality || 1);
    }
    toBlob() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return $f268b97836dca6b6$var$toBlob(this.toCanvasElement(options), options.format || 'png', options.quality || 1);
    }
    /**
   * Returns true if any of the specified types is identical to the type of an instance
   * @param {String} type Type to check against
   * @return {Boolean}
   */ isType() {
        for(var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++)types[_key] = arguments[_key];
        return types.includes(this.constructor.type) || types.includes(this.type);
    }
    /**
   * Returns complexity of an instance
   * @return {Number} complexity of this instance (is 1 unless subclassed)
   */ complexity() {
        return 1;
    }
    /**
   * Returns a JSON representation of an instance
   * @return {Object} JSON
   */ toJSON() {
        // delegate, not alias
        return this.toObject();
    }
    /**
   * Sets "angle" of an instance with centered rotation
   * @param {TDegree} angle Angle value (in degrees)
   */ rotate(angle) {
        const { centeredRotation: centeredRotation, originX: originX, originY: originY } = this;
        if (centeredRotation) {
            const { x: x, y: y } = this.getRelativeCenterPoint();
            this.originX = $f268b97836dca6b6$var$CENTER;
            this.originY = $f268b97836dca6b6$var$CENTER;
            this.left = x;
            this.top = y;
        }
        this.set('angle', angle);
        if (centeredRotation) {
            const { x: x, y: y } = this.translateToOriginPoint(this.getRelativeCenterPoint(), originX, originY);
            this.left = x;
            this.top = y;
            this.originX = originX;
            this.originY = originY;
        }
    }
    /**
   * This callback function is called by the parent group of an object every
   * time a non-delegated property changes on the group. It is passed the key
   * and value as parameters. Not adding in this function's signature to avoid
   * Travis build error about unused variables.
   */ setOnGroup() {
    // implemented by sub-classes, as needed.
    }
    /**
   * Sets canvas globalCompositeOperation for specific object
   * custom composition operation for the particular object can be specified using globalCompositeOperation property
   * @param {CanvasRenderingContext2D} ctx Rendering canvas context
   */ _setupCompositeOperation(ctx) {
        if (this.globalCompositeOperation) ctx.globalCompositeOperation = this.globalCompositeOperation;
    }
    /**
   * cancel instance's running animations
   * override if necessary to dispose artifacts such as `clipPath`
   */ dispose() {
        $f268b97836dca6b6$export$dc18923894d9e56a.cancelByTarget(this);
        this.off();
        this._set('canvas', undefined);
        // clear caches
        this._cacheCanvas && $f268b97836dca6b6$export$4bd44a2aa29d3d6e().dispose(this._cacheCanvas);
        this._cacheCanvas = undefined;
        this._cacheContext = null;
    }
    // #region Animation methods
    /**
   * List of properties to consider for animating colors.
   * @type String[]
   */ /**
   * Animates object's properties
   * @param {Record<string, number | number[] | TColorArg>} animatable map of keys and end values
   * @param {Partial<AnimationOptions<T>>} options
   * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#animation}
   * @return {Record<string, TAnimation<T>>} map of animation contexts
   *
   * As object — multiple properties
   *
   * object.animate({ left: ..., top: ... });
   * object.animate({ left: ..., top: ... }, { duration: ... });
   */ animate(animatable, options) {
        return Object.entries(animatable).reduce((acc, _ref2)=>{
            let [key, endValue] = _ref2;
            acc[key] = this._animate(key, endValue, options);
            return acc;
        }, {});
    }
    /**
   * @private
   * @param {String} key Property to animate
   * @param {String} to Value to animate to
   * @param {Object} [options] Options object
   */ _animate(key, endValue) {
        let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const path = key.split('.');
        const propIsColor = this.constructor.colorProperties.includes(path[path.length - 1]);
        const { abort: abort, startValue: startValue, onChange: onChange, onComplete: onComplete } = options;
        const animationOptions = $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, options), {}, {
            target: this,
            // path.reduce... is the current value in case start value isn't provided
            startValue: startValue !== null && startValue !== void 0 ? startValue : path.reduce((deep, key)=>deep[key], this),
            endValue: endValue,
            abort: abort === null || abort === void 0 ? void 0 : abort.bind(this),
            onChange: (value, valueProgress, durationProgress)=>{
                path.reduce((deep, key, index)=>{
                    if (index === path.length - 1) deep[key] = value;
                    return deep[key];
                }, this);
                onChange && // @ts-expect-error generic callback arg0 is wrong
                onChange(value, valueProgress, durationProgress);
            },
            onComplete: (value, valueProgress, durationProgress)=>{
                this.setCoords();
                onComplete && // @ts-expect-error generic callback arg0 is wrong
                onComplete(value, valueProgress, durationProgress);
            }
        });
        return propIsColor ? $f268b97836dca6b6$var$animateColor(animationOptions) : $f268b97836dca6b6$var$animate(animationOptions);
    }
    // #region Object stacking methods
    /**
   * A reference to the parent of the object
   * Used to keep the original parent ref when the object has been added to an ActiveSelection, hence loosing the `group` ref
   */ /**
   * Checks if object is descendant of target
   * Should be used instead of {@link Group.contains} or {@link StaticCanvas.contains} for performance reasons
   * @param {TAncestor} target
   * @returns {boolean}
   */ isDescendantOf(target) {
        const { parent: parent, group: group } = this;
        return parent === target || group === target || // walk up
        !!parent && parent.isDescendantOf(target) || !!group && group !== parent && group.isDescendantOf(target);
    }
    /**
   * @returns {Ancestors} ancestors (excluding `ActiveSelection`) from bottom to top
   */ getAncestors() {
        const ancestors = [];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let parent = this;
        do {
            parent = parent.parent;
            parent && ancestors.push(parent);
        }while (parent);
        return ancestors;
    }
    /**
   * Compare ancestors
   *
   * @param {StackedObject} other
   * @returns {AncestryComparison} an object that represent the ancestry situation.
   */ findCommonAncestors(other) {
        if (this === other) return {
            fork: [],
            otherFork: [],
            common: [
                this,
                ...this.getAncestors()
            ]
        };
        const ancestors = this.getAncestors();
        const otherAncestors = other.getAncestors();
        //  if `this` has no ancestors and `this` is top ancestor of `other` we must handle the following case
        if (ancestors.length === 0 && otherAncestors.length > 0 && this === otherAncestors[otherAncestors.length - 1]) return {
            fork: [],
            otherFork: [
                other,
                ...otherAncestors.slice(0, otherAncestors.length - 1)
            ],
            common: [
                this
            ]
        };
        //  compare ancestors
        for(let i = 0, ancestor; i < ancestors.length; i++){
            ancestor = ancestors[i];
            if (ancestor === other) return {
                fork: [
                    this,
                    ...ancestors.slice(0, i)
                ],
                otherFork: [],
                common: ancestors.slice(i)
            };
            for(let j = 0; j < otherAncestors.length; j++){
                if (this === otherAncestors[j]) return {
                    fork: [],
                    otherFork: [
                        other,
                        ...otherAncestors.slice(0, j)
                    ],
                    common: [
                        this,
                        ...ancestors
                    ]
                };
                if (ancestor === otherAncestors[j]) return {
                    fork: [
                        this,
                        ...ancestors.slice(0, i)
                    ],
                    otherFork: [
                        other,
                        ...otherAncestors.slice(0, j)
                    ],
                    common: ancestors.slice(i)
                };
            }
        }
        // nothing shared
        return {
            fork: [
                this,
                ...ancestors
            ],
            otherFork: [
                other,
                ...otherAncestors
            ],
            common: []
        };
    }
    /**
   *
   * @param {StackedObject} other
   * @returns {boolean}
   */ hasCommonAncestors(other) {
        const commonAncestors = this.findCommonAncestors(other);
        return commonAncestors && !!commonAncestors.common.length;
    }
    /**
   *
   * @param {FabricObject} other object to compare against
   * @returns {boolean | undefined} if objects do not share a common ancestor or they are strictly equal it is impossible to determine which is in front of the other; in such cases the function returns `undefined`
   */ isInFrontOf(other) {
        if (this === other) return undefined;
        const ancestorData = this.findCommonAncestors(other);
        if (ancestorData.fork.includes(other)) return true;
        if (ancestorData.otherFork.includes(this)) return false;
        // if there isn't a common ancestor, we take the canvas.
        // if there is no canvas, there is nothing to compare
        const firstCommonAncestor = ancestorData.common[0] || this.canvas;
        if (!firstCommonAncestor) return undefined;
        const headOfFork = ancestorData.fork.pop(), headOfOtherFork = ancestorData.otherFork.pop(), thisIndex = firstCommonAncestor._objects.indexOf(headOfFork), otherIndex = firstCommonAncestor._objects.indexOf(headOfOtherFork);
        return thisIndex > -1 && thisIndex > otherIndex;
    }
    // #region Serialization
    /**
   * Define a list of custom properties that will be serialized when
   * instance.toObject() gets called
   */ /**
   * Returns an object representation of an instance
   * @param {string[]} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} Object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        const propertiesToSerialize = propertiesToInclude.concat(FabricObject.customProperties, this.constructor.customProperties || []);
        let clipPathData;
        const NUM_FRACTION_DIGITS = $f268b97836dca6b6$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS;
        const { clipPath: clipPath, fill: fill, stroke: stroke, shadow: shadow, strokeDashArray: strokeDashArray, left: left, top: top, originX: originX, originY: originY, width: width, height: height, strokeWidth: strokeWidth, strokeLineCap: strokeLineCap, strokeDashOffset: strokeDashOffset, strokeLineJoin: strokeLineJoin, strokeUniform: strokeUniform, strokeMiterLimit: strokeMiterLimit, scaleX: scaleX, scaleY: scaleY, angle: angle, flipX: flipX, flipY: flipY, opacity: opacity, visible: visible, backgroundColor: backgroundColor, fillRule: fillRule, paintFirst: paintFirst, globalCompositeOperation: globalCompositeOperation, skewX: skewX, skewY: skewY } = this;
        if (clipPath && !clipPath.excludeFromExport) clipPathData = clipPath.toObject(propertiesToSerialize.concat('inverted', 'absolutePositioned'));
        const toFixedBound = (val)=>$f268b97836dca6b6$var$toFixed(val, NUM_FRACTION_DIGITS);
        const object = $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, $f268b97836dca6b6$var$pick(this, propertiesToSerialize)), {}, {
            type: this.constructor.type,
            version: $f268b97836dca6b6$export$83d89fbfd8236492,
            originX: originX,
            originY: originY,
            left: toFixedBound(left),
            top: toFixedBound(top),
            width: toFixedBound(width),
            height: toFixedBound(height),
            fill: $f268b97836dca6b6$var$isSerializableFiller(fill) ? fill.toObject() : fill,
            stroke: $f268b97836dca6b6$var$isSerializableFiller(stroke) ? stroke.toObject() : stroke,
            strokeWidth: toFixedBound(strokeWidth),
            strokeDashArray: strokeDashArray ? strokeDashArray.concat() : strokeDashArray,
            strokeLineCap: strokeLineCap,
            strokeDashOffset: strokeDashOffset,
            strokeLineJoin: strokeLineJoin,
            strokeUniform: strokeUniform,
            strokeMiterLimit: toFixedBound(strokeMiterLimit),
            scaleX: toFixedBound(scaleX),
            scaleY: toFixedBound(scaleY),
            angle: toFixedBound(angle),
            flipX: flipX,
            flipY: flipY,
            opacity: toFixedBound(opacity),
            shadow: shadow ? shadow.toObject() : shadow,
            visible: visible,
            backgroundColor: backgroundColor,
            fillRule: fillRule,
            paintFirst: paintFirst,
            globalCompositeOperation: globalCompositeOperation,
            skewX: toFixedBound(skewX),
            skewY: toFixedBound(skewY)
        }, clipPathData ? {
            clipPath: clipPathData
        } : null);
        return !this.includeDefaultValues ? this._removeDefaultValues(object) : object;
    }
    /**
   * Returns (dataless) object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} Object representation of an instance
   */ toDatalessObject(propertiesToInclude) {
        // will be overwritten by subclasses
        return this.toObject(propertiesToInclude);
    }
    /**
   * @private
   * @param {Object} object
   */ _removeDefaultValues(object) {
        // getDefaults() ( get from static ownDefaults ) should win over prototype since anyway they get assigned to instance
        // ownDefault vs prototype is swappable only if you change all the fabric objects consistently.
        const defaults = this.constructor.getDefaults();
        const hasStaticDefaultValues = Object.keys(defaults).length > 0;
        const baseValues = hasStaticDefaultValues ? defaults : Object.getPrototypeOf(this);
        return $f268b97836dca6b6$var$pickBy(object, (value, key)=>{
            if (key === $f268b97836dca6b6$var$LEFT || key === $f268b97836dca6b6$var$TOP || key === 'type') return true;
            const baseValue = baseValues[key];
            return value !== baseValue && // basically a check for [] === []
            !(Array.isArray(value) && Array.isArray(baseValue) && value.length === 0 && baseValue.length === 0);
        });
    }
    /**
   * Returns a string representation of an instance
   * @return {String}
   */ toString() {
        return "#<".concat(this.constructor.type, ">");
    }
    /**
   *
   * @param {Function} klass
   * @param {object} object
   * @param {object} [options]
   * @param {string} [options.extraParam] property to pass as first argument to the constructor
   * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @returns {Promise<FabricObject>}
   */ static _fromObject(_ref3) {
        let serializedObjectOptions = $f268b97836dca6b6$var$_objectWithoutProperties(_ref3, $f268b97836dca6b6$var$_excluded$e);
        let _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, { extraParam: extraParam } = _ref4, options = $f268b97836dca6b6$var$_objectWithoutProperties(_ref4, $f268b97836dca6b6$var$_excluded2$4);
        return $f268b97836dca6b6$var$enlivenObjectEnlivables(serializedObjectOptions, options).then((enlivedObjectOptions)=>{
            // from the resulting enlived options, extract options.extraParam to arg0
            // to avoid accidental overrides later
            if (extraParam) {
                delete enlivedObjectOptions[extraParam];
                return new this(serializedObjectOptions[extraParam], // @ts-expect-error different signature
                enlivedObjectOptions);
            } else return new this(enlivedObjectOptions);
        });
    }
    /**
   *
   * @param {object} object
   * @param {object} [options]
   * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @returns {Promise<FabricObject>}
   */ static fromObject(object, options) {
        return this._fromObject(object, options);
    }
    /**
   * Constructor
   * @param {Object} [options] Options object
   */ constructor(options){
        super();
        /**
     * Quick access for the _cacheCanvas rendering context
     * This is part of the objectCaching feature
     * since 1.7.0
     * @type boolean
     * @default undefined
     * @private
     */ $f268b97836dca6b6$var$_defineProperty(this, "_cacheContext", null);
        Object.assign(this, FabricObject.ownDefaults);
        this.setOptions(options);
    }
};
/**
 * This list of properties is used to check if the state of an object is changed.
 * This state change now is only used for children of groups to understand if a group
 * needs its cache regenerated during a .set call
 * @type Array
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$c2d2360b5ec84692, "stateProperties", $f268b97836dca6b6$var$stateProperties);
/**
 * List of properties to consider when checking if cache needs refresh
 * Those properties are checked by
 * calls to Object.set(key, value). If the key is in this list, the object is marked as dirty
 * and refreshed at the next render
 * @type Array
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$c2d2360b5ec84692, "cacheProperties", $f268b97836dca6b6$var$cacheProperties);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$c2d2360b5ec84692, "ownDefaults", $f268b97836dca6b6$var$fabricObjectDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$c2d2360b5ec84692, "type", 'FabricObject');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$c2d2360b5ec84692, "colorProperties", [
    $f268b97836dca6b6$var$FILL,
    $f268b97836dca6b6$var$STROKE,
    'backgroundColor'
]);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$c2d2360b5ec84692, "customProperties", []);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$c2d2360b5ec84692);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$c2d2360b5ec84692, 'object');
/**
 * Wrap an action handler with firing an event if the action is performed
 * @param {TModificationEvents} eventName the event we want to fire
 * @param {TransformActionHandler<T>} actionHandler the function to wrap
 * @param {object} extraEventInfo extra information to pas to the event handler
 * @return {TransformActionHandler<T>} a function with an action handler signature
 */ const $f268b97836dca6b6$var$wrapWithFireEvent = (eventName, actionHandler, extraEventInfo)=>{
    return (eventData, transform, x, y)=>{
        const actionPerformed = actionHandler(eventData, transform, x, y);
        if (actionPerformed) $f268b97836dca6b6$var$fireEvent(eventName, $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, $f268b97836dca6b6$var$commonEventInfo(eventData, transform, x, y)), extraEventInfo));
        return actionPerformed;
    };
};
/**
 * Wrap an action handler with saving/restoring object position on the transform.
 * this is the code that permits to objects to keep their position while transforming.
 * @param {Function} actionHandler the function to wrap
 * @return {Function} a function with an action handler signature
 */ function $f268b97836dca6b6$var$wrapWithFixedAnchor(actionHandler) {
    return (eventData, transform, x, y)=>{
        const { target: target, originX: originX, originY: originY } = transform, centerPoint = target.getRelativeCenterPoint(), constraint = target.translateToOriginPoint(centerPoint, originX, originY), actionPerformed = actionHandler(eventData, transform, x, y);
        // flipping requires to change the transform origin, so we read from the mutated transform
        // instead of leveraging the one destructured before
        target.setPositionByOrigin(constraint, transform.originX, transform.originY);
        return actionPerformed;
    };
}
/**
 * Action handler to change object's width
 * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ const $f268b97836dca6b6$var$changeObjectWidth = (eventData, transform, x, y)=>{
    const localPoint = $f268b97836dca6b6$var$getLocalPoint(transform, transform.originX, transform.originY, x, y);
    //  make sure the control changes width ONLY from it's side of target
    if ($f268b97836dca6b6$var$resolveOrigin(transform.originX) === $f268b97836dca6b6$var$resolveOrigin($f268b97836dca6b6$var$CENTER) || $f268b97836dca6b6$var$resolveOrigin(transform.originX) === $f268b97836dca6b6$var$resolveOrigin($f268b97836dca6b6$var$RIGHT) && localPoint.x < 0 || $f268b97836dca6b6$var$resolveOrigin(transform.originX) === $f268b97836dca6b6$var$resolveOrigin($f268b97836dca6b6$var$LEFT) && localPoint.x > 0) {
        const { target: target } = transform, strokePadding = target.strokeWidth / (target.strokeUniform ? target.scaleX : 1), multiplier = $f268b97836dca6b6$var$isTransformCentered(transform) ? 2 : 1, oldWidth = target.width, newWidth = Math.abs(localPoint.x * multiplier / target.scaleX) - strokePadding;
        target.set('width', Math.max(newWidth, 1));
        //  check against actual target width in case `newWidth` was rejected
        return oldWidth !== target.width;
    }
    return false;
};
const $f268b97836dca6b6$var$changeWidth = $f268b97836dca6b6$var$wrapWithFireEvent($f268b97836dca6b6$var$RESIZING, $f268b97836dca6b6$var$wrapWithFixedAnchor($f268b97836dca6b6$var$changeObjectWidth));
/**
 * Render a round control, as per fabric features.
 * This function is written to respect object properties like transparentCorners, cornerSize
 * cornerColor, cornerStrokeColor
 * plus the addition of offsetY and offsetX.
 * @param {CanvasRenderingContext2D} ctx context to render on
 * @param {Number} left x coordinate where the control center should be
 * @param {Number} top y coordinate where the control center should be
 * @param {Object} styleOverride override for FabricObject controls style
 * @param {FabricObject} fabricObject the fabric object for which we are rendering controls
 */ function $f268b97836dca6b6$var$renderCircleControl(ctx, left, top, styleOverride, fabricObject) {
    styleOverride = styleOverride || {};
    const xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize, ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize, transparentCorners = typeof styleOverride.transparentCorners !== 'undefined' ? styleOverride.transparentCorners : fabricObject.transparentCorners, methodName = transparentCorners ? $f268b97836dca6b6$var$STROKE : $f268b97836dca6b6$var$FILL, stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor);
    let myLeft = left, myTop = top, size;
    ctx.save();
    ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor || '';
    ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor || '';
    // TODO: use proper ellipse code.
    if (xSize > ySize) {
        size = xSize;
        ctx.scale(1.0, ySize / xSize);
        myTop = top * xSize / ySize;
    } else if (ySize > xSize) {
        size = ySize;
        ctx.scale(xSize / ySize, 1.0);
        myLeft = left * ySize / xSize;
    } else size = xSize;
    ctx.beginPath();
    ctx.arc(myLeft, myTop, size / 2, 0, $f268b97836dca6b6$var$twoMathPi, false);
    ctx[methodName]();
    if (stroke) ctx.stroke();
    ctx.restore();
}
/**
 * Render a square control, as per fabric features.
 * This function is written to respect object properties like transparentCorners, cornerSize
 * cornerColor, cornerStrokeColor
 * plus the addition of offsetY and offsetX.
 * @param {CanvasRenderingContext2D} ctx context to render on
 * @param {Number} left x coordinate where the control center should be
 * @param {Number} top y coordinate where the control center should be
 * @param {Object} styleOverride override for FabricObject controls style
 * @param {FabricObject} fabricObject the fabric object for which we are rendering controls
 */ function $f268b97836dca6b6$var$renderSquareControl(ctx, left, top, styleOverride, fabricObject) {
    styleOverride = styleOverride || {};
    const xSize = this.sizeX || styleOverride.cornerSize || fabricObject.cornerSize, ySize = this.sizeY || styleOverride.cornerSize || fabricObject.cornerSize, transparentCorners = typeof styleOverride.transparentCorners !== 'undefined' ? styleOverride.transparentCorners : fabricObject.transparentCorners, methodName = transparentCorners ? $f268b97836dca6b6$var$STROKE : $f268b97836dca6b6$var$FILL, stroke = !transparentCorners && (styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor), xSizeBy2 = xSize / 2, ySizeBy2 = ySize / 2;
    ctx.save();
    ctx.fillStyle = styleOverride.cornerColor || fabricObject.cornerColor || '';
    ctx.strokeStyle = styleOverride.cornerStrokeColor || fabricObject.cornerStrokeColor || '';
    ctx.translate(left, top);
    //  angle is relative to canvas plane
    const angle = fabricObject.getTotalAngle();
    ctx.rotate($f268b97836dca6b6$var$degreesToRadians(angle));
    // this does not work, and fixed with ( && ) does not make sense.
    // to have real transparent corners we need the controls on upperCanvas
    // transparentCorners || ctx.clearRect(-xSizeBy2, -ySizeBy2, xSize, ySize);
    ctx["".concat(methodName, "Rect")](-xSizeBy2, -ySizeBy2, xSize, ySize);
    if (stroke) ctx.strokeRect(-xSizeBy2, -ySizeBy2, xSize, ySize);
    ctx.restore();
}
class $f268b97836dca6b6$export$7a7fa4424cb20976 {
    /**
   * The control actionHandler, provide one to handle action ( control being moved )
   * @param {Event} eventData the native mouse event
   * @param {Transform} transformData properties of the current transform
   * @param {Number} x x position of the cursor
   * @param {Number} y y position of the cursor
   * @return {Boolean} true if the action/event modified the object
   */ /**
   * The control handler for mouse down, provide one to handle mouse down on control
   * @param {Event} eventData the native mouse event
   * @param {Transform} transformData properties of the current transform
   * @param {Number} x x position of the cursor
   * @param {Number} y y position of the cursor
   * @return {Boolean} true if the action/event modified the object
   */ /**
   * The control mouseUpHandler, provide one to handle an effect on mouse up.
   * @param {Event} eventData the native mouse event
   * @param {Transform} transformData properties of the current transform
   * @param {Number} x x position of the cursor
   * @param {Number} y y position of the cursor
   * @return {Boolean} true if the action/event modified the object
   */ shouldActivate(controlKey, fabricObject, pointer, _ref) {
        var _fabricObject$canvas;
        let { tl: tl, tr: tr, br: br, bl: bl } = _ref;
        // TODO: locking logic can be handled here instead of in the control handler logic
        return ((_fabricObject$canvas = fabricObject.canvas) === null || _fabricObject$canvas === void 0 ? void 0 : _fabricObject$canvas.getActiveObject()) === fabricObject && fabricObject.isControlVisible(controlKey) && $f268b97836dca6b6$export$869c896bf338bf5a.isPointInPolygon(pointer, [
            tl,
            tr,
            br,
            bl
        ]);
    }
    /**
   * Returns control actionHandler
   * @param {Event} eventData the native mouse event
   * @param {FabricObject} fabricObject on which the control is displayed
   * @param {Control} control control for which the action handler is being asked
   * @return {Function} the action handler
   */ getActionHandler(eventData, fabricObject, control) {
        return this.actionHandler;
    }
    /**
   * Returns control mouseDown handler
   * @param {Event} eventData the native mouse event
   * @param {FabricObject} fabricObject on which the control is displayed
   * @param {Control} control control for which the action handler is being asked
   * @return {Function} the action handler
   */ getMouseDownHandler(eventData, fabricObject, control) {
        return this.mouseDownHandler;
    }
    /**
   * Returns control mouseUp handler.
   * During actions the fabricObject or the control can be of different obj
   * @param {Event} eventData the native mouse event
   * @param {FabricObject} fabricObject on which the control is displayed
   * @param {Control} control control for which the action handler is being asked
   * @return {Function} the action handler
   */ getMouseUpHandler(eventData, fabricObject, control) {
        return this.mouseUpHandler;
    }
    /**
   * Returns control cursorStyle for css using cursorStyle. If you need a more elaborate
   * function you can pass one in the constructor
   * the cursorStyle property
   * @param {Event} eventData the native mouse event
   * @param {Control} control the current control ( likely this)
   * @param {FabricObject} object on which the control is displayed
   * @return {String}
   */ cursorStyleHandler(eventData, control, fabricObject) {
        return control.cursorStyle;
    }
    /**
   * Returns the action name. The basic implementation just return the actionName property.
   * @param {Event} eventData the native mouse event
   * @param {Control} control the current control ( likely this)
   * @param {FabricObject} object on which the control is displayed
   * @return {String}
   */ getActionName(eventData, control, fabricObject) {
        return control.actionName;
    }
    /**
   * Returns controls visibility
   * @param {FabricObject} object on which the control is displayed
   * @param {String} controlKey key where the control is memorized on the
   * @return {Boolean}
   */ getVisibility(fabricObject, controlKey) {
        var _fabricObject$_contro, _fabricObject$_contro2;
        return (_fabricObject$_contro = (_fabricObject$_contro2 = fabricObject._controlsVisibility) === null || _fabricObject$_contro2 === void 0 ? void 0 : _fabricObject$_contro2[controlKey]) !== null && _fabricObject$_contro !== void 0 ? _fabricObject$_contro : this.visible;
    }
    /**
   * Sets controls visibility
   * @param {Boolean} visibility for the object
   * @return {Void}
   */ setVisibility(visibility, name, fabricObject) {
        this.visible = visibility;
    }
    positionHandler(dim, finalMatrix, fabricObject, currentControl) {
        return new $f268b97836dca6b6$export$baf26146a414f24a(this.x * dim.x + this.offsetX, this.y * dim.y + this.offsetY).transform(finalMatrix);
    }
    /**
   * Returns the coords for this control based on object values.
   * @param {Number} objectAngle angle from the fabric object holding the control
   * @param {Number} objectCornerSize cornerSize from the fabric object holding the control (or touchCornerSize if
   *   isTouch is true)
   * @param {Number} centerX x coordinate where the control center should be
   * @param {Number} centerY y coordinate where the control center should be
   * @param {boolean} isTouch true if touch corner, false if normal corner
   */ calcCornerCoords(angle, objectCornerSize, centerX, centerY, isTouch, fabricObject) {
        const t = $f268b97836dca6b6$var$multiplyTransformMatrixArray([
            $f268b97836dca6b6$var$createTranslateMatrix(centerX, centerY),
            $f268b97836dca6b6$var$createRotateMatrix({
                angle: angle
            }),
            $f268b97836dca6b6$var$createScaleMatrix((isTouch ? this.touchSizeX : this.sizeX) || objectCornerSize, (isTouch ? this.touchSizeY : this.sizeY) || objectCornerSize)
        ]);
        return {
            tl: new $f268b97836dca6b6$export$baf26146a414f24a(-0.5, -0.5).transform(t),
            tr: new $f268b97836dca6b6$export$baf26146a414f24a(0.5, -0.5).transform(t),
            br: new $f268b97836dca6b6$export$baf26146a414f24a(0.5, 0.5).transform(t),
            bl: new $f268b97836dca6b6$export$baf26146a414f24a(-0.5, 0.5).transform(t)
        };
    }
    /**
   * Render function for the control.
   * When this function runs the context is unscaled. unrotate. Just retina scaled.
   * all the functions will have to translate to the point left,top before starting Drawing
   * if they want to draw a control where the position is detected.
   * left and top are the result of the positionHandler function
   * @param {RenderingContext2D} ctx the context where the control will be drawn
   * @param {Number} left position of the canvas where we are about to render the control.
   * @param {Number} top position of the canvas where we are about to render the control.
   * @param {Object} styleOverride
   * @param {FabricObject} fabricObject the object where the control is about to be rendered
   */ render(ctx, left, top, styleOverride, fabricObject) {
        styleOverride = styleOverride || {};
        switch(styleOverride.cornerStyle || fabricObject.cornerStyle){
            case 'circle':
                $f268b97836dca6b6$var$renderCircleControl.call(this, ctx, left, top, styleOverride, fabricObject);
                break;
            default:
                $f268b97836dca6b6$var$renderSquareControl.call(this, ctx, left, top, styleOverride, fabricObject);
        }
    }
    constructor(options){
        /**
     * keep track of control visibility.
     * mainly for backward compatibility.
     * if you do not want to see a control, you can remove it
     * from the control set.
     * @type {Boolean}
     * @default true
     */ $f268b97836dca6b6$var$_defineProperty(this, "visible", true);
        /**
     * Name of the action that the control will likely execute.
     * This is optional. FabricJS uses to identify what the user is doing for some
     * extra optimizations. If you are writing a custom control and you want to know
     * somewhere else in the code what is going on, you can use this string here.
     * you can also provide a custom getActionName if your control run multiple actions
     * depending on some external state.
     * default to scale since is the most common, used on 4 corners by default
     * @type {String}
     * @default 'scale'
     */ $f268b97836dca6b6$var$_defineProperty(this, "actionName", $f268b97836dca6b6$var$SCALE);
        /**
     * Drawing angle of the control.
     * NOT used for now, but name marked as needed for internal logic
     * example: to reuse the same drawing function for different rotated controls
     * @type {Number}
     * @default 0
     */ $f268b97836dca6b6$var$_defineProperty(this, "angle", 0);
        /**
     * Relative position of the control. X
     * 0,0 is the center of the Object, while -0.5 (left) or 0.5 (right) are the extremities
     * of the bounding box.
     * @type {Number}
     * @default 0
     */ $f268b97836dca6b6$var$_defineProperty(this, "x", 0);
        /**
     * Relative position of the control. Y
     * 0,0 is the center of the Object, while -0.5 (top) or 0.5 (bottom) are the extremities
     * of the bounding box.
     * @type {Number}
     * @default 0
     */ $f268b97836dca6b6$var$_defineProperty(this, "y", 0);
        /**
     * Horizontal offset of the control from the defined position. In pixels
     * Positive offset moves the control to the right, negative to the left.
     * It used when you want to have position of control that does not scale with
     * the bounding box. Example: rotation control is placed at x:0, y: 0.5 on
     * the boundind box, with an offset of 30 pixels vertically. Those 30 pixels will
     * stay 30 pixels no matter how the object is big. Another example is having 2
     * controls in the corner, that stay in the same position when the object scale.
     * of the bounding box.
     * @type {Number}
     * @default 0
     */ $f268b97836dca6b6$var$_defineProperty(this, "offsetX", 0);
        /**
     * Vertical offset of the control from the defined position. In pixels
     * Positive offset moves the control to the bottom, negative to the top.
     * @type {Number}
     * @default 0
     */ $f268b97836dca6b6$var$_defineProperty(this, "offsetY", 0);
        /**
     * Sets the length of the control. If null, defaults to object's cornerSize.
     * Expects both sizeX and sizeY to be set when set.
     * @type {?Number}
     * @default null
     */ $f268b97836dca6b6$var$_defineProperty(this, "sizeX", 0);
        /**
     * Sets the height of the control. If null, defaults to object's cornerSize.
     * Expects both sizeX and sizeY to be set when set.
     * @type {?Number}
     * @default null
     */ $f268b97836dca6b6$var$_defineProperty(this, "sizeY", 0);
        /**
     * Sets the length of the touch area of the control. If null, defaults to object's touchCornerSize.
     * Expects both touchSizeX and touchSizeY to be set when set.
     * @type {?Number}
     * @default null
     */ $f268b97836dca6b6$var$_defineProperty(this, "touchSizeX", 0);
        /**
     * Sets the height of the touch area of the control. If null, defaults to object's touchCornerSize.
     * Expects both touchSizeX and touchSizeY to be set when set.
     * @type {?Number}
     * @default null
     */ $f268b97836dca6b6$var$_defineProperty(this, "touchSizeY", 0);
        /**
     * Css cursor style to display when the control is hovered.
     * if the method `cursorStyleHandler` is provided, this property is ignored.
     * @type {String}
     * @default 'crosshair'
     */ $f268b97836dca6b6$var$_defineProperty(this, "cursorStyle", 'crosshair');
        /**
     * If controls has an offsetY or offsetX, draw a line that connects
     * the control to the bounding box
     * @type {Boolean}
     * @default false
     */ $f268b97836dca6b6$var$_defineProperty(this, "withConnection", false);
        Object.assign(this, options);
    }
}
/**
 * Find the correct style for the control that is used for rotation.
 * this function is very simple and it just take care of not-allowed or standard cursor
 * @param {Event} eventData the javascript event that is causing the scale
 * @param {Control} control the control that is interested in the action
 * @param {FabricObject} fabricObject the fabric object that is interested in the action
 * @return {String} a valid css string for the cursor
 */ const $f268b97836dca6b6$var$rotationStyleHandler = (eventData, control, fabricObject)=>{
    if (fabricObject.lockRotation) return $f268b97836dca6b6$var$NOT_ALLOWED_CURSOR;
    return control.cursorStyle;
};
/**
 * Action handler for rotation and snapping, without anchor point.
 * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 * @private
 */ const $f268b97836dca6b6$var$rotateObjectWithSnapping = (eventData, _ref, x, y)=>{
    let { target: target, ex: ex, ey: ey, theta: theta, originX: originX, originY: originY } = _ref;
    const pivotPoint = target.translateToOriginPoint(target.getRelativeCenterPoint(), originX, originY);
    if ($f268b97836dca6b6$var$isLocked(target, 'lockRotation')) return false;
    const lastAngle = Math.atan2(ey - pivotPoint.y, ex - pivotPoint.x), curAngle = Math.atan2(y - pivotPoint.y, x - pivotPoint.x);
    let angle = $f268b97836dca6b6$var$radiansToDegrees(curAngle - lastAngle + theta);
    if (target.snapAngle && target.snapAngle > 0) {
        const snapAngle = target.snapAngle, snapThreshold = target.snapThreshold || snapAngle, rightAngleLocked = Math.ceil(angle / snapAngle) * snapAngle, leftAngleLocked = Math.floor(angle / snapAngle) * snapAngle;
        if (Math.abs(angle - leftAngleLocked) < snapThreshold) angle = leftAngleLocked;
        else if (Math.abs(angle - rightAngleLocked) < snapThreshold) angle = rightAngleLocked;
    }
    // normalize angle to positive value
    if (angle < 0) angle = 360 + angle;
    angle %= 360;
    const hasRotated = target.angle !== angle;
    // TODO: why aren't we using set?
    target.angle = angle;
    return hasRotated;
};
const $f268b97836dca6b6$var$rotationWithSnapping = $f268b97836dca6b6$var$wrapWithFireEvent($f268b97836dca6b6$var$ROTATING, $f268b97836dca6b6$var$wrapWithFixedAnchor($f268b97836dca6b6$var$rotateObjectWithSnapping));
/**
 * Inspect event and fabricObject properties to understand if the scaling action
 * @param {Event} eventData from the user action
 * @param {FabricObject} fabricObject the fabric object about to scale
 * @return {Boolean} true if scale is proportional
 */ function $f268b97836dca6b6$var$scaleIsProportional(eventData, fabricObject) {
    const canvas = fabricObject.canvas, uniformIsToggled = eventData[canvas.uniScaleKey];
    return canvas.uniformScaling && !uniformIsToggled || !canvas.uniformScaling && uniformIsToggled;
}
/**
 * Inspect fabricObject to understand if the current scaling action is allowed
 * @param {FabricObject} fabricObject the fabric object about to scale
 * @param {String} by 'x' or 'y' or ''
 * @param {Boolean} scaleProportionally true if we are trying to scale proportionally
 * @return {Boolean} true if scaling is not allowed at current conditions
 */ function $f268b97836dca6b6$var$scalingIsForbidden(fabricObject, by, scaleProportionally) {
    const lockX = $f268b97836dca6b6$var$isLocked(fabricObject, 'lockScalingX'), lockY = $f268b97836dca6b6$var$isLocked(fabricObject, 'lockScalingY');
    if (lockX && lockY) return true;
    if (!by && (lockX || lockY) && scaleProportionally) return true;
    if (lockX && by === 'x') return true;
    if (lockY && by === 'y') return true;
    // code crashes because of a division by 0 if a 0 sized object is scaled
    // forbid to prevent scaling to happen. ISSUE-9475
    const { width: width, height: height, strokeWidth: strokeWidth } = fabricObject;
    if (width === 0 && strokeWidth === 0 && by !== 'y') return true;
    if (height === 0 && strokeWidth === 0 && by !== 'x') return true;
    return false;
}
const $f268b97836dca6b6$var$scaleMap = [
    'e',
    'se',
    's',
    'sw',
    'w',
    'nw',
    'n',
    'ne',
    'e'
];
/**
 * return the correct cursor style for the scale action
 * @param {Event} eventData the javascript event that is causing the scale
 * @param {Control} control the control that is interested in the action
 * @param {FabricObject} fabricObject the fabric object that is interested in the action
 * @return {String} a valid css string for the cursor
 */ const $f268b97836dca6b6$var$scaleCursorStyleHandler = (eventData, control, fabricObject)=>{
    const scaleProportionally = $f268b97836dca6b6$var$scaleIsProportional(eventData, fabricObject), by = control.x !== 0 && control.y === 0 ? 'x' : control.x === 0 && control.y !== 0 ? 'y' : '';
    if ($f268b97836dca6b6$var$scalingIsForbidden(fabricObject, by, scaleProportionally)) return $f268b97836dca6b6$var$NOT_ALLOWED_CURSOR;
    const n = $f268b97836dca6b6$var$findCornerQuadrant(fabricObject, control);
    return "".concat($f268b97836dca6b6$var$scaleMap[n], "-resize");
};
/**
 * Basic scaling logic, reused with different constrain for scaling X,Y, freely or equally.
 * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @param {Object} options additional information for scaling
 * @param {String} options.by 'x', 'y', 'equally' or '' to indicate type of scaling
 * @return {Boolean} true if some change happened
 * @private
 */ function $f268b97836dca6b6$var$scaleObject(eventData, transform, x, y) {
    let options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    const target = transform.target, by = options.by, scaleProportionally = $f268b97836dca6b6$var$scaleIsProportional(eventData, target), forbidScaling = $f268b97836dca6b6$var$scalingIsForbidden(target, by, scaleProportionally);
    let newPoint, scaleX, scaleY, dim, signX, signY;
    if (forbidScaling) return false;
    if (transform.gestureScale) {
        scaleX = transform.scaleX * transform.gestureScale;
        scaleY = transform.scaleY * transform.gestureScale;
    } else {
        newPoint = $f268b97836dca6b6$var$getLocalPoint(transform, transform.originX, transform.originY, x, y);
        // use of sign: We use sign to detect change of direction of an action. sign usually change when
        // we cross the origin point with the mouse. So a scale flip for example. There is an issue when scaling
        // by center and scaling using one middle control ( default: mr, mt, ml, mb), the mouse movement can easily
        // cross many time the origin point and flip the object. so we need a way to filter out the noise.
        // This ternary here should be ok to filter out X scaling when we want Y only and vice versa.
        signX = by !== 'y' ? Math.sign(newPoint.x || transform.signX || 1) : 1;
        signY = by !== 'x' ? Math.sign(newPoint.y || transform.signY || 1) : 1;
        if (!transform.signX) transform.signX = signX;
        if (!transform.signY) transform.signY = signY;
        if ($f268b97836dca6b6$var$isLocked(target, 'lockScalingFlip') && (transform.signX !== signX || transform.signY !== signY)) return false;
        dim = target._getTransformedDimensions();
        // missing detection of flip and logic to switch the origin
        if (scaleProportionally && !by) {
            // uniform scaling
            const distance = Math.abs(newPoint.x) + Math.abs(newPoint.y), { original: original } = transform, originalDistance = Math.abs(dim.x * original.scaleX / target.scaleX) + Math.abs(dim.y * original.scaleY / target.scaleY), scale = distance / originalDistance;
            scaleX = original.scaleX * scale;
            scaleY = original.scaleY * scale;
        } else {
            scaleX = Math.abs(newPoint.x * target.scaleX / dim.x);
            scaleY = Math.abs(newPoint.y * target.scaleY / dim.y);
        }
        // if we are scaling by center, we need to double the scale
        if ($f268b97836dca6b6$var$isTransformCentered(transform)) {
            scaleX *= 2;
            scaleY *= 2;
        }
        if (transform.signX !== signX && by !== 'y') {
            transform.originX = $f268b97836dca6b6$var$invertOrigin(transform.originX);
            scaleX *= -1;
            transform.signX = signX;
        }
        if (transform.signY !== signY && by !== 'x') {
            transform.originY = $f268b97836dca6b6$var$invertOrigin(transform.originY);
            scaleY *= -1;
            transform.signY = signY;
        }
    }
    // minScale is taken care of in the setter.
    const oldScaleX = target.scaleX, oldScaleY = target.scaleY;
    if (!by) {
        !$f268b97836dca6b6$var$isLocked(target, 'lockScalingX') && target.set($f268b97836dca6b6$var$SCALE_X, scaleX);
        !$f268b97836dca6b6$var$isLocked(target, 'lockScalingY') && target.set($f268b97836dca6b6$var$SCALE_Y, scaleY);
    } else {
        // forbidden cases already handled on top here.
        by === 'x' && target.set($f268b97836dca6b6$var$SCALE_X, scaleX);
        by === 'y' && target.set($f268b97836dca6b6$var$SCALE_Y, scaleY);
    }
    return oldScaleX !== target.scaleX || oldScaleY !== target.scaleY;
}
/**
 * Generic scaling logic, to scale from corners either equally or freely.
 * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ const $f268b97836dca6b6$var$scaleObjectFromCorner = (eventData, transform, x, y)=>{
    return $f268b97836dca6b6$var$scaleObject(eventData, transform, x, y);
};
/**
 * Scaling logic for the X axis.
 * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ const $f268b97836dca6b6$var$scaleObjectX = (eventData, transform, x, y)=>{
    return $f268b97836dca6b6$var$scaleObject(eventData, transform, x, y, {
        by: 'x'
    });
};
/**
 * Scaling logic for the Y axis.
 * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ const $f268b97836dca6b6$var$scaleObjectY = (eventData, transform, x, y)=>{
    return $f268b97836dca6b6$var$scaleObject(eventData, transform, x, y, {
        by: 'y'
    });
};
const $f268b97836dca6b6$var$scalingEqually = $f268b97836dca6b6$var$wrapWithFireEvent($f268b97836dca6b6$var$SCALING, $f268b97836dca6b6$var$wrapWithFixedAnchor($f268b97836dca6b6$var$scaleObjectFromCorner));
const $f268b97836dca6b6$var$scalingX = $f268b97836dca6b6$var$wrapWithFireEvent($f268b97836dca6b6$var$SCALING, $f268b97836dca6b6$var$wrapWithFixedAnchor($f268b97836dca6b6$var$scaleObjectX));
const $f268b97836dca6b6$var$scalingY = $f268b97836dca6b6$var$wrapWithFireEvent($f268b97836dca6b6$var$SCALING, $f268b97836dca6b6$var$wrapWithFixedAnchor($f268b97836dca6b6$var$scaleObjectY));
const $f268b97836dca6b6$var$_excluded$d = [
    "target",
    "ex",
    "ey",
    "skewingSide"
];
const $f268b97836dca6b6$var$AXIS_KEYS = {
    x: {
        counterAxis: 'y',
        scale: $f268b97836dca6b6$var$SCALE_X,
        skew: $f268b97836dca6b6$var$SKEW_X,
        lockSkewing: 'lockSkewingX',
        origin: 'originX',
        flip: 'flipX'
    },
    y: {
        counterAxis: 'x',
        scale: $f268b97836dca6b6$var$SCALE_Y,
        skew: $f268b97836dca6b6$var$SKEW_Y,
        lockSkewing: 'lockSkewingY',
        origin: 'originY',
        flip: 'flipY'
    }
};
const $f268b97836dca6b6$var$skewMap = [
    'ns',
    'nesw',
    'ew',
    'nwse'
];
/**
 * return the correct cursor style for the skew action
 * @param {Event} eventData the javascript event that is causing the scale
 * @param {Control} control the control that is interested in the action
 * @param {FabricObject} fabricObject the fabric object that is interested in the action
 * @return {String} a valid css string for the cursor
 */ const $f268b97836dca6b6$var$skewCursorStyleHandler = (eventData, control, fabricObject)=>{
    if (control.x !== 0 && $f268b97836dca6b6$var$isLocked(fabricObject, 'lockSkewingY')) return $f268b97836dca6b6$var$NOT_ALLOWED_CURSOR;
    if (control.y !== 0 && $f268b97836dca6b6$var$isLocked(fabricObject, 'lockSkewingX')) return $f268b97836dca6b6$var$NOT_ALLOWED_CURSOR;
    const n = $f268b97836dca6b6$var$findCornerQuadrant(fabricObject, control) % 4;
    return "".concat($f268b97836dca6b6$var$skewMap[n], "-resize");
};
/**
 * Since skewing is applied before scaling, calculations are done in a scaleless plane
 * @see https://github.com/fabricjs/fabric.js/pull/8380
 */ function $f268b97836dca6b6$var$skewObject(axis, _ref, pointer) {
    let { target: target, ex: ex, ey: ey, skewingSide: skewingSide } = _ref, transform = $f268b97836dca6b6$var$_objectWithoutProperties(_ref, $f268b97836dca6b6$var$_excluded$d);
    const { skew: skewKey } = $f268b97836dca6b6$var$AXIS_KEYS[axis], offset = pointer.subtract(new $f268b97836dca6b6$export$baf26146a414f24a(ex, ey)).divide(new $f268b97836dca6b6$export$baf26146a414f24a(target.scaleX, target.scaleY))[axis], skewingBefore = target[skewKey], skewingStart = transform[skewKey], shearingStart = Math.tan($f268b97836dca6b6$var$degreesToRadians(skewingStart)), // let a, b be the size of target
    // let a' be the value of a after applying skewing
    // then:
    // a' = a + b * skewA => skewA = (a' - a) / b
    // the value b is tricky since skewY is applied before skewX
    b = axis === 'y' ? target._getTransformedDimensions({
        scaleX: 1,
        scaleY: 1,
        // since skewY is applied before skewX, b (=width) is not affected by skewX
        skewX: 0
    }).x : target._getTransformedDimensions({
        scaleX: 1,
        scaleY: 1
    }).y;
    const shearing = 2 * offset * skewingSide / // we max out fractions to safeguard from asymptotic behavior
    Math.max(b, 1) + // add starting state
    shearingStart;
    const skewing = $f268b97836dca6b6$var$radiansToDegrees(Math.atan(shearing));
    target.set(skewKey, skewing);
    const changed = skewingBefore !== target[skewKey];
    if (changed && axis === 'y') {
        // we don't want skewing to affect scaleX
        // so we factor it by the inverse skewing diff to make it seem unchanged to the viewer
        const { skewX: skewX, scaleX: scaleX } = target, dimBefore = target._getTransformedDimensions({
            skewY: skewingBefore
        }), dimAfter = target._getTransformedDimensions(), compensationFactor = skewX !== 0 ? dimBefore.x / dimAfter.x : 1;
        compensationFactor !== 1 && target.set($f268b97836dca6b6$var$SCALE_X, compensationFactor * scaleX);
    }
    return changed;
}
/**
 * Wrapped Action handler for skewing on a given axis, takes care of the
 * skew direction and determines the correct transform origin for the anchor point
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ function $f268b97836dca6b6$var$skewHandler(axis, eventData, transform, x, y) {
    const { target: target } = transform, { counterAxis: counterAxis, origin: originKey, lockSkewing: lockSkewingKey, skew: skewKey, flip: flipKey } = $f268b97836dca6b6$var$AXIS_KEYS[axis];
    if ($f268b97836dca6b6$var$isLocked(target, lockSkewingKey)) return false;
    const { origin: counterOriginKey, flip: counterFlipKey } = $f268b97836dca6b6$var$AXIS_KEYS[counterAxis], counterOriginFactor = $f268b97836dca6b6$var$resolveOrigin(transform[counterOriginKey]) * (target[counterFlipKey] ? -1 : 1), // if the counter origin is top/left (= -0.5) then we are skewing x/y values on the bottom/right side of target respectively.
    // if the counter origin is bottom/right (= 0.5) then we are skewing x/y values on the top/left side of target respectively.
    // skewing direction on the top/left side of target is OPPOSITE to the direction of the movement of the pointer,
    // so we factor skewing direction by this value.
    skewingSide = -Math.sign(counterOriginFactor) * (target[flipKey] ? -1 : 1), skewingDirection = (target[skewKey] === 0 && // in case skewing equals 0 we use the pointer offset from target center to determine the direction of skewing
    $f268b97836dca6b6$var$getLocalPoint(transform, $f268b97836dca6b6$var$CENTER, $f268b97836dca6b6$var$CENTER, x, y)[axis] > 0 || // in case target has skewing we use that as the direction
    target[skewKey] > 0 ? 1 : -1) * skewingSide, // anchor to the opposite side of the skewing direction
    // normalize value from [-1, 1] to origin value [0, 1]
    origin = -skewingDirection * 0.5 + 0.5;
    const finalHandler = $f268b97836dca6b6$var$wrapWithFireEvent($f268b97836dca6b6$var$SKEWING, $f268b97836dca6b6$var$wrapWithFixedAnchor((eventData, transform, x, y)=>$f268b97836dca6b6$var$skewObject(axis, transform, new $f268b97836dca6b6$export$baf26146a414f24a(x, y))));
    return finalHandler(eventData, $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, transform), {}, {
        [originKey]: origin,
        skewingSide: skewingSide
    }), x, y);
}
/**
 * Wrapped Action handler for skewing on the X axis, takes care of the
 * skew direction and determines the correct transform origin for the anchor point
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ const $f268b97836dca6b6$var$skewHandlerX = (eventData, transform, x, y)=>{
    return $f268b97836dca6b6$var$skewHandler('x', eventData, transform, x, y);
};
/**
 * Wrapped Action handler for skewing on the Y axis, takes care of the
 * skew direction and determines the correct transform origin for the anchor point
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ const $f268b97836dca6b6$var$skewHandlerY = (eventData, transform, x, y)=>{
    return $f268b97836dca6b6$var$skewHandler('y', eventData, transform, x, y);
};
function $f268b97836dca6b6$var$isAltAction(eventData, target) {
    return eventData[target.canvas.altActionKey];
}
/**
 * Inspect event, control and fabricObject to return the correct action name
 * @param {Event} eventData the javascript event that is causing the scale
 * @param {Control} control the control that is interested in the action
 * @param {FabricObject} fabricObject the fabric object that is interested in the action
 * @return {String} an action name
 */ const $f268b97836dca6b6$var$scaleOrSkewActionName = (eventData, control, fabricObject)=>{
    const isAlternative = $f268b97836dca6b6$var$isAltAction(eventData, fabricObject);
    if (control.x === 0) // then is scaleY or skewX
    return isAlternative ? $f268b97836dca6b6$var$SKEW_X : $f268b97836dca6b6$var$SCALE_Y;
    if (control.y === 0) // then is scaleY or skewX
    return isAlternative ? $f268b97836dca6b6$var$SKEW_Y : $f268b97836dca6b6$var$SCALE_X;
    return '';
};
/**
 * Combine skew and scale style handlers to cover fabric standard use case
 * @param {Event} eventData the javascript event that is causing the scale
 * @param {Control} control the control that is interested in the action
 * @param {FabricObject} fabricObject the fabric object that is interested in the action
 * @return {String} a valid css string for the cursor
 */ const $f268b97836dca6b6$var$scaleSkewCursorStyleHandler = (eventData, control, fabricObject)=>{
    return $f268b97836dca6b6$var$isAltAction(eventData, fabricObject) ? $f268b97836dca6b6$var$skewCursorStyleHandler(eventData, control, fabricObject) : $f268b97836dca6b6$var$scaleCursorStyleHandler(eventData, control, fabricObject);
};
/**
 * Composed action handler to either scale X or skew Y
 * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ const $f268b97836dca6b6$var$scalingXOrSkewingY = (eventData, transform, x, y)=>{
    return $f268b97836dca6b6$var$isAltAction(eventData, transform.target) ? $f268b97836dca6b6$var$skewHandlerY(eventData, transform, x, y) : $f268b97836dca6b6$var$scalingX(eventData, transform, x, y);
};
/**
 * Composed action handler to either scale Y or skew X
 * Needs to be wrapped with `wrapWithFixedAnchor` to be effective
 * @param {Event} eventData javascript event that is doing the transform
 * @param {Object} transform javascript object containing a series of information around the current transform
 * @param {number} x current mouse x position, canvas normalized
 * @param {number} y current mouse y position, canvas normalized
 * @return {Boolean} true if some change happened
 */ const $f268b97836dca6b6$var$scalingYOrSkewingX = (eventData, transform, x, y)=>{
    return $f268b97836dca6b6$var$isAltAction(eventData, transform.target) ? $f268b97836dca6b6$var$skewHandlerX(eventData, transform, x, y) : $f268b97836dca6b6$var$scalingY(eventData, transform, x, y);
};
// use this function if you want to generate new controls for every instance
const $f268b97836dca6b6$var$createObjectDefaultControls = ()=>({
        ml: new $f268b97836dca6b6$export$7a7fa4424cb20976({
            x: -0.5,
            y: 0,
            cursorStyleHandler: $f268b97836dca6b6$var$scaleSkewCursorStyleHandler,
            actionHandler: $f268b97836dca6b6$var$scalingXOrSkewingY,
            getActionName: $f268b97836dca6b6$var$scaleOrSkewActionName
        }),
        mr: new $f268b97836dca6b6$export$7a7fa4424cb20976({
            x: 0.5,
            y: 0,
            cursorStyleHandler: $f268b97836dca6b6$var$scaleSkewCursorStyleHandler,
            actionHandler: $f268b97836dca6b6$var$scalingXOrSkewingY,
            getActionName: $f268b97836dca6b6$var$scaleOrSkewActionName
        }),
        mb: new $f268b97836dca6b6$export$7a7fa4424cb20976({
            x: 0,
            y: 0.5,
            cursorStyleHandler: $f268b97836dca6b6$var$scaleSkewCursorStyleHandler,
            actionHandler: $f268b97836dca6b6$var$scalingYOrSkewingX,
            getActionName: $f268b97836dca6b6$var$scaleOrSkewActionName
        }),
        mt: new $f268b97836dca6b6$export$7a7fa4424cb20976({
            x: 0,
            y: -0.5,
            cursorStyleHandler: $f268b97836dca6b6$var$scaleSkewCursorStyleHandler,
            actionHandler: $f268b97836dca6b6$var$scalingYOrSkewingX,
            getActionName: $f268b97836dca6b6$var$scaleOrSkewActionName
        }),
        tl: new $f268b97836dca6b6$export$7a7fa4424cb20976({
            x: -0.5,
            y: -0.5,
            cursorStyleHandler: $f268b97836dca6b6$var$scaleCursorStyleHandler,
            actionHandler: $f268b97836dca6b6$var$scalingEqually
        }),
        tr: new $f268b97836dca6b6$export$7a7fa4424cb20976({
            x: 0.5,
            y: -0.5,
            cursorStyleHandler: $f268b97836dca6b6$var$scaleCursorStyleHandler,
            actionHandler: $f268b97836dca6b6$var$scalingEqually
        }),
        bl: new $f268b97836dca6b6$export$7a7fa4424cb20976({
            x: -0.5,
            y: 0.5,
            cursorStyleHandler: $f268b97836dca6b6$var$scaleCursorStyleHandler,
            actionHandler: $f268b97836dca6b6$var$scalingEqually
        }),
        br: new $f268b97836dca6b6$export$7a7fa4424cb20976({
            x: 0.5,
            y: 0.5,
            cursorStyleHandler: $f268b97836dca6b6$var$scaleCursorStyleHandler,
            actionHandler: $f268b97836dca6b6$var$scalingEqually
        }),
        mtr: new $f268b97836dca6b6$export$7a7fa4424cb20976({
            x: 0,
            y: -0.5,
            actionHandler: $f268b97836dca6b6$var$rotationWithSnapping,
            cursorStyleHandler: $f268b97836dca6b6$var$rotationStyleHandler,
            offsetY: -40,
            withConnection: true,
            actionName: $f268b97836dca6b6$var$ROTATE
        })
    });
const $f268b97836dca6b6$var$createResizeControls = ()=>({
        mr: new $f268b97836dca6b6$export$7a7fa4424cb20976({
            x: 0.5,
            y: 0,
            actionHandler: $f268b97836dca6b6$var$changeWidth,
            cursorStyleHandler: $f268b97836dca6b6$var$scaleSkewCursorStyleHandler,
            actionName: $f268b97836dca6b6$var$RESIZING
        }),
        ml: new $f268b97836dca6b6$export$7a7fa4424cb20976({
            x: -0.5,
            y: 0,
            actionHandler: $f268b97836dca6b6$var$changeWidth,
            cursorStyleHandler: $f268b97836dca6b6$var$scaleSkewCursorStyleHandler,
            actionName: $f268b97836dca6b6$var$RESIZING
        })
    });
const $f268b97836dca6b6$var$createTextboxDefaultControls = ()=>$f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, $f268b97836dca6b6$var$createObjectDefaultControls()), $f268b97836dca6b6$var$createResizeControls());
class $f268b97836dca6b6$export$bee544043763fa88 extends $f268b97836dca6b6$export$c2d2360b5ec84692 {
    static getDefaults() {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.getDefaults()), $f268b97836dca6b6$export$bee544043763fa88.ownDefaults);
    }
    /**
   * Creates the default control object.
   * If you prefer to have on instance of controls shared among all objects
   * make this function return an empty object and add controls to the ownDefaults
   * @param {Object} [options] Options object
   */ static createControls() {
        return {
            controls: $f268b97836dca6b6$var$createObjectDefaultControls()
        };
    }
    /**
   * Update width and height of the canvas for cache
   * returns true or false if canvas needed resize.
   * @private
   * @return {Boolean} true if the canvas has been resized
   */ _updateCacheCanvas() {
        const targetCanvas = this.canvas;
        if (this.noScaleCache && targetCanvas && targetCanvas._currentTransform) {
            const transform = targetCanvas._currentTransform, target = transform.target, action = transform.action;
            if (this === target && action && action.startsWith($f268b97836dca6b6$var$SCALE)) return false;
        }
        return super._updateCacheCanvas();
    }
    getActiveControl() {
        const key = this.__corner;
        return key ? {
            key: key,
            control: this.controls[key],
            coord: this.oCoords[key]
        } : undefined;
    }
    /**
   * Determines which corner is under the mouse cursor, represented by `pointer`.
   * This function is return a corner only if the object is the active one.
   * This is done to avoid selecting corner of non active object and activating transformations
   * rather than drag action. The default behavior of fabricJS is that if you want to transform
   * an object, first you select it to show the control set
   * @private
   * @param {Object} pointer The pointer indicating the mouse position
   * @param {boolean} forTouch indicates if we are looking for interaction area with a touch action
   * @return {String|Boolean} corner code (tl, tr, bl, br, etc.), or 0 if nothing is found.
   */ findControl(pointer) {
        let forTouch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        if (!this.hasControls || !this.canvas) return undefined;
        this.__corner = undefined;
        const cornerEntries = Object.entries(this.oCoords);
        for(let i = cornerEntries.length - 1; i >= 0; i--){
            const [key, corner] = cornerEntries[i];
            const control = this.controls[key];
            if (control.shouldActivate(key, this, pointer, forTouch ? corner.touchCorner : corner.corner)) {
                // this.canvas.contextTop.fillRect(pointer.x - 1, pointer.y - 1, 2, 2);
                this.__corner = key;
                return {
                    key: key,
                    control: control,
                    coord: this.oCoords[key]
                };
            }
        }
        return undefined;
    }
    /**
   * Calculates the coordinates of the center of each control plus the corners of the control itself
   * This basically just delegates to each control positionHandler
   * WARNING: changing what is passed to positionHandler is a breaking change, since position handler
   * is a public api and should be done just if extremely necessary
   * @return {Record<string, TOCoord>}
   */ calcOCoords() {
        const vpt = this.getViewportTransform(), center = this.getCenterPoint(), tMatrix = $f268b97836dca6b6$var$createTranslateMatrix(center.x, center.y), rMatrix = $f268b97836dca6b6$var$createRotateMatrix({
            angle: this.getTotalAngle() - (!!this.group && this.flipX ? 180 : 0)
        }), positionMatrix = $f268b97836dca6b6$var$multiplyTransformMatrices(tMatrix, rMatrix), startMatrix = $f268b97836dca6b6$var$multiplyTransformMatrices(vpt, positionMatrix), finalMatrix = $f268b97836dca6b6$var$multiplyTransformMatrices(startMatrix, [
            1 / vpt[0],
            0,
            0,
            1 / vpt[3],
            0,
            0
        ]), transformOptions = this.group ? $f268b97836dca6b6$var$qrDecompose(this.calcTransformMatrix()) : undefined;
        // decomposing could bring negative scaling and `_calculateCurrentDimensions` can't take it
        if (transformOptions) {
            transformOptions.scaleX = Math.abs(transformOptions.scaleX);
            transformOptions.scaleY = Math.abs(transformOptions.scaleY);
        }
        const dim = this._calculateCurrentDimensions(transformOptions), coords = {};
        this.forEachControl((control, key)=>{
            const position = control.positionHandler(dim, finalMatrix, this, control);
            // coords[key] are sometimes used as points. Those are points to which we add
            // the property corner and touchCorner from `_calcCornerCoords`.
            // don't remove this assign for an object spread.
            coords[key] = Object.assign(position, this._calcCornerCoords(control, position));
        });
        // debug code
        /*
      const canvas = this.canvas;
      setTimeout(function () {
      if (!canvas) return;
        canvas.contextTop.clearRect(0, 0, 700, 700);
        canvas.contextTop.fillStyle = 'green';
        Object.keys(coords).forEach(function(key) {
          const control = coords[key];
          canvas.contextTop.fillRect(control.x, control.y, 3, 3);
        });
      } 50);
    */ return coords;
    }
    /**
   * Sets the coordinates that determine the interaction area of each control
   * note: if we would switch to ROUND corner area, all of this would disappear.
   * everything would resolve to a single point and a pythagorean theorem for the distance
   * @todo evaluate simplification of code switching to circle interaction area at runtime
   * @private
   */ _calcCornerCoords(control, position) {
        const angle = this.getTotalAngle();
        const corner = control.calcCornerCoords(angle, this.cornerSize, position.x, position.y, false, this);
        const touchCorner = control.calcCornerCoords(angle, this.touchCornerSize, position.x, position.y, true, this);
        return {
            corner: corner,
            touchCorner: touchCorner
        };
    }
    /**
   * @override set controls' coordinates as well
   * See {@link https://github.com/fabricjs/fabric.js/wiki/When-to-call-setCoords} and {@link http://fabricjs.com/fabric-gotchas}
   * @return {void}
   */ setCoords() {
        super.setCoords();
        this.canvas && (this.oCoords = this.calcOCoords());
    }
    /**
   * Calls a function for each control. The function gets called,
   * with the control, the control's key and the object that is calling the iterator
   * @param {Function} fn function to iterate over the controls over
   */ forEachControl(fn) {
        for(const i in this.controls)fn(this.controls[i], i, this);
    }
    /**
   * Draws a colored layer behind the object, inside its selection borders.
   * Requires public options: padding, selectionBackgroundColor
   * this function is called when the context is transformed
   * has checks to be skipped when the object is on a staticCanvas
   * @todo evaluate if make this disappear in favor of a pre-render hook for objects
   * this was added by Andrea Bogazzi to make possible some feature for work reasons
   * it seemed a good option, now is an edge case
   * @param {CanvasRenderingContext2D} ctx Context to draw on
   */ drawSelectionBackground(ctx) {
        if (!this.selectionBackgroundColor || this.canvas && this.canvas._activeObject !== this) return;
        ctx.save();
        const center = this.getRelativeCenterPoint(), wh = this._calculateCurrentDimensions(), vpt = this.getViewportTransform();
        ctx.translate(center.x, center.y);
        ctx.scale(1 / vpt[0], 1 / vpt[3]);
        ctx.rotate($f268b97836dca6b6$var$degreesToRadians(this.angle));
        ctx.fillStyle = this.selectionBackgroundColor;
        ctx.fillRect(-wh.x / 2, -wh.y / 2, wh.x, wh.y);
        ctx.restore();
    }
    /**
   * @public override this function in order to customize the drawing of the control box, e.g. rounded corners, different border style.
   * @param {CanvasRenderingContext2D} ctx ctx is rotated and translated so that (0,0) is at object's center
   * @param {Point} size the control box size used
   */ strokeBorders(ctx, size) {
        ctx.strokeRect(-size.x / 2, -size.y / 2, size.x, size.y);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to draw on
   * @param {Point} size
   * @param {TStyleOverride} styleOverride object to override the object style
   */ _drawBorders(ctx, size) {
        let styleOverride = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        const options = $f268b97836dca6b6$var$_objectSpread2({
            hasControls: this.hasControls,
            borderColor: this.borderColor,
            borderDashArray: this.borderDashArray
        }, styleOverride);
        ctx.save();
        ctx.strokeStyle = options.borderColor;
        this._setLineDash(ctx, options.borderDashArray);
        this.strokeBorders(ctx, size);
        options.hasControls && this.drawControlsConnectingLines(ctx, size);
        ctx.restore();
    }
    /**
   * Renders controls and borders for the object
   * the context here is not transformed
   * @todo move to interactivity
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {TStyleOverride} [styleOverride] properties to override the object style
   */ _renderControls(ctx) {
        let styleOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const { hasBorders: hasBorders, hasControls: hasControls } = this;
        const styleOptions = $f268b97836dca6b6$var$_objectSpread2({
            hasBorders: hasBorders,
            hasControls: hasControls
        }, styleOverride);
        const vpt = this.getViewportTransform(), shouldDrawBorders = styleOptions.hasBorders, shouldDrawControls = styleOptions.hasControls;
        const matrix = $f268b97836dca6b6$var$multiplyTransformMatrices(vpt, this.calcTransformMatrix());
        const options = $f268b97836dca6b6$var$qrDecompose(matrix);
        ctx.save();
        ctx.translate(options.translateX, options.translateY);
        ctx.lineWidth = this.borderScaleFactor; // 1 * this.borderScaleFactor;
        // since interactive groups have been introduced, an object could be inside a group and needing controls
        // the following equality check `this.group === this.parent` covers:
        // object without a group ( undefined === undefined )
        // object inside a group
        // excludes object inside a group but multi selected since group and parent will differ in value
        if (this.group === this.parent) ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
        if (this.flipX) options.angle -= 180;
        ctx.rotate($f268b97836dca6b6$var$degreesToRadians(this.group ? options.angle : this.angle));
        shouldDrawBorders && this.drawBorders(ctx, options, styleOverride);
        shouldDrawControls && this.drawControls(ctx, styleOverride);
        ctx.restore();
    }
    /**
   * Draws borders of an object's bounding box.
   * Requires public properties: width, height
   * Requires public options: padding, borderColor
   * @param {CanvasRenderingContext2D} ctx Context to draw on
   * @param {object} options object representing current object parameters
   * @param {TStyleOverride} [styleOverride] object to override the object style
   */ drawBorders(ctx, options, styleOverride) {
        let size;
        if (styleOverride && styleOverride.forActiveSelection || this.group) {
            const bbox = $f268b97836dca6b6$var$sizeAfterTransform(this.width, this.height, $f268b97836dca6b6$var$calcDimensionsMatrix(options)), stroke = !this.isStrokeAccountedForInDimensions() ? (this.strokeUniform ? new $f268b97836dca6b6$export$baf26146a414f24a().scalarAdd(this.canvas ? this.canvas.getZoom() : 1) : // this is extremely confusing. options comes from the upper function
            // and is the qrDecompose of a matrix that takes in account zoom too
            new $f268b97836dca6b6$export$baf26146a414f24a(options.scaleX, options.scaleY)).scalarMultiply(this.strokeWidth) : $f268b97836dca6b6$var$ZERO;
            size = bbox.add(stroke).scalarAdd(this.borderScaleFactor).scalarAdd(this.padding * 2);
        } else size = this._calculateCurrentDimensions().scalarAdd(this.borderScaleFactor);
        this._drawBorders(ctx, size, styleOverride);
    }
    /**
   * Draws lines from a borders of an object's bounding box to controls that have `withConnection` property set.
   * Requires public properties: width, height
   * Requires public options: padding, borderColor
   * @param {CanvasRenderingContext2D} ctx Context to draw on
   * @param {Point} size object size x = width, y = height
   */ drawControlsConnectingLines(ctx, size) {
        let shouldStroke = false;
        ctx.beginPath();
        this.forEachControl((control, key)=>{
            // in this moment, the ctx is centered on the object.
            // width and height of the above function are the size of the bbox.
            if (control.withConnection && control.getVisibility(this, key)) {
                // reset movement for each control
                shouldStroke = true;
                ctx.moveTo(control.x * size.x, control.y * size.y);
                ctx.lineTo(control.x * size.x + control.offsetX, control.y * size.y + control.offsetY);
            }
        });
        shouldStroke && ctx.stroke();
    }
    /**
   * Draws corners of an object's bounding box.
   * Requires public properties: width, height
   * Requires public options: cornerSize, padding
   * Be aware that since fabric 6.0 this function does not call setCoords anymore.
   * setCoords needs to be called manually if the object of which we are rendering controls
   * is outside the standard selection and transform process.
   * @param {CanvasRenderingContext2D} ctx Context to draw on
   * @param {ControlRenderingStyleOverride} styleOverride object to override the object style
   */ drawControls(ctx) {
        let styleOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        ctx.save();
        const retinaScaling = this.getCanvasRetinaScaling();
        const { cornerStrokeColor: cornerStrokeColor, cornerDashArray: cornerDashArray, cornerColor: cornerColor } = this;
        const options = $f268b97836dca6b6$var$_objectSpread2({
            cornerStrokeColor: cornerStrokeColor,
            cornerDashArray: cornerDashArray,
            cornerColor: cornerColor
        }, styleOverride);
        ctx.setTransform(retinaScaling, 0, 0, retinaScaling, 0, 0);
        ctx.strokeStyle = ctx.fillStyle = options.cornerColor;
        if (!this.transparentCorners) ctx.strokeStyle = options.cornerStrokeColor;
        this._setLineDash(ctx, options.cornerDashArray);
        this.forEachControl((control, key)=>{
            if (control.getVisibility(this, key)) {
                const p = this.oCoords[key];
                control.render(ctx, p.x, p.y, options, this);
            }
        });
        ctx.restore();
    }
    /**
   * Returns true if the specified control is visible, false otherwise.
   * @param {string} controlKey The key of the control. Possible values are usually 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr',
   * but since the control api allow for any control name, can be any string.
   * @returns {boolean} true if the specified control is visible, false otherwise
   */ isControlVisible(controlKey) {
        return this.controls[controlKey] && this.controls[controlKey].getVisibility(this, controlKey);
    }
    /**
   * Sets the visibility of the specified control.
   * please do not use.
   * @param {String} controlKey The key of the control. Possible values are 'tl', 'tr', 'br', 'bl', 'ml', 'mt', 'mr', 'mb', 'mtr'.
   * but since the control api allow for any control name, can be any string.
   * @param {Boolean} visible true to set the specified control visible, false otherwise
   * @todo discuss this overlap of priority here with the team. Andrea Bogazzi for details
   */ setControlVisible(controlKey, visible) {
        if (!this._controlsVisibility) this._controlsVisibility = {};
        this._controlsVisibility[controlKey] = visible;
    }
    /**
   * Sets the visibility state of object controls, this is just a bulk option for setControlVisible;
   * @param {Record<string, boolean>} [options] with an optional key per control
   * example: {Boolean} [options.bl] true to enable the bottom-left control, false to disable it
   */ setControlsVisibility() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        Object.entries(options).forEach((_ref)=>{
            let [controlKey, visibility] = _ref;
            return this.setControlVisible(controlKey, visibility);
        });
    }
    /**
   * Clears the canvas.contextTop in a specific area that corresponds to the object's bounding box
   * that is in the canvas.contextContainer.
   * This function is used to clear pieces of contextTop where we render ephemeral effects on top of the object.
   * Example: blinking cursor text selection, drag effects.
   * @todo discuss swapping restoreManually with a renderCallback, but think of async issues
   * @param {Boolean} [restoreManually] When true won't restore the context after clear, in order to draw something else.
   * @return {CanvasRenderingContext2D|undefined} canvas.contextTop that is either still transformed
   * with the object transformMatrix, or restored to neutral transform
   */ clearContextTop(restoreManually) {
        if (!this.canvas) return;
        const ctx = this.canvas.contextTop;
        if (!ctx) return;
        const v = this.canvas.viewportTransform;
        ctx.save();
        ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
        this.transform(ctx);
        // we add 4 pixel, to be sure to do not leave any pixel out
        const width = this.width + 4, height = this.height + 4;
        ctx.clearRect(-width / 2, -height / 2, width, height);
        restoreManually || ctx.restore();
        return ctx;
    }
    /**
   * This callback function is called every time _discardActiveObject or _setActiveObject
   * try to to deselect this object. If the function returns true, the process is cancelled
   * @param {Object} [_options] options sent from the upper functions
   * @param {TPointerEvent} [options.e] event if the process is generated by an event
   * @param {FabricObject} [options.object] next object we are setting as active, and reason why
   * this is being deselected
   */ onDeselect(_options) {
        // implemented by sub-classes, as needed.
        return false;
    }
    /**
   * This callback function is called every time _discardActiveObject or _setActiveObject
   * try to to select this object. If the function returns true, the process is cancelled
   * @param {Object} [_options] options sent from the upper functions
   * @param {Event} [_options.e] event if the process is generated by an event
   */ onSelect(_options) {
        // implemented by sub-classes, as needed.
        return false;
    }
    /**
   * Override to customize Drag behavior
   * Fired from {@link Canvas#_onMouseMove}
   * @returns true in order for the window to start a drag session
   */ shouldStartDragging(_e) {
        return false;
    }
    /**
   * Override to customize Drag behavior\
   * Fired once a drag session has started
   * @returns true to handle the drag event
   */ onDragStart(_e) {
        return false;
    }
    /**
   * Override to customize drag and drop behavior
   * @public
   * @param {DragEvent} _e
   * @returns {boolean} true if the object currently dragged can be dropped on the target
   */ canDrop(_e) {
        return false;
    }
    /**
   * Override to customize drag and drop behavior
   * render a specific effect when an object is the source of a drag event
   * example: render the selection status for the part of text that is being dragged from a text object
   * @public
   * @param {DragEvent} _e
   */ renderDragSourceEffect(_e) {
    // for subclasses
    }
    /**
   * Override to customize drag and drop behavior
   * render a specific effect when an object is the target of a drag event
   * used to show that the underly object can receive a drop, or to show how the
   * object will change when dropping. example: show the cursor where the text is about to be dropped
   * @public
   * @param {DragEvent} _e
   */ renderDropTargetEffect(_e) {
    // for subclasses
    }
    /**
   * Constructor
   * @param {Object} [options] Options object
   */ constructor(options){
        super();
        Object.assign(this, this.constructor.createControls(), $f268b97836dca6b6$export$bee544043763fa88.ownDefaults);
        this.setOptions(options);
    }
}
/**
 * The object's controls' position in viewport coordinates
 * Calculated by {@link Control#positionHandler} and {@link Control#calcCornerCoords}, depending on {@link padding}.
 * `corner/touchCorner` describe the 4 points forming the interactive area of the corner.
 * Used to draw and locate controls.
 */ /**
 * keeps the value of the last hovered corner during mouse move.
 * 0 is no corner, or 'mt', 'ml', 'mtr' etc..
 * It should be private, but there is no harm in using it as
 * a read-only property.
 * this isn't cleaned automatically. Non selected objects may have wrong values
 * @type [string]
 */ /**
 * a map of control visibility for this object.
 * this was left when controls were introduced to not break the api too much
 * this takes priority over the generic control visibility
 */ /**
 * holds the controls for the object.
 * controls are added by default_controls.js
 */ /**
 * internal boolean to signal the code that the object is
 * part of the move action.
 */ /**
 * A boolean used from the gesture module to keep tracking of a scaling
 * action when there is no scaling transform in place.
 * This is an edge case and is used twice in all codebase.
 * Probably added to keep track of some performance issues
 * @TODO use git blame to investigate why it was added
 * DON'T USE IT. WE WILL TRY TO REMOVE IT
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$bee544043763fa88, "ownDefaults", $f268b97836dca6b6$var$interactiveObjectDefaultValues);
/***
 * https://www.typescriptlang.org/docs/handbook/mixins.html#alternative-pattern
 */ function $f268b97836dca6b6$var$applyMixins(derivedCtor, constructors) {
    constructors.forEach((baseCtor)=>{
        Object.getOwnPropertyNames(baseCtor.prototype).forEach((name)=>{
            name !== 'constructor' && Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name) || Object.create(null));
        });
    });
    return derivedCtor;
}
// TODO somehow we have to make a tree-shakeable import
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
class $f268b97836dca6b6$export$5a5fba7eea6847b1 extends $f268b97836dca6b6$export$bee544043763fa88 {
}
$f268b97836dca6b6$var$applyMixins($f268b97836dca6b6$export$5a5fba7eea6847b1, [
    $f268b97836dca6b6$var$FabricObjectSVGExportMixin
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$5a5fba7eea6847b1);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$5a5fba7eea6847b1, 'object');
/**
 * Returns true if context has transparent pixel
 * at specified location (taking tolerance into account)
 * @param {CanvasRenderingContext2D} ctx context
 * @param {Number} x x coordinate in canvasElementCoordinate, not fabric space. integer
 * @param {Number} y y coordinate in canvasElementCoordinate, not fabric space. integer
 * @param {Number} tolerance Tolerance pixels around the point, not alpha tolerance, integer
 * @return {boolean} true if transparent
 */ const $f268b97836dca6b6$var$isTransparent = (ctx, x, y, tolerance)=>{
    tolerance = Math.round(tolerance);
    const size = tolerance * 2 + 1;
    const { data: data } = ctx.getImageData(x - tolerance, y - tolerance, size, size);
    // Split image data - for tolerance > 1, pixelDataSize = 4;
    for(let i = 3; i < data.length; i += 4){
        const alphaChannel = data[i];
        if (alphaChannel > 0) return false;
    }
    return true;
};
/**
 * Rotates `point` around `origin` with `radians`
 * @deprecated use the Point.rotate
 * @param {Point} origin The origin of the rotation
 * @param {Point} origin The origin of the rotation
 * @param {TRadian} radians The radians of the angle for the rotation
 * @return {Point} The new rotated point
 */ const $f268b97836dca6b6$var$rotatePoint = (point, origin, radians)=>point.rotate(radians, origin);
const $f268b97836dca6b6$var$findIndexRight = (array, predicate)=>{
    for(let index = array.length - 1; index >= 0; index--){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
};
/**
 * @see https://github.com/fabricjs/fabric.js/pull/8344
 * @todo consider removing skewing from points before calculating stroke projection,
 * see https://github.com/fabricjs/fabric.js/commit/494a10ee2f8c2278ae9a55b20bf50cf6ee25b064#commitcomment-94751537
 */ class $f268b97836dca6b6$var$StrokeProjectionsBase {
    /**
   * When the stroke is uniform, scaling affects the arrangement of points. So we must take it into account.
   */ createSideVector(from, to) {
        const v = $f268b97836dca6b6$var$createVector(from, to);
        return this.options.strokeUniform ? v.multiply(this.scale) : v;
    }
    projectOrthogonally(from, to, magnitude) {
        return this.applySkew(from.add(this.calcOrthogonalProjection(from, to, magnitude)));
    }
    isSkewed() {
        return this.options.skewX !== 0 || this.options.skewY !== 0;
    }
    applySkew(point) {
        const p = new $f268b97836dca6b6$export$baf26146a414f24a(point);
        // skewY must be applied before skewX as this distortion affects skewX calculation
        p.y += p.x * Math.tan($f268b97836dca6b6$var$degreesToRadians(this.options.skewY));
        p.x += p.y * Math.tan($f268b97836dca6b6$var$degreesToRadians(this.options.skewX));
        return p;
    }
    scaleUnitVector(unitVector, scalar) {
        return unitVector.multiply(this.strokeUniformScalar).scalarMultiply(scalar);
    }
    constructor(options){
        this.options = options;
        this.strokeProjectionMagnitude = this.options.strokeWidth / 2;
        this.scale = new $f268b97836dca6b6$export$baf26146a414f24a(this.options.scaleX, this.options.scaleY);
        this.strokeUniformScalar = this.options.strokeUniform ? new $f268b97836dca6b6$export$baf26146a414f24a(1 / this.options.scaleX, 1 / this.options.scaleY) : new $f268b97836dca6b6$export$baf26146a414f24a(1, 1);
    }
}
const $f268b97836dca6b6$var$zeroVector = new $f268b97836dca6b6$export$baf26146a414f24a();
/**
 * class in charge of finding projections for each type of line join
 * @see {@link [Closed path projections at #8344](https://github.com/fabricjs/fabric.js/pull/8344#2-closed-path)}
 *
 * - MDN:
 *   - https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/lineJoin
 *   - https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-linejoin
 * - Spec: https://svgwg.org/svg2-draft/painting.html#StrokeLinejoinProperty
 * - Playground to understand how the line joins works: https://hypertolosana.github.io/efficient-webgl-stroking/index.html
 * - View the calculated projections for each of the control points: https://codesandbox.io/s/project-stroke-points-with-context-to-trace-b8jc4j?file=/src/index.js
 *
 */ class $f268b97836dca6b6$var$StrokeLineJoinProjections extends $f268b97836dca6b6$var$StrokeProjectionsBase {
    static getOrthogonalRotationFactor(vector1, vector2) {
        const angle = vector2 ? $f268b97836dca6b6$var$calcAngleBetweenVectors(vector1, vector2) : $f268b97836dca6b6$var$calcVectorRotation(vector1);
        return Math.abs(angle) < $f268b97836dca6b6$var$halfPI ? -1 : 1;
    }
    calcOrthogonalProjection(from, to) {
        let magnitude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.strokeProjectionMagnitude;
        const vector = this.createSideVector(from, to);
        const orthogonalProjection = $f268b97836dca6b6$var$getOrthonormalVector(vector);
        const correctSide = $f268b97836dca6b6$var$StrokeLineJoinProjections.getOrthogonalRotationFactor(orthogonalProjection, this.bisector);
        return this.scaleUnitVector(orthogonalProjection, magnitude * correctSide);
    }
    /**
   * BEVEL
   * Calculation: the projection points are formed by the vector orthogonal to the vertex.
   *
   * @see https://github.com/fabricjs/fabric.js/pull/8344#2-2-bevel
   */ projectBevel() {
        const projections = [];
        // if `alpha` equals 0 or 2*PI, the projections are the same for `B` and `C`
        (this.alpha % $f268b97836dca6b6$var$twoMathPi === 0 ? [
            this.B
        ] : [
            this.B,
            this.C
        ]).forEach((to)=>{
            projections.push(this.projectOrthogonally(this.A, to));
            projections.push(this.projectOrthogonally(this.A, to, -this.strokeProjectionMagnitude));
        });
        return projections;
    }
    /**
   * MITER
   * Calculation: the corner is formed by extending the outer edges of the stroke
   * at the tangents of the path segments until they intersect.
   *
   * @see https://github.com/fabricjs/fabric.js/pull/8344#2-1-miter
   */ projectMiter() {
        const projections = [], alpha = Math.abs(this.alpha), hypotUnitScalar = 1 / Math.sin(alpha / 2), miterVector = this.scaleUnitVector(this.bisector, -this.strokeProjectionMagnitude * hypotUnitScalar);
        // When two line segments meet at a sharp angle, it is possible for the join to extend,
        // far beyond the thickness of the line stroking the path. The stroke-miterlimit imposes
        // a limit on the extent of the line join.
        // MDN: https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-miterlimit
        // When the stroke is uniform, scaling changes the arrangement of points, this changes the miter-limit
        const strokeMiterLimit = this.options.strokeUniform ? $f268b97836dca6b6$var$magnitude(this.scaleUnitVector(this.bisector, this.options.strokeMiterLimit)) : this.options.strokeMiterLimit;
        if ($f268b97836dca6b6$var$magnitude(miterVector) / this.strokeProjectionMagnitude <= strokeMiterLimit) projections.push(this.applySkew(this.A.add(miterVector)));
        /* when the miter-limit is reached, the stroke line join becomes of type bevel.
      We always need two orthogonal projections which are basically bevel-type projections,
      so regardless of whether the miter-limit was reached or not, we include these projections.
    */ projections.push(...this.projectBevel());
        return projections;
    }
    /**
   * ROUND (without skew)
   * Calculation: the projections are the two vectors parallel to X and Y axes
   *
   * @see https://github.com/fabricjs/fabric.js/pull/8344#2-3-1-round-without-skew
   */ projectRoundNoSkew(startCircle, endCircle) {
        const projections = [], // correctSide is used to only consider projecting for the outer side
        correctSide = new $f268b97836dca6b6$export$baf26146a414f24a($f268b97836dca6b6$var$StrokeLineJoinProjections.getOrthogonalRotationFactor(this.bisector), $f268b97836dca6b6$var$StrokeLineJoinProjections.getOrthogonalRotationFactor(new $f268b97836dca6b6$export$baf26146a414f24a(this.bisector.y, this.bisector.x))), radiusOnAxisX = new $f268b97836dca6b6$export$baf26146a414f24a(1, 0).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar).multiply(correctSide), radiusOnAxisY = new $f268b97836dca6b6$export$baf26146a414f24a(0, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar).multiply(correctSide);
        [
            radiusOnAxisX,
            radiusOnAxisY
        ].forEach((vector)=>{
            if ($f268b97836dca6b6$var$isBetweenVectors(vector, startCircle, endCircle)) projections.push(this.A.add(vector));
        });
        return projections;
    }
    /**
   * ROUND (with skew)
   * Calculation: the projections are the points furthest from the vertex in
   * the direction of the X and Y axes after distortion.
   *
   * @see https://github.com/fabricjs/fabric.js/pull/8344#2-3-2-round-skew
   */ projectRoundWithSkew(startCircle, endCircle) {
        const projections = [];
        const { skewX: skewX, skewY: skewY, scaleX: scaleX, scaleY: scaleY, strokeUniform: strokeUniform } = this.options, shearing = new $f268b97836dca6b6$export$baf26146a414f24a(Math.tan($f268b97836dca6b6$var$degreesToRadians(skewX)), Math.tan($f268b97836dca6b6$var$degreesToRadians(skewY)));
        // The points furthest from the vertex in the direction of the X and Y axes after distortion
        const circleRadius = this.strokeProjectionMagnitude, newY = strokeUniform ? circleRadius / scaleY / Math.sqrt(1 / scaleY ** 2 + 1 / scaleX ** 2 * shearing.y ** 2) : circleRadius / Math.sqrt(1 + shearing.y ** 2), furthestY = new $f268b97836dca6b6$export$baf26146a414f24a(// Safe guard due to floating point precision. In some situations the square root
        // was returning NaN because of a negative number close to zero.
        Math.sqrt(Math.max(circleRadius ** 2 - newY ** 2, 0)), newY), newX = strokeUniform ? circleRadius / Math.sqrt(1 + shearing.x ** 2 * (1 / scaleY) ** 2 / (1 / scaleX + 1 / scaleX * shearing.x * shearing.y) ** 2) : circleRadius / Math.sqrt(1 + shearing.x ** 2 / (1 + shearing.x * shearing.y) ** 2), furthestX = new $f268b97836dca6b6$export$baf26146a414f24a(newX, Math.sqrt(Math.max(circleRadius ** 2 - newX ** 2, 0)));
        [
            furthestX,
            furthestX.scalarMultiply(-1),
            furthestY,
            furthestY.scalarMultiply(-1)
        ]// We need to skew the vector here as this information is used to check if
        // it is between the start and end of the circle segment
        .map((vector)=>this.applySkew(strokeUniform ? vector.multiply(this.strokeUniformScalar) : vector)).forEach((vector)=>{
            if ($f268b97836dca6b6$var$isBetweenVectors(vector, startCircle, endCircle)) projections.push(this.applySkew(this.A).add(vector));
        });
        return projections;
    }
    projectRound() {
        const projections = [];
        /* Include the start and end points of the circle segment, so that only
      the projections contained within it are included */ // add the orthogonal projections (start and end points of circle segment)
        projections.push(...this.projectBevel());
        // let's determines which one of the orthogonal projection is the beginning and end of the circle segment.
        // when `alpha` equals 0 or 2*PI, we have a straight line, so the way to find the start/end is different.
        const isStraightLine = this.alpha % $f268b97836dca6b6$var$twoMathPi === 0, // change the origin of the projections to point A
        // so that the cross product calculation is correct
        newOrigin = this.applySkew(this.A), proj0 = projections[isStraightLine ? 0 : 2].subtract(newOrigin), proj1 = projections[isStraightLine ? 1 : 0].subtract(newOrigin), // when `isStraightLine` === true, we compare with the vector opposite AB, otherwise we compare with the bisector.
        comparisonVector = isStraightLine ? this.applySkew(this.AB.scalarMultiply(-1)) : this.applySkew(this.bisector.multiply(this.strokeUniformScalar).scalarMultiply(-1)), // the beginning of the circle segment is always to the right of the comparison vector (cross product > 0)
        isProj0Start = $f268b97836dca6b6$var$crossProduct(proj0, comparisonVector) > 0, startCircle = isProj0Start ? proj0 : proj1, endCircle = isProj0Start ? proj1 : proj0;
        if (!this.isSkewed()) projections.push(...this.projectRoundNoSkew(startCircle, endCircle));
        else projections.push(...this.projectRoundWithSkew(startCircle, endCircle));
        return projections;
    }
    /**
   * Project stroke width on points returning projections for each point as follows:
   * - `miter`: 1 point corresponding to the outer boundary. If the miter limit is exceeded, it will be 2 points (becomes bevel)
   * - `bevel`: 2 points corresponding to the bevel possible boundaries, orthogonal to the stroke.
   * - `round`: same as `bevel` when it has no skew, with skew are 4 points.
   */ projectPoints() {
        switch(this.options.strokeLineJoin){
            case 'miter':
                return this.projectMiter();
            case 'round':
                return this.projectRound();
            default:
                return this.projectBevel();
        }
    }
    project() {
        return this.projectPoints().map((point)=>({
                originPoint: this.A,
                projectedPoint: point,
                angle: this.alpha,
                bisector: this.bisector
            }));
    }
    constructor(A, B, C, options){
        super(options);
        /**
     * The point being projected (the angle ∠BAC)
     */ /**
     * The point before A
     */ /**
     * The point after A
     */ /**
     * The AB vector
     */ $f268b97836dca6b6$var$_defineProperty(this, "AB", void 0);
        /**
     * The AC vector
     */ $f268b97836dca6b6$var$_defineProperty(this, "AC", void 0);
        /**
     * The angle of A (∠BAC)
     */ $f268b97836dca6b6$var$_defineProperty(this, "alpha", void 0);
        /**
     * The bisector of A (∠BAC)
     */ $f268b97836dca6b6$var$_defineProperty(this, "bisector", void 0);
        this.A = new $f268b97836dca6b6$export$baf26146a414f24a(A);
        this.B = new $f268b97836dca6b6$export$baf26146a414f24a(B);
        this.C = new $f268b97836dca6b6$export$baf26146a414f24a(C);
        this.AB = this.createSideVector(this.A, this.B);
        this.AC = this.createSideVector(this.A, this.C);
        this.alpha = $f268b97836dca6b6$var$calcAngleBetweenVectors(this.AB, this.AC);
        this.bisector = $f268b97836dca6b6$var$getUnitVector(// if AC is also the zero vector nothing will be projected
        // in that case the next point will handle the projection
        $f268b97836dca6b6$var$rotateVector(this.AB.eq($f268b97836dca6b6$var$zeroVector) ? this.AC : this.AB, this.alpha / 2));
    }
}
/**
 * class in charge of finding projections for each type of line cap for start/end of an open path
 * @see {@link [Open path projections at #8344](https://github.com/fabricjs/fabric.js/pull/8344#1-open-path)}
 *
 * Reference:
 * - MDN:
 *   - https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/lineCap
 *   - https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/stroke-linecap
 * - Spec: https://html.spec.whatwg.org/multipage/canvas.html#dom-context-2d-linecap-dev
 * - Playground to understand how the line joins works: https://hypertolosana.github.io/efficient-webgl-stroking/index.html
 * - View the calculated projections for each of the control points: https://codesandbox.io/s/project-stroke-points-with-context-to-trace-b8jc4j?file=/src/index.js
 */ class $f268b97836dca6b6$var$StrokeLineCapProjections extends $f268b97836dca6b6$var$StrokeProjectionsBase {
    calcOrthogonalProjection(from, to) {
        let magnitude = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.strokeProjectionMagnitude;
        const vector = this.createSideVector(from, to);
        return this.scaleUnitVector($f268b97836dca6b6$var$getOrthonormalVector(vector), magnitude);
    }
    /**
   * OPEN PATH START/END - Line cap: Butt
   * Calculation: to find the projections, just find the points orthogonal to the stroke
   *
   * @see https://github.com/fabricjs/fabric.js/pull/8344#1-1-butt
   */ projectButt() {
        return [
            this.projectOrthogonally(this.A, this.T, this.strokeProjectionMagnitude),
            this.projectOrthogonally(this.A, this.T, -this.strokeProjectionMagnitude)
        ];
    }
    /**
   * OPEN PATH START/END - Line cap: Round
   * Calculation: same as stroke line join `round`
   *
   * @see https://github.com/fabricjs/fabric.js/pull/8344#1-2-round
   */ projectRound() {
        const projections = [];
        if (!this.isSkewed() && this.A.eq(this.T)) {
            /* 1 point case without `skew`
        When `strokeUniform` is true, scaling has no effect.
        So we divide by scale, to remove its effect.
      */ const projection = new $f268b97836dca6b6$export$baf26146a414f24a(1, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar);
            projections.push(this.applySkew(this.A.add(projection)), this.applySkew(this.A.subtract(projection)));
        } else projections.push(...new $f268b97836dca6b6$var$StrokeLineJoinProjections(this.A, this.T, this.T, this.options).projectRound());
        return projections;
    }
    /**
   * OPEN PATH START/END - Line cap: Square
   * Calculation: project a rectangle of points on the stroke in the opposite direction of the vector `AT`
   *
   * @see https://github.com/fabricjs/fabric.js/pull/8344#1-3-square
   */ projectSquare() {
        const projections = [];
        if (this.A.eq(this.T)) {
            /* 1 point case without `skew`
        When `strokeUniform` is true, scaling has no effect.
        So we divide by scale, to remove its effect.
      */ const projection = new $f268b97836dca6b6$export$baf26146a414f24a(1, 1).scalarMultiply(this.strokeProjectionMagnitude).multiply(this.strokeUniformScalar);
            projections.push(this.A.add(projection), this.A.subtract(projection));
        } else {
            const orthogonalProjection = this.calcOrthogonalProjection(this.A, this.T, this.strokeProjectionMagnitude);
            const strokePointingOut = this.scaleUnitVector($f268b97836dca6b6$var$getUnitVector(this.createSideVector(this.A, this.T)), -this.strokeProjectionMagnitude);
            const projectedA = this.A.add(strokePointingOut);
            projections.push(projectedA.add(orthogonalProjection), projectedA.subtract(orthogonalProjection));
        }
        return projections.map((p)=>this.applySkew(p));
    }
    projectPoints() {
        switch(this.options.strokeLineCap){
            case 'round':
                return this.projectRound();
            case 'square':
                return this.projectSquare();
            default:
                return this.projectButt();
        }
    }
    project() {
        return this.projectPoints().map((point)=>({
                originPoint: this.A,
                projectedPoint: point
            }));
    }
    /**
   * edge point
   */ /**
   * point next to edge point
   */ constructor(A, T, options){
        super(options);
        this.A = new $f268b97836dca6b6$export$baf26146a414f24a(A);
        this.T = new $f268b97836dca6b6$export$baf26146a414f24a(T);
    }
}
/**
 *
 * Used to calculate object's bounding box
 *
 * @see https://github.com/fabricjs/fabric.js/pull/8344
 *
 */ const $f268b97836dca6b6$var$projectStrokeOnPoints = function(points, options) {
    let openPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const projections = [];
    if (points.length === 0) return projections;
    // first we remove duplicate neighboring points
    const reduced = points.reduce((reduced, point)=>{
        if (!reduced[reduced.length - 1].eq(point)) reduced.push(new $f268b97836dca6b6$export$baf26146a414f24a(point));
        return reduced;
    }, [
        new $f268b97836dca6b6$export$baf26146a414f24a(points[0])
    ]);
    if (reduced.length === 1) openPath = true;
    else if (!openPath) {
        // remove points from end in case they equal the first point
        // in order to correctly project the first point
        const start = reduced[0];
        const index = $f268b97836dca6b6$var$findIndexRight(reduced, (point)=>!point.eq(start));
        reduced.splice(index + 1);
    }
    reduced.forEach((A, index, points)=>{
        let B, C;
        if (index === 0) {
            C = points[1];
            B = openPath ? A : points[points.length - 1];
        } else if (index === points.length - 1) {
            B = points[index - 1];
            C = openPath ? A : points[0];
        } else {
            B = points[index - 1];
            C = points[index + 1];
        }
        if (openPath && points.length === 1) projections.push(...new $f268b97836dca6b6$var$StrokeLineCapProjections(A, A, options).project());
        else if (openPath && (index === 0 || index === points.length - 1)) projections.push(...new $f268b97836dca6b6$var$StrokeLineCapProjections(A, index === 0 ? C : B, options).project());
        else projections.push(...new $f268b97836dca6b6$var$StrokeLineJoinProjections(A, B, C, options).project());
    });
    return projections;
};
const $f268b97836dca6b6$var$cloneStyles = (style)=>{
    const newObj = {};
    Object.keys(style).forEach((key)=>{
        newObj[key] = {};
        Object.keys(style[key]).forEach((keyInner)=>{
            newObj[key][keyInner] = $f268b97836dca6b6$var$_objectSpread2({}, style[key][keyInner]);
        });
    });
    return newObj;
};
/**
 * Capitalizes a string
 * @param {String} string String to capitalize
 * @param {Boolean} [firstLetterOnly] If true only first letter is capitalized
 * and other letters stay untouched, if false first letter is capitalized
 * and other letters are converted to lowercase.
 * @return {String} Capitalized version of a string
 */ const $f268b97836dca6b6$var$capitalize = function(string) {
    let firstLetterOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return "".concat(string.charAt(0).toUpperCase()).concat(firstLetterOnly ? string.slice(1) : string.slice(1).toLowerCase());
};
/**
 * Escapes XML in a string
 * @param {String} string String to escape
 * @return {String} Escaped version of a string
 */ const $f268b97836dca6b6$var$escapeXml = (string)=>string.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&apos;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
let $f268b97836dca6b6$var$segmenter;
const $f268b97836dca6b6$var$getSegmenter = ()=>{
    if (!$f268b97836dca6b6$var$segmenter) $f268b97836dca6b6$var$segmenter = 'Intl' in $f268b97836dca6b6$export$4a3a3142573970c3() && 'Segmenter' in Intl && new Intl.Segmenter(undefined, {
        granularity: 'grapheme'
    });
    return $f268b97836dca6b6$var$segmenter;
};
/**
 * Divide a string in the user perceived single units
 * @param {String} textstring String to escape
 * @return {Array} array containing the graphemes
 */ const $f268b97836dca6b6$var$graphemeSplit = (textstring)=>{
    $f268b97836dca6b6$var$segmenter || $f268b97836dca6b6$var$getSegmenter();
    if ($f268b97836dca6b6$var$segmenter) {
        const segments = $f268b97836dca6b6$var$segmenter.segment(textstring);
        return Array.from(segments).map((_ref)=>{
            let { segment: segment } = _ref;
            return segment;
        });
    }
    //Fallback
    return $f268b97836dca6b6$var$graphemeSplitImpl(textstring);
};
const $f268b97836dca6b6$var$graphemeSplitImpl = (textstring)=>{
    const graphemes = [];
    for(let i = 0, chr; i < textstring.length; i++){
        if ((chr = $f268b97836dca6b6$var$getWholeChar(textstring, i)) === false) continue;
        graphemes.push(chr);
    }
    return graphemes;
};
// taken from mdn in the charAt doc page.
const $f268b97836dca6b6$var$getWholeChar = (str, i)=>{
    const code = str.charCodeAt(i);
    if (isNaN(code)) return ''; // Position not found
    if (code < 0xd800 || code > 0xdfff) return str.charAt(i);
    // High surrogate (could change last hex to 0xDB7F to treat high private
    // surrogates as single characters)
    if (0xd800 <= code && code <= 0xdbff) {
        if (str.length <= i + 1) throw 'High surrogate without following low surrogate';
        const next = str.charCodeAt(i + 1);
        if (0xdc00 > next || next > 0xdfff) throw 'High surrogate without following low surrogate';
        return str.charAt(i) + str.charAt(i + 1);
    }
    // Low surrogate (0xDC00 <= code && code <= 0xDFFF)
    if (i === 0) throw 'Low surrogate without preceding high surrogate';
    const prev = str.charCodeAt(i - 1);
    // (could change last hex to 0xDB7F to treat high private
    // surrogates as single characters)
    if (0xd800 > prev || prev > 0xdbff) throw 'Low surrogate without preceding high surrogate';
    // We can pass over low surrogates now as the second component
    // in a pair which we have already processed
    return false;
};
var $f268b97836dca6b6$var$lang_string = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    capitalize: $f268b97836dca6b6$var$capitalize,
    escapeXml: $f268b97836dca6b6$var$escapeXml,
    graphemeSplit: $f268b97836dca6b6$var$graphemeSplit
});
/**
 * @param {Object} prevStyle first style to compare
 * @param {Object} thisStyle second style to compare
 * @param {boolean} forTextSpans whether to check overline, underline, and line-through properties
 * @return {boolean} true if the style changed
 */ const $f268b97836dca6b6$var$hasStyleChanged = function(prevStyle, thisStyle) {
    let forTextSpans = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return prevStyle.fill !== thisStyle.fill || prevStyle.stroke !== thisStyle.stroke || prevStyle.strokeWidth !== thisStyle.strokeWidth || prevStyle.fontSize !== thisStyle.fontSize || prevStyle.fontFamily !== thisStyle.fontFamily || prevStyle.fontWeight !== thisStyle.fontWeight || prevStyle.fontStyle !== thisStyle.fontStyle || prevStyle.textDecorationThickness !== thisStyle.textDecorationThickness || prevStyle.textBackgroundColor !== thisStyle.textBackgroundColor || prevStyle.deltaY !== thisStyle.deltaY || forTextSpans && (prevStyle.overline !== thisStyle.overline || prevStyle.underline !== thisStyle.underline || prevStyle.linethrough !== thisStyle.linethrough);
};
/**
 * Returns the array form of a text object's inline styles property with styles grouped in ranges
 * rather than per character. This format is less verbose, and is better suited for storage
 * so it is used in serialization (not during runtime).
 * @param {object} styles per character styles for a text object
 * @param {String} text the text string that the styles are applied to
 * @return {{start: number, end: number, style: object}[]}
 */ const $f268b97836dca6b6$var$stylesToArray = (styles, text)=>{
    const textLines = text.split('\n'), stylesArray = [];
    let charIndex = -1, prevStyle = {};
    // clone style structure to prevent mutation
    styles = $f268b97836dca6b6$var$cloneStyles(styles);
    //loop through each textLine
    for(let i = 0; i < textLines.length; i++){
        const chars = $f268b97836dca6b6$var$graphemeSplit(textLines[i]);
        if (!styles[i]) {
            //no styles exist for this line, so add the line's length to the charIndex total and reset prevStyle
            charIndex += chars.length;
            prevStyle = {};
            continue;
        }
        //loop through each character of the current line
        for(let c = 0; c < chars.length; c++){
            charIndex++;
            const thisStyle = styles[i][c];
            //check if style exists for this character
            if (thisStyle && Object.keys(thisStyle).length > 0) {
                if ($f268b97836dca6b6$var$hasStyleChanged(prevStyle, thisStyle, true)) stylesArray.push({
                    start: charIndex,
                    end: charIndex + 1,
                    style: thisStyle
                });
                else //if style is the same as previous character, increase end index
                stylesArray[stylesArray.length - 1].end++;
            }
            prevStyle = thisStyle || {};
        }
    }
    return stylesArray;
};
/**
 * Returns the object form of the styles property with styles that are assigned per
 * character rather than grouped by range. This format is more verbose, and is
 * only used during runtime (not for serialization/storage)
 * @param {Array} styles the serialized form of a text object's styles
 * @param {String} text the text string that the styles are applied to
 * @return {Object}
 */ const $f268b97836dca6b6$var$stylesFromArray = (styles, text)=>{
    if (!Array.isArray(styles)) // clone to prevent mutation
    return $f268b97836dca6b6$var$cloneStyles(styles);
    const textLines = text.split($f268b97836dca6b6$var$reNewline), stylesObject = {};
    let charIndex = -1, styleIndex = 0;
    //loop through each textLine
    for(let i = 0; i < textLines.length; i++){
        const chars = $f268b97836dca6b6$var$graphemeSplit(textLines[i]);
        //loop through each character of the current line
        for(let c = 0; c < chars.length; c++){
            charIndex++;
            //check if there's a style collection that includes the current character
            if (styles[styleIndex] && styles[styleIndex].start <= charIndex && charIndex < styles[styleIndex].end) {
                //create object for line index if it doesn't exist
                stylesObject[i] = stylesObject[i] || {};
                //assign a style at this character's index
                stylesObject[i][c] = $f268b97836dca6b6$var$_objectSpread2({}, styles[styleIndex].style);
                //if character is at the end of the current style collection, move to the next
                if (charIndex === styles[styleIndex].end - 1) styleIndex++;
            }
        }
    }
    return stylesObject;
};
/**
 * Attributes parsed from all SVG elements
 * @type array
 */ const $f268b97836dca6b6$var$SHARED_ATTRIBUTES = [
    'display',
    'transform',
    $f268b97836dca6b6$var$FILL,
    'fill-opacity',
    'fill-rule',
    'opacity',
    $f268b97836dca6b6$var$STROKE,
    'stroke-dasharray',
    'stroke-linecap',
    'stroke-dashoffset',
    'stroke-linejoin',
    'stroke-miterlimit',
    'stroke-opacity',
    'stroke-width',
    'id',
    'paint-order',
    'vector-effect',
    'instantiated_by_use',
    'clip-path'
];
function $f268b97836dca6b6$var$selectorMatches(element, selector) {
    const nodeName = element.nodeName;
    const classNames = element.getAttribute('class');
    const id = element.getAttribute('id');
    const azAz = '(?![a-zA-Z\\-]+)';
    let matcher;
    // i check if a selector matches slicing away part from it.
    // if i get empty string i should match
    matcher = new RegExp('^' + nodeName, 'i');
    selector = selector.replace(matcher, '');
    if (id && selector.length) {
        matcher = new RegExp('#' + id + azAz, 'i');
        selector = selector.replace(matcher, '');
    }
    if (classNames && selector.length) {
        const splitClassNames = classNames.split(' ');
        for(let i = splitClassNames.length; i--;){
            matcher = new RegExp('\\.' + splitClassNames[i] + azAz, 'i');
            selector = selector.replace(matcher, '');
        }
    }
    return selector.length === 0;
}
function $f268b97836dca6b6$var$doesSomeParentMatch(element, selectors) {
    let selector, parentMatching = true;
    while(element.parentElement && element.parentElement.nodeType === 1 && selectors.length){
        if (parentMatching) selector = selectors.pop();
        element = element.parentElement;
        parentMatching = $f268b97836dca6b6$var$selectorMatches(element, selector);
    }
    return selectors.length === 0;
}
/**
 * @private
 */ function $f268b97836dca6b6$var$elementMatchesRule(element, selectors) {
    let parentMatching = true;
    // start from rightmost selector.
    const firstMatching = $f268b97836dca6b6$var$selectorMatches(element, selectors.pop());
    if (firstMatching && selectors.length) parentMatching = $f268b97836dca6b6$var$doesSomeParentMatch(element, selectors);
    return firstMatching && parentMatching && selectors.length === 0;
}
/**
 * @private
 */ function $f268b97836dca6b6$var$getGlobalStylesForElement(element) {
    let cssRules = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let styles = {};
    for(const rule in cssRules)if ($f268b97836dca6b6$var$elementMatchesRule(element, rule.split(' '))) styles = $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, styles), cssRules[rule]);
    return styles;
}
const $f268b97836dca6b6$var$normalizeAttr = (attr)=>{
    var _attributesMap;
    return (_attributesMap = $f268b97836dca6b6$var$attributesMap[attr]) !== null && _attributesMap !== void 0 ? _attributesMap : attr;
};
const $f268b97836dca6b6$var$regex$1 = new RegExp("(".concat($f268b97836dca6b6$var$reNum, ")"), 'gi');
const $f268b97836dca6b6$var$cleanupSvgAttribute = (attributeValue)=>$f268b97836dca6b6$var$normalizeWs(attributeValue.replace($f268b97836dca6b6$var$regex$1, ' $1 ')// replace annoying commas and arbitrary whitespace with single spaces
    .replace(/,/gi, ' '));
var $f268b97836dca6b6$var$_templateObject, $f268b97836dca6b6$var$_templateObject2, $f268b97836dca6b6$var$_templateObject3, $f268b97836dca6b6$var$_templateObject4, $f268b97836dca6b6$var$_templateObject5, $f268b97836dca6b6$var$_templateObject6, $f268b97836dca6b6$var$_templateObject7;
// == begin transform regexp
const $f268b97836dca6b6$var$p$1 = "(".concat($f268b97836dca6b6$var$reNum, ")");
const $f268b97836dca6b6$var$skewX = String.raw($f268b97836dca6b6$var$_templateObject || ($f268b97836dca6b6$var$_templateObject = $f268b97836dca6b6$var$_taggedTemplateLiteral([
    "(skewX)(",
    ")"
], [
    "(skewX)\\(",
    "\\)"
])), $f268b97836dca6b6$var$p$1);
const $f268b97836dca6b6$var$skewY = String.raw($f268b97836dca6b6$var$_templateObject2 || ($f268b97836dca6b6$var$_templateObject2 = $f268b97836dca6b6$var$_taggedTemplateLiteral([
    "(skewY)(",
    ")"
], [
    "(skewY)\\(",
    "\\)"
])), $f268b97836dca6b6$var$p$1);
const $f268b97836dca6b6$var$rotate = String.raw($f268b97836dca6b6$var$_templateObject3 || ($f268b97836dca6b6$var$_templateObject3 = $f268b97836dca6b6$var$_taggedTemplateLiteral([
    "(rotate)(",
    "(?: ",
    " ",
    ")?)"
], [
    "(rotate)\\(",
    "(?: ",
    " ",
    ")?\\)"
])), $f268b97836dca6b6$var$p$1, $f268b97836dca6b6$var$p$1, $f268b97836dca6b6$var$p$1);
const $f268b97836dca6b6$var$scale = String.raw($f268b97836dca6b6$var$_templateObject4 || ($f268b97836dca6b6$var$_templateObject4 = $f268b97836dca6b6$var$_taggedTemplateLiteral([
    "(scale)(",
    "(?: ",
    ")?)"
], [
    "(scale)\\(",
    "(?: ",
    ")?\\)"
])), $f268b97836dca6b6$var$p$1, $f268b97836dca6b6$var$p$1);
const $f268b97836dca6b6$var$translate = String.raw($f268b97836dca6b6$var$_templateObject5 || ($f268b97836dca6b6$var$_templateObject5 = $f268b97836dca6b6$var$_taggedTemplateLiteral([
    "(translate)(",
    "(?: ",
    ")?)"
], [
    "(translate)\\(",
    "(?: ",
    ")?\\)"
])), $f268b97836dca6b6$var$p$1, $f268b97836dca6b6$var$p$1);
const $f268b97836dca6b6$var$matrix = String.raw($f268b97836dca6b6$var$_templateObject6 || ($f268b97836dca6b6$var$_templateObject6 = $f268b97836dca6b6$var$_taggedTemplateLiteral([
    "(matrix)(",
    " ",
    " ",
    " ",
    " ",
    " ",
    ")"
], [
    "(matrix)\\(",
    " ",
    " ",
    " ",
    " ",
    " ",
    "\\)"
])), $f268b97836dca6b6$var$p$1, $f268b97836dca6b6$var$p$1, $f268b97836dca6b6$var$p$1, $f268b97836dca6b6$var$p$1, $f268b97836dca6b6$var$p$1, $f268b97836dca6b6$var$p$1);
const $f268b97836dca6b6$var$transform = "(?:".concat($f268b97836dca6b6$var$matrix, "|").concat($f268b97836dca6b6$var$translate, "|").concat($f268b97836dca6b6$var$rotate, "|").concat($f268b97836dca6b6$var$scale, "|").concat($f268b97836dca6b6$var$skewX, "|").concat($f268b97836dca6b6$var$skewY, ")");
const $f268b97836dca6b6$var$transforms = "(?:".concat($f268b97836dca6b6$var$transform, "*)");
const $f268b97836dca6b6$var$transformList = String.raw($f268b97836dca6b6$var$_templateObject7 || ($f268b97836dca6b6$var$_templateObject7 = $f268b97836dca6b6$var$_taggedTemplateLiteral([
    "^s*(?:",
    "?)s*$"
], [
    "^\\s*(?:",
    "?)\\s*$"
])), $f268b97836dca6b6$var$transforms);
// http://www.w3.org/TR/SVG/coords.html#TransformAttribute
const $f268b97836dca6b6$var$reTransformList = new RegExp($f268b97836dca6b6$var$transformList);
const $f268b97836dca6b6$var$reTransform = new RegExp($f268b97836dca6b6$var$transform);
const $f268b97836dca6b6$var$reTransformAll = new RegExp($f268b97836dca6b6$var$transform, 'g');
// == end transform regexp
/**
 * Parses "transform" attribute, returning an array of values
 * @static
 * @function
 * @memberOf fabric
 * @param {String} attributeValue String containing attribute value
 * @return {TTransformMatrix} Array of 6 elements representing transformation matrix
 */ function $f268b97836dca6b6$export$6655c0d22b13de1f(attributeValue) {
    // first we clean the string
    attributeValue = $f268b97836dca6b6$var$cleanupSvgAttribute(attributeValue)// remove spaces around front parentheses
    .replace(/\s*([()])\s*/gi, '$1');
    // start with identity matrix
    const matrices = [];
    // return if no argument was given or
    // an argument does not match transform attribute regexp
    if (!attributeValue || attributeValue && !$f268b97836dca6b6$var$reTransformList.test(attributeValue)) return [
        ...$f268b97836dca6b6$export$3c5a7f9475b116e0
    ];
    for (const match of attributeValue.matchAll($f268b97836dca6b6$var$reTransformAll)){
        const transformMatch = $f268b97836dca6b6$var$reTransform.exec(match[0]);
        if (!transformMatch) continue;
        let matrix = $f268b97836dca6b6$export$3c5a7f9475b116e0;
        const matchedParams = transformMatch.filter((m)=>!!m);
        const [, operation, ...rawArgs] = matchedParams;
        const [arg0, arg1, arg2, arg3, arg4, arg5] = rawArgs.map((arg)=>parseFloat(arg));
        switch(operation){
            case 'translate':
                matrix = $f268b97836dca6b6$var$createTranslateMatrix(arg0, arg1);
                break;
            case $f268b97836dca6b6$var$ROTATE:
                matrix = $f268b97836dca6b6$var$createRotateMatrix({
                    angle: arg0
                }, {
                    x: arg1,
                    y: arg2
                });
                break;
            case $f268b97836dca6b6$var$SCALE:
                matrix = $f268b97836dca6b6$var$createScaleMatrix(arg0, arg1);
                break;
            case $f268b97836dca6b6$var$SKEW_X:
                matrix = $f268b97836dca6b6$var$createSkewXMatrix(arg0);
                break;
            case $f268b97836dca6b6$var$SKEW_Y:
                matrix = $f268b97836dca6b6$var$createSkewYMatrix(arg0);
                break;
            case 'matrix':
                matrix = [
                    arg0,
                    arg1,
                    arg2,
                    arg3,
                    arg4,
                    arg5
                ];
                break;
        }
        // snapshot current matrix into matrices array
        matrices.push(matrix);
    }
    return $f268b97836dca6b6$var$multiplyTransformMatrixArray(matrices);
}
function $f268b97836dca6b6$var$normalizeValue(attr, value, parentAttributes, fontSize) {
    const isArray = Array.isArray(value);
    let parsed;
    let ouputValue = value;
    if ((attr === $f268b97836dca6b6$var$FILL || attr === $f268b97836dca6b6$var$STROKE) && value === $f268b97836dca6b6$var$NONE) ouputValue = '';
    else if (attr === 'strokeUniform') return value === 'non-scaling-stroke';
    else if (attr === 'strokeDashArray') {
        if (value === $f268b97836dca6b6$var$NONE) ouputValue = null;
        else ouputValue = value.replace(/,/g, ' ').split(/\s+/).map(parseFloat);
    } else if (attr === 'transformMatrix') {
        if (parentAttributes && parentAttributes.transformMatrix) ouputValue = $f268b97836dca6b6$var$multiplyTransformMatrices(parentAttributes.transformMatrix, $f268b97836dca6b6$export$6655c0d22b13de1f(value));
        else ouputValue = $f268b97836dca6b6$export$6655c0d22b13de1f(value);
    } else if (attr === 'visible') {
        ouputValue = value !== $f268b97836dca6b6$var$NONE && value !== 'hidden';
        // display=none on parent element always takes precedence over child element
        if (parentAttributes && parentAttributes.visible === false) ouputValue = false;
    } else if (attr === 'opacity') {
        ouputValue = parseFloat(value);
        if (parentAttributes && typeof parentAttributes.opacity !== 'undefined') ouputValue *= parentAttributes.opacity;
    } else if (attr === 'textAnchor' /* text-anchor */ ) ouputValue = value === 'start' ? $f268b97836dca6b6$var$LEFT : value === 'end' ? $f268b97836dca6b6$var$RIGHT : $f268b97836dca6b6$var$CENTER;
    else if (attr === 'charSpacing' || attr === $f268b97836dca6b6$var$TEXT_DECORATION_THICKNESS) // parseUnit returns px and we convert it to em
    parsed = $f268b97836dca6b6$var$parseUnit(value, fontSize) / fontSize * 1000;
    else if (attr === 'paintFirst') {
        const fillIndex = value.indexOf($f268b97836dca6b6$var$FILL);
        const strokeIndex = value.indexOf($f268b97836dca6b6$var$STROKE);
        ouputValue = $f268b97836dca6b6$var$FILL;
        if (fillIndex > -1 && strokeIndex > -1 && strokeIndex < fillIndex) ouputValue = $f268b97836dca6b6$var$STROKE;
        else if (fillIndex === -1 && strokeIndex > -1) ouputValue = $f268b97836dca6b6$var$STROKE;
    } else if (attr === 'href' || attr === 'xlink:href' || attr === 'font' || attr === 'id') return value;
    else if (attr === 'imageSmoothing') return value === 'optimizeQuality';
    else parsed = isArray ? value.map($f268b97836dca6b6$var$parseUnit) : $f268b97836dca6b6$var$parseUnit(value, fontSize);
    return !isArray && isNaN(parsed) ? ouputValue : parsed;
}
/**
 * Parses a short font declaration, building adding its properties to a style object
 * @static
 * @function
 * @memberOf fabric
 * @param {String} value font declaration
 * @param {Object} oStyle definition
 */ function $f268b97836dca6b6$export$da5b8f587c2501a(value, oStyle) {
    const match = value.match($f268b97836dca6b6$var$reFontDeclaration);
    if (!match) return;
    const fontStyle = match[1], // font variant is not used
    // fontVariant = match[2],
    fontWeight = match[3], fontSize = match[4], lineHeight = match[5], fontFamily = match[6];
    if (fontStyle) oStyle.fontStyle = fontStyle;
    if (fontWeight) oStyle.fontWeight = isNaN(parseFloat(fontWeight)) ? fontWeight : parseFloat(fontWeight);
    if (fontSize) oStyle.fontSize = $f268b97836dca6b6$var$parseUnit(fontSize);
    if (fontFamily) oStyle.fontFamily = fontFamily;
    if (lineHeight) oStyle.lineHeight = lineHeight === 'normal' ? 1 : lineHeight;
}
/**
 * Takes a style object and parses it in one that has only defined values
 * and lowercases properties
 * @param style
 * @param oStyle
 */ function $f268b97836dca6b6$var$parseStyleObject(style, oStyle) {
    Object.entries(style).forEach((_ref)=>{
        let [prop, value] = _ref;
        if (value === undefined) return;
        oStyle[prop.toLowerCase()] = value;
    });
}
/**
 * Takes a style string and parses it in one that has only defined values
 * and lowercases properties
 * @param style
 * @param oStyle
 */ function $f268b97836dca6b6$var$parseStyleString(style, oStyle) {
    style.replace(/;\s*$/, '').split(';').forEach((chunk)=>{
        if (!chunk) return;
        const [attr, value] = chunk.split(':');
        oStyle[attr.trim().toLowerCase()] = value.trim();
    });
}
/**
 * Parses "style" attribute, retuning an object with values
 * @static
 * @memberOf fabric
 * @param {SVGElement} element Element to parse
 * @return {Object} Objects with values parsed from style attribute of an element
 */ function $f268b97836dca6b6$export$d0c59994cd7c3b84(element) {
    const oStyle = {}, style = element.getAttribute('style');
    if (!style) return oStyle;
    if (typeof style === 'string') $f268b97836dca6b6$var$parseStyleString(style, oStyle);
    else $f268b97836dca6b6$var$parseStyleObject(style, oStyle);
    return oStyle;
}
const $f268b97836dca6b6$var$colorAttributesMap = {
    stroke: 'strokeOpacity',
    fill: 'fillOpacity'
};
/**
 * @private
 * @param {Object} attributes Array of attributes to parse
 */ function $f268b97836dca6b6$var$setStrokeFillOpacity(attributes) {
    const defaults = $f268b97836dca6b6$export$5a5fba7eea6847b1.getDefaults();
    Object.entries($f268b97836dca6b6$var$colorAttributesMap).forEach((_ref)=>{
        let [attr, colorAttr] = _ref;
        if (typeof attributes[colorAttr] === 'undefined' || attributes[attr] === '') return;
        if (typeof attributes[attr] === 'undefined') {
            if (!defaults[attr]) return;
            attributes[attr] = defaults[attr];
        }
        if (attributes[attr].indexOf('url(') === 0) return;
        const color = new $f268b97836dca6b6$export$892596cec99bc70e(attributes[attr]);
        attributes[attr] = color.setAlpha($f268b97836dca6b6$var$toFixed(color.getAlpha() * attributes[colorAttr], 2)).toRgba();
    });
    return attributes;
}
/**
 * Returns an object of attributes' name/value, given element and an array of attribute names;
 * Parses parent "g" nodes recursively upwards.
 * @param {SVGElement | HTMLElement} element Element to parse
 * @param {Array} attributes Array of attributes to parse
 * @return {Object} object containing parsed attributes' names/values
 */ function $f268b97836dca6b6$export$fbe550151e406473(element, attributes, cssRules) {
    if (!element) return {};
    let parentAttributes = {}, fontSize, parentFontSize = $f268b97836dca6b6$var$DEFAULT_SVG_FONT_SIZE;
    // if there's a parent container (`g` or `a` or `symbol` node), parse its attributes recursively upwards
    if (element.parentNode && $f268b97836dca6b6$var$svgValidParentsRegEx.test(element.parentNode.nodeName)) {
        parentAttributes = $f268b97836dca6b6$export$fbe550151e406473(element.parentElement, attributes, cssRules);
        if (parentAttributes.fontSize) fontSize = parentFontSize = $f268b97836dca6b6$var$parseUnit(parentAttributes.fontSize);
    }
    const ownAttributes = $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, attributes.reduce((memo, attr)=>{
        const value = element.getAttribute(attr);
        if (value) memo[attr] = value;
        return memo;
    }, {})), $f268b97836dca6b6$var$getGlobalStylesForElement(element, cssRules)), $f268b97836dca6b6$export$d0c59994cd7c3b84(element));
    if (ownAttributes[$f268b97836dca6b6$var$cPath]) element.setAttribute($f268b97836dca6b6$var$cPath, ownAttributes[$f268b97836dca6b6$var$cPath]);
    if (ownAttributes[$f268b97836dca6b6$var$fSize]) {
        // looks like the minimum should be 9px when dealing with ems. this is what looks like in browsers.
        fontSize = $f268b97836dca6b6$var$parseUnit(ownAttributes[$f268b97836dca6b6$var$fSize], parentFontSize);
        ownAttributes[$f268b97836dca6b6$var$fSize] = "".concat(fontSize);
    }
    // this should have its own complex type
    const normalizedStyle = {};
    for(const attr in ownAttributes){
        const normalizedAttr = $f268b97836dca6b6$var$normalizeAttr(attr);
        const normalizedValue = $f268b97836dca6b6$var$normalizeValue(normalizedAttr, ownAttributes[attr], parentAttributes, fontSize);
        normalizedStyle[normalizedAttr] = normalizedValue;
    }
    if (normalizedStyle && normalizedStyle.font) $f268b97836dca6b6$export$da5b8f587c2501a(normalizedStyle.font, normalizedStyle);
    const mergedAttrs = $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, parentAttributes), normalizedStyle);
    return $f268b97836dca6b6$var$svgValidParentsRegEx.test(element.nodeName) ? mergedAttrs : $f268b97836dca6b6$var$setStrokeFillOpacity(mergedAttrs);
}
const $f268b97836dca6b6$var$_excluded$c = [
    "left",
    "top",
    "width",
    "height",
    "visible"
];
const $f268b97836dca6b6$var$rectDefaultValues = {
    rx: 0,
    ry: 0
};
const $f268b97836dca6b6$var$RECT_PROPS = [
    'rx',
    'ry'
];
class $f268b97836dca6b6$export$c79fc6492f3af13d extends $f268b97836dca6b6$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.getDefaults()), $f268b97836dca6b6$export$c79fc6492f3af13d.ownDefaults);
    }
    /**
   * Initializes rx/ry attributes
   * @private
   */ _initRxRy() {
        const { rx: rx, ry: ry } = this;
        if (rx && !ry) this.ry = rx;
        else if (ry && !rx) this.rx = ry;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _render(ctx) {
        const { width: w, height: h } = this;
        const x = -w / 2;
        const y = -h / 2;
        const rx = this.rx ? Math.min(this.rx, w / 2) : 0;
        const ry = this.ry ? Math.min(this.ry, h / 2) : 0;
        const isRounded = rx !== 0 || ry !== 0;
        ctx.beginPath();
        ctx.moveTo(x + rx, y);
        ctx.lineTo(x + w - rx, y);
        isRounded && ctx.bezierCurveTo(x + w - $f268b97836dca6b6$var$kRect * rx, y, x + w, y + $f268b97836dca6b6$var$kRect * ry, x + w, y + ry);
        ctx.lineTo(x + w, y + h - ry);
        isRounded && ctx.bezierCurveTo(x + w, y + h - $f268b97836dca6b6$var$kRect * ry, x + w - $f268b97836dca6b6$var$kRect * rx, y + h, x + w - rx, y + h);
        ctx.lineTo(x + rx, y + h);
        isRounded && ctx.bezierCurveTo(x + $f268b97836dca6b6$var$kRect * rx, y + h, x, y + h - $f268b97836dca6b6$var$kRect * ry, x, y + h - ry);
        ctx.lineTo(x, y + ry);
        isRounded && ctx.bezierCurveTo(x, y + $f268b97836dca6b6$var$kRect * ry, x + $f268b97836dca6b6$var$kRect * rx, y, x + rx, y);
        ctx.closePath();
        this._renderPaintInOrder(ctx);
    }
    /**
   * Returns object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return super.toObject([
            ...$f268b97836dca6b6$var$RECT_PROPS,
            ...propertiesToInclude
        ]);
    }
    /**
   * Returns svg representation of an instance
   * @return {Array} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG() {
        const { width: width, height: height, rx: rx, ry: ry } = this;
        return [
            '<rect ',
            'COMMON_PARTS',
            "x=\"".concat(-width / 2, "\" y=\"").concat(-height / 2, "\" rx=\"").concat(rx, "\" ry=\"").concat(ry, "\" width=\"").concat(width, "\" height=\"").concat(height, "\" />\n")
        ];
    }
    /**
   * List of attribute names to account for when parsing SVG element (used by `Rect.fromElement`)
   * @static
   * @memberOf Rect
   * @see: http://www.w3.org/TR/SVG/shapes.html#RectElement
   */ /* _FROM_SVG_START_ */ /**
   * Returns {@link Rect} instance from an SVG element
   * @static
   * @memberOf Rect
   * @param {HTMLElement} element Element to parse
   * @param {Object} [options] Options object
   */ static async fromElement(element, options, cssRules) {
        const _parseAttributes = $f268b97836dca6b6$export$fbe550151e406473(element, this.ATTRIBUTE_NAMES, cssRules), { left: left = 0, top: top = 0, width: width = 0, height: height = 0, visible: visible = true } = _parseAttributes, restOfparsedAttributes = $f268b97836dca6b6$var$_objectWithoutProperties(_parseAttributes, $f268b97836dca6b6$var$_excluded$c);
        return new this($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, options), restOfparsedAttributes), {}, {
            left: left,
            top: top,
            width: width,
            height: height,
            visible: Boolean(visible && width && height)
        }));
    }
    /**
   * Constructor
   * @param {Object} [options] Options object
   */ constructor(options){
        super();
        Object.assign(this, $f268b97836dca6b6$export$c79fc6492f3af13d.ownDefaults);
        this.setOptions(options);
        this._initRxRy();
    }
}
/**
 * Horizontal border radius
 * @type Number
 * @default
 */ /**
 * Vertical border radius
 * @type Number
 * @default
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$c79fc6492f3af13d, "type", 'Rect');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$c79fc6492f3af13d, "cacheProperties", [
    ...$f268b97836dca6b6$var$cacheProperties,
    ...$f268b97836dca6b6$var$RECT_PROPS
]);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$c79fc6492f3af13d, "ownDefaults", $f268b97836dca6b6$var$rectDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$c79fc6492f3af13d, "ATTRIBUTE_NAMES", [
    ...$f268b97836dca6b6$var$SHARED_ATTRIBUTES,
    'x',
    'y',
    'rx',
    'ry',
    'width',
    'height'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$c79fc6492f3af13d);
$f268b97836dca6b6$export$2792378e23a7920c.setSVGClass($f268b97836dca6b6$export$c79fc6492f3af13d);
const $f268b97836dca6b6$var$LAYOUT_TYPE_INITIALIZATION = 'initialization';
const $f268b97836dca6b6$var$LAYOUT_TYPE_ADDED = 'added';
const $f268b97836dca6b6$var$LAYOUT_TYPE_REMOVED = 'removed';
const $f268b97836dca6b6$var$LAYOUT_TYPE_IMPERATIVE = 'imperative';
const $f268b97836dca6b6$var$LAYOUT_TYPE_OBJECT_MODIFIED = 'object_modified';
const $f268b97836dca6b6$var$LAYOUT_TYPE_OBJECT_MODIFYING = 'object_modifying';
/**
 * @returns 2 points, the tl and br corners of the non rotated bounding box of an object
 * in the {@link group} plane, taking into account objects that {@link group} is their parent
 * but also belong to the active selection.
 */ const $f268b97836dca6b6$var$getObjectBounds = (destinationGroup, object)=>{
    const { strokeUniform: strokeUniform, strokeWidth: strokeWidth, width: width, height: height, group: currentGroup } = object;
    const t = currentGroup && currentGroup !== destinationGroup ? $f268b97836dca6b6$var$calcPlaneChangeMatrix(currentGroup.calcTransformMatrix(), destinationGroup.calcTransformMatrix()) : null;
    const objectCenter = t ? object.getRelativeCenterPoint().transform(t) : object.getRelativeCenterPoint();
    const accountForStroke = !object['isStrokeAccountedForInDimensions']();
    const strokeUniformVector = strokeUniform && accountForStroke ? $f268b97836dca6b6$var$sendVectorToPlane(new $f268b97836dca6b6$export$baf26146a414f24a(strokeWidth, strokeWidth), undefined, destinationGroup.calcTransformMatrix()) : $f268b97836dca6b6$var$ZERO;
    const scalingStrokeWidth = !strokeUniform && accountForStroke ? strokeWidth : 0;
    const sizeVector = $f268b97836dca6b6$var$sizeAfterTransform(width + scalingStrokeWidth, height + scalingStrokeWidth, $f268b97836dca6b6$var$multiplyTransformMatrixArray([
        t,
        object.calcOwnMatrix()
    ], true)).add(strokeUniformVector).scalarDivide(2);
    return [
        objectCenter.subtract(sizeVector),
        objectCenter.add(sizeVector)
    ];
};
/**
 * Exposes a main public method {@link calcLayoutResult} that is used by the `LayoutManager` to perform layout.
 * Returning `undefined` signals the `LayoutManager` to skip the layout.
 *
 * In charge of calculating the bounding box of the passed objects.
 */ class $f268b97836dca6b6$export$f7b260234c293505 {
    /**
   * Used by the `LayoutManager` to perform layout
   * @TODO/fix: if this method is calcResult, should calc unconditionally.
   * the condition to not calc should be evaluated by the layoutManager.
   * @returns layout result **OR** `undefined` to skip layout
   */ calcLayoutResult(context, objects) {
        if (this.shouldPerformLayout(context)) return this.calcBoundingBox(objects, context);
    }
    shouldPerformLayout(_ref) {
        let { type: type, prevStrategy: prevStrategy, strategy: strategy } = _ref;
        return type === $f268b97836dca6b6$var$LAYOUT_TYPE_INITIALIZATION || type === $f268b97836dca6b6$var$LAYOUT_TYPE_IMPERATIVE || !!prevStrategy && strategy !== prevStrategy;
    }
    shouldLayoutClipPath(_ref2) {
        let { type: type, target: { clipPath: clipPath } } = _ref2;
        return type !== $f268b97836dca6b6$var$LAYOUT_TYPE_INITIALIZATION && clipPath && !clipPath.absolutePositioned;
    }
    getInitialSize(context, result) {
        return result.size;
    }
    /**
   * Override this method to customize layout.
   */ calcBoundingBox(objects, context) {
        const { type: type, target: target } = context;
        if (type === $f268b97836dca6b6$var$LAYOUT_TYPE_IMPERATIVE && context.overrides) return context.overrides;
        if (objects.length === 0) return;
        const { left: left, top: top, width: width, height: height } = $f268b97836dca6b6$var$makeBoundingBoxFromPoints(objects.map((object)=>$f268b97836dca6b6$var$getObjectBounds(target, object)).reduce((coords, curr)=>coords.concat(curr), []));
        const bboxSize = new $f268b97836dca6b6$export$baf26146a414f24a(width, height);
        const bboxLeftTop = new $f268b97836dca6b6$export$baf26146a414f24a(left, top);
        const bboxCenter = bboxLeftTop.add(bboxSize.scalarDivide(2));
        if (type === $f268b97836dca6b6$var$LAYOUT_TYPE_INITIALIZATION) {
            const actualSize = this.getInitialSize(context, {
                size: bboxSize,
                center: bboxCenter
            });
            return {
                // in `initialization` we do not account for target's transformation matrix
                center: bboxCenter,
                // TODO: investigate if this is still necessary
                relativeCorrection: new $f268b97836dca6b6$export$baf26146a414f24a(0, 0),
                size: actualSize
            };
        } else {
            //  we send `relativeCenter` up to group's containing plane
            const center = bboxCenter.transform(target.calcOwnMatrix());
            return {
                center: center,
                size: bboxSize
            };
        }
    }
}
/**
 * override by subclass for persistence (TS does not support `static abstract`)
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$f7b260234c293505, "type", 'strategy');
/**
 * Layout will adjust the bounding box to fit target's objects.
 */ class $f268b97836dca6b6$export$36cf2cf6e71f4d55 extends $f268b97836dca6b6$export$f7b260234c293505 {
    /**
   * @override layout on all triggers
   * Override at will
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    shouldPerformLayout(context) {
        return true;
    }
}
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$36cf2cf6e71f4d55, "type", 'fit-content');
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$36cf2cf6e71f4d55);
const $f268b97836dca6b6$var$_excluded$b = [
    "strategy"
], $f268b97836dca6b6$var$_excluded2$3 = [
    "target",
    "strategy",
    "bubbles",
    "prevStrategy"
];
const $f268b97836dca6b6$var$LAYOUT_MANAGER = 'layoutManager';
class $f268b97836dca6b6$export$4a04ad01c410b415 {
    performLayout(context) {
        const strictContext = $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({
            bubbles: true,
            strategy: this.strategy
        }, context), {}, {
            prevStrategy: this._prevLayoutStrategy,
            stopPropagation () {
                this.bubbles = false;
            }
        });
        this.onBeforeLayout(strictContext);
        const layoutResult = this.getLayoutResult(strictContext);
        if (layoutResult) this.commitLayout(strictContext, layoutResult);
        this.onAfterLayout(strictContext, layoutResult);
        this._prevLayoutStrategy = strictContext.strategy;
    }
    /**
   * Attach handlers for events that we know will invalidate the layout when
   * performed on child objects ( general transforms ).
   * Returns the disposers for later unsubscribing and cleanup
   * @param {FabricObject} object
   * @param {RegistrationContext & Partial<StrictLayoutContext>} context
   * @returns {VoidFunction[]} disposers remove the handlers
   */ attachHandlers(object, context) {
        const { target: target } = context;
        return [
            $f268b97836dca6b6$var$MODIFIED,
            $f268b97836dca6b6$var$MOVING,
            $f268b97836dca6b6$var$RESIZING,
            $f268b97836dca6b6$var$ROTATING,
            $f268b97836dca6b6$var$SCALING,
            $f268b97836dca6b6$var$SKEWING,
            $f268b97836dca6b6$var$CHANGED,
            $f268b97836dca6b6$var$MODIFY_POLY,
            $f268b97836dca6b6$var$MODIFY_PATH
        ].map((key)=>object.on(key, (e)=>this.performLayout(key === $f268b97836dca6b6$var$MODIFIED ? {
                    type: $f268b97836dca6b6$var$LAYOUT_TYPE_OBJECT_MODIFIED,
                    trigger: key,
                    e: e,
                    target: target
                } : {
                    type: $f268b97836dca6b6$var$LAYOUT_TYPE_OBJECT_MODIFYING,
                    trigger: key,
                    e: e,
                    target: target
                })));
    }
    /**
   * Subscribe an object to transform events that will trigger a layout change on the parent
   * This is important only for interactive groups.
   * @param object
   * @param context
   */ subscribe(object, context) {
        this.unsubscribe(object, context);
        const disposers = this.attachHandlers(object, context);
        this._subscriptions.set(object, disposers);
    }
    /**
   * unsubscribe object layout triggers
   */ unsubscribe(object, _context) {
        (this._subscriptions.get(object) || []).forEach((d)=>d());
        this._subscriptions.delete(object);
    }
    unsubscribeTargets(context) {
        context.targets.forEach((object)=>this.unsubscribe(object, context));
    }
    subscribeTargets(context) {
        context.targets.forEach((object)=>this.subscribe(object, context));
    }
    onBeforeLayout(context) {
        const { target: target, type: type } = context;
        const { canvas: canvas } = target;
        // handle layout triggers subscription
        // @TODO: gate the registration when the group is interactive
        if (type === $f268b97836dca6b6$var$LAYOUT_TYPE_INITIALIZATION || type === $f268b97836dca6b6$var$LAYOUT_TYPE_ADDED) this.subscribeTargets(context);
        else if (type === $f268b97836dca6b6$var$LAYOUT_TYPE_REMOVED) this.unsubscribeTargets(context);
        // fire layout event (event will fire only for layouts after initialization layout)
        target.fire('layout:before', {
            context: context
        });
        canvas && canvas.fire('object:layout:before', {
            target: target,
            context: context
        });
        if (type === $f268b97836dca6b6$var$LAYOUT_TYPE_IMPERATIVE && context.deep) {
            const tricklingContext = $f268b97836dca6b6$var$_objectWithoutProperties(context, $f268b97836dca6b6$var$_excluded$b);
            // traverse the tree
            target.forEachObject((object)=>object.layoutManager && object.layoutManager.performLayout($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, tricklingContext), {}, {
                    bubbles: false,
                    target: object
                })));
        }
    }
    getLayoutResult(context) {
        const { target: target, strategy: strategy, type: type } = context;
        const result = strategy.calcLayoutResult(context, target.getObjects());
        if (!result) return;
        const prevCenter = type === $f268b97836dca6b6$var$LAYOUT_TYPE_INITIALIZATION ? new $f268b97836dca6b6$export$baf26146a414f24a() : target.getRelativeCenterPoint();
        const { center: nextCenter, correction: correction = new $f268b97836dca6b6$export$baf26146a414f24a(), relativeCorrection: relativeCorrection = new $f268b97836dca6b6$export$baf26146a414f24a() } = result;
        const offset = prevCenter.subtract(nextCenter).add(correction).transform(// in `initialization` we do not account for target's transformation matrix
        type === $f268b97836dca6b6$var$LAYOUT_TYPE_INITIALIZATION ? $f268b97836dca6b6$export$3c5a7f9475b116e0 : $f268b97836dca6b6$var$invertTransform(target.calcOwnMatrix()), true).add(relativeCorrection);
        return {
            result: result,
            prevCenter: prevCenter,
            nextCenter: nextCenter,
            offset: offset
        };
    }
    commitLayout(context, layoutResult) {
        const { target: target } = context;
        const { result: { size: size }, nextCenter: nextCenter } = layoutResult;
        // set dimensions
        target.set({
            width: size.x,
            height: size.y
        });
        // layout descendants
        this.layoutObjects(context, layoutResult);
        //  set position
        // in `initialization` we do not account for target's transformation matrix
        if (context.type === $f268b97836dca6b6$var$LAYOUT_TYPE_INITIALIZATION) {
            var _context$x, _context$y;
            // TODO: what about strokeWidth?
            target.set({
                left: (_context$x = context.x) !== null && _context$x !== void 0 ? _context$x : nextCenter.x + size.x * $f268b97836dca6b6$var$resolveOrigin(target.originX),
                top: (_context$y = context.y) !== null && _context$y !== void 0 ? _context$y : nextCenter.y + size.y * $f268b97836dca6b6$var$resolveOrigin(target.originY)
            });
        } else {
            target.setPositionByOrigin(nextCenter, $f268b97836dca6b6$var$CENTER, $f268b97836dca6b6$var$CENTER);
            // invalidate
            target.setCoords();
            target.set('dirty', true);
        }
    }
    layoutObjects(context, layoutResult) {
        const { target: target } = context;
        //  adjust objects to account for new center
        target.forEachObject((object)=>{
            object.group === target && this.layoutObject(context, layoutResult, object);
        });
        // adjust clip path to account for new center
        context.strategy.shouldLayoutClipPath(context) && this.layoutObject(context, layoutResult, target.clipPath);
    }
    /**
   * @param {FabricObject} object
   * @param {Point} offset
   */ layoutObject(context, _ref, object) {
        let { offset: offset } = _ref;
        // TODO: this is here for cache invalidation.
        // verify if this is necessary since we have explicit
        // cache invalidation at the end of commitLayout
        object.set({
            left: object.left + offset.x,
            top: object.top + offset.y
        });
    }
    onAfterLayout(context, layoutResult) {
        const { target: target, strategy: strategy, bubbles: bubbles, prevStrategy: _ } = context, bubblingContext = $f268b97836dca6b6$var$_objectWithoutProperties(context, $f268b97836dca6b6$var$_excluded2$3);
        const { canvas: canvas } = target;
        //  fire layout event (event will fire only for layouts after initialization layout)
        target.fire('layout:after', {
            context: context,
            result: layoutResult
        });
        canvas && canvas.fire('object:layout:after', {
            context: context,
            result: layoutResult,
            target: target
        });
        //  bubble
        const parent = target.parent;
        if (bubbles && parent !== null && parent !== void 0 && parent.layoutManager) {
            //  add target to context#path
            (bubblingContext.path || (bubblingContext.path = [])).push(target);
            //  all parents should invalidate their layout
            parent.layoutManager.performLayout($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, bubblingContext), {}, {
                target: parent
            }));
        }
        target.set('dirty', true);
    }
    dispose() {
        const { _subscriptions: _subscriptions } = this;
        _subscriptions.forEach((disposers)=>disposers.forEach((d)=>d()));
        _subscriptions.clear();
    }
    toObject() {
        return {
            type: $f268b97836dca6b6$var$LAYOUT_MANAGER,
            strategy: this.strategy.constructor.type
        };
    }
    toJSON() {
        return this.toObject();
    }
    constructor(){
        let strategy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new $f268b97836dca6b6$export$36cf2cf6e71f4d55();
        $f268b97836dca6b6$var$_defineProperty(this, "strategy", void 0);
        this.strategy = strategy;
        this._subscriptions = new Map();
    }
}
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$4a04ad01c410b415, $f268b97836dca6b6$var$LAYOUT_MANAGER);
const $f268b97836dca6b6$var$_excluded$a = [
    "type",
    "objects",
    "layoutManager"
];
/**
 * This class handles the specific case of creating a group using {@link Group#fromObject} and is not meant to be used in any other case.
 * We could have used a boolean in the constructor, as we did previously, but we think the boolean
 * would stay in the group's constructor interface and create confusion, therefore it was removed.
 * This layout manager doesn't do anything and therefore keeps the exact layout the group had when {@link Group#toObject} was called.
 */ class $f268b97836dca6b6$var$NoopLayoutManager extends $f268b97836dca6b6$export$4a04ad01c410b415 {
    performLayout() {}
}
const $f268b97836dca6b6$var$groupDefaultValues = {
    strokeWidth: 0,
    subTargetCheck: false,
    interactive: false
};
/**
 * @fires object:added
 * @fires object:removed
 * @fires layout:before
 * @fires layout:after
 */ class $f268b97836dca6b6$export$eb2fcfdbd7ba97d4 extends $f268b97836dca6b6$export$f589b6d5b7ad4722($f268b97836dca6b6$export$5a5fba7eea6847b1) {
    static getDefaults() {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.getDefaults()), $f268b97836dca6b6$export$eb2fcfdbd7ba97d4.ownDefaults);
    }
    /**
   * Shared code between group and active selection
   * Meant to be used by the constructor.
   */ groupInit(objects, options) {
        var _options$layoutManage;
        this._objects = [
            ...objects
        ]; // Avoid unwanted mutations of Collection to affect the caller
        this.__objectSelectionTracker = this.__objectSelectionMonitor.bind(this, true);
        this.__objectSelectionDisposer = this.__objectSelectionMonitor.bind(this, false);
        this.forEachObject((object)=>{
            this.enterGroup(object, false);
        });
        // perform initial layout
        this.layoutManager = (_options$layoutManage = options.layoutManager) !== null && _options$layoutManage !== void 0 ? _options$layoutManage : new $f268b97836dca6b6$export$4a04ad01c410b415();
        this.layoutManager.performLayout({
            type: $f268b97836dca6b6$var$LAYOUT_TYPE_INITIALIZATION,
            target: this,
            targets: [
                ...objects
            ],
            // @TODO remove this concept from the layout manager.
            // Layout manager will calculate the correct position,
            // group options can override it later.
            x: options.left,
            y: options.top
        });
    }
    /**
   * Checks if object can enter group and logs relevant warnings
   * @private
   * @param {FabricObject} object
   * @returns
   */ canEnterGroup(object) {
        if (object === this || this.isDescendantOf(object)) {
            //  prevent circular object tree
            $f268b97836dca6b6$var$log('error', 'Group: circular object trees are not supported, this call has no effect');
            return false;
        } else if (this._objects.indexOf(object) !== -1) {
            // is already in the objects array
            $f268b97836dca6b6$var$log('error', 'Group: duplicate objects are not supported inside group, this call has no effect');
            return false;
        }
        return true;
    }
    /**
   * Override this method to enhance performance (for groups with a lot of objects).
   * If Overriding, be sure not pass illegal objects to group - it will break your app.
   * @private
   */ _filterObjectsBeforeEnteringGroup(objects) {
        return objects.filter((object, index, array)=>{
            // can enter AND is the first occurrence of the object in the passed args (to prevent adding duplicates)
            return this.canEnterGroup(object) && array.indexOf(object) === index;
        });
    }
    /**
   * Add objects
   * @param {...FabricObject[]} objects
   */ add() {
        for(var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++)objects[_key] = arguments[_key];
        const allowedObjects = this._filterObjectsBeforeEnteringGroup(objects);
        const size = super.add(...allowedObjects);
        this._onAfterObjectsChange($f268b97836dca6b6$var$LAYOUT_TYPE_ADDED, allowedObjects);
        return size;
    }
    /**
   * Inserts an object into collection at specified index
   * @param {FabricObject[]} objects Object to insert
   * @param {Number} index Index to insert object at
   */ insertAt(index) {
        for(var _len2 = arguments.length, objects = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)objects[_key2 - 1] = arguments[_key2];
        const allowedObjects = this._filterObjectsBeforeEnteringGroup(objects);
        const size = super.insertAt(index, ...allowedObjects);
        this._onAfterObjectsChange($f268b97836dca6b6$var$LAYOUT_TYPE_ADDED, allowedObjects);
        return size;
    }
    /**
   * Remove objects
   * @param {...FabricObject[]} objects
   * @returns {FabricObject[]} removed objects
   */ remove() {
        const removed = super.remove(...arguments);
        this._onAfterObjectsChange($f268b97836dca6b6$var$LAYOUT_TYPE_REMOVED, removed);
        return removed;
    }
    _onObjectAdded(object) {
        this.enterGroup(object, true);
        this.fire('object:added', {
            target: object
        });
        object.fire('added', {
            target: this
        });
    }
    /**
   * @private
   * @param {FabricObject} object
   * @param {boolean} [removeParentTransform] true if object should exit group without applying group's transform to it
   */ _onObjectRemoved(object, removeParentTransform) {
        this.exitGroup(object, removeParentTransform);
        this.fire('object:removed', {
            target: object
        });
        object.fire('removed', {
            target: this
        });
    }
    /**
   * @private
   * @param {'added'|'removed'} type
   * @param {FabricObject[]} targets
   */ _onAfterObjectsChange(type, targets) {
        this.layoutManager.performLayout({
            type: type,
            targets: targets,
            target: this
        });
    }
    _onStackOrderChanged() {
        this._set('dirty', true);
    }
    /**
   * @private
   * @param {string} key
   * @param {*} value
   */ _set(key, value) {
        const prev = this[key];
        super._set(key, value);
        if (key === 'canvas' && prev !== value) (this._objects || []).forEach((object)=>{
            object._set(key, value);
        });
        return this;
    }
    /**
   * @private
   */ _shouldSetNestedCoords() {
        return this.subTargetCheck;
    }
    /**
   * Remove all objects
   * @returns {FabricObject[]} removed objects
   */ removeAll() {
        this._activeObjects = [];
        return this.remove(...this._objects);
    }
    /**
   * keeps track of the selected objects
   * @private
   */ __objectSelectionMonitor(selected, _ref) {
        let { target: object } = _ref;
        const activeObjects = this._activeObjects;
        if (selected) {
            activeObjects.push(object);
            this._set('dirty', true);
        } else if (activeObjects.length > 0) {
            const index = activeObjects.indexOf(object);
            if (index > -1) {
                activeObjects.splice(index, 1);
                this._set('dirty', true);
            }
        }
    }
    /**
   * @private
   * @param {boolean} watch
   * @param {FabricObject} object
   */ _watchObject(watch, object) {
        //  make sure we listen only once
        watch && this._watchObject(false, object);
        if (watch) {
            object.on('selected', this.__objectSelectionTracker);
            object.on('deselected', this.__objectSelectionDisposer);
        } else {
            object.off('selected', this.__objectSelectionTracker);
            object.off('deselected', this.__objectSelectionDisposer);
        }
    }
    /**
   * @private
   * @param {FabricObject} object
   * @param {boolean} [removeParentTransform] true if object is in canvas coordinate plane
   */ enterGroup(object, removeParentTransform) {
        object.group && object.group.remove(object);
        object._set('parent', this);
        this._enterGroup(object, removeParentTransform);
    }
    /**
   * @private
   * @param {FabricObject} object
   * @param {boolean} [removeParentTransform] true if object is in canvas coordinate plane
   */ _enterGroup(object, removeParentTransform) {
        if (removeParentTransform) // can this be converted to utils (sendObjectToPlane)?
        $f268b97836dca6b6$var$applyTransformToObject(object, $f268b97836dca6b6$var$multiplyTransformMatrices($f268b97836dca6b6$var$invertTransform(this.calcTransformMatrix()), object.calcTransformMatrix()));
        this._shouldSetNestedCoords() && object.setCoords();
        object._set('group', this);
        object._set('canvas', this.canvas);
        this._watchObject(true, object);
        const activeObject = this.canvas && this.canvas.getActiveObject && this.canvas.getActiveObject();
        // if we are adding the activeObject in a group
        if (activeObject && (activeObject === object || object.isDescendantOf(activeObject))) this._activeObjects.push(object);
    }
    /**
   * @private
   * @param {FabricObject} object
   * @param {boolean} [removeParentTransform] true if object should exit group without applying group's transform to it
   */ exitGroup(object, removeParentTransform) {
        this._exitGroup(object, removeParentTransform);
        object._set('parent', undefined);
        object._set('canvas', undefined);
    }
    /**
   * Executes the inner fabric logic of exiting a group.
   * - Stop watching the object
   * - Remove the object from the optimization map this._activeObjects
   * - unset the group property of the object
   * @protected
   * @param {FabricObject} object
   * @param {boolean} [removeParentTransform] true if object should exit group without applying group's transform to it
   */ _exitGroup(object, removeParentTransform) {
        object._set('group', undefined);
        if (!removeParentTransform) {
            $f268b97836dca6b6$var$applyTransformToObject(object, $f268b97836dca6b6$var$multiplyTransformMatrices(this.calcTransformMatrix(), object.calcTransformMatrix()));
            object.setCoords();
        }
        this._watchObject(false, object);
        const index = this._activeObjects.length > 0 ? this._activeObjects.indexOf(object) : -1;
        if (index > -1) this._activeObjects.splice(index, 1);
    }
    /**
   * Decide if the group should cache or not. Create its own cache level
   * needsItsOwnCache should be used when the object drawing method requires
   * a cache step.
   * Generally you do not cache objects in groups because the group is already cached.
   * @return {Boolean}
   */ shouldCache() {
        const ownCache = $f268b97836dca6b6$export$5a5fba7eea6847b1.prototype.shouldCache.call(this);
        if (ownCache) {
            for(let i = 0; i < this._objects.length; i++)if (this._objects[i].willDrawShadow()) {
                this.ownCaching = false;
                return false;
            }
        }
        return ownCache;
    }
    /**
   * Check if this object or a child object will cast a shadow
   * @return {Boolean}
   */ willDrawShadow() {
        if (super.willDrawShadow()) return true;
        for(let i = 0; i < this._objects.length; i++){
            if (this._objects[i].willDrawShadow()) return true;
        }
        return false;
    }
    /**
   * Check if instance or its group are caching, recursively up
   * @return {Boolean}
   */ isOnACache() {
        return this.ownCaching || !!this.parent && this.parent.isOnACache();
    }
    /**
   * Execute the drawing operation for an object on a specified context
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ drawObject(ctx, forClipping, context) {
        this._renderBackground(ctx);
        for(let i = 0; i < this._objects.length; i++){
            var _this$canvas;
            const obj = this._objects[i];
            // TODO: handle rendering edge case somehow
            if ((_this$canvas = this.canvas) !== null && _this$canvas !== void 0 && _this$canvas.preserveObjectStacking && obj.group !== this) {
                ctx.save();
                ctx.transform(...$f268b97836dca6b6$var$invertTransform(this.calcTransformMatrix()));
                obj.render(ctx);
                ctx.restore();
            } else if (obj.group === this) obj.render(ctx);
        }
        this._drawClipPath(ctx, this.clipPath, context);
    }
    /**
   * @override
   * @return {Boolean}
   */ setCoords() {
        super.setCoords();
        this._shouldSetNestedCoords() && this.forEachObject((object)=>object.setCoords());
    }
    triggerLayout() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        this.layoutManager.performLayout($f268b97836dca6b6$var$_objectSpread2({
            target: this,
            type: $f268b97836dca6b6$var$LAYOUT_TYPE_IMPERATIVE
        }, options));
    }
    /**
   * Renders instance on a given context
   * @param {CanvasRenderingContext2D} ctx context to render instance on
   */ render(ctx) {
        this._transformDone = true;
        super.render(ctx);
        this._transformDone = false;
    }
    /**
   *
   * @private
   * @param {'toObject'|'toDatalessObject'} [method]
   * @param {string[]} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @returns {FabricObject[]} serialized objects
   */ __serializeObjects(method, propertiesToInclude) {
        const _includeDefaultValues = this.includeDefaultValues;
        return this._objects.filter(function(obj) {
            return !obj.excludeFromExport;
        }).map(function(obj) {
            const originalDefaults = obj.includeDefaultValues;
            obj.includeDefaultValues = _includeDefaultValues;
            const data = obj[method || 'toObject'](propertiesToInclude);
            obj.includeDefaultValues = originalDefaults;
            // delete data.version;
            return data;
        });
    }
    /**
   * Returns object representation of an instance
   * @param {string[]} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        const layoutManager = this.layoutManager.toObject();
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.toObject([
            'subTargetCheck',
            'interactive',
            ...propertiesToInclude
        ])), layoutManager.strategy !== 'fit-content' || this.includeDefaultValues ? {
            layoutManager: layoutManager
        } : {}), {}, {
            objects: this.__serializeObjects('toObject', propertiesToInclude)
        });
    }
    toString() {
        return "#<Group: (".concat(this.complexity(), ")>");
    }
    dispose() {
        this.layoutManager.unsubscribeTargets({
            targets: this.getObjects(),
            target: this
        });
        this._activeObjects = [];
        this.forEachObject((object)=>{
            this._watchObject(false, object);
            object.dispose();
        });
        super.dispose();
    }
    /**
   * @private
   */ _createSVGBgRect(reviver) {
        if (!this.backgroundColor) return '';
        const fillStroke = $f268b97836dca6b6$export$c79fc6492f3af13d.prototype._toSVG.call(this);
        const commons = fillStroke.indexOf('COMMON_PARTS');
        fillStroke[commons] = 'for="group" ';
        const markup = fillStroke.join('');
        return reviver ? reviver(markup) : markup;
    }
    /**
   * Returns svg representation of an instance
   * @param {TSVGReviver} [reviver] Method for further parsing of svg representation.
   * @return {String} svg representation of an instance
   */ _toSVG(reviver) {
        const svgString = [
            '<g ',
            'COMMON_PARTS',
            ' >\n'
        ];
        const bg = this._createSVGBgRect(reviver);
        bg && svgString.push('\t\t', bg);
        for(let i = 0; i < this._objects.length; i++)svgString.push('\t\t', this._objects[i].toSVG(reviver));
        svgString.push('</g>\n');
        return svgString;
    }
    /**
   * Returns styles-string for svg-export, specific version for group
   * @return {String}
   */ getSvgStyles() {
        const opacity = typeof this.opacity !== 'undefined' && this.opacity !== 1 ? "opacity: ".concat(this.opacity, ";") : '', visibility = this.visible ? '' : ' visibility: hidden;';
        return [
            opacity,
            this.getSvgFilter(),
            visibility
        ].join('');
    }
    /**
   * Returns svg clipPath representation of an instance
   * @param {Function} [reviver] Method for further parsing of svg representation.
   * @return {String} svg representation of an instance
   */ toClipPathSVG(reviver) {
        const svgString = [];
        const bg = this._createSVGBgRect(reviver);
        bg && svgString.push('\t', bg);
        for(let i = 0; i < this._objects.length; i++)svgString.push('\t', this._objects[i].toClipPathSVG(reviver));
        return this._createBaseClipPathSVGMarkup(svgString, {
            reviver: reviver
        });
    }
    /**
   * @todo support loading from svg
   * @private
   * @static
   * @memberOf Group
   * @param {Object} object Object to create a group from
   * @returns {Promise<Group>}
   */ static fromObject(_ref2, abortable) {
        let { type: type, objects: objects = [], layoutManager: layoutManager } = _ref2, options = $f268b97836dca6b6$var$_objectWithoutProperties(_ref2, $f268b97836dca6b6$var$_excluded$a);
        return Promise.all([
            $f268b97836dca6b6$var$enlivenObjects(objects, abortable),
            $f268b97836dca6b6$var$enlivenObjectEnlivables(options, abortable)
        ]).then((_ref3)=>{
            let [objects, hydratedOptions] = _ref3;
            const group = new this(objects, $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, options), hydratedOptions), {}, {
                layoutManager: new $f268b97836dca6b6$var$NoopLayoutManager()
            }));
            if (layoutManager) {
                const layoutClass = $f268b97836dca6b6$export$2792378e23a7920c.getClass(layoutManager.type);
                const strategyClass = $f268b97836dca6b6$export$2792378e23a7920c.getClass(layoutManager.strategy);
                group.layoutManager = new layoutClass(new strategyClass());
            } else group.layoutManager = new $f268b97836dca6b6$export$4a04ad01c410b415();
            group.layoutManager.subscribeTargets({
                type: $f268b97836dca6b6$var$LAYOUT_TYPE_INITIALIZATION,
                target: group,
                targets: group.getObjects()
            });
            group.setCoords();
            return group;
        });
    }
    /**
   * Constructor
   *
   * @param {FabricObject[]} [objects] instance objects
   * @param {Object} [options] Options object
   */ constructor(){
        let objects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        /**
     * Used to optimize performance
     * set to `false` if you don't need contained objects to be targets of events
     * @default
     * @type boolean
     */ /**
     * Used to allow targeting of object inside groups.
     * set to true if you want to select an object inside a group.\
     * **REQUIRES** `subTargetCheck` set to true
     * This will be not removed but slowly replaced with a method setInteractive
     * that will take care of enabling subTargetCheck and necessary object events.
     * There is too much attached to group interactivity to just be evaluated by a
     * boolean in the code
     * @default
     * @deprecated
     * @type boolean
     */ /**
     * Used internally to optimize performance
     * Once an object is selected, instance is rendered without the selected object.
     * This way instance is cached only once for the entire interaction with the selected object.
     * @private
     */ $f268b97836dca6b6$var$_defineProperty(this, "_activeObjects", []);
        $f268b97836dca6b6$var$_defineProperty(this, "__objectSelectionTracker", void 0);
        $f268b97836dca6b6$var$_defineProperty(this, "__objectSelectionDisposer", void 0);
        Object.assign(this, $f268b97836dca6b6$export$eb2fcfdbd7ba97d4.ownDefaults);
        this.setOptions(options);
        this.groupInit(objects, options);
    }
}
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$eb2fcfdbd7ba97d4, "type", 'Group');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$eb2fcfdbd7ba97d4, "ownDefaults", $f268b97836dca6b6$var$groupDefaultValues);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$eb2fcfdbd7ba97d4);
/**
 * TODO experiment with different layout manager and svg results ( fixed fit content )
 * Groups SVG elements (usually those retrieved from SVG document)
 * @static
 * @param {FabricObject[]} elements FabricObject(s) parsed from svg, to group
 * @return {FabricObject | Group}
 */ const $f268b97836dca6b6$var$groupSVGElements = (elements, options)=>{
    if (elements && elements.length === 1) return elements[0];
    return new $f268b97836dca6b6$export$eb2fcfdbd7ba97d4(elements, options);
};
/**
 * Finds the scale for the object source to fit inside the object destination,
 * keeping aspect ratio intact.
 * respect the total allowed area for the cache.
 * @param {TSize} source natural unscaled size of the object
 * @param {TSize} destination natural unscaled size of the object
 * @return {Number} scale factor to apply to source to fit into destination
 */ const $f268b97836dca6b6$var$findScaleToFit = (source, destination)=>Math.min(destination.width / source.width, destination.height / source.height);
/**
 * Finds the scale for the object source to cover entirely the object destination,
 * keeping aspect ratio intact.
 * respect the total allowed area for the cache.
 * @param {TSize} source natural unscaled size of the object
 * @param {TSize} destination natural unscaled size of the object
 * @return {Number} scale factor to apply to source to cover destination
 */ const $f268b97836dca6b6$var$findScaleToCover = (source, destination)=>Math.max(destination.width / source.width, destination.height / source.height);
const $f268b97836dca6b6$var$commaWsp = "\\s*,?\\s*";
/**
 * p for param
 * using "bad naming" here because it makes the regex much easier to read
 * p is a number that is preceded by an arbitary number of spaces, maybe 0,
 * a comma or not, and then possibly more spaces or not.
 */ const $f268b97836dca6b6$var$p = "".concat($f268b97836dca6b6$var$commaWsp, "(").concat($f268b97836dca6b6$var$reNum, ")");
// const reMoveToCommand = `(M) ?(?:${p}${p} ?)+`;
// const reLineCommand = `(L) ?(?:${p}${p} ?)+`;
// const reHorizontalLineCommand = `(H) ?(?:${p} ?)+`;
// const reVerticalLineCommand = `(V) ?(?:${p} ?)+`;
// const reClosePathCommand = String.raw`(Z)\s*`;
// const reCubicCurveCommand = `(C) ?(?:${p}${p}${p}${p}${p}${p} ?)+`;
// const reCubicCurveShortcutCommand = `(S) ?(?:${p}${p}${p}${p} ?)+`;
// const reQuadraticCurveCommand = `(Q) ?(?:${p}${p}${p}${p} ?)+`;
// const reQuadraticCurveShortcutCommand = `(T) ?(?:${p}${p} ?)+`;
const $f268b97836dca6b6$var$reArcCommandPoints = "".concat($f268b97836dca6b6$var$p).concat($f268b97836dca6b6$var$p).concat($f268b97836dca6b6$var$p).concat($f268b97836dca6b6$var$commaWsp, "([01])").concat($f268b97836dca6b6$var$commaWsp, "([01])").concat($f268b97836dca6b6$var$p).concat($f268b97836dca6b6$var$p);
// const reArcCommand = `(A) ?(?:${reArcCommandPoints} ?)+`;
// export const rePathCommandGroups =
//   `(?:(?:${reMoveToCommand})` +
//   `|(?:${reLineCommand})` +
//   `|(?:${reHorizontalLineCommand})` +
//   `|(?:${reVerticalLineCommand})` +
//   `|(?:${reClosePathCommand})` +
//   `|(?:${reCubicCurveCommand})` +
//   `|(?:${reCubicCurveShortcutCommand})` +
//   `|(?:${reQuadraticCurveCommand})` +
//   `|(?:${reQuadraticCurveShortcutCommand})` +
//   `|(?:${reArcCommand}))`;
const $f268b97836dca6b6$var$rePathCommand = '[mzlhvcsqta][^mzlhvcsqta]*';
/**
 * Commands that may be repeated
 */ const $f268b97836dca6b6$var$repeatedCommands = {
    m: 'l',
    M: 'L'
};
/**
 * Convert an arc of a rotated ellipse to a Bezier Curve
 * @param {TRadian} theta1 start of the arc
 * @param {TRadian} theta2 end of the arc
 * @param cosTh cosine of the angle of rotation
 * @param sinTh sine of the angle of rotation
 * @param rx x-axis radius (before rotation)
 * @param ry y-axis radius (before rotation)
 * @param cx1 center x of the ellipse
 * @param cy1 center y of the ellipse
 * @param mT
 * @param fromX starting point of arc x
 * @param fromY starting point of arc y
 */ const $f268b97836dca6b6$var$segmentToBezier = (theta1, theta2, cosTh, sinTh, rx, ry, cx1, cy1, mT, fromX, fromY)=>{
    const costh1 = $f268b97836dca6b6$var$cos(theta1), sinth1 = $f268b97836dca6b6$var$sin(theta1), costh2 = $f268b97836dca6b6$var$cos(theta2), sinth2 = $f268b97836dca6b6$var$sin(theta2), toX = cosTh * rx * costh2 - sinTh * ry * sinth2 + cx1, toY = sinTh * rx * costh2 + cosTh * ry * sinth2 + cy1, cp1X = fromX + mT * (-cosTh * rx * sinth1 - sinTh * ry * costh1), cp1Y = fromY + mT * (-sinTh * rx * sinth1 + cosTh * ry * costh1), cp2X = toX + mT * (cosTh * rx * sinth2 + sinTh * ry * costh2), cp2Y = toY + mT * (sinTh * rx * sinth2 - cosTh * ry * costh2);
    return [
        'C',
        cp1X,
        cp1Y,
        cp2X,
        cp2Y,
        toX,
        toY
    ];
};
/**
 * Adapted from {@link http://dxr.mozilla.org/mozilla-central/source/dom/svg/SVGPathDataParser.cpp}
 * by Andrea Bogazzi code is under MPL. if you don't have a copy of the license you can take it here
 * http://mozilla.org/MPL/2.0/
 * @param toX
 * @param toY
 * @param rx
 * @param ry
 * @param {number} large 0 or 1 flag
 * @param {number} sweep 0 or 1 flag
 * @param rotateX
 */ const $f268b97836dca6b6$var$arcToSegments = (toX, toY, rx, ry, large, sweep, rotateX)=>{
    if (rx === 0 || ry === 0) return [];
    let fromX = 0, fromY = 0, root = 0;
    const PI = Math.PI, theta = rotateX * $f268b97836dca6b6$var$PiBy180, sinTheta = $f268b97836dca6b6$var$sin(theta), cosTh = $f268b97836dca6b6$var$cos(theta), px = 0.5 * (-cosTh * toX - sinTheta * toY), py = 0.5 * (-cosTh * toY + sinTheta * toX), rx2 = rx ** 2, ry2 = ry ** 2, py2 = py ** 2, px2 = px ** 2, pl = rx2 * ry2 - rx2 * py2 - ry2 * px2;
    let _rx = Math.abs(rx);
    let _ry = Math.abs(ry);
    if (pl < 0) {
        const s = Math.sqrt(1 - pl / (rx2 * ry2));
        _rx *= s;
        _ry *= s;
    } else root = (large === sweep ? -1 : 1.0) * Math.sqrt(pl / (rx2 * py2 + ry2 * px2));
    const cx = root * _rx * py / _ry, cy = -root * _ry * px / _rx, cx1 = cosTh * cx - sinTheta * cy + toX * 0.5, cy1 = sinTheta * cx + cosTh * cy + toY * 0.5;
    let mTheta = $f268b97836dca6b6$var$calcVectorAngle(1, 0, (px - cx) / _rx, (py - cy) / _ry);
    let dtheta = $f268b97836dca6b6$var$calcVectorAngle((px - cx) / _rx, (py - cy) / _ry, (-px - cx) / _rx, (-py - cy) / _ry);
    if (sweep === 0 && dtheta > 0) dtheta -= 2 * PI;
    else if (sweep === 1 && dtheta < 0) dtheta += 2 * PI;
    // Convert into cubic bezier segments <= 90deg
    const segments = Math.ceil(Math.abs(dtheta / PI * 2)), result = [], mDelta = dtheta / segments, mT = 8 / 3 * Math.sin(mDelta / 4) * Math.sin(mDelta / 4) / Math.sin(mDelta / 2);
    let th3 = mTheta + mDelta;
    for(let i = 0; i < segments; i++){
        result[i] = $f268b97836dca6b6$var$segmentToBezier(mTheta, th3, cosTh, sinTheta, _rx, _ry, cx1, cy1, mT, fromX, fromY);
        fromX = result[i][5];
        fromY = result[i][6];
        mTheta = th3;
        th3 += mDelta;
    }
    return result;
};
/**
 * @private
 * Calculate the angle between two vectors
 * @param ux u endpoint x
 * @param uy u endpoint y
 * @param vx v endpoint x
 * @param vy v endpoint y
 */ const $f268b97836dca6b6$var$calcVectorAngle = (ux, uy, vx, vy)=>{
    const ta = Math.atan2(uy, ux), tb = Math.atan2(vy, vx);
    if (tb >= ta) return tb - ta;
    else return 2 * Math.PI - (ta - tb);
};
// functions for the Cubic beizer
// taken from: https://github.com/konvajs/konva/blob/7.0.5/src/shapes/Path.ts#L350
const $f268b97836dca6b6$var$CB1 = (t)=>t ** 3;
const $f268b97836dca6b6$var$CB2 = (t)=>3 * t ** 2 * (1 - t);
const $f268b97836dca6b6$var$CB3 = (t)=>3 * t * (1 - t) ** 2;
const $f268b97836dca6b6$var$CB4 = (t)=>(1 - t) ** 3;
/**
 * Calculate bounding box of a cubic Bezier curve
 * Taken from http://jsbin.com/ivomiq/56/edit (no credits available)
 * TODO: can we normalize this with the starting points set at 0 and then translated the bbox?
 * @param {number} begx starting point
 * @param {number} begy
 * @param {number} cp1x first control point
 * @param {number} cp1y
 * @param {number} cp2x second control point
 * @param {number} cp2y
 * @param {number} endx end of bezier
 * @param {number} endy
 * @return {TRectBounds} the rectangular bounds
 */ function $f268b97836dca6b6$var$getBoundsOfCurve(begx, begy, cp1x, cp1y, cp2x, cp2y, endx, endy) {
    let argsString;
    if ($f268b97836dca6b6$export$e506a1d27d1eaa20.cachesBoundsOfCurve) {
        // eslint-disable-next-line
        argsString = [
            ...arguments
        ].join();
        if ($f268b97836dca6b6$export$69a3209f1a06c04d.boundsOfCurveCache[argsString]) return $f268b97836dca6b6$export$69a3209f1a06c04d.boundsOfCurveCache[argsString];
    }
    const sqrt = Math.sqrt, abs = Math.abs, tvalues = [], bounds = [
        [
            0,
            0
        ],
        [
            0,
            0
        ]
    ];
    let b = 6 * begx - 12 * cp1x + 6 * cp2x;
    let a = -3 * begx + 9 * cp1x - 9 * cp2x + 3 * endx;
    let c = 3 * cp1x - 3 * begx;
    for(let i = 0; i < 2; ++i){
        if (i > 0) {
            b = 6 * begy - 12 * cp1y + 6 * cp2y;
            a = -3 * begy + 9 * cp1y - 9 * cp2y + 3 * endy;
            c = 3 * cp1y - 3 * begy;
        }
        if (abs(a) < 1e-12) {
            if (abs(b) < 1e-12) continue;
            const t = -c / b;
            if (0 < t && t < 1) tvalues.push(t);
            continue;
        }
        const b2ac = b * b - 4 * c * a;
        if (b2ac < 0) continue;
        const sqrtb2ac = sqrt(b2ac);
        const t1 = (-b + sqrtb2ac) / (2 * a);
        if (0 < t1 && t1 < 1) tvalues.push(t1);
        const t2 = (-b - sqrtb2ac) / (2 * a);
        if (0 < t2 && t2 < 1) tvalues.push(t2);
    }
    let j = tvalues.length;
    const jlen = j;
    const iterator = $f268b97836dca6b6$var$getPointOnCubicBezierIterator(begx, begy, cp1x, cp1y, cp2x, cp2y, endx, endy);
    while(j--){
        const { x: x, y: y } = iterator(tvalues[j]);
        bounds[0][j] = x;
        bounds[1][j] = y;
    }
    bounds[0][jlen] = begx;
    bounds[1][jlen] = begy;
    bounds[0][jlen + 1] = endx;
    bounds[1][jlen + 1] = endy;
    const result = [
        new $f268b97836dca6b6$export$baf26146a414f24a(Math.min(...bounds[0]), Math.min(...bounds[1])),
        new $f268b97836dca6b6$export$baf26146a414f24a(Math.max(...bounds[0]), Math.max(...bounds[1]))
    ];
    if ($f268b97836dca6b6$export$e506a1d27d1eaa20.cachesBoundsOfCurve) $f268b97836dca6b6$export$69a3209f1a06c04d.boundsOfCurveCache[argsString] = result;
    return result;
}
/**
 * Converts arc to a bunch of cubic Bezier curves
 * @param {number} fx starting point x
 * @param {number} fy starting point y
 * @param {TParsedArcCommand} coords Arc command
 */ const $f268b97836dca6b6$var$fromArcToBeziers = (fx, fy, _ref)=>{
    let [_, rx, ry, rot, large, sweep, tx, ty] = _ref;
    const segsNorm = $f268b97836dca6b6$var$arcToSegments(tx - fx, ty - fy, rx, ry, large, sweep, rot);
    for(let i = 0, len = segsNorm.length; i < len; i++){
        segsNorm[i][1] += fx;
        segsNorm[i][2] += fy;
        segsNorm[i][3] += fx;
        segsNorm[i][4] += fy;
        segsNorm[i][5] += fx;
        segsNorm[i][6] += fy;
    }
    return segsNorm;
};
/**
 * This function takes a parsed SVG path and makes it simpler for fabricJS logic.
 * Simplification consist of:
 * - All commands converted to absolute (lowercase to uppercase)
 * - S converted to C
 * - T converted to Q
 * - A converted to C
 * @param {TComplexPathData} path the array of commands of a parsed SVG path for `Path`
 * @return {TSimplePathData} the simplified array of commands of a parsed SVG path for `Path`
 * TODO: figure out how to remove the type assertions in a nice way
 */ const $f268b97836dca6b6$var$makePathSimpler = (path)=>{
    // x and y represent the last point of the path, AKA the previous command point.
    // we add them to each relative command to make it an absolute comment.
    // we also swap the v V h H with L, because are easier to transform.
    let x = 0, y = 0;
    // x1 and y1 represent the last point of the subpath. the subpath is started with
    // m or M command. When a z or Z command is drawn, x and y need to be resetted to
    // the last x1 and y1.
    let x1 = 0, y1 = 0;
    // previous will host the letter of the previous command, to handle S and T.
    // controlX and controlY will host the previous reflected control point
    const destinationPath = [];
    let previous, // placeholders
    controlX = 0, controlY = 0;
    for (const parsedCommand of path){
        const current = [
            ...parsedCommand
        ];
        let converted;
        switch(current[0] // first letter
        ){
            case 'l':
                // lineto, relative
                current[1] += x;
                current[2] += y;
            // falls through
            case 'L':
                x = current[1];
                y = current[2];
                converted = [
                    'L',
                    x,
                    y
                ];
                break;
            case 'h':
                // horizontal lineto, relative
                current[1] += x;
            // falls through
            case 'H':
                x = current[1];
                converted = [
                    'L',
                    x,
                    y
                ];
                break;
            case 'v':
                // vertical lineto, relative
                current[1] += y;
            // falls through
            case 'V':
                y = current[1];
                converted = [
                    'L',
                    x,
                    y
                ];
                break;
            case 'm':
                // moveTo, relative
                current[1] += x;
                current[2] += y;
            // falls through
            case 'M':
                x = current[1];
                y = current[2];
                x1 = current[1];
                y1 = current[2];
                converted = [
                    'M',
                    x,
                    y
                ];
                break;
            case 'c':
                // bezierCurveTo, relative
                current[1] += x;
                current[2] += y;
                current[3] += x;
                current[4] += y;
                current[5] += x;
                current[6] += y;
            // falls through
            case 'C':
                controlX = current[3];
                controlY = current[4];
                x = current[5];
                y = current[6];
                converted = [
                    'C',
                    current[1],
                    current[2],
                    controlX,
                    controlY,
                    x,
                    y
                ];
                break;
            case 's':
                // shorthand cubic bezierCurveTo, relative
                current[1] += x;
                current[2] += y;
                current[3] += x;
                current[4] += y;
            // falls through
            case 'S':
                // would be sScC but since we are swapping sSc for C, we check just that.
                if (previous === 'C') {
                    // calculate reflection of previous control points
                    controlX = 2 * x - controlX;
                    controlY = 2 * y - controlY;
                } else {
                    // If there is no previous command or if the previous command was not a C, c, S, or s,
                    // the control point is coincident with the current point
                    controlX = x;
                    controlY = y;
                }
                x = current[3];
                y = current[4];
                converted = [
                    'C',
                    controlX,
                    controlY,
                    current[1],
                    current[2],
                    x,
                    y
                ];
                // converted[3] and converted[4] are NOW the second control point.
                // we keep it for the next reflection.
                controlX = converted[3];
                controlY = converted[4];
                break;
            case 'q':
                // quadraticCurveTo, relative
                current[1] += x;
                current[2] += y;
                current[3] += x;
                current[4] += y;
            // falls through
            case 'Q':
                controlX = current[1];
                controlY = current[2];
                x = current[3];
                y = current[4];
                converted = [
                    'Q',
                    controlX,
                    controlY,
                    x,
                    y
                ];
                break;
            case 't':
                // shorthand quadraticCurveTo, relative
                current[1] += x;
                current[2] += y;
            // falls through
            case 'T':
                if (previous === 'Q') {
                    // calculate reflection of previous control point
                    controlX = 2 * x - controlX;
                    controlY = 2 * y - controlY;
                } else {
                    // If there is no previous command or if the previous command was not a Q, q, T or t,
                    // assume the control point is coincident with the current point
                    controlX = x;
                    controlY = y;
                }
                x = current[1];
                y = current[2];
                converted = [
                    'Q',
                    controlX,
                    controlY,
                    x,
                    y
                ];
                break;
            case 'a':
                current[6] += x;
                current[7] += y;
            // falls through
            case 'A':
                $f268b97836dca6b6$var$fromArcToBeziers(x, y, current).forEach((b)=>destinationPath.push(b));
                x = current[6];
                y = current[7];
                break;
            case 'z':
            case 'Z':
                x = x1;
                y = y1;
                converted = [
                    'Z'
                ];
                break;
        }
        if (converted) {
            destinationPath.push(converted);
            previous = converted[0];
        } else previous = '';
    }
    return destinationPath;
};
// todo verify if we can just use the point class here
/**
 * Calc length from point x1,y1 to x2,y2
 * @param {number} x1 starting point x
 * @param {number} y1 starting point y
 * @param {number} x2 starting point x
 * @param {number} y2 starting point y
 * @return {number} length of segment
 */ const $f268b97836dca6b6$var$calcLineLength = (x1, y1, x2, y2)=>Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
/**
 * Get an iterator that takes a percentage and returns a point
 * @param {number} begx
 * @param {number} begy
 * @param {number} cp1x
 * @param {number} cp1y
 * @param {number} cp2x
 * @param {number} cp2y
 * @param {number} endx
 * @param {number} endy
 */ const $f268b97836dca6b6$var$getPointOnCubicBezierIterator = (begx, begy, cp1x, cp1y, cp2x, cp2y, endx, endy)=>(pct)=>{
        const c1 = $f268b97836dca6b6$var$CB1(pct), c2 = $f268b97836dca6b6$var$CB2(pct), c3 = $f268b97836dca6b6$var$CB3(pct), c4 = $f268b97836dca6b6$var$CB4(pct);
        return new $f268b97836dca6b6$export$baf26146a414f24a(endx * c1 + cp2x * c2 + cp1x * c3 + begx * c4, endy * c1 + cp2y * c2 + cp1y * c3 + begy * c4);
    };
const $f268b97836dca6b6$var$QB1 = (t)=>t ** 2;
const $f268b97836dca6b6$var$QB2 = (t)=>2 * t * (1 - t);
const $f268b97836dca6b6$var$QB3 = (t)=>(1 - t) ** 2;
const $f268b97836dca6b6$var$getTangentCubicIterator = (p1x, p1y, p2x, p2y, p3x, p3y, p4x, p4y)=>(pct)=>{
        const qb1 = $f268b97836dca6b6$var$QB1(pct), qb2 = $f268b97836dca6b6$var$QB2(pct), qb3 = $f268b97836dca6b6$var$QB3(pct), tangentX = 3 * (qb3 * (p2x - p1x) + qb2 * (p3x - p2x) + qb1 * (p4x - p3x)), tangentY = 3 * (qb3 * (p2y - p1y) + qb2 * (p3y - p2y) + qb1 * (p4y - p3y));
        return Math.atan2(tangentY, tangentX);
    };
const $f268b97836dca6b6$var$getPointOnQuadraticBezierIterator = (p1x, p1y, p2x, p2y, p3x, p3y)=>(pct)=>{
        const c1 = $f268b97836dca6b6$var$QB1(pct), c2 = $f268b97836dca6b6$var$QB2(pct), c3 = $f268b97836dca6b6$var$QB3(pct);
        return new $f268b97836dca6b6$export$baf26146a414f24a(p3x * c1 + p2x * c2 + p1x * c3, p3y * c1 + p2y * c2 + p1y * c3);
    };
const $f268b97836dca6b6$var$getTangentQuadraticIterator = (p1x, p1y, p2x, p2y, p3x, p3y)=>(pct)=>{
        const invT = 1 - pct, tangentX = 2 * (invT * (p2x - p1x) + pct * (p3x - p2x)), tangentY = 2 * (invT * (p2y - p1y) + pct * (p3y - p2y));
        return Math.atan2(tangentY, tangentX);
    };
// this will run over a path segment (a cubic or quadratic segment) and approximate it
// with 100 segments. This will good enough to calculate the length of the curve
const $f268b97836dca6b6$var$pathIterator = (iterator, x1, y1)=>{
    let tempP = new $f268b97836dca6b6$export$baf26146a414f24a(x1, y1), tmpLen = 0;
    for(let perc = 1; perc <= 100; perc += 1){
        const p = iterator(perc / 100);
        tmpLen += $f268b97836dca6b6$var$calcLineLength(tempP.x, tempP.y, p.x, p.y);
        tempP = p;
    }
    return tmpLen;
};
/**
 * Given a pathInfo, and a distance in pixels, find the percentage from 0 to 1
 * that correspond to that pixels run over the path.
 * The percentage will be then used to find the correct point on the canvas for the path.
 * @param {Array} segInfo fabricJS collection of information on a parsed path
 * @param {number} distance from starting point, in pixels.
 * @return {TPointAngle} info object with x and y ( the point on canvas ) and angle, the tangent on that point;
 */ const $f268b97836dca6b6$var$findPercentageForDistance = (segInfo, distance)=>{
    let perc = 0, tmpLen = 0, tempP = {
        x: segInfo.x,
        y: segInfo.y
    }, p = $f268b97836dca6b6$var$_objectSpread2({}, tempP), nextLen, nextStep = 0.01, lastPerc = 0;
    // nextStep > 0.0001 covers 0.00015625 that 1/64th of 1/100
    // the path
    const iterator = segInfo.iterator, angleFinder = segInfo.angleFinder;
    while(tmpLen < distance && nextStep > 0.0001){
        p = iterator(perc);
        lastPerc = perc;
        nextLen = $f268b97836dca6b6$var$calcLineLength(tempP.x, tempP.y, p.x, p.y);
        // compare tmpLen each cycle with distance, decide next perc to test.
        if (nextLen + tmpLen > distance) {
            // we discard this step and we make smaller steps.
            perc -= nextStep;
            nextStep /= 2;
        } else {
            tempP = p;
            perc += nextStep;
            tmpLen += nextLen;
        }
    }
    return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, p), {}, {
        angle: angleFinder(lastPerc)
    });
};
/**
 * Run over a parsed and simplified path and extract some information (length of each command and starting point)
 * @param {TSimplePathData} path parsed path commands
 * @return {TPathSegmentInfo[]} path commands information
 */ const $f268b97836dca6b6$var$getPathSegmentsInfo = (path)=>{
    let totalLength = 0, //x2 and y2 are the coords of segment start
    //x1 and y1 are the coords of the current point
    x1 = 0, y1 = 0, x2 = 0, y2 = 0, iterator, tempInfo;
    const info = [];
    for (const current of path){
        const basicInfo = {
            x: x1,
            y: y1,
            command: current[0],
            length: 0
        };
        switch(current[0] //first letter
        ){
            case 'M':
                tempInfo = basicInfo;
                tempInfo.x = x2 = x1 = current[1];
                tempInfo.y = y2 = y1 = current[2];
                break;
            case 'L':
                tempInfo = basicInfo;
                tempInfo.length = $f268b97836dca6b6$var$calcLineLength(x1, y1, current[1], current[2]);
                x1 = current[1];
                y1 = current[2];
                break;
            case 'C':
                iterator = $f268b97836dca6b6$var$getPointOnCubicBezierIterator(x1, y1, current[1], current[2], current[3], current[4], current[5], current[6]);
                tempInfo = basicInfo;
                tempInfo.iterator = iterator;
                tempInfo.angleFinder = $f268b97836dca6b6$var$getTangentCubicIterator(x1, y1, current[1], current[2], current[3], current[4], current[5], current[6]);
                tempInfo.length = $f268b97836dca6b6$var$pathIterator(iterator, x1, y1);
                x1 = current[5];
                y1 = current[6];
                break;
            case 'Q':
                iterator = $f268b97836dca6b6$var$getPointOnQuadraticBezierIterator(x1, y1, current[1], current[2], current[3], current[4]);
                tempInfo = basicInfo;
                tempInfo.iterator = iterator;
                tempInfo.angleFinder = $f268b97836dca6b6$var$getTangentQuadraticIterator(x1, y1, current[1], current[2], current[3], current[4]);
                tempInfo.length = $f268b97836dca6b6$var$pathIterator(iterator, x1, y1);
                x1 = current[3];
                y1 = current[4];
                break;
            case 'Z':
                // we add those in order to ease calculations later
                tempInfo = basicInfo;
                tempInfo.destX = x2;
                tempInfo.destY = y2;
                tempInfo.length = $f268b97836dca6b6$var$calcLineLength(x1, y1, x2, y2);
                x1 = x2;
                y1 = y2;
                break;
        }
        totalLength += tempInfo.length;
        info.push(tempInfo);
    }
    info.push({
        length: totalLength,
        x: x1,
        y: y1
    });
    return info;
};
/**
 * Get the point on the path that is distance along the path
 * @param path
 * @param distance
 * @param infos
 */ const $f268b97836dca6b6$var$getPointOnPath = function(path, distance) {
    let infos = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $f268b97836dca6b6$var$getPathSegmentsInfo(path);
    let i = 0;
    while(distance - infos[i].length > 0 && i < infos.length - 2){
        distance -= infos[i].length;
        i++;
    }
    const segInfo = infos[i], segPercent = distance / segInfo.length, segment = path[i];
    switch(segInfo.command){
        case 'M':
            return {
                x: segInfo.x,
                y: segInfo.y,
                angle: 0
            };
        case 'Z':
            return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, new $f268b97836dca6b6$export$baf26146a414f24a(segInfo.x, segInfo.y).lerp(new $f268b97836dca6b6$export$baf26146a414f24a(segInfo.destX, segInfo.destY), segPercent)), {}, {
                angle: Math.atan2(segInfo.destY - segInfo.y, segInfo.destX - segInfo.x)
            });
        case 'L':
            return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, new $f268b97836dca6b6$export$baf26146a414f24a(segInfo.x, segInfo.y).lerp(new $f268b97836dca6b6$export$baf26146a414f24a(segment[1], segment[2]), segPercent)), {}, {
                angle: Math.atan2(segment[2] - segInfo.y, segment[1] - segInfo.x)
            });
        case 'C':
            return $f268b97836dca6b6$var$findPercentageForDistance(segInfo, distance);
        case 'Q':
            return $f268b97836dca6b6$var$findPercentageForDistance(segInfo, distance);
    }
};
const $f268b97836dca6b6$var$rePathCmdAll = new RegExp($f268b97836dca6b6$var$rePathCommand, 'gi');
const $f268b97836dca6b6$var$regExpArcCommandPoints = new RegExp($f268b97836dca6b6$var$reArcCommandPoints, 'g');
const $f268b97836dca6b6$var$reMyNum = new RegExp($f268b97836dca6b6$var$reNum, 'gi');
const $f268b97836dca6b6$var$commandLengths = {
    m: 2,
    l: 2,
    h: 1,
    v: 1,
    c: 6,
    s: 4,
    q: 4,
    t: 2,
    a: 7
};
/**
 *
 * @param {string} pathString
 * @return {TComplexPathData} An array of SVG path commands
 * @example <caption>Usage</caption>
 * parsePath('M 3 4 Q 3 5 2 1 4 0 Q 9 12 2 1 4 0') === [
 *   ['M', 3, 4],
 *   ['Q', 3, 5, 2, 1, 4, 0],
 *   ['Q', 9, 12, 2, 1, 4, 0],
 * ];
 */ const $f268b97836dca6b6$var$parsePath = (pathString)=>{
    var _pathString$match;
    const chain = [];
    const all = (_pathString$match = pathString.match($f268b97836dca6b6$var$rePathCmdAll)) !== null && _pathString$match !== void 0 ? _pathString$match : [];
    for (const matchStr of all){
        // take match string and save the first letter as the command
        const commandLetter = matchStr[0];
        // in case of Z we have very little to do
        if (commandLetter === 'z' || commandLetter === 'Z') {
            chain.push([
                commandLetter
            ]);
            continue;
        }
        const commandLength = $f268b97836dca6b6$var$commandLengths[commandLetter.toLowerCase()];
        let paramArr = [];
        if (commandLetter === 'a' || commandLetter === 'A') {
            // the arc command ha some peculariaties that requires a special regex other than numbers
            // it is possible to avoid using a space between the sweep and large arc flags, making them either
            // 00, 01, 10 or 11, making them identical to a plain number for the regex reMyNum
            // reset the regexp
            $f268b97836dca6b6$var$regExpArcCommandPoints.lastIndex = 0;
            for(let out = null; out = $f268b97836dca6b6$var$regExpArcCommandPoints.exec(matchStr);)paramArr.push(...out.slice(1));
        } else paramArr = matchStr.match($f268b97836dca6b6$var$reMyNum) || [];
        // inspect the length of paramArr, if is longer than commandLength
        // we are dealing with repeated commands
        for(let i = 0; i < paramArr.length; i += commandLength){
            const newCommand = new Array(commandLength);
            const transformedCommand = $f268b97836dca6b6$var$repeatedCommands[commandLetter];
            newCommand[0] = i > 0 && transformedCommand ? transformedCommand : commandLetter;
            for(let j = 0; j < commandLength; j++)newCommand[j + 1] = parseFloat(paramArr[i + j]);
            chain.push(newCommand);
        }
    }
    return chain;
};
/**
 *
 * Converts points to a smooth SVG path
 * @param {XY[]} points Array of points
 * @param {number} [correction] Apply a correction to the path (usually we use `width / 1000`). If value is undefined 0 is used as the correction value.
 * @return {(string|number)[][]} An array of SVG path commands
 */ const $f268b97836dca6b6$var$getSmoothPathFromPoints = function(points) {
    let correction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let p1 = new $f268b97836dca6b6$export$baf26146a414f24a(points[0]), p2 = new $f268b97836dca6b6$export$baf26146a414f24a(points[1]), multSignX = 1, multSignY = 0;
    const path = [], len = points.length, manyPoints = len > 2;
    if (manyPoints) {
        multSignX = points[2].x < p2.x ? -1 : points[2].x === p2.x ? 0 : 1;
        multSignY = points[2].y < p2.y ? -1 : points[2].y === p2.y ? 0 : 1;
    }
    path.push([
        'M',
        p1.x - multSignX * correction,
        p1.y - multSignY * correction
    ]);
    let i;
    for(i = 1; i < len; i++){
        if (!p1.eq(p2)) {
            const midPoint = p1.midPointFrom(p2);
            // p1 is our bezier control point
            // midpoint is our endpoint
            // start point is p(i-1) value.
            path.push([
                'Q',
                p1.x,
                p1.y,
                midPoint.x,
                midPoint.y
            ]);
        }
        p1 = points[i];
        if (i + 1 < points.length) p2 = points[i + 1];
    }
    if (manyPoints) {
        multSignX = p1.x > points[i - 2].x ? 1 : p1.x === points[i - 2].x ? 0 : -1;
        multSignY = p1.y > points[i - 2].y ? 1 : p1.y === points[i - 2].y ? 0 : -1;
    }
    path.push([
        'L',
        p1.x + multSignX * correction,
        p1.y + multSignY * correction
    ]);
    return path;
};
/**
 * Transform a path by transforming each segment.
 * it has to be a simplified path or it won't work.
 * WARNING: this depends from pathOffset for correct operation
 * @param {TSimplePathData} path fabricJS parsed and simplified path commands
 * @param {TMat2D} transform matrix that represent the transformation
 * @param {Point} [pathOffset] `Path.pathOffset`
 * @returns {TSimplePathData} the transformed path
 */ const $f268b97836dca6b6$var$transformPath = (path, transform, pathOffset)=>{
    if (pathOffset) transform = $f268b97836dca6b6$var$multiplyTransformMatrices(transform, [
        1,
        0,
        0,
        1,
        -pathOffset.x,
        -pathOffset.y
    ]);
    return path.map((pathSegment)=>{
        const newSegment = [
            ...pathSegment
        ];
        for(let i = 1; i < pathSegment.length - 1; i += 2){
            // TODO: is there a way to get around casting to any?
            const { x: x, y: y } = $f268b97836dca6b6$var$transformPoint({
                x: pathSegment[i],
                y: pathSegment[i + 1]
            }, transform);
            newSegment[i] = x;
            newSegment[i + 1] = y;
        }
        return newSegment;
    });
};
/**
 * Returns an array of path commands to create a regular polygon
 * @param {number} numVertexes
 * @param {number} radius
 * @returns {TSimplePathData} An array of SVG path commands
 */ const $f268b97836dca6b6$var$getRegularPolygonPath = (numVertexes, radius)=>{
    const interiorAngle = Math.PI * 2 / numVertexes;
    // rotationAdjustment rotates the path by 1/2 the interior angle so that the polygon always has a flat side on the bottom
    // This isn't strictly necessary, but it's how we tend to think of and expect polygons to be drawn
    let rotationAdjustment = -$f268b97836dca6b6$var$halfPI;
    if (numVertexes % 2 === 0) rotationAdjustment += interiorAngle / 2;
    const d = new Array(numVertexes + 1);
    for(let i = 0; i < numVertexes; i++){
        const rad = i * interiorAngle + rotationAdjustment;
        const { x: x, y: y } = new $f268b97836dca6b6$export$baf26146a414f24a($f268b97836dca6b6$var$cos(rad), $f268b97836dca6b6$var$sin(rad)).scalarMultiply(radius);
        d[i] = [
            i === 0 ? 'M' : 'L',
            x,
            y
        ];
    }
    d[numVertexes] = [
        'Z'
    ];
    return d;
};
/**
 * Join path commands to go back to svg format
 * @param {TSimplePathData} pathData fabricJS parsed path commands
 * @param {number} fractionDigits number of fraction digits to "leave"
 * @return {String} joined path 'M 0 0 L 20 30'
 */ const $f268b97836dca6b6$var$joinPath = (pathData, fractionDigits)=>pathData.map((segment)=>{
        return segment.map((arg, i)=>{
            if (i === 0) return arg;
            return fractionDigits === undefined ? arg : $f268b97836dca6b6$var$toFixed(arg, fractionDigits);
        }).join(' ');
    }).join(' ');
// TODO this file needs to go away, cross browser style support is not fabricjs domain.
/**
 * wrapper for setting element's style
 * @param {HTMLElement} element
 * @param {Object | string} styles
 */ function $f268b97836dca6b6$var$setStyle(element, styles) {
    const elementStyle = element.style;
    if (!elementStyle || !styles) return;
    else if (typeof styles === 'string') elementStyle.cssText += ';' + styles;
    else Object.entries(styles).forEach((_ref)=>{
        let [property, value] = _ref;
        return elementStyle.setProperty(property, value);
    });
}
/**
 * Merges 2 clip paths into one visually equal clip path
 *
 * **IMPORTANT**:\
 * Does **NOT** clone the arguments, clone them proir if necessary.
 *
 * Creates a wrapper (group) that contains one clip path and is clipped by the other so content is kept where both overlap.
 * Use this method if both the clip paths may have nested clip paths of their own, so assigning one to the other's clip path property is not possible.
 *
 * In order to handle the `inverted` property we follow logic described in the following cases:\
 * **(1)** both clip paths are inverted - the clip paths pass the inverted prop to the wrapper and loose it themselves.\
 * **(2)** one is inverted and the other isn't - the wrapper shouldn't become inverted and the inverted clip path must clip the non inverted one to produce an identical visual effect.\
 * **(3)** both clip paths are not inverted - wrapper and clip paths remain unchanged.
 *
 * @memberOf fabric.util
 * @param {fabric.Object} c1
 * @param {fabric.Object} c2
 * @returns {fabric.Object} merged clip path
 */ const $f268b97836dca6b6$var$mergeClipPaths = (c1, c2)=>{
    var _b$group;
    let a = c1, b = c2;
    if (a.inverted && !b.inverted) {
        //  case (2)
        a = c2;
        b = c1;
    }
    //  `b` becomes `a`'s clip path so we transform `b` to `a` coordinate plane
    $f268b97836dca6b6$var$sendObjectToPlane(b, (_b$group = b.group) === null || _b$group === void 0 ? void 0 : _b$group.calcTransformMatrix(), a.calcTransformMatrix());
    //  assign the `inverted` prop to the wrapping group
    const inverted = a.inverted && b.inverted;
    if (inverted) //  case (1)
    a.inverted = b.inverted = false;
    return new $f268b97836dca6b6$export$eb2fcfdbd7ba97d4([
        a
    ], {
        clipPath: b,
        inverted: inverted
    });
};
/**
 * Returns random number between 2 specified ones.
 * @param {Number} min lower limit
 * @param {Number} max upper limit
 * @return {Number} random value (between min and max)
 */ const $f268b97836dca6b6$var$getRandomInt = (min, max)=>Math.floor(Math.random() * (max - min + 1)) + min;
/**
 * Cross-browser abstraction for sending XMLHttpRequest
 * @deprecated this has to go away, we can use a modern browser method to do the same.
 * @param {String} url URL to send XMLHttpRequest to
 * @param {Object} [options] Options object
 * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
 * @param {Function} options.onComplete Callback to invoke when request is completed
 * @return {XMLHttpRequest} request
 */ function $f268b97836dca6b6$var$request(url) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const onComplete = options.onComplete || $f268b97836dca6b6$var$noop, xhr = new ($f268b97836dca6b6$export$4a3a3142573970c3()).XMLHttpRequest(), signal = options.signal, abort = function() {
        xhr.abort();
    }, removeListener = function() {
        signal && signal.removeEventListener('abort', abort);
        xhr.onerror = xhr.ontimeout = $f268b97836dca6b6$var$noop;
    };
    if (signal && signal.aborted) throw new $f268b97836dca6b6$var$SignalAbortedError('request');
    else if (signal) signal.addEventListener('abort', abort, {
        once: true
    });
    /** @ignore */ xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) {
            removeListener();
            onComplete(xhr);
            xhr.onreadystatechange = $f268b97836dca6b6$var$noop;
        }
    };
    xhr.onerror = xhr.ontimeout = removeListener;
    xhr.open('get', url, true);
    xhr.send();
    return xhr;
}
/**
 * This function is an helper for svg import. it decompose the transformMatrix
 * and assign properties to object.
 * untransformed coordinates
 * @private
 */ const $f268b97836dca6b6$var$_assignTransformMatrixProps = (object)=>{
    if (object.transformMatrix) {
        const { scaleX: scaleX, scaleY: scaleY, angle: angle, skewX: skewX } = $f268b97836dca6b6$var$qrDecompose(object.transformMatrix);
        object.flipX = false;
        object.flipY = false;
        object.set($f268b97836dca6b6$var$SCALE_X, scaleX);
        object.set($f268b97836dca6b6$var$SCALE_Y, scaleY);
        object.angle = angle;
        object.skewX = skewX;
        object.skewY = 0;
    }
};
/**
 * This function is an helper for svg import. it removes the transform matrix
 * and set to object properties that fabricjs can handle
 * @private
 * @param {Object} preserveAspectRatioOptions
 */ const $f268b97836dca6b6$var$removeTransformMatrixForSvgParsing = (object, preserveAspectRatioOptions)=>{
    let center = object._findCenterFromElement();
    if (object.transformMatrix) {
        $f268b97836dca6b6$var$_assignTransformMatrixProps(object);
        center = center.transform(object.transformMatrix);
    }
    delete object.transformMatrix;
    if (preserveAspectRatioOptions) {
        object.scaleX *= preserveAspectRatioOptions.scaleX;
        object.scaleY *= preserveAspectRatioOptions.scaleY;
        object.cropX = preserveAspectRatioOptions.cropX;
        object.cropY = preserveAspectRatioOptions.cropY;
        center.x += preserveAspectRatioOptions.offsetLeft;
        center.y += preserveAspectRatioOptions.offsetTop;
        object.width = preserveAspectRatioOptions.width;
        object.height = preserveAspectRatioOptions.height;
    }
    object.setPositionByOrigin(center, $f268b97836dca6b6$var$CENTER, $f268b97836dca6b6$var$CENTER);
};
var $f268b97836dca6b6$export$7debb50ef11d5e0b = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    addTransformToObject: $f268b97836dca6b6$var$addTransformToObject,
    animate: $f268b97836dca6b6$var$animate,
    animateColor: $f268b97836dca6b6$var$animateColor,
    applyTransformToObject: $f268b97836dca6b6$var$applyTransformToObject,
    calcAngleBetweenVectors: $f268b97836dca6b6$var$calcAngleBetweenVectors,
    calcDimensionsMatrix: $f268b97836dca6b6$var$calcDimensionsMatrix,
    calcPlaneChangeMatrix: $f268b97836dca6b6$var$calcPlaneChangeMatrix,
    calcVectorRotation: $f268b97836dca6b6$var$calcVectorRotation,
    cancelAnimFrame: $f268b97836dca6b6$var$cancelAnimFrame,
    capValue: $f268b97836dca6b6$var$capValue,
    composeMatrix: $f268b97836dca6b6$var$composeMatrix,
    copyCanvasElement: $f268b97836dca6b6$var$copyCanvasElement,
    cos: $f268b97836dca6b6$var$cos,
    createCanvasElement: $f268b97836dca6b6$var$createCanvasElement,
    createImage: $f268b97836dca6b6$var$createImage,
    createRotateMatrix: $f268b97836dca6b6$var$createRotateMatrix,
    createScaleMatrix: $f268b97836dca6b6$var$createScaleMatrix,
    createSkewXMatrix: $f268b97836dca6b6$var$createSkewXMatrix,
    createSkewYMatrix: $f268b97836dca6b6$var$createSkewYMatrix,
    createTranslateMatrix: $f268b97836dca6b6$var$createTranslateMatrix,
    createVector: $f268b97836dca6b6$var$createVector,
    crossProduct: $f268b97836dca6b6$var$crossProduct,
    degreesToRadians: $f268b97836dca6b6$var$degreesToRadians,
    dotProduct: $f268b97836dca6b6$var$dotProduct,
    ease: $f268b97836dca6b6$var$easing,
    enlivenObjectEnlivables: $f268b97836dca6b6$var$enlivenObjectEnlivables,
    enlivenObjects: $f268b97836dca6b6$var$enlivenObjects,
    findScaleToCover: $f268b97836dca6b6$var$findScaleToCover,
    findScaleToFit: $f268b97836dca6b6$var$findScaleToFit,
    getBoundsOfCurve: $f268b97836dca6b6$var$getBoundsOfCurve,
    getOrthonormalVector: $f268b97836dca6b6$var$getOrthonormalVector,
    getPathSegmentsInfo: $f268b97836dca6b6$var$getPathSegmentsInfo,
    getPointOnPath: $f268b97836dca6b6$var$getPointOnPath,
    getPointer: $f268b97836dca6b6$var$getPointer,
    getRandomInt: $f268b97836dca6b6$var$getRandomInt,
    getRegularPolygonPath: $f268b97836dca6b6$var$getRegularPolygonPath,
    getSmoothPathFromPoints: $f268b97836dca6b6$var$getSmoothPathFromPoints,
    getSvgAttributes: $f268b97836dca6b6$var$getSvgAttributes,
    getUnitVector: $f268b97836dca6b6$var$getUnitVector,
    groupSVGElements: $f268b97836dca6b6$var$groupSVGElements,
    hasStyleChanged: $f268b97836dca6b6$var$hasStyleChanged,
    invertTransform: $f268b97836dca6b6$var$invertTransform,
    isBetweenVectors: $f268b97836dca6b6$var$isBetweenVectors,
    isIdentityMatrix: $f268b97836dca6b6$var$isIdentityMatrix,
    isTouchEvent: $f268b97836dca6b6$var$isTouchEvent,
    isTransparent: $f268b97836dca6b6$var$isTransparent,
    joinPath: $f268b97836dca6b6$var$joinPath,
    loadImage: $f268b97836dca6b6$var$loadImage,
    magnitude: $f268b97836dca6b6$var$magnitude,
    makeBoundingBoxFromPoints: $f268b97836dca6b6$var$makeBoundingBoxFromPoints,
    makePathSimpler: $f268b97836dca6b6$var$makePathSimpler,
    matrixToSVG: $f268b97836dca6b6$var$matrixToSVG,
    mergeClipPaths: $f268b97836dca6b6$var$mergeClipPaths,
    multiplyTransformMatrices: $f268b97836dca6b6$var$multiplyTransformMatrices,
    multiplyTransformMatrixArray: $f268b97836dca6b6$var$multiplyTransformMatrixArray,
    parsePath: $f268b97836dca6b6$var$parsePath,
    parsePreserveAspectRatioAttribute: $f268b97836dca6b6$var$parsePreserveAspectRatioAttribute,
    parseUnit: $f268b97836dca6b6$var$parseUnit,
    pick: $f268b97836dca6b6$var$pick,
    projectStrokeOnPoints: $f268b97836dca6b6$var$projectStrokeOnPoints,
    qrDecompose: $f268b97836dca6b6$var$qrDecompose,
    radiansToDegrees: $f268b97836dca6b6$var$radiansToDegrees,
    removeFromArray: $f268b97836dca6b6$var$removeFromArray,
    removeTransformFromObject: $f268b97836dca6b6$var$removeTransformFromObject,
    removeTransformMatrixForSvgParsing: $f268b97836dca6b6$var$removeTransformMatrixForSvgParsing,
    request: $f268b97836dca6b6$var$request,
    requestAnimFrame: $f268b97836dca6b6$var$requestAnimFrame,
    resetObjectTransform: $f268b97836dca6b6$var$resetObjectTransform,
    rotatePoint: $f268b97836dca6b6$var$rotatePoint,
    rotateVector: $f268b97836dca6b6$var$rotateVector,
    saveObjectTransform: $f268b97836dca6b6$var$saveObjectTransform,
    sendObjectToPlane: $f268b97836dca6b6$var$sendObjectToPlane,
    sendPointToPlane: $f268b97836dca6b6$var$sendPointToPlane,
    sendVectorToPlane: $f268b97836dca6b6$var$sendVectorToPlane,
    setStyle: $f268b97836dca6b6$var$setStyle,
    sin: $f268b97836dca6b6$var$sin,
    sizeAfterTransform: $f268b97836dca6b6$var$sizeAfterTransform,
    string: $f268b97836dca6b6$var$lang_string,
    stylesFromArray: $f268b97836dca6b6$var$stylesFromArray,
    stylesToArray: $f268b97836dca6b6$var$stylesToArray,
    toBlob: $f268b97836dca6b6$var$toBlob,
    toDataURL: $f268b97836dca6b6$var$toDataURL,
    toFixed: $f268b97836dca6b6$var$toFixed,
    transformPath: $f268b97836dca6b6$var$transformPath,
    transformPoint: $f268b97836dca6b6$var$transformPoint
});
class $f268b97836dca6b6$export$fc395a588fa002d0 extends $f268b97836dca6b6$export$cf489a44e232c033 {
    createUpperCanvas() {
        const { el: lowerCanvasEl } = this.lower;
        const el = $f268b97836dca6b6$var$createCanvasElement();
        // we assign the same classname of the lowerCanvas
        el.className = lowerCanvasEl.className;
        // but then we remove the lower-canvas specific className
        el.classList.remove('lower-canvas');
        // we add the specific upper-canvas class
        el.classList.add('upper-canvas');
        el.setAttribute('data-fabric', 'top');
        el.style.cssText = lowerCanvasEl.style.cssText;
        el.setAttribute('draggable', 'true');
        return el;
    }
    createContainerElement() {
        const container = $f268b97836dca6b6$export$91e93c41e950ddbb().createElement('div');
        container.setAttribute('data-fabric', 'wrapper');
        $f268b97836dca6b6$var$setStyle(container, {
            position: 'relative'
        });
        $f268b97836dca6b6$var$makeElementUnselectable(container);
        return container;
    }
    /**
   * @private
   * @param {HTMLCanvasElement} element canvas element to apply styles on
   */ applyCanvasStyle(element, options) {
        const { styles: styles, allowTouchScrolling: allowTouchScrolling } = options;
        $f268b97836dca6b6$var$setStyle(element, $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, styles), {}, {
            'touch-action': allowTouchScrolling ? 'manipulation' : $f268b97836dca6b6$var$NONE
        }));
        $f268b97836dca6b6$var$makeElementUnselectable(element);
    }
    setDimensions(size, retinaScaling) {
        super.setDimensions(size, retinaScaling);
        const { el: el, ctx: ctx } = this.upper;
        $f268b97836dca6b6$var$setCanvasDimensions(el, ctx, size, retinaScaling);
    }
    setCSSDimensions(size) {
        super.setCSSDimensions(size);
        $f268b97836dca6b6$var$setCSSDimensions(this.upper.el, size);
        $f268b97836dca6b6$var$setCSSDimensions(this.container, size);
    }
    cleanupDOM(size) {
        const container = this.container, { el: lowerCanvasEl } = this.lower, { el: upperCanvasEl } = this.upper;
        super.cleanupDOM(size);
        container.removeChild(upperCanvasEl);
        container.removeChild(lowerCanvasEl);
        if (container.parentNode) container.parentNode.replaceChild(lowerCanvasEl, container);
    }
    dispose() {
        super.dispose();
        $f268b97836dca6b6$export$4bd44a2aa29d3d6e().dispose(this.upper.el);
        // @ts-expect-error disposing
        delete this.upper;
        // @ts-expect-error disposing
        delete this.container;
    }
    constructor(arg0){
        let { allowTouchScrolling: allowTouchScrolling = false, containerClass: containerClass = '' } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(arg0);
        $f268b97836dca6b6$var$_defineProperty(this, "upper", void 0);
        $f268b97836dca6b6$var$_defineProperty(this, "container", void 0);
        const { el: lowerCanvasEl } = this.lower;
        const upperCanvasEl = this.createUpperCanvas();
        this.upper = {
            el: upperCanvasEl,
            ctx: upperCanvasEl.getContext('2d')
        };
        this.applyCanvasStyle(lowerCanvasEl, {
            allowTouchScrolling: allowTouchScrolling
        });
        this.applyCanvasStyle(upperCanvasEl, {
            allowTouchScrolling: allowTouchScrolling,
            styles: {
                position: 'absolute',
                left: '0',
                top: '0'
            }
        });
        const container = this.createContainerElement();
        container.classList.add(containerClass);
        if (lowerCanvasEl.parentNode) lowerCanvasEl.parentNode.replaceChild(container, lowerCanvasEl);
        container.append(lowerCanvasEl, upperCanvasEl);
        this.container = container;
    }
}
const $f268b97836dca6b6$var$canvasDefaults = {
    uniformScaling: true,
    uniScaleKey: 'shiftKey',
    centeredScaling: false,
    centeredRotation: false,
    centeredKey: 'altKey',
    altActionKey: 'shiftKey',
    selection: true,
    selectionKey: 'shiftKey',
    selectionColor: 'rgba(100, 100, 255, 0.3)',
    selectionDashArray: [],
    selectionBorderColor: 'rgba(255, 255, 255, 0.3)',
    selectionLineWidth: 1,
    selectionFullyContained: false,
    hoverCursor: 'move',
    moveCursor: 'move',
    defaultCursor: 'default',
    freeDrawingCursor: 'crosshair',
    notAllowedCursor: 'not-allowed',
    perPixelTargetFind: false,
    targetFindTolerance: 0,
    skipTargetFind: false,
    stopContextMenu: false,
    fireRightClick: false,
    fireMiddleClick: false,
    enablePointerEvents: false,
    containerClass: 'canvas-container',
    // turn to true for fabric 7.0
    preserveObjectStacking: false
};
/**
 * Canvas class
 * @class Canvas
 * @extends StaticCanvas
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#canvas}
 *
 * @fires object:modified at the end of a transform
 * @fires object:rotating while an object is being rotated from the control
 * @fires object:scaling while an object is being scaled by controls
 * @fires object:moving while an object is being dragged
 * @fires object:skewing while an object is being skewed from the controls
 *
 * @fires before:transform before a transform is is started
 * @fires before:selection:cleared
 * @fires selection:cleared
 * @fires selection:updated
 * @fires selection:created
 *
 * @fires path:created after a drawing operation ends and the path is added
 * @fires mouse:down
 * @fires mouse:move
 * @fires mouse:up
 * @fires mouse:down:before  on mouse down, before the inner fabric logic runs
 * @fires mouse:move:before on mouse move, before the inner fabric logic runs
 * @fires mouse:up:before on mouse up, before the inner fabric logic runs
 * @fires mouse:over
 * @fires mouse:out
 * @fires mouse:dblclick whenever a native dbl click event fires on the canvas.
 *
 * @fires dragover
 * @fires dragenter
 * @fires dragleave
 * @fires drag:enter object drag enter
 * @fires drag:leave object drag leave
 * @fires drop:before before drop event. Prepare for the drop event (same native event).
 * @fires drop
 * @fires drop:after after drop event. Run logic on canvas after event has been accepted/declined (same native event).
 * @example
 * let a: fabric.Object, b: fabric.Object;
 * let flag = false;
 * canvas.add(a, b);
 * a.on('drop:before', opt => {
 *  //  we want a to accept the drop even though it's below b in the stack
 *  flag = this.canDrop(opt.e);
 * });
 * b.canDrop = function(e) {
 *  !flag && this.draggableTextDelegate.canDrop(e);
 * }
 * b.on('dragover', opt => b.set('fill', opt.dropTarget === b ? 'pink' : 'black'));
 * a.on('drop', opt => {
 *  opt.e.defaultPrevented  //  drop occurred
 *  opt.didDrop             //  drop occurred on canvas
 *  opt.target              //  drop target
 *  opt.target !== a && a.set('text', 'I lost');
 * });
 * canvas.on('drop:after', opt => {
 *  //  inform user who won
 *  if(!opt.e.defaultPrevented) {
 *    // no winners
 *  }
 *  else if(!opt.didDrop) {
 *    //  my objects didn't win, some other lucky object
 *  }
 *  else {
 *    //  we have a winner it's opt.target!!
 *  }
 * })
 *
 * @fires after:render at the end of the render process, receives the context in the callback
 * @fires before:render at start the render process, receives the context in the callback
 *
 * @fires contextmenu:before
 * @fires contextmenu
 * @example
 * let handler;
 * targets.forEach(target => {
 *   target.on('contextmenu:before', opt => {
 *     //  decide which target should handle the event before canvas hijacks it
 *     if (someCaseHappens && opt.targets.includes(target)) {
 *       handler = target;
 *     }
 *   });
 *   target.on('contextmenu', opt => {
 *     //  do something fantastic
 *   });
 * });
 * canvas.on('contextmenu', opt => {
 *   if (!handler) {
 *     //  no one takes responsibility, it's always left to me
 *     //  let's show them how it's done!
 *   }
 * });
 *
 */ class $f268b97836dca6b6$var$SelectableCanvas extends $f268b97836dca6b6$export$ad01921fb0b1386e {
    static getDefaults() {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.getDefaults()), $f268b97836dca6b6$var$SelectableCanvas.ownDefaults);
    }
    get upperCanvasEl() {
        var _this$elements$upper;
        return (_this$elements$upper = this.elements.upper) === null || _this$elements$upper === void 0 ? void 0 : _this$elements$upper.el;
    }
    get contextTop() {
        var _this$elements$upper2;
        return (_this$elements$upper2 = this.elements.upper) === null || _this$elements$upper2 === void 0 ? void 0 : _this$elements$upper2.ctx;
    }
    get wrapperEl() {
        return this.elements.container;
    }
    initElements(el) {
        this.elements = new $f268b97836dca6b6$export$fc395a588fa002d0(el, {
            allowTouchScrolling: this.allowTouchScrolling,
            containerClass: this.containerClass
        });
        this._createCacheCanvas();
    }
    /**
   * @private
   * @param {FabricObject} obj Object that was added
   */ _onObjectAdded(obj) {
        this._objectsToRender = undefined;
        super._onObjectAdded(obj);
    }
    /**
   * @private
   * @param {FabricObject} obj Object that was removed
   */ _onObjectRemoved(obj) {
        this._objectsToRender = undefined;
        // removing active object should fire "selection:cleared" events
        if (obj === this._activeObject) {
            this.fire('before:selection:cleared', {
                deselected: [
                    obj
                ]
            });
            this._discardActiveObject();
            this.fire('selection:cleared', {
                deselected: [
                    obj
                ]
            });
            obj.fire('deselected', {
                target: obj
            });
        }
        if (obj === this._hoveredTarget) {
            this._hoveredTarget = undefined;
            this._hoveredTargets = [];
        }
        super._onObjectRemoved(obj);
    }
    _onStackOrderChanged() {
        this._objectsToRender = undefined;
        super._onStackOrderChanged();
    }
    /**
   * Divides objects in two groups, one to render immediately
   * and one to render as activeGroup.
   * @return {Array} objects to render immediately and pushes the other in the activeGroup.
   */ _chooseObjectsToRender() {
        const activeObject = this._activeObject;
        return !this.preserveObjectStacking && activeObject ? this._objects.filter((object)=>!object.group && object !== activeObject).concat(activeObject) : this._objects;
    }
    /**
   * Renders both the top canvas and the secondary container canvas.
   */ renderAll() {
        this.cancelRequestedRender();
        if (this.destroyed) return;
        if (this.contextTopDirty && !this._groupSelector && !this.isDrawingMode) {
            this.clearContext(this.contextTop);
            this.contextTopDirty = false;
        }
        if (this.hasLostContext) {
            this.renderTopLayer(this.contextTop);
            this.hasLostContext = false;
        }
        !this._objectsToRender && (this._objectsToRender = this._chooseObjectsToRender());
        this.renderCanvas(this.getContext(), this._objectsToRender);
    }
    /**
   * text selection is rendered by the active text instance during the rendering cycle
   */ renderTopLayer(ctx) {
        ctx.save();
        if (this.isDrawingMode && this._isCurrentlyDrawing) {
            this.freeDrawingBrush && this.freeDrawingBrush._render();
            this.contextTopDirty = true;
        }
        // we render the top context - last object
        if (this.selection && this._groupSelector) {
            this._drawSelection(ctx);
            this.contextTopDirty = true;
        }
        ctx.restore();
    }
    /**
   * Method to render only the top canvas.
   * Also used to render the group selection box.
   * Does not render text selection.
   */ renderTop() {
        const ctx = this.contextTop;
        this.clearContext(ctx);
        this.renderTopLayer(ctx);
        // todo: how do i know if the after:render is for the top or normal contex?
        this.fire('after:render', {
            ctx: ctx
        });
    }
    /**
   * Set the canvas tolerance value for pixel taret find.
   * Use only integer numbers.
   * @private
   */ setTargetFindTolerance(value) {
        value = Math.round(value);
        this.targetFindTolerance = value;
        const retina = this.getRetinaScaling();
        const size = Math.ceil((value * 2 + 1) * retina);
        this.pixelFindCanvasEl.width = this.pixelFindCanvasEl.height = size;
        this.pixelFindContext.scale(retina, retina);
    }
    /**
   * Returns true if object is transparent at a certain location
   * Clarification: this is `is target transparent at location X or are controls there`
   * @TODO this seems dumb that we treat controls with transparency. we can find controls
   * programmatically without painting them, the cache canvas optimization is always valid
   * @param {FabricObject} target Object to check
   * @param {Number} x Left coordinate in viewport space
   * @param {Number} y Top coordinate in viewport space
   * @return {Boolean}
   */ isTargetTransparent(target, x, y) {
        const tolerance = this.targetFindTolerance;
        const ctx = this.pixelFindContext;
        this.clearContext(ctx);
        ctx.save();
        ctx.translate(-x + tolerance, -y + tolerance);
        ctx.transform(...this.viewportTransform);
        const selectionBgc = target.selectionBackgroundColor;
        target.selectionBackgroundColor = '';
        target.render(ctx);
        target.selectionBackgroundColor = selectionBgc;
        ctx.restore();
        // our canvas is square, and made around tolerance.
        // so tolerance in this case also represent the center of the canvas.
        const enhancedTolerance = Math.round(tolerance * this.getRetinaScaling());
        return $f268b97836dca6b6$var$isTransparent(ctx, enhancedTolerance, enhancedTolerance, enhancedTolerance);
    }
    /**
   * takes an event and determines if selection key has been pressed
   * @private
   * @param {TPointerEvent} e Event object
   */ _isSelectionKeyPressed(e) {
        const sKey = this.selectionKey;
        if (!sKey) return false;
        if (Array.isArray(sKey)) return !!sKey.find((key)=>!!key && e[key] === true);
        else return e[sKey];
    }
    /**
   * @private
   * @param {TPointerEvent} e Event object
   * @param {FabricObject} target
   */ _shouldClearSelection(e, target) {
        const activeObjects = this.getActiveObjects(), activeObject = this._activeObject;
        return !!(!target || target && activeObject && activeObjects.length > 1 && activeObjects.indexOf(target) === -1 && activeObject !== target && !this._isSelectionKeyPressed(e) || target && !target.evented || target && !target.selectable && activeObject && activeObject !== target);
    }
    /**
   * This method will take in consideration a modifier key pressed and the control we are
   * about to drag, and try to guess the anchor point ( origin ) of the transormation.
   * This should be really in the realm of controls, and we should remove specific code for legacy
   * embedded actions.
   * @TODO this probably deserve discussion/rediscovery and change/refactor
   * @private
   * @deprecated
   * @param {FabricObject} target
   * @param {string} action
   * @param {boolean} altKey
   * @returns {boolean} true if the transformation should be centered
   */ _shouldCenterTransform(target, action, modifierKeyPressed) {
        if (!target) return;
        let centerTransform;
        if (action === $f268b97836dca6b6$var$SCALE || action === $f268b97836dca6b6$var$SCALE_X || action === $f268b97836dca6b6$var$SCALE_Y || action === $f268b97836dca6b6$var$RESIZING) centerTransform = this.centeredScaling || target.centeredScaling;
        else if (action === $f268b97836dca6b6$var$ROTATE) centerTransform = this.centeredRotation || target.centeredRotation;
        return centerTransform ? !modifierKeyPressed : modifierKeyPressed;
    }
    /**
   * Given the control clicked, determine the origin of the transform.
   * This is bad because controls can totally have custom names
   * should disappear before release 4.0
   * @private
   * @deprecated
   */ _getOriginFromCorner(target, controlName) {
        const origin = {
            x: target.originX,
            y: target.originY
        };
        if (!controlName) return origin;
        // is a left control ?
        if ([
            'ml',
            'tl',
            'bl'
        ].includes(controlName)) origin.x = $f268b97836dca6b6$var$RIGHT;
        else if ([
            'mr',
            'tr',
            'br'
        ].includes(controlName)) origin.x = $f268b97836dca6b6$var$LEFT;
        // is a top control ?
        if ([
            'tl',
            'mt',
            'tr'
        ].includes(controlName)) origin.y = $f268b97836dca6b6$var$BOTTOM;
        else if ([
            'bl',
            'mb',
            'br'
        ].includes(controlName)) origin.y = $f268b97836dca6b6$var$TOP;
        return origin;
    }
    /**
   * @private
   * @param {Event} e Event object
   * @param {FabricObject} target
   * @param {boolean} [alreadySelected] pass true to setup the active control
   */ _setupCurrentTransform(e, target, alreadySelected) {
        var _control$getActionHan;
        const pointer = target.group ? // transform pointer to target's containing coordinate plane
        $f268b97836dca6b6$var$sendPointToPlane(this.getScenePoint(e), undefined, target.group.calcTransformMatrix()) : this.getScenePoint(e);
        const { key: corner = '', control: control } = target.getActiveControl() || {}, actionHandler = alreadySelected && control ? (_control$getActionHan = control.getActionHandler(e, target, control)) === null || _control$getActionHan === void 0 ? void 0 : _control$getActionHan.bind(control) : $f268b97836dca6b6$var$dragHandler, action = $f268b97836dca6b6$var$getActionFromCorner(alreadySelected, corner, e, target), altKey = e[this.centeredKey], origin = this._shouldCenterTransform(target, action, altKey) ? {
            x: $f268b97836dca6b6$var$CENTER,
            y: $f268b97836dca6b6$var$CENTER
        } : this._getOriginFromCorner(target, corner), /**
       * relative to target's containing coordinate plane
       * both agree on every point
       **/ transform = {
            target: target,
            action: action,
            actionHandler: actionHandler,
            actionPerformed: false,
            corner: corner,
            scaleX: target.scaleX,
            scaleY: target.scaleY,
            skewX: target.skewX,
            skewY: target.skewY,
            offsetX: pointer.x - target.left,
            offsetY: pointer.y - target.top,
            originX: origin.x,
            originY: origin.y,
            ex: pointer.x,
            ey: pointer.y,
            lastX: pointer.x,
            lastY: pointer.y,
            theta: $f268b97836dca6b6$var$degreesToRadians(target.angle),
            width: target.width,
            height: target.height,
            shiftKey: e.shiftKey,
            altKey: altKey,
            original: $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, $f268b97836dca6b6$var$saveObjectTransform(target)), {}, {
                originX: origin.x,
                originY: origin.y
            })
        };
        this._currentTransform = transform;
        this.fire('before:transform', {
            e: e,
            transform: transform
        });
    }
    /**
   * Set the cursor type of the canvas element
   * @param {String} value Cursor type of the canvas element.
   * @see http://www.w3.org/TR/css3-ui/#cursor
   */ setCursor(value) {
        this.upperCanvasEl.style.cursor = value;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx to draw the selection on
   */ _drawSelection(ctx) {
        const { x: x, y: y, deltaX: deltaX, deltaY: deltaY } = this._groupSelector, start = new $f268b97836dca6b6$export$baf26146a414f24a(x, y).transform(this.viewportTransform), extent = new $f268b97836dca6b6$export$baf26146a414f24a(x + deltaX, y + deltaY).transform(this.viewportTransform), strokeOffset = this.selectionLineWidth / 2;
        let minX = Math.min(start.x, extent.x), minY = Math.min(start.y, extent.y), maxX = Math.max(start.x, extent.x), maxY = Math.max(start.y, extent.y);
        if (this.selectionColor) {
            ctx.fillStyle = this.selectionColor;
            ctx.fillRect(minX, minY, maxX - minX, maxY - minY);
        }
        if (!this.selectionLineWidth || !this.selectionBorderColor) return;
        ctx.lineWidth = this.selectionLineWidth;
        ctx.strokeStyle = this.selectionBorderColor;
        minX += strokeOffset;
        minY += strokeOffset;
        maxX -= strokeOffset;
        maxY -= strokeOffset;
        // selection border
        // @TODO: is _setLineDash still necessary on modern canvas?
        $f268b97836dca6b6$export$5a5fba7eea6847b1.prototype._setLineDash.call(this, ctx, this.selectionDashArray);
        ctx.strokeRect(minX, minY, maxX - minX, maxY - minY);
    }
    /**
   * Method that determines what object we are clicking on
   * 11/09/2018 TODO: would be cool if findTarget could discern between being a full target
   * or the outside part of the corner.
   * @param {Event} e mouse event
   * @return {FabricObject | null} the target found
   */ findTarget(e) {
        if (this.skipTargetFind) return undefined;
        const pointer = this.getViewportPoint(e), activeObject = this._activeObject, aObjects = this.getActiveObjects();
        this.targets = [];
        if (activeObject && aObjects.length >= 1) {
            if (activeObject.findControl(pointer, $f268b97836dca6b6$var$isTouchEvent(e))) // if we hit the corner of the active object, let's return that.
            return activeObject;
            else if (aObjects.length > 1 && // check pointer is over active selection and possibly perform `subTargetCheck`
            this.searchPossibleTargets([
                activeObject
            ], pointer)) // active selection does not select sub targets like normal groups
            return activeObject;
            else if (activeObject === this.searchPossibleTargets([
                activeObject
            ], pointer)) {
                // active object is not an active selection
                if (!this.preserveObjectStacking) return activeObject;
                else {
                    const subTargets = this.targets;
                    this.targets = [];
                    const target = this.searchPossibleTargets(this._objects, pointer);
                    if (e[this.altSelectionKey] && target && target !== activeObject) {
                        // alt selection: select active object even though it is not the top most target
                        // restore targets
                        this.targets = subTargets;
                        return activeObject;
                    }
                    return target;
                }
            }
        }
        return this.searchPossibleTargets(this._objects, pointer);
    }
    /**
   * Checks if the point is inside the object selection area including padding
   * @param {FabricObject} obj Object to test against
   * @param {Object} [pointer] point in scene coordinates
   * @return {Boolean} true if point is contained within an area of given object
   * @private
   */ _pointIsInObjectSelectionArea(obj, point) {
        // getCoords will already take care of group de-nesting
        let coords = obj.getCoords();
        const viewportZoom = this.getZoom();
        const padding = obj.padding / viewportZoom;
        if (padding) {
            const [tl, tr, br, bl] = coords;
            // what is the angle of the object?
            // we could use getTotalAngle, but is way easier to look at it
            // from how coords are oriented, since if something went wrong
            // at least we are consistent.
            const angleRadians = Math.atan2(tr.y - tl.y, tr.x - tl.x), cosP = $f268b97836dca6b6$var$cos(angleRadians) * padding, sinP = $f268b97836dca6b6$var$sin(angleRadians) * padding, cosPSinP = cosP + sinP, cosPMinusSinP = cosP - sinP;
            coords = [
                new $f268b97836dca6b6$export$baf26146a414f24a(tl.x - cosPMinusSinP, tl.y - cosPSinP),
                new $f268b97836dca6b6$export$baf26146a414f24a(tr.x + cosPSinP, tr.y - cosPMinusSinP),
                new $f268b97836dca6b6$export$baf26146a414f24a(br.x + cosPMinusSinP, br.y + cosPSinP),
                new $f268b97836dca6b6$export$baf26146a414f24a(bl.x - cosPSinP, bl.y + cosPMinusSinP)
            ];
        // in case of padding we calculate the new coords on the fly.
        // otherwise we have to maintain 2 sets of coordinates for everything.
        // we can reiterate on storing them.
        // if this is slow, for now the semplification is large and doesn't impact
        // rendering.
        // the idea behind this is that outside target check we don't need ot know
        // where those coords are
        }
        return $f268b97836dca6b6$export$869c896bf338bf5a.isPointInPolygon(point, coords);
    }
    /**
   * Checks point is inside the object selection condition. Either area with padding
   * or over pixels if perPixelTargetFind is enabled
   * @param {FabricObject} obj Object to test against
   * @param {Object} [pointer] point from viewport.
   * @return {Boolean} true if point is contained within an area of given object
   * @private
   */ _checkTarget(obj, pointer) {
        if (obj && obj.visible && obj.evented && this._pointIsInObjectSelectionArea(obj, $f268b97836dca6b6$var$sendPointToPlane(pointer, undefined, this.viewportTransform))) {
            if ((this.perPixelTargetFind || obj.perPixelTargetFind) && !obj.isEditing) {
                if (!this.isTargetTransparent(obj, pointer.x, pointer.y)) return true;
            } else return true;
        }
        return false;
    }
    /**
   * Internal Function used to search inside objects an object that contains pointer in bounding box or that contains pointerOnCanvas when painted
   * @param {Array} [objects] objects array to look into
   * @param {Object} [pointer] x,y object of point coordinates we want to check.
   * @return {FabricObject} **top most object from given `objects`** that contains pointer
   * @private
   */ _searchPossibleTargets(objects, pointer) {
        // Cache all targets where their bounding box contains point.
        let i = objects.length;
        // Do not check for currently grouped objects, since we check the parent group itself.
        // until we call this function specifically to search inside the activeGroup
        while(i--){
            const target = objects[i];
            if (this._checkTarget(target, pointer)) {
                if ($f268b97836dca6b6$var$isCollection(target) && target.subTargetCheck) {
                    const subTarget = this._searchPossibleTargets(target._objects, pointer);
                    subTarget && this.targets.push(subTarget);
                }
                return target;
            }
        }
    }
    /**
   * Function used to search inside objects an object that contains pointer in bounding box or that contains pointerOnCanvas when painted
   * @see {@link _searchPossibleTargets}
   * @param {FabricObject[]} [objects] objects array to look into
   * @param {Point} [pointer] coordinates from viewport to check.
   * @return {FabricObject} **top most object on screen** that contains pointer
   */ searchPossibleTargets(objects, pointer) {
        const target = this._searchPossibleTargets(objects, pointer);
        // if we found something in this.targets, and the group is interactive, return the innermost subTarget
        // that is still interactive
        // TODO: reverify why interactive. the target should be returned always, but selected only
        // if interactive.
        if (target && $f268b97836dca6b6$var$isCollection(target) && target.interactive && this.targets[0]) {
            /** targets[0] is the innermost nested target, but it could be inside non interactive groups and so not a selection target */ const targets = this.targets;
            for(let i = targets.length - 1; i > 0; i--){
                const t = targets[i];
                if (!($f268b97836dca6b6$var$isCollection(t) && t.interactive)) // one of the subtargets was not interactive. that is the last subtarget we can return.
                // we can't dig more deep;
                return t;
            }
            return targets[0];
        }
        return target;
    }
    /**
   * @returns point existing in the same plane as the {@link HTMLCanvasElement},
   * `(0, 0)` being the top left corner of the {@link HTMLCanvasElement}.
   * This means that changes to the {@link viewportTransform} do not change the values of the point
   * and it remains unchanged from the viewer's perspective.
   *
   * @example
   * const scenePoint = sendPointToPlane(
   *  this.getViewportPoint(e),
   *  undefined,
   *  canvas.viewportTransform
   * );
   *
   */ getViewportPoint(e) {
        if (this._pointer) return this._pointer;
        return this.getPointer(e, true);
    }
    /**
   * @returns point existing in the scene (the same plane as the plane {@link FabricObject#getCenterPoint} exists in).
   * This means that changes to the {@link viewportTransform} do not change the values of the point,
   * however, from the viewer's perspective, the point is changed.
   *
   * @example
   * const viewportPoint = sendPointToPlane(
   *  this.getScenePoint(e),
   *  canvas.viewportTransform
   * );
   *
   */ getScenePoint(e) {
        if (this._absolutePointer) return this._absolutePointer;
        return this.getPointer(e);
    }
    /**
   * Returns pointer relative to canvas.
   *
   * @deprecated This method is deprecated since v6 to protect you from misuse.
   * Use {@link getViewportPoint} or {@link getScenePoint} instead.
   *
   * @param {Event} e
   * @param {Boolean} [fromViewport] whether to return the point from the viewport or in the scene
   * @return {Point}
   */ getPointer(e) {
        let fromViewport = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const upperCanvasEl = this.upperCanvasEl, bounds = upperCanvasEl.getBoundingClientRect();
        let pointer = $f268b97836dca6b6$var$getPointer(e), boundsWidth = bounds.width || 0, boundsHeight = bounds.height || 0;
        if (!boundsWidth || !boundsHeight) {
            if ($f268b97836dca6b6$var$TOP in bounds && $f268b97836dca6b6$var$BOTTOM in bounds) boundsHeight = Math.abs(bounds.top - bounds.bottom);
            if ($f268b97836dca6b6$var$RIGHT in bounds && $f268b97836dca6b6$var$LEFT in bounds) boundsWidth = Math.abs(bounds.right - bounds.left);
        }
        this.calcOffset();
        pointer.x = pointer.x - this._offset.left;
        pointer.y = pointer.y - this._offset.top;
        if (!fromViewport) pointer = $f268b97836dca6b6$var$sendPointToPlane(pointer, undefined, this.viewportTransform);
        const retinaScaling = this.getRetinaScaling();
        if (retinaScaling !== 1) {
            pointer.x /= retinaScaling;
            pointer.y /= retinaScaling;
        }
        // If bounds are not available (i.e. not visible), do not apply scale.
        const cssScale = boundsWidth === 0 || boundsHeight === 0 ? new $f268b97836dca6b6$export$baf26146a414f24a(1, 1) : new $f268b97836dca6b6$export$baf26146a414f24a(upperCanvasEl.width / boundsWidth, upperCanvasEl.height / boundsHeight);
        return pointer.multiply(cssScale);
    }
    /**
   * Internal use only
   * @protected
   */ _setDimensionsImpl(dimensions, options) {
        // @ts-expect-error this method exists in the subclass - should be moved or declared as abstract
        this._resetTransformEventData();
        super._setDimensionsImpl(dimensions, options);
        if (this._isCurrentlyDrawing) this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles(this.contextTop);
    }
    _createCacheCanvas() {
        this.pixelFindCanvasEl = $f268b97836dca6b6$var$createCanvasElement();
        this.pixelFindContext = this.pixelFindCanvasEl.getContext('2d', {
            willReadFrequently: true
        });
        this.setTargetFindTolerance(this.targetFindTolerance);
    }
    /**
   * Returns context of top canvas where interactions are drawn
   * @returns {CanvasRenderingContext2D}
   */ getTopContext() {
        return this.elements.upper.ctx;
    }
    /**
   * Returns context of canvas where object selection is drawn
   * @alias
   * @return {CanvasRenderingContext2D}
   */ getSelectionContext() {
        return this.elements.upper.ctx;
    }
    /**
   * Returns &lt;canvas> element on which object selection is drawn
   * @return {HTMLCanvasElement}
   */ getSelectionElement() {
        return this.elements.upper.el;
    }
    /**
   * Returns currently active object
   * @return {FabricObject | null} active object
   */ getActiveObject() {
        return this._activeObject;
    }
    /**
   * Returns an array with the current selected objects
   * @return {FabricObject[]} active objects array
   */ getActiveObjects() {
        const active = this._activeObject;
        return $f268b97836dca6b6$var$isActiveSelection(active) ? active.getObjects() : active ? [
            active
        ] : [];
    }
    /**
   * @private
   * Compares the old activeObject with the current one and fires correct events
   * @param {FabricObject[]} oldObjects old activeObject
   * @param {TPointerEvent} e mouse event triggering the selection events
   */ _fireSelectionEvents(oldObjects, e) {
        let somethingChanged = false, invalidate = false;
        const objects = this.getActiveObjects(), added = [], removed = [];
        oldObjects.forEach((target)=>{
            if (!objects.includes(target)) {
                somethingChanged = true;
                target.fire('deselected', {
                    e: e,
                    target: target
                });
                removed.push(target);
            }
        });
        objects.forEach((target)=>{
            if (!oldObjects.includes(target)) {
                somethingChanged = true;
                target.fire('selected', {
                    e: e,
                    target: target
                });
                added.push(target);
            }
        });
        if (oldObjects.length > 0 && objects.length > 0) {
            invalidate = true;
            somethingChanged && this.fire('selection:updated', {
                e: e,
                selected: added,
                deselected: removed
            });
        } else if (objects.length > 0) {
            invalidate = true;
            this.fire('selection:created', {
                e: e,
                selected: added
            });
        } else if (oldObjects.length > 0) {
            invalidate = true;
            this.fire('selection:cleared', {
                e: e,
                deselected: removed
            });
        }
        invalidate && (this._objectsToRender = undefined);
    }
    /**
   * Sets given object as the only active object on canvas
   * @param {FabricObject} object Object to set as an active one
   * @param {TPointerEvent} [e] Event (passed along when firing "object:selected")
   * @return {Boolean} true if the object has been selected
   */ setActiveObject(object, e) {
        // we can't inline this, since _setActiveObject will change what getActiveObjects returns
        const currentActives = this.getActiveObjects();
        const selected = this._setActiveObject(object, e);
        this._fireSelectionEvents(currentActives, e);
        return selected;
    }
    /**
   * This is supposed to be equivalent to setActiveObject but without firing
   * any event. There is commitment to have this stay this way.
   * This is the functional part of setActiveObject.
   * @param {Object} object to set as active
   * @param {Event} [e] Event (passed along when firing "object:selected")
   * @return {Boolean} true if the object has been selected
   */ _setActiveObject(object, e) {
        const prevActiveObject = this._activeObject;
        if (prevActiveObject === object) return false;
        // after calling this._discardActiveObject, this,_activeObject could be undefined
        if (!this._discardActiveObject(e, object) && this._activeObject) // refused to deselect
        return false;
        if (object.onSelect({
            e: e
        })) return false;
        this._activeObject = object;
        if ($f268b97836dca6b6$var$isActiveSelection(object) && prevActiveObject !== object) object.set('canvas', this);
        object.setCoords();
        return true;
    }
    /**
   * This is supposed to be equivalent to discardActiveObject but without firing
   * any selection events ( can still fire object transformation events ). There is commitment to have this stay this way.
   * This is the functional part of discardActiveObject.
   * @param {Event} [e] Event (passed along when firing "object:deselected")
   * @param {Object} object the next object to set as active, reason why we are discarding this
   * @return {Boolean} true if the active object has been discarded
   */ _discardActiveObject(e, object) {
        const obj = this._activeObject;
        if (obj) {
            // onDeselect return TRUE to cancel selection;
            if (obj.onDeselect({
                e: e,
                object: object
            })) return false;
            if (this._currentTransform && this._currentTransform.target === obj) this.endCurrentTransform(e);
            if ($f268b97836dca6b6$var$isActiveSelection(obj) && obj === this._hoveredTarget) this._hoveredTarget = undefined;
            this._activeObject = undefined;
            return true;
        }
        return false;
    }
    /**
   * Discards currently active object and fire events. If the function is called by fabric
   * as a consequence of a mouse event, the event is passed as a parameter and
   * sent to the fire function for the custom events. When used as a method the
   * e param does not have any application.
   * @param {event} e
   * @return {Boolean} true if the active object has been discarded
   */ discardActiveObject(e) {
        const currentActives = this.getActiveObjects(), activeObject = this.getActiveObject();
        if (currentActives.length) this.fire('before:selection:cleared', {
            e: e,
            deselected: [
                activeObject
            ]
        });
        const discarded = this._discardActiveObject(e);
        this._fireSelectionEvents(currentActives, e);
        return discarded;
    }
    /**
   * End the current transform.
   * You don't usually need to call this method unless you are interrupting a user initiated transform
   * because of some other event ( a press of key combination, or something that block the user UX )
   * @param {Event} [e] send the mouse event that generate the finalize down, so it can be used in the event
   */ endCurrentTransform(e) {
        const transform = this._currentTransform;
        this._finalizeCurrentTransform(e);
        if (transform && transform.target) // this could probably go inside _finalizeCurrentTransform
        transform.target.isMoving = false;
        this._currentTransform = null;
    }
    /**
   * @private
   * @param {Event} e send the mouse event that generate the finalize down, so it can be used in the event
   */ _finalizeCurrentTransform(e) {
        const transform = this._currentTransform, target = transform.target, options = {
            e: e,
            target: target,
            transform: transform,
            action: transform.action
        };
        if (target._scaling) target._scaling = false;
        target.setCoords();
        if (transform.actionPerformed) {
            this.fire('object:modified', options);
            target.fire($f268b97836dca6b6$var$MODIFIED, options);
        }
    }
    /**
   * Sets viewport transformation of this canvas instance
   * @param {Array} vpt a Canvas 2D API transform matrix
   */ setViewportTransform(vpt) {
        super.setViewportTransform(vpt);
        const activeObject = this._activeObject;
        if (activeObject) activeObject.setCoords();
    }
    /**
   * @override clears active selection ref and interactive canvas elements and contexts
   */ destroy() {
        // dispose of active selection
        const activeObject = this._activeObject;
        if ($f268b97836dca6b6$var$isActiveSelection(activeObject)) {
            activeObject.removeAll();
            activeObject.dispose();
        }
        delete this._activeObject;
        super.destroy();
        // free resources
        // pixel find canvas
        // @ts-expect-error disposing
        this.pixelFindContext = null;
        // @ts-expect-error disposing
        this.pixelFindCanvasEl = undefined;
    }
    /**
   * Clears all contexts (background, main, top) of an instance
   */ clear() {
        // discard active object and fire events
        this.discardActiveObject();
        // make sure we clear the active object in case it refused to be discarded
        this._activeObject = undefined;
        this.clearContext(this.contextTop);
        super.clear();
    }
    /**
   * Draws objects' controls (borders/controls)
   * @param {CanvasRenderingContext2D} ctx Context to render controls on
   */ drawControls(ctx) {
        const activeObject = this._activeObject;
        if (activeObject) activeObject._renderControls(ctx);
    }
    /**
   * @private
   */ _toObject(instance, methodName, propertiesToInclude) {
        // If the object is part of the current selection group, it should
        // be transformed appropriately
        // i.e. it should be serialised as it would appear if the selection group
        // were to be destroyed.
        const originalProperties = this._realizeGroupTransformOnObject(instance), object = super._toObject(instance, methodName, propertiesToInclude);
        //Undo the damage we did by changing all of its properties
        instance.set(originalProperties);
        return object;
    }
    /**
   * Realizes an object's group transformation on it
   * @private
   * @param {FabricObject} [instance] the object to transform (gets mutated)
   * @returns the original values of instance which were changed
   */ _realizeGroupTransformOnObject(instance) {
        const { group: group } = instance;
        if (group && $f268b97836dca6b6$var$isActiveSelection(group) && this._activeObject === group) {
            const layoutProps = [
                'angle',
                'flipX',
                'flipY',
                $f268b97836dca6b6$var$LEFT,
                $f268b97836dca6b6$var$SCALE_X,
                $f268b97836dca6b6$var$SCALE_Y,
                $f268b97836dca6b6$var$SKEW_X,
                $f268b97836dca6b6$var$SKEW_Y,
                $f268b97836dca6b6$var$TOP
            ];
            const originalValues = $f268b97836dca6b6$var$pick(instance, layoutProps);
            $f268b97836dca6b6$var$addTransformToObject(instance, group.calcOwnMatrix());
            return originalValues;
        } else return {};
    }
    /**
   * @private
   */ _setSVGObject(markup, instance, reviver) {
        // If the object is in a selection group, simulate what would happen to that
        // object when the group is deselected
        const originalProperties = this._realizeGroupTransformOnObject(instance);
        super._setSVGObject(markup, instance, reviver);
        instance.set(originalProperties);
    }
    constructor(){
        super(...arguments);
        // transform config
        // selection config
        // cursors
        // target find config
        /**
     * When true, mouse events on canvas (mousedown/mousemove/mouseup) result in free drawing.
     * After mousedown, mousemove creates a shape,
     * and then mouseup finalizes it and adds an instance of `fabric.Path` onto canvas.
     * @tutorial {@link http://fabricjs.com/fabric-intro-part-4#free_drawing}
     * @type Boolean
     * @default
     */ // event config
        /**
     * Keep track of the subTargets for Mouse Events, ordered bottom up from innermost nested subTarget
     * @type FabricObject[]
     */ $f268b97836dca6b6$var$_defineProperty(this, "targets", []);
        /**
     * hold the list of nested targets hovered in the previous events
     * @type FabricObject[]
     * @private
     */ $f268b97836dca6b6$var$_defineProperty(this, "_hoveredTargets", []);
        /**
     * hold a reference to a data structure that contains information
     * on the current on going transform
     * @type
     * @private
     */ $f268b97836dca6b6$var$_defineProperty(this, "_currentTransform", null);
        /**
     * hold a reference to a data structure used to track the selection
     * box on canvas drag
     * on the current on going transform
     * x, y, deltaX and deltaY are in scene plane
     * @type
     * @private
     */ $f268b97836dca6b6$var$_defineProperty(this, "_groupSelector", null);
        /**
     * internal flag used to understand if the context top requires a cleanup
     * in case this is true, the contextTop will be cleared at the next render
     * @type boolean
     * @private
     */ $f268b97836dca6b6$var$_defineProperty(this, "contextTopDirty", false);
    }
}
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$SelectableCanvas, "ownDefaults", $f268b97836dca6b6$var$canvasDefaults);
/**
 * In charge of synchronizing all interactive text instances of a canvas
 */ class $f268b97836dca6b6$var$TextEditingManager {
    exitTextEditing() {
        this.target = undefined;
        this.targets.forEach((target)=>{
            if (target.isEditing) target.exitEditing();
        });
    }
    add(target) {
        this.targets.push(target);
    }
    remove(target) {
        this.unregister(target);
        $f268b97836dca6b6$var$removeFromArray(this.targets, target);
    }
    register(target) {
        this.target = target;
    }
    unregister(target) {
        if (target === this.target) this.target = undefined;
    }
    onMouseMove(e) {
        var _this$target;
        ((_this$target = this.target) === null || _this$target === void 0 ? void 0 : _this$target.isEditing) && this.target.updateSelectionOnMouseMove(e);
    }
    clear() {
        this.targets = [];
        this.target = undefined;
    }
    dispose() {
        this.clear();
        this.__disposer();
        // @ts-expect-error disposing
        delete this.__disposer;
    }
    constructor(canvas){
        $f268b97836dca6b6$var$_defineProperty(this, "targets", []);
        $f268b97836dca6b6$var$_defineProperty(this, "__disposer", void 0);
        const cb = ()=>{
            const { hiddenTextarea: hiddenTextarea } = canvas.getActiveObject() || {};
            hiddenTextarea && hiddenTextarea.focus();
        };
        const el = canvas.upperCanvasEl;
        el.addEventListener('click', cb);
        this.__disposer = ()=>el.removeEventListener('click', cb);
    }
}
const $f268b97836dca6b6$var$_excluded$9 = [
    "target",
    "oldTarget",
    "fireCanvas",
    "e"
];
const $f268b97836dca6b6$var$addEventOptions = {
    passive: false
};
const $f268b97836dca6b6$var$getEventPoints = (canvas, e)=>{
    const viewportPoint = canvas.getViewportPoint(e);
    const scenePoint = canvas.getScenePoint(e);
    return {
        viewportPoint: viewportPoint,
        scenePoint: scenePoint,
        pointer: viewportPoint,
        absolutePointer: scenePoint
    };
};
// just to be clear, the utils are now deprecated and those are here exactly as minifier helpers
// because el.addEventListener can't me be minified while a const yes and we use it 47 times in this file.
// few bytes but why give it away.
const $f268b97836dca6b6$var$addListener = function(el) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    return el.addEventListener(...args);
};
const $f268b97836dca6b6$var$removeListener = function(el) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    return el.removeEventListener(...args);
};
const $f268b97836dca6b6$var$syntheticEventConfig = {
    mouse: {
        in: 'over',
        out: 'out',
        targetIn: 'mouseover',
        targetOut: 'mouseout',
        canvasIn: 'mouse:over',
        canvasOut: 'mouse:out'
    },
    drag: {
        in: 'enter',
        out: 'leave',
        targetIn: 'dragenter',
        targetOut: 'dragleave',
        canvasIn: 'drag:enter',
        canvasOut: 'drag:leave'
    }
};
class $f268b97836dca6b6$export$8d01c972ee8b14a9 extends $f268b97836dca6b6$var$SelectableCanvas {
    /**
   * return an event prefix pointer or mouse.
   * @private
   */ _getEventPrefix() {
        return this.enablePointerEvents ? 'pointer' : 'mouse';
    }
    addOrRemove(functor, _eventjsFunctor) {
        const canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
        functor($f268b97836dca6b6$var$getWindowFromElement(canvasElement), 'resize', this._onResize);
        functor(canvasElement, eventTypePrefix + 'down', this._onMouseDown);
        functor(canvasElement, "".concat(eventTypePrefix, "move"), this._onMouseMove, $f268b97836dca6b6$var$addEventOptions);
        functor(canvasElement, "".concat(eventTypePrefix, "out"), this._onMouseOut);
        functor(canvasElement, "".concat(eventTypePrefix, "enter"), this._onMouseEnter);
        functor(canvasElement, 'wheel', this._onMouseWheel, {
            passive: false
        });
        functor(canvasElement, 'contextmenu', this._onContextMenu);
        functor(canvasElement, 'click', this._onClick);
        // decide if to remove in fabric 7.0
        functor(canvasElement, 'dblclick', this._onClick);
        functor(canvasElement, 'dragstart', this._onDragStart);
        functor(canvasElement, 'dragend', this._onDragEnd);
        functor(canvasElement, 'dragover', this._onDragOver);
        functor(canvasElement, 'dragenter', this._onDragEnter);
        functor(canvasElement, 'dragleave', this._onDragLeave);
        functor(canvasElement, 'drop', this._onDrop);
        if (!this.enablePointerEvents) functor(canvasElement, 'touchstart', this._onTouchStart, $f268b97836dca6b6$var$addEventOptions);
    // if (typeof eventjs !== 'undefined' && eventjsFunctor in eventjs) {
    //   eventjs[eventjsFunctor](canvasElement, 'gesture', this._onGesture);
    //   eventjs[eventjsFunctor](canvasElement, 'drag', this._onDrag);
    //   eventjs[eventjsFunctor](
    //     canvasElement,
    //     'orientation',
    //     this._onOrientationChange
    //   );
    //   eventjs[eventjsFunctor](canvasElement, 'shake', this._onShake);
    //   eventjs[eventjsFunctor](canvasElement, 'longpress', this._onLongPress);
    // }
    }
    /**
   * Removes all event listeners, used when disposing the instance
   */ removeListeners() {
        this.addOrRemove($f268b97836dca6b6$var$removeListener, 'remove');
        // if you dispose on a mouseDown, before mouse up, you need to clean document to...
        const eventTypePrefix = this._getEventPrefix();
        const doc = $f268b97836dca6b6$var$getDocumentFromElement(this.upperCanvasEl);
        $f268b97836dca6b6$var$removeListener(doc, "".concat(eventTypePrefix, "up"), this._onMouseUp);
        $f268b97836dca6b6$var$removeListener(doc, 'touchend', this._onTouchEnd, $f268b97836dca6b6$var$addEventOptions);
        $f268b97836dca6b6$var$removeListener(doc, "".concat(eventTypePrefix, "move"), this._onMouseMove, $f268b97836dca6b6$var$addEventOptions);
        $f268b97836dca6b6$var$removeListener(doc, 'touchmove', this._onMouseMove, $f268b97836dca6b6$var$addEventOptions);
        clearTimeout(this._willAddMouseDown);
    }
    /**
   * @private
   * @param {Event} [e] Event object fired on wheel event
   */ _onMouseWheel(e) {
        this.__onMouseWheel(e);
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousedown
   */ _onMouseOut(e) {
        const target = this._hoveredTarget;
        const shared = $f268b97836dca6b6$var$_objectSpread2({
            e: e
        }, $f268b97836dca6b6$var$getEventPoints(this, e));
        this.fire('mouse:out', $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, shared), {}, {
            target: target
        }));
        this._hoveredTarget = undefined;
        target && target.fire('mouseout', $f268b97836dca6b6$var$_objectSpread2({}, shared));
        this._hoveredTargets.forEach((nestedTarget)=>{
            this.fire('mouse:out', $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, shared), {}, {
                target: nestedTarget
            }));
            nestedTarget && nestedTarget.fire('mouseout', $f268b97836dca6b6$var$_objectSpread2({}, shared));
        });
        this._hoveredTargets = [];
    }
    /**
   * @private
   * @param {Event} e Event object fired on mouseenter
   */ _onMouseEnter(e) {
        // This find target and consequent 'mouse:over' is used to
        // clear old instances on hovered target.
        // calling findTarget has the side effect of killing target.__corner.
        // as a short term fix we are not firing this if we are currently transforming.
        // as a long term fix we need to separate the action of finding a target with the
        // side effects we added to it.
        if (!this._currentTransform && !this.findTarget(e)) {
            this.fire('mouse:over', $f268b97836dca6b6$var$_objectSpread2({
                e: e
            }, $f268b97836dca6b6$var$getEventPoints(this, e)));
            this._hoveredTarget = undefined;
            this._hoveredTargets = [];
        }
    }
    /**
   * supports native like text dragging
   * @private
   * @param {DragEvent} e
   */ _onDragStart(e) {
        this._isClick = false;
        const activeObject = this.getActiveObject();
        if (activeObject && activeObject.onDragStart(e)) {
            this._dragSource = activeObject;
            const options = {
                e: e,
                target: activeObject
            };
            this.fire('dragstart', options);
            activeObject.fire('dragstart', options);
            $f268b97836dca6b6$var$addListener(this.upperCanvasEl, 'drag', this._onDragProgress);
            return;
        }
        $f268b97836dca6b6$var$stopEvent(e);
    }
    /**
   * First we clear top context where the effects are being rendered.
   * Then we render the effects.
   * Doing so will render the correct effect for all cases including an overlap between `source` and `target`.
   * @private
   */ _renderDragEffects(e, source, target) {
        let dirty = false;
        // clear top context
        const dropTarget = this._dropTarget;
        if (dropTarget && dropTarget !== source && dropTarget !== target) {
            dropTarget.clearContextTop();
            dirty = true;
        }
        source === null || source === void 0 || source.clearContextTop();
        target !== source && (target === null || target === void 0 || target.clearContextTop());
        // render effects
        const ctx = this.contextTop;
        ctx.save();
        ctx.transform(...this.viewportTransform);
        if (source) {
            ctx.save();
            source.transform(ctx);
            source.renderDragSourceEffect(e);
            ctx.restore();
            dirty = true;
        }
        if (target) {
            ctx.save();
            target.transform(ctx);
            target.renderDropTargetEffect(e);
            ctx.restore();
            dirty = true;
        }
        ctx.restore();
        dirty && (this.contextTopDirty = true);
    }
    /**
   * supports native like text dragging
   * https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#finishing_a_drag
   * @private
   * @param {DragEvent} e
   */ _onDragEnd(e) {
        const didDrop = !!e.dataTransfer && e.dataTransfer.dropEffect !== $f268b97836dca6b6$var$NONE, dropTarget = didDrop ? this._activeObject : undefined, options = {
            e: e,
            target: this._dragSource,
            subTargets: this.targets,
            dragSource: this._dragSource,
            didDrop: didDrop,
            dropTarget: dropTarget
        };
        $f268b97836dca6b6$var$removeListener(this.upperCanvasEl, 'drag', this._onDragProgress);
        this.fire('dragend', options);
        this._dragSource && this._dragSource.fire('dragend', options);
        delete this._dragSource;
        // we need to call mouse up synthetically because the browser won't
        this._onMouseUp(e);
    }
    /**
   * fire `drag` event on canvas and drag source
   * @private
   * @param {DragEvent} e
   */ _onDragProgress(e) {
        const options = {
            e: e,
            target: this._dragSource,
            dragSource: this._dragSource,
            dropTarget: this._draggedoverTarget
        };
        this.fire('drag', options);
        this._dragSource && this._dragSource.fire('drag', options);
    }
    /**
   * As opposed to {@link findTarget} we want the top most object to be returned w/o the active object cutting in line.
   * Override at will
   */ findDragTargets(e) {
        this.targets = [];
        const target = this._searchPossibleTargets(this._objects, this.getViewportPoint(e));
        return {
            target: target,
            targets: [
                ...this.targets
            ]
        };
    }
    /**
   * prevent default to allow drop event to be fired
   * https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#specifying_drop_targets
   * @private
   * @param {DragEvent} [e] Event object fired on Event.js shake
   */ _onDragOver(e) {
        const eventType = 'dragover';
        const { target: target, targets: targets } = this.findDragTargets(e);
        const dragSource = this._dragSource;
        const options = {
            e: e,
            target: target,
            subTargets: targets,
            dragSource: dragSource,
            canDrop: false,
            dropTarget: undefined
        };
        let dropTarget;
        //  fire on canvas
        this.fire(eventType, options);
        //  make sure we fire dragenter events before dragover
        //  if dragleave is needed, object will not fire dragover so we don't need to trouble ourselves with it
        this._fireEnterLeaveEvents(target, options);
        if (target) {
            if (target.canDrop(e)) dropTarget = target;
            target.fire(eventType, options);
        }
        //  propagate the event to subtargets
        for(let i = 0; i < targets.length; i++){
            const subTarget = targets[i];
            // accept event only if previous targets didn't (the accepting target calls `preventDefault` to inform that the event is taken)
            // TODO: verify if those should loop in inverse order then?
            // what is the order of subtargets?
            if (subTarget.canDrop(e)) dropTarget = subTarget;
            subTarget.fire(eventType, options);
        }
        //  render drag effects now that relations between source and target is clear
        this._renderDragEffects(e, dragSource, dropTarget);
        this._dropTarget = dropTarget;
    }
    /**
   * fire `dragleave` on `dragover` targets
   * @private
   * @param {Event} [e] Event object fired on Event.js shake
   */ _onDragEnter(e) {
        const { target: target, targets: targets } = this.findDragTargets(e);
        const options = {
            e: e,
            target: target,
            subTargets: targets,
            dragSource: this._dragSource
        };
        this.fire('dragenter', options);
        //  fire dragenter on targets
        this._fireEnterLeaveEvents(target, options);
    }
    /**
   * fire `dragleave` on `dragover` targets
   * @private
   * @param {Event} [e] Event object fired on Event.js shake
   */ _onDragLeave(e) {
        const options = {
            e: e,
            target: this._draggedoverTarget,
            subTargets: this.targets,
            dragSource: this._dragSource
        };
        this.fire('dragleave', options);
        //  fire dragleave on targets
        this._fireEnterLeaveEvents(undefined, options);
        this._renderDragEffects(e, this._dragSource);
        this._dropTarget = undefined;
        //  clear targets
        this.targets = [];
        this._hoveredTargets = [];
    }
    /**
   * `drop:before` is a an event that allows you to schedule logic
   * before the `drop` event. Prefer `drop` event always, but if you need
   * to run some drop-disabling logic on an event, since there is no way
   * to handle event handlers ordering, use `drop:before`
   * @private
   * @param {Event} e
   */ _onDrop(e) {
        const { target: target, targets: targets } = this.findDragTargets(e);
        const options = this._basicEventHandler('drop:before', $f268b97836dca6b6$var$_objectSpread2({
            e: e,
            target: target,
            subTargets: targets,
            dragSource: this._dragSource
        }, $f268b97836dca6b6$var$getEventPoints(this, e)));
        //  will be set by the drop target
        options.didDrop = false;
        //  will be set by the drop target, used in case options.target refuses the drop
        options.dropTarget = undefined;
        //  fire `drop`
        this._basicEventHandler('drop', options);
        //  inform canvas of the drop
        //  we do this because canvas was unaware of what happened at the time the `drop` event was fired on it
        //  use for side effects
        this.fire('drop:after', options);
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousedown
   */ _onContextMenu(e) {
        const target = this.findTarget(e), subTargets = this.targets || [];
        const options = this._basicEventHandler('contextmenu:before', {
            e: e,
            target: target,
            subTargets: subTargets
        });
        // TODO: this line is silly because the dev can subscribe to the event and prevent it themselves
        this.stopContextMenu && $f268b97836dca6b6$var$stopEvent(e);
        this._basicEventHandler('contextmenu', options);
        return false;
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousedown
   */ _onClick(e) {
        const clicks = e.detail;
        if (clicks > 3 || clicks < 2) return;
        this._cacheTransformEventData(e);
        clicks == 2 && e.type === 'dblclick' && this._handleEvent(e, 'dblclick');
        clicks == 3 && this._handleEvent(e, 'tripleclick');
        this._resetTransformEventData();
    }
    /**
   * Return a the id of an event.
   * returns either the pointerId or the identifier or 0 for the mouse event
   * @private
   * @param {Event} evt Event object
   */ getPointerId(evt) {
        const changedTouches = evt.changedTouches;
        if (changedTouches) return changedTouches[0] && changedTouches[0].identifier;
        if (this.enablePointerEvents) return evt.pointerId;
        return -1;
    }
    /**
   * Determines if an event has the id of the event that is considered main
   * @private
   * @param {evt} event Event object
   */ _isMainEvent(evt) {
        if (evt.isPrimary === true) return true;
        if (evt.isPrimary === false) return false;
        if (evt.type === 'touchend' && evt.touches.length === 0) return true;
        if (evt.changedTouches) return evt.changedTouches[0].identifier === this.mainTouchId;
        return true;
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousedown
   */ _onTouchStart(e) {
        // we will prevent scrolling if allowTouchScrolling is not enabled and
        let shouldPreventScrolling = !this.allowTouchScrolling;
        const currentActiveObject = this._activeObject;
        if (this.mainTouchId === undefined) this.mainTouchId = this.getPointerId(e);
        this.__onMouseDown(e);
        // after executing fabric logic for mouse down let's see
        // if we didn't change target or if we are drawing
        // we want to prevent scrolling anyway
        if (this.isDrawingMode || currentActiveObject && this._target === currentActiveObject) shouldPreventScrolling = true;
        // prevent default, will block scrolling from start
        shouldPreventScrolling && e.preventDefault();
        this._resetTransformEventData();
        const canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
        const doc = $f268b97836dca6b6$var$getDocumentFromElement(canvasElement);
        $f268b97836dca6b6$var$addListener(doc, 'touchend', this._onTouchEnd, $f268b97836dca6b6$var$addEventOptions);
        // if we scroll don't register the touch move event
        shouldPreventScrolling && $f268b97836dca6b6$var$addListener(doc, 'touchmove', this._onMouseMove, $f268b97836dca6b6$var$addEventOptions);
        // Unbind mousedown to prevent double triggers from touch devices
        $f268b97836dca6b6$var$removeListener(canvasElement, "".concat(eventTypePrefix, "down"), this._onMouseDown);
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousedown
   */ _onMouseDown(e) {
        this.__onMouseDown(e);
        this._resetTransformEventData();
        const canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
        $f268b97836dca6b6$var$removeListener(canvasElement, "".concat(eventTypePrefix, "move"), this._onMouseMove, $f268b97836dca6b6$var$addEventOptions);
        const doc = $f268b97836dca6b6$var$getDocumentFromElement(canvasElement);
        $f268b97836dca6b6$var$addListener(doc, "".concat(eventTypePrefix, "up"), this._onMouseUp);
        $f268b97836dca6b6$var$addListener(doc, "".concat(eventTypePrefix, "move"), this._onMouseMove, $f268b97836dca6b6$var$addEventOptions);
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousedown
   */ _onTouchEnd(e) {
        if (e.touches.length > 0) // if there are still touches stop here
        return;
        this.__onMouseUp(e);
        this._resetTransformEventData();
        delete this.mainTouchId;
        const eventTypePrefix = this._getEventPrefix();
        const doc = $f268b97836dca6b6$var$getDocumentFromElement(this.upperCanvasEl);
        $f268b97836dca6b6$var$removeListener(doc, 'touchend', this._onTouchEnd, $f268b97836dca6b6$var$addEventOptions);
        $f268b97836dca6b6$var$removeListener(doc, 'touchmove', this._onMouseMove, $f268b97836dca6b6$var$addEventOptions);
        if (this._willAddMouseDown) clearTimeout(this._willAddMouseDown);
        this._willAddMouseDown = setTimeout(()=>{
            // Wait 400ms before rebinding mousedown to prevent double triggers
            // from touch devices
            $f268b97836dca6b6$var$addListener(this.upperCanvasEl, "".concat(eventTypePrefix, "down"), this._onMouseDown);
            this._willAddMouseDown = 0;
        }, 400);
    }
    /**
   * @private
   * @param {Event} e Event object fired on mouseup
   */ _onMouseUp(e) {
        this.__onMouseUp(e);
        this._resetTransformEventData();
        const canvasElement = this.upperCanvasEl, eventTypePrefix = this._getEventPrefix();
        if (this._isMainEvent(e)) {
            const doc = $f268b97836dca6b6$var$getDocumentFromElement(this.upperCanvasEl);
            $f268b97836dca6b6$var$removeListener(doc, "".concat(eventTypePrefix, "up"), this._onMouseUp);
            $f268b97836dca6b6$var$removeListener(doc, "".concat(eventTypePrefix, "move"), this._onMouseMove, $f268b97836dca6b6$var$addEventOptions);
            $f268b97836dca6b6$var$addListener(canvasElement, "".concat(eventTypePrefix, "move"), this._onMouseMove, $f268b97836dca6b6$var$addEventOptions);
        }
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousemove
   */ _onMouseMove(e) {
        const activeObject = this.getActiveObject();
        !this.allowTouchScrolling && (!activeObject || // a drag event sequence is started by the active object flagging itself on mousedown / mousedown:before
        // we must not prevent the event's default behavior in order for the window to start dragging
        !activeObject.shouldStartDragging(e)) && e.preventDefault && e.preventDefault();
        this.__onMouseMove(e);
    }
    /**
   * @private
   */ _onResize() {
        this.calcOffset();
        this._resetTransformEventData();
    }
    /**
   * Decides whether the canvas should be redrawn in mouseup and mousedown events.
   * @private
   * @param {Object} target
   */ _shouldRender(target) {
        const activeObject = this.getActiveObject();
        // if just one of them is available or if they are both but are different objects
        // this covers: switch of target, from target to no target, selection of target
        // multiSelection with key and mouse
        return !!activeObject !== !!target || activeObject && target && activeObject !== target;
    }
    /**
   * Method that defines the actions when mouse is released on canvas.
   * The method resets the currentTransform parameters, store the image corner
   * position in the image object and render the canvas on top.
   * @private
   * @param {Event} e Event object fired on mouseup
   */ __onMouseUp(e) {
        var _this$_activeObject;
        this._cacheTransformEventData(e);
        this._handleEvent(e, 'up:before');
        const transform = this._currentTransform;
        const isClick = this._isClick;
        const target = this._target;
        // if right/middle click just fire events and return
        // target undefined will make the _handleEvent search the target
        const { button: button } = e;
        if (button) {
            (this.fireMiddleClick && button === 1 || this.fireRightClick && button === 2) && this._handleEvent(e, 'up');
            this._resetTransformEventData();
            return;
        }
        if (this.isDrawingMode && this._isCurrentlyDrawing) {
            this._onMouseUpInDrawingMode(e);
            return;
        }
        if (!this._isMainEvent(e)) return;
        let shouldRender = false;
        if (transform) {
            this._finalizeCurrentTransform(e);
            shouldRender = transform.actionPerformed;
        }
        if (!isClick) {
            const targetWasActive = target === this._activeObject;
            this.handleSelection(e);
            if (!shouldRender) shouldRender = this._shouldRender(target) || !targetWasActive && target === this._activeObject;
        }
        let pointer, corner;
        if (target) {
            const found = target.findControl(this.getViewportPoint(e), $f268b97836dca6b6$var$isTouchEvent(e));
            const { key: key, control: control } = found || {};
            corner = key;
            if (target.selectable && target !== this._activeObject && target.activeOn === 'up') {
                this.setActiveObject(target, e);
                shouldRender = true;
            } else if (control) {
                const mouseUpHandler = control.getMouseUpHandler(e, target, control);
                if (mouseUpHandler) {
                    pointer = this.getScenePoint(e);
                    mouseUpHandler.call(control, e, transform, pointer.x, pointer.y);
                }
            }
            target.isMoving = false;
        }
        // if we are ending up a transform on a different control or a new object
        // fire the original mouse up from the corner that started the transform
        if (transform && (transform.target !== target || transform.corner !== corner)) {
            const originalControl = transform.target && transform.target.controls[transform.corner], originalMouseUpHandler = originalControl && originalControl.getMouseUpHandler(e, transform.target, originalControl);
            pointer = pointer || this.getScenePoint(e);
            originalMouseUpHandler && originalMouseUpHandler.call(originalControl, e, transform, pointer.x, pointer.y);
        }
        this._setCursorFromEvent(e, target);
        this._handleEvent(e, 'up');
        this._groupSelector = null;
        this._currentTransform = null;
        // reset the target information about which corner is selected
        target && (target.__corner = undefined);
        if (shouldRender) this.requestRenderAll();
        else if (!isClick && !((_this$_activeObject = this._activeObject) !== null && _this$_activeObject !== void 0 && _this$_activeObject.isEditing)) this.renderTop();
    }
    _basicEventHandler(eventType, options) {
        const { target: target, subTargets: subTargets = [] } = options;
        this.fire(eventType, options);
        target && target.fire(eventType, options);
        for(let i = 0; i < subTargets.length; i++)subTargets[i] !== target && subTargets[i].fire(eventType, options);
        return options;
    }
    /**
   * @private
   * Handle event firing for target and subtargets
   * @param {TPointerEvent} e event from mouse
   * @param {TPointerEventNames} eventType
   */ _handleEvent(e, eventType, extraData) {
        const target = this._target, targets = this.targets || [], options = $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({
            e: e,
            target: target,
            subTargets: targets
        }, $f268b97836dca6b6$var$getEventPoints(this, e)), {}, {
            transform: this._currentTransform
        }, eventType === 'up:before' || eventType === 'up' ? {
            isClick: this._isClick,
            currentTarget: this.findTarget(e),
            // set by the preceding `findTarget` call
            currentSubTargets: this.targets
        } : {}), eventType === 'down:before' || eventType === 'down' ? extraData : {});
        this.fire("mouse:".concat(eventType), options);
        // this may be a little be more complicated of what we want to handle
        target && target.fire("mouse".concat(eventType), options);
        for(let i = 0; i < targets.length; i++)targets[i] !== target && targets[i].fire("mouse".concat(eventType), options);
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousedown
   */ _onMouseDownInDrawingMode(e) {
        this._isCurrentlyDrawing = true;
        if (this.getActiveObject()) {
            this.discardActiveObject(e);
            this.requestRenderAll();
        }
        // TODO: this is a scene point so it should be renamed
        const pointer = this.getScenePoint(e);
        this.freeDrawingBrush && this.freeDrawingBrush.onMouseDown(pointer, {
            e: e,
            pointer: pointer
        });
        this._handleEvent(e, 'down', {
            alreadySelected: false
        });
    }
    /**
   * @private
   * @param {Event} e Event object fired on mousemove
   */ _onMouseMoveInDrawingMode(e) {
        if (this._isCurrentlyDrawing) {
            const pointer = this.getScenePoint(e);
            this.freeDrawingBrush && this.freeDrawingBrush.onMouseMove(pointer, {
                e: e,
                pointer: // this is an absolute pointer, the naming is wrong
                pointer
            });
        }
        this.setCursor(this.freeDrawingCursor);
        this._handleEvent(e, 'move');
    }
    /**
   * @private
   * @param {Event} e Event object fired on mouseup
   */ _onMouseUpInDrawingMode(e) {
        const pointer = this.getScenePoint(e);
        if (this.freeDrawingBrush) this._isCurrentlyDrawing = !!this.freeDrawingBrush.onMouseUp({
            e: e,
            pointer: // this is an absolute pointer, the naming is wrong
            pointer
        });
        else this._isCurrentlyDrawing = false;
        this._handleEvent(e, 'up');
    }
    /**
   * Method that defines the actions when mouse is clicked on canvas.
   * The method inits the currentTransform parameters and renders all the
   * canvas so the current image can be placed on the top canvas and the rest
   * in on the container one.
   * @private
   * @param {Event} e Event object fired on mousedown
   */ __onMouseDown(e) {
        this._isClick = true;
        this._cacheTransformEventData(e);
        this._handleEvent(e, 'down:before');
        let target = this._target;
        let alreadySelected = !!target && target === this._activeObject;
        // if right/middle click just fire events
        const { button: button } = e;
        if (button) {
            (this.fireMiddleClick && button === 1 || this.fireRightClick && button === 2) && this._handleEvent(e, 'down', {
                alreadySelected: alreadySelected
            });
            this._resetTransformEventData();
            return;
        }
        if (this.isDrawingMode) {
            this._onMouseDownInDrawingMode(e);
            return;
        }
        if (!this._isMainEvent(e)) return;
        // ignore if some object is being transformed at this moment
        if (this._currentTransform) return;
        let shouldRender = this._shouldRender(target);
        let grouped = false;
        if (this.handleMultiSelection(e, target)) {
            // active object might have changed while grouping
            target = this._activeObject;
            grouped = true;
            shouldRender = true;
        } else if (this._shouldClearSelection(e, target)) this.discardActiveObject(e);
        // we start a group selector rectangle if
        // selection is enabled
        // and there is no target, or the following 3 conditions are satisfied:
        // target is not selectable ( otherwise we selected it )
        // target is not editing
        // target is not already selected ( otherwise we drag )
        if (this.selection && (!target || !target.selectable && !target.isEditing && target !== this._activeObject)) {
            const p = this.getScenePoint(e);
            this._groupSelector = {
                x: p.x,
                y: p.y,
                deltaY: 0,
                deltaX: 0
            };
        }
        // check again because things could have changed
        alreadySelected = !!target && target === this._activeObject;
        if (target) {
            if (target.selectable && target.activeOn === 'down') this.setActiveObject(target, e);
            const handle = target.findControl(this.getViewportPoint(e), $f268b97836dca6b6$var$isTouchEvent(e));
            if (target === this._activeObject && (handle || !grouped)) {
                this._setupCurrentTransform(e, target, alreadySelected);
                const control = handle ? handle.control : undefined, pointer = this.getScenePoint(e), mouseDownHandler = control && control.getMouseDownHandler(e, target, control);
                mouseDownHandler && mouseDownHandler.call(control, e, this._currentTransform, pointer.x, pointer.y);
            }
        }
        //  we clear `_objectsToRender` in case of a change in order to repopulate it at rendering
        //  run before firing the `down` event to give the dev a chance to populate it themselves
        shouldRender && (this._objectsToRender = undefined);
        this._handleEvent(e, 'down', {
            alreadySelected: alreadySelected
        });
        // we must renderAll so that we update the visuals
        shouldRender && this.requestRenderAll();
    }
    /**
   * reset cache form common information needed during event processing
   * @private
   */ _resetTransformEventData() {
        this._target = this._pointer = this._absolutePointer = undefined;
    }
    /**
   * Cache common information needed during event processing
   * @private
   * @param {Event} e Event object fired on event
   */ _cacheTransformEventData(e) {
        // reset in order to avoid stale caching
        this._resetTransformEventData();
        this._pointer = this.getViewportPoint(e);
        this._absolutePointer = $f268b97836dca6b6$var$sendPointToPlane(this._pointer, undefined, this.viewportTransform);
        this._target = this._currentTransform ? this._currentTransform.target : this.findTarget(e);
    }
    /**
   * Method that defines the actions when mouse is hovering the canvas.
   * The currentTransform parameter will define whether the user is rotating/scaling/translating
   * an image or neither of them (only hovering). A group selection is also possible and would cancel
   * all any other type of action.
   * In case of an image transformation only the top canvas will be rendered.
   * @private
   * @param {Event} e Event object fired on mousemove
   */ __onMouseMove(e) {
        this._isClick = false;
        this._cacheTransformEventData(e);
        this._handleEvent(e, 'move:before');
        if (this.isDrawingMode) {
            this._onMouseMoveInDrawingMode(e);
            return;
        }
        if (!this._isMainEvent(e)) return;
        const groupSelector = this._groupSelector;
        // We initially clicked in an empty area, so we draw a box for multiple selection
        if (groupSelector) {
            const pointer = this.getScenePoint(e);
            groupSelector.deltaX = pointer.x - groupSelector.x;
            groupSelector.deltaY = pointer.y - groupSelector.y;
            this.renderTop();
        } else if (!this._currentTransform) {
            const target = this.findTarget(e);
            this._setCursorFromEvent(e, target);
            this._fireOverOutEvents(e, target);
        } else this._transformObject(e);
        this.textEditingManager.onMouseMove(e);
        this._handleEvent(e, 'move');
        this._resetTransformEventData();
    }
    /**
   * Manage the mouseout, mouseover events for the fabric object on the canvas
   * @param {Fabric.Object} target the target where the target from the mousemove event
   * @param {Event} e Event object fired on mousemove
   * @private
   */ _fireOverOutEvents(e, target) {
        const _hoveredTarget = this._hoveredTarget, _hoveredTargets = this._hoveredTargets, targets = this.targets, length = Math.max(_hoveredTargets.length, targets.length);
        this.fireSyntheticInOutEvents('mouse', {
            e: e,
            target: target,
            oldTarget: _hoveredTarget,
            fireCanvas: true
        });
        for(let i = 0; i < length; i++){
            if (targets[i] === target || _hoveredTargets[i] && _hoveredTargets[i] === _hoveredTarget) continue;
            this.fireSyntheticInOutEvents('mouse', {
                e: e,
                target: targets[i],
                oldTarget: _hoveredTargets[i]
            });
        }
        this._hoveredTarget = target;
        this._hoveredTargets = this.targets.concat();
    }
    /**
   * Manage the dragEnter, dragLeave events for the fabric objects on the canvas
   * @param {Fabric.Object} target the target where the target from the onDrag event
   * @param {Object} data Event object fired on dragover
   * @private
   */ _fireEnterLeaveEvents(target, data) {
        const draggedoverTarget = this._draggedoverTarget, _hoveredTargets = this._hoveredTargets, targets = this.targets, length = Math.max(_hoveredTargets.length, targets.length);
        this.fireSyntheticInOutEvents('drag', $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, data), {}, {
            target: target,
            oldTarget: draggedoverTarget,
            fireCanvas: true
        }));
        for(let i = 0; i < length; i++)this.fireSyntheticInOutEvents('drag', $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, data), {}, {
            target: targets[i],
            oldTarget: _hoveredTargets[i]
        }));
        this._draggedoverTarget = target;
    }
    /**
   * Manage the synthetic in/out events for the fabric objects on the canvas
   * @param {Fabric.Object} target the target where the target from the supported events
   * @param {Object} data Event object fired
   * @param {Object} config configuration for the function to work
   * @param {String} config.targetName property on the canvas where the old target is stored
   * @param {String} [config.canvasEvtOut] name of the event to fire at canvas level for out
   * @param {String} config.evtOut name of the event to fire for out
   * @param {String} [config.canvasEvtIn] name of the event to fire at canvas level for in
   * @param {String} config.evtIn name of the event to fire for in
   * @private
   */ fireSyntheticInOutEvents(type, _ref) {
        let { target: target, oldTarget: oldTarget, fireCanvas: fireCanvas, e: e } = _ref, data = $f268b97836dca6b6$var$_objectWithoutProperties(_ref, $f268b97836dca6b6$var$_excluded$9);
        const { targetIn: targetIn, targetOut: targetOut, canvasIn: canvasIn, canvasOut: canvasOut } = $f268b97836dca6b6$var$syntheticEventConfig[type];
        const targetChanged = oldTarget !== target;
        if (oldTarget && targetChanged) {
            const outOpt = $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, data), {}, {
                e: e,
                target: oldTarget,
                nextTarget: target
            }, $f268b97836dca6b6$var$getEventPoints(this, e));
            fireCanvas && this.fire(canvasOut, outOpt);
            oldTarget.fire(targetOut, outOpt);
        }
        if (target && targetChanged) {
            const inOpt = $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, data), {}, {
                e: e,
                target: target,
                previousTarget: oldTarget
            }, $f268b97836dca6b6$var$getEventPoints(this, e));
            fireCanvas && this.fire(canvasIn, inOpt);
            target.fire(targetIn, inOpt);
        }
    }
    /**
   * Method that defines actions when an Event Mouse Wheel
   * @param {Event} e Event object fired on mouseup
   */ __onMouseWheel(e) {
        this._cacheTransformEventData(e);
        this._handleEvent(e, 'wheel');
        this._resetTransformEventData();
    }
    /**
   * @private
   * @param {Event} e Event fired on mousemove
   */ _transformObject(e) {
        const scenePoint = this.getScenePoint(e), transform = this._currentTransform, target = transform.target, //  transform pointer to target's containing coordinate plane
        //  both pointer and object should agree on every point
        localPointer = target.group ? $f268b97836dca6b6$var$sendPointToPlane(scenePoint, undefined, target.group.calcTransformMatrix()) : scenePoint;
        transform.shiftKey = e.shiftKey;
        transform.altKey = !!this.centeredKey && e[this.centeredKey];
        this._performTransformAction(e, transform, localPointer);
        transform.actionPerformed && this.requestRenderAll();
    }
    /**
   * @private
   */ _performTransformAction(e, transform, pointer) {
        const { action: action, actionHandler: actionHandler, target: target } = transform;
        const actionPerformed = !!actionHandler && actionHandler(e, transform, pointer.x, pointer.y);
        actionPerformed && target.setCoords();
        // this object could be created from the function in the control handlers
        if (action === 'drag' && actionPerformed) {
            transform.target.isMoving = true;
            this.setCursor(transform.target.moveCursor || this.moveCursor);
        }
        transform.actionPerformed = transform.actionPerformed || actionPerformed;
    }
    /**
   * Sets the cursor depending on where the canvas is being hovered.
   * Note: very buggy in Opera
   * @param {Event} e Event object
   * @param {Object} target Object that the mouse is hovering, if so.
   */ _setCursorFromEvent(e, target) {
        if (!target) {
            this.setCursor(this.defaultCursor);
            return;
        }
        let hoverCursor = target.hoverCursor || this.hoverCursor;
        const activeSelection = $f268b97836dca6b6$var$isActiveSelection(this._activeObject) ? this._activeObject : null, // only show proper corner when group selection is not active
        corner = (!activeSelection || target.group !== activeSelection) && // here we call findTargetCorner always with undefined for the touch parameter.
        // we assume that if you are using a cursor you do not need to interact with
        // the bigger touch area.
        target.findControl(this.getViewportPoint(e));
        if (!corner) {
            if (target.subTargetCheck) // hoverCursor should come from top-most subTarget,
            // so we walk the array backwards
            this.targets.concat().reverse().map((_target)=>{
                hoverCursor = _target.hoverCursor || hoverCursor;
            });
            this.setCursor(hoverCursor);
        } else {
            const control = corner.control;
            this.setCursor(control.cursorStyleHandler(e, control, target));
        }
    }
    /**
   * ## Handles multiple selection
   * - toggles `target` selection (selects/deselects `target` if it isn't/is selected respectively)
   * - sets the active object in case it is not set or in case there is a single active object left under active selection.
   * ---
   * - If the active object is the active selection we add/remove `target` from it
   * - If not, add the active object and `target` to the active selection and make it the active object.
   * @private
   * @param {TPointerEvent} e Event object
   * @param {FabricObject} target target of event to select/deselect
   * @returns true if grouping occurred
   */ handleMultiSelection(e, target) {
        const activeObject = this._activeObject;
        const isAS = $f268b97836dca6b6$var$isActiveSelection(activeObject);
        if (// check if an active object exists on canvas and if the user is pressing the `selectionKey` while canvas supports multi selection.
        !!activeObject && this._isSelectionKeyPressed(e) && this.selection && // on top of that the user also has to hit a target that is selectable.
        !!target && target.selectable && // group target and active object only if they are different objects
        // else we try to find a subtarget of `ActiveSelection`
        (activeObject !== target || isAS) && //  make sure `activeObject` and `target` aren't ancestors of each other in case `activeObject` is not `ActiveSelection`
        // if it is then we want to remove `target` from it
        (isAS || !target.isDescendantOf(activeObject) && !activeObject.isDescendantOf(target)) && //  target accepts selection
        !target.onSelect({
            e: e
        }) && // make sure we are not on top of a control
        !activeObject.getActiveControl()) {
            if (isAS) {
                const prevActiveObjects = activeObject.getObjects();
                if (target === activeObject) {
                    const pointer = this.getViewportPoint(e);
                    target = // first search active objects for a target to remove
                    this.searchPossibleTargets(prevActiveObjects, pointer) || //  if not found, search under active selection for a target to add
                    // `prevActiveObjects` will be searched but we already know they will not be found
                    this.searchPossibleTargets(this._objects, pointer);
                    // if nothing is found bail out
                    if (!target || !target.selectable) return false;
                }
                if (target.group === activeObject) {
                    // `target` is part of active selection => remove it
                    activeObject.remove(target);
                    this._hoveredTarget = target;
                    this._hoveredTargets = [
                        ...this.targets
                    ];
                    // if after removing an object we are left with one only...
                    if (activeObject.size() === 1) // activate last remaining object
                    // deselecting the active selection will remove the remaining object from it
                    this._setActiveObject(activeObject.item(0), e);
                } else {
                    // `target` isn't part of active selection => add it
                    activeObject.multiSelectAdd(target);
                    this._hoveredTarget = activeObject;
                    this._hoveredTargets = [
                        ...this.targets
                    ];
                }
                this._fireSelectionEvents(prevActiveObjects, e);
            } else {
                activeObject.isEditing && activeObject.exitEditing();
                // add the active object and the target to the active selection and set it as the active object
                const klass = $f268b97836dca6b6$export$2792378e23a7920c.getClass('ActiveSelection');
                const newActiveSelection = new klass([], {
                    /**
           * it is crucial to pass the canvas ref before calling {@link ActiveSelection#multiSelectAdd}
           * since it uses {@link FabricObject#isInFrontOf} which relies on the canvas ref
           */ canvas: this
                });
                newActiveSelection.multiSelectAdd(activeObject, target);
                this._hoveredTarget = newActiveSelection;
                // ISSUE 4115: should we consider subTargets here?
                // this._hoveredTargets = [];
                // this._hoveredTargets = this.targets.concat();
                this._setActiveObject(newActiveSelection, e);
                this._fireSelectionEvents([
                    activeObject
                ], e);
            }
            return true;
        }
        return false;
    }
    /**
   * ## Handles selection
   * - selects objects that are contained in (and possibly intersecting) the selection bounding box
   * - sets the active object
   * ---
   * runs on mouse up after a mouse move
   */ handleSelection(e) {
        if (!this.selection || !this._groupSelector) return false;
        const { x: x, y: y, deltaX: deltaX, deltaY: deltaY } = this._groupSelector, point1 = new $f268b97836dca6b6$export$baf26146a414f24a(x, y), point2 = point1.add(new $f268b97836dca6b6$export$baf26146a414f24a(deltaX, deltaY)), tl = point1.min(point2), br = point1.max(point2), size = br.subtract(tl);
        const collectedObjects = this.collectObjects({
            left: tl.x,
            top: tl.y,
            width: size.x,
            height: size.y
        }, {
            includeIntersecting: !this.selectionFullyContained
        });
        const objects = // though this method runs only after mouse move the pointer could do a mouse up on the same position as mouse down
        // should it be handled as is?
        point1.eq(point2) ? collectedObjects[0] ? [
            collectedObjects[0]
        ] : [] : collectedObjects.length > 1 ? collectedObjects.filter((object)=>!object.onSelect({
                e: e
            })).reverse() : // `setActiveObject` will call `onSelect(collectedObjects[0])` in this case
        collectedObjects;
        // set active object
        if (objects.length === 1) // set as active object
        this.setActiveObject(objects[0], e);
        else if (objects.length > 1) {
            // add to active selection and make it the active object
            const klass = $f268b97836dca6b6$export$2792378e23a7920c.getClass('ActiveSelection');
            this.setActiveObject(new klass(objects, {
                canvas: this
            }), e);
        }
        // cleanup
        this._groupSelector = null;
        return true;
    }
    /**
   * Wraps the original toCanvasElement with a function that removes
   * the context top for the time the function is run.
   * So we avoid painting side effects on the upper canvas when exporting
   */ toCanvasElement() {
        let multiplier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        let options = arguments.length > 1 ? arguments[1] : undefined;
        const { upper: upper } = this.elements;
        upper.ctx = undefined;
        const htmlElement = super.toCanvasElement(multiplier, options);
        upper.ctx = upper.el.getContext('2d');
        return htmlElement;
    }
    /**
   * @override clear {@link textEditingManager}
   */ clear() {
        this.textEditingManager.clear();
        super.clear();
    }
    /**
   * @override clear {@link textEditingManager}
   */ destroy() {
        this.removeListeners();
        this.textEditingManager.dispose();
        super.destroy();
    }
    constructor(el){
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super(el, options);
        // bind event handlers
        /**
     * Contains the id of the touch event that owns the fabric transform
     * @type Number
     * @private
     */ /**
     * Holds a reference to a setTimeout timer for event synchronization
     * @type number
     * @private
     */ /**
     * Holds a reference to an object on the canvas that is receiving the drag over event.
     * @type FabricObject
     * @private
     */ /**
     * Holds a reference to an object on the canvas from where the drag operation started
     * @type FabricObject
     * @private
     */ /**
     * Holds a reference to an object on the canvas that is the current drop target
     * May differ from {@link _draggedoverTarget}
     * @todo inspect whether {@link _draggedoverTarget} and {@link _dropTarget} should be merged somehow
     * @type FabricObject
     * @private
     */ /**
     * a boolean that keeps track of the click state during a cycle of mouse down/up.
     * If a mouse move occurs it becomes false.
     * Is true by default, turns false on mouse move.
     * Used to determine if a mouseUp is a click
     */ $f268b97836dca6b6$var$_defineProperty(this, "_isClick", void 0);
        $f268b97836dca6b6$var$_defineProperty(this, "textEditingManager", new $f268b97836dca6b6$var$TextEditingManager(this));
        [
            '_onMouseDown',
            '_onTouchStart',
            '_onMouseMove',
            '_onMouseUp',
            '_onTouchEnd',
            '_onResize',
            // '_onGesture',
            // '_onDrag',
            // '_onShake',
            // '_onLongPress',
            // '_onOrientationChange',
            '_onMouseWheel',
            '_onMouseOut',
            '_onMouseEnter',
            '_onContextMenu',
            '_onClick',
            '_onDragStart',
            '_onDragEnd',
            '_onDragProgress',
            '_onDragOver',
            '_onDragEnter',
            '_onDragLeave',
            '_onDrop'
        ].forEach((eventHandler)=>{
            // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
            this[eventHandler] = this[eventHandler].bind(this);
        });
        // register event handlers
        this.addOrRemove($f268b97836dca6b6$var$addListener, 'add');
    }
}
const $f268b97836dca6b6$var$linearDefaultCoords = {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0
};
const $f268b97836dca6b6$var$radialDefaultCoords = $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, $f268b97836dca6b6$var$linearDefaultCoords), {}, {
    r1: 0,
    r2: 0
});
/**
 *
 * @param value value to check if NaN
 * @param [valueIfNaN]
 * @returns `fallback` is `value is NaN
 */ const $f268b97836dca6b6$var$ifNaN = (value, valueIfNaN)=>{
    return isNaN(value) && typeof valueIfNaN === 'number' ? valueIfNaN : value;
};
/**
 * Will loosely accept as percent numbers that are not like
 * 3.4a%. This function does not check for the correctness of a percentage
 * but it checks that values that are in theory correct are or arent percentages
 */ function $f268b97836dca6b6$var$isPercent(value) {
    // /%$/ Matches strings that end with a percent sign (%)
    return value && /%$/.test(value) && Number.isFinite(parseFloat(value));
}
/**
 * Parse a percentage value in an svg.
 * @param value
 * @param fallback in case of not possible to parse the number
 * @returns ∈ [0, 1]
 */ function $f268b97836dca6b6$var$parsePercent(value, valueIfNaN) {
    const parsed = typeof value === 'number' ? value : typeof value === 'string' ? parseFloat(value) / ($f268b97836dca6b6$var$isPercent(value) ? 100 : 1) : NaN;
    return $f268b97836dca6b6$var$capValue(0, $f268b97836dca6b6$var$ifNaN(parsed, valueIfNaN), 1);
}
const $f268b97836dca6b6$var$RE_KEY_VALUE_PAIRS = /\s*;\s*/;
const $f268b97836dca6b6$var$RE_KEY_VALUE = /\s*:\s*/;
function $f268b97836dca6b6$var$parseColorStop(el, multiplier) {
    let colorValue, opacity;
    const style = el.getAttribute('style');
    if (style) {
        const keyValuePairs = style.split($f268b97836dca6b6$var$RE_KEY_VALUE_PAIRS);
        if (keyValuePairs[keyValuePairs.length - 1] === '') keyValuePairs.pop();
        for(let i = keyValuePairs.length; i--;){
            const [key, value] = keyValuePairs[i].split($f268b97836dca6b6$var$RE_KEY_VALUE).map((s)=>s.trim());
            if (key === 'stop-color') colorValue = value;
            else if (key === 'stop-opacity') opacity = value;
        }
    }
    const color = new $f268b97836dca6b6$export$892596cec99bc70e(colorValue || el.getAttribute('stop-color') || 'rgb(0,0,0)');
    return {
        offset: $f268b97836dca6b6$var$parsePercent(el.getAttribute('offset'), 0),
        color: color.toRgb(),
        opacity: $f268b97836dca6b6$var$ifNaN(parseFloat(opacity || el.getAttribute('stop-opacity') || ''), 1) * color.getAlpha() * multiplier
    };
}
function $f268b97836dca6b6$var$parseColorStops(el, opacityAttr) {
    const colorStops = [], colorStopEls = el.getElementsByTagName('stop'), multiplier = $f268b97836dca6b6$var$parsePercent(opacityAttr, 1);
    for(let i = colorStopEls.length; i--;)colorStops.push($f268b97836dca6b6$var$parseColorStop(colorStopEls[i], multiplier));
    return colorStops;
}
function $f268b97836dca6b6$var$parseType(el) {
    return el.nodeName === 'linearGradient' || el.nodeName === 'LINEARGRADIENT' ? 'linear' : 'radial';
}
function $f268b97836dca6b6$var$parseGradientUnits(el) {
    return el.getAttribute('gradientUnits') === 'userSpaceOnUse' ? 'pixels' : 'percentage';
}
function $f268b97836dca6b6$var$convertPercentUnitsToValues(valuesToConvert, _ref) {
    let { width: width, height: height, gradientUnits: gradientUnits } = _ref;
    let finalValue;
    return Object.entries(valuesToConvert).reduce((acc, _ref2)=>{
        let [prop, propValue] = _ref2;
        if (propValue === 'Infinity') finalValue = 1;
        else if (propValue === '-Infinity') finalValue = 0;
        else {
            const isString = typeof propValue === 'string';
            finalValue = isString ? parseFloat(propValue) : propValue;
            if (isString && $f268b97836dca6b6$var$isPercent(propValue)) {
                finalValue *= 0.01;
                if (gradientUnits === 'pixels') {
                    // then we need to fix those percentages here in svg parsing
                    if (prop === 'x1' || prop === 'x2' || prop === 'r2') finalValue *= width;
                    if (prop === 'y1' || prop === 'y2') finalValue *= height;
                }
            }
        }
        acc[prop] = finalValue;
        return acc;
    }, {});
}
function $f268b97836dca6b6$var$getValue(el, key) {
    return el.getAttribute(key);
}
function $f268b97836dca6b6$var$parseLinearCoords(el) {
    return {
        x1: $f268b97836dca6b6$var$getValue(el, 'x1') || 0,
        y1: $f268b97836dca6b6$var$getValue(el, 'y1') || 0,
        x2: $f268b97836dca6b6$var$getValue(el, 'x2') || '100%',
        y2: $f268b97836dca6b6$var$getValue(el, 'y2') || 0
    };
}
function $f268b97836dca6b6$var$parseRadialCoords(el) {
    return {
        x1: $f268b97836dca6b6$var$getValue(el, 'fx') || $f268b97836dca6b6$var$getValue(el, 'cx') || '50%',
        y1: $f268b97836dca6b6$var$getValue(el, 'fy') || $f268b97836dca6b6$var$getValue(el, 'cy') || '50%',
        r1: 0,
        x2: $f268b97836dca6b6$var$getValue(el, 'cx') || '50%',
        y2: $f268b97836dca6b6$var$getValue(el, 'cy') || '50%',
        r2: $f268b97836dca6b6$var$getValue(el, 'r') || '50%'
    };
}
function $f268b97836dca6b6$var$parseCoords(el, size) {
    return $f268b97836dca6b6$var$convertPercentUnitsToValues($f268b97836dca6b6$var$parseType(el) === 'linear' ? $f268b97836dca6b6$var$parseLinearCoords(el) : $f268b97836dca6b6$var$parseRadialCoords(el), $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, size), {}, {
        gradientUnits: $f268b97836dca6b6$var$parseGradientUnits(el)
    }));
}
/**
 * Gradient class
 * @class Gradient
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#gradients}
 */ class $f268b97836dca6b6$export$3d3dd8f63ff0f876 {
    /**
   * Adds another colorStop
   * @param {Record<string, string>} colorStop Object with offset and color
   * @return {Gradient} thisArg
   */ addColorStop(colorStops) {
        for(const position in colorStops){
            const color = new $f268b97836dca6b6$export$892596cec99bc70e(colorStops[position]);
            this.colorStops.push({
                offset: parseFloat(position),
                color: color.toRgb(),
                opacity: color.getAlpha()
            });
        }
        return this;
    }
    /**
   * Returns object representation of a gradient
   * @param {string[]} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {object}
   */ toObject(propertiesToInclude) {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, $f268b97836dca6b6$var$pick(this, propertiesToInclude)), {}, {
            type: this.type,
            coords: $f268b97836dca6b6$var$_objectSpread2({}, this.coords),
            colorStops: this.colorStops.map((colorStop)=>$f268b97836dca6b6$var$_objectSpread2({}, colorStop)),
            offsetX: this.offsetX,
            offsetY: this.offsetY,
            gradientUnits: this.gradientUnits,
            gradientTransform: this.gradientTransform ? [
                ...this.gradientTransform
            ] : undefined
        });
    }
    /* _TO_SVG_START_ */ /**
   * Returns SVG representation of an gradient
   * @param {FabricObject} object Object to create a gradient for
   * @return {String} SVG representation of an gradient (linear/radial)
   */ toSVG(object) {
        let { additionalTransform: preTransform } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        const markup = [], transform = this.gradientTransform ? this.gradientTransform.concat() : $f268b97836dca6b6$export$3c5a7f9475b116e0.concat(), gradientUnits = this.gradientUnits === 'pixels' ? 'userSpaceOnUse' : 'objectBoundingBox';
        // colorStops must be sorted ascending, and guarded against deep mutations
        const colorStops = this.colorStops.map((colorStop)=>$f268b97836dca6b6$var$_objectSpread2({}, colorStop)).sort((a, b)=>{
            return a.offset - b.offset;
        });
        let offsetX = -this.offsetX, offsetY = -this.offsetY;
        if (gradientUnits === 'objectBoundingBox') {
            offsetX /= object.width;
            offsetY /= object.height;
        } else {
            offsetX += object.width / 2;
            offsetY += object.height / 2;
        }
        // todo what about polygon/polyline?
        if ($f268b97836dca6b6$var$isPath(object) && this.gradientUnits !== 'percentage') {
            offsetX -= object.pathOffset.x;
            offsetY -= object.pathOffset.y;
        }
        transform[4] -= offsetX;
        transform[5] -= offsetY;
        const commonAttributes = [
            "id=\"SVGID_".concat(this.id, "\""),
            "gradientUnits=\"".concat(gradientUnits, "\""),
            "gradientTransform=\"".concat(preTransform ? preTransform + ' ' : '').concat($f268b97836dca6b6$var$matrixToSVG(transform), "\""),
            ''
        ].join(' ');
        if (this.type === 'linear') {
            const { x1: x1, y1: y1, x2: x2, y2: y2 } = this.coords;
            markup.push('<linearGradient ', commonAttributes, ' x1="', x1, '" y1="', y1, '" x2="', x2, '" y2="', y2, '">\n');
        } else if (this.type === 'radial') {
            const { x1: x1, y1: y1, x2: x2, y2: y2, r1: r1, r2: r2 } = this.coords;
            const needsSwap = r1 > r2;
            // svg radial gradient has just 1 radius. the biggest.
            markup.push('<radialGradient ', commonAttributes, ' cx="', needsSwap ? x1 : x2, '" cy="', needsSwap ? y1 : y2, '" r="', needsSwap ? r1 : r2, '" fx="', needsSwap ? x2 : x1, '" fy="', needsSwap ? y2 : y1, '">\n');
            if (needsSwap) {
                // svg goes from internal to external radius. if radius are inverted, swap color stops.
                colorStops.reverse(); //  mutates array
                colorStops.forEach((colorStop)=>{
                    colorStop.offset = 1 - colorStop.offset;
                });
            }
            const minRadius = Math.min(r1, r2);
            if (minRadius > 0) {
                // i have to shift all colorStops and add new one in 0.
                const maxRadius = Math.max(r1, r2), percentageShift = minRadius / maxRadius;
                colorStops.forEach((colorStop)=>{
                    colorStop.offset += percentageShift * (1 - colorStop.offset);
                });
            }
        }
        colorStops.forEach((_ref)=>{
            let { color: color, offset: offset, opacity: opacity } = _ref;
            markup.push('<stop ', 'offset="', offset * 100 + '%', '" style="stop-color:', color, typeof opacity !== 'undefined' ? ';stop-opacity: ' + opacity : ';', '"/>\n');
        });
        markup.push(this.type === 'linear' ? '</linearGradient>' : '</radialGradient>', '\n');
        return markup.join('');
    }
    /* _TO_SVG_END_ */ /**
   * Returns an instance of CanvasGradient
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @return {CanvasGradient}
   */ toLive(ctx) {
        const { x1: x1, y1: y1, x2: x2, y2: y2, r1: r1, r2: r2 } = this.coords;
        const gradient = this.type === 'linear' ? ctx.createLinearGradient(x1, y1, x2, y2) : ctx.createRadialGradient(x1, y1, r1, x2, y2, r2);
        this.colorStops.forEach((_ref2)=>{
            let { color: color, opacity: opacity, offset: offset } = _ref2;
            gradient.addColorStop(offset, typeof opacity !== 'undefined' ? new $f268b97836dca6b6$export$892596cec99bc70e(color).setAlpha(opacity).toRgba() : color);
        });
        return gradient;
    }
    static async fromObject(options) {
        const { colorStops: colorStops, gradientTransform: gradientTransform } = options;
        return new this($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, options), {}, {
            colorStops: colorStops ? colorStops.map((colorStop)=>$f268b97836dca6b6$var$_objectSpread2({}, colorStop)) : undefined,
            gradientTransform: gradientTransform ? [
                ...gradientTransform
            ] : undefined
        }));
    }
    /* _FROM_SVG_START_ */ /**
   * Returns {@link Gradient} instance from an SVG element
   * @static
   * @memberOf Gradient
   * @param {SVGGradientElement} el SVG gradient element
   * @param {FabricObject} instance
   * @param {String} opacity A fill-opacity or stroke-opacity attribute to multiply to each stop's opacity.
   * @param {SVGOptions} svgOptions an object containing the size of the SVG in order to parse correctly gradients
   * that uses gradientUnits as 'userSpaceOnUse' and percentages.
   * @return {Gradient} Gradient instance
   * @see http://www.w3.org/TR/SVG/pservers.html#LinearGradientElement
   * @see http://www.w3.org/TR/SVG/pservers.html#RadialGradientElement
   *
   *  @example
   *
   *  <linearGradient id="linearGrad1">
   *    <stop offset="0%" stop-color="white"/>
   *    <stop offset="100%" stop-color="black"/>
   *  </linearGradient>
   *
   *  OR
   *
   *  <linearGradient id="linearGrad2">
   *    <stop offset="0" style="stop-color:rgb(255,255,255)"/>
   *    <stop offset="1" style="stop-color:rgb(0,0,0)"/>
   *  </linearGradient>
   *
   *  OR
   *
   *  <radialGradient id="radialGrad1">
   *    <stop offset="0%" stop-color="white" stop-opacity="1" />
   *    <stop offset="50%" stop-color="black" stop-opacity="0.5" />
   *    <stop offset="100%" stop-color="white" stop-opacity="1" />
   *  </radialGradient>
   *
   *  OR
   *
   *  <radialGradient id="radialGrad2">
   *    <stop offset="0" stop-color="rgb(255,255,255)" />
   *    <stop offset="0.5" stop-color="rgb(0,0,0)" />
   *    <stop offset="1" stop-color="rgb(255,255,255)" />
   *  </radialGradient>
   *
   */ static fromElement(el, instance, svgOptions) {
        const gradientUnits = $f268b97836dca6b6$var$parseGradientUnits(el);
        const center = instance._findCenterFromElement();
        return new this($f268b97836dca6b6$var$_objectSpread2({
            id: el.getAttribute('id') || undefined,
            type: $f268b97836dca6b6$var$parseType(el),
            coords: $f268b97836dca6b6$var$parseCoords(el, {
                width: svgOptions.viewBoxWidth || svgOptions.width,
                height: svgOptions.viewBoxHeight || svgOptions.height
            }),
            colorStops: $f268b97836dca6b6$var$parseColorStops(el, svgOptions.opacity),
            gradientUnits: gradientUnits,
            gradientTransform: $f268b97836dca6b6$export$6655c0d22b13de1f(el.getAttribute('gradientTransform') || '')
        }, gradientUnits === 'pixels' ? {
            offsetX: instance.width / 2 - center.x,
            offsetY: instance.height / 2 - center.y
        } : {
            offsetX: 0,
            offsetY: 0
        }));
    }
    constructor(options){
        const { type: type = 'linear', gradientUnits: gradientUnits = 'pixels', coords: coords = {}, colorStops: colorStops = [], offsetX: offsetX = 0, offsetY: offsetY = 0, gradientTransform: gradientTransform, id: id } = options || {};
        Object.assign(this, {
            type: type,
            gradientUnits: gradientUnits,
            coords: $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, type === 'radial' ? $f268b97836dca6b6$var$radialDefaultCoords : $f268b97836dca6b6$var$linearDefaultCoords), coords),
            colorStops: colorStops,
            offsetX: offsetX,
            offsetY: offsetY,
            gradientTransform: gradientTransform,
            id: id ? "".concat(id, "_").concat($f268b97836dca6b6$var$uid()) : $f268b97836dca6b6$var$uid()
        });
    }
}
/**
 * Horizontal offset for aligning gradients coming from SVG when outside pathgroups
 * @type Number
 * @default 0
 */ /**
 * Vertical offset for aligning gradients coming from SVG when outside pathgroups
 * @type Number
 * @default 0
 */ /**
 * A transform matrix to apply to the gradient before painting.
 * Imported from svg gradients, is not applied with the current transform in the center.
 * Before this transform is applied, the origin point is at the top left corner of the object
 * plus the addition of offsetY and offsetX.
 * @type Number[]
 * @default null
 */ /**
 * coordinates units for coords.
 * If `pixels`, the number of coords are in the same unit of width / height.
 * If set as `percentage` the coords are still a number, but 1 means 100% of width
 * for the X and 100% of the height for the y. It can be bigger than 1 and negative.
 * allowed values pixels or percentage.
 * @type GradientUnits
 * @default 'pixels'
 */ /**
 * Gradient type linear or radial
 * @type GradientType
 * @default 'linear'
 */ /**
 * Defines how the gradient is located in space and spread
 * @type GradientCoords
 */ /**
 * Defines how many colors a gradient has and how they are located on the axis
 * defined by coords
 * @type GradientCoords
 */ /**
 * If true, this object will not be exported during the serialization of a canvas
 * @type boolean
 */ /**
 * ID used for SVG export functionalities
 * @type number | string
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$3d3dd8f63ff0f876, "type", 'Gradient');
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$3d3dd8f63ff0f876, 'gradient');
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$3d3dd8f63ff0f876, 'linear');
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$3d3dd8f63ff0f876, 'radial');
const $f268b97836dca6b6$var$_excluded$8 = [
    "type",
    "source",
    "patternTransform"
];
/**
 * @see {@link http://fabricjs.com/patterns demo}
 * @see {@link http://fabricjs.com/dynamic-patterns demo}
 */ class $f268b97836dca6b6$export$47606a6ae3eaed8e {
    /**
   * Legacy identifier of the class. Prefer using this.constructor.type 'Pattern'
   * or utils like isPattern, or instance of to indentify a pattern in your code.
   * Will be removed in future versiones
   * @TODO add sustainable warning message
   * @type string
   * @deprecated
   */ get type() {
        return 'pattern';
    }
    set type(value) {
        $f268b97836dca6b6$var$log('warn', 'Setting type has no effect', value);
    }
    /**
   * @returns true if {@link source} is an <img> element
   */ isImageSource() {
        return !!this.source && typeof this.source.src === 'string';
    }
    /**
   * @returns true if {@link source} is a <canvas> element
   */ isCanvasSource() {
        return !!this.source && !!this.source.toDataURL;
    }
    sourceToString() {
        return this.isImageSource() ? this.source.src : this.isCanvasSource() ? this.source.toDataURL() : '';
    }
    /**
   * Returns an instance of CanvasPattern
   * @param {CanvasRenderingContext2D} ctx Context to create pattern
   * @return {CanvasPattern}
   */ toLive(ctx) {
        if (// if the image failed to load, return, and allow rest to continue loading
        !this.source || // if an image
        this.isImageSource() && (!this.source.complete || this.source.naturalWidth === 0 || this.source.naturalHeight === 0)) return null;
        return ctx.createPattern(this.source, this.repeat);
    }
    /**
   * Returns object representation of a pattern
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {object} Object representation of a pattern instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        const { repeat: repeat, crossOrigin: crossOrigin } = this;
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, $f268b97836dca6b6$var$pick(this, propertiesToInclude)), {}, {
            type: 'pattern',
            source: this.sourceToString(),
            repeat: repeat,
            crossOrigin: crossOrigin,
            offsetX: $f268b97836dca6b6$var$toFixed(this.offsetX, $f268b97836dca6b6$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS),
            offsetY: $f268b97836dca6b6$var$toFixed(this.offsetY, $f268b97836dca6b6$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS),
            patternTransform: this.patternTransform ? [
                ...this.patternTransform
            ] : null
        });
    }
    /* _TO_SVG_START_ */ /**
   * Returns SVG representation of a pattern
   */ toSVG(_ref) {
        let { width: width, height: height } = _ref;
        const { source: patternSource, repeat: repeat, id: id } = this, patternOffsetX = $f268b97836dca6b6$var$ifNaN(this.offsetX / width, 0), patternOffsetY = $f268b97836dca6b6$var$ifNaN(this.offsetY / height, 0), patternWidth = repeat === 'repeat-y' || repeat === 'no-repeat' ? 1 + Math.abs(patternOffsetX || 0) : $f268b97836dca6b6$var$ifNaN(patternSource.width / width, 0), patternHeight = repeat === 'repeat-x' || repeat === 'no-repeat' ? 1 + Math.abs(patternOffsetY || 0) : $f268b97836dca6b6$var$ifNaN(patternSource.height / height, 0);
        return [
            "<pattern id=\"SVGID_".concat(id, "\" x=\"").concat(patternOffsetX, "\" y=\"").concat(patternOffsetY, "\" width=\"").concat(patternWidth, "\" height=\"").concat(patternHeight, "\">"),
            "<image x=\"0\" y=\"0\" width=\"".concat(patternSource.width, "\" height=\"").concat(patternSource.height, "\" xlink:href=\"").concat(this.sourceToString(), "\"></image>"),
            "</pattern>",
            ''
        ].join('\n');
    }
    /* _TO_SVG_END_ */ static async fromObject(_ref2, options) {
        let { type: type, source: source, patternTransform: patternTransform } = _ref2, otherOptions = $f268b97836dca6b6$var$_objectWithoutProperties(_ref2, $f268b97836dca6b6$var$_excluded$8);
        const img = await $f268b97836dca6b6$var$loadImage(source, $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, options), {}, {
            crossOrigin: otherOptions.crossOrigin
        }));
        return new this($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, otherOptions), {}, {
            patternTransform: patternTransform && patternTransform.slice(0),
            source: img
        }));
    }
    /**
   * @type PatternRepeat
   * @defaults
   */ /**
   * transform matrix to change the pattern, imported from svgs.
   * @todo verify if using the identity matrix as default makes the rest of the code more easy
   * @type Array
   * @default
   */ /**
   * The actual pixel source of the pattern
   */ /**
   * If true, this object will not be exported during the serialization of a canvas
   * @type boolean
   */ /**
   * ID used for SVG export functionalities
   * @type number
   */ /**
   * Constructor
   * @param {Object} [options] Options object
   * @param {option.source} [source] the pattern source, eventually empty or a drawable
   */ constructor(options){
        $f268b97836dca6b6$var$_defineProperty(this, "repeat", 'repeat');
        /**
     * Pattern horizontal offset from object's left/top corner
     * @type Number
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "offsetX", 0);
        /**
     * Pattern vertical offset from object's left/top corner
     * @type Number
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "offsetY", 0);
        /**
     * @type TCrossOrigin
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "crossOrigin", '');
        this.id = $f268b97836dca6b6$var$uid();
        Object.assign(this, options);
    }
}
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$47606a6ae3eaed8e, "type", 'Pattern');
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$47606a6ae3eaed8e);
// kept for compatibility reason
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$47606a6ae3eaed8e, 'pattern');
/**
 * @see {@link http://fabricjs.com/freedrawing|Freedrawing demo}
 */ class $f268b97836dca6b6$export$c7531c1a025bcfe2 {
    /**
   * @returns true if brush should continue blocking interaction
   */ /**
   * Sets brush styles
   * @private
   * @param {CanvasRenderingContext2D} ctx
   */ _setBrushStyles(ctx) {
        ctx.strokeStyle = this.color;
        ctx.lineWidth = this.width;
        ctx.lineCap = this.strokeLineCap;
        ctx.miterLimit = this.strokeMiterLimit;
        ctx.lineJoin = this.strokeLineJoin;
        ctx.setLineDash(this.strokeDashArray || []);
    }
    /**
   * Sets the transformation on given context
   * @param {CanvasRenderingContext2D} ctx context to render on
   * @private
   */ _saveAndTransform(ctx) {
        const v = this.canvas.viewportTransform;
        ctx.save();
        ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
    }
    needsFullRender() {
        const color = new $f268b97836dca6b6$export$892596cec99bc70e(this.color);
        return color.getAlpha() < 1 || !!this.shadow;
    }
    /**
   * Sets brush shadow styles
   * @private
   */ _setShadow() {
        if (!this.shadow || !this.canvas) return;
        const canvas = this.canvas, shadow = this.shadow, ctx = canvas.contextTop, zoom = canvas.getZoom() * canvas.getRetinaScaling();
        ctx.shadowColor = shadow.color;
        ctx.shadowBlur = shadow.blur * zoom;
        ctx.shadowOffsetX = shadow.offsetX * zoom;
        ctx.shadowOffsetY = shadow.offsetY * zoom;
    }
    /**
   * Removes brush shadow styles
   * @private
   */ _resetShadow() {
        const ctx = this.canvas.contextTop;
        ctx.shadowColor = '';
        ctx.shadowBlur = ctx.shadowOffsetX = ctx.shadowOffsetY = 0;
    }
    /**
   * Check is pointer is outside canvas boundaries
   * @param {Object} pointer
   * @private
   */ _isOutSideCanvas(pointer) {
        return pointer.x < 0 || pointer.x > this.canvas.getWidth() || pointer.y < 0 || pointer.y > this.canvas.getHeight();
    }
    /**
   * @todo add type
   */ constructor(canvas){
        /**
     * Color of a brush
     * @type String
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "color", 'rgb(0, 0, 0)');
        /**
     * Width of a brush, has to be a Number, no string literals
     * @type Number
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "width", 1);
        /**
     * Shadow object representing shadow of this shape.
     * <b>Backwards incompatibility note:</b> This property replaces "shadowColor" (String), "shadowOffsetX" (Number),
     * "shadowOffsetY" (Number) and "shadowBlur" (Number) since v1.2.12
     * @type Shadow
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "shadow", null);
        /**
     * Line endings style of a brush (one of "butt", "round", "square")
     * @type String
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "strokeLineCap", 'round');
        /**
     * Corner style of a brush (one of "bevel", "round", "miter")
     * @type String
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "strokeLineJoin", 'round');
        /**
     * Maximum miter length (used for strokeLineJoin = "miter") of a brush's
     * @type Number
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "strokeMiterLimit", 10);
        /**
     * Stroke Dash Array.
     * @type Array
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "strokeDashArray", null);
        /**
     * When `true`, the free drawing is limited to the whiteboard size. Default to false.
     * @type Boolean
     * @default false
     */ $f268b97836dca6b6$var$_defineProperty(this, "limitedToCanvasSize", false);
        this.canvas = canvas;
    }
}
const $f268b97836dca6b6$var$_excluded$7 = [
    "path",
    "left",
    "top"
], $f268b97836dca6b6$var$_excluded2$2 = [
    "d"
];
class $f268b97836dca6b6$export$4b2950bdac9b6ee9 extends $f268b97836dca6b6$export$5a5fba7eea6847b1 {
    /**
   * @private
   * @param {TComplexPathData | string} path Path data (sequence of coordinates and corresponding "command" tokens)
   * @param {boolean} [adjustPosition] pass true to reposition the object according to the bounding box
   * @returns {Point} top left position of the bounding box, useful for complementary positioning
   */ _setPath(path, adjustPosition) {
        this.path = $f268b97836dca6b6$var$makePathSimpler(Array.isArray(path) ? path : $f268b97836dca6b6$var$parsePath(path));
        this.setBoundingBox(adjustPosition);
    }
    /**
   * This function is an helper for svg import. it returns the center of the object in the svg
   * untransformed coordinates, by look at the polyline/polygon points.
   * @private
   * @return {Point} center point from element coordinates
   */ _findCenterFromElement() {
        const bbox = this._calcBoundsFromPath();
        return new $f268b97836dca6b6$export$baf26146a414f24a(bbox.left + bbox.width / 2, bbox.top + bbox.height / 2);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx context to render path on
   */ _renderPathCommands(ctx) {
        const l = -this.pathOffset.x, t = -this.pathOffset.y;
        ctx.beginPath();
        for (const command of this.path)switch(command[0] // first letter
        ){
            case 'L':
                // lineto, absolute
                ctx.lineTo(command[1] + l, command[2] + t);
                break;
            case 'M':
                // moveTo, absolute
                ctx.moveTo(command[1] + l, command[2] + t);
                break;
            case 'C':
                // bezierCurveTo, absolute
                ctx.bezierCurveTo(command[1] + l, command[2] + t, command[3] + l, command[4] + t, command[5] + l, command[6] + t);
                break;
            case 'Q':
                // quadraticCurveTo, absolute
                ctx.quadraticCurveTo(command[1] + l, command[2] + t, command[3] + l, command[4] + t);
                break;
            case 'Z':
                ctx.closePath();
                break;
        }
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx context to render path on
   */ _render(ctx) {
        this._renderPathCommands(ctx);
        this._renderPaintInOrder(ctx);
    }
    /**
   * Returns string representation of an instance
   * @return {string} string representation of an instance
   */ toString() {
        return "#<Path (".concat(this.complexity(), "): { \"top\": ").concat(this.top, ", \"left\": ").concat(this.left, " }>");
    }
    /**
   * Returns object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.toObject(propertiesToInclude)), {}, {
            path: this.path.map((pathCmd)=>pathCmd.slice())
        });
    }
    /**
   * Returns dataless object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toDatalessObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        const o = this.toObject(propertiesToInclude);
        if (this.sourcePath) {
            delete o.path;
            o.sourcePath = this.sourcePath;
        }
        return o;
    }
    /**
   * Returns svg representation of an instance
   * @return {Array} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG() {
        const path = $f268b97836dca6b6$var$joinPath(this.path, $f268b97836dca6b6$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS);
        return [
            '<path ',
            'COMMON_PARTS',
            "d=\"".concat(path, "\" stroke-linecap=\"round\" />\n")
        ];
    }
    /**
   * @private
   * @return the path command's translate transform attribute
   */ _getOffsetTransform() {
        const digits = $f268b97836dca6b6$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS;
        return " translate(".concat($f268b97836dca6b6$var$toFixed(-this.pathOffset.x, digits), ", ").concat($f268b97836dca6b6$var$toFixed(-this.pathOffset.y, digits), ")");
    }
    /**
   * Returns svg clipPath representation of an instance
   * @param {Function} [reviver] Method for further parsing of svg representation.
   * @return {string} svg representation of an instance
   */ toClipPathSVG(reviver) {
        const additionalTransform = this._getOffsetTransform();
        return '\t' + this._createBaseClipPathSVGMarkup(this._toSVG(), {
            reviver: reviver,
            additionalTransform: additionalTransform
        });
    }
    /**
   * Returns svg representation of an instance
   * @param {Function} [reviver] Method for further parsing of svg representation.
   * @return {string} svg representation of an instance
   */ toSVG(reviver) {
        const additionalTransform = this._getOffsetTransform();
        return this._createBaseSVGMarkup(this._toSVG(), {
            reviver: reviver,
            additionalTransform: additionalTransform
        });
    }
    /**
   * Returns number representation of an instance complexity
   * @return {number} complexity of this instance
   */ complexity() {
        return this.path.length;
    }
    setDimensions() {
        this.setBoundingBox();
    }
    setBoundingBox(adjustPosition) {
        const { width: width, height: height, pathOffset: pathOffset } = this._calcDimensions();
        this.set({
            width: width,
            height: height,
            pathOffset: pathOffset
        });
        // using pathOffset because it match the use case.
        // if pathOffset change here we need to use left + width/2 , top + height/2
        adjustPosition && this.setPositionByOrigin(pathOffset, $f268b97836dca6b6$var$CENTER, $f268b97836dca6b6$var$CENTER);
    }
    _calcBoundsFromPath() {
        const bounds = [];
        let subpathStartX = 0, subpathStartY = 0, x = 0, // current x
        y = 0; // current y
        for (const command of this.path)// current instruction
        switch(command[0] // first letter
        ){
            case 'L':
                // lineto, absolute
                x = command[1];
                y = command[2];
                bounds.push({
                    x: subpathStartX,
                    y: subpathStartY
                }, {
                    x: x,
                    y: y
                });
                break;
            case 'M':
                // moveTo, absolute
                x = command[1];
                y = command[2];
                subpathStartX = x;
                subpathStartY = y;
                break;
            case 'C':
                // bezierCurveTo, absolute
                bounds.push(...$f268b97836dca6b6$var$getBoundsOfCurve(x, y, command[1], command[2], command[3], command[4], command[5], command[6]));
                x = command[5];
                y = command[6];
                break;
            case 'Q':
                // quadraticCurveTo, absolute
                bounds.push(...$f268b97836dca6b6$var$getBoundsOfCurve(x, y, command[1], command[2], command[1], command[2], command[3], command[4]));
                x = command[3];
                y = command[4];
                break;
            case 'Z':
                x = subpathStartX;
                y = subpathStartY;
                break;
        }
        return $f268b97836dca6b6$var$makeBoundingBoxFromPoints(bounds);
    }
    /**
   * @private
   */ _calcDimensions() {
        const bbox = this._calcBoundsFromPath();
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, bbox), {}, {
            pathOffset: new $f268b97836dca6b6$export$baf26146a414f24a(bbox.left + bbox.width / 2, bbox.top + bbox.height / 2)
        });
    }
    /**
   * List of attribute names to account for when parsing SVG element (used by `Path.fromElement`)
   * @static
   * @memberOf Path
   * @see http://www.w3.org/TR/SVG/paths.html#PathElement
   */ /**
   * Creates an instance of Path from an object
   * @static
   * @memberOf Path
   * @param {Object} object
   * @returns {Promise<Path>}
   */ static fromObject(object) {
        return this._fromObject(object, {
            extraParam: 'path'
        });
    }
    /**
   * Creates an instance of Path from an SVG <path> element
   * @static
   * @memberOf Path
   * @param {HTMLElement} element to parse
   * @param {Partial<PathProps>} [options] Options object
   */ static async fromElement(element, options, cssRules) {
        const _parseAttributes = $f268b97836dca6b6$export$fbe550151e406473(element, this.ATTRIBUTE_NAMES, cssRules), { d: d } = _parseAttributes, parsedAttributes = $f268b97836dca6b6$var$_objectWithoutProperties(_parseAttributes, $f268b97836dca6b6$var$_excluded2$2);
        return new this(d, $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, parsedAttributes), options), {}, {
            // we pass undefined to instruct the constructor to position the object using the bbox
            left: undefined,
            top: undefined
        }));
    }
    /**
   * Constructor
   * @param {TComplexPathData} path Path data (sequence of coordinates and corresponding "command" tokens)
   * @param {Partial<PathProps>} [options] Options object
   * @return {Path} thisArg
   */ constructor(path){
        let _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, { path: _, left: left, top: top } = _ref, options = $f268b97836dca6b6$var$_objectWithoutProperties(_ref, $f268b97836dca6b6$var$_excluded$7);
        super();
        Object.assign(this, $f268b97836dca6b6$export$4b2950bdac9b6ee9.ownDefaults);
        this.setOptions(options);
        this._setPath(path || [], true);
        typeof left === 'number' && this.set($f268b97836dca6b6$var$LEFT, left);
        typeof top === 'number' && this.set($f268b97836dca6b6$var$TOP, top);
    }
}
/**
 * Array of path points
 * @type Array
 * @default
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$4b2950bdac9b6ee9, "type", 'Path');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$4b2950bdac9b6ee9, "cacheProperties", [
    ...$f268b97836dca6b6$var$cacheProperties,
    'path',
    'fillRule'
]);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$4b2950bdac9b6ee9, "ATTRIBUTE_NAMES", [
    ...$f268b97836dca6b6$var$SHARED_ATTRIBUTES,
    'd'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$4b2950bdac9b6ee9);
$f268b97836dca6b6$export$2792378e23a7920c.setSVGClass($f268b97836dca6b6$export$4b2950bdac9b6ee9);
/* _FROM_SVG_START_ */ /**
 * @private
 * @param {TSimplePathData} pathData SVG path commands
 * @returns {boolean}
 */ function $f268b97836dca6b6$var$isEmptySVGPath(pathData) {
    return $f268b97836dca6b6$var$joinPath(pathData) === 'M 0 0 Q 0 0 0 0 L 0 0';
}
class $f268b97836dca6b6$export$672d658927d3b57b extends $f268b97836dca6b6$export$c7531c1a025bcfe2 {
    needsFullRender() {
        return super.needsFullRender() || this._hasStraightLine;
    }
    static drawSegment(ctx, p1, p2) {
        const midPoint = p1.midPointFrom(p2);
        ctx.quadraticCurveTo(p1.x, p1.y, midPoint.x, midPoint.y);
        return midPoint;
    }
    /**
   * Invoked on mouse down
   * @param {Point} pointer
   */ onMouseDown(pointer, _ref) {
        let { e: e } = _ref;
        if (!this.canvas._isMainEvent(e)) return;
        this.drawStraightLine = !!this.straightLineKey && e[this.straightLineKey];
        this._prepareForDrawing(pointer);
        // capture coordinates immediately
        // this allows to draw dots (when movement never occurs)
        this._addPoint(pointer);
        this._render();
    }
    /**
   * Invoked on mouse move
   * @param {Point} pointer
   */ onMouseMove(pointer, _ref2) {
        let { e: e } = _ref2;
        if (!this.canvas._isMainEvent(e)) return;
        this.drawStraightLine = !!this.straightLineKey && e[this.straightLineKey];
        if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) return;
        if (this._addPoint(pointer) && this._points.length > 1) {
            if (this.needsFullRender()) {
                // redraw curve
                // clear top canvas
                this.canvas.clearContext(this.canvas.contextTop);
                this._render();
            } else {
                const points = this._points, length = points.length, ctx = this.canvas.contextTop;
                // draw the curve update
                this._saveAndTransform(ctx);
                if (this.oldEnd) {
                    ctx.beginPath();
                    ctx.moveTo(this.oldEnd.x, this.oldEnd.y);
                }
                this.oldEnd = $f268b97836dca6b6$export$672d658927d3b57b.drawSegment(ctx, points[length - 2], points[length - 1]);
                ctx.stroke();
                ctx.restore();
            }
        }
    }
    /**
   * Invoked on mouse up
   */ onMouseUp(_ref3) {
        let { e: e } = _ref3;
        if (!this.canvas._isMainEvent(e)) return true;
        this.drawStraightLine = false;
        this.oldEnd = undefined;
        this._finalizeAndAddPath();
        return false;
    }
    /**
   * @private
   * @param {Point} pointer Actual mouse position related to the canvas.
   */ _prepareForDrawing(pointer) {
        this._reset();
        this._addPoint(pointer);
        this.canvas.contextTop.moveTo(pointer.x, pointer.y);
    }
    /**
   * @private
   * @param {Point} point Point to be added to points array
   */ _addPoint(point) {
        if (this._points.length > 1 && point.eq(this._points[this._points.length - 1])) return false;
        if (this.drawStraightLine && this._points.length > 1) {
            this._hasStraightLine = true;
            this._points.pop();
        }
        this._points.push(point);
        return true;
    }
    /**
   * Clear points array and set contextTop canvas style.
   * @private
   */ _reset() {
        this._points = [];
        this._setBrushStyles(this.canvas.contextTop);
        this._setShadow();
        this._hasStraightLine = false;
    }
    /**
   * Draw a smooth path on the topCanvas using quadraticCurveTo
   * @private
   * @param {CanvasRenderingContext2D} [ctx]
   */ _render() {
        let ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.canvas.contextTop;
        let p1 = this._points[0], p2 = this._points[1];
        this._saveAndTransform(ctx);
        ctx.beginPath();
        //if we only have 2 points in the path and they are the same
        //it means that the user only clicked the canvas without moving the mouse
        //then we should be drawing a dot. A path isn't drawn between two identical dots
        //that's why we set them apart a bit
        if (this._points.length === 2 && p1.x === p2.x && p1.y === p2.y) {
            const width = this.width / 1000;
            p1.x -= width;
            p2.x += width;
        }
        ctx.moveTo(p1.x, p1.y);
        for(let i = 1; i < this._points.length; i++){
            // we pick the point between pi + 1 & pi + 2 as the
            // end point and p1 as our control point.
            $f268b97836dca6b6$export$672d658927d3b57b.drawSegment(ctx, p1, p2);
            p1 = this._points[i];
            p2 = this._points[i + 1];
        }
        // Draw last line as a straight line while
        // we wait for the next point to be able to calculate
        // the bezier control point
        ctx.lineTo(p1.x, p1.y);
        ctx.stroke();
        ctx.restore();
    }
    /**
   * Converts points to SVG path
   * @param {Point[]} points Array of points
   * @return {TSimplePathData} SVG path commands
   */ convertPointsToSVGPath(points) {
        const correction = this.width / 1000;
        return $f268b97836dca6b6$var$getSmoothPathFromPoints(points, correction);
    }
    /**
   * Creates a Path object to add on canvas
   * @param {TSimplePathData} pathData Path data
   * @return {Path} Path to add on canvas
   */ createPath(pathData) {
        const path = new $f268b97836dca6b6$export$4b2950bdac9b6ee9(pathData, {
            fill: null,
            stroke: this.color,
            strokeWidth: this.width,
            strokeLineCap: this.strokeLineCap,
            strokeMiterLimit: this.strokeMiterLimit,
            strokeLineJoin: this.strokeLineJoin,
            strokeDashArray: this.strokeDashArray
        });
        if (this.shadow) {
            this.shadow.affectStroke = true;
            path.shadow = new $f268b97836dca6b6$export$a24c14443968327c(this.shadow);
        }
        return path;
    }
    /**
   * Decimate points array with the decimate value
   */ decimatePoints(points, distance) {
        if (points.length <= 2) return points;
        let lastPoint = points[0], cDistance;
        const zoom = this.canvas.getZoom(), adjustedDistance = Math.pow(distance / zoom, 2), l = points.length - 1, newPoints = [
            lastPoint
        ];
        for(let i = 1; i < l - 1; i++){
            cDistance = Math.pow(lastPoint.x - points[i].x, 2) + Math.pow(lastPoint.y - points[i].y, 2);
            if (cDistance >= adjustedDistance) {
                lastPoint = points[i];
                newPoints.push(lastPoint);
            }
        }
        // Add the last point from the original line to the end of the array.
        // This ensures decimate doesn't delete the last point on the line, and ensures the line is > 1 point.
        newPoints.push(points[l]);
        return newPoints;
    }
    /**
   * On mouseup after drawing the path on contextTop canvas
   * we use the points captured to create an new Path object
   * and add it to the canvas.
   */ _finalizeAndAddPath() {
        const ctx = this.canvas.contextTop;
        ctx.closePath();
        if (this.decimate) this._points = this.decimatePoints(this._points, this.decimate);
        const pathData = this.convertPointsToSVGPath(this._points);
        if ($f268b97836dca6b6$var$isEmptySVGPath(pathData)) {
            // do not create 0 width/height paths, as they are
            // rendered inconsistently across browsers
            // Firefox 4, for example, renders a dot,
            // whereas Chrome 10 renders nothing
            this.canvas.requestRenderAll();
            return;
        }
        const path = this.createPath(pathData);
        this.canvas.clearContext(this.canvas.contextTop);
        this.canvas.fire('before:path:created', {
            path: path
        });
        this.canvas.add(path);
        this.canvas.requestRenderAll();
        path.setCoords();
        this._resetShadow();
        // fire event 'path' created
        this.canvas.fire('path:created', {
            path: path
        });
    }
    constructor(canvas){
        super(canvas);
        /**
     * Discard points that are less than `decimate` pixel distant from each other
     * @type Number
     * @default 0.4
     */ $f268b97836dca6b6$var$_defineProperty(this, "decimate", 0.4);
        /**
     * Draws a straight line between last recorded point to current pointer
     * Used for `shift` functionality
     *
     * @type boolean
     * @default false
     */ $f268b97836dca6b6$var$_defineProperty(this, "drawStraightLine", false);
        /**
     * The event modifier key that makes the brush draw a straight line.
     * If `null` or 'none' or any other string that is not a modifier key the feature is disabled.
     * @type {ModifierKey | undefined | null}
     */ $f268b97836dca6b6$var$_defineProperty(this, "straightLineKey", 'shiftKey');
        this._points = [];
        this._hasStraightLine = false;
    }
}
const $f268b97836dca6b6$var$_excluded$6 = [
    "left",
    "top",
    "radius"
];
const $f268b97836dca6b6$var$CIRCLE_PROPS = [
    'radius',
    'startAngle',
    'endAngle',
    'counterClockwise'
];
const $f268b97836dca6b6$var$circleDefaultValues = {
    radius: 0,
    startAngle: 0,
    endAngle: 360,
    counterClockwise: false
};
class $f268b97836dca6b6$export$c89a927ffc67e6fa extends $f268b97836dca6b6$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.getDefaults()), $f268b97836dca6b6$export$c89a927ffc67e6fa.ownDefaults);
    }
    /**
   * @private
   * @param {String} key
   * @param {*} value
   */ _set(key, value) {
        super._set(key, value);
        if (key === 'radius') this.setRadius(value);
        return this;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx context to render on
   */ _render(ctx) {
        ctx.beginPath();
        ctx.arc(0, 0, this.radius, $f268b97836dca6b6$var$degreesToRadians(this.startAngle), $f268b97836dca6b6$var$degreesToRadians(this.endAngle), this.counterClockwise);
        this._renderPaintInOrder(ctx);
    }
    /**
   * Returns horizontal radius of an object (according to how an object is scaled)
   * @return {Number}
   */ getRadiusX() {
        return this.get('radius') * this.get($f268b97836dca6b6$var$SCALE_X);
    }
    /**
   * Returns vertical radius of an object (according to how an object is scaled)
   * @return {Number}
   */ getRadiusY() {
        return this.get('radius') * this.get($f268b97836dca6b6$var$SCALE_Y);
    }
    /**
   * Sets radius of an object (and updates width accordingly)
   */ setRadius(value) {
        this.radius = value;
        this.set({
            width: value * 2,
            height: value * 2
        });
    }
    /**
   * Returns object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return super.toObject([
            ...$f268b97836dca6b6$var$CIRCLE_PROPS,
            ...propertiesToInclude
        ]);
    }
    /* _TO_SVG_START_ */ /**
   * Returns svg representation of an instance
   * @return {Array} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG() {
        const angle = (this.endAngle - this.startAngle) % 360;
        if (angle === 0) return [
            '<circle ',
            'COMMON_PARTS',
            'cx="0" cy="0" ',
            'r="',
            "".concat(this.radius),
            '" />\n'
        ];
        else {
            const { radius: radius } = this;
            const start = $f268b97836dca6b6$var$degreesToRadians(this.startAngle), end = $f268b97836dca6b6$var$degreesToRadians(this.endAngle), startX = $f268b97836dca6b6$var$cos(start) * radius, startY = $f268b97836dca6b6$var$sin(start) * radius, endX = $f268b97836dca6b6$var$cos(end) * radius, endY = $f268b97836dca6b6$var$sin(end) * radius, largeFlag = angle > 180 ? 1 : 0, sweepFlag = this.counterClockwise ? 0 : 1;
            return [
                "<path d=\"M ".concat(startX, " ").concat(startY, " A ").concat(radius, " ").concat(radius, " 0 ").concat(largeFlag, " ").concat(sweepFlag, " ").concat(endX, " ").concat(endY, "\" "),
                'COMMON_PARTS',
                ' />\n'
            ];
        }
    }
    /* _TO_SVG_END_ */ /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link Circle.fromElement})
   * @static
   * @memberOf Circle
   * @see: http://www.w3.org/TR/SVG/shapes.html#CircleElement
   */ /**
   * Returns {@link Circle} instance from an SVG element
   * @static
   * @memberOf Circle
   * @param {HTMLElement} element Element to parse
   * @param {Object} [options] Partial Circle object to default missing properties on the element.
   * @throws {Error} If value of `r` attribute is missing or invalid
   */ static async fromElement(element, options, cssRules) {
        const _ref = $f268b97836dca6b6$export$fbe550151e406473(element, this.ATTRIBUTE_NAMES, cssRules), { left: left = 0, top: top = 0, radius: radius = 0 } = _ref, otherParsedAttributes = $f268b97836dca6b6$var$_objectWithoutProperties(_ref, $f268b97836dca6b6$var$_excluded$6);
        // this probably requires to be fixed for default origins not being top/left.
        return new this($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, otherParsedAttributes), {}, {
            radius: radius,
            left: left - radius,
            top: top - radius
        }));
    }
    /* _FROM_SVG_END_ */ /**
   * @todo how do we declare this??
   */ static fromObject(object) {
        return super._fromObject(object);
    }
    /**
   * Constructor
   * @param {Object} [options] Options object
   */ constructor(options){
        super();
        Object.assign(this, $f268b97836dca6b6$export$c89a927ffc67e6fa.ownDefaults);
        this.setOptions(options);
    }
}
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$c89a927ffc67e6fa, "type", 'Circle');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$c89a927ffc67e6fa, "cacheProperties", [
    ...$f268b97836dca6b6$var$cacheProperties,
    ...$f268b97836dca6b6$var$CIRCLE_PROPS
]);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$c89a927ffc67e6fa, "ownDefaults", $f268b97836dca6b6$var$circleDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$c89a927ffc67e6fa, "ATTRIBUTE_NAMES", [
    'cx',
    'cy',
    'r',
    ...$f268b97836dca6b6$var$SHARED_ATTRIBUTES
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$c89a927ffc67e6fa);
$f268b97836dca6b6$export$2792378e23a7920c.setSVGClass($f268b97836dca6b6$export$c89a927ffc67e6fa);
class $f268b97836dca6b6$export$c5553759ab21b788 extends $f268b97836dca6b6$export$c7531c1a025bcfe2 {
    /**
   * Invoked inside on mouse down and mouse move
   * @param {Point} pointer
   */ drawDot(pointer) {
        const point = this.addPoint(pointer), ctx = this.canvas.contextTop;
        this._saveAndTransform(ctx);
        this.dot(ctx, point);
        ctx.restore();
    }
    dot(ctx, point) {
        ctx.fillStyle = point.fill;
        ctx.beginPath();
        ctx.arc(point.x, point.y, point.radius, 0, Math.PI * 2, false);
        ctx.closePath();
        ctx.fill();
    }
    /**
   * Invoked on mouse down
   */ onMouseDown(pointer) {
        this.points = [];
        this.canvas.clearContext(this.canvas.contextTop);
        this._setShadow();
        this.drawDot(pointer);
    }
    /**
   * Render the full state of the brush
   * @private
   */ _render() {
        const ctx = this.canvas.contextTop, points = this.points;
        this._saveAndTransform(ctx);
        for(let i = 0; i < points.length; i++)this.dot(ctx, points[i]);
        ctx.restore();
    }
    /**
   * Invoked on mouse move
   * @param {Point} pointer
   */ onMouseMove(pointer) {
        if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) return;
        if (this.needsFullRender()) {
            this.canvas.clearContext(this.canvas.contextTop);
            this.addPoint(pointer);
            this._render();
        } else this.drawDot(pointer);
    }
    /**
   * Invoked on mouse up
   */ onMouseUp() {
        const originalRenderOnAddRemove = this.canvas.renderOnAddRemove;
        this.canvas.renderOnAddRemove = false;
        const circles = [];
        for(let i = 0; i < this.points.length; i++){
            const point = this.points[i], circle = new $f268b97836dca6b6$export$c89a927ffc67e6fa({
                radius: point.radius,
                left: point.x,
                top: point.y,
                originX: $f268b97836dca6b6$var$CENTER,
                originY: $f268b97836dca6b6$var$CENTER,
                fill: point.fill
            });
            this.shadow && (circle.shadow = new $f268b97836dca6b6$export$a24c14443968327c(this.shadow));
            circles.push(circle);
        }
        const group = new $f268b97836dca6b6$export$eb2fcfdbd7ba97d4(circles, {
            canvas: this.canvas
        });
        this.canvas.fire('before:path:created', {
            path: group
        });
        this.canvas.add(group);
        this.canvas.fire('path:created', {
            path: group
        });
        this.canvas.clearContext(this.canvas.contextTop);
        this._resetShadow();
        this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
        this.canvas.requestRenderAll();
    }
    /**
   * @param {Object} pointer
   * @return {Point} Just added pointer point
   */ addPoint(_ref) {
        let { x: x, y: y } = _ref;
        const pointerPoint = {
            x: x,
            y: y,
            radius: $f268b97836dca6b6$var$getRandomInt(Math.max(0, this.width - 20), this.width + 20) / 2,
            fill: new $f268b97836dca6b6$export$892596cec99bc70e(this.color).setAlpha($f268b97836dca6b6$var$getRandomInt(0, 100) / 100).toRgba()
        };
        this.points.push(pointerPoint);
        return pointerPoint;
    }
    constructor(canvas){
        super(canvas);
        /**
     * Width of a brush
     * @type Number
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "width", 10);
        this.points = [];
    }
}
/**
 *
 * @param rects
 * @returns
 */ function $f268b97836dca6b6$var$getUniqueRects(rects) {
    const uniqueRects = {};
    const uniqueRectsArray = [];
    for(let i = 0, key; i < rects.length; i++){
        key = "".concat(rects[i].left).concat(rects[i].top);
        if (!uniqueRects[key]) {
            uniqueRects[key] = true;
            uniqueRectsArray.push(rects[i]);
        }
    }
    return uniqueRectsArray;
}
class $f268b97836dca6b6$export$6bbd078120d9a520 extends $f268b97836dca6b6$export$c7531c1a025bcfe2 {
    /**
   * Invoked on mouse down
   * @param {Point} pointer
   */ onMouseDown(pointer) {
        this.sprayChunks = [];
        this.canvas.clearContext(this.canvas.contextTop);
        this._setShadow();
        this.addSprayChunk(pointer);
        this.renderChunck(this.sprayChunk);
    }
    /**
   * Invoked on mouse move
   * @param {Point} pointer
   */ onMouseMove(pointer) {
        if (this.limitedToCanvasSize === true && this._isOutSideCanvas(pointer)) return;
        this.addSprayChunk(pointer);
        this.renderChunck(this.sprayChunk);
    }
    /**
   * Invoked on mouse up
   */ onMouseUp() {
        const originalRenderOnAddRemove = this.canvas.renderOnAddRemove;
        this.canvas.renderOnAddRemove = false;
        const rects = [];
        for(let i = 0; i < this.sprayChunks.length; i++){
            const sprayChunk = this.sprayChunks[i];
            for(let j = 0; j < sprayChunk.length; j++){
                const chunck = sprayChunk[j];
                const rect = new $f268b97836dca6b6$export$c79fc6492f3af13d({
                    width: chunck.width,
                    height: chunck.width,
                    left: chunck.x + 1,
                    top: chunck.y + 1,
                    originX: $f268b97836dca6b6$var$CENTER,
                    originY: $f268b97836dca6b6$var$CENTER,
                    fill: this.color
                });
                rects.push(rect);
            }
        }
        const group = new $f268b97836dca6b6$export$eb2fcfdbd7ba97d4(this.optimizeOverlapping ? $f268b97836dca6b6$var$getUniqueRects(rects) : rects, {
            objectCaching: true,
            subTargetCheck: false,
            interactive: false
        });
        this.shadow && group.set('shadow', new $f268b97836dca6b6$export$a24c14443968327c(this.shadow));
        this.canvas.fire('before:path:created', {
            path: group
        });
        this.canvas.add(group);
        this.canvas.fire('path:created', {
            path: group
        });
        this.canvas.clearContext(this.canvas.contextTop);
        this._resetShadow();
        this.canvas.renderOnAddRemove = originalRenderOnAddRemove;
        this.canvas.requestRenderAll();
    }
    renderChunck(sprayChunck) {
        const ctx = this.canvas.contextTop;
        ctx.fillStyle = this.color;
        this._saveAndTransform(ctx);
        for(let i = 0; i < sprayChunck.length; i++){
            const point = sprayChunck[i];
            ctx.globalAlpha = point.opacity;
            ctx.fillRect(point.x, point.y, point.width, point.width);
        }
        ctx.restore();
    }
    /**
   * Render all spray chunks
   */ _render() {
        const ctx = this.canvas.contextTop;
        ctx.fillStyle = this.color;
        this._saveAndTransform(ctx);
        for(let i = 0; i < this.sprayChunks.length; i++)this.renderChunck(this.sprayChunks[i]);
        ctx.restore();
    }
    /**
   * @param {Point} pointer
   */ addSprayChunk(pointer) {
        this.sprayChunk = [];
        const radius = this.width / 2;
        for(let i = 0; i < this.density; i++)this.sprayChunk.push({
            x: $f268b97836dca6b6$var$getRandomInt(pointer.x - radius, pointer.x + radius),
            y: $f268b97836dca6b6$var$getRandomInt(pointer.y - radius, pointer.y + radius),
            width: this.dotWidthVariance ? $f268b97836dca6b6$var$getRandomInt(// bottom clamp width to 1
            Math.max(1, this.dotWidth - this.dotWidthVariance), this.dotWidth + this.dotWidthVariance) : this.dotWidth,
            opacity: this.randomOpacity ? $f268b97836dca6b6$var$getRandomInt(0, 100) / 100 : 1
        });
        this.sprayChunks.push(this.sprayChunk);
    }
    /**
   * Constructor
   * @param {Canvas} canvas
   * @return {SprayBrush} Instance of a spray brush
   */ constructor(canvas){
        super(canvas);
        /**
     * Width of a spray
     * @type Number
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "width", 10);
        /**
     * Density of a spray (number of dots per chunk)
     * @type Number
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "density", 20);
        /**
     * Width of spray dots
     * @type Number
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "dotWidth", 1);
        /**
     * Width variance of spray dots
     * @type Number
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "dotWidthVariance", 1);
        /**
     * Whether opacity of a dot should be random
     * @type Boolean
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "randomOpacity", false);
        /**
     * Whether overlapping dots (rectangles) should be removed (for performance reasons)
     * @type Boolean
     * @default
     */ $f268b97836dca6b6$var$_defineProperty(this, "optimizeOverlapping", true);
        this.sprayChunks = [];
        this.sprayChunk = [];
    }
}
class $f268b97836dca6b6$export$3c92be346cf41088 extends $f268b97836dca6b6$export$672d658927d3b57b {
    getPatternSrc() {
        const dotWidth = 20, dotDistance = 5, patternCanvas = $f268b97836dca6b6$var$createCanvasElement(), patternCtx = patternCanvas.getContext('2d');
        patternCanvas.width = patternCanvas.height = dotWidth + dotDistance;
        if (patternCtx) {
            patternCtx.fillStyle = this.color;
            patternCtx.beginPath();
            patternCtx.arc(dotWidth / 2, dotWidth / 2, dotWidth / 2, 0, Math.PI * 2, false);
            patternCtx.closePath();
            patternCtx.fill();
        }
        return patternCanvas;
    }
    /**
   * Creates "pattern" instance property
   * @param {CanvasRenderingContext2D} ctx
   */ getPattern(ctx) {
        return ctx.createPattern(this.source || this.getPatternSrc(), 'repeat');
    }
    /**
   * Sets brush styles
   * @param {CanvasRenderingContext2D} ctx
   */ _setBrushStyles(ctx) {
        super._setBrushStyles(ctx);
        const pattern = this.getPattern(ctx);
        pattern && (ctx.strokeStyle = pattern);
    }
    /**
   * Creates path
   */ createPath(pathData) {
        const path = super.createPath(pathData), topLeft = path._getLeftTopCoords().scalarAdd(path.strokeWidth / 2);
        path.stroke = new $f268b97836dca6b6$export$47606a6ae3eaed8e({
            source: this.source || this.getPatternSrc(),
            offsetX: -topLeft.x,
            offsetY: -topLeft.y
        });
        return path;
    }
    constructor(canvas){
        super(canvas);
    }
}
const $f268b97836dca6b6$var$_excluded$5 = [
    "x1",
    "y1",
    "x2",
    "y2"
], $f268b97836dca6b6$var$_excluded2$1 = [
    "x1",
    "y1",
    "x2",
    "y2"
];
// @TODO this code is terrible and Line should be a special case of polyline.
const $f268b97836dca6b6$var$coordProps = [
    'x1',
    'x2',
    'y1',
    'y2'
];
class $f268b97836dca6b6$export$17d680238e50603e extends $f268b97836dca6b6$export$5a5fba7eea6847b1 {
    /**
   * @private
   * @param {Object} [options] Options
   */ _setWidthHeight() {
        const { x1: x1, y1: y1, x2: x2, y2: y2 } = this;
        this.width = Math.abs(x2 - x1);
        this.height = Math.abs(y2 - y1);
        const { left: left, top: top, width: width, height: height } = $f268b97836dca6b6$var$makeBoundingBoxFromPoints([
            {
                x: x1,
                y: y1
            },
            {
                x: x2,
                y: y2
            }
        ]);
        const position = new $f268b97836dca6b6$export$baf26146a414f24a(left + width / 2, top + height / 2);
        this.setPositionByOrigin(position, $f268b97836dca6b6$var$CENTER, $f268b97836dca6b6$var$CENTER);
    }
    /**
   * @private
   * @param {String} key
   * @param {*} value
   */ _set(key, value) {
        super._set(key, value);
        if ($f268b97836dca6b6$var$coordProps.includes(key)) // this doesn't make sense very much, since setting x1 when top or left
        // are already set, is just going to show a strange result since the
        // line will move way more than the developer expect.
        // in fabric5 it worked only when the line didn't have extra transformations,
        // in fabric6 too. With extra transform they behave bad in different ways.
        // This needs probably a good rework or a tutorial if you have to create a dynamic line
        this._setWidthHeight();
        return this;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _render(ctx) {
        ctx.beginPath();
        const p = this.calcLinePoints();
        ctx.moveTo(p.x1, p.y1);
        ctx.lineTo(p.x2, p.y2);
        ctx.lineWidth = this.strokeWidth;
        // TODO: test this
        // make sure setting "fill" changes color of a line
        // (by copying fillStyle to strokeStyle, since line is stroked, not filled)
        const origStrokeStyle = ctx.strokeStyle;
        if ($f268b97836dca6b6$var$isFiller(this.stroke)) ctx.strokeStyle = this.stroke.toLive(ctx);
        else {
            var _this$stroke;
            ctx.strokeStyle = (_this$stroke = this.stroke) !== null && _this$stroke !== void 0 ? _this$stroke : ctx.fillStyle;
        }
        this.stroke && this._renderStroke(ctx);
        ctx.strokeStyle = origStrokeStyle;
    }
    /**
   * This function is an helper for svg import. it returns the center of the object in the svg
   * untransformed coordinates
   * @private
   * @return {Point} center point from element coordinates
   */ _findCenterFromElement() {
        return new $f268b97836dca6b6$export$baf26146a414f24a((this.x1 + this.x2) / 2, (this.y1 + this.y2) / 2);
    }
    /**
   * Returns object representation of an instance
   * @method toObject
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.toObject(propertiesToInclude)), this.calcLinePoints());
    }
    /*
   * Calculate object dimensions from its properties
   * @private
   */ _getNonTransformedDimensions() {
        const dim = super._getNonTransformedDimensions();
        if (this.strokeLineCap === 'butt') {
            if (this.width === 0) dim.y -= this.strokeWidth;
            if (this.height === 0) dim.x -= this.strokeWidth;
        }
        return dim;
    }
    /**
   * Recalculates line points given width and height
   * Those points are simply placed around the center,
   * This is not useful outside internal render functions and svg output
   * Is not meant to be for the developer.
   * @private
   */ calcLinePoints() {
        const { x1: _x1, x2: _x2, y1: _y1, y2: _y2, width: width, height: height } = this;
        const xMult = _x1 <= _x2 ? -1 : 1, yMult = _y1 <= _y2 ? -1 : 1, x1 = xMult * width / 2, y1 = yMult * height / 2, x2 = xMult * -width / 2, y2 = yMult * -height / 2;
        return {
            x1: x1,
            x2: x2,
            y1: y1,
            y2: y2
        };
    }
    /* _FROM_SVG_START_ */ /**
   * Returns svg representation of an instance
   * @return {Array} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG() {
        const { x1: x1, x2: x2, y1: y1, y2: y2 } = this.calcLinePoints();
        return [
            '<line ',
            'COMMON_PARTS',
            "x1=\"".concat(x1, "\" y1=\"").concat(y1, "\" x2=\"").concat(x2, "\" y2=\"").concat(y2, "\" />\n")
        ];
    }
    /**
   * List of attribute names to account for when parsing SVG element (used by {@link Line.fromElement})
   * @static
   * @memberOf Line
   * @see http://www.w3.org/TR/SVG/shapes.html#LineElement
   */ /**
   * Returns Line instance from an SVG element
   * @static
   * @memberOf Line
   * @param {HTMLElement} element Element to parse
   * @param {Object} [options] Options object
   * @param {Function} [callback] callback function invoked after parsing
   */ static async fromElement(element, options, cssRules) {
        const _parseAttributes = $f268b97836dca6b6$export$fbe550151e406473(element, this.ATTRIBUTE_NAMES, cssRules), { x1: x1 = 0, y1: y1 = 0, x2: x2 = 0, y2: y2 = 0 } = _parseAttributes, parsedAttributes = $f268b97836dca6b6$var$_objectWithoutProperties(_parseAttributes, $f268b97836dca6b6$var$_excluded$5);
        return new this([
            x1,
            y1,
            x2,
            y2
        ], parsedAttributes);
    }
    /* _FROM_SVG_END_ */ /**
   * Returns Line instance from an object representation
   * @static
   * @memberOf Line
   * @param {Object} object Object to create an instance from
   * @returns {Promise<Line>}
   */ static fromObject(_ref) {
        let { x1: x1, y1: y1, x2: x2, y2: y2 } = _ref, object = $f268b97836dca6b6$var$_objectWithoutProperties(_ref, $f268b97836dca6b6$var$_excluded2$1);
        return this._fromObject($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, object), {}, {
            points: [
                x1,
                y1,
                x2,
                y2
            ]
        }), {
            extraParam: 'points'
        });
    }
    /**
   * Constructor
   * @param {Array} [points] Array of points
   * @param {Object} [options] Options object
   * @return {Line} thisArg
   */ constructor(){
        let [x1, y1, x2, y2] = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
            0,
            0,
            0,
            0
        ];
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        Object.assign(this, $f268b97836dca6b6$export$17d680238e50603e.ownDefaults);
        this.setOptions(options);
        this.x1 = x1;
        this.x2 = x2;
        this.y1 = y1;
        this.y2 = y2;
        this._setWidthHeight();
        const { left: left, top: top } = options;
        typeof left === 'number' && this.set($f268b97836dca6b6$var$LEFT, left);
        typeof top === 'number' && this.set($f268b97836dca6b6$var$TOP, top);
    }
}
/**
 * x value or first line edge
 * @type number
 * @default
 */ /**
 * y value or first line edge
 * @type number
 * @default
 */ /**
 * x value or second line edge
 * @type number
 * @default
 */ /**
 * y value or second line edge
 * @type number
 * @default
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$17d680238e50603e, "type", 'Line');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$17d680238e50603e, "cacheProperties", [
    ...$f268b97836dca6b6$var$cacheProperties,
    ...$f268b97836dca6b6$var$coordProps
]);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$17d680238e50603e, "ATTRIBUTE_NAMES", $f268b97836dca6b6$var$SHARED_ATTRIBUTES.concat($f268b97836dca6b6$var$coordProps));
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$17d680238e50603e);
$f268b97836dca6b6$export$2792378e23a7920c.setSVGClass($f268b97836dca6b6$export$17d680238e50603e);
const $f268b97836dca6b6$var$triangleDefaultValues = {
    width: 100,
    height: 100
};
class $f268b97836dca6b6$export$5a465592bfe74b48 extends $f268b97836dca6b6$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.getDefaults()), $f268b97836dca6b6$export$5a465592bfe74b48.ownDefaults);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _render(ctx) {
        const widthBy2 = this.width / 2, heightBy2 = this.height / 2;
        ctx.beginPath();
        ctx.moveTo(-widthBy2, heightBy2);
        ctx.lineTo(0, -heightBy2);
        ctx.lineTo(widthBy2, heightBy2);
        ctx.closePath();
        this._renderPaintInOrder(ctx);
    }
    /**
   * Returns svg representation of an instance
   * @return {Array} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG() {
        const widthBy2 = this.width / 2, heightBy2 = this.height / 2, points = "".concat(-widthBy2, " ").concat(heightBy2, ",0 ").concat(-heightBy2, ",").concat(widthBy2, " ").concat(heightBy2);
        return [
            '<polygon ',
            'COMMON_PARTS',
            'points="',
            points,
            '" />'
        ];
    }
    /**
   * Constructor
   * @param {Object} [options] Options object
   */ constructor(options){
        super();
        Object.assign(this, $f268b97836dca6b6$export$5a465592bfe74b48.ownDefaults);
        this.setOptions(options);
    }
}
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$5a465592bfe74b48, "type", 'Triangle');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$5a465592bfe74b48, "ownDefaults", $f268b97836dca6b6$var$triangleDefaultValues);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$5a465592bfe74b48);
$f268b97836dca6b6$export$2792378e23a7920c.setSVGClass($f268b97836dca6b6$export$5a465592bfe74b48);
const $f268b97836dca6b6$var$ellipseDefaultValues = {
    rx: 0,
    ry: 0
};
const $f268b97836dca6b6$var$ELLIPSE_PROPS = [
    'rx',
    'ry'
];
class $f268b97836dca6b6$export$80b0269ab108fa11 extends $f268b97836dca6b6$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.getDefaults()), $f268b97836dca6b6$export$80b0269ab108fa11.ownDefaults);
    }
    /**
   * @private
   * @param {String} key
   * @param {*} value
   * @return {Ellipse} thisArg
   */ _set(key, value) {
        super._set(key, value);
        switch(key){
            case 'rx':
                this.rx = value;
                this.set('width', value * 2);
                break;
            case 'ry':
                this.ry = value;
                this.set('height', value * 2);
                break;
        }
        return this;
    }
    /**
   * Returns horizontal radius of an object (according to how an object is scaled)
   * @return {Number}
   */ getRx() {
        return this.get('rx') * this.get($f268b97836dca6b6$var$SCALE_X);
    }
    /**
   * Returns Vertical radius of an object (according to how an object is scaled)
   * @return {Number}
   */ getRy() {
        return this.get('ry') * this.get($f268b97836dca6b6$var$SCALE_Y);
    }
    /**
   * Returns object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return super.toObject([
            ...$f268b97836dca6b6$var$ELLIPSE_PROPS,
            ...propertiesToInclude
        ]);
    }
    /**
   * Returns svg representation of an instance
   * @return {Array} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG() {
        return [
            '<ellipse ',
            'COMMON_PARTS',
            "cx=\"0\" cy=\"0\" rx=\"".concat(this.rx, "\" ry=\"").concat(this.ry, "\" />\n")
        ];
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx context to render on
   */ _render(ctx) {
        ctx.beginPath();
        ctx.save();
        ctx.transform(1, 0, 0, this.ry / this.rx, 0, 0);
        ctx.arc(0, 0, this.rx, 0, $f268b97836dca6b6$var$twoMathPi, false);
        ctx.restore();
        this._renderPaintInOrder(ctx);
    }
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link Ellipse.fromElement})
   * @static
   * @memberOf Ellipse
   * @see http://www.w3.org/TR/SVG/shapes.html#EllipseElement
   */ /**
   * Returns {@link Ellipse} instance from an SVG element
   * @static
   * @memberOf Ellipse
   * @param {HTMLElement} element Element to parse
   * @return {Ellipse}
   */ static async fromElement(element, options, cssRules) {
        const parsedAttributes = $f268b97836dca6b6$export$fbe550151e406473(element, this.ATTRIBUTE_NAMES, cssRules);
        parsedAttributes.left = (parsedAttributes.left || 0) - parsedAttributes.rx;
        parsedAttributes.top = (parsedAttributes.top || 0) - parsedAttributes.ry;
        return new this(parsedAttributes);
    }
    /**
   * Constructor
   * @param {Object} [options] Options object
   */ constructor(options){
        super();
        Object.assign(this, $f268b97836dca6b6$export$80b0269ab108fa11.ownDefaults);
        this.setOptions(options);
    }
}
/**
 * Horizontal radius
 * @type Number
 * @default
 */ /**
 * Vertical radius
 * @type Number
 * @default
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$80b0269ab108fa11, "type", 'Ellipse');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$80b0269ab108fa11, "cacheProperties", [
    ...$f268b97836dca6b6$var$cacheProperties,
    ...$f268b97836dca6b6$var$ELLIPSE_PROPS
]);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$80b0269ab108fa11, "ownDefaults", $f268b97836dca6b6$var$ellipseDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$80b0269ab108fa11, "ATTRIBUTE_NAMES", [
    ...$f268b97836dca6b6$var$SHARED_ATTRIBUTES,
    'cx',
    'cy',
    'rx',
    'ry'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$80b0269ab108fa11);
$f268b97836dca6b6$export$2792378e23a7920c.setSVGClass($f268b97836dca6b6$export$80b0269ab108fa11);
/**
 * Parses "points" attribute, returning an array of values
 * @static
 * @memberOf fabric
 * @param {String} points points attribute string
 * @return {Array} array of points
 */ function $f268b97836dca6b6$export$809af63a824f9f55(points) {
    // points attribute is required and must not be empty
    if (!points) return [];
    // replace commas with whitespace and remove bookending whitespace
    const pointsSplit = points.replace(/,/g, ' ').trim().split(/\s+/);
    const parsedPoints = [];
    for(let i = 0; i < pointsSplit.length; i += 2)parsedPoints.push({
        x: parseFloat(pointsSplit[i]),
        y: parseFloat(pointsSplit[i + 1])
    });
    // odd number of points is an error
    // if (parsedPoints.length % 2 !== 0) {
    //   return null;
    // }
    return parsedPoints;
}
const $f268b97836dca6b6$var$_excluded$4 = [
    "left",
    "top"
];
const $f268b97836dca6b6$var$polylineDefaultValues = {
    /**
   * @deprecated transient option soon to be removed in favor of a different design
   */ exactBoundingBox: false
};
class $f268b97836dca6b6$export$79f3ee03e63e7073 extends $f268b97836dca6b6$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.getDefaults()), $f268b97836dca6b6$export$79f3ee03e63e7073.ownDefaults);
    }
    isOpen() {
        return true;
    }
    _projectStrokeOnPoints(options) {
        return $f268b97836dca6b6$var$projectStrokeOnPoints(this.points, options, this.isOpen());
    }
    /**
   * Calculate the polygon bounding box
   * @private
   */ _calcDimensions(options) {
        options = $f268b97836dca6b6$var$_objectSpread2({
            scaleX: this.scaleX,
            scaleY: this.scaleY,
            skewX: this.skewX,
            skewY: this.skewY,
            strokeLineCap: this.strokeLineCap,
            strokeLineJoin: this.strokeLineJoin,
            strokeMiterLimit: this.strokeMiterLimit,
            strokeUniform: this.strokeUniform,
            strokeWidth: this.strokeWidth
        }, options || {});
        const points = this.exactBoundingBox ? this._projectStrokeOnPoints(options).map((projection)=>projection.projectedPoint) : this.points;
        if (points.length === 0) return {
            left: 0,
            top: 0,
            width: 0,
            height: 0,
            pathOffset: new $f268b97836dca6b6$export$baf26146a414f24a(),
            strokeOffset: new $f268b97836dca6b6$export$baf26146a414f24a(),
            strokeDiff: new $f268b97836dca6b6$export$baf26146a414f24a()
        };
        const bbox = $f268b97836dca6b6$var$makeBoundingBoxFromPoints(points), // Remove scale effect, since it's applied after
        matrix = $f268b97836dca6b6$var$calcDimensionsMatrix($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, options), {}, {
            scaleX: 1,
            scaleY: 1
        })), bboxNoStroke = $f268b97836dca6b6$var$makeBoundingBoxFromPoints(this.points.map((p)=>$f268b97836dca6b6$var$transformPoint(p, matrix, true))), scale = new $f268b97836dca6b6$export$baf26146a414f24a(this.scaleX, this.scaleY);
        let offsetX = bbox.left + bbox.width / 2, offsetY = bbox.top + bbox.height / 2;
        if (this.exactBoundingBox) {
            offsetX = offsetX - offsetY * Math.tan($f268b97836dca6b6$var$degreesToRadians(this.skewX));
            // Order of those assignments is important.
            // offsetY relies on offsetX being already changed by the line above
            offsetY = offsetY - offsetX * Math.tan($f268b97836dca6b6$var$degreesToRadians(this.skewY));
        }
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, bbox), {}, {
            pathOffset: new $f268b97836dca6b6$export$baf26146a414f24a(offsetX, offsetY),
            strokeOffset: new $f268b97836dca6b6$export$baf26146a414f24a(bboxNoStroke.left, bboxNoStroke.top).subtract(new $f268b97836dca6b6$export$baf26146a414f24a(bbox.left, bbox.top)).multiply(scale),
            strokeDiff: new $f268b97836dca6b6$export$baf26146a414f24a(bbox.width, bbox.height).subtract(new $f268b97836dca6b6$export$baf26146a414f24a(bboxNoStroke.width, bboxNoStroke.height)).multiply(scale)
        });
    }
    /**
   * This function is an helper for svg import. it returns the center of the object in the svg
   * untransformed coordinates, by look at the polyline/polygon points.
   * @private
   * @return {Point} center point from element coordinates
   */ _findCenterFromElement() {
        const bbox = $f268b97836dca6b6$var$makeBoundingBoxFromPoints(this.points);
        return new $f268b97836dca6b6$export$baf26146a414f24a(bbox.left + bbox.width / 2, bbox.top + bbox.height / 2);
    }
    setDimensions() {
        this.setBoundingBox();
    }
    setBoundingBox(adjustPosition) {
        const { left: left, top: top, width: width, height: height, pathOffset: pathOffset, strokeOffset: strokeOffset, strokeDiff: strokeDiff } = this._calcDimensions();
        this.set({
            width: width,
            height: height,
            pathOffset: pathOffset,
            strokeOffset: strokeOffset,
            strokeDiff: strokeDiff
        });
        adjustPosition && this.setPositionByOrigin(new $f268b97836dca6b6$export$baf26146a414f24a(left + width / 2, top + height / 2), $f268b97836dca6b6$var$CENTER, $f268b97836dca6b6$var$CENTER);
    }
    /**
   * @deprecated intermidiate method to be removed, do not use
   */ isStrokeAccountedForInDimensions() {
        return this.exactBoundingBox;
    }
    /**
   * @override stroke is taken in account in size
   */ _getNonTransformedDimensions() {
        return this.exactBoundingBox ? // TODO: fix this
        new $f268b97836dca6b6$export$baf26146a414f24a(this.width, this.height) : super._getNonTransformedDimensions();
    }
    /**
   * @override stroke and skewing are taken into account when projecting stroke on points,
   * therefore we don't want the default calculation to account for skewing as well.
   * Though it is possible to pass `width` and `height` in `options`, doing so is very strange, use with discretion.
   *
   * @private
   */ _getTransformedDimensions() {
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (this.exactBoundingBox) {
            let size;
            /* When `strokeUniform = true`, any changes to the properties require recalculating the `width` and `height` because
        the stroke projections are affected.
        When `strokeUniform = false`, we don't need to recalculate for scale transformations, as the effect of scale on
        projections follows a linear function (e.g. scaleX of 2 just multiply width by 2)*/ if (Object.keys(options).some((key)=>this.strokeUniform || this.constructor.layoutProperties.includes(key))) {
                var _options$width, _options$height;
                const { width: width, height: height } = this._calcDimensions(options);
                size = new $f268b97836dca6b6$export$baf26146a414f24a((_options$width = options.width) !== null && _options$width !== void 0 ? _options$width : width, (_options$height = options.height) !== null && _options$height !== void 0 ? _options$height : height);
            } else {
                var _options$width2, _options$height2;
                size = new $f268b97836dca6b6$export$baf26146a414f24a((_options$width2 = options.width) !== null && _options$width2 !== void 0 ? _options$width2 : this.width, (_options$height2 = options.height) !== null && _options$height2 !== void 0 ? _options$height2 : this.height);
            }
            return size.multiply(new $f268b97836dca6b6$export$baf26146a414f24a(options.scaleX || this.scaleX, options.scaleY || this.scaleY));
        } else return super._getTransformedDimensions(options);
    }
    /**
   * Recalculates dimensions when changing skew and scale
   * @private
   */ _set(key, value) {
        const changed = this.initialized && this[key] !== value;
        const output = super._set(key, value);
        if (this.exactBoundingBox && changed && ((key === $f268b97836dca6b6$var$SCALE_X || key === $f268b97836dca6b6$var$SCALE_Y) && this.strokeUniform && this.constructor.layoutProperties.includes('strokeUniform') || this.constructor.layoutProperties.includes(key))) this.setDimensions();
        return output;
    }
    /**
   * Returns object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} Object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.toObject(propertiesToInclude)), {}, {
            points: this.points.map((_ref)=>{
                let { x: x, y: y } = _ref;
                return {
                    x: x,
                    y: y
                };
            })
        });
    }
    /**
   * Returns svg representation of an instance
   * @return {Array} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG() {
        const points = [], diffX = this.pathOffset.x, diffY = this.pathOffset.y, NUM_FRACTION_DIGITS = $f268b97836dca6b6$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS;
        for(let i = 0, len = this.points.length; i < len; i++)points.push($f268b97836dca6b6$var$toFixed(this.points[i].x - diffX, NUM_FRACTION_DIGITS), ',', $f268b97836dca6b6$var$toFixed(this.points[i].y - diffY, NUM_FRACTION_DIGITS), ' ');
        return [
            "<".concat(this.constructor.type.toLowerCase(), " "),
            'COMMON_PARTS',
            "points=\"".concat(points.join(''), "\" />\n")
        ];
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _render(ctx) {
        const len = this.points.length, x = this.pathOffset.x, y = this.pathOffset.y;
        if (!len || isNaN(this.points[len - 1].y)) // do not draw if no points or odd points
        // NaN comes from parseFloat of a empty string in parser
        return;
        ctx.beginPath();
        ctx.moveTo(this.points[0].x - x, this.points[0].y - y);
        for(let i = 0; i < len; i++){
            const point = this.points[i];
            ctx.lineTo(point.x - x, point.y - y);
        }
        !this.isOpen() && ctx.closePath();
        this._renderPaintInOrder(ctx);
    }
    /**
   * Returns complexity of an instance
   * @return {Number} complexity of this instance
   */ complexity() {
        return this.points.length;
    }
    /* _FROM_SVG_START_ */ /**
   * List of attribute names to account for when parsing SVG element (used by {@link Polyline.fromElement})
   * @static
   * @memberOf Polyline
   * @see: http://www.w3.org/TR/SVG/shapes.html#PolylineElement
   */ /**
   * Returns Polyline instance from an SVG element
   * @static
   * @memberOf Polyline
   * @param {HTMLElement} element Element to parser
   * @param {Object} [options] Options object
   */ static async fromElement(element, options, cssRules) {
        const points = $f268b97836dca6b6$export$809af63a824f9f55(element.getAttribute('points')), _parseAttributes = $f268b97836dca6b6$export$fbe550151e406473(element, this.ATTRIBUTE_NAMES, cssRules), parsedAttributes = $f268b97836dca6b6$var$_objectWithoutProperties(_parseAttributes, $f268b97836dca6b6$var$_excluded$4);
        return new this(points, $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, parsedAttributes), options));
    }
    /* _FROM_SVG_END_ */ /**
   * Returns Polyline instance from an object representation
   * @static
   * @memberOf Polyline
   * @param {Object} object Object to create an instance from
   * @returns {Promise<Polyline>}
   */ static fromObject(object) {
        return this._fromObject(object, {
            extraParam: 'points'
        });
    }
    /**
   * A list of properties that if changed trigger a recalculation of dimensions
   * @todo check if you really need to recalculate for all cases
   */ /**
   * Constructor
   * @param {Array} points Array of points (where each point is an object with x and y)
   * @param {Object} [options] Options object
   * @return {Polyline} thisArg
   * @example
   * var poly = new Polyline([
   *     { x: 10, y: 10 },
   *     { x: 50, y: 30 },
   *     { x: 40, y: 70 },
   *     { x: 60, y: 50 },
   *     { x: 100, y: 150 },
   *     { x: 40, y: 100 }
   *   ], {
   *   stroke: 'red',
   *   left: 100,
   *   top: 100
   * });
   */ constructor(){
        let points = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        $f268b97836dca6b6$var$_defineProperty(this, "strokeDiff", void 0);
        Object.assign(this, $f268b97836dca6b6$export$79f3ee03e63e7073.ownDefaults);
        this.setOptions(options);
        this.points = points;
        const { left: left, top: top } = options;
        this.initialized = true;
        this.setBoundingBox(true);
        typeof left === 'number' && this.set($f268b97836dca6b6$var$LEFT, left);
        typeof top === 'number' && this.set($f268b97836dca6b6$var$TOP, top);
    }
}
/**
 * Points array
 * @type Array
 * @default
 */ /**
 * WARNING: Feature in progress
 * Calculate the exact bounding box taking in account strokeWidth on acute angles
 * this will be turned to true by default on fabric 6.0
 * maybe will be left in as an optimization since calculations may be slow
 * @deprecated transient option soon to be removed in favor of a different design
 * @type Boolean
 * @default false
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$79f3ee03e63e7073, "ownDefaults", $f268b97836dca6b6$var$polylineDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$79f3ee03e63e7073, "type", 'Polyline');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$79f3ee03e63e7073, "layoutProperties", [
    $f268b97836dca6b6$var$SKEW_X,
    $f268b97836dca6b6$var$SKEW_Y,
    'strokeLineCap',
    'strokeLineJoin',
    'strokeMiterLimit',
    'strokeWidth',
    'strokeUniform',
    'points'
]);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$79f3ee03e63e7073, "cacheProperties", [
    ...$f268b97836dca6b6$var$cacheProperties,
    'points'
]);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$79f3ee03e63e7073, "ATTRIBUTE_NAMES", [
    ...$f268b97836dca6b6$var$SHARED_ATTRIBUTES
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$79f3ee03e63e7073);
$f268b97836dca6b6$export$2792378e23a7920c.setSVGClass($f268b97836dca6b6$export$79f3ee03e63e7073);
class $f268b97836dca6b6$export$7d31b617c820d435 extends $f268b97836dca6b6$export$79f3ee03e63e7073 {
    isOpen() {
        return false;
    }
}
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$7d31b617c820d435, "ownDefaults", $f268b97836dca6b6$var$polylineDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$7d31b617c820d435, "type", 'Polygon');
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$7d31b617c820d435);
$f268b97836dca6b6$export$2792378e23a7920c.setSVGClass($f268b97836dca6b6$export$7d31b617c820d435);
class $f268b97836dca6b6$var$StyledText extends $f268b97836dca6b6$export$5a5fba7eea6847b1 {
    /**
   * Returns true if object has no styling or no styling in a line
   * @param {Number} lineIndex , lineIndex is on wrapped lines.
   * @return {Boolean}
   */ isEmptyStyles(lineIndex) {
        if (!this.styles) return true;
        if (typeof lineIndex !== 'undefined' && !this.styles[lineIndex]) return true;
        const obj = typeof lineIndex === 'undefined' ? this.styles : {
            line: this.styles[lineIndex]
        };
        for(const p1 in obj)for(const p2 in obj[p1]){
            // eslint-disable-next-line no-unused-vars
            for(const p3 in obj[p1][p2])return false;
        }
        return true;
    }
    /**
   * Returns true if object has a style property or has it ina specified line
   * This function is used to detect if a text will use a particular property or not.
   * @param {String} property to check for
   * @param {Number} lineIndex to check the style on
   * @return {Boolean}
   */ styleHas(property, lineIndex) {
        if (!this.styles) return false;
        if (typeof lineIndex !== 'undefined' && !this.styles[lineIndex]) return false;
        const obj = typeof lineIndex === 'undefined' ? this.styles : {
            0: this.styles[lineIndex]
        };
        // eslint-disable-next-line
        for(const p1 in obj)// eslint-disable-next-line
        for(const p2 in obj[p1]){
            if (typeof obj[p1][p2][property] !== 'undefined') return true;
        }
        return false;
    }
    /**
   * Check if characters in a text have a value for a property
   * whose value matches the textbox's value for that property.  If so,
   * the character-level property is deleted.  If the character
   * has no other properties, then it is also deleted.  Finally,
   * if the line containing that character has no other characters
   * then it also is deleted.
   */ cleanStyle(property) {
        if (!this.styles) return false;
        const obj = this.styles;
        let stylesCount = 0, letterCount, stylePropertyValue, allStyleObjectPropertiesMatch = true, graphemeCount = 0;
        for(const p1 in obj){
            letterCount = 0;
            for(const p2 in obj[p1]){
                const styleObject = obj[p1][p2] || {}, stylePropertyHasBeenSet = styleObject[property] !== undefined;
                stylesCount++;
                if (stylePropertyHasBeenSet) {
                    if (!stylePropertyValue) stylePropertyValue = styleObject[property];
                    else if (styleObject[property] !== stylePropertyValue) allStyleObjectPropertiesMatch = false;
                    if (styleObject[property] === this[property]) delete styleObject[property];
                } else allStyleObjectPropertiesMatch = false;
                if (Object.keys(styleObject).length !== 0) letterCount++;
                else delete obj[p1][p2];
            }
            if (letterCount === 0) delete obj[p1];
        }
        // if every grapheme has the same style set then
        // delete those styles and set it on the parent
        for(let i = 0; i < this._textLines.length; i++)graphemeCount += this._textLines[i].length;
        if (allStyleObjectPropertiesMatch && stylesCount === graphemeCount) {
            this[property] = stylePropertyValue;
            this.removeStyle(property);
        }
    }
    /**
   * Remove a style property or properties from all individual character styles
   * in a text object.  Deletes the character style object if it contains no other style
   * props.  Deletes a line style object if it contains no other character styles.
   *
   * @param {String} props The property to remove from character styles.
   */ removeStyle(property) {
        if (!this.styles) return;
        const obj = this.styles;
        let line, lineNum, charNum;
        for(lineNum in obj){
            line = obj[lineNum];
            for(charNum in line){
                delete line[charNum][property];
                if (Object.keys(line[charNum]).length === 0) delete line[charNum];
            }
            if (Object.keys(line).length === 0) delete obj[lineNum];
        }
    }
    _extendStyles(index, style) {
        const { lineIndex: lineIndex, charIndex: charIndex } = this.get2DCursorLocation(index);
        if (!this._getLineStyle(lineIndex)) this._setLineStyle(lineIndex);
        const newStyle = $f268b97836dca6b6$var$pickBy($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, this._getStyleDeclaration(lineIndex, charIndex)), style), (value)=>value !== undefined);
        // finally assign to the old position the new style
        this._setStyleDeclaration(lineIndex, charIndex, newStyle);
    }
    /**
   * Gets style of a current selection/cursor (at the start position)
   * @param {Number} startIndex Start index to get styles at
   * @param {Number} endIndex End index to get styles at, if not specified startIndex + 1
   * @param {Boolean} [complete] get full style or not
   * @return {Array} styles an array with one, zero or more Style objects
   */ getSelectionStyles(startIndex, endIndex, complete) {
        const styles = [];
        for(let i = startIndex; i < (endIndex || startIndex); i++)styles.push(this.getStyleAtPosition(i, complete));
        return styles;
    }
    /**
   * Gets style of a current selection/cursor position
   * @param {Number} position  to get styles at
   * @param {Boolean} [complete] full style if true
   * @return {Object} style Style object at a specified index
   * @private
   */ getStyleAtPosition(position, complete) {
        const { lineIndex: lineIndex, charIndex: charIndex } = this.get2DCursorLocation(position);
        return complete ? this.getCompleteStyleDeclaration(lineIndex, charIndex) : this._getStyleDeclaration(lineIndex, charIndex);
    }
    /**
   * Sets style of a current selection, if no selection exist, do not set anything.
   * @param {Object} styles Styles object
   * @param {Number} startIndex Start index to get styles at
   * @param {Number} [endIndex] End index to get styles at, if not specified startIndex + 1
   */ setSelectionStyles(styles, startIndex, endIndex) {
        for(let i = startIndex; i < (endIndex || startIndex); i++)this._extendStyles(i, styles);
        /* not included in _extendStyles to avoid clearing cache more than once */ this._forceClearCache = true;
    }
    /**
   * Get a reference, not a clone, to the style object for a given character,
   * if no style is set for a line or char, return a new empty object.
   * This is tricky and confusing because when you get an empty object you can't
   * determine if it is a reference or a new one.
   * @TODO this should always return a reference or always a clone or undefined when necessary.
   * @protected
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @return {TextStyleDeclaration} a style object reference to the existing one or a new empty object when undefined
   */ _getStyleDeclaration(lineIndex, charIndex) {
        var _lineStyle$charIndex;
        const lineStyle = this.styles && this.styles[lineIndex];
        return lineStyle ? (_lineStyle$charIndex = lineStyle[charIndex]) !== null && _lineStyle$charIndex !== void 0 ? _lineStyle$charIndex : {} : {};
    }
    /**
   * return a new object that contains all the style property for a character
   * the object returned is newly created
   * @param {Number} lineIndex of the line where the character is
   * @param {Number} charIndex position of the character on the line
   * @return {Object} style object
   */ getCompleteStyleDeclaration(lineIndex, charIndex) {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, $f268b97836dca6b6$var$pick(this, this.constructor._styleProperties)), this._getStyleDeclaration(lineIndex, charIndex));
    }
    /**
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @param {Object} style
   * @private
   */ _setStyleDeclaration(lineIndex, charIndex, style) {
        this.styles[lineIndex][charIndex] = style;
    }
    /**
   *
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @private
   */ _deleteStyleDeclaration(lineIndex, charIndex) {
        delete this.styles[lineIndex][charIndex];
    }
    /**
   * @param {Number} lineIndex
   * @return {Boolean} if the line exists or not
   * @private
   */ _getLineStyle(lineIndex) {
        return !!this.styles[lineIndex];
    }
    /**
   * Set the line style to an empty object so that is initialized
   * @param {Number} lineIndex
   * @private
   */ _setLineStyle(lineIndex) {
        this.styles[lineIndex] = {};
    }
    _deleteLineStyle(lineIndex) {
        delete this.styles[lineIndex];
    }
}
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$StyledText, "_styleProperties", $f268b97836dca6b6$var$styleProperties);
const $f268b97836dca6b6$var$multipleSpacesRegex = /  +/g;
const $f268b97836dca6b6$var$dblQuoteRegex = /"/g;
function $f268b97836dca6b6$var$createSVGInlineRect(color, left, top, width, height) {
    return "\t\t".concat($f268b97836dca6b6$var$createSVGRect(color, {
        left: left,
        top: top,
        width: width,
        height: height
    }), "\n");
}
class $f268b97836dca6b6$var$TextSVGExportMixin extends $f268b97836dca6b6$var$FabricObjectSVGExportMixin {
    _toSVG() {
        const offsets = this._getSVGLeftTopOffsets(), textAndBg = this._getSVGTextAndBg(offsets.textTop, offsets.textLeft);
        return this._wrapSVGTextAndBg(textAndBg);
    }
    toSVG(reviver) {
        const textSvg = this._createBaseSVGMarkup(this._toSVG(), {
            reviver: reviver,
            noStyle: true,
            withShadow: true
        }), path = this.path;
        if (path) return textSvg + path._createBaseSVGMarkup(path._toSVG(), {
            reviver: reviver,
            withShadow: true,
            additionalTransform: $f268b97836dca6b6$var$matrixToSVG(this.calcOwnMatrix())
        });
        return textSvg;
    }
    _getSVGLeftTopOffsets() {
        return {
            textLeft: -this.width / 2,
            textTop: -this.height / 2,
            lineTop: this.getHeightOfLine(0)
        };
    }
    _wrapSVGTextAndBg(_ref) {
        let { textBgRects: textBgRects, textSpans: textSpans } = _ref;
        const noShadow = true, textDecoration = this.getSvgTextDecoration(this);
        return [
            textBgRects.join(''),
            '\t\t<text xml:space="preserve" ',
            "font-family=\"".concat(this.fontFamily.replace($f268b97836dca6b6$var$dblQuoteRegex, "'"), "\" "),
            "font-size=\"".concat(this.fontSize, "\" "),
            this.fontStyle ? "font-style=\"".concat(this.fontStyle, "\" ") : '',
            this.fontWeight ? "font-weight=\"".concat(this.fontWeight, "\" ") : '',
            textDecoration ? "text-decoration=\"".concat(textDecoration, "\" ") : '',
            this.direction === 'rtl' ? "direction=\"".concat(this.direction, "\" ") : '',
            'style="',
            this.getSvgStyles(noShadow),
            '"',
            this.addPaintOrder(),
            ' >',
            textSpans.join(''),
            '</text>\n'
        ];
    }
    /**
   * @private
   * @param {Number} textTopOffset Text top offset
   * @param {Number} textLeftOffset Text left offset
   * @return {Object}
   */ _getSVGTextAndBg(textTopOffset, textLeftOffset) {
        const textSpans = [], textBgRects = [];
        let height = textTopOffset, lineOffset;
        // bounding-box background
        this.backgroundColor && textBgRects.push(...$f268b97836dca6b6$var$createSVGInlineRect(this.backgroundColor, -this.width / 2, -this.height / 2, this.width, this.height));
        // text and text-background
        for(let i = 0, len = this._textLines.length; i < len; i++){
            lineOffset = this._getLineLeftOffset(i);
            if (this.direction === 'rtl') lineOffset += this.width;
            if (this.textBackgroundColor || this.styleHas('textBackgroundColor', i)) this._setSVGTextLineBg(textBgRects, i, textLeftOffset + lineOffset, height);
            this._setSVGTextLineText(textSpans, i, textLeftOffset + lineOffset, height);
            height += this.getHeightOfLine(i);
        }
        return {
            textSpans: textSpans,
            textBgRects: textBgRects
        };
    }
    _createTextCharSpan(char, styleDecl, left, top, charBox) {
        const numFractionDigit = $f268b97836dca6b6$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS;
        const styleProps = this.getSvgSpanStyles(styleDecl, char !== char.trim() || !!char.match($f268b97836dca6b6$var$multipleSpacesRegex)), fillStyles = styleProps ? "style=\"".concat(styleProps, "\"") : '', dy = styleDecl.deltaY, dySpan = dy ? " dy=\"".concat($f268b97836dca6b6$var$toFixed(dy, numFractionDigit), "\" ") : '', { angle: angle, renderLeft: renderLeft, renderTop: renderTop, width: width } = charBox;
        let angleAttr = '';
        if (renderLeft !== undefined) {
            const wBy2 = width / 2;
            angle && (angleAttr = " rotate=\"".concat($f268b97836dca6b6$var$toFixed($f268b97836dca6b6$var$radiansToDegrees(angle), numFractionDigit), "\""));
            const m = $f268b97836dca6b6$var$createRotateMatrix({
                angle: $f268b97836dca6b6$var$radiansToDegrees(angle)
            });
            m[4] = renderLeft;
            m[5] = renderTop;
            const renderPoint = new $f268b97836dca6b6$export$baf26146a414f24a(-wBy2, 0).transform(m);
            left = renderPoint.x;
            top = renderPoint.y;
        }
        return "<tspan x=\"".concat($f268b97836dca6b6$var$toFixed(left, numFractionDigit), "\" y=\"").concat($f268b97836dca6b6$var$toFixed(top, numFractionDigit), "\" ").concat(dySpan).concat(angleAttr).concat(fillStyles, ">").concat($f268b97836dca6b6$var$escapeXml(char), "</tspan>");
    }
    _setSVGTextLineText(textSpans, lineIndex, textLeftOffset, textTopOffset) {
        const lineHeight = this.getHeightOfLine(lineIndex), isJustify = this.textAlign.includes($f268b97836dca6b6$var$JUSTIFY), line = this._textLines[lineIndex];
        let actualStyle, nextStyle, charsToRender = '', charBox, style, boxWidth = 0, timeToRender;
        textTopOffset += lineHeight * (1 - this._fontSizeFraction) / this.lineHeight;
        for(let i = 0, len = line.length - 1; i <= len; i++){
            timeToRender = i === len || this.charSpacing || this.path;
            charsToRender += line[i];
            charBox = this.__charBounds[lineIndex][i];
            if (boxWidth === 0) {
                textLeftOffset += charBox.kernedWidth - charBox.width;
                boxWidth += charBox.width;
            } else boxWidth += charBox.kernedWidth;
            if (isJustify && !timeToRender) {
                if (this._reSpaceAndTab.test(line[i])) timeToRender = true;
            }
            if (!timeToRender) {
                // if we have charSpacing or a path, we render char by char
                actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
                nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
                timeToRender = $f268b97836dca6b6$var$hasStyleChanged(actualStyle, nextStyle, true);
            }
            if (timeToRender) {
                style = this._getStyleDeclaration(lineIndex, i);
                textSpans.push(this._createTextCharSpan(charsToRender, style, textLeftOffset, textTopOffset, charBox));
                charsToRender = '';
                actualStyle = nextStyle;
                if (this.direction === 'rtl') textLeftOffset -= boxWidth;
                else textLeftOffset += boxWidth;
                boxWidth = 0;
            }
        }
    }
    _setSVGTextLineBg(textBgRects, i, leftOffset, textTopOffset) {
        const line = this._textLines[i], heightOfLine = this.getHeightOfLine(i) / this.lineHeight;
        let boxWidth = 0, boxStart = 0, currentColor, lastColor = this.getValueOfPropertyAt(i, 0, 'textBackgroundColor');
        for(let j = 0; j < line.length; j++){
            const { left: left, width: width, kernedWidth: kernedWidth } = this.__charBounds[i][j];
            currentColor = this.getValueOfPropertyAt(i, j, 'textBackgroundColor');
            if (currentColor !== lastColor) {
                lastColor && textBgRects.push(...$f268b97836dca6b6$var$createSVGInlineRect(lastColor, leftOffset + boxStart, textTopOffset, boxWidth, heightOfLine));
                boxStart = left;
                boxWidth = width;
                lastColor = currentColor;
            } else boxWidth += kernedWidth;
        }
        currentColor && textBgRects.push(...$f268b97836dca6b6$var$createSVGInlineRect(lastColor, leftOffset + boxStart, textTopOffset, boxWidth, heightOfLine));
    }
    /**
   * @deprecated unused
   */ _getSVGLineTopOffset(lineIndex) {
        let lineTopOffset = 0, j;
        for(j = 0; j < lineIndex; j++)lineTopOffset += this.getHeightOfLine(j);
        const lastHeight = this.getHeightOfLine(j);
        return {
            lineTop: lineTopOffset,
            offset: (this._fontSizeMult - this._fontSizeFraction) * lastHeight / (this.lineHeight * this._fontSizeMult)
        };
    }
    /**
   * Returns styles-string for svg-export
   * @param {Boolean} skipShadow a boolean to skip shadow filter output
   * @return {String}
   */ getSvgStyles(skipShadow) {
        return "".concat(super.getSvgStyles(skipShadow), " text-decoration-thickness: ").concat($f268b97836dca6b6$var$toFixed(this.textDecorationThickness * this.getObjectScaling().y / 10, $f268b97836dca6b6$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS), "%; white-space: pre;");
    }
    /**
   * Returns styles-string for svg-export
   * @param {Object} style the object from which to retrieve style properties
   * @param {Boolean} useWhiteSpace a boolean to include an additional attribute in the style.
   * @return {String}
   */ getSvgSpanStyles(style, useWhiteSpace) {
        const { fontFamily: fontFamily, strokeWidth: strokeWidth, stroke: stroke, fill: fill, fontSize: fontSize, fontStyle: fontStyle, fontWeight: fontWeight, deltaY: deltaY, textDecorationThickness: textDecorationThickness, linethrough: linethrough, overline: overline, underline: underline } = style;
        const textDecoration = this.getSvgTextDecoration({
            underline: underline !== null && underline !== void 0 ? underline : this.underline,
            overline: overline !== null && overline !== void 0 ? overline : this.overline,
            linethrough: linethrough !== null && linethrough !== void 0 ? linethrough : this.linethrough
        });
        const thickness = textDecorationThickness || this.textDecorationThickness;
        return [
            stroke ? $f268b97836dca6b6$var$colorPropToSVG($f268b97836dca6b6$var$STROKE, stroke) : '',
            strokeWidth ? "stroke-width: ".concat(strokeWidth, "; ") : '',
            fontFamily ? "font-family: ".concat(!fontFamily.includes("'") && !fontFamily.includes('"') ? "'".concat(fontFamily, "'") : fontFamily, "; ") : '',
            fontSize ? "font-size: ".concat(fontSize, "px; ") : '',
            fontStyle ? "font-style: ".concat(fontStyle, "; ") : '',
            fontWeight ? "font-weight: ".concat(fontWeight, "; ") : '',
            textDecoration ? "text-decoration: ".concat(textDecoration, "; text-decoration-thickness: ").concat($f268b97836dca6b6$var$toFixed(thickness * this.getObjectScaling().y / 10, $f268b97836dca6b6$export$e506a1d27d1eaa20.NUM_FRACTION_DIGITS), "%; ") : '',
            fill ? $f268b97836dca6b6$var$colorPropToSVG($f268b97836dca6b6$var$FILL, fill) : '',
            deltaY ? "baseline-shift: ".concat(-deltaY, "; ") : '',
            useWhiteSpace ? 'white-space: pre; ' : ''
        ].join('');
    }
    /**
   * Returns text-decoration property for svg-export
   * @param {Object} style the object from which to retrieve style properties
   * @return {String}
   */ getSvgTextDecoration(style) {
        return [
            'overline',
            'underline',
            'line-through'
        ].filter((decoration)=>style[decoration.replace('-', '')]).join(' ');
    }
}
const $f268b97836dca6b6$var$_excluded$3 = [
    "textAnchor",
    "textDecoration",
    "dx",
    "dy",
    "top",
    "left",
    "fontSize",
    "strokeWidth"
];
let $f268b97836dca6b6$var$measuringContext;
/**
 * Return a context for measurement of text string.
 * if created it gets stored for reuse
 */ function $f268b97836dca6b6$var$getMeasuringContext() {
    if (!$f268b97836dca6b6$var$measuringContext) {
        const canvas = $f268b97836dca6b6$var$createCanvasElementFor({
            width: 0,
            height: 0
        });
        $f268b97836dca6b6$var$measuringContext = canvas.getContext('2d');
    }
    return $f268b97836dca6b6$var$measuringContext;
}
/**
 * Measure and return the info of a single grapheme.
 * needs the the info of previous graphemes already filled
 * Override to customize measuring
 */ // @TODO this is not complete
/**
 * Text class
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-2#text}
 */ class $f268b97836dca6b6$export$72cf63a35cb577f7 extends $f268b97836dca6b6$var$StyledText {
    static getDefaults() {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.getDefaults()), $f268b97836dca6b6$export$72cf63a35cb577f7.ownDefaults);
    }
    /**
   * If text has a path, it will add the extra information needed
   * for path and text calculations
   */ setPathInfo() {
        const path = this.path;
        if (path) path.segmentsInfo = $f268b97836dca6b6$var$getPathSegmentsInfo(path.path);
    }
    /**
   * @private
   * Divides text into lines of text and lines of graphemes.
   */ _splitText() {
        const newLines = this._splitTextIntoLines(this.text);
        this.textLines = newLines.lines;
        this._textLines = newLines.graphemeLines;
        this._unwrappedTextLines = newLines._unwrappedLines;
        this._text = newLines.graphemeText;
        return newLines;
    }
    /**
   * Initialize or update text dimensions.
   * Updates this.width and this.height with the proper values.
   * Does not return dimensions.
   */ initDimensions() {
        this._splitText();
        this._clearCache();
        this.dirty = true;
        if (this.path) {
            this.width = this.path.width;
            this.height = this.path.height;
        } else {
            this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH;
            this.height = this.calcTextHeight();
        }
        if (this.textAlign.includes($f268b97836dca6b6$var$JUSTIFY)) // once text is measured we need to make space fatter to make justified text.
        this.enlargeSpaces();
    }
    /**
   * Enlarge space boxes and shift the others
   */ enlargeSpaces() {
        let diffSpace, currentLineWidth, numberOfSpaces, accumulatedSpace, line, charBound, spaces;
        for(let i = 0, len = this._textLines.length; i < len; i++){
            if (this.textAlign !== $f268b97836dca6b6$var$JUSTIFY && (i === len - 1 || this.isEndOfWrapping(i))) continue;
            accumulatedSpace = 0;
            line = this._textLines[i];
            currentLineWidth = this.getLineWidth(i);
            if (currentLineWidth < this.width && (spaces = this.textLines[i].match(this._reSpacesAndTabs))) {
                numberOfSpaces = spaces.length;
                diffSpace = (this.width - currentLineWidth) / numberOfSpaces;
                for(let j = 0; j <= line.length; j++){
                    charBound = this.__charBounds[i][j];
                    if (this._reSpaceAndTab.test(line[j])) {
                        charBound.width += diffSpace;
                        charBound.kernedWidth += diffSpace;
                        charBound.left += accumulatedSpace;
                        accumulatedSpace += diffSpace;
                    } else charBound.left += accumulatedSpace;
                }
            }
        }
    }
    /**
   * Detect if the text line is ended with an hard break
   * text and itext do not have wrapping, return false
   * @return {Boolean}
   */ isEndOfWrapping(lineIndex) {
        return lineIndex === this._textLines.length - 1;
    }
    /**
   * Detect if a line has a linebreak and so we need to account for it when moving
   * and counting style.
   * It return always 1 for text and Itext. Textbox has its own implementation
   * @return Number
   */ missingNewlineOffset(_lineIndex) {
        return 1;
    }
    /**
   * Returns 2d representation (lineIndex and charIndex) of cursor
   * @param {Number} selectionStart
   * @param {Boolean} [skipWrapping] consider the location for unwrapped lines. useful to manage styles.
   */ get2DCursorLocation(selectionStart, skipWrapping) {
        const lines = skipWrapping ? this._unwrappedTextLines : this._textLines;
        let i;
        for(i = 0; i < lines.length; i++){
            if (selectionStart <= lines[i].length) return {
                lineIndex: i,
                charIndex: selectionStart
            };
            selectionStart -= lines[i].length + this.missingNewlineOffset(i, skipWrapping);
        }
        return {
            lineIndex: i - 1,
            charIndex: lines[i - 1].length < selectionStart ? lines[i - 1].length : selectionStart
        };
    }
    /**
   * Returns string representation of an instance
   * @return {String} String representation of text object
   */ toString() {
        return "#<Text (".concat(this.complexity(), "): { \"text\": \"").concat(this.text, "\", \"fontFamily\": \"").concat(this.fontFamily, "\" }>");
    }
    /**
   * Return the dimension and the zoom level needed to create a cache canvas
   * big enough to host the object to be cached.
   * @private
   * @param {Object} dim.x width of object to be cached
   * @param {Object} dim.y height of object to be cached
   * @return {Object}.width width of canvas
   * @return {Object}.height height of canvas
   * @return {Object}.zoomX zoomX zoom value to unscale the canvas before drawing cache
   * @return {Object}.zoomY zoomY zoom value to unscale the canvas before drawing cache
   */ _getCacheCanvasDimensions() {
        const dims = super._getCacheCanvasDimensions();
        const fontSize = this.fontSize;
        dims.width += fontSize * dims.zoomX;
        dims.height += fontSize * dims.zoomY;
        return dims;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _render(ctx) {
        const path = this.path;
        path && !path.isNotVisible() && path._render(ctx);
        this._setTextStyles(ctx);
        this._renderTextLinesBackground(ctx);
        this._renderTextDecoration(ctx, 'underline');
        this._renderText(ctx);
        this._renderTextDecoration(ctx, 'overline');
        this._renderTextDecoration(ctx, 'linethrough');
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderText(ctx) {
        if (this.paintFirst === $f268b97836dca6b6$var$STROKE) {
            this._renderTextStroke(ctx);
            this._renderTextFill(ctx);
        } else {
            this._renderTextFill(ctx);
            this._renderTextStroke(ctx);
        }
    }
    /**
   * Set the font parameter of the context with the object properties or with charStyle
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {Object} [charStyle] object with font style properties
   * @param {String} [charStyle.fontFamily] Font Family
   * @param {Number} [charStyle.fontSize] Font size in pixels. ( without px suffix )
   * @param {String} [charStyle.fontWeight] Font weight
   * @param {String} [charStyle.fontStyle] Font style (italic|normal)
   */ _setTextStyles(ctx, charStyle, forMeasuring) {
        ctx.textBaseline = 'alphabetic';
        if (this.path) switch(this.pathAlign){
            case $f268b97836dca6b6$var$CENTER:
                ctx.textBaseline = 'middle';
                break;
            case 'ascender':
                ctx.textBaseline = $f268b97836dca6b6$var$TOP;
                break;
            case 'descender':
                ctx.textBaseline = $f268b97836dca6b6$var$BOTTOM;
                break;
        }
        ctx.font = this._getFontDeclaration(charStyle, forMeasuring);
    }
    /**
   * calculate and return the text Width measuring each line.
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @return {Number} Maximum width of Text object
   */ calcTextWidth() {
        let maxWidth = this.getLineWidth(0);
        for(let i = 1, len = this._textLines.length; i < len; i++){
            const currentLineWidth = this.getLineWidth(i);
            if (currentLineWidth > maxWidth) maxWidth = currentLineWidth;
        }
        return maxWidth;
    }
    /**
   * @private
   * @param {String} method Method name ("fillText" or "strokeText")
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {String} line Text to render
   * @param {Number} left Left position of text
   * @param {Number} top Top position of text
   * @param {Number} lineIndex Index of a line in a text
   */ _renderTextLine(method, ctx, line, left, top, lineIndex) {
        this._renderChars(method, ctx, line, left, top, lineIndex);
    }
    /**
   * Renders the text background for lines, taking care of style
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderTextLinesBackground(ctx) {
        if (!this.textBackgroundColor && !this.styleHas('textBackgroundColor')) return;
        const originalFill = ctx.fillStyle, leftOffset = this._getLeftOffset();
        let lineTopOffset = this._getTopOffset();
        for(let i = 0, len = this._textLines.length; i < len; i++){
            const heightOfLine = this.getHeightOfLine(i);
            if (!this.textBackgroundColor && !this.styleHas('textBackgroundColor', i)) {
                lineTopOffset += heightOfLine;
                continue;
            }
            const jlen = this._textLines[i].length;
            const lineLeftOffset = this._getLineLeftOffset(i);
            let boxWidth = 0;
            let boxStart = 0;
            let drawStart;
            let currentColor;
            let lastColor = this.getValueOfPropertyAt(i, 0, 'textBackgroundColor');
            const bgHeight = this.getHeightOfLineImpl(i);
            for(let j = 0; j < jlen; j++){
                // at this point charbox are either standard or full with pathInfo if there is a path.
                const charBox = this.__charBounds[i][j];
                currentColor = this.getValueOfPropertyAt(i, j, 'textBackgroundColor');
                if (this.path) {
                    ctx.save();
                    ctx.translate(charBox.renderLeft, charBox.renderTop);
                    ctx.rotate(charBox.angle);
                    ctx.fillStyle = currentColor;
                    currentColor && ctx.fillRect(-charBox.width / 2, -bgHeight * (1 - this._fontSizeFraction), charBox.width, bgHeight);
                    ctx.restore();
                } else if (currentColor !== lastColor) {
                    drawStart = leftOffset + lineLeftOffset + boxStart;
                    if (this.direction === 'rtl') drawStart = this.width - drawStart - boxWidth;
                    ctx.fillStyle = lastColor;
                    lastColor && ctx.fillRect(drawStart, lineTopOffset, boxWidth, bgHeight);
                    boxStart = charBox.left;
                    boxWidth = charBox.width;
                    lastColor = currentColor;
                } else boxWidth += charBox.kernedWidth;
            }
            if (currentColor && !this.path) {
                drawStart = leftOffset + lineLeftOffset + boxStart;
                if (this.direction === 'rtl') drawStart = this.width - drawStart - boxWidth;
                ctx.fillStyle = currentColor;
                ctx.fillRect(drawStart, lineTopOffset, boxWidth, bgHeight);
            }
            lineTopOffset += heightOfLine;
        }
        ctx.fillStyle = originalFill;
        // if there is text background color no
        // other shadows should be casted
        this._removeShadow(ctx);
    }
    /**
   * measure and return the width of a single character.
   * possibly overridden to accommodate different measure logic or
   * to hook some external lib for character measurement
   * @private
   * @param {String} _char, char to be measured
   * @param {Object} charStyle style of char to be measured
   * @param {String} [previousChar] previous char
   * @param {Object} [prevCharStyle] style of previous char
   */ _measureChar(_char, charStyle, previousChar, prevCharStyle) {
        const fontCache = $f268b97836dca6b6$export$69a3209f1a06c04d.getFontCache(charStyle), fontDeclaration = this._getFontDeclaration(charStyle), couple = previousChar ? previousChar + _char : _char, stylesAreEqual = previousChar && fontDeclaration === this._getFontDeclaration(prevCharStyle), fontMultiplier = charStyle.fontSize / this.CACHE_FONT_SIZE;
        let width, coupleWidth, previousWidth, kernedWidth;
        if (previousChar && fontCache.has(previousChar)) previousWidth = fontCache.get(previousChar);
        if (fontCache.has(_char)) kernedWidth = width = fontCache.get(_char);
        if (stylesAreEqual && fontCache.has(couple)) {
            coupleWidth = fontCache.get(couple);
            kernedWidth = coupleWidth - previousWidth;
        }
        if (width === undefined || previousWidth === undefined || coupleWidth === undefined) {
            const ctx = $f268b97836dca6b6$var$getMeasuringContext();
            // send a TRUE to specify measuring font size CACHE_FONT_SIZE
            this._setTextStyles(ctx, charStyle, true);
            if (width === undefined) {
                kernedWidth = width = ctx.measureText(_char).width;
                fontCache.set(_char, width);
            }
            if (previousWidth === undefined && stylesAreEqual && previousChar) {
                previousWidth = ctx.measureText(previousChar).width;
                fontCache.set(previousChar, previousWidth);
            }
            if (stylesAreEqual && coupleWidth === undefined) {
                // we can measure the kerning couple and subtract the width of the previous character
                coupleWidth = ctx.measureText(couple).width;
                fontCache.set(couple, coupleWidth);
                // safe to use the non-null since if undefined we defined it before.
                kernedWidth = coupleWidth - previousWidth;
            }
        }
        return {
            width: width * fontMultiplier,
            kernedWidth: kernedWidth * fontMultiplier
        };
    }
    /**
   * Computes height of character at given position
   * @param {Number} line the line index number
   * @param {Number} _char the character index number
   * @return {Number} fontSize of the character
   */ getHeightOfChar(line, _char) {
        return this.getValueOfPropertyAt(line, _char, 'fontSize');
    }
    /**
   * measure a text line measuring all characters.
   * @param {Number} lineIndex line number
   */ measureLine(lineIndex) {
        const lineInfo = this._measureLine(lineIndex);
        if (this.charSpacing !== 0) lineInfo.width -= this._getWidthOfCharSpacing();
        if (lineInfo.width < 0) lineInfo.width = 0;
        return lineInfo;
    }
    /**
   * measure every grapheme of a line, populating __charBounds
   * @param {Number} lineIndex
   * @return {Object} object.width total width of characters
   * @return {Object} object.numOfSpaces length of chars that match this._reSpacesAndTabs
   */ _measureLine(lineIndex) {
        let width = 0, prevGrapheme, graphemeInfo;
        const reverse = this.pathSide === $f268b97836dca6b6$var$RIGHT, path = this.path, line = this._textLines[lineIndex], llength = line.length, lineBounds = new Array(llength);
        this.__charBounds[lineIndex] = lineBounds;
        for(let i = 0; i < llength; i++){
            const grapheme = line[i];
            graphemeInfo = this._getGraphemeBox(grapheme, lineIndex, i, prevGrapheme);
            lineBounds[i] = graphemeInfo;
            width += graphemeInfo.kernedWidth;
            prevGrapheme = grapheme;
        }
        // this latest bound box represent the last character of the line
        // to simplify cursor handling in interactive mode.
        lineBounds[llength] = {
            left: graphemeInfo ? graphemeInfo.left + graphemeInfo.width : 0,
            width: 0,
            kernedWidth: 0,
            height: this.fontSize,
            deltaY: 0
        };
        if (path && path.segmentsInfo) {
            let positionInPath = 0;
            const totalPathLength = path.segmentsInfo[path.segmentsInfo.length - 1].length;
            switch(this.textAlign){
                case $f268b97836dca6b6$var$LEFT:
                    positionInPath = reverse ? totalPathLength - width : 0;
                    break;
                case $f268b97836dca6b6$var$CENTER:
                    positionInPath = (totalPathLength - width) / 2;
                    break;
                case $f268b97836dca6b6$var$RIGHT:
                    positionInPath = reverse ? 0 : totalPathLength - width;
                    break;
            }
            positionInPath += this.pathStartOffset * (reverse ? -1 : 1);
            for(let i = reverse ? llength - 1 : 0; reverse ? i >= 0 : i < llength; reverse ? i-- : i++){
                graphemeInfo = lineBounds[i];
                if (positionInPath > totalPathLength) positionInPath %= totalPathLength;
                else if (positionInPath < 0) positionInPath += totalPathLength;
                // it would probably much faster to send all the grapheme position for a line
                // and calculate path position/angle at once.
                this._setGraphemeOnPath(positionInPath, graphemeInfo);
                positionInPath += graphemeInfo.kernedWidth;
            }
        }
        return {
            width: width,
            numOfSpaces: 0
        };
    }
    /**
   * Calculate the angle  and the left,top position of the char that follow a path.
   * It appends it to graphemeInfo to be reused later at rendering
   * @private
   * @param {Number} positionInPath to be measured
   * @param {GraphemeBBox} graphemeInfo current grapheme box information
   * @param {Object} startingPoint position of the point
   */ _setGraphemeOnPath(positionInPath, graphemeInfo) {
        const centerPosition = positionInPath + graphemeInfo.kernedWidth / 2, path = this.path;
        // we are at currentPositionOnPath. we want to know what point on the path is.
        const info = $f268b97836dca6b6$var$getPointOnPath(path.path, centerPosition, path.segmentsInfo);
        graphemeInfo.renderLeft = info.x - path.pathOffset.x;
        graphemeInfo.renderTop = info.y - path.pathOffset.y;
        graphemeInfo.angle = info.angle + (this.pathSide === $f268b97836dca6b6$var$RIGHT ? Math.PI : 0);
    }
    /**
   *
   * @param {String} grapheme to be measured
   * @param {Number} lineIndex index of the line where the char is
   * @param {Number} charIndex position in the line
   * @param {String} [prevGrapheme] character preceding the one to be measured
   * @returns {GraphemeBBox} grapheme bbox
   */ _getGraphemeBox(grapheme, lineIndex, charIndex, prevGrapheme, skipLeft) {
        const style = this.getCompleteStyleDeclaration(lineIndex, charIndex), prevStyle = prevGrapheme ? this.getCompleteStyleDeclaration(lineIndex, charIndex - 1) : {}, info = this._measureChar(grapheme, style, prevGrapheme, prevStyle);
        let kernedWidth = info.kernedWidth, width = info.width, charSpacing;
        if (this.charSpacing !== 0) {
            charSpacing = this._getWidthOfCharSpacing();
            width += charSpacing;
            kernedWidth += charSpacing;
        }
        const box = {
            width: width,
            left: 0,
            height: style.fontSize,
            kernedWidth: kernedWidth,
            deltaY: style.deltaY
        };
        if (charIndex > 0 && !skipLeft) {
            const previousBox = this.__charBounds[lineIndex][charIndex - 1];
            box.left = previousBox.left + previousBox.width + info.kernedWidth - info.width;
        }
        return box;
    }
    /**
   * Calculate height of line at 'lineIndex',
   * without the lineHeigth multiplication factor
   * @private
   * @param {Number} lineIndex index of line to calculate
   * @return {Number}
   */ getHeightOfLineImpl(lineIndex) {
        const lh = this.__lineHeights;
        if (lh[lineIndex]) return lh[lineIndex];
        // char 0 is measured before the line cycle because it needs to char
        // emptylines
        let maxHeight = this.getHeightOfChar(lineIndex, 0);
        for(let i = 1, len = this._textLines[lineIndex].length; i < len; i++)maxHeight = Math.max(this.getHeightOfChar(lineIndex, i), maxHeight);
        return lh[lineIndex] = maxHeight * this._fontSizeMult;
    }
    /**
   * Calculate height of line at 'lineIndex'
   * @param {Number} lineIndex index of line to calculate
   * @return {Number}
   */ getHeightOfLine(lineIndex) {
        return this.getHeightOfLineImpl(lineIndex) * this.lineHeight;
    }
    /**
   * Calculate text box height
   */ calcTextHeight() {
        let height = 0;
        for(let i = 0, len = this._textLines.length; i < len; i++)height += i === len - 1 ? this.getHeightOfLineImpl(i) : this.getHeightOfLine(i);
        return height;
    }
    /**
   * @private
   * @return {Number} Left offset
   */ _getLeftOffset() {
        return this.direction === 'ltr' ? -this.width / 2 : this.width / 2;
    }
    /**
   * @private
   * @return {Number} Top offset
   */ _getTopOffset() {
        return -this.height / 2;
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {String} method Method name ("fillText" or "strokeText")
   */ _renderTextCommon(ctx, method) {
        ctx.save();
        let lineHeights = 0;
        const left = this._getLeftOffset(), top = this._getTopOffset();
        for(let i = 0, len = this._textLines.length; i < len; i++){
            this._renderTextLine(method, ctx, this._textLines[i], left + this._getLineLeftOffset(i), top + lineHeights + this.getHeightOfLineImpl(i), i);
            lineHeights += this.getHeightOfLine(i);
        }
        ctx.restore();
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderTextFill(ctx) {
        if (!this.fill && !this.styleHas($f268b97836dca6b6$var$FILL)) return;
        this._renderTextCommon(ctx, 'fillText');
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderTextStroke(ctx) {
        if ((!this.stroke || this.strokeWidth === 0) && this.isEmptyStyles()) return;
        if (this.shadow && !this.shadow.affectStroke) this._removeShadow(ctx);
        ctx.save();
        this._setLineDash(ctx, this.strokeDashArray);
        ctx.beginPath();
        this._renderTextCommon(ctx, 'strokeText');
        ctx.closePath();
        ctx.restore();
    }
    /**
   * @private
   * @param {String} method fillText or strokeText.
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {Array} line Content of the line, splitted in an array by grapheme
   * @param {Number} left
   * @param {Number} top
   * @param {Number} lineIndex
   */ _renderChars(method, ctx, line, left, top, lineIndex) {
        const isJustify = this.textAlign.includes($f268b97836dca6b6$var$JUSTIFY), path = this.path, shortCut = !isJustify && this.charSpacing === 0 && this.isEmptyStyles(lineIndex) && !path, isLtr = this.direction === 'ltr', sign = this.direction === 'ltr' ? 1 : -1, // this was changed in the PR #7674
        // currentDirection = ctx.canvas.getAttribute('dir');
        currentDirection = ctx.direction;
        let actualStyle, nextStyle, charsToRender = '', charBox, boxWidth = 0, timeToRender, drawingLeft;
        ctx.save();
        if (currentDirection !== this.direction) {
            ctx.canvas.setAttribute('dir', isLtr ? 'ltr' : 'rtl');
            ctx.direction = isLtr ? 'ltr' : 'rtl';
            ctx.textAlign = isLtr ? $f268b97836dca6b6$var$LEFT : $f268b97836dca6b6$var$RIGHT;
        }
        top -= this.getHeightOfLineImpl(lineIndex) * this._fontSizeFraction;
        if (shortCut) {
            // render all the line in one pass without checking
            // drawingLeft = isLtr ? left : left - this.getLineWidth(lineIndex);
            this._renderChar(method, ctx, lineIndex, 0, line.join(''), left, top);
            ctx.restore();
            return;
        }
        for(let i = 0, len = line.length - 1; i <= len; i++){
            timeToRender = i === len || this.charSpacing || path;
            charsToRender += line[i];
            charBox = this.__charBounds[lineIndex][i];
            if (boxWidth === 0) {
                left += sign * (charBox.kernedWidth - charBox.width);
                boxWidth += charBox.width;
            } else boxWidth += charBox.kernedWidth;
            if (isJustify && !timeToRender) {
                if (this._reSpaceAndTab.test(line[i])) timeToRender = true;
            }
            if (!timeToRender) {
                // if we have charSpacing, we render char by char
                actualStyle = actualStyle || this.getCompleteStyleDeclaration(lineIndex, i);
                nextStyle = this.getCompleteStyleDeclaration(lineIndex, i + 1);
                timeToRender = $f268b97836dca6b6$var$hasStyleChanged(actualStyle, nextStyle, false);
            }
            if (timeToRender) {
                if (path) {
                    ctx.save();
                    ctx.translate(charBox.renderLeft, charBox.renderTop);
                    ctx.rotate(charBox.angle);
                    this._renderChar(method, ctx, lineIndex, i, charsToRender, -boxWidth / 2, 0);
                    ctx.restore();
                } else {
                    drawingLeft = left;
                    this._renderChar(method, ctx, lineIndex, i, charsToRender, drawingLeft, top);
                }
                charsToRender = '';
                actualStyle = nextStyle;
                left += sign * boxWidth;
                boxWidth = 0;
            }
        }
        ctx.restore();
    }
    /**
   * This function try to patch the missing gradientTransform on canvas gradients.
   * transforming a context to transform the gradient, is going to transform the stroke too.
   * we want to transform the gradient but not the stroke operation, so we create
   * a transformed gradient on a pattern and then we use the pattern instead of the gradient.
   * this method has drawbacks: is slow, is in low resolution, needs a patch for when the size
   * is limited.
   * @private
   * @param {TFiller} filler a fabric gradient instance
   * @return {CanvasPattern} a pattern to use as fill/stroke style
   */ _applyPatternGradientTransformText(filler) {
        // TODO: verify compatibility with strokeUniform
        const width = this.width + this.strokeWidth, height = this.height + this.strokeWidth, pCanvas = $f268b97836dca6b6$var$createCanvasElementFor({
            width: width,
            height: height
        }), pCtx = pCanvas.getContext('2d');
        pCanvas.width = width;
        pCanvas.height = height;
        pCtx.beginPath();
        pCtx.moveTo(0, 0);
        pCtx.lineTo(width, 0);
        pCtx.lineTo(width, height);
        pCtx.lineTo(0, height);
        pCtx.closePath();
        pCtx.translate(width / 2, height / 2);
        pCtx.fillStyle = filler.toLive(pCtx);
        this._applyPatternGradientTransform(pCtx, filler);
        pCtx.fill();
        return pCtx.createPattern(pCanvas, 'no-repeat');
    }
    handleFiller(ctx, property, filler) {
        let offsetX, offsetY;
        if ($f268b97836dca6b6$var$isFiller(filler)) {
            if (filler.gradientUnits === 'percentage' || filler.gradientTransform || filler.patternTransform) {
                // need to transform gradient in a pattern.
                // this is a slow process. If you are hitting this codepath, and the object
                // is not using caching, you should consider switching it on.
                // we need a canvas as big as the current object caching canvas.
                offsetX = -this.width / 2;
                offsetY = -this.height / 2;
                ctx.translate(offsetX, offsetY);
                ctx[property] = this._applyPatternGradientTransformText(filler);
                return {
                    offsetX: offsetX,
                    offsetY: offsetY
                };
            } else {
                // is a simple gradient or pattern
                ctx[property] = filler.toLive(ctx);
                return this._applyPatternGradientTransform(ctx, filler);
            }
        } else // is a color
        ctx[property] = filler;
        return {
            offsetX: 0,
            offsetY: 0
        };
    }
    /**
   * This function prepare the canvas for a stroke style, and stroke and strokeWidth
   * need to be sent in as defined
   * @param {CanvasRenderingContext2D} ctx
   * @param {CompleteTextStyleDeclaration} style with stroke and strokeWidth defined
   * @returns
   */ _setStrokeStyles(ctx, _ref) {
        let { stroke: stroke, strokeWidth: strokeWidth } = _ref;
        ctx.lineWidth = strokeWidth;
        ctx.lineCap = this.strokeLineCap;
        ctx.lineDashOffset = this.strokeDashOffset;
        ctx.lineJoin = this.strokeLineJoin;
        ctx.miterLimit = this.strokeMiterLimit;
        return this.handleFiller(ctx, 'strokeStyle', stroke);
    }
    /**
   * This function prepare the canvas for a ill style, and fill
   * need to be sent in as defined
   * @param {CanvasRenderingContext2D} ctx
   * @param {CompleteTextStyleDeclaration} style with ill defined
   * @returns
   */ _setFillStyles(ctx, _ref2) {
        let { fill: fill } = _ref2;
        return this.handleFiller(ctx, 'fillStyle', fill);
    }
    /**
   * @private
   * @param {String} method
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @param {String} _char
   * @param {Number} left Left coordinate
   * @param {Number} top Top coordinate
   * @param {Number} lineHeight Height of the line
   */ _renderChar(method, ctx, lineIndex, charIndex, _char, left, top) {
        const decl = this._getStyleDeclaration(lineIndex, charIndex), fullDecl = this.getCompleteStyleDeclaration(lineIndex, charIndex), shouldFill = method === 'fillText' && fullDecl.fill, shouldStroke = method === 'strokeText' && fullDecl.stroke && fullDecl.strokeWidth;
        if (!shouldStroke && !shouldFill) return;
        ctx.save();
        ctx.font = this._getFontDeclaration(fullDecl);
        if (decl.textBackgroundColor) this._removeShadow(ctx);
        if (decl.deltaY) top += decl.deltaY;
        if (shouldFill) {
            const fillOffsets = this._setFillStyles(ctx, fullDecl);
            ctx.fillText(_char, left - fillOffsets.offsetX, top - fillOffsets.offsetY);
        }
        if (shouldStroke) {
            const strokeOffsets = this._setStrokeStyles(ctx, fullDecl);
            ctx.strokeText(_char, left - strokeOffsets.offsetX, top - strokeOffsets.offsetY);
        }
        ctx.restore();
    }
    /**
   * Turns the character into a 'superior figure' (i.e. 'superscript')
   * @param {Number} start selection start
   * @param {Number} end selection end
   */ setSuperscript(start, end) {
        this._setScript(start, end, this.superscript);
    }
    /**
   * Turns the character into an 'inferior figure' (i.e. 'subscript')
   * @param {Number} start selection start
   * @param {Number} end selection end
   */ setSubscript(start, end) {
        this._setScript(start, end, this.subscript);
    }
    /**
   * Applies 'schema' at given position
   * @private
   * @param {Number} start selection start
   * @param {Number} end selection end
   * @param {Number} schema
   */ _setScript(start, end, schema) {
        const loc = this.get2DCursorLocation(start, true), fontSize = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, 'fontSize'), dy = this.getValueOfPropertyAt(loc.lineIndex, loc.charIndex, 'deltaY'), style = {
            fontSize: fontSize * schema.size,
            deltaY: dy + fontSize * schema.baseline
        };
        this.setSelectionStyles(style, start, end);
    }
    /**
   * @private
   * @param {Number} lineIndex index text line
   * @return {Number} Line left offset
   */ _getLineLeftOffset(lineIndex) {
        const lineWidth = this.getLineWidth(lineIndex), lineDiff = this.width - lineWidth, textAlign = this.textAlign, direction = this.direction, isEndOfWrapping = this.isEndOfWrapping(lineIndex);
        let leftOffset = 0;
        if (textAlign === $f268b97836dca6b6$var$JUSTIFY || textAlign === $f268b97836dca6b6$var$JUSTIFY_CENTER && !isEndOfWrapping || textAlign === $f268b97836dca6b6$var$JUSTIFY_RIGHT && !isEndOfWrapping || textAlign === $f268b97836dca6b6$var$JUSTIFY_LEFT && !isEndOfWrapping) return 0;
        if (textAlign === $f268b97836dca6b6$var$CENTER) leftOffset = lineDiff / 2;
        if (textAlign === $f268b97836dca6b6$var$RIGHT) leftOffset = lineDiff;
        if (textAlign === $f268b97836dca6b6$var$JUSTIFY_CENTER) leftOffset = lineDiff / 2;
        if (textAlign === $f268b97836dca6b6$var$JUSTIFY_RIGHT) leftOffset = lineDiff;
        if (direction === 'rtl') {
            if (textAlign === $f268b97836dca6b6$var$RIGHT || textAlign === $f268b97836dca6b6$var$JUSTIFY || textAlign === $f268b97836dca6b6$var$JUSTIFY_RIGHT) leftOffset = 0;
            else if (textAlign === $f268b97836dca6b6$var$LEFT || textAlign === $f268b97836dca6b6$var$JUSTIFY_LEFT) leftOffset = -lineDiff;
            else if (textAlign === $f268b97836dca6b6$var$CENTER || textAlign === $f268b97836dca6b6$var$JUSTIFY_CENTER) leftOffset = -lineDiff / 2;
        }
        return leftOffset;
    }
    /**
   * @private
   */ _clearCache() {
        this._forceClearCache = false;
        this.__lineWidths = [];
        this.__lineHeights = [];
        this.__charBounds = [];
    }
    /**
   * Measure a single line given its index. Used to calculate the initial
   * text bounding box. The values are calculated and stored in __lineWidths cache.
   * @private
   * @param {Number} lineIndex line number
   * @return {Number} Line width
   */ getLineWidth(lineIndex) {
        if (this.__lineWidths[lineIndex] !== undefined) return this.__lineWidths[lineIndex];
        const { width: width } = this.measureLine(lineIndex);
        this.__lineWidths[lineIndex] = width;
        return width;
    }
    _getWidthOfCharSpacing() {
        if (this.charSpacing !== 0) return this.fontSize * this.charSpacing / 1000;
        return 0;
    }
    /**
   * Retrieves the value of property at given character position
   * @param {Number} lineIndex the line number
   * @param {Number} charIndex the character number
   * @param {String} property the property name
   * @returns the value of 'property'
   */ getValueOfPropertyAt(lineIndex, charIndex, property) {
        var _charStyle$property;
        const charStyle = this._getStyleDeclaration(lineIndex, charIndex);
        return (_charStyle$property = charStyle[property]) !== null && _charStyle$property !== void 0 ? _charStyle$property : this[property];
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _renderTextDecoration(ctx, type) {
        if (!this[type] && !this.styleHas(type)) return;
        let topOffset = this._getTopOffset();
        const leftOffset = this._getLeftOffset(), path = this.path, charSpacing = this._getWidthOfCharSpacing(), offsetAligner = type === 'linethrough' ? 0.5 : type === 'overline' ? 1 : 0, offsetY = this.offsets[type];
        for(let i = 0, len = this._textLines.length; i < len; i++){
            const heightOfLine = this.getHeightOfLine(i);
            if (!this[type] && !this.styleHas(type, i)) {
                topOffset += heightOfLine;
                continue;
            }
            const line = this._textLines[i];
            const maxHeight = heightOfLine / this.lineHeight;
            const lineLeftOffset = this._getLineLeftOffset(i);
            let boxStart = 0;
            let boxWidth = 0;
            let lastDecoration = this.getValueOfPropertyAt(i, 0, type);
            let lastFill = this.getValueOfPropertyAt(i, 0, $f268b97836dca6b6$var$FILL);
            let lastTickness = this.getValueOfPropertyAt(i, 0, $f268b97836dca6b6$var$TEXT_DECORATION_THICKNESS);
            let currentDecoration = lastDecoration;
            let currentFill = lastFill;
            let currentTickness = lastTickness;
            const top = topOffset + maxHeight * (1 - this._fontSizeFraction);
            let size = this.getHeightOfChar(i, 0);
            let dy = this.getValueOfPropertyAt(i, 0, 'deltaY');
            for(let j = 0, jlen = line.length; j < jlen; j++){
                const charBox = this.__charBounds[i][j];
                currentDecoration = this.getValueOfPropertyAt(i, j, type);
                currentFill = this.getValueOfPropertyAt(i, j, $f268b97836dca6b6$var$FILL);
                currentTickness = this.getValueOfPropertyAt(i, j, $f268b97836dca6b6$var$TEXT_DECORATION_THICKNESS);
                const currentSize = this.getHeightOfChar(i, j);
                const currentDy = this.getValueOfPropertyAt(i, j, 'deltaY');
                if (path && currentDecoration && currentFill) {
                    const finalTickness = this.fontSize * currentTickness / 1000;
                    ctx.save();
                    // bug? verify lastFill is a valid fill here.
                    ctx.fillStyle = lastFill;
                    ctx.translate(charBox.renderLeft, charBox.renderTop);
                    ctx.rotate(charBox.angle);
                    ctx.fillRect(-charBox.kernedWidth / 2, offsetY * currentSize + currentDy - offsetAligner * finalTickness, charBox.kernedWidth, finalTickness);
                    ctx.restore();
                } else if ((currentDecoration !== lastDecoration || currentFill !== lastFill || currentSize !== size || currentTickness !== lastTickness || currentDy !== dy) && boxWidth > 0) {
                    const finalTickness = this.fontSize * lastTickness / 1000;
                    let drawStart = leftOffset + lineLeftOffset + boxStart;
                    if (this.direction === 'rtl') drawStart = this.width - drawStart - boxWidth;
                    if (lastDecoration && lastFill && lastTickness) {
                        // bug? verify lastFill is a valid fill here.
                        ctx.fillStyle = lastFill;
                        ctx.fillRect(drawStart, top + offsetY * size + dy - offsetAligner * finalTickness, boxWidth, finalTickness);
                    }
                    boxStart = charBox.left;
                    boxWidth = charBox.width;
                    lastDecoration = currentDecoration;
                    lastTickness = currentTickness;
                    lastFill = currentFill;
                    size = currentSize;
                    dy = currentDy;
                } else boxWidth += charBox.kernedWidth;
            }
            let drawStart = leftOffset + lineLeftOffset + boxStart;
            if (this.direction === 'rtl') drawStart = this.width - drawStart - boxWidth;
            ctx.fillStyle = currentFill;
            const finalTickness = this.fontSize * currentTickness / 1000;
            currentDecoration && currentFill && currentTickness && ctx.fillRect(drawStart, top + offsetY * size + dy - offsetAligner * finalTickness, boxWidth - charSpacing, finalTickness);
            topOffset += heightOfLine;
        }
        // if there is text background color no
        // other shadows should be casted
        this._removeShadow(ctx);
    }
    /**
   * return font declaration string for canvas context
   * @param {Object} [styleObject] object
   * @returns {String} font declaration formatted for canvas context.
   */ _getFontDeclaration() {
        let { fontFamily: fontFamily = this.fontFamily, fontStyle: fontStyle = this.fontStyle, fontWeight: fontWeight = this.fontWeight, fontSize: fontSize = this.fontSize } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let forMeasuring = arguments.length > 1 ? arguments[1] : undefined;
        const parsedFontFamily = fontFamily.includes("'") || fontFamily.includes('"') || fontFamily.includes(',') || $f268b97836dca6b6$export$72cf63a35cb577f7.genericFonts.includes(fontFamily.toLowerCase()) ? fontFamily : "\"".concat(fontFamily, "\"");
        return [
            fontStyle,
            fontWeight,
            "".concat(forMeasuring ? this.CACHE_FONT_SIZE : fontSize, "px"),
            parsedFontFamily
        ].join(' ');
    }
    /**
   * Renders text instance on a specified context
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ render(ctx) {
        if (!this.visible) return;
        if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) return;
        if (this._forceClearCache) this.initDimensions();
        super.render(ctx);
    }
    /**
   * Override this method to customize grapheme splitting
   * @todo the util `graphemeSplit` needs to be injectable in some way.
   * is more comfortable to inject the correct util rather than having to override text
   * in the middle of the prototype chain
   * @param {string} value
   * @returns {string[]} array of graphemes
   */ graphemeSplit(value) {
        return $f268b97836dca6b6$var$graphemeSplit(value);
    }
    /**
   * Returns the text as an array of lines.
   * @param {String} text text to split
   * @returns  Lines in the text
   */ _splitTextIntoLines(text) {
        const lines = text.split(this._reNewline), newLines = new Array(lines.length), newLine = [
            '\n'
        ];
        let newText = [];
        for(let i = 0; i < lines.length; i++){
            newLines[i] = this.graphemeSplit(lines[i]);
            newText = newText.concat(newLines[i], newLine);
        }
        newText.pop();
        return {
            _unwrappedLines: newLines,
            lines: lines,
            graphemeText: newText,
            graphemeLines: newLines
        };
    }
    /**
   * Returns object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} Object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.toObject([
            ...$f268b97836dca6b6$var$additionalProps,
            ...propertiesToInclude
        ])), {}, {
            styles: $f268b97836dca6b6$var$stylesToArray(this.styles, this.text)
        }, this.path ? {
            path: this.path.toObject()
        } : {});
    }
    set(key, value) {
        const { textLayoutProperties: textLayoutProperties } = this.constructor;
        super.set(key, value);
        let needsDims = false;
        let isAddingPath = false;
        if (typeof key === 'object') for(const _key in key){
            if (_key === 'path') this.setPathInfo();
            needsDims = needsDims || textLayoutProperties.includes(_key);
            isAddingPath = isAddingPath || _key === 'path';
        }
        else {
            needsDims = textLayoutProperties.includes(key);
            isAddingPath = key === 'path';
        }
        if (isAddingPath) this.setPathInfo();
        if (needsDims && this.initialized) {
            this.initDimensions();
            this.setCoords();
        }
        return this;
    }
    /**
   * Returns complexity of an instance
   * @return {Number} complexity
   */ complexity() {
        return 1;
    }
    /**
   * List of generic font families
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/font-family#generic-name
   */ /**
   * Returns FabricText instance from an SVG element (<b>not yet implemented</b>)
   * @static
   * @memberOf Text
   * @param {HTMLElement} element Element to parse
   * @param {Object} [options] Options object
   */ static async fromElement(element, options, cssRules) {
        const parsedAttributes = $f268b97836dca6b6$export$fbe550151e406473(element, $f268b97836dca6b6$export$72cf63a35cb577f7.ATTRIBUTE_NAMES, cssRules);
        const _options$parsedAttrib = $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, options), parsedAttributes), { textAnchor: textAnchor = $f268b97836dca6b6$var$LEFT, textDecoration: textDecoration = '', dx: dx = 0, dy: dy = 0, top: top = 0, left: left = 0, fontSize: fontSize = $f268b97836dca6b6$var$DEFAULT_SVG_FONT_SIZE, strokeWidth: strokeWidth = 1 } = _options$parsedAttrib, restOfOptions = $f268b97836dca6b6$var$_objectWithoutProperties(_options$parsedAttrib, $f268b97836dca6b6$var$_excluded$3);
        const textContent = $f268b97836dca6b6$var$normalizeWs(element.textContent || '').trim();
        // this code here is probably the usual issue for SVG center find
        // this can later looked at again and probably removed.
        const text = new this(textContent, $f268b97836dca6b6$var$_objectSpread2({
            left: left + dx,
            top: top + dy,
            underline: textDecoration.includes('underline'),
            overline: textDecoration.includes('overline'),
            linethrough: textDecoration.includes('line-through'),
            // we initialize this as 0
            strokeWidth: 0,
            fontSize: fontSize
        }, restOfOptions)), textHeightScaleFactor = text.getScaledHeight() / text.height, lineHeightDiff = (text.height + text.strokeWidth) * text.lineHeight - text.height, scaledDiff = lineHeightDiff * textHeightScaleFactor, textHeight = text.getScaledHeight() + scaledDiff;
        let offX = 0;
        /*
      Adjust positioning:
        x/y attributes in SVG correspond to the bottom-left corner of text bounding box
        fabric output by default at top, left.
    */ if (textAnchor === $f268b97836dca6b6$var$CENTER) offX = text.getScaledWidth() / 2;
        if (textAnchor === $f268b97836dca6b6$var$RIGHT) offX = text.getScaledWidth();
        text.set({
            left: text.left - offX,
            top: text.top - (textHeight - text.fontSize * (0.07 + text._fontSizeFraction)) / text.lineHeight,
            strokeWidth: strokeWidth
        });
        return text;
    }
    /* _FROM_SVG_END_ */ /**
   * Returns FabricText instance from an object representation
   * @param {Object} object plain js Object to create an instance from
   * @returns {Promise<FabricText>}
   */ static fromObject(object) {
        return this._fromObject($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, object), {}, {
            styles: $f268b97836dca6b6$var$stylesFromArray(object.styles || {}, object.text)
        }), {
            extraParam: 'text'
        });
    }
    constructor(text, options){
        super();
        /**
     * contains characters bounding boxes
     * This variable is considered to be protected.
     * But for how mixins are implemented right now, we can't leave it private
     * @protected
     */ $f268b97836dca6b6$var$_defineProperty(this, "__charBounds", []);
        Object.assign(this, $f268b97836dca6b6$export$72cf63a35cb577f7.ownDefaults);
        this.setOptions(options);
        if (!this.styles) this.styles = {};
        this.text = text;
        this.initialized = true;
        if (this.path) this.setPathInfo();
        this.initDimensions();
        this.setCoords();
    }
}
/**
 * Properties that requires a text layout recalculation when changed
 * @type string[]
 * @protected
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$72cf63a35cb577f7, "textLayoutProperties", $f268b97836dca6b6$var$textLayoutProperties);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$72cf63a35cb577f7, "cacheProperties", [
    ...$f268b97836dca6b6$var$cacheProperties,
    ...$f268b97836dca6b6$var$additionalProps
]);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$72cf63a35cb577f7, "ownDefaults", $f268b97836dca6b6$var$textDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$72cf63a35cb577f7, "type", 'Text');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$72cf63a35cb577f7, "genericFonts", [
    'serif',
    'sans-serif',
    'monospace',
    'cursive',
    'fantasy',
    'system-ui',
    'ui-serif',
    'ui-sans-serif',
    'ui-monospace',
    'ui-rounded',
    'math',
    'emoji',
    'fangsong'
]);
/* _FROM_SVG_START_ */ /**
 * List of attribute names to account for when parsing SVG element (used by {@link FabricText.fromElement})
 * @static
 * @memberOf Text
 * @see: http://www.w3.org/TR/SVG/text.html#TextElement
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$72cf63a35cb577f7, "ATTRIBUTE_NAMES", $f268b97836dca6b6$var$SHARED_ATTRIBUTES.concat('x', 'y', 'dx', 'dy', 'font-family', 'font-style', 'font-weight', 'font-size', 'letter-spacing', 'text-decoration', 'text-anchor'));
$f268b97836dca6b6$var$applyMixins($f268b97836dca6b6$export$72cf63a35cb577f7, [
    $f268b97836dca6b6$var$TextSVGExportMixin
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$72cf63a35cb577f7);
$f268b97836dca6b6$export$2792378e23a7920c.setSVGClass($f268b97836dca6b6$export$72cf63a35cb577f7);
/**
 * #### Dragging IText/Textbox Lifecycle
 * - {@link start} is called from `mousedown` {@link IText#_mouseDownHandler} and determines if dragging should start by testing {@link isPointerOverSelection}
 * - if true `mousedown` {@link IText#_mouseDownHandler} is blocked to keep selection
 * - if the pointer moves, canvas fires numerous mousemove {@link Canvas#_onMouseMove} that we make sure **aren't** prevented ({@link IText#shouldStartDragging}) in order for the window to start a drag session
 * - once/if the session starts canvas calls {@link onDragStart} on the active object to determine if dragging should occur
 * - canvas fires relevant drag events that are handled by the handlers defined in this scope
 * - {@link end} is called from `mouseup` {@link IText#mouseUpHandler}, blocking IText default click behavior
 * - in case the drag session didn't occur, {@link end} handles a click, since logic to do so was blocked during `mousedown`
 */ class $f268b97836dca6b6$var$DraggableTextDelegate {
    isPointerOverSelection(e) {
        const target = this.target;
        const newSelection = target.getSelectionStartFromPointer(e);
        return target.isEditing && newSelection >= target.selectionStart && newSelection <= target.selectionEnd && target.selectionStart < target.selectionEnd;
    }
    /**
   * @public override this method to disable dragging and default to mousedown logic
   */ start(e) {
        return this.__mouseDownInPlace = this.isPointerOverSelection(e);
    }
    /**
   * @public override this method to disable dragging without discarding selection
   */ isActive() {
        return this.__mouseDownInPlace;
    }
    /**
   * Ends interaction and sets cursor in case of a click
   * @returns true if was active
   */ end(e) {
        const active = this.isActive();
        if (active && !this.__dragStartFired) {
            // mousedown has been blocked since `active` is true => cursor has not been set.
            // `__dragStartFired` is false => dragging didn't occur, pointer didn't move and is over selection.
            // meaning this is actually a click, `active` is a false positive.
            this.target.setCursorByClick(e);
            this.target.initDelayedCursor(true);
        }
        this.__mouseDownInPlace = false;
        this.__dragStartFired = false;
        this.__isDraggingOver = false;
        return active;
    }
    getDragStartSelection() {
        return this.__dragStartSelection;
    }
    /**
   * Override to customize the drag image
   * https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage
   */ setDragImage(e, _ref) {
        var _e$dataTransfer;
        let { selectionStart: selectionStart, selectionEnd: selectionEnd } = _ref;
        const target = this.target;
        const canvas = target.canvas;
        const flipFactor = new $f268b97836dca6b6$export$baf26146a414f24a(target.flipX ? -1 : 1, target.flipY ? -1 : 1);
        const boundaries = target._getCursorBoundaries(selectionStart);
        const selectionPosition = new $f268b97836dca6b6$export$baf26146a414f24a(boundaries.left + boundaries.leftOffset, boundaries.top + boundaries.topOffset).multiply(flipFactor);
        const pos = selectionPosition.transform(target.calcTransformMatrix());
        const pointer = canvas.getScenePoint(e);
        const diff = pointer.subtract(pos);
        const retinaScaling = target.getCanvasRetinaScaling();
        const bbox = target.getBoundingRect();
        const correction = pos.subtract(new $f268b97836dca6b6$export$baf26146a414f24a(bbox.left, bbox.top));
        const vpt = canvas.viewportTransform;
        const offset = correction.add(diff).transform(vpt, true);
        //  prepare instance for drag image snapshot by making all non selected text invisible
        const bgc = target.backgroundColor;
        const styles = $f268b97836dca6b6$var$cloneStyles(target.styles);
        target.backgroundColor = '';
        const styleOverride = {
            stroke: 'transparent',
            fill: 'transparent',
            textBackgroundColor: 'transparent'
        };
        target.setSelectionStyles(styleOverride, 0, selectionStart);
        target.setSelectionStyles(styleOverride, selectionEnd, target.text.length);
        target.dirty = true;
        const dragImage = target.toCanvasElement({
            enableRetinaScaling: canvas.enableRetinaScaling,
            viewportTransform: true
        });
        // restore values
        target.backgroundColor = bgc;
        target.styles = styles;
        target.dirty = true;
        //  position drag image offscreen
        $f268b97836dca6b6$var$setStyle(dragImage, {
            position: 'fixed',
            left: "".concat(-dragImage.width, "px"),
            border: $f268b97836dca6b6$var$NONE,
            width: "".concat(dragImage.width / retinaScaling, "px"),
            height: "".concat(dragImage.height / retinaScaling, "px")
        });
        this.__dragImageDisposer && this.__dragImageDisposer();
        this.__dragImageDisposer = ()=>{
            dragImage.remove();
        };
        $f268b97836dca6b6$var$getDocumentFromElement(e.target || this.target.hiddenTextarea).body.appendChild(dragImage);
        (_e$dataTransfer = e.dataTransfer) === null || _e$dataTransfer === void 0 || _e$dataTransfer.setDragImage(dragImage, offset.x, offset.y);
    }
    /**
   * @returns {boolean} determines whether {@link target} should/shouldn't become a drag source
   */ onDragStart(e) {
        this.__dragStartFired = true;
        const target = this.target;
        const active = this.isActive();
        if (active && e.dataTransfer) {
            const selection = this.__dragStartSelection = {
                selectionStart: target.selectionStart,
                selectionEnd: target.selectionEnd
            };
            const value = target._text.slice(selection.selectionStart, selection.selectionEnd).join('');
            const data = $f268b97836dca6b6$var$_objectSpread2({
                text: target.text,
                value: value
            }, selection);
            e.dataTransfer.setData('text/plain', value);
            e.dataTransfer.setData('application/fabric', JSON.stringify({
                value: value,
                styles: target.getSelectionStyles(selection.selectionStart, selection.selectionEnd, true)
            }));
            e.dataTransfer.effectAllowed = 'copyMove';
            this.setDragImage(e, data);
        }
        target.abortCursorAnimation();
        return active;
    }
    /**
   * use {@link targetCanDrop} to respect overriding
   * @returns {boolean} determines whether {@link target} should/shouldn't become a drop target
   */ canDrop(e) {
        if (this.target.editable && !this.target.getActiveControl() && !e.defaultPrevented) {
            if (this.isActive() && this.__dragStartSelection) {
                //  drag source trying to drop over itself
                //  allow dropping only outside of drag start selection
                const index = this.target.getSelectionStartFromPointer(e);
                const dragStartSelection = this.__dragStartSelection;
                return index < dragStartSelection.selectionStart || index > dragStartSelection.selectionEnd;
            }
            return true;
        }
        return false;
    }
    /**
   * in order to respect overriding {@link IText#canDrop} we call that instead of calling {@link canDrop} directly
   */ targetCanDrop(e) {
        return this.target.canDrop(e);
    }
    dragEnterHandler(_ref2) {
        let { e: e } = _ref2;
        const canDrop = this.targetCanDrop(e);
        if (!this.__isDraggingOver && canDrop) this.__isDraggingOver = true;
    }
    dragOverHandler(ev) {
        const { e: e } = ev;
        const canDrop = this.targetCanDrop(e);
        if (!this.__isDraggingOver && canDrop) this.__isDraggingOver = true;
        else if (this.__isDraggingOver && !canDrop) //  drop state has changed
        this.__isDraggingOver = false;
        if (this.__isDraggingOver) {
            //  can be dropped, inform browser
            e.preventDefault();
            //  inform event subscribers
            ev.canDrop = true;
            ev.dropTarget = this.target;
        }
    }
    dragLeaveHandler() {
        if (this.__isDraggingOver || this.isActive()) this.__isDraggingOver = false;
    }
    /**
   * Override the `text/plain | application/fabric` types of {@link DragEvent#dataTransfer}
   * in order to change the drop value or to customize styling respectively, by listening to the `drop:before` event
   * https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#performing_a_drop
   */ dropHandler(ev) {
        var _e$dataTransfer2;
        const { e: e } = ev;
        const didDrop = e.defaultPrevented;
        this.__isDraggingOver = false;
        // inform browser that the drop has been accepted
        e.preventDefault();
        let insert = (_e$dataTransfer2 = e.dataTransfer) === null || _e$dataTransfer2 === void 0 ? void 0 : _e$dataTransfer2.getData('text/plain');
        if (insert && !didDrop) {
            const target = this.target;
            const canvas = target.canvas;
            let insertAt = target.getSelectionStartFromPointer(e);
            const { styles: styles } = e.dataTransfer.types.includes('application/fabric') ? JSON.parse(e.dataTransfer.getData('application/fabric')) : {};
            const trailing = insert[Math.max(0, insert.length - 1)];
            const selectionStartOffset = 0;
            //  drag and drop in same instance
            if (this.__dragStartSelection) {
                const selectionStart = this.__dragStartSelection.selectionStart;
                const selectionEnd = this.__dragStartSelection.selectionEnd;
                if (insertAt > selectionStart && insertAt <= selectionEnd) insertAt = selectionStart;
                else if (insertAt > selectionEnd) insertAt -= selectionEnd - selectionStart;
                target.removeChars(selectionStart, selectionEnd);
                // prevent `dragend` from handling event
                delete this.__dragStartSelection;
            }
            //  remove redundant line break
            if (target._reNewline.test(trailing) && (target._reNewline.test(target._text[insertAt]) || insertAt === target._text.length)) insert = insert.trimEnd();
            //  inform subscribers
            ev.didDrop = true;
            ev.dropTarget = target;
            //  finalize
            target.insertChars(insert, styles, insertAt);
            // can this part be moved in an outside event? andrea to check.
            canvas.setActiveObject(target);
            target.enterEditing(e);
            target.selectionStart = Math.min(insertAt + selectionStartOffset, target._text.length);
            target.selectionEnd = Math.min(target.selectionStart + insert.length, target._text.length);
            target.hiddenTextarea.value = target.text;
            target._updateTextarea();
            target.hiddenTextarea.focus();
            target.fire($f268b97836dca6b6$var$CHANGED, {
                index: insertAt + selectionStartOffset,
                action: 'drop'
            });
            canvas.fire('text:changed', {
                target: target
            });
            canvas.contextTopDirty = true;
            canvas.requestRenderAll();
        }
    }
    /**
   * fired only on the drag source after drop (if occurred)
   * handle changes to the drag source in case of a drop on another object or a cancellation
   * https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#finishing_a_drag
   */ dragEndHandler(_ref3) {
        let { e: e } = _ref3;
        if (this.isActive() && this.__dragStartFired) //  once the drop event finishes we check if we need to change the drag source
        //  if the drag source received the drop we bail out since the drop handler has already handled logic
        {
            if (this.__dragStartSelection) {
                var _e$dataTransfer3;
                const target = this.target;
                const canvas = this.target.canvas;
                const { selectionStart: selectionStart, selectionEnd: selectionEnd } = this.__dragStartSelection;
                const dropEffect = ((_e$dataTransfer3 = e.dataTransfer) === null || _e$dataTransfer3 === void 0 ? void 0 : _e$dataTransfer3.dropEffect) || $f268b97836dca6b6$var$NONE;
                if (dropEffect === $f268b97836dca6b6$var$NONE) {
                    // pointer is back over selection
                    target.selectionStart = selectionStart;
                    target.selectionEnd = selectionEnd;
                    target._updateTextarea();
                    target.hiddenTextarea.focus();
                } else {
                    target.clearContextTop();
                    if (dropEffect === 'move') {
                        target.removeChars(selectionStart, selectionEnd);
                        target.selectionStart = target.selectionEnd = selectionStart;
                        target.hiddenTextarea && (target.hiddenTextarea.value = target.text);
                        target._updateTextarea();
                        target.fire($f268b97836dca6b6$var$CHANGED, {
                            index: selectionStart,
                            action: 'dragend'
                        });
                        canvas.fire('text:changed', {
                            target: target
                        });
                        canvas.requestRenderAll();
                    }
                    target.exitEditing();
                }
            }
        }
        this.__dragImageDisposer && this.__dragImageDisposer();
        delete this.__dragImageDisposer;
        delete this.__dragStartSelection;
        this.__isDraggingOver = false;
    }
    dispose() {
        this._dispose && this._dispose();
    }
    constructor(target){
        $f268b97836dca6b6$var$_defineProperty(this, "target", void 0);
        $f268b97836dca6b6$var$_defineProperty(this, "__mouseDownInPlace", false);
        $f268b97836dca6b6$var$_defineProperty(this, "__dragStartFired", false);
        $f268b97836dca6b6$var$_defineProperty(this, "__isDraggingOver", false);
        $f268b97836dca6b6$var$_defineProperty(this, "__dragStartSelection", void 0);
        $f268b97836dca6b6$var$_defineProperty(this, "__dragImageDisposer", void 0);
        $f268b97836dca6b6$var$_defineProperty(this, "_dispose", void 0);
        this.target = target;
        const disposers = [
            this.target.on('dragenter', this.dragEnterHandler.bind(this)),
            this.target.on('dragover', this.dragOverHandler.bind(this)),
            this.target.on('dragleave', this.dragLeaveHandler.bind(this)),
            this.target.on('dragend', this.dragEndHandler.bind(this)),
            this.target.on('drop', this.dropHandler.bind(this))
        ];
        this._dispose = ()=>{
            disposers.forEach((d)=>d());
            this._dispose = undefined;
        };
    }
}
/**
 *  extend this regex to support non english languages
 *
 *  - ` `      Matches a SPACE character (char code 32).
 *  - `\n`     Matches a LINE FEED character (char code 10).
 *  - `\.`     Matches a "." character (char code 46).
 *  - `,`      Matches a "," character (char code 44).
 *  - `;`      Matches a ";" character (char code 59).
 *  - `!`      Matches a "!" character (char code 33).
 *  - `\?`     Matches a "?" character (char code 63).
 *  - `\-`     Matches a "-" character (char code 45).
 */ // eslint-disable-next-line no-useless-escape
const $f268b97836dca6b6$var$reNonWord = /[ \n\.,;!\?\-]/;
class $f268b97836dca6b6$var$ITextBehavior extends $f268b97836dca6b6$export$72cf63a35cb577f7 {
    /**
   * Keeps track if the IText object was selected before the actual click.
   * This because we want to delay enter editing by a click.
   */ /**
   * Initializes all the interactive behavior of IText
   */ initBehavior() {
        this._tick = this._tick.bind(this);
        this._onTickComplete = this._onTickComplete.bind(this);
        this.updateSelectionOnMouseMove = this.updateSelectionOnMouseMove.bind(this);
    }
    onDeselect(options) {
        this.isEditing && this.exitEditing();
        this.selected = false;
        return super.onDeselect(options);
    }
    /**
   * @private
   */ _animateCursor(_ref) {
        let { toValue: toValue, duration: duration, delay: delay, onComplete: onComplete } = _ref;
        return $f268b97836dca6b6$var$animate({
            startValue: this._currentCursorOpacity,
            endValue: toValue,
            duration: duration,
            delay: delay,
            onComplete: onComplete,
            abort: ()=>!this.canvas || // we do not want to animate a selection, only cursor
                this.selectionStart !== this.selectionEnd,
            onChange: (value)=>{
                this._currentCursorOpacity = value;
                this.renderCursorOrSelection();
            }
        });
    }
    /**
   * changes the cursor from visible to invisible
   */ _tick(delay) {
        this._currentTickState = this._animateCursor({
            toValue: 0,
            duration: this.cursorDuration / 2,
            delay: Math.max(delay || 0, 100),
            onComplete: this._onTickComplete
        });
    }
    /**
   * Changes the cursor from invisible to visible
   */ _onTickComplete() {
        var _this$_currentTickCom;
        (_this$_currentTickCom = this._currentTickCompleteState) === null || _this$_currentTickCom === void 0 || _this$_currentTickCom.abort();
        this._currentTickCompleteState = this._animateCursor({
            toValue: 1,
            duration: this.cursorDuration,
            onComplete: this._tick
        });
    }
    /**
   * Initializes delayed cursor
   */ initDelayedCursor(restart) {
        this.abortCursorAnimation();
        this._tick(restart ? 0 : this.cursorDelay);
    }
    /**
   * Aborts cursor animation, clears all timeouts and clear textarea context if necessary
   */ abortCursorAnimation() {
        let shouldClear = false;
        [
            this._currentTickState,
            this._currentTickCompleteState
        ].forEach((cursorAnimation)=>{
            if (cursorAnimation && !cursorAnimation.isDone()) {
                shouldClear = true;
                cursorAnimation.abort();
            }
        });
        this._currentCursorOpacity = 1;
        //  make sure we clear context even if instance is not editing
        if (shouldClear) this.clearContextTop();
    }
    /**
   * Restart tue cursor animation if either is in complete state ( between animations )
   * or if it never started before
   */ restartCursorIfNeeded() {
        if ([
            this._currentTickState,
            this._currentTickCompleteState
        ].some((cursorAnimation)=>!cursorAnimation || cursorAnimation.isDone())) this.initDelayedCursor();
    }
    /**
   * Selects entire text
   */ selectAll() {
        this.selectionStart = 0;
        this.selectionEnd = this._text.length;
        this._fireSelectionChanged();
        this._updateTextarea();
        return this;
    }
    /**
   * Selects entire text and updates the visual state
   */ cmdAll() {
        this.selectAll();
        this.renderCursorOrSelection();
    }
    /**
   * Returns selected text
   * @return {String}
   */ getSelectedText() {
        return this._text.slice(this.selectionStart, this.selectionEnd).join('');
    }
    /**
   * Find new selection index representing start of current word according to current selection index
   * @param {Number} startFrom Current selection index
   * @return {Number} New selection index
   */ findWordBoundaryLeft(startFrom) {
        let offset = 0, index = startFrom - 1;
        // remove space before cursor first
        if (this._reSpace.test(this._text[index])) while(this._reSpace.test(this._text[index])){
            offset++;
            index--;
        }
        while(/\S/.test(this._text[index]) && index > -1){
            offset++;
            index--;
        }
        return startFrom - offset;
    }
    /**
   * Find new selection index representing end of current word according to current selection index
   * @param {Number} startFrom Current selection index
   * @return {Number} New selection index
   */ findWordBoundaryRight(startFrom) {
        let offset = 0, index = startFrom;
        // remove space after cursor first
        if (this._reSpace.test(this._text[index])) while(this._reSpace.test(this._text[index])){
            offset++;
            index++;
        }
        while(/\S/.test(this._text[index]) && index < this._text.length){
            offset++;
            index++;
        }
        return startFrom + offset;
    }
    /**
   * Find new selection index representing start of current line according to current selection index
   * @param {Number} startFrom Current selection index
   * @return {Number} New selection index
   */ findLineBoundaryLeft(startFrom) {
        let offset = 0, index = startFrom - 1;
        while(!/\n/.test(this._text[index]) && index > -1){
            offset++;
            index--;
        }
        return startFrom - offset;
    }
    /**
   * Find new selection index representing end of current line according to current selection index
   * @param {Number} startFrom Current selection index
   * @return {Number} New selection index
   */ findLineBoundaryRight(startFrom) {
        let offset = 0, index = startFrom;
        while(!/\n/.test(this._text[index]) && index < this._text.length){
            offset++;
            index++;
        }
        return startFrom + offset;
    }
    /**
   * Finds index corresponding to beginning or end of a word
   * @param {Number} selectionStart Index of a character
   * @param {Number} direction 1 or -1
   * @return {Number} Index of the beginning or end of a word
   */ searchWordBoundary(selectionStart, direction) {
        const text = this._text;
        // if we land on a space we move the cursor backwards
        // if we are searching boundary end we move the cursor backwards ONLY if we don't land on a line break
        let index = selectionStart > 0 && this._reSpace.test(text[selectionStart]) && (direction === -1 || !$f268b97836dca6b6$var$reNewline.test(text[selectionStart - 1])) ? selectionStart - 1 : selectionStart, _char = text[index];
        while(index > 0 && index < text.length && !$f268b97836dca6b6$var$reNonWord.test(_char)){
            index += direction;
            _char = text[index];
        }
        if (direction === -1 && $f268b97836dca6b6$var$reNonWord.test(_char)) index++;
        return index;
    }
    /**
   * Selects the word that contains the char at index selectionStart
   * @param {Number} selectionStart Index of a character
   */ selectWord(selectionStart) {
        var _selectionStart;
        selectionStart = (_selectionStart = selectionStart) !== null && _selectionStart !== void 0 ? _selectionStart : this.selectionStart;
        // search backwards
        const newSelectionStart = this.searchWordBoundary(selectionStart, -1), // search forward
        newSelectionEnd = Math.max(newSelectionStart, this.searchWordBoundary(selectionStart, 1));
        this.selectionStart = newSelectionStart;
        this.selectionEnd = newSelectionEnd;
        this._fireSelectionChanged();
        this._updateTextarea();
        // remove next major, for now it renders twice :(
        this.renderCursorOrSelection();
    }
    /**
   * Selects the line that contains selectionStart
   * @param {Number} selectionStart Index of a character
   */ selectLine(selectionStart) {
        var _selectionStart2;
        selectionStart = (_selectionStart2 = selectionStart) !== null && _selectionStart2 !== void 0 ? _selectionStart2 : this.selectionStart;
        const newSelectionStart = this.findLineBoundaryLeft(selectionStart), newSelectionEnd = this.findLineBoundaryRight(selectionStart);
        this.selectionStart = newSelectionStart;
        this.selectionEnd = newSelectionEnd;
        this._fireSelectionChanged();
        this._updateTextarea();
    }
    /**
   * Enters editing state
   */ enterEditing(e) {
        if (this.isEditing || !this.editable) return;
        this.enterEditingImpl();
        this.fire('editing:entered', e ? {
            e: e
        } : undefined);
        this._fireSelectionChanged();
        if (this.canvas) {
            this.canvas.fire('text:editing:entered', {
                target: this,
                e: e
            });
            this.canvas.requestRenderAll();
        }
    }
    /**
   * runs the actual logic that enter from editing state, see {@link enterEditing}
   */ enterEditingImpl() {
        if (this.canvas) {
            this.canvas.calcOffset();
            this.canvas.textEditingManager.exitTextEditing();
        }
        this.isEditing = true;
        this.initHiddenTextarea();
        this.hiddenTextarea.focus();
        this.hiddenTextarea.value = this.text;
        this._updateTextarea();
        this._saveEditingProps();
        this._setEditingProps();
        this._textBeforeEdit = this.text;
        this._tick();
    }
    /**
   * called by {@link Canvas#textEditingManager}
   */ updateSelectionOnMouseMove(e) {
        if (this.getActiveControl()) return;
        const el = this.hiddenTextarea;
        // regain focus
        $f268b97836dca6b6$var$getDocumentFromElement(el).activeElement !== el && el.focus();
        const newSelectionStart = this.getSelectionStartFromPointer(e), currentStart = this.selectionStart, currentEnd = this.selectionEnd;
        if ((newSelectionStart !== this.__selectionStartOnMouseDown || currentStart === currentEnd) && (currentStart === newSelectionStart || currentEnd === newSelectionStart)) return;
        if (newSelectionStart > this.__selectionStartOnMouseDown) {
            this.selectionStart = this.__selectionStartOnMouseDown;
            this.selectionEnd = newSelectionStart;
        } else {
            this.selectionStart = newSelectionStart;
            this.selectionEnd = this.__selectionStartOnMouseDown;
        }
        if (this.selectionStart !== currentStart || this.selectionEnd !== currentEnd) {
            this._fireSelectionChanged();
            this._updateTextarea();
            this.renderCursorOrSelection();
        }
    }
    /**
   * @private
   */ _setEditingProps() {
        this.hoverCursor = 'text';
        if (this.canvas) this.canvas.defaultCursor = this.canvas.moveCursor = 'text';
        this.borderColor = this.editingBorderColor;
        this.hasControls = this.selectable = false;
        this.lockMovementX = this.lockMovementY = true;
    }
    /**
   * convert from textarea to grapheme indexes
   */ fromStringToGraphemeSelection(start, end, text) {
        const smallerTextStart = text.slice(0, start), graphemeStart = this.graphemeSplit(smallerTextStart).length;
        if (start === end) return {
            selectionStart: graphemeStart,
            selectionEnd: graphemeStart
        };
        const smallerTextEnd = text.slice(start, end), graphemeEnd = this.graphemeSplit(smallerTextEnd).length;
        return {
            selectionStart: graphemeStart,
            selectionEnd: graphemeStart + graphemeEnd
        };
    }
    /**
   * convert from fabric to textarea values
   */ fromGraphemeToStringSelection(start, end, graphemes) {
        const smallerTextStart = graphemes.slice(0, start), graphemeStart = smallerTextStart.join('').length;
        if (start === end) return {
            selectionStart: graphemeStart,
            selectionEnd: graphemeStart
        };
        const smallerTextEnd = graphemes.slice(start, end), graphemeEnd = smallerTextEnd.join('').length;
        return {
            selectionStart: graphemeStart,
            selectionEnd: graphemeStart + graphemeEnd
        };
    }
    /**
   * @private
   */ _updateTextarea() {
        this.cursorOffsetCache = {};
        if (!this.hiddenTextarea) return;
        if (!this.inCompositionMode) {
            const newSelection = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
            this.hiddenTextarea.selectionStart = newSelection.selectionStart;
            this.hiddenTextarea.selectionEnd = newSelection.selectionEnd;
        }
        this.updateTextareaPosition();
    }
    /**
   * @private
   */ updateFromTextArea() {
        if (!this.hiddenTextarea) return;
        this.cursorOffsetCache = {};
        const textarea = this.hiddenTextarea;
        this.text = textarea.value;
        this.set('dirty', true);
        this.initDimensions();
        this.setCoords();
        const newSelection = this.fromStringToGraphemeSelection(textarea.selectionStart, textarea.selectionEnd, textarea.value);
        this.selectionEnd = this.selectionStart = newSelection.selectionEnd;
        if (!this.inCompositionMode) this.selectionStart = newSelection.selectionStart;
        this.updateTextareaPosition();
    }
    /**
   * @private
   */ updateTextareaPosition() {
        if (this.selectionStart === this.selectionEnd) {
            const style = this._calcTextareaPosition();
            this.hiddenTextarea.style.left = style.left;
            this.hiddenTextarea.style.top = style.top;
        }
    }
    /**
   * @private
   * @return {Object} style contains style for hiddenTextarea
   */ _calcTextareaPosition() {
        if (!this.canvas) return {
            left: '1px',
            top: '1px'
        };
        const desiredPosition = this.inCompositionMode ? this.compositionStart : this.selectionStart, boundaries = this._getCursorBoundaries(desiredPosition), cursorLocation = this.get2DCursorLocation(desiredPosition), lineIndex = cursorLocation.lineIndex, charIndex = cursorLocation.charIndex, charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize') * this.lineHeight, leftOffset = boundaries.leftOffset, retinaScaling = this.getCanvasRetinaScaling(), upperCanvas = this.canvas.upperCanvasEl, upperCanvasWidth = upperCanvas.width / retinaScaling, upperCanvasHeight = upperCanvas.height / retinaScaling, maxWidth = upperCanvasWidth - charHeight, maxHeight = upperCanvasHeight - charHeight;
        const p = new $f268b97836dca6b6$export$baf26146a414f24a(boundaries.left + leftOffset, boundaries.top + boundaries.topOffset + charHeight).transform(this.calcTransformMatrix()).transform(this.canvas.viewportTransform).multiply(new $f268b97836dca6b6$export$baf26146a414f24a(upperCanvas.clientWidth / upperCanvasWidth, upperCanvas.clientHeight / upperCanvasHeight));
        if (p.x < 0) p.x = 0;
        if (p.x > maxWidth) p.x = maxWidth;
        if (p.y < 0) p.y = 0;
        if (p.y > maxHeight) p.y = maxHeight;
        // add canvas offset on document
        p.x += this.canvas._offset.left;
        p.y += this.canvas._offset.top;
        return {
            left: "".concat(p.x, "px"),
            top: "".concat(p.y, "px"),
            fontSize: "".concat(charHeight, "px"),
            charHeight: charHeight
        };
    }
    /**
   * @private
   */ _saveEditingProps() {
        this._savedProps = {
            hasControls: this.hasControls,
            borderColor: this.borderColor,
            lockMovementX: this.lockMovementX,
            lockMovementY: this.lockMovementY,
            hoverCursor: this.hoverCursor,
            selectable: this.selectable,
            defaultCursor: this.canvas && this.canvas.defaultCursor,
            moveCursor: this.canvas && this.canvas.moveCursor
        };
    }
    /**
   * @private
   */ _restoreEditingProps() {
        if (!this._savedProps) return;
        this.hoverCursor = this._savedProps.hoverCursor;
        this.hasControls = this._savedProps.hasControls;
        this.borderColor = this._savedProps.borderColor;
        this.selectable = this._savedProps.selectable;
        this.lockMovementX = this._savedProps.lockMovementX;
        this.lockMovementY = this._savedProps.lockMovementY;
        if (this.canvas) {
            this.canvas.defaultCursor = this._savedProps.defaultCursor || this.canvas.defaultCursor;
            this.canvas.moveCursor = this._savedProps.moveCursor || this.canvas.moveCursor;
        }
        delete this._savedProps;
    }
    /**
   * runs the actual logic that exits from editing state, see {@link exitEditing}
   * Please use exitEditingImpl, this function was kept to avoid breaking changes.
   * Will be removed in fabric 7.0
   * @deprecated use "exitEditingImpl"
   */ _exitEditing() {
        const hiddenTextarea = this.hiddenTextarea;
        this.selected = false;
        this.isEditing = false;
        if (hiddenTextarea) {
            hiddenTextarea.blur && hiddenTextarea.blur();
            hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
        }
        this.hiddenTextarea = null;
        this.abortCursorAnimation();
        this.selectionStart !== this.selectionEnd && this.clearContextTop();
    }
    /**
   * runs the actual logic that exits from editing state, see {@link exitEditing}
   * But it does not fire events
   */ exitEditingImpl() {
        this._exitEditing();
        this.selectionEnd = this.selectionStart;
        this._restoreEditingProps();
        if (this._forceClearCache) {
            this.initDimensions();
            this.setCoords();
        }
    }
    /**
   * Exits from editing state and fires relevant events
   */ exitEditing() {
        const isTextChanged = this._textBeforeEdit !== this.text;
        this.exitEditingImpl();
        this.fire('editing:exited');
        isTextChanged && this.fire($f268b97836dca6b6$var$MODIFIED);
        if (this.canvas) {
            this.canvas.fire('text:editing:exited', {
                target: this
            });
            // todo: evaluate add an action to this event
            isTextChanged && this.canvas.fire('object:modified', {
                target: this
            });
        }
        return this;
    }
    /**
   * @private
   */ _removeExtraneousStyles() {
        for(const prop in this.styles)if (!this._textLines[prop]) delete this.styles[prop];
    }
    /**
   * remove and reflow a style block from start to end.
   * @param {Number} start linear start position for removal (included in removal)
   * @param {Number} end linear end position for removal ( excluded from removal )
   */ removeStyleFromTo(start, end) {
        const { lineIndex: lineStart, charIndex: charStart } = this.get2DCursorLocation(start, true), { lineIndex: lineEnd, charIndex: charEnd } = this.get2DCursorLocation(end, true);
        if (lineStart !== lineEnd) {
            // step1 remove the trailing of lineStart
            if (this.styles[lineStart]) for(let i = charStart; i < this._unwrappedTextLines[lineStart].length; i++)delete this.styles[lineStart][i];
            // step2 move the trailing of lineEnd to lineStart if needed
            if (this.styles[lineEnd]) for(let i = charEnd; i < this._unwrappedTextLines[lineEnd].length; i++){
                const styleObj = this.styles[lineEnd][i];
                if (styleObj) {
                    this.styles[lineStart] || (this.styles[lineStart] = {});
                    this.styles[lineStart][charStart + i - charEnd] = styleObj;
                }
            }
            // step3 detects lines will be completely removed.
            for(let i = lineStart + 1; i <= lineEnd; i++)delete this.styles[i];
            // step4 shift remaining lines.
            this.shiftLineStyles(lineEnd, lineStart - lineEnd);
        } else // remove and shift left on the same line
        if (this.styles[lineStart]) {
            const styleObj = this.styles[lineStart];
            const diff = charEnd - charStart;
            for(let i = charStart; i < charEnd; i++)delete styleObj[i];
            for(const char in this.styles[lineStart]){
                const numericChar = parseInt(char, 10);
                if (numericChar >= charEnd) {
                    styleObj[numericChar - diff] = styleObj[char];
                    delete styleObj[char];
                }
            }
        }
    }
    /**
   * Shifts line styles up or down
   * @param {Number} lineIndex Index of a line
   * @param {Number} offset Can any number?
   */ shiftLineStyles(lineIndex, offset) {
        const clonedStyles = Object.assign({}, this.styles);
        for(const line in this.styles){
            const numericLine = parseInt(line, 10);
            if (numericLine > lineIndex) {
                this.styles[numericLine + offset] = clonedStyles[numericLine];
                if (!clonedStyles[numericLine - offset]) delete this.styles[numericLine];
            }
        }
    }
    /**
   * Handle insertion of more consecutive style lines for when one or more
   * newlines gets added to the text. Since current style needs to be shifted
   * first we shift the current style of the number lines needed, then we add
   * new lines from the last to the first.
   * @param {Number} lineIndex Index of a line
   * @param {Number} charIndex Index of a char
   * @param {Number} qty number of lines to add
   * @param {Array} copiedStyle Array of objects styles
   */ insertNewlineStyleObject(lineIndex, charIndex, qty, copiedStyle) {
        const newLineStyles = {};
        const originalLineLength = this._unwrappedTextLines[lineIndex].length;
        const isEndOfLine = originalLineLength === charIndex;
        let someStyleIsCarryingOver = false;
        qty || (qty = 1);
        this.shiftLineStyles(lineIndex, qty);
        const currentCharStyle = this.styles[lineIndex] ? this.styles[lineIndex][charIndex === 0 ? charIndex : charIndex - 1] : undefined;
        // we clone styles of all chars
        // after cursor onto the current line
        for(const index in this.styles[lineIndex]){
            const numIndex = parseInt(index, 10);
            if (numIndex >= charIndex) {
                someStyleIsCarryingOver = true;
                newLineStyles[numIndex - charIndex] = this.styles[lineIndex][index];
                // remove lines from the previous line since they're on a new line now
                if (!(isEndOfLine && charIndex === 0)) delete this.styles[lineIndex][index];
            }
        }
        let styleCarriedOver = false;
        if (someStyleIsCarryingOver && !isEndOfLine) {
            // if is end of line, the extra style we copied
            // is probably not something we want
            this.styles[lineIndex + qty] = newLineStyles;
            styleCarriedOver = true;
        }
        if (styleCarriedOver || originalLineLength > charIndex) // skip the last line of since we already prepared it.
        // or contains text without style that we don't want to style
        // just because it changed lines
        qty--;
        // for the all the lines or all the other lines
        // we clone current char style onto the next (otherwise empty) line
        while(qty > 0){
            if (copiedStyle && copiedStyle[qty - 1]) this.styles[lineIndex + qty] = {
                0: $f268b97836dca6b6$var$_objectSpread2({}, copiedStyle[qty - 1])
            };
            else if (currentCharStyle) this.styles[lineIndex + qty] = {
                0: $f268b97836dca6b6$var$_objectSpread2({}, currentCharStyle)
            };
            else delete this.styles[lineIndex + qty];
            qty--;
        }
        this._forceClearCache = true;
    }
    /**
   * Inserts style object for a given line/char index
   * @param {Number} lineIndex Index of a line
   * @param {Number} charIndex Index of a char
   * @param {Number} quantity number Style object to insert, if given
   * @param {Array} copiedStyle array of style objects
   */ insertCharStyleObject(lineIndex, charIndex, quantity, copiedStyle) {
        if (!this.styles) this.styles = {};
        const currentLineStyles = this.styles[lineIndex], currentLineStylesCloned = currentLineStyles ? $f268b97836dca6b6$var$_objectSpread2({}, currentLineStyles) : {};
        quantity || (quantity = 1);
        // shift all char styles by quantity forward
        // 0,1,2,3 -> (charIndex=2) -> 0,1,3,4 -> (insert 2) -> 0,1,2,3,4
        for(const index in currentLineStylesCloned){
            const numericIndex = parseInt(index, 10);
            if (numericIndex >= charIndex) {
                currentLineStyles[numericIndex + quantity] = currentLineStylesCloned[numericIndex];
                // only delete the style if there was nothing moved there
                if (!currentLineStylesCloned[numericIndex - quantity]) delete currentLineStyles[numericIndex];
            }
        }
        this._forceClearCache = true;
        if (copiedStyle) {
            while(quantity--){
                if (!Object.keys(copiedStyle[quantity]).length) continue;
                if (!this.styles[lineIndex]) this.styles[lineIndex] = {};
                this.styles[lineIndex][charIndex + quantity] = $f268b97836dca6b6$var$_objectSpread2({}, copiedStyle[quantity]);
            }
            return;
        }
        if (!currentLineStyles) return;
        const newStyle = currentLineStyles[charIndex ? charIndex - 1 : 1];
        while(newStyle && quantity--)this.styles[lineIndex][charIndex + quantity] = $f268b97836dca6b6$var$_objectSpread2({}, newStyle);
    }
    /**
   * Inserts style object(s)
   * @param {Array} insertedText Characters at the location where style is inserted
   * @param {Number} start cursor index for inserting style
   * @param {Array} [copiedStyle] array of style objects to insert.
   */ insertNewStyleBlock(insertedText, start, copiedStyle) {
        const cursorLoc = this.get2DCursorLocation(start, true), addedLines = [
            0
        ];
        let linesLength = 0;
        // get an array of how many char per lines are being added.
        for(let i = 0; i < insertedText.length; i++)if (insertedText[i] === '\n') {
            linesLength++;
            addedLines[linesLength] = 0;
        } else addedLines[linesLength]++;
        // for the first line copy the style from the current char position.
        if (addedLines[0] > 0) {
            this.insertCharStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex, addedLines[0], copiedStyle);
            copiedStyle = copiedStyle && copiedStyle.slice(addedLines[0] + 1);
        }
        linesLength && this.insertNewlineStyleObject(cursorLoc.lineIndex, cursorLoc.charIndex + addedLines[0], linesLength);
        let i;
        for(i = 1; i < linesLength; i++){
            if (addedLines[i] > 0) this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
            else if (copiedStyle) // this test is required in order to close #6841
            // when a pasted buffer begins with a newline then
            // this.styles[cursorLoc.lineIndex + i] and copiedStyle[0]
            // may be undefined for some reason
            {
                if (this.styles[cursorLoc.lineIndex + i] && copiedStyle[0]) this.styles[cursorLoc.lineIndex + i][0] = copiedStyle[0];
            }
            copiedStyle = copiedStyle && copiedStyle.slice(addedLines[i] + 1);
        }
        if (addedLines[i] > 0) this.insertCharStyleObject(cursorLoc.lineIndex + i, 0, addedLines[i], copiedStyle);
    }
    /**
   * Removes characters from start/end
   * start/end ar per grapheme position in _text array.
   *
   * @param {Number} start
   * @param {Number} end default to start + 1
   */ removeChars(start) {
        let end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : start + 1;
        this.removeStyleFromTo(start, end);
        this._text.splice(start, end - start);
        this.text = this._text.join('');
        this.set('dirty', true);
        this.initDimensions();
        this.setCoords();
        this._removeExtraneousStyles();
    }
    /**
   * insert characters at start position, before start position.
   * start  equal 1 it means the text get inserted between actual grapheme 0 and 1
   * if style array is provided, it must be as the same length of text in graphemes
   * if end is provided and is bigger than start, old text is replaced.
   * start/end ar per grapheme position in _text array.
   *
   * @param {String} text text to insert
   * @param {Array} style array of style objects
   * @param {Number} start
   * @param {Number} end default to start + 1
   */ insertChars(text, style, start) {
        let end = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : start;
        if (end > start) this.removeStyleFromTo(start, end);
        const graphemes = this.graphemeSplit(text);
        this.insertNewStyleBlock(graphemes, start, style);
        this._text = [
            ...this._text.slice(0, start),
            ...graphemes,
            ...this._text.slice(end)
        ];
        this.text = this._text.join('');
        this.set('dirty', true);
        this.initDimensions();
        this.setCoords();
        this._removeExtraneousStyles();
    }
    /**
   * Set the selectionStart and selectionEnd according to the new position of cursor
   * mimic the key - mouse navigation when shift is pressed.
   */ setSelectionStartEndWithShift(start, end, newSelection) {
        if (newSelection <= start) {
            if (end === start) this._selectionDirection = $f268b97836dca6b6$var$LEFT;
            else if (this._selectionDirection === $f268b97836dca6b6$var$RIGHT) {
                this._selectionDirection = $f268b97836dca6b6$var$LEFT;
                this.selectionEnd = start;
            }
            this.selectionStart = newSelection;
        } else if (newSelection > start && newSelection < end) {
            if (this._selectionDirection === $f268b97836dca6b6$var$RIGHT) this.selectionEnd = newSelection;
            else this.selectionStart = newSelection;
        } else {
            // newSelection is > selection start and end
            if (end === start) this._selectionDirection = $f268b97836dca6b6$var$RIGHT;
            else if (this._selectionDirection === $f268b97836dca6b6$var$LEFT) {
                this._selectionDirection = $f268b97836dca6b6$var$RIGHT;
                this.selectionStart = end;
            }
            this.selectionEnd = newSelection;
        }
    }
    constructor(){
        super(...arguments);
        /**
     * Helps determining when the text is in composition, so that the cursor
     * rendering is altered.
     */ $f268b97836dca6b6$var$_defineProperty(this, "_currentCursorOpacity", 1);
    }
}
class $f268b97836dca6b6$var$ITextKeyBehavior extends $f268b97836dca6b6$var$ITextBehavior {
    /**
   * For functionalities on keyDown
   * Map a special key to a function of the instance/prototype
   * If you need different behavior for ESC or TAB or arrows, you have to change
   * this map setting the name of a function that you build on the IText or
   * your prototype.
   * the map change will affect all Instances unless you need for only some text Instances
   * in that case you have to clone this object and assign your Instance.
   * this.keysMap = Object.assign({}, this.keysMap);
   * The function must be in IText.prototype.myFunction And will receive event as args[0]
   */ /**
   * For functionalities on keyUp + ctrl || cmd
   */ /**
   * For functionalities on keyDown + ctrl || cmd
   */ /**
   * DOM container to append the hiddenTextarea.
   * An alternative to attaching to the document.body.
   * Useful to reduce laggish redraw of the full document.body tree and
   * also with modals event capturing that won't let the textarea take focus.
   * @type HTMLElement
   * @default
   */ /**
   * Initializes hidden textarea (needed to bring up keyboard in iOS)
   */ initHiddenTextarea() {
        const doc = this.canvas && $f268b97836dca6b6$var$getDocumentFromElement(this.canvas.getElement()) || $f268b97836dca6b6$export$91e93c41e950ddbb();
        const textarea = doc.createElement('textarea');
        Object.entries({
            autocapitalize: 'off',
            autocorrect: 'off',
            autocomplete: 'off',
            spellcheck: 'false',
            'data-fabric': 'textarea',
            wrap: 'off',
            name: 'fabricTextarea'
        }).map((_ref)=>{
            let [attribute, value] = _ref;
            return textarea.setAttribute(attribute, value);
        });
        const { top: top, left: left, fontSize: fontSize } = this._calcTextareaPosition();
        // line-height: 1px; was removed from the style to fix this:
        // https://bugs.chromium.org/p/chromium/issues/detail?id=870966
        textarea.style.cssText = "position: absolute; top: ".concat(top, "; left: ").concat(left, "; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px; padding-top: ").concat(fontSize, ";");
        (this.hiddenTextareaContainer || doc.body).appendChild(textarea);
        Object.entries({
            blur: 'blur',
            keydown: 'onKeyDown',
            keyup: 'onKeyUp',
            input: 'onInput',
            copy: 'copy',
            cut: 'copy',
            paste: 'paste',
            compositionstart: 'onCompositionStart',
            compositionupdate: 'onCompositionUpdate',
            compositionend: 'onCompositionEnd'
        }).map((_ref2)=>{
            let [eventName, handler] = _ref2;
            return textarea.addEventListener(eventName, this[handler].bind(this));
        });
        this.hiddenTextarea = textarea;
    }
    /**
   * Override this method to customize cursor behavior on textbox blur
   */ blur() {
        this.abortCursorAnimation();
    }
    /**
   * Handles keydown event
   * only used for arrows and combination of modifier keys.
   * @param {KeyboardEvent} e Event object
   */ onKeyDown(e) {
        if (!this.isEditing) return;
        const keyMap = this.direction === 'rtl' ? this.keysMapRtl : this.keysMap;
        if (e.keyCode in keyMap) this[keyMap[e.keyCode]](e);
        else if (e.keyCode in this.ctrlKeysMapDown && (e.ctrlKey || e.metaKey)) this[this.ctrlKeysMapDown[e.keyCode]](e);
        else return;
        e.stopImmediatePropagation();
        e.preventDefault();
        if (e.keyCode >= 33 && e.keyCode <= 40) {
            // if i press an arrow key just update selection
            this.inCompositionMode = false;
            this.clearContextTop();
            this.renderCursorOrSelection();
        } else this.canvas && this.canvas.requestRenderAll();
    }
    /**
   * Handles keyup event
   * We handle KeyUp because ie11 and edge have difficulties copy/pasting
   * if a copy/cut event fired, keyup is dismissed
   * @param {KeyboardEvent} e Event object
   */ onKeyUp(e) {
        if (!this.isEditing || this._copyDone || this.inCompositionMode) {
            this._copyDone = false;
            return;
        }
        if (e.keyCode in this.ctrlKeysMapUp && (e.ctrlKey || e.metaKey)) this[this.ctrlKeysMapUp[e.keyCode]](e);
        else return;
        e.stopImmediatePropagation();
        e.preventDefault();
        this.canvas && this.canvas.requestRenderAll();
    }
    /**
   * Handles onInput event
   * @param {Event} e Event object
   */ onInput(e) {
        const fromPaste = this.fromPaste;
        const { value: value, selectionStart: selectionStart, selectionEnd: selectionEnd } = this.hiddenTextarea;
        this.fromPaste = false;
        e && e.stopPropagation();
        if (!this.isEditing) return;
        const updateAndFire = ()=>{
            this.updateFromTextArea();
            this.fire($f268b97836dca6b6$var$CHANGED);
            if (this.canvas) {
                this.canvas.fire('text:changed', {
                    target: this
                });
                this.canvas.requestRenderAll();
            }
        };
        if (this.hiddenTextarea.value === '') {
            this.styles = {};
            updateAndFire();
            return;
        }
        // decisions about style changes.
        const nextText = this._splitTextIntoLines(value).graphemeText, charCount = this._text.length, nextCharCount = nextText.length, _selectionStart = this.selectionStart, _selectionEnd = this.selectionEnd, selection = _selectionStart !== _selectionEnd;
        let copiedStyle, removedText, charDiff = nextCharCount - charCount, removeFrom, removeTo;
        const textareaSelection = this.fromStringToGraphemeSelection(selectionStart, selectionEnd, value);
        const backDelete = _selectionStart > textareaSelection.selectionStart;
        if (selection) {
            removedText = this._text.slice(_selectionStart, _selectionEnd);
            charDiff += _selectionEnd - _selectionStart;
        } else if (nextCharCount < charCount) {
            if (backDelete) removedText = this._text.slice(_selectionEnd + charDiff, _selectionEnd);
            else removedText = this._text.slice(_selectionStart, _selectionStart - charDiff);
        }
        const insertedText = nextText.slice(textareaSelection.selectionEnd - charDiff, textareaSelection.selectionEnd);
        if (removedText && removedText.length) {
            if (insertedText.length) {
                // let's copy some style before deleting.
                // we want to copy the style before the cursor OR the style at the cursor if selection
                // is bigger than 0.
                copiedStyle = this.getSelectionStyles(_selectionStart, _selectionStart + 1, false);
                // now duplicate the style one for each inserted text.
                copiedStyle = insertedText.map(()=>// this return an array of references, but that is fine since we are
                    // copying the style later.
                    copiedStyle[0]);
            }
            if (selection) {
                removeFrom = _selectionStart;
                removeTo = _selectionEnd;
            } else if (backDelete) {
                // detect differences between forwardDelete and backDelete
                removeFrom = _selectionEnd - removedText.length;
                removeTo = _selectionEnd;
            } else {
                removeFrom = _selectionEnd;
                removeTo = _selectionEnd + removedText.length;
            }
            this.removeStyleFromTo(removeFrom, removeTo);
        }
        if (insertedText.length) {
            const { copyPasteData: copyPasteData } = $f268b97836dca6b6$export$4bd44a2aa29d3d6e();
            if (fromPaste && insertedText.join('') === copyPasteData.copiedText && !$f268b97836dca6b6$export$e506a1d27d1eaa20.disableStyleCopyPaste) copiedStyle = copyPasteData.copiedTextStyle;
            this.insertNewStyleBlock(insertedText, _selectionStart, copiedStyle);
        }
        updateAndFire();
    }
    /**
   * Composition start
   */ onCompositionStart() {
        this.inCompositionMode = true;
    }
    /**
   * Composition end
   */ onCompositionEnd() {
        this.inCompositionMode = false;
    }
    onCompositionUpdate(_ref3) {
        let { target: target } = _ref3;
        const { selectionStart: selectionStart, selectionEnd: selectionEnd } = target;
        this.compositionStart = selectionStart;
        this.compositionEnd = selectionEnd;
        this.updateTextareaPosition();
    }
    /**
   * Copies selected text
   */ copy() {
        if (this.selectionStart === this.selectionEnd) //do not cut-copy if no selection
        return;
        const { copyPasteData: copyPasteData } = $f268b97836dca6b6$export$4bd44a2aa29d3d6e();
        copyPasteData.copiedText = this.getSelectedText();
        if (!$f268b97836dca6b6$export$e506a1d27d1eaa20.disableStyleCopyPaste) copyPasteData.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, true);
        else copyPasteData.copiedTextStyle = undefined;
        this._copyDone = true;
    }
    /**
   * Pastes text
   */ paste() {
        this.fromPaste = true;
    }
    /**
   * Finds the width in pixels before the cursor on the same line
   * @private
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @return {Number} widthBeforeCursor width before cursor
   */ _getWidthBeforeCursor(lineIndex, charIndex) {
        let widthBeforeCursor = this._getLineLeftOffset(lineIndex), bound;
        if (charIndex > 0) {
            bound = this.__charBounds[lineIndex][charIndex - 1];
            widthBeforeCursor += bound.left + bound.width;
        }
        return widthBeforeCursor;
    }
    /**
   * Gets start offset of a selection
   * @param {KeyboardEvent} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */ getDownCursorOffset(e, isRight) {
        const selectionProp = this._getSelectionForOffset(e, isRight), cursorLocation = this.get2DCursorLocation(selectionProp), lineIndex = cursorLocation.lineIndex;
        // if on last line, down cursor goes to end of line
        if (lineIndex === this._textLines.length - 1 || e.metaKey || e.keyCode === 34) // move to the end of a text
        return this._text.length - selectionProp;
        const charIndex = cursorLocation.charIndex, widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex), indexOnOtherLine = this._getIndexOnLine(lineIndex + 1, widthBeforeCursor), textAfterCursor = this._textLines[lineIndex].slice(charIndex);
        return textAfterCursor.length + indexOnOtherLine + 1 + this.missingNewlineOffset(lineIndex);
    }
    /**
   * private
   * Helps finding if the offset should be counted from Start or End
   * @param {KeyboardEvent} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */ _getSelectionForOffset(e, isRight) {
        if (e.shiftKey && this.selectionStart !== this.selectionEnd && isRight) return this.selectionEnd;
        else return this.selectionStart;
    }
    /**
   * @param {KeyboardEvent} e Event object
   * @param {Boolean} isRight
   * @return {Number}
   */ getUpCursorOffset(e, isRight) {
        const selectionProp = this._getSelectionForOffset(e, isRight), cursorLocation = this.get2DCursorLocation(selectionProp), lineIndex = cursorLocation.lineIndex;
        if (lineIndex === 0 || e.metaKey || e.keyCode === 33) // if on first line, up cursor goes to start of line
        return -selectionProp;
        const charIndex = cursorLocation.charIndex, widthBeforeCursor = this._getWidthBeforeCursor(lineIndex, charIndex), indexOnOtherLine = this._getIndexOnLine(lineIndex - 1, widthBeforeCursor), textBeforeCursor = this._textLines[lineIndex].slice(0, charIndex), missingNewlineOffset = this.missingNewlineOffset(lineIndex - 1);
        // return a negative offset
        return -this._textLines[lineIndex - 1].length + indexOnOtherLine - textBeforeCursor.length + (1 - missingNewlineOffset);
    }
    /**
   * for a given width it founds the matching character.
   * @private
   */ _getIndexOnLine(lineIndex, width) {
        const line = this._textLines[lineIndex], lineLeftOffset = this._getLineLeftOffset(lineIndex);
        let widthOfCharsOnLine = lineLeftOffset, indexOnLine = 0, charWidth, foundMatch;
        for(let j = 0, jlen = line.length; j < jlen; j++){
            charWidth = this.__charBounds[lineIndex][j].width;
            widthOfCharsOnLine += charWidth;
            if (widthOfCharsOnLine > width) {
                foundMatch = true;
                const leftEdge = widthOfCharsOnLine - charWidth, rightEdge = widthOfCharsOnLine, offsetFromLeftEdge = Math.abs(leftEdge - width), offsetFromRightEdge = Math.abs(rightEdge - width);
                indexOnLine = offsetFromRightEdge < offsetFromLeftEdge ? j : j - 1;
                break;
            }
        }
        // reached end
        if (!foundMatch) indexOnLine = line.length - 1;
        return indexOnLine;
    }
    /**
   * Moves cursor down
   * @param {KeyboardEvent} e Event object
   */ moveCursorDown(e) {
        if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) return;
        this._moveCursorUpOrDown('Down', e);
    }
    /**
   * Moves cursor up
   * @param {KeyboardEvent} e Event object
   */ moveCursorUp(e) {
        if (this.selectionStart === 0 && this.selectionEnd === 0) return;
        this._moveCursorUpOrDown('Up', e);
    }
    /**
   * Moves cursor up or down, fires the events
   * @param {String} direction 'Up' or 'Down'
   * @param {KeyboardEvent} e Event object
   */ _moveCursorUpOrDown(direction, e) {
        const offset = this["get".concat(direction, "CursorOffset")](e, this._selectionDirection === $f268b97836dca6b6$var$RIGHT);
        if (e.shiftKey) this.moveCursorWithShift(offset);
        else this.moveCursorWithoutShift(offset);
        if (offset !== 0) {
            const max = this.text.length;
            this.selectionStart = $f268b97836dca6b6$var$capValue(0, this.selectionStart, max);
            this.selectionEnd = $f268b97836dca6b6$var$capValue(0, this.selectionEnd, max);
            // TODO fix: abort and init should be an alternative depending
            // on selectionStart/End being equal or different
            this.abortCursorAnimation();
            this.initDelayedCursor();
            this._fireSelectionChanged();
            this._updateTextarea();
        }
    }
    /**
   * Moves cursor with shift
   * @param {Number} offset
   */ moveCursorWithShift(offset) {
        const newSelection = this._selectionDirection === $f268b97836dca6b6$var$LEFT ? this.selectionStart + offset : this.selectionEnd + offset;
        this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, newSelection);
        return offset !== 0;
    }
    /**
   * Moves cursor up without shift
   * @param {Number} offset
   */ moveCursorWithoutShift(offset) {
        if (offset < 0) {
            this.selectionStart += offset;
            this.selectionEnd = this.selectionStart;
        } else {
            this.selectionEnd += offset;
            this.selectionStart = this.selectionEnd;
        }
        return offset !== 0;
    }
    /**
   * Moves cursor left
   * @param {KeyboardEvent} e Event object
   */ moveCursorLeft(e) {
        if (this.selectionStart === 0 && this.selectionEnd === 0) return;
        this._moveCursorLeftOrRight('Left', e);
    }
    /**
   * @private
   * @return {Boolean} true if a change happened
   *
   * @todo refactor not to use method name composition
   */ _move(e, prop, direction) {
        let newValue;
        if (e.altKey) newValue = this["findWordBoundary".concat(direction)](this[prop]);
        else if (e.metaKey || e.keyCode === 35 || e.keyCode === 36) newValue = this["findLineBoundary".concat(direction)](this[prop]);
        else {
            this[prop] += direction === 'Left' ? -1 : 1;
            return true;
        }
        if (typeof newValue !== 'undefined' && this[prop] !== newValue) {
            this[prop] = newValue;
            return true;
        }
        return false;
    }
    /**
   * @private
   */ _moveLeft(e, prop) {
        return this._move(e, prop, 'Left');
    }
    /**
   * @private
   */ _moveRight(e, prop) {
        return this._move(e, prop, 'Right');
    }
    /**
   * Moves cursor left without keeping selection
   * @param {KeyboardEvent} e
   */ moveCursorLeftWithoutShift(e) {
        let change = true;
        this._selectionDirection = $f268b97836dca6b6$var$LEFT;
        // only move cursor when there is no selection,
        // otherwise we discard it, and leave cursor on same place
        if (this.selectionEnd === this.selectionStart && this.selectionStart !== 0) change = this._moveLeft(e, 'selectionStart');
        this.selectionEnd = this.selectionStart;
        return change;
    }
    /**
   * Moves cursor left while keeping selection
   * @param {KeyboardEvent} e
   */ moveCursorLeftWithShift(e) {
        if (this._selectionDirection === $f268b97836dca6b6$var$RIGHT && this.selectionStart !== this.selectionEnd) return this._moveLeft(e, 'selectionEnd');
        else if (this.selectionStart !== 0) {
            this._selectionDirection = $f268b97836dca6b6$var$LEFT;
            return this._moveLeft(e, 'selectionStart');
        }
    }
    /**
   * Moves cursor right
   * @param {KeyboardEvent} e Event object
   */ moveCursorRight(e) {
        if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) return;
        this._moveCursorLeftOrRight('Right', e);
    }
    /**
   * Moves cursor right or Left, fires event
   * @param {String} direction 'Left', 'Right'
   * @param {KeyboardEvent} e Event object
   */ _moveCursorLeftOrRight(direction, e) {
        const actionName = "moveCursor".concat(direction).concat(e.shiftKey ? 'WithShift' : 'WithoutShift');
        this._currentCursorOpacity = 1;
        if (this[actionName](e)) {
            // TODO fix: abort and init should be an alternative depending
            // on selectionStart/End being equal or different
            this.abortCursorAnimation();
            this.initDelayedCursor();
            this._fireSelectionChanged();
            this._updateTextarea();
        }
    }
    /**
   * Moves cursor right while keeping selection
   * @param {KeyboardEvent} e
   */ moveCursorRightWithShift(e) {
        if (this._selectionDirection === $f268b97836dca6b6$var$LEFT && this.selectionStart !== this.selectionEnd) return this._moveRight(e, 'selectionStart');
        else if (this.selectionEnd !== this._text.length) {
            this._selectionDirection = $f268b97836dca6b6$var$RIGHT;
            return this._moveRight(e, 'selectionEnd');
        }
    }
    /**
   * Moves cursor right without keeping selection
   * @param {KeyboardEvent} e Event object
   */ moveCursorRightWithoutShift(e) {
        let changed = true;
        this._selectionDirection = $f268b97836dca6b6$var$RIGHT;
        if (this.selectionStart === this.selectionEnd) {
            changed = this._moveRight(e, 'selectionStart');
            this.selectionEnd = this.selectionStart;
        } else this.selectionStart = this.selectionEnd;
        return changed;
    }
}
/**
 * `LEFT_CLICK === 0`
 */ const $f268b97836dca6b6$var$notALeftClick = (e)=>!!e.button;
class $f268b97836dca6b6$var$ITextClickBehavior extends $f268b97836dca6b6$var$ITextKeyBehavior {
    initBehavior() {
        // Initializes event handlers related to cursor or selection
        this.on('mousedown', this._mouseDownHandler);
        this.on('mouseup', this.mouseUpHandler);
        this.on('mousedblclick', this.doubleClickHandler);
        this.on('mousetripleclick', this.tripleClickHandler);
        this.draggableTextDelegate = new $f268b97836dca6b6$var$DraggableTextDelegate(this);
        super.initBehavior();
    }
    /**
   * If this method returns true a mouse move operation over a text selection
   * will not prevent the native mouse event allowing the browser to start a drag operation.
   * shouldStartDragging can be read 'do not prevent default for mouse move event'
   * To prevent drag and drop between objects both shouldStartDragging and onDragStart should return false
   * @returns
   */ shouldStartDragging() {
        return this.draggableTextDelegate.isActive();
    }
    /**
   * @public override this method to control whether instance should/shouldn't become a drag source,
   * @see also {@link DraggableTextDelegate#isActive}
   * To prevent drag and drop between objects both shouldStartDragging and onDragStart should return false
   * @returns {boolean} should handle event
   */ onDragStart(e) {
        return this.draggableTextDelegate.onDragStart(e);
    }
    /**
   * @public override this method to control whether instance should/shouldn't become a drop target
   */ canDrop(e) {
        return this.draggableTextDelegate.canDrop(e);
    }
    /**
   * Default handler for double click, select a word
   */ doubleClickHandler(options) {
        if (!this.isEditing) return;
        this.selectWord(this.getSelectionStartFromPointer(options.e));
        this.renderCursorOrSelection();
    }
    /**
   * Default handler for triple click, select a line
   */ tripleClickHandler(options) {
        if (!this.isEditing) return;
        this.selectLine(this.getSelectionStartFromPointer(options.e));
        this.renderCursorOrSelection();
    }
    /**
   * Default event handler for the basic functionalities needed on _mouseDown
   * can be overridden to do something different.
   * Scope of this implementation is: find the click position, set selectionStart
   * find selectionEnd, initialize the drawing of either cursor or selection area
   * initializing a mousedDown on a text area will cancel fabricjs knowledge of
   * current compositionMode. It will be set to false.
   */ _mouseDownHandler(_ref) {
        let { e: e, alreadySelected: alreadySelected } = _ref;
        if (!this.canvas || !this.editable || $f268b97836dca6b6$var$notALeftClick(e) || this.getActiveControl()) return;
        if (this.draggableTextDelegate.start(e)) return;
        this.canvas.textEditingManager.register(this);
        if (alreadySelected) {
            this.inCompositionMode = false;
            this.setCursorByClick(e);
        }
        if (this.isEditing) {
            this.__selectionStartOnMouseDown = this.selectionStart;
            if (this.selectionStart === this.selectionEnd) this.abortCursorAnimation();
            this.renderCursorOrSelection();
        }
        this.selected || (this.selected = alreadySelected || this.isEditing);
    }
    /**
   * standard handler for mouse up, overridable
   * @private
   */ mouseUpHandler(_ref2) {
        let { e: e, transform: transform } = _ref2;
        const didDrag = this.draggableTextDelegate.end(e);
        if (this.canvas) {
            this.canvas.textEditingManager.unregister(this);
            const activeObject = this.canvas._activeObject;
            if (activeObject && activeObject !== this) // avoid running this logic when there is an active object
            // this because is possible with shift click and fast clicks,
            // to rapidly deselect and reselect this object and trigger an enterEdit
            return;
        }
        if (!this.editable || this.group && !this.group.interactive || transform && transform.actionPerformed || $f268b97836dca6b6$var$notALeftClick(e) || didDrag) return;
        if (this.selected && !this.getActiveControl()) {
            this.enterEditing(e);
            if (this.selectionStart === this.selectionEnd) this.initDelayedCursor(true);
            else this.renderCursorOrSelection();
        }
    }
    /**
   * Changes cursor location in a text depending on passed pointer (x/y) object
   * @param {TPointerEvent} e Event object
   */ setCursorByClick(e) {
        const newSelection = this.getSelectionStartFromPointer(e), start = this.selectionStart, end = this.selectionEnd;
        if (e.shiftKey) this.setSelectionStartEndWithShift(start, end, newSelection);
        else {
            this.selectionStart = newSelection;
            this.selectionEnd = newSelection;
        }
        if (this.isEditing) {
            this._fireSelectionChanged();
            this._updateTextarea();
        }
    }
    /**
   * Returns index of a character corresponding to where an object was clicked
   * @param {TPointerEvent} e Event object
   * @return {Number} Index of a character
   */ getSelectionStartFromPointer(e) {
        const mouseOffset = this.canvas.getScenePoint(e).transform($f268b97836dca6b6$var$invertTransform(this.calcTransformMatrix())).add(new $f268b97836dca6b6$export$baf26146a414f24a(-this._getLeftOffset(), -this._getTopOffset()));
        let height = 0, charIndex = 0, lineIndex = 0;
        for(let i = 0; i < this._textLines.length; i++){
            if (height <= mouseOffset.y) {
                height += this.getHeightOfLine(i);
                lineIndex = i;
                if (i > 0) charIndex += this._textLines[i - 1].length + this.missingNewlineOffset(i - 1);
            } else break;
        }
        const lineLeftOffset = Math.abs(this._getLineLeftOffset(lineIndex));
        let width = lineLeftOffset;
        const charLength = this._textLines[lineIndex].length;
        const chars = this.__charBounds[lineIndex];
        for(let j = 0; j < charLength; j++){
            // i removed something about flipX here, check.
            const charWidth = chars[j].kernedWidth;
            const widthAfter = width + charWidth;
            if (mouseOffset.x <= widthAfter) {
                // if the pointer is closer to the end of the char we increment charIndex
                // in order to position the cursor after the char
                if (Math.abs(mouseOffset.x - widthAfter) <= Math.abs(mouseOffset.x - width)) charIndex++;
                break;
            }
            width = widthAfter;
            charIndex++;
        }
        return Math.min(// if object is horizontally flipped, mirror cursor location from the end
        this.flipX ? charLength - charIndex : charIndex, this._text.length);
    }
    constructor(){
        super(...arguments);
        $f268b97836dca6b6$var$_defineProperty(this, "draggableTextDelegate", void 0);
    }
}
const $f268b97836dca6b6$var$MOVE_CURSOR_UP = 'moveCursorUp';
const $f268b97836dca6b6$var$MOVE_CURSOR_DOWN = 'moveCursorDown';
const $f268b97836dca6b6$var$MOVE_CURSOR_LEFT = 'moveCursorLeft';
const $f268b97836dca6b6$var$MOVE_CURSOR_RIGHT = 'moveCursorRight';
const $f268b97836dca6b6$var$EXIT_EDITING = 'exitEditing';
// @TODO look into import { Key } from 'ts-key-enum';
// and transition from keyCode to Key
// also reduce string duplication
const $f268b97836dca6b6$var$keysMap = {
    9: $f268b97836dca6b6$var$EXIT_EDITING,
    27: $f268b97836dca6b6$var$EXIT_EDITING,
    33: $f268b97836dca6b6$var$MOVE_CURSOR_UP,
    34: $f268b97836dca6b6$var$MOVE_CURSOR_DOWN,
    35: $f268b97836dca6b6$var$MOVE_CURSOR_RIGHT,
    36: $f268b97836dca6b6$var$MOVE_CURSOR_LEFT,
    37: $f268b97836dca6b6$var$MOVE_CURSOR_LEFT,
    38: $f268b97836dca6b6$var$MOVE_CURSOR_UP,
    39: $f268b97836dca6b6$var$MOVE_CURSOR_RIGHT,
    40: $f268b97836dca6b6$var$MOVE_CURSOR_DOWN
};
const $f268b97836dca6b6$var$keysMapRtl = {
    9: $f268b97836dca6b6$var$EXIT_EDITING,
    27: $f268b97836dca6b6$var$EXIT_EDITING,
    33: $f268b97836dca6b6$var$MOVE_CURSOR_UP,
    34: $f268b97836dca6b6$var$MOVE_CURSOR_DOWN,
    35: $f268b97836dca6b6$var$MOVE_CURSOR_LEFT,
    36: $f268b97836dca6b6$var$MOVE_CURSOR_RIGHT,
    37: $f268b97836dca6b6$var$MOVE_CURSOR_RIGHT,
    38: $f268b97836dca6b6$var$MOVE_CURSOR_UP,
    39: $f268b97836dca6b6$var$MOVE_CURSOR_LEFT,
    40: $f268b97836dca6b6$var$MOVE_CURSOR_DOWN
};
/**
 * For functionalities on keyUp + ctrl || cmd
 */ const $f268b97836dca6b6$var$ctrlKeysMapUp = {
    67: 'copy',
    // there was a reason this wasn't deleted. for now leave it here
    88: 'cut'
};
/**
 * For functionalities on keyDown + ctrl || cmd
 */ const $f268b97836dca6b6$var$ctrlKeysMapDown = {
    65: 'cmdAll'
};
/**
 * Set the transform of the passed context to the same of a specific Canvas or StaticCanvas.
 * setTransform is used since this utility will RESET the ctx transform to the basic value
 * of retina scaling and viewport transform
 * It is not meant to be added to other transforms, it is used internally to preapre canvases to draw
 * @param ctx
 * @param canvas
 */ const $f268b97836dca6b6$var$applyCanvasTransform = (ctx, canvas)=>{
    const scale = canvas.getRetinaScaling();
    ctx.setTransform(scale, 0, 0, scale, 0, 0);
    const v = canvas.viewportTransform;
    ctx.transform(v[0], v[1], v[2], v[3], v[4], v[5]);
};
// Declare IText protected properties to workaround TS
const $f268b97836dca6b6$var$protectedDefaultValues = {
    _selectionDirection: null,
    _reSpace: /\s|\r?\n/,
    inCompositionMode: false
};
const $f268b97836dca6b6$var$iTextDefaultValues = $f268b97836dca6b6$var$_objectSpread2({
    selectionStart: 0,
    selectionEnd: 0,
    selectionColor: 'rgba(17,119,255,0.3)',
    isEditing: false,
    editable: true,
    editingBorderColor: 'rgba(102,153,255,0.25)',
    cursorWidth: 2,
    cursorColor: '',
    cursorDelay: 1000,
    cursorDuration: 600,
    caching: true,
    hiddenTextareaContainer: null,
    keysMap: $f268b97836dca6b6$var$keysMap,
    keysMapRtl: $f268b97836dca6b6$var$keysMapRtl,
    ctrlKeysMapDown: $f268b97836dca6b6$var$ctrlKeysMapDown,
    ctrlKeysMapUp: $f268b97836dca6b6$var$ctrlKeysMapUp
}, $f268b97836dca6b6$var$protectedDefaultValues);
// @TODO this is not complete
/**
 * @fires changed
 * @fires selection:changed
 * @fires editing:entered
 * @fires editing:exited
 * @fires dragstart
 * @fires drag drag event firing on the drag source
 * @fires dragend
 * @fires copy
 * @fires cut
 * @fires paste
 *
 * #### Supported key combinations
 * ```
 *   Move cursor:                    left, right, up, down
 *   Select character:               shift + left, shift + right
 *   Select text vertically:         shift + up, shift + down
 *   Move cursor by word:            alt + left, alt + right
 *   Select words:                   shift + alt + left, shift + alt + right
 *   Move cursor to line start/end:  cmd + left, cmd + right or home, end
 *   Select till start/end of line:  cmd + shift + left, cmd + shift + right or shift + home, shift + end
 *   Jump to start/end of text:      cmd + up, cmd + down
 *   Select till start/end of text:  cmd + shift + up, cmd + shift + down or shift + pgUp, shift + pgDown
 *   Delete character:               backspace
 *   Delete word:                    alt + backspace
 *   Delete line:                    cmd + backspace
 *   Forward delete:                 delete
 *   Copy text:                      ctrl/cmd + c
 *   Paste text:                     ctrl/cmd + v
 *   Cut text:                       ctrl/cmd + x
 *   Select entire text:             ctrl/cmd + a
 *   Quit editing                    tab or esc
 * ```
 *
 * #### Supported mouse/touch combination
 * ```
 *   Position cursor:                click/touch
 *   Create selection:               click/touch & drag
 *   Create selection:               click & shift + click
 *   Select word:                    double click
 *   Select line:                    triple click
 * ```
 */ class $f268b97836dca6b6$export$6e837253f56cbab0 extends $f268b97836dca6b6$var$ITextClickBehavior {
    static getDefaults() {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.getDefaults()), $f268b97836dca6b6$export$6e837253f56cbab0.ownDefaults);
    }
    get type() {
        const type = super.type;
        // backward compatibility
        return type === 'itext' ? 'i-text' : type;
    }
    /**
   * While editing handle differently
   * @private
   * @param {string} key
   * @param {*} value
   */ _set(key, value) {
        if (this.isEditing && this._savedProps && key in this._savedProps) {
            // @ts-expect-error irritating TS
            this._savedProps[key] = value;
            return this;
        }
        if (key === 'canvas') {
            this.canvas instanceof $f268b97836dca6b6$export$8d01c972ee8b14a9 && this.canvas.textEditingManager.remove(this);
            value instanceof $f268b97836dca6b6$export$8d01c972ee8b14a9 && value.textEditingManager.add(this);
        }
        return super._set(key, value);
    }
    /**
   * Sets selection start (left boundary of a selection)
   * @param {Number} index Index to set selection start to
   */ setSelectionStart(index) {
        index = Math.max(index, 0);
        this._updateAndFire('selectionStart', index);
    }
    /**
   * Sets selection end (right boundary of a selection)
   * @param {Number} index Index to set selection end to
   */ setSelectionEnd(index) {
        index = Math.min(index, this.text.length);
        this._updateAndFire('selectionEnd', index);
    }
    /**
   * @private
   * @param {String} property 'selectionStart' or 'selectionEnd'
   * @param {Number} index new position of property
   */ _updateAndFire(property, index) {
        if (this[property] !== index) {
            this._fireSelectionChanged();
            this[property] = index;
        }
        this._updateTextarea();
    }
    /**
   * Fires the even of selection changed
   * @private
   */ _fireSelectionChanged() {
        this.fire('selection:changed');
        this.canvas && this.canvas.fire('text:selection:changed', {
            target: this
        });
    }
    /**
   * Initialize text dimensions. Render all text on given context
   * or on a offscreen canvas to get the text width with measureText.
   * Updates this.width and this.height with the proper values.
   * Does not return dimensions.
   * @private
   */ initDimensions() {
        this.isEditing && this.initDelayedCursor();
        super.initDimensions();
    }
    /**
   * Gets style of a current selection/cursor (at the start position)
   * if startIndex or endIndex are not provided, selectionStart or selectionEnd will be used.
   * @param {Number} startIndex Start index to get styles at
   * @param {Number} endIndex End index to get styles at, if not specified selectionEnd or startIndex + 1
   * @param {Boolean} [complete] get full style or not
   * @return {Array} styles an array with one, zero or more Style objects
   */ getSelectionStyles() {
        let startIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectionStart || 0;
        let endIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selectionEnd;
        let complete = arguments.length > 2 ? arguments[2] : undefined;
        return super.getSelectionStyles(startIndex, endIndex, complete);
    }
    /**
   * Sets style of a current selection, if no selection exist, do not set anything.
   * @param {Object} [styles] Styles object
   * @param {Number} [startIndex] Start index to get styles at
   * @param {Number} [endIndex] End index to get styles at, if not specified selectionEnd or startIndex + 1
   */ setSelectionStyles(styles) {
        let startIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.selectionStart || 0;
        let endIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.selectionEnd;
        return super.setSelectionStyles(styles, startIndex, endIndex);
    }
    /**
   * Returns 2d representation (lineIndex and charIndex) of cursor (or selection start)
   * @param {Number} [selectionStart] Optional index. When not given, current selectionStart is used.
   * @param {Boolean} [skipWrapping] consider the location for unwrapped lines. useful to manage styles.
   */ get2DCursorLocation() {
        let selectionStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectionStart;
        let skipWrapping = arguments.length > 1 ? arguments[1] : undefined;
        return super.get2DCursorLocation(selectionStart, skipWrapping);
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ render(ctx) {
        super.render(ctx);
        // clear the cursorOffsetCache, so we ensure to calculate once per renderCursor
        // the correct position but not at every cursor animation.
        this.cursorOffsetCache = {};
        this.renderCursorOrSelection();
    }
    /**
   * @override block cursor/selection logic while rendering the exported canvas
   * @todo this workaround should be replaced with a more robust solution
   */ toCanvasElement(options) {
        const isEditing = this.isEditing;
        this.isEditing = false;
        const canvas = super.toCanvasElement(options);
        this.isEditing = isEditing;
        return canvas;
    }
    /**
   * Renders cursor or selection (depending on what exists)
   * it does on the contextTop. If contextTop is not available, do nothing.
   */ renderCursorOrSelection() {
        if (!this.isEditing || !this.canvas) return;
        const ctx = this.clearContextTop(true);
        if (!ctx) return;
        const boundaries = this._getCursorBoundaries();
        const ancestors = this.findAncestorsWithClipPath();
        const hasAncestorsWithClipping = ancestors.length > 0;
        let drawingCtx = ctx;
        let drawingCanvas = undefined;
        if (hasAncestorsWithClipping) {
            // we have some clipPath, we need to draw the selection on an intermediate layer.
            drawingCanvas = $f268b97836dca6b6$var$createCanvasElementFor(ctx.canvas);
            drawingCtx = drawingCanvas.getContext('2d');
            $f268b97836dca6b6$var$applyCanvasTransform(drawingCtx, this.canvas);
            const m = this.calcTransformMatrix();
            drawingCtx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
        }
        if (this.selectionStart === this.selectionEnd && !this.inCompositionMode) this.renderCursor(drawingCtx, boundaries);
        else this.renderSelection(drawingCtx, boundaries);
        if (hasAncestorsWithClipping) // we need a neutral context.
        // this won't work for nested clippaths in which a clippath
        // has its own clippath
        for (const ancestor of ancestors){
            const clipPath = ancestor.clipPath;
            const clippingCanvas = $f268b97836dca6b6$var$createCanvasElementFor(ctx.canvas);
            const clippingCtx = clippingCanvas.getContext('2d');
            $f268b97836dca6b6$var$applyCanvasTransform(clippingCtx, this.canvas);
            // position the ctx in the center of the outer ancestor
            if (!clipPath.absolutePositioned) {
                const m = ancestor.calcTransformMatrix();
                clippingCtx.transform(m[0], m[1], m[2], m[3], m[4], m[5]);
            }
            clipPath.transform(clippingCtx);
            // we assign an empty drawing context, we don't plan to have this working for nested clippaths for now
            clipPath.drawObject(clippingCtx, true, {});
            this.drawClipPathOnCache(drawingCtx, clipPath, clippingCanvas);
        }
        if (hasAncestorsWithClipping) {
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.drawImage(drawingCanvas, 0, 0);
        }
        this.canvas.contextTopDirty = true;
        ctx.restore();
    }
    /**
   * Finds and returns an array of clip paths that are applied to the parent
   * group(s) of the current FabricObject instance. The object's hierarchy is
   * traversed upwards (from the current object towards the root of the canvas),
   * checking each parent object for the presence of a `clipPath` that is not
   * absolutely positioned.
   */ findAncestorsWithClipPath() {
        const clipPathAncestors = [];
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let obj = this;
        while(obj){
            if (obj.clipPath) clipPathAncestors.push(obj);
            obj = obj.parent;
        }
        return clipPathAncestors;
    }
    /**
   * Returns cursor boundaries (left, top, leftOffset, topOffset)
   * left/top are left/top of entire text box
   * leftOffset/topOffset are offset from that left/top point of a text box
   * @private
   * @param {number} [index] index from start
   * @param {boolean} [skipCaching]
   */ _getCursorBoundaries() {
        let index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectionStart;
        let skipCaching = arguments.length > 1 ? arguments[1] : undefined;
        const left = this._getLeftOffset(), top = this._getTopOffset(), offsets = this._getCursorBoundariesOffsets(index, skipCaching);
        return {
            left: left,
            top: top,
            leftOffset: offsets.left,
            topOffset: offsets.top
        };
    }
    /**
   * Caches and returns cursor left/top offset relative to instance's center point
   * @private
   * @param {number} index index from start
   * @param {boolean} [skipCaching]
   */ _getCursorBoundariesOffsets(index, skipCaching) {
        if (skipCaching) return this.__getCursorBoundariesOffsets(index);
        if (this.cursorOffsetCache && 'top' in this.cursorOffsetCache) return this.cursorOffsetCache;
        return this.cursorOffsetCache = this.__getCursorBoundariesOffsets(index);
    }
    /**
   * Calculates cursor left/top offset relative to instance's center point
   * @private
   * @param {number} index index from start
   */ __getCursorBoundariesOffsets(index) {
        let topOffset = 0, leftOffset = 0;
        const { charIndex: charIndex, lineIndex: lineIndex } = this.get2DCursorLocation(index);
        for(let i = 0; i < lineIndex; i++)topOffset += this.getHeightOfLine(i);
        const lineLeftOffset = this._getLineLeftOffset(lineIndex);
        const bound = this.__charBounds[lineIndex][charIndex];
        bound && (leftOffset = bound.left);
        if (this.charSpacing !== 0 && charIndex === this._textLines[lineIndex].length) leftOffset -= this._getWidthOfCharSpacing();
        const boundaries = {
            top: topOffset,
            left: lineLeftOffset + (leftOffset > 0 ? leftOffset : 0)
        };
        if (this.direction === 'rtl') {
            if (this.textAlign === $f268b97836dca6b6$var$RIGHT || this.textAlign === $f268b97836dca6b6$var$JUSTIFY || this.textAlign === $f268b97836dca6b6$var$JUSTIFY_RIGHT) boundaries.left *= -1;
            else if (this.textAlign === $f268b97836dca6b6$var$LEFT || this.textAlign === $f268b97836dca6b6$var$JUSTIFY_LEFT) boundaries.left = lineLeftOffset - (leftOffset > 0 ? leftOffset : 0);
            else if (this.textAlign === $f268b97836dca6b6$var$CENTER || this.textAlign === $f268b97836dca6b6$var$JUSTIFY_CENTER) boundaries.left = lineLeftOffset - (leftOffset > 0 ? leftOffset : 0);
        }
        return boundaries;
    }
    /**
   * Renders cursor on context Top, outside the animation cycle, on request
   * Used for the drag/drop effect.
   * If contextTop is not available, do nothing.
   */ renderCursorAt(selectionStart) {
        this._renderCursor(this.canvas.contextTop, this._getCursorBoundaries(selectionStart, true), selectionStart);
    }
    /**
   * Renders cursor
   * @param {Object} boundaries
   * @param {CanvasRenderingContext2D} ctx transformed context to draw on
   */ renderCursor(ctx, boundaries) {
        this._renderCursor(ctx, boundaries, this.selectionStart);
    }
    /**
   * Return the data needed to render the cursor for given selection start
   * The left,top are relative to the object, while width and height are prescaled
   * to look think with canvas zoom and object scaling,
   * so they depend on canvas and object scaling
   */ getCursorRenderingData() {
        let selectionStart = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectionStart;
        let boundaries = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._getCursorBoundaries(selectionStart);
        const cursorLocation = this.get2DCursorLocation(selectionStart), lineIndex = cursorLocation.lineIndex, charIndex = cursorLocation.charIndex > 0 ? cursorLocation.charIndex - 1 : 0, charHeight = this.getValueOfPropertyAt(lineIndex, charIndex, 'fontSize'), multiplier = this.getObjectScaling().x * this.canvas.getZoom(), cursorWidth = this.cursorWidth / multiplier, dy = this.getValueOfPropertyAt(lineIndex, charIndex, 'deltaY'), topOffset = boundaries.topOffset + (1 - this._fontSizeFraction) * this.getHeightOfLine(lineIndex) / this.lineHeight - charHeight * (1 - this._fontSizeFraction);
        return {
            color: this.cursorColor || this.getValueOfPropertyAt(lineIndex, charIndex, 'fill'),
            opacity: this._currentCursorOpacity,
            left: boundaries.left + boundaries.leftOffset - cursorWidth / 2,
            top: topOffset + boundaries.top + dy,
            width: cursorWidth,
            height: charHeight
        };
    }
    /**
   * Render the cursor at the given selectionStart.
   * @param {CanvasRenderingContext2D} ctx transformed context to draw on
   */ _renderCursor(ctx, boundaries, selectionStart) {
        const { color: color, opacity: opacity, left: left, top: top, width: width, height: height } = this.getCursorRenderingData(selectionStart, boundaries);
        ctx.fillStyle = color;
        ctx.globalAlpha = opacity;
        ctx.fillRect(left, top, width, height);
    }
    /**
   * Renders text selection
   * @param {Object} boundaries Object with left/top/leftOffset/topOffset
   * @param {CanvasRenderingContext2D} ctx transformed context to draw on
   */ renderSelection(ctx, boundaries) {
        const selection = {
            selectionStart: this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart,
            selectionEnd: this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd
        };
        this._renderSelection(ctx, selection, boundaries);
    }
    /**
   * Renders drag start text selection
   */ renderDragSourceEffect() {
        const dragStartSelection = this.draggableTextDelegate.getDragStartSelection();
        this._renderSelection(this.canvas.contextTop, dragStartSelection, this._getCursorBoundaries(dragStartSelection.selectionStart, true));
    }
    renderDropTargetEffect(e) {
        const dragSelection = this.getSelectionStartFromPointer(e);
        this.renderCursorAt(dragSelection);
    }
    /**
   * Renders text selection
   * @private
   * @param {{ selectionStart: number, selectionEnd: number }} selection
   * @param {Object} boundaries Object with left/top/leftOffset/topOffset
   * @param {CanvasRenderingContext2D} ctx transformed context to draw on
   */ _renderSelection(ctx, selection, boundaries) {
        const selectionStart = selection.selectionStart, selectionEnd = selection.selectionEnd, isJustify = this.textAlign.includes($f268b97836dca6b6$var$JUSTIFY), start = this.get2DCursorLocation(selectionStart), end = this.get2DCursorLocation(selectionEnd), startLine = start.lineIndex, endLine = end.lineIndex, startChar = start.charIndex < 0 ? 0 : start.charIndex, endChar = end.charIndex < 0 ? 0 : end.charIndex;
        for(let i = startLine; i <= endLine; i++){
            const lineOffset = this._getLineLeftOffset(i) || 0;
            let lineHeight = this.getHeightOfLine(i), realLineHeight = 0, boxStart = 0, boxEnd = 0;
            if (i === startLine) boxStart = this.__charBounds[startLine][startChar].left;
            if (i >= startLine && i < endLine) boxEnd = isJustify && !this.isEndOfWrapping(i) ? this.width : this.getLineWidth(i) || 5; // WTF is this 5?
            else if (i === endLine) {
                if (endChar === 0) boxEnd = this.__charBounds[endLine][endChar].left;
                else {
                    const charSpacing = this._getWidthOfCharSpacing();
                    boxEnd = this.__charBounds[endLine][endChar - 1].left + this.__charBounds[endLine][endChar - 1].width - charSpacing;
                }
            }
            realLineHeight = lineHeight;
            if (this.lineHeight < 1 || i === endLine && this.lineHeight > 1) lineHeight /= this.lineHeight;
            let drawStart = boundaries.left + lineOffset + boxStart, drawHeight = lineHeight, extraTop = 0;
            const drawWidth = boxEnd - boxStart;
            if (this.inCompositionMode) {
                ctx.fillStyle = this.compositionColor || 'black';
                drawHeight = 1;
                extraTop = lineHeight;
            } else ctx.fillStyle = this.selectionColor;
            if (this.direction === 'rtl') {
                if (this.textAlign === $f268b97836dca6b6$var$RIGHT || this.textAlign === $f268b97836dca6b6$var$JUSTIFY || this.textAlign === $f268b97836dca6b6$var$JUSTIFY_RIGHT) drawStart = this.width - drawStart - drawWidth;
                else if (this.textAlign === $f268b97836dca6b6$var$LEFT || this.textAlign === $f268b97836dca6b6$var$JUSTIFY_LEFT) drawStart = boundaries.left + lineOffset - boxEnd;
                else if (this.textAlign === $f268b97836dca6b6$var$CENTER || this.textAlign === $f268b97836dca6b6$var$JUSTIFY_CENTER) drawStart = boundaries.left + lineOffset - boxEnd;
            }
            ctx.fillRect(drawStart, boundaries.top + boundaries.topOffset + extraTop, drawWidth, drawHeight);
            boundaries.topOffset += realLineHeight;
        }
    }
    /**
   * High level function to know the height of the cursor.
   * the currentChar is the one that precedes the cursor
   * Returns fontSize of char at the current cursor
   * Unused from the library, is for the end user
   * @return {Number} Character font size
   */ getCurrentCharFontSize() {
        const cp = this._getCurrentCharIndex();
        return this.getValueOfPropertyAt(cp.l, cp.c, 'fontSize');
    }
    /**
   * High level function to know the color of the cursor.
   * the currentChar is the one that precedes the cursor
   * Returns color (fill) of char at the current cursor
   * if the text object has a pattern or gradient for filler, it will return that.
   * Unused by the library, is for the end user
   * @return {String | TFiller} Character color (fill)
   */ getCurrentCharColor() {
        const cp = this._getCurrentCharIndex();
        return this.getValueOfPropertyAt(cp.l, cp.c, $f268b97836dca6b6$var$FILL);
    }
    /**
   * Returns the cursor position for the getCurrent.. functions
   * @private
   */ _getCurrentCharIndex() {
        const cursorPosition = this.get2DCursorLocation(this.selectionStart, true), charIndex = cursorPosition.charIndex > 0 ? cursorPosition.charIndex - 1 : 0;
        return {
            l: cursorPosition.lineIndex,
            c: charIndex
        };
    }
    dispose() {
        this.exitEditingImpl();
        this.draggableTextDelegate.dispose();
        super.dispose();
    }
    /**
   * Constructor
   * @param {String} text Text string
   * @param {Object} [options] Options object
   */ constructor(text, options){
        super(text, $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, $f268b97836dca6b6$export$6e837253f56cbab0.ownDefaults), options));
        this.initBehavior();
    }
}
/**
 * Index where text selection starts (or where cursor is when there is no selection)
 * @type Number
 * @default
 */ /**
 * Index where text selection ends
 * @type Number
 * @default
 */ /**
 * Color of text selection
 * @type String
 * @default
 */ /**
 * Indicates whether text is in editing mode
 * @type Boolean
 * @default
 */ /**
 * Indicates whether a text can be edited
 * @type Boolean
 * @default
 */ /**
 * Border color of text object while it's in editing mode
 * @type String
 * @default
 */ /**
 * Width of cursor (in px)
 * @type Number
 * @default
 */ /**
 * Color of text cursor color in editing mode.
 * if not set (default) will take color from the text.
 * if set to a color value that fabric can understand, it will
 * be used instead of the color of the text at the current position.
 * @type String
 * @default
 */ /**
 * Delay between cursor blink (in ms)
 * @type Number
 * @default
 */ /**
 * Duration of cursor fade in (in ms)
 * @type Number
 * @default
 */ /**
 * Indicates whether internal text char widths can be cached
 * @type Boolean
 * @default
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$6e837253f56cbab0, "ownDefaults", $f268b97836dca6b6$var$iTextDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$6e837253f56cbab0, "type", 'IText');
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$6e837253f56cbab0);
// legacy
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$6e837253f56cbab0, 'i-text');
// @TODO: Many things here are configuration related and shouldn't be on the class nor prototype
// regexes, list of properties that are not suppose to change by instances, magic consts.
// this will be a separated effort
const $f268b97836dca6b6$var$textboxDefaultValues = {
    minWidth: 20,
    dynamicMinWidth: 2,
    lockScalingFlip: true,
    noScaleCache: false,
    _wordJoiners: /[ \t\r]/,
    splitByGrapheme: false
};
// @TODO this is not complete
/**
 * Textbox class, based on IText, allows the user to resize the text rectangle
 * and wraps lines automatically. Textboxes have their Y scaling locked, the
 * user can only change width. Height is adjusted automatically based on the
 * wrapping of lines.
 */ class $f268b97836dca6b6$export$8e3dca5fa4d5f04b extends $f268b97836dca6b6$export$6e837253f56cbab0 {
    static getDefaults() {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.getDefaults()), $f268b97836dca6b6$export$8e3dca5fa4d5f04b.ownDefaults);
    }
    /**
   * Creates the default control object.
   * If you prefer to have on instance of controls shared among all objects
   * make this function return an empty object and add controls to the ownDefaults object
   */ static createControls() {
        return {
            controls: $f268b97836dca6b6$var$createTextboxDefaultControls()
        };
    }
    /**
   * Unlike superclass's version of this function, Textbox does not update
   * its width.
   * @private
   * @override
   */ initDimensions() {
        if (!this.initialized) return;
        this.isEditing && this.initDelayedCursor();
        this._clearCache();
        // clear dynamicMinWidth as it will be different after we re-wrap line
        this.dynamicMinWidth = 0;
        // wrap lines
        this._styleMap = this._generateStyleMap(this._splitText());
        // if after wrapping, the width is smaller than dynamicMinWidth, change the width and re-wrap
        if (this.dynamicMinWidth > this.width) this._set('width', this.dynamicMinWidth);
        if (this.textAlign.includes($f268b97836dca6b6$var$JUSTIFY)) // once text is measured we need to make space fatter to make justified text.
        this.enlargeSpaces();
        // clear cache and re-calculate height
        this.height = this.calcTextHeight();
    }
    /**
   * Generate an object that translates the style object so that it is
   * broken up by visual lines (new lines and automatic wrapping).
   * The original text styles object is broken up by actual lines (new lines only),
   * which is only sufficient for Text / IText
   * @private
   */ _generateStyleMap(textInfo) {
        let realLineCount = 0, realLineCharCount = 0, charCount = 0;
        const map = {};
        for(let i = 0; i < textInfo.graphemeLines.length; i++){
            if (textInfo.graphemeText[charCount] === '\n' && i > 0) {
                realLineCharCount = 0;
                charCount++;
                realLineCount++;
            } else if (!this.splitByGrapheme && this._reSpaceAndTab.test(textInfo.graphemeText[charCount]) && i > 0) {
                // this case deals with space's that are removed from end of lines when wrapping
                realLineCharCount++;
                charCount++;
            }
            map[i] = {
                line: realLineCount,
                offset: realLineCharCount
            };
            charCount += textInfo.graphemeLines[i].length;
            realLineCharCount += textInfo.graphemeLines[i].length;
        }
        return map;
    }
    /**
   * Returns true if object has a style property or has it on a specified line
   * @param {Number} lineIndex
   * @return {Boolean}
   */ styleHas(property, lineIndex) {
        if (this._styleMap && !this.isWrapping) {
            const map = this._styleMap[lineIndex];
            if (map) lineIndex = map.line;
        }
        return super.styleHas(property, lineIndex);
    }
    /**
   * Returns true if object has no styling or no styling in a line
   * @param {Number} lineIndex , lineIndex is on wrapped lines.
   * @return {Boolean}
   */ isEmptyStyles(lineIndex) {
        if (!this.styles) return true;
        let offset = 0, nextLineIndex = lineIndex + 1, nextOffset, shouldLimit = false;
        const map = this._styleMap[lineIndex], mapNextLine = this._styleMap[lineIndex + 1];
        if (map) {
            lineIndex = map.line;
            offset = map.offset;
        }
        if (mapNextLine) {
            nextLineIndex = mapNextLine.line;
            shouldLimit = nextLineIndex === lineIndex;
            nextOffset = mapNextLine.offset;
        }
        const obj = typeof lineIndex === 'undefined' ? this.styles : {
            line: this.styles[lineIndex]
        };
        for(const p1 in obj)for(const p2 in obj[p1]){
            const p2Number = parseInt(p2, 10);
            if (p2Number >= offset && (!shouldLimit || p2Number < nextOffset)) {
                // eslint-disable-next-line no-unused-vars
                for(const p3 in obj[p1][p2])return false;
            }
        }
        return true;
    }
    /**
   * @protected
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @return {TextStyleDeclaration} a style object reference to the existing one or a new empty object when undefined
   */ _getStyleDeclaration(lineIndex, charIndex) {
        if (this._styleMap && !this.isWrapping) {
            const map = this._styleMap[lineIndex];
            if (!map) return {};
            lineIndex = map.line;
            charIndex = map.offset + charIndex;
        }
        return super._getStyleDeclaration(lineIndex, charIndex);
    }
    /**
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @param {Object} style
   * @private
   */ _setStyleDeclaration(lineIndex, charIndex, style) {
        const map = this._styleMap[lineIndex];
        super._setStyleDeclaration(map.line, map.offset + charIndex, style);
    }
    /**
   * @param {Number} lineIndex
   * @param {Number} charIndex
   * @private
   */ _deleteStyleDeclaration(lineIndex, charIndex) {
        const map = this._styleMap[lineIndex];
        super._deleteStyleDeclaration(map.line, map.offset + charIndex);
    }
    /**
   * probably broken need a fix
   * Returns the real style line that correspond to the wrapped lineIndex line
   * Used just to verify if the line does exist or not.
   * @param {Number} lineIndex
   * @returns {Boolean} if the line exists or not
   * @private
   */ _getLineStyle(lineIndex) {
        const map = this._styleMap[lineIndex];
        return !!this.styles[map.line];
    }
    /**
   * Set the line style to an empty object so that is initialized
   * @param {Number} lineIndex
   * @param {Object} style
   * @private
   */ _setLineStyle(lineIndex) {
        const map = this._styleMap[lineIndex];
        super._setLineStyle(map.line);
    }
    /**
   * Wraps text using the 'width' property of Textbox. First this function
   * splits text on newlines, so we preserve newlines entered by the user.
   * Then it wraps each line using the width of the Textbox by calling
   * _wrapLine().
   * @param {Array} lines The string array of text that is split into lines
   * @param {Number} desiredWidth width you want to wrap to
   * @returns {Array} Array of lines
   */ _wrapText(lines, desiredWidth) {
        this.isWrapping = true;
        // extract all thewords and the widths to optimally wrap lines.
        const data = this.getGraphemeDataForRender(lines);
        const wrapped = [];
        for(let i = 0; i < data.wordsData.length; i++)wrapped.push(...this._wrapLine(i, desiredWidth, data));
        this.isWrapping = false;
        return wrapped;
    }
    /**
   * For each line of text terminated by an hard line stop,
   * measure each word width and extract the largest word from all.
   * The returned words here are the one that at the end will be rendered.
   * @param {string[]} lines the lines we need to measure
   *
   */ getGraphemeDataForRender(lines) {
        const splitByGrapheme = this.splitByGrapheme, infix = splitByGrapheme ? '' : ' ';
        let largestWordWidth = 0;
        const data = lines.map((line, lineIndex)=>{
            let offset = 0;
            const wordsOrGraphemes = splitByGrapheme ? this.graphemeSplit(line) : this.wordSplit(line);
            if (wordsOrGraphemes.length === 0) return [
                {
                    word: [],
                    width: 0
                }
            ];
            return wordsOrGraphemes.map((word)=>{
                // if using splitByGrapheme words are already in graphemes.
                const graphemeArray = splitByGrapheme ? [
                    word
                ] : this.graphemeSplit(word);
                const width = this._measureWord(graphemeArray, lineIndex, offset);
                largestWordWidth = Math.max(width, largestWordWidth);
                offset += graphemeArray.length + infix.length;
                return {
                    word: graphemeArray,
                    width: width
                };
            });
        });
        return {
            wordsData: data,
            largestWordWidth: largestWordWidth
        };
    }
    /**
   * Helper function to measure a string of text, given its lineIndex and charIndex offset
   * It gets called when charBounds are not available yet.
   * Override if necessary
   * Use with {@link Textbox#wordSplit}
   *
   * @param {CanvasRenderingContext2D} ctx
   * @param {String} text
   * @param {number} lineIndex
   * @param {number} charOffset
   * @returns {number}
   */ _measureWord(word, lineIndex) {
        let charOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        let width = 0, prevGrapheme;
        const skipLeft = true;
        for(let i = 0, len = word.length; i < len; i++){
            const box = this._getGraphemeBox(word[i], lineIndex, i + charOffset, prevGrapheme, skipLeft);
            width += box.kernedWidth;
            prevGrapheme = word[i];
        }
        return width;
    }
    /**
   * Override this method to customize word splitting
   * Use with {@link Textbox#_measureWord}
   * @param {string} value
   * @returns {string[]} array of words
   */ wordSplit(value) {
        return value.split(this._wordJoiners);
    }
    /**
   * Wraps a line of text using the width of the Textbox as desiredWidth
   * and leveraging the known width o words from GraphemeData
   * @private
   * @param {Number} lineIndex
   * @param {Number} desiredWidth width you want to wrap the line to
   * @param {GraphemeData} graphemeData an object containing all the lines' words width.
   * @param {Number} reservedSpace space to remove from wrapping for custom functionalities
   * @returns {Array} Array of line(s) into which the given text is wrapped
   * to.
   */ _wrapLine(lineIndex, desiredWidth, _ref) {
        let { largestWordWidth: largestWordWidth, wordsData: wordsData } = _ref;
        let reservedSpace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        const additionalSpace = this._getWidthOfCharSpacing(), splitByGrapheme = this.splitByGrapheme, graphemeLines = [], infix = splitByGrapheme ? '' : ' ';
        let lineWidth = 0, line = [], // spaces in different languages?
        offset = 0, infixWidth = 0, lineJustStarted = true;
        desiredWidth -= reservedSpace;
        const maxWidth = Math.max(desiredWidth, largestWordWidth, this.dynamicMinWidth);
        // layout words
        const data = wordsData[lineIndex];
        offset = 0;
        let i;
        for(i = 0; i < data.length; i++){
            const { word: word, width: wordWidth } = data[i];
            offset += word.length;
            lineWidth += infixWidth + wordWidth - additionalSpace;
            if (lineWidth > maxWidth && !lineJustStarted) {
                graphemeLines.push(line);
                line = [];
                lineWidth = wordWidth;
                lineJustStarted = true;
            } else lineWidth += additionalSpace;
            if (!lineJustStarted && !splitByGrapheme) line.push(infix);
            line = line.concat(word);
            infixWidth = splitByGrapheme ? 0 : this._measureWord([
                infix
            ], lineIndex, offset);
            offset++;
            lineJustStarted = false;
        }
        i && graphemeLines.push(line);
        // TODO: this code is probably not necessary anymore.
        // it can be moved out of this function since largestWordWidth is now
        // known in advance
        if (largestWordWidth + reservedSpace > this.dynamicMinWidth) this.dynamicMinWidth = largestWordWidth - additionalSpace + reservedSpace;
        return graphemeLines;
    }
    /**
   * Detect if the text line is ended with an hard break
   * text and itext do not have wrapping, return false
   * @param {Number} lineIndex text to split
   * @return {Boolean}
   */ isEndOfWrapping(lineIndex) {
        if (!this._styleMap[lineIndex + 1]) // is last line, return true;
        return true;
        if (this._styleMap[lineIndex + 1].line !== this._styleMap[lineIndex].line) // this is last line before a line break, return true;
        return true;
        return false;
    }
    /**
   * Detect if a line has a linebreak and so we need to account for it when moving
   * and counting style.
   * This is important only for splitByGrapheme at the end of wrapping.
   * If we are not wrapping the offset is always 1
   * @return Number
   */ missingNewlineOffset(lineIndex, skipWrapping) {
        if (this.splitByGrapheme && !skipWrapping) return this.isEndOfWrapping(lineIndex) ? 1 : 0;
        return 1;
    }
    /**
   * Gets lines of text to render in the Textbox. This function calculates
   * text wrapping on the fly every time it is called.
   * @param {String} text text to split
   * @returns {Array} Array of lines in the Textbox.
   * @override
   */ _splitTextIntoLines(text) {
        const newText = super._splitTextIntoLines(text), graphemeLines = this._wrapText(newText.lines, this.width), lines = new Array(graphemeLines.length);
        for(let i = 0; i < graphemeLines.length; i++)lines[i] = graphemeLines[i].join('');
        newText.lines = lines;
        newText.graphemeLines = graphemeLines;
        return newText;
    }
    getMinWidth() {
        return Math.max(this.minWidth, this.dynamicMinWidth);
    }
    _removeExtraneousStyles() {
        const linesToKeep = new Map();
        for(const prop in this._styleMap){
            const propNumber = parseInt(prop, 10);
            if (this._textLines[propNumber]) {
                const lineIndex = this._styleMap[prop].line;
                linesToKeep.set("".concat(lineIndex), true);
            }
        }
        for(const prop in this.styles)if (!linesToKeep.has(prop)) delete this.styles[prop];
    }
    /**
   * Returns object representation of an instance
   * @method toObject
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return super.toObject([
            'minWidth',
            'splitByGrapheme',
            ...propertiesToInclude
        ]);
    }
    /**
   * Constructor
   * @param {String} text Text string
   * @param {Object} [options] Options object
   */ constructor(text, options){
        super(text, $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, $f268b97836dca6b6$export$8e3dca5fa4d5f04b.ownDefaults), options));
    }
}
/**
 * Minimum width of textbox, in pixels.
 * @type Number
 * @default
 */ /**
 * Minimum calculated width of a textbox, in pixels.
 * fixed to 2 so that an empty textbox cannot go to 0
 * and is still selectable without text.
 * @type Number
 * @default
 */ /**
 * Use this boolean property in order to split strings that have no white space concept.
 * this is a cheap way to help with chinese/japanese
 * @type Boolean
 * @since 2.6.0
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$8e3dca5fa4d5f04b, "type", 'Textbox');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$8e3dca5fa4d5f04b, "textLayoutProperties", [
    ...$f268b97836dca6b6$export$6e837253f56cbab0.textLayoutProperties,
    'width'
]);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$8e3dca5fa4d5f04b, "ownDefaults", $f268b97836dca6b6$var$textboxDefaultValues);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$8e3dca5fa4d5f04b);
/**
 * Layout will adjust the bounding box to match the clip path bounding box.
 */ class $f268b97836dca6b6$export$73ee6802ebd70462 extends $f268b97836dca6b6$export$f7b260234c293505 {
    shouldPerformLayout(context) {
        return !!context.target.clipPath && super.shouldPerformLayout(context);
    }
    shouldLayoutClipPath() {
        return false;
    }
    calcLayoutResult(context, objects) {
        const { target: target } = context;
        const { clipPath: clipPath, group: group } = target;
        if (!clipPath || !this.shouldPerformLayout(context)) return;
        // TODO: remove stroke calculation from this case
        const { width: width, height: height } = $f268b97836dca6b6$var$makeBoundingBoxFromPoints($f268b97836dca6b6$var$getObjectBounds(target, clipPath));
        const size = new $f268b97836dca6b6$export$baf26146a414f24a(width, height);
        if (clipPath.absolutePositioned) {
            //  we want the center point to exist in group's containing plane
            const clipPathCenter = $f268b97836dca6b6$var$sendPointToPlane(clipPath.getRelativeCenterPoint(), undefined, group ? group.calcTransformMatrix() : undefined);
            return {
                center: clipPathCenter,
                size: size
            };
        } else {
            //  we want the center point to exist in group's containing plane, so we send it upwards
            const clipPathCenter = clipPath.getRelativeCenterPoint().transform(target.calcOwnMatrix(), true);
            if (this.shouldPerformLayout(context)) {
                // the clip path is positioned relative to the group's center which is affected by the bbox
                // so we first calculate the bbox
                const { center: center = new $f268b97836dca6b6$export$baf26146a414f24a(), correction: correction = new $f268b97836dca6b6$export$baf26146a414f24a() } = this.calcBoundingBox(objects, context) || {};
                return {
                    center: center.add(clipPathCenter),
                    correction: correction.subtract(clipPathCenter),
                    size: size
                };
            } else return {
                center: target.getRelativeCenterPoint().add(clipPathCenter),
                size: size
            };
        }
    }
}
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$73ee6802ebd70462, "type", 'clip-path');
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$73ee6802ebd70462);
/**
 * Layout will keep target's initial size.
 */ class $f268b97836dca6b6$export$50774ba6edfcc9a extends $f268b97836dca6b6$export$f7b260234c293505 {
    /**
   * @override respect target's initial size
   */ getInitialSize(_ref, _ref2) {
        let { target: target } = _ref;
        let { size: size } = _ref2;
        return new $f268b97836dca6b6$export$baf26146a414f24a(target.width || size.x, target.height || size.y);
    }
}
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$50774ba6edfcc9a, "type", 'fixed');
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$50774ba6edfcc9a);
/**
 * Today the LayoutManager class also takes care of subscribing event handlers
 * to update the group layout when the group is interactive and a transform is applied
 * to a child object.
 * The ActiveSelection is never interactive, but it could contain objects from
 * groups that are.
 * The standard LayoutManager would subscribe the children of the activeSelection to
 * perform layout changes to the active selection itself, what we need instead is that
 * the transformation applied to the active selection will trigger changes to the
 * original group of the children ( the one referenced under the parent property )
 * This subclass of the LayoutManager has a single duty to fill the gap of this difference.`
 */ class $f268b97836dca6b6$var$ActiveSelectionLayoutManager extends $f268b97836dca6b6$export$4a04ad01c410b415 {
    subscribeTargets(context) {
        const activeSelection = context.target;
        const parents = context.targets.reduce((parents, target)=>{
            target.parent && parents.add(target.parent);
            return parents;
        }, new Set());
        parents.forEach((parent)=>{
            parent.layoutManager.subscribeTargets({
                target: parent,
                targets: [
                    activeSelection
                ]
            });
        });
    }
    /**
   * unsubscribe from parent only if all its children were deselected
   */ unsubscribeTargets(context) {
        const activeSelection = context.target;
        const selectedObjects = activeSelection.getObjects();
        const parents = context.targets.reduce((parents, target)=>{
            target.parent && parents.add(target.parent);
            return parents;
        }, new Set());
        parents.forEach((parent)=>{
            !selectedObjects.some((object)=>object.parent === parent) && parent.layoutManager.unsubscribeTargets({
                target: parent,
                targets: [
                    activeSelection
                ]
            });
        });
    }
}
const $f268b97836dca6b6$var$activeSelectionDefaultValues = {
    multiSelectionStacking: 'canvas-stacking'
};
/**
 * Used by Canvas to manage selection.
 *
 * @example
 * class MyActiveSelection extends ActiveSelection {
 *   ...
 * }
 *
 * // override the default `ActiveSelection` class
 * classRegistry.setClass(MyActiveSelection)
 */ class $f268b97836dca6b6$export$c57a942eef0ccd19 extends $f268b97836dca6b6$export$eb2fcfdbd7ba97d4 {
    static getDefaults() {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.getDefaults()), $f268b97836dca6b6$export$c57a942eef0ccd19.ownDefaults);
    }
    /**
   * @private
   */ _shouldSetNestedCoords() {
        return true;
    }
    /**
   * @private
   * @override we don't want the selection monitor to be active
   */ __objectSelectionMonitor() {
    //  noop
    }
    /**
   * Adds objects with respect to {@link multiSelectionStacking}
   * @param targets object to add to selection
   */ multiSelectAdd() {
        for(var _len = arguments.length, targets = new Array(_len), _key = 0; _key < _len; _key++)targets[_key] = arguments[_key];
        if (this.multiSelectionStacking === 'selection-order') this.add(...targets);
        else //  respect object stacking as it is on canvas
        //  perf enhancement for large ActiveSelection: consider a binary search of `isInFrontOf`
        targets.forEach((target)=>{
            const index = this._objects.findIndex((obj)=>obj.isInFrontOf(target));
            const insertAt = index === -1 ? //  `target` is in front of all other objects
            this.size() : index;
            this.insertAt(insertAt, target);
        });
    }
    /**
   * @override block ancestors/descendants of selected objects from being selected to prevent a circular object tree
   */ canEnterGroup(object) {
        if (this.getObjects().some((o)=>o.isDescendantOf(object) || object.isDescendantOf(o))) {
            //  prevent circular object tree
            $f268b97836dca6b6$var$log('error', 'ActiveSelection: circular object trees are not supported, this call has no effect');
            return false;
        }
        return super.canEnterGroup(object);
    }
    /**
   * Change an object so that it can be part of an active selection.
   * this method is called by multiselectAdd from canvas code.
   * @private
   * @param {FabricObject} object
   * @param {boolean} [removeParentTransform] true if object is in canvas coordinate plane
   */ enterGroup(object, removeParentTransform) {
        // This condition check that the object has currently a group, and the group
        // is also its parent, meaning that is not in an active selection, but is
        // in a normal group.
        if (object.parent && object.parent === object.group) // Disconnect the object from the group functionalities, but keep the ref parent intact
        // for later re-enter
        object.parent._exitGroup(object);
        else if (object.group && object.parent !== object.group) // in this case group.remove will also clear the old parent reference.
        object.group.remove(object);
        // enter the active selection from a render perspective
        // the object will be in the objects array of both the ActiveSelection and the Group
        // but referenced in the group's _activeObjects so that it won't be rendered twice.
        this._enterGroup(object, removeParentTransform);
    }
    /**
   * we want objects to retain their canvas ref when exiting instance
   * @private
   * @param {FabricObject} object
   * @param {boolean} [removeParentTransform] true if object should exit group without applying group's transform to it
   */ exitGroup(object, removeParentTransform) {
        this._exitGroup(object, removeParentTransform);
        // return to parent
        object.parent && object.parent._enterGroup(object, true);
    }
    /**
   * @private
   * @param {'added'|'removed'} type
   * @param {FabricObject[]} targets
   */ _onAfterObjectsChange(type, targets) {
        super._onAfterObjectsChange(type, targets);
        const groups = new Set();
        targets.forEach((object)=>{
            const { parent: parent } = object;
            parent && groups.add(parent);
        });
        if (type === $f268b97836dca6b6$var$LAYOUT_TYPE_REMOVED) //  invalidate groups' layout and mark as dirty
        groups.forEach((group)=>{
            group._onAfterObjectsChange($f268b97836dca6b6$var$LAYOUT_TYPE_ADDED, targets);
        });
        else //  mark groups as dirty
        groups.forEach((group)=>{
            group._set('dirty', true);
        });
    }
    /**
   * @override remove all objects
   */ onDeselect() {
        this.removeAll();
        return false;
    }
    /**
   * Returns string representation of a group
   * @return {String}
   */ toString() {
        return "#<ActiveSelection: (".concat(this.complexity(), ")>");
    }
    /**
   * Decide if the object should cache or not. The Active selection never caches
   * @return {Boolean}
   */ shouldCache() {
        return false;
    }
    /**
   * Check if this group or its parent group are caching, recursively up
   * @return {Boolean}
   */ isOnACache() {
        return false;
    }
    /**
   * Renders controls and borders for the object
   * @param {CanvasRenderingContext2D} ctx Context to render on
   * @param {Object} [styleOverride] properties to override the object style
   * @param {Object} [childrenOverride] properties to override the children overrides
   */ _renderControls(ctx, styleOverride, childrenOverride) {
        ctx.save();
        ctx.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
        const options = $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({
            hasControls: false
        }, childrenOverride), {}, {
            forActiveSelection: true
        });
        for(let i = 0; i < this._objects.length; i++)this._objects[i]._renderControls(ctx, options);
        super._renderControls(ctx, styleOverride);
        ctx.restore();
    }
    /**
   * The ActiveSelection needs to use the ActiveSelectionLayoutManager
   * or selections on interactive groups may be broken
   */ /**
   * controls how selected objects are added during a multiselection event
   * - `canvas-stacking` adds the selected object to the active selection while respecting canvas object stacking order
   * - `selection-order` adds the selected object to the top of the stack,
   * meaning that the stack is ordered by the order in which objects were selected
   * @default `canvas-stacking`
   */ constructor(){
        let objects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        super();
        Object.assign(this, $f268b97836dca6b6$export$c57a942eef0ccd19.ownDefaults);
        this.setOptions(options);
        const { left: left, top: top, layoutManager: layoutManager } = options;
        this.groupInit(objects, {
            left: left,
            top: top,
            layoutManager: layoutManager !== null && layoutManager !== void 0 ? layoutManager : new $f268b97836dca6b6$var$ActiveSelectionLayoutManager()
        });
    }
}
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$c57a942eef0ccd19, "type", 'ActiveSelection');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$c57a942eef0ccd19, "ownDefaults", $f268b97836dca6b6$var$activeSelectionDefaultValues);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$c57a942eef0ccd19);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$c57a942eef0ccd19, 'activeSelection');
/**
 * Canvas 2D filter backend.
 */ class $f268b97836dca6b6$export$eaf5984e5c8f09c5 {
    /**
   * Apply a set of filters against a source image and draw the filtered output
   * to the provided destination canvas.
   *
   * @param {EnhancedFilter} filters The filter to apply.
   * @param {HTMLImageElement|HTMLCanvasElement} sourceElement The source to be filtered.
   * @param {Number} sourceWidth The width of the source input.
   * @param {Number} sourceHeight The height of the source input.
   * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
   */ applyFilters(filters, sourceElement, sourceWidth, sourceHeight, targetCanvas) {
        const ctx = targetCanvas.getContext('2d');
        if (!ctx) return;
        ctx.drawImage(sourceElement, 0, 0, sourceWidth, sourceHeight);
        const imageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
        const originalImageData = ctx.getImageData(0, 0, sourceWidth, sourceHeight);
        const pipelineState = {
            sourceWidth: sourceWidth,
            sourceHeight: sourceHeight,
            imageData: imageData,
            originalEl: sourceElement,
            originalImageData: originalImageData,
            canvasEl: targetCanvas,
            ctx: ctx,
            filterBackend: this
        };
        filters.forEach((filter)=>{
            filter.applyTo(pipelineState);
        });
        const { imageData: imageDataPostFilter } = pipelineState;
        if (imageDataPostFilter.width !== sourceWidth || imageDataPostFilter.height !== sourceHeight) {
            targetCanvas.width = imageDataPostFilter.width;
            targetCanvas.height = imageDataPostFilter.height;
        }
        ctx.putImageData(imageDataPostFilter, 0, 0);
        return pipelineState;
    }
    constructor(){
        /**
     * Experimental. This object is a sort of repository of help layers used to avoid
     * of recreating them during frequent filtering. If you are previewing a filter with
     * a slider you probably do not want to create help layers every filter step.
     * in this object there will be appended some canvases, created once, resized sometimes
     * cleared never. Clearing is left to the developer.
     **/ $f268b97836dca6b6$var$_defineProperty(this, "resources", {});
    }
}
class $f268b97836dca6b6$export$42da2a27efef173b {
    /**
   * Setup a WebGL context suitable for filtering, and bind any needed event handlers.
   */ setupGLContext(width, height) {
        this.dispose();
        this.createWebGLCanvas(width, height);
    }
    /**
   * Create a canvas element and associated WebGL context and attaches them as
   * class properties to the GLFilterBackend class.
   */ createWebGLCanvas(width, height) {
        const canvas = $f268b97836dca6b6$var$createCanvasElementFor({
            width: width,
            height: height
        });
        const glOptions = {
            alpha: true,
            premultipliedAlpha: false,
            depth: false,
            stencil: false,
            antialias: false
        }, gl = canvas.getContext('webgl', glOptions);
        if (!gl) return;
        gl.clearColor(0, 0, 0, 0);
        // this canvas can fire webglcontextlost and webglcontextrestored
        this.canvas = canvas;
        this.gl = gl;
    }
    /**
   * Attempts to apply the requested filters to the source provided, drawing the filtered output
   * to the provided target canvas.
   *
   * @param {Array} filters The filters to apply.
   * @param {TexImageSource} source The source to be filtered.
   * @param {Number} width The width of the source input.
   * @param {Number} height The height of the source input.
   * @param {HTMLCanvasElement} targetCanvas The destination for filtered output to be drawn.
   * @param {String|undefined} cacheKey A key used to cache resources related to the source. If
   * omitted, caching will be skipped.
   */ applyFilters(filters, source, width, height, targetCanvas, cacheKey) {
        const gl = this.gl;
        const ctx = targetCanvas.getContext('2d');
        if (!gl || !ctx) return;
        let cachedTexture;
        if (cacheKey) cachedTexture = this.getCachedTexture(cacheKey, source);
        const pipelineState = {
            originalWidth: source.width || source.naturalWidth || 0,
            originalHeight: source.height || source.naturalHeight || 0,
            sourceWidth: width,
            sourceHeight: height,
            destinationWidth: width,
            destinationHeight: height,
            context: gl,
            sourceTexture: this.createTexture(gl, width, height, !cachedTexture ? source : undefined),
            targetTexture: this.createTexture(gl, width, height),
            originalTexture: cachedTexture || this.createTexture(gl, width, height, !cachedTexture ? source : undefined),
            passes: filters.length,
            webgl: true,
            aPosition: this.aPosition,
            programCache: this.programCache,
            pass: 0,
            filterBackend: this,
            targetCanvas: targetCanvas
        };
        const tempFbo = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, tempFbo);
        filters.forEach((filter)=>{
            filter && filter.applyTo(pipelineState);
        });
        $f268b97836dca6b6$var$resizeCanvasIfNeeded(pipelineState);
        this.copyGLTo2D(gl, pipelineState);
        gl.bindTexture(gl.TEXTURE_2D, null);
        gl.deleteTexture(pipelineState.sourceTexture);
        gl.deleteTexture(pipelineState.targetTexture);
        gl.deleteFramebuffer(tempFbo);
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        return pipelineState;
    }
    /**
   * Detach event listeners, remove references, and clean up caches.
   */ dispose() {
        if (this.canvas) {
            // we are disposing, we don't care about the fact
            // that the canvas shouldn't be null.
            // @ts-expect-error disposing
            this.canvas = null;
            // @ts-expect-error disposing
            this.gl = null;
        }
        this.clearWebGLCaches();
    }
    /**
   * Wipe out WebGL-related caches.
   */ clearWebGLCaches() {
        this.programCache = {};
        this.textureCache = {};
    }
    /**
   * Create a WebGL texture object.
   *
   * Accepts specific dimensions to initialize the texture to or a source image.
   *
   * @param {WebGLRenderingContext} gl The GL context to use for creating the texture.
   * @param {number} width The width to initialize the texture at.
   * @param {number} height The height to initialize the texture.
   * @param {TexImageSource} textureImageSource A source for the texture data.
   * @param {number} filter gl.NEAREST default or gl.LINEAR filters for the texture.
   * This filter is very useful for LUTs filters. If you need interpolation use gl.LINEAR
   * @returns {WebGLTexture}
   */ createTexture(gl, width, height, textureImageSource, filter) {
        const { NEAREST: NEAREST, TEXTURE_2D: TEXTURE_2D, RGBA: RGBA, UNSIGNED_BYTE: UNSIGNED_BYTE, CLAMP_TO_EDGE: CLAMP_TO_EDGE, TEXTURE_MAG_FILTER: TEXTURE_MAG_FILTER, TEXTURE_MIN_FILTER: TEXTURE_MIN_FILTER, TEXTURE_WRAP_S: TEXTURE_WRAP_S, TEXTURE_WRAP_T: TEXTURE_WRAP_T } = gl;
        const texture = gl.createTexture();
        gl.bindTexture(TEXTURE_2D, texture);
        gl.texParameteri(TEXTURE_2D, TEXTURE_MAG_FILTER, filter || NEAREST);
        gl.texParameteri(TEXTURE_2D, TEXTURE_MIN_FILTER, filter || NEAREST);
        gl.texParameteri(TEXTURE_2D, TEXTURE_WRAP_S, CLAMP_TO_EDGE);
        gl.texParameteri(TEXTURE_2D, TEXTURE_WRAP_T, CLAMP_TO_EDGE);
        if (textureImageSource) gl.texImage2D(TEXTURE_2D, 0, RGBA, RGBA, UNSIGNED_BYTE, textureImageSource);
        else gl.texImage2D(TEXTURE_2D, 0, RGBA, width, height, 0, RGBA, UNSIGNED_BYTE, null);
        return texture;
    }
    /**
   * Can be optionally used to get a texture from the cache array
   *
   * If an existing texture is not found, a new texture is created and cached.
   *
   * @param {String} uniqueId A cache key to use to find an existing texture.
   * @param {HTMLImageElement|HTMLCanvasElement} textureImageSource A source to use to create the
   * texture cache entry if one does not already exist.
   */ getCachedTexture(uniqueId, textureImageSource, filter) {
        const { textureCache: textureCache } = this;
        if (textureCache[uniqueId]) return textureCache[uniqueId];
        else {
            const texture = this.createTexture(this.gl, textureImageSource.width, textureImageSource.height, textureImageSource, filter);
            if (texture) textureCache[uniqueId] = texture;
            return texture;
        }
    }
    /**
   * Clear out cached resources related to a source image that has been
   * filtered previously.
   *
   * @param {String} cacheKey The cache key provided when the source image was filtered.
   */ evictCachesForKey(cacheKey) {
        if (this.textureCache[cacheKey]) {
            this.gl.deleteTexture(this.textureCache[cacheKey]);
            delete this.textureCache[cacheKey];
        }
    }
    /**
   * Copy an input WebGL canvas on to an output 2D canvas.
   *
   * The WebGL canvas is assumed to be upside down, with the top-left pixel of the
   * desired output image appearing in the bottom-left corner of the WebGL canvas.
   *
   * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
   * @param {Object} pipelineState The 2D target canvas to copy on to.
   */ copyGLTo2D(gl, pipelineState) {
        const glCanvas = gl.canvas, targetCanvas = pipelineState.targetCanvas, ctx = targetCanvas.getContext('2d');
        if (!ctx) return;
        ctx.translate(0, targetCanvas.height); // move it down again
        ctx.scale(1, -1); // vertical flip
        // where is my image on the big glcanvas?
        const sourceY = glCanvas.height - targetCanvas.height;
        ctx.drawImage(glCanvas, 0, sourceY, targetCanvas.width, targetCanvas.height, 0, 0, targetCanvas.width, targetCanvas.height);
    }
    /**
   * Copy an input WebGL canvas on to an output 2D canvas using 2d canvas' putImageData
   * API. Measurably faster than using ctx.drawImage in Firefox (version 54 on OSX Sierra).
   *
   * @param {WebGLRenderingContext} sourceContext The WebGL context to copy from.
   * @param {HTMLCanvasElement} targetCanvas The 2D target canvas to copy on to.
   * @param {Object} pipelineState The 2D target canvas to copy on to.
   */ copyGLTo2DPutImageData(gl, pipelineState) {
        const targetCanvas = pipelineState.targetCanvas, ctx = targetCanvas.getContext('2d'), dWidth = pipelineState.destinationWidth, dHeight = pipelineState.destinationHeight, numBytes = dWidth * dHeight * 4;
        if (!ctx) return;
        const u8 = new Uint8Array(this.imageBuffer, 0, numBytes);
        const u8Clamped = new Uint8ClampedArray(this.imageBuffer, 0, numBytes);
        gl.readPixels(0, 0, dWidth, dHeight, gl.RGBA, gl.UNSIGNED_BYTE, u8);
        const imgData = new ImageData(u8Clamped, dWidth, dHeight);
        ctx.putImageData(imgData, 0, 0);
    }
    /**
   * Attempt to extract GPU information strings from a WebGL context.
   *
   * Useful information when debugging or blacklisting specific GPUs.
   *
   * @returns {Object} A GPU info object with renderer and vendor strings.
   */ captureGPUInfo() {
        if (this.gpuInfo) return this.gpuInfo;
        const gl = this.gl, gpuInfo = {
            renderer: '',
            vendor: ''
        };
        if (!gl) return gpuInfo;
        const ext = gl.getExtension('WEBGL_debug_renderer_info');
        if (ext) {
            const renderer = gl.getParameter(ext.UNMASKED_RENDERER_WEBGL);
            const vendor = gl.getParameter(ext.UNMASKED_VENDOR_WEBGL);
            if (renderer) gpuInfo.renderer = renderer.toLowerCase();
            if (vendor) gpuInfo.vendor = vendor.toLowerCase();
        }
        this.gpuInfo = gpuInfo;
        return gpuInfo;
    }
    constructor(){
        let { tileSize: tileSize = $f268b97836dca6b6$export$e506a1d27d1eaa20.textureSize } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        /**
     * Define ...
     **/ $f268b97836dca6b6$var$_defineProperty(this, "aPosition", new Float32Array([
            0,
            0,
            0,
            1,
            1,
            0,
            1,
            1
        ]));
        /**
     * Experimental. This object is a sort of repository of help layers used to avoid
     * of recreating them during frequent filtering. If you are previewing a filter with
     * a slider you probably do not want to create help layers every filter step.
     * in this object there will be appended some canvases, created once, resized sometimes
     * cleared never. Clearing is left to the developer.
     **/ $f268b97836dca6b6$var$_defineProperty(this, "resources", {});
        this.tileSize = tileSize;
        this.setupGLContext(tileSize, tileSize);
        this.captureGPUInfo();
    }
}
function $f268b97836dca6b6$var$resizeCanvasIfNeeded(pipelineState) {
    const targetCanvas = pipelineState.targetCanvas, width = targetCanvas.width, height = targetCanvas.height, dWidth = pipelineState.destinationWidth, dHeight = pipelineState.destinationHeight;
    if (width !== dWidth || height !== dHeight) {
        targetCanvas.width = dWidth;
        targetCanvas.height = dHeight;
    }
}
let $f268b97836dca6b6$var$filterBackend;
/**
 * Verifies if it is possible to initialize webgl or fallback on a canvas2d filtering backend
 */ function $f268b97836dca6b6$export$4747bee7c8857651() {
    const { WebGLProbe: WebGLProbe } = $f268b97836dca6b6$export$4bd44a2aa29d3d6e();
    WebGLProbe.queryWebGL($f268b97836dca6b6$var$createCanvasElement());
    if ($f268b97836dca6b6$export$e506a1d27d1eaa20.enableGLFiltering && WebGLProbe.isSupported($f268b97836dca6b6$export$e506a1d27d1eaa20.textureSize)) return new $f268b97836dca6b6$export$42da2a27efef173b({
        tileSize: $f268b97836dca6b6$export$e506a1d27d1eaa20.textureSize
    });
    else return new $f268b97836dca6b6$export$eaf5984e5c8f09c5();
}
/**
 * Get the current fabricJS filter backend  or initialize one if not available yet
 * @param [strict] pass `true` to create the backend if it wasn't created yet (default behavior),
 * pass `false` to get the backend ref without mutating it
 */ function $f268b97836dca6b6$export$8c3a6bdf56bdf106() {
    let strict = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (!$f268b97836dca6b6$var$filterBackend && strict) $f268b97836dca6b6$var$filterBackend = $f268b97836dca6b6$export$4747bee7c8857651();
    return $f268b97836dca6b6$var$filterBackend;
}
function $f268b97836dca6b6$export$99b8b463935976a6(backend) {
    $f268b97836dca6b6$var$filterBackend = backend;
}
const $f268b97836dca6b6$var$_excluded$2 = [
    "filters",
    "resizeFilter",
    "src",
    "crossOrigin",
    "type"
];
// @todo Would be nice to have filtering code not imported directly.
const $f268b97836dca6b6$var$imageDefaultValues = {
    strokeWidth: 0,
    srcFromAttribute: false,
    minimumScaleTrigger: 0.5,
    cropX: 0,
    cropY: 0,
    imageSmoothing: true
};
const $f268b97836dca6b6$var$IMAGE_PROPS = [
    'cropX',
    'cropY'
];
/**
 * @tutorial {@link http://fabricjs.com/fabric-intro-part-1#images}
 */ class $f268b97836dca6b6$export$3148ec5c6497ddc8 extends $f268b97836dca6b6$export$5a5fba7eea6847b1 {
    static getDefaults() {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.getDefaults()), $f268b97836dca6b6$export$3148ec5c6497ddc8.ownDefaults);
    }
    /**
   * Returns image element which this instance if based on
   */ getElement() {
        return this._element;
    }
    /**
   * Sets image element for this instance to a specified one.
   * If filters defined they are applied to new image.
   * You might need to call `canvas.renderAll` and `object.setCoords` after replacing, to render new image and update controls area.
   * @param {HTMLImageElement} element
   * @param {Partial<TSize>} [size] Options object
   */ setElement(element) {
        var _element$classList;
        let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        this.removeTexture(this.cacheKey);
        this.removeTexture("".concat(this.cacheKey, "_filtered"));
        this._element = element;
        this._originalElement = element;
        this._setWidthHeight(size);
        (_element$classList = element.classList) === null || _element$classList === void 0 || _element$classList.add($f268b97836dca6b6$export$3148ec5c6497ddc8.CSS_CANVAS);
        if (this.filters.length !== 0) this.applyFilters();
        // resizeFilters work on the already filtered copy.
        // we need to apply resizeFilters AFTER normal filters.
        // applyResizeFilters is run more often than normal filters
        // and is triggered by user interactions rather than dev code
        if (this.resizeFilter) this.applyResizeFilters();
    }
    /**
   * Delete a single texture if in webgl mode
   */ removeTexture(key) {
        const backend = $f268b97836dca6b6$export$8c3a6bdf56bdf106(false);
        if (backend instanceof $f268b97836dca6b6$export$42da2a27efef173b) backend.evictCachesForKey(key);
    }
    /**
   * Delete textures, reference to elements and eventually JSDOM cleanup
   */ dispose() {
        super.dispose();
        this.removeTexture(this.cacheKey);
        this.removeTexture("".concat(this.cacheKey, "_filtered"));
        this._cacheContext = null;
        [
            '_originalElement',
            '_element',
            '_filteredEl',
            '_cacheCanvas'
        ].forEach((elementKey)=>{
            const el = this[elementKey];
            el && $f268b97836dca6b6$export$4bd44a2aa29d3d6e().dispose(el);
            // @ts-expect-error disposing
            this[elementKey] = undefined;
        });
    }
    /**
   * Get the crossOrigin value (of the corresponding image element)
   */ getCrossOrigin() {
        return this._originalElement && (this._originalElement.crossOrigin || null);
    }
    /**
   * Returns original size of an image
   */ getOriginalSize() {
        const element = this.getElement();
        if (!element) return {
            width: 0,
            height: 0
        };
        return {
            width: element.naturalWidth || element.width,
            height: element.naturalHeight || element.height
        };
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _stroke(ctx) {
        if (!this.stroke || this.strokeWidth === 0) return;
        const w = this.width / 2, h = this.height / 2;
        ctx.beginPath();
        ctx.moveTo(-w, -h);
        ctx.lineTo(w, -h);
        ctx.lineTo(w, h);
        ctx.lineTo(-w, h);
        ctx.lineTo(-w, -h);
        ctx.closePath();
    }
    /**
   * Returns object representation of an instance
   * @param {Array} [propertiesToInclude] Any properties that you might want to additionally include in the output
   * @return {Object} Object representation of an instance
   */ toObject() {
        let propertiesToInclude = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        const filters = [];
        this.filters.forEach((filterObj)=>{
            filterObj && filters.push(filterObj.toObject());
        });
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.toObject([
            ...$f268b97836dca6b6$var$IMAGE_PROPS,
            ...propertiesToInclude
        ])), {}, {
            src: this.getSrc(),
            crossOrigin: this.getCrossOrigin(),
            filters: filters
        }, this.resizeFilter ? {
            resizeFilter: this.resizeFilter.toObject()
        } : {});
    }
    /**
   * Returns true if an image has crop applied, inspecting values of cropX,cropY,width,height.
   * @return {Boolean}
   */ hasCrop() {
        return !!this.cropX || !!this.cropY || this.width < this._element.width || this.height < this._element.height;
    }
    /**
   * Returns svg representation of an instance
   * @return {string[]} an array of strings with the specific svg representation
   * of the instance
   */ _toSVG() {
        const imageMarkup = [], element = this._element, x = -this.width / 2, y = -this.height / 2;
        let svgString = [], strokeSvg = [], clipPath = '', imageRendering = '';
        if (!element) return [];
        if (this.hasCrop()) {
            const clipPathId = $f268b97836dca6b6$var$uid();
            svgString.push('<clipPath id="imageCrop_' + clipPathId + '">\n', '\t<rect x="' + x + '" y="' + y + '" width="' + this.width + '" height="' + this.height + '" />\n', '</clipPath>\n');
            clipPath = ' clip-path="url(#imageCrop_' + clipPathId + ')" ';
        }
        if (!this.imageSmoothing) imageRendering = ' image-rendering="optimizeSpeed"';
        imageMarkup.push('\t<image ', 'COMMON_PARTS', "xlink:href=\"".concat(this.getSvgSrc(true), "\" x=\"").concat(x - this.cropX, "\" y=\"").concat(y - this.cropY, "\" width=\"").concat(element.width || element.naturalWidth, "\" height=\"").concat(element.height || element.naturalHeight, "\"").concat(imageRendering).concat(clipPath, "></image>\n"));
        if (this.stroke || this.strokeDashArray) {
            const origFill = this.fill;
            this.fill = null;
            strokeSvg = [
                "\t<rect x=\"".concat(x, "\" y=\"").concat(y, "\" width=\"").concat(this.width, "\" height=\"").concat(this.height, "\" style=\"").concat(this.getSvgStyles(), "\" />\n")
            ];
            this.fill = origFill;
        }
        if (this.paintFirst !== $f268b97836dca6b6$var$FILL) svgString = svgString.concat(strokeSvg, imageMarkup);
        else svgString = svgString.concat(imageMarkup, strokeSvg);
        return svgString;
    }
    /**
   * Returns source of an image
   * @param {Boolean} filtered indicates if the src is needed for svg
   * @return {String} Source of an image
   */ getSrc(filtered) {
        const element = filtered ? this._element : this._originalElement;
        if (element) {
            if (element.toDataURL) return element.toDataURL();
            if (this.srcFromAttribute) return element.getAttribute('src') || '';
            else return element.src;
        } else return this.src || '';
    }
    /**
   * Alias for getSrc
   * @param filtered
   * @deprecated
   */ getSvgSrc(filtered) {
        return this.getSrc(filtered);
    }
    /**
   * Loads and sets source of an image\
   * **IMPORTANT**: It is recommended to abort loading tasks before calling this method to prevent race conditions and unnecessary networking
   * @param {String} src Source string (URL)
   * @param {LoadImageOptions} [options] Options object
   */ setSrc(src) {
        let { crossOrigin: crossOrigin, signal: signal } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return $f268b97836dca6b6$var$loadImage(src, {
            crossOrigin: crossOrigin,
            signal: signal
        }).then((img)=>{
            typeof crossOrigin !== 'undefined' && this.set({
                crossOrigin: crossOrigin
            });
            this.setElement(img);
        });
    }
    /**
   * Returns string representation of an instance
   * @return {String} String representation of an instance
   */ toString() {
        return "#<Image: { src: \"".concat(this.getSrc(), "\" }>");
    }
    applyResizeFilters() {
        const filter = this.resizeFilter, minimumScale = this.minimumScaleTrigger, objectScale = this.getTotalObjectScaling(), scaleX = objectScale.x, scaleY = objectScale.y, elementToFilter = this._filteredEl || this._originalElement;
        if (this.group) this.set('dirty', true);
        if (!filter || scaleX > minimumScale && scaleY > minimumScale) {
            this._element = elementToFilter;
            this._filterScalingX = 1;
            this._filterScalingY = 1;
            this._lastScaleX = scaleX;
            this._lastScaleY = scaleY;
            return;
        }
        const canvasEl = $f268b97836dca6b6$var$createCanvasElementFor(elementToFilter), { width: width, height: height } = elementToFilter;
        this._element = canvasEl;
        this._lastScaleX = filter.scaleX = scaleX;
        this._lastScaleY = filter.scaleY = scaleY;
        $f268b97836dca6b6$export$8c3a6bdf56bdf106().applyFilters([
            filter
        ], elementToFilter, width, height, this._element);
        this._filterScalingX = canvasEl.width / this._originalElement.width;
        this._filterScalingY = canvasEl.height / this._originalElement.height;
    }
    /**
   * Applies filters assigned to this image (from "filters" array) or from filter param
   * @method applyFilters
   * @param {Array} filters to be applied
   * @param {Boolean} forResizing specify if the filter operation is a resize operation
   */ applyFilters() {
        let filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.filters || [];
        filters = filters.filter((filter)=>filter && !filter.isNeutralState());
        this.set('dirty', true);
        // needs to clear out or WEBGL will not resize correctly
        this.removeTexture("".concat(this.cacheKey, "_filtered"));
        if (filters.length === 0) {
            this._element = this._originalElement;
            // this is unsafe and needs to be rethinkend
            this._filteredEl = undefined;
            this._filterScalingX = 1;
            this._filterScalingY = 1;
            return;
        }
        const imgElement = this._originalElement, sourceWidth = imgElement.naturalWidth || imgElement.width, sourceHeight = imgElement.naturalHeight || imgElement.height;
        if (this._element === this._originalElement) {
            // if the _element a reference to _originalElement
            // we need to create a new element to host the filtered pixels
            const canvasEl = $f268b97836dca6b6$var$createCanvasElementFor({
                width: sourceWidth,
                height: sourceHeight
            });
            this._element = canvasEl;
            this._filteredEl = canvasEl;
        } else if (this._filteredEl) {
            // if the _element is it own element,
            // and we also have a _filteredEl, then we clean up _filteredEl
            // and we assign it to _element.
            // in this way we invalidate the eventual old resize filtered element
            this._element = this._filteredEl;
            this._filteredEl.getContext('2d').clearRect(0, 0, sourceWidth, sourceHeight);
            // we also need to resize again at next renderAll, so remove saved _lastScaleX/Y
            this._lastScaleX = 1;
            this._lastScaleY = 1;
        }
        $f268b97836dca6b6$export$8c3a6bdf56bdf106().applyFilters(filters, this._originalElement, sourceWidth, sourceHeight, this._element, this.cacheKey);
        if (this._originalElement.width !== this._element.width || this._originalElement.height !== this._element.height) {
            this._filterScalingX = this._element.width / this._originalElement.width;
            this._filterScalingY = this._element.height / this._originalElement.height;
        }
    }
    /**
   * @private
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ _render(ctx) {
        ctx.imageSmoothingEnabled = this.imageSmoothing;
        if (this.isMoving !== true && this.resizeFilter && this._needsResize()) this.applyResizeFilters();
        this._stroke(ctx);
        this._renderPaintInOrder(ctx);
    }
    /**
   * Paint the cached copy of the object on the target context.
   * it will set the imageSmoothing for the draw operation
   * @param {CanvasRenderingContext2D} ctx Context to render on
   */ drawCacheOnCanvas(ctx) {
        ctx.imageSmoothingEnabled = this.imageSmoothing;
        super.drawCacheOnCanvas(ctx);
    }
    /**
   * Decide if the FabricImage should cache or not. Create its own cache level
   * needsItsOwnCache should be used when the object drawing method requires
   * a cache step.
   * Generally you do not cache objects in groups because the group outside is cached.
   * This is the special Image version where we would like to avoid caching where possible.
   * Essentially images do not benefit from caching. They may require caching, and in that
   * case we do it. Also caching an image usually ends in a loss of details.
   * A full performance audit should be done.
   * @return {Boolean}
   */ shouldCache() {
        return this.needsItsOwnCache();
    }
    _renderFill(ctx) {
        const elementToDraw = this._element;
        if (!elementToDraw) return;
        const scaleX = this._filterScalingX, scaleY = this._filterScalingY, w = this.width, h = this.height, // crop values cannot be lesser than 0.
        cropX = Math.max(this.cropX, 0), cropY = Math.max(this.cropY, 0), elWidth = elementToDraw.naturalWidth || elementToDraw.width, elHeight = elementToDraw.naturalHeight || elementToDraw.height, sX = cropX * scaleX, sY = cropY * scaleY, // the width height cannot exceed element width/height, starting from the crop offset.
        sW = Math.min(w * scaleX, elWidth - sX), sH = Math.min(h * scaleY, elHeight - sY), x = -w / 2, y = -h / 2, maxDestW = Math.min(w, elWidth / scaleX - cropX), maxDestH = Math.min(h, elHeight / scaleY - cropY);
        elementToDraw && ctx.drawImage(elementToDraw, sX, sY, sW, sH, x, y, maxDestW, maxDestH);
    }
    /**
   * needed to check if image needs resize
   * @private
   */ _needsResize() {
        const scale = this.getTotalObjectScaling();
        return scale.x !== this._lastScaleX || scale.y !== this._lastScaleY;
    }
    /**
   * @private
   * @deprecated unused
   */ _resetWidthHeight() {
        this.set(this.getOriginalSize());
    }
    /**
   * @private
   * Set the width and the height of the image object, using the element or the
   * options.
   */ _setWidthHeight() {
        let { width: width, height: height } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        const size = this.getOriginalSize();
        this.width = width || size.width;
        this.height = height || size.height;
    }
    /**
   * Calculate offset for center and scale factor for the image in order to respect
   * the preserveAspectRatio attribute
   * @private
   */ parsePreserveAspectRatioAttribute() {
        const pAR = $f268b97836dca6b6$var$parsePreserveAspectRatioAttribute(this.preserveAspectRatio || ''), pWidth = this.width, pHeight = this.height, parsedAttributes = {
            width: pWidth,
            height: pHeight
        };
        let rWidth = this._element.width, rHeight = this._element.height, scaleX = 1, scaleY = 1, offsetLeft = 0, offsetTop = 0, cropX = 0, cropY = 0, offset;
        if (pAR && (pAR.alignX !== $f268b97836dca6b6$var$NONE || pAR.alignY !== $f268b97836dca6b6$var$NONE)) {
            if (pAR.meetOrSlice === 'meet') {
                scaleX = scaleY = $f268b97836dca6b6$var$findScaleToFit(this._element, parsedAttributes);
                offset = (pWidth - rWidth * scaleX) / 2;
                if (pAR.alignX === 'Min') offsetLeft = -offset;
                if (pAR.alignX === 'Max') offsetLeft = offset;
                offset = (pHeight - rHeight * scaleY) / 2;
                if (pAR.alignY === 'Min') offsetTop = -offset;
                if (pAR.alignY === 'Max') offsetTop = offset;
            }
            if (pAR.meetOrSlice === 'slice') {
                scaleX = scaleY = $f268b97836dca6b6$var$findScaleToCover(this._element, parsedAttributes);
                offset = rWidth - pWidth / scaleX;
                if (pAR.alignX === 'Mid') cropX = offset / 2;
                if (pAR.alignX === 'Max') cropX = offset;
                offset = rHeight - pHeight / scaleY;
                if (pAR.alignY === 'Mid') cropY = offset / 2;
                if (pAR.alignY === 'Max') cropY = offset;
                rWidth = pWidth / scaleX;
                rHeight = pHeight / scaleY;
            }
        } else {
            scaleX = pWidth / rWidth;
            scaleY = pHeight / rHeight;
        }
        return {
            width: rWidth,
            height: rHeight,
            scaleX: scaleX,
            scaleY: scaleY,
            offsetLeft: offsetLeft,
            offsetTop: offsetTop,
            cropX: cropX,
            cropY: cropY
        };
    }
    /**
   * Default CSS class name for canvas
   * Will be removed from fabric 7
   * @static
   * @deprecated
   * @type String
   * @default
   */ /**
   * Creates an instance of FabricImage from its object representation
   * @static
   * @param {Object} object Object to create an instance from
   * @param {object} [options] Options object
   * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @returns {Promise<FabricImage>}
   */ static fromObject(_ref, options) {
        let { filters: f, resizeFilter: rf, src: src, crossOrigin: crossOrigin, type: type } = _ref, object = $f268b97836dca6b6$var$_objectWithoutProperties(_ref, $f268b97836dca6b6$var$_excluded$2);
        return Promise.all([
            $f268b97836dca6b6$var$loadImage(src, $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, options), {}, {
                crossOrigin: crossOrigin
            })),
            f && $f268b97836dca6b6$var$enlivenObjects(f, options),
            // TODO: redundant - handled by enlivenObjectEnlivables
            rf && $f268b97836dca6b6$var$enlivenObjects([
                rf
            ], options),
            $f268b97836dca6b6$var$enlivenObjectEnlivables(object, options)
        ]).then((_ref2)=>{
            let [el, filters = [], [resizeFilter] = [], hydratedProps = {}] = _ref2;
            return new this(el, $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, object), {}, {
                src: // TODO: this creates a difference between image creation and restoring from JSON
                src,
                filters: filters,
                resizeFilter: resizeFilter
            }, hydratedProps));
        });
    }
    /**
   * Creates an instance of Image from an URL string
   * @static
   * @param {String} url URL to create an image from
   * @param {LoadImageOptions} [options] Options object
   * @returns {Promise<FabricImage>}
   */ static fromURL(url) {
        let { crossOrigin: crossOrigin = null, signal: signal } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let imageOptions = arguments.length > 2 ? arguments[2] : undefined;
        return $f268b97836dca6b6$var$loadImage(url, {
            crossOrigin: crossOrigin,
            signal: signal
        }).then((img)=>new this(img, imageOptions));
    }
    /**
   * Returns {@link FabricImage} instance from an SVG element
   * @static
   * @param {HTMLElement} element Element to parse
   * @param {Object} [options] Options object
   * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @param {Function} callback Callback to execute when Image object is created
   */ static async fromElement(element) {
        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let cssRules = arguments.length > 2 ? arguments[2] : undefined;
        const parsedAttributes = $f268b97836dca6b6$export$fbe550151e406473(element, this.ATTRIBUTE_NAMES, cssRules);
        return this.fromURL(parsedAttributes['xlink:href'] || parsedAttributes['href'], options, parsedAttributes).catch((err)=>{
            $f268b97836dca6b6$var$log('log', 'Unable to parse Image', err);
            return null;
        });
    }
    /**
   * Constructor
   * Image can be initialized with any canvas drawable or a string.
   * The string should be a url and will be loaded as an image.
   * Canvas and Image element work out of the box, while videos require extra code to work.
   * Please check video element events for seeking.
   * @param {ImageSource | string} element Image element
   * @param {Object} [options] Options object
   */ constructor(arg0, options){
        super();
        /**
     * When calling {@link FabricImage.getSrc}, return value from element src with `element.getAttribute('src')`.
     * This allows for relative urls as image src.
     * @since 2.7.0
     * @type Boolean
     * @default false
     */ /**
     * private
     * contains last value of scaleX to detect
     * if the Image got resized after the last Render
     * @type Number
     */ $f268b97836dca6b6$var$_defineProperty(this, "_lastScaleX", 1);
        /**
     * private
     * contains last value of scaleY to detect
     * if the Image got resized after the last Render
     * @type Number
     */ $f268b97836dca6b6$var$_defineProperty(this, "_lastScaleY", 1);
        /**
     * private
     * contains last value of scaling applied by the apply filter chain
     * @type Number
     */ $f268b97836dca6b6$var$_defineProperty(this, "_filterScalingX", 1);
        /**
     * private
     * contains last value of scaling applied by the apply filter chain
     * @type Number
     */ $f268b97836dca6b6$var$_defineProperty(this, "_filterScalingY", 1);
        this.filters = [];
        Object.assign(this, $f268b97836dca6b6$export$3148ec5c6497ddc8.ownDefaults);
        this.setOptions(options);
        this.cacheKey = "texture".concat($f268b97836dca6b6$var$uid());
        this.setElement(typeof arg0 === 'string' ? (this.canvas && $f268b97836dca6b6$var$getDocumentFromElement(this.canvas.getElement()) || $f268b97836dca6b6$export$91e93c41e950ddbb()).getElementById(arg0) : arg0, options);
    }
}
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$3148ec5c6497ddc8, "type", 'Image');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$3148ec5c6497ddc8, "cacheProperties", [
    ...$f268b97836dca6b6$var$cacheProperties,
    ...$f268b97836dca6b6$var$IMAGE_PROPS
]);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$3148ec5c6497ddc8, "ownDefaults", $f268b97836dca6b6$var$imageDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$3148ec5c6497ddc8, "CSS_CANVAS", 'canvas-img');
/**
 * List of attribute names to account for when parsing SVG element (used by {@link FabricImage.fromElement})
 * @static
 * @see {@link http://www.w3.org/TR/SVG/struct.html#ImageElement}
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$export$3148ec5c6497ddc8, "ATTRIBUTE_NAMES", [
    ...$f268b97836dca6b6$var$SHARED_ATTRIBUTES,
    'x',
    'y',
    'width',
    'height',
    'preserveAspectRatio',
    'xlink:href',
    'href',
    'crossOrigin',
    'image-rendering'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$export$3148ec5c6497ddc8);
$f268b97836dca6b6$export$2792378e23a7920c.setSVGClass($f268b97836dca6b6$export$3148ec5c6497ddc8);
/**
 * Add a <g> element that envelop all child elements and makes the viewbox transformMatrix descend on all elements
 */ function $f268b97836dca6b6$var$applyViewboxTransform(element) {
    if (!$f268b97836dca6b6$var$svgViewBoxElementsRegEx.test(element.nodeName)) return {};
    const viewBoxAttr = element.getAttribute('viewBox');
    let scaleX = 1;
    let scaleY = 1;
    let minX = 0;
    let minY = 0;
    let matrix;
    let el;
    const widthAttr = element.getAttribute('width');
    const heightAttr = element.getAttribute('height');
    const x = element.getAttribute('x') || 0;
    const y = element.getAttribute('y') || 0;
    const goodViewbox = viewBoxAttr && $f268b97836dca6b6$var$reViewBoxAttrValue.test(viewBoxAttr);
    const missingViewBox = !goodViewbox;
    const missingDimAttr = !widthAttr || !heightAttr || widthAttr === '100%' || heightAttr === '100%';
    let translateMatrix = '';
    let widthDiff = 0;
    let heightDiff = 0;
    if (missingViewBox) {
        if ((x || y) && element.parentNode && element.parentNode.nodeName !== '#document') {
            translateMatrix = ' translate(' + $f268b97836dca6b6$var$parseUnit(x || '0') + ' ' + $f268b97836dca6b6$var$parseUnit(y || '0') + ') ';
            matrix = (element.getAttribute('transform') || '') + translateMatrix;
            element.setAttribute('transform', matrix);
            element.removeAttribute('x');
            element.removeAttribute('y');
        }
    }
    if (missingViewBox && missingDimAttr) return {
        width: 0,
        height: 0
    };
    const parsedDim = {
        width: 0,
        height: 0
    };
    if (missingViewBox) {
        parsedDim.width = $f268b97836dca6b6$var$parseUnit(widthAttr);
        parsedDim.height = $f268b97836dca6b6$var$parseUnit(heightAttr);
        // set a transform for elements that have x y and are inner(only) SVGs
        return parsedDim;
    }
    const pasedViewBox = viewBoxAttr.match($f268b97836dca6b6$var$reViewBoxAttrValue);
    minX = -parseFloat(pasedViewBox[1]);
    minY = -parseFloat(pasedViewBox[2]);
    const viewBoxWidth = parseFloat(pasedViewBox[3]);
    const viewBoxHeight = parseFloat(pasedViewBox[4]);
    parsedDim.minX = minX;
    parsedDim.minY = minY;
    parsedDim.viewBoxWidth = viewBoxWidth;
    parsedDim.viewBoxHeight = viewBoxHeight;
    if (!missingDimAttr) {
        parsedDim.width = $f268b97836dca6b6$var$parseUnit(widthAttr);
        parsedDim.height = $f268b97836dca6b6$var$parseUnit(heightAttr);
        scaleX = parsedDim.width / viewBoxWidth;
        scaleY = parsedDim.height / viewBoxHeight;
    } else {
        parsedDim.width = viewBoxWidth;
        parsedDim.height = viewBoxHeight;
    }
    // default is to preserve aspect ratio
    const preserveAspectRatio = $f268b97836dca6b6$var$parsePreserveAspectRatioAttribute(element.getAttribute('preserveAspectRatio') || '');
    if (preserveAspectRatio.alignX !== $f268b97836dca6b6$var$NONE) {
        //translate all container for the effect of Mid, Min, Max
        if (preserveAspectRatio.meetOrSlice === 'meet') scaleY = scaleX = scaleX > scaleY ? scaleY : scaleX;
        if (preserveAspectRatio.meetOrSlice === 'slice') scaleY = scaleX = scaleX > scaleY ? scaleX : scaleY;
        widthDiff = parsedDim.width - viewBoxWidth * scaleX;
        heightDiff = parsedDim.height - viewBoxHeight * scaleX;
        if (preserveAspectRatio.alignX === 'Mid') widthDiff /= 2;
        if (preserveAspectRatio.alignY === 'Mid') heightDiff /= 2;
        if (preserveAspectRatio.alignX === 'Min') widthDiff = 0;
        if (preserveAspectRatio.alignY === 'Min') heightDiff = 0;
    }
    if (scaleX === 1 && scaleY === 1 && minX === 0 && minY === 0 && x === 0 && y === 0) return parsedDim;
    if ((x || y) && element.parentNode.nodeName !== '#document') translateMatrix = ' translate(' + $f268b97836dca6b6$var$parseUnit(x || '0') + ' ' + $f268b97836dca6b6$var$parseUnit(y || '0') + ') ';
    matrix = translateMatrix + ' matrix(' + scaleX + ' 0' + ' 0 ' + scaleY + ' ' + (minX * scaleX + widthDiff) + ' ' + (minY * scaleY + heightDiff) + ') ';
    // seems unused.
    // parsedDim.viewboxTransform = parseTransformAttribute(matrix);
    if (element.nodeName === 'svg') {
        el = element.ownerDocument.createElementNS($f268b97836dca6b6$var$svgNS, 'g');
        // element.firstChild != null
        while(element.firstChild)el.appendChild(element.firstChild);
        element.appendChild(el);
    } else {
        el = element;
        el.removeAttribute('x');
        el.removeAttribute('y');
        matrix = el.getAttribute('transform') + matrix;
    }
    el.setAttribute('transform', matrix);
    return parsedDim;
}
const $f268b97836dca6b6$var$getTagName = (node)=>node.tagName.replace('svg:', '');
const $f268b97836dca6b6$var$svgInvalidAncestorsRegEx = $f268b97836dca6b6$var$getSvgRegex($f268b97836dca6b6$var$svgInvalidAncestors);
function $f268b97836dca6b6$var$hasInvalidAncestor(element) {
    let _element = element;
    while(_element && (_element = _element.parentElement)){
        if (_element && _element.nodeName && $f268b97836dca6b6$var$svgInvalidAncestorsRegEx.test($f268b97836dca6b6$var$getTagName(_element)) && !_element.getAttribute('instantiated_by_use')) return true;
    }
    return false;
}
function $f268b97836dca6b6$var$getMultipleNodes(doc, nodeNames) {
    let nodeName, nodeArray = [], nodeList, i, len;
    for(i = 0, len = nodeNames.length; i < len; i++){
        nodeName = nodeNames[i];
        nodeList = doc.getElementsByTagNameNS('http://www.w3.org/2000/svg', nodeName);
        nodeArray = nodeArray.concat(Array.from(nodeList));
    }
    return nodeArray;
}
function $f268b97836dca6b6$var$parseUseDirectives(doc) {
    const nodelist = $f268b97836dca6b6$var$getMultipleNodes(doc, [
        'use',
        'svg:use'
    ]);
    const skipAttributes = [
        'x',
        'y',
        'xlink:href',
        'href',
        'transform'
    ];
    for (const useElement of nodelist){
        const useAttributes = useElement.attributes;
        const useAttrMap = {};
        for (const attr of useAttributes)attr.value && (useAttrMap[attr.name] = attr.value);
        const xlink = (useAttrMap['xlink:href'] || useAttrMap.href || '').slice(1);
        if (xlink === '') return;
        const referencedElement = doc.getElementById(xlink);
        if (referencedElement === null) // if we can't find the target of the xlink, consider this use tag bad, similar to no xlink
        return;
        let clonedOriginal = referencedElement.cloneNode(true);
        const originalAttributes = clonedOriginal.attributes;
        const originalAttrMap = {};
        for (const attr of originalAttributes)attr.value && (originalAttrMap[attr.name] = attr.value);
        // Transform attribute needs to be merged in a particular way
        const { x: x = 0, y: y = 0, transform: transform = '' } = useAttrMap;
        const currentTrans = "".concat(transform, " ").concat(originalAttrMap.transform || '', " translate(").concat(x, ", ").concat(y, ")");
        $f268b97836dca6b6$var$applyViewboxTransform(clonedOriginal);
        if (/^svg$/i.test(clonedOriginal.nodeName)) {
            // if is an SVG, create a group and apply all the attributes on top of it
            const el3 = clonedOriginal.ownerDocument.createElementNS($f268b97836dca6b6$var$svgNS, 'g');
            Object.entries(originalAttrMap).forEach((_ref)=>{
                let [name, value] = _ref;
                return el3.setAttributeNS($f268b97836dca6b6$var$svgNS, name, value);
            });
            el3.append(...clonedOriginal.childNodes);
            clonedOriginal = el3;
        }
        for (const attr of useAttributes){
            if (!attr) continue;
            const { name: name, value: value } = attr;
            if (skipAttributes.includes(name)) continue;
            if (name === 'style') {
                // when use has a style, merge the two styles, with the ref being priority (not use)
                // priority is by feature. an attribute for fill on the original element
                // will overwrite the fill in style or attribute for tha use
                const styleRecord = {};
                $f268b97836dca6b6$var$parseStyleString(value, styleRecord);
                // cleanup styleRecord from attributes of original
                Object.entries(originalAttrMap).forEach((_ref2)=>{
                    let [name, value] = _ref2;
                    styleRecord[name] = value;
                });
                // now we can put in the style of the original that will overwrite the original attributes
                $f268b97836dca6b6$var$parseStyleString(originalAttrMap.style || '', styleRecord);
                const mergedStyles = Object.entries(styleRecord).map((entry)=>entry.join(':')).join(';');
                clonedOriginal.setAttribute(name, mergedStyles);
            } else // set the attribute from use element only if the original does not have it already
            !originalAttrMap[name] && clonedOriginal.setAttribute(name, value);
        }
        clonedOriginal.setAttribute('transform', currentTrans);
        clonedOriginal.setAttribute('instantiated_by_use', '1');
        clonedOriginal.removeAttribute('id');
        useElement.parentNode.replaceChild(clonedOriginal, useElement);
    }
}
const $f268b97836dca6b6$var$gradientsAttrs = [
    'gradientTransform',
    'x1',
    'x2',
    'y1',
    'y2',
    'gradientUnits',
    'cx',
    'cy',
    'r',
    'fx',
    'fy'
];
const $f268b97836dca6b6$var$xlinkAttr = 'xlink:href';
function $f268b97836dca6b6$var$recursivelyParseGradientsXlink(doc, gradient) {
    var _gradient$getAttribut;
    const xLink = ((_gradient$getAttribut = gradient.getAttribute($f268b97836dca6b6$var$xlinkAttr)) === null || _gradient$getAttribut === void 0 ? void 0 : _gradient$getAttribut.slice(1)) || '', referencedGradient = doc.getElementById(xLink);
    if (referencedGradient && referencedGradient.getAttribute($f268b97836dca6b6$var$xlinkAttr)) $f268b97836dca6b6$var$recursivelyParseGradientsXlink(doc, referencedGradient);
    if (referencedGradient) {
        $f268b97836dca6b6$var$gradientsAttrs.forEach((attr)=>{
            const value = referencedGradient.getAttribute(attr);
            if (!gradient.hasAttribute(attr) && value) gradient.setAttribute(attr, value);
        });
        if (!gradient.children.length) {
            const referenceClone = referencedGradient.cloneNode(true);
            while(referenceClone.firstChild)gradient.appendChild(referenceClone.firstChild);
        }
    }
    gradient.removeAttribute($f268b97836dca6b6$var$xlinkAttr);
}
const $f268b97836dca6b6$var$tagArray = [
    'linearGradient',
    'radialGradient',
    'svg:linearGradient',
    'svg:radialGradient'
];
/**
 * Parses an SVG document, returning all of the gradient declarations found in it
 * @param {SVGDocument} doc SVG document to parse
 * @return {Object} Gradient definitions; key corresponds to element id, value -- to gradient definition element
 */ function $f268b97836dca6b6$var$getGradientDefs(doc) {
    const elList = $f268b97836dca6b6$var$getMultipleNodes(doc, $f268b97836dca6b6$var$tagArray);
    const gradientDefs = {};
    let j = elList.length;
    while(j--){
        const el = elList[j];
        if (el.getAttribute('xlink:href')) $f268b97836dca6b6$var$recursivelyParseGradientsXlink(doc, el);
        const id = el.getAttribute('id');
        if (id) gradientDefs[id] = el;
    }
    return gradientDefs;
}
/**
 * Returns CSS rules for a given SVG document
 * @param {HTMLElement} doc SVG document to parse
 * @return {Object} CSS rules of this document
 */ function $f268b97836dca6b6$export$4277ecee4fbb0012(doc) {
    const styles = doc.getElementsByTagName('style');
    const allRules = {};
    // very crude parsing of style contents
    for(let i = 0; i < styles.length; i++){
        const styleContents = (styles[i].textContent || '').replace(// remove comments
        /\/\*[\s\S]*?\*\//g, '');
        if (styleContents.trim() === '') continue;
        // recovers all the rule in this form `body { style code... }`
        // rules = styleContents.match(/[^{]*\{[\s\S]*?\}/g);
        styleContents.split('}')// remove empty rules and remove everything if we didn't split in at least 2 pieces
        .filter((rule, index, array)=>array.length > 1 && rule.trim())// at this point we have hopefully an array of rules `body { style code... `
        .forEach((rule)=>{
            // if there is more than one opening bracket and the rule starts with '@', it is likely
            // a nested at-rule like @media, @supports, @scope, etc. Ignore these as the code below
            // can not handle it.
            if ((rule.match(/{/g) || []).length > 1 && rule.trim().startsWith('@')) return;
            const match = rule.split('{'), ruleObj = {}, declaration = match[1].trim(), propertyValuePairs = declaration.split(';').filter(function(pair) {
                return pair.trim();
            });
            for(let j = 0; j < propertyValuePairs.length; j++){
                const pair = propertyValuePairs[j].split(':'), property = pair[0].trim(), value = pair[1].trim();
                ruleObj[property] = value;
            }
            rule = match[0].trim();
            rule.split(',').forEach((_rule)=>{
                _rule = _rule.replace(/^svg/i, '').trim();
                if (_rule === '') return;
                allRules[_rule] = $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, allRules[_rule] || {}), ruleObj);
            });
        });
    }
    return allRules;
}
const $f268b97836dca6b6$var$findTag = (el)=>$f268b97836dca6b6$export$2792378e23a7920c.getSVGClass($f268b97836dca6b6$var$getTagName(el).toLowerCase());
class $f268b97836dca6b6$var$ElementsParser {
    parse() {
        return Promise.all(this.elements.map((element)=>this.createObject(element)));
    }
    async createObject(el) {
        const klass = $f268b97836dca6b6$var$findTag(el);
        if (klass) {
            const obj = await klass.fromElement(el, this.options, this.cssRules);
            this.resolveGradient(obj, el, $f268b97836dca6b6$var$FILL);
            this.resolveGradient(obj, el, $f268b97836dca6b6$var$STROKE);
            if (obj instanceof $f268b97836dca6b6$export$3148ec5c6497ddc8 && obj._originalElement) $f268b97836dca6b6$var$removeTransformMatrixForSvgParsing(obj, obj.parsePreserveAspectRatioAttribute());
            else $f268b97836dca6b6$var$removeTransformMatrixForSvgParsing(obj);
            await this.resolveClipPath(obj, el);
            this.reviver && this.reviver(el, obj);
            return obj;
        }
        return null;
    }
    extractPropertyDefinition(obj, property, storage) {
        const value = obj[property], regex = this.regexUrl;
        if (!regex.test(value)) return undefined;
        // verify: can we remove the 'g' flag? and remove lastIndex changes?
        regex.lastIndex = 0;
        // we passed the regex test, so we know is not null;
        const id = regex.exec(value)[1];
        regex.lastIndex = 0;
        // @todo fix this
        return storage[id];
    }
    resolveGradient(obj, el, property) {
        const gradientDef = this.extractPropertyDefinition(obj, property, this.gradientDefs);
        if (gradientDef) {
            const opacityAttr = el.getAttribute(property + '-opacity');
            const gradient = $f268b97836dca6b6$export$3d3dd8f63ff0f876.fromElement(gradientDef, obj, $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, this.options), {}, {
                opacity: opacityAttr
            }));
            obj.set(property, gradient);
        }
    }
    // TODO: resolveClipPath could be run once per clippath with minor work per object.
    // is a refactor that i m not sure is worth on this code
    async resolveClipPath(obj, usingElement, exactOwner) {
        const clipPathElements = this.extractPropertyDefinition(obj, 'clipPath', this.clipPaths);
        if (clipPathElements) {
            const objTransformInv = $f268b97836dca6b6$var$invertTransform(obj.calcTransformMatrix());
            const clipPathTag = clipPathElements[0].parentElement;
            let clipPathOwner = usingElement;
            while(!exactOwner && clipPathOwner.parentElement && clipPathOwner.getAttribute('clip-path') !== obj.clipPath)clipPathOwner = clipPathOwner.parentElement;
            // move the clipPath tag as sibling to the real element that is using it
            clipPathOwner.parentElement.appendChild(clipPathTag);
            // this multiplication order could be opposite.
            // but i don't have an svg to test it
            // at the first SVG that has a transform on both places and is misplaced
            // try to invert this multiplication order
            const finalTransform = $f268b97836dca6b6$export$6655c0d22b13de1f("".concat(clipPathOwner.getAttribute('transform') || '', " ").concat(clipPathTag.getAttribute('originalTransform') || ''));
            clipPathTag.setAttribute('transform', "matrix(".concat(finalTransform.join(','), ")"));
            const container = await Promise.all(clipPathElements.map((clipPathElement)=>{
                return $f268b97836dca6b6$var$findTag(clipPathElement).fromElement(clipPathElement, this.options, this.cssRules).then((enlivedClippath)=>{
                    $f268b97836dca6b6$var$removeTransformMatrixForSvgParsing(enlivedClippath);
                    enlivedClippath.fillRule = enlivedClippath.clipRule;
                    delete enlivedClippath.clipRule;
                    return enlivedClippath;
                });
            }));
            const clipPath = container.length === 1 ? container[0] : new $f268b97836dca6b6$export$eb2fcfdbd7ba97d4(container);
            const gTransform = $f268b97836dca6b6$var$multiplyTransformMatrices(objTransformInv, clipPath.calcTransformMatrix());
            if (clipPath.clipPath) await this.resolveClipPath(clipPath, clipPathOwner, // this is tricky.
            // it tries to differentiate from when clipPaths are inherited by outside groups
            // or when are really clipPaths referencing other clipPaths
            clipPathTag.getAttribute('clip-path') ? clipPathOwner : undefined);
            const { scaleX: scaleX, scaleY: scaleY, angle: angle, skewX: skewX, translateX: translateX, translateY: translateY } = $f268b97836dca6b6$var$qrDecompose(gTransform);
            clipPath.set({
                flipX: false,
                flipY: false
            });
            clipPath.set({
                scaleX: scaleX,
                scaleY: scaleY,
                angle: angle,
                skewX: skewX,
                skewY: 0
            });
            clipPath.setPositionByOrigin(new $f268b97836dca6b6$export$baf26146a414f24a(translateX, translateY), $f268b97836dca6b6$var$CENTER, $f268b97836dca6b6$var$CENTER);
            obj.clipPath = clipPath;
        } else {
            // if clip-path does not resolve to any element, delete the property.
            delete obj.clipPath;
            return;
        }
    }
    constructor(elements, options, reviver, doc, clipPaths){
        this.elements = elements;
        this.options = options;
        this.reviver = reviver;
        this.regexUrl = /^url\(['"]?#([^'"]+)['"]?\)/g;
        this.doc = doc;
        this.clipPaths = clipPaths;
        this.gradientDefs = $f268b97836dca6b6$var$getGradientDefs(doc);
        this.cssRules = $f268b97836dca6b6$export$4277ecee4fbb0012(doc);
    }
}
const $f268b97836dca6b6$var$isValidSvgTag = (el)=>$f268b97836dca6b6$var$svgValidTagNamesRegEx.test($f268b97836dca6b6$var$getTagName(el));
const $f268b97836dca6b6$var$createEmptyResponse = ()=>({
        objects: [],
        elements: [],
        options: {},
        allElements: []
    });
/**
 * Parses an SVG document, converts it to an array of corresponding fabric.* instances and passes them to a callback
 * @static
 * @function
 * @memberOf fabric
 * @param {HTMLElement} doc SVG document to parse
 * @param {TSvgParsedCallback} callback Invoked when the parsing is done, with null if parsing wasn't possible with the list of svg nodes.
 * @param {TSvgReviverCallback} [reviver] Extra callback for further parsing of SVG elements, called after each fabric object has been created.
 * Takes as input the original svg element and the generated `FabricObject` as arguments. Used to inspect extra properties not parsed by fabric,
 * or extra custom manipulation
 * @param {Object} [options] Object containing options for parsing
 * @param {String} [options.crossOrigin] crossOrigin setting to use for external resources
 * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
 * @return {SVGParsingOutput}
 * {@link SVGParsingOutput} also receives `allElements` array as the last argument. This is the full list of svg nodes available in the document.
 * You may want to use it if you are trying to regroup the objects as they were originally grouped in the SVG. ( This was the reason why it was added )
 */ async function $f268b97836dca6b6$export$7489c3bacab04ae5(doc, reviver) {
    let { crossOrigin: crossOrigin, signal: signal } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (signal && signal.aborted) {
        $f268b97836dca6b6$var$log('log', new $f268b97836dca6b6$var$SignalAbortedError('parseSVGDocument'));
        // this is an unhappy path, we dont care about speed
        return $f268b97836dca6b6$var$createEmptyResponse();
    }
    const documentElement = doc.documentElement;
    $f268b97836dca6b6$var$parseUseDirectives(doc);
    const descendants = Array.from(documentElement.getElementsByTagName('*')), options = $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, $f268b97836dca6b6$var$applyViewboxTransform(documentElement)), {}, {
        crossOrigin: crossOrigin,
        signal: signal
    });
    const elements = descendants.filter((el)=>{
        $f268b97836dca6b6$var$applyViewboxTransform(el);
        return $f268b97836dca6b6$var$isValidSvgTag(el) && !$f268b97836dca6b6$var$hasInvalidAncestor(el); // http://www.w3.org/TR/SVG/struct.html#DefsElement
    });
    if (!elements || elements && !elements.length) return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, $f268b97836dca6b6$var$createEmptyResponse()), {}, {
        options: options,
        allElements: descendants
    });
    const localClipPaths = {};
    descendants.filter((el)=>$f268b97836dca6b6$var$getTagName(el) === 'clipPath').forEach((el)=>{
        el.setAttribute('originalTransform', el.getAttribute('transform') || '');
        const id = el.getAttribute('id');
        localClipPaths[id] = Array.from(el.getElementsByTagName('*')).filter((el)=>$f268b97836dca6b6$var$isValidSvgTag(el));
    });
    // Precedence of rules:   style > class > attribute
    const elementParser = new $f268b97836dca6b6$var$ElementsParser(elements, options, reviver, doc, localClipPaths);
    const instances = await elementParser.parse();
    return {
        objects: instances,
        elements: elements,
        options: options,
        allElements: descendants
    };
}
/**
 * Takes string corresponding to an SVG document, and parses it into a set of fabric objects
 * @memberOf fabric
 * @param {String} string representing the svg
 * @param {TSvgParsedCallback} callback Invoked when the parsing is done, with null if parsing wasn't possible with the list of svg nodes.
 * {@link TSvgParsedCallback} also receives `allElements` array as the last argument. This is the full list of svg nodes available in the document.
 * You may want to use it if you are trying to regroup the objects as they were originally grouped in the SVG. ( This was the reason why it was added )
 * @param {TSvgReviverCallback} [reviver] Extra callback for further parsing of SVG elements, called after each fabric object has been created.
 * Takes as input the original svg element and the generated `FabricObject` as arguments. Used to inspect extra properties not parsed by fabric,
 * or extra custom manipulation
 * @param {Object} [options] Object containing options for parsing
 * @param {String} [options.crossOrigin] crossOrigin setting to use for external resources
 * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
 */ function $f268b97836dca6b6$export$a0c5917fb6a8d612(string, reviver, options) {
    const parser = new ($f268b97836dca6b6$export$4a3a3142573970c3()).DOMParser(), // should we use `image/svg+xml` here?
    doc = parser.parseFromString(string.trim(), 'text/xml');
    return $f268b97836dca6b6$export$7489c3bacab04ae5(doc, reviver, options);
}
/**
 * Takes url corresponding to an SVG document, and parses it into a set of fabric objects.
 * Note that SVG is fetched via XMLHttpRequest, so it needs to conform to SOP (Same Origin Policy)
 * @memberOf fabric
 * @param {string} url where the SVG is
 * @param {TSvgParsedCallback} callback Invoked when the parsing is done, with null if parsing wasn't possible with the list of svg nodes.
 * {@link TSvgParsedCallback} also receives `allElements` array as the last argument. This is the full list of svg nodes available in the document.
 * You may want to use it if you are trying to regroup the objects as they were originally grouped in the SVG. ( This was the reason why it was added )
 * @param {TSvgReviverCallback} [reviver] Extra callback for further parsing of SVG elements, called after each fabric object has been created.
 * Takes as input the original svg element and the generated `FabricObject` as arguments. Used to inspect extra properties not parsed by fabric,
 * or extra custom manipulation
 * @param {Object} [options] Object containing options for parsing
 * @param {String} [options.crossOrigin] crossOrigin setting to use for external resources
 * @param {AbortSignal} [options.signal] handle aborting, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
 */ function $f268b97836dca6b6$export$2b20e5519a374(url, reviver) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // need to handle error properly
    return new Promise((resolve, reject)=>{
        const onComplete = (r)=>{
            const xml = r.responseXML;
            if (xml) resolve(xml);
            reject();
        };
        $f268b97836dca6b6$var$request(url.replace(/^\n\s*/, '').trim(), {
            onComplete: onComplete,
            signal: options.signal
        });
    }).then((parsedDoc)=>$f268b97836dca6b6$export$7489c3bacab04ae5(parsedDoc, reviver, options)).catch(()=>{
        // this is an unhappy path, we dont care about speed
        return $f268b97836dca6b6$var$createEmptyResponse();
    });
}
const $f268b97836dca6b6$var$ACTION_NAME$1 = $f268b97836dca6b6$var$MODIFY_POLY;
/**
 * This function locates the controls.
 * It'll be used both for drawing and for interaction.
 */ const $f268b97836dca6b6$var$createPolyPositionHandler = (pointIndex)=>{
    return function(dim, finalMatrix, polyObject) {
        const { points: points, pathOffset: pathOffset } = polyObject;
        return new $f268b97836dca6b6$export$baf26146a414f24a(points[pointIndex]).subtract(pathOffset).transform($f268b97836dca6b6$var$multiplyTransformMatrices(polyObject.getViewportTransform(), polyObject.calcTransformMatrix()));
    };
};
/**
 * This function defines what the control does.
 * It'll be called on every mouse move after a control has been clicked and is being dragged.
 * The function receives as argument the mouse event, the current transform object
 * and the current position in canvas coordinate `transform.target` is a reference to the
 * current object being transformed.
 */ const $f268b97836dca6b6$var$polyActionHandler = (eventData, transform, x, y)=>{
    const { target: target, pointIndex: pointIndex } = transform;
    const poly = target;
    const mouseLocalPosition = $f268b97836dca6b6$var$sendPointToPlane(new $f268b97836dca6b6$export$baf26146a414f24a(x, y), undefined, poly.calcOwnMatrix());
    poly.points[pointIndex] = mouseLocalPosition.add(poly.pathOffset);
    poly.setDimensions();
    poly.set('dirty', true);
    return true;
};
/**
 * Keep the polygon in the same position when we change its `width`/`height`/`top`/`left`.
 */ const $f268b97836dca6b6$var$factoryPolyActionHandler = (pointIndex, fn)=>{
    return function(eventData, transform, x, y) {
        const poly = transform.target, anchorPoint = new $f268b97836dca6b6$export$baf26146a414f24a(poly.points[(pointIndex > 0 ? pointIndex : poly.points.length) - 1]), anchorPointInParentPlane = anchorPoint.subtract(poly.pathOffset).transform(poly.calcOwnMatrix()), actionPerformed = fn(eventData, $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, transform), {}, {
            pointIndex: pointIndex
        }), x, y);
        const newAnchorPointInParentPlane = anchorPoint.subtract(poly.pathOffset).transform(poly.calcOwnMatrix());
        const diff = newAnchorPointInParentPlane.subtract(anchorPointInParentPlane);
        poly.left -= diff.x;
        poly.top -= diff.y;
        return actionPerformed;
    };
};
const $f268b97836dca6b6$var$createPolyActionHandler = (pointIndex)=>$f268b97836dca6b6$var$wrapWithFireEvent($f268b97836dca6b6$var$ACTION_NAME$1, $f268b97836dca6b6$var$factoryPolyActionHandler(pointIndex, $f268b97836dca6b6$var$polyActionHandler));
function $f268b97836dca6b6$var$createPolyControls(arg0) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const controls = {};
    for(let idx = 0; idx < (typeof arg0 === 'number' ? arg0 : arg0.points.length); idx++)controls["p".concat(idx)] = new $f268b97836dca6b6$export$7a7fa4424cb20976($f268b97836dca6b6$var$_objectSpread2({
        actionName: $f268b97836dca6b6$var$ACTION_NAME$1,
        positionHandler: $f268b97836dca6b6$var$createPolyPositionHandler(idx),
        actionHandler: $f268b97836dca6b6$var$createPolyActionHandler(idx)
    }, options));
    return controls;
}
const $f268b97836dca6b6$var$ACTION_NAME = 'modifyPath';
const $f268b97836dca6b6$var$calcPathPointPosition = (pathObject, commandIndex, pointIndex)=>{
    const { path: path, pathOffset: pathOffset } = pathObject;
    const command = path[commandIndex];
    return new $f268b97836dca6b6$export$baf26146a414f24a(command[pointIndex] - pathOffset.x, command[pointIndex + 1] - pathOffset.y).transform($f268b97836dca6b6$var$multiplyTransformMatrices(pathObject.getViewportTransform(), pathObject.calcTransformMatrix()));
};
const $f268b97836dca6b6$var$movePathPoint = (pathObject, x, y, commandIndex, pointIndex)=>{
    const { path: path, pathOffset: pathOffset } = pathObject;
    const anchorCommand = path[(commandIndex > 0 ? commandIndex : path.length) - 1];
    const anchorPoint = new $f268b97836dca6b6$export$baf26146a414f24a(anchorCommand[pointIndex], anchorCommand[pointIndex + 1]);
    const anchorPointInParentPlane = anchorPoint.subtract(pathOffset).transform(pathObject.calcOwnMatrix());
    const mouseLocalPosition = $f268b97836dca6b6$var$sendPointToPlane(new $f268b97836dca6b6$export$baf26146a414f24a(x, y), undefined, pathObject.calcOwnMatrix());
    path[commandIndex][pointIndex] = mouseLocalPosition.x + pathOffset.x;
    path[commandIndex][pointIndex + 1] = mouseLocalPosition.y + pathOffset.y;
    pathObject.setDimensions();
    const newAnchorPointInParentPlane = anchorPoint.subtract(pathObject.pathOffset).transform(pathObject.calcOwnMatrix());
    const diff = newAnchorPointInParentPlane.subtract(anchorPointInParentPlane);
    pathObject.left -= diff.x;
    pathObject.top -= diff.y;
    pathObject.set('dirty', true);
    return true;
};
/**
 * This function locates the controls.
 * It'll be used both for drawing and for interaction.
 */ function $f268b97836dca6b6$var$pathPositionHandler(dim, finalMatrix, pathObject) {
    const { commandIndex: commandIndex, pointIndex: pointIndex } = this;
    return $f268b97836dca6b6$var$calcPathPointPosition(pathObject, commandIndex, pointIndex);
}
/**
 * This function defines what the control does.
 * It'll be called on every mouse move after a control has been clicked and is being dragged.
 * The function receives as argument the mouse event, the current transform object
 * and the current position in canvas coordinate `transform.target` is a reference to the
 * current object being transformed.
 */ function $f268b97836dca6b6$var$pathActionHandler(eventData, transform, x, y) {
    const { target: target } = transform;
    const { commandIndex: commandIndex, pointIndex: pointIndex } = this;
    const actionPerformed = $f268b97836dca6b6$var$movePathPoint(target, x, y, commandIndex, pointIndex);
    $f268b97836dca6b6$var$fireEvent(this.actionName, $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, $f268b97836dca6b6$var$commonEventInfo(eventData, transform, x, y)), {}, {
        commandIndex: commandIndex,
        pointIndex: pointIndex
    }));
    return actionPerformed;
}
const $f268b97836dca6b6$var$indexFromPrevCommand = (previousCommandType)=>previousCommandType === 'C' ? 5 : previousCommandType === 'Q' ? 3 : 1;
class $f268b97836dca6b6$var$PathPointControl extends $f268b97836dca6b6$export$7a7fa4424cb20976 {
    render(ctx, left, top, styleOverride, fabricObject) {
        const overrides = $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, styleOverride), {}, {
            cornerColor: this.controlFill,
            cornerStrokeColor: this.controlStroke,
            transparentCorners: !this.controlFill
        });
        super.render(ctx, left, top, overrides, fabricObject);
    }
    constructor(options){
        super(options);
    }
}
class $f268b97836dca6b6$var$PathControlPointControl extends $f268b97836dca6b6$var$PathPointControl {
    render(ctx, left, top, styleOverride, fabricObject) {
        const { path: path } = fabricObject;
        const { commandIndex: commandIndex, pointIndex: pointIndex, connectToCommandIndex: connectToCommandIndex, connectToPointIndex: connectToPointIndex } = this;
        ctx.save();
        ctx.strokeStyle = this.controlStroke;
        if (this.connectionDashArray) ctx.setLineDash(this.connectionDashArray);
        const [commandType] = path[commandIndex];
        const point = $f268b97836dca6b6$var$calcPathPointPosition(fabricObject, connectToCommandIndex, connectToPointIndex);
        if (commandType === 'Q') {
            // one control point connects to 2 points
            const point2 = $f268b97836dca6b6$var$calcPathPointPosition(fabricObject, commandIndex, pointIndex + 2);
            ctx.moveTo(point2.x, point2.y);
            ctx.lineTo(left, top);
        } else ctx.moveTo(left, top);
        ctx.lineTo(point.x, point.y);
        ctx.stroke();
        ctx.restore();
        super.render(ctx, left, top, styleOverride, fabricObject);
    }
    constructor(options){
        super(options);
    }
}
const $f268b97836dca6b6$var$createControl = (commandIndexPos, pointIndexPos, isControlPoint, options, connectToCommandIndex, connectToPointIndex)=>new (isControlPoint ? $f268b97836dca6b6$var$PathControlPointControl : $f268b97836dca6b6$var$PathPointControl)($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({
        commandIndex: commandIndexPos,
        pointIndex: pointIndexPos,
        actionName: $f268b97836dca6b6$var$ACTION_NAME,
        positionHandler: $f268b97836dca6b6$var$pathPositionHandler,
        actionHandler: $f268b97836dca6b6$var$pathActionHandler,
        connectToCommandIndex: connectToCommandIndex,
        connectToPointIndex: connectToPointIndex
    }, options), isControlPoint ? options.controlPointStyle : options.pointStyle));
function $f268b97836dca6b6$var$createPathControls(path) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const controls = {};
    let previousCommandType = 'M';
    path.path.forEach((command, commandIndex)=>{
        const commandType = command[0];
        if (commandType !== 'Z') controls["c_".concat(commandIndex, "_").concat(commandType)] = $f268b97836dca6b6$var$createControl(commandIndex, command.length - 2, false, options);
        switch(commandType){
            case 'C':
                controls["c_".concat(commandIndex, "_C_CP_1")] = $f268b97836dca6b6$var$createControl(commandIndex, 1, true, options, commandIndex - 1, $f268b97836dca6b6$var$indexFromPrevCommand(previousCommandType));
                controls["c_".concat(commandIndex, "_C_CP_2")] = $f268b97836dca6b6$var$createControl(commandIndex, 3, true, options, commandIndex, 5);
                break;
            case 'Q':
                controls["c_".concat(commandIndex, "_Q_CP_1")] = $f268b97836dca6b6$var$createControl(commandIndex, 1, true, options, commandIndex, 3);
                break;
        }
        previousCommandType = commandType;
    });
    return controls;
}
var $f268b97836dca6b6$export$d13a0d9b79355c3 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    changeWidth: $f268b97836dca6b6$var$changeWidth,
    createObjectDefaultControls: $f268b97836dca6b6$var$createObjectDefaultControls,
    createPathControls: $f268b97836dca6b6$var$createPathControls,
    createPolyActionHandler: $f268b97836dca6b6$var$createPolyActionHandler,
    createPolyControls: $f268b97836dca6b6$var$createPolyControls,
    createPolyPositionHandler: $f268b97836dca6b6$var$createPolyPositionHandler,
    createResizeControls: $f268b97836dca6b6$var$createResizeControls,
    createTextboxDefaultControls: $f268b97836dca6b6$var$createTextboxDefaultControls,
    dragHandler: $f268b97836dca6b6$var$dragHandler,
    factoryPolyActionHandler: $f268b97836dca6b6$var$factoryPolyActionHandler,
    getLocalPoint: $f268b97836dca6b6$var$getLocalPoint,
    polyActionHandler: $f268b97836dca6b6$var$polyActionHandler,
    renderCircleControl: $f268b97836dca6b6$var$renderCircleControl,
    renderSquareControl: $f268b97836dca6b6$var$renderSquareControl,
    rotationStyleHandler: $f268b97836dca6b6$var$rotationStyleHandler,
    rotationWithSnapping: $f268b97836dca6b6$var$rotationWithSnapping,
    scaleCursorStyleHandler: $f268b97836dca6b6$var$scaleCursorStyleHandler,
    scaleOrSkewActionName: $f268b97836dca6b6$var$scaleOrSkewActionName,
    scaleSkewCursorStyleHandler: $f268b97836dca6b6$var$scaleSkewCursorStyleHandler,
    scalingEqually: $f268b97836dca6b6$var$scalingEqually,
    scalingX: $f268b97836dca6b6$var$scalingX,
    scalingXOrSkewingY: $f268b97836dca6b6$var$scalingXOrSkewingY,
    scalingY: $f268b97836dca6b6$var$scalingY,
    scalingYOrSkewingX: $f268b97836dca6b6$var$scalingYOrSkewingX,
    skewCursorStyleHandler: $f268b97836dca6b6$var$skewCursorStyleHandler,
    skewHandlerX: $f268b97836dca6b6$var$skewHandlerX,
    skewHandlerY: $f268b97836dca6b6$var$skewHandlerY,
    wrapWithFireEvent: $f268b97836dca6b6$var$wrapWithFireEvent,
    wrapWithFixedAnchor: $f268b97836dca6b6$var$wrapWithFixedAnchor
});
const $f268b97836dca6b6$export$ec9091584da1706b = (options)=>{
    return options.webgl !== undefined;
};
/**
 * Pick a method to copy data from GL context to 2d canvas.  In some browsers using
 * drawImage should be faster, but is also bugged for a small combination of old hardware
 * and drivers.
 * putImageData is faster than drawImage for that specific operation.
 */ const $f268b97836dca6b6$export$be5e33ed1f656bf4 = (width, height)=>{
    const targetCanvas = $f268b97836dca6b6$var$createCanvasElementFor({
        width: width,
        height: height
    });
    const sourceCanvas = $f268b97836dca6b6$var$createCanvasElement();
    const gl = sourceCanvas.getContext('webgl');
    // eslint-disable-next-line no-undef
    const imageBuffer = new ArrayBuffer(width * height * 4);
    const testContext = {
        imageBuffer: imageBuffer
    };
    const testPipelineState = {
        destinationWidth: width,
        destinationHeight: height,
        targetCanvas: targetCanvas
    };
    let startTime;
    startTime = $f268b97836dca6b6$export$4a3a3142573970c3().performance.now();
    $f268b97836dca6b6$export$42da2a27efef173b.prototype.copyGLTo2D.call(testContext, gl, testPipelineState);
    const drawImageTime = $f268b97836dca6b6$export$4a3a3142573970c3().performance.now() - startTime;
    startTime = $f268b97836dca6b6$export$4a3a3142573970c3().performance.now();
    $f268b97836dca6b6$export$42da2a27efef173b.prototype.copyGLTo2DPutImageData.call(testContext, gl, testPipelineState);
    const putImageDataTime = $f268b97836dca6b6$export$4a3a3142573970c3().performance.now() - startTime;
    return drawImageTime > putImageDataTime;
};
const $f268b97836dca6b6$var$highPsourceCode = "precision highp float";
const $f268b97836dca6b6$var$identityFragmentShader = "\n    ".concat($f268b97836dca6b6$var$highPsourceCode, ";\n    varying vec2 vTexCoord;\n    uniform sampler2D uTexture;\n    void main() {\n      gl_FragColor = texture2D(uTexture, vTexCoord);\n    }");
const $f268b97836dca6b6$var$vertexSource$1 = "\n    attribute vec2 aPosition;\n    varying vec2 vTexCoord;\n    void main() {\n      vTexCoord = aPosition;\n      gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n    }";
const $f268b97836dca6b6$var$_excluded$1 = [
    "type"
], $f268b97836dca6b6$var$_excluded2 = [
    "type"
];
const $f268b97836dca6b6$var$regex = new RegExp($f268b97836dca6b6$var$highPsourceCode, 'g');
class $f268b97836dca6b6$var$BaseFilter {
    /**
   * Filter type
   * @param {String} type
   * @default
   */ get type() {
        return this.constructor.type;
    }
    getFragmentSource() {
        return $f268b97836dca6b6$var$identityFragmentShader;
    }
    getVertexSource() {
        return $f268b97836dca6b6$var$vertexSource$1;
    }
    /**
   * Compile this filter's shader program.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context to use for shader compilation.
   * @param {String} fragmentSource fragmentShader source for compilation
   * @param {String} vertexSource vertexShader source for compilation
   */ createProgram(gl) {
        let fragmentSource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getFragmentSource();
        let vertexSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.getVertexSource();
        const { WebGLProbe: { GLPrecision: GLPrecision = 'highp' } } = $f268b97836dca6b6$export$4bd44a2aa29d3d6e();
        if (GLPrecision !== 'highp') fragmentSource = fragmentSource.replace($f268b97836dca6b6$var$regex, $f268b97836dca6b6$var$highPsourceCode.replace('highp', GLPrecision));
        const vertexShader = gl.createShader(gl.VERTEX_SHADER);
        const fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
        const program = gl.createProgram();
        if (!vertexShader || !fragmentShader || !program) throw new $f268b97836dca6b6$var$FabricError('Vertex, fragment shader or program creation error');
        gl.shaderSource(vertexShader, vertexSource);
        gl.compileShader(vertexShader);
        if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) throw new $f268b97836dca6b6$var$FabricError("Vertex shader compile error for ".concat(this.type, ": ").concat(gl.getShaderInfoLog(vertexShader)));
        gl.shaderSource(fragmentShader, fragmentSource);
        gl.compileShader(fragmentShader);
        if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) throw new $f268b97836dca6b6$var$FabricError("Fragment shader compile error for ".concat(this.type, ": ").concat(gl.getShaderInfoLog(fragmentShader)));
        gl.attachShader(program, vertexShader);
        gl.attachShader(program, fragmentShader);
        gl.linkProgram(program);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) throw new $f268b97836dca6b6$var$FabricError("Shader link error for \"".concat(this.type, "\" ").concat(gl.getProgramInfoLog(program)));
        const uniformLocations = this.getUniformLocations(gl, program) || {};
        uniformLocations.uStepW = gl.getUniformLocation(program, 'uStepW');
        uniformLocations.uStepH = gl.getUniformLocation(program, 'uStepH');
        return {
            program: program,
            attributeLocations: this.getAttributeLocations(gl, program),
            uniformLocations: uniformLocations
        };
    }
    /**
   * Return a map of attribute names to WebGLAttributeLocation objects.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {WebGLShaderProgram} program The shader program from which to take attribute locations.
   * @returns {Object} A map of attribute names to attribute locations.
   */ getAttributeLocations(gl, program) {
        return {
            aPosition: gl.getAttribLocation(program, 'aPosition')
        };
    }
    /**
   * Return a map of uniform names to WebGLUniformLocation objects.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {WebGLShaderProgram} program The shader program from which to take uniform locations.
   * @returns {Object} A map of uniform names to uniform locations.
   */ getUniformLocations(gl, program) {
        const locations = this.constructor.uniformLocations;
        const uniformLocations = {};
        for(let i = 0; i < locations.length; i++)uniformLocations[locations[i]] = gl.getUniformLocation(program, locations[i]);
        return uniformLocations;
    }
    /**
   * Send attribute data from this filter to its shader program on the GPU.
   *
   * @param {WebGLRenderingContext} gl The canvas context used to compile the shader program.
   * @param {Object} attributeLocations A map of shader attribute names to their locations.
   */ sendAttributeData(gl, attributeLocations, aPositionData) {
        const attributeLocation = attributeLocations.aPosition;
        const buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
        gl.enableVertexAttribArray(attributeLocation);
        gl.vertexAttribPointer(attributeLocation, 2, gl.FLOAT, false, 0, 0);
        gl.bufferData(gl.ARRAY_BUFFER, aPositionData, gl.STATIC_DRAW);
    }
    _setupFrameBuffer(options) {
        const gl = options.context;
        if (options.passes > 1) {
            const width = options.destinationWidth;
            const height = options.destinationHeight;
            if (options.sourceWidth !== width || options.sourceHeight !== height) {
                gl.deleteTexture(options.targetTexture);
                options.targetTexture = options.filterBackend.createTexture(gl, width, height);
            }
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, options.targetTexture, 0);
        } else {
            // draw last filter on canvas and not to framebuffer.
            gl.bindFramebuffer(gl.FRAMEBUFFER, null);
            gl.finish();
        }
    }
    _swapTextures(options) {
        options.passes--;
        options.pass++;
        const temp = options.targetTexture;
        options.targetTexture = options.sourceTexture;
        options.sourceTexture = temp;
    }
    /**
   * Generic isNeutral implementation for one parameter based filters.
   * Used only in image applyFilters to discard filters that will not have an effect
   * on the image
   * Other filters may need their own version ( ColorMatrix, HueRotation, gamma, ComposedFilter )
   * @param {Object} options
   **/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isNeutralState(options) {
        return false;
    }
    /**
   * Apply this filter to the input image data provided.
   *
   * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */ applyTo(options) {
        if ($f268b97836dca6b6$export$ec9091584da1706b(options)) {
            this._setupFrameBuffer(options);
            this.applyToWebGL(options);
            this._swapTextures(options);
        } else this.applyTo2d(options);
    }
    applyTo2d(_options) {
    // override by subclass
    }
    /**
   * Returns a string that represent the current selected shader code for the filter.
   * Used to force recompilation when parameters change or to retrieve the shader from cache
   * @type string
   **/ getCacheKey() {
        return this.type;
    }
    /**
   * Retrieves the cached shader.
   * @param {Object} options
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   * @return {WebGLProgram} the compiled program shader
   */ retrieveShader(options) {
        const key = this.getCacheKey();
        if (!options.programCache[key]) options.programCache[key] = this.createProgram(options.context);
        return options.programCache[key];
    }
    /**
   * Apply this filter using webgl.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.originalTexture The texture of the original input image.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */ applyToWebGL(options) {
        const gl = options.context;
        const shader = this.retrieveShader(options);
        if (options.pass === 0 && options.originalTexture) gl.bindTexture(gl.TEXTURE_2D, options.originalTexture);
        else gl.bindTexture(gl.TEXTURE_2D, options.sourceTexture);
        gl.useProgram(shader.program);
        this.sendAttributeData(gl, shader.attributeLocations, options.aPosition);
        gl.uniform1f(shader.uniformLocations.uStepW, 1 / options.sourceWidth);
        gl.uniform1f(shader.uniformLocations.uStepH, 1 / options.sourceHeight);
        this.sendUniformData(gl, shader.uniformLocations);
        gl.viewport(0, 0, options.destinationWidth, options.destinationHeight);
        gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4);
    }
    bindAdditionalTexture(gl, texture, textureUnit) {
        gl.activeTexture(textureUnit);
        gl.bindTexture(gl.TEXTURE_2D, texture);
        // reset active texture to 0 as usual
        gl.activeTexture(gl.TEXTURE0);
    }
    unbindAdditionalTexture(gl, textureUnit) {
        gl.activeTexture(textureUnit);
        gl.bindTexture(gl.TEXTURE_2D, null);
        gl.activeTexture(gl.TEXTURE0);
    }
    /**
   * Send uniform data from this filter to its shader program on the GPU.
   *
   * Intended to be overridden by subclasses.
   *
   * @param {WebGLRenderingContext} _gl The canvas context used to compile the shader program.
   * @param {Object} _uniformLocations A map of shader uniform names to their locations.
   */ sendUniformData(_gl, _uniformLocations) {
    // override by subclass
    }
    /**
   * If needed by a 2d filter, this functions can create an helper canvas to be used
   * remember that options.targetCanvas is available for use till end of chain.
   */ createHelpLayer(options) {
        if (!options.helpLayer) {
            const { sourceWidth: sourceWidth, sourceHeight: sourceHeight } = options;
            const helpLayer = $f268b97836dca6b6$var$createCanvasElementFor({
                width: sourceWidth,
                height: sourceHeight
            });
            options.helpLayer = helpLayer;
        }
    }
    /**
   * Returns object representation of an instance
   * It will automatically export the default values of a filter,
   * stored in the static defaults property.
   * @return {Object} Object representation of an instance
   */ toObject() {
        const defaultKeys = Object.keys(this.constructor.defaults || {});
        return $f268b97836dca6b6$var$_objectSpread2({
            type: this.type
        }, defaultKeys.reduce((acc, key)=>{
            acc[key] = this[key];
            return acc;
        }, {}));
    }
    /**
   * Returns a JSON representation of an instance
   * @return {Object} JSON
   */ toJSON() {
        // delegate, not alias
        return this.toObject();
    }
    static async fromObject(_ref2, _options) {
        let filterOptions = $f268b97836dca6b6$var$_objectWithoutProperties(_ref2, $f268b97836dca6b6$var$_excluded2);
        return new this(filterOptions);
    }
    /**
   * The class type. Used to identify which class this is.
   * This is used for serialization purposes and internally it can be used
   * to identify classes. As a developer you could use `instance of Class`
   * but to avoid importing all the code and blocking tree shaking we try
   * to avoid doing that.
   */ /**
   * Constructor
   * @param {Object} [options] Options object
   */ constructor(){
        let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, options = $f268b97836dca6b6$var$_objectWithoutProperties(_ref, $f268b97836dca6b6$var$_excluded$1);
        Object.assign(this, this.constructor.defaults, options);
    }
}
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$BaseFilter, "type", 'BaseFilter');
/**
 * Contains the uniform locations for the fragment shader.
 * uStepW and uStepH are handled by the BaseFilter, each filter class
 * needs to specify all the one that are needed
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$BaseFilter, "uniformLocations", []);
const $f268b97836dca6b6$var$blendColorFragmentSource = {
    multiply: 'gl_FragColor.rgb *= uColor.rgb;\n',
    screen: 'gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);\n',
    add: 'gl_FragColor.rgb += uColor.rgb;\n',
    difference: 'gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);\n',
    subtract: 'gl_FragColor.rgb -= uColor.rgb;\n',
    lighten: 'gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);\n',
    darken: 'gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);\n',
    exclusion: 'gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);\n',
    overlay: "\n    if (uColor.r < 0.5) {\n      gl_FragColor.r *= 2.0 * uColor.r;\n    } else {\n      gl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);\n    }\n    if (uColor.g < 0.5) {\n      gl_FragColor.g *= 2.0 * uColor.g;\n    } else {\n      gl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);\n    }\n    if (uColor.b < 0.5) {\n      gl_FragColor.b *= 2.0 * uColor.b;\n    } else {\n      gl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);\n    }\n    ",
    tint: "\n    gl_FragColor.rgb *= (1.0 - uColor.a);\n    gl_FragColor.rgb += uColor.rgb;\n    "
};
const $f268b97836dca6b6$var$blendColorDefaultValues = {
    color: '#F95C63',
    mode: 'multiply',
    alpha: 1
};
/**
 * Color Blend filter class
 * @example
 * const filter = new BlendColor({
 *  color: '#000',
 *  mode: 'multiply'
 * });
 *
 * const filter = new BlendImage({
 *  image: fabricImageObject,
 *  mode: 'multiply'
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 */ class $f268b97836dca6b6$var$BlendColor extends $f268b97836dca6b6$var$BaseFilter {
    getCacheKey() {
        return "".concat(this.type, "_").concat(this.mode);
    }
    getFragmentSource() {
        return "\n      precision highp float;\n      uniform sampler2D uTexture;\n      uniform vec4 uColor;\n      varying vec2 vTexCoord;\n      void main() {\n        vec4 color = texture2D(uTexture, vTexCoord);\n        gl_FragColor = color;\n        if (color.a > 0.0) {\n          ".concat($f268b97836dca6b6$var$blendColorFragmentSource[this.mode], "\n        }\n      }\n      ");
    }
    /**
   * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        const source = new $f268b97836dca6b6$export$892596cec99bc70e(this.color).getSource();
        const alpha = this.alpha;
        const tr = source[0] * alpha;
        const tg = source[1] * alpha;
        const tb = source[2] * alpha;
        const alpha1 = 1 - alpha;
        for(let i = 0; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            let oR, oG, oB;
            switch(this.mode){
                case 'multiply':
                    oR = r * tr / 255;
                    oG = g * tg / 255;
                    oB = b * tb / 255;
                    break;
                case 'screen':
                    oR = 255 - (255 - r) * (255 - tr) / 255;
                    oG = 255 - (255 - g) * (255 - tg) / 255;
                    oB = 255 - (255 - b) * (255 - tb) / 255;
                    break;
                case 'add':
                    oR = r + tr;
                    oG = g + tg;
                    oB = b + tb;
                    break;
                case 'difference':
                    oR = Math.abs(r - tr);
                    oG = Math.abs(g - tg);
                    oB = Math.abs(b - tb);
                    break;
                case 'subtract':
                    oR = r - tr;
                    oG = g - tg;
                    oB = b - tb;
                    break;
                case 'darken':
                    oR = Math.min(r, tr);
                    oG = Math.min(g, tg);
                    oB = Math.min(b, tb);
                    break;
                case 'lighten':
                    oR = Math.max(r, tr);
                    oG = Math.max(g, tg);
                    oB = Math.max(b, tb);
                    break;
                case 'overlay':
                    oR = tr < 128 ? 2 * r * tr / 255 : 255 - 2 * (255 - r) * (255 - tr) / 255;
                    oG = tg < 128 ? 2 * g * tg / 255 : 255 - 2 * (255 - g) * (255 - tg) / 255;
                    oB = tb < 128 ? 2 * b * tb / 255 : 255 - 2 * (255 - b) * (255 - tb) / 255;
                    break;
                case 'exclusion':
                    oR = tr + r - 2 * tr * r / 255;
                    oG = tg + g - 2 * tg * g / 255;
                    oB = tb + b - 2 * tb * b / 255;
                    break;
                case 'tint':
                    oR = tr + r * alpha1;
                    oG = tg + g * alpha1;
                    oB = tb + b * alpha1;
            }
            data[i] = oR;
            data[i + 1] = oG;
            data[i + 2] = oB;
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        const source = new $f268b97836dca6b6$export$892596cec99bc70e(this.color).getSource();
        source[0] = this.alpha * source[0] / 255;
        source[1] = this.alpha * source[1] / 255;
        source[2] = this.alpha * source[2] / 255;
        source[3] = this.alpha;
        gl.uniform4fv(uniformLocations.uColor, source);
    }
}
/**
 * Color to make the blend operation with. default to a reddish color since black or white
 * gives always strong result.
 * @type String
 * @default
 **/ /**
 * Blend mode for the filter: one of multiply, add, difference, screen, subtract,
 * darken, lighten, overlay, exclusion, tint.
 * @type String
 * @default
 **/ /**
 * alpha value. represent the strength of the blend color operation.
 * @type Number
 * @default
 **/ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$BlendColor, "defaults", $f268b97836dca6b6$var$blendColorDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$BlendColor, "type", 'BlendColor');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$BlendColor, "uniformLocations", [
    'uColor'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$BlendColor);
const $f268b97836dca6b6$var$fragmentSource$c = {
    multiply: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform sampler2D uImage;\n    uniform vec4 uColor;\n    varying vec2 vTexCoord;\n    varying vec2 vTexCoord2;\n    void main() {\n      vec4 color = texture2D(uTexture, vTexCoord);\n      vec4 color2 = texture2D(uImage, vTexCoord2);\n      color.rgba *= color2.rgba;\n      gl_FragColor = color;\n    }\n    ",
    mask: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform sampler2D uImage;\n    uniform vec4 uColor;\n    varying vec2 vTexCoord;\n    varying vec2 vTexCoord2;\n    void main() {\n      vec4 color = texture2D(uTexture, vTexCoord);\n      vec4 color2 = texture2D(uImage, vTexCoord2);\n      color.a = color2.a;\n      gl_FragColor = color;\n    }\n    "
};
const $f268b97836dca6b6$var$vertexSource = "\n    attribute vec2 aPosition;\n    varying vec2 vTexCoord;\n    varying vec2 vTexCoord2;\n    uniform mat3 uTransformMatrix;\n    void main() {\n      vTexCoord = aPosition;\n      vTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;\n      gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n    }\n    ";
const $f268b97836dca6b6$var$_excluded = [
    "type",
    "image"
];
const $f268b97836dca6b6$var$blendImageDefaultValues = {
    mode: 'multiply',
    alpha: 1
};
/**
 * Image Blend filter class
 * @example
 * const filter = new filters.BlendColor({
 *  color: '#000',
 *  mode: 'multiply'
 * });
 *
 * const filter = new BlendImage({
 *  image: fabricImageObject,
 *  mode: 'multiply'
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 */ class $f268b97836dca6b6$var$BlendImage extends $f268b97836dca6b6$var$BaseFilter {
    getCacheKey() {
        return "".concat(this.type, "_").concat(this.mode);
    }
    getFragmentSource() {
        return $f268b97836dca6b6$var$fragmentSource$c[this.mode];
    }
    getVertexSource() {
        return $f268b97836dca6b6$var$vertexSource;
    }
    applyToWebGL(options) {
        const gl = options.context, texture = this.createTexture(options.filterBackend, this.image);
        this.bindAdditionalTexture(gl, texture, gl.TEXTURE1);
        super.applyToWebGL(options);
        this.unbindAdditionalTexture(gl, gl.TEXTURE1);
    }
    createTexture(backend, image) {
        return backend.getCachedTexture(image.cacheKey, image.getElement());
    }
    /**
   * Calculate a transformMatrix to adapt the image to blend over
   * @param {Object} options
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */ calculateMatrix() {
        const image = this.image, { width: width, height: height } = image.getElement();
        return [
            1 / image.scaleX,
            0,
            0,
            0,
            1 / image.scaleY,
            0,
            -image.left / width,
            -image.top / height,
            1
        ];
    }
    /**
   * Apply the Blend operation to a Uint8ClampedArray representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data, width: width, height: height }, filterBackend: { resources: resources } } = _ref;
        const image = this.image;
        if (!resources.blendImage) resources.blendImage = $f268b97836dca6b6$var$createCanvasElement();
        const canvas1 = resources.blendImage;
        const context = canvas1.getContext('2d');
        if (canvas1.width !== width || canvas1.height !== height) {
            canvas1.width = width;
            canvas1.height = height;
        } else context.clearRect(0, 0, width, height);
        context.setTransform(image.scaleX, 0, 0, image.scaleY, image.left, image.top);
        context.drawImage(image.getElement(), 0, 0, width, height);
        const blendData = context.getImageData(0, 0, width, height).data;
        for(let i = 0; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            const a = data[i + 3];
            const tr = blendData[i];
            const tg = blendData[i + 1];
            const tb = blendData[i + 2];
            const ta = blendData[i + 3];
            switch(this.mode){
                case 'multiply':
                    data[i] = r * tr / 255;
                    data[i + 1] = g * tg / 255;
                    data[i + 2] = b * tb / 255;
                    data[i + 3] = a * ta / 255;
                    break;
                case 'mask':
                    data[i + 3] = ta;
                    break;
            }
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        const matrix = this.calculateMatrix();
        gl.uniform1i(uniformLocations.uImage, 1); // texture unit 1.
        gl.uniformMatrix3fv(uniformLocations.uTransformMatrix, false, matrix);
    }
    /**
   * Returns object representation of an instance
   * TODO: Handle the possibility of missing image better.
   * As of now a BlendImage filter without image can't be used with fromObject
   * @return {Object} Object representation of an instance
   */ toObject() {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.toObject()), {}, {
            image: this.image && this.image.toObject()
        });
    }
    /**
   * Create filter instance from an object representation
   * @static
   * @param {object} object Object to create an instance from
   * @param {object} [options]
   * @param {AbortSignal} [options.signal] handle aborting image loading, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @returns {Promise<BlendImage>}
   */ static async fromObject(_ref2, options) {
        let { type: type, image: image } = _ref2, filterOptions = $f268b97836dca6b6$var$_objectWithoutProperties(_ref2, $f268b97836dca6b6$var$_excluded);
        return $f268b97836dca6b6$export$3148ec5c6497ddc8.fromObject(image, options).then((enlivedImage)=>new this($f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, filterOptions), {}, {
                image: enlivedImage
            })));
    }
}
/**
 * Image to make the blend operation with.
 **/ /**
 * Blend mode for the filter: either 'multiply' or 'mask'. 'multiply' will
 * multiply the values of each channel (R, G, B, and A) of the filter image by
 * their corresponding values in the base image. 'mask' will only look at the
 * alpha channel of the filter image, and apply those values to the base
 * image's alpha channel.
 * @type String
 * @default
 **/ /**
 * alpha value. represent the strength of the blend image operation.
 * not implemented.
 **/ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$BlendImage, "type", 'BlendImage');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$BlendImage, "defaults", $f268b97836dca6b6$var$blendImageDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$BlendImage, "uniformLocations", [
    'uTransformMatrix',
    'uImage'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$BlendImage);
const $f268b97836dca6b6$var$fragmentSource$b = "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform vec2 uDelta;\n    varying vec2 vTexCoord;\n    const float nSamples = 15.0;\n    vec3 v3offset = vec3(12.9898, 78.233, 151.7182);\n    float random(vec3 scale) {\n      /* use the fragment position for a different seed per-pixel */\n      return fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);\n    }\n    void main() {\n      vec4 color = vec4(0.0);\n      float totalC = 0.0;\n      float totalA = 0.0;\n      float offset = random(v3offset);\n      for (float t = -nSamples; t <= nSamples; t++) {\n        float percent = (t + offset - 0.5) / nSamples;\n        vec4 sample = texture2D(uTexture, vTexCoord + uDelta * percent);\n        float weight = 1.0 - abs(percent);\n        float alpha = weight * sample.a;\n        color.rgb += sample.rgb * alpha;\n        color.a += alpha;\n        totalA += weight;\n        totalC += alpha;\n      }\n      gl_FragColor.rgb = color.rgb / totalC;\n      gl_FragColor.a = color.a / totalA;\n    }\n  ";
const $f268b97836dca6b6$var$blurDefaultValues = {
    blur: 0
};
/**
 * Blur filter class
 * @example
 * const filter = new Blur({
 *   blur: 0.5
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 */ class $f268b97836dca6b6$var$Blur extends $f268b97836dca6b6$var$BaseFilter {
    getFragmentSource() {
        return $f268b97836dca6b6$var$fragmentSource$b;
    }
    applyTo(options) {
        if ($f268b97836dca6b6$export$ec9091584da1706b(options)) {
            // this aspectRatio is used to give the same blur to vertical and horizontal
            this.aspectRatio = options.sourceWidth / options.sourceHeight;
            options.passes++;
            this._setupFrameBuffer(options);
            this.horizontal = true;
            this.applyToWebGL(options);
            this._swapTextures(options);
            this._setupFrameBuffer(options);
            this.horizontal = false;
            this.applyToWebGL(options);
            this._swapTextures(options);
        } else this.applyTo2d(options);
    }
    applyTo2d(_ref) {
        let { imageData: { data: data, width: width, height: height } } = _ref;
        // this code mimic the shader for output consistency
        // it samples 31 pixels across the image over a distance that depends from the blur value.
        this.aspectRatio = width / height;
        this.horizontal = true;
        let blurValue = this.getBlurValue() * width;
        const imageData = new Uint8ClampedArray(data);
        const samples = 15;
        const bytesInRow = 4 * width;
        for(let i = 0; i < data.length; i += 4){
            let r = 0.0, g = 0.0, b = 0.0, a = 0.0, totalA = 0;
            const minIRow = i - i % bytesInRow;
            const maxIRow = minIRow + bytesInRow;
            // for now let's keep noise out of the way
            // let pixelOffset = 0;
            // const offset = Math.random() * 3;
            // if (offset > 2) {
            //   pixelOffset = 4;
            // } else if (offset < 1) {
            //   pixelOffset = -4;
            // }
            for(let j = -samples + 1; j < samples; j++){
                const percent = j / samples;
                const distance = Math.floor(blurValue * percent) * 4;
                const weight = 1 - Math.abs(percent);
                let sampledPixel = i + distance; // + pixelOffset;
                // try to implement edge mirroring
                if (sampledPixel < minIRow) sampledPixel = minIRow;
                else if (sampledPixel > maxIRow) sampledPixel = maxIRow;
                const localAlpha = data[sampledPixel + 3] * weight;
                r += data[sampledPixel] * localAlpha;
                g += data[sampledPixel + 1] * localAlpha;
                b += data[sampledPixel + 2] * localAlpha;
                a += localAlpha;
                totalA += weight;
            }
            imageData[i] = r / a;
            imageData[i + 1] = g / a;
            imageData[i + 2] = b / a;
            imageData[i + 3] = a / totalA;
        }
        this.horizontal = false;
        blurValue = this.getBlurValue() * height;
        for(let i = 0; i < imageData.length; i += 4){
            let r = 0.0, g = 0.0, b = 0.0, a = 0.0, totalA = 0;
            const minIRow = i % bytesInRow;
            const maxIRow = imageData.length - bytesInRow + minIRow;
            // for now let's keep noise out of the way
            // let pixelOffset = 0;
            // const offset = Math.random() * 3;
            // if (offset > 2) {
            //   pixelOffset = bytesInRow;
            // } else if (offset < 1) {
            //   pixelOffset = -bytesInRow;
            // }
            for(let j = -samples + 1; j < samples; j++){
                const percent = j / samples;
                const distance = Math.floor(blurValue * percent) * bytesInRow;
                const weight = 1 - Math.abs(percent);
                let sampledPixel = i + distance; // + pixelOffset;
                // try to implement edge mirroring
                if (sampledPixel < minIRow) sampledPixel = minIRow;
                else if (sampledPixel > maxIRow) sampledPixel = maxIRow;
                const localAlpha = imageData[sampledPixel + 3] * weight;
                r += imageData[sampledPixel] * localAlpha;
                g += imageData[sampledPixel + 1] * localAlpha;
                b += imageData[sampledPixel + 2] * localAlpha;
                a += localAlpha;
                totalA += weight;
            }
            data[i] = r / a;
            data[i + 1] = g / a;
            data[i + 2] = b / a;
            data[i + 3] = a / totalA;
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        const delta = this.chooseRightDelta();
        gl.uniform2fv(uniformLocations.uDelta, delta);
    }
    isNeutralState() {
        return this.blur === 0;
    }
    getBlurValue() {
        let blurScale = 1;
        const { horizontal: horizontal, aspectRatio: aspectRatio } = this;
        if (horizontal) {
            if (aspectRatio > 1) // image is wide, i want to shrink radius horizontal
            blurScale = 1 / aspectRatio;
        } else if (aspectRatio < 1) // image is tall, i want to shrink radius vertical
        blurScale = aspectRatio;
        return blurScale * this.blur * 0.12;
    }
    /**
   * choose right value of image percentage to blur with
   * @returns {Array} a numeric array with delta values
   */ chooseRightDelta() {
        const blur = this.getBlurValue();
        return this.horizontal ? [
            blur,
            0
        ] : [
            0,
            blur
        ];
    }
}
/**
 * blur value, in percentage of image dimensions.
 * specific to keep the image blur constant at different resolutions
 * range between 0 and 1.
 * @type Number
 * @default
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Blur, "type", 'Blur');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Blur, "defaults", $f268b97836dca6b6$var$blurDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Blur, "uniformLocations", [
    'uDelta'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$Blur);
const $f268b97836dca6b6$var$fragmentSource$a = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uBrightness;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    color.rgb += uBrightness;\n    gl_FragColor = color;\n  }\n";
const $f268b97836dca6b6$var$brightnessDefaultValues = {
    brightness: 0
};
/**
 * Brightness filter class
 * @example
 * const filter = new Brightness({
 *   brightness: 0.05
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 */ class $f268b97836dca6b6$var$Brightness extends $f268b97836dca6b6$var$BaseFilter {
    getFragmentSource() {
        return $f268b97836dca6b6$var$fragmentSource$a;
    }
    /**
   * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        const brightness = Math.round(this.brightness * 255);
        for(let i = 0; i < data.length; i += 4){
            data[i] += brightness;
            data[i + 1] += brightness;
            data[i + 2] += brightness;
        }
    }
    isNeutralState() {
        return this.brightness === 0;
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uBrightness, this.brightness);
    }
}
/**
 * Brightness value, from -1 to 1.
 * translated to -255 to 255 for 2d
 * 0.0039215686 is the part of 1 that get translated to 1 in 2d
 * @param {Number} brightness
 * @default
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Brightness, "type", 'Brightness');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Brightness, "defaults", $f268b97836dca6b6$var$brightnessDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Brightness, "uniformLocations", [
    'uBrightness'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$Brightness);
const $f268b97836dca6b6$var$fragmentSource$9 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  varying vec2 vTexCoord;\n  uniform mat4 uColorMatrix;\n  uniform vec4 uConstants;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    color *= uColorMatrix;\n    color += uConstants;\n    gl_FragColor = color;\n  }";
const $f268b97836dca6b6$var$colorMatrixDefaultValues = {
    matrix: [
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        1,
        0
    ],
    colorsOnly: true
};
/**
   * Color Matrix filter class
   * @see {@link http://fabricjs.com/image-filters|ImageFilters demo}
   * @see {@Link http://phoboslab.org/log/2013/11/fast-image-filters-with-webgl demo}
   * @example <caption>Kodachrome filter</caption>
   * const filter = new ColorMatrix({
   *  matrix: [
       1.1285582396593525, -0.3967382283601348, -0.03992559172921793, 0, 63.72958762196502,
       -0.16404339962244616, 1.0835251566291304, -0.05498805115633132, 0, 24.732407896706203,
       -0.16786010706155763, -0.5603416277695248, 1.6014850761964943, 0, 35.62982807460946,
       0, 0, 0, 1, 0
      ]
   * });
   * object.filters.push(filter);
   * object.applyFilters();
   */ class $f268b97836dca6b6$var$ColorMatrix extends $f268b97836dca6b6$var$BaseFilter {
    getFragmentSource() {
        return $f268b97836dca6b6$var$fragmentSource$9;
    }
    /**
   * Apply the ColorMatrix operation to a Uint8Array representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8Array to be filtered.
   */ applyTo2d(options) {
        const imageData = options.imageData, data = imageData.data, m = this.matrix, colorsOnly = this.colorsOnly;
        for(let i = 0; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            data[i] = r * m[0] + g * m[1] + b * m[2] + m[4] * 255;
            data[i + 1] = r * m[5] + g * m[6] + b * m[7] + m[9] * 255;
            data[i + 2] = r * m[10] + g * m[11] + b * m[12] + m[14] * 255;
            if (!colorsOnly) {
                const a = data[i + 3];
                data[i] += a * m[3];
                data[i + 1] += a * m[8];
                data[i + 2] += a * m[13];
                data[i + 3] = r * m[15] + g * m[16] + b * m[17] + a * m[18] + m[19] * 255;
            }
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        const m = this.matrix, matrix = [
            m[0],
            m[1],
            m[2],
            m[3],
            m[5],
            m[6],
            m[7],
            m[8],
            m[10],
            m[11],
            m[12],
            m[13],
            m[15],
            m[16],
            m[17],
            m[18]
        ], constants = [
            m[4],
            m[9],
            m[14],
            m[19]
        ];
        gl.uniformMatrix4fv(uniformLocations.uColorMatrix, false, matrix);
        gl.uniform4fv(uniformLocations.uConstants, constants);
    }
    toObject() {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.toObject()), {}, {
            matrix: [
                ...this.matrix
            ]
        });
    }
}
/**
 * Colormatrix for pixels.
 * array of 20 floats. Numbers in positions 4, 9, 14, 19 loose meaning
 * outside the -1, 1 range.
 * 0.0039215686 is the part of 1 that get translated to 1 in 2d
 * @param {Array} matrix array of 20 numbers.
 * @default
 */ /**
 * Lock the colormatrix on the color part, skipping alpha, mainly for non webgl scenario
 * to save some calculation
 * @type Boolean
 * @default true
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$ColorMatrix, "type", 'ColorMatrix');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$ColorMatrix, "defaults", $f268b97836dca6b6$var$colorMatrixDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$ColorMatrix, "uniformLocations", [
    'uColorMatrix',
    'uConstants'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$ColorMatrix);
function $f268b97836dca6b6$var$createColorMatrixFilter(key, matrix) {
    var _Class;
    const newClass = (_Class = class newClass extends $f268b97836dca6b6$var$ColorMatrix {
        toObject() {
            return {
                type: this.type,
                colorsOnly: this.colorsOnly
            };
        }
    }, $f268b97836dca6b6$var$_defineProperty(_Class, "type", key), $f268b97836dca6b6$var$_defineProperty(_Class, "defaults", {
        colorsOnly: false,
        matrix: matrix
    }), _Class);
    $f268b97836dca6b6$export$2792378e23a7920c.setClass(newClass, key);
    return newClass;
}
const $f268b97836dca6b6$var$Brownie = $f268b97836dca6b6$var$createColorMatrixFilter('Brownie', [
    0.5997,
    0.34553,
    -0.27082,
    0,
    0.186,
    -0.0377,
    0.86095,
    0.15059,
    0,
    -0.1449,
    0.24113,
    -0.07441,
    0.44972,
    0,
    -0.02965,
    0,
    0,
    0,
    1,
    0
]);
const $f268b97836dca6b6$var$Vintage = $f268b97836dca6b6$var$createColorMatrixFilter('Vintage', [
    0.62793,
    0.32021,
    -0.03965,
    0,
    0.03784,
    0.02578,
    0.64411,
    0.03259,
    0,
    0.02926,
    0.0466,
    -0.08512,
    0.52416,
    0,
    0.02023,
    0,
    0,
    0,
    1,
    0
]);
const $f268b97836dca6b6$var$Kodachrome = $f268b97836dca6b6$var$createColorMatrixFilter('Kodachrome', [
    1.12855,
    -0.39673,
    -0.03992,
    0,
    0.24991,
    -0.16404,
    1.08352,
    -0.05498,
    0,
    0.09698,
    -0.16786,
    -0.56034,
    1.60148,
    0,
    0.13972,
    0,
    0,
    0,
    1,
    0
]);
const $f268b97836dca6b6$var$Technicolor = $f268b97836dca6b6$var$createColorMatrixFilter('Technicolor', [
    1.91252,
    -0.85453,
    -0.09155,
    0,
    0.04624,
    -0.30878,
    1.76589,
    -0.10601,
    0,
    -0.27589,
    -0.2311,
    -0.75018,
    1.84759,
    0,
    0.12137,
    0,
    0,
    0,
    1,
    0
]);
const $f268b97836dca6b6$var$Polaroid = $f268b97836dca6b6$var$createColorMatrixFilter('Polaroid', [
    1.438,
    -0.062,
    -0.062,
    0,
    0,
    -0.122,
    1.378,
    -0.122,
    0,
    0,
    -0.016,
    -0.016,
    1.483,
    0,
    0,
    0,
    0,
    0,
    1,
    0
]);
const $f268b97836dca6b6$var$Sepia = $f268b97836dca6b6$var$createColorMatrixFilter('Sepia', [
    0.393,
    0.769,
    0.189,
    0,
    0,
    0.349,
    0.686,
    0.168,
    0,
    0,
    0.272,
    0.534,
    0.131,
    0,
    0,
    0,
    0,
    0,
    1,
    0
]);
const $f268b97836dca6b6$var$BlackWhite = $f268b97836dca6b6$var$createColorMatrixFilter('BlackWhite', [
    1.5,
    1.5,
    1.5,
    0,
    -1,
    1.5,
    1.5,
    1.5,
    0,
    -1,
    1.5,
    1.5,
    1.5,
    0,
    -1,
    0,
    0,
    0,
    1,
    0
]);
/**
 * A container class that knows how to apply a sequence of filters to an input image.
 */ class $f268b97836dca6b6$var$Composed extends $f268b97836dca6b6$var$BaseFilter {
    /**
   * Apply this container's filters to the input image provided.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be applied.
   */ applyTo(options) {
        if ($f268b97836dca6b6$export$ec9091584da1706b(options)) options.passes += this.subFilters.length - 1;
        this.subFilters.forEach((filter)=>{
            filter.applyTo(options);
        });
    }
    /**
   * Serialize this filter into JSON.
   * @returns {Object} A JSON representation of this filter.
   */ toObject() {
        return {
            type: this.type,
            subFilters: this.subFilters.map((filter)=>filter.toObject())
        };
    }
    isNeutralState() {
        return !this.subFilters.some((filter)=>!filter.isNeutralState());
    }
    /**
   * Deserialize a JSON definition of a ComposedFilter into a concrete instance.
   * @static
   * @param {oject} object Object to create an instance from
   * @param {object} [options]
   * @param {AbortSignal} [options.signal] handle aborting `BlendImage` filter loading, see https://developer.mozilla.org/en-US/docs/Web/API/AbortController/signal
   * @returns {Promise<Composed>}
   */ static fromObject(object, options) {
        return Promise.all((object.subFilters || []).map((filter)=>$f268b97836dca6b6$export$2792378e23a7920c.getClass(filter.type).fromObject(filter, options))).then((enlivedFilters)=>new this({
                subFilters: enlivedFilters
            }));
    }
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        super(options);
        this.subFilters = options.subFilters || [];
    }
}
/**
 * A non sparse array of filters to apply
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Composed, "type", 'Composed');
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$Composed);
const $f268b97836dca6b6$var$fragmentSource$8 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uContrast;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    float contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));\n    color.rgb = contrastF * (color.rgb - 0.5) + 0.5;\n    gl_FragColor = color;\n  }";
const $f268b97836dca6b6$var$contrastDefaultValues = {
    contrast: 0
};
/**
 * Contrast filter class
 * @example
 * const filter = new Contrast({
 *   contrast: 0.25
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 */ class $f268b97836dca6b6$var$Contrast extends $f268b97836dca6b6$var$BaseFilter {
    getFragmentSource() {
        return $f268b97836dca6b6$var$fragmentSource$8;
    }
    isNeutralState() {
        return this.contrast === 0;
    }
    /**
   * Apply the Contrast operation to a Uint8Array representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8Array to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        const contrast = Math.floor(this.contrast * 255), contrastF = 259 * (contrast + 255) / (255 * (259 - contrast));
        for(let i = 0; i < data.length; i += 4){
            data[i] = contrastF * (data[i] - 128) + 128;
            data[i + 1] = contrastF * (data[i + 1] - 128) + 128;
            data[i + 2] = contrastF * (data[i + 2] - 128) + 128;
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uContrast, this.contrast);
    }
}
/**
 * contrast value, range from -1 to 1.
 * @param {Number} contrast
 * @default 0
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Contrast, "type", 'Contrast');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Contrast, "defaults", $f268b97836dca6b6$var$contrastDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Contrast, "uniformLocations", [
    'uContrast'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$Contrast);
const $f268b97836dca6b6$var$fragmentSource$7 = {
    Convolute_3_1: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[9];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 0);\n      for (float h = 0.0; h < 3.0; h+=1.0) {\n        for (float w = 0.0; w < 3.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));\n          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];\n        }\n      }\n      gl_FragColor = color;\n    }\n    ",
    Convolute_3_0: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[9];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 1);\n      for (float h = 0.0; h < 3.0; h+=1.0) {\n        for (float w = 0.0; w < 3.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));\n          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];\n        }\n      }\n      float alpha = texture2D(uTexture, vTexCoord).a;\n      gl_FragColor = color;\n      gl_FragColor.a = alpha;\n    }\n    ",
    Convolute_5_1: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[25];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 0);\n      for (float h = 0.0; h < 5.0; h+=1.0) {\n        for (float w = 0.0; w < 5.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];\n        }\n      }\n      gl_FragColor = color;\n    }\n    ",
    Convolute_5_0: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[25];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 1);\n      for (float h = 0.0; h < 5.0; h+=1.0) {\n        for (float w = 0.0; w < 5.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];\n        }\n      }\n      float alpha = texture2D(uTexture, vTexCoord).a;\n      gl_FragColor = color;\n      gl_FragColor.a = alpha;\n    }\n    ",
    Convolute_7_1: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[49];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 0);\n      for (float h = 0.0; h < 7.0; h+=1.0) {\n        for (float w = 0.0; w < 7.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];\n        }\n      }\n      gl_FragColor = color;\n    }\n    ",
    Convolute_7_0: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[49];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 1);\n      for (float h = 0.0; h < 7.0; h+=1.0) {\n        for (float w = 0.0; w < 7.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];\n        }\n      }\n      float alpha = texture2D(uTexture, vTexCoord).a;\n      gl_FragColor = color;\n      gl_FragColor.a = alpha;\n    }\n    ",
    Convolute_9_1: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[81];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 0);\n      for (float h = 0.0; h < 9.0; h+=1.0) {\n        for (float w = 0.0; w < 9.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n          color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];\n        }\n      }\n      gl_FragColor = color;\n    }\n    ",
    Convolute_9_0: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform float uMatrix[81];\n    uniform float uStepW;\n    uniform float uStepH;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = vec4(0, 0, 0, 1);\n      for (float h = 0.0; h < 9.0; h+=1.0) {\n        for (float w = 0.0; w < 9.0; w+=1.0) {\n          vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n          color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];\n        }\n      }\n      float alpha = texture2D(uTexture, vTexCoord).a;\n      gl_FragColor = color;\n      gl_FragColor.a = alpha;\n    }\n    "
};
const $f268b97836dca6b6$var$convoluteDefaultValues = {
    opaque: false,
    matrix: [
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0
    ]
};
/**
 * Adapted from <a href="http://www.html5rocks.com/en/tutorials/canvas/imagefilters/">html5rocks article</a>
 * @example <caption>Sharpen filter</caption>
 * const filter = new Convolute({
 *   matrix: [ 0, -1,  0,
 *            -1,  5, -1,
 *             0, -1,  0 ]
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 * @example <caption>Blur filter</caption>
 * const filter = new Convolute({
 *   matrix: [ 1/9, 1/9, 1/9,
 *             1/9, 1/9, 1/9,
 *             1/9, 1/9, 1/9 ]
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 * @example <caption>Emboss filter</caption>
 * const filter = new Convolute({
 *   matrix: [ 1,   1,  1,
 *             1, 0.7, -1,
 *            -1,  -1, -1 ]
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 * @example <caption>Emboss filter with opaqueness</caption>
 * const filter = new Convolute({
 *   opaque: true,
 *   matrix: [ 1,   1,  1,
 *             1, 0.7, -1,
 *            -1,  -1, -1 ]
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 */ class $f268b97836dca6b6$var$Convolute extends $f268b97836dca6b6$var$BaseFilter {
    getCacheKey() {
        return "".concat(this.type, "_").concat(Math.sqrt(this.matrix.length), "_").concat(this.opaque ? 1 : 0);
    }
    getFragmentSource() {
        return $f268b97836dca6b6$var$fragmentSource$7[this.getCacheKey()];
    }
    /**
   * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
   */ applyTo2d(options) {
        const imageData = options.imageData, data = imageData.data, weights = this.matrix, side = Math.round(Math.sqrt(weights.length)), halfSide = Math.floor(side / 2), sw = imageData.width, sh = imageData.height, output = options.ctx.createImageData(sw, sh), dst = output.data, // go through the destination image pixels
        alphaFac = this.opaque ? 1 : 0;
        let r, g, b, a, dstOff, scx, scy, srcOff, wt, x, y, cx, cy;
        for(y = 0; y < sh; y++)for(x = 0; x < sw; x++){
            dstOff = (y * sw + x) * 4;
            // calculate the weighed sum of the source image pixels that
            // fall under the convolution matrix
            r = 0;
            g = 0;
            b = 0;
            a = 0;
            for(cy = 0; cy < side; cy++)for(cx = 0; cx < side; cx++){
                scy = y + cy - halfSide;
                scx = x + cx - halfSide;
                // eslint-disable-next-line max-depth
                if (scy < 0 || scy >= sh || scx < 0 || scx >= sw) continue;
                srcOff = (scy * sw + scx) * 4;
                wt = weights[cy * side + cx];
                r += data[srcOff] * wt;
                g += data[srcOff + 1] * wt;
                b += data[srcOff + 2] * wt;
                // eslint-disable-next-line max-depth
                if (!alphaFac) a += data[srcOff + 3] * wt;
            }
            dst[dstOff] = r;
            dst[dstOff + 1] = g;
            dst[dstOff + 2] = b;
            if (!alphaFac) dst[dstOff + 3] = a;
            else dst[dstOff + 3] = data[dstOff + 3];
        }
        options.imageData = output;
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform1fv(uniformLocations.uMatrix, this.matrix);
    }
    /**
   * Returns object representation of an instance
   * @return {Object} Object representation of an instance
   */ toObject() {
        return $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, super.toObject()), {}, {
            opaque: this.opaque,
            matrix: [
                ...this.matrix
            ]
        });
    }
}
/*
 * Opaque value (true/false)
 */ /*
 * matrix for the filter, max 9x9
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Convolute, "type", 'Convolute');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Convolute, "defaults", $f268b97836dca6b6$var$convoluteDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Convolute, "uniformLocations", [
    'uMatrix',
    'uOpaque',
    'uHalfSize',
    'uSize'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$Convolute);
const $f268b97836dca6b6$var$fragmentSource$6 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform vec3 uGamma;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    vec3 correction = (1.0 / uGamma);\n    color.r = pow(color.r, correction.r);\n    color.g = pow(color.g, correction.g);\n    color.b = pow(color.b, correction.b);\n    gl_FragColor = color;\n    gl_FragColor.rgb *= color.a;\n  }\n";
const $f268b97836dca6b6$var$GAMMA = 'Gamma';
const $f268b97836dca6b6$var$gammaDefaultValues = {
    gamma: [
        1,
        1,
        1
    ]
};
/**
 * Gamma filter class
 * @example
 * const filter = new Gamma({
 *   gamma: [1, 0.5, 2.1]
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 */ class $f268b97836dca6b6$var$Gamma extends $f268b97836dca6b6$var$BaseFilter {
    getFragmentSource() {
        return $f268b97836dca6b6$var$fragmentSource$6;
    }
    /**
   * Apply the Gamma operation to a Uint8Array representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8Array to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        const gamma = this.gamma, rInv = 1 / gamma[0], gInv = 1 / gamma[1], bInv = 1 / gamma[2];
        if (!this.rgbValues) this.rgbValues = {
            r: new Uint8Array(256),
            g: new Uint8Array(256),
            b: new Uint8Array(256)
        };
        // This is an optimization - pre-compute a look-up table for each color channel
        // instead of performing these pow calls for each pixel in the image.
        const rgb = this.rgbValues;
        for(let i = 0; i < 256; i++){
            rgb.r[i] = Math.pow(i / 255, rInv) * 255;
            rgb.g[i] = Math.pow(i / 255, gInv) * 255;
            rgb.b[i] = Math.pow(i / 255, bInv) * 255;
        }
        for(let i = 0; i < data.length; i += 4){
            data[i] = rgb.r[data[i]];
            data[i + 1] = rgb.g[data[i + 1]];
            data[i + 2] = rgb.b[data[i + 2]];
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform3fv(uniformLocations.uGamma, this.gamma);
    }
    isNeutralState() {
        const { gamma: gamma } = this;
        return gamma[0] === 1 && gamma[1] === 1 && gamma[2] === 1;
    }
    toObject() {
        return {
            type: $f268b97836dca6b6$var$GAMMA,
            gamma: this.gamma.concat()
        };
    }
    constructor(){
        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        super(options);
        this.gamma = options.gamma || this.constructor.defaults.gamma.concat();
    }
}
/**
 * Gamma array value, from 0.01 to 2.2.
 * @param {Array} gamma
 * @default
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Gamma, "type", $f268b97836dca6b6$var$GAMMA);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Gamma, "defaults", $f268b97836dca6b6$var$gammaDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Gamma, "uniformLocations", [
    'uGamma'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$Gamma);
const $f268b97836dca6b6$var$fragmentSource$5 = {
    average: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 color = texture2D(uTexture, vTexCoord);\n      float average = (color.r + color.b + color.g) / 3.0;\n      gl_FragColor = vec4(average, average, average, color.a);\n    }\n    ",
    lightness: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform int uMode;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 col = texture2D(uTexture, vTexCoord);\n      float average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;\n      gl_FragColor = vec4(average, average, average, col.a);\n    }\n    ",
    luminosity: "\n    precision highp float;\n    uniform sampler2D uTexture;\n    uniform int uMode;\n    varying vec2 vTexCoord;\n    void main() {\n      vec4 col = texture2D(uTexture, vTexCoord);\n      float average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;\n      gl_FragColor = vec4(average, average, average, col.a);\n    }\n    "
};
const $f268b97836dca6b6$var$grayscaleDefaultValues = {
    mode: 'average'
};
/**
 * Grayscale image filter class
 * @example
 * const filter = new Grayscale();
 * object.filters.push(filter);
 * object.applyFilters();
 */ class $f268b97836dca6b6$var$Grayscale extends $f268b97836dca6b6$var$BaseFilter {
    /**
   * Apply the Grayscale operation to a Uint8Array representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8Array to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        for(let i = 0, value; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            switch(this.mode){
                case 'average':
                    value = (r + g + b) / 3;
                    break;
                case 'lightness':
                    value = (Math.min(r, g, b) + Math.max(r, g, b)) / 2;
                    break;
                case 'luminosity':
                    value = 0.21 * r + 0.72 * g + 0.07 * b;
                    break;
            }
            data[i + 2] = data[i + 1] = data[i] = value;
        }
    }
    getCacheKey() {
        return "".concat(this.type, "_").concat(this.mode);
    }
    getFragmentSource() {
        return $f268b97836dca6b6$var$fragmentSource$5[this.mode];
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        const mode = 1;
        gl.uniform1i(uniformLocations.uMode, mode);
    }
    /**
   * Grayscale filter isNeutralState implementation
   * The filter is never neutral
   * on the image
   **/ isNeutralState() {
        return false;
    }
}
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Grayscale, "type", 'Grayscale');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Grayscale, "defaults", $f268b97836dca6b6$var$grayscaleDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Grayscale, "uniformLocations", [
    'uMode'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$Grayscale);
const $f268b97836dca6b6$var$hueRotationDefaultValues = $f268b97836dca6b6$var$_objectSpread2($f268b97836dca6b6$var$_objectSpread2({}, $f268b97836dca6b6$var$colorMatrixDefaultValues), {}, {
    rotation: 0
});
/**
 * HueRotation filter class
 * @example
 * const filter = new HueRotation({
 *   rotation: -0.5
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 */ class $f268b97836dca6b6$var$HueRotation extends $f268b97836dca6b6$var$ColorMatrix {
    calculateMatrix() {
        const rad = this.rotation * Math.PI, cosine = $f268b97836dca6b6$var$cos(rad), sine = $f268b97836dca6b6$var$sin(rad), aThird = 1 / 3, aThirdSqtSin = Math.sqrt(aThird) * sine, OneMinusCos = 1 - cosine;
        this.matrix = [
            cosine + OneMinusCos / 3,
            aThird * OneMinusCos - aThirdSqtSin,
            aThird * OneMinusCos + aThirdSqtSin,
            0,
            0,
            aThird * OneMinusCos + aThirdSqtSin,
            cosine + aThird * OneMinusCos,
            aThird * OneMinusCos - aThirdSqtSin,
            0,
            0,
            aThird * OneMinusCos - aThirdSqtSin,
            aThird * OneMinusCos + aThirdSqtSin,
            cosine + aThird * OneMinusCos,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ];
    }
    isNeutralState() {
        return this.rotation === 0;
    }
    applyTo(options) {
        this.calculateMatrix();
        super.applyTo(options);
    }
    toObject() {
        return {
            type: this.type,
            rotation: this.rotation
        };
    }
}
/**
 * HueRotation value, from -1 to 1.
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$HueRotation, "type", 'HueRotation');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$HueRotation, "defaults", $f268b97836dca6b6$var$hueRotationDefaultValues);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$HueRotation);
const $f268b97836dca6b6$var$fragmentSource$4 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform int uInvert;\n  uniform int uAlpha;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    if (uInvert == 1) {\n      if (uAlpha == 1) {\n        gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,1.0 -color.a);\n      } else {\n        gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);\n      }\n    } else {\n      gl_FragColor = color;\n    }\n  }\n";
const $f268b97836dca6b6$var$invertDefaultValues = {
    alpha: false,
    invert: true
};
/**
 * @example
 * const filter = new Invert();
 * object.filters.push(filter);
 * object.applyFilters(canvas.renderAll.bind(canvas));
 */ class $f268b97836dca6b6$var$Invert extends $f268b97836dca6b6$var$BaseFilter {
    /**
   * Apply the Invert operation to a Uint8Array representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8Array to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        for(let i = 0; i < data.length; i += 4){
            data[i] = 255 - data[i];
            data[i + 1] = 255 - data[i + 1];
            data[i + 2] = 255 - data[i + 2];
            if (this.alpha) data[i + 3] = 255 - data[i + 3];
        }
    }
    getFragmentSource() {
        return $f268b97836dca6b6$var$fragmentSource$4;
    }
    /**
   * Invert filter isNeutralState implementation
   * Used only in image applyFilters to discard filters that will not have an effect
   * on the image
   * @param {Object} options
   **/ isNeutralState() {
        return !this.invert;
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform1i(uniformLocations.uInvert, Number(this.invert));
        gl.uniform1i(uniformLocations.uAlpha, Number(this.alpha));
    }
}
/**
 * Invert also alpha.
 * @param {Boolean} alpha
 * @default
 **/ /**
 * Filter invert. if false, does nothing
 * @param {Boolean} invert
 * @default
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Invert, "type", 'Invert');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Invert, "defaults", $f268b97836dca6b6$var$invertDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Invert, "uniformLocations", [
    'uInvert',
    'uAlpha'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$Invert);
const $f268b97836dca6b6$var$fragmentSource$3 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uStepH;\n  uniform float uNoise;\n  uniform float uSeed;\n  varying vec2 vTexCoord;\n  float rand(vec2 co, float seed, float vScale) {\n    return fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);\n  }\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    color.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;\n    gl_FragColor = color;\n  }\n";
const $f268b97836dca6b6$var$noiseDefaultValues = {
    noise: 0
};
/**
 * Noise filter class
 * @example
 * const filter = new Noise({
 *   noise: 700
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 */ class $f268b97836dca6b6$var$Noise extends $f268b97836dca6b6$var$BaseFilter {
    getFragmentSource() {
        return $f268b97836dca6b6$var$fragmentSource$3;
    }
    /**
   * Apply the Brightness operation to a Uint8ClampedArray representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        const noise = this.noise;
        for(let i = 0; i < data.length; i += 4){
            const rand = (0.5 - Math.random()) * noise;
            data[i] += rand;
            data[i + 1] += rand;
            data[i + 2] += rand;
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uNoise, this.noise / 255);
        gl.uniform1f(uniformLocations.uSeed, Math.random());
    }
    isNeutralState() {
        return this.noise === 0;
    }
}
/**
 * Noise value, from
 * @param {Number} noise
 * @default
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Noise, "type", 'Noise');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Noise, "defaults", $f268b97836dca6b6$var$noiseDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Noise, "uniformLocations", [
    'uNoise',
    'uSeed'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$Noise);
const $f268b97836dca6b6$var$fragmentSource$2 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uBlocksize;\n  uniform float uStepW;\n  uniform float uStepH;\n  varying vec2 vTexCoord;\n  void main() {\n    float blockW = uBlocksize * uStepW;\n    float blockH = uBlocksize * uStepH;\n    int posX = int(vTexCoord.x / blockW);\n    int posY = int(vTexCoord.y / blockH);\n    float fposX = float(posX);\n    float fposY = float(posY);\n    vec2 squareCoords = vec2(fposX * blockW, fposY * blockH);\n    vec4 color = texture2D(uTexture, squareCoords);\n    gl_FragColor = color;\n  }\n";
const $f268b97836dca6b6$var$pixelateDefaultValues = {
    blocksize: 4
};
/**
 * Pixelate filter class
 * @example
 * const filter = new Pixelate({
 *   blocksize: 8
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 */ class $f268b97836dca6b6$var$Pixelate extends $f268b97836dca6b6$var$BaseFilter {
    /**
   * Apply the Pixelate operation to a Uint8ClampedArray representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data, width: width, height: height } } = _ref;
        for(let i = 0; i < height; i += this.blocksize)for(let j = 0; j < width; j += this.blocksize){
            const index = i * 4 * width + j * 4;
            const r = data[index];
            const g = data[index + 1];
            const b = data[index + 2];
            const a = data[index + 3];
            for(let _i = i; _i < Math.min(i + this.blocksize, height); _i++)for(let _j = j; _j < Math.min(j + this.blocksize, width); _j++){
                const index = _i * 4 * width + _j * 4;
                data[index] = r;
                data[index + 1] = g;
                data[index + 2] = b;
                data[index + 3] = a;
            }
        }
    }
    /**
   * Indicate when the filter is not gonna apply changes to the image
   **/ isNeutralState() {
        return this.blocksize === 1;
    }
    getFragmentSource() {
        return $f268b97836dca6b6$var$fragmentSource$2;
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uBlocksize, this.blocksize);
    }
}
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Pixelate, "type", 'Pixelate');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Pixelate, "defaults", $f268b97836dca6b6$var$pixelateDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Pixelate, "uniformLocations", [
    'uBlocksize'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$Pixelate);
const $f268b97836dca6b6$var$fragmentShader = "\nprecision highp float;\nuniform sampler2D uTexture;\nuniform vec4 uLow;\nuniform vec4 uHigh;\nvarying vec2 vTexCoord;\nvoid main() {\n  gl_FragColor = texture2D(uTexture, vTexCoord);\n  if(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {\n    gl_FragColor.a = 0.0;\n  }\n}\n";
const $f268b97836dca6b6$var$removeColorDefaultValues = {
    color: '#FFFFFF',
    distance: 0.02,
    useAlpha: false
};
/**
 * Remove white filter class
 * @example
 * const filter = new RemoveColor({
 *   threshold: 0.2,
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 * canvas.renderAll();
 */ class $f268b97836dca6b6$var$RemoveColor extends $f268b97836dca6b6$var$BaseFilter {
    getFragmentSource() {
        return $f268b97836dca6b6$var$fragmentShader;
    }
    /**
   * Applies filter to canvas element
   * @param {Object} canvasEl Canvas element to apply filter to
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        const distance = this.distance * 255, source = new $f268b97836dca6b6$export$892596cec99bc70e(this.color).getSource(), lowC = [
            source[0] - distance,
            source[1] - distance,
            source[2] - distance
        ], highC = [
            source[0] + distance,
            source[1] + distance,
            source[2] + distance
        ];
        for(let i = 0; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            if (r > lowC[0] && g > lowC[1] && b > lowC[2] && r < highC[0] && g < highC[1] && b < highC[2]) data[i + 3] = 0;
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        const source = new $f268b97836dca6b6$export$892596cec99bc70e(this.color).getSource(), distance = this.distance, lowC = [
            0 + source[0] / 255 - distance,
            0 + source[1] / 255 - distance,
            0 + source[2] / 255 - distance,
            1
        ], highC = [
            source[0] / 255 + distance,
            source[1] / 255 + distance,
            source[2] / 255 + distance,
            1
        ];
        gl.uniform4fv(uniformLocations.uLow, lowC);
        gl.uniform4fv(uniformLocations.uHigh, highC);
    }
}
/**
 * Color to remove, in any format understood by {@link Color}.
 * @param {String} type
 * @default
 */ /**
 * distance to actual color, as value up or down from each r,g,b
 * between 0 and 1
 **/ /**
 * For color to remove inside distance, use alpha channel for a smoother deletion
 * NOT IMPLEMENTED YET
 **/ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$RemoveColor, "type", 'RemoveColor');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$RemoveColor, "defaults", $f268b97836dca6b6$var$removeColorDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$RemoveColor, "uniformLocations", [
    'uLow',
    'uHigh'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$RemoveColor);
const $f268b97836dca6b6$var$resizeDefaultValues = {
    resizeType: 'hermite',
    scaleX: 1,
    scaleY: 1,
    lanczosLobes: 3
};
/**
 * Resize image filter class
 * @example
 * const filter = new Resize();
 * object.filters.push(filter);
 * object.applyFilters(canvas.renderAll.bind(canvas));
 */ class $f268b97836dca6b6$var$Resize extends $f268b97836dca6b6$var$BaseFilter {
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform2fv(uniformLocations.uDelta, this.horizontal ? [
            1 / this.width,
            0
        ] : [
            0,
            1 / this.height
        ]);
        gl.uniform1fv(uniformLocations.uTaps, this.taps);
    }
    getFilterWindow() {
        const scale = this.tempScale;
        return Math.ceil(this.lanczosLobes / scale);
    }
    getCacheKey() {
        const filterWindow = this.getFilterWindow();
        return "".concat(this.type, "_").concat(filterWindow);
    }
    getFragmentSource() {
        const filterWindow = this.getFilterWindow();
        return this.generateShader(filterWindow);
    }
    getTaps() {
        const lobeFunction = this.lanczosCreate(this.lanczosLobes), scale = this.tempScale, filterWindow = this.getFilterWindow(), taps = new Array(filterWindow);
        for(let i = 1; i <= filterWindow; i++)taps[i - 1] = lobeFunction(i * scale);
        return taps;
    }
    /**
   * Generate vertex and shader sources from the necessary steps numbers
   * @param {Number} filterWindow
   */ generateShader(filterWindow) {
        const offsets = new Array(filterWindow);
        for(let i = 1; i <= filterWindow; i++)offsets[i - 1] = "".concat(i, ".0 * uDelta");
        return "\n      precision highp float;\n      uniform sampler2D uTexture;\n      uniform vec2 uDelta;\n      varying vec2 vTexCoord;\n      uniform float uTaps[".concat(filterWindow, "];\n      void main() {\n        vec4 color = texture2D(uTexture, vTexCoord);\n        float sum = 1.0;\n        ").concat(offsets.map((offset, i)=>"\n              color += texture2D(uTexture, vTexCoord + ".concat(offset, ") * uTaps[").concat(i, "] + texture2D(uTexture, vTexCoord - ").concat(offset, ") * uTaps[").concat(i, "];\n              sum += 2.0 * uTaps[").concat(i, "];\n            ")).join('\n'), "\n        gl_FragColor = color / sum;\n      }\n    ");
    }
    applyToForWebgl(options) {
        options.passes++;
        this.width = options.sourceWidth;
        this.horizontal = true;
        this.dW = Math.round(this.width * this.scaleX);
        this.dH = options.sourceHeight;
        this.tempScale = this.dW / this.width;
        this.taps = this.getTaps();
        options.destinationWidth = this.dW;
        super.applyTo(options);
        options.sourceWidth = options.destinationWidth;
        this.height = options.sourceHeight;
        this.horizontal = false;
        this.dH = Math.round(this.height * this.scaleY);
        this.tempScale = this.dH / this.height;
        this.taps = this.getTaps();
        options.destinationHeight = this.dH;
        super.applyTo(options);
        options.sourceHeight = options.destinationHeight;
    }
    /**
   * Apply the resize filter to the image
   * Determines whether to use WebGL or Canvas2D based on the options.webgl flag.
   *
   * @param {Object} options
   * @param {Number} options.passes The number of filters remaining to be executed
   * @param {Boolean} options.webgl Whether to use webgl to render the filter.
   * @param {WebGLTexture} options.sourceTexture The texture setup as the source to be filtered.
   * @param {WebGLTexture} options.targetTexture The texture where filtered output should be drawn.
   * @param {WebGLRenderingContext} options.context The GL context used for rendering.
   * @param {Object} options.programCache A map of compiled shader programs, keyed by filter type.
   */ applyTo(options) {
        if ($f268b97836dca6b6$export$ec9091584da1706b(options)) this.applyToForWebgl(options);
        else this.applyTo2d(options);
    }
    isNeutralState() {
        return this.scaleX === 1 && this.scaleY === 1;
    }
    lanczosCreate(lobes) {
        return (x)=>{
            if (x >= lobes || x <= -lobes) return 0.0;
            if (x < 1.1920929e-7 && x > -0.00000011920929) return 1.0;
            x *= Math.PI;
            const xx = x / lobes;
            return Math.sin(x) / x * Math.sin(xx) / xx;
        };
    }
    applyTo2d(options) {
        const imageData = options.imageData, scaleX = this.scaleX, scaleY = this.scaleY;
        this.rcpScaleX = 1 / scaleX;
        this.rcpScaleY = 1 / scaleY;
        const oW = imageData.width;
        const oH = imageData.height;
        const dW = Math.round(oW * scaleX);
        const dH = Math.round(oH * scaleY);
        let newData;
        if (this.resizeType === 'sliceHack') newData = this.sliceByTwo(options, oW, oH, dW, dH);
        else if (this.resizeType === 'hermite') newData = this.hermiteFastResize(options, oW, oH, dW, dH);
        else if (this.resizeType === 'bilinear') newData = this.bilinearFiltering(options, oW, oH, dW, dH);
        else if (this.resizeType === 'lanczos') newData = this.lanczosResize(options, oW, oH, dW, dH);
        else // this should never trigger, is here just for safety net.
        newData = new ImageData(dW, dH);
        options.imageData = newData;
    }
    /**
   * Filter sliceByTwo
   * @param {Object} canvasEl Canvas element to apply filter to
   * @param {Number} oW Original Width
   * @param {Number} oH Original Height
   * @param {Number} dW Destination Width
   * @param {Number} dH Destination Height
   * @returns {ImageData}
   */ sliceByTwo(options, oW, oH, dW, dH) {
        const imageData = options.imageData;
        const mult = 0.5;
        let doneW = false;
        let doneH = false;
        let stepW = oW * mult;
        let stepH = oH * mult;
        const resources = options.filterBackend.resources;
        let sX = 0;
        let sY = 0;
        const dX = oW;
        let dY = 0;
        if (!resources.sliceByTwo) resources.sliceByTwo = $f268b97836dca6b6$var$createCanvasElement();
        const tmpCanvas = resources.sliceByTwo;
        if (tmpCanvas.width < oW * 1.5 || tmpCanvas.height < oH) {
            tmpCanvas.width = oW * 1.5;
            tmpCanvas.height = oH;
        }
        const ctx = tmpCanvas.getContext('2d');
        ctx.clearRect(0, 0, oW * 1.5, oH);
        ctx.putImageData(imageData, 0, 0);
        dW = Math.floor(dW);
        dH = Math.floor(dH);
        while(!doneW || !doneH){
            oW = stepW;
            oH = stepH;
            if (dW < Math.floor(stepW * mult)) stepW = Math.floor(stepW * mult);
            else {
                stepW = dW;
                doneW = true;
            }
            if (dH < Math.floor(stepH * mult)) stepH = Math.floor(stepH * mult);
            else {
                stepH = dH;
                doneH = true;
            }
            ctx.drawImage(tmpCanvas, sX, sY, oW, oH, dX, dY, stepW, stepH);
            sX = dX;
            sY = dY;
            dY += stepH;
        }
        return ctx.getImageData(sX, sY, dW, dH);
    }
    /**
   * Filter lanczosResize
   * @param {Object} canvasEl Canvas element to apply filter to
   * @param {Number} oW Original Width
   * @param {Number} oH Original Height
   * @param {Number} dW Destination Width
   * @param {Number} dH Destination Height
   * @returns {ImageData}
   */ lanczosResize(options, oW, oH, dW, dH) {
        function process(u) {
            let v, i, weight, idx, a, red, green, blue, alpha, fX, fY;
            center.x = (u + 0.5) * ratioX;
            icenter.x = Math.floor(center.x);
            for(v = 0; v < dH; v++){
                center.y = (v + 0.5) * ratioY;
                icenter.y = Math.floor(center.y);
                a = 0;
                red = 0;
                green = 0;
                blue = 0;
                alpha = 0;
                for(i = icenter.x - range2X; i <= icenter.x + range2X; i++){
                    if (i < 0 || i >= oW) continue;
                    fX = Math.floor(1000 * Math.abs(i - center.x));
                    if (!cacheLanc[fX]) cacheLanc[fX] = {};
                    for(let j = icenter.y - range2Y; j <= icenter.y + range2Y; j++){
                        if (j < 0 || j >= oH) continue;
                        fY = Math.floor(1000 * Math.abs(j - center.y));
                        if (!cacheLanc[fX][fY]) cacheLanc[fX][fY] = lanczos(Math.sqrt(Math.pow(fX * rcpRatioX, 2) + Math.pow(fY * rcpRatioY, 2)) / 1000);
                        weight = cacheLanc[fX][fY];
                        if (weight > 0) {
                            idx = (j * oW + i) * 4;
                            a += weight;
                            red += weight * srcData[idx];
                            green += weight * srcData[idx + 1];
                            blue += weight * srcData[idx + 2];
                            alpha += weight * srcData[idx + 3];
                        }
                    }
                }
                idx = (v * dW + u) * 4;
                destData[idx] = red / a;
                destData[idx + 1] = green / a;
                destData[idx + 2] = blue / a;
                destData[idx + 3] = alpha / a;
            }
            if (++u < dW) return process(u);
            else return destImg;
        }
        const srcData = options.imageData.data, destImg = options.ctx.createImageData(dW, dH), destData = destImg.data, lanczos = this.lanczosCreate(this.lanczosLobes), ratioX = this.rcpScaleX, ratioY = this.rcpScaleY, rcpRatioX = 2 / this.rcpScaleX, rcpRatioY = 2 / this.rcpScaleY, range2X = Math.ceil(ratioX * this.lanczosLobes / 2), range2Y = Math.ceil(ratioY * this.lanczosLobes / 2), cacheLanc = {}, center = {
            x: 0,
            y: 0
        }, icenter = {
            x: 0,
            y: 0
        };
        return process(0);
    }
    /**
   * bilinearFiltering
   * @param {Object} canvasEl Canvas element to apply filter to
   * @param {Number} oW Original Width
   * @param {Number} oH Original Height
   * @param {Number} dW Destination Width
   * @param {Number} dH Destination Height
   * @returns {ImageData}
   */ bilinearFiltering(options, oW, oH, dW, dH) {
        let a;
        let b;
        let c;
        let d;
        let x;
        let y;
        let i;
        let j;
        let xDiff;
        let yDiff;
        let chnl;
        let color;
        let offset = 0;
        let origPix;
        const ratioX = this.rcpScaleX;
        const ratioY = this.rcpScaleY;
        const w4 = 4 * (oW - 1);
        const img = options.imageData;
        const pixels = img.data;
        const destImage = options.ctx.createImageData(dW, dH);
        const destPixels = destImage.data;
        for(i = 0; i < dH; i++)for(j = 0; j < dW; j++){
            x = Math.floor(ratioX * j);
            y = Math.floor(ratioY * i);
            xDiff = ratioX * j - x;
            yDiff = ratioY * i - y;
            origPix = 4 * (y * oW + x);
            for(chnl = 0; chnl < 4; chnl++){
                a = pixels[origPix + chnl];
                b = pixels[origPix + 4 + chnl];
                c = pixels[origPix + w4 + chnl];
                d = pixels[origPix + w4 + 4 + chnl];
                color = a * (1 - xDiff) * (1 - yDiff) + b * xDiff * (1 - yDiff) + c * yDiff * (1 - xDiff) + d * xDiff * yDiff;
                destPixels[offset++] = color;
            }
        }
        return destImage;
    }
    /**
   * hermiteFastResize
   * @param {Object} canvasEl Canvas element to apply filter to
   * @param {Number} oW Original Width
   * @param {Number} oH Original Height
   * @param {Number} dW Destination Width
   * @param {Number} dH Destination Height
   * @returns {ImageData}
   */ hermiteFastResize(options, oW, oH, dW, dH) {
        const ratioW = this.rcpScaleX, ratioH = this.rcpScaleY, ratioWHalf = Math.ceil(ratioW / 2), ratioHHalf = Math.ceil(ratioH / 2), img = options.imageData, data = img.data, img2 = options.ctx.createImageData(dW, dH), data2 = img2.data;
        for(let j = 0; j < dH; j++)for(let i = 0; i < dW; i++){
            const x2 = (i + j * dW) * 4;
            let weight = 0;
            let weights = 0;
            let weightsAlpha = 0;
            let gxR = 0;
            let gxG = 0;
            let gxB = 0;
            let gxA = 0;
            const centerY = (j + 0.5) * ratioH;
            for(let yy = Math.floor(j * ratioH); yy < (j + 1) * ratioH; yy++){
                const dy = Math.abs(centerY - (yy + 0.5)) / ratioHHalf, centerX = (i + 0.5) * ratioW, w0 = dy * dy;
                for(let xx = Math.floor(i * ratioW); xx < (i + 1) * ratioW; xx++){
                    let dx = Math.abs(centerX - (xx + 0.5)) / ratioWHalf;
                    const w = Math.sqrt(w0 + dx * dx);
                    /* eslint-disable max-depth */ if (w > 1 && w < -1) continue;
                    //hermite filter
                    weight = 2 * w * w * w - 3 * w * w + 1;
                    if (weight > 0) {
                        dx = 4 * (xx + yy * oW);
                        //alpha
                        gxA += weight * data[dx + 3];
                        weightsAlpha += weight;
                        //colors
                        if (data[dx + 3] < 255) weight = weight * data[dx + 3] / 250;
                        gxR += weight * data[dx];
                        gxG += weight * data[dx + 1];
                        gxB += weight * data[dx + 2];
                        weights += weight;
                    }
                /* eslint-enable max-depth */ }
            }
            data2[x2] = gxR / weights;
            data2[x2 + 1] = gxG / weights;
            data2[x2 + 2] = gxB / weights;
            data2[x2 + 3] = gxA / weightsAlpha;
        }
        return img2;
    }
}
/**
 * Resize type
 * for webgl resizeType is just lanczos, for canvas2d can be:
 * bilinear, hermite, sliceHack, lanczos.
 * @default
 */ /**
 * Scale factor for resizing, x axis
 * @param {Number} scaleX
 * @default
 */ /**
 * Scale factor for resizing, y axis
 * @param {Number} scaleY
 * @default
 */ /**
 * LanczosLobes parameter for lanczos filter, valid for resizeType lanczos
 * @param {Number} lanczosLobes
 * @default
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Resize, "type", 'Resize');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Resize, "defaults", $f268b97836dca6b6$var$resizeDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Resize, "uniformLocations", [
    'uDelta',
    'uTaps'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$Resize);
const $f268b97836dca6b6$var$fragmentSource$1 = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uSaturation;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    float rgMax = max(color.r, color.g);\n    float rgbMax = max(rgMax, color.b);\n    color.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;\n    color.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;\n    color.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;\n    gl_FragColor = color;\n  }\n";
const $f268b97836dca6b6$var$saturationDefaultValues = {
    saturation: 0
};
/**
 * Saturate filter class
 * @example
 * const filter = new Saturation({
 *   saturation: 1
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 */ class $f268b97836dca6b6$var$Saturation extends $f268b97836dca6b6$var$BaseFilter {
    getFragmentSource() {
        return $f268b97836dca6b6$var$fragmentSource$1;
    }
    /**
   * Apply the Saturation operation to a Uint8ClampedArray representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        const adjust = -this.saturation;
        for(let i = 0; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            const max = Math.max(r, g, b);
            data[i] += max !== r ? (max - r) * adjust : 0;
            data[i + 1] += max !== g ? (max - g) * adjust : 0;
            data[i + 2] += max !== b ? (max - b) * adjust : 0;
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {Object} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uSaturation, -this.saturation);
    }
    isNeutralState() {
        return this.saturation === 0;
    }
}
/**
 * Saturation value, from -1 to 1.
 * Increases/decreases the color saturation.
 * A value of 0 has no effect.
 *
 * @param {Number} saturation
 * @default
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Saturation, "type", 'Saturation');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Saturation, "defaults", $f268b97836dca6b6$var$saturationDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Saturation, "uniformLocations", [
    'uSaturation'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$Saturation);
const $f268b97836dca6b6$var$fragmentSource = "\n  precision highp float;\n  uniform sampler2D uTexture;\n  uniform float uVibrance;\n  varying vec2 vTexCoord;\n  void main() {\n    vec4 color = texture2D(uTexture, vTexCoord);\n    float max = max(color.r, max(color.g, color.b));\n    float avg = (color.r + color.g + color.b) / 3.0;\n    float amt = (abs(max - avg) * 2.0) * uVibrance;\n    color.r += max != color.r ? (max - color.r) * amt : 0.00;\n    color.g += max != color.g ? (max - color.g) * amt : 0.00;\n    color.b += max != color.b ? (max - color.b) * amt : 0.00;\n    gl_FragColor = color;\n  }\n";
const $f268b97836dca6b6$var$vibranceDefaultValues = {
    vibrance: 0
};
/**
 * Vibrance filter class
 * @example
 * const filter = new Vibrance({
 *   vibrance: 1
 * });
 * object.filters.push(filter);
 * object.applyFilters();
 */ class $f268b97836dca6b6$var$Vibrance extends $f268b97836dca6b6$var$BaseFilter {
    getFragmentSource() {
        return $f268b97836dca6b6$var$fragmentSource;
    }
    /**
   * Apply the Vibrance operation to a Uint8ClampedArray representing the pixels of an image.
   *
   * @param {Object} options
   * @param {ImageData} options.imageData The Uint8ClampedArray to be filtered.
   */ applyTo2d(_ref) {
        let { imageData: { data: data } } = _ref;
        const adjust = -this.vibrance;
        for(let i = 0; i < data.length; i += 4){
            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            const max = Math.max(r, g, b);
            const avg = (r + g + b) / 3;
            const amt = Math.abs(max - avg) * 2 / 255 * adjust;
            data[i] += max !== r ? (max - r) * amt : 0;
            data[i + 1] += max !== g ? (max - g) * amt : 0;
            data[i + 2] += max !== b ? (max - b) * amt : 0;
        }
    }
    /**
   * Send data from this filter to its shader program's uniforms.
   *
   * @param {WebGLRenderingContext} gl The GL canvas context used to compile this filter's shader.
   * @param {TWebGLUniformLocationMap} uniformLocations A map of string uniform names to WebGLUniformLocation objects
   */ sendUniformData(gl, uniformLocations) {
        gl.uniform1f(uniformLocations.uVibrance, -this.vibrance);
    }
    isNeutralState() {
        return this.vibrance === 0;
    }
}
/**
 * Vibrance value, from -1 to 1.
 * Increases/decreases the saturation of more muted colors with less effect on saturated colors.
 * A value of 0 has no effect.
 *
 * @param {Number} vibrance
 * @default
 */ $f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Vibrance, "type", 'Vibrance');
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Vibrance, "defaults", $f268b97836dca6b6$var$vibranceDefaultValues);
$f268b97836dca6b6$var$_defineProperty($f268b97836dca6b6$var$Vibrance, "uniformLocations", [
    'uVibrance'
]);
$f268b97836dca6b6$export$2792378e23a7920c.setClass($f268b97836dca6b6$var$Vibrance);
var $f268b97836dca6b6$export$82462a21aead86ed = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BaseFilter: $f268b97836dca6b6$var$BaseFilter,
    BlackWhite: $f268b97836dca6b6$var$BlackWhite,
    BlendColor: $f268b97836dca6b6$var$BlendColor,
    BlendImage: $f268b97836dca6b6$var$BlendImage,
    Blur: $f268b97836dca6b6$var$Blur,
    Brightness: $f268b97836dca6b6$var$Brightness,
    Brownie: $f268b97836dca6b6$var$Brownie,
    ColorMatrix: $f268b97836dca6b6$var$ColorMatrix,
    Composed: $f268b97836dca6b6$var$Composed,
    Contrast: $f268b97836dca6b6$var$Contrast,
    Convolute: $f268b97836dca6b6$var$Convolute,
    Gamma: $f268b97836dca6b6$var$Gamma,
    Grayscale: $f268b97836dca6b6$var$Grayscale,
    HueRotation: $f268b97836dca6b6$var$HueRotation,
    Invert: $f268b97836dca6b6$var$Invert,
    Kodachrome: $f268b97836dca6b6$var$Kodachrome,
    Noise: $f268b97836dca6b6$var$Noise,
    Pixelate: $f268b97836dca6b6$var$Pixelate,
    Polaroid: $f268b97836dca6b6$var$Polaroid,
    RemoveColor: $f268b97836dca6b6$var$RemoveColor,
    Resize: $f268b97836dca6b6$var$Resize,
    Saturation: $f268b97836dca6b6$var$Saturation,
    Sepia: $f268b97836dca6b6$var$Sepia,
    Technicolor: $f268b97836dca6b6$var$Technicolor,
    Vibrance: $f268b97836dca6b6$var$Vibrance,
    Vintage: $f268b97836dca6b6$var$Vintage
});



const $71b5b71c2777aff7$var$RightOperationBoard = ({ quaters: quaters, width: width, height: height, onQuaterUpdate: onQuaterUpdate })=>{
    const canvasRef = (0, $7fPBF.useRef)(null);
    const fabricRef = (0, $7fPBF.useRef)(null);
    const randomInt = (min, max)=>Math.floor(Math.random() * (max - min + 1)) + min;
    const getBasePositionByPosition1 = (position, index)=>{
        let baseX = 20;
        let baseY = height / 2;
        if (position === 'GK') {
            baseY = height - height / 12;
            baseX = width / 2 - 20;
        } else if (position === 'CF') baseY = height / 4;
        else if (position === 'WF') baseY = height / 3;
        else if (position === 'MF') baseY = height / 2;
        else if (position === 'SB') baseY = height - height / 3;
        else if (position === 'CB') baseY = height - height / 4;
        return {
            x: position === 'GK' ? baseX : baseX + index * 15,
            y: baseY
        };
    };
    /** 1️⃣ 초기 캔버스 생성 */ (0, $7fPBF.useEffect)(()=>{
        if (!canvasRef.current) return;
        const canvas = new $f268b97836dca6b6$export$8d01c972ee8b14a9(canvasRef.current, {
            width: width,
            height: height,
            backgroundColor: '#15803d',
            // 잔디
            selection: false
        });
        fabricRef.current = canvas;
        drawField(canvas);
        return ()=>{
            canvas.dispose();
            fabricRef.current = null;
        };
    }, []);
    /** 2️⃣ width / height 변경 시 캔버스 리사이즈 */ (0, $7fPBF.useEffect)(()=>{
        if (!fabricRef.current) return;
        const canvas = fabricRef.current;
        canvas.setWidth(width);
        canvas.setHeight(height);
        canvas.clear();
        canvas.backgroundColor = '#15803d';
        drawField(canvas);
        quaters.forEach(addPlayer);
        canvas.renderAll();
    }, [
        width,
        height
    ]);
    /** 3️⃣ quaters 변경 시 선수 다시 그림 */ (0, $7fPBF.useEffect)(()=>{
        if (!fabricRef.current) return;
        const canvas = fabricRef.current;
        canvas.getObjects('group').forEach((o)=>canvas.remove(o));
        quaters.forEach(addPlayer);
        canvas.renderAll();
    }, [
        quaters
    ]);
    /** ⚽ 축구장 */ const drawField = (canvas)=>{
        const goalWidth = width / 4;
        const goalHeight = height / 15;
        canvas.add(new $f268b97836dca6b6$export$c79fc6492f3af13d({
            left: 5,
            top: 5,
            width: width - 10,
            height: height - 10,
            stroke: 'white',
            strokeWidth: 4,
            fill: 'transparent',
            selectable: false,
            evented: false
        }), new $f268b97836dca6b6$export$17d680238e50603e([
            5,
            height / 2,
            width - 5,
            height / 2
        ], {
            stroke: 'white',
            strokeWidth: 2,
            selectable: false,
            evented: false
        }), new $f268b97836dca6b6$export$c89a927ffc67e6fa({
            left: width / 2 - 50,
            top: height / 2 - 50,
            radius: 50,
            stroke: 'white',
            strokeWidth: 3,
            fill: 'transparent',
            selectable: false,
            evented: false
        }), /** 🥅 상단 골대 */ new $f268b97836dca6b6$export$c79fc6492f3af13d({
            left: width / 2 - goalWidth / 2,
            top: 5,
            width: goalWidth,
            height: goalHeight,
            stroke: 'white',
            strokeWidth: 3,
            fill: 'transparent',
            selectable: false,
            evented: false
        }), /** 🥅 하단 골대 */ new $f268b97836dca6b6$export$c79fc6492f3af13d({
            left: width / 2 - goalWidth / 2,
            top: height - goalHeight - 5,
            width: goalWidth,
            height: goalHeight,
            stroke: 'white',
            strokeWidth: 3,
            fill: 'transparent',
            selectable: false,
            evented: false
        }));
    };
    /** 👕 선수 추가 */ const addPlayer = (q)=>{
        const index = quaters.findIndex((item)=>item.id === q.id);
        if (!fabricRef.current) return;
        const canvas = fabricRef.current;
        const color = q.playerTeamABType === 'A' ? q.status === "\uAD50\uCCB4" ? 'yellow' : '#ef4444' : q.status === "\uAD50\uCCB4" ? 'yellow' : '#2563eb';
        const circle = new $f268b97836dca6b6$export$c89a927ffc67e6fa({
            radius: 23,
            fill: color,
            originX: 'center',
            originY: 'center'
        });
        const label = new $f268b97836dca6b6$export$72cf63a35cb577f7(`${q.playerName}\n${q.playerPosition1}${q.playerPosition2 ? `/${q.playerPosition2}` : ''}`, {
            fontSize: 14,
            fontWeight: 700,
            fill: 'black',
            textAlign: 'center',
            originX: 'center',
            originY: 'center',
            top: 0
        });
        const basePos = q.pointX != null && q.pointY != null ? {
            x: percentToPxX(q.pointX),
            y: percentToPxY(q.pointY)
        } : getBasePositionByPosition1(q.playerPosition1, index);
        const group = new $f268b97836dca6b6$export$eb2fcfdbd7ba97d4([
            circle,
            label
        ], {
            left: basePos.x,
            top: basePos.y,
            hasControls: false,
            lockScalingX: true,
            lockScalingY: true
        });
        /** 드래그 후 위치 저장 */ group.on('mouseup', async ()=>{
            const { left: left, top: top } = group;
            if (left == null || top == null) return;
            await (0, $b1b7259e07d8b034$export$2e2bcd8739ae039).updateQuater(q.id, {
                status: q.status,
                pointX: pxToPercentX(Math.round(left)),
                pointY: pxToPercenY(Math.round(top))
            });
            const updatedQuater = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, q), {
                pointX: pxToPercentX(Math.round(left)),
                pointY: pxToPercenY(Math.round(top))
            });
            onQuaterUpdate(updatedQuater);
        });
        canvas.add(group);
    };
    /** px → % */ const pxToPercentX = (x)=>{
        return +(x / width * 100).toFixed(2);
    };
    const pxToPercenY = (y)=>{
        return +(y / height * 100).toFixed(2);
    };
    /** % → px */ const percentToPxX = (xRate)=>{
        return Math.round(xRate / 100 * width);
    };
    const percentToPxY = (yRate)=>{
        return Math.round(yRate / 100 * height);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)("canvas", {
        ref: canvasRef,
        style: {
            display: 'block'
        }
    });
};
var $71b5b71c2777aff7$export$2e2bcd8739ae039 = $71b5b71c2777aff7$var$RightOperationBoard;


const $a4f26e7bbe06b45e$var$QUARTERS = [
    1,
    2,
    3,
    4
];
const $a4f26e7bbe06b45e$var$STATUS_ORDER = [
    "\uCD9C\uC804",
    "\uAD50\uCCB4",
    "\uD734\uC2DD"
];
const $a4f26e7bbe06b45e$var$OperationTab = ({ game: game })=>{
    const isSelfGame = game.type === "\uC790\uCCB4\uC804";
    const [collapsed, setCollapsed] = (0, $7fPBF.useState)(false);
    const [selectedQuarter, setSelectedQuarter] = (0, $7fPBF.useState)(1);
    const [team, setTeam] = (0, $7fPBF.useState)('A');
    const [quaters, setQuaters] = (0, $7fPBF.useState)([]);
    const [rightQuaters, setRightQuaters] = (0, $7fPBF.useState)([]);
    const rightRef = (0, $7fPBF.useRef)(null);
    const [rightSize, setRightSize] = (0, $7fPBF.useState)({
        width: 0,
        height: 0
    });
    const teamName = localStorage.getItem('TEAM_NAME');
    const POSITIONS = [
        'CF',
        'WF',
        'MF',
        'CB',
        'SB',
        'GK'
    ];
    const getPositionOrder = (pos)=>{
        const idx = POSITIONS.indexOf(pos);
        return idx === -1 ? POSITIONS.length : idx;
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!game.id) return;
        (0, $b1b7259e07d8b034$export$2e2bcd8739ae039).getQuatersByGame(game.id).then(setQuaters);
    }, [
        game.id
    ]);
    /** 플레이어 기준으로 그룹핑 */ const groupedByPlayer = (0, $7fPBF.useMemo)(()=>{
        const map = new Map();
        quaters.forEach((q)=>{
            if (isSelfGame && q.playerTeamABType !== team) return;
            if (!map.has(q.playerId)) map.set(q.playerId, []);
            map.get(q.playerId).push(q);
        });
        // 쿼터 번호 정렬
        map.forEach((list)=>list.sort((a, b)=>a.quarterNo - b.quarterNo));
        return Array.from(map.values()).sort((a, b)=>{
            const aBase = a[0];
            const bBase = b[0];
            // 1️⃣ 포지션1 기준 정렬
            const posDiff = getPositionOrder(aBase.playerPosition1) - getPositionOrder(bBase.playerPosition1);
            if (posDiff !== 0) return posDiff;
            // 2️⃣ 같은 포지션이면 이름순 (선택)
            return aBase.playerName.localeCompare(bBase.playerName);
        });
    }, [
        quaters,
        team,
        isSelfGame
    ]);
    /** 선택된 쿼터만 상태 변경 */ const toggleStatus = async (q)=>{
        const next = $a4f26e7bbe06b45e$var$STATUS_ORDER[($a4f26e7bbe06b45e$var$STATUS_ORDER.indexOf(q.status) + 1) % $a4f26e7bbe06b45e$var$STATUS_ORDER.length];
        const updated = await (0, $b1b7259e07d8b034$export$2e2bcd8739ae039).updateQuater(q.id, {
            status: next,
            pointX: q.pointX,
            pointY: q.pointY
        });
        setQuaters((prev)=>prev.map((it)=>it.id === updated.id ? updated : it));
    };
    const onClickPlayerName = (playerQuaters)=>{
        const target = playerQuaters.find((q)=>q.quarterNo === selectedQuarter);
        if (!target) return;
        toggleStatus(target);
    };
    const teamStats = (0, $7fPBF.useMemo)(()=>{
        const filtered = quaters.filter((q)=>q.quarterNo === selectedQuarter && (!isSelfGame || q.playerTeamABType === team));
        const uniquePlayers = new Set(filtered.map((q)=>q.playerId)).size;
        const playCount = filtered.filter((q)=>q.status === "\uCD9C\uC804").length;
        const subCount = filtered.filter((q)=>q.status === "\uAD50\uCCB4").length;
        return {
            participants: uniquePlayers,
            playCount: playCount,
            subCount: subCount
        };
    }, [
        quaters,
        selectedQuarter,
        team,
        isSelfGame
    ]);
    const handleQuaterUpdate = (updated)=>{
        setQuaters((prev)=>prev.map((q)=>q.id === updated.id ? updated : q));
    };
    (0, $7fPBF.useEffect)(()=>{
        const filtered = quaters.filter((q)=>q.quarterNo === selectedQuarter && (q.status === "\uCD9C\uC804" || q.status === "\uAD50\uCCB4") && (!isSelfGame || q.playerTeamABType === team));
        setRightQuaters(filtered);
    }, [
        quaters,
        selectedQuarter,
        team,
        isSelfGame
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!rightRef.current) return;
        const observer = new ResizeObserver((entries)=>{
            const entry = entries[0];
            const { width: width, height: height } = entry.contentRect;
            setRightSize({
                width: Math.floor(width),
                height: Math.floor(height)
            });
        });
        observer.observe(rightRef.current);
        return ()=>observer.disconnect();
    }, []);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: 'quater',
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                sx: {
                    width: collapsed ? '10%' : '80%',
                    transition: 'width 0.3s',
                    position: 'relative',
                    borderRight: '1px solid #24cbaa',
                    display: 'flex',
                    flexDirection: 'column'
                },
                children: [
                    !collapsed && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                sx: {
                                    p: 1,
                                    display: 'flex',
                                    gap: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                        size: "small",
                                        value: selectedQuarter,
                                        onChange: (e)=>setSelectedQuarter(e.target.value),
                                        children: $a4f26e7bbe06b45e$var$QUARTERS.map((q)=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                value: q,
                                                children: [
                                                    q,
                                                    "Q"
                                                ]
                                            }, q))
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                        size: "small",
                                        value: team,
                                        onChange: (e)=>setTeam(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                value: "A",
                                                children: isSelfGame ? 'A Team' : teamName
                                            }),
                                            isSelfGame && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                                value: "B",
                                                children: "B Team "
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                        className: 'teamStats-playCount',
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                children: teamStats.playCount + teamStats.subCount * 0.5
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                children: "/"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                children: teamStats.participants
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                                className: 'quater-list',
                                children: groupedByPlayer.map((playerQuaters)=>{
                                    const base = playerQuaters[0];
                                    // quarterNo → quater 매핑
                                    const qMap = new Map(playerQuaters.map((q)=>[
                                            q.quarterNo,
                                            q
                                        ]));
                                    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                        className: 'quater-list-item',
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                onClick: ()=>onClickPlayerName(playerQuaters),
                                                className: 'quater-name',
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                        className: `quater-name-info ${!base.playerMemberId ? 'mercenary-position' : ''}`,
                                                        style: {
                                                            marginRight: '3px'
                                                        },
                                                        children: base.playerName
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                        className: 'position',
                                                        style: {
                                                            marginRight: '10px'
                                                        },
                                                        children: [
                                                            base.playerPosition1,
                                                            base.playerPosition2 && ` / ${base.playerPosition2}`
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                className: "quater-item",
                                                children: [
                                                    1,
                                                    2,
                                                    3,
                                                    4
                                                ].map((qNo)=>{
                                                    const q = qMap.get(qNo);
                                                    if (!q) return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {}, qNo);
                                                    const isActive = qNo === selectedQuarter;
                                                    const statusColorMap = {
                                                        \uCD9C\uC804: 'play',
                                                        \uAD50\uCCB4: 'sub',
                                                        \uD734\uC2DD: 'rest'
                                                    };
                                                    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                        className: `quater-status
                                                                    ${statusColorMap[q.status]}
                                                                    ${!isActive ? 'inactive' : 'active'}
                                                                `,
                                                        children: isActive ? q.status : /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                            className: "status-dot",
                                                            children: "\u25CF"
                                                        })
                                                    }, q.id);
                                                })
                                            })
                                        ]
                                    }, base.playerId);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        onClick: ()=>setCollapsed(!collapsed),
                        className: 'collapse-button',
                        children: collapsed ? "\u25B6" : "\u25C0"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                ref: rightRef,
                className: "quater-right",
                style: {
                    pointerEvents: collapsed ? 'auto' : 'none',
                    opacity: collapsed ? 1 : 0.1,
                    zIndex: collapsed ? 2 : 0,
                    position: 'relative',
                    transition: 'opacity 0.2s ease'
                },
                children: rightSize.width > 0 && rightSize.height > 0 && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $71b5b71c2777aff7$export$2e2bcd8739ae039), {
                    quaters: rightQuaters,
                    width: rightSize.width,
                    height: rightSize.height,
                    onQuaterUpdate: handleQuaterUpdate
                })
            })
        ]
    });
};
var $a4f26e7bbe06b45e$export$2e2bcd8739ae039 = $a4f26e7bbe06b45e$var$OperationTab;


const $00dbfe3007fdc781$var$GameDetail = (props)=>{
    const handleOverlayClick = (0, $7fPBF.useCallback)(()=>props.onClose(), [
        props.onClose
    ]);
    const handleReturnClick = (0, $7fPBF.useCallback)(()=>{
        props.onReturn();
    }, [
        props.onReturn
    ]);
    const [tabIndex, setTabIndex] = (0, $7fPBF.useState)(0);
    const handleChange = (_, newValue)=>{
        setTabIndex(newValue);
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5f47bfd43cc47d77$export$2e2bcd8739ae039), {
                title: "Match",
                onClose: handleOverlayClick,
                leftIcon: 'prev-w w-8 w-17'
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "game-detail",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4ac626799ed465c3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $c45f613599c3205d$export$2e2bcd8739ae039), {
                        value: tabIndex,
                        onChange: handleChange,
                        variant: "fullWidth",
                        className: "game-detail-tabs",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b2a8111cea006e88$export$2e2bcd8739ae039), {
                                label: "Match"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b2a8111cea006e88$export$2e2bcd8739ae039), {
                                label: "\uCC38\uAC00\uC790"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b2a8111cea006e88$export$2e2bcd8739ae039), {
                                label: "\uC791\uC804\uD310"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b2a8111cea006e88$export$2e2bcd8739ae039), {
                                label: "\uACB0\uACFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        className: "game-detail-content",
                        children: [
                            tabIndex === 0 && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $888f0a95330227fe$export$2e2bcd8739ae039), {
                                    game: props.game,
                                    onClose: props.onClose,
                                    onReturn: handleReturnClick
                                })
                            }),
                            tabIndex === 1 && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $56417fab94697bb2$export$2e2bcd8739ae039), {
                                    game: props.game
                                })
                            }),
                            tabIndex === 2 && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a4f26e7bbe06b45e$export$2e2bcd8739ae039), {
                                    game: props.game
                                })
                            }),
                            tabIndex === 3 && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9037145f40acf490$export$2e2bcd8739ae039), {
                                    game: props.game,
                                    onClose: props.onClose,
                                    onReturn: handleReturnClick
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $00dbfe3007fdc781$export$2e2bcd8739ae039 = $00dbfe3007fdc781$var$GameDetail;


const $5035db66448631e7$var$GameListItem = (props)=>{
    const handleReturnClick = (0, $7fPBF.useCallback)(()=>{
        props.onReturn();
    }, [
        props.onReturn
    ]);
    const [openDetail, setOpenDetail] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                className: "game-list-item b2_r mt-12px",
                onClick: ()=>setOpenDetail(true),
                sx: {
                    cursor: props.onClick ? "pointer" : "default"
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8bffaacbbee0c705$export$2e2bcd8739ae039), {
                    className: "p-16px cl-primary-cyan01",
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            className: 'game-list-item-box',
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                    className: 'game-list-item-box-row-1',
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                            children: [
                                                "\uD83D\uDCC5 ",
                                                props.game.matchDt
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                            children: [
                                                "\u23F0 ",
                                                props.game.time
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                    className: 'game-list-item-box-row-2',
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                            children: [
                                                "\uD83D\uDCCD ",
                                                props.game.place
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                            children: [
                                                "\u2694\uFE0F ",
                                                props.game.type && props.game.type === "\uC790\uCCB4\uC804" ? props.game.type : props.game.vsName
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                            children: props.game.status === "\uC644\uB8CC" ? " \u26BD " + props.game.teamAScore + ' : ' + props.game.teamBScore : ''
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7f096abd658f7c85$export$2e2bcd8739ae039), {
                fullScreen: true,
                open: openDetail,
                onClose: ()=>setOpenDetail(false),
                PaperProps: {
                    sx: {
                        backgroundColor: '#1A1A1A',
                        color: '#24cbaa',
                        padding: 0,
                        /* TextField */ '& .MuiOutlinedInput-root': {
                            color: '#24cbaa',
                            backgroundColor: '#111'
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#24cbaa'
                        },
                        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#2fffd7'
                        },
                        '& .MuiInputLabel-root': {
                            color: '#24cbaa'
                        },
                        '& .MuiSvgIcon-root': {
                            color: '#24cbaa'
                        },
                        '& .MuiBox-root': {
                            backgroundColor: '#1A1A1A',
                            color: '#24cbaa'
                        }
                    }
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $00dbfe3007fdc781$export$2e2bcd8739ae039), {
                    onClose: ()=>setOpenDetail(false),
                    game: props.game,
                    onReturn: handleReturnClick
                })
            })
        ]
    });
};
var $5035db66448631e7$export$2e2bcd8739ae039 = $5035db66448631e7$var$GameListItem;


const $07e964405d7af5b3$var$GameList = (props)=>{
    const handleReturnClick = (0, $7fPBF.useCallback)(()=>{
        props.onReturn();
    }, [
        props.onReturn
    ]);
    if (props.gameList.length === 0) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {});
    else return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            className: "game-list",
            children: props.gameList.map((data, index)=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: "mb-4px",
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5035db66448631e7$export$2e2bcd8739ae039), {
                        game: data,
                        onReturn: handleReturnClick
                    })
                }, index))
        })
    });
};
var $07e964405d7af5b3$export$2e2bcd8739ae039 = $07e964405d7af5b3$var$GameList;





var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");












const $3f43d27514aad457$var$GameAdd = (props)=>{
    const handleOverlayClick = (0, $7fPBF.useCallback)(()=>props.onClose(), [
        props.onClose
    ]);
    const handleOverlayReturn = (0, $7fPBF.useCallback)(()=>props.onReturn(), [
        props.onReturn
    ]);
    const dateRef = (0, $7fPBF.useRef)(null);
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const [places, setPlaces] = (0, $7fPBF.useState)([]);
    const writerId = (0, $33eb00f42ea63933$export$2e2bcd8739ae039).getLocalStorage((0, $2df1405d783f614e$export$212a8f1ea37518bd));
    const [gameItem, setGameItem] = (0, $7fPBF.useState)({
        writerId: writerId,
        matchDt: '',
        time: '',
        place: '',
        type: '',
        playersCountType: '',
        vsName: ''
    });
    const TIME_OPTIONS = [
        '20:00~22:00',
        '19:00~21:00',
        '18:00~20:00',
        '17:00~19:00',
        '16:00~18:00',
        '15:00~17:00',
        '14:00~16:00',
        '13:00~15:00',
        '12:00~14:00',
        '11:00~13:00',
        '10:00~12:00',
        '09:00~11:00',
        '08:00~10:00',
        '07:00~09:00',
        '06:00~08:00'
    ];
    const TYPE_OPTIONS = [
        {
            value: "\uC790\uCCB4\uC804",
            label: "\uC790\uCCB4\uC804"
        },
        {
            value: "\uC0C1\uB300\uC804",
            label: "\uC0C1\uB300\uC804"
        }
    ];
    const PLAYER_OPTIONS = [
        '11 VS 11',
        '10 VS 10'
    ];
    const [registItem, setRegistItem] = (0, $7fPBF.useState)();
    const [isOpen, setIsOpen] = (0, $7fPBF.useState)(false);
    let registFlag = false;
    /** 뒤로가기 감지 */ (0, $7fPBF.useEffect)(()=>{
        const unlisten = (0, $82bcba16c3ce4448$export$55abd4691b317664).listen(({ action: action })=>{
            if (action === 'POP') checkIsChanged();
        });
        return unlisten;
    }, []);
    const checkIsChanged = ()=>{
        if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(gameItem.matchDt) || (0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(gameItem.place)) setIsOpen(true);
        else handleOverlayClick();
    };
    const inputChanged = (event)=>{
        const { id: id, value: value } = event.target;
        setGameItem((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, gameItem), {
            [id]: value
        }));
    };
    /** 경기 등록 API */ const { refetch: postGame } = (0, $d8deb3a6a62b947e$export$dd0a697e1782aedd)([
        'postGame'
    ], ()=>(0, $9edd82d19644f411$export$2e2bcd8739ae039).postGame(registItem), {
        onSuccess: ()=>{
            handleOverlayReturn();
            handleOverlayClick();
        }
    });
    const registGame = ()=>{
        setRegistItem({
            writerId: writerId,
            matchDt: gameItem.matchDt,
            time: gameItem.time,
            place: gameItem.place,
            type: gameItem.type,
            playersCountType: gameItem.playersCountType,
            vsName: gameItem.vsName
        });
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!registItem) return;
        if (registFlag) return;
        registFlag = true;
        postGame().then(()=>{
            registFlag = false;
            return Promise;
        }).catch(console.log);
    }, [
        registItem
    ]);
    const isDisabled = gameItem.matchDt === '' || gameItem.time === '' || gameItem.place === '' || gameItem.type === '' || gameItem.playersCountType === '' || gameItem.type === "\uC0C1\uB300\uC804" && gameItem.vsName === '';
    (0, $7fPBF.useEffect)(()=>{
        loadPlaces();
    }, []);
    const loadPlaces = async ()=>{
        try {
            const list = await (0, $744a577e8e94e017$export$2e2bcd8739ae039).getPlaceList();
            setPlaces(list);
        } catch (e) {
            console.error(e);
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: 'game',
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5f47bfd43cc47d77$export$2e2bcd8739ae039), {
                        onClose: checkIsChanged,
                        title: "Match \uB4F1\uB85D",
                        leftIcon: 'prev-w w-8 w-17'
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4ac626799ed465c3$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "mainInput",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
                                id: "matchDt",
                                type: "date",
                                variant: "outlined",
                                fullWidth: true,
                                className: "b2_r mt-24px",
                                inputRef: dateRef,
                                InputLabelProps: {
                                    shrink: true
                                },
                                onClick: ()=>{
                                    const input = dateRef.current;
                                    if (input === null || input === void 0 ? void 0 : input.showPicker) input.showPicker();
                                    else input === null || input === void 0 ? void 0 : input.focus();
                                },
                                onChange: inputChanged
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                value: gameItem.time,
                                displayEmpty: true,
                                className: "b2_r w-100p mt-16px",
                                onChange: (e)=>setGameItem((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, gameItem), {
                                        time: e.target.value
                                    })),
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                        value: "",
                                        disabled: true,
                                        children: "\uC2DC\uAC04"
                                    }),
                                    TIME_OPTIONS.map((time)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: time,
                                            children: time
                                        }, time))
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                value: gameItem.place,
                                displayEmpty: true,
                                className: "b2_r w-100p mt-16px",
                                onChange: (e)=>setGameItem((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, gameItem), {
                                        place: e.target.value
                                    })),
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                        value: "",
                                        disabled: true,
                                        children: "\uC7A5\uC18C"
                                    }),
                                    places.map((place)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: place.name,
                                            children: place.name
                                        }, place.id))
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                value: gameItem.type,
                                displayEmpty: true,
                                className: "b2_r w-100p mt-16px",
                                onChange: (e)=>setGameItem((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, gameItem), {
                                        type: e.target.value
                                    })),
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                        value: "",
                                        disabled: true,
                                        children: "\uD0C0\uC785"
                                    }),
                                    TYPE_OPTIONS.map((type)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: type.value,
                                            children: type.label
                                        }, type.value))
                                ]
                            }),
                            gameItem.type === "\uC0C1\uB300\uC804" && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $afe2b905acb8b9f6$export$2e2bcd8739ae039), {
                                id: "vsName",
                                variant: "outlined",
                                fullWidth: true,
                                className: "b2_r w-100p mt-16px",
                                placeholder: "\uC0C1\uB300\uD300 \uC774\uB984",
                                value: gameItem.vsName,
                                inputProps: {
                                    maxLength: 30
                                },
                                onChange: inputChanged
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e07ff65b28ac412d$export$2e2bcd8739ae039), {
                                value: gameItem.playersCountType,
                                displayEmpty: true,
                                className: "b2_r w-100p mt-16px",
                                onChange: (e)=>setGameItem((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, gameItem), {
                                        playersCountType: e.target.value
                                    })),
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                        value: "",
                                        disabled: true,
                                        children: "\uC778\uC6D0 \uC120\uD0DD"
                                    }),
                                    PLAYER_OPTIONS.map((cnt)=>/*#__PURE__*/ (0, $bbzbN.jsx)((0, $3bdbe9250415b022$export$2e2bcd8739ae039), {
                                            value: cnt,
                                            children: cnt
                                        }, cnt))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fd30181b78da18c2$export$2e2bcd8739ae039), {
                        className: "primary",
                        disabled: isDisabled,
                        title: "\uC800\uC7A5",
                        onClick: registGame
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $79d0143175d5363b$export$2e2bcd8739ae039), {
                content: /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                    children: [
                        "\uC791\uC131 \uC911\uC778 \uB0B4\uC6A9\uC774 \uC0AC\uB77C\uC9D1\uB2C8\uB2E4",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        "\uADF8\uB798\uB3C4 \uB098\uAC00\uC2DC\uACA0\uC2B5\uB2C8\uAE4C?"
                    ]
                }),
                leftBtnContent: "\uC544\uB2C8\uC624",
                rightBtnContent: "\uB124",
                isOpen: isOpen,
                onClick: ()=>setIsOpen(false),
                onClose: ()=>props.onClose()
            })
        ]
    });
};
var $3f43d27514aad457$export$2e2bcd8739ae039 = $3f43d27514aad457$var$GameAdd;


const $a988aef1862d88ec$var$GameView = ()=>{
    const handleOverlayClick = ()=>{
        console.log('close');
    };
    const handleReturnClick = (0, $7fPBF.useCallback)(()=>{
        initData();
    }, []);
    const handleEditComplete = (0, $7fPBF.useCallback)(()=>{
        initData();
        console.log('handleEditComplete');
    }, []);
    const [open, setOpen] = (0, $7fPBF.useState)(false);
    const [gameList, setGameList] = (0, $7fPBF.useState)([]);
    const { refetch: getGameList } = (0, $d8deb3a6a62b947e$export$dd0a697e1782aedd)([
        'getGameList'
    ], ()=>(0, $9edd82d19644f411$export$2e2bcd8739ae039).getGameList(), {
        onSuccess: (v)=>setGameList(v !== null && v !== void 0 ? v : [])
    });
    const initData = ()=>{
        getGameList().catch(console.log);
    };
    (0, $7fPBF.useEffect)(()=>{
        initData();
    }, []);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: 'game',
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $07e964405d7af5b3$export$2e2bcd8739ae039), {
                    gameList: gameList,
                    onReturn: handleReturnClick
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fd30181b78da18c2$export$2e2bcd8739ae039), {
                title: "Match \uB4F1\uB85D",
                disabled: false,
                onClick: ()=>setOpen(true),
                main: true
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7f096abd658f7c85$export$2e2bcd8739ae039), {
                fullScreen: true,
                open: open,
                onClose: ()=>setOpen(false),
                PaperProps: {
                    sx: {
                        backgroundColor: '#1A1A1A',
                        color: '#24cbaa',
                        padding: 0,
                        /* TextField */ '& .MuiOutlinedInput-root': {
                            color: '#24cbaa',
                            backgroundColor: '#111'
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#24cbaa'
                        },
                        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: '#2fffd7'
                        },
                        '& .MuiInputLabel-root': {
                            color: '#24cbaa'
                        },
                        '& .MuiSvgIcon-root': {
                            color: '#24cbaa'
                        }
                    }
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3f43d27514aad457$export$2e2bcd8739ae039), {
                    onClose: ()=>setOpen(false),
                    onReturn: handleReturnClick
                })
            })
        ]
    });
};
var $a988aef1862d88ec$export$2e2bcd8739ae039 = $a988aef1862d88ec$var$GameView;


const $06806f6c4c86bac5$export$861edd1ccea2f746 = ()=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            id: 'Main',
            className: 'body',
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a988aef1862d88ec$export$2e2bcd8739ae039), {})
        })
    });
};
var $06806f6c4c86bac5$export$2e2bcd8739ae039 = $06806f6c4c86bac5$export$861edd1ccea2f746;


const $dd12cd8b8470e831$var$MainView = ()=>{
    const [headType, setHeadType] = (0, $7fPBF.useState)(0);
    const [response, setResponse] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            headType === 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a44d74230def4758$export$2e2bcd8739ae039), {
                leftIcon: 'menu-w'
            }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a44d74230def4758$export$2e2bcd8739ae039), {
                leftIcon: 'menu-b'
            }),
            headType === 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4ac626799ed465c3$export$2e2bcd8739ae039), {
                className: "bg-cl-black"
            }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4ac626799ed465c3$export$2e2bcd8739ae039), {
                className: "bg-cl-gray-7"
            }),
            response ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $06806f6c4c86bac5$export$2e2bcd8739ae039), {})
            }) : /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $06806f6c4c86bac5$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $dd12cd8b8470e831$export$2e2bcd8739ae039 = $dd12cd8b8470e831$var$MainView;



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");





var $5nUae = parcelRequire("5nUae");





function $978389e4a0c045ec$export$29cad1383b3f235d(slot) {
    return (0, $ea3dfa6b173640a4$export$2e2bcd8739ae039)('MuiCircularProgress', slot);
}
const $978389e4a0c045ec$var$circularProgressClasses = (0, $32447174989d1976$export$2e2bcd8739ae039)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $978389e4a0c045ec$export$2e2bcd8739ae039 = $978389e4a0c045ec$var$circularProgressClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
let $d513166e63c42433$var$_ = (t)=>t, $d513166e63c42433$var$t, $d513166e63c42433$var$t1, $d513166e63c42433$var$t2, $d513166e63c42433$var$t3;
const $d513166e63c42433$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $d513166e63c42433$var$_1 = (t)=>t, $d513166e63c42433$var$_t, $d513166e63c42433$var$_t2, $d513166e63c42433$var$_t3, $d513166e63c42433$var$_t4;
const $d513166e63c42433$var$SIZE = 44;
const $d513166e63c42433$var$circularRotateKeyframe = (0, $5nUae.keyframes)($d513166e63c42433$var$_t || ($d513166e63c42433$var$_t = $d513166e63c42433$var$_1($d513166e63c42433$var$t || ($d513166e63c42433$var$t = $d513166e63c42433$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`))));
const $d513166e63c42433$var$circularDashKeyframe = (0, $5nUae.keyframes)($d513166e63c42433$var$_t2 || ($d513166e63c42433$var$_t2 = $d513166e63c42433$var$_1($d513166e63c42433$var$t1 || ($d513166e63c42433$var$t1 = $d513166e63c42433$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`))));
const $d513166e63c42433$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $93971f0806345477$export$2e2bcd8739ae039)(slots, (0, $978389e4a0c045ec$export$29cad1383b3f235d), classes);
};
const $d513166e63c42433$var$CircularProgressRoot = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $5nUae.css)($d513166e63c42433$var$_t3 || ($d513166e63c42433$var$_t3 = $d513166e63c42433$var$_1($d513166e63c42433$var$t2 || ($d513166e63c42433$var$t2 = $d513166e63c42433$var$_`
      animation: ${0} 1.4s linear infinite;
    `), 0)), $d513166e63c42433$var$circularRotateKeyframe));
const $d513166e63c42433$var$CircularProgressSVG = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $d513166e63c42433$var$CircularProgressCircle = (0, $f0645ef192f222f7$export$2e2bcd8739ae039)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $816c65c0e1f7082c$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $5nUae.css)($d513166e63c42433$var$_t4 || ($d513166e63c42433$var$_t4 = $d513166e63c42433$var$_1($d513166e63c42433$var$t3 || ($d513166e63c42433$var$t3 = $d513166e63c42433$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), 0)), $d513166e63c42433$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $d513166e63c42433$var$CircularProgress = /*#__PURE__*/ $7fPBF.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $dc79fb0f6686e80b$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $cFLic.default)(props, $d513166e63c42433$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $d513166e63c42433$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($d513166e63c42433$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)($d513166e63c42433$var$CircularProgressRoot, (0, $kY3Ke.default)({
        className: (0, $07a883fe7c352c85$export$2e2bcd8739ae039)(classes.root, className),
        style: (0, $kY3Ke.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($d513166e63c42433$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$d513166e63c42433$var$SIZE / 2} ${$d513166e63c42433$var$SIZE / 2} ${$d513166e63c42433$var$SIZE} ${$d513166e63c42433$var$SIZE}`,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)($d513166e63c42433$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $d513166e63c42433$var$SIZE,
                cy: $d513166e63c42433$var$SIZE,
                r: ($d513166e63c42433$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $d513166e63c42433$export$2e2bcd8739ae039 = $d513166e63c42433$var$CircularProgress;



const $f997398eb8f0e318$var$Loading = ()=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        id: "loading-page",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
            sx: {
                display: 'flex'
            },
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d513166e63c42433$export$2e2bcd8739ae039), {
                color: "primary"
            })
        })
    });
};
var $f997398eb8f0e318$export$2e2bcd8739ae039 = $f997398eb8f0e318$var$Loading;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");


const $4f2ef10ac997660e$var$style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 270
};
const $4f2ef10ac997660e$var$Alert = (props)=>{
    const handleClose = (0, $7fPBF.useCallback)(()=>{
        props.onClose();
    }, [
        props.onClose
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            className: 'modal-dialog',
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a65b89a1133e1fe4$export$2e2bcd8739ae039), {
                open: props.isOpen,
                onClose: handleClose,
                "aria-describedby": "modal-modal-description",
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                    sx: $4f2ef10ac997660e$var$style,
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            id: "modal-modal-description",
                            className: 'modal-body',
                            children: [
                                props.title !== undefined ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
                                    children: props.title
                                }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {}),
                                props.content
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: "modal-footer",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: 'modal-btn alert-btn',
                                onClick: handleClose,
                                children: props.btnContent
                            })
                        })
                    ]
                })
            })
        })
    });
};
var $4f2ef10ac997660e$export$2e2bcd8739ae039 = $4f2ef10ac997660e$var$Alert;




var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");




var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");


const $a86038245a3af4e6$var$Input = (props)=>{
    const [type, setType] = (0, $7fPBF.useState)(props.type ? props.type : 'text');
    const [inputValue, setInputValue] = (0, $7fPBF.useState)(props.value ? props.value : '');
    const [themeClass, setThemeClass] = (0, $7fPBF.useState)(props.theme);
    const [errorDisplay, setErrorDisplay] = (0, $7fPBF.useState)('none');
    const inputRef = (0, $7fPBF.useRef)(null);
    const changeHandler = (ev)=>{
        props.onChange && props.onChange(ev); // optional로 인한 코드
        setInputValue(ev.target.value);
    };
    const focusHandler = ()=>{
        setThemeClass(props.errorMsg ? props.theme + '_error' : props.theme + '_selected');
    };
    const blurHandler = ()=>{
        if (props.onBlur) {
            props.onBlur();
            if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(props.errorMsg)) setThemeClass(props.theme);
        } else if (props.required && (0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(inputValue.toString())) setThemeClass(props.theme + '_error');
        else setThemeClass(props.errorMsg ? props.theme + '_error' : props.theme);
    };
    const keyUpHandler = ()=>{
        props.onKeyUp && props.onKeyUp();
    };
    const inputFocus = ()=>{
        if (inputRef.current !== null) {
            inputRef.current.focus();
            props.onClick && props.onClick();
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        if (themeClass.includes('_error')) setErrorDisplay('');
        else setErrorDisplay('none');
    }, [
        themeClass
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!(0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(props.errorMsg)) setThemeClass(props.theme + '_error');
        else setThemeClass((prevState)=>prevState.includes('_error') ? props.theme + '_selected' : prevState.includes('_selected') ? props.theme + '_selected' : props.theme);
    }, [
        props.errorMsg
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setInputValue(props.value || '');
    }, [
        props.value
    ]);
    (0, $7fPBF.useEffect)(()=>{}, [
        inputValue
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (props.type !== undefined) setType(props.type);
    }, [
        props.type
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: 'custom-input',
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            className: themeClass,
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: 'custom-input-box',
                    onFocus: focusHandler,
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                            className: 'c2_r pt-14px ml-16px',
                            children: props.label
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            className: 'pl-16px w-100p flex justify-between',
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                                    className: 'b1_r',
                                    placeholder: props.placeholder,
                                    value: inputValue,
                                    onChange: changeHandler,
                                    onBlur: blurHandler,
                                    readOnly: props.readOnly,
                                    onClick: props.onClick,
                                    onKeyUp: keyUpHandler,
                                    maxLength: props.maxLength,
                                    type: props.type,
                                    ref: inputRef
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                    className: 'icon-wrapper',
                                    children: props.rightContent && inputValue ? props.rightContent : ''
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    style: {
                        display: `${errorDisplay}`
                    },
                    onClick: inputFocus,
                    children: props.errorMsg ? /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: 'error mt-8px flex',
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                                iconClass: 'error-info'
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                className: 'c1_r cl-point03 ml-3px',
                                children: props.errorMsg
                            })
                        ]
                    }) : ''
                })
            ]
        })
    });
};
var $a86038245a3af4e6$export$2e2bcd8739ae039 = $a86038245a3af4e6$var$Input;








var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

const $65919ee74aa6a840$var$Toast = (props)=>{
    const handleCloseClick = (0, $7fPBF.useCallback)(()=>props.onClose(), [
        props.onClose
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (props.isOpen) setTimeout(function() {
            // Code here
            handleCloseClick();
        }, 4000);
    }, [
        props.isOpen
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: props.isOpen ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c181cff0789717b3$export$2e2bcd8739ae039), {
            icon: false,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: 'toast-alert-detail',
                children: props.content
            })
        }) : null
    });
};
var $65919ee74aa6a840$export$2e2bcd8739ae039 = $65919ee74aa6a840$var$Toast;



const $ad54f78bb65efc46$export$7c69d0d1979f52dd = [
    "10\uC0C8\uB07C",
    "10\uC384\uB07C",
    "10\uC54C",
    "10\uCC3D",
    "10\uD0F1",
    "10\uD0F1\uC544",
    "10\uD314",
    "10\uD314\uB144",
    "10\uD314\uB188",
    "10\uD314\uC5F0",
    "10\uD560\uB144",
    "10\uD560\uC5F0",
    "18\uB118",
    "18\uB144",
    "18\uB188",
    "18\uB214",
    "18\uB2A0",
    "18\uC138\uB07C",
    "18\uC251\uB07C",
    "18\uC384\uB9AC",
    "18\uC49C\uB9AC",
    "18\uC49D\uB07C",
    "18\uC528\uB07C",
    '2c8',
    "2c\uD314",
    "\uAC08\uBCF4",
    "\uAC15\uAC04",
    "\uAC1C\uB118",
    "\uAC1C\uB144",
    "\uAC1C\uB188",
    "\uAC1C\uB1EC",
    "\uAC1C\uB214",
    "\uAC1C\uB2A0",
    "\uAC1C\uB54C\uAE84",
    "\uAC1C\uB54C\uB07C",
    "\uAC1C\uB610\uB77C\uC774",
    "\uAC1C\uB625",
    "\uAC1C\uBCF4\uC9C0",
    "\uAC1C\uBD80\uB784",
    "\uAC1C\uBD80\uB7F4",
    "\uAC1C\uBD88\uC54C",
    "\uAC1C\uC0C8",
    "\uAC1C\uC0C8\uAE84",
    "\uAC1C\uC0C8\uB07C",
    "\uAC1C\uC0C8\uB9AC",
    "\uAC1C\uC0C8\uC57C",
    "\uAC1C\uC0C9",
    "\uAC1C\uC0C9\uAE30",
    "\uAC1C\uC0C9\uAE84",
    "\uAC1C\uC0C9\uB07C",
    "\uAC1C\uC0C9\uD788",
    "\uAC1C\uC0E5",
    "\uAC1C\uC138",
    "\uAC1C\uC138\uB07C",
    "\uAC1C\uC138\uC774",
    "\uAC1C\uC139",
    "\uAC1C\uC13A",
    "\uAC1C\uC143",
    "\uAC1C\uC14B\uD0A4",
    "\uAC1C\uC150",
    "\uAC1C\uC18C\uB9AC",
    "\uAC1C\uC1C4\uB07C",
    "\uAC1C\uC1C5",
    "\uAC1C\uC1C5\uAC38",
    "\uAC1C\uC1C5\uAE30",
    "\uAC1C\uC1C5\uAE84",
    "\uAC1C\uC1C5\uB07C",
    "\uAC1C\uC1C5\uCEAC",
    "\uAC1C\uC1C5\uD0A4",
    "\uAC1C\uC1D7",
    "\uAC1C\uC1D7\uAE30",
    "\uAC1C\uC1E0\uB9AC",
    "\uAC1C\uC250",
    "\uAC1C\uC250\uB07C",
    "\uAC1C\uC250\uB9AC",
    "\uAC1C\uC250\uC774",
    "\uAC1C\uC251",
    "\uAC1C\uC251\uAC38",
    "\uAC1C\uC251\uAE30",
    "\uAC1C\uC251\uAE84",
    "\uAC1C\uC251\uB07C",
    "\uAC1C\uC251\uC774",
    "\uAC1C\uC251\uCEAC",
    "\uAC1C\uC251\uD0A4",
    "\uAC1C\uC251\uD788",
    "\uAC1C\uC262",
    "\uAC1C\uC268",
    "\uAC1C\uC26C\uB07C",
    "\uAC1C\uC2C0\uB07C",
    "\uAC1C\uC2D8",
    "\uAC1C\uC2DC\uD034",
    "\uAC1C\uC2DC\uD0A4",
    "\uAC1C\uC2ED\uD314",
    "\uAC1C\uC2EF\uB07C",
    "\uAC1C\uC2EF\uD0A4",
    "\uAC1C\uC2F4",
    "\uAC1C\uC30D\uB118",
    "\uAC1C\uC30D\uB144",
    "\uAC1C\uC30D\uB188",
    "\uAC1C\uC314",
    "\uAC1C\uC314\uAE84",
    "\uAC1C\uC314\uB07C",
    "\uAC1C\uC315",
    "\uAC1C\uC315\uB07C",
    "\uAC1C\uC345\uB118",
    "\uAC1C\uC345\uB144",
    "\uAC1C\uC345\uB188",
    "\uAC1C\uC345\uB2A0",
    "\uAC1C\uC345\uC5F0",
    "\uAC1C\uC385",
    "\uAC1C\uC410\uB9AC",
    "\uAC1C\uC49C",
    "\uAC1C\uC49C\uB07C",
    "\uAC1C\uC49C\uB9AC",
    "\uAC1C\uC49D",
    "\uAC1C\uC49D\uAC38",
    "\uAC1C\uC49D\uAE30",
    "\uAC1C\uC49D\uAE84",
    "\uAC1C\uC49D\uB07C",
    "\uAC1C\uC49D\uD0A4",
    "\uAC1C\uC4AF",
    "\uAC1C\uC4B8",
    "\uAC1C\uC4B9\uAE30",
    "\uAC1C\uC50C\uB07C",
    "\uAC1C\uC528\uB07C",
    "\uAC1C\uC528\uBC1C",
    "\uAC1C\uC528\uD315",
    "\uAC1C\uC539",
    "\uAC1C\uC539\uCC3D",
    "\uAC1C\uC539\uD314",
    "\uAC1C\uC790\uC2A5",
    "\uAC1C\uC790\uC2C1",
    "\uAC1C\uC790\uC2DD",
    "\uAC1C\uC790\uC9C0",
    "\uAC1C\uC813",
    "\uAC1C\uC816",
    "\uAC1C\uC84B",
    "\uAC1C\uC84E",
    "\uAC1C\uC870\uB610",
    "\uAC1C\uC870\uC637",
    "\uAC1C\uC871",
    "\uAC1C\uC886",
    "\uAC1C\uC9C0\uB784",
    "\uAC1C\uD6C4\uB808",
    "\uAC1C\uD6C4\uC7A5",
    "\uAC70\uC2DC\uAE30",
    "\uAC81\uD0C8",
    "\uAC8C\uB118",
    "\uAC8C\uB144",
    "\uAC8C\uB188",
    "\uAC8C\uB1EC",
    "\uAC8C\uB1FD",
    "\uAC8C\uB214",
    "\uAC8C\uC0C8\uB07C",
    "\uAC8C\uC0C8\uB9AC",
    "\uAC8C\uC0C9",
    "\uAC8C\uC0C9\uAE30",
    "\uAC8C\uC0C9\uB07C",
    "\uAC8C\uC138",
    "\uAC8C\uC138\uAE84",
    "\uAC8C\uC138\uB07C",
    "\uAC8C\uC139",
    "\uAC8C\uC250",
    "\uAC8C\uC250\uC774",
    "\uAC8C\uC2DC\uB07C",
    "\uAC8C\uC2DC\uD034",
    "\uACE0\uD658",
    "\uACF5\uC9DC\uBC84\uADF8",
    "\uACF5\uC9DC\uCE90\uC26C",
    "\uADF8\uB8F9\uC139\uC2A4",
    "\uADF8\uC9C0\uC0C8\uB07C",
    "\uADF8\uC9C0\uC883\uBC25",
    "\uADF8\uC9C0\uC883\uBE71",
    "\uADF8\uC9C0\uC886\uBC25",
    "\uADFC\uCE5C",
    "\uADFC\uCE5C\uC0C1\uAC04",
    "\uAE30\uC5C9\uC544",
    "\uAE30\uD615\uC544",
    "\uAF34\uB824",
    "\uAF34\uB9AC\uB294",
    "\uAF34\uB9AC\uB2E4",
    "\uB09C\uAD50",
    "\uB123\uAC8C\uBC8C\uB824",
    "\uB123\uACE0\uC2F8\uACE0",
    "\uB124\uC5D0\uBBF8",
    "\uB144\uB188",
    "\uB2C8\uBBF8\uB784",
    "\uB2C8\uBBF8\uB7F4",
    "\uB2C8\uBBF8\uB864",
    "\uB2C8\uBBF8\uB97C",
    "\uB2C8\uBCF4\uC9C0",
    "\uB2C8\uC560\uBBF8",
    "\uB2C8\uC560\uBE44",
    "\uB2C8\uC5B4\uBBF8",
    "\uB2C8\uC5D0\uBBF8",
    "\uB2C8\uC5D0\uBE44",
    "\uB2C8\uC886",
    "\uB300\uB538",
    "\uB538\uB538\uC774",
    "\uB5A1\uCE58\uAE30",
    "\uB5A1\uCE60\uB140",
    "\uB8F8\uC139\uC2A4",
    "\uB9C8\uC2A4\uD130\uBCA0\uC774\uC158",
    "\uB9E4\uCD98",
    "\uB9E4\uCD98\uBD80",
    "\uBAB8\uC548\uC5D0\uC0AC\uC815",
    "\uBAB8\uCEA0",
    "\uBAB8\uCF10",
    "\uBAB8\uD30C\uB294",
    "\uBB88\uCE40\uC138\uB07C",
    "\uBB88\uCE40\uC138\uB9AC",
    "\uBB88\uCE40\uC139\uB07C",
    "\uBB88\uCE5C",
    "\uBB88\uCE5C\uC138\uB9AC",
    "\uBB88\uCE5C\uC139\uB07C",
    "\uBB88\uCE5C\uC139\uC774",
    "\uBBF8\uCDEC",
    "\uBBF8\uCDEC\uB144",
    "\uBBF8\uCDEC\uC138\uB07C",
    "\uBBF8\uCDEC\uC250\uB9AC",
    "\uBBF8\uCE5C",
    "\uBBF8\uCE5C\uB118",
    "\uBBF8\uCE5C\uB144",
    "\uBBF8\uCE5C\uB188",
    "\uBBF8\uCE5C\uB1EC",
    "\uBBF8\uCE5C\uC0C8\uB07C",
    "\uBBF8\uCE5C\uC138\uB9AC",
    "\uBBF8\uCE5C\uC139\uC774",
    "\uBBF8\uCE5C\uC790\uC2DD",
    "\uBBF8\uD284",
    "\uBBF8\uD2D8",
    "\uBBF8\uD2E9",
    "\uBBF8\uD2F4",
    "\uBBF8\uD2F4\uB1EC",
    "\uBC11\uAD6C\uB155",
    "\uBC11\uAD6C\uB155\uBE68\uAE30",
    "\uBC15\uACE0\uC2F6\uB2E4",
    "\uBC15\uACE0\uC2F6\uD37C",
    "\uBC15\uC544\uC904\uAC8C",
    "\uBC15\uC544\uC904\uAED8",
    "\uBC15\uC744\uAED8",
    "\uBC15\uC744\uB144",
    "\uBC45\uC270",
    "\uBC45\uC2C4",
    "\uBC45\uC2E0",
    "\uBC61\uC2E0",
    "\uBC84\uC9A4",
    "\uBC84\uC9C0",
    "\uBC84\uC9C0\uBB3C",
    "\uBC84\uC9D3\uBB3C",
    "\uBC88\uC139",
    "\uBC88\uC315",
    "\uBC88\uC385",
    "\uBC99\uC5B4\uB9AC",
    "\uBCBC\uC5C9\uC2E0",
    "\uBCC0\uC139",
    "\uBCC0\uD0DC",
    "\uBCC0\uD1F4",
    "\uBCD1\uC270",
    "\uBCD1\uC2C0",
    "\uBCD1\uC2C4",
    "\uBCD1\uC2E0",
    "\uBCD1\uC52C",
    "\uBCF4\uC624\uC9C0",
    "\uBCF4\uC950",
    "\uBCF4\uC9A4",
    "\uBCF4\uC9C0",
    "\uBCF4\uC9C0\uAC78",
    "\uBCF4\uC9C0\uAD6C\uB155",
    "\uBCF4\uC9C0\uAD6C\uBA4D",
    "\uBCF4\uC9C0\uB098\uB77C",
    "\uBCF4\uC9C0\uB2F9",
    "\uBCF4\uC9C0\uBB3C",
    "\uBCF4\uC9C0\uBCF4\uC9C0",
    "\uBCF4\uC9C0\uD138",
    "\uBCF4\uC9D3\uB144",
    "\uBCF4\uC9D3\uBB3C",
    "\uBCF4\uC9D6\uBB3C",
    "\uBCF4G",
    "\uBD09\uC54C",
    "\uBD64\uC9A4",
    "\uBD64\uC9C0",
    "\uBD68\uD0DC",
    "\uBD79\uB531",
    "\uBD79\uC2C4",
    "\uBD79\uC2E0",
    "\uBD80\uB784",
    "\uBD80\uBD80\uC139\uC2A4",
    "\uBD80\uCE74\uCF00",
    "\uBD88\uB95C",
    "\uBD88\uC54C",
    "\uBD95\uB531",
    "\uBD95\uB532",
    "\uBD95\uB6F4",
    "\uBD95\uC2C4",
    "\uBD95\uC2DC\uB098",
    "\uBD95\uC2E0",
    "\uBD95\uC54C",
    "\uBD9C\uC9C0",
    "\uBDB1\uC2E0",
    "\uBDCD\uC2A8",
    "\uBDCD\uC2C4",
    "\uBDCD\uC2E0",
    "\uBDE9\uC26C",
    "\uBDE9\uC270",
    "\uBDE9\uC2C4",
    "\uBDE9\uC2E0",
    "\uBDF0\uC6C5\uC2E0",
    "\uBE05\uB531",
    "\uBE05\uC270",
    "\uBE05\uC2C4",
    "\uBE05\uC2DC",
    "\uBE05\uC2E0",
    "\uBE05\uC544",
    "\uBE0C\uB784",
    "\uBE14\uC54C",
    "\uBE21\uB531",
    "\uBE21\uC270",
    "\uBE21\uC2E0",
    "\uBE3D\uB531",
    "\uBE3D\uC26C",
    "\uBE3D\uC2A8",
    "\uBE3D\uC2C4",
    "\uBE3D\uC2DC",
    "\uBE3D\uC2E0",
    "\uBE44\uC789\uC2E0",
    "\uBE59\uB531",
    "\uBE59\uC26C",
    "\uBE59\uC270",
    "\uBE59\uC2C0",
    "\uBE59\uC2C4",
    "\uBE59\uC2DC",
    "\uBE59\uC2E0",
    "\uBE60\uAC78",
    "\uBE60\uAD6C\uB9AC",
    "\uBE60\uAD74",
    "\uBE60\uAD74\uC774",
    "\uBE60\uAFB8\uB9AC",
    "\uBE60\uB3C4\uB9AC",
    "\uBE60\uB3CC\uC774",
    "\uBE60\uB77C",
    "\uBE60\uB77C\uC870",
    "\uBE60\uB77C\uC918",
    "\uBE60\uB7EC",
    "\uBE60\uC218\uB2C8",
    "\uBE60\uC21C\uC774",
    "\uBE60\uD050",
    "\uBE61\uB3CC",
    "\uBE61\uCD0C",
    "\uBE61\uD050",
    "\uBE68\uC5B4\uD565\uC5B4\uBC15\uC5B4",
    "\uBE68\uC790\uC883",
    "\uBE68\uC790\uC886",
    "\uBE7D\uBCF4\uC9C0",
    "\uBE7D\uC790\uC9C0",
    "\uBE91\uC2E0",
    "\uBE91\uC4BC",
    "\uBE91\uC52C",
    "\uBE98\uD050",
    "\uBED0\uC5B4\uD050",
    "\uBED0\uD050",
    "\uBED0\uD0B9",
    "\uBF1D\uC2E0",
    "\uBF40\uAC1C",
    "\uBF40\uB85C\uB178",
    "\uBF40\uB974\uB098",
    "\uBF40\uB974\uB108",
    "\uBF40\uB974\uB178",
    "\uBF40\uC950",
    "\uBF40\uC9C0",
    "\uBF40\uCB9C",
    "\uBF55\uC54C",
    "\uBFC5\uC2E0",
    "\uBFC5\uC52C",
    "\uBFE1\uC54C",
    "\uC051\uC2E0",
    "\uC090\uAFB8",
    "\uC0A5\uC270",
    "\uC0A5\uC4BC",
    "\uC0A5\uC52C",
    "\uC0AC\uAE4C\uC2DC",
    "\uC0AC\uAE4C\uCE58",
    "\uC0AC\uC774\uBC84\uC139\uC2A4",
    "\uC0AC\uCC3D\uAC00",
    "\uC0AC\uCE74\uC2DC",
    "\uC0AC\uCE74\uCE58",
    "\uC0BD\uC958",
    "\uC0BF\uAC00\uC2DC",
    "\uC0BF\uAE4C\uC2DC",
    "\uC0BF\uAE5F\uC2DC",
    "\uC0C1\uB144",
    "\uC0C1\uB178\uBB34",
    "\uC0C1\uB188",
    "\uC0C8\uAE84",
    "\uC0C8\uB00C",
    "\uC0C8\uB060",
    "\uC0C8\uB07C",
    "\uC0C8\uB93C",
    "\uC0C8\uC5D0\uB07C",
    "\uC0C8\uD0A4",
    "\uC0C8X",
    "\uC0C9\uAC38",
    "\uC0C9\uAC78",
    "\uC0C9\uACE8",
    "\uC0C9\uAD11",
    "\uC0C9\uAE30",
    "\uC0C9\uAE84",
    "\uC0C9\uB07C",
    "\uC0C9\uB0A8",
    "\uC0C9\uB140",
    "\uC0C9\uB9C8",
    "\uC0C9\uC2A4",
    "\uC0C9\uC464",
    "\uC0C9\uC4F0",
    "\uC0C9\uCEAC",
    "\uC0C9\uD0A4",
    "\uC0C9\uD560",
    "\uC0C9\uD590",
    "\uC0C9\uD788",
    "\uC0CA\uAE84",
    "\uC0E4\uBD88\uB144",
    "\uC0E4\uC559\uB144",
    "\uC0F5\uB144",
    "\uC0F9\uB118",
    "\uC0F9\uB144",
    "\uC0F9\uB188",
    "\uC0F9\uB2A0",
    "\uC131\uAD00\uACC4",
    "\uC131\uAD50",
    "\uC131\uB9E4\uB9E4",
    "\uC131\uC139\uC2A4",
    "\uC131\uC695\uAD6C",
    "\uC131\uC778\uC6A9\uD488",
    "\uC131\uCCB4\uC704",
    "\uC131\uCCB4\uD5D8",
    "\uC131\uCD94\uD589",
    "\uC131\uCDA9\uB3D9",
    "\uC131\uD3ED\uB825",
    "\uC131\uD3ED\uD589",
    "\uC131\uD589\uC704",
    "\uC138\uAC8C\uBE68\uC544",
    "\uC138\uAE84",
    "\uC138\uB00C",
    "\uC138\uB060",
    "\uC138\uB07C",
    "\uC138\uC561\uC2A4",
    "\uC138\uC5D0\uB07C",
    "\uC138\uC5D0\uC4F0",
    "\uC138\uC5D1",
    "\uC138\uD034",
    "\uC138\uD0A4",
    "\uC139\uB0A8",
    "\uC139\uB140",
    "\uC139\uB9C8",
    "\uC139\uBCF4\uC9C0",
    "\uC139\uC218",
    "\uC139\uC26C",
    "\uC139\uC288",
    "\uC139\uC2A4",
    "\uC139\uC2DC",
    "\uC139\uD30C\uD2B8\uB108",
    "\uC139\uD558\uC790",
    "\uC139\uD558\uC7A5",
    "\uC139\uD560",
    "\uC139\uD574",
    "\uC139\uD788",
    "\uC139s",
    "\uC218\uAC04",
    "\uC218\uC74C",
    "\uC251\uC218",
    "\uC251\uC2A4",
    "\uC251\uC464",
    "\uC251\uC4F0",
    "\uC251\uCEAC",
    "\uC2A4\uC640\uD551",
    "\uC2A4\uD2B8\uB9BD\uC1FC",
    "\uC2A4\uD2B8\uB9BD\uC448",
    "\uC2A4\uD384",
    "\uC2ED8",
    "\uC2ED\uB118",
    "\uC2ED\uB140",
    "\uC2ED\uB188",
    "\uC2ED\uB54C\uAE84",
    "\uC2ED\uB54C\uB07C",
    "\uC2ED\uB5BC\uB07C",
    "\uC2ED\uBC38",
    "\uC2ED\uC0C8",
    "\uC2ED\uC0C8\uAE84",
    "\uC2ED\uC0C8\uB07C",
    "\uC2ED\uC0C8\uCEAC",
    "\uC2ED\uC0C8\uD0A4",
    "\uC2ED\uC0C9",
    "\uC2ED\uC0C9\uAE84",
    "\uC2ED\uC0C9\uB07C",
    "\uC2ED\uC0C9\uD788",
    "\uC2ED\uC138",
    "\uC2ED\uC138\uB07C",
    "\uC2ED\uC1C4\uB9AC",
    "\uC2ED\uC250",
    "\uC2ED\uC250\uB9AC",
    "\uC2ED\uC250\uC774",
    "\uC2ED\uC251",
    "\uC2ED\uC251\uD788",
    "\uC2ED\uC2DC\uB07C",
    "\uC2ED\uC314",
    "\uC2ED\uC314\uAE84",
    "\uC2ED\uC384\uB07C",
    "\uC2ED\uC528\uD0A4",
    "\uC2ED\uC54C",
    "\uC2ED\uC9C8",
    "\uC2ED\uCC3D",
    "\uC2ED\uD0F1",
    "\uC2ED\uD0F1\uAD6C\uB9AC",
    "\uC2ED\uD314",
    "\uC2ED\uD314\uB144",
    "\uC2ED\uD314\uB828",
    "\uC2ED\uD314\uC5F0",
    "\uC2ED\uD560",
    "\uC2ED\uD560\uB828",
    "\uC2EF\uB07C",
    "\uC2EF\uBE68",
    "\uC2EF\uD314",
    "\uC2F2\uD314",
    "\uC2F4\uD314",
    "\uC2F5\uD314",
    "\uC2F6\uC54C",
    "\uC2F6\uD314",
    "\uC2F8\uBC1C\uB144",
    "\uC2F8\uC559\uB118",
    "\uC2F8\uC559\uB140",
    "\uC2F8\uC559\uB144",
    "\uC2F8\uC904\uAED8",
    "\uC2F9\uB144",
    "\uC309\uB144",
    "\uC30D\uB10C",
    "\uC30D\uB118",
    "\uC30D\uB144",
    "\uC30D\uB150",
    "\uC30D\uB178\uBB34",
    "\uC30D\uB188",
    "\uC30D\uB188\uC544",
    "\uC30D\uB1E8\uB098",
    "\uC30D\uB1EC",
    "\uC30D\uB1F8",
    "\uC30D\uB1FD",
    "\uC30D\uB278",
    "\uC30D\uC5F0",
    "\uC314\uAE84",
    "\uC314\uB07C",
    "\uC314\uB9AC",
    "\uC314\uCEAC",
    "\uC314\uD0A4",
    "\uC315",
    "\uC315\uAC38",
    "\uC315\uAC78",
    "\uC315\uAE84",
    "\uC315\uC218",
    "\uC315\uC2A4",
    "\uC315\uC464",
    "\uC315\uC4F0",
    "\uC329\uBCF4\uC9C0",
    "\uC329\uD3EC\uB974\uB178",
    "\uC330\uC559\uB118",
    "\uC330\uC559\uB140",
    "\uC330\uC559\uB144",
    "\uC330\uC559\uB214",
    "\uC330\uC559\uB278",
    "\uC341\uC0C9",
    "\uC345",
    "\uC345\uB10C",
    "\uC345\uB118",
    "\uC345\uB140",
    "\uC345\uB144",
    "\uC345\uB188",
    "\uC345\uB1EC",
    "\uC345\uC5F0",
    "\uC369\uC744\uB144",
    "\uC385\uC2A4",
    "\uC4F0\uAE00\uB118",
    "\uC4F0\uAE00\uB144",
    "\uC4F0\uAE00\uB188",
    "\uC4F0\uAE00\uB2A0",
    "\uC4F0\uBC1C",
    "\uC4F0\uBC1C\uB118",
    "\uC4F0\uBC8C",
    "\uC4F0\uBD88",
    "\uC4F0\uBDC0",
    "\uC4F0\uBE14",
    "\uC528\uB315",
    "\uC528\uB315\uB144",
    "\uC528\uB385",
    "\uC528\uBC14",
    "\uC528\uBC14\uB77C",
    "\uC528\uBC15",
    "\uC528\uBC1C",
    "\uC528\uBC1C\uB118",
    "\uC528\uBC1C\uB144",
    "\uC528\uBC1C\uB188",
    "\uC528\uBC1C\uB188\uC544",
    "\uC528\uBC29\uC0C8",
    "\uC528\uBC29\uC138",
    "\uC528\uBC54",
    "\uC528\uBC8C",
    "\uC528\uBC8C\uB144",
    "\uC528\uBCA7",
    "\uC528\uBCA8\uB144",
    "\uC528\uBCB5",
    "\uC528\uBD09",
    "\uC528\uBD09\uC54C",
    "\uC528\uBD80\uB784",
    "\uC528\uBD80\uB7F4",
    "\uC528\uBD88",
    "\uC528\uBD88\uB144",
    "\uC528\uBD88\uC5BC",
    "\uC528\uBD95",
    "\uC528\uBDC0",
    "\uC528\uBE0C",
    "\uC528\uBE0C\uB784",
    "\uC528\uBE0C\uB7F4",
    "\uC528\uBE14",
    "\uC528\uBE14\uB144",
    "\uC528\uC559\uB144",
    "\uC528\uC591\uB144",
    "\uC528\uC774\uBC14",
    "\uC528\uC774\uBC1C",
    "\uC528\uC774\uBC29",
    "\uC528\uC774\uBC38",
    "\uC528\uC774\uBC8C",
    "\uC528\uC774\uBE68",
    "\uC528\uC774\uD314",
    "\uC528\uC785\uB144",
    "\uC528\uC785\uB1EC",
    "\uC528\uD30C",
    "\uC528\uD30D",
    "\uC528\uD30F",
    "\uC528\uD314",
    "\uC528\uD314\uB144",
    "\uC528\uD384",
    "\uC539",
    "\uC5398",
    "\uC539\uB118",
    "\uC539\uB144",
    "\uC539\uB188",
    "\uC539\uB1EC",
    "\uC539\uB531\uAFCD",
    "\uC539\uB54C\uAE84",
    "\uC539\uB54C\uB07C",
    "\uC539\uB5BC",
    "\uC539\uB5BC\uB07C",
    "\uC539\uBB3C",
    "\uC539\uBC38",
    "\uC539\uBC8C",
    "\uC539\uBCF4\uC9C0",
    "\uC539\uBCF4\uC9C0\uB144",
    "\uC539\uBE14",
    "\uC539\uBE61",
    "\uC539\uBE68",
    "\uC539\uBED8",
    "\uC539\uC0C8",
    "\uC539\uC0C8\uAE84",
    "\uC539\uC0C8\uB07C",
    "\uC539\uC0C8\uCEAC",
    "\uC539\uC0C8\uD0A4",
    "\uC539\uC0C9\uAE84",
    "\uC539\uC0C9\uB07C",
    "\uC539\uC0C9\uD788",
    "\uC539\uC0DB\uAE38",
    "\uC539\uC0DD\uC54C",
    "\uC539\uC138",
    "\uC539\uC138\uB07C",
    "\uC539\uC138\uC774",
    "\uC539\uC250",
    "\uC539\uC250\uB9AC",
    "\uC539\uC250\uC774",
    "\uC539\uC251",
    "\uC539\uC251\uD788",
    "\uC539\uC314",
    "\uC539\uC314\uAE30",
    "\uC539\uC314\uAE84",
    "\uC539\uC314\uB07C",
    "\uC539\uC314\uD0A4",
    "\uC539\uC384",
    "\uC539\uC384\uB07C",
    "\uC539\uC49C",
    "\uC539\uC528\uD0A4",
    "\uC539\uC54C",
    "\uC539\uC5F0",
    "\uC539\uC9C8",
    "\uC539\uCC3D",
    "\uC539\uD0F1",
    "\uC539\uD0F1\uAD6C\uB9AC",
    "\uC539\uD314",
    "\uC539\uD314\uB144",
    "\uC539\uD314\uB828",
    "\uC539\uD314\uC5F0",
    "\uC539\uD384",
    "\uC539\uD480",
    "\uC539\uD560",
    "\uC539\uD560\uB828",
    "\uC539\uD560\uC5F0",
    "\uC53B\uB07C",
    "\uC53B\uBC1C",
    "\uC53B\uBC8C",
    "\uC53B\uBED8",
    "\uC53B\uD401",
    "\uC53E\uD314",
    "\uC542\uB144",
    "\uC542\uD314",
    "\uC544\uC774\uD15C\uB9E4\uB2C8\uC544",
    "\uC544\uC774\uD15C\uBA54\uB2C8\uC544",
    "\uC544\uC774\uD15C\uBCA0\uC774",
    "\uC548\uC5D0\uC0AC\uC815",
    "\uC54C\uBAB8",
    "\uC54C\uBAB8\uACF5\uAC1C",
    "\uC54C\uBAB8\uC0AC\uC9C4",
    "\uC54C\uBAB8\uC1FC",
    "\uC560\uC561",
    "\uC570\uBCD1",
    "\uC570\uCC3D",
    "\uC57C\uB140",
    "\uC57C\uB3D9",
    "\uC57C\uC124",
    "\uC5C4\uCC3D",
    "\uC5D0\uBBDC",
    "\uC5D0\uBBF8",
    "\uC5EC\uC790\uBCF4\uC9C0",
    "\uC5FC\uBCD1",
    "\uC5FC\uBCD1\uD560",
    "\uC5FF\uBA39",
    "\uC5FF\uBA39\uC5B4",
    "\uC618\uBCD1",
    "\uC624\uB098\uB2C8",
    "\uC624\uB784",
    "\uC624\uB7F4",
    "\uC624\uB7F4\uC139\uC2A4",
    "\uC624\uB974\uAC00\uC998",
    "\uC639\uB140",
    "\uC655\uBCF4\uC9C0",
    "\uC655\uC790\uC9C0",
    "\uC6B0\uB77C\uC9C8",
    "\uC6D0\uC870\uAD50\uC7AC",
    "\uC6D0\uC870\uAD50\uC81C",
    "\uC6D0\uC870\uC54C\uBC14",
    "\uC6D4\uACBD",
    "\uC720\uB450",
    "\uC720\uBC29",
    "\uC721\uBD09",
    "\uC721\uC2DC\uB784",
    "\uC721\uC2DC\uB7F4",
    "\uC724\uAC04",
    "\uC724\uB77D",
    "\uC74C\uACBD",
    "\uC74C\uB2F4\uD328\uC124",
    "\uC74C\uB780",
    "\uC74C\uC21C",
    "\uC74C\uC561",
    "\uC74C\uC695",
    "\uC785\uC0AC\uD6C4\uC7A5",
    "\uC785\uC548\uC0AC\uC815",
    "\uC790\uC704",
    "\uC790\uC704\uAE30\uAD6C",
    "\uC790\uC704\uB0A8",
    "\uC790\uC704\uB140",
    "\uC790\uC9C0",
    "\uC7A1\uB144",
    "\uC7A1\uB188",
    "\uC7A1\uB1EC",
    "\uC813\uAC00\uD2BC",
    "\uC813\uAC19\uC740",
    "\uC813\uAE4C",
    "\uC813\uAE4C\uB294",
    "\uC813\uB098",
    "\uC813\uB098\uAC8C",
    "\uC813\uB9C8\uB09C",
    "\uC813\uB9CC\uD55C",
    "\uC813\uBC25",
    "\uC813\uBE60\uC9C0\uAC8C",
    "\uC815\uBC15\uC544",
    "\uC815\uC790",
    "\uC816",
    "\uC816\uAC00\uD2BC",
    "\uC816\uAC19\uC740",
    "\uC816\uAE4C",
    "\uC816\uAE4C\uB294",
    "\uC816\uAF2D\uC9C0",
    "\uC816\uB098\uAC8C",
    "\uC816\uB3C4",
    "\uC816\uB9C8\uB09C",
    "\uC816\uB9CC\uD55C",
    "\uC816\uBB3C",
    "\uC816\uBC25",
    "\uC816\uBE60\uC9C0\uAC8C",
    "\uC816\uD0F1\uC774",
    "\uC816\uD1B5",
    "\uC870\uAC00\uD2CD",
    "\uC870\uAE4C",
    "\uC870\uAE4C\uB294",
    "\uC870\uAE4C\uB77C",
    "\uC870\uAE4C\uD2BC",
    "\uC870\uB0B8",
    "\uC870\uB610",
    "\uC870\uB8E8",
    "\uC870\uBE60\uB77C",
    "\uC870\uBE60\uC9C0\uAC8C",
    "\uC870\uBE71",
    "\uC870\uC637\uB098",
    "\uC870\uC9C8\uB798",
    "\uC870\uCE74\uD230",
    "\uC870\uD138",
    "\uC871\uAC00\uD2BC",
    "\uC880\uBB3C",
    "\uC883",
    "\uC883\uAC00\uD2BC",
    "\uC883\uAC19\uC740",
    "\uC883\uAE4C",
    "\uC883\uAE4C\uB294",
    "\uC883\uAE4C\uB77C",
    "\uC883\uB098",
    "\uC883\uB098\uAC8C",
    "\uC883\uB3C4",
    "\uC883\uBB3C",
    "\uC883\uBC25",
    "\uC883\uBE60\uC9C0\uAC8C",
    "\uC884\uAE4C",
    "\uC886",
    "\uC886\uAD6C\uB155",
    "\uC886\uAE4C",
    "\uC886\uAE4C\uB294",
    "\uC886\uB098",
    "\uC886\uB300\uAC00\uB9AC",
    "\uC886\uB3C4",
    "\uC886\uBB3C",
    "\uC886\uBC25",
    "\uC887",
    "\uC887\uAE4C",
    "\uC8F3",
    "\uC8F6",
    "\uC8F6\uAC00\uD2BC",
    "\uC8F6\uBE60\uC9C0\uAC8C",
    "\uC9C0\uB784",
    "\uC9EC\uC9C0",
    "\uCC0C\uCC0C",
    "\uCC3D\uB0A8",
    "\uCC3D\uB140",
    "\uCC3D\uB140\uCD0C",
    "\uCC3D\uB144",
    "\uCC3D\uB1E8",
    "\uCC3D\uB1EC",
    "\uCC75\uB140",
    "\uCC75\uB144",
    "\uCC75\uB1EC",
    "\uCC98\uB140\uB9C9",
    "\uCD5C\uC74C\uC81C",
    "\uCE74\uC139",
    "\uCE74\uC139\uC2A4",
    "\uCE90\uC138\uB07C",
    "\uCE90\uC26C\uBC84\uADF8",
    "\uCE90\uC2DC\uBC84\uADF8",
    "\uD070\uBCF4\uC9C0",
    "\uD070\uC790\uC9C0",
    "\uD398\uB2C8\uC2A4",
    "\uD3EC\uB974\uB178",
    "\uD3EC\uB974\uB178\uC0AC\uC9C4",
    "\uD3EC\uB974\uB178\uC139\uC2A4",
    "\uD3F0\uC0C9",
    "\uD3F0\uC138\uC5D1",
    "\uD3F0\uC139",
    "\uD3F0\uC139\uC2A4",
    "\uD3F0\uC251",
    "\uD3F0\uC315",
    "\uD3F0\uC385",
    "\uD504\uB9AC\uC139\uC2A4",
    "\uD50C\uB808\uC774\uBCF4\uC9C0",
    "\uD55C\uBC88\uAF42\uC790",
    "\uD55C\uBC88\uC8FC\uAED8",
    "\uD55C\uBC88\uC904\uB798",
    "\uD565\uC544\uC8FC\uAED8",
    "\uD567\uC544\uC904\uAED8",
    "\uD568\uB300\uC8FC\uAE4C",
    "\uD568\uB300\uC904\uB798",
    "\uD568\uBE68\uC790",
    "\uD56D\uBB38",
    "\uD5C8\uBC8C",
    "\uD5C8\uBC8C\uCC3D",
    "\uD638\uB85C\uB144",
    "\uD638\uB85C\uC0C8\uB07C",
    "\uD638\uB85C\uC0C8\uB9AC",
    "\uD638\uB85C\uC0C9",
    "\uD638\uB85C\uC0C9\uB07C",
    "\uD638\uB85C\uC790\uC2A5",
    "\uD638\uB85C\uC790\uC2DD",
    "\uD638\uBAA8\uC139\uAE30",
    "\uD638\uBAA8\uC384\uB07C",
    "\uD638\uBE60",
    "\uD638\uC2A4\uD2B8\uBC14",
    "\uD638\uC2A4\uD2B8\uBE60",
    "\uD63C\uC74C",
    "\uD654\uB0E5",
    "\uD654\uB0E5\uB144",
    "\uD654\uB958",
    "\uD654\uC591\uB144",
    "\uD6C4\uB808\uC790\uC2DD",
    "\uD6C4\uC7A5",
    "\uD6C4\uC7A5\uC785\uC0AC",
    "ac\uBC1C",
    "x\uB300\uAC00\uB9AC",
    "\uAC04\uB098\uC0C8\uB07C",
    "\uAC04\uB098",
    "\uAC1C\uAC04\uB098",
    "\uC30D\uAC04\uB098",
    "\uC885\uAC04\uB098",
    "\uC886\uAC04\uB098",
    "\uAC1C\uD310",
    "\uAC1C\uAF34\uD1B5",
    "\uAC1C\uB625\uCC28",
    "\uAC1C\uC30D\uD310",
    "\uAC1C\uAFC8",
    "\uAC1C\uC218\uC791",
    "\uAC1C\uB9DD\uB098\uB2C8",
    "\uAC1C\uB3FC\uC9C0",
    "\uAC1C\uC4F0\uB808\uAE30",
    "\uAC1C\uC871\uC0C8",
    "\uAC1C\uCC28\uBC18",
    "\uAC1C\uCD08\uB529",
    "\uAC78\uB808",
    "\uACE0\uC790",
    "\uAD11\uB140",
    "\uAD11\uB144\uC774",
    "\uAD34\uB8B0",
    "\uAD34\uB8B0\uAD70",
    "\uADF8\uC9C0\uAE7D\uAE7D\uC774",
    "\uAE09\uC2DD\uCDA9",
    "\uAE40\uCE58\uB140",
    "\uAE40\uCE58\uB0A8",
    "\uAEBC\uBC99\uC774",
    "\uAF2C\uBD95",
    "\uAF30\uB300",
    "\uAF34\uD1B5",
    "\uB0A8\uCC3D",
    "\u3134\u3137\u3146",
    "\uB290\uAC1C\uBE44",
    "\uB290\uAE08\uB9C8",
    "\uB2C8\uBBF8",
    "\uB2C8\uAE30\uBBF8",
    "\uB2E5\uCCD0",
    "\uB530\uAE4C\uB9AC",
    "\uB610\uB77C\uC774",
    "\uB618\uCD94",
    "\uB809\uCE74\uCDA9",
    "\uB9D8\uCDA9",
    "\uB9E4\uAD6D\uB178",
    "\uBA38\uC800\uB9AC",
    "\uBA39\uC0AC",
    "\uBA4D\uCCAD\uB3C4",
    "\uBA54\uAC08\uB9AC\uC544",
    "\uC6CC\uB9C8\uB4DC",
    "\uBCF4\uC2AC\uC544\uCE58",
    "\uBB34\uB1CC",
    "\uBB34\uB1CC\uCDA9",
    "\uBBF8\uCE5C\uAC1C",
    "\uBC14\uBCF4",
    "\uBC84\uB7EC\uC9C0",
    "\uBCC0\uD0DC\uC0C8\uB07C",
    "\uBC8C\uB808\uC0C8\uB07C",
    "\uBCF4\uC804\uAE68",
    "\uBCF4\uC9C0\uB144",
    "\uBCF4\uCD94",
    "\uBE60\uB3FC\uC30D",
    "\uBE68\uD1B5",
    "\uBE61\uB300\uAC00\uB9AC",
    "\uBE68\uAC31\uC774",
    "\uC2F8\uC774\uCF54",
    "\uC0AC\uC774\uCF54",
    "\uC0C1\uD3D0\uB140",
    "\uC0C1\uD3D0\uB144",
    "\uC0C1\uD3D0\uB188",
    "\uC369\uC744\uB188",
    "\uC528\uBC29\uB188",
    "\uC528\uBC29\uB144",
    "\uC2DC\uBD80\uB784",
    "\uC539\uCC3D\uB144",
    "\uC539\uB355",
    "\uC539\uC4F0\uB808\uAE30",
    "\uC539\uCE58\uB0A8",
    "\uC539\uCE58\uB144",
    "\uC30D\uB178\uBB34\uC0C8\uB07C",
    "\uC544\uB2E4",
    "\uD6C4\uB2E4",
    "\uC560\uBE44\uCDA9",
    "\uC560\uC0C8\uB07C",
    "\uC560\uC790",
    "\uC591\uB188",
    "\uC570\uD751",
    "\uC5E0\uCC3D",
    "\uB2C8\uBBF8\uC528\uBC1C",
    "\uC624\uC720\uCDA9",
    "\uC6B4\uC9C0",
    "\uC721\uBCC0\uAE30",
    "\uC751 \uB2C8\uC560\uBBF8",
    "\uC778\uC870\uC0C8",
    "\uC77C\uBCA0\uCDA9",
    "\uC800\uB2A5\uC544",
    "\uC815\uC2E0\uBCD1\uC790",
    "\uC81C\uAE30\uB784",
    "\uC81C\uAE38",
    "\uC878\uB77C",
    "\uC886\uB9DD",
    "\uC886\uBB34\uC704\uD0A4",
    "\uC886\uB9CC\uC774",
    "\uC874\uB9CC\uC774",
    "\uC886\uC9D1",
    "\uC886\uC2EC",
    "\uC886\uBCD1\uC2E0",
    "\uC950\uC0C8\uB07C",
    "\uC950\uBC15\uC774",
    "\uC9ED\uC0C8",
    "\uC9F1\uAE68",
    "\uCABC\uB2E4",
    "\uCA4C\uB9AC",
    "\uCABD\uBC1C\uC774",
    "\uCABD\uBC14\uB9AC",
    "\uCAC4\uBCF4",
    "\uCC0C\uB7AD\uC774",
    "\uCC0C\uC9C8\uC774",
    "\uCC10\uB530",
    "\uCC10\uCC0C\uBC84\uAC70",
    "\uCC3D\uB188",
    "\uCD1B\uBD88\uC880\uBE44",
    "\uCD5C\uC21C\uC2E4",
    "\uCD94\uB0A8",
    "\uCD94\uB140",
    "\uD2B8\uB864",
    "\uD2C0\uB531\uCDA9",
    "\uD53C\uC2F8\uAC1C",
    "\uD55C\uB0A8",
    "\uD55C\uB0A8\uCDA9",
    "\uD55C\uB140",
    "\uD55C\uB140\uCDA9",
    "\uD638\uAD6C",
    "\uD638\uBAA8",
    "\uD6C4\uBE68",
    "\uD751\uD615",
    "\uB545\uD06C",
    "\uB2EC\uCC3D",
    "\uB124\uB2E4\uD64D",
    "\uB808\uC774\uB514\uAC00\uCE74",
    "\uB808\uC774\uB514 \uAC00\uCE74",
    "\uBBFC\uC8FC\uD654",
    "\u3141\u3148\u314E",
    "\uC804\uB545\uD06C",
    "\uBCF4\uBE68",
    "\uC0B0\uC5C5\uD654",
    "\uC2A8\uC0C1",
    "\uC2A8\uD0C4\uC808",
    "\uC2A8\uC0AD\uC808",
    "\uC2A8\uC0C1\uADF8\uB77C\uB4DC",
    "\u3147\u3142",
    "\uC554\uBCA0",
    "\uC559\uB9DD",
    "\uC5D1\uC73D",
    "\uC5D1\uC73D\uC5D1\uC5D1",
    "\uC5D1\uC5D1\uC73D\uC5D1",
    "\uC5D8\uC824\uB450\uD658",
    "\uC5D4\uB450\uB098",
    "\uC6D0\uC870\uAC00\uCE74",
    "\uAC00\uCE74",
    "\uC774\uC2DC\uAD6D\uCDA9",
    "\uC77C\uAC8C\uC774",
    "\uC77C\uBC0D\uC544\uC6C3",
    "\uD30C\uC624\uD6C4",
    "\uCFF0\uCC99\uCFF0\uCC99",
    "\uD5C8\uBC84\uD5C8\uBC84",
    "\uD3ED\uB3D9\uC808",
    "\uD601\uBA85\uC808",
    "\uD0D5\uD0D5\uC808",
    "\uD63C\uBAA8\uB178",
    "MC\uBB34\uD604",
    "\uB178\uBB34",
    "\uB178\uC54C\uB77C",
    "\uB178\uC6B4\uC9C0",
    "\uB178\uD0C4\uC808",
    "\uB1CC\uBB3C\uD604",
    "\uBD80\uC5C9\uC774\uBC14\uC704",
    "\uC774\uAE30\uC57C",
    "\uC911\uB825\uC808",
    "\uC6B4\uC9C0\uC808",
    "\uB2EC\uBE5B\uAE30\uC0AC\uB2E8",
    "\uBC15\uC0AC\uBAA8",
    "\uAD00\uC7A6",
    "\uAD00\uC886",
    "\uAD70\uBB34\uC0C8",
    "\uAD70\uCF85\uC774",
    "\uAE40\uC544\uC7AC",
    "\uAF41\uCE58\uB0A8",
    "\uB0C4\uC838",
    "\uB0C4\uC801\uB0C4",
    "\uB290\uAC2D",
    "\uBE60\uAC00\uB0A8",
    "\uC18C\uCD94",
    '6.9',
    "\uC2F8\uD280\uCDA9",
    "\uB300\uB514\uCDA9",
    "\uC560\uD638\uBC15\uB0A8",
    "\uC640\uB784\uB784\uB77C",
    "\uC790\uB315\uC774",
    "\uC790\uB989\uB0B4",
    "\uC790\uB4E4\uC790\uB4E4",
    "\uC790\uC774\uB8E8",
    "\uC790\uC801\uC790",
    "\uC790\uD610",
    "\uC870\uD314",
    "\uC886\uB4E4\uC886\uB4E4",
    "\uC886\uC2A4\uD50C\uB808\uC778",
    "\uC904\uC4F0\uCF58",
    "\uD325\uC8FD\uB0A8",
    "\uD6C4\uC804\uAE68",
    "\uD55C\uB0A8\uC720\uCDA9",
    "\uD568\uD765\uC790\uC9C0",
    "\uC6B4\uB3D9\uAD8C",
    "\uAFD8",
    "\uBC29\uAD00\uCDA9",
    "\uBC15\uADFC\uD61C",
    "\uBB38\uC7AC\uC778",
    "\uC774\uBA85\uBC15",
    "\uC804\uB450\uD658",
    "\uAE40\uB300\uC911",
    "\uBC15\uC815\uD76C",
    "\uB178\uD0DC\uC6B0",
    "\uAE40\uC601\uC0BC",
    "\uB178\uBB34\uD604",
    "\uBC88\uD0C8\uB0A8",
    "\uC790\uB974\uC14B",
    "\uC790\uD2B8\uB9AD\uC2A4",
    "\uC886\uC758\uC219\uC8FC",
    "\uD55C\uB0A8\uB610",
    "\uD5C8\uC218\uC560\uBE44",
    "\uD22C\uBA85\uC560\uBE44",
    "\uC539\uCE58",
    "\uC7AC\uAE30\uD558\uB2E4",
    "\uBA85\uC790",
    "\uAC13\uCE58",
    "\uBCF4\uC9C0\uB300\uC7A5\uBD80",
    "\uC131\uB2D8",
    "\uD0C8\uCF54\uB974\uC14B",
    "\uBCF4\uB825\uC9C0\uC6D0",
    "\uD749\uC790",
    "\uAC00\uC886",
    "\uAE30\uC218\uC9D3",
    "\uAE30\uC548\uB0B4",
    "\uB0A8\uB9AC\uB0A8\uB9AC",
    "\uB625\uB0D0",
    "\uB9DD\uD63C",
    "\uBC14\uC6A9\uAC00",
    "\uC4F0\uAE4C\uD398\uBBF8",
    "\uC571\uCE5C",
    "\uC571\uD2F0\uC5E0",
    "\uC815\uD608",
    "\uC820\uC2E0\uBCD1\uC790",
    "\uD558\uC6A9\uAC00",
    "\uD610\uC560",
    "\uD798\uC870",
    "\uD798\uC8E0",
    "\uD64D\uBCF8\uC790\uBB34\uC8C4",
    "6\uC791\uC740\uB530\uC634\uD45C9",
    "66\uD070\uB530\uC634\uD45C99",
    "\uC886\uD55C\uBBFC\uAD6D",
    "\uAC1C\uC800\uC528",
    "\uD398\uBBF8\uB2C8\uC998",
    "\uD398\uBBF8\uB098\uCE58",
    "\uD2B8\uD398\uBBF8",
    "\uBCD1\uC2E0\uC0C8\uB07C",
    "\uC886\uB098\uAC8C",
    "\uC874\uB098\uAC8C",
    "\uC804\uB098\uAC8C",
    "\uC878\uB77C\uAC8C",
    "\uC808\uB77C\uAC8C",
    "\uC874\uB098",
    "\uC816\uB098",
    "\uC804\uB098",
    "\uC808\uB77C",
    "\uC886\uB9CC\uD55C",
    "\uC883\uB9CC\uD55C",
    "\uC874\uB9CC\uD55C",
    "\uC886\uB9C8\uB09C",
    "\uC883\uB9C8\uB09C",
    "\uC874\uB9C8\uB09C",
    "\uC886\uAC19\uC740",
    "\uC886\uAC00\uD2BC",
    "\uC883\uAC00\uD2BC,",
    "\uC800\uAE4C\uD2BC",
    "\uC886\uBE60\uC9C0\uAC8C",
    "\uC800\uBE60\uC9C0\uAC8C",
    "\uC881\uBC25",
    "\uC811\uBC25",
    "\uC800\uBE71",
    "\uC800\uAE4C",
    "\uC528\uC774\uBD88",
    "\uB760\uBC1C",
    "\uB760\uBC8C",
    "\uB760\uBD88",
    "\uB760\uBC29",
    "\uB760\uBC14",
    "\uB760\uBD95",
    "\uB760\uBC38",
    "\uB760\uD314",
    "\uB760\uD384",
    "\uC2DC\uBC8C",
    "\uC2DC\uD314",
    "\uC2DC\uC774\uBC1C",
    "\uC2DC\uC774\uBC8C",
    "\uC2DC\uC774\uBD88",
    "\uC2DC\uC774\uBC14",
    "\uC2DC\uC774\uBD95",
    "\uC2DC\uC774\uBD80",
    "\uC2DC\uC774\uBC38",
    "\uC2DC\uC774\uD314",
    "\uC2DC\uC774\uD384",
    "\uC2DC\uC774\uD480",
    "\uC2DC\uC774\uBE61",
    "\uC4B8\uBC1C",
    "\uC4B8\uBC8C",
    "\uC4B8\uBD88",
    "\uC4B8\uBC29",
    "\uC4B8\uBC14",
    "\uC4B8\uBE61",
    "\uC4B8\uC774\uBC1C",
    "\uC4B8\uC774\uBC8C",
    "\uC4B8\uC774\uBD88",
    "\uC4B8\uC774\uBC29",
    "\uC4B8\uC774\uBC14",
    "\uC26C\uBC1C",
    "\uC26C\uBC8C",
    "\uC26C\uBD88",
    "\uC26C\uBC29",
    "\uC26C\uBC14",
    "\uC26C\uBD95",
    "\uC26C\uBD80",
    "\uC26C\uBC38",
    "\uC26C\uD314",
    "\uC26C\uD480",
    "\uC26C\uBE61",
    "\uC4F0\uBC29",
    "\uC4F0\uBC14",
    "\uC4F0\uBD95",
    "\uC4F0\uBD80",
    "\uC4F0\uBC38",
    "\uC4F0\uD314",
    "\uC4F0\uD384",
    "\uC4F0\uD480",
    "\uC4F0\uBE61",
    "\uC4F0\uC774\uBC1C",
    "\uC4F0\uC774\uBC8C",
    "\uC4F0\uC774\uBD88",
    "\uAE4C\uB300",
    "\uAE4C\uB304",
    "\uB2C8\uBBF8\uB8F0",
    "\uC81C\uAE30\uB7F4",
    "\uC81C\uAE30\uB864",
    "\uC81C\uAE30\uB8F0",
    "\uB2DD\uAE30\uBBF8",
    "\uB2C8\uC8FC\uAC00\uB9AC",
    "\uAC1C\uB10C",
    "\uC9C0\uB7F4",
    "\uC9C0\uB864",
    "\uC950\uB784",
    "\uC950\uB7F4",
    "\uC950\uB864",
    "\uB4F1\uC2E0",
    "\uBBF8\uCDEC\uB188",
    "\uBBF8\uCDEC\uB118",
    "\uBBF8\uCE5C\uB10C",
    "\uBBF8\uCDEC\uB1EC",
    "\uBBF8\uCDEC\uB10C",
    "\uC2F8\uAC00\uC9C0",
    "\uC2F9\uC544\uC9C0",
    "c\uD314",
    "\uAC1C\uAC19\uC740\uB144",
    'c8',
    "\uAC1C\uAC19\uC740\uB188",
    "\uC51D\uD560",
    "\uC250\uB07C",
    "\uC1C4\uB07C",
    "\uC1C5\uB07C",
    "\uC528\uD0A4",
    "\u3145 \u3150\uB07C",
    "\u3145 \u3150\u3132 \u3163",
    "\u3145 \u3150 \u3132 \u3163",
    "\uC2DC\uBC1C",
    "\uC2C0\uBC1C",
    "\uC2A4\uBC1C",
    "\uC2A4\uBC8C",
    "\uC26C\uC774\uBC1C",
    "\uC4F0\uC73C\uBC29",
    "\uC26C\uBE68",
    "\uC26C\uD30D",
    "\uC501\uC54C",
    "\uC51D\uC54C",
    "\uC51D\uD0F1",
    "\uC874\uB2C8",
    "\uC8F6\uB098",
    "\uC8E8\uB77C",
    "\uC8F6\uB2C8",
    "\uC8E4\uB2C8",
    "\uC8E4\uB098",
    "\uC8F6\uB9C8\uB09C",
    "\uC8F6\uAC19\uC740",
    "\uC9A4\uB784",
    "\uC9C8\uC54C",
    "\u3147\u3150\uC790",
    "\uB2C8\uC5E0",
    "\uBBDC\uCE5C",
    "\u3141l\uCE5C",
    "\uC560\uC7C8",
    "\uB5A0\uB77C\uC774",
    "\u3146l\uD314",
    "\u3146l\uBC1C",
    "\u3134 \u3163\u3141 \u3163",
    "\u3134l\u3141l",
    "\uB2AC\uBBF8",
    "\uB2C8\uBBDC",
    "\uC4F0\uD30D",
    "\uC50C\uD314",
    "\uC50C\uBC1C",
    "\uC2C0\uD314",
    "\u31461\uD314",
    "\u31461\uBC1C",
    "\uACC4\uAC19\uC740\uB1EC",
    "\uAC1C\uAC19\uC740\uB1EC",
    "\uC8F3\uB098",
    "\uB2C8\uC570",
    "\uC560\uBBF8",
    "\uC539\uB561",
    "\uC51D\uB144",
    "\u3131H\uB1EC",
    "\uC50C\uBC8C",
    "\uC2C0\uBC29",
    "\uC2C0\uBD09",
    "\uC50C\uBC29",
    "\u3146I\uBC1C",
    "\u31451\uBC1C",
    "\u31341\u3147H\uBBF8",
    "\u3148l\uB784",
    "\uBBF8\uCE40",
    "\uD638\uB85C\uC790\uC2A5\uC560",
    "\uC820\uC7A5",
    "\uC831\uC7A5",
    "\uC81C\uAE1C",
    "\uC81D\uC77C",
    "\uBC14\uBD80",
    "\uB4D5\uC2E0",
    "\uC528\uBCA8",
    "\uC2DC\uBCB5",
    "\uC2DC\uD384",
    "\uB4F1\uC26C",
    "\uB2AC\uADC0\uBBF8",
    "\uC528\uBC1D",
    "\uAC1C\uC0DB\uB07C",
    "\uAC1C\uC4F0\uB809\uAE30",
    "\uC26C\uD0A4",
    "\uC138\uCEAC",
    "\uC2DD\uD0A4",
    "\uC2DC\uD0A4",
    "\uC0C8\uCEAC",
    "\uB4D5\uC2DC\uB098",
    "\uB618\uC544\uC774",
    "\u31411\uCE5C",
    "\u31411\uCE5C\uB144",
    "\uBB88\uCDEC",
    "\uBB88\uCE5C\uB144",
    "\uBBF8\uCDD0",
    "\uBBF8\uCDD0\uB144",
    "\uBC0F\uCE5C",
    "\uBCB5\uC2E0",
    "\uBCD1\uC2DC\uB098",
    "\uBCD1\uC2DC",
    "\uBDE9\uC2DC",
    "\uC0C9\uADC0",
    "\uC165\uC0C8",
    "\uC27D\uB144",
    "\uC27D\uC0C8",
    "\uC2DC\uBC14\uB77C",
    "\uC27D\uD314",
    "\uC2DC\uBC1D",
    "\uC2DC\uBCA8",
    "\uC2ED\uC0F9",
    "\u3146\u2502\uBC1C",
    "\uC4B8\uBC45",
    "\uC50C\uD30C",
    "\uC50C\uBE68",
    "\uC50C\uBC38",
    "\uC50C\uBC14",
    "\uC4B8\uBC15",
    "\uC528\uBC45",
    "c\uBC1C",
    "g\uB784",
    "zl\uB784",
    "\u51F8,\uBBF8\uC6CC",
    "\uB258\uBBF8",
    "\uB258\uADC0\uBBF8",
    "^^\u3163\uBC1C",
    "\u3131 \u3150",
    "\u3145 \u3150\u3131\u3131\u3163",
    "\u3131H",
    "\u3145 \u3154\u3132 \u3163",
    "\u3145H\u3132I",
    "\u3145H\uB07C",
    "\u3145 \u3154\u3132",
    "\u31451\uD314",
    "\u3146 \u3163\uBD88",
    "\u3146\u3142",
    "\u3145\u3142",
    "\uC539\uBC1C",
    "\uAC1C`",
    "\uAC1C\uC1C4",
    "\uC528`\uBC1C",
    "\uC0C8'\uAE84",
    "\uC0C8'\uB07C",
    "\uC100\uCEAC",
    "\uC0F9\uB1EC",
    "\uC1C4\uD0A4",
    "\uC100\uB07C",
    "\uC314\uAE30",
    "\u3141 \u3163\uCE5C",
    "\uB9DD\uD560",
    "\uC528'\uBC1C",
    "\uC528\uBE68",
    "\uC539\uC30D",
    "\u31481\uB784",
    "\u3146 \u3163\uBC1C",
    "\u3146 \u3163\uBC29",
    "\u3146 \u3163\uD314",
    "\u3146 \u3163\uBC8C",
    "\u3146!\uBC1C",
    "\uC4B8\uBCA8",
    "\uB4F1\uC270",
    "\uB618\uCE04",
    "\u3134 \u3163\uBBF8",
    "\u3134 \u3163\u3131 \u3163",
    "\u31341\u31311",
    "\u31341\u31411",
    "\u31341\uBBF8",
    "\u31341 \u3147 \u3150",
    "\u31341 \uC560",
    "\uB2C8M\uCC3D",
    "\uB2C8OH\uBBF8",
    "\uC2DC\uD30D",
    "\uC2DC\uBE68",
    "\uC2DC\uD30C",
    "\uC2DC\uBC38",
    "\uC27D\uB1EC",
    "\uAC1C\uB828",
    "\u31461\uBC38",
    "\u31461\uBCA8",
    "\uC50C\uBCA8",
    "\uC560\uC88C",
    "\uC53B\uD314",
    "\u31461\uBC14",
    "\uAC1C\uC0DB\uD788\uC560",
    "\uC0C9\uD718",
    "\uC139\uD0A4",
    "\uC4C9\uB144",
    "\uC4C9\uCC3D",
    "\uD638\uB85C\uC790\uC2DD\uC560",
    "\uC50C\uBC45",
    "\uC528\uD330",
    "\uC50C\uB315",
    "\uC50C\uB385",
    "\uC5E0\uBCD1",
    "\uD6C4\uB808\uC790\uC2DD\uC560",
    "\uD6C4\uB808\uC790\uC2A5\uC560",
    "\uD6C4\uB808\uB144",
    "\uC539\uBE60",
    "\uBED1\uD050",
    "\u3143r\uD050",
    "\uAC1C\uC100\uB07C",
    "\uAC1C\uC0F9\uB828",
    "\uB2C8\uBB88\uB7F4",
    "\uB2AC\uAE30\uBBF8",
    "\uC4F0\uBC15",
    "\uC539\uC0F9",
    "\uC5F0\uBCD1",
    "\uC2DC\uBC1F",
    "\uB4A4\uC838",
    "\uC9DC\uC838",
    "\uAEBC\uC838",
    "\uB4A4\uC9C8\uB798",
    "\uB514\uC9C8\uB798",
    "\uC544\uAC08",
    "\uD5C8\uC811",
    "\uD750\uC811",
    "\uB099\uD0DC\uC544",
    "\uB2E4\uBC29\uB144",
    "\uC560\uBE44\uC790\uC9C0",
    "\uC560\uBBF8\uBCF4\uC9C0",
    "\uC7A0\uC9C0",
    "\uACF5\uC54C",
    "\uB538\uB530\uB9AC",
    "\uC139\uC4F0",
    "\uC385\uC4F0",
    "\uAC1C\uC2D1\uCC3D",
    "\uC8F7",
    "\uC887\uB098",
    "\uC6A7\uB098",
    "\uC7C8\uC9C0",
    "\uC8E0\uB610",
    "\uC8F5\uB098",
    "\uC790\uC963",
    "\uC8E0\uBE60",
    "\uCAD3\uAE4C",
    "\uC8E1\uCCD0",
    "\uC7D8\uC950",
    "\uAF2C\uCD94",
    "\uAF2C\uCE04",
    "\uAC78\uB808\uB144",
    "\uACE7\uD734",
    "\uC7D8\uC9C0",
    "\u3148 \u314F\u3148 \u3163",
    "\u3148 \u314F\uC9C0",
    "\uC790\uC950",
    "\uC7A0\uC950",
    "\uBCF4'\uC9C0",
    "\uC139'\uC2A4",
    "\uCC28\uC559\uB144",
    "\uCC3D\u3134 \u3155",
    "\uCD39\uB144",
    "\uCD39\uB1EC",
    "\u3143r\uAD74",
    "\uACE0\uCE04",
    "\uC8E0\uAE4C",
    'sex',
    'fuck',
    'fuk',
    'porno',
    'dildo',
    'pussy',
    'shit',
    'bitch',
    'anal',
    'fetish',
    'gay',
    'lesbien',
    'bastard',
    'cunt',
    'damn',
    'asshole',
    "\uADC0\uB450"
];
const $ad54f78bb65efc46$export$3d3dfb6b953b083 = [
    'admin',
    'master',
    'test'
];



const $f42572f639d7eece$export$8ed14f7d88366aa1 = [
    {
        name: "\uB0A8",
        value: 'M'
    },
    {
        name: "\uC5EC",
        value: 'F'
    }
];
function $f42572f639d7eece$var$convertGenderName(value) {
    let result = '';
    $f42572f639d7eece$export$8ed14f7d88366aa1.map((data)=>{
        if (data.value === value) result = data.name;
    });
    return result;
}
function $f42572f639d7eece$var$convertGenderValue(name) {
    let result = '';
    $f42572f639d7eece$export$8ed14f7d88366aa1.map((data)=>{
        if (data.name === name) result = data.value;
    });
    return result;
}
function $f42572f639d7eece$var$checkValidBirthday(value) {
    let replaceValue = value.replace(/[^0-9]/g, '');
    let errMsg = '';
    if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(replaceValue)) errMsg = "\uC0DD\uB144\uC6D4\uC77C 8\uAE00\uC790\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.";
    else if (replaceValue.length >= 4) {
        if ($f42572f639d7eece$var$calcAge(replaceValue) < 14) errMsg = "\uB9CC 14\uC138 \uC774\uC0C1\uBD80\uD130 \uC0AC\uC6A9\uD558\uC2E4 \uC218 \uC788\uC5B4\uC694.";
        else if (Number(replaceValue.substring(0, 4)) <= 1921) errMsg = "1921\uB144 \uC774\uC804 \uCD9C\uC0DD\uC790\uB294 \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4.";
        else if (replaceValue.length === 6 && !$f42572f639d7eece$var$checkMonth(replaceValue)) errMsg = "\uC62C\uBC14\uB978 \uC0DD\uB144\uC6D4\uC77C\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.";
        else if (replaceValue.length === 8 && (!$f42572f639d7eece$var$checkMonth(replaceValue) || !$f42572f639d7eece$var$checkDay(replaceValue))) errMsg = "\uC62C\uBC14\uB978 \uC0DD\uB144\uC6D4\uC77C\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.";
        else if (replaceValue.length < 8) errMsg = "\uC0DD\uB144\uC6D4\uC77C 8\uAE00\uC790\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.";
        else {
            replaceValue = replaceValue.replace(/(\d{4})(\d{2})(\d{2})/g, '$1.$2.$3');
            errMsg = '';
        }
    } else if (replaceValue.length < 8) errMsg = "\uC0DD\uB144\uC6D4\uC77C 8\uAE00\uC790\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.";
    else {
        replaceValue = replaceValue.replace(/(\d{4})(\d{2})(\d{2})/g, '$1.$2.$3');
        errMsg = '';
    }
    return {
        value: replaceValue,
        errMsg: errMsg
    };
}
const $f42572f639d7eece$var$checkMonth = (value)=>{
    const month = Number(value.substring(4, 6));
    return !(month < 1 || month > 12);
};
const $f42572f639d7eece$var$checkDay = (value)=>{
    const year = Number(value.substring(0, 4));
    const isLeapYear = year % 4 == 0 && year % 100 === 0 && year % 400 === 0; //윤년체크
    const month = Number(value.substring(4, 6));
    const day = Number(value.substring(6, 8));
    const days31 = [
        1,
        3,
        5,
        7,
        8,
        10,
        12
    ];
    const days30 = [
        4,
        6,
        9,
        11
    ];
    if (month === 2) {
        if (isLeapYear && (day < 1 || day > 29)) return false;
        if (!isLeapYear && (day < 1 || day > 28)) return false;
    } else if (days31.includes(month) && (day < 1 || day > 31)) return false;
    else if (days30.includes(month) && (day < 1 || day > 30)) return false;
    return true;
};
function $f42572f639d7eece$var$calcAge(value) {
    const year = Number(value.substring(0, 4));
    const month = Number(value.substring(4, 6));
    const day = Number(value.substring(6, 8));
    const today = new Date();
    const birthDate = new Date(year, month, day);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) age--;
    return age;
}
function $f42572f639d7eece$var$checkValidTall(value) {
    let errMsg;
    if (/^[\d]*\.?[\d]{0,1}$/.test(value.replace(' cm', ''))) {
        const tall = Number(value);
        if (tall < 100 || tall > 250) errMsg = "\uC2E4\uC81C \uD0A4\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.";
        else errMsg = '';
    } else errMsg = "\uC2E4\uC81C \uD0A4\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.";
    return {
        value: value,
        errMsg: errMsg
    };
}
function $f42572f639d7eece$var$checkValidNickName(value) {
    let errMsg = '';
    if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(value)) errMsg = "\uB2C9\uB124\uC784\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.";
    else if (value.length > 20) errMsg = "\uCD5C\uB300 20\uC790\uAE4C\uC9C0 \uC785\uB825\uD558\uC2E4 \uC218 \uC788\uC5B4\uC694.";
    else if ($f42572f639d7eece$var$includeSlangWord(value)) errMsg = "\uBE44\uC18D\uC5B4\uB294 \uC0AC\uC6A9\uD558\uC2E4 \uC218 \uC5C6\uC5B4\uC694.";
    else if ($f42572f639d7eece$var$includeForbiddenWord(value)) errMsg = "\uC0AC\uC6A9\uD558\uC2E4 \uC218 \uC5C6\uB294 \uB2C9\uB124\uC784\uC774\uC5D0\uC694.";
    else if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(value.replaceAll(' ', ''))) errMsg = "\uC0AC\uC6A9\uD558\uC2E4 \uC218 \uC5C6\uB294 \uB2C9\uB124\uC784\uC774\uC5D0\uC694.";
    else errMsg = '';
    return {
        value: value,
        errMsg: errMsg
    };
}
function $f42572f639d7eece$var$includeSlangWord(value) {
    for (const word of (0, $ad54f78bb65efc46$export$7c69d0d1979f52dd)){
        if (value.toUpperCase().includes(word.toUpperCase())) return true;
    }
    return false;
}
function $f42572f639d7eece$var$includeForbiddenWord(value) {
    for (const word of (0, $ad54f78bb65efc46$export$3d3dfb6b953b083)){
        if (value.toUpperCase().includes(word.toUpperCase())) return true;
    }
    return false;
}
function $f42572f639d7eece$var$checkDuplicate(value) {
    return (0, $4d624a4edc63c668$export$2e2bcd8739ae039).checkNickNmDuplicate(value).then((res)=>res.data).catch(()=>false);
}
function $f42572f639d7eece$var$checkEmailDuplicate(value) {
    return (0, $4d624a4edc63c668$export$2e2bcd8739ae039).checkEmailDuplicate(value).then((res)=>res.data).catch(()=>false);
}
function $f42572f639d7eece$var$checkValidEmail(value) {
    const resultValue = value.replaceAll(' ', '');
    let errMsg = "\uC62C\uBC14\uB978 \uC774\uBA54\uC77C \uC8FC\uC18C\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694.";
    try {
        const result1 = value.indexOf('@');
        const result2 = value.indexOf('.');
        const result3 = value.split('@');
        const result4 = result3[1].split('.');
        const result6 = result3[1].indexOf('.');
        const result5 = value.split('@').length - 1;
        if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(resultValue)) errMsg = "\uC774\uBA54\uC77C\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.";
        else if (result1 < 0 || result2 < 0) ;
        else if (result5 > 1) ;
        else if (result6 < 0) ;
        else if (result3[0].length < 2 || result4[0].length < 2 || result4[result4.length - 1].length < 2) ;
        else errMsg = '';
    } catch (e) {
        return {
            value: resultValue,
            errMsg: errMsg
        };
    }
    return {
        value: resultValue,
        errMsg: errMsg
    };
}
function $f42572f639d7eece$var$checkValidPwd(value) {
    const resultValue = value.replaceAll(' ', '');
    const regType1 = /^[A-Za-z0-9!@#$%^&*()]+$/;
    const regType2 = /^[A-Za-z]+$/;
    const regType3 = /^[0-9]+$/;
    let errMsg = '';
    try {
        if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(resultValue)) errMsg = "\uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.";
        else if (value.length < 10) errMsg = "\uC601\uBB38, \uC22B\uC790 \uD3EC\uD568 10\uC790 \uC774\uC0C1 \uC785\uB825\uD574 \uC8FC\uC138\uC694.";
        else if (!regType1.test(resultValue)) errMsg = "\uC601\uBB38\uACFC \uC22B\uC790\uB9CC \uC785\uB825\uD574 \uC8FC\uC138\uC694.";
        else if (regType2.test(resultValue) || regType3.test(resultValue)) errMsg = "\uC601\uBB38, \uC22B\uC790\uB97C \uBAA8\uB450 \uD3EC\uD568\uD574\uC11C \uC785\uB825\uD574 \uC8FC\uC138\uC694.";
    } catch (e) {
        errMsg = "\uC62C\uBC14\uB978 \uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574 \uC8FC\uC138\uC694.";
        return {
            value: resultValue,
            errMsg: errMsg
        };
    }
    return {
        value: resultValue,
        errMsg: errMsg
    };
}
var $f42572f639d7eece$export$2e2bcd8739ae039 = {
    convertGenderName: $f42572f639d7eece$var$convertGenderName,
    checkValidBirthday: $f42572f639d7eece$var$checkValidBirthday,
    checkValidTall: $f42572f639d7eece$var$checkValidTall,
    checkValidNickName: $f42572f639d7eece$var$checkValidNickName,
    checkValidEmail: $f42572f639d7eece$var$checkValidEmail,
    checkValidPwd: $f42572f639d7eece$var$checkValidPwd,
    checkDuplicate: $f42572f639d7eece$var$checkDuplicate,
    checkEmailDuplicate: $f42572f639d7eece$var$checkEmailDuplicate
};


const $f941190610f1dcd0$var$EmailLogin = ()=>{
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const defaultTheme = 'dark';
    const messageList = {
        'email': {
            'label': "\uC774\uBA54\uC77C",
            'name': 'email',
            'title': 'Football Position',
            'subTitle': "\uAC00\uC785\uD560 \uB54C \uC0AC\uC6A9\uD55C \uC774\uBA54\uC77C\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694"
        },
        'pwd': {
            'label': "\uBE44\uBC00\uBC88\uD638",
            'name': 'pwd',
            'title': 'Football Position',
            'subTitle': "\uC601\uBB38, \uC22B\uC790 \uD3EC\uD568 10\uC790 \uC774\uC0C1\uC774\uC5D0\uC694"
        }
    };
    const [isOpen2, setIsOpen2] = (0, $7fPBF.useState)(false);
    const [isOpen3, setIsOpen3] = (0, $7fPBF.useState)(false);
    const [isOpen4, setIsOpen4] = (0, $7fPBF.useState)(false);
    const [message, setMessage] = (0, $7fPBF.useState)(messageList.email);
    const [searchParam] = (0, $a0cf24fd73ae067c$export$f1a78c17382fe22a)();
    const searchParamEmail = searchParam.get("email");
    const [email, setEmail] = (0, $7fPBF.useState)({
        value: searchParamEmail !== null ? searchParamEmail : '',
        errMsg: ''
    });
    const [pwd, setPwd] = (0, $7fPBF.useState)({
        value: '',
        errMsg: ''
    });
    const [disable, setDisable] = (0, $7fPBF.useState)(true);
    const [typePassword, setTypePassword] = (0, $7fPBF.useState)('password');
    const { refetch: emailSignIn } = (0, $d8deb3a6a62b947e$export$dd0a697e1782aedd)([
        'emailSignIn'
    ], ()=>(0, $4d624a4edc63c668$export$2e2bcd8739ae039).emailSignIn(email.value, pwd.value), {
        onSuccess: (data)=>{
            signInSuccess(data);
        }
    });
    const clickLogin = async ()=>{
        await emailSignIn();
    };
    const signInSuccess = (data)=>{
        if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(String(data.data))) switch(data.data.status){
            case "\uC815\uC0C1":
                (0, $33eb00f42ea63933$export$2e2bcd8739ae039).setLocalStorage((0, $2df1405d783f614e$export$cdbdf26448f9da5b), data.data.token);
                (0, $33eb00f42ea63933$export$2e2bcd8739ae039).setLocalStorage((0, $2df1405d783f614e$export$212a8f1ea37518bd), data.data.userId.toString());
                (0, $33eb00f42ea63933$export$2e2bcd8739ae039).setLocalStorage((0, $2df1405d783f614e$export$9228056436eff844), data.data.teamId.toString());
                (0, $33eb00f42ea63933$export$2e2bcd8739ae039).setLocalStorage((0, $2df1405d783f614e$export$d57b6b390e78d90f), data.data.teamName.toString());
                (0, $33eb00f42ea63933$export$2e2bcd8739ae039).setLocalStorage((0, $2df1405d783f614e$export$77078610759fe5f6), data.data.nickName.toString());
                navigate('/');
                break;
            case "\uC2E0\uCCAD":
                setIsOpen3(true);
                break;
            case "\uD0C8\uD1F4":
                setIsOpen4(true);
                break;
        }
        else setIsOpen2(true);
    };
    const validateEmail = (value)=>{
        const result = (0, $f42572f639d7eece$export$2e2bcd8739ae039).checkValidEmail(value);
        setEmail({
            value: result.value,
            errMsg: result.errMsg
        });
    };
    const validatePwd = (value)=>{
        const result = (0, $f42572f639d7eece$export$2e2bcd8739ae039).checkValidPwd(value);
        setPwd({
            value: result.value,
            errMsg: result.errMsg
        });
    };
    const clickLook = ()=>{
        if (typePassword === 'text') setTypePassword('password');
        else setTypePassword('text');
    };
    (0, $7fPBF.useEffect)(()=>{
        if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(email.value) || (0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(pwd.value)) setDisable(true);
        else if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(email.errMsg) || (0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(pwd.errMsg)) setDisable(true);
        else setDisable(false);
    }, [
        email,
        pwd
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                id: "NoSignUpEmail",
                className: 'bg-cl-black',
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: 'main-content',
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: 'h5_m title mt-39px',
                                children: message.title
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: 'b2_r title mt-16px ft-cl-hint',
                                children: message.subTitle
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: 'input-wrapper',
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        className: 'b1_r input-item',
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a86038245a3af4e6$export$2e2bcd8739ae039), {
                                            theme: defaultTheme,
                                            label: messageList.email.label,
                                            name: messageList.email.name,
                                            value: email.value,
                                            rightContent: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                className: 'click-area',
                                                onClick: ()=>setEmail({
                                                        value: '',
                                                        errMsg: ''
                                                    }),
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                                                    iconClass: 'input-delete-d h-17px'
                                                })
                                            }),
                                            onChange: (ev)=>setEmail((prevState)=>({
                                                        value: ev.target.value,
                                                        errMsg: prevState.errMsg
                                                    })),
                                            required: true,
                                            onBlur: ()=>validateEmail(email.value),
                                            onKeyUp: ()=>validateEmail(email.value),
                                            onClick: ()=>setMessage(messageList.email),
                                            errorMsg: email.errMsg,
                                            children: email.value
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        className: 'b1_r input-item',
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a86038245a3af4e6$export$2e2bcd8739ae039), {
                                            theme: defaultTheme,
                                            label: messageList.pwd.label,
                                            name: messageList.pwd.name,
                                            value: pwd.value,
                                            rightContent: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                className: 'click-area',
                                                onClick: ()=>clickLook(),
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                                                    iconClass: 'ic-look h-17px'
                                                })
                                            }),
                                            onChange: (ev)=>setPwd((prevState)=>({
                                                        value: ev.target.value,
                                                        errMsg: prevState.errMsg
                                                    })),
                                            required: true,
                                            onBlur: ()=>validatePwd(pwd.value),
                                            onKeyUp: ()=>validatePwd(pwd.value),
                                            onClick: ()=>setMessage(messageList.pwd),
                                            errorMsg: pwd.errMsg,
                                            type: typePassword,
                                            children: pwd.value
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: 'signup-wrapper text-center',
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                        className: 'c1_r signup-item ft-cl-caption',
                                        children: "\uACC4\uC815\uC774 \uC5C6\uC73C\uC2E0\uAC00\uC694?"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                        className: 'c1_r signup-item text-underline',
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                                            to: "/signup",
                                            children: "\uC774\uBA54\uC77C \uD68C\uC6D0\uAC00\uC785"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !disable ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fd30181b78da18c2$export$2e2bcd8739ae039), {
                        title: "\uB2E4\uC74C",
                        disabled: false,
                        onClick: ()=>clickLogin()
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fd30181b78da18c2$export$2e2bcd8739ae039), {
                        title: "\uB2E4\uC74C",
                        disabled: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $65919ee74aa6a840$export$2e2bcd8739ae039), {
                content: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    style: {
                        lineHeight: '1.5'
                    },
                    children: [
                        "\uD68C\uC6D0\uC815\uBCF4\uC640 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC544\uC694.",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        "\uC774\uBA54\uC77C\uACFC \uBE44\uBC00\uBC88\uD638\uB97C \uD655\uC778\uD574\uC8FC\uC138\uC694."
                    ]
                }),
                isOpen: isOpen2,
                onClose: ()=>setIsOpen2(false)
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $65919ee74aa6a840$export$2e2bcd8739ae039), {
                content: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    style: {
                        lineHeight: '1.5'
                    },
                    children: [
                        "\uD68C\uC6D0\uAC00\uC785 \uC2E0\uCCAD \uD6C4",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        " \uAD00\uB9AC\uC790\uC758 \uC2B9\uC778\uC744 \uAE30\uB2E4\uB9AC\uACE0 \uC788\uC2B5\uB2C8\uB2E4."
                    ]
                }),
                isOpen: isOpen3,
                onClose: ()=>setIsOpen3(false)
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $65919ee74aa6a840$export$2e2bcd8739ae039), {
                content: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    style: {
                        lineHeight: '1.5'
                    },
                    children: [
                        "\uD0C8\uD1F4\uD55C \uACC4\uC815 \uC785\uB2C8\uB2E4.",
                        /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                        "\uAD00\uB9AC\uC790\uC5D0\uAC8C \uBB38\uC758 \uD558\uC138\uC694."
                    ]
                }),
                isOpen: isOpen4,
                onClose: ()=>setIsOpen4(false)
            })
        ]
    });
};
var $f941190610f1dcd0$export$2e2bcd8739ae039 = $f941190610f1dcd0$var$EmailLogin;



const $d53e4957d2fe3c5e$var$EmailLoginView = ()=>{
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                id: "rootBg-black"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4ac626799ed465c3$export$2e2bcd8739ae039), {
                className: "bg-cl-black"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f941190610f1dcd0$export$2e2bcd8739ae039), {})
        ]
    });
};
var $d53e4957d2fe3c5e$export$2e2bcd8739ae039 = $d53e4957d2fe3c5e$var$EmailLoginView;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");


var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");


const $54d085f8f18f5fb5$var$LinkHeader = (props)=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            className: "header",
            children: [
                props.leftLink && props.leftIcon && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                            to: props.leftLink,
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "left svg",
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                                    iconClass: props.leftIcon
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                            className: "b1_r",
                            children: props.title
                        })
                    ]
                }),
                props.rightLink && props.rightIcon && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                    to: props.rightLink,
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "right svg",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                            iconClass: props.rightIcon
                        })
                    })
                })
            ]
        })
    });
};
var $54d085f8f18f5fb5$export$2e2bcd8739ae039 = $54d085f8f18f5fb5$var$LinkHeader;





var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");


function $483bc232120caa64$var$e(e) {
    this.message = e;
}
$483bc232120caa64$var$e.prototype = new Error, $483bc232120caa64$var$e.prototype.name = "InvalidCharacterError";
var $483bc232120caa64$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $483bc232120caa64$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $483bc232120caa64$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($483bc232120caa64$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $483bc232120caa64$var$r(t);
    }
}
function $483bc232120caa64$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $483bc232120caa64$var$o(e, r) {
    if ("string" != typeof e) throw new $483bc232120caa64$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($483bc232120caa64$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $483bc232120caa64$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$483bc232120caa64$export$b9721ef022f71a68.prototype = new Error, $483bc232120caa64$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $483bc232120caa64$export$2e2bcd8739ae039 = $483bc232120caa64$var$o;






var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
// src/index.ts

// src/hooks/useChain.ts
function $8d60f2ee7fd1c983$export$71511d61b312f219() {
    $8d60f2ee7fd1c983$export$71511d61b312f219 = Object.assign || function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8d60f2ee7fd1c983$export$71511d61b312f219.apply(this, arguments);
}


function $7ae6b455e4a352e9$export$71511d61b312f219(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}







// src/index.ts
var $24333df8762df523$var$updateQueue = $24333df8762df523$var$makeQueue();
var $24333df8762df523$export$27f233d61a9e2fa4 = (fn)=>$24333df8762df523$var$schedule(fn, $24333df8762df523$var$updateQueue);
var $24333df8762df523$var$writeQueue = $24333df8762df523$var$makeQueue();
$24333df8762df523$export$27f233d61a9e2fa4.write = (fn)=>$24333df8762df523$var$schedule(fn, $24333df8762df523$var$writeQueue);
var $24333df8762df523$var$onStartQueue = $24333df8762df523$var$makeQueue();
$24333df8762df523$export$27f233d61a9e2fa4.onStart = (fn)=>$24333df8762df523$var$schedule(fn, $24333df8762df523$var$onStartQueue);
var $24333df8762df523$var$onFrameQueue = $24333df8762df523$var$makeQueue();
$24333df8762df523$export$27f233d61a9e2fa4.onFrame = (fn)=>$24333df8762df523$var$schedule(fn, $24333df8762df523$var$onFrameQueue);
var $24333df8762df523$var$onFinishQueue = $24333df8762df523$var$makeQueue();
$24333df8762df523$export$27f233d61a9e2fa4.onFinish = (fn)=>$24333df8762df523$var$schedule(fn, $24333df8762df523$var$onFinishQueue);
var $24333df8762df523$var$timeouts = [];
$24333df8762df523$export$27f233d61a9e2fa4.setTimeout = (handler, ms)=>{
    const time = $24333df8762df523$export$27f233d61a9e2fa4.now() + ms;
    const cancel = ()=>{
        const i = $24333df8762df523$var$timeouts.findIndex((t)=>t.cancel == cancel);
        if (~i) $24333df8762df523$var$timeouts.splice(i, 1);
        $24333df8762df523$var$pendingCount -= ~i ? 1 : 0;
    };
    const timeout = {
        time: time,
        handler: handler,
        cancel: cancel
    };
    $24333df8762df523$var$timeouts.splice($24333df8762df523$var$findTimeout(time), 0, timeout);
    $24333df8762df523$var$pendingCount += 1;
    $24333df8762df523$var$start();
    return timeout;
};
var $24333df8762df523$var$findTimeout = (time)=>~(~$24333df8762df523$var$timeouts.findIndex((t)=>t.time > time) || ~$24333df8762df523$var$timeouts.length);
$24333df8762df523$export$27f233d61a9e2fa4.cancel = (fn)=>{
    $24333df8762df523$var$onStartQueue.delete(fn);
    $24333df8762df523$var$onFrameQueue.delete(fn);
    $24333df8762df523$var$onFinishQueue.delete(fn);
    $24333df8762df523$var$updateQueue.delete(fn);
    $24333df8762df523$var$writeQueue.delete(fn);
};
$24333df8762df523$export$27f233d61a9e2fa4.sync = (fn)=>{
    $24333df8762df523$var$sync = true;
    $24333df8762df523$export$27f233d61a9e2fa4.batchedUpdates(fn);
    $24333df8762df523$var$sync = false;
};
$24333df8762df523$export$27f233d61a9e2fa4.throttle = (fn)=>{
    let lastArgs;
    function queuedFn() {
        try {
            fn(...lastArgs);
        } finally{
            lastArgs = null;
        }
    }
    function throttled(...args) {
        lastArgs = args;
        $24333df8762df523$export$27f233d61a9e2fa4.onStart(queuedFn);
    }
    throttled.handler = fn;
    throttled.cancel = ()=>{
        $24333df8762df523$var$onStartQueue.delete(queuedFn);
        lastArgs = null;
    };
    return throttled;
};
var $24333df8762df523$var$nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : // eslint-disable-next-line @typescript-eslint/no-empty-function
()=>{};
$24333df8762df523$export$27f233d61a9e2fa4.use = (impl)=>$24333df8762df523$var$nativeRaf = impl;
$24333df8762df523$export$27f233d61a9e2fa4.now = typeof performance != "undefined" ? ()=>performance.now() : Date.now;
$24333df8762df523$export$27f233d61a9e2fa4.batchedUpdates = (fn)=>fn();
$24333df8762df523$export$27f233d61a9e2fa4.catch = console.error;
$24333df8762df523$export$27f233d61a9e2fa4.frameLoop = "always";
$24333df8762df523$export$27f233d61a9e2fa4.advance = ()=>{
    if ($24333df8762df523$export$27f233d61a9e2fa4.frameLoop !== "demand") console.warn("Cannot call the manual advancement of rafz whilst frameLoop is not set as demand");
    else $24333df8762df523$var$update();
};
var $24333df8762df523$var$ts = -1;
var $24333df8762df523$var$pendingCount = 0;
var $24333df8762df523$var$sync = false;
function $24333df8762df523$var$schedule(fn, queue) {
    if ($24333df8762df523$var$sync) {
        queue.delete(fn);
        fn(0);
    } else {
        queue.add(fn);
        $24333df8762df523$var$start();
    }
}
function $24333df8762df523$var$start() {
    if ($24333df8762df523$var$ts < 0) {
        $24333df8762df523$var$ts = 0;
        if ($24333df8762df523$export$27f233d61a9e2fa4.frameLoop !== "demand") $24333df8762df523$var$nativeRaf($24333df8762df523$var$loop);
    }
}
function $24333df8762df523$var$stop() {
    $24333df8762df523$var$ts = -1;
}
function $24333df8762df523$var$loop() {
    if (~$24333df8762df523$var$ts) {
        $24333df8762df523$var$nativeRaf($24333df8762df523$var$loop);
        $24333df8762df523$export$27f233d61a9e2fa4.batchedUpdates($24333df8762df523$var$update);
    }
}
function $24333df8762df523$var$update() {
    const prevTs = $24333df8762df523$var$ts;
    $24333df8762df523$var$ts = $24333df8762df523$export$27f233d61a9e2fa4.now();
    const count = $24333df8762df523$var$findTimeout($24333df8762df523$var$ts);
    if (count) {
        $24333df8762df523$var$eachSafely($24333df8762df523$var$timeouts.splice(0, count), (t)=>t.handler());
        $24333df8762df523$var$pendingCount -= count;
    }
    if (!$24333df8762df523$var$pendingCount) {
        $24333df8762df523$var$stop();
        return;
    }
    $24333df8762df523$var$onStartQueue.flush();
    $24333df8762df523$var$updateQueue.flush(prevTs ? Math.min(64, $24333df8762df523$var$ts - prevTs) : 16.667);
    $24333df8762df523$var$onFrameQueue.flush();
    $24333df8762df523$var$writeQueue.flush();
    $24333df8762df523$var$onFinishQueue.flush();
}
function $24333df8762df523$var$makeQueue() {
    let next = /* @__PURE__ */ new Set();
    let current = next;
    return {
        add (fn) {
            $24333df8762df523$var$pendingCount += current == next && !next.has(fn) ? 1 : 0;
            next.add(fn);
        },
        delete (fn) {
            $24333df8762df523$var$pendingCount -= current == next && next.has(fn) ? 1 : 0;
            return next.delete(fn);
        },
        flush (arg) {
            if (current.size) {
                next = /* @__PURE__ */ new Set();
                $24333df8762df523$var$pendingCount -= current.size;
                $24333df8762df523$var$eachSafely(current, (fn)=>fn(arg) && next.add(fn));
                $24333df8762df523$var$pendingCount += next.size;
                current = next;
            }
        }
    };
}
function $24333df8762df523$var$eachSafely(values, each) {
    values.forEach((value)=>{
        try {
            each(value);
        } catch (e) {
            $24333df8762df523$export$27f233d61a9e2fa4.catch(e);
        }
    });
}
var $24333df8762df523$export$ef91a23fc803e177 = {
    /** The number of pending tasks */ count () {
        return $24333df8762df523$var$pendingCount;
    },
    /** Whether there's a raf update loop running */ isRunning () {
        return $24333df8762df523$var$ts >= 0;
    },
    /** Clear internal state. Never call from update loop! */ clear () {
        $24333df8762df523$var$ts = -1;
        $24333df8762df523$var$timeouts = [];
        $24333df8762df523$var$onStartQueue = $24333df8762df523$var$makeQueue();
        $24333df8762df523$var$updateQueue = $24333df8762df523$var$makeQueue();
        $24333df8762df523$var$onFrameQueue = $24333df8762df523$var$makeQueue();
        $24333df8762df523$var$writeQueue = $24333df8762df523$var$makeQueue();
        $24333df8762df523$var$onFinishQueue = $24333df8762df523$var$makeQueue();
        $24333df8762df523$var$pendingCount = 0;
    }
};



var $7fPBF = parcelRequire("7fPBF");
var $3cb6d3769806d9dc$var$__defProp = Object.defineProperty;
var $3cb6d3769806d9dc$var$__export = (target, all)=>{
    for(var name in all)$3cb6d3769806d9dc$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
// src/globals.ts
var $3cb6d3769806d9dc$export$cceeabf822b64fc0 = {};
$3cb6d3769806d9dc$var$__export($3cb6d3769806d9dc$export$cceeabf822b64fc0, {
    assign: ()=>$3cb6d3769806d9dc$var$assign,
    colors: ()=>$3cb6d3769806d9dc$var$colors,
    createStringInterpolator: ()=>$3cb6d3769806d9dc$var$createStringInterpolator,
    skipAnimation: ()=>$3cb6d3769806d9dc$var$skipAnimation,
    to: ()=>$3cb6d3769806d9dc$var$to,
    willAdvance: ()=>$3cb6d3769806d9dc$var$willAdvance
});
// src/helpers.ts
function $3cb6d3769806d9dc$export$8793edee2d425525() {}
var $3cb6d3769806d9dc$export$5c74248ea0e35446 = (obj, key, value)=>Object.defineProperty(obj, key, {
        value: value,
        writable: true,
        configurable: true
    });
var $3cb6d3769806d9dc$export$226b3eccf92c9ed9 = {
    arr: Array.isArray,
    obj: (a)=>!!a && a.constructor.name === "Object",
    fun: (a)=>typeof a === "function",
    str: (a)=>typeof a === "string",
    num: (a)=>typeof a === "number",
    und: (a)=>a === void 0
};
function $3cb6d3769806d9dc$export$248d38f6296296c5(a, b) {
    if ($3cb6d3769806d9dc$export$226b3eccf92c9ed9.arr(a)) {
        if (!$3cb6d3769806d9dc$export$226b3eccf92c9ed9.arr(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return a === b;
}
var $3cb6d3769806d9dc$export$79b2f7037acddd43 = (obj, fn)=>obj.forEach(fn);
function $3cb6d3769806d9dc$export$f4c6fe153f5a944e(obj, fn, ctx) {
    if ($3cb6d3769806d9dc$export$226b3eccf92c9ed9.arr(obj)) {
        for(let i = 0; i < obj.length; i++)fn.call(ctx, obj[i], `${i}`);
        return;
    }
    for(const key in obj)if (obj.hasOwnProperty(key)) fn.call(ctx, obj[key], key);
}
var $3cb6d3769806d9dc$export$45b10814cc054894 = (a)=>$3cb6d3769806d9dc$export$226b3eccf92c9ed9.und(a) ? [] : $3cb6d3769806d9dc$export$226b3eccf92c9ed9.arr(a) ? a : [
        a
    ];
function $3cb6d3769806d9dc$export$4909b86c8034bf73(queue, iterator) {
    if (queue.size) {
        const items = Array.from(queue);
        queue.clear();
        $3cb6d3769806d9dc$export$79b2f7037acddd43(items, iterator);
    }
}
var $3cb6d3769806d9dc$export$7ba486852759e806 = (queue, ...args)=>$3cb6d3769806d9dc$export$4909b86c8034bf73(queue, (fn)=>fn(...args));
var $3cb6d3769806d9dc$export$48d7c418edadb60c = ()=>typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
// src/globals.ts
var $3cb6d3769806d9dc$var$createStringInterpolator;
var $3cb6d3769806d9dc$var$to;
var $3cb6d3769806d9dc$var$colors = null;
var $3cb6d3769806d9dc$var$skipAnimation = false;
var $3cb6d3769806d9dc$var$willAdvance = $3cb6d3769806d9dc$export$8793edee2d425525;
var $3cb6d3769806d9dc$var$assign = (globals)=>{
    if (globals.to) $3cb6d3769806d9dc$var$to = globals.to;
    if (globals.now) (0, $24333df8762df523$export$27f233d61a9e2fa4).now = globals.now;
    if (globals.colors !== void 0) $3cb6d3769806d9dc$var$colors = globals.colors;
    if (globals.skipAnimation != null) $3cb6d3769806d9dc$var$skipAnimation = globals.skipAnimation;
    if (globals.createStringInterpolator) $3cb6d3769806d9dc$var$createStringInterpolator = globals.createStringInterpolator;
    if (globals.requestAnimationFrame) (0, $24333df8762df523$export$27f233d61a9e2fa4).use(globals.requestAnimationFrame);
    if (globals.batchedUpdates) (0, $24333df8762df523$export$27f233d61a9e2fa4).batchedUpdates = globals.batchedUpdates;
    if (globals.willAdvance) $3cb6d3769806d9dc$var$willAdvance = globals.willAdvance;
    if (globals.frameLoop) (0, $24333df8762df523$export$27f233d61a9e2fa4).frameLoop = globals.frameLoop;
};
var $3cb6d3769806d9dc$var$startQueue = /* @__PURE__ */ new Set();
var $3cb6d3769806d9dc$var$currentFrame = [];
var $3cb6d3769806d9dc$var$prevFrame = [];
var $3cb6d3769806d9dc$var$priority = 0;
var $3cb6d3769806d9dc$export$a57f5080a3bcc90a = {
    get idle () {
        return !$3cb6d3769806d9dc$var$startQueue.size && !$3cb6d3769806d9dc$var$currentFrame.length;
    },
    /** Advance the given animation on every frame until idle. */ start (animation) {
        if ($3cb6d3769806d9dc$var$priority > animation.priority) {
            $3cb6d3769806d9dc$var$startQueue.add(animation);
            (0, $24333df8762df523$export$27f233d61a9e2fa4).onStart($3cb6d3769806d9dc$var$flushStartQueue);
        } else {
            $3cb6d3769806d9dc$var$startSafely(animation);
            (0, $24333df8762df523$export$27f233d61a9e2fa4)($3cb6d3769806d9dc$var$advance);
        }
    },
    advance: /** Advance all animations by the given time. */ $3cb6d3769806d9dc$var$advance,
    /** Call this when an animation's priority changes. */ sort (animation) {
        if ($3cb6d3769806d9dc$var$priority) (0, $24333df8762df523$export$27f233d61a9e2fa4).onFrame(()=>$3cb6d3769806d9dc$export$a57f5080a3bcc90a.sort(animation));
        else {
            const prevIndex = $3cb6d3769806d9dc$var$currentFrame.indexOf(animation);
            if (~prevIndex) {
                $3cb6d3769806d9dc$var$currentFrame.splice(prevIndex, 1);
                $3cb6d3769806d9dc$var$startUnsafely(animation);
            }
        }
    },
    /**
   * Clear all animations. For testing purposes.
   *
   * ☠️ Never call this from within the frameloop.
   */ clear () {
        $3cb6d3769806d9dc$var$currentFrame = [];
        $3cb6d3769806d9dc$var$startQueue.clear();
    }
};
function $3cb6d3769806d9dc$var$flushStartQueue() {
    $3cb6d3769806d9dc$var$startQueue.forEach($3cb6d3769806d9dc$var$startSafely);
    $3cb6d3769806d9dc$var$startQueue.clear();
    (0, $24333df8762df523$export$27f233d61a9e2fa4)($3cb6d3769806d9dc$var$advance);
}
function $3cb6d3769806d9dc$var$startSafely(animation) {
    if (!$3cb6d3769806d9dc$var$currentFrame.includes(animation)) $3cb6d3769806d9dc$var$startUnsafely(animation);
}
function $3cb6d3769806d9dc$var$startUnsafely(animation) {
    $3cb6d3769806d9dc$var$currentFrame.splice($3cb6d3769806d9dc$var$findIndex($3cb6d3769806d9dc$var$currentFrame, (other)=>other.priority > animation.priority), 0, animation);
}
function $3cb6d3769806d9dc$var$advance(dt) {
    const nextFrame = $3cb6d3769806d9dc$var$prevFrame;
    for(let i = 0; i < $3cb6d3769806d9dc$var$currentFrame.length; i++){
        const animation = $3cb6d3769806d9dc$var$currentFrame[i];
        $3cb6d3769806d9dc$var$priority = animation.priority;
        if (!animation.idle) {
            $3cb6d3769806d9dc$var$willAdvance(animation);
            animation.advance(dt);
            if (!animation.idle) nextFrame.push(animation);
        }
    }
    $3cb6d3769806d9dc$var$priority = 0;
    $3cb6d3769806d9dc$var$prevFrame = $3cb6d3769806d9dc$var$currentFrame;
    $3cb6d3769806d9dc$var$prevFrame.length = 0;
    $3cb6d3769806d9dc$var$currentFrame = nextFrame;
    return $3cb6d3769806d9dc$var$currentFrame.length > 0;
}
function $3cb6d3769806d9dc$var$findIndex(arr, test) {
    const index = arr.findIndex(test);
    return index < 0 ? arr.length : index;
}
// src/clamp.ts
var $3cb6d3769806d9dc$export$7d15b64cf5a3a4c4 = (min, max, v)=>Math.min(Math.max(v, min), max);
// src/colors.ts
var $3cb6d3769806d9dc$export$8f45430ccf837300 = {
    transparent: 0,
    aliceblue: 4042850303,
    antiquewhite: 4209760255,
    aqua: 16777215,
    aquamarine: 2147472639,
    azure: 4043309055,
    beige: 4126530815,
    bisque: 4293182719,
    black: 255,
    blanchedalmond: 4293643775,
    blue: 65535,
    blueviolet: 2318131967,
    brown: 2771004159,
    burlywood: 3736635391,
    burntsienna: 3934150143,
    cadetblue: 1604231423,
    chartreuse: 2147418367,
    chocolate: 3530104575,
    coral: 4286533887,
    cornflowerblue: 1687547391,
    cornsilk: 4294499583,
    crimson: 3692313855,
    cyan: 16777215,
    darkblue: 35839,
    darkcyan: 9145343,
    darkgoldenrod: 3095792639,
    darkgray: 2846468607,
    darkgreen: 6553855,
    darkgrey: 2846468607,
    darkkhaki: 3182914559,
    darkmagenta: 2332068863,
    darkolivegreen: 1433087999,
    darkorange: 4287365375,
    darkorchid: 2570243327,
    darkred: 2332033279,
    darksalmon: 3918953215,
    darkseagreen: 2411499519,
    darkslateblue: 1211993087,
    darkslategray: 793726975,
    darkslategrey: 793726975,
    darkturquoise: 13554175,
    darkviolet: 2483082239,
    deeppink: 4279538687,
    deepskyblue: 12582911,
    dimgray: 1768516095,
    dimgrey: 1768516095,
    dodgerblue: 512819199,
    firebrick: 2988581631,
    floralwhite: 4294635775,
    forestgreen: 579543807,
    fuchsia: 4278255615,
    gainsboro: 3705462015,
    ghostwhite: 4177068031,
    gold: 4292280575,
    goldenrod: 3668254975,
    gray: 2155905279,
    green: 8388863,
    greenyellow: 2919182335,
    grey: 2155905279,
    honeydew: 4043305215,
    hotpink: 4285117695,
    indianred: 3445382399,
    indigo: 1258324735,
    ivory: 4294963455,
    khaki: 4041641215,
    lavender: 3873897215,
    lavenderblush: 4293981695,
    lawngreen: 2096890111,
    lemonchiffon: 4294626815,
    lightblue: 2916673279,
    lightcoral: 4034953471,
    lightcyan: 3774873599,
    lightgoldenrodyellow: 4210742015,
    lightgray: 3553874943,
    lightgreen: 2431553791,
    lightgrey: 3553874943,
    lightpink: 4290167295,
    lightsalmon: 4288707327,
    lightseagreen: 548580095,
    lightskyblue: 2278488831,
    lightslategray: 2005441023,
    lightslategrey: 2005441023,
    lightsteelblue: 2965692159,
    lightyellow: 4294959359,
    lime: 16711935,
    limegreen: 852308735,
    linen: 4210091775,
    magenta: 4278255615,
    maroon: 2147483903,
    mediumaquamarine: 1724754687,
    mediumblue: 52735,
    mediumorchid: 3126187007,
    mediumpurple: 2473647103,
    mediumseagreen: 1018393087,
    mediumslateblue: 2070474495,
    mediumspringgreen: 16423679,
    mediumturquoise: 1221709055,
    mediumvioletred: 3340076543,
    midnightblue: 421097727,
    mintcream: 4127193855,
    mistyrose: 4293190143,
    moccasin: 4293178879,
    navajowhite: 4292783615,
    navy: 33023,
    oldlace: 4260751103,
    olive: 2155872511,
    olivedrab: 1804477439,
    orange: 4289003775,
    orangered: 4282712319,
    orchid: 3664828159,
    palegoldenrod: 4008225535,
    palegreen: 2566625535,
    paleturquoise: 2951671551,
    palevioletred: 3681588223,
    papayawhip: 4293907967,
    peachpuff: 4292524543,
    peru: 3448061951,
    pink: 4290825215,
    plum: 3718307327,
    powderblue: 2967529215,
    purple: 2147516671,
    rebeccapurple: 1714657791,
    red: 4278190335,
    rosybrown: 3163525119,
    royalblue: 1097458175,
    saddlebrown: 2336560127,
    salmon: 4202722047,
    sandybrown: 4104413439,
    seagreen: 780883967,
    seashell: 4294307583,
    sienna: 2689740287,
    silver: 3233857791,
    skyblue: 2278484991,
    slateblue: 1784335871,
    slategray: 1887473919,
    slategrey: 1887473919,
    snow: 4294638335,
    springgreen: 16744447,
    steelblue: 1182971135,
    tan: 3535047935,
    teal: 8421631,
    thistle: 3636451583,
    tomato: 4284696575,
    turquoise: 1088475391,
    violet: 4001558271,
    wheat: 4125012991,
    white: 4294967295,
    whitesmoke: 4126537215,
    yellow: 4294902015,
    yellowgreen: 2597139199
};
// src/colorMatchers.ts
var $3cb6d3769806d9dc$var$NUMBER = "[-+]?\\d*\\.?\\d+";
var $3cb6d3769806d9dc$var$PERCENTAGE = $3cb6d3769806d9dc$var$NUMBER + "%";
function $3cb6d3769806d9dc$var$call(...parts) {
    return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
var $3cb6d3769806d9dc$export$8972dc0e6ad9238f = new RegExp("rgb" + $3cb6d3769806d9dc$var$call($3cb6d3769806d9dc$var$NUMBER, $3cb6d3769806d9dc$var$NUMBER, $3cb6d3769806d9dc$var$NUMBER));
var $3cb6d3769806d9dc$export$4e46ac54fc82cf3b = new RegExp("rgba" + $3cb6d3769806d9dc$var$call($3cb6d3769806d9dc$var$NUMBER, $3cb6d3769806d9dc$var$NUMBER, $3cb6d3769806d9dc$var$NUMBER, $3cb6d3769806d9dc$var$NUMBER));
var $3cb6d3769806d9dc$export$8f4a7c0bb78e6ea8 = new RegExp("hsl" + $3cb6d3769806d9dc$var$call($3cb6d3769806d9dc$var$NUMBER, $3cb6d3769806d9dc$var$PERCENTAGE, $3cb6d3769806d9dc$var$PERCENTAGE));
var $3cb6d3769806d9dc$export$810b04175080204c = new RegExp("hsla" + $3cb6d3769806d9dc$var$call($3cb6d3769806d9dc$var$NUMBER, $3cb6d3769806d9dc$var$PERCENTAGE, $3cb6d3769806d9dc$var$PERCENTAGE, $3cb6d3769806d9dc$var$NUMBER));
var $3cb6d3769806d9dc$export$a99b93d698493da5 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $3cb6d3769806d9dc$export$4573e032242724d8 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
var $3cb6d3769806d9dc$export$86e51e8f361b966e = /^#([0-9a-fA-F]{6})$/;
var $3cb6d3769806d9dc$export$a09ec12fb14c61c4 = /^#([0-9a-fA-F]{8})$/;
// src/normalizeColor.ts
function $3cb6d3769806d9dc$var$normalizeColor(color) {
    let match;
    if (typeof color === "number") return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
    if (match = $3cb6d3769806d9dc$export$86e51e8f361b966e.exec(color)) return parseInt(match[1] + "ff", 16) >>> 0;
    if ($3cb6d3769806d9dc$var$colors && $3cb6d3769806d9dc$var$colors[color] !== void 0) return $3cb6d3769806d9dc$var$colors[color];
    if (match = $3cb6d3769806d9dc$export$8972dc0e6ad9238f.exec(color)) return ($3cb6d3769806d9dc$var$parse255(match[1]) << 24 | // r
    $3cb6d3769806d9dc$var$parse255(match[2]) << 16 | // g
    $3cb6d3769806d9dc$var$parse255(match[3]) << 8 | // b
    255) >>> // a
    0;
    if (match = $3cb6d3769806d9dc$export$4e46ac54fc82cf3b.exec(color)) return ($3cb6d3769806d9dc$var$parse255(match[1]) << 24 | // r
    $3cb6d3769806d9dc$var$parse255(match[2]) << 16 | // g
    $3cb6d3769806d9dc$var$parse255(match[3]) << 8 | // b
    $3cb6d3769806d9dc$var$parse1(match[4])) >>> // a
    0;
    if (match = $3cb6d3769806d9dc$export$a99b93d698493da5.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    "ff", // a
    16) >>> 0;
    if (match = $3cb6d3769806d9dc$export$a09ec12fb14c61c4.exec(color)) return parseInt(match[1], 16) >>> 0;
    if (match = $3cb6d3769806d9dc$export$4573e032242724d8.exec(color)) return parseInt(match[1] + match[1] + // r
    match[2] + match[2] + // g
    match[3] + match[3] + // b
    match[4] + match[4], // a
    16) >>> 0;
    if (match = $3cb6d3769806d9dc$export$8f4a7c0bb78e6ea8.exec(color)) return ($3cb6d3769806d9dc$var$hslToRgb($3cb6d3769806d9dc$var$parse360(match[1]), // h
    $3cb6d3769806d9dc$var$parsePercentage(match[2]), // s
    $3cb6d3769806d9dc$var$parsePercentage(match[3])) | 255) >>> // a
    0;
    if (match = $3cb6d3769806d9dc$export$810b04175080204c.exec(color)) return ($3cb6d3769806d9dc$var$hslToRgb($3cb6d3769806d9dc$var$parse360(match[1]), // h
    $3cb6d3769806d9dc$var$parsePercentage(match[2]), // s
    $3cb6d3769806d9dc$var$parsePercentage(match[3])) | $3cb6d3769806d9dc$var$parse1(match[4])) >>> // a
    0;
    return null;
}
function $3cb6d3769806d9dc$var$hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $3cb6d3769806d9dc$var$hslToRgb(h, s, l) {
    const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    const p = 2 * l - q;
    const r = $3cb6d3769806d9dc$var$hue2rgb(p, q, h + 1 / 3);
    const g = $3cb6d3769806d9dc$var$hue2rgb(p, q, h);
    const b = $3cb6d3769806d9dc$var$hue2rgb(p, q, h - 1 / 3);
    return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function $3cb6d3769806d9dc$var$parse255(str) {
    const int = parseInt(str, 10);
    if (int < 0) return 0;
    if (int > 255) return 255;
    return int;
}
function $3cb6d3769806d9dc$var$parse360(str) {
    const int = parseFloat(str);
    return (int % 360 + 360) % 360 / 360;
}
function $3cb6d3769806d9dc$var$parse1(str) {
    const num = parseFloat(str);
    if (num < 0) return 0;
    if (num > 1) return 255;
    return Math.round(num * 255);
}
function $3cb6d3769806d9dc$var$parsePercentage(str) {
    const int = parseFloat(str);
    if (int < 0) return 0;
    if (int > 100) return 1;
    return int / 100;
}
// src/colorToRgba.ts
function $3cb6d3769806d9dc$export$61db176b839af1f(input) {
    let int32Color = $3cb6d3769806d9dc$var$normalizeColor(input);
    if (int32Color === null) return input;
    int32Color = int32Color || 0;
    const r = (int32Color & 4278190080) >>> 24;
    const g = (int32Color & 16711680) >>> 16;
    const b = (int32Color & 65280) >>> 8;
    const a = (int32Color & 255) / 255;
    return `rgba(${r}, ${g}, ${b}, ${a})`;
}
// src/createInterpolator.ts
var $3cb6d3769806d9dc$export$b12af43b97697ef5 = (range, output, extrapolate)=>{
    if ($3cb6d3769806d9dc$export$226b3eccf92c9ed9.fun(range)) return range;
    if ($3cb6d3769806d9dc$export$226b3eccf92c9ed9.arr(range)) return $3cb6d3769806d9dc$export$b12af43b97697ef5({
        range: range,
        output: output,
        extrapolate: extrapolate
    });
    if ($3cb6d3769806d9dc$export$226b3eccf92c9ed9.str(range.output[0])) return $3cb6d3769806d9dc$var$createStringInterpolator(range);
    const config = range;
    const outputRange = config.output;
    const inputRange = config.range || [
        0,
        1
    ];
    const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
    const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
    const easing = config.easing || ((t)=>t);
    return (input)=>{
        const range2 = $3cb6d3769806d9dc$var$findRange(input, inputRange);
        return $3cb6d3769806d9dc$var$interpolate(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
    };
};
function $3cb6d3769806d9dc$var$interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
    let result = map ? map(input) : input;
    if (result < inputMin) {
        if (extrapolateLeft === "identity") return result;
        else if (extrapolateLeft === "clamp") result = inputMin;
    }
    if (result > inputMax) {
        if (extrapolateRight === "identity") return result;
        else if (extrapolateRight === "clamp") result = inputMax;
    }
    if (outputMin === outputMax) return outputMin;
    if (inputMin === inputMax) return input <= inputMin ? outputMin : outputMax;
    if (inputMin === -Infinity) result = -result;
    else if (inputMax === Infinity) result = result - inputMin;
    else result = (result - inputMin) / (inputMax - inputMin);
    result = easing(result);
    if (outputMin === -Infinity) result = -result;
    else if (outputMax === Infinity) result = result + outputMin;
    else result = result * (outputMax - outputMin) + outputMin;
    return result;
}
function $3cb6d3769806d9dc$var$findRange(input, inputRange) {
    for(var i = 1; i < inputRange.length - 1; ++i)if (inputRange[i] >= input) break;
    return i - 1;
}
// src/easings.ts
var $3cb6d3769806d9dc$var$steps = (steps2, direction = "end")=>(progress2)=>{
        progress2 = direction === "end" ? Math.min(progress2, 0.999) : Math.max(progress2, 1e-3);
        const expanded = progress2 * steps2;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return $3cb6d3769806d9dc$export$7d15b64cf5a3a4c4(0, 1, rounded / steps2);
    };
var $3cb6d3769806d9dc$var$c1 = 1.70158;
var $3cb6d3769806d9dc$var$c2 = $3cb6d3769806d9dc$var$c1 * 1.525;
var $3cb6d3769806d9dc$var$c3 = $3cb6d3769806d9dc$var$c1 + 1;
var $3cb6d3769806d9dc$var$c4 = 2 * Math.PI / 3;
var $3cb6d3769806d9dc$var$c5 = 2 * Math.PI / 4.5;
var $3cb6d3769806d9dc$var$bounceOut = (x)=>{
    const n1 = 7.5625;
    const d1 = 2.75;
    if (x < 1 / d1) return n1 * x * x;
    else if (x < 2 / d1) return n1 * (x -= 1.5 / d1) * x + 0.75;
    else if (x < 2.5 / d1) return n1 * (x -= 2.25 / d1) * x + 0.9375;
    else return n1 * (x -= 2.625 / d1) * x + 0.984375;
};
var $3cb6d3769806d9dc$export$15a0bf1b4bbacad8 = {
    linear: (x)=>x,
    easeInQuad: (x)=>x * x,
    easeOutQuad: (x)=>1 - (1 - x) * (1 - x),
    easeInOutQuad: (x)=>x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2,
    easeInCubic: (x)=>x * x * x,
    easeOutCubic: (x)=>1 - Math.pow(1 - x, 3),
    easeInOutCubic: (x)=>x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2,
    easeInQuart: (x)=>x * x * x * x,
    easeOutQuart: (x)=>1 - Math.pow(1 - x, 4),
    easeInOutQuart: (x)=>x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2,
    easeInQuint: (x)=>x * x * x * x * x,
    easeOutQuint: (x)=>1 - Math.pow(1 - x, 5),
    easeInOutQuint: (x)=>x < 0.5 ? 16 * x * x * x * x * x : 1 - Math.pow(-2 * x + 2, 5) / 2,
    easeInSine: (x)=>1 - Math.cos(x * Math.PI / 2),
    easeOutSine: (x)=>Math.sin(x * Math.PI / 2),
    easeInOutSine: (x)=>-(Math.cos(Math.PI * x) - 1) / 2,
    easeInExpo: (x)=>x === 0 ? 0 : Math.pow(2, 10 * x - 10),
    easeOutExpo: (x)=>x === 1 ? 1 : 1 - Math.pow(2, -10 * x),
    easeInOutExpo: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? Math.pow(2, 20 * x - 10) / 2 : (2 - Math.pow(2, -20 * x + 10)) / 2,
    easeInCirc: (x)=>1 - Math.sqrt(1 - Math.pow(x, 2)),
    easeOutCirc: (x)=>Math.sqrt(1 - Math.pow(x - 1, 2)),
    easeInOutCirc: (x)=>x < 0.5 ? (1 - Math.sqrt(1 - Math.pow(2 * x, 2))) / 2 : (Math.sqrt(1 - Math.pow(-2 * x + 2, 2)) + 1) / 2,
    easeInBack: (x)=>$3cb6d3769806d9dc$var$c3 * x * x * x - $3cb6d3769806d9dc$var$c1 * x * x,
    easeOutBack: (x)=>1 + $3cb6d3769806d9dc$var$c3 * Math.pow(x - 1, 3) + $3cb6d3769806d9dc$var$c1 * Math.pow(x - 1, 2),
    easeInOutBack: (x)=>x < 0.5 ? Math.pow(2 * x, 2) * (($3cb6d3769806d9dc$var$c2 + 1) * 2 * x - $3cb6d3769806d9dc$var$c2) / 2 : (Math.pow(2 * x - 2, 2) * (($3cb6d3769806d9dc$var$c2 + 1) * (x * 2 - 2) + $3cb6d3769806d9dc$var$c2) + 2) / 2,
    easeInElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : -Math.pow(2, 10 * x - 10) * Math.sin((x * 10 - 10.75) * $3cb6d3769806d9dc$var$c4),
    easeOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : Math.pow(2, -10 * x) * Math.sin((x * 10 - 0.75) * $3cb6d3769806d9dc$var$c4) + 1,
    easeInOutElastic: (x)=>x === 0 ? 0 : x === 1 ? 1 : x < 0.5 ? -(Math.pow(2, 20 * x - 10) * Math.sin((20 * x - 11.125) * $3cb6d3769806d9dc$var$c5)) / 2 : Math.pow(2, -20 * x + 10) * Math.sin((20 * x - 11.125) * $3cb6d3769806d9dc$var$c5) / 2 + 1,
    easeInBounce: (x)=>1 - $3cb6d3769806d9dc$var$bounceOut(1 - x),
    easeOutBounce: $3cb6d3769806d9dc$var$bounceOut,
    easeInOutBounce: (x)=>x < 0.5 ? (1 - $3cb6d3769806d9dc$var$bounceOut(1 - 2 * x)) / 2 : (1 + $3cb6d3769806d9dc$var$bounceOut(2 * x - 1)) / 2,
    steps: $3cb6d3769806d9dc$var$steps
};
// src/fluids.ts
var $3cb6d3769806d9dc$var$$get = Symbol.for("FluidValue.get");
var $3cb6d3769806d9dc$var$$observers = Symbol.for("FluidValue.observers");
var $3cb6d3769806d9dc$export$57ea7e3a7f6280c7 = (arg)=>Boolean(arg && arg[$3cb6d3769806d9dc$var$$get]);
var $3cb6d3769806d9dc$export$e37b7520edd66839 = (arg)=>arg && arg[$3cb6d3769806d9dc$var$$get] ? arg[$3cb6d3769806d9dc$var$$get]() : arg;
var $3cb6d3769806d9dc$export$133f54e9f7cf1796 = (target)=>target[$3cb6d3769806d9dc$var$$observers] || null;
function $3cb6d3769806d9dc$export$8cbca1207adce0c0(observer2, event) {
    if (observer2.eventObserved) observer2.eventObserved(event);
    else observer2(event);
}
function $3cb6d3769806d9dc$export$31752c40a5fab62a(target, event) {
    const observers = target[$3cb6d3769806d9dc$var$$observers];
    if (observers) observers.forEach((observer2)=>{
        $3cb6d3769806d9dc$export$8cbca1207adce0c0(observer2, event);
    });
}
var $3cb6d3769806d9dc$export$aff8e1ac1a016a2 = class {
    constructor(get){
        if (!get && !(get = this.get)) throw Error("Unknown getter");
        $3cb6d3769806d9dc$export$a3b4618659637aa3(this, get);
    }
};
$3cb6d3769806d9dc$var$$get, $3cb6d3769806d9dc$var$$observers;
var $3cb6d3769806d9dc$export$a3b4618659637aa3 = (target, get)=>$3cb6d3769806d9dc$var$setHidden(target, $3cb6d3769806d9dc$var$$get, get);
function $3cb6d3769806d9dc$export$72d604e3f8d000a5(target, observer2) {
    if (target[$3cb6d3769806d9dc$var$$get]) {
        let observers = target[$3cb6d3769806d9dc$var$$observers];
        if (!observers) $3cb6d3769806d9dc$var$setHidden(target, $3cb6d3769806d9dc$var$$observers, observers = /* @__PURE__ */ new Set());
        if (!observers.has(observer2)) {
            observers.add(observer2);
            if (target.observerAdded) target.observerAdded(observers.size, observer2);
        }
    }
    return observer2;
}
function $3cb6d3769806d9dc$export$7a0eb830d336339b(target, observer2) {
    const observers = target[$3cb6d3769806d9dc$var$$observers];
    if (observers && observers.has(observer2)) {
        const count = observers.size - 1;
        if (count) observers.delete(observer2);
        else target[$3cb6d3769806d9dc$var$$observers] = null;
        if (target.observerRemoved) target.observerRemoved(count, observer2);
    }
}
var $3cb6d3769806d9dc$var$setHidden = (target, key, value)=>Object.defineProperty(target, key, {
        value: value,
        writable: true,
        configurable: true
    });
// src/regexs.ts
var $3cb6d3769806d9dc$var$numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
var $3cb6d3769806d9dc$var$colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var $3cb6d3769806d9dc$var$unitRegex = new RegExp(`(${$3cb6d3769806d9dc$var$numberRegex.source})(%|[a-z]+)`, "i");
var $3cb6d3769806d9dc$var$rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
var $3cb6d3769806d9dc$var$cssVariableRegex = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
// src/variableToRgba.ts
var $3cb6d3769806d9dc$var$variableToRgba = (input)=>{
    const [token, fallback] = $3cb6d3769806d9dc$var$parseCSSVariable(input);
    if (!token || $3cb6d3769806d9dc$export$48d7c418edadb60c()) return input;
    const value = window.getComputedStyle(document.documentElement).getPropertyValue(token);
    if (value) return value.trim();
    else if (fallback && fallback.startsWith("--")) {
        const value2 = window.getComputedStyle(document.documentElement).getPropertyValue(fallback);
        if (value2) return value2;
        else return input;
    } else if (fallback && $3cb6d3769806d9dc$var$cssVariableRegex.test(fallback)) return $3cb6d3769806d9dc$var$variableToRgba(fallback);
    else if (fallback) return fallback;
    return input;
};
var $3cb6d3769806d9dc$var$parseCSSVariable = (current)=>{
    const match = $3cb6d3769806d9dc$var$cssVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token, fallback] = match;
    return [
        token,
        fallback
    ];
};
// src/stringInterpolation.ts
var $3cb6d3769806d9dc$var$namedColorRegex;
var $3cb6d3769806d9dc$var$rgbaRound = (_, p1, p2, p3, p4)=>`rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
var $3cb6d3769806d9dc$export$4759a013d387347a = (config)=>{
    if (!$3cb6d3769806d9dc$var$namedColorRegex) $3cb6d3769806d9dc$var$namedColorRegex = $3cb6d3769806d9dc$var$colors ? // match color names, ignore partial matches
    new RegExp(`(${Object.keys($3cb6d3769806d9dc$var$colors).join("|")})(?!\\w)`, "g") : // never match
    /^\b$/;
    const output = config.output.map((value)=>{
        return $3cb6d3769806d9dc$export$e37b7520edd66839(value).replace($3cb6d3769806d9dc$var$cssVariableRegex, $3cb6d3769806d9dc$var$variableToRgba).replace($3cb6d3769806d9dc$var$colorRegex, $3cb6d3769806d9dc$export$61db176b839af1f).replace($3cb6d3769806d9dc$var$namedColorRegex, $3cb6d3769806d9dc$export$61db176b839af1f);
    });
    const keyframes = output.map((value)=>value.match($3cb6d3769806d9dc$var$numberRegex).map(Number));
    const outputRanges = keyframes[0].map((_, i)=>keyframes.map((values)=>{
            if (!(i in values)) throw Error('The arity of each "output" value must be equal');
            return values[i];
        }));
    const interpolators = outputRanges.map((output2)=>$3cb6d3769806d9dc$export$b12af43b97697ef5((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, config), {
            output: output2
        })));
    return (input)=>{
        var _output_find;
        const missingUnit = !$3cb6d3769806d9dc$var$unitRegex.test(output[0]) && ((_output_find = output.find((value)=>$3cb6d3769806d9dc$var$unitRegex.test(value))) === null || _output_find === void 0 ? void 0 : _output_find.replace($3cb6d3769806d9dc$var$numberRegex, ""));
        let i = 0;
        return output[0].replace($3cb6d3769806d9dc$var$numberRegex, ()=>`${interpolators[i++](input)}${missingUnit || ""}`).replace($3cb6d3769806d9dc$var$rgbaRegex, $3cb6d3769806d9dc$var$rgbaRound);
    };
};
// src/deprecations.ts
var $3cb6d3769806d9dc$export$82e9f45cca5ba907 = "react-spring: ";
var $3cb6d3769806d9dc$export$d2de3aaeafa91619 = (fn)=>{
    const func = fn;
    let called = false;
    if (typeof func != "function") throw new TypeError(`${$3cb6d3769806d9dc$export$82e9f45cca5ba907}once requires a function parameter`);
    return (...args)=>{
        if (!called) {
            func(...args);
            called = true;
        }
    };
};
var $3cb6d3769806d9dc$var$warnInterpolate = $3cb6d3769806d9dc$export$d2de3aaeafa91619(console.warn);
function $3cb6d3769806d9dc$export$2abfcde8ae218ba8() {
    $3cb6d3769806d9dc$var$warnInterpolate(`${$3cb6d3769806d9dc$export$82e9f45cca5ba907}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
var $3cb6d3769806d9dc$var$warnDirectCall = $3cb6d3769806d9dc$export$d2de3aaeafa91619(console.warn);
function $3cb6d3769806d9dc$export$d99d974913ad3b12() {
    $3cb6d3769806d9dc$var$warnDirectCall(`${$3cb6d3769806d9dc$export$82e9f45cca5ba907}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead), this will be removed in later 0.X.0 versions`);
}
// src/isAnimatedString.ts
function $3cb6d3769806d9dc$export$75bed621f62abfa9(value) {
    return $3cb6d3769806d9dc$export$226b3eccf92c9ed9.str(value) && (value[0] == "#" || /\d/.test(value) || // Do not identify a CSS variable as an AnimatedString if its SSR
    !$3cb6d3769806d9dc$export$48d7c418edadb60c() && $3cb6d3769806d9dc$var$cssVariableRegex.test(value) || value in ($3cb6d3769806d9dc$var$colors || {}));
}
// src/dom-events/resize/resizeElement.ts
var $3cb6d3769806d9dc$var$observer;
var $3cb6d3769806d9dc$var$resizeHandlers = /* @__PURE__ */ new WeakMap();
var $3cb6d3769806d9dc$var$handleObservation = (entries)=>entries.forEach(({ target: target, contentRect: contentRect })=>{
        var _resizeHandlers_get;
        return (_resizeHandlers_get = $3cb6d3769806d9dc$var$resizeHandlers.get(target)) === null || _resizeHandlers_get === void 0 ? void 0 : _resizeHandlers_get.forEach((handler)=>handler(contentRect));
    });
function $3cb6d3769806d9dc$var$resizeElement(handler, target) {
    if (!$3cb6d3769806d9dc$var$observer) {
        if (typeof ResizeObserver !== "undefined") $3cb6d3769806d9dc$var$observer = new ResizeObserver($3cb6d3769806d9dc$var$handleObservation);
    }
    let elementHandlers = $3cb6d3769806d9dc$var$resizeHandlers.get(target);
    if (!elementHandlers) {
        elementHandlers = /* @__PURE__ */ new Set();
        $3cb6d3769806d9dc$var$resizeHandlers.set(target, elementHandlers);
    }
    elementHandlers.add(handler);
    if ($3cb6d3769806d9dc$var$observer) $3cb6d3769806d9dc$var$observer.observe(target);
    return ()=>{
        const elementHandlers2 = $3cb6d3769806d9dc$var$resizeHandlers.get(target);
        if (!elementHandlers2) return;
        elementHandlers2.delete(handler);
        if (!elementHandlers2.size && $3cb6d3769806d9dc$var$observer) $3cb6d3769806d9dc$var$observer.unobserve(target);
    };
}
// src/dom-events/resize/resizeWindow.ts
var $3cb6d3769806d9dc$var$listeners = /* @__PURE__ */ new Set();
var $3cb6d3769806d9dc$var$cleanupWindowResizeHandler;
var $3cb6d3769806d9dc$var$createResizeHandler = ()=>{
    const handleResize = ()=>{
        $3cb6d3769806d9dc$var$listeners.forEach((callback)=>callback({
                width: window.innerWidth,
                height: window.innerHeight
            }));
    };
    window.addEventListener("resize", handleResize);
    return ()=>{
        window.removeEventListener("resize", handleResize);
    };
};
var $3cb6d3769806d9dc$var$resizeWindow = (callback)=>{
    $3cb6d3769806d9dc$var$listeners.add(callback);
    if (!$3cb6d3769806d9dc$var$cleanupWindowResizeHandler) $3cb6d3769806d9dc$var$cleanupWindowResizeHandler = $3cb6d3769806d9dc$var$createResizeHandler();
    return ()=>{
        $3cb6d3769806d9dc$var$listeners.delete(callback);
        if (!$3cb6d3769806d9dc$var$listeners.size && $3cb6d3769806d9dc$var$cleanupWindowResizeHandler) {
            $3cb6d3769806d9dc$var$cleanupWindowResizeHandler();
            $3cb6d3769806d9dc$var$cleanupWindowResizeHandler = void 0;
        }
    };
};
// src/dom-events/resize/index.ts
var $3cb6d3769806d9dc$export$45b39e67d4ce4921 = (callback, { container: container = document.documentElement } = {})=>{
    if (container === document.documentElement) return $3cb6d3769806d9dc$var$resizeWindow(callback);
    else return $3cb6d3769806d9dc$var$resizeElement(callback, container);
};
// src/progress.ts
var $3cb6d3769806d9dc$var$progress = (min, max, value)=>max - min === 0 ? 1 : (value - min) / (max - min);
// src/dom-events/scroll/ScrollHandler.ts
var $3cb6d3769806d9dc$var$SCROLL_KEYS = {
    x: {
        length: "Width",
        position: "Left"
    },
    y: {
        length: "Height",
        position: "Top"
    }
};
var $3cb6d3769806d9dc$var$ScrollHandler = class {
    constructor(callback, container){
        this.createAxis = ()=>({
                current: 0,
                progress: 0,
                scrollLength: 0
            });
        this.updateAxis = (axisName)=>{
            const axis = this.info[axisName];
            const { length: length, position: position } = $3cb6d3769806d9dc$var$SCROLL_KEYS[axisName];
            axis.current = this.container[`scroll${position}`];
            axis.scrollLength = this.container[`scroll${length}`] - this.container[`client${length}`];
            axis.progress = $3cb6d3769806d9dc$var$progress(0, axis.scrollLength, axis.current);
        };
        this.update = ()=>{
            this.updateAxis("x");
            this.updateAxis("y");
        };
        this.sendEvent = ()=>{
            this.callback(this.info);
        };
        this.advance = ()=>{
            this.update();
            this.sendEvent();
        };
        this.callback = callback;
        this.container = container;
        this.info = {
            time: 0,
            x: this.createAxis(),
            y: this.createAxis()
        };
    }
};
// src/dom-events/scroll/index.ts
var $3cb6d3769806d9dc$var$scrollListeners = /* @__PURE__ */ new WeakMap();
var $3cb6d3769806d9dc$var$resizeListeners = /* @__PURE__ */ new WeakMap();
var $3cb6d3769806d9dc$var$onScrollHandlers = /* @__PURE__ */ new WeakMap();
var $3cb6d3769806d9dc$var$getTarget = (container)=>container === document.documentElement ? window : container;
var $3cb6d3769806d9dc$export$d4d89fd61e5416ee = (callback, { container: container = document.documentElement } = {})=>{
    let containerHandlers = $3cb6d3769806d9dc$var$onScrollHandlers.get(container);
    if (!containerHandlers) {
        containerHandlers = /* @__PURE__ */ new Set();
        $3cb6d3769806d9dc$var$onScrollHandlers.set(container, containerHandlers);
    }
    const containerHandler = new $3cb6d3769806d9dc$var$ScrollHandler(callback, container);
    containerHandlers.add(containerHandler);
    if (!$3cb6d3769806d9dc$var$scrollListeners.has(container)) {
        const listener = ()=>{
            containerHandlers === null || containerHandlers === void 0 ? void 0 : containerHandlers.forEach((handler)=>handler.advance());
            return true;
        };
        $3cb6d3769806d9dc$var$scrollListeners.set(container, listener);
        const target = $3cb6d3769806d9dc$var$getTarget(container);
        window.addEventListener("resize", listener, {
            passive: true
        });
        if (container !== document.documentElement) $3cb6d3769806d9dc$var$resizeListeners.set(container, $3cb6d3769806d9dc$export$45b39e67d4ce4921(listener, {
            container: container
        }));
        target.addEventListener("scroll", listener, {
            passive: true
        });
    }
    const animateScroll = $3cb6d3769806d9dc$var$scrollListeners.get(container);
    (0, $24333df8762df523$export$27f233d61a9e2fa4)(animateScroll);
    return ()=>{
        (0, $24333df8762df523$export$27f233d61a9e2fa4).cancel(animateScroll);
        const containerHandlers2 = $3cb6d3769806d9dc$var$onScrollHandlers.get(container);
        if (!containerHandlers2) return;
        containerHandlers2.delete(containerHandler);
        if (containerHandlers2.size) return;
        const listener = $3cb6d3769806d9dc$var$scrollListeners.get(container);
        $3cb6d3769806d9dc$var$scrollListeners.delete(container);
        if (listener) {
            var _resizeListeners_get;
            $3cb6d3769806d9dc$var$getTarget(container).removeEventListener("scroll", listener);
            window.removeEventListener("resize", listener);
            (_resizeListeners_get = $3cb6d3769806d9dc$var$resizeListeners.get(container)) === null || _resizeListeners_get === void 0 ? void 0 : _resizeListeners_get();
        }
    };
};
function $3cb6d3769806d9dc$export$fe4300aa8eebea86(init) {
    const ref = (0, $7fPBF.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}
var $3cb6d3769806d9dc$export$700979bc83e7db82 = $3cb6d3769806d9dc$export$48d7c418edadb60c() ? (0, $7fPBF.useEffect) : (0, $7fPBF.useLayoutEffect);
// src/hooks/useIsMounted.ts
var $3cb6d3769806d9dc$var$useIsMounted = ()=>{
    const isMounted = (0, $7fPBF.useRef)(false);
    $3cb6d3769806d9dc$export$700979bc83e7db82(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, []);
    return isMounted;
};
// src/hooks/useForceUpdate.ts
function $3cb6d3769806d9dc$export$91db9bc4f8ac944a() {
    const update = (0, $7fPBF.useState)()[1];
    const isMounted = $3cb6d3769806d9dc$var$useIsMounted();
    return ()=>{
        if (isMounted.current) update(Math.random());
    };
}
function $3cb6d3769806d9dc$export$b6feb8998cd9b342(getResult, inputs) {
    const [initial] = (0, $7fPBF.useState)(()=>({
            inputs: inputs,
            result: getResult()
        }));
    const committed = (0, $7fPBF.useRef)();
    const prevCache = committed.current;
    let cache = prevCache;
    if (cache) {
        const useCache = Boolean(inputs && cache.inputs && $3cb6d3769806d9dc$var$areInputsEqual(inputs, cache.inputs));
        if (!useCache) cache = {
            inputs: inputs,
            result: getResult()
        };
    } else cache = initial;
    (0, $7fPBF.useEffect)(()=>{
        committed.current = cache;
        if (prevCache == initial) initial.inputs = initial.result = void 0;
    }, [
        cache
    ]);
    return cache.result;
}
function $3cb6d3769806d9dc$var$areInputsEqual(next, prev) {
    if (next.length !== prev.length) return false;
    for(let i = 0; i < next.length; i++){
        if (next[i] !== prev[i]) return false;
    }
    return true;
}
var $3cb6d3769806d9dc$export$392544347a18b6ea = (effect)=>(0, $7fPBF.useEffect)(effect, $3cb6d3769806d9dc$var$emptyDeps);
var $3cb6d3769806d9dc$var$emptyDeps = [];
function $3cb6d3769806d9dc$export$ef7ad0c4e19d7fbf(value) {
    const prevRef = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(()=>{
        prevRef.current = value;
    });
    return prevRef.current;
}
var $3cb6d3769806d9dc$export$6a42007cf1e7b6f8 = ()=>{
    const [reducedMotion, setReducedMotion] = (0, $7fPBF.useState)(null);
    $3cb6d3769806d9dc$export$700979bc83e7db82(()=>{
        const mql = window.matchMedia("(prefers-reduced-motion)");
        const handleMediaChange = (e)=>{
            setReducedMotion(e.matches);
            $3cb6d3769806d9dc$var$assign({
                skipAnimation: e.matches
            });
        };
        handleMediaChange(mql);
        if (mql.addEventListener) mql.addEventListener("change", handleMediaChange);
        else mql.addListener(handleMediaChange);
        return ()=>{
            if (mql.removeEventListener) mql.removeEventListener("change", handleMediaChange);
            else mql.removeListener(handleMediaChange);
        };
    }, []);
    return reducedMotion;
};



var $7fPBF = parcelRequire("7fPBF");
// src/Animated.ts




var $7fPBF = parcelRequire("7fPBF");
var $913d375866ff6257$var$$node = Symbol.for("Animated:node");
var $913d375866ff6257$export$3df5e165e801a70f = (value)=>!!value && value[$913d375866ff6257$var$$node] === value;
var $913d375866ff6257$export$6b63995194a3a9e4 = (owner)=>owner && owner[$913d375866ff6257$var$$node];
var $913d375866ff6257$export$b553cb5b22b81b04 = (owner, node)=>(0, $3cb6d3769806d9dc$export$5c74248ea0e35446)(owner, $913d375866ff6257$var$$node, node);
var $913d375866ff6257$export$ccab2b64c5d440 = (owner)=>owner && owner[$913d375866ff6257$var$$node] && owner[$913d375866ff6257$var$$node].getPayload();
var $913d375866ff6257$export$31627395a3b18e54 = class {
    /** Get every `AnimatedValue` used by this node. */ getPayload() {
        return this.payload || [];
    }
    constructor(){
        $913d375866ff6257$export$b553cb5b22b81b04(this, this);
    }
};
var $913d375866ff6257$export$cb1e8f3c05d37ad5 = class extends $913d375866ff6257$export$31627395a3b18e54 {
    /** @internal */ static create(value) {
        return new $913d375866ff6257$export$cb1e8f3c05d37ad5(value);
    }
    getPayload() {
        return [
            this
        ];
    }
    getValue() {
        return this._value;
    }
    setValue(value, step) {
        if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).num(value)) {
            this.lastPosition = value;
            if (step) {
                value = Math.round(value / step) * step;
                if (this.done) this.lastPosition = value;
            }
        }
        if (this._value === value) return false;
        this._value = value;
        return true;
    }
    reset() {
        const { done: done } = this;
        this.done = false;
        if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).num(this._value)) {
            this.elapsedTime = 0;
            this.durationProgress = 0;
            this.lastPosition = this._value;
            if (done) this.lastVelocity = null;
            this.v0 = null;
        }
    }
    constructor(_value){
        super();
        this._value = _value;
        this.done = true;
        this.durationProgress = 0;
        if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).num(this._value)) this.lastPosition = this._value;
    }
};
var $913d375866ff6257$export$f6c6c4cbd7fa5b93 = class extends $913d375866ff6257$export$cb1e8f3c05d37ad5 {
    /** @internal */ static create(value) {
        return new $913d375866ff6257$export$f6c6c4cbd7fa5b93(value);
    }
    getValue() {
        const value = this._string;
        return value == null ? this._string = this._toString(this._value) : value;
    }
    setValue(value) {
        if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).str(value)) {
            if (value == this._string) return false;
            this._string = value;
            this._value = 1;
        } else if (super.setValue(value)) this._string = null;
        else return false;
        return true;
    }
    reset(goal) {
        if (goal) this._toString = (0, $3cb6d3769806d9dc$export$b12af43b97697ef5)({
            output: [
                this.getValue(),
                goal
            ]
        });
        this._value = 0;
        super.reset();
    }
    constructor(value){
        super(0);
        this._string = null;
        this._toString = (0, $3cb6d3769806d9dc$export$b12af43b97697ef5)({
            output: [
                value,
                value
            ]
        });
    }
};
// src/context.ts
var $913d375866ff6257$var$TreeContext = {
    dependencies: null
};
// src/AnimatedObject.ts
var $913d375866ff6257$export$f1b0b9e366a6e2d4 = class extends $913d375866ff6257$export$31627395a3b18e54 {
    getValue(animated) {
        const values = {};
        (0, $3cb6d3769806d9dc$export$f4c6fe153f5a944e)(this.source, (source, key)=>{
            if ($913d375866ff6257$export$3df5e165e801a70f(source)) values[key] = source.getValue(animated);
            else if ((0, $3cb6d3769806d9dc$export$57ea7e3a7f6280c7)(source)) values[key] = (0, $3cb6d3769806d9dc$export$e37b7520edd66839)(source);
            else if (!animated) values[key] = source;
        });
        return values;
    }
    /** Replace the raw object data */ setValue(source) {
        this.source = source;
        this.payload = this._makePayload(source);
    }
    reset() {
        if (this.payload) (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(this.payload, (node)=>node.reset());
    }
    /** Create a payload set. */ _makePayload(source) {
        if (source) {
            const payload = /* @__PURE__ */ new Set();
            (0, $3cb6d3769806d9dc$export$f4c6fe153f5a944e)(source, this._addToPayload, payload);
            return Array.from(payload);
        }
    }
    /** Add to a payload set. */ _addToPayload(source) {
        if ($913d375866ff6257$var$TreeContext.dependencies && (0, $3cb6d3769806d9dc$export$57ea7e3a7f6280c7)(source)) $913d375866ff6257$var$TreeContext.dependencies.add(source);
        const payload = $913d375866ff6257$export$ccab2b64c5d440(source);
        if (payload) (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(payload, (node)=>this.add(node));
    }
    constructor(source){
        super();
        this.source = source;
        this.setValue(source);
    }
};
// src/AnimatedArray.ts
var $913d375866ff6257$export$ede394683406942d = class extends $913d375866ff6257$export$f1b0b9e366a6e2d4 {
    /** @internal */ static create(source) {
        return new $913d375866ff6257$export$ede394683406942d(source);
    }
    getValue() {
        return this.source.map((node)=>node.getValue());
    }
    setValue(source) {
        const payload = this.getPayload();
        if (source.length == payload.length) return payload.map((node, i)=>node.setValue(source[i])).some(Boolean);
        super.setValue(source.map($913d375866ff6257$var$makeAnimated));
        return true;
    }
    constructor(source){
        super(source);
    }
};
function $913d375866ff6257$var$makeAnimated(value) {
    const nodeType = (0, $3cb6d3769806d9dc$export$75bed621f62abfa9)(value) ? $913d375866ff6257$export$f6c6c4cbd7fa5b93 : $913d375866ff6257$export$cb1e8f3c05d37ad5;
    return nodeType.create(value);
}
function $913d375866ff6257$export$e6b77ddbe47b132e(value) {
    const parentNode = $913d375866ff6257$export$6b63995194a3a9e4(value);
    return parentNode ? parentNode.constructor : (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).arr(value) ? $913d375866ff6257$export$ede394683406942d : (0, $3cb6d3769806d9dc$export$75bed621f62abfa9)(value) ? $913d375866ff6257$export$f6c6c4cbd7fa5b93 : $913d375866ff6257$export$cb1e8f3c05d37ad5;
}
var $913d375866ff6257$var$withAnimated = (Component, host)=>{
    const hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(Component) || Component.prototype && Component.prototype.isReactComponent;
    return (0, $7fPBF.forwardRef)((givenProps, givenRef)=>{
        const instanceRef = (0, $7fPBF.useRef)(null);
        const ref = hasInstance && // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $7fPBF.useCallback)((value)=>{
            instanceRef.current = $913d375866ff6257$var$updateRef(givenRef, value);
        }, [
            givenRef
        ]);
        const [props, deps] = $913d375866ff6257$var$getAnimatedState(givenProps, host);
        const forceUpdate = (0, $3cb6d3769806d9dc$export$91db9bc4f8ac944a)();
        const callback = ()=>{
            const instance = instanceRef.current;
            if (hasInstance && !instance) return;
            const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
            if (didUpdate === false) forceUpdate();
        };
        const observer = new $913d375866ff6257$var$PropsObserver(callback, deps);
        const observerRef = (0, $7fPBF.useRef)();
        (0, $3cb6d3769806d9dc$export$700979bc83e7db82)(()=>{
            observerRef.current = observer;
            (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(deps, (dep)=>(0, $3cb6d3769806d9dc$export$72d604e3f8d000a5)(dep, observer));
            return ()=>{
                if (observerRef.current) {
                    (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(observerRef.current.deps, (dep)=>(0, $3cb6d3769806d9dc$export$7a0eb830d336339b)(dep, observerRef.current));
                    (0, $24333df8762df523$export$27f233d61a9e2fa4).cancel(observerRef.current.update);
                }
            };
        });
        (0, $7fPBF.useEffect)(callback, []);
        (0, $3cb6d3769806d9dc$export$392544347a18b6ea)(()=>()=>{
                const observer2 = observerRef.current;
                (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(observer2.deps, (dep)=>(0, $3cb6d3769806d9dc$export$7a0eb830d336339b)(dep, observer2));
            });
        const usedProps = host.getComponentProps(props.getValue());
        return /* @__PURE__ */ $7fPBF.createElement(Component, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, usedProps), {
            ref: ref
        }));
    });
};
var $913d375866ff6257$var$PropsObserver = class {
    eventObserved(event) {
        if (event.type == "change") (0, $24333df8762df523$export$27f233d61a9e2fa4).write(this.update);
    }
    constructor(update, deps){
        this.update = update;
        this.deps = deps;
    }
};
function $913d375866ff6257$var$getAnimatedState(props, host) {
    const dependencies = /* @__PURE__ */ new Set();
    $913d375866ff6257$var$TreeContext.dependencies = dependencies;
    if (props.style) props = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        style: host.createAnimatedStyle(props.style)
    });
    props = new $913d375866ff6257$export$f1b0b9e366a6e2d4(props);
    $913d375866ff6257$var$TreeContext.dependencies = null;
    return [
        props,
        dependencies
    ];
}
function $913d375866ff6257$var$updateRef(ref, value) {
    if (ref) {
        if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(ref)) ref(value);
        else ref.current = value;
    }
    return value;
}
// src/createHost.ts
var $913d375866ff6257$var$cacheKey = Symbol.for("AnimatedComponent");
var $913d375866ff6257$export$4ee5c78f6dcbcef = (components, { applyAnimatedValues: applyAnimatedValues = ()=>false, createAnimatedStyle: createAnimatedStyle = (style)=>new $913d375866ff6257$export$f1b0b9e366a6e2d4(style), getComponentProps: getComponentProps = (props)=>props } = {})=>{
    const hostConfig = {
        applyAnimatedValues: applyAnimatedValues,
        createAnimatedStyle: createAnimatedStyle,
        getComponentProps: getComponentProps
    };
    const animated = (Component)=>{
        const displayName = $913d375866ff6257$var$getDisplayName(Component) || "Anonymous";
        if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).str(Component)) Component = animated[Component] || (animated[Component] = $913d375866ff6257$var$withAnimated(Component, hostConfig));
        else Component = Component[$913d375866ff6257$var$cacheKey] || (Component[$913d375866ff6257$var$cacheKey] = $913d375866ff6257$var$withAnimated(Component, hostConfig));
        Component.displayName = `Animated(${displayName})`;
        return Component;
    };
    (0, $3cb6d3769806d9dc$export$f4c6fe153f5a944e)(components, (Component, key)=>{
        if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).arr(components)) key = $913d375866ff6257$var$getDisplayName(Component);
        animated[key] = animated(Component);
    });
    return {
        animated: animated
    };
};
var $913d375866ff6257$var$getDisplayName = (arg)=>(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).str(arg) ? arg : arg && (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).str(arg.displayName) ? arg.displayName : (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(arg) && arg.name || null;


// src/utils.ts
var $3cf2c5f9d123518e$export$b24b633b1364b94b = class {
};


function $5aec47966e5882be$var$callProp(value, ...args) {
    return (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(value) ? value(...args) : value;
}
var $5aec47966e5882be$var$matchProp = (value, key)=>value === true || !!(key && value && ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(value) ? value(key) : (0, $3cb6d3769806d9dc$export$45b10814cc054894)(value).includes(key)));
var $5aec47966e5882be$var$resolveProp = (prop, key)=>(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).obj(prop) ? key && prop[key] : prop;
var $5aec47966e5882be$var$getDefaultProp = (props, key)=>props.default === true ? props[key] : props.default ? props.default[key] : void 0;
var $5aec47966e5882be$var$noopTransform = (value)=>value;
var $5aec47966e5882be$var$getDefaultProps = (props, transform = $5aec47966e5882be$var$noopTransform)=>{
    let keys = $5aec47966e5882be$var$DEFAULT_PROPS;
    if (props.default && props.default !== true) {
        props = props.default;
        keys = Object.keys(props);
    }
    const defaults2 = {};
    for (const key of keys){
        const value = transform(props[key], key);
        if (!(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(value)) defaults2[key] = value;
    }
    return defaults2;
};
var $5aec47966e5882be$var$DEFAULT_PROPS = [
    "config",
    "onProps",
    "onStart",
    "onChange",
    "onPause",
    "onResume",
    "onRest"
];
var $5aec47966e5882be$var$RESERVED_PROPS = {
    config: 1,
    from: 1,
    to: 1,
    ref: 1,
    loop: 1,
    reset: 1,
    pause: 1,
    cancel: 1,
    reverse: 1,
    immediate: 1,
    default: 1,
    delay: 1,
    onProps: 1,
    onStart: 1,
    onChange: 1,
    onPause: 1,
    onResume: 1,
    onRest: 1,
    onResolve: 1,
    // Transition props
    items: 1,
    trail: 1,
    sort: 1,
    expires: 1,
    initial: 1,
    enter: 1,
    update: 1,
    leave: 1,
    children: 1,
    onDestroyed: 1,
    // Internal props
    keys: 1,
    callId: 1,
    parentId: 1
};
function $5aec47966e5882be$var$getForwardProps(props) {
    const forward = {};
    let count = 0;
    (0, $3cb6d3769806d9dc$export$f4c6fe153f5a944e)(props, (value, prop)=>{
        if (!$5aec47966e5882be$var$RESERVED_PROPS[prop]) {
            forward[prop] = value;
            count++;
        }
    });
    if (count) return forward;
}
function $5aec47966e5882be$export$b971039a739bf227(props) {
    const to2 = $5aec47966e5882be$var$getForwardProps(props);
    if (to2) {
        const out = {
            to: to2
        };
        (0, $3cb6d3769806d9dc$export$f4c6fe153f5a944e)(props, (val, key)=>key in to2 || (out[key] = val));
        return out;
    }
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props);
}
function $5aec47966e5882be$var$computeGoal(value) {
    value = (0, $3cb6d3769806d9dc$export$e37b7520edd66839)(value);
    return (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).arr(value) ? value.map($5aec47966e5882be$var$computeGoal) : (0, $3cb6d3769806d9dc$export$75bed621f62abfa9)(value) ? (0, $3cb6d3769806d9dc$export$cceeabf822b64fc0).createStringInterpolator({
        range: [
            0,
            1
        ],
        output: [
            value,
            value
        ]
    })(1) : value;
}
function $5aec47966e5882be$var$hasProps(props) {
    for(const _ in props)return true;
    return false;
}
function $5aec47966e5882be$var$isAsyncTo(to2) {
    return (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(to2) || (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).arr(to2) && (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).obj(to2[0]);
}
function $5aec47966e5882be$var$detachRefs(ctrl, ref) {
    var _ctrl_ref;
    (_ctrl_ref = ctrl.ref) === null || _ctrl_ref === void 0 ? void 0 : _ctrl_ref.delete(ctrl);
    ref === null || ref === void 0 ? void 0 : ref.delete(ctrl);
}
function $5aec47966e5882be$var$replaceRef(ctrl, ref) {
    if (ref && ctrl.ref !== ref) {
        var _ctrl_ref;
        (_ctrl_ref = ctrl.ref) === null || _ctrl_ref === void 0 ? void 0 : _ctrl_ref.delete(ctrl);
        ref.add(ctrl);
        ctrl.ref = ref;
    }
}
// src/hooks/useChain.ts
function $5aec47966e5882be$export$a4a17273dffcc09c(refs, timeSteps, timeFrame = 1e3) {
    (0, $3cb6d3769806d9dc$export$700979bc83e7db82)(()=>{
        if (timeSteps) {
            let prevDelay = 0;
            (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(refs, (ref, i)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    let delay = timeFrame * timeSteps[i];
                    if (isNaN(delay)) delay = prevDelay;
                    else prevDelay = delay;
                    (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(controllers, (ctrl)=>{
                        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(ctrl.queue, (props)=>{
                            const memoizedDelayProp = props.delay;
                            props.delay = (key)=>delay + $5aec47966e5882be$var$callProp(memoizedDelayProp || 0, key);
                        });
                    });
                    ref.start();
                }
            });
        } else {
            let p = Promise.resolve();
            (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(refs, (ref)=>{
                const controllers = ref.current;
                if (controllers.length) {
                    const queues = controllers.map((ctrl)=>{
                        const q = ctrl.queue;
                        ctrl.queue = [];
                        return q;
                    });
                    p = p.then(()=>{
                        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(controllers, (ctrl, i)=>(0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(queues[i] || [], (update2)=>ctrl.queue.push(update2)));
                        return Promise.all(ref.start());
                    });
                }
            });
        }
    });
}
// src/constants.ts
var $5aec47966e5882be$export$e506a1d27d1eaa20 = {
    default: {
        tension: 170,
        friction: 26
    },
    gentle: {
        tension: 120,
        friction: 14
    },
    wobbly: {
        tension: 180,
        friction: 12
    },
    stiff: {
        tension: 210,
        friction: 20
    },
    slow: {
        tension: 280,
        friction: 60
    },
    molasses: {
        tension: 280,
        friction: 120
    }
};
// src/AnimationConfig.ts
var $5aec47966e5882be$var$defaults = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $5aec47966e5882be$export$e506a1d27d1eaa20.default), {
    mass: 1,
    damping: 1,
    easing: (0, $3cb6d3769806d9dc$export$15a0bf1b4bbacad8).linear,
    clamp: false
});
var $5aec47966e5882be$var$AnimationConfig = class {
    constructor(){
        /**
     * The initial velocity of one or more values.
     *
     * @default 0
     */ this.velocity = 0;
        Object.assign(this, $5aec47966e5882be$var$defaults);
    }
};
function $5aec47966e5882be$var$mergeConfig(config2, newConfig, defaultConfig) {
    if (defaultConfig) {
        defaultConfig = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultConfig);
        $5aec47966e5882be$var$sanitizeConfig(defaultConfig, newConfig);
        newConfig = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultConfig, newConfig);
    }
    $5aec47966e5882be$var$sanitizeConfig(config2, newConfig);
    Object.assign(config2, newConfig);
    for(const key in $5aec47966e5882be$var$defaults)if (config2[key] == null) config2[key] = $5aec47966e5882be$var$defaults[key];
    let { frequency: frequency, damping: damping } = config2;
    const { mass: mass } = config2;
    if (!(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(frequency)) {
        if (frequency < 0.01) frequency = 0.01;
        if (damping < 0) damping = 0;
        config2.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
        config2.friction = 4 * Math.PI * damping * mass / frequency;
    }
    return config2;
}
function $5aec47966e5882be$var$sanitizeConfig(config2, props) {
    if (!(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(props.decay)) config2.duration = void 0;
    else {
        const isTensionConfig = !(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(props.tension) || !(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(props.friction);
        if (isTensionConfig || !(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(props.frequency) || !(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(props.damping) || !(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(props.mass)) {
            config2.duration = void 0;
            config2.decay = void 0;
        }
        if (isTensionConfig) config2.frequency = void 0;
    }
}
// src/Animation.ts
var $5aec47966e5882be$var$emptyArray = [];
var $5aec47966e5882be$var$Animation = class {
    constructor(){
        this.changed = false;
        this.values = $5aec47966e5882be$var$emptyArray;
        this.toValues = null;
        this.fromValues = $5aec47966e5882be$var$emptyArray;
        this.config = new $5aec47966e5882be$var$AnimationConfig();
        this.immediate = false;
    }
};
function $5aec47966e5882be$var$scheduleProps(callId, { key: key, props: props, defaultProps: defaultProps, state: state, actions: actions }) {
    return new Promise((resolve, reject)=>{
        let delay;
        let timeout;
        var _props_cancel;
        let cancel = $5aec47966e5882be$var$matchProp((_props_cancel = props.cancel) !== null && _props_cancel !== void 0 ? _props_cancel : defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.cancel, key);
        if (cancel) onStart();
        else {
            if (!(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(props.pause)) state.paused = $5aec47966e5882be$var$matchProp(props.pause, key);
            let pause = defaultProps === null || defaultProps === void 0 ? void 0 : defaultProps.pause;
            if (pause !== true) pause = state.paused || $5aec47966e5882be$var$matchProp(pause, key);
            delay = $5aec47966e5882be$var$callProp(props.delay || 0, key);
            if (pause) {
                state.resumeQueue.add(onResume);
                actions.pause();
            } else {
                actions.resume();
                onResume();
            }
        }
        function onPause() {
            state.resumeQueue.add(onResume);
            state.timeouts.delete(timeout);
            timeout.cancel();
            delay = timeout.time - (0, $24333df8762df523$export$27f233d61a9e2fa4).now();
        }
        function onResume() {
            if (delay > 0 && !(0, $3cb6d3769806d9dc$export$cceeabf822b64fc0).skipAnimation) {
                state.delayed = true;
                timeout = (0, $24333df8762df523$export$27f233d61a9e2fa4).setTimeout(onStart, delay);
                state.pauseQueue.add(onPause);
                state.timeouts.add(timeout);
            } else onStart();
        }
        function onStart() {
            if (state.delayed) state.delayed = false;
            state.pauseQueue.delete(onPause);
            state.timeouts.delete(timeout);
            if (callId <= (state.cancelId || 0)) cancel = true;
            try {
                actions.start((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
                    callId: callId,
                    cancel: cancel
                }), resolve);
            } catch (err) {
                reject(err);
            }
        }
    });
}
// src/AnimationResult.ts
var $5aec47966e5882be$var$getCombinedResult = (target, results)=>results.length == 1 ? results[0] : results.some((result)=>result.cancelled) ? $5aec47966e5882be$var$getCancelledResult(target.get()) : results.every((result)=>result.noop) ? $5aec47966e5882be$var$getNoopResult(target.get()) : $5aec47966e5882be$var$getFinishedResult(target.get(), results.every((result)=>result.finished));
var $5aec47966e5882be$var$getNoopResult = (value)=>({
        value: value,
        noop: true,
        finished: true,
        cancelled: false
    });
var $5aec47966e5882be$var$getFinishedResult = (value, finished, cancelled = false)=>({
        value: value,
        finished: finished,
        cancelled: cancelled
    });
var $5aec47966e5882be$var$getCancelledResult = (value)=>({
        value: value,
        cancelled: true,
        finished: false
    });
// src/runAsync.ts
function $5aec47966e5882be$var$runAsync(to2, props, state, target) {
    const { callId: callId, parentId: parentId, onRest: onRest } = props;
    const { asyncTo: prevTo, promise: prevPromise } = state;
    if (!parentId && to2 === prevTo && !props.reset) return prevPromise;
    return state.promise = (async ()=>{
        state.asyncId = callId;
        state.asyncTo = to2;
        const defaultProps = $5aec47966e5882be$var$getDefaultProps(props, (value, key)=>// The `onRest` prop is only called when the `runAsync` promise is resolved.
            key === "onRest" ? void 0 : value);
        let preventBail;
        let bail;
        const bailPromise = new Promise((resolve, reject)=>(preventBail = resolve, bail = reject));
        const bailIfEnded = (bailSignal)=>{
            const bailResult = // The `cancel` prop or `stop` method was used.
            callId <= (state.cancelId || 0) && $5aec47966e5882be$var$getCancelledResult(target) || // The async `to` prop was replaced.
            callId !== state.asyncId && $5aec47966e5882be$var$getFinishedResult(target, false);
            if (bailResult) {
                bailSignal.result = bailResult;
                bail(bailSignal);
                throw bailSignal;
            }
        };
        const animate = (arg1, arg2)=>{
            const bailSignal = new $5aec47966e5882be$export$d362d093fa99dc7();
            const skipAnimationSignal = new $5aec47966e5882be$var$SkipAnimationSignal();
            return (async ()=>{
                if ((0, $3cb6d3769806d9dc$export$cceeabf822b64fc0).skipAnimation) {
                    $5aec47966e5882be$var$stopAsync(state);
                    skipAnimationSignal.result = $5aec47966e5882be$var$getFinishedResult(target, false);
                    bail(skipAnimationSignal);
                    throw skipAnimationSignal;
                }
                bailIfEnded(bailSignal);
                const props2 = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).obj(arg1) ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg1) : (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg2), {
                    to: arg1
                });
                props2.parentId = callId;
                (0, $3cb6d3769806d9dc$export$f4c6fe153f5a944e)(defaultProps, (value, key)=>{
                    if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(props2[key])) props2[key] = value;
                });
                const result2 = await target.start(props2);
                bailIfEnded(bailSignal);
                if (state.paused) await new Promise((resume)=>{
                    state.resumeQueue.add(resume);
                });
                return result2;
            })();
        };
        let result;
        if ((0, $3cb6d3769806d9dc$export$cceeabf822b64fc0).skipAnimation) {
            $5aec47966e5882be$var$stopAsync(state);
            return $5aec47966e5882be$var$getFinishedResult(target, false);
        }
        try {
            let animating;
            if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).arr(to2)) animating = (async (queue)=>{
                for (const props2 of queue)await animate(props2);
            })(to2);
            else animating = Promise.resolve(to2(animate, target.stop.bind(target)));
            await Promise.all([
                animating.then(preventBail),
                bailPromise
            ]);
            result = $5aec47966e5882be$var$getFinishedResult(target.get(), true, false);
        } catch (err) {
            if (err instanceof $5aec47966e5882be$export$d362d093fa99dc7) result = err.result;
            else if (err instanceof $5aec47966e5882be$var$SkipAnimationSignal) result = err.result;
            else throw err;
        } finally{
            if (callId == state.asyncId) {
                state.asyncId = parentId;
                state.asyncTo = parentId ? prevTo : void 0;
                state.promise = parentId ? prevPromise : void 0;
            }
        }
        if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(onRest)) (0, $24333df8762df523$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            onRest(result, target, target.item);
        });
        return result;
    })();
}
function $5aec47966e5882be$var$stopAsync(state, cancelId) {
    (0, $3cb6d3769806d9dc$export$4909b86c8034bf73)(state.timeouts, (t)=>t.cancel());
    state.pauseQueue.clear();
    state.resumeQueue.clear();
    state.asyncId = state.asyncTo = state.promise = void 0;
    if (cancelId) state.cancelId = cancelId;
}
var $5aec47966e5882be$export$d362d093fa99dc7 = class extends Error {
    constructor(){
        super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
    }
};
var $5aec47966e5882be$var$SkipAnimationSignal = class extends Error {
    constructor(){
        super("SkipAnimationSignal");
    }
};
var $5aec47966e5882be$var$isFrameValue = (value)=>value instanceof $5aec47966e5882be$export$8229896f80e2495e;
var $5aec47966e5882be$var$nextId = 1;
var $5aec47966e5882be$export$8229896f80e2495e = class extends (0, $3cb6d3769806d9dc$export$aff8e1ac1a016a2) {
    get priority() {
        return this._priority;
    }
    set priority(priority) {
        if (this._priority != priority) {
            this._priority = priority;
            this._onPriorityChange(priority);
        }
    }
    /** Get the current value */ get() {
        const node = (0, $913d375866ff6257$export$6b63995194a3a9e4)(this);
        return node && node.getValue();
    }
    /** Create a spring that maps our value to another value */ to(...args) {
        return (0, $3cb6d3769806d9dc$export$cceeabf822b64fc0).to(this, args);
    }
    /** @deprecated Use the `to` method instead. */ interpolate(...args) {
        (0, $3cb6d3769806d9dc$export$2abfcde8ae218ba8)();
        return (0, $3cb6d3769806d9dc$export$cceeabf822b64fc0).to(this, args);
    }
    toJSON() {
        return this.get();
    }
    observerAdded(count) {
        if (count == 1) this._attach();
    }
    observerRemoved(count) {
        if (count == 0) this._detach();
    }
    /** Called when the first child is added. */ _attach() {}
    /** Called when the last child is removed. */ _detach() {}
    /** Tell our children about our new value */ _onChange(value, idle = false) {
        (0, $3cb6d3769806d9dc$export$31752c40a5fab62a)(this, {
            type: "change",
            parent: this,
            value: value,
            idle: idle
        });
    }
    /** Tell our children about our new priority */ _onPriorityChange(priority) {
        if (!this.idle) (0, $3cb6d3769806d9dc$export$a57f5080a3bcc90a).sort(this);
        (0, $3cb6d3769806d9dc$export$31752c40a5fab62a)(this, {
            type: "priority",
            parent: this,
            priority: priority
        });
    }
    constructor(){
        super(...arguments);
        this.id = $5aec47966e5882be$var$nextId++;
        this._priority = 0;
    }
};
// src/SpringPhase.ts
var $5aec47966e5882be$var$$P = Symbol.for("SpringPhase");
var $5aec47966e5882be$var$HAS_ANIMATED = 1;
var $5aec47966e5882be$var$IS_ANIMATING = 2;
var $5aec47966e5882be$var$IS_PAUSED = 4;
var $5aec47966e5882be$var$hasAnimated = (target)=>(target[$5aec47966e5882be$var$$P] & $5aec47966e5882be$var$HAS_ANIMATED) > 0;
var $5aec47966e5882be$var$isAnimating = (target)=>(target[$5aec47966e5882be$var$$P] & $5aec47966e5882be$var$IS_ANIMATING) > 0;
var $5aec47966e5882be$var$isPaused = (target)=>(target[$5aec47966e5882be$var$$P] & $5aec47966e5882be$var$IS_PAUSED) > 0;
var $5aec47966e5882be$var$setActiveBit = (target, active)=>active ? target[$5aec47966e5882be$var$$P] |= $5aec47966e5882be$var$IS_ANIMATING | $5aec47966e5882be$var$HAS_ANIMATED : target[$5aec47966e5882be$var$$P] &= ~$5aec47966e5882be$var$IS_ANIMATING;
var $5aec47966e5882be$var$setPausedBit = (target, paused)=>paused ? target[$5aec47966e5882be$var$$P] |= $5aec47966e5882be$var$IS_PAUSED : target[$5aec47966e5882be$var$$P] &= ~$5aec47966e5882be$var$IS_PAUSED;
// src/SpringValue.ts
var $5aec47966e5882be$export$5854d13427d5a954 = class extends $5aec47966e5882be$export$8229896f80e2495e {
    /** Equals true when not advancing on each frame. */ get idle() {
        return !($5aec47966e5882be$var$isAnimating(this) || this._state.asyncTo) || $5aec47966e5882be$var$isPaused(this);
    }
    get goal() {
        return (0, $3cb6d3769806d9dc$export$e37b7520edd66839)(this.animation.to);
    }
    get velocity() {
        const node = (0, $913d375866ff6257$export$6b63995194a3a9e4)(this);
        return node instanceof (0, $913d375866ff6257$export$cb1e8f3c05d37ad5) ? node.lastVelocity || 0 : node.getPayload().map((node2)=>node2.lastVelocity || 0);
    }
    /**
   * When true, this value has been animated at least once.
   */ get hasAnimated() {
        return $5aec47966e5882be$var$hasAnimated(this);
    }
    /**
   * When true, this value has an unfinished animation,
   * which is either active or paused.
   */ get isAnimating() {
        return $5aec47966e5882be$var$isAnimating(this);
    }
    /**
   * When true, all current and future animations are paused.
   */ get isPaused() {
        return $5aec47966e5882be$var$isPaused(this);
    }
    /**
   *
   *
   */ get isDelayed() {
        return this._state.delayed;
    }
    /** Advance the current animation by a number of milliseconds */ advance(dt) {
        let idle = true;
        let changed = false;
        const anim = this.animation;
        let { toValues: toValues } = anim;
        const { config: config2 } = anim;
        const payload = (0, $913d375866ff6257$export$ccab2b64c5d440)(anim.to);
        if (!payload && (0, $3cb6d3769806d9dc$export$57ea7e3a7f6280c7)(anim.to)) toValues = (0, $3cb6d3769806d9dc$export$45b10814cc054894)((0, $3cb6d3769806d9dc$export$e37b7520edd66839)(anim.to));
        anim.values.forEach((node2, i)=>{
            if (node2.done) return;
            const to2 = // Animated strings always go from 0 to 1.
            node2.constructor == (0, $913d375866ff6257$export$f6c6c4cbd7fa5b93) ? 1 : payload ? payload[i].lastPosition : toValues[i];
            let finished = anim.immediate;
            let position = to2;
            if (!finished) {
                position = node2.lastPosition;
                if (config2.tension <= 0) {
                    node2.done = true;
                    return;
                }
                let elapsed = node2.elapsedTime += dt;
                const from = anim.fromValues[i];
                const v0 = node2.v0 != null ? node2.v0 : node2.v0 = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).arr(config2.velocity) ? config2.velocity[i] : config2.velocity;
                let velocity;
                const precision = config2.precision || (from == to2 ? 5e-3 : Math.min(1, Math.abs(to2 - from) * 1e-3));
                if (!(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(config2.duration)) {
                    let p = 1;
                    if (config2.duration > 0) {
                        if (this._memoizedDuration !== config2.duration) {
                            this._memoizedDuration = config2.duration;
                            if (node2.durationProgress > 0) {
                                node2.elapsedTime = config2.duration * node2.durationProgress;
                                elapsed = node2.elapsedTime += dt;
                            }
                        }
                        p = (config2.progress || 0) + elapsed / this._memoizedDuration;
                        p = p > 1 ? 1 : p < 0 ? 0 : p;
                        node2.durationProgress = p;
                    }
                    position = from + config2.easing(p) * (to2 - from);
                    velocity = (position - node2.lastPosition) / dt;
                    finished = p == 1;
                } else if (config2.decay) {
                    const decay = config2.decay === true ? 0.998 : config2.decay;
                    const e = Math.exp(-(1 - decay) * elapsed);
                    position = from + v0 / (1 - decay) * (1 - e);
                    finished = Math.abs(node2.lastPosition - position) <= precision;
                    velocity = v0 * e;
                } else {
                    velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
                    const restVelocity = config2.restVelocity || precision / 10;
                    const bounceFactor = config2.clamp ? 0 : config2.bounce;
                    const canBounce = !(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(bounceFactor);
                    const isGrowing = from == to2 ? node2.v0 > 0 : from < to2;
                    let isMoving;
                    let isBouncing = false;
                    const step = 1;
                    const numSteps = Math.ceil(dt / step);
                    for(let n = 0; n < numSteps; ++n){
                        isMoving = Math.abs(velocity) > restVelocity;
                        if (!isMoving) {
                            finished = Math.abs(to2 - position) <= precision;
                            if (finished) break;
                        }
                        if (canBounce) {
                            isBouncing = position == to2 || position > to2 == isGrowing;
                            if (isBouncing) {
                                velocity = -velocity * bounceFactor;
                                position = to2;
                            }
                        }
                        const springForce = -config2.tension * 1e-6 * (position - to2);
                        const dampingForce = -config2.friction * 1e-3 * velocity;
                        const acceleration = (springForce + dampingForce) / config2.mass;
                        velocity = velocity + acceleration * step;
                        position = position + velocity * step;
                    }
                }
                node2.lastVelocity = velocity;
                if (Number.isNaN(position)) {
                    console.warn(`Got NaN while animating:`, this);
                    finished = true;
                }
            }
            if (payload && !payload[i].done) finished = false;
            if (finished) node2.done = true;
            else idle = false;
            if (node2.setValue(position, config2.round)) changed = true;
        });
        const node = (0, $913d375866ff6257$export$6b63995194a3a9e4)(this);
        const currVal = node.getValue();
        if (idle) {
            const finalVal = (0, $3cb6d3769806d9dc$export$e37b7520edd66839)(anim.to);
            if ((currVal !== finalVal || changed) && !config2.decay) {
                node.setValue(finalVal);
                this._onChange(finalVal);
            } else if (changed && config2.decay) this._onChange(currVal);
            this._stop();
        } else if (changed) this._onChange(currVal);
    }
    /** Set the current value, while stopping the current animation */ set(value) {
        (0, $24333df8762df523$export$27f233d61a9e2fa4).batchedUpdates(()=>{
            this._stop();
            this._focus(value);
            this._set(value);
        });
        return this;
    }
    /**
   * Freeze the active animation in time, as well as any updates merged
   * before `resume` is called.
   */ pause() {
        this._update({
            pause: true
        });
    }
    /** Resume the animation if paused. */ resume() {
        this._update({
            pause: false
        });
    }
    /** Skip to the end of the current animation. */ finish() {
        if ($5aec47966e5882be$var$isAnimating(this)) {
            const { to: to2, config: config2 } = this.animation;
            (0, $24333df8762df523$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                this._onStart();
                if (!config2.decay) this._set(to2, false);
                this._stop();
            });
        }
        return this;
    }
    /** Push props into the pending queue. */ update(props) {
        const queue = this.queue || (this.queue = []);
        queue.push(props);
        return this;
    }
    start(to2, arg2) {
        let queue;
        if (!(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(to2)) queue = [
            (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).obj(to2) ? to2 : (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg2), {
                to: to2
            })
        ];
        else {
            queue = this.queue || [];
            this.queue = [];
        }
        return Promise.all(queue.map((props)=>{
            const up = this._update(props);
            return up;
        })).then((results)=>$5aec47966e5882be$var$getCombinedResult(this, results));
    }
    /**
   * Stop the current animation, and cancel any delayed updates.
   *
   * Pass `true` to call `onRest` with `cancelled: true`.
   */ stop(cancel) {
        const { to: to2 } = this.animation;
        this._focus(this.get());
        $5aec47966e5882be$var$stopAsync(this._state, cancel && this._lastCallId);
        (0, $24333df8762df523$export$27f233d61a9e2fa4).batchedUpdates(()=>this._stop(to2, cancel));
        return this;
    }
    /** Restart the animation. */ reset() {
        this._update({
            reset: true
        });
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") this._start();
        else if (event.type == "priority") this.priority = event.priority + 1;
    }
    /**
   * Parse the `to` and `from` range from the given `props` object.
   *
   * This also ensures the initial value is available to animated components
   * during the render phase.
   */ _prepareNode(props) {
        const key = this.key || "";
        let { to: to2, from: from } = props;
        to2 = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).obj(to2) ? to2[key] : to2;
        if (to2 == null || $5aec47966e5882be$var$isAsyncTo(to2)) to2 = void 0;
        from = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).obj(from) ? from[key] : from;
        if (from == null) from = void 0;
        const range = {
            to: to2,
            from: from
        };
        if (!$5aec47966e5882be$var$hasAnimated(this)) {
            if (props.reverse) [to2, from] = [
                from,
                to2
            ];
            from = (0, $3cb6d3769806d9dc$export$e37b7520edd66839)(from);
            if (!(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(from)) this._set(from);
            else if (!(0, $913d375866ff6257$export$6b63995194a3a9e4)(this)) this._set(to2);
        }
        return range;
    }
    /** Every update is processed by this method before merging. */ _update(_param, isLoop) {
        var props = (0, $8d60f2ee7fd1c983$export$71511d61b312f219)({}, (0, $7ae6b455e4a352e9$export$71511d61b312f219)(_param));
        const { key: key, defaultProps: defaultProps } = this;
        if (props.default) Object.assign(defaultProps, $5aec47966e5882be$var$getDefaultProps(props, (value, prop)=>/^on/.test(prop) ? $5aec47966e5882be$var$resolveProp(value, key) : value));
        $5aec47966e5882be$var$mergeActiveFn(this, props, "onProps");
        $5aec47966e5882be$var$sendEvent(this, "onProps", props, this);
        const range = this._prepareNode(props);
        if (Object.isFrozen(this)) throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
        const state = this._state;
        return $5aec47966e5882be$var$scheduleProps(++this._lastCallId, {
            key: key,
            props: props,
            defaultProps: defaultProps,
            state: state,
            actions: {
                pause: ()=>{
                    if (!$5aec47966e5882be$var$isPaused(this)) {
                        $5aec47966e5882be$var$setPausedBit(this, true);
                        (0, $3cb6d3769806d9dc$export$7ba486852759e806)(state.pauseQueue);
                        $5aec47966e5882be$var$sendEvent(this, "onPause", $5aec47966e5882be$var$getFinishedResult(this, $5aec47966e5882be$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                resume: ()=>{
                    if ($5aec47966e5882be$var$isPaused(this)) {
                        $5aec47966e5882be$var$setPausedBit(this, false);
                        if ($5aec47966e5882be$var$isAnimating(this)) this._resume();
                        (0, $3cb6d3769806d9dc$export$7ba486852759e806)(state.resumeQueue);
                        $5aec47966e5882be$var$sendEvent(this, "onResume", $5aec47966e5882be$var$getFinishedResult(this, $5aec47966e5882be$var$checkFinished(this, this.animation.to)), this);
                    }
                },
                start: this._merge.bind(this, range)
            }
        }).then((result)=>{
            if (props.loop && result.finished && !(isLoop && result.noop)) {
                const nextProps = $5aec47966e5882be$var$createLoopUpdate(props);
                if (nextProps) return this._update(nextProps, true);
            }
            return result;
        });
    }
    /** Merge props into the current animation */ _merge(range, props, resolve) {
        if (props.cancel) {
            this.stop(true);
            return resolve($5aec47966e5882be$var$getCancelledResult(this));
        }
        const hasToProp = !(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(range.to);
        const hasFromProp = !(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(range.from);
        if (hasToProp || hasFromProp) {
            if (props.callId > this._lastToId) this._lastToId = props.callId;
            else return resolve($5aec47966e5882be$var$getCancelledResult(this));
        }
        const { key: key, defaultProps: defaultProps, animation: anim } = this;
        const { to: prevTo, from: prevFrom } = anim;
        let { to: to2 = prevTo, from: from = prevFrom } = range;
        if (hasFromProp && !hasToProp && (!props.default || (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(to2))) to2 = from;
        if (props.reverse) [to2, from] = [
            from,
            to2
        ];
        const hasFromChanged = !(0, $3cb6d3769806d9dc$export$248d38f6296296c5)(from, prevFrom);
        if (hasFromChanged) anim.from = from;
        from = (0, $3cb6d3769806d9dc$export$e37b7520edd66839)(from);
        const hasToChanged = !(0, $3cb6d3769806d9dc$export$248d38f6296296c5)(to2, prevTo);
        if (hasToChanged) this._focus(to2);
        const hasAsyncTo = $5aec47966e5882be$var$isAsyncTo(props.to);
        const { config: config2 } = anim;
        const { decay: decay, velocity: velocity } = config2;
        if (hasToProp || hasFromProp) config2.velocity = 0;
        if (props.config && !hasAsyncTo) $5aec47966e5882be$var$mergeConfig(config2, $5aec47966e5882be$var$callProp(props.config, key), // Avoid calling the same "config" prop twice.
        props.config !== defaultProps.config ? $5aec47966e5882be$var$callProp(defaultProps.config, key) : void 0);
        let node = (0, $913d375866ff6257$export$6b63995194a3a9e4)(this);
        if (!node || (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(to2)) return resolve($5aec47966e5882be$var$getFinishedResult(this, true));
        const reset = // When `reset` is undefined, the `from` prop implies `reset: true`,
        // except for declarative updates. When `reset` is defined, there
        // must exist a value to animate from.
        (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(props.reset) ? hasFromProp && !props.default : !(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(from) && $5aec47966e5882be$var$matchProp(props.reset, key);
        const value = reset ? from : this.get();
        const goal = $5aec47966e5882be$var$computeGoal(to2);
        const isAnimatable = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).num(goal) || (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).arr(goal) || (0, $3cb6d3769806d9dc$export$75bed621f62abfa9)(goal);
        const immediate = !hasAsyncTo && (!isAnimatable || $5aec47966e5882be$var$matchProp(defaultProps.immediate || props.immediate, key));
        if (hasToChanged) {
            const nodeType = (0, $913d375866ff6257$export$e6b77ddbe47b132e)(to2);
            if (nodeType !== node.constructor) {
                if (immediate) node = this._set(goal);
                else throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
            }
        }
        const goalType = node.constructor;
        let started = (0, $3cb6d3769806d9dc$export$57ea7e3a7f6280c7)(to2);
        let finished = false;
        if (!started) {
            const hasValueChanged = reset || !$5aec47966e5882be$var$hasAnimated(this) && hasFromChanged;
            if (hasToChanged || hasValueChanged) {
                finished = (0, $3cb6d3769806d9dc$export$248d38f6296296c5)($5aec47966e5882be$var$computeGoal(value), goal);
                started = !finished;
            }
            if (!(0, $3cb6d3769806d9dc$export$248d38f6296296c5)(anim.immediate, immediate) && !immediate || !(0, $3cb6d3769806d9dc$export$248d38f6296296c5)(config2.decay, decay) || !(0, $3cb6d3769806d9dc$export$248d38f6296296c5)(config2.velocity, velocity)) started = true;
        }
        if (finished && $5aec47966e5882be$var$isAnimating(this)) {
            if (anim.changed && !reset) started = true;
            else if (!started) this._stop(prevTo);
        }
        if (!hasAsyncTo) {
            if (started || (0, $3cb6d3769806d9dc$export$57ea7e3a7f6280c7)(prevTo)) {
                anim.values = node.getPayload();
                anim.toValues = (0, $3cb6d3769806d9dc$export$57ea7e3a7f6280c7)(to2) ? null : goalType == (0, $913d375866ff6257$export$f6c6c4cbd7fa5b93) ? [
                    1
                ] : (0, $3cb6d3769806d9dc$export$45b10814cc054894)(goal);
            }
            if (anim.immediate != immediate) {
                anim.immediate = immediate;
                if (!immediate && !reset) this._set(prevTo);
            }
            if (started) {
                const { onRest: onRest } = anim;
                (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)($5aec47966e5882be$var$ACTIVE_EVENTS, (type)=>$5aec47966e5882be$var$mergeActiveFn(this, props, type));
                const result = $5aec47966e5882be$var$getFinishedResult(this, $5aec47966e5882be$var$checkFinished(this, prevTo));
                (0, $3cb6d3769806d9dc$export$7ba486852759e806)(this._pendingCalls, result);
                this._pendingCalls.add(resolve);
                if (anim.changed) (0, $24333df8762df523$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    var _anim_onStart;
                    anim.changed = !reset;
                    onRest === null || onRest === void 0 ? void 0 : onRest(result, this);
                    if (reset) $5aec47966e5882be$var$callProp(defaultProps.onRest, result);
                    else (_anim_onStart = anim.onStart) === null || _anim_onStart === void 0 ? void 0 : _anim_onStart.call(anim, result, this);
                });
            }
        }
        if (reset) this._set(value);
        if (hasAsyncTo) resolve($5aec47966e5882be$var$runAsync(props.to, props, this._state, this));
        else if (started) this._start();
        else if ($5aec47966e5882be$var$isAnimating(this) && !hasToChanged) this._pendingCalls.add(resolve);
        else resolve($5aec47966e5882be$var$getNoopResult(value));
    }
    /** Update the `animation.to` value, which might be a `FluidValue` */ _focus(value) {
        const anim = this.animation;
        if (value !== anim.to) {
            if ((0, $3cb6d3769806d9dc$export$133f54e9f7cf1796)(this)) this._detach();
            anim.to = value;
            if ((0, $3cb6d3769806d9dc$export$133f54e9f7cf1796)(this)) this._attach();
        }
    }
    _attach() {
        let priority = 0;
        const { to: to2 } = this.animation;
        if ((0, $3cb6d3769806d9dc$export$57ea7e3a7f6280c7)(to2)) {
            (0, $3cb6d3769806d9dc$export$72d604e3f8d000a5)(to2, this);
            if ($5aec47966e5882be$var$isFrameValue(to2)) priority = to2.priority + 1;
        }
        this.priority = priority;
    }
    _detach() {
        const { to: to2 } = this.animation;
        if ((0, $3cb6d3769806d9dc$export$57ea7e3a7f6280c7)(to2)) (0, $3cb6d3769806d9dc$export$7a0eb830d336339b)(to2, this);
    }
    /**
   * Update the current value from outside the frameloop,
   * and return the `Animated` node.
   */ _set(arg, idle = true) {
        const value = (0, $3cb6d3769806d9dc$export$e37b7520edd66839)(arg);
        if (!(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(value)) {
            const oldNode = (0, $913d375866ff6257$export$6b63995194a3a9e4)(this);
            if (!oldNode || !(0, $3cb6d3769806d9dc$export$248d38f6296296c5)(value, oldNode.getValue())) {
                const nodeType = (0, $913d375866ff6257$export$e6b77ddbe47b132e)(value);
                if (!oldNode || oldNode.constructor != nodeType) (0, $913d375866ff6257$export$b553cb5b22b81b04)(this, nodeType.create(value));
                else oldNode.setValue(value);
                if (oldNode) (0, $24333df8762df523$export$27f233d61a9e2fa4).batchedUpdates(()=>{
                    this._onChange(value, idle);
                });
            }
        }
        return (0, $913d375866ff6257$export$6b63995194a3a9e4)(this);
    }
    _onStart() {
        const anim = this.animation;
        if (!anim.changed) {
            anim.changed = true;
            $5aec47966e5882be$var$sendEvent(this, "onStart", $5aec47966e5882be$var$getFinishedResult(this, $5aec47966e5882be$var$checkFinished(this, anim.to)), this);
        }
    }
    _onChange(value, idle) {
        if (!idle) {
            this._onStart();
            $5aec47966e5882be$var$callProp(this.animation.onChange, value, this);
        }
        $5aec47966e5882be$var$callProp(this.defaultProps.onChange, value, this);
        super._onChange(value, idle);
    }
    // This method resets the animation state (even if already animating) to
    // ensure the latest from/to range is used, and it also ensures this spring
    // is added to the frameloop.
    _start() {
        const anim = this.animation;
        (0, $913d375866ff6257$export$6b63995194a3a9e4)(this).reset((0, $3cb6d3769806d9dc$export$e37b7520edd66839)(anim.to));
        if (!anim.immediate) anim.fromValues = anim.values.map((node)=>node.lastPosition);
        if (!$5aec47966e5882be$var$isAnimating(this)) {
            $5aec47966e5882be$var$setActiveBit(this, true);
            if (!$5aec47966e5882be$var$isPaused(this)) this._resume();
        }
    }
    _resume() {
        if ((0, $3cb6d3769806d9dc$export$cceeabf822b64fc0).skipAnimation) this.finish();
        else (0, $3cb6d3769806d9dc$export$a57f5080a3bcc90a).start(this);
    }
    /**
   * Exit the frameloop and notify `onRest` listeners.
   *
   * Always wrap `_stop` calls with `batchedUpdates`.
   */ _stop(goal, cancel) {
        if ($5aec47966e5882be$var$isAnimating(this)) {
            $5aec47966e5882be$var$setActiveBit(this, false);
            const anim = this.animation;
            (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(anim.values, (node)=>{
                node.done = true;
            });
            if (anim.toValues) anim.onChange = anim.onPause = anim.onResume = void 0;
            (0, $3cb6d3769806d9dc$export$31752c40a5fab62a)(this, {
                type: "idle",
                parent: this
            });
            const result = cancel ? $5aec47966e5882be$var$getCancelledResult(this.get()) : $5aec47966e5882be$var$getFinishedResult(this.get(), $5aec47966e5882be$var$checkFinished(this, goal !== null && goal !== void 0 ? goal : anim.to));
            (0, $3cb6d3769806d9dc$export$7ba486852759e806)(this._pendingCalls, result);
            if (anim.changed) {
                anim.changed = false;
                $5aec47966e5882be$var$sendEvent(this, "onRest", result, this);
            }
        }
    }
    constructor(arg1, arg2){
        super();
        /** The animation state */ this.animation = new $5aec47966e5882be$var$Animation();
        /** Some props have customizable default values */ this.defaultProps = {};
        /** The state for `runAsync` calls */ this._state = {
            paused: false,
            delayed: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The promise resolvers of pending `start` calls */ this._pendingCalls = /* @__PURE__ */ new Set();
        /** The counter for tracking `scheduleProps` calls */ this._lastCallId = 0;
        /** The last `scheduleProps` call that changed the `to` prop */ this._lastToId = 0;
        this._memoizedDuration = 0;
        if (!(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(arg1) || !(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(arg2)) {
            const props = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).obj(arg1) ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg1) : (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arg2), {
                from: arg1
            });
            if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(props.default)) props.default = true;
            this.start(props);
        }
    }
};
function $5aec47966e5882be$var$checkFinished(target, to2) {
    const goal = $5aec47966e5882be$var$computeGoal(to2);
    const value = $5aec47966e5882be$var$computeGoal(target.get());
    return (0, $3cb6d3769806d9dc$export$248d38f6296296c5)(value, goal);
}
function $5aec47966e5882be$var$createLoopUpdate(props, loop = props.loop, to2 = props.to) {
    const loopRet = $5aec47966e5882be$var$callProp(loop);
    if (loopRet) {
        const overrides = loopRet !== true && $5aec47966e5882be$export$b971039a739bf227(loopRet);
        const reverse = (overrides || props).reverse;
        const reset = !overrides || overrides.reset;
        return $5aec47966e5882be$var$createUpdate((0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
            loop: loop,
            // Avoid updating default props when looping.
            default: false,
            // Never loop the `pause` prop.
            pause: void 0,
            // For the "reverse" prop to loop as expected, the "to" prop
            // must be undefined. The "reverse" prop is ignored when the
            // "to" prop is an array or function.
            to: !reverse || $5aec47966e5882be$var$isAsyncTo(to2) ? to2 : void 0,
            // Ignore the "from" prop except on reset.
            from: reset ? props.from : void 0,
            reset: reset
        }), overrides));
    }
}
function $5aec47966e5882be$var$createUpdate(props) {
    const { to: to2, from: from } = props = $5aec47966e5882be$export$b971039a739bf227(props);
    const keys = /* @__PURE__ */ new Set();
    if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).obj(to2)) $5aec47966e5882be$var$findDefined(to2, keys);
    if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).obj(from)) $5aec47966e5882be$var$findDefined(from, keys);
    props.keys = keys.size ? Array.from(keys) : null;
    return props;
}
function $5aec47966e5882be$var$declareUpdate(props) {
    const update2 = $5aec47966e5882be$var$createUpdate(props);
    if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(update2.default)) update2.default = $5aec47966e5882be$var$getDefaultProps(update2);
    return update2;
}
function $5aec47966e5882be$var$findDefined(values, keys) {
    (0, $3cb6d3769806d9dc$export$f4c6fe153f5a944e)(values, (value, key)=>value != null && keys.add(key));
}
var $5aec47966e5882be$var$ACTIVE_EVENTS = [
    "onStart",
    "onRest",
    "onChange",
    "onPause",
    "onResume"
];
function $5aec47966e5882be$var$mergeActiveFn(target, props, type) {
    target.animation[type] = props[type] !== $5aec47966e5882be$var$getDefaultProp(props, type) ? $5aec47966e5882be$var$resolveProp(props[type], target.key) : void 0;
}
function $5aec47966e5882be$var$sendEvent(target, type, ...args) {
    var _target_animation_type, _target_animation, _target_defaultProps_type, _target_defaultProps;
    (_target_animation_type = (_target_animation = target.animation)[type]) === null || _target_animation_type === void 0 ? void 0 : _target_animation_type.call(_target_animation, ...args);
    (_target_defaultProps_type = (_target_defaultProps = target.defaultProps)[type]) === null || _target_defaultProps_type === void 0 ? void 0 : _target_defaultProps_type.call(_target_defaultProps, ...args);
}
var $5aec47966e5882be$var$BATCHED_EVENTS = [
    "onStart",
    "onChange",
    "onRest"
];
var $5aec47966e5882be$var$nextId2 = 1;
var $5aec47966e5882be$export$bd0bf19f25da8474 = class {
    /**
   * Equals `true` when no spring values are in the frameloop, and
   * no async animation is currently active.
   */ get idle() {
        return !this._state.asyncTo && Object.values(this.springs).every((spring)=>{
            return spring.idle && !spring.isDelayed && !spring.isPaused;
        });
    }
    get item() {
        return this._item;
    }
    set item(item) {
        this._item = item;
    }
    /** Get the current values of our springs */ get() {
        const values = {};
        this.each((spring, key)=>values[key] = spring.get());
        return values;
    }
    /** Set the current values without animating. */ set(values) {
        for(const key in values){
            const value = values[key];
            if (!(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(value)) this.springs[key].set(value);
        }
    }
    /** Push an update onto the queue of each value. */ update(props) {
        if (props) this.queue.push($5aec47966e5882be$var$createUpdate(props));
        return this;
    }
    /**
   * Start the queued animations for every spring, and resolve the returned
   * promise once all queued animations have finished or been cancelled.
   *
   * When you pass a queue (instead of nothing), that queue is used instead of
   * the queued animations added with the `update` method, which are left alone.
   */ start(props) {
        let { queue: queue } = this;
        if (props) queue = (0, $3cb6d3769806d9dc$export$45b10814cc054894)(props).map($5aec47966e5882be$var$createUpdate);
        else this.queue = [];
        if (this._flush) return this._flush(this, queue);
        $5aec47966e5882be$var$prepareKeys(this, queue);
        return $5aec47966e5882be$var$flushUpdateQueue(this, queue);
    }
    /** @internal */ stop(arg, keys) {
        if (arg !== !!arg) keys = arg;
        if (keys) {
            const springs = this.springs;
            (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)((0, $3cb6d3769806d9dc$export$45b10814cc054894)(keys), (key)=>springs[key].stop(!!arg));
        } else {
            $5aec47966e5882be$var$stopAsync(this._state, this._lastAsyncId);
            this.each((spring)=>spring.stop(!!arg));
        }
        return this;
    }
    /** Freeze the active animation in time */ pause(keys) {
        if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: true
        });
        else {
            const springs = this.springs;
            (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)((0, $3cb6d3769806d9dc$export$45b10814cc054894)(keys), (key)=>springs[key].pause());
        }
        return this;
    }
    /** Resume the animation if paused. */ resume(keys) {
        if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(keys)) this.start({
            pause: false
        });
        else {
            const springs = this.springs;
            (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)((0, $3cb6d3769806d9dc$export$45b10814cc054894)(keys), (key)=>springs[key].resume());
        }
        return this;
    }
    /** Call a function once per spring value */ each(iterator) {
        (0, $3cb6d3769806d9dc$export$f4c6fe153f5a944e)(this.springs, iterator);
    }
    /** @internal Called at the end of every animation frame */ _onFrame() {
        const { onStart: onStart, onChange: onChange, onRest: onRest } = this._events;
        const active = this._active.size > 0;
        const changed = this._changed.size > 0;
        if (active && !this._started || changed && !this._started) {
            this._started = true;
            (0, $3cb6d3769806d9dc$export$4909b86c8034bf73)(onStart, ([onStart2, result])=>{
                result.value = this.get();
                onStart2(result, this, this._item);
            });
        }
        const idle = !active && this._started;
        const values = changed || idle && onRest.size ? this.get() : null;
        if (changed && onChange.size) (0, $3cb6d3769806d9dc$export$4909b86c8034bf73)(onChange, ([onChange2, result])=>{
            result.value = values;
            onChange2(result, this, this._item);
        });
        if (idle) {
            this._started = false;
            (0, $3cb6d3769806d9dc$export$4909b86c8034bf73)(onRest, ([onRest2, result])=>{
                result.value = values;
                onRest2(result, this, this._item);
            });
        }
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            this._changed.add(event.parent);
            if (!event.idle) this._active.add(event.parent);
        } else if (event.type == "idle") this._active.delete(event.parent);
        else return;
        (0, $24333df8762df523$export$27f233d61a9e2fa4).onFrame(this._onFrame);
    }
    constructor(props, flush3){
        this.id = $5aec47966e5882be$var$nextId2++;
        /** The animated values */ this.springs = {};
        /** The queue of props passed to the `update` method. */ this.queue = [];
        /** The counter for tracking `scheduleProps` calls */ this._lastAsyncId = 0;
        /** The values currently being animated */ this._active = /* @__PURE__ */ new Set();
        /** The values that changed recently */ this._changed = /* @__PURE__ */ new Set();
        /** Equals false when `onStart` listeners can be called */ this._started = false;
        /** State used by the `runAsync` function */ this._state = {
            paused: false,
            pauseQueue: /* @__PURE__ */ new Set(),
            resumeQueue: /* @__PURE__ */ new Set(),
            timeouts: /* @__PURE__ */ new Set()
        };
        /** The event queues that are flushed once per frame maximum */ this._events = {
            onStart: /* @__PURE__ */ new Map(),
            onChange: /* @__PURE__ */ new Map(),
            onRest: /* @__PURE__ */ new Map()
        };
        this._onFrame = this._onFrame.bind(this);
        if (flush3) this._flush = flush3;
        if (props) this.start((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            default: true
        }, props));
    }
};
function $5aec47966e5882be$var$flushUpdateQueue(ctrl, queue) {
    return Promise.all(queue.map((props)=>$5aec47966e5882be$var$flushUpdate(ctrl, props))).then((results)=>$5aec47966e5882be$var$getCombinedResult(ctrl, results));
}
async function $5aec47966e5882be$var$flushUpdate(ctrl, props, isLoop) {
    const { keys: keys, to: to2, from: from, loop: loop, onRest: onRest, onResolve: onResolve } = props;
    const defaults2 = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).obj(props.default) && props.default;
    if (loop) props.loop = false;
    if (to2 === false) props.to = null;
    if (from === false) props.from = null;
    const asyncTo = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).arr(to2) || (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(to2) ? to2 : void 0;
    if (asyncTo) {
        props.to = void 0;
        props.onRest = void 0;
        if (defaults2) defaults2.onRest = void 0;
    } else (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)($5aec47966e5882be$var$BATCHED_EVENTS, (key)=>{
        const handler = props[key];
        if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(handler)) {
            const queue = ctrl["_events"][key];
            props[key] = ({ finished: finished, cancelled: cancelled })=>{
                const result2 = queue.get(handler);
                if (result2) {
                    if (!finished) result2.finished = false;
                    if (cancelled) result2.cancelled = true;
                } else queue.set(handler, {
                    value: null,
                    finished: finished || false,
                    cancelled: cancelled || false
                });
            };
            if (defaults2) defaults2[key] = props[key];
        }
    });
    const state = ctrl["_state"];
    if (props.pause === !state.paused) {
        state.paused = props.pause;
        (0, $3cb6d3769806d9dc$export$7ba486852759e806)(props.pause ? state.pauseQueue : state.resumeQueue);
    } else if (state.paused) props.pause = true;
    const promises = (keys || Object.keys(ctrl.springs)).map((key)=>ctrl.springs[key].start(props));
    const cancel = props.cancel === true || $5aec47966e5882be$var$getDefaultProp(props, "cancel") === true;
    if (asyncTo || cancel && state.asyncId) promises.push($5aec47966e5882be$var$scheduleProps(++ctrl["_lastAsyncId"], {
        props: props,
        state: state,
        actions: {
            pause: (0, $3cb6d3769806d9dc$export$8793edee2d425525),
            resume: (0, $3cb6d3769806d9dc$export$8793edee2d425525),
            start (props2, resolve) {
                if (cancel) {
                    $5aec47966e5882be$var$stopAsync(state, ctrl["_lastAsyncId"]);
                    resolve($5aec47966e5882be$var$getCancelledResult(ctrl));
                } else {
                    props2.onRest = onRest;
                    resolve($5aec47966e5882be$var$runAsync(asyncTo, props2, state, ctrl));
                }
            }
        }
    }));
    if (state.paused) await new Promise((resume)=>{
        state.resumeQueue.add(resume);
    });
    const result = $5aec47966e5882be$var$getCombinedResult(ctrl, await Promise.all(promises));
    if (loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = $5aec47966e5882be$var$createLoopUpdate(props, loop, to2);
        if (nextProps) {
            $5aec47966e5882be$var$prepareKeys(ctrl, [
                nextProps
            ]);
            return $5aec47966e5882be$var$flushUpdate(ctrl, nextProps, true);
        }
    }
    if (onResolve) (0, $24333df8762df523$export$27f233d61a9e2fa4).batchedUpdates(()=>onResolve(result, ctrl, ctrl.item));
    return result;
}
function $5aec47966e5882be$var$getSprings(ctrl, props) {
    const springs = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, ctrl.springs);
    if (props) (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)((0, $3cb6d3769806d9dc$export$45b10814cc054894)(props), (props2)=>{
        if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(props2.keys)) props2 = $5aec47966e5882be$var$createUpdate(props2);
        if (!(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).obj(props2.to)) props2 = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props2), {
            to: void 0
        });
        $5aec47966e5882be$var$prepareSprings(springs, props2, (key)=>{
            return $5aec47966e5882be$var$createSpring(key);
        });
    });
    $5aec47966e5882be$var$setSprings(ctrl, springs);
    return springs;
}
function $5aec47966e5882be$var$setSprings(ctrl, springs) {
    (0, $3cb6d3769806d9dc$export$f4c6fe153f5a944e)(springs, (spring, key)=>{
        if (!ctrl.springs[key]) {
            ctrl.springs[key] = spring;
            (0, $3cb6d3769806d9dc$export$72d604e3f8d000a5)(spring, ctrl);
        }
    });
}
function $5aec47966e5882be$var$createSpring(key, observer) {
    const spring = new $5aec47966e5882be$export$5854d13427d5a954();
    spring.key = key;
    if (observer) (0, $3cb6d3769806d9dc$export$72d604e3f8d000a5)(spring, observer);
    return spring;
}
function $5aec47966e5882be$var$prepareSprings(springs, props, create) {
    if (props.keys) (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(props.keys, (key)=>{
        const spring = springs[key] || (springs[key] = create(key));
        spring["_prepareNode"](props);
    });
}
function $5aec47966e5882be$var$prepareKeys(ctrl, queue) {
    (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(queue, (props)=>{
        $5aec47966e5882be$var$prepareSprings(ctrl.springs, props, (key)=>{
            return $5aec47966e5882be$var$createSpring(key, ctrl);
        });
    });
}
var $5aec47966e5882be$export$f12a216ec50d2cf1 = (_param)=>{
    var { children: children } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "children"
    ]);
    const inherited = (0, $7fPBF.useContext)($5aec47966e5882be$var$ctx);
    const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
    props = (0, $3cb6d3769806d9dc$export$b6feb8998cd9b342)(()=>({
            pause: pause,
            immediate: immediate
        }), [
        pause,
        immediate
    ]);
    const { Provider: Provider } = $5aec47966e5882be$var$ctx;
    return /* @__PURE__ */ $7fPBF.createElement(Provider, {
        value: props
    }, children);
};
var $5aec47966e5882be$var$ctx = $5aec47966e5882be$var$makeContext($5aec47966e5882be$export$f12a216ec50d2cf1, {});
$5aec47966e5882be$export$f12a216ec50d2cf1.Provider = $5aec47966e5882be$var$ctx.Provider;
$5aec47966e5882be$export$f12a216ec50d2cf1.Consumer = $5aec47966e5882be$var$ctx.Consumer;
function $5aec47966e5882be$var$makeContext(target, init) {
    Object.assign(target, $7fPBF.createContext(init));
    target.Provider._context = target;
    target.Consumer._context = target;
    return target;
}
var $5aec47966e5882be$export$2471ae76e2946684 = ()=>{
    const current = [];
    const SpringRef2 = function(props) {
        (0, $3cb6d3769806d9dc$export$d99d974913ad3b12)();
        const results = [];
        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = _getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.current = current;
    SpringRef2.add = function(ctrl) {
        if (!current.includes(ctrl)) current.push(ctrl);
    };
    SpringRef2.delete = function(ctrl) {
        const i = current.indexOf(ctrl);
        if (~i) current.splice(i, 1);
    };
    SpringRef2.pause = function() {
        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.pause(...arguments));
        return this;
    };
    SpringRef2.resume = function() {
        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.resume(...arguments));
        return this;
    };
    SpringRef2.set = function(values) {
        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            const update2 = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(values) ? values(i, ctrl) : values;
            if (update2) ctrl.set(update2);
        });
    };
    SpringRef2.start = function(props) {
        const results = [];
        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(current, (ctrl, i)=>{
            if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(props)) results.push(ctrl.start());
            else {
                const update2 = this._getProps(props, ctrl, i);
                if (update2) results.push(ctrl.start(update2));
            }
        });
        return results;
    };
    SpringRef2.stop = function() {
        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(current, (ctrl)=>ctrl.stop(...arguments));
        return this;
    };
    SpringRef2.update = function(props) {
        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(current, (ctrl, i)=>ctrl.update(this._getProps(props, ctrl, i)));
        return this;
    };
    const _getProps = function(arg, ctrl, index) {
        return (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(arg) ? arg(index, ctrl) : arg;
    };
    SpringRef2._getProps = _getProps;
    return SpringRef2;
};
// src/hooks/useSprings.ts
function $5aec47966e5882be$export$15786d483ab9f469(length, props, deps) {
    const propsFn = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(props) && props;
    if (propsFn && !deps) deps = [];
    const ref = (0, $7fPBF.useMemo)(()=>propsFn || arguments.length == 3 ? $5aec47966e5882be$export$2471ae76e2946684() : void 0, []);
    const layoutId = (0, $7fPBF.useRef)(0);
    const forceUpdate = (0, $3cb6d3769806d9dc$export$91db9bc4f8ac944a)();
    const state = (0, $7fPBF.useMemo)(()=>({
            ctrls: [],
            queue: [],
            flush (ctrl, updates2) {
                const springs2 = $5aec47966e5882be$var$getSprings(ctrl, updates2);
                const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key)=>!ctrl.springs[key]);
                return canFlushSync ? $5aec47966e5882be$var$flushUpdateQueue(ctrl, updates2) : new Promise((resolve)=>{
                    $5aec47966e5882be$var$setSprings(ctrl, springs2);
                    state.queue.push(()=>{
                        resolve($5aec47966e5882be$var$flushUpdateQueue(ctrl, updates2));
                    });
                    forceUpdate();
                });
            }
        }), []);
    const ctrls = (0, $7fPBF.useRef)([
        ...state.ctrls
    ]);
    const updates = [];
    const prevLength = (0, $3cb6d3769806d9dc$export$ef7ad0c4e19d7fbf)(length) || 0;
    (0, $7fPBF.useMemo)(()=>{
        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(ctrls.current.slice(length, prevLength), (ctrl)=>{
            $5aec47966e5882be$var$detachRefs(ctrl, ref);
            ctrl.stop(true);
        });
        ctrls.current.length = length;
        declareUpdates(prevLength, length);
    }, [
        length
    ]);
    (0, $7fPBF.useMemo)(()=>{
        declareUpdates(0, Math.min(prevLength, length));
    }, deps);
    function declareUpdates(startIndex, endIndex) {
        for(let i = startIndex; i < endIndex; i++){
            const ctrl = ctrls.current[i] || (ctrls.current[i] = new $5aec47966e5882be$export$bd0bf19f25da8474(null, state.flush));
            const update2 = propsFn ? propsFn(i, ctrl) : props[i];
            if (update2) updates[i] = $5aec47966e5882be$var$declareUpdate(update2);
        }
    }
    const springs = ctrls.current.map((ctrl, i)=>$5aec47966e5882be$var$getSprings(ctrl, updates[i]));
    const context = (0, $7fPBF.useContext)($5aec47966e5882be$export$f12a216ec50d2cf1);
    const prevContext = (0, $3cb6d3769806d9dc$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $5aec47966e5882be$var$hasProps(context);
    (0, $3cb6d3769806d9dc$export$700979bc83e7db82)(()=>{
        layoutId.current++;
        state.ctrls = ctrls.current;
        const { queue: queue } = state;
        if (queue.length) {
            state.queue = [];
            (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(queue, (cb)=>cb());
        }
        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(ctrls.current, (ctrl, i)=>{
            ref === null || ref === void 0 ? void 0 : ref.add(ctrl);
            if (hasContext) ctrl.start({
                default: context
            });
            const update2 = updates[i];
            if (update2) {
                $5aec47966e5882be$var$replaceRef(ctrl, update2.ref);
                if (ctrl.ref) ctrl.queue.push(update2);
                else ctrl.start(update2);
            }
        });
    });
    (0, $3cb6d3769806d9dc$export$392544347a18b6ea)(()=>()=>{
            (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(state.ctrls, (ctrl)=>ctrl.stop(true));
        });
    const values = springs.map((x)=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, x));
    return ref ? [
        values,
        ref
    ] : values;
}
// src/hooks/useSpring.ts
function $5aec47966e5882be$export$c4af9125706c4d30(props, deps) {
    const isFn = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(props);
    const [[values], ref] = $5aec47966e5882be$export$15786d483ab9f469(1, isFn ? props : [
        props
    ], isFn ? deps || [] : deps);
    return isFn || arguments.length == 2 ? [
        values,
        ref
    ] : values;
}
var $5aec47966e5882be$var$initSpringRef = ()=>$5aec47966e5882be$export$2471ae76e2946684();
var $5aec47966e5882be$export$564bff9c23cad2ca = ()=>(0, $7fPBF.useState)($5aec47966e5882be$var$initSpringRef)[0];
var $5aec47966e5882be$export$ab73804b080feffc = (initial, props)=>{
    const springValue = (0, $3cb6d3769806d9dc$export$fe4300aa8eebea86)(()=>new $5aec47966e5882be$export$5854d13427d5a954(initial, props));
    (0, $3cb6d3769806d9dc$export$392544347a18b6ea)(()=>()=>{
            springValue.stop();
        });
    return springValue;
};
function $5aec47966e5882be$export$250279104b4672ed(length, propsArg, deps) {
    const propsFn = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(propsArg) && propsArg;
    if (propsFn && !deps) deps = [];
    let reverse = true;
    let passedRef = void 0;
    const result = $5aec47966e5882be$export$15786d483ab9f469(length, (i, ctrl)=>{
        const props = propsFn ? propsFn(i, ctrl) : propsArg;
        passedRef = props.ref;
        reverse = reverse && props.reverse;
        return props;
    }, // Ensure the props function is called when no deps exist.
    // This works around the 3 argument rule.
    deps || [
        {}
    ]);
    (0, $3cb6d3769806d9dc$export$700979bc83e7db82)(()=>{
        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(result[1].current, (ctrl, i)=>{
            const parent = result[1].current[i + (reverse ? 1 : -1)];
            $5aec47966e5882be$var$replaceRef(ctrl, passedRef);
            if (ctrl.ref) {
                if (parent) ctrl.update({
                    to: parent.springs
                });
                return;
            }
            if (parent) ctrl.start({
                to: parent.springs
            });
            else ctrl.start();
        });
    }, deps);
    if (propsFn || arguments.length == 3) {
        const ref = passedRef !== null && passedRef !== void 0 ? passedRef : result[1];
        ref["_getProps"] = (propsArg2, ctrl, i)=>{
            const props = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(propsArg2) ? propsArg2(i, ctrl) : propsArg2;
            if (props) {
                const parent = ref.current[i + (props.reverse ? 1 : -1)];
                if (parent) props.to = parent.springs;
                return props;
            }
        };
        return result;
    }
    return result[0];
}
function $5aec47966e5882be$export$7b286972b8d8ccbf(data, props, deps) {
    const propsFn = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(props) && props;
    const { reset: reset, sort: sort, trail: trail = 0, expires: expires = true, exitBeforeEnter: exitBeforeEnter = false, onDestroyed: onDestroyed, ref: propsRef, config: propsConfig } = propsFn ? propsFn() : props;
    const ref = (0, $7fPBF.useMemo)(()=>propsFn || arguments.length == 3 ? $5aec47966e5882be$export$2471ae76e2946684() : void 0, []);
    const items = (0, $3cb6d3769806d9dc$export$45b10814cc054894)(data);
    const transitions = [];
    const usedTransitions = (0, $7fPBF.useRef)(null);
    const prevTransitions = reset ? null : usedTransitions.current;
    (0, $3cb6d3769806d9dc$export$700979bc83e7db82)(()=>{
        usedTransitions.current = transitions;
    });
    (0, $3cb6d3769806d9dc$export$392544347a18b6ea)(()=>{
        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(transitions, (t)=>{
            ref === null || ref === void 0 ? void 0 : ref.add(t.ctrl);
            t.ctrl.ref = ref;
        });
        return ()=>{
            (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(usedTransitions.current, (t)=>{
                if (t.expired) clearTimeout(t.expirationId);
                $5aec47966e5882be$var$detachRefs(t.ctrl, ref);
                t.ctrl.stop(true);
            });
        };
    });
    const keys = $5aec47966e5882be$var$getKeys(items, propsFn ? propsFn() : props, prevTransitions);
    const expired = reset && usedTransitions.current || [];
    (0, $3cb6d3769806d9dc$export$700979bc83e7db82)(()=>(0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(expired, ({ ctrl: ctrl, item: item, key: key })=>{
            $5aec47966e5882be$var$detachRefs(ctrl, ref);
            $5aec47966e5882be$var$callProp(onDestroyed, item, key);
        }));
    const reused = [];
    if (prevTransitions) (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(prevTransitions, (t, i)=>{
        if (t.expired) {
            clearTimeout(t.expirationId);
            expired.push(t);
        } else {
            i = reused[i] = keys.indexOf(t.key);
            if (~i) transitions[i] = t;
        }
    });
    (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(items, (item, i)=>{
        if (!transitions[i]) {
            transitions[i] = {
                key: keys[i],
                item: item,
                phase: "mount" /* MOUNT */ ,
                ctrl: new $5aec47966e5882be$export$bd0bf19f25da8474()
            };
            transitions[i].ctrl.item = item;
        }
    });
    if (reused.length) {
        let i = -1;
        const { leave: leave } = propsFn ? propsFn() : props;
        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(reused, (keyIndex, prevIndex)=>{
            const t = prevTransitions[prevIndex];
            if (~keyIndex) {
                i = transitions.indexOf(t);
                transitions[i] = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, t), {
                    item: items[keyIndex]
                });
            } else if (leave) transitions.splice(++i, 0, t);
        });
    }
    if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(sort)) transitions.sort((a, b)=>sort(a.item, b.item));
    let delay = -trail;
    const forceUpdate = (0, $3cb6d3769806d9dc$export$91db9bc4f8ac944a)();
    const defaultProps = $5aec47966e5882be$var$getDefaultProps(props);
    const changes = /* @__PURE__ */ new Map();
    const exitingTransitions = (0, $7fPBF.useRef)(/* @__PURE__ */ new Map());
    const forceChange = (0, $7fPBF.useRef)(false);
    (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(transitions, (t, i)=>{
        const key = t.key;
        const prevPhase = t.phase;
        const p = propsFn ? propsFn() : props;
        let to2;
        let phase;
        const propsDelay = $5aec47966e5882be$var$callProp(p.delay || 0, key);
        if (prevPhase == "mount" /* MOUNT */ ) {
            to2 = p.enter;
            phase = "enter" /* ENTER */ ;
        } else {
            const isLeave = keys.indexOf(key) < 0;
            if (prevPhase != "leave" /* LEAVE */ ) {
                if (isLeave) {
                    to2 = p.leave;
                    phase = "leave" /* LEAVE */ ;
                } else if (to2 = p.update) phase = "update" /* UPDATE */ ;
                else return;
            } else if (!isLeave) {
                to2 = p.enter;
                phase = "enter" /* ENTER */ ;
            } else return;
        }
        to2 = $5aec47966e5882be$var$callProp(to2, t.item, i);
        to2 = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).obj(to2) ? $5aec47966e5882be$export$b971039a739bf227(to2) : {
            to: to2
        };
        if (!to2.config) {
            const config2 = propsConfig || defaultProps.config;
            to2.config = $5aec47966e5882be$var$callProp(config2, t.item, i, phase);
        }
        delay += trail;
        const payload = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProps), {
            // we need to add our props.delay value you here.
            delay: propsDelay + delay,
            ref: propsRef,
            immediate: p.immediate,
            // This prevents implied resets.
            reset: false
        }), to2);
        if (phase == "enter" /* ENTER */  && (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(payload.from)) {
            const p2 = propsFn ? propsFn() : props;
            const from = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(p2.initial) || prevTransitions ? p2.from : p2.initial;
            payload.from = $5aec47966e5882be$var$callProp(from, t.item, i);
        }
        const { onResolve: onResolve } = payload;
        payload.onResolve = (result)=>{
            $5aec47966e5882be$var$callProp(onResolve, result);
            const transitions2 = usedTransitions.current;
            const t2 = transitions2.find((t3)=>t3.key === key);
            if (!t2) return;
            if (result.cancelled && t2.phase != "update" /* UPDATE */ ) return;
            if (t2.ctrl.idle) {
                const idle = transitions2.every((t3)=>t3.ctrl.idle);
                if (t2.phase == "leave" /* LEAVE */ ) {
                    const expiry = $5aec47966e5882be$var$callProp(expires, t2.item);
                    if (expiry !== false) {
                        const expiryMs = expiry === true ? 0 : expiry;
                        t2.expired = true;
                        if (!idle && expiryMs > 0) {
                            if (expiryMs <= 2147483647) t2.expirationId = setTimeout(forceUpdate, expiryMs);
                            return;
                        }
                    }
                }
                if (idle && transitions2.some((t3)=>t3.expired)) {
                    exitingTransitions.current.delete(t2);
                    if (exitBeforeEnter) forceChange.current = true;
                    forceUpdate();
                }
            }
        };
        const springs = $5aec47966e5882be$var$getSprings(t.ctrl, payload);
        if (phase === "leave" /* LEAVE */  && exitBeforeEnter) exitingTransitions.current.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
        else changes.set(t, {
            phase: phase,
            springs: springs,
            payload: payload
        });
    });
    const context = (0, $7fPBF.useContext)($5aec47966e5882be$export$f12a216ec50d2cf1);
    const prevContext = (0, $3cb6d3769806d9dc$export$ef7ad0c4e19d7fbf)(context);
    const hasContext = context !== prevContext && $5aec47966e5882be$var$hasProps(context);
    (0, $3cb6d3769806d9dc$export$700979bc83e7db82)(()=>{
        if (hasContext) (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(transitions, (t)=>{
            t.ctrl.start({
                default: context
            });
        });
    }, [
        context
    ]);
    (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(changes, (_, t)=>{
        if (exitingTransitions.current.size) {
            const ind = transitions.findIndex((state)=>state.key === t.key);
            transitions.splice(ind, 1);
        }
    });
    (0, $3cb6d3769806d9dc$export$700979bc83e7db82)(()=>{
        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(exitingTransitions.current.size ? exitingTransitions.current : changes, ({ phase: phase, payload: payload }, t)=>{
            const { ctrl: ctrl } = t;
            t.phase = phase;
            ref === null || ref === void 0 ? void 0 : ref.add(ctrl);
            if (hasContext && phase == "enter" /* ENTER */ ) ctrl.start({
                default: context
            });
            if (payload) {
                $5aec47966e5882be$var$replaceRef(ctrl, payload.ref);
                if ((ctrl.ref || ref) && !forceChange.current) ctrl.update(payload);
                else {
                    ctrl.start(payload);
                    if (forceChange.current) forceChange.current = false;
                }
            }
        });
    }, reset ? void 0 : deps);
    const renderTransitions = (render)=>/* @__PURE__ */ $7fPBF.createElement($7fPBF.Fragment, null, transitions.map((t, i)=>{
            const { springs: springs } = changes.get(t) || t.ctrl;
            const elem = render((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, springs), t.item, t, i);
            return elem && elem.type ? /* @__PURE__ */ $7fPBF.createElement(elem.type, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, elem.props), {
                key: (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).str(t.key) || (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).num(t.key) ? t.key : t.ctrl.id,
                ref: elem.ref
            })) : elem;
        }));
    return ref ? [
        renderTransitions,
        ref
    ] : renderTransitions;
}
var $5aec47966e5882be$var$nextKey = 1;
function $5aec47966e5882be$var$getKeys(items, { key: key, keys: keys = key }, prevTransitions) {
    if (keys === null) {
        const reused = /* @__PURE__ */ new Set();
        return items.map((item)=>{
            const t = prevTransitions && prevTransitions.find((t2)=>t2.item === item && t2.phase !== "leave" /* LEAVE */  && !reused.has(t2));
            if (t) {
                reused.add(t);
                return t.key;
            }
            return $5aec47966e5882be$var$nextKey++;
        });
    }
    return (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(keys) ? items : (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(keys) ? items.map(keys) : (0, $3cb6d3769806d9dc$export$45b10814cc054894)(keys);
}
var $5aec47966e5882be$export$d928051c8cd740b = (_param = {})=>{
    var { container: container } = _param, springOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "container"
    ]);
    const [scrollValues, api] = $5aec47966e5882be$export$c4af9125706c4d30(()=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            scrollX: 0,
            scrollY: 0,
            scrollXProgress: 0,
            scrollYProgress: 0
        }, springOptions), []);
    (0, $3cb6d3769806d9dc$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $3cb6d3769806d9dc$export$d4d89fd61e5416ee)(({ x: x, y: y })=>{
            api.start({
                scrollX: x.current,
                scrollXProgress: x.progress,
                scrollY: y.current,
                scrollYProgress: y.progress
            });
        }, {
            container: (container === null || container === void 0 ? void 0 : container.current) || void 0
        });
        return ()=>{
            (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(Object.values(scrollValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return scrollValues;
};
var $5aec47966e5882be$export$e8b771555dc4a003 = (_param)=>{
    var { container: container } = _param, springOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "container"
    ]);
    const [sizeValues, api] = $5aec47966e5882be$export$c4af9125706c4d30(()=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            width: 0,
            height: 0
        }, springOptions), []);
    (0, $3cb6d3769806d9dc$export$700979bc83e7db82)(()=>{
        const cleanupScroll = (0, $3cb6d3769806d9dc$export$45b39e67d4ce4921)(({ width: width, height: height })=>{
            api.start({
                width: width,
                height: height,
                immediate: sizeValues.width.get() === 0 || sizeValues.height.get() === 0
            });
        }, {
            container: (container === null || container === void 0 ? void 0 : container.current) || void 0
        });
        return ()=>{
            (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(Object.values(sizeValues), (value)=>value.stop());
            cleanupScroll();
        };
    }, []);
    return sizeValues;
};
var $5aec47966e5882be$var$defaultThresholdOptions = {
    any: 0,
    all: 1
};
function $5aec47966e5882be$export$2f62ee6831462844(props, args) {
    const [isInView, setIsInView] = (0, $7fPBF.useState)(false);
    const ref = (0, $7fPBF.useRef)();
    const propsFn = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(props) && props;
    const springsProps = propsFn ? propsFn() : {};
    const { to: to2 = {}, from: from = {} } = springsProps, restSpringProps = (0, $8901fc92b5563702$export$71511d61b312f219)(springsProps, [
        "to",
        "from"
    ]);
    const intersectionArguments = propsFn ? args : props;
    const [springs, api] = $5aec47966e5882be$export$c4af9125706c4d30(()=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            from: from
        }, restSpringProps), []);
    (0, $3cb6d3769806d9dc$export$700979bc83e7db82)(()=>{
        const element = ref.current;
        const _ref = intersectionArguments !== null && intersectionArguments !== void 0 ? intersectionArguments : {}, { root: root, once: once, amount: amount = "any" } = _ref, restArgs = (0, $8901fc92b5563702$export$71511d61b312f219)(_ref, [
            "root",
            "once",
            "amount"
        ]);
        if (!element || once && isInView || typeof IntersectionObserver === "undefined") return;
        const activeIntersections = /* @__PURE__ */ new WeakMap();
        const onEnter = ()=>{
            if (to2) api.start(to2);
            setIsInView(true);
            const cleanup = ()=>{
                if (from) api.start(from);
                setIsInView(false);
            };
            return once ? void 0 : cleanup;
        };
        const handleIntersection = (entries)=>{
            entries.forEach((entry)=>{
                const onLeave = activeIntersections.get(entry.target);
                if (entry.isIntersecting === Boolean(onLeave)) return;
                if (entry.isIntersecting) {
                    const newOnLeave = onEnter();
                    if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(newOnLeave)) activeIntersections.set(entry.target, newOnLeave);
                    else observer.unobserve(entry.target);
                } else if (onLeave) {
                    onLeave();
                    activeIntersections.delete(entry.target);
                }
            });
        };
        const observer = new IntersectionObserver(handleIntersection, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            root: root && root.current || void 0,
            threshold: typeof amount === "number" || Array.isArray(amount) ? amount : $5aec47966e5882be$var$defaultThresholdOptions[amount]
        }, restArgs));
        observer.observe(element);
        return ()=>observer.unobserve(element);
    }, [
        intersectionArguments
    ]);
    if (propsFn) return [
        ref,
        springs
    ];
    return [
        ref,
        isInView
    ];
}
// src/components/Spring.tsx
function $5aec47966e5882be$export$a500e5b516cedfc(_param) {
    var { children: children } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "children"
    ]);
    return children($5aec47966e5882be$export$c4af9125706c4d30(props));
}
function $5aec47966e5882be$export$3b8b9d47fbf8fd2b(_param) {
    var { items: items, children: children } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "items",
        "children"
    ]);
    const trails = $5aec47966e5882be$export$250279104b4672ed(items.length, props);
    return items.map((item, index)=>{
        const result = children(item, index);
        return (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).fun(result) ? result(trails[index]) : result;
    });
}
// src/components/Transition.tsx
function $5aec47966e5882be$export$be58926105124dd4(_param) {
    var { items: items, children: children } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "items",
        "children"
    ]);
    return $5aec47966e5882be$export$7b286972b8d8ccbf(items, props)(children);
}
var $5aec47966e5882be$export$b0cc4f9860136880 = class extends $5aec47966e5882be$export$8229896f80e2495e {
    advance(_dt) {
        const value = this._get();
        const oldValue = this.get();
        if (!(0, $3cb6d3769806d9dc$export$248d38f6296296c5)(value, oldValue)) {
            (0, $913d375866ff6257$export$6b63995194a3a9e4)(this).setValue(value);
            this._onChange(value, this.idle);
        }
        if (!this.idle && $5aec47966e5882be$var$checkIdle(this._active)) $5aec47966e5882be$var$becomeIdle(this);
    }
    _get() {
        const inputs = (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).arr(this.source) ? this.source.map((0, $3cb6d3769806d9dc$export$e37b7520edd66839)) : (0, $3cb6d3769806d9dc$export$45b10814cc054894)((0, $3cb6d3769806d9dc$export$e37b7520edd66839)(this.source));
        return this.calc(...inputs);
    }
    _start() {
        if (this.idle && !$5aec47966e5882be$var$checkIdle(this._active)) {
            this.idle = false;
            (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)((0, $913d375866ff6257$export$ccab2b64c5d440)(this), (node)=>{
                node.done = false;
            });
            if ((0, $3cb6d3769806d9dc$export$cceeabf822b64fc0).skipAnimation) {
                (0, $24333df8762df523$export$27f233d61a9e2fa4).batchedUpdates(()=>this.advance());
                $5aec47966e5882be$var$becomeIdle(this);
            } else (0, $3cb6d3769806d9dc$export$a57f5080a3bcc90a).start(this);
        }
    }
    // Observe our sources only when we're observed.
    _attach() {
        let priority = 1;
        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)((0, $3cb6d3769806d9dc$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $3cb6d3769806d9dc$export$57ea7e3a7f6280c7)(source)) (0, $3cb6d3769806d9dc$export$72d604e3f8d000a5)(source, this);
            if ($5aec47966e5882be$var$isFrameValue(source)) {
                if (!source.idle) this._active.add(source);
                priority = Math.max(priority, source.priority + 1);
            }
        });
        this.priority = priority;
        this._start();
    }
    // Stop observing our sources once we have no observers.
    _detach() {
        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)((0, $3cb6d3769806d9dc$export$45b10814cc054894)(this.source), (source)=>{
            if ((0, $3cb6d3769806d9dc$export$57ea7e3a7f6280c7)(source)) (0, $3cb6d3769806d9dc$export$7a0eb830d336339b)(source, this);
        });
        this._active.clear();
        $5aec47966e5882be$var$becomeIdle(this);
    }
    /** @internal */ eventObserved(event) {
        if (event.type == "change") {
            if (event.idle) this.advance();
            else {
                this._active.add(event.parent);
                this._start();
            }
        } else if (event.type == "idle") this._active.delete(event.parent);
        else if (event.type == "priority") this.priority = (0, $3cb6d3769806d9dc$export$45b10814cc054894)(this.source).reduce((highest, parent)=>Math.max(highest, ($5aec47966e5882be$var$isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
    constructor(source, args){
        super();
        this.source = source;
        /** Equals false when in the frameloop */ this.idle = true;
        /** The inputs which are currently animating */ this._active = /* @__PURE__ */ new Set();
        this.calc = (0, $3cb6d3769806d9dc$export$b12af43b97697ef5)(...args);
        const value = this._get();
        const nodeType = (0, $913d375866ff6257$export$e6b77ddbe47b132e)(value);
        (0, $913d375866ff6257$export$b553cb5b22b81b04)(this, nodeType.create(value));
    }
};
function $5aec47966e5882be$var$isIdle(source) {
    return source.idle !== false;
}
function $5aec47966e5882be$var$checkIdle(active) {
    return !active.size || Array.from(active).every($5aec47966e5882be$var$isIdle);
}
function $5aec47966e5882be$var$becomeIdle(self) {
    if (!self.idle) {
        self.idle = true;
        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)((0, $913d375866ff6257$export$ccab2b64c5d440)(self), (node)=>{
            node.done = true;
        });
        (0, $3cb6d3769806d9dc$export$31752c40a5fab62a)(self, {
            type: "idle",
            parent: self
        });
    }
}
// src/interpolate.ts
var $5aec47966e5882be$export$2c618a4308a30424 = (source, ...args)=>new $5aec47966e5882be$export$b0cc4f9860136880(source, args);
var $5aec47966e5882be$export$89e29e4ab65e70a9 = (source, ...args)=>((0, $3cb6d3769806d9dc$export$2abfcde8ae218ba8)(), new $5aec47966e5882be$export$b0cc4f9860136880(source, args));
(0, $3cb6d3769806d9dc$export$cceeabf822b64fc0).assign({
    createStringInterpolator: $3cb6d3769806d9dc$export$4759a013d387347a,
    to: (source, args)=>new $5aec47966e5882be$export$b0cc4f9860136880(source, args)
});
var $5aec47966e5882be$export$722fbec263ad908a = (0, $3cb6d3769806d9dc$export$a57f5080a3bcc90a).advance;





// src/applyAnimatedValues.ts
var $9c385584ad92366d$var$isCustomPropRE = /^--/;
function $9c385584ad92366d$var$dangerousStyleValue(name, value) {
    if (value == null || typeof value === "boolean" || value === "") return "";
    if (typeof value === "number" && value !== 0 && !$9c385584ad92366d$var$isCustomPropRE.test(name) && !($9c385584ad92366d$var$isUnitlessNumber.hasOwnProperty(name) && $9c385584ad92366d$var$isUnitlessNumber[name])) return value + "px";
    return ("" + value).trim();
}
var $9c385584ad92366d$var$attributeCache = {};
function $9c385584ad92366d$var$applyAnimatedValues(instance, props) {
    if (!instance.nodeType || !instance.setAttribute) return false;
    const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
    const { className: className, style: style, children: children, scrollTop: scrollTop, scrollLeft: scrollLeft, viewBox: viewBox } = props, attributes = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "className",
        "style",
        "children",
        "scrollTop",
        "scrollLeft",
        "viewBox"
    ]);
    const values = Object.values(attributes);
    const names = Object.keys(attributes).map((name)=>isFilterElement || instance.hasAttribute(name) ? name : $9c385584ad92366d$var$attributeCache[name] || ($9c385584ad92366d$var$attributeCache[name] = name.replace(/([A-Z])/g, // Attributes are written in dash case
        (n)=>"-" + n.toLowerCase())));
    if (children !== void 0) instance.textContent = children;
    for(const name in style)if (style.hasOwnProperty(name)) {
        const value = $9c385584ad92366d$var$dangerousStyleValue(name, style[name]);
        if ($9c385584ad92366d$var$isCustomPropRE.test(name)) instance.style.setProperty(name, value);
        else instance.style[name] = value;
    }
    names.forEach((name, i)=>{
        instance.setAttribute(name, values[i]);
    });
    if (className !== void 0) instance.className = className;
    if (scrollTop !== void 0) instance.scrollTop = scrollTop;
    if (scrollLeft !== void 0) instance.scrollLeft = scrollLeft;
    if (viewBox !== void 0) instance.setAttribute("viewBox", viewBox);
}
var $9c385584ad92366d$var$isUnitlessNumber = {
    animationIterationCount: true,
    borderImageOutset: true,
    borderImageSlice: true,
    borderImageWidth: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    columns: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridRowEnd: true,
    gridRowSpan: true,
    gridRowStart: true,
    gridColumn: true,
    gridColumnEnd: true,
    gridColumnSpan: true,
    gridColumnStart: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    floodOpacity: true,
    stopOpacity: true,
    strokeDasharray: true,
    strokeDashoffset: true,
    strokeMiterlimit: true,
    strokeOpacity: true,
    strokeWidth: true
};
var $9c385584ad92366d$var$prefixKey = (prefix, key)=>prefix + key.charAt(0).toUpperCase() + key.substring(1);
var $9c385584ad92366d$var$prefixes = [
    "Webkit",
    "Ms",
    "Moz",
    "O"
];
$9c385584ad92366d$var$isUnitlessNumber = Object.keys($9c385584ad92366d$var$isUnitlessNumber).reduce((acc, prop)=>{
    $9c385584ad92366d$var$prefixes.forEach((prefix)=>acc[$9c385584ad92366d$var$prefixKey(prefix, prop)] = acc[prop]);
    return acc;
}, $9c385584ad92366d$var$isUnitlessNumber);
var $9c385584ad92366d$var$domTransforms = /^(matrix|translate|scale|rotate|skew)/;
var $9c385584ad92366d$var$pxTransforms = /^(translate)/;
var $9c385584ad92366d$var$degTransforms = /^(rotate|skew)/;
var $9c385584ad92366d$var$addUnit = (value, unit)=>(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).num(value) && value !== 0 ? value + unit : value;
var $9c385584ad92366d$var$isValueIdentity = (value, id)=>(0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).arr(value) ? value.every((v)=>$9c385584ad92366d$var$isValueIdentity(v, id)) : (0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).num(value) ? value === id : parseFloat(value) === id;
var $9c385584ad92366d$var$AnimatedStyle = class extends (0, $913d375866ff6257$export$f1b0b9e366a6e2d4) {
    constructor(_param){
        var { x: x, y: y, z: z } = _param, style = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
            "x",
            "y",
            "z"
        ]);
        const inputs = [];
        const transforms = [];
        if (x || y || z) {
            inputs.push([
                x || 0,
                y || 0,
                z || 0
            ]);
            transforms.push((xyz)=>[
                    `translate3d(${xyz.map((v)=>$9c385584ad92366d$var$addUnit(v, "px")).join(",")})`,
                    // prettier-ignore
                    $9c385584ad92366d$var$isValueIdentity(xyz, 0)
                ]);
        }
        (0, $3cb6d3769806d9dc$export$f4c6fe153f5a944e)(style, (value, key)=>{
            if (key === "transform") {
                inputs.push([
                    value || ""
                ]);
                transforms.push((transform)=>[
                        transform,
                        transform === ""
                    ]);
            } else if ($9c385584ad92366d$var$domTransforms.test(key)) {
                delete style[key];
                if ((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).und(value)) return;
                const unit = $9c385584ad92366d$var$pxTransforms.test(key) ? "px" : $9c385584ad92366d$var$degTransforms.test(key) ? "deg" : "";
                inputs.push((0, $3cb6d3769806d9dc$export$45b10814cc054894)(value));
                transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg])=>[
                        `rotate3d(${x2},${y2},${z2},${$9c385584ad92366d$var$addUnit(deg, unit)})`,
                        $9c385584ad92366d$var$isValueIdentity(deg, 0)
                    ] : (input)=>[
                        `${key}(${input.map((v)=>$9c385584ad92366d$var$addUnit(v, unit)).join(",")})`,
                        $9c385584ad92366d$var$isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
                    ]);
            }
        });
        if (inputs.length) style.transform = new $9c385584ad92366d$var$FluidTransform(inputs, transforms);
        super(style);
    }
};
var $9c385584ad92366d$var$FluidTransform = class extends (0, $3cb6d3769806d9dc$export$aff8e1ac1a016a2) {
    get() {
        return this._value || (this._value = this._get());
    }
    _get() {
        let transform = "";
        let identity = true;
        (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(this.inputs, (input, i)=>{
            const arg1 = (0, $3cb6d3769806d9dc$export$e37b7520edd66839)(input[0]);
            const [t, id] = this.transforms[i]((0, $3cb6d3769806d9dc$export$226b3eccf92c9ed9).arr(arg1) ? arg1 : input.map((0, $3cb6d3769806d9dc$export$e37b7520edd66839)));
            transform += " " + t;
            identity = identity && id;
        });
        return identity ? "none" : transform;
    }
    // Start observing our inputs once we have an observer.
    observerAdded(count) {
        if (count == 1) (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(input, (value)=>(0, $3cb6d3769806d9dc$export$57ea7e3a7f6280c7)(value) && (0, $3cb6d3769806d9dc$export$72d604e3f8d000a5)(value, this)));
    }
    // Stop observing our inputs once we have no observers.
    observerRemoved(count) {
        if (count == 0) (0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(this.inputs, (input)=>(0, $3cb6d3769806d9dc$export$79b2f7037acddd43)(input, (value)=>(0, $3cb6d3769806d9dc$export$57ea7e3a7f6280c7)(value) && (0, $3cb6d3769806d9dc$export$7a0eb830d336339b)(value, this)));
    }
    eventObserved(event) {
        if (event.type == "change") this._value = null;
        (0, $3cb6d3769806d9dc$export$31752c40a5fab62a)(this, event);
    }
    constructor(inputs, transforms){
        super();
        this.inputs = inputs;
        this.transforms = transforms;
        this._value = null;
    }
};
// src/primitives.ts
var $9c385584ad92366d$var$primitives = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    // SVG
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
(0, $3cb6d3769806d9dc$export$cceeabf822b64fc0).assign({
    batchedUpdates: (0, $b4ba1c853f6e1116$exports.unstable_batchedUpdates),
    createStringInterpolator: $3cb6d3769806d9dc$export$4759a013d387347a,
    colors: $3cb6d3769806d9dc$export$8f45430ccf837300
});
var $9c385584ad92366d$var$host = (0, $913d375866ff6257$export$4ee5c78f6dcbcef)($9c385584ad92366d$var$primitives, {
    applyAnimatedValues: $9c385584ad92366d$var$applyAnimatedValues,
    createAnimatedStyle: (style)=>new $9c385584ad92366d$var$AnimatedStyle(style),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getComponentProps: (_param)=>{
        var { scrollTop: scrollTop, scrollLeft: scrollLeft } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
            "scrollTop",
            "scrollLeft"
        ]);
        return props;
    }
});
var $9c385584ad92366d$export$407448d2b89b1813 = $9c385584ad92366d$var$host.animated;



const $48e0a9531b279704$var$Popup = (props)=>{
    var _contentRef_current, _titleRef_current;
    const [isInDOM, setIsInDOM] = (0, $7fPBF.useState)(false);
    const bodyOverflowStyleRef = (0, $7fPBF.useRef)(document.body.style.overflow);
    const topRef = (0, $7fPBF.useRef)(document.body.style.top);
    const contentRef = (0, $7fPBF.useRef)(null);
    const titleRef = (0, $7fPBF.useRef)(null);
    const heightPixel = (((_contentRef_current = contentRef.current) === null || _contentRef_current === void 0 ? void 0 : _contentRef_current.offsetHeight) || window.innerHeight / 2) + (((_titleRef_current = titleRef.current) === null || _titleRef_current === void 0 ? void 0 : _titleRef_current.offsetHeight) || 0);
    const [popupStyle, popupStyleApi] = (0, $5aec47966e5882be$export$c4af9125706c4d30)(()=>({
            opacity: 0
        }));
    const [popupBodyStyle, popupBodyStyleApi] = (0, $5aec47966e5882be$export$c4af9125706c4d30)(()=>({
            height: '0px',
            onRest: {
                height: (height)=>{
                    if (height.value === `${heightPixel}px`) return;
                    if (height.value === '0px') setIsInDOM(false);
                }
            }
        }));
    const handleOverlayClick = (0, $7fPBF.useCallback)(()=>props.onClose(), [
        props.onClose
    ]);
    const handleContentClick = (0, $7fPBF.useCallback)((e)=>e.stopPropagation(), []);
    (0, $7fPBF.useEffect)(()=>{
        if (props.isOpen) {
            const currY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
            bodyOverflowStyleRef.current = document.body.style.overflow;
            topRef.current = document.body.style.top;
            document.body.style.overflow = 'hidden';
            document.body.style.top = `-${currY}px`;
            setIsInDOM(true);
        } else {
            popupBodyStyleApi.start({
                height: '0px'
            });
            popupStyleApi.start({
                opacity: 0,
                delay: 100
            });
            setIsInDOM(false);
        }
    }, [
        props.isOpen,
        popupBodyStyleApi,
        popupStyleApi
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (isInDOM) {
            popupStyleApi.start({
                opacity: 1
            });
            popupBodyStyleApi.start({
                height: `${heightPixel}px`,
                delay: 100
            });
        } else if (document.body.style.overflow === 'hidden') {
            document.body.style.overflow = bodyOverflowStyleRef.current;
            document.body.style.top = topRef.current;
        }
    }, [
        isInDOM,
        popupBodyStyleApi,
        popupStyleApi
    ]);
    (0, $7fPBF.useEffect)(()=>()=>{
            if (document.body.style.overflow === 'hidden') {
                document.body.style.overflow = bodyOverflowStyleRef.current;
                document.body.style.top = topRef.current;
            }
        }, []);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {
        children: props.isOpen ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $9c385584ad92366d$export$407448d2b89b1813).div, {
            className: 'common-popup',
            style: popupStyle,
            onClick: handleOverlayClick,
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $9c385584ad92366d$export$407448d2b89b1813).div, {
                className: `popup-body${props.className ? ' ' + props.className : ''}`,
                style: popupBodyStyle,
                onClick: handleContentClick,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        ref: titleRef,
                        className: 'b1_m ml-24px flex',
                        children: [
                            props.title,
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                onClick: props.onClose,
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                                    iconClass: `${props.iconClass ? props.iconClass : 'close'} w-17px h-17px`
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        ref: contentRef,
                        children: props.content
                    })
                ]
            })
        }) : null
    });
};
var $48e0a9531b279704$export$2e2bcd8739ae039 = $48e0a9531b279704$var$Popup;






var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");


const $7dbb63010eed711d$var$GenderSelect = (props)=>{
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: 'custom-select',
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
            className: `${props.className}`,
            children: (0, $f42572f639d7eece$export$8ed14f7d88366aa1).map((data, index)=>{
                return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: `select-items ${index === (0, $f42572f639d7eece$export$8ed14f7d88366aa1).length - 1 ? 'mb-8px' : ''} ${data.name === props.selected ? 'item-selected' : ''}`,
                    onClick: ()=>props.onClick(data.value),
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                            className: 'b2_r',
                            children: data.name
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            id: 'select-item-' + index.toString(),
                            style: {
                                display: data.name === props.selected ? '' : 'none'
                            },
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                                iconClass: 'select-box-selected'
                            })
                        })
                    ]
                }, index);
            })
        })
    });
};
var $7dbb63010eed711d$export$2e2bcd8739ae039 = $7dbb63010eed711d$var$GenderSelect;


const $0274153e4213d614$var$Signup = (props)=>{
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const messageList = {
        'email': {
            'label': "\uC774\uBA54\uC77C",
            'name': 'email',
            'title': "\uBA54\uC77C \uC8FC\uC18C\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
            'subTitle': "\uC544\uC774\uB514\uB85C \uC4F0\uC77C \uC8FC\uC18C\uC608\uC694"
        },
        'pwd': {
            'label': "\uBE44\uBC00\uBC88\uD638",
            'name': 'pwd',
            'title': "\uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694",
            'subTitle': "\uC601\uBB38, \uC22B\uC790 \uD3EC\uD568 10\uC790 \uC774\uC0C1\uC774\uC5D0\uC694"
        },
        'pwdCheck': {
            'label': "\uBE44\uBC00\uBC88\uD638",
            'name': 'pwdCheck',
            'title': "\uBE44\uBC00\uBC88\uD638\uB97C \uD655\uC778\uD574\uC8FC\uC138\uC694",
            'subTitle': "\uC601\uBB38, \uC22B\uC790 \uD3EC\uD568 10\uC790 \uC774\uC0C1\uC774\uC5D0\uC694"
        },
        'nickName': {
            'label': "\uB2C9\uB124\uC784",
            'name': 'nickNm',
            'title': "\uB2C9\uB124\uC784\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694",
            'subTitle': "20\uC790 \uC774\uB0B4\uB85C \uC785\uB825\uD574\uC8FC\uC138\uC694"
        },
        'tall': {
            'label': "\uD0A4",
            'name': 'tall',
            'title': "\uD0A4\uB97C \uC54C\uB824\uC8FC\uC138\uC694",
            'subTitle': "\uC18C\uC218\uC810 \uCCAB \uBC88\uC9F8 \uC790\uB9AC\uAE4C\uC9C0 \uC785\uB825\uD560 \uC218 \uC788\uC5B4\uC694"
        },
        'gender': {
            'label': "\uC131\uBCC4",
            'name': 'gender',
            'title': "\uC131\uBCC4\uC744 \uC120\uD0DD\uD574 \uC8FC\uC138\uC694",
            'subTitle': ''
        },
        'birthday': {
            'label': "\uC0DD\uB144\uC6D4\uC77C",
            'name': 'birthday',
            'title': "\uC0DD\uB144\uC6D4\uC77C\uC744 \uC785\uB825\uD574 \uC8FC\uC138\uC694",
            'subTitle': "8\uAE00\uC790\uB85C \uC785\uB825\uD574\uC8FC\uC138\uC694"
        },
        'sns': {
            'label': '',
            'name': '',
            'title': "SNS \uD68C\uC6D0\uAC00\uC785",
            'subTitle': "\uBE44\uBC00\uBC88\uD638 \uC5C6\uC774 \uC0AC\uC6A9\uD558\uB294 SNS \uD68C\uC6D0\uAC00\uC785\uC774\uC5D0\uC694"
        },
        'complete': {
            'label': '',
            'name': '',
            'title': "\uC815\uBCF4\uB97C \uD655\uC778 \uD574 \uC8FC\uC138\uC694",
            'subTitle': "\uC785\uB825\uD558\uC2E0 \uC815\uBCF4\uAC00 \uB9DE\uB098\uC694?"
        }
    };
    const [message, setMessage] = (0, $7fPBF.useState)(messageList.email);
    const defaultTheme = 'dark';
    const [_mnbrNtrySeCd] = (0, $7fPBF.useState)(props.prevType ? props.prevType : '');
    const [_uuid] = (0, $7fPBF.useState)(props.uuid);
    const [email, setEmail] = (0, $7fPBF.useState)({
        value: props.email ? props.email : '',
        errMsg: ''
    });
    const [pwd, setPwd] = (0, $7fPBF.useState)({
        value: '',
        errMsg: ''
    });
    const [pwdCheck, setPwdCheck] = (0, $7fPBF.useState)({
        value: '',
        errMsg: ''
    });
    const [nickName, setNickName] = (0, $7fPBF.useState)({
        value: '',
        errMsg: ''
    });
    const [tall, setTall] = (0, $7fPBF.useState)({
        value: '',
        errMsg: ''
    });
    const [gender, setGender] = (0, $7fPBF.useState)({
        value: '',
        errMsg: ''
    });
    const [birthday, setBirthday] = (0, $7fPBF.useState)({
        value: '',
        errMsg: ''
    });
    const [typePassword, setTypePassword] = (0, $7fPBF.useState)('password');
    const [typePassword2, setTypePassword2] = (0, $7fPBF.useState)('password');
    const [disable, setDisable] = (0, $7fPBF.useState)(true);
    (0, $7fPBF.useEffect)(()=>{
        if (_uuid) {
            let decodedToken = {
                email: ''
            };
            if (_mnbrNtrySeCd === 'A') {
                decodedToken = (0, $483bc232120caa64$export$2e2bcd8739ae039)(_uuid);
                if (decodedToken.email) setEmail({
                    value: decodedToken.email,
                    errMsg: ''
                });
            }
        }
    }, [
        _uuid
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (_mnbrNtrySeCd === 'G' || _mnbrNtrySeCd === 'N' || _mnbrNtrySeCd === 'K' || _mnbrNtrySeCd === 'A') {
            pwd.value = _mnbrNtrySeCd;
            pwdCheck.value = _mnbrNtrySeCd;
            setMessage(messageList.sns);
        }
    }, [
        _mnbrNtrySeCd
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(email.value) || (0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(pwd.value) || (0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(pwdCheck.value) || (0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(nickName.value)) setDisable(true);
        else if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(email.errMsg) || (0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(pwd.errMsg) || (0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(pwdCheck.errMsg) || (0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(nickName.errMsg)) setDisable(true);
        else {
            setDisable(false);
            setMessage(messageList.complete);
        }
    }, [
        email,
        pwd,
        pwdCheck,
        nickName,
        tall,
        gender,
        birthday
    ]);
    const svcUser = new (0, $4d624a4edc63c668$export$78aa35cd3523fa8f)('', '', '');
    const { refetch: signUp } = (0, $d8deb3a6a62b947e$export$dd0a697e1782aedd)([
        'signUp'
    ], ()=>(0, $4d624a4edc63c668$export$2e2bcd8739ae039).signUp(svcUser), {
        onSuccess: (data)=>{
            signUpSuccess(data);
        }
    });
    const signUpSuccess = (data)=>{
        navigate('/');
    };
    const [isOpen, setIsOpen] = (0, $7fPBF.useState)(false);
    let flag = false;
    const clickSignUp = async ()=>{
        if (flag) return;
        flag = true;
        svcUser.nickName = nickName.value;
        svcUser.userEmail = email.value;
        svcUser.pwd = pwd.value;
        await signUp();
        flag = false;
    };
    const clearBirthday = ()=>{
        setBirthday({
            value: '',
            errMsg: ''
        });
    };
    let ignore2 = false;
    const validateNickName = async (value)=>{
        if (ignore2) return;
        ignore2 = true;
        const result = (0, $f42572f639d7eece$export$2e2bcd8739ae039).checkValidNickName(value);
        if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(result.value) && (0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(result.errMsg)) await (0, $f42572f639d7eece$export$2e2bcd8739ae039).checkDuplicate(result.value).then((res)=>{
            if (!res) setNickName({
                value: result.value,
                errMsg: "\uC0AC\uC6A9\uD558\uC2E4 \uC218 \uC5C6\uB294 \uB2C9\uB124\uC784\uC774\uC5D0\uC694."
            });
            else setNickName((prevState)=>({
                    value: prevState.value,
                    errMsg: ''
                }));
        }).catch(()=>{
            console.log("\uC2DC\uC2A4\uD15C \uC5D0\uB7EC");
        });
        else setNickName({
            value: result.value,
            errMsg: result.errMsg
        });
        ignore2 = false;
    };
    const clearNickName = ()=>{
        setNickName({
            value: '',
            errMsg: ''
        });
    };
    const validateTall = (value)=>{
        const result = (0, $f42572f639d7eece$export$2e2bcd8739ae039).checkValidTall(value);
        setTall({
            value: result.value,
            errMsg: result.errMsg
        });
    };
    const validateBirthday = (value)=>{
        const result = (0, $f42572f639d7eece$export$2e2bcd8739ae039).checkValidBirthday(value);
        setBirthday({
            value: result.value,
            errMsg: result.errMsg
        });
    };
    let ignore = false;
    const validateEmail = async (value)=>{
        if (ignore) return;
        ignore = true;
        const result = (0, $f42572f639d7eece$export$2e2bcd8739ae039).checkValidEmail(value);
        if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(result.value) && (0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(result.errMsg)) await (0, $f42572f639d7eece$export$2e2bcd8739ae039).checkEmailDuplicate(result.value).then((res)=>{
            if (!res) setEmail({
                value: result.value,
                errMsg: "\uB2E4\uB978 \uC0AC\uB78C\uC774 \uC0AC\uC6A9 \uC911\uC778 \uC774\uBA54\uC77C\uC774\uC5D0\uC694."
            });
            else setEmail((prevState)=>({
                    value: prevState.value,
                    errMsg: ''
                }));
        }).catch(()=>{
            console.log("\uC2DC\uC2A4\uD15C \uC5D0\uB7EC");
        });
        else setEmail({
            value: result.value,
            errMsg: result.errMsg
        });
        ignore = false;
    };
    const validatePwd = (value)=>{
        const result = (0, $f42572f639d7eece$export$2e2bcd8739ae039).checkValidPwd(value);
        setPwd({
            value: result.value,
            errMsg: result.errMsg
        });
    };
    const validatePwdOnBlur = (value)=>{
        const result = (0, $f42572f639d7eece$export$2e2bcd8739ae039).checkValidPwd(value);
        setPwd({
            value: result.value,
            errMsg: result.errMsg
        });
        if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(result.errMsg) && (0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(pwd.value) && (0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(pwdCheck.value)) {
            if (pwd.value !== pwdCheck.value) setPwd({
                value: result.value,
                errMsg: "\uBE44\uBC00\uBC88\uD638\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC544\uC694."
            });
            else setPwdCheck({
                value: pwdCheck.value,
                errMsg: ''
            });
        }
    };
    const validatePwdCheck = (value)=>{
        const result = (0, $f42572f639d7eece$export$2e2bcd8739ae039).checkValidPwd(value);
        setPwdCheck({
            value: result.value,
            errMsg: result.errMsg
        });
    };
    const validatePwdCheckOnBlur = (value)=>{
        const result = (0, $f42572f639d7eece$export$2e2bcd8739ae039).checkValidPwd(value);
        setPwdCheck({
            value: result.value,
            errMsg: result.errMsg
        });
        if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(result.errMsg) && (0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(pwd.value) && (0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(pwdCheck.value)) {
            if (pwd.value !== pwdCheck.value) setPwdCheck({
                value: result.value,
                errMsg: "\uBE44\uBC00\uBC88\uD638\uAC00 \uC77C\uCE58\uD558\uC9C0 \uC54A\uC544\uC694."
            });
            else setPwd({
                value: pwd.value,
                errMsg: ''
            });
        }
    };
    const clickLook = ()=>{
        if (typePassword === 'text') setTypePassword('password');
        else setTypePassword('text');
    };
    const clickLook2 = ()=>{
        if (typePassword2 === 'text') setTypePassword2('password');
        else setTypePassword2('text');
    };
    const genderClicked = ()=>{
        setMessage(messageList.gender);
        setIsOpen(true);
    };
    const genderSelected = (value)=>{
        setGender((prevState)=>({
                value: (0, $f42572f639d7eece$export$2e2bcd8739ae039).convertGenderName(value),
                errMsg: prevState.errMsg
            }));
        setIsOpen(false);
    };
    (0, $7fPBF.useEffect)(()=>{
        if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(nickName.value) || (0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(nickName.errMsg)) {
            if ((0, $b553984b7fac59de$export$2e2bcd8739ae039).isEmpty(nickName.value)) setNickName((prevState)=>({
                    value: prevState.value,
                    errMsg: "\uB2C9\uB124\uC784\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694"
                }));
            else setNickName((prevState)=>({
                    value: prevState.value,
                    errMsg: prevState.errMsg
                }));
        }
    }, [
        nickName.value,
        nickName.errMsg
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                id: "Signup",
                className: 'bg-cl-black',
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: 'main-content',
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: 'h5_m title mt-39px',
                                children: message.title
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: 'b2_r title mt-16px ft-cl-hint',
                                children: message.subTitle
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: 'input-wrapper',
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        className: 'b1_r input-item',
                                        children: _mnbrNtrySeCd === 'G' || _mnbrNtrySeCd === 'N' || _mnbrNtrySeCd === 'K' || _mnbrNtrySeCd === 'A' ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a86038245a3af4e6$export$2e2bcd8739ae039), {
                                            theme: defaultTheme,
                                            label: messageList.email.label,
                                            name: messageList.email.name,
                                            value: email.value,
                                            required: true,
                                            errorMsg: email.errMsg,
                                            readOnly: true,
                                            children: email.value
                                        }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a86038245a3af4e6$export$2e2bcd8739ae039), {
                                            theme: defaultTheme,
                                            label: messageList.email.label,
                                            name: messageList.email.name,
                                            value: email.value,
                                            rightContent: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                className: 'click-area',
                                                onClick: ()=>setEmail({
                                                        value: '',
                                                        errMsg: ''
                                                    }),
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                                                    iconClass: 'input-delete-d h-17px'
                                                })
                                            }),
                                            onChange: (ev)=>setEmail((prevState)=>({
                                                        value: ev.target.value,
                                                        errMsg: prevState.errMsg
                                                    })),
                                            required: true,
                                            onBlur: ()=>validateEmail(email.value),
                                            onKeyUp: ()=>validateEmail(email.value),
                                            onClick: ()=>setMessage(messageList.email),
                                            errorMsg: email.errMsg,
                                            children: email.value
                                        })
                                    }),
                                    _mnbrNtrySeCd === 'G' || _mnbrNtrySeCd === 'N' || _mnbrNtrySeCd === 'K' || _mnbrNtrySeCd === 'A' ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bbzbN.Fragment), {}) : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                className: 'b1_r input-item',
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a86038245a3af4e6$export$2e2bcd8739ae039), {
                                                    theme: defaultTheme,
                                                    label: messageList.pwd.label,
                                                    name: messageList.pwd.name,
                                                    value: pwd.value,
                                                    rightContent: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                        className: 'click-area',
                                                        onClick: ()=>clickLook(),
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                                                            iconClass: 'ic-look h-17px'
                                                        })
                                                    }),
                                                    onChange: (ev)=>setPwd((prevState)=>({
                                                                value: ev.target.value,
                                                                errMsg: prevState.errMsg
                                                            })),
                                                    required: true,
                                                    onBlur: ()=>validatePwdOnBlur(pwd.value),
                                                    onKeyUp: ()=>validatePwd(pwd.value),
                                                    onClick: ()=>setMessage(messageList.pwd),
                                                    errorMsg: pwd.errMsg,
                                                    type: typePassword,
                                                    children: pwd.value
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                className: 'b1_r input-item',
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a86038245a3af4e6$export$2e2bcd8739ae039), {
                                                    theme: defaultTheme,
                                                    label: messageList.pwdCheck.label,
                                                    name: messageList.pwdCheck.name,
                                                    value: pwdCheck.value,
                                                    rightContent: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                        className: 'click-area',
                                                        onClick: ()=>clickLook2(),
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                                                            iconClass: 'ic-look h-17px'
                                                        })
                                                    }),
                                                    onChange: (ev)=>setPwdCheck((prevState)=>({
                                                                value: ev.target.value,
                                                                errMsg: prevState.errMsg
                                                            })),
                                                    required: true,
                                                    onBlur: ()=>validatePwdCheckOnBlur(pwdCheck.value),
                                                    onKeyUp: ()=>validatePwdCheck(pwdCheck.value),
                                                    onClick: ()=>setMessage(messageList.pwdCheck),
                                                    errorMsg: pwdCheck.errMsg,
                                                    type: typePassword2,
                                                    children: pwdCheck.value
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        className: 'b1_r input-item',
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a86038245a3af4e6$export$2e2bcd8739ae039), {
                                            theme: defaultTheme,
                                            label: "\uB2C9\uB124\uC784",
                                            name: 'nickName',
                                            value: nickName.value,
                                            rightContent: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                className: 'click-area',
                                                onClick: ()=>clearNickName(),
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $82f6451296af3115$export$2e2bcd8739ae039), {
                                                    iconClass: 'input-delete-d h-17px'
                                                })
                                            }),
                                            onChange: (ev)=>setNickName((prevState)=>({
                                                        value: ev.target.value,
                                                        errMsg: prevState.errMsg
                                                    })),
                                            //onChange={(ev) => validateNickName(ev.target.value)}
                                            onBlur: ()=>validateNickName(nickName.value),
                                            onKeyUp: ()=>validateNickName(nickName.value),
                                            required: true,
                                            errorMsg: nickName.errMsg,
                                            onClick: ()=>setMessage(messageList.nickName)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        className: 'h-48px'
                                    })
                                ]
                            })
                        ]
                    }),
                    !disable ? /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fd30181b78da18c2$export$2e2bcd8739ae039), {
                        title: "\uC644\uB8CC",
                        disabled: false,
                        onClick: ()=>clickSignUp()
                    }) : /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fd30181b78da18c2$export$2e2bcd8739ae039), {
                        title: "\uC644\uB8CC",
                        disabled: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $48e0a9531b279704$export$2e2bcd8739ae039), {
                className: "bg-cl-gray-2 ft-cl-white",
                title: "\uC131\uBCC4 \uC120\uD0DD",
                iconClass: 'close-w',
                content: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7dbb63010eed711d$export$2e2bcd8739ae039), {
                    onClick: genderSelected,
                    className: defaultTheme,
                    selected: gender.value
                }),
                isOpen: isOpen,
                onClose: ()=>setIsOpen(!isOpen)
            })
        ]
    });
};
var $0274153e4213d614$export$2e2bcd8739ae039 = $0274153e4213d614$var$Signup;


const $70685a3d339204f3$var$SignupView = ()=>{
    const [searchParam] = (0, $a0cf24fd73ae067c$export$f1a78c17382fe22a)();
    const [_email] = (0, $7fPBF.useState)((0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(searchParam.get("email")) ? searchParam.get("email") : undefined);
    const [_prevType] = (0, $7fPBF.useState)((0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(searchParam.get("prevType")) ? searchParam.get("prevType") : undefined);
    const [_uuid] = (0, $7fPBF.useState)((0, $b553984b7fac59de$export$2e2bcd8739ae039).isNotEmpty(searchParam.get("uuid")) ? searchParam.get("uuid") : undefined);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                id: "rootBg-black"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $54d085f8f18f5fb5$export$2e2bcd8739ae039), {
                leftIcon: 'prev-w',
                leftLink: '/login'
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4ac626799ed465c3$export$2e2bcd8739ae039), {
                className: "bg-cl-black"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $0274153e4213d614$export$2e2bcd8739ae039), {})
        ]
    });
};
var $70685a3d339204f3$export$2e2bcd8739ae039 = $70685a3d339204f3$var$SignupView;


const $5c121a02b943fe91$var$App = ()=>{
    const [isOpen, setIsOpen] = (0, $7fPBF.useState)(false);
    const [isOpen2, setIsOpen2] = (0, $7fPBF.useState)(false);
    const queryClient = new (0, $c2aa340bb6cff64d$export$405d0624ed55a03f)({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
                cacheTime: 0,
                // 시간안에 같은 key로 요청오면 캐싱된 데이터 리턴 1000 -> 1초, default: 0초, 공지사항, FAQ: 1시간(1000 * 60 * 60) 으로 오버라이딩 해서 사용
                retry: false,
                // false: 에러시 재시도 없음. 1: 재시도 1회
                enabled: false,
                // true: mount시 함수 호출, false mount시 함수 호출 되지 않음
                onError: (err)=>{
                    const error = err;
                    if (error.response !== undefined && (error.response.status === undefined || error.response.status !== 401 && error.response.status !== 403)) setIsOpen(true);
                }
            }
        }
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2a48bc0174310031$export$45604f0cc8ae667b), {
                client: queryClient,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54), {
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d9fd026bfea79ab9$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $020b91714255568e$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                path: "/login",
                                element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d53e4957d2fe3c5e$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                path: "/main",
                                element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $dd12cd8b8470e831$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                path: "/loading",
                                element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f997398eb8f0e318$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                path: "/signup",
                                element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $70685a3d339204f3$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4f2ef10ac997660e$export$2e2bcd8739ae039), {
                content: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: 'text-center b2_r',
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            children: (0, $2df1405d783f614e$export$145c04625c32c6f3).ERROR1
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            children: (0, $2df1405d783f614e$export$145c04625c32c6f3).ERROR2
                        })
                    ]
                }),
                title: undefined,
                btnContent: "\uD655\uC778",
                isOpen: isOpen,
                onClose: ()=>setIsOpen(false)
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4f2ef10ac997660e$export$2e2bcd8739ae039), {
                content: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: 'text-center b2_r',
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            children: "\uC0AC\uC6A9\uC790 \uC778\uC99D\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            children: "\uB2E4\uC2DC \uB85C\uADF8\uC778\uD574 \uC8FC\uC138\uC694."
                        })
                    ]
                }),
                title: undefined,
                btnContent: "\uD655\uC778",
                isOpen: isOpen2,
                onClose: ()=>setIsOpen2(false)
            })
        ]
    });
};
var $5c121a02b943fe91$export$2e2bcd8739ae039 = $5c121a02b943fe91$var$App;



const $d7ff3ee147cb4273$var$theme = (0, $ca3239ce6bf6e490$export$2e2bcd8739ae039)({
    palette: {
        primary: {
            light: '#8FE2D2',
            main: '#24CBAA',
            dark: '#11B998'
        },
        secondary: {
            light: '#FFD976',
            main: '#FFC223'
        }
    }
});
const $d7ff3ee147cb4273$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($f11ec298ebcca059$exports))).createRoot(document.getElementById('contentBody'));
$d7ff3ee147cb4273$var$root.render(/*#__PURE__*/ (0, $bbzbN.jsx)((0, $b8226d5132dedede$export$2e2bcd8739ae039), {
    theme: $d7ff3ee147cb4273$var$theme,
    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5c121a02b943fe91$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=football-manager-front.790508bd.js.map
